/**
 * Diamond Grading Tables - COMPLETE
 * Generated from common.json with actual point values
 * Uses ONLY exact combinations from common.json (no category mapping)
 * 
 * FANCY shapes: Individual colors and clarities (Color, Clarity, Symmetry, Polish, Fluorescence)
 * ROUND diamonds: Individual colors and clarities + Cut grade
 * 
 * Scores are based on actual point calculations from common.json
 */

(function() {
  'use strict';

  // FANCY SHAPES GRADING TABLE
  // Key format: COLOR-CLARITY-SYMMETRY-POLISH-FLUORESCENCE
  // Uses individual colors (D, E, F, etc.) and clarities (IF, VVS1, VVS2, etc.)
  window.FANCY_GRADING_TABLE = {
    'D-IF-EX-EX-NONE': 10.0,
    'E-IF-EX-EX-NONE': 9.73,
    'D-IF-EX-EX-FAINT': 9.7,
    'D-VVS1-EX-EX-NONE': 9.69,
    'D-IF-VG-EX-NONE': 9.63,
    'D-IF-EX-VG-NONE': 9.63,
    'F-IF-EX-EX-NONE': 9.45,
    'E-IF-EX-EX-FAINT': 9.43,
    'E-VVS1-EX-EX-NONE': 9.42,
    'D-IF-EX-EX-MEDIUM': 9.4,
    'D-VVS1-EX-EX-FAINT': 9.39,
    'D-VVS2-EX-EX-NONE': 9.39,
    'E-IF-VG-EX-NONE': 9.36,
    'E-IF-EX-VG-NONE': 9.36,
    'D-IF-VG-EX-FAINT': 9.33,
    'D-IF-EX-VG-FAINT': 9.33,
    'D-VVS1-VG-EX-NONE': 9.32,
    'D-VVS1-EX-VG-NONE': 9.32,
    'D-IF-VG-VG-NONE': 9.26,
    'D-IF-GOOD-EX-NONE': 9.25,
    'D-IF-EX-GOOD-NONE': 9.25,
    'G-IF-EX-EX-NONE': 9.18,
    'F-IF-EX-EX-FAINT': 9.15,
    'F-VVS1-EX-EX-NONE': 9.14,
    'E-IF-EX-EX-MEDIUM': 9.13,
    'E-VVS1-EX-EX-FAINT': 9.12,
    'E-VVS2-EX-EX-NONE': 9.12,
    'D-IF-EX-EX-STRONG': 9.1,
    'D-VVS1-EX-EX-MEDIUM': 9.09,
    'D-VVS2-EX-EX-FAINT': 9.09,
    'D-VS1-EX-EX-NONE': 9.08,
    'F-IF-VG-EX-NONE': 9.08,
    'F-IF-EX-VG-NONE': 9.08,
    'E-IF-VG-EX-FAINT': 9.06,
    'E-IF-EX-VG-FAINT': 9.06,
    'E-VVS1-VG-EX-NONE': 9.05,
    'E-VVS1-EX-VG-NONE': 9.05,
    'D-IF-VG-EX-MEDIUM': 9.03,
    'D-IF-EX-VG-MEDIUM': 9.03,
    'D-VVS1-VG-EX-FAINT': 9.02,
    'D-VVS1-EX-VG-FAINT': 9.02,
    'D-VVS2-VG-EX-NONE': 9.02,
    'D-VVS2-EX-VG-NONE': 9.02,
    'E-IF-VG-VG-NONE': 8.99,
    'E-IF-GOOD-EX-NONE': 8.98,
    'E-IF-EX-GOOD-NONE': 8.98,
    'D-IF-VG-VG-FAINT': 8.96,
    'D-IF-GOOD-EX-FAINT': 8.95,
    'D-IF-EX-GOOD-FAINT': 8.95,
    'D-VVS1-VG-VG-NONE': 8.95,
    'D-VVS1-GOOD-EX-NONE': 8.94,
    'D-VVS1-EX-GOOD-NONE': 8.94,
    'H-IF-EX-EX-NONE': 8.9,
    'D-IF-POOR-EX-NONE': 8.88,
    'D-IF-GOOD-VG-NONE': 8.88,
    'D-IF-VG-GOOD-NONE': 8.88,
    'D-IF-EX-POOR-NONE': 8.88,
    'G-IF-EX-EX-FAINT': 8.88,
    'G-VVS1-EX-EX-NONE': 8.87,
    'F-IF-EX-EX-MEDIUM': 8.85,
    'F-VVS1-EX-EX-FAINT': 8.84,
    'F-VVS2-EX-EX-NONE': 8.84,
    'E-IF-EX-EX-STRONG': 8.83,
    'E-VVS1-EX-EX-MEDIUM': 8.82,
    'E-VVS2-EX-EX-FAINT': 8.82,
    'E-VS1-EX-EX-NONE': 8.81,
    'G-IF-VG-EX-NONE': 8.81,
    'G-IF-EX-VG-NONE': 8.81,
    'D-VVS1-EX-EX-STRONG': 8.79,
    'D-VVS2-EX-EX-MEDIUM': 8.79,
    'D-VS1-EX-EX-FAINT': 8.78,
    'D-VS2-EX-EX-NONE': 8.78,
    'F-IF-VG-EX-FAINT': 8.78,
    'F-IF-EX-VG-FAINT': 8.78,
    'F-VVS1-VG-EX-NONE': 8.77,
    'F-VVS1-EX-VG-NONE': 8.77,
    'E-IF-VG-EX-MEDIUM': 8.76,
    'E-IF-EX-VG-MEDIUM': 8.76,
    'E-VVS1-VG-EX-FAINT': 8.75,
    'E-VVS1-EX-VG-FAINT': 8.75,
    'E-VVS2-VG-EX-NONE': 8.75,
    'E-VVS2-EX-VG-NONE': 8.75,
    'D-IF-VG-EX-STRONG': 8.73,
    'D-IF-EX-VG-STRONG': 8.73,
    'D-VVS1-VG-EX-MEDIUM': 8.72,
    'D-VVS1-EX-VG-MEDIUM': 8.72,
    'D-VVS2-VG-EX-FAINT': 8.72,
    'D-VVS2-EX-VG-FAINT': 8.72,
    'D-VS1-VG-EX-NONE': 8.71,
    'D-VS1-EX-VG-NONE': 8.71,
    'F-IF-VG-VG-NONE': 8.71,
    'F-IF-GOOD-EX-NONE': 8.7,
    'F-IF-EX-GOOD-NONE': 8.7,
    'E-IF-VG-VG-FAINT': 8.69,
    'E-IF-GOOD-EX-FAINT': 8.68,
    'E-IF-EX-GOOD-FAINT': 8.68,
    'E-VVS1-VG-VG-NONE': 8.68,
    'E-VVS1-GOOD-EX-NONE': 8.67,
    'E-VVS1-EX-GOOD-NONE': 8.67,
    'D-IF-VG-VG-MEDIUM': 8.66,
    'D-IF-GOOD-EX-MEDIUM': 8.65,
    'D-IF-EX-GOOD-MEDIUM': 8.65,
    'D-VVS1-VG-VG-FAINT': 8.65,
    'D-VVS2-VG-VG-NONE': 8.65,
    'D-VVS1-GOOD-EX-FAINT': 8.64,
    'D-VVS1-EX-GOOD-FAINT': 8.64,
    'D-VVS2-GOOD-EX-NONE': 8.64,
    'D-VVS2-EX-GOOD-NONE': 8.64,
    'I-IF-EX-EX-NONE': 8.63,
    'E-IF-POOR-EX-NONE': 8.61,
    'E-IF-GOOD-VG-NONE': 8.61,
    'E-IF-VG-GOOD-NONE': 8.61,
    'E-IF-EX-POOR-NONE': 8.61,
    'H-IF-EX-EX-FAINT': 8.6,
    'H-VVS1-EX-EX-NONE': 8.59,
    'D-IF-POOR-EX-FAINT': 8.58,
    'D-IF-GOOD-VG-FAINT': 8.58,
    'D-IF-VG-GOOD-FAINT': 8.58,
    'D-IF-EX-POOR-FAINT': 8.58,
    'G-IF-EX-EX-MEDIUM': 8.58,
    'D-VVS1-POOR-EX-NONE': 8.57,
    'D-VVS1-GOOD-VG-NONE': 8.57,
    'D-VVS1-VG-GOOD-NONE': 8.57,
    'D-VVS1-EX-POOR-NONE': 8.57,
    'G-VVS1-EX-EX-FAINT': 8.57,
    'G-VVS2-EX-EX-NONE': 8.57,
    'F-IF-EX-EX-STRONG': 8.55,
    'F-VVS1-EX-EX-MEDIUM': 8.54,
    'F-VVS2-EX-EX-FAINT': 8.54,
    'F-VS1-EX-EX-NONE': 8.53,
    'H-IF-VG-EX-NONE': 8.53,
    'H-IF-EX-VG-NONE': 8.53,
    'E-VVS1-EX-EX-STRONG': 8.52,
    'E-VVS2-EX-EX-MEDIUM': 8.52,
    'D-IF-POOR-VG-NONE': 8.51,
    'D-IF-VG-POOR-NONE': 8.51,
    'E-VS1-EX-EX-FAINT': 8.51,
    'E-VS2-EX-EX-NONE': 8.51,
    'G-IF-VG-EX-FAINT': 8.51,
    'G-IF-EX-VG-FAINT': 8.51,
    'D-IF-GOOD-GOOD-NONE': 8.5,
    'G-VVS1-VG-EX-NONE': 8.5,
    'G-VVS1-EX-VG-NONE': 8.5,
    'D-VVS2-EX-EX-STRONG': 8.49,
    'D-VS1-EX-EX-MEDIUM': 8.48,
    'D-VS2-EX-EX-FAINT': 8.48,
    'F-IF-VG-EX-MEDIUM': 8.48,
    'F-IF-EX-VG-MEDIUM': 8.48,
    'D-SI1-EX-EX-NONE': 8.47,
    'F-VVS1-VG-EX-FAINT': 8.47,
    'F-VVS1-EX-VG-FAINT': 8.47,
    'F-VVS2-VG-EX-NONE': 8.47,
    'F-VVS2-EX-VG-NONE': 8.47,
    'E-IF-VG-EX-STRONG': 8.46,
    'E-IF-EX-VG-STRONG': 8.46,
    'E-VVS1-VG-EX-MEDIUM': 8.45,
    'E-VVS1-EX-VG-MEDIUM': 8.45,
    'E-VVS2-VG-EX-FAINT': 8.45,
    'E-VVS2-EX-VG-FAINT': 8.45,
    'E-VS1-VG-EX-NONE': 8.44,
    'E-VS1-EX-VG-NONE': 8.44,
    'G-IF-VG-VG-NONE': 8.44,
    'G-IF-GOOD-EX-NONE': 8.43,
    'G-IF-EX-GOOD-NONE': 8.43,
    'D-VVS1-VG-EX-STRONG': 8.42,
    'D-VVS1-EX-VG-STRONG': 8.42,
    'D-VVS2-VG-EX-MEDIUM': 8.42,
    'D-VVS2-EX-VG-MEDIUM': 8.42,
    'D-VS1-VG-EX-FAINT': 8.41,
    'D-VS1-EX-VG-FAINT': 8.41,
    'D-VS2-VG-EX-NONE': 8.41,
    'D-VS2-EX-VG-NONE': 8.41,
    'F-IF-VG-VG-FAINT': 8.41,
    'F-IF-GOOD-EX-FAINT': 8.4,
    'F-IF-EX-GOOD-FAINT': 8.4,
    'F-VVS1-VG-VG-NONE': 8.4,
    'E-IF-VG-VG-MEDIUM': 8.39,
    'F-VVS1-GOOD-EX-NONE': 8.39,
    'F-VVS1-EX-GOOD-NONE': 8.39,
    'E-IF-GOOD-EX-MEDIUM': 8.38,
    'E-IF-EX-GOOD-MEDIUM': 8.38,
    'E-VVS1-VG-VG-FAINT': 8.38,
    'E-VVS2-VG-VG-NONE': 8.38,
    'E-VVS1-GOOD-EX-FAINT': 8.37,
    'E-VVS1-EX-GOOD-FAINT': 8.37,
    'E-VVS2-GOOD-EX-NONE': 8.37,
    'E-VVS2-EX-GOOD-NONE': 8.37,
    'D-IF-VG-VG-STRONG': 8.36,
    'D-IF-GOOD-EX-STRONG': 8.35,
    'D-IF-EX-GOOD-STRONG': 8.35,
    'D-VVS1-VG-VG-MEDIUM': 8.35,
    'D-VVS2-VG-VG-FAINT': 8.35,
    'J-IF-EX-EX-NONE': 8.35,
    'D-VVS1-GOOD-EX-MEDIUM': 8.34,
    'D-VVS1-EX-GOOD-MEDIUM': 8.34,
    'D-VVS2-GOOD-EX-FAINT': 8.34,
    'D-VVS2-EX-GOOD-FAINT': 8.34,
    'D-VS1-VG-VG-NONE': 8.34,
    'D-VS1-GOOD-EX-NONE': 8.33,
    'D-VS1-EX-GOOD-NONE': 8.33,
    'F-IF-POOR-EX-NONE': 8.33,
    'F-IF-GOOD-VG-NONE': 8.33,
    'F-IF-VG-GOOD-NONE': 8.33,
    'F-IF-EX-POOR-NONE': 8.33,
    'I-IF-EX-EX-FAINT': 8.33,
    'I-VVS1-EX-EX-NONE': 8.32,
    'E-IF-POOR-EX-FAINT': 8.31,
    'E-IF-GOOD-VG-FAINT': 8.31,
    'E-IF-VG-GOOD-FAINT': 8.31,
    'E-IF-EX-POOR-FAINT': 8.31,
    'E-VVS1-POOR-EX-NONE': 8.3,
    'E-VVS1-GOOD-VG-NONE': 8.3,
    'E-VVS1-VG-GOOD-NONE': 8.3,
    'E-VVS1-EX-POOR-NONE': 8.3,
    'H-IF-EX-EX-MEDIUM': 8.3,
    'H-VVS1-EX-EX-FAINT': 8.29,
    'H-VVS2-EX-EX-NONE': 8.29,
    'D-IF-POOR-EX-MEDIUM': 8.28,
    'D-IF-GOOD-VG-MEDIUM': 8.28,
    'D-IF-VG-GOOD-MEDIUM': 8.28,
    'D-IF-EX-POOR-MEDIUM': 8.28,
    'G-IF-EX-EX-STRONG': 8.28,
    'D-VVS1-POOR-EX-FAINT': 8.27,
    'D-VVS1-GOOD-VG-FAINT': 8.27,
    'D-VVS1-VG-GOOD-FAINT': 8.27,
    'D-VVS1-EX-POOR-FAINT': 8.27,
    'D-VVS2-POOR-EX-NONE': 8.27,
    'D-VVS2-GOOD-VG-NONE': 8.27,
    'D-VVS2-VG-GOOD-NONE': 8.27,
    'D-VVS2-EX-POOR-NONE': 8.27,
    'G-VVS1-EX-EX-MEDIUM': 8.27,
    'G-VVS2-EX-EX-FAINT': 8.27,
    'G-VS1-EX-EX-NONE': 8.26,
    'I-IF-VG-EX-NONE': 8.26,
    'I-IF-EX-VG-NONE': 8.26,
    'E-IF-POOR-VG-NONE': 8.24,
    'E-IF-VG-POOR-NONE': 8.24,
    'F-VVS1-EX-EX-STRONG': 8.24,
    'F-VVS2-EX-EX-MEDIUM': 8.24,
    'E-IF-GOOD-GOOD-NONE': 8.23,
    'F-VS1-EX-EX-FAINT': 8.23,
    'F-VS2-EX-EX-NONE': 8.23,
    'H-IF-VG-EX-FAINT': 8.23,
    'H-IF-EX-VG-FAINT': 8.23,
    'E-VVS2-EX-EX-STRONG': 8.22,
    'H-VVS1-VG-EX-NONE': 8.22,
    'H-VVS1-EX-VG-NONE': 8.22,
    'D-IF-POOR-VG-FAINT': 8.21,
    'D-IF-VG-POOR-FAINT': 8.21,
    'E-VS1-EX-EX-MEDIUM': 8.21,
    'E-VS2-EX-EX-FAINT': 8.21,
    'G-IF-VG-EX-MEDIUM': 8.21,
    'G-IF-EX-VG-MEDIUM': 8.21,
    'D-IF-GOOD-GOOD-FAINT': 8.2,
    'D-VVS1-POOR-VG-NONE': 8.2,
    'D-VVS1-VG-POOR-NONE': 8.2,
    'E-SI1-EX-EX-NONE': 8.2,
    'G-VVS1-VG-EX-FAINT': 8.2,
    'G-VVS1-EX-VG-FAINT': 8.2,
    'G-VVS2-VG-EX-NONE': 8.2,
    'G-VVS2-EX-VG-NONE': 8.2,
    'D-VVS1-GOOD-GOOD-NONE': 8.19,
    'D-VS1-EX-EX-STRONG': 8.18,
    'D-VS2-EX-EX-MEDIUM': 8.18,
    'F-IF-VG-EX-STRONG': 8.18,
    'F-IF-EX-VG-STRONG': 8.18,
    'D-SI1-EX-EX-FAINT': 8.17,
    'D-SI2-EX-EX-NONE': 8.17,
    'F-VVS1-VG-EX-MEDIUM': 8.17,
    'F-VVS1-EX-VG-MEDIUM': 8.17,
    'F-VVS2-VG-EX-FAINT': 8.17,
    'F-VVS2-EX-VG-FAINT': 8.17,
    'F-VS1-VG-EX-NONE': 8.16,
    'F-VS1-EX-VG-NONE': 8.16,
    'H-IF-VG-VG-NONE': 8.16,
    'E-VVS1-VG-EX-STRONG': 8.15,
    'E-VVS1-EX-VG-STRONG': 8.15,
    'E-VVS2-VG-EX-MEDIUM': 8.15,
    'E-VVS2-EX-VG-MEDIUM': 8.15,
    'H-IF-GOOD-EX-NONE': 8.15,
    'H-IF-EX-GOOD-NONE': 8.15,
    'E-VS1-VG-EX-FAINT': 8.14,
    'E-VS1-EX-VG-FAINT': 8.14,
    'E-VS2-VG-EX-NONE': 8.14,
    'E-VS2-EX-VG-NONE': 8.14,
    'G-IF-VG-VG-FAINT': 8.14,
    'D-IF-POOR-GOOD-NONE': 8.13,
    'D-IF-GOOD-POOR-NONE': 8.13,
    'G-IF-GOOD-EX-FAINT': 8.13,
    'G-IF-EX-GOOD-FAINT': 8.13,
    'G-VVS1-VG-VG-NONE': 8.13,
    'D-VVS2-VG-EX-STRONG': 8.12,
    'D-VVS2-EX-VG-STRONG': 8.12,
    'G-VVS1-GOOD-EX-NONE': 8.12,
    'G-VVS1-EX-GOOD-NONE': 8.12,
    'D-VS1-VG-EX-MEDIUM': 8.11,
    'D-VS1-EX-VG-MEDIUM': 8.11,
    'D-VS2-VG-EX-FAINT': 8.11,
    'D-VS2-EX-VG-FAINT': 8.11,
    'F-IF-VG-VG-MEDIUM': 8.11,
    'D-SI1-VG-EX-NONE': 8.1,
    'D-SI1-EX-VG-NONE': 8.1,
    'F-IF-GOOD-EX-MEDIUM': 8.1,
    'F-IF-EX-GOOD-MEDIUM': 8.1,
    'F-VVS1-VG-VG-FAINT': 8.1,
    'F-VVS2-VG-VG-NONE': 8.1,
    'E-IF-VG-VG-STRONG': 8.09,
    'F-VVS1-GOOD-EX-FAINT': 8.09,
    'F-VVS1-EX-GOOD-FAINT': 8.09,
    'F-VVS2-GOOD-EX-NONE': 8.09,
    'F-VVS2-EX-GOOD-NONE': 8.09,
    'E-IF-GOOD-EX-STRONG': 8.08,
    'E-IF-EX-GOOD-STRONG': 8.08,
    'E-VVS1-VG-VG-MEDIUM': 8.08,
    'E-VVS2-VG-VG-FAINT': 8.08,
    'K-IF-EX-EX-NONE': 8.08,
    'E-VVS1-GOOD-EX-MEDIUM': 8.07,
    'E-VVS1-EX-GOOD-MEDIUM': 8.07,
    'E-VVS2-GOOD-EX-FAINT': 8.07,
    'E-VVS2-EX-GOOD-FAINT': 8.07,
    'E-VS1-VG-VG-NONE': 8.07,
    'E-VS1-GOOD-EX-NONE': 8.06,
    'E-VS1-EX-GOOD-NONE': 8.06,
    'G-IF-POOR-EX-NONE': 8.06,
    'G-IF-GOOD-VG-NONE': 8.06,
    'G-IF-VG-GOOD-NONE': 8.06,
    'G-IF-EX-POOR-NONE': 8.06,
    'D-VVS1-VG-VG-STRONG': 8.05,
    'D-VVS2-VG-VG-MEDIUM': 8.05,
    'J-IF-EX-EX-FAINT': 8.05,
    'D-VVS1-GOOD-EX-STRONG': 8.04,
    'D-VVS1-EX-GOOD-STRONG': 8.04,
    'D-VVS2-GOOD-EX-MEDIUM': 8.04,
    'D-VVS2-EX-GOOD-MEDIUM': 8.04,
    'D-VS1-VG-VG-FAINT': 8.04,
    'D-VS2-VG-VG-NONE': 8.04,
    'J-VVS1-EX-EX-NONE': 8.04,
    'D-VS1-GOOD-EX-FAINT': 8.03,
    'D-VS1-EX-GOOD-FAINT': 8.03,
    'D-VS2-GOOD-EX-NONE': 8.03,
    'D-VS2-EX-GOOD-NONE': 8.03,
    'F-IF-POOR-EX-FAINT': 8.03,
    'F-IF-GOOD-VG-FAINT': 8.03,
    'F-IF-VG-GOOD-FAINT': 8.03,
    'F-IF-EX-POOR-FAINT': 8.03,
    'I-IF-EX-EX-MEDIUM': 8.03,
    'F-VVS1-POOR-EX-NONE': 8.02,
    'F-VVS1-GOOD-VG-NONE': 8.02,
    'F-VVS1-VG-GOOD-NONE': 8.02,
    'F-VVS1-EX-POOR-NONE': 8.02,
    'I-VVS1-EX-EX-FAINT': 8.02,
    'I-VVS2-EX-EX-NONE': 8.02,
    'E-IF-POOR-EX-MEDIUM': 8.01,
    'E-IF-GOOD-VG-MEDIUM': 8.01,
    'E-IF-VG-GOOD-MEDIUM': 8.01,
    'E-IF-EX-POOR-MEDIUM': 8.01,
    'E-VVS1-POOR-EX-FAINT': 8.0,
    'E-VVS1-GOOD-VG-FAINT': 8.0,
    'E-VVS1-VG-GOOD-FAINT': 8.0,
    'E-VVS1-EX-POOR-FAINT': 8.0,
    'E-VVS2-POOR-EX-NONE': 8.0,
    'E-VVS2-GOOD-VG-NONE': 8.0,
    'E-VVS2-VG-GOOD-NONE': 8.0,
    'E-VVS2-EX-POOR-NONE': 8.0,
    'H-IF-EX-EX-STRONG': 8.0,
    'H-VVS1-EX-EX-MEDIUM': 7.99,
    'H-VVS2-EX-EX-FAINT': 7.99,
    'D-IF-POOR-EX-STRONG': 7.98,
    'D-IF-GOOD-VG-STRONG': 7.98,
    'D-IF-VG-GOOD-STRONG': 7.98,
    'D-IF-EX-POOR-STRONG': 7.98,
    'H-VS1-EX-EX-NONE': 7.98,
    'J-IF-VG-EX-NONE': 7.98,
    'J-IF-EX-VG-NONE': 7.98,
    'D-VVS1-POOR-EX-MEDIUM': 7.97,
    'D-VVS1-GOOD-VG-MEDIUM': 7.97,
    'D-VVS1-VG-GOOD-MEDIUM': 7.97,
    'D-VVS1-EX-POOR-MEDIUM': 7.97,
    'D-VVS2-POOR-EX-FAINT': 7.97,
    'D-VVS2-GOOD-VG-FAINT': 7.97,
    'D-VVS2-VG-GOOD-FAINT': 7.97,
    'D-VVS2-EX-POOR-FAINT': 7.97,
    'G-VVS1-EX-EX-STRONG': 7.97,
    'G-VVS2-EX-EX-MEDIUM': 7.97,
    'D-VS1-POOR-EX-NONE': 7.96,
    'D-VS1-GOOD-VG-NONE': 7.96,
    'D-VS1-VG-GOOD-NONE': 7.96,
    'D-VS1-EX-POOR-NONE': 7.96,
    'F-IF-POOR-VG-NONE': 7.96,
    'F-IF-VG-POOR-NONE': 7.96,
    'G-VS1-EX-EX-FAINT': 7.96,
    'G-VS2-EX-EX-NONE': 7.96,
    'I-IF-VG-EX-FAINT': 7.96,
    'I-IF-EX-VG-FAINT': 7.96,
    'F-IF-GOOD-GOOD-NONE': 7.95,
    'I-VVS1-VG-EX-NONE': 7.95,
    'I-VVS1-EX-VG-NONE': 7.95,
    'E-IF-POOR-VG-FAINT': 7.94,
    'E-IF-VG-POOR-FAINT': 7.94,
    'F-VVS2-EX-EX-STRONG': 7.94,
    'E-IF-GOOD-GOOD-FAINT': 7.93,
    'E-VVS1-POOR-VG-NONE': 7.93,
    'E-VVS1-VG-POOR-NONE': 7.93,
    'F-VS1-EX-EX-MEDIUM': 7.93,
    'F-VS2-EX-EX-FAINT': 7.93,
    'H-IF-VG-EX-MEDIUM': 7.93,
    'H-IF-EX-VG-MEDIUM': 7.93,
    'E-VVS1-GOOD-GOOD-NONE': 7.92,
    'F-SI1-EX-EX-NONE': 7.92,
    'H-VVS1-VG-EX-FAINT': 7.92,
    'H-VVS1-EX-VG-FAINT': 7.92,
    'H-VVS2-VG-EX-NONE': 7.92,
    'H-VVS2-EX-VG-NONE': 7.92,
    'D-IF-POOR-VG-MEDIUM': 7.91,
    'D-IF-VG-POOR-MEDIUM': 7.91,
    'E-VS1-EX-EX-STRONG': 7.91,
    'E-VS2-EX-EX-MEDIUM': 7.91,
    'G-IF-VG-EX-STRONG': 7.91,
    'G-IF-EX-VG-STRONG': 7.91,
    'D-IF-GOOD-GOOD-MEDIUM': 7.9,
    'D-VVS1-POOR-VG-FAINT': 7.9,
    'D-VVS1-VG-POOR-FAINT': 7.9,
    'D-VVS2-POOR-VG-NONE': 7.9,
    'D-VVS2-VG-POOR-NONE': 7.9,
    'E-SI1-EX-EX-FAINT': 7.9,
    'E-SI2-EX-EX-NONE': 7.9,
    'G-VVS1-VG-EX-MEDIUM': 7.9,
    'G-VVS1-EX-VG-MEDIUM': 7.9,
    'G-VVS2-VG-EX-FAINT': 7.9,
    'G-VVS2-EX-VG-FAINT': 7.9,
    'D-VVS1-GOOD-GOOD-FAINT': 7.89,
    'D-VVS2-GOOD-GOOD-NONE': 7.89,
    'G-VS1-VG-EX-NONE': 7.89,
    'G-VS1-EX-VG-NONE': 7.89,
    'I-IF-VG-VG-NONE': 7.89,
    'D-VS2-EX-EX-STRONG': 7.88,
    'I-IF-GOOD-EX-NONE': 7.88,
    'I-IF-EX-GOOD-NONE': 7.88,
    'D-SI1-EX-EX-MEDIUM': 7.87,
    'D-SI2-EX-EX-FAINT': 7.87,
    'F-VVS1-VG-EX-STRONG': 7.87,
    'F-VVS1-EX-VG-STRONG': 7.87,
    'F-VVS2-VG-EX-MEDIUM': 7.87,
    'F-VVS2-EX-VG-MEDIUM': 7.87,
    'D-I1-EX-EX-NONE': 7.86,
    'E-IF-POOR-GOOD-NONE': 7.86,
    'E-IF-GOOD-POOR-NONE': 7.86,
    'F-VS1-VG-EX-FAINT': 7.86,
    'F-VS1-EX-VG-FAINT': 7.86,
    'F-VS2-VG-EX-NONE': 7.86,
    'F-VS2-EX-VG-NONE': 7.86,
    'H-IF-VG-VG-FAINT': 7.86,
    'E-VVS2-VG-EX-STRONG': 7.85,
    'E-VVS2-EX-VG-STRONG': 7.85,
    'H-IF-GOOD-EX-FAINT': 7.85,
    'H-IF-EX-GOOD-FAINT': 7.85,
    'H-VVS1-VG-VG-NONE': 7.85,
    'E-VS1-VG-EX-MEDIUM': 7.84,
    'E-VS1-EX-VG-MEDIUM': 7.84,
    'E-VS2-VG-EX-FAINT': 7.84,
    'E-VS2-EX-VG-FAINT': 7.84,
    'G-IF-VG-VG-MEDIUM': 7.84,
    'H-VVS1-GOOD-EX-NONE': 7.84,
    'H-VVS1-EX-GOOD-NONE': 7.84,
    'D-IF-POOR-GOOD-FAINT': 7.83,
    'D-IF-GOOD-POOR-FAINT': 7.83,
    'E-SI1-VG-EX-NONE': 7.83,
    'E-SI1-EX-VG-NONE': 7.83,
    'G-IF-GOOD-EX-MEDIUM': 7.83,
    'G-IF-EX-GOOD-MEDIUM': 7.83,
    'G-VVS1-VG-VG-FAINT': 7.83,
    'G-VVS2-VG-VG-NONE': 7.83,
    'D-VVS1-POOR-GOOD-NONE': 7.82,
    'D-VVS1-GOOD-POOR-NONE': 7.82,
    'G-VVS1-GOOD-EX-FAINT': 7.82,
    'G-VVS1-EX-GOOD-FAINT': 7.82,
    'G-VVS2-GOOD-EX-NONE': 7.82,
    'G-VVS2-EX-GOOD-NONE': 7.82,
    'D-VS1-VG-EX-STRONG': 7.81,
    'D-VS1-EX-VG-STRONG': 7.81,
    'D-VS2-VG-EX-MEDIUM': 7.81,
    'D-VS2-EX-VG-MEDIUM': 7.81,
    'F-IF-VG-VG-STRONG': 7.81,
    'D-SI1-VG-EX-FAINT': 7.8,
    'D-SI1-EX-VG-FAINT': 7.8,
    'D-SI2-VG-EX-NONE': 7.8,
    'D-SI2-EX-VG-NONE': 7.8,
    'F-IF-GOOD-EX-STRONG': 7.8,
    'F-IF-EX-GOOD-STRONG': 7.8,
    'F-VVS1-VG-VG-MEDIUM': 7.8,
    'F-VVS2-VG-VG-FAINT': 7.8,
    'L-IF-EX-EX-NONE': 7.8,
    'F-VVS1-GOOD-EX-MEDIUM': 7.79,
    'F-VVS1-EX-GOOD-MEDIUM': 7.79,
    'F-VVS2-GOOD-EX-FAINT': 7.79,
    'F-VVS2-EX-GOOD-FAINT': 7.79,
    'F-VS1-VG-VG-NONE': 7.79,
    'E-VVS1-VG-VG-STRONG': 7.78,
    'E-VVS2-VG-VG-MEDIUM': 7.78,
    'F-VS1-GOOD-EX-NONE': 7.78,
    'F-VS1-EX-GOOD-NONE': 7.78,
    'H-IF-POOR-EX-NONE': 7.78,
    'H-IF-GOOD-VG-NONE': 7.78,
    'H-IF-VG-GOOD-NONE': 7.78,
    'H-IF-EX-POOR-NONE': 7.78,
    'K-IF-EX-EX-FAINT': 7.78,
    'E-VVS1-GOOD-EX-STRONG': 7.77,
    'E-VVS1-EX-GOOD-STRONG': 7.77,
    'E-VVS2-GOOD-EX-MEDIUM': 7.77,
    'E-VVS2-EX-GOOD-MEDIUM': 7.77,
    'E-VS1-VG-VG-FAINT': 7.77,
    'E-VS2-VG-VG-NONE': 7.77,
    'K-VVS1-EX-EX-NONE': 7.77,
    'D-IF-POOR-POOR-NONE': 7.76,
    'E-VS1-GOOD-EX-FAINT': 7.76,
    'E-VS1-EX-GOOD-FAINT': 7.76,
    'E-VS2-GOOD-EX-NONE': 7.76,
    'E-VS2-EX-GOOD-NONE': 7.76,
    'G-IF-POOR-EX-FAINT': 7.76,
    'G-IF-GOOD-VG-FAINT': 7.76,
    'G-IF-VG-GOOD-FAINT': 7.76,
    'G-IF-EX-POOR-FAINT': 7.76,
    'D-VVS2-VG-VG-STRONG': 7.75,
    'G-VVS1-POOR-EX-NONE': 7.75,
    'G-VVS1-GOOD-VG-NONE': 7.75,
    'G-VVS1-VG-GOOD-NONE': 7.75,
    'G-VVS1-EX-POOR-NONE': 7.75,
    'J-IF-EX-EX-MEDIUM': 7.75,
    'D-VVS2-GOOD-EX-STRONG': 7.74,
    'D-VVS2-EX-GOOD-STRONG': 7.74,
    'D-VS1-VG-VG-MEDIUM': 7.74,
    'D-VS2-VG-VG-FAINT': 7.74,
    'J-VVS1-EX-EX-FAINT': 7.74,
    'J-VVS2-EX-EX-NONE': 7.74,
    'D-VS1-GOOD-EX-MEDIUM': 7.73,
    'D-VS1-EX-GOOD-MEDIUM': 7.73,
    'D-VS2-GOOD-EX-FAINT': 7.73,
    'D-VS2-EX-GOOD-FAINT': 7.73,
    'D-SI1-VG-VG-NONE': 7.73,
    'F-IF-POOR-EX-MEDIUM': 7.73,
    'F-IF-GOOD-VG-MEDIUM': 7.73,
    'F-IF-VG-GOOD-MEDIUM': 7.73,
    'F-IF-EX-POOR-MEDIUM': 7.73,
    'I-IF-EX-EX-STRONG': 7.73,
    'D-SI1-GOOD-EX-NONE': 7.72,
    'D-SI1-EX-GOOD-NONE': 7.72,
    'F-VVS1-POOR-EX-FAINT': 7.72,
    'F-VVS1-GOOD-VG-FAINT': 7.72,
    'F-VVS1-VG-GOOD-FAINT': 7.72,
    'F-VVS1-EX-POOR-FAINT': 7.72,
    'F-VVS2-POOR-EX-NONE': 7.72,
    'F-VVS2-GOOD-VG-NONE': 7.72,
    'F-VVS2-VG-GOOD-NONE': 7.72,
    'F-VVS2-EX-POOR-NONE': 7.72,
    'I-VVS1-EX-EX-MEDIUM': 7.72,
    'I-VVS2-EX-EX-FAINT': 7.72,
    'E-IF-POOR-EX-STRONG': 7.71,
    'E-IF-GOOD-VG-STRONG': 7.71,
    'E-IF-VG-GOOD-STRONG': 7.71,
    'E-IF-EX-POOR-STRONG': 7.71,
    'I-VS1-EX-EX-NONE': 7.71,
    'K-IF-VG-EX-NONE': 7.71,
    'K-IF-EX-VG-NONE': 7.71,
    'E-VVS1-POOR-EX-MEDIUM': 7.7,
    'E-VVS1-GOOD-VG-MEDIUM': 7.7,
    'E-VVS1-VG-GOOD-MEDIUM': 7.7,
    'E-VVS1-EX-POOR-MEDIUM': 7.7,
    'E-VVS2-POOR-EX-FAINT': 7.7,
    'E-VVS2-GOOD-VG-FAINT': 7.7,
    'E-VVS2-VG-GOOD-FAINT': 7.7,
    'E-VVS2-EX-POOR-FAINT': 7.7,
    'E-VS1-POOR-EX-NONE': 7.69,
    'E-VS1-GOOD-VG-NONE': 7.69,
    'E-VS1-VG-GOOD-NONE': 7.69,
    'E-VS1-EX-POOR-NONE': 7.69,
    'G-IF-POOR-VG-NONE': 7.69,
    'G-IF-VG-POOR-NONE': 7.69,
    'H-VVS1-EX-EX-STRONG': 7.69,
    'H-VVS2-EX-EX-MEDIUM': 7.69,
    'G-IF-GOOD-GOOD-NONE': 7.68,
    'H-VS1-EX-EX-FAINT': 7.68,
    'H-VS2-EX-EX-NONE': 7.68,
    'J-IF-VG-EX-FAINT': 7.68,
    'J-IF-EX-VG-FAINT': 7.68,
    'D-VVS1-POOR-EX-STRONG': 7.67,
    'D-VVS1-GOOD-VG-STRONG': 7.67,
    'D-VVS1-VG-GOOD-STRONG': 7.67,
    'D-VVS1-EX-POOR-STRONG': 7.67,
    'D-VVS2-POOR-EX-MEDIUM': 7.67,
    'D-VVS2-GOOD-VG-MEDIUM': 7.67,
    'D-VVS2-VG-GOOD-MEDIUM': 7.67,
    'D-VVS2-EX-POOR-MEDIUM': 7.67,
    'G-VVS2-EX-EX-STRONG': 7.67,
    'J-VVS1-VG-EX-NONE': 7.67,
    'J-VVS1-EX-VG-NONE': 7.67,
    'D-VS1-POOR-EX-FAINT': 7.66,
    'D-VS1-GOOD-VG-FAINT': 7.66,
    'D-VS1-VG-GOOD-FAINT': 7.66,
    'D-VS1-EX-POOR-FAINT': 7.66,
    'D-VS2-POOR-EX-NONE': 7.66,
    'D-VS2-GOOD-VG-NONE': 7.66,
    'D-VS2-VG-GOOD-NONE': 7.66,
    'D-VS2-EX-POOR-NONE': 7.66,
    'F-IF-POOR-VG-FAINT': 7.66,
    'F-IF-VG-POOR-FAINT': 7.66,
    'G-VS1-EX-EX-MEDIUM': 7.66,
    'G-VS2-EX-EX-FAINT': 7.66,
    'I-IF-VG-EX-MEDIUM': 7.66,
    'I-IF-EX-VG-MEDIUM': 7.66,
    'F-IF-GOOD-GOOD-FAINT': 7.65,
    'F-VVS1-POOR-VG-NONE': 7.65,
    'F-VVS1-VG-POOR-NONE': 7.65,
    'G-SI1-EX-EX-NONE': 7.65,
    'I-VVS1-VG-EX-FAINT': 7.65,
    'I-VVS1-EX-VG-FAINT': 7.65,
    'I-VVS2-VG-EX-NONE': 7.65,
    'I-VVS2-EX-VG-NONE': 7.65,
    'E-IF-POOR-VG-MEDIUM': 7.64,
    'E-IF-VG-POOR-MEDIUM': 7.64,
    'F-VVS1-GOOD-GOOD-NONE': 7.64,
    'E-IF-GOOD-GOOD-MEDIUM': 7.63,
    'E-VVS1-POOR-VG-FAINT': 7.63,
    'E-VVS1-VG-POOR-FAINT': 7.63,
    'E-VVS2-POOR-VG-NONE': 7.63,
    'E-VVS2-VG-POOR-NONE': 7.63,
    'F-VS1-EX-EX-STRONG': 7.63,
    'F-VS2-EX-EX-MEDIUM': 7.63,
    'H-IF-VG-EX-STRONG': 7.63,
    'H-IF-EX-VG-STRONG': 7.63,
    'E-VVS1-GOOD-GOOD-FAINT': 7.62,
    'E-VVS2-GOOD-GOOD-NONE': 7.62,
    'F-SI1-EX-EX-FAINT': 7.62,
    'F-SI2-EX-EX-NONE': 7.62,
    'H-VVS1-VG-EX-MEDIUM': 7.62,
    'H-VVS1-EX-VG-MEDIUM': 7.62,
    'H-VVS2-VG-EX-FAINT': 7.62,
    'H-VVS2-EX-VG-FAINT': 7.62,
    'D-IF-POOR-VG-STRONG': 7.61,
    'D-IF-VG-POOR-STRONG': 7.61,
    'E-VS2-EX-EX-STRONG': 7.61,
    'H-VS1-VG-EX-NONE': 7.61,
    'H-VS1-EX-VG-NONE': 7.61,
    'J-IF-VG-VG-NONE': 7.61,
    'D-IF-GOOD-GOOD-STRONG': 7.6,
    'D-VVS1-POOR-VG-MEDIUM': 7.6,
    'D-VVS1-VG-POOR-MEDIUM': 7.6,
    'D-VVS2-POOR-VG-FAINT': 7.6,
    'D-VVS2-VG-POOR-FAINT': 7.6,
    'E-SI1-EX-EX-MEDIUM': 7.6,
    'E-SI2-EX-EX-FAINT': 7.6,
    'G-VVS1-VG-EX-STRONG': 7.6,
    'G-VVS1-EX-VG-STRONG': 7.6,
    'G-VVS2-VG-EX-MEDIUM': 7.6,
    'G-VVS2-EX-VG-MEDIUM': 7.6,
    'J-IF-GOOD-EX-NONE': 7.6,
    'J-IF-EX-GOOD-NONE': 7.6,
    'D-VVS1-GOOD-GOOD-MEDIUM': 7.59,
    'D-VVS2-GOOD-GOOD-FAINT': 7.59,
    'D-VS1-POOR-VG-NONE': 7.59,
    'D-VS1-VG-POOR-NONE': 7.59,
    'E-I1-EX-EX-NONE': 7.59,
    'G-VS1-VG-EX-FAINT': 7.59,
    'G-VS1-EX-VG-FAINT': 7.59,
    'G-VS2-VG-EX-NONE': 7.59,
    'G-VS2-EX-VG-NONE': 7.59,
    'I-IF-VG-VG-FAINT': 7.59,
    'D-VS1-GOOD-GOOD-NONE': 7.58,
    'F-IF-POOR-GOOD-NONE': 7.58,
    'F-IF-GOOD-POOR-NONE': 7.58,
    'I-IF-GOOD-EX-FAINT': 7.58,
    'I-IF-EX-GOOD-FAINT': 7.58,
    'I-VVS1-VG-VG-NONE': 7.58,
    'D-SI1-EX-EX-STRONG': 7.57,
    'D-SI2-EX-EX-MEDIUM': 7.57,
    'F-VVS2-VG-EX-STRONG': 7.57,
    'F-VVS2-EX-VG-STRONG': 7.57,
    'I-VVS1-GOOD-EX-NONE': 7.57,
    'I-VVS1-EX-GOOD-NONE': 7.57,
    'D-I1-EX-EX-FAINT': 7.56,
    'D-I2-EX-EX-NONE': 7.56,
    'E-IF-POOR-GOOD-FAINT': 7.56,
    'E-IF-GOOD-POOR-FAINT': 7.56,
    'F-VS1-VG-EX-MEDIUM': 7.56,
    'F-VS1-EX-VG-MEDIUM': 7.56,
    'F-VS2-VG-EX-FAINT': 7.56,
    'F-VS2-EX-VG-FAINT': 7.56,
    'H-IF-VG-VG-MEDIUM': 7.56,
    'E-VVS1-POOR-GOOD-NONE': 7.55,
    'E-VVS1-GOOD-POOR-NONE': 7.55,
    'F-SI1-VG-EX-NONE': 7.55,
    'F-SI1-EX-VG-NONE': 7.55,
    'H-IF-GOOD-EX-MEDIUM': 7.55,
    'H-IF-EX-GOOD-MEDIUM': 7.55,
    'H-VVS1-VG-VG-FAINT': 7.55,
    'H-VVS2-VG-VG-NONE': 7.55,
    'E-VS1-VG-EX-STRONG': 7.54,
    'E-VS1-EX-VG-STRONG': 7.54,
    'E-VS2-VG-EX-MEDIUM': 7.54,
    'E-VS2-EX-VG-MEDIUM': 7.54,
    'G-IF-VG-VG-STRONG': 7.54,
    'H-VVS1-GOOD-EX-FAINT': 7.54,
    'H-VVS1-EX-GOOD-FAINT': 7.54,
    'H-VVS2-GOOD-EX-NONE': 7.54,
    'H-VVS2-EX-GOOD-NONE': 7.54,
    'D-IF-POOR-GOOD-MEDIUM': 7.53,
    'D-IF-GOOD-POOR-MEDIUM': 7.53,
    'E-SI1-VG-EX-FAINT': 7.53,
    'E-SI1-EX-VG-FAINT': 7.53,
    'E-SI2-VG-EX-NONE': 7.53,
    'E-SI2-EX-VG-NONE': 7.53,
    'G-IF-GOOD-EX-STRONG': 7.53,
    'G-IF-EX-GOOD-STRONG': 7.53,
    'G-VVS1-VG-VG-MEDIUM': 7.53,
    'G-VVS2-VG-VG-FAINT': 7.53,
    'M-IF-EX-EX-NONE': 7.53,
    'D-VVS1-POOR-GOOD-FAINT': 7.52,
    'D-VVS1-GOOD-POOR-FAINT': 7.52,
    'D-VVS2-POOR-GOOD-NONE': 7.52,
    'D-VVS2-GOOD-POOR-NONE': 7.52,
    'G-VVS1-GOOD-EX-MEDIUM': 7.52,
    'G-VVS1-EX-GOOD-MEDIUM': 7.52,
    'G-VVS2-GOOD-EX-FAINT': 7.52,
    'G-VVS2-EX-GOOD-FAINT': 7.52,
    'G-VS1-VG-VG-NONE': 7.52,
    'D-VS2-VG-EX-STRONG': 7.51,
    'D-VS2-EX-VG-STRONG': 7.51,
    'G-VS1-GOOD-EX-NONE': 7.51,
    'G-VS1-EX-GOOD-NONE': 7.51,
    'I-IF-POOR-EX-NONE': 7.51,
    'I-IF-GOOD-VG-NONE': 7.51,
    'I-IF-VG-GOOD-NONE': 7.51,
    'I-IF-EX-POOR-NONE': 7.51,
    'D-SI1-VG-EX-MEDIUM': 7.5,
    'D-SI1-EX-VG-MEDIUM': 7.5,
    'D-SI2-VG-EX-FAINT': 7.5,
    'D-SI2-EX-VG-FAINT': 7.5,
    'F-VVS1-VG-VG-STRONG': 7.5,
    'F-VVS2-VG-VG-MEDIUM': 7.5,
    'L-IF-EX-EX-FAINT': 7.5,
    'D-I1-VG-EX-NONE': 7.49,
    'D-I1-EX-VG-NONE': 7.49,
    'E-IF-POOR-POOR-NONE': 7.49,
    'F-VVS1-GOOD-EX-STRONG': 7.49,
    'F-VVS1-EX-GOOD-STRONG': 7.49,
    'F-VVS2-GOOD-EX-MEDIUM': 7.49,
    'F-VVS2-EX-GOOD-MEDIUM': 7.49,
    'F-VS1-VG-VG-FAINT': 7.49,
    'F-VS2-VG-VG-NONE': 7.49,
    'L-VVS1-EX-EX-NONE': 7.49,
    'E-VVS2-VG-VG-STRONG': 7.48,
    'F-VS1-GOOD-EX-FAINT': 7.48,
    'F-VS1-EX-GOOD-FAINT': 7.48,
    'F-VS2-GOOD-EX-NONE': 7.48,
    'F-VS2-EX-GOOD-NONE': 7.48,
    'H-IF-POOR-EX-FAINT': 7.48,
    'H-IF-GOOD-VG-FAINT': 7.48,
    'H-IF-VG-GOOD-FAINT': 7.48,
    'H-IF-EX-POOR-FAINT': 7.48,
    'K-IF-EX-EX-MEDIUM': 7.48,
    'E-VVS2-GOOD-EX-STRONG': 7.47,
    'E-VVS2-EX-GOOD-STRONG': 7.47,
    'E-VS1-VG-VG-MEDIUM': 7.47,
    'E-VS2-VG-VG-FAINT': 7.47,
    'H-VVS1-POOR-EX-NONE': 7.47,
    'H-VVS1-GOOD-VG-NONE': 7.47,
    'H-VVS1-VG-GOOD-NONE': 7.47,
    'H-VVS1-EX-POOR-NONE': 7.47,
    'K-VVS1-EX-EX-FAINT': 7.47,
    'K-VVS2-EX-EX-NONE': 7.47,
    'D-IF-POOR-POOR-FAINT': 7.46,
    'E-VS1-GOOD-EX-MEDIUM': 7.46,
    'E-VS1-EX-GOOD-MEDIUM': 7.46,
    'E-VS2-GOOD-EX-FAINT': 7.46,
    'E-VS2-EX-GOOD-FAINT': 7.46,
    'E-SI1-VG-VG-NONE': 7.46,
    'G-IF-POOR-EX-MEDIUM': 7.46,
    'G-IF-GOOD-VG-MEDIUM': 7.46,
    'G-IF-VG-GOOD-MEDIUM': 7.46,
    'G-IF-EX-POOR-MEDIUM': 7.46,
    'D-VVS1-POOR-POOR-NONE': 7.45,
    'E-SI1-GOOD-EX-NONE': 7.45,
    'E-SI1-EX-GOOD-NONE': 7.45,
    'G-VVS1-POOR-EX-FAINT': 7.45,
    'G-VVS1-GOOD-VG-FAINT': 7.45,
    'G-VVS1-VG-GOOD-FAINT': 7.45,
    'G-VVS1-EX-POOR-FAINT': 7.45,
    'G-VVS2-POOR-EX-NONE': 7.45,
    'G-VVS2-GOOD-VG-NONE': 7.45,
    'G-VVS2-VG-GOOD-NONE': 7.45,
    'G-VVS2-EX-POOR-NONE': 7.45,
    'J-IF-EX-EX-STRONG': 7.45,
    'D-VS1-VG-VG-STRONG': 7.44,
    'D-VS2-VG-VG-MEDIUM': 7.44,
    'J-VVS1-EX-EX-MEDIUM': 7.44,
    'J-VVS2-EX-EX-FAINT': 7.44,
    'D-VS1-GOOD-EX-STRONG': 7.43,
    'D-VS1-EX-GOOD-STRONG': 7.43,
    'D-VS2-GOOD-EX-MEDIUM': 7.43,
    'D-VS2-EX-GOOD-MEDIUM': 7.43,
    'D-SI1-VG-VG-FAINT': 7.43,
    'D-SI2-VG-VG-NONE': 7.43,
    'F-IF-POOR-EX-STRONG': 7.43,
    'F-IF-GOOD-VG-STRONG': 7.43,
    'F-IF-VG-GOOD-STRONG': 7.43,
    'F-IF-EX-POOR-STRONG': 7.43,
    'J-VS1-EX-EX-NONE': 7.43,
    'L-IF-VG-EX-NONE': 7.43,
    'L-IF-EX-VG-NONE': 7.43,
    'D-SI1-GOOD-EX-FAINT': 7.42,
    'D-SI1-EX-GOOD-FAINT': 7.42,
    'D-SI2-GOOD-EX-NONE': 7.42,
    'D-SI2-EX-GOOD-NONE': 7.42,
    'F-VVS1-POOR-EX-MEDIUM': 7.42,
    'F-VVS1-GOOD-VG-MEDIUM': 7.42,
    'F-VVS1-VG-GOOD-MEDIUM': 7.42,
    'F-VVS1-EX-POOR-MEDIUM': 7.42,
    'F-VVS2-POOR-EX-FAINT': 7.42,
    'F-VVS2-GOOD-VG-FAINT': 7.42,
    'F-VVS2-VG-GOOD-FAINT': 7.42,
    'F-VVS2-EX-POOR-FAINT': 7.42,
    'I-VVS1-EX-EX-STRONG': 7.42,
    'I-VVS2-EX-EX-MEDIUM': 7.42,
    'F-VS1-POOR-EX-NONE': 7.41,
    'F-VS1-GOOD-VG-NONE': 7.41,
    'F-VS1-VG-GOOD-NONE': 7.41,
    'F-VS1-EX-POOR-NONE': 7.41,
    'H-IF-POOR-VG-NONE': 7.41,
    'H-IF-VG-POOR-NONE': 7.41,
    'I-VS1-EX-EX-FAINT': 7.41,
    'I-VS2-EX-EX-NONE': 7.41,
    'K-IF-VG-EX-FAINT': 7.41,
    'K-IF-EX-VG-FAINT': 7.41,
    'E-VVS1-POOR-EX-STRONG': 7.4,
    'E-VVS1-GOOD-VG-STRONG': 7.4,
    'E-VVS1-VG-GOOD-STRONG': 7.4,
    'E-VVS1-EX-POOR-STRONG': 7.4,
    'E-VVS2-POOR-EX-MEDIUM': 7.4,
    'E-VVS2-GOOD-VG-MEDIUM': 7.4,
    'E-VVS2-VG-GOOD-MEDIUM': 7.4,
    'E-VVS2-EX-POOR-MEDIUM': 7.4,
    'H-IF-GOOD-GOOD-NONE': 7.4,
    'K-VVS1-VG-EX-NONE': 7.4,
    'K-VVS1-EX-VG-NONE': 7.4,
    'E-VS1-POOR-EX-FAINT': 7.39,
    'E-VS1-GOOD-VG-FAINT': 7.39,
    'E-VS1-VG-GOOD-FAINT': 7.39,
    'E-VS1-EX-POOR-FAINT': 7.39,
    'E-VS2-POOR-EX-NONE': 7.39,
    'E-VS2-GOOD-VG-NONE': 7.39,
    'E-VS2-VG-GOOD-NONE': 7.39,
    'E-VS2-EX-POOR-NONE': 7.39,
    'G-IF-POOR-VG-FAINT': 7.39,
    'G-IF-VG-POOR-FAINT': 7.39,
    'H-VVS2-EX-EX-STRONG': 7.39,
    'G-IF-GOOD-GOOD-FAINT': 7.38,
    'G-VVS1-POOR-VG-NONE': 7.38,
    'G-VVS1-VG-POOR-NONE': 7.38,
    'H-VS1-EX-EX-MEDIUM': 7.38,
    'H-VS2-EX-EX-FAINT': 7.38,
    'J-IF-VG-EX-MEDIUM': 7.38,
    'J-IF-EX-VG-MEDIUM': 7.38,
    'D-VVS2-POOR-EX-STRONG': 7.37,
    'D-VVS2-GOOD-VG-STRONG': 7.37,
    'D-VVS2-VG-GOOD-STRONG': 7.37,
    'D-VVS2-EX-POOR-STRONG': 7.37,
    'G-VVS1-GOOD-GOOD-NONE': 7.37,
    'H-SI1-EX-EX-NONE': 7.37,
    'J-VVS1-VG-EX-FAINT': 7.37,
    'J-VVS1-EX-VG-FAINT': 7.37,
    'J-VVS2-VG-EX-NONE': 7.37,
    'J-VVS2-EX-VG-NONE': 7.37,
    'D-VS1-POOR-EX-MEDIUM': 7.36,
    'D-VS1-GOOD-VG-MEDIUM': 7.36,
    'D-VS1-VG-GOOD-MEDIUM': 7.36,
    'D-VS1-EX-POOR-MEDIUM': 7.36,
    'D-VS2-POOR-EX-FAINT': 7.36,
    'D-VS2-GOOD-VG-FAINT': 7.36,
    'D-VS2-VG-GOOD-FAINT': 7.36,
    'D-VS2-EX-POOR-FAINT': 7.36,
    'F-IF-POOR-VG-MEDIUM': 7.36,
    'F-IF-VG-POOR-MEDIUM': 7.36,
    'G-VS1-EX-EX-STRONG': 7.36,
    'G-VS2-EX-EX-MEDIUM': 7.36,
    'I-IF-VG-EX-STRONG': 7.36,
    'I-IF-EX-VG-STRONG': 7.36,
    'D-SI1-POOR-EX-NONE': 7.35,
    'D-SI1-GOOD-VG-NONE': 7.35,
    'D-SI1-VG-GOOD-NONE': 7.35,
    'D-SI1-EX-POOR-NONE': 7.35,
    'F-IF-GOOD-GOOD-MEDIUM': 7.35,
    'F-VVS1-POOR-VG-FAINT': 7.35,
    'F-VVS1-VG-POOR-FAINT': 7.35,
    'F-VVS2-POOR-VG-NONE': 7.35,
    'F-VVS2-VG-POOR-NONE': 7.35,
    'G-SI1-EX-EX-FAINT': 7.35,
    'G-SI2-EX-EX-NONE': 7.35,
    'I-VVS1-VG-EX-MEDIUM': 7.35,
    'I-VVS1-EX-VG-MEDIUM': 7.35,
    'I-VVS2-VG-EX-FAINT': 7.35,
    'I-VVS2-EX-VG-FAINT': 7.35,
    'E-IF-POOR-VG-STRONG': 7.34,
    'E-IF-VG-POOR-STRONG': 7.34,
    'F-VVS1-GOOD-GOOD-FAINT': 7.34,
    'F-VVS2-GOOD-GOOD-NONE': 7.34,
    'I-VS1-VG-EX-NONE': 7.34,
    'I-VS1-EX-VG-NONE': 7.34,
    'K-IF-VG-VG-NONE': 7.34,
    'E-IF-GOOD-GOOD-STRONG': 7.33,
    'E-VVS1-POOR-VG-MEDIUM': 7.33,
    'E-VVS1-VG-POOR-MEDIUM': 7.33,
    'E-VVS2-POOR-VG-FAINT': 7.33,
    'E-VVS2-VG-POOR-FAINT': 7.33,
    'F-VS2-EX-EX-STRONG': 7.33,
    'K-IF-GOOD-EX-NONE': 7.33,
    'K-IF-EX-GOOD-NONE': 7.33,
    'E-VVS1-GOOD-GOOD-MEDIUM': 7.32,
    'E-VVS2-GOOD-GOOD-FAINT': 7.32,
    'E-VS1-POOR-VG-NONE': 7.32,
    'E-VS1-VG-POOR-NONE': 7.32,
    'F-SI1-EX-EX-MEDIUM': 7.32,
    'F-SI2-EX-EX-FAINT': 7.32,
    'H-VVS1-VG-EX-STRONG': 7.32,
    'H-VVS1-EX-VG-STRONG': 7.32,
    'H-VVS2-VG-EX-MEDIUM': 7.32,
    'H-VVS2-EX-VG-MEDIUM': 7.32,
    'E-VS1-GOOD-GOOD-NONE': 7.31,
    'F-I1-EX-EX-NONE': 7.31,
    'G-IF-POOR-GOOD-NONE': 7.31,
    'G-IF-GOOD-POOR-NONE': 7.31,
    'H-VS1-VG-EX-FAINT': 7.31,
    'H-VS1-EX-VG-FAINT': 7.31,
    'H-VS2-VG-EX-NONE': 7.31,
    'H-VS2-EX-VG-NONE': 7.31,
    'J-IF-VG-VG-FAINT': 7.31,
    'D-VVS1-POOR-VG-STRONG': 7.3,
    'D-VVS1-VG-POOR-STRONG': 7.3,
    'D-VVS2-POOR-VG-MEDIUM': 7.3,
    'D-VVS2-VG-POOR-MEDIUM': 7.3,
    'E-SI1-EX-EX-STRONG': 7.3,
    'E-SI2-EX-EX-MEDIUM': 7.3,
    'G-VVS2-VG-EX-STRONG': 7.3,
    'G-VVS2-EX-VG-STRONG': 7.3,
    'J-IF-GOOD-EX-FAINT': 7.3,
    'J-IF-EX-GOOD-FAINT': 7.3,
    'J-VVS1-VG-VG-NONE': 7.3,
    'D-VVS1-GOOD-GOOD-STRONG': 7.29,
    'D-VVS2-GOOD-GOOD-MEDIUM': 7.29,
    'D-VS1-POOR-VG-FAINT': 7.29,
    'D-VS1-VG-POOR-FAINT': 7.29,
    'D-VS2-POOR-VG-NONE': 7.29,
    'D-VS2-VG-POOR-NONE': 7.29,
    'E-I1-EX-EX-FAINT': 7.29,
    'E-I2-EX-EX-NONE': 7.29,
    'G-VS1-VG-EX-MEDIUM': 7.29,
    'G-VS1-EX-VG-MEDIUM': 7.29,
    'G-VS2-VG-EX-FAINT': 7.29,
    'G-VS2-EX-VG-FAINT': 7.29,
    'I-IF-VG-VG-MEDIUM': 7.29,
    'J-VVS1-GOOD-EX-NONE': 7.29,
    'J-VVS1-EX-GOOD-NONE': 7.29,
    'D-VS1-GOOD-GOOD-FAINT': 7.28,
    'D-VS2-GOOD-GOOD-NONE': 7.28,
    'F-IF-POOR-GOOD-FAINT': 7.28,
    'F-IF-GOOD-POOR-FAINT': 7.28,
    'G-SI1-VG-EX-NONE': 7.28,
    'G-SI1-EX-VG-NONE': 7.28,
    'I-IF-GOOD-EX-MEDIUM': 7.28,
    'I-IF-EX-GOOD-MEDIUM': 7.28,
    'I-VVS1-VG-VG-FAINT': 7.28,
    'I-VVS2-VG-VG-NONE': 7.28,
    'D-SI2-EX-EX-STRONG': 7.27,
    'F-VVS1-POOR-GOOD-NONE': 7.27,
    'F-VVS1-GOOD-POOR-NONE': 7.27,
    'I-VVS1-GOOD-EX-FAINT': 7.27,
    'I-VVS1-EX-GOOD-FAINT': 7.27,
    'I-VVS2-GOOD-EX-NONE': 7.27,
    'I-VVS2-EX-GOOD-NONE': 7.27,
    'D-I1-EX-EX-MEDIUM': 7.26,
    'D-I2-EX-EX-FAINT': 7.26,
    'E-IF-POOR-GOOD-MEDIUM': 7.26,
    'E-IF-GOOD-POOR-MEDIUM': 7.26,
    'F-VS1-VG-EX-STRONG': 7.26,
    'F-VS1-EX-VG-STRONG': 7.26,
    'F-VS2-VG-EX-MEDIUM': 7.26,
    'F-VS2-EX-VG-MEDIUM': 7.26,
    'H-IF-VG-VG-STRONG': 7.26,
    'E-VVS1-POOR-GOOD-FAINT': 7.25,
    'E-VVS1-GOOD-POOR-FAINT': 7.25,
    'E-VVS2-POOR-GOOD-NONE': 7.25,
    'E-VVS2-GOOD-POOR-NONE': 7.25,
    'F-SI1-VG-EX-FAINT': 7.25,
    'F-SI1-EX-VG-FAINT': 7.25,
    'F-SI2-VG-EX-NONE': 7.25,
    'F-SI2-EX-VG-NONE': 7.25,
    'H-IF-GOOD-EX-STRONG': 7.25,
    'H-IF-EX-GOOD-STRONG': 7.25,
    'H-VVS1-VG-VG-MEDIUM': 7.25,
    'H-VVS2-VG-VG-FAINT': 7.25,
    'E-VS2-VG-EX-STRONG': 7.24,
    'E-VS2-EX-VG-STRONG': 7.24,
    'H-VVS1-GOOD-EX-MEDIUM': 7.24,
    'H-VVS1-EX-GOOD-MEDIUM': 7.24,
    'H-VVS2-GOOD-EX-FAINT': 7.24,
    'H-VVS2-EX-GOOD-FAINT': 7.24,
    'H-VS1-VG-VG-NONE': 7.24,
    'D-IF-POOR-GOOD-STRONG': 7.23,
    'D-IF-GOOD-POOR-STRONG': 7.23,
    'E-SI1-VG-EX-MEDIUM': 7.23,
    'E-SI1-EX-VG-MEDIUM': 7.23,
    'E-SI2-VG-EX-FAINT': 7.23,
    'E-SI2-EX-VG-FAINT': 7.23,
    'G-VVS1-VG-VG-STRONG': 7.23,
    'G-VVS2-VG-VG-MEDIUM': 7.23,
    'H-VS1-GOOD-EX-NONE': 7.23,
    'H-VS1-EX-GOOD-NONE': 7.23,
    'J-IF-POOR-EX-NONE': 7.23,
    'J-IF-GOOD-VG-NONE': 7.23,
    'J-IF-VG-GOOD-NONE': 7.23,
    'J-IF-EX-POOR-NONE': 7.23,
    'M-IF-EX-EX-FAINT': 7.23,
    'D-VVS1-POOR-GOOD-MEDIUM': 7.22,
    'D-VVS1-GOOD-POOR-MEDIUM': 7.22,
    'D-VVS2-POOR-GOOD-FAINT': 7.22,
    'D-VVS2-GOOD-POOR-FAINT': 7.22,
    'E-I1-VG-EX-NONE': 7.22,
    'E-I1-EX-VG-NONE': 7.22,
    'G-VVS1-GOOD-EX-STRONG': 7.22,
    'G-VVS1-EX-GOOD-STRONG': 7.22,
    'G-VVS2-GOOD-EX-MEDIUM': 7.22,
    'G-VVS2-EX-GOOD-MEDIUM': 7.22,
    'G-VS1-VG-VG-FAINT': 7.22,
    'G-VS2-VG-VG-NONE': 7.22,
    'M-VVS1-EX-EX-NONE': 7.22,
    'D-VS1-POOR-GOOD-NONE': 7.21,
    'D-VS1-GOOD-POOR-NONE': 7.21,
    'F-IF-POOR-POOR-NONE': 7.21,
    'G-VS1-GOOD-EX-FAINT': 7.21,
    'G-VS1-EX-GOOD-FAINT': 7.21,
    'G-VS2-GOOD-EX-NONE': 7.21,
    'G-VS2-EX-GOOD-NONE': 7.21,
    'I-IF-POOR-EX-FAINT': 7.21,
    'I-IF-GOOD-VG-FAINT': 7.21,
    'I-IF-VG-GOOD-FAINT': 7.21,
    'I-IF-EX-POOR-FAINT': 7.21,
    'D-SI1-VG-EX-STRONG': 7.2,
    'D-SI1-EX-VG-STRONG': 7.2,
    'D-SI2-VG-EX-MEDIUM': 7.2,
    'D-SI2-EX-VG-MEDIUM': 7.2,
    'F-VVS2-VG-VG-STRONG': 7.2,
    'I-VVS1-POOR-EX-NONE': 7.2,
    'I-VVS1-GOOD-VG-NONE': 7.2,
    'I-VVS1-VG-GOOD-NONE': 7.2,
    'I-VVS1-EX-POOR-NONE': 7.2,
    'L-IF-EX-EX-MEDIUM': 7.2,
    'D-I1-VG-EX-FAINT': 7.19,
    'D-I1-EX-VG-FAINT': 7.19,
    'D-I2-VG-EX-NONE': 7.19,
    'D-I2-EX-VG-NONE': 7.19,
    'E-IF-POOR-POOR-FAINT': 7.19,
    'F-VVS2-GOOD-EX-STRONG': 7.19,
    'F-VVS2-EX-GOOD-STRONG': 7.19,
    'F-VS1-VG-VG-MEDIUM': 7.19,
    'F-VS2-VG-VG-FAINT': 7.19,
    'L-VVS1-EX-EX-FAINT': 7.19,
    'L-VVS2-EX-EX-NONE': 7.19,
    'E-VVS1-POOR-POOR-NONE': 7.18,
    'F-VS1-GOOD-EX-MEDIUM': 7.18,
    'F-VS1-EX-GOOD-MEDIUM': 7.18,
    'F-VS2-GOOD-EX-FAINT': 7.18,
    'F-VS2-EX-GOOD-FAINT': 7.18,
    'F-SI1-VG-VG-NONE': 7.18,
    'H-IF-POOR-EX-MEDIUM': 7.18,
    'H-IF-GOOD-VG-MEDIUM': 7.18,
    'H-IF-VG-GOOD-MEDIUM': 7.18,
    'H-IF-EX-POOR-MEDIUM': 7.18,
    'K-IF-EX-EX-STRONG': 7.18,
    'E-VS1-VG-VG-STRONG': 7.17,
    'E-VS2-VG-VG-MEDIUM': 7.17,
    'F-SI1-GOOD-EX-NONE': 7.17,
    'F-SI1-EX-GOOD-NONE': 7.17,
    'H-VVS1-POOR-EX-FAINT': 7.17,
    'H-VVS1-GOOD-VG-FAINT': 7.17,
    'H-VVS1-VG-GOOD-FAINT': 7.17,
    'H-VVS1-EX-POOR-FAINT': 7.17,
    'H-VVS2-POOR-EX-NONE': 7.17,
    'H-VVS2-GOOD-VG-NONE': 7.17,
    'H-VVS2-VG-GOOD-NONE': 7.17,
    'H-VVS2-EX-POOR-NONE': 7.17,
    'K-VVS1-EX-EX-MEDIUM': 7.17,
    'K-VVS2-EX-EX-FAINT': 7.17,
    'D-IF-POOR-POOR-MEDIUM': 7.16,
    'E-VS1-GOOD-EX-STRONG': 7.16,
    'E-VS1-EX-GOOD-STRONG': 7.16,
    'E-VS2-GOOD-EX-MEDIUM': 7.16,
    'E-VS2-EX-GOOD-MEDIUM': 7.16,
    'E-SI1-VG-VG-FAINT': 7.16,
    'E-SI2-VG-VG-NONE': 7.16,
    'G-IF-POOR-EX-STRONG': 7.16,
    'G-IF-GOOD-VG-STRONG': 7.16,
    'G-IF-VG-GOOD-STRONG': 7.16,
    'G-IF-EX-POOR-STRONG': 7.16,
    'K-VS1-EX-EX-NONE': 7.16,
    'M-IF-VG-EX-NONE': 7.16,
    'M-IF-EX-VG-NONE': 7.16,
    'D-VVS1-POOR-POOR-FAINT': 7.15,
    'D-VVS2-POOR-POOR-NONE': 7.15,
    'E-SI1-GOOD-EX-FAINT': 7.15,
    'E-SI1-EX-GOOD-FAINT': 7.15,
    'E-SI2-GOOD-EX-NONE': 7.15,
    'E-SI2-EX-GOOD-NONE': 7.15,
    'G-VVS1-POOR-EX-MEDIUM': 7.15,
    'G-VVS1-GOOD-VG-MEDIUM': 7.15,
    'G-VVS1-VG-GOOD-MEDIUM': 7.15,
    'G-VVS1-EX-POOR-MEDIUM': 7.15,
    'G-VVS2-POOR-EX-FAINT': 7.15,
    'G-VVS2-GOOD-VG-FAINT': 7.15,
    'G-VVS2-VG-GOOD-FAINT': 7.15,
    'G-VVS2-EX-POOR-FAINT': 7.15,
    'D-VS2-VG-VG-STRONG': 7.14,
    'G-VS1-POOR-EX-NONE': 7.14,
    'G-VS1-GOOD-VG-NONE': 7.14,
    'G-VS1-VG-GOOD-NONE': 7.14,
    'G-VS1-EX-POOR-NONE': 7.14,
    'I-IF-POOR-VG-NONE': 7.14,
    'I-IF-VG-POOR-NONE': 7.14,
    'J-VVS1-EX-EX-STRONG': 7.14,
    'J-VVS2-EX-EX-MEDIUM': 7.14,
    'D-VS2-GOOD-EX-STRONG': 7.13,
    'D-VS2-EX-GOOD-STRONG': 7.13,
    'D-SI1-VG-VG-MEDIUM': 7.13,
    'D-SI2-VG-VG-FAINT': 7.13,
    'I-IF-GOOD-GOOD-NONE': 7.13,
    'J-VS1-EX-EX-FAINT': 7.13,
    'J-VS2-EX-EX-NONE': 7.13,
    'L-IF-VG-EX-FAINT': 7.13,
    'L-IF-EX-VG-FAINT': 7.13,
    'D-SI1-GOOD-EX-MEDIUM': 7.12,
    'D-SI1-EX-GOOD-MEDIUM': 7.12,
    'D-SI2-GOOD-EX-FAINT': 7.12,
    'D-SI2-EX-GOOD-FAINT': 7.12,
    'D-I1-VG-VG-NONE': 7.12,
    'F-VVS1-POOR-EX-STRONG': 7.12,
    'F-VVS1-GOOD-VG-STRONG': 7.12,
    'F-VVS1-VG-GOOD-STRONG': 7.12,
    'F-VVS1-EX-POOR-STRONG': 7.12,
    'F-VVS2-POOR-EX-MEDIUM': 7.12,
    'F-VVS2-GOOD-VG-MEDIUM': 7.12,
    'F-VVS2-VG-GOOD-MEDIUM': 7.12,
    'F-VVS2-EX-POOR-MEDIUM': 7.12,
    'I-VVS2-EX-EX-STRONG': 7.12,
    'L-VVS1-VG-EX-NONE': 7.12,
    'L-VVS1-EX-VG-NONE': 7.12,
    'D-I1-GOOD-EX-NONE': 7.11,
    'D-I1-EX-GOOD-NONE': 7.11,
    'F-VS1-POOR-EX-FAINT': 7.11,
    'F-VS1-GOOD-VG-FAINT': 7.11,
    'F-VS1-VG-GOOD-FAINT': 7.11,
    'F-VS1-EX-POOR-FAINT': 7.11,
    'F-VS2-POOR-EX-NONE': 7.11,
    'F-VS2-GOOD-VG-NONE': 7.11,
    'F-VS2-VG-GOOD-NONE': 7.11,
    'F-VS2-EX-POOR-NONE': 7.11,
    'H-IF-POOR-VG-FAINT': 7.11,
    'H-IF-VG-POOR-FAINT': 7.11,
    'I-VS1-EX-EX-MEDIUM': 7.11,
    'I-VS2-EX-EX-FAINT': 7.11,
    'K-IF-VG-EX-MEDIUM': 7.11,
    'K-IF-EX-VG-MEDIUM': 7.11,
    'E-VVS2-POOR-EX-STRONG': 7.1,
    'E-VVS2-GOOD-VG-STRONG': 7.1,
    'E-VVS2-VG-GOOD-STRONG': 7.1,
    'E-VVS2-EX-POOR-STRONG': 7.1,
    'H-IF-GOOD-GOOD-FAINT': 7.1,
    'H-VVS1-POOR-VG-NONE': 7.1,
    'H-VVS1-VG-POOR-NONE': 7.1,
    'I-SI1-EX-EX-NONE': 7.1,
    'K-VVS1-VG-EX-FAINT': 7.1,
    'K-VVS1-EX-VG-FAINT': 7.1,
    'K-VVS2-VG-EX-NONE': 7.1,
    'K-VVS2-EX-VG-NONE': 7.1,
    'E-VS1-POOR-EX-MEDIUM': 7.09,
    'E-VS1-GOOD-VG-MEDIUM': 7.09,
    'E-VS1-VG-GOOD-MEDIUM': 7.09,
    'E-VS1-EX-POOR-MEDIUM': 7.09,
    'E-VS2-POOR-EX-FAINT': 7.09,
    'E-VS2-GOOD-VG-FAINT': 7.09,
    'E-VS2-VG-GOOD-FAINT': 7.09,
    'E-VS2-EX-POOR-FAINT': 7.09,
    'G-IF-POOR-VG-MEDIUM': 7.09,
    'G-IF-VG-POOR-MEDIUM': 7.09,
    'H-VVS1-GOOD-GOOD-NONE': 7.09,
    'E-SI1-POOR-EX-NONE': 7.08,
    'E-SI1-GOOD-VG-NONE': 7.08,
    'E-SI1-VG-GOOD-NONE': 7.08,
    'E-SI1-EX-POOR-NONE': 7.08,
    'G-IF-GOOD-GOOD-MEDIUM': 7.08,
    'G-VVS1-POOR-VG-FAINT': 7.08,
    'G-VVS1-VG-POOR-FAINT': 7.08,
    'G-VVS2-POOR-VG-NONE': 7.08,
    'G-VVS2-VG-POOR-NONE': 7.08,
    'H-VS1-EX-EX-STRONG': 7.08,
    'H-VS2-EX-EX-MEDIUM': 7.08,
    'J-IF-VG-EX-STRONG': 7.08,
    'J-IF-EX-VG-STRONG': 7.08,
    'G-VVS1-GOOD-GOOD-FAINT': 7.07,
    'G-VVS2-GOOD-GOOD-NONE': 7.07,
    'H-SI1-EX-EX-FAINT': 7.07,
    'H-SI2-EX-EX-NONE': 7.07,
    'J-VVS1-VG-EX-MEDIUM': 7.07,
    'J-VVS1-EX-VG-MEDIUM': 7.07,
    'J-VVS2-VG-EX-FAINT': 7.07,
    'J-VVS2-EX-VG-FAINT': 7.07,
    'D-VS1-POOR-EX-STRONG': 7.06,
    'D-VS1-GOOD-VG-STRONG': 7.06,
    'D-VS1-VG-GOOD-STRONG': 7.06,
    'D-VS1-EX-POOR-STRONG': 7.06,
    'D-VS2-POOR-EX-MEDIUM': 7.06,
    'D-VS2-GOOD-VG-MEDIUM': 7.06,
    'D-VS2-VG-GOOD-MEDIUM': 7.06,
    'D-VS2-EX-POOR-MEDIUM': 7.06,
    'F-IF-POOR-VG-STRONG': 7.06,
    'F-IF-VG-POOR-STRONG': 7.06,
    'G-VS2-EX-EX-STRONG': 7.06,
    'J-VS1-VG-EX-NONE': 7.06,
    'J-VS1-EX-VG-NONE': 7.06,
    'L-IF-VG-VG-NONE': 7.06,
    'D-SI1-POOR-EX-FAINT': 7.05,
    'D-SI1-GOOD-VG-FAINT': 7.05,
    'D-SI1-VG-GOOD-FAINT': 7.05,
    'D-SI1-EX-POOR-FAINT': 7.05,
    'D-SI2-POOR-EX-NONE': 7.05,
    'D-SI2-GOOD-VG-NONE': 7.05,
    'D-SI2-VG-GOOD-NONE': 7.05,
    'D-SI2-EX-POOR-NONE': 7.05,
    'F-IF-GOOD-GOOD-STRONG': 7.05,
    'F-VVS1-POOR-VG-MEDIUM': 7.05,
    'F-VVS1-VG-POOR-MEDIUM': 7.05,
    'F-VVS2-POOR-VG-FAINT': 7.05,
    'F-VVS2-VG-POOR-FAINT': 7.05,
    'G-SI1-EX-EX-MEDIUM': 7.05,
    'G-SI2-EX-EX-FAINT': 7.05,
    'I-VVS1-VG-EX-STRONG': 7.05,
    'I-VVS1-EX-VG-STRONG': 7.05,
    'I-VVS2-VG-EX-MEDIUM': 7.05,
    'I-VVS2-EX-VG-MEDIUM': 7.05,
    'L-IF-GOOD-EX-NONE': 7.05,
    'L-IF-EX-GOOD-NONE': 7.05,
    'F-VVS1-GOOD-GOOD-MEDIUM': 7.04,
    'F-VVS2-GOOD-GOOD-FAINT': 7.04,
    'F-VS1-POOR-VG-NONE': 7.04,
    'F-VS1-VG-POOR-NONE': 7.04,
    'G-I1-EX-EX-NONE': 7.04,
    'I-VS1-VG-EX-FAINT': 7.04,
    'I-VS1-EX-VG-FAINT': 7.04,
    'I-VS2-VG-EX-NONE': 7.04,
    'I-VS2-EX-VG-NONE': 7.04,
    'K-IF-VG-VG-FAINT': 7.04,
    'E-VVS1-POOR-VG-STRONG': 7.03,
    'E-VVS1-VG-POOR-STRONG': 7.03,
    'E-VVS2-POOR-VG-MEDIUM': 7.03,
    'E-VVS2-VG-POOR-MEDIUM': 7.03,
    'F-VS1-GOOD-GOOD-NONE': 7.03,
    'H-IF-POOR-GOOD-NONE': 7.03,
    'H-IF-GOOD-POOR-NONE': 7.03,
    'K-IF-GOOD-EX-FAINT': 7.03,
    'K-IF-EX-GOOD-FAINT': 7.03,
    'K-VVS1-VG-VG-NONE': 7.03,
    'E-VVS1-GOOD-GOOD-STRONG': 7.02,
    'E-VVS2-GOOD-GOOD-MEDIUM': 7.02,
    'E-VS1-POOR-VG-FAINT': 7.02,
    'E-VS1-VG-POOR-FAINT': 7.02,
    'E-VS2-POOR-VG-NONE': 7.02,
    'E-VS2-VG-POOR-NONE': 7.02,
    'F-SI1-EX-EX-STRONG': 7.02,
    'F-SI2-EX-EX-MEDIUM': 7.02,
    'H-VVS2-VG-EX-STRONG': 7.02,
    'H-VVS2-EX-VG-STRONG': 7.02,
    'K-VVS1-GOOD-EX-NONE': 7.02,
    'K-VVS1-EX-GOOD-NONE': 7.02,
    'E-VS1-GOOD-GOOD-FAINT': 7.01,
    'E-VS2-GOOD-GOOD-NONE': 7.01,
    'F-I1-EX-EX-FAINT': 7.01,
    'F-I2-EX-EX-NONE': 7.01,
    'G-IF-POOR-GOOD-FAINT': 7.01,
    'G-IF-GOOD-POOR-FAINT': 7.01,
    'H-VS1-VG-EX-MEDIUM': 7.01,
    'H-VS1-EX-VG-MEDIUM': 7.01,
    'H-VS2-VG-EX-FAINT': 7.01,
    'H-VS2-EX-VG-FAINT': 7.01,
    'J-IF-VG-VG-MEDIUM': 7.01,
    'D-VVS2-POOR-VG-STRONG': 7.0,
    'D-VVS2-VG-POOR-STRONG': 7.0,
    'E-SI2-EX-EX-STRONG': 7.0,
    'G-VVS1-POOR-GOOD-NONE': 7.0,
    'G-VVS1-GOOD-POOR-NONE': 7.0,
    'H-SI1-VG-EX-NONE': 7.0,
    'H-SI1-EX-VG-NONE': 7.0,
    'J-IF-GOOD-EX-MEDIUM': 7.0,
    'J-IF-EX-GOOD-MEDIUM': 7.0,
    'J-VVS1-VG-VG-FAINT': 7.0,
    'J-VVS2-VG-VG-NONE': 7.0,
    'D-VVS2-GOOD-GOOD-STRONG': 6.99,
    'D-VS1-POOR-VG-MEDIUM': 6.99,
    'D-VS1-VG-POOR-MEDIUM': 6.99,
    'D-VS2-POOR-VG-FAINT': 6.99,
    'D-VS2-VG-POOR-FAINT': 6.99,
    'E-I1-EX-EX-MEDIUM': 6.99,
    'E-I2-EX-EX-FAINT': 6.99,
    'G-VS1-VG-EX-STRONG': 6.99,
    'G-VS1-EX-VG-STRONG': 6.99,
    'G-VS2-VG-EX-MEDIUM': 6.99,
    'G-VS2-EX-VG-MEDIUM': 6.99,
    'I-IF-VG-VG-STRONG': 6.99,
    'J-VVS1-GOOD-EX-FAINT': 6.99,
    'J-VVS1-EX-GOOD-FAINT': 6.99,
    'J-VVS2-GOOD-EX-NONE': 6.99,
    'J-VVS2-EX-GOOD-NONE': 6.99,
    'D-VS1-GOOD-GOOD-MEDIUM': 6.98,
    'D-VS2-GOOD-GOOD-FAINT': 6.98,
    'D-SI1-POOR-VG-NONE': 6.98,
    'D-SI1-VG-POOR-NONE': 6.98,
    'F-IF-POOR-GOOD-MEDIUM': 6.98,
    'F-IF-GOOD-POOR-MEDIUM': 6.98,
    'G-SI1-VG-EX-FAINT': 6.98,
    'G-SI1-EX-VG-FAINT': 6.98,
    'G-SI2-VG-EX-NONE': 6.98,
    'G-SI2-EX-VG-NONE': 6.98,
    'I-IF-GOOD-EX-STRONG': 6.98,
    'I-IF-EX-GOOD-STRONG': 6.98,
    'I-VVS1-VG-VG-MEDIUM': 6.98,
    'I-VVS2-VG-VG-FAINT': 6.98,
    'D-SI1-GOOD-GOOD-NONE': 6.97,
    'F-VVS1-POOR-GOOD-FAINT': 6.97,
    'F-VVS1-GOOD-POOR-FAINT': 6.97,
    'F-VVS2-POOR-GOOD-NONE': 6.97,
    'F-VVS2-GOOD-POOR-NONE': 6.97,
    'I-VVS1-GOOD-EX-MEDIUM': 6.97,
    'I-VVS1-EX-GOOD-MEDIUM': 6.97,
    'I-VVS2-GOOD-EX-FAINT': 6.97,
    'I-VVS2-EX-GOOD-FAINT': 6.97,
    'I-VS1-VG-VG-NONE': 6.97,
    'D-I1-EX-EX-STRONG': 6.96,
    'D-I2-EX-EX-MEDIUM': 6.96,
    'E-IF-POOR-GOOD-STRONG': 6.96,
    'E-IF-GOOD-POOR-STRONG': 6.96,
    'F-VS2-VG-EX-STRONG': 6.96,
    'F-VS2-EX-VG-STRONG': 6.96,
    'I-VS1-GOOD-EX-NONE': 6.96,
    'I-VS1-EX-GOOD-NONE': 6.96,
    'K-IF-POOR-EX-NONE': 6.96,
    'K-IF-GOOD-VG-NONE': 6.96,
    'K-IF-VG-GOOD-NONE': 6.96,
    'K-IF-EX-POOR-NONE': 6.96,
    'E-VVS1-POOR-GOOD-MEDIUM': 6.95,
    'E-VVS1-GOOD-POOR-MEDIUM': 6.95,
    'E-VVS2-POOR-GOOD-FAINT': 6.95,
    'E-VVS2-GOOD-POOR-FAINT': 6.95,
    'F-SI1-VG-EX-MEDIUM': 6.95,
    'F-SI1-EX-VG-MEDIUM': 6.95,
    'F-SI2-VG-EX-FAINT': 6.95,
    'F-SI2-EX-VG-FAINT': 6.95,
    'H-VVS1-VG-VG-STRONG': 6.95,
    'H-VVS2-VG-VG-MEDIUM': 6.95,
    'E-VS1-POOR-GOOD-NONE': 6.94,
    'E-VS1-GOOD-POOR-NONE': 6.94,
    'F-I1-VG-EX-NONE': 6.94,
    'F-I1-EX-VG-NONE': 6.94,
    'G-IF-POOR-POOR-NONE': 6.94,
    'H-VVS1-GOOD-EX-STRONG': 6.94,
    'H-VVS1-EX-GOOD-STRONG': 6.94,
    'H-VVS2-GOOD-EX-MEDIUM': 6.94,
    'H-VVS2-EX-GOOD-MEDIUM': 6.94,
    'H-VS1-VG-VG-FAINT': 6.94,
    'H-VS2-VG-VG-NONE': 6.94,
    'E-SI1-VG-EX-STRONG': 6.93,
    'E-SI1-EX-VG-STRONG': 6.93,
    'E-SI2-VG-EX-MEDIUM': 6.93,
    'E-SI2-EX-VG-MEDIUM': 6.93,
    'G-VVS2-VG-VG-STRONG': 6.93,
    'H-VS1-GOOD-EX-FAINT': 6.93,
    'H-VS1-EX-GOOD-FAINT': 6.93,
    'H-VS2-GOOD-EX-NONE': 6.93,
    'H-VS2-EX-GOOD-NONE': 6.93,
    'J-IF-POOR-EX-FAINT': 6.93,
    'J-IF-GOOD-VG-FAINT': 6.93,
    'J-IF-VG-GOOD-FAINT': 6.93,
    'J-IF-EX-POOR-FAINT': 6.93,
    'M-IF-EX-EX-MEDIUM': 6.93,
    'D-VVS1-POOR-GOOD-STRONG': 6.92,
    'D-VVS1-GOOD-POOR-STRONG': 6.92,
    'D-VVS2-POOR-GOOD-MEDIUM': 6.92,
    'D-VVS2-GOOD-POOR-MEDIUM': 6.92,
    'E-I1-VG-EX-FAINT': 6.92,
    'E-I1-EX-VG-FAINT': 6.92,
    'E-I2-VG-EX-NONE': 6.92,
    'E-I2-EX-VG-NONE': 6.92,
    'G-VVS2-GOOD-EX-STRONG': 6.92,
    'G-VVS2-EX-GOOD-STRONG': 6.92,
    'G-VS1-VG-VG-MEDIUM': 6.92,
    'G-VS2-VG-VG-FAINT': 6.92,
    'J-VVS1-POOR-EX-NONE': 6.92,
    'J-VVS1-GOOD-VG-NONE': 6.92,
    'J-VVS1-VG-GOOD-NONE': 6.92,
    'J-VVS1-EX-POOR-NONE': 6.92,
    'M-VVS1-EX-EX-FAINT': 6.92,
    'M-VVS2-EX-EX-NONE': 6.92,
    'D-VS1-POOR-GOOD-FAINT': 6.91,
    'D-VS1-GOOD-POOR-FAINT': 6.91,
    'D-VS2-POOR-GOOD-NONE': 6.91,
    'D-VS2-GOOD-POOR-NONE': 6.91,
    'F-IF-POOR-POOR-FAINT': 6.91,
    'G-VS1-GOOD-EX-MEDIUM': 6.91,
    'G-VS1-EX-GOOD-MEDIUM': 6.91,
    'G-VS2-GOOD-EX-FAINT': 6.91,
    'G-VS2-EX-GOOD-FAINT': 6.91,
    'G-SI1-VG-VG-NONE': 6.91,
    'I-IF-POOR-EX-MEDIUM': 6.91,
    'I-IF-GOOD-VG-MEDIUM': 6.91,
    'I-IF-VG-GOOD-MEDIUM': 6.91,
    'I-IF-EX-POOR-MEDIUM': 6.91,
    'D-SI2-VG-EX-STRONG': 6.9,
    'D-SI2-EX-VG-STRONG': 6.9,
    'F-VVS1-POOR-POOR-NONE': 6.9,
    'G-SI1-GOOD-EX-NONE': 6.9,
    'G-SI1-EX-GOOD-NONE': 6.9,
    'I-VVS1-POOR-EX-FAINT': 6.9,
    'I-VVS1-GOOD-VG-FAINT': 6.9,
    'I-VVS1-VG-GOOD-FAINT': 6.9,
    'I-VVS1-EX-POOR-FAINT': 6.9,
    'I-VVS2-POOR-EX-NONE': 6.9,
    'I-VVS2-GOOD-VG-NONE': 6.9,
    'I-VVS2-VG-GOOD-NONE': 6.9,
    'I-VVS2-EX-POOR-NONE': 6.9,
    'L-IF-EX-EX-STRONG': 6.9,
    'D-I1-VG-EX-MEDIUM': 6.89,
    'D-I1-EX-VG-MEDIUM': 6.89,
    'D-I2-VG-EX-FAINT': 6.89,
    'D-I2-EX-VG-FAINT': 6.89,
    'E-IF-POOR-POOR-MEDIUM': 6.89,
    'F-VS1-VG-VG-STRONG': 6.89,
    'F-VS2-VG-VG-MEDIUM': 6.89,
    'L-VVS1-EX-EX-MEDIUM': 6.89,
    'L-VVS2-EX-EX-FAINT': 6.89,
    'E-VVS1-POOR-POOR-FAINT': 6.88,
    'E-VVS2-POOR-POOR-NONE': 6.88,
    'F-VS1-GOOD-EX-STRONG': 6.88,
    'F-VS1-EX-GOOD-STRONG': 6.88,
    'F-VS2-GOOD-EX-MEDIUM': 6.88,
    'F-VS2-EX-GOOD-MEDIUM': 6.88,
    'F-SI1-VG-VG-FAINT': 6.88,
    'F-SI2-VG-VG-NONE': 6.88,
    'H-IF-POOR-EX-STRONG': 6.88,
    'H-IF-GOOD-VG-STRONG': 6.88,
    'H-IF-VG-GOOD-STRONG': 6.88,
    'H-IF-EX-POOR-STRONG': 6.88,
    'L-VS1-EX-EX-NONE': 6.88,
    'E-VS2-VG-VG-STRONG': 6.87,
    'F-SI1-GOOD-EX-FAINT': 6.87,
    'F-SI1-EX-GOOD-FAINT': 6.87,
    'F-SI2-GOOD-EX-NONE': 6.87,
    'F-SI2-EX-GOOD-NONE': 6.87,
    'H-VVS1-POOR-EX-MEDIUM': 6.87,
    'H-VVS1-GOOD-VG-MEDIUM': 6.87,
    'H-VVS1-VG-GOOD-MEDIUM': 6.87,
    'H-VVS1-EX-POOR-MEDIUM': 6.87,
    'H-VVS2-POOR-EX-FAINT': 6.87,
    'H-VVS2-GOOD-VG-FAINT': 6.87,
    'H-VVS2-VG-GOOD-FAINT': 6.87,
    'H-VVS2-EX-POOR-FAINT': 6.87,
    'K-VVS1-EX-EX-STRONG': 6.87,
    'K-VVS2-EX-EX-MEDIUM': 6.87,
    'D-IF-POOR-POOR-STRONG': 6.86,
    'E-VS2-GOOD-EX-STRONG': 6.86,
    'E-VS2-EX-GOOD-STRONG': 6.86,
    'E-SI1-VG-VG-MEDIUM': 6.86,
    'E-SI2-VG-VG-FAINT': 6.86,
    'H-VS1-POOR-EX-NONE': 6.86,
    'H-VS1-GOOD-VG-NONE': 6.86,
    'H-VS1-VG-GOOD-NONE': 6.86,
    'H-VS1-EX-POOR-NONE': 6.86,
    'J-IF-POOR-VG-NONE': 6.86,
    'J-IF-VG-POOR-NONE': 6.86,
    'K-VS1-EX-EX-FAINT': 6.86,
    'K-VS2-EX-EX-NONE': 6.86,
    'M-IF-VG-EX-FAINT': 6.86,
    'M-IF-EX-VG-FAINT': 6.86,
    'D-VVS1-POOR-POOR-MEDIUM': 6.85,
    'D-VVS2-POOR-POOR-FAINT': 6.85,
    'E-SI1-GOOD-EX-MEDIUM': 6.85,
    'E-SI1-EX-GOOD-MEDIUM': 6.85,
    'E-SI2-GOOD-EX-FAINT': 6.85,
    'E-SI2-EX-GOOD-FAINT': 6.85,
    'E-I1-VG-VG-NONE': 6.85,
    'G-VVS1-POOR-EX-STRONG': 6.85,
    'G-VVS1-GOOD-VG-STRONG': 6.85,
    'G-VVS1-VG-GOOD-STRONG': 6.85,
    'G-VVS1-EX-POOR-STRONG': 6.85,
    'G-VVS2-POOR-EX-MEDIUM': 6.85,
    'G-VVS2-GOOD-VG-MEDIUM': 6.85,
    'G-VVS2-VG-GOOD-MEDIUM': 6.85,
    'G-VVS2-EX-POOR-MEDIUM': 6.85,
    'J-IF-GOOD-GOOD-NONE': 6.85,
    'M-VVS1-VG-EX-NONE': 6.85,
    'M-VVS1-EX-VG-NONE': 6.85,
    'D-VS1-POOR-POOR-NONE': 6.84,
    'E-I1-GOOD-EX-NONE': 6.84,
    'E-I1-EX-GOOD-NONE': 6.84,
    'G-VS1-POOR-EX-FAINT': 6.84,
    'G-VS1-GOOD-VG-FAINT': 6.84,
    'G-VS1-VG-GOOD-FAINT': 6.84,
    'G-VS1-EX-POOR-FAINT': 6.84,
    'G-VS2-POOR-EX-NONE': 6.84,
    'G-VS2-GOOD-VG-NONE': 6.84,
    'G-VS2-VG-GOOD-NONE': 6.84,
    'G-VS2-EX-POOR-NONE': 6.84,
    'I-IF-POOR-VG-FAINT': 6.84,
    'I-IF-VG-POOR-FAINT': 6.84,
    'J-VVS2-EX-EX-STRONG': 6.84,
    'D-SI1-VG-VG-STRONG': 6.83,
    'D-SI2-VG-VG-MEDIUM': 6.83,
    'I-IF-GOOD-GOOD-FAINT': 6.83,
    'I-VVS1-POOR-VG-NONE': 6.83,
    'I-VVS1-VG-POOR-NONE': 6.83,
    'J-VS1-EX-EX-MEDIUM': 6.83,
    'J-VS2-EX-EX-FAINT': 6.83,
    'L-IF-VG-EX-MEDIUM': 6.83,
    'L-IF-EX-VG-MEDIUM': 6.83,
    'D-SI1-GOOD-EX-STRONG': 6.82,
    'D-SI1-EX-GOOD-STRONG': 6.82,
    'D-SI2-GOOD-EX-MEDIUM': 6.82,
    'D-SI2-EX-GOOD-MEDIUM': 6.82,
    'D-I1-VG-VG-FAINT': 6.82,
    'D-I2-VG-VG-NONE': 6.82,
    'F-VVS2-POOR-EX-STRONG': 6.82,
    'F-VVS2-GOOD-VG-STRONG': 6.82,
    'F-VVS2-VG-GOOD-STRONG': 6.82,
    'F-VVS2-EX-POOR-STRONG': 6.82,
    'I-VVS1-GOOD-GOOD-NONE': 6.82,
    'J-SI1-EX-EX-NONE': 6.82,
    'L-VVS1-VG-EX-FAINT': 6.82,
    'L-VVS1-EX-VG-FAINT': 6.82,
    'L-VVS2-VG-EX-NONE': 6.82,
    'L-VVS2-EX-VG-NONE': 6.82,
    'D-I1-GOOD-EX-FAINT': 6.81,
    'D-I1-EX-GOOD-FAINT': 6.81,
    'D-I2-GOOD-EX-NONE': 6.81,
    'D-I2-EX-GOOD-NONE': 6.81,
    'F-VS1-POOR-EX-MEDIUM': 6.81,
    'F-VS1-GOOD-VG-MEDIUM': 6.81,
    'F-VS1-VG-GOOD-MEDIUM': 6.81,
    'F-VS1-EX-POOR-MEDIUM': 6.81,
    'F-VS2-POOR-EX-FAINT': 6.81,
    'F-VS2-GOOD-VG-FAINT': 6.81,
    'F-VS2-VG-GOOD-FAINT': 6.81,
    'F-VS2-EX-POOR-FAINT': 6.81,
    'H-IF-POOR-VG-MEDIUM': 6.81,
    'H-IF-VG-POOR-MEDIUM': 6.81,
    'I-VS1-EX-EX-STRONG': 6.81,
    'I-VS2-EX-EX-MEDIUM': 6.81,
    'K-IF-VG-EX-STRONG': 6.81,
    'K-IF-EX-VG-STRONG': 6.81,
    'F-SI1-POOR-EX-NONE': 6.8,
    'F-SI1-GOOD-VG-NONE': 6.8,
    'F-SI1-VG-GOOD-NONE': 6.8,
    'F-SI1-EX-POOR-NONE': 6.8,
    'H-IF-GOOD-GOOD-MEDIUM': 6.8,
    'H-VVS1-POOR-VG-FAINT': 6.8,
    'H-VVS1-VG-POOR-FAINT': 6.8,
    'H-VVS2-POOR-VG-NONE': 6.8,
    'H-VVS2-VG-POOR-NONE': 6.8,
    'I-SI1-EX-EX-FAINT': 6.8,
    'I-SI2-EX-EX-NONE': 6.8,
    'K-VVS1-VG-EX-MEDIUM': 6.8,
    'K-VVS1-EX-VG-MEDIUM': 6.8,
    'K-VVS2-VG-EX-FAINT': 6.8,
    'K-VVS2-EX-VG-FAINT': 6.8,
    'E-VS1-POOR-EX-STRONG': 6.79,
    'E-VS1-GOOD-VG-STRONG': 6.79,
    'E-VS1-VG-GOOD-STRONG': 6.79,
    'E-VS1-EX-POOR-STRONG': 6.79,
    'E-VS2-POOR-EX-MEDIUM': 6.79,
    'E-VS2-GOOD-VG-MEDIUM': 6.79,
    'E-VS2-VG-GOOD-MEDIUM': 6.79,
    'E-VS2-EX-POOR-MEDIUM': 6.79,
    'G-IF-POOR-VG-STRONG': 6.79,
    'G-IF-VG-POOR-STRONG': 6.79,
    'H-VVS1-GOOD-GOOD-FAINT': 6.79,
    'H-VVS2-GOOD-GOOD-NONE': 6.79,
    'K-VS1-VG-EX-NONE': 6.79,
    'K-VS1-EX-VG-NONE': 6.79,
    'M-IF-VG-VG-NONE': 6.79,
    'E-SI1-POOR-EX-FAINT': 6.78,
    'E-SI1-GOOD-VG-FAINT': 6.78,
    'E-SI1-VG-GOOD-FAINT': 6.78,
    'E-SI1-EX-POOR-FAINT': 6.78,
    'E-SI2-POOR-EX-NONE': 6.78,
    'E-SI2-GOOD-VG-NONE': 6.78,
    'E-SI2-VG-GOOD-NONE': 6.78,
    'E-SI2-EX-POOR-NONE': 6.78,
    'G-IF-GOOD-GOOD-STRONG': 6.78,
    'G-VVS1-POOR-VG-MEDIUM': 6.78,
    'G-VVS1-VG-POOR-MEDIUM': 6.78,
    'G-VVS2-POOR-VG-FAINT': 6.78,
    'G-VVS2-VG-POOR-FAINT': 6.78,
    'H-VS2-EX-EX-STRONG': 6.78,
    'M-IF-GOOD-EX-NONE': 6.78,
    'M-IF-EX-GOOD-NONE': 6.78,
    'G-VVS1-GOOD-GOOD-MEDIUM': 6.77,
    'G-VVS2-GOOD-GOOD-FAINT': 6.77,
    'G-VS1-POOR-VG-NONE': 6.77,
    'G-VS1-VG-POOR-NONE': 6.77,
    'H-SI1-EX-EX-MEDIUM': 6.77,
    'H-SI2-EX-EX-FAINT': 6.77,
    'J-VVS1-VG-EX-STRONG': 6.77,
    'J-VVS1-EX-VG-STRONG': 6.77,
    'J-VVS2-VG-EX-MEDIUM': 6.77,
    'J-VVS2-EX-VG-MEDIUM': 6.77,
    'D-VS2-POOR-EX-STRONG': 6.76,
    'D-VS2-GOOD-VG-STRONG': 6.76,
    'D-VS2-VG-GOOD-STRONG': 6.76,
    'D-VS2-EX-POOR-STRONG': 6.76,
    'G-VS1-GOOD-GOOD-NONE': 6.76,
    'H-I1-EX-EX-NONE': 6.76,
    'I-IF-POOR-GOOD-NONE': 6.76,
    'I-IF-GOOD-POOR-NONE': 6.76,
    'J-VS1-VG-EX-FAINT': 6.76,
    'J-VS1-EX-VG-FAINT': 6.76,
    'J-VS2-VG-EX-NONE': 6.76,
    'J-VS2-EX-VG-NONE': 6.76,
    'L-IF-VG-VG-FAINT': 6.76,
    'D-SI1-POOR-EX-MEDIUM': 6.75,
    'D-SI1-GOOD-VG-MEDIUM': 6.75,
    'D-SI1-VG-GOOD-MEDIUM': 6.75,
    'D-SI1-EX-POOR-MEDIUM': 6.75,
    'D-SI2-POOR-EX-FAINT': 6.75,
    'D-SI2-GOOD-VG-FAINT': 6.75,
    'D-SI2-VG-GOOD-FAINT': 6.75,
    'D-SI2-EX-POOR-FAINT': 6.75,
    'F-VVS1-POOR-VG-STRONG': 6.75,
    'F-VVS1-VG-POOR-STRONG': 6.75,
    'F-VVS2-POOR-VG-MEDIUM': 6.75,
    'F-VVS2-VG-POOR-MEDIUM': 6.75,
    'G-SI1-EX-EX-STRONG': 6.75,
    'G-SI2-EX-EX-MEDIUM': 6.75,
    'I-VVS2-VG-EX-STRONG': 6.75,
    'I-VVS2-EX-VG-STRONG': 6.75,
    'L-IF-GOOD-EX-FAINT': 6.75,
    'L-IF-EX-GOOD-FAINT': 6.75,
    'L-VVS1-VG-VG-NONE': 6.75,
    'D-I1-POOR-EX-NONE': 6.74,
    'D-I1-GOOD-VG-NONE': 6.74,
    'D-I1-VG-GOOD-NONE': 6.74,
    'D-I1-EX-POOR-NONE': 6.74,
    'F-VVS1-GOOD-GOOD-STRONG': 6.74,
    'F-VVS2-GOOD-GOOD-MEDIUM': 6.74,
    'F-VS1-POOR-VG-FAINT': 6.74,
    'F-VS1-VG-POOR-FAINT': 6.74,
    'F-VS2-POOR-VG-NONE': 6.74,
    'F-VS2-VG-POOR-NONE': 6.74,
    'G-I1-EX-EX-FAINT': 6.74,
    'G-I2-EX-EX-NONE': 6.74,
    'I-VS1-VG-EX-MEDIUM': 6.74,
    'I-VS1-EX-VG-MEDIUM': 6.74,
    'I-VS2-VG-EX-FAINT': 6.74,
    'I-VS2-EX-VG-FAINT': 6.74,
    'K-IF-VG-VG-MEDIUM': 6.74,
    'L-VVS1-GOOD-EX-NONE': 6.74,
    'L-VVS1-EX-GOOD-NONE': 6.74,
    'E-VVS2-POOR-VG-STRONG': 6.73,
    'E-VVS2-VG-POOR-STRONG': 6.73,
    'F-VS1-GOOD-GOOD-FAINT': 6.73,
    'F-VS2-GOOD-GOOD-NONE': 6.73,
    'H-IF-POOR-GOOD-FAINT': 6.73,
    'H-IF-GOOD-POOR-FAINT': 6.73,
    'I-SI1-VG-EX-NONE': 6.73,
    'I-SI1-EX-VG-NONE': 6.73,
    'K-IF-GOOD-EX-MEDIUM': 6.73,
    'K-IF-EX-GOOD-MEDIUM': 6.73,
    'K-VVS1-VG-VG-FAINT': 6.73,
    'K-VVS2-VG-VG-NONE': 6.73,
    'E-VVS2-GOOD-GOOD-STRONG': 6.72,
    'E-VS1-POOR-VG-MEDIUM': 6.72,
    'E-VS1-VG-POOR-MEDIUM': 6.72,
    'E-VS2-POOR-VG-FAINT': 6.72,
    'E-VS2-VG-POOR-FAINT': 6.72,
    'F-SI2-EX-EX-STRONG': 6.72,
    'H-VVS1-POOR-GOOD-NONE': 6.72,
    'H-VVS1-GOOD-POOR-NONE': 6.72,
    'K-VVS1-GOOD-EX-FAINT': 6.72,
    'K-VVS1-EX-GOOD-FAINT': 6.72,
    'K-VVS2-GOOD-EX-NONE': 6.72,
    'K-VVS2-EX-GOOD-NONE': 6.72,
    'E-VS1-GOOD-GOOD-MEDIUM': 6.71,
    'E-VS2-GOOD-GOOD-FAINT': 6.71,
    'E-SI1-POOR-VG-NONE': 6.71,
    'E-SI1-VG-POOR-NONE': 6.71,
    'F-I1-EX-EX-MEDIUM': 6.71,
    'F-I2-EX-EX-FAINT': 6.71,
    'G-IF-POOR-GOOD-MEDIUM': 6.71,
    'G-IF-GOOD-POOR-MEDIUM': 6.71,
    'H-VS1-VG-EX-STRONG': 6.71,
    'H-VS1-EX-VG-STRONG': 6.71,
    'H-VS2-VG-EX-MEDIUM': 6.71,
    'H-VS2-EX-VG-MEDIUM': 6.71,
    'J-IF-VG-VG-STRONG': 6.71,
    'E-SI1-GOOD-GOOD-NONE': 6.7,
    'G-VVS1-POOR-GOOD-FAINT': 6.7,
    'G-VVS1-GOOD-POOR-FAINT': 6.7,
    'G-VVS2-POOR-GOOD-NONE': 6.7,
    'G-VVS2-GOOD-POOR-NONE': 6.7,
    'H-SI1-VG-EX-FAINT': 6.7,
    'H-SI1-EX-VG-FAINT': 6.7,
    'H-SI2-VG-EX-NONE': 6.7,
    'H-SI2-EX-VG-NONE': 6.7,
    'J-IF-GOOD-EX-STRONG': 6.7,
    'J-IF-EX-GOOD-STRONG': 6.7,
    'J-VVS1-VG-VG-MEDIUM': 6.7,
    'J-VVS2-VG-VG-FAINT': 6.7,
    'D-VS1-POOR-VG-STRONG': 6.69,
    'D-VS1-VG-POOR-STRONG': 6.69,
    'D-VS2-POOR-VG-MEDIUM': 6.69,
    'D-VS2-VG-POOR-MEDIUM': 6.69,
    'E-I1-EX-EX-STRONG': 6.69,
    'E-I2-EX-EX-MEDIUM': 6.69,
    'G-VS2-VG-EX-STRONG': 6.69,
    'G-VS2-EX-VG-STRONG': 6.69,
    'J-VVS1-GOOD-EX-MEDIUM': 6.69,
    'J-VVS1-EX-GOOD-MEDIUM': 6.69,
    'J-VVS2-GOOD-EX-FAINT': 6.69,
    'J-VVS2-EX-GOOD-FAINT': 6.69,
    'J-VS1-VG-VG-NONE': 6.69,
    'D-VS1-GOOD-GOOD-STRONG': 6.68,
    'D-VS2-GOOD-GOOD-MEDIUM': 6.68,
    'D-SI1-POOR-VG-FAINT': 6.68,
    'D-SI1-VG-POOR-FAINT': 6.68,
    'D-SI2-POOR-VG-NONE': 6.68,
    'D-SI2-VG-POOR-NONE': 6.68,
    'F-IF-POOR-GOOD-STRONG': 6.68,
    'F-IF-GOOD-POOR-STRONG': 6.68,
    'G-SI1-VG-EX-MEDIUM': 6.68,
    'G-SI1-EX-VG-MEDIUM': 6.68,
    'G-SI2-VG-EX-FAINT': 6.68,
    'G-SI2-EX-VG-FAINT': 6.68,
    'I-VVS1-VG-VG-STRONG': 6.68,
    'I-VVS2-VG-VG-MEDIUM': 6.68,
    'J-VS1-GOOD-EX-NONE': 6.68,
    'J-VS1-EX-GOOD-NONE': 6.68,
    'L-IF-POOR-EX-NONE': 6.68,
    'L-IF-GOOD-VG-NONE': 6.68,
    'L-IF-VG-GOOD-NONE': 6.68,
    'L-IF-EX-POOR-NONE': 6.68,
    'D-SI1-GOOD-GOOD-FAINT': 6.67,
    'D-SI2-GOOD-GOOD-NONE': 6.67,
    'F-VVS1-POOR-GOOD-MEDIUM': 6.67,
    'F-VVS1-GOOD-POOR-MEDIUM': 6.67,
    'F-VVS2-POOR-GOOD-FAINT': 6.67,
    'F-VVS2-GOOD-POOR-FAINT': 6.67,
    'G-I1-VG-EX-NONE': 6.67,
    'G-I1-EX-VG-NONE': 6.67,
    'I-VVS1-GOOD-EX-STRONG': 6.67,
    'I-VVS1-EX-GOOD-STRONG': 6.67,
    'I-VVS2-GOOD-EX-MEDIUM': 6.67,
    'I-VVS2-EX-GOOD-MEDIUM': 6.67,
    'I-VS1-VG-VG-FAINT': 6.67,
    'I-VS2-VG-VG-NONE': 6.67,
    'D-I2-EX-EX-STRONG': 6.66,
    'F-VS1-POOR-GOOD-NONE': 6.66,
    'F-VS1-GOOD-POOR-NONE': 6.66,
    'H-IF-POOR-POOR-NONE': 6.66,
    'I-VS1-GOOD-EX-FAINT': 6.66,
    'I-VS1-EX-GOOD-FAINT': 6.66,
    'I-VS2-GOOD-EX-NONE': 6.66,
    'I-VS2-EX-GOOD-NONE': 6.66,
    'K-IF-POOR-EX-FAINT': 6.66,
    'K-IF-GOOD-VG-FAINT': 6.66,
    'K-IF-VG-GOOD-FAINT': 6.66,
    'K-IF-EX-POOR-FAINT': 6.66,
    'E-VVS1-POOR-GOOD-STRONG': 6.65,
    'E-VVS1-GOOD-POOR-STRONG': 6.65,
    'E-VVS2-POOR-GOOD-MEDIUM': 6.65,
    'E-VVS2-GOOD-POOR-MEDIUM': 6.65,
    'F-SI1-VG-EX-STRONG': 6.65,
    'F-SI1-EX-VG-STRONG': 6.65,
    'F-SI2-VG-EX-MEDIUM': 6.65,
    'F-SI2-EX-VG-MEDIUM': 6.65,
    'H-VVS2-VG-VG-STRONG': 6.65,
    'K-VVS1-POOR-EX-NONE': 6.65,
    'K-VVS1-GOOD-VG-NONE': 6.65,
    'K-VVS1-VG-GOOD-NONE': 6.65,
    'K-VVS1-EX-POOR-NONE': 6.65,
    'E-VS1-POOR-GOOD-FAINT': 6.64,
    'E-VS1-GOOD-POOR-FAINT': 6.64,
    'E-VS2-POOR-GOOD-NONE': 6.64,
    'E-VS2-GOOD-POOR-NONE': 6.64,
    'F-I1-VG-EX-FAINT': 6.64,
    'F-I1-EX-VG-FAINT': 6.64,
    'F-I2-VG-EX-NONE': 6.64,
    'F-I2-EX-VG-NONE': 6.64,
    'G-IF-POOR-POOR-FAINT': 6.64,
    'H-VVS2-GOOD-EX-STRONG': 6.64,
    'H-VVS2-EX-GOOD-STRONG': 6.64,
    'H-VS1-VG-VG-MEDIUM': 6.64,
    'H-VS2-VG-VG-FAINT': 6.64,
    'E-SI2-VG-EX-STRONG': 6.63,
    'E-SI2-EX-VG-STRONG': 6.63,
    'G-VVS1-POOR-POOR-NONE': 6.63,
    'H-VS1-GOOD-EX-MEDIUM': 6.63,
    'H-VS1-EX-GOOD-MEDIUM': 6.63,
    'H-VS2-GOOD-EX-FAINT': 6.63,
    'H-VS2-EX-GOOD-FAINT': 6.63,
    'H-SI1-VG-VG-NONE': 6.63,
    'J-IF-POOR-EX-MEDIUM': 6.63,
    'J-IF-GOOD-VG-MEDIUM': 6.63,
    'J-IF-VG-GOOD-MEDIUM': 6.63,
    'J-IF-EX-POOR-MEDIUM': 6.63,
    'M-IF-EX-EX-STRONG': 6.63,
    'D-VVS2-POOR-GOOD-STRONG': 6.62,
    'D-VVS2-GOOD-POOR-STRONG': 6.62,
    'E-I1-VG-EX-MEDIUM': 6.62,
    'E-I1-EX-VG-MEDIUM': 6.62,
    'E-I2-VG-EX-FAINT': 6.62,
    'E-I2-EX-VG-FAINT': 6.62,
    'G-VS1-VG-VG-STRONG': 6.62,
    'G-VS2-VG-VG-MEDIUM': 6.62,
    'H-SI1-GOOD-EX-NONE': 6.62,
    'H-SI1-EX-GOOD-NONE': 6.62,
    'J-VVS1-POOR-EX-FAINT': 6.62,
    'J-VVS1-GOOD-VG-FAINT': 6.62,
    'J-VVS1-VG-GOOD-FAINT': 6.62,
    'J-VVS1-EX-POOR-FAINT': 6.62,
    'J-VVS2-POOR-EX-NONE': 6.62,
    'J-VVS2-GOOD-VG-NONE': 6.62,
    'J-VVS2-VG-GOOD-NONE': 6.62,
    'J-VVS2-EX-POOR-NONE': 6.62,
    'M-VVS1-EX-EX-MEDIUM': 6.62,
    'M-VVS2-EX-EX-FAINT': 6.62,
    'D-VS1-POOR-GOOD-MEDIUM': 6.61,
    'D-VS1-GOOD-POOR-MEDIUM': 6.61,
    'D-VS2-POOR-GOOD-FAINT': 6.61,
    'D-VS2-GOOD-POOR-FAINT': 6.61,
    'F-IF-POOR-POOR-MEDIUM': 6.61,
    'G-VS1-GOOD-EX-STRONG': 6.61,
    'G-VS1-EX-GOOD-STRONG': 6.61,
    'G-VS2-GOOD-EX-MEDIUM': 6.61,
    'G-VS2-EX-GOOD-MEDIUM': 6.61,
    'G-SI1-VG-VG-FAINT': 6.61,
    'G-SI2-VG-VG-NONE': 6.61,
    'I-IF-POOR-EX-STRONG': 6.61,
    'I-IF-GOOD-VG-STRONG': 6.61,
    'I-IF-VG-GOOD-STRONG': 6.61,
    'I-IF-EX-POOR-STRONG': 6.61,
    'M-VS1-EX-EX-NONE': 6.61,
    'D-SI1-POOR-GOOD-NONE': 6.6,
    'D-SI1-GOOD-POOR-NONE': 6.6,
    'F-VVS1-POOR-POOR-FAINT': 6.6,
    'F-VVS2-POOR-POOR-NONE': 6.6,
    'G-SI1-GOOD-EX-FAINT': 6.6,
    'G-SI1-EX-GOOD-FAINT': 6.6,
    'G-SI2-GOOD-EX-NONE': 6.6,
    'G-SI2-EX-GOOD-NONE': 6.6,
    'I-VVS1-POOR-EX-MEDIUM': 6.6,
    'I-VVS1-GOOD-VG-MEDIUM': 6.6,
    'I-VVS1-VG-GOOD-MEDIUM': 6.6,
    'I-VVS1-EX-POOR-MEDIUM': 6.6,
    'I-VVS2-POOR-EX-FAINT': 6.6,
    'I-VVS2-GOOD-VG-FAINT': 6.6,
    'I-VVS2-VG-GOOD-FAINT': 6.6,
    'I-VVS2-EX-POOR-FAINT': 6.6,
    'D-I1-VG-EX-STRONG': 6.59,
    'D-I1-EX-VG-STRONG': 6.59,
    'D-I2-VG-EX-MEDIUM': 6.59,
    'D-I2-EX-VG-MEDIUM': 6.59,
    'E-IF-POOR-POOR-STRONG': 6.59,
    'F-VS2-VG-VG-STRONG': 6.59,
    'I-VS1-POOR-EX-NONE': 6.59,
    'I-VS1-GOOD-VG-NONE': 6.59,
    'I-VS1-VG-GOOD-NONE': 6.59,
    'I-VS1-EX-POOR-NONE': 6.59,
    'K-IF-POOR-VG-NONE': 6.59,
    'K-IF-VG-POOR-NONE': 6.59,
    'L-VVS1-EX-EX-STRONG': 6.59,
    'L-VVS2-EX-EX-MEDIUM': 6.59,
    'E-VVS1-POOR-POOR-MEDIUM': 6.58,
    'E-VVS2-POOR-POOR-FAINT': 6.58,
    'F-VS2-GOOD-EX-STRONG': 6.58,
    'F-VS2-EX-GOOD-STRONG': 6.58,
    'F-SI1-VG-VG-MEDIUM': 6.58,
    'F-SI2-VG-VG-FAINT': 6.58,
    'K-IF-GOOD-GOOD-NONE': 6.58,
    'L-VS1-EX-EX-FAINT': 6.58,
    'L-VS2-EX-EX-NONE': 6.58,
    'E-VS1-POOR-POOR-NONE': 6.57,
    'F-SI1-GOOD-EX-MEDIUM': 6.57,
    'F-SI1-EX-GOOD-MEDIUM': 6.57,
    'F-SI2-GOOD-EX-FAINT': 6.57,
    'F-SI2-EX-GOOD-FAINT': 6.57,
    'F-I1-VG-VG-NONE': 6.57,
    'H-VVS1-POOR-EX-STRONG': 6.57,
    'H-VVS1-GOOD-VG-STRONG': 6.57,
    'H-VVS1-VG-GOOD-STRONG': 6.57,
    'H-VVS1-EX-POOR-STRONG': 6.57,
    'H-VVS2-POOR-EX-MEDIUM': 6.57,
    'H-VVS2-GOOD-VG-MEDIUM': 6.57,
    'H-VVS2-VG-GOOD-MEDIUM': 6.57,
    'H-VVS2-EX-POOR-MEDIUM': 6.57,
    'K-VVS2-EX-EX-STRONG': 6.57,
    'E-SI1-VG-VG-STRONG': 6.56,
    'E-SI2-VG-VG-MEDIUM': 6.56,
    'F-I1-GOOD-EX-NONE': 6.56,
    'F-I1-EX-GOOD-NONE': 6.56,
    'H-VS1-POOR-EX-FAINT': 6.56,
    'H-VS1-GOOD-VG-FAINT': 6.56,
    'H-VS1-VG-GOOD-FAINT': 6.56,
    'H-VS1-EX-POOR-FAINT': 6.56,
    'H-VS2-POOR-EX-NONE': 6.56,
    'H-VS2-GOOD-VG-NONE': 6.56,
    'H-VS2-VG-GOOD-NONE': 6.56,
    'H-VS2-EX-POOR-NONE': 6.56,
    'J-IF-POOR-VG-FAINT': 6.56,
    'J-IF-VG-POOR-FAINT': 6.56,
    'K-VS1-EX-EX-MEDIUM': 6.56,
    'K-VS2-EX-EX-FAINT': 6.56,
    'M-IF-VG-EX-MEDIUM': 6.56,
    'M-IF-EX-VG-MEDIUM': 6.56,
    'D-VVS1-POOR-POOR-STRONG': 6.55,
    'D-VVS2-POOR-POOR-MEDIUM': 6.55,
    'E-SI1-GOOD-EX-STRONG': 6.55,
    'E-SI1-EX-GOOD-STRONG': 6.55,
    'E-SI2-GOOD-EX-MEDIUM': 6.55,
    'E-SI2-EX-GOOD-MEDIUM': 6.55,
    'E-I1-VG-VG-FAINT': 6.55,
    'E-I2-VG-VG-NONE': 6.55,
    'G-VVS2-POOR-EX-STRONG': 6.55,
    'G-VVS2-GOOD-VG-STRONG': 6.55,
    'G-VVS2-VG-GOOD-STRONG': 6.55,
    'G-VVS2-EX-POOR-STRONG': 6.55,
    'J-IF-GOOD-GOOD-FAINT': 6.55,
    'J-VVS1-POOR-VG-NONE': 6.55,
    'J-VVS1-VG-POOR-NONE': 6.55,
    'K-SI1-EX-EX-NONE': 6.55,
    'M-VVS1-VG-EX-FAINT': 6.55,
    'M-VVS1-EX-VG-FAINT': 6.55,
    'M-VVS2-VG-EX-NONE': 6.55,
    'M-VVS2-EX-VG-NONE': 6.55,
    'D-VS1-POOR-POOR-FAINT': 6.54,
    'D-VS2-POOR-POOR-NONE': 6.54,
    'E-I1-GOOD-EX-FAINT': 6.54,
    'E-I1-EX-GOOD-FAINT': 6.54,
    'E-I2-GOOD-EX-NONE': 6.54,
    'E-I2-EX-GOOD-NONE': 6.54,
    'G-VS1-POOR-EX-MEDIUM': 6.54,
    'G-VS1-GOOD-VG-MEDIUM': 6.54,
    'G-VS1-VG-GOOD-MEDIUM': 6.54,
    'G-VS1-EX-POOR-MEDIUM': 6.54,
    'G-VS2-POOR-EX-FAINT': 6.54,
    'G-VS2-GOOD-VG-FAINT': 6.54,
    'G-VS2-VG-GOOD-FAINT': 6.54,
    'G-VS2-EX-POOR-FAINT': 6.54,
    'I-IF-POOR-VG-MEDIUM': 6.54,
    'I-IF-VG-POOR-MEDIUM': 6.54,
    'J-VVS1-GOOD-GOOD-NONE': 6.54,
    'D-SI2-VG-VG-STRONG': 6.53,
    'G-SI1-POOR-EX-NONE': 6.53,
    'G-SI1-GOOD-VG-NONE': 6.53,
    'G-SI1-VG-GOOD-NONE': 6.53,
    'G-SI1-EX-POOR-NONE': 6.53,
    'I-IF-GOOD-GOOD-MEDIUM': 6.53,
    'I-VVS1-POOR-VG-FAINT': 6.53,
    'I-VVS1-VG-POOR-FAINT': 6.53,
    'I-VVS2-POOR-VG-NONE': 6.53,
    'I-VVS2-VG-POOR-NONE': 6.53,
    'J-VS1-EX-EX-STRONG': 6.53,
    'J-VS2-EX-EX-MEDIUM': 6.53,
    'L-IF-VG-EX-STRONG': 6.53,
    'L-IF-EX-VG-STRONG': 6.53,
    'D-SI2-GOOD-EX-STRONG': 6.52,
    'D-SI2-EX-GOOD-STRONG': 6.52,
    'D-I1-VG-VG-MEDIUM': 6.52,
    'D-I2-VG-VG-FAINT': 6.52,
    'I-VVS1-GOOD-GOOD-FAINT': 6.52,
    'I-VVS2-GOOD-GOOD-NONE': 6.52,
    'J-SI1-EX-EX-FAINT': 6.52,
    'J-SI2-EX-EX-NONE': 6.52,
    'L-VVS1-VG-EX-MEDIUM': 6.52,
    'L-VVS1-EX-VG-MEDIUM': 6.52,
    'L-VVS2-VG-EX-FAINT': 6.52,
    'L-VVS2-EX-VG-FAINT': 6.52,
    'D-I1-GOOD-EX-MEDIUM': 6.51,
    'D-I1-EX-GOOD-MEDIUM': 6.51,
    'D-I2-GOOD-EX-FAINT': 6.51,
    'D-I2-EX-GOOD-FAINT': 6.51,
    'F-VS1-POOR-EX-STRONG': 6.51,
    'F-VS1-GOOD-VG-STRONG': 6.51,
    'F-VS1-VG-GOOD-STRONG': 6.51,
    'F-VS1-EX-POOR-STRONG': 6.51,
    'F-VS2-POOR-EX-MEDIUM': 6.51,
    'F-VS2-GOOD-VG-MEDIUM': 6.51,
    'F-VS2-VG-GOOD-MEDIUM': 6.51,
    'F-VS2-EX-POOR-MEDIUM': 6.51,
    'H-IF-POOR-VG-STRONG': 6.51,
    'H-IF-VG-POOR-STRONG': 6.51,
    'I-VS2-EX-EX-STRONG': 6.51,
    'L-VS1-VG-EX-NONE': 6.51,
    'L-VS1-EX-VG-NONE': 6.51,
    'F-SI1-POOR-EX-FAINT': 6.5,
    'F-SI1-GOOD-VG-FAINT': 6.5,
    'F-SI1-VG-GOOD-FAINT': 6.5,
    'F-SI1-EX-POOR-FAINT': 6.5,
    'F-SI2-POOR-EX-NONE': 6.5,
    'F-SI2-GOOD-VG-NONE': 6.5,
    'F-SI2-VG-GOOD-NONE': 6.5,
    'F-SI2-EX-POOR-NONE': 6.5,
    'H-IF-GOOD-GOOD-STRONG': 6.5,
    'H-VVS1-POOR-VG-MEDIUM': 6.5,
    'H-VVS1-VG-POOR-MEDIUM': 6.5,
    'H-VVS2-POOR-VG-FAINT': 6.5,
    'H-VVS2-VG-POOR-FAINT': 6.5,
    'I-SI1-EX-EX-MEDIUM': 6.5,
    'I-SI2-EX-EX-FAINT': 6.5,
    'K-VVS1-VG-EX-STRONG': 6.5,
    'K-VVS1-EX-VG-STRONG': 6.5,
    'K-VVS2-VG-EX-MEDIUM': 6.5,
    'K-VVS2-EX-VG-MEDIUM': 6.5,
    'E-VS2-POOR-EX-STRONG': 6.49,
    'E-VS2-GOOD-VG-STRONG': 6.49,
    'E-VS2-VG-GOOD-STRONG': 6.49,
    'E-VS2-EX-POOR-STRONG': 6.49,
    'H-VVS1-GOOD-GOOD-MEDIUM': 6.49,
    'H-VVS2-GOOD-GOOD-FAINT': 6.49,
    'H-VS1-POOR-VG-NONE': 6.49,
    'H-VS1-VG-POOR-NONE': 6.49,
    'I-I1-EX-EX-NONE': 6.49,
    'K-VS1-VG-EX-FAINT': 6.49,
    'K-VS1-EX-VG-FAINT': 6.49,
    'K-VS2-VG-EX-NONE': 6.49,
    'K-VS2-EX-VG-NONE': 6.49,
    'M-IF-VG-VG-FAINT': 6.49,
    'E-SI1-POOR-EX-MEDIUM': 6.48,
    'E-SI1-GOOD-VG-MEDIUM': 6.48,
    'E-SI1-VG-GOOD-MEDIUM': 6.48,
    'E-SI1-EX-POOR-MEDIUM': 6.48,
    'E-SI2-POOR-EX-FAINT': 6.48,
    'E-SI2-GOOD-VG-FAINT': 6.48,
    'E-SI2-VG-GOOD-FAINT': 6.48,
    'E-SI2-EX-POOR-FAINT': 6.48,
    'G-VVS1-POOR-VG-STRONG': 6.48,
    'G-VVS1-VG-POOR-STRONG': 6.48,
    'G-VVS2-POOR-VG-MEDIUM': 6.48,
    'G-VVS2-VG-POOR-MEDIUM': 6.48,
    'H-VS1-GOOD-GOOD-NONE': 6.48,
    'J-IF-POOR-GOOD-NONE': 6.48,
    'J-IF-GOOD-POOR-NONE': 6.48,
    'M-IF-GOOD-EX-FAINT': 6.48,
    'M-IF-EX-GOOD-FAINT': 6.48,
    'M-VVS1-VG-VG-NONE': 6.48,
    'E-I1-POOR-EX-NONE': 6.47,
    'E-I1-GOOD-VG-NONE': 6.47,
    'E-I1-VG-GOOD-NONE': 6.47,
    'E-I1-EX-POOR-NONE': 6.47,
    'G-VVS1-GOOD-GOOD-STRONG': 6.47,
    'G-VVS2-GOOD-GOOD-MEDIUM': 6.47,
    'G-VS1-POOR-VG-FAINT': 6.47,
    'G-VS1-VG-POOR-FAINT': 6.47,
    'G-VS2-POOR-VG-NONE': 6.47,
    'G-VS2-VG-POOR-NONE': 6.47,
    'H-SI1-EX-EX-STRONG': 6.47,
    'H-SI2-EX-EX-MEDIUM': 6.47,
    'J-VVS2-VG-EX-STRONG': 6.47,
    'J-VVS2-EX-VG-STRONG': 6.47,
    'M-VVS1-GOOD-EX-NONE': 6.47,
    'M-VVS1-EX-GOOD-NONE': 6.47,
    'G-VS1-GOOD-GOOD-FAINT': 6.46,
    'G-VS2-GOOD-GOOD-NONE': 6.46,
    'H-I1-EX-EX-FAINT': 6.46,
    'H-I2-EX-EX-NONE': 6.46,
    'I-IF-POOR-GOOD-FAINT': 6.46,
    'I-IF-GOOD-POOR-FAINT': 6.46,
    'J-VS1-VG-EX-MEDIUM': 6.46,
    'J-VS1-EX-VG-MEDIUM': 6.46,
    'J-VS2-VG-EX-FAINT': 6.46,
    'J-VS2-EX-VG-FAINT': 6.46,
    'L-IF-VG-VG-MEDIUM': 6.46,
    'D-SI1-POOR-EX-STRONG': 6.45,
    'D-SI1-GOOD-VG-STRONG': 6.45,
    'D-SI1-VG-GOOD-STRONG': 6.45,
    'D-SI1-EX-POOR-STRONG': 6.45,
    'D-SI2-POOR-EX-MEDIUM': 6.45,
    'D-SI2-GOOD-VG-MEDIUM': 6.45,
    'D-SI2-VG-GOOD-MEDIUM': 6.45,
    'D-SI2-EX-POOR-MEDIUM': 6.45,
    'F-VVS2-POOR-VG-STRONG': 6.45,
    'F-VVS2-VG-POOR-STRONG': 6.45,
    'G-SI2-EX-EX-STRONG': 6.45,
    'I-VVS1-POOR-GOOD-NONE': 6.45,
    'I-VVS1-GOOD-POOR-NONE': 6.45,
    'J-SI1-VG-EX-NONE': 6.45,
    'J-SI1-EX-VG-NONE': 6.45,
    'L-IF-GOOD-EX-MEDIUM': 6.45,
    'L-IF-EX-GOOD-MEDIUM': 6.45,
    'L-VVS1-VG-VG-FAINT': 6.45,
    'L-VVS2-VG-VG-NONE': 6.45,
    'D-I1-POOR-EX-FAINT': 6.44,
    'D-I1-GOOD-VG-FAINT': 6.44,
    'D-I1-VG-GOOD-FAINT': 6.44,
    'D-I1-EX-POOR-FAINT': 6.44,
    'D-I2-POOR-EX-NONE': 6.44,
    'D-I2-GOOD-VG-NONE': 6.44,
    'D-I2-VG-GOOD-NONE': 6.44,
    'D-I2-EX-POOR-NONE': 6.44,
    'F-VVS2-GOOD-GOOD-STRONG': 6.44,
    'F-VS1-POOR-VG-MEDIUM': 6.44,
    'F-VS1-VG-POOR-MEDIUM': 6.44,
    'F-VS2-POOR-VG-FAINT': 6.44,
    'F-VS2-VG-POOR-FAINT': 6.44,
    'G-I1-EX-EX-MEDIUM': 6.44,
    'G-I2-EX-EX-FAINT': 6.44,
    'I-VS1-VG-EX-STRONG': 6.44,
    'I-VS1-EX-VG-STRONG': 6.44,
    'I-VS2-VG-EX-MEDIUM': 6.44,
    'I-VS2-EX-VG-MEDIUM': 6.44,
    'K-IF-VG-VG-STRONG': 6.44,
    'L-VVS1-GOOD-EX-FAINT': 6.44,
    'L-VVS1-EX-GOOD-FAINT': 6.44,
    'L-VVS2-GOOD-EX-NONE': 6.44,
    'L-VVS2-EX-GOOD-NONE': 6.44,
    'F-VS1-GOOD-GOOD-MEDIUM': 6.43,
    'F-VS2-GOOD-GOOD-FAINT': 6.43,
    'F-SI1-POOR-VG-NONE': 6.43,
    'F-SI1-VG-POOR-NONE': 6.43,
    'H-IF-POOR-GOOD-MEDIUM': 6.43,
    'H-IF-GOOD-POOR-MEDIUM': 6.43,
    'I-SI1-VG-EX-FAINT': 6.43,
    'I-SI1-EX-VG-FAINT': 6.43,
    'I-SI2-VG-EX-NONE': 6.43,
    'I-SI2-EX-VG-NONE': 6.43,
    'K-IF-GOOD-EX-STRONG': 6.43,
    'K-IF-EX-GOOD-STRONG': 6.43,
    'K-VVS1-VG-VG-MEDIUM': 6.43,
    'K-VVS2-VG-VG-FAINT': 6.43,
    'E-VS1-POOR-VG-STRONG': 6.42,
    'E-VS1-VG-POOR-STRONG': 6.42,
    'E-VS2-POOR-VG-MEDIUM': 6.42,
    'E-VS2-VG-POOR-MEDIUM': 6.42,
    'F-SI1-GOOD-GOOD-NONE': 6.42,
    'H-VVS1-POOR-GOOD-FAINT': 6.42,
    'H-VVS1-GOOD-POOR-FAINT': 6.42,
    'H-VVS2-POOR-GOOD-NONE': 6.42,
    'H-VVS2-GOOD-POOR-NONE': 6.42,
    'K-VVS1-GOOD-EX-MEDIUM': 6.42,
    'K-VVS1-EX-GOOD-MEDIUM': 6.42,
    'K-VVS2-GOOD-EX-FAINT': 6.42,
    'K-VVS2-EX-GOOD-FAINT': 6.42,
    'K-VS1-VG-VG-NONE': 6.42,
    'E-VS1-GOOD-GOOD-STRONG': 6.41,
    'E-VS2-GOOD-GOOD-MEDIUM': 6.41,
    'E-SI1-POOR-VG-FAINT': 6.41,
    'E-SI1-VG-POOR-FAINT': 6.41,
    'E-SI2-POOR-VG-NONE': 6.41,
    'E-SI2-VG-POOR-NONE': 6.41,
    'F-I1-EX-EX-STRONG': 6.41,
    'F-I2-EX-EX-MEDIUM': 6.41,
    'G-IF-POOR-GOOD-STRONG': 6.41,
    'G-IF-GOOD-POOR-STRONG': 6.41,
    'H-VS2-VG-EX-STRONG': 6.41,
    'H-VS2-EX-VG-STRONG': 6.41,
    'K-VS1-GOOD-EX-NONE': 6.41,
    'K-VS1-EX-GOOD-NONE': 6.41,
    'M-IF-POOR-EX-NONE': 6.41,
    'M-IF-GOOD-VG-NONE': 6.41,
    'M-IF-VG-GOOD-NONE': 6.41,
    'M-IF-EX-POOR-NONE': 6.41,
    'E-SI1-GOOD-GOOD-FAINT': 6.4,
    'E-SI2-GOOD-GOOD-NONE': 6.4,
    'G-VVS1-POOR-GOOD-MEDIUM': 6.4,
    'G-VVS1-GOOD-POOR-MEDIUM': 6.4,
    'G-VVS2-POOR-GOOD-FAINT': 6.4,
    'G-VVS2-GOOD-POOR-FAINT': 6.4,
    'H-SI1-VG-EX-MEDIUM': 6.4,
    'H-SI1-EX-VG-MEDIUM': 6.4,
    'H-SI2-VG-EX-FAINT': 6.4,
    'H-SI2-EX-VG-FAINT': 6.4,
    'J-VVS1-VG-VG-STRONG': 6.4,
    'J-VVS2-VG-VG-MEDIUM': 6.4,
    'D-VS2-POOR-VG-STRONG': 6.39,
    'D-VS2-VG-POOR-STRONG': 6.39,
    'E-I2-EX-EX-STRONG': 6.39,
    'G-VS1-POOR-GOOD-NONE': 6.39,
    'G-VS1-GOOD-POOR-NONE': 6.39,
    'H-I1-VG-EX-NONE': 6.39,
    'H-I1-EX-VG-NONE': 6.39,
    'I-IF-POOR-POOR-NONE': 6.39,
    'J-VVS1-GOOD-EX-STRONG': 6.39,
    'J-VVS1-EX-GOOD-STRONG': 6.39,
    'J-VVS2-GOOD-EX-MEDIUM': 6.39,
    'J-VVS2-EX-GOOD-MEDIUM': 6.39,
    'J-VS1-VG-VG-FAINT': 6.39,
    'J-VS2-VG-VG-NONE': 6.39,
    'D-VS2-GOOD-GOOD-STRONG': 6.38,
    'D-SI1-POOR-VG-MEDIUM': 6.38,
    'D-SI1-VG-POOR-MEDIUM': 6.38,
    'D-SI2-POOR-VG-FAINT': 6.38,
    'D-SI2-VG-POOR-FAINT': 6.38,
    'G-SI1-VG-EX-STRONG': 6.38,
    'G-SI1-EX-VG-STRONG': 6.38,
    'G-SI2-VG-EX-MEDIUM': 6.38,
    'G-SI2-EX-VG-MEDIUM': 6.38,
    'I-VVS2-VG-VG-STRONG': 6.38,
    'J-VS1-GOOD-EX-FAINT': 6.38,
    'J-VS1-EX-GOOD-FAINT': 6.38,
    'J-VS2-GOOD-EX-NONE': 6.38,
    'J-VS2-EX-GOOD-NONE': 6.38,
    'L-IF-POOR-EX-FAINT': 6.38,
    'L-IF-GOOD-VG-FAINT': 6.38,
    'L-IF-VG-GOOD-FAINT': 6.38,
    'L-IF-EX-POOR-FAINT': 6.38,
    'D-SI1-GOOD-GOOD-MEDIUM': 6.37,
    'D-SI2-GOOD-GOOD-FAINT': 6.37,
    'D-I1-POOR-VG-NONE': 6.37,
    'D-I1-VG-POOR-NONE': 6.37,
    'F-VVS1-POOR-GOOD-STRONG': 6.37,
    'F-VVS1-GOOD-POOR-STRONG': 6.37,
    'F-VVS2-POOR-GOOD-MEDIUM': 6.37,
    'F-VVS2-GOOD-POOR-MEDIUM': 6.37,
    'G-I1-VG-EX-FAINT': 6.37,
    'G-I1-EX-VG-FAINT': 6.37,
    'G-I2-VG-EX-NONE': 6.37,
    'G-I2-EX-VG-NONE': 6.37,
    'I-VVS2-GOOD-EX-STRONG': 6.37,
    'I-VVS2-EX-GOOD-STRONG': 6.37,
    'I-VS1-VG-VG-MEDIUM': 6.37,
    'I-VS2-VG-VG-FAINT': 6.37,
    'L-VVS1-POOR-EX-NONE': 6.37,
    'L-VVS1-GOOD-VG-NONE': 6.37,
    'L-VVS1-VG-GOOD-NONE': 6.37,
    'L-VVS1-EX-POOR-NONE': 6.37,
    'D-I1-GOOD-GOOD-NONE': 6.36,
    'F-VS1-POOR-GOOD-FAINT': 6.36,
    'F-VS1-GOOD-POOR-FAINT': 6.36,
    'F-VS2-POOR-GOOD-NONE': 6.36,
    'F-VS2-GOOD-POOR-NONE': 6.36,
    'H-IF-POOR-POOR-FAINT': 6.36,
    'I-VS1-GOOD-EX-MEDIUM': 6.36,
    'I-VS1-EX-GOOD-MEDIUM': 6.36,
    'I-VS2-GOOD-EX-FAINT': 6.36,
    'I-VS2-EX-GOOD-FAINT': 6.36,
    'I-SI1-VG-VG-NONE': 6.36,
    'K-IF-POOR-EX-MEDIUM': 6.36,
    'K-IF-GOOD-VG-MEDIUM': 6.36,
    'K-IF-VG-GOOD-MEDIUM': 6.36,
    'K-IF-EX-POOR-MEDIUM': 6.36,
    'E-VVS2-POOR-GOOD-STRONG': 6.35,
    'E-VVS2-GOOD-POOR-STRONG': 6.35,
    'F-SI2-VG-EX-STRONG': 6.35,
    'F-SI2-EX-VG-STRONG': 6.35,
    'H-VVS1-POOR-POOR-NONE': 6.35,
    'I-SI1-GOOD-EX-NONE': 6.35,
    'I-SI1-EX-GOOD-NONE': 6.35,
    'K-VVS1-POOR-EX-FAINT': 6.35,
    'K-VVS1-GOOD-VG-FAINT': 6.35,
    'K-VVS1-VG-GOOD-FAINT': 6.35,
    'K-VVS1-EX-POOR-FAINT': 6.35,
    'K-VVS2-POOR-EX-NONE': 6.35,
    'K-VVS2-GOOD-VG-NONE': 6.35,
    'K-VVS2-VG-GOOD-NONE': 6.35,
    'K-VVS2-EX-POOR-NONE': 6.35,
    'E-VS1-POOR-GOOD-MEDIUM': 6.34,
    'E-VS1-GOOD-POOR-MEDIUM': 6.34,
    'E-VS2-POOR-GOOD-FAINT': 6.34,
    'E-VS2-GOOD-POOR-FAINT': 6.34,
    'F-I1-VG-EX-MEDIUM': 6.34,
    'F-I1-EX-VG-MEDIUM': 6.34,
    'F-I2-VG-EX-FAINT': 6.34,
    'F-I2-EX-VG-FAINT': 6.34,
    'G-IF-POOR-POOR-MEDIUM': 6.34,
    'H-VS1-VG-VG-STRONG': 6.34,
    'H-VS2-VG-VG-MEDIUM': 6.34,
    'E-SI1-POOR-GOOD-NONE': 6.33,
    'E-SI1-GOOD-POOR-NONE': 6.33,
    'G-VVS1-POOR-POOR-FAINT': 6.33,
    'G-VVS2-POOR-POOR-NONE': 6.33,
    'H-VS1-GOOD-EX-STRONG': 6.33,
    'H-VS1-EX-GOOD-STRONG': 6.33,
    'H-VS2-GOOD-EX-MEDIUM': 6.33,
    'H-VS2-EX-GOOD-MEDIUM': 6.33,
    'H-SI1-VG-VG-FAINT': 6.33,
    'H-SI2-VG-VG-NONE': 6.33,
    'J-IF-POOR-EX-STRONG': 6.33,
    'J-IF-GOOD-VG-STRONG': 6.33,
    'J-IF-VG-GOOD-STRONG': 6.33,
    'J-IF-EX-POOR-STRONG': 6.33,
    'E-I1-VG-EX-STRONG': 6.32,
    'E-I1-EX-VG-STRONG': 6.32,
    'E-I2-VG-EX-MEDIUM': 6.32,
    'E-I2-EX-VG-MEDIUM': 6.32,
    'G-VS2-VG-VG-STRONG': 6.32,
    'H-SI1-GOOD-EX-FAINT': 6.32,
    'H-SI1-EX-GOOD-FAINT': 6.32,
    'H-SI2-GOOD-EX-NONE': 6.32,
    'H-SI2-EX-GOOD-NONE': 6.32,
    'J-VVS1-POOR-EX-MEDIUM': 6.32,
    'J-VVS1-GOOD-VG-MEDIUM': 6.32,
    'J-VVS1-VG-GOOD-MEDIUM': 6.32,
    'J-VVS1-EX-POOR-MEDIUM': 6.32,
    'J-VVS2-POOR-EX-FAINT': 6.32,
    'J-VVS2-GOOD-VG-FAINT': 6.32,
    'J-VVS2-VG-GOOD-FAINT': 6.32,
    'J-VVS2-EX-POOR-FAINT': 6.32,
    'M-VVS1-EX-EX-STRONG': 6.32,
    'M-VVS2-EX-EX-MEDIUM': 6.32,
    'D-VS1-POOR-GOOD-STRONG': 6.31,
    'D-VS1-GOOD-POOR-STRONG': 6.31,
    'D-VS2-POOR-GOOD-MEDIUM': 6.31,
    'D-VS2-GOOD-POOR-MEDIUM': 6.31,
    'F-IF-POOR-POOR-STRONG': 6.31,
    'G-VS2-GOOD-EX-STRONG': 6.31,
    'G-VS2-EX-GOOD-STRONG': 6.31,
    'G-SI1-VG-VG-MEDIUM': 6.31,
    'G-SI2-VG-VG-FAINT': 6.31,
    'J-VS1-POOR-EX-NONE': 6.31,
    'J-VS1-GOOD-VG-NONE': 6.31,
    'J-VS1-VG-GOOD-NONE': 6.31,
    'J-VS1-EX-POOR-NONE': 6.31,
    'L-IF-POOR-VG-NONE': 6.31,
    'L-IF-VG-POOR-NONE': 6.31,
    'M-VS1-EX-EX-FAINT': 6.31,
    'M-VS2-EX-EX-NONE': 6.31,
    'D-SI1-POOR-GOOD-FAINT': 6.3,
    'D-SI1-GOOD-POOR-FAINT': 6.3,
    'D-SI2-POOR-GOOD-NONE': 6.3,
    'D-SI2-GOOD-POOR-NONE': 6.3,
    'F-VVS1-POOR-POOR-MEDIUM': 6.3,
    'F-VVS2-POOR-POOR-FAINT': 6.3,
    'G-SI1-GOOD-EX-MEDIUM': 6.3,
    'G-SI1-EX-GOOD-MEDIUM': 6.3,
    'G-SI2-GOOD-EX-FAINT': 6.3,
    'G-SI2-EX-GOOD-FAINT': 6.3,
    'G-I1-VG-VG-NONE': 6.3,
    'I-VVS1-POOR-EX-STRONG': 6.3,
    'I-VVS1-GOOD-VG-STRONG': 6.3,
    'I-VVS1-VG-GOOD-STRONG': 6.3,
    'I-VVS1-EX-POOR-STRONG': 6.3,
    'I-VVS2-POOR-EX-MEDIUM': 6.3,
    'I-VVS2-GOOD-VG-MEDIUM': 6.3,
    'I-VVS2-VG-GOOD-MEDIUM': 6.3,
    'I-VVS2-EX-POOR-MEDIUM': 6.3,
    'L-IF-GOOD-GOOD-NONE': 6.3,
    'D-I2-VG-EX-STRONG': 6.29,
    'D-I2-EX-VG-STRONG': 6.29,
    'F-VS1-POOR-POOR-NONE': 6.29,
    'G-I1-GOOD-EX-NONE': 6.29,
    'G-I1-EX-GOOD-NONE': 6.29,
    'I-VS1-POOR-EX-FAINT': 6.29,
    'I-VS1-GOOD-VG-FAINT': 6.29,
    'I-VS1-VG-GOOD-FAINT': 6.29,
    'I-VS1-EX-POOR-FAINT': 6.29,
    'I-VS2-POOR-EX-NONE': 6.29,
    'I-VS2-GOOD-VG-NONE': 6.29,
    'I-VS2-VG-GOOD-NONE': 6.29,
    'I-VS2-EX-POOR-NONE': 6.29,
    'K-IF-POOR-VG-FAINT': 6.29,
    'K-IF-VG-POOR-FAINT': 6.29,
    'L-VVS2-EX-EX-STRONG': 6.29,
    'E-VVS1-POOR-POOR-STRONG': 6.28,
    'E-VVS2-POOR-POOR-MEDIUM': 6.28,
    'F-SI1-VG-VG-STRONG': 6.28,
    'F-SI2-VG-VG-MEDIUM': 6.28,
    'K-IF-GOOD-GOOD-FAINT': 6.28,
    'K-VVS1-POOR-VG-NONE': 6.28,
    'K-VVS1-VG-POOR-NONE': 6.28,
    'L-VS1-EX-EX-MEDIUM': 6.28,
    'L-VS2-EX-EX-FAINT': 6.28,
    'E-VS1-POOR-POOR-FAINT': 6.27,
    'E-VS2-POOR-POOR-NONE': 6.27,
    'F-SI1-GOOD-EX-STRONG': 6.27,
    'F-SI1-EX-GOOD-STRONG': 6.27,
    'F-SI2-GOOD-EX-MEDIUM': 6.27,
    'F-SI2-EX-GOOD-MEDIUM': 6.27,
    'F-I1-VG-VG-FAINT': 6.27,
    'F-I2-VG-VG-NONE': 6.27,
    'H-VVS2-POOR-EX-STRONG': 6.27,
    'H-VVS2-GOOD-VG-STRONG': 6.27,
    'H-VVS2-VG-GOOD-STRONG': 6.27,
    'H-VVS2-EX-POOR-STRONG': 6.27,
    'K-VVS1-GOOD-GOOD-NONE': 6.27,
    'L-SI1-EX-EX-NONE': 6.27,
    'E-SI2-VG-VG-STRONG': 6.26,
    'F-I1-GOOD-EX-FAINT': 6.26,
    'F-I1-EX-GOOD-FAINT': 6.26,
    'F-I2-GOOD-EX-NONE': 6.26,
    'F-I2-EX-GOOD-NONE': 6.26,
    'H-VS1-POOR-EX-MEDIUM': 6.26,
    'H-VS1-GOOD-VG-MEDIUM': 6.26,
    'H-VS1-VG-GOOD-MEDIUM': 6.26,
    'H-VS1-EX-POOR-MEDIUM': 6.26,
    'H-VS2-POOR-EX-FAINT': 6.26,
    'H-VS2-GOOD-VG-FAINT': 6.26,
    'H-VS2-VG-GOOD-FAINT': 6.26,
    'H-VS2-EX-POOR-FAINT': 6.26,
    'J-IF-POOR-VG-MEDIUM': 6.26,
    'J-IF-VG-POOR-MEDIUM': 6.26,
    'K-VS1-EX-EX-STRONG': 6.26,
    'K-VS2-EX-EX-MEDIUM': 6.26,
    'M-IF-VG-EX-STRONG': 6.26,
    'M-IF-EX-VG-STRONG': 6.26,
    'D-VVS2-POOR-POOR-STRONG': 6.25,
    'E-SI2-GOOD-EX-STRONG': 6.25,
    'E-SI2-EX-GOOD-STRONG': 6.25,
    'E-I1-VG-VG-MEDIUM': 6.25,
    'E-I2-VG-VG-FAINT': 6.25,
    'H-SI1-POOR-EX-NONE': 6.25,
    'H-SI1-GOOD-VG-NONE': 6.25,
    'H-SI1-VG-GOOD-NONE': 6.25,
    'H-SI1-EX-POOR-NONE': 6.25,
    'J-IF-GOOD-GOOD-MEDIUM': 6.25,
    'J-VVS1-POOR-VG-FAINT': 6.25,
    'J-VVS1-VG-POOR-FAINT': 6.25,
    'J-VVS2-POOR-VG-NONE': 6.25,
    'J-VVS2-VG-POOR-NONE': 6.25,
    'K-SI1-EX-EX-FAINT': 6.25,
    'K-SI2-EX-EX-NONE': 6.25,
    'M-VVS1-VG-EX-MEDIUM': 6.25,
    'M-VVS1-EX-VG-MEDIUM': 6.25,
    'M-VVS2-VG-EX-FAINT': 6.25,
    'M-VVS2-EX-VG-FAINT': 6.25,
    'D-VS1-POOR-POOR-MEDIUM': 6.24,
    'D-VS2-POOR-POOR-FAINT': 6.24,
    'E-I1-GOOD-EX-MEDIUM': 6.24,
    'E-I1-EX-GOOD-MEDIUM': 6.24,
    'E-I2-GOOD-EX-FAINT': 6.24,
    'E-I2-EX-GOOD-FAINT': 6.24,
    'G-VS1-POOR-EX-STRONG': 6.24,
    'G-VS1-GOOD-VG-STRONG': 6.24,
    'G-VS1-VG-GOOD-STRONG': 6.24,
    'G-VS1-EX-POOR-STRONG': 6.24,
    'G-VS2-POOR-EX-MEDIUM': 6.24,
    'G-VS2-GOOD-VG-MEDIUM': 6.24,
    'G-VS2-VG-GOOD-MEDIUM': 6.24,
    'G-VS2-EX-POOR-MEDIUM': 6.24,
    'I-IF-POOR-VG-STRONG': 6.24,
    'I-IF-VG-POOR-STRONG': 6.24,
    'J-VVS1-GOOD-GOOD-FAINT': 6.24,
    'J-VVS2-GOOD-GOOD-NONE': 6.24,
    'M-VS1-VG-EX-NONE': 6.24,
    'M-VS1-EX-VG-NONE': 6.24,
    'D-SI1-POOR-POOR-NONE': 6.23,
    'G-SI1-POOR-EX-FAINT': 6.23,
    'G-SI1-GOOD-VG-FAINT': 6.23,
    'G-SI1-VG-GOOD-FAINT': 6.23,
    'G-SI1-EX-POOR-FAINT': 6.23,
    'G-SI2-POOR-EX-NONE': 6.23,
    'G-SI2-GOOD-VG-NONE': 6.23,
    'G-SI2-VG-GOOD-NONE': 6.23,
    'G-SI2-EX-POOR-NONE': 6.23,
    'I-IF-GOOD-GOOD-STRONG': 6.23,
    'I-VVS1-POOR-VG-MEDIUM': 6.23,
    'I-VVS1-VG-POOR-MEDIUM': 6.23,
    'I-VVS2-POOR-VG-FAINT': 6.23,
    'I-VVS2-VG-POOR-FAINT': 6.23,
    'J-VS2-EX-EX-STRONG': 6.23,
    'D-I1-VG-VG-STRONG': 6.22,
    'D-I2-VG-VG-MEDIUM': 6.22,
    'I-VVS1-GOOD-GOOD-MEDIUM': 6.22,
    'I-VVS2-GOOD-GOOD-FAINT': 6.22,
    'I-VS1-POOR-VG-NONE': 6.22,
    'I-VS1-VG-POOR-NONE': 6.22,
    'J-SI1-EX-EX-MEDIUM': 6.22,
    'J-SI2-EX-EX-FAINT': 6.22,
    'L-VVS1-VG-EX-STRONG': 6.22,
    'L-VVS1-EX-VG-STRONG': 6.22,
    'L-VVS2-VG-EX-MEDIUM': 6.22,
    'L-VVS2-EX-VG-MEDIUM': 6.22,
    'D-I1-GOOD-EX-STRONG': 6.21,
    'D-I1-EX-GOOD-STRONG': 6.21,
    'D-I2-GOOD-EX-MEDIUM': 6.21,
    'D-I2-EX-GOOD-MEDIUM': 6.21,
    'F-VS2-POOR-EX-STRONG': 6.21,
    'F-VS2-GOOD-VG-STRONG': 6.21,
    'F-VS2-VG-GOOD-STRONG': 6.21,
    'F-VS2-EX-POOR-STRONG': 6.21,
    'I-VS1-GOOD-GOOD-NONE': 6.21,
    'J-I1-EX-EX-NONE': 6.21,
    'K-IF-POOR-GOOD-NONE': 6.21,
    'K-IF-GOOD-POOR-NONE': 6.21,
    'L-VS1-VG-EX-FAINT': 6.21,
    'L-VS1-EX-VG-FAINT': 6.21,
    'L-VS2-VG-EX-NONE': 6.21,
    'L-VS2-EX-VG-NONE': 6.21,
    'F-SI1-POOR-EX-MEDIUM': 6.2,
    'F-SI1-GOOD-VG-MEDIUM': 6.2,
    'F-SI1-VG-GOOD-MEDIUM': 6.2,
    'F-SI1-EX-POOR-MEDIUM': 6.2,
    'F-SI2-POOR-EX-FAINT': 6.2,
    'F-SI2-GOOD-VG-FAINT': 6.2,
    'F-SI2-VG-GOOD-FAINT': 6.2,
    'F-SI2-EX-POOR-FAINT': 6.2,
    'H-VVS1-POOR-VG-STRONG': 6.2,
    'H-VVS1-VG-POOR-STRONG': 6.2,
    'H-VVS2-POOR-VG-MEDIUM': 6.2,
    'H-VVS2-VG-POOR-MEDIUM': 6.2,
    'I-SI1-EX-EX-STRONG': 6.2,
    'I-SI2-EX-EX-MEDIUM': 6.2,
    'K-VVS2-VG-EX-STRONG': 6.2,
    'K-VVS2-EX-VG-STRONG': 6.2,
    'F-I1-POOR-EX-NONE': 6.19,
    'F-I1-GOOD-VG-NONE': 6.19,
    'F-I1-VG-GOOD-NONE': 6.19,
    'F-I1-EX-POOR-NONE': 6.19,
    'H-VVS1-GOOD-GOOD-STRONG': 6.19,
    'H-VVS2-GOOD-GOOD-MEDIUM': 6.19,
    'H-VS1-POOR-VG-FAINT': 6.19,
    'H-VS1-VG-POOR-FAINT': 6.19,
    'H-VS2-POOR-VG-NONE': 6.19,
    'H-VS2-VG-POOR-NONE': 6.19,
    'I-I1-EX-EX-FAINT': 6.19,
    'I-I2-EX-EX-NONE': 6.19,
    'K-VS1-VG-EX-MEDIUM': 6.19,
    'K-VS1-EX-VG-MEDIUM': 6.19,
    'K-VS2-VG-EX-FAINT': 6.19,
    'K-VS2-EX-VG-FAINT': 6.19,
    'M-IF-VG-VG-MEDIUM': 6.19,
    'E-SI1-POOR-EX-STRONG': 6.18,
    'E-SI1-GOOD-VG-STRONG': 6.18,
    'E-SI1-VG-GOOD-STRONG': 6.18,
    'E-SI1-EX-POOR-STRONG': 6.18,
    'E-SI2-POOR-EX-MEDIUM': 6.18,
    'E-SI2-GOOD-VG-MEDIUM': 6.18,
    'E-SI2-VG-GOOD-MEDIUM': 6.18,
    'E-SI2-EX-POOR-MEDIUM': 6.18,
    'G-VVS2-POOR-VG-STRONG': 6.18,
    'G-VVS2-VG-POOR-STRONG': 6.18,
    'H-VS1-GOOD-GOOD-FAINT': 6.18,
    'H-VS2-GOOD-GOOD-NONE': 6.18,
    'J-IF-POOR-GOOD-FAINT': 6.18,
    'J-IF-GOOD-POOR-FAINT': 6.18,
    'K-SI1-VG-EX-NONE': 6.18,
    'K-SI1-EX-VG-NONE': 6.18,
    'M-IF-GOOD-EX-MEDIUM': 6.18,
    'M-IF-EX-GOOD-MEDIUM': 6.18,
    'M-VVS1-VG-VG-FAINT': 6.18,
    'M-VVS2-VG-VG-NONE': 6.18,
    'E-I1-POOR-EX-FAINT': 6.17,
    'E-I1-GOOD-VG-FAINT': 6.17,
    'E-I1-VG-GOOD-FAINT': 6.17,
    'E-I1-EX-POOR-FAINT': 6.17,
    'E-I2-POOR-EX-NONE': 6.17,
    'E-I2-GOOD-VG-NONE': 6.17,
    'E-I2-VG-GOOD-NONE': 6.17,
    'E-I2-EX-POOR-NONE': 6.17,
    'G-VVS2-GOOD-GOOD-STRONG': 6.17,
    'G-VS1-POOR-VG-MEDIUM': 6.17,
    'G-VS1-VG-POOR-MEDIUM': 6.17,
    'G-VS2-POOR-VG-FAINT': 6.17,
    'G-VS2-VG-POOR-FAINT': 6.17,
    'H-SI2-EX-EX-STRONG': 6.17,
    'J-VVS1-POOR-GOOD-NONE': 6.17,
    'J-VVS1-GOOD-POOR-NONE': 6.17,
    'M-VVS1-GOOD-EX-FAINT': 6.17,
    'M-VVS1-EX-GOOD-FAINT': 6.17,
    'M-VVS2-GOOD-EX-NONE': 6.17,
    'M-VVS2-EX-GOOD-NONE': 6.17,
    'G-VS1-GOOD-GOOD-MEDIUM': 6.16,
    'G-VS2-GOOD-GOOD-FAINT': 6.16,
    'G-SI1-POOR-VG-NONE': 6.16,
    'G-SI1-VG-POOR-NONE': 6.16,
    'H-I1-EX-EX-MEDIUM': 6.16,
    'H-I2-EX-EX-FAINT': 6.16,
    'I-IF-POOR-GOOD-MEDIUM': 6.16,
    'I-IF-GOOD-POOR-MEDIUM': 6.16,
    'J-VS1-VG-EX-STRONG': 6.16,
    'J-VS1-EX-VG-STRONG': 6.16,
    'J-VS2-VG-EX-MEDIUM': 6.16,
    'J-VS2-EX-VG-MEDIUM': 6.16,
    'L-IF-VG-VG-STRONG': 6.16,
    'D-SI2-POOR-EX-STRONG': 6.15,
    'D-SI2-GOOD-VG-STRONG': 6.15,
    'D-SI2-VG-GOOD-STRONG': 6.15,
    'D-SI2-EX-POOR-STRONG': 6.15,
    'G-SI1-GOOD-GOOD-NONE': 6.15,
    'I-VVS1-POOR-GOOD-FAINT': 6.15,
    'I-VVS1-GOOD-POOR-FAINT': 6.15,
    'I-VVS2-POOR-GOOD-NONE': 6.15,
    'I-VVS2-GOOD-POOR-NONE': 6.15,
    'J-SI1-VG-EX-FAINT': 6.15,
    'J-SI1-EX-VG-FAINT': 6.15,
    'J-SI2-VG-EX-NONE': 6.15,
    'J-SI2-EX-VG-NONE': 6.15,
    'L-IF-GOOD-EX-STRONG': 6.15,
    'L-IF-EX-GOOD-STRONG': 6.15,
    'L-VVS1-VG-VG-MEDIUM': 6.15,
    'L-VVS2-VG-VG-FAINT': 6.15,
    'D-I1-POOR-EX-MEDIUM': 6.14,
    'D-I1-GOOD-VG-MEDIUM': 6.14,
    'D-I1-VG-GOOD-MEDIUM': 6.14,
    'D-I1-EX-POOR-MEDIUM': 6.14,
    'D-I2-POOR-EX-FAINT': 6.14,
    'D-I2-GOOD-VG-FAINT': 6.14,
    'D-I2-VG-GOOD-FAINT': 6.14,
    'D-I2-EX-POOR-FAINT': 6.14,
    'F-VS1-POOR-VG-STRONG': 6.14,
    'F-VS1-VG-POOR-STRONG': 6.14,
    'F-VS2-POOR-VG-MEDIUM': 6.14,
    'F-VS2-VG-POOR-MEDIUM': 6.14,
    'G-I1-EX-EX-STRONG': 6.14,
    'G-I2-EX-EX-MEDIUM': 6.14,
    'I-VS2-VG-EX-STRONG': 6.14,
    'I-VS2-EX-VG-STRONG': 6.14,
    'L-VVS1-GOOD-EX-MEDIUM': 6.14,
    'L-VVS1-EX-GOOD-MEDIUM': 6.14,
    'L-VVS2-GOOD-EX-FAINT': 6.14,
    'L-VVS2-EX-GOOD-FAINT': 6.14,
    'L-VS1-VG-VG-NONE': 6.14,
    'F-VS1-GOOD-GOOD-STRONG': 6.13,
    'F-VS2-GOOD-GOOD-MEDIUM': 6.13,
    'F-SI1-POOR-VG-FAINT': 6.13,
    'F-SI1-VG-POOR-FAINT': 6.13,
    'F-SI2-POOR-VG-NONE': 6.13,
    'F-SI2-VG-POOR-NONE': 6.13,
    'H-IF-POOR-GOOD-STRONG': 6.13,
    'H-IF-GOOD-POOR-STRONG': 6.13,
    'I-SI1-VG-EX-MEDIUM': 6.13,
    'I-SI1-EX-VG-MEDIUM': 6.13,
    'I-SI2-VG-EX-FAINT': 6.13,
    'I-SI2-EX-VG-FAINT': 6.13,
    'K-VVS1-VG-VG-STRONG': 6.13,
    'K-VVS2-VG-VG-MEDIUM': 6.13,
    'L-VS1-GOOD-EX-NONE': 6.13,
    'L-VS1-EX-GOOD-NONE': 6.13,
    'E-VS2-POOR-VG-STRONG': 6.12,
    'E-VS2-VG-POOR-STRONG': 6.12,
    'F-SI1-GOOD-GOOD-FAINT': 6.12,
    'F-SI2-GOOD-GOOD-NONE': 6.12,
    'H-VVS1-POOR-GOOD-MEDIUM': 6.12,
    'H-VVS1-GOOD-POOR-MEDIUM': 6.12,
    'H-VVS2-POOR-GOOD-FAINT': 6.12,
    'H-VVS2-GOOD-POOR-FAINT': 6.12,
    'I-I1-VG-EX-NONE': 6.12,
    'I-I1-EX-VG-NONE': 6.12,
    'K-VVS1-GOOD-EX-STRONG': 6.12,
    'K-VVS1-EX-GOOD-STRONG': 6.12,
    'K-VVS2-GOOD-EX-MEDIUM': 6.12,
    'K-VVS2-EX-GOOD-MEDIUM': 6.12,
    'K-VS1-VG-VG-FAINT': 6.12,
    'K-VS2-VG-VG-NONE': 6.12,
    'E-VS2-GOOD-GOOD-STRONG': 6.11,
    'E-SI1-POOR-VG-MEDIUM': 6.11,
    'E-SI1-VG-POOR-MEDIUM': 6.11,
    'E-SI2-POOR-VG-FAINT': 6.11,
    'E-SI2-VG-POOR-FAINT': 6.11,
    'F-I2-EX-EX-STRONG': 6.11,
    'H-VS1-POOR-GOOD-NONE': 6.11,
    'H-VS1-GOOD-POOR-NONE': 6.11,
    'J-IF-POOR-POOR-NONE': 6.11,
    'K-VS1-GOOD-EX-FAINT': 6.11,
    'K-VS1-EX-GOOD-FAINT': 6.11,
    'K-VS2-GOOD-EX-NONE': 6.11,
    'K-VS2-EX-GOOD-NONE': 6.11,
    'M-IF-POOR-EX-FAINT': 6.11,
    'M-IF-GOOD-VG-FAINT': 6.11,
    'M-IF-VG-GOOD-FAINT': 6.11,
    'M-IF-EX-POOR-FAINT': 6.11,
    'E-SI1-GOOD-GOOD-MEDIUM': 6.1,
    'E-SI2-GOOD-GOOD-FAINT': 6.1,
    'E-I1-POOR-VG-NONE': 6.1,
    'E-I1-VG-POOR-NONE': 6.1,
    'G-VVS1-POOR-GOOD-STRONG': 6.1,
    'G-VVS1-GOOD-POOR-STRONG': 6.1,
    'G-VVS2-POOR-GOOD-MEDIUM': 6.1,
    'G-VVS2-GOOD-POOR-MEDIUM': 6.1,
    'H-SI1-VG-EX-STRONG': 6.1,
    'H-SI1-EX-VG-STRONG': 6.1,
    'H-SI2-VG-EX-MEDIUM': 6.1,
    'H-SI2-EX-VG-MEDIUM': 6.1,
    'J-VVS2-VG-VG-STRONG': 6.1,
    'M-VVS1-POOR-EX-NONE': 6.1,
    'M-VVS1-GOOD-VG-NONE': 6.1,
    'M-VVS1-VG-GOOD-NONE': 6.1,
    'M-VVS1-EX-POOR-NONE': 6.1,
    'E-I1-GOOD-GOOD-NONE': 6.09,
    'G-VS1-POOR-GOOD-FAINT': 6.09,
    'G-VS1-GOOD-POOR-FAINT': 6.09,
    'G-VS2-POOR-GOOD-NONE': 6.09,
    'G-VS2-GOOD-POOR-NONE': 6.09,
    'H-I1-VG-EX-FAINT': 6.09,
    'H-I1-EX-VG-FAINT': 6.09,
    'H-I2-VG-EX-NONE': 6.09,
    'H-I2-EX-VG-NONE': 6.09,
    'I-IF-POOR-POOR-FAINT': 6.09,
    'J-VVS2-GOOD-EX-STRONG': 6.09,
    'J-VVS2-EX-GOOD-STRONG': 6.09,
    'J-VS1-VG-VG-MEDIUM': 6.09,
    'J-VS2-VG-VG-FAINT': 6.09,
    'D-SI1-POOR-VG-STRONG': 6.08,
    'D-SI1-VG-POOR-STRONG': 6.08,
    'D-SI2-POOR-VG-MEDIUM': 6.08,
    'D-SI2-VG-POOR-MEDIUM': 6.08,
    'G-SI2-VG-EX-STRONG': 6.08,
    'G-SI2-EX-VG-STRONG': 6.08,
    'I-VVS1-POOR-POOR-NONE': 6.08,
    'J-VS1-GOOD-EX-MEDIUM': 6.08,
    'J-VS1-EX-GOOD-MEDIUM': 6.08,
    'J-VS2-GOOD-EX-FAINT': 6.08,
    'J-VS2-EX-GOOD-FAINT': 6.08,
    'J-SI1-VG-VG-NONE': 6.08,
    'L-IF-POOR-EX-MEDIUM': 6.08,
    'L-IF-GOOD-VG-MEDIUM': 6.08,
    'L-IF-VG-GOOD-MEDIUM': 6.08,
    'L-IF-EX-POOR-MEDIUM': 6.08,
    'D-SI1-GOOD-GOOD-STRONG': 6.07,
    'D-SI2-GOOD-GOOD-MEDIUM': 6.07,
    'D-I1-POOR-VG-FAINT': 6.07,
    'D-I1-VG-POOR-FAINT': 6.07,
    'D-I2-POOR-VG-NONE': 6.07,
    'D-I2-VG-POOR-NONE': 6.07,
    'F-VVS2-POOR-GOOD-STRONG': 6.07,
    'F-VVS2-GOOD-POOR-STRONG': 6.07,
    'G-I1-VG-EX-MEDIUM': 6.07,
    'G-I1-EX-VG-MEDIUM': 6.07,
    'G-I2-VG-EX-FAINT': 6.07,
    'G-I2-EX-VG-FAINT': 6.07,
    'I-VS1-VG-VG-STRONG': 6.07,
    'I-VS2-VG-VG-MEDIUM': 6.07,
    'J-SI1-GOOD-EX-NONE': 6.07,
    'J-SI1-EX-GOOD-NONE': 6.07,
    'L-VVS1-POOR-EX-FAINT': 6.07,
    'L-VVS1-GOOD-VG-FAINT': 6.07,
    'L-VVS1-VG-GOOD-FAINT': 6.07,
    'L-VVS1-EX-POOR-FAINT': 6.07,
    'L-VVS2-POOR-EX-NONE': 6.07,
    'L-VVS2-GOOD-VG-NONE': 6.07,
    'L-VVS2-VG-GOOD-NONE': 6.07,
    'L-VVS2-EX-POOR-NONE': 6.07,
    'D-I1-GOOD-GOOD-FAINT': 6.06,
    'D-I2-GOOD-GOOD-NONE': 6.06,
    'F-VS1-POOR-GOOD-MEDIUM': 6.06,
    'F-VS1-GOOD-POOR-MEDIUM': 6.06,
    'F-VS2-POOR-GOOD-FAINT': 6.06,
    'F-VS2-GOOD-POOR-FAINT': 6.06,
    'H-IF-POOR-POOR-MEDIUM': 6.06,
    'I-VS1-GOOD-EX-STRONG': 6.06,
    'I-VS1-EX-GOOD-STRONG': 6.06,
    'I-VS2-GOOD-EX-MEDIUM': 6.06,
    'I-VS2-EX-GOOD-MEDIUM': 6.06,
    'I-SI1-VG-VG-FAINT': 6.06,
    'I-SI2-VG-VG-NONE': 6.06,
    'K-IF-POOR-EX-STRONG': 6.06,
    'K-IF-GOOD-VG-STRONG': 6.06,
    'K-IF-VG-GOOD-STRONG': 6.06,
    'K-IF-EX-POOR-STRONG': 6.06,
    'F-SI1-POOR-GOOD-NONE': 6.05,
    'F-SI1-GOOD-POOR-NONE': 6.05,
    'H-VVS1-POOR-POOR-FAINT': 6.05,
    'H-VVS2-POOR-POOR-NONE': 6.05,
    'I-SI1-GOOD-EX-FAINT': 6.05,
    'I-SI1-EX-GOOD-FAINT': 6.05,
    'I-SI2-GOOD-EX-NONE': 6.05,
    'I-SI2-EX-GOOD-NONE': 6.05,
    'K-VVS1-POOR-EX-MEDIUM': 6.05,
    'K-VVS1-GOOD-VG-MEDIUM': 6.05,
    'K-VVS1-VG-GOOD-MEDIUM': 6.05,
    'K-VVS1-EX-POOR-MEDIUM': 6.05,
    'K-VVS2-POOR-EX-FAINT': 6.05,
    'K-VVS2-GOOD-VG-FAINT': 6.05,
    'K-VVS2-VG-GOOD-FAINT': 6.05,
    'K-VVS2-EX-POOR-FAINT': 6.05,
    'E-VS1-POOR-GOOD-STRONG': 6.04,
    'E-VS1-GOOD-POOR-STRONG': 6.04,
    'E-VS2-POOR-GOOD-MEDIUM': 6.04,
    'E-VS2-GOOD-POOR-MEDIUM': 6.04,
    'F-I1-VG-EX-STRONG': 6.04,
    'F-I1-EX-VG-STRONG': 6.04,
    'F-I2-VG-EX-MEDIUM': 6.04,
    'F-I2-EX-VG-MEDIUM': 6.04,
    'G-IF-POOR-POOR-STRONG': 6.04,
    'H-VS2-VG-VG-STRONG': 6.04,
    'K-VS1-POOR-EX-NONE': 6.04,
    'K-VS1-GOOD-VG-NONE': 6.04,
    'K-VS1-VG-GOOD-NONE': 6.04,
    'K-VS1-EX-POOR-NONE': 6.04,
    'M-IF-POOR-VG-NONE': 6.04,
    'M-IF-VG-POOR-NONE': 6.04,
    'E-SI1-POOR-GOOD-FAINT': 6.03,
    'E-SI1-GOOD-POOR-FAINT': 6.03,
    'E-SI2-POOR-GOOD-NONE': 6.03,
    'E-SI2-GOOD-POOR-NONE': 6.03,
    'G-VVS1-POOR-POOR-MEDIUM': 6.03,
    'G-VVS2-POOR-POOR-FAINT': 6.03,
    'H-VS2-GOOD-EX-STRONG': 6.03,
    'H-VS2-EX-GOOD-STRONG': 6.03,
    'H-SI1-VG-VG-MEDIUM': 6.03,
    'H-SI2-VG-VG-FAINT': 6.03,
    'M-IF-GOOD-GOOD-NONE': 6.03,
    'E-I2-VG-EX-STRONG': 6.02,
    'E-I2-EX-VG-STRONG': 6.02,
    'G-VS1-POOR-POOR-NONE': 6.02,
    'H-SI1-GOOD-EX-MEDIUM': 6.02,
    'H-SI1-EX-GOOD-MEDIUM': 6.02,
    'H-SI2-GOOD-EX-FAINT': 6.02,
    'H-SI2-EX-GOOD-FAINT': 6.02,
    'H-I1-VG-VG-NONE': 6.02,
    'J-VVS1-POOR-EX-STRONG': 6.02,
    'J-VVS1-GOOD-VG-STRONG': 6.02,
    'J-VVS1-VG-GOOD-STRONG': 6.02,
    'J-VVS1-EX-POOR-STRONG': 6.02,
    'J-VVS2-POOR-EX-MEDIUM': 6.02,
    'J-VVS2-GOOD-VG-MEDIUM': 6.02,
    'J-VVS2-VG-GOOD-MEDIUM': 6.02,
    'J-VVS2-EX-POOR-MEDIUM': 6.02,
    'M-VVS2-EX-EX-STRONG': 6.02,
    'D-VS2-POOR-GOOD-STRONG': 6.01,
    'D-VS2-GOOD-POOR-STRONG': 6.01,
    'G-SI1-VG-VG-STRONG': 6.01,
    'G-SI2-VG-VG-MEDIUM': 6.01,
    'H-I1-GOOD-EX-NONE': 6.01,
    'H-I1-EX-GOOD-NONE': 6.01,
    'J-VS1-POOR-EX-FAINT': 6.01,
    'J-VS1-GOOD-VG-FAINT': 6.01,
    'J-VS1-VG-GOOD-FAINT': 6.01,
    'J-VS1-EX-POOR-FAINT': 6.01,
    'J-VS2-POOR-EX-NONE': 6.01,
    'J-VS2-GOOD-VG-NONE': 6.01,
    'J-VS2-VG-GOOD-NONE': 6.01,
    'J-VS2-EX-POOR-NONE': 6.01,
    'L-IF-POOR-VG-FAINT': 6.01,
    'L-IF-VG-POOR-FAINT': 6.01,
    'M-VS1-EX-EX-MEDIUM': 6.01,
    'M-VS2-EX-EX-FAINT': 6.01,
    'D-SI1-POOR-GOOD-MEDIUM': 6.0,
    'D-SI1-GOOD-POOR-MEDIUM': 6.0,
    'D-SI2-POOR-GOOD-FAINT': 6.0,
    'D-SI2-GOOD-POOR-FAINT': 6.0,
    'F-VVS1-POOR-POOR-STRONG': 6.0,
    'F-VVS2-POOR-POOR-MEDIUM': 6.0,
    'G-SI1-GOOD-EX-STRONG': 6.0,
    'G-SI1-EX-GOOD-STRONG': 6.0,
    'G-SI2-GOOD-EX-MEDIUM': 6.0,
    'G-SI2-EX-GOOD-MEDIUM': 6.0,
    'G-I1-VG-VG-FAINT': 6.0,
    'G-I2-VG-VG-NONE': 6.0,
    'I-VVS2-POOR-EX-STRONG': 6.0,
    'I-VVS2-GOOD-VG-STRONG': 6.0,
    'I-VVS2-VG-GOOD-STRONG': 6.0,
    'I-VVS2-EX-POOR-STRONG': 6.0,
    'L-IF-GOOD-GOOD-FAINT': 6.0,
    'L-VVS1-POOR-VG-NONE': 6.0,
    'L-VVS1-VG-POOR-NONE': 6.0,
    'M-SI1-EX-EX-NONE': 6.0,
    'D-I1-POOR-GOOD-NONE': 5.99,
    'D-I1-GOOD-POOR-NONE': 5.99,
    'F-VS1-POOR-POOR-FAINT': 5.99,
    'F-VS2-POOR-POOR-NONE': 5.99,
    'G-I1-GOOD-EX-FAINT': 5.99,
    'G-I1-EX-GOOD-FAINT': 5.99,
    'G-I2-GOOD-EX-NONE': 5.99,
    'G-I2-EX-GOOD-NONE': 5.99,
    'I-VS1-POOR-EX-MEDIUM': 5.99,
    'I-VS1-GOOD-VG-MEDIUM': 5.99,
    'I-VS1-VG-GOOD-MEDIUM': 5.99,
    'I-VS1-EX-POOR-MEDIUM': 5.99,
    'I-VS2-POOR-EX-FAINT': 5.99,
    'I-VS2-GOOD-VG-FAINT': 5.99,
    'I-VS2-VG-GOOD-FAINT': 5.99,
    'I-VS2-EX-POOR-FAINT': 5.99,
    'K-IF-POOR-VG-MEDIUM': 5.99,
    'K-IF-VG-POOR-MEDIUM': 5.99,
    'L-VVS1-GOOD-GOOD-NONE': 5.99,
    'E-VVS2-POOR-POOR-STRONG': 5.98,
    'F-SI2-VG-VG-STRONG': 5.98,
    'I-SI1-POOR-EX-NONE': 5.98,
    'I-SI1-GOOD-VG-NONE': 5.98,
    'I-SI1-VG-GOOD-NONE': 5.98,
    'I-SI1-EX-POOR-NONE': 5.98,
    'K-IF-GOOD-GOOD-MEDIUM': 5.98,
    'K-VVS1-POOR-VG-FAINT': 5.98,
    'K-VVS1-VG-POOR-FAINT': 5.98,
    'K-VVS2-POOR-VG-NONE': 5.98,
    'K-VVS2-VG-POOR-NONE': 5.98,
    'L-VS1-EX-EX-STRONG': 5.98,
    'L-VS2-EX-EX-MEDIUM': 5.98,
    'E-VS1-POOR-POOR-MEDIUM': 5.97,
    'E-VS2-POOR-POOR-FAINT': 5.97,
    'F-SI2-GOOD-EX-STRONG': 5.97,
    'F-SI2-EX-GOOD-STRONG': 5.97,
    'F-I1-VG-VG-MEDIUM': 5.97,
    'F-I2-VG-VG-FAINT': 5.97,
    'K-VVS1-GOOD-GOOD-FAINT': 5.97,
    'K-VVS2-GOOD-GOOD-NONE': 5.97,
    'L-SI1-EX-EX-FAINT': 5.97,
    'L-SI2-EX-EX-NONE': 5.97,
    'E-SI1-POOR-POOR-NONE': 5.96,
    'F-I1-GOOD-EX-MEDIUM': 5.96,
    'F-I1-EX-GOOD-MEDIUM': 5.96,
    'F-I2-GOOD-EX-FAINT': 5.96,
    'F-I2-EX-GOOD-FAINT': 5.96,
    'H-VS1-POOR-EX-STRONG': 5.96,
    'H-VS1-GOOD-VG-STRONG': 5.96,
    'H-VS1-VG-GOOD-STRONG': 5.96,
    'H-VS1-EX-POOR-STRONG': 5.96,
    'H-VS2-POOR-EX-MEDIUM': 5.96,
    'H-VS2-GOOD-VG-MEDIUM': 5.96,
    'H-VS2-VG-GOOD-MEDIUM': 5.96,
    'H-VS2-EX-POOR-MEDIUM': 5.96,
    'J-IF-POOR-VG-STRONG': 5.96,
    'J-IF-VG-POOR-STRONG': 5.96,
    'K-VS2-EX-EX-STRONG': 5.96,
    'E-I1-VG-VG-STRONG': 5.95,
    'E-I2-VG-VG-MEDIUM': 5.95,
    'H-SI1-POOR-EX-FAINT': 5.95,
    'H-SI1-GOOD-VG-FAINT': 5.95,
    'H-SI1-VG-GOOD-FAINT': 5.95,
    'H-SI1-EX-POOR-FAINT': 5.95,
    'H-SI2-POOR-EX-NONE': 5.95,
    'H-SI2-GOOD-VG-NONE': 5.95,
    'H-SI2-VG-GOOD-NONE': 5.95,
    'H-SI2-EX-POOR-NONE': 5.95,
    'J-IF-GOOD-GOOD-STRONG': 5.95,
    'J-VVS1-POOR-VG-MEDIUM': 5.95,
    'J-VVS1-VG-POOR-MEDIUM': 5.95,
    'J-VVS2-POOR-VG-FAINT': 5.95,
    'J-VVS2-VG-POOR-FAINT': 5.95,
    'K-SI1-EX-EX-MEDIUM': 5.95,
    'K-SI2-EX-EX-FAINT': 5.95,
    'M-VVS1-VG-EX-STRONG': 5.95,
    'M-VVS1-EX-VG-STRONG': 5.95,
    'M-VVS2-VG-EX-MEDIUM': 5.95,
    'M-VVS2-EX-VG-MEDIUM': 5.95,
    'D-VS1-POOR-POOR-STRONG': 5.94,
    'D-VS2-POOR-POOR-MEDIUM': 5.94,
    'E-I1-GOOD-EX-STRONG': 5.94,
    'E-I1-EX-GOOD-STRONG': 5.94,
    'E-I2-GOOD-EX-MEDIUM': 5.94,
    'E-I2-EX-GOOD-MEDIUM': 5.94,
    'G-VS2-POOR-EX-STRONG': 5.94,
    'G-VS2-GOOD-VG-STRONG': 5.94,
    'G-VS2-VG-GOOD-STRONG': 5.94,
    'G-VS2-EX-POOR-STRONG': 5.94,
    'J-VVS1-GOOD-GOOD-MEDIUM': 5.94,
    'J-VVS2-GOOD-GOOD-FAINT': 5.94,
    'J-VS1-POOR-VG-NONE': 5.94,
    'J-VS1-VG-POOR-NONE': 5.94,
    'K-I1-EX-EX-NONE': 5.94,
    'M-VS1-VG-EX-FAINT': 5.94,
    'M-VS1-EX-VG-FAINT': 5.94,
    'M-VS2-VG-EX-NONE': 5.94,
    'M-VS2-EX-VG-NONE': 5.94,
    'D-SI1-POOR-POOR-FAINT': 5.93,
    'D-SI2-POOR-POOR-NONE': 5.93,
    'G-SI1-POOR-EX-MEDIUM': 5.93,
    'G-SI1-GOOD-VG-MEDIUM': 5.93,
    'G-SI1-VG-GOOD-MEDIUM': 5.93,
    'G-SI1-EX-POOR-MEDIUM': 5.93,
    'G-SI2-POOR-EX-FAINT': 5.93,
    'G-SI2-GOOD-VG-FAINT': 5.93,
    'G-SI2-VG-GOOD-FAINT': 5.93,
    'G-SI2-EX-POOR-FAINT': 5.93,
    'I-VVS1-POOR-VG-STRONG': 5.93,
    'I-VVS1-VG-POOR-STRONG': 5.93,
    'I-VVS2-POOR-VG-MEDIUM': 5.93,
    'I-VVS2-VG-POOR-MEDIUM': 5.93,
    'J-VS1-GOOD-GOOD-NONE': 5.93,
    'L-IF-POOR-GOOD-NONE': 5.93,
    'L-IF-GOOD-POOR-NONE': 5.93,
    'D-I2-VG-VG-STRONG': 5.92,
    'G-I1-POOR-EX-NONE': 5.92,
    'G-I1-GOOD-VG-NONE': 5.92,
    'G-I1-VG-GOOD-NONE': 5.92,
    'G-I1-EX-POOR-NONE': 5.92,
    'I-VVS1-GOOD-GOOD-STRONG': 5.92,
    'I-VVS2-GOOD-GOOD-MEDIUM': 5.92,
    'I-VS1-POOR-VG-FAINT': 5.92,
    'I-VS1-VG-POOR-FAINT': 5.92,
    'I-VS2-POOR-VG-NONE': 5.92,
    'I-VS2-VG-POOR-NONE': 5.92,
    'J-SI1-EX-EX-STRONG': 5.92,
    'J-SI2-EX-EX-MEDIUM': 5.92,
    'L-VVS2-VG-EX-STRONG': 5.92,
    'L-VVS2-EX-VG-STRONG': 5.92,
    'D-I2-GOOD-EX-STRONG': 5.91,
    'D-I2-EX-GOOD-STRONG': 5.91,
    'I-VS1-GOOD-GOOD-FAINT': 5.91,
    'I-VS2-GOOD-GOOD-NONE': 5.91,
    'J-I1-EX-EX-FAINT': 5.91,
    'J-I2-EX-EX-NONE': 5.91,
    'K-IF-POOR-GOOD-FAINT': 5.91,
    'K-IF-GOOD-POOR-FAINT': 5.91,
    'L-VS1-VG-EX-MEDIUM': 5.91,
    'L-VS1-EX-VG-MEDIUM': 5.91,
    'L-VS2-VG-EX-FAINT': 5.91,
    'L-VS2-EX-VG-FAINT': 5.91,
    'F-SI1-POOR-EX-STRONG': 5.9,
    'F-SI1-GOOD-VG-STRONG': 5.9,
    'F-SI1-VG-GOOD-STRONG': 5.9,
    'F-SI1-EX-POOR-STRONG': 5.9,
    'F-SI2-POOR-EX-MEDIUM': 5.9,
    'F-SI2-GOOD-VG-MEDIUM': 5.9,
    'F-SI2-VG-GOOD-MEDIUM': 5.9,
    'F-SI2-EX-POOR-MEDIUM': 5.9,
    'H-VVS2-POOR-VG-STRONG': 5.9,
    'H-VVS2-VG-POOR-STRONG': 5.9,
    'I-SI2-EX-EX-STRONG': 5.9,
    'K-VVS1-POOR-GOOD-NONE': 5.9,
    'K-VVS1-GOOD-POOR-NONE': 5.9,
    'L-SI1-VG-EX-NONE': 5.9,
    'L-SI1-EX-VG-NONE': 5.9,
    'F-I1-POOR-EX-FAINT': 5.89,
    'F-I1-GOOD-VG-FAINT': 5.89,
    'F-I1-VG-GOOD-FAINT': 5.89,
    'F-I1-EX-POOR-FAINT': 5.89,
    'F-I2-POOR-EX-NONE': 5.89,
    'F-I2-GOOD-VG-NONE': 5.89,
    'F-I2-VG-GOOD-NONE': 5.89,
    'F-I2-EX-POOR-NONE': 5.89,
    'H-VVS2-GOOD-GOOD-STRONG': 5.89,
    'H-VS1-POOR-VG-MEDIUM': 5.89,
    'H-VS1-VG-POOR-MEDIUM': 5.89,
    'H-VS2-POOR-VG-FAINT': 5.89,
    'H-VS2-VG-POOR-FAINT': 5.89,
    'I-I1-EX-EX-MEDIUM': 5.89,
    'I-I2-EX-EX-FAINT': 5.89,
    'K-VS1-VG-EX-STRONG': 5.89,
    'K-VS1-EX-VG-STRONG': 5.89,
    'K-VS2-VG-EX-MEDIUM': 5.89,
    'K-VS2-EX-VG-MEDIUM': 5.89,
    'M-IF-VG-VG-STRONG': 5.89,
    'E-SI2-POOR-EX-STRONG': 5.88,
    'E-SI2-GOOD-VG-STRONG': 5.88,
    'E-SI2-VG-GOOD-STRONG': 5.88,
    'E-SI2-EX-POOR-STRONG': 5.88,
    'H-VS1-GOOD-GOOD-MEDIUM': 5.88,
    'H-VS2-GOOD-GOOD-FAINT': 5.88,
    'H-SI1-POOR-VG-NONE': 5.88,
    'H-SI1-VG-POOR-NONE': 5.88,
    'J-IF-POOR-GOOD-MEDIUM': 5.88,
    'J-IF-GOOD-POOR-MEDIUM': 5.88,
    'K-SI1-VG-EX-FAINT': 5.88,
    'K-SI1-EX-VG-FAINT': 5.88,
    'K-SI2-VG-EX-NONE': 5.88,
    'K-SI2-EX-VG-NONE': 5.88,
    'M-IF-GOOD-EX-STRONG': 5.88,
    'M-IF-EX-GOOD-STRONG': 5.88,
    'M-VVS1-VG-VG-MEDIUM': 5.88,
    'M-VVS2-VG-VG-FAINT': 5.88,
    'E-I1-POOR-EX-MEDIUM': 5.87,
    'E-I1-GOOD-VG-MEDIUM': 5.87,
    'E-I1-VG-GOOD-MEDIUM': 5.87,
    'E-I1-EX-POOR-MEDIUM': 5.87,
    'E-I2-POOR-EX-FAINT': 5.87,
    'E-I2-GOOD-VG-FAINT': 5.87,
    'E-I2-VG-GOOD-FAINT': 5.87,
    'E-I2-EX-POOR-FAINT': 5.87,
    'G-VS1-POOR-VG-STRONG': 5.87,
    'G-VS1-VG-POOR-STRONG': 5.87,
    'G-VS2-POOR-VG-MEDIUM': 5.87,
    'G-VS2-VG-POOR-MEDIUM': 5.87,
    'H-SI1-GOOD-GOOD-NONE': 5.87,
    'J-VVS1-POOR-GOOD-FAINT': 5.87,
    'J-VVS1-GOOD-POOR-FAINT': 5.87,
    'J-VVS2-POOR-GOOD-NONE': 5.87,
    'J-VVS2-GOOD-POOR-NONE': 5.87,
    'M-VVS1-GOOD-EX-MEDIUM': 5.87,
    'M-VVS1-EX-GOOD-MEDIUM': 5.87,
    'M-VVS2-GOOD-EX-FAINT': 5.87,
    'M-VVS2-EX-GOOD-FAINT': 5.87,
    'M-VS1-VG-VG-NONE': 5.87,
    'G-VS1-GOOD-GOOD-STRONG': 5.86,
    'G-VS2-GOOD-GOOD-MEDIUM': 5.86,
    'G-SI1-POOR-VG-FAINT': 5.86,
    'G-SI1-VG-POOR-FAINT': 5.86,
    'G-SI2-POOR-VG-NONE': 5.86,
    'G-SI2-VG-POOR-NONE': 5.86,
    'H-I1-EX-EX-STRONG': 5.86,
    'H-I2-EX-EX-MEDIUM': 5.86,
    'I-IF-POOR-GOOD-STRONG': 5.86,
    'I-IF-GOOD-POOR-STRONG': 5.86,
    'J-VS2-VG-EX-STRONG': 5.86,
    'J-VS2-EX-VG-STRONG': 5.86,
    'M-VS1-GOOD-EX-NONE': 5.86,
    'M-VS1-EX-GOOD-NONE': 5.86,
    'G-SI1-GOOD-GOOD-FAINT': 5.85,
    'G-SI2-GOOD-GOOD-NONE': 5.85,
    'I-VVS1-POOR-GOOD-MEDIUM': 5.85,
    'I-VVS1-GOOD-POOR-MEDIUM': 5.85,
    'I-VVS2-POOR-GOOD-FAINT': 5.85,
    'I-VVS2-GOOD-POOR-FAINT': 5.85,
    'J-SI1-VG-EX-MEDIUM': 5.85,
    'J-SI1-EX-VG-MEDIUM': 5.85,
    'J-SI2-VG-EX-FAINT': 5.85,
    'J-SI2-EX-VG-FAINT': 5.85,
    'L-VVS1-VG-VG-STRONG': 5.85,
    'L-VVS2-VG-VG-MEDIUM': 5.85,
    'D-I1-POOR-EX-STRONG': 5.84,
    'D-I1-GOOD-VG-STRONG': 5.84,
    'D-I1-VG-GOOD-STRONG': 5.84,
    'D-I1-EX-POOR-STRONG': 5.84,
    'D-I2-POOR-EX-MEDIUM': 5.84,
    'D-I2-GOOD-VG-MEDIUM': 5.84,
    'D-I2-VG-GOOD-MEDIUM': 5.84,
    'D-I2-EX-POOR-MEDIUM': 5.84,
    'F-VS2-POOR-VG-STRONG': 5.84,
    'F-VS2-VG-POOR-STRONG': 5.84,
    'G-I2-EX-EX-STRONG': 5.84,
    'I-VS1-POOR-GOOD-NONE': 5.84,
    'I-VS1-GOOD-POOR-NONE': 5.84,
    'J-I1-VG-EX-NONE': 5.84,
    'J-I1-EX-VG-NONE': 5.84,
    'K-IF-POOR-POOR-NONE': 5.84,
    'L-VVS1-GOOD-EX-STRONG': 5.84,
    'L-VVS1-EX-GOOD-STRONG': 5.84,
    'L-VVS2-GOOD-EX-MEDIUM': 5.84,
    'L-VVS2-EX-GOOD-MEDIUM': 5.84,
    'L-VS1-VG-VG-FAINT': 5.84,
    'L-VS2-VG-VG-NONE': 5.84,
    'F-VS2-GOOD-GOOD-STRONG': 5.83,
    'F-SI1-POOR-VG-MEDIUM': 5.83,
    'F-SI1-VG-POOR-MEDIUM': 5.83,
    'F-SI2-POOR-VG-FAINT': 5.83,
    'F-SI2-VG-POOR-FAINT': 5.83,
    'I-SI1-VG-EX-STRONG': 5.83,
    'I-SI1-EX-VG-STRONG': 5.83,
    'I-SI2-VG-EX-MEDIUM': 5.83,
    'I-SI2-EX-VG-MEDIUM': 5.83,
    'K-VVS2-VG-VG-STRONG': 5.83,
    'L-VS1-GOOD-EX-FAINT': 5.83,
    'L-VS1-EX-GOOD-FAINT': 5.83,
    'L-VS2-GOOD-EX-NONE': 5.83,
    'L-VS2-EX-GOOD-NONE': 5.83,
    'F-SI1-GOOD-GOOD-MEDIUM': 5.82,
    'F-SI2-GOOD-GOOD-FAINT': 5.82,
    'F-I1-POOR-VG-NONE': 5.82,
    'F-I1-VG-POOR-NONE': 5.82,
    'H-VVS1-POOR-GOOD-STRONG': 5.82,
    'H-VVS1-GOOD-POOR-STRONG': 5.82,
    'H-VVS2-POOR-GOOD-MEDIUM': 5.82,
    'H-VVS2-GOOD-POOR-MEDIUM': 5.82,
    'I-I1-VG-EX-FAINT': 5.82,
    'I-I1-EX-VG-FAINT': 5.82,
    'I-I2-VG-EX-NONE': 5.82,
    'I-I2-EX-VG-NONE': 5.82,
    'K-VVS2-GOOD-EX-STRONG': 5.82,
    'K-VVS2-EX-GOOD-STRONG': 5.82,
    'K-VS1-VG-VG-MEDIUM': 5.82,
    'K-VS2-VG-VG-FAINT': 5.82,
    'E-SI1-POOR-VG-STRONG': 5.81,
    'E-SI1-VG-POOR-STRONG': 5.81,
    'E-SI2-POOR-VG-MEDIUM': 5.81,
    'E-SI2-VG-POOR-MEDIUM': 5.81,
    'F-I1-GOOD-GOOD-NONE': 5.81,
    'H-VS1-POOR-GOOD-FAINT': 5.81,
    'H-VS1-GOOD-POOR-FAINT': 5.81,
    'H-VS2-POOR-GOOD-NONE': 5.81,
    'H-VS2-GOOD-POOR-NONE': 5.81,
    'J-IF-POOR-POOR-FAINT': 5.81,
    'K-VS1-GOOD-EX-MEDIUM': 5.81,
    'K-VS1-EX-GOOD-MEDIUM': 5.81,
    'K-VS2-GOOD-EX-FAINT': 5.81,
    'K-VS2-EX-GOOD-FAINT': 5.81,
    'K-SI1-VG-VG-NONE': 5.81,
    'M-IF-POOR-EX-MEDIUM': 5.81,
    'M-IF-GOOD-VG-MEDIUM': 5.81,
    'M-IF-VG-GOOD-MEDIUM': 5.81,
    'M-IF-EX-POOR-MEDIUM': 5.81,
    'E-SI1-GOOD-GOOD-STRONG': 5.8,
    'E-SI2-GOOD-GOOD-MEDIUM': 5.8,
    'E-I1-POOR-VG-FAINT': 5.8,
    'E-I1-VG-POOR-FAINT': 5.8,
    'E-I2-POOR-VG-NONE': 5.8,
    'E-I2-VG-POOR-NONE': 5.8,
    'G-VVS2-POOR-GOOD-STRONG': 5.8,
    'G-VVS2-GOOD-POOR-STRONG': 5.8,
    'H-SI2-VG-EX-STRONG': 5.8,
    'H-SI2-EX-VG-STRONG': 5.8,
    'J-VVS1-POOR-POOR-NONE': 5.8,
    'K-SI1-GOOD-EX-NONE': 5.8,
    'K-SI1-EX-GOOD-NONE': 5.8,
    'M-VVS1-POOR-EX-FAINT': 5.8,
    'M-VVS1-GOOD-VG-FAINT': 5.8,
    'M-VVS1-VG-GOOD-FAINT': 5.8,
    'M-VVS1-EX-POOR-FAINT': 5.8,
    'M-VVS2-POOR-EX-NONE': 5.8,
    'M-VVS2-GOOD-VG-NONE': 5.8,
    'M-VVS2-VG-GOOD-NONE': 5.8,
    'M-VVS2-EX-POOR-NONE': 5.8,
    'E-I1-GOOD-GOOD-FAINT': 5.79,
    'E-I2-GOOD-GOOD-NONE': 5.79,
    'G-VS1-POOR-GOOD-MEDIUM': 5.79,
    'G-VS1-GOOD-POOR-MEDIUM': 5.79,
    'G-VS2-POOR-GOOD-FAINT': 5.79,
    'G-VS2-GOOD-POOR-FAINT': 5.79,
    'H-I1-VG-EX-MEDIUM': 5.79,
    'H-I1-EX-VG-MEDIUM': 5.79,
    'H-I2-VG-EX-FAINT': 5.79,
    'H-I2-EX-VG-FAINT': 5.79,
    'I-IF-POOR-POOR-MEDIUM': 5.79,
    'J-VS1-VG-VG-STRONG': 5.79,
    'J-VS2-VG-VG-MEDIUM': 5.79,
    'D-SI2-POOR-VG-STRONG': 5.78,
    'D-SI2-VG-POOR-STRONG': 5.78,
    'G-SI1-POOR-GOOD-NONE': 5.78,
    'G-SI1-GOOD-POOR-NONE': 5.78,
    'I-VVS1-POOR-POOR-FAINT': 5.78,
    'I-VVS2-POOR-POOR-NONE': 5.78,
    'J-VS1-GOOD-EX-STRONG': 5.78,
    'J-VS1-EX-GOOD-STRONG': 5.78,
    'J-VS2-GOOD-EX-MEDIUM': 5.78,
    'J-VS2-EX-GOOD-MEDIUM': 5.78,
    'J-SI1-VG-VG-FAINT': 5.78,
    'J-SI2-VG-VG-NONE': 5.78,
    'L-IF-POOR-EX-STRONG': 5.78,
    'L-IF-GOOD-VG-STRONG': 5.78,
    'L-IF-VG-GOOD-STRONG': 5.78,
    'L-IF-EX-POOR-STRONG': 5.78,
    'D-SI2-GOOD-GOOD-STRONG': 5.77,
    'D-I1-POOR-VG-MEDIUM': 5.77,
    'D-I1-VG-POOR-MEDIUM': 5.77,
    'D-I2-POOR-VG-FAINT': 5.77,
    'D-I2-VG-POOR-FAINT': 5.77,
    'G-I1-VG-EX-STRONG': 5.77,
    'G-I1-EX-VG-STRONG': 5.77,
    'G-I2-VG-EX-MEDIUM': 5.77,
    'G-I2-EX-VG-MEDIUM': 5.77,
    'I-VS2-VG-VG-STRONG': 5.77,
    'J-SI1-GOOD-EX-FAINT': 5.77,
    'J-SI1-EX-GOOD-FAINT': 5.77,
    'J-SI2-GOOD-EX-NONE': 5.77,
    'J-SI2-EX-GOOD-NONE': 5.77,
    'L-VVS1-POOR-EX-MEDIUM': 5.77,
    'L-VVS1-GOOD-VG-MEDIUM': 5.77,
    'L-VVS1-VG-GOOD-MEDIUM': 5.77,
    'L-VVS1-EX-POOR-MEDIUM': 5.77,
    'L-VVS2-POOR-EX-FAINT': 5.77,
    'L-VVS2-GOOD-VG-FAINT': 5.77,
    'L-VVS2-VG-GOOD-FAINT': 5.77,
    'L-VVS2-EX-POOR-FAINT': 5.77,
    'D-I1-GOOD-GOOD-MEDIUM': 5.76,
    'D-I2-GOOD-GOOD-FAINT': 5.76,
    'F-VS1-POOR-GOOD-STRONG': 5.76,
    'F-VS1-GOOD-POOR-STRONG': 5.76,
    'F-VS2-POOR-GOOD-MEDIUM': 5.76,
    'F-VS2-GOOD-POOR-MEDIUM': 5.76,
    'H-IF-POOR-POOR-STRONG': 5.76,
    'I-VS2-GOOD-EX-STRONG': 5.76,
    'I-VS2-EX-GOOD-STRONG': 5.76,
    'I-SI1-VG-VG-MEDIUM': 5.76,
    'I-SI2-VG-VG-FAINT': 5.76,
    'L-VS1-POOR-EX-NONE': 5.76,
    'L-VS1-GOOD-VG-NONE': 5.76,
    'L-VS1-VG-GOOD-NONE': 5.76,
    'L-VS1-EX-POOR-NONE': 5.76,
    'F-SI1-POOR-GOOD-FAINT': 5.75,
    'F-SI1-GOOD-POOR-FAINT': 5.75,
    'F-SI2-POOR-GOOD-NONE': 5.75,
    'F-SI2-GOOD-POOR-NONE': 5.75,
    'H-VVS1-POOR-POOR-MEDIUM': 5.75,
    'H-VVS2-POOR-POOR-FAINT': 5.75,
    'I-SI1-GOOD-EX-MEDIUM': 5.75,
    'I-SI1-EX-GOOD-MEDIUM': 5.75,
    'I-SI2-GOOD-EX-FAINT': 5.75,
    'I-SI2-EX-GOOD-FAINT': 5.75,
    'I-I1-VG-VG-NONE': 5.75,
    'K-VVS1-POOR-EX-STRONG': 5.75,
    'K-VVS1-GOOD-VG-STRONG': 5.75,
    'K-VVS1-VG-GOOD-STRONG': 5.75,
    'K-VVS1-EX-POOR-STRONG': 5.75,
    'K-VVS2-POOR-EX-MEDIUM': 5.75,
    'K-VVS2-GOOD-VG-MEDIUM': 5.75,
    'K-VVS2-VG-GOOD-MEDIUM': 5.75,
    'K-VVS2-EX-POOR-MEDIUM': 5.75,
    'E-VS2-POOR-GOOD-STRONG': 5.74,
    'E-VS2-GOOD-POOR-STRONG': 5.74,
    'F-I2-VG-EX-STRONG': 5.74,
    'F-I2-EX-VG-STRONG': 5.74,
    'H-VS1-POOR-POOR-NONE': 5.74,
    'I-I1-GOOD-EX-NONE': 5.74,
    'I-I1-EX-GOOD-NONE': 5.74,
    'K-VS1-POOR-EX-FAINT': 5.74,
    'K-VS1-GOOD-VG-FAINT': 5.74,
    'K-VS1-VG-GOOD-FAINT': 5.74,
    'K-VS1-EX-POOR-FAINT': 5.74,
    'K-VS2-POOR-EX-NONE': 5.74,
    'K-VS2-GOOD-VG-NONE': 5.74,
    'K-VS2-VG-GOOD-NONE': 5.74,
    'K-VS2-EX-POOR-NONE': 5.74,
    'M-IF-POOR-VG-FAINT': 5.74,
    'M-IF-VG-POOR-FAINT': 5.74,
    'E-SI1-POOR-GOOD-MEDIUM': 5.73,
    'E-SI1-GOOD-POOR-MEDIUM': 5.73,
    'E-SI2-POOR-GOOD-FAINT': 5.73,
    'E-SI2-GOOD-POOR-FAINT': 5.73,
    'G-VVS1-POOR-POOR-STRONG': 5.73,
    'G-VVS2-POOR-POOR-MEDIUM': 5.73,
    'H-SI1-VG-VG-STRONG': 5.73,
    'H-SI2-VG-VG-MEDIUM': 5.73,
    'M-IF-GOOD-GOOD-FAINT': 5.73,
    'M-VVS1-POOR-VG-NONE': 5.73,
    'M-VVS1-VG-POOR-NONE': 5.73,
    'E-I1-POOR-GOOD-NONE': 5.72,
    'E-I1-GOOD-POOR-NONE': 5.72,
    'G-VS1-POOR-POOR-FAINT': 5.72,
    'G-VS2-POOR-POOR-NONE': 5.72,
    'H-SI1-GOOD-EX-STRONG': 5.72,
    'H-SI1-EX-GOOD-STRONG': 5.72,
    'H-SI2-GOOD-EX-MEDIUM': 5.72,
    'H-SI2-EX-GOOD-MEDIUM': 5.72,
    'H-I1-VG-VG-FAINT': 5.72,
    'H-I2-VG-VG-NONE': 5.72,
    'J-VVS2-POOR-EX-STRONG': 5.72,
    'J-VVS2-GOOD-VG-STRONG': 5.72,
    'J-VVS2-VG-GOOD-STRONG': 5.72,
    'J-VVS2-EX-POOR-STRONG': 5.72,
    'M-VVS1-GOOD-GOOD-NONE': 5.72,
    'G-SI2-VG-VG-STRONG': 5.71,
    'H-I1-GOOD-EX-FAINT': 5.71,
    'H-I1-EX-GOOD-FAINT': 5.71,
    'H-I2-GOOD-EX-NONE': 5.71,
    'H-I2-EX-GOOD-NONE': 5.71,
    'J-VS1-POOR-EX-MEDIUM': 5.71,
    'J-VS1-GOOD-VG-MEDIUM': 5.71,
    'J-VS1-VG-GOOD-MEDIUM': 5.71,
    'J-VS1-EX-POOR-MEDIUM': 5.71,
    'J-VS2-POOR-EX-FAINT': 5.71,
    'J-VS2-GOOD-VG-FAINT': 5.71,
    'J-VS2-VG-GOOD-FAINT': 5.71,
    'J-VS2-EX-POOR-FAINT': 5.71,
    'L-IF-POOR-VG-MEDIUM': 5.71,
    'L-IF-VG-POOR-MEDIUM': 5.71,
    'M-VS1-EX-EX-STRONG': 5.71,
    'M-VS2-EX-EX-MEDIUM': 5.71,
    'D-SI1-POOR-GOOD-STRONG': 5.7,
    'D-SI1-GOOD-POOR-STRONG': 5.7,
    'D-SI2-POOR-GOOD-MEDIUM': 5.7,
    'D-SI2-GOOD-POOR-MEDIUM': 5.7,
    'F-VVS2-POOR-POOR-STRONG': 5.7,
    'G-SI2-GOOD-EX-STRONG': 5.7,
    'G-SI2-EX-GOOD-STRONG': 5.7,
    'G-I1-VG-VG-MEDIUM': 5.7,
    'G-I2-VG-VG-FAINT': 5.7,
    'J-SI1-POOR-EX-NONE': 5.7,
    'J-SI1-GOOD-VG-NONE': 5.7,
    'J-SI1-VG-GOOD-NONE': 5.7,
    'J-SI1-EX-POOR-NONE': 5.7,
    'L-IF-GOOD-GOOD-MEDIUM': 5.7,
    'L-VVS1-POOR-VG-FAINT': 5.7,
    'L-VVS1-VG-POOR-FAINT': 5.7,
    'L-VVS2-POOR-VG-NONE': 5.7,
    'L-VVS2-VG-POOR-NONE': 5.7,
    'M-SI1-EX-EX-FAINT': 5.7,
    'M-SI2-EX-EX-NONE': 5.7,
    'D-I1-POOR-GOOD-FAINT': 5.69,
    'D-I1-GOOD-POOR-FAINT': 5.69,
    'D-I2-POOR-GOOD-NONE': 5.69,
    'D-I2-GOOD-POOR-NONE': 5.69,
    'F-VS1-POOR-POOR-MEDIUM': 5.69,
    'F-VS2-POOR-POOR-FAINT': 5.69,
    'G-I1-GOOD-EX-MEDIUM': 5.69,
    'G-I1-EX-GOOD-MEDIUM': 5.69,
    'G-I2-GOOD-EX-FAINT': 5.69,
    'G-I2-EX-GOOD-FAINT': 5.69,
    'I-VS1-POOR-EX-STRONG': 5.69,
    'I-VS1-GOOD-VG-STRONG': 5.69,
    'I-VS1-VG-GOOD-STRONG': 5.69,
    'I-VS1-EX-POOR-STRONG': 5.69,
    'I-VS2-POOR-EX-MEDIUM': 5.69,
    'I-VS2-GOOD-VG-MEDIUM': 5.69,
    'I-VS2-VG-GOOD-MEDIUM': 5.69,
    'I-VS2-EX-POOR-MEDIUM': 5.69,
    'K-IF-POOR-VG-STRONG': 5.69,
    'K-IF-VG-POOR-STRONG': 5.69,
    'L-VVS1-GOOD-GOOD-FAINT': 5.69,
    'L-VVS2-GOOD-GOOD-NONE': 5.69,
    'F-SI1-POOR-POOR-NONE': 5.68,
    'I-SI1-POOR-EX-FAINT': 5.68,
    'I-SI1-GOOD-VG-FAINT': 5.68,
    'I-SI1-VG-GOOD-FAINT': 5.68,
    'I-SI1-EX-POOR-FAINT': 5.68,
    'I-SI2-POOR-EX-NONE': 5.68,
    'I-SI2-GOOD-VG-NONE': 5.68,
    'I-SI2-VG-GOOD-NONE': 5.68,
    'I-SI2-EX-POOR-NONE': 5.68,
    'K-IF-GOOD-GOOD-STRONG': 5.68,
    'K-VVS1-POOR-VG-MEDIUM': 5.68,
    'K-VVS1-VG-POOR-MEDIUM': 5.68,
    'K-VVS2-POOR-VG-FAINT': 5.68,
    'K-VVS2-VG-POOR-FAINT': 5.68,
    'L-VS2-EX-EX-STRONG': 5.68,
    'E-VS1-POOR-POOR-STRONG': 5.67,
    'E-VS2-POOR-POOR-MEDIUM': 5.67,
    'F-I1-VG-VG-STRONG': 5.67,
    'F-I2-VG-VG-MEDIUM': 5.67,
    'K-VVS1-GOOD-GOOD-MEDIUM': 5.67,
    'K-VVS2-GOOD-GOOD-FAINT': 5.67,
    'K-VS1-POOR-VG-NONE': 5.67,
    'K-VS1-VG-POOR-NONE': 5.67,
    'L-SI1-EX-EX-MEDIUM': 5.67,
    'L-SI2-EX-EX-FAINT': 5.67,
    'E-SI1-POOR-POOR-FAINT': 5.66,
    'E-SI2-POOR-POOR-NONE': 5.66,
    'F-I1-GOOD-EX-STRONG': 5.66,
    'F-I1-EX-GOOD-STRONG': 5.66,
    'F-I2-GOOD-EX-MEDIUM': 5.66,
    'F-I2-EX-GOOD-MEDIUM': 5.66,
    'H-VS2-POOR-EX-STRONG': 5.66,
    'H-VS2-GOOD-VG-STRONG': 5.66,
    'H-VS2-VG-GOOD-STRONG': 5.66,
    'H-VS2-EX-POOR-STRONG': 5.66,
    'K-VS1-GOOD-GOOD-NONE': 5.66,
    'L-I1-EX-EX-NONE': 5.66,
    'M-IF-POOR-GOOD-NONE': 5.66,
    'M-IF-GOOD-POOR-NONE': 5.66,
    'E-I2-VG-VG-STRONG': 5.65,
    'H-SI1-POOR-EX-MEDIUM': 5.65,
    'H-SI1-GOOD-VG-MEDIUM': 5.65,
    'H-SI1-VG-GOOD-MEDIUM': 5.65,
    'H-SI1-EX-POOR-MEDIUM': 5.65,
    'H-SI2-POOR-EX-FAINT': 5.65,
    'H-SI2-GOOD-VG-FAINT': 5.65,
    'H-SI2-VG-GOOD-FAINT': 5.65,
    'H-SI2-EX-POOR-FAINT': 5.65,
    'J-VVS1-POOR-VG-STRONG': 5.65,
    'J-VVS1-VG-POOR-STRONG': 5.65,
    'J-VVS2-POOR-VG-MEDIUM': 5.65,
    'J-VVS2-VG-POOR-MEDIUM': 5.65,
    'K-SI1-EX-EX-STRONG': 5.65,
    'K-SI2-EX-EX-MEDIUM': 5.65,
    'M-VVS2-VG-EX-STRONG': 5.65,
    'M-VVS2-EX-VG-STRONG': 5.65,
    'D-VS2-POOR-POOR-STRONG': 5.64,
    'E-I2-GOOD-EX-STRONG': 5.64,
    'E-I2-EX-GOOD-STRONG': 5.64,
    'H-I1-POOR-EX-NONE': 5.64,
    'H-I1-GOOD-VG-NONE': 5.64,
    'H-I1-VG-GOOD-NONE': 5.64,
    'H-I1-EX-POOR-NONE': 5.64,
    'J-VVS1-GOOD-GOOD-STRONG': 5.64,
    'J-VVS2-GOOD-GOOD-MEDIUM': 5.64,
    'J-VS1-POOR-VG-FAINT': 5.64,
    'J-VS1-VG-POOR-FAINT': 5.64,
    'J-VS2-POOR-VG-NONE': 5.64,
    'J-VS2-VG-POOR-NONE': 5.64,
    'K-I1-EX-EX-FAINT': 5.64,
    'K-I2-EX-EX-NONE': 5.64,
    'M-VS1-VG-EX-MEDIUM': 5.64,
    'M-VS1-EX-VG-MEDIUM': 5.64,
    'M-VS2-VG-EX-FAINT': 5.64,
    'M-VS2-EX-VG-FAINT': 5.64,
    'D-SI1-POOR-POOR-MEDIUM': 5.63,
    'D-SI2-POOR-POOR-FAINT': 5.63,
    'G-SI1-POOR-EX-STRONG': 5.63,
    'G-SI1-GOOD-VG-STRONG': 5.63,
    'G-SI1-VG-GOOD-STRONG': 5.63,
    'G-SI1-EX-POOR-STRONG': 5.63,
    'G-SI2-POOR-EX-MEDIUM': 5.63,
    'G-SI2-GOOD-VG-MEDIUM': 5.63,
    'G-SI2-VG-GOOD-MEDIUM': 5.63,
    'G-SI2-EX-POOR-MEDIUM': 5.63,
    'I-VVS2-POOR-VG-STRONG': 5.63,
    'I-VVS2-VG-POOR-STRONG': 5.63,
    'J-VS1-GOOD-GOOD-FAINT': 5.63,
    'J-VS2-GOOD-GOOD-NONE': 5.63,
    'L-IF-POOR-GOOD-FAINT': 5.63,
    'L-IF-GOOD-POOR-FAINT': 5.63,
    'M-SI1-VG-EX-NONE': 5.63,
    'M-SI1-EX-VG-NONE': 5.63,
    'D-I1-POOR-POOR-NONE': 5.62,
    'G-I1-POOR-EX-FAINT': 5.62,
    'G-I1-GOOD-VG-FAINT': 5.62,
    'G-I1-VG-GOOD-FAINT': 5.62,
    'G-I1-EX-POOR-FAINT': 5.62,
    'G-I2-POOR-EX-NONE': 5.62,
    'G-I2-GOOD-VG-NONE': 5.62,
    'G-I2-VG-GOOD-NONE': 5.62,
    'G-I2-EX-POOR-NONE': 5.62,
    'I-VVS2-GOOD-GOOD-STRONG': 5.62,
    'I-VS1-POOR-VG-MEDIUM': 5.62,
    'I-VS1-VG-POOR-MEDIUM': 5.62,
    'I-VS2-POOR-VG-FAINT': 5.62,
    'I-VS2-VG-POOR-FAINT': 5.62,
    'J-SI2-EX-EX-STRONG': 5.62,
    'L-VVS1-POOR-GOOD-NONE': 5.62,
    'L-VVS1-GOOD-POOR-NONE': 5.62,
    'I-VS1-GOOD-GOOD-MEDIUM': 5.61,
    'I-VS2-GOOD-GOOD-FAINT': 5.61,
    'I-SI1-POOR-VG-NONE': 5.61,
    'I-SI1-VG-POOR-NONE': 5.61,
    'J-I1-EX-EX-MEDIUM': 5.61,
    'J-I2-EX-EX-FAINT': 5.61,
    'K-IF-POOR-GOOD-MEDIUM': 5.61,
    'K-IF-GOOD-POOR-MEDIUM': 5.61,
    'L-VS1-VG-EX-STRONG': 5.61,
    'L-VS1-EX-VG-STRONG': 5.61,
    'L-VS2-VG-EX-MEDIUM': 5.61,
    'L-VS2-EX-VG-MEDIUM': 5.61,
    'F-SI2-POOR-EX-STRONG': 5.6,
    'F-SI2-GOOD-VG-STRONG': 5.6,
    'F-SI2-VG-GOOD-STRONG': 5.6,
    'F-SI2-EX-POOR-STRONG': 5.6,
    'I-SI1-GOOD-GOOD-NONE': 5.6,
    'K-VVS1-POOR-GOOD-FAINT': 5.6,
    'K-VVS1-GOOD-POOR-FAINT': 5.6,
    'K-VVS2-POOR-GOOD-NONE': 5.6,
    'K-VVS2-GOOD-POOR-NONE': 5.6,
    'L-SI1-VG-EX-FAINT': 5.6,
    'L-SI1-EX-VG-FAINT': 5.6,
    'L-SI2-VG-EX-NONE': 5.6,
    'L-SI2-EX-VG-NONE': 5.6,
    'F-I1-POOR-EX-MEDIUM': 5.59,
    'F-I1-GOOD-VG-MEDIUM': 5.59,
    'F-I1-VG-GOOD-MEDIUM': 5.59,
    'F-I1-EX-POOR-MEDIUM': 5.59,
    'F-I2-POOR-EX-FAINT': 5.59,
    'F-I2-GOOD-VG-FAINT': 5.59,
    'F-I2-VG-GOOD-FAINT': 5.59,
    'F-I2-EX-POOR-FAINT': 5.59,
    'H-VS1-POOR-VG-STRONG': 5.59,
    'H-VS1-VG-POOR-STRONG': 5.59,
    'H-VS2-POOR-VG-MEDIUM': 5.59,
    'H-VS2-VG-POOR-MEDIUM': 5.59,
    'I-I1-EX-EX-STRONG': 5.59,
    'I-I2-EX-EX-MEDIUM': 5.59,
    'K-VS2-VG-EX-STRONG': 5.59,
    'K-VS2-EX-VG-STRONG': 5.59,
    'H-VS1-GOOD-GOOD-STRONG': 5.58,
    'H-VS2-GOOD-GOOD-MEDIUM': 5.58,
    'H-SI1-POOR-VG-FAINT': 5.58,
    'H-SI1-VG-POOR-FAINT': 5.58,
    'H-SI2-POOR-VG-NONE': 5.58,
    'H-SI2-VG-POOR-NONE': 5.58,
    'J-IF-POOR-GOOD-STRONG': 5.58,
    'J-IF-GOOD-POOR-STRONG': 5.58,
    'K-SI1-VG-EX-MEDIUM': 5.58,
    'K-SI1-EX-VG-MEDIUM': 5.58,
    'K-SI2-VG-EX-FAINT': 5.58,
    'K-SI2-EX-VG-FAINT': 5.58,
    'M-VVS1-VG-VG-STRONG': 5.58,
    'M-VVS2-VG-VG-MEDIUM': 5.58,
    'E-I1-POOR-EX-STRONG': 5.57,
    'E-I1-GOOD-VG-STRONG': 5.57,
    'E-I1-VG-GOOD-STRONG': 5.57,
    'E-I1-EX-POOR-STRONG': 5.57,
    'E-I2-POOR-EX-MEDIUM': 5.57,
    'E-I2-GOOD-VG-MEDIUM': 5.57,
    'E-I2-VG-GOOD-MEDIUM': 5.57,
    'E-I2-EX-POOR-MEDIUM': 5.57,
    'G-VS2-POOR-VG-STRONG': 5.57,
    'G-VS2-VG-POOR-STRONG': 5.57,
    'H-SI1-GOOD-GOOD-FAINT': 5.57,
    'H-SI2-GOOD-GOOD-NONE': 5.57,
    'J-VVS1-POOR-GOOD-MEDIUM': 5.57,
    'J-VVS1-GOOD-POOR-MEDIUM': 5.57,
    'J-VVS2-POOR-GOOD-FAINT': 5.57,
    'J-VVS2-GOOD-POOR-FAINT': 5.57,
    'K-I1-VG-EX-NONE': 5.57,
    'K-I1-EX-VG-NONE': 5.57,
    'M-VVS1-GOOD-EX-STRONG': 5.57,
    'M-VVS1-EX-GOOD-STRONG': 5.57,
    'M-VVS2-GOOD-EX-MEDIUM': 5.57,
    'M-VVS2-EX-GOOD-MEDIUM': 5.57,
    'M-VS1-VG-VG-FAINT': 5.57,
    'M-VS2-VG-VG-NONE': 5.57,
    'G-VS2-GOOD-GOOD-STRONG': 5.56,
    'G-SI1-POOR-VG-MEDIUM': 5.56,
    'G-SI1-VG-POOR-MEDIUM': 5.56,
    'G-SI2-POOR-VG-FAINT': 5.56,
    'G-SI2-VG-POOR-FAINT': 5.56,
    'H-I2-EX-EX-STRONG': 5.56,
    'J-VS1-POOR-GOOD-NONE': 5.56,
    'J-VS1-GOOD-POOR-NONE': 5.56,
    'L-IF-POOR-POOR-NONE': 5.56,
    'M-VS1-GOOD-EX-FAINT': 5.56,
    'M-VS1-EX-GOOD-FAINT': 5.56,
    'M-VS2-GOOD-EX-NONE': 5.56,
    'M-VS2-EX-GOOD-NONE': 5.56,
    'G-SI1-GOOD-GOOD-MEDIUM': 5.55,
    'G-SI2-GOOD-GOOD-FAINT': 5.55,
    'G-I1-POOR-VG-NONE': 5.55,
    'G-I1-VG-POOR-NONE': 5.55,
    'I-VVS1-POOR-GOOD-STRONG': 5.55,
    'I-VVS1-GOOD-POOR-STRONG': 5.55,
    'I-VVS2-POOR-GOOD-MEDIUM': 5.55,
    'I-VVS2-GOOD-POOR-MEDIUM': 5.55,
    'J-SI1-VG-EX-STRONG': 5.55,
    'J-SI1-EX-VG-STRONG': 5.55,
    'J-SI2-VG-EX-MEDIUM': 5.55,
    'J-SI2-EX-VG-MEDIUM': 5.55,
    'L-VVS2-VG-VG-STRONG': 5.55,
    'D-I2-POOR-EX-STRONG': 5.54,
    'D-I2-GOOD-VG-STRONG': 5.54,
    'D-I2-VG-GOOD-STRONG': 5.54,
    'D-I2-EX-POOR-STRONG': 5.54,
    'G-I1-GOOD-GOOD-NONE': 5.54,
    'I-VS1-POOR-GOOD-FAINT': 5.54,
    'I-VS1-GOOD-POOR-FAINT': 5.54,
    'I-VS2-POOR-GOOD-NONE': 5.54,
    'I-VS2-GOOD-POOR-NONE': 5.54,
    'J-I1-VG-EX-FAINT': 5.54,
    'J-I1-EX-VG-FAINT': 5.54,
    'J-I2-VG-EX-NONE': 5.54,
    'J-I2-EX-VG-NONE': 5.54,
    'K-IF-POOR-POOR-FAINT': 5.54,
    'L-VVS2-GOOD-EX-STRONG': 5.54,
    'L-VVS2-EX-GOOD-STRONG': 5.54,
    'L-VS1-VG-VG-MEDIUM': 5.54,
    'L-VS2-VG-VG-FAINT': 5.54,
    'F-SI1-POOR-VG-STRONG': 5.53,
    'F-SI1-VG-POOR-STRONG': 5.53,
    'F-SI2-POOR-VG-MEDIUM': 5.53,
    'F-SI2-VG-POOR-MEDIUM': 5.53,
    'I-SI2-VG-EX-STRONG': 5.53,
    'I-SI2-EX-VG-STRONG': 5.53,
    'K-VVS1-POOR-POOR-NONE': 5.53,
    'L-VS1-GOOD-EX-MEDIUM': 5.53,
    'L-VS1-EX-GOOD-MEDIUM': 5.53,
    'L-VS2-GOOD-EX-FAINT': 5.53,
    'L-VS2-EX-GOOD-FAINT': 5.53,
    'L-SI1-VG-VG-NONE': 5.53,
    'F-SI1-GOOD-GOOD-STRONG': 5.52,
    'F-SI2-GOOD-GOOD-MEDIUM': 5.52,
    'F-I1-POOR-VG-FAINT': 5.52,
    'F-I1-VG-POOR-FAINT': 5.52,
    'F-I2-POOR-VG-NONE': 5.52,
    'F-I2-VG-POOR-NONE': 5.52,
    'H-VVS2-POOR-GOOD-STRONG': 5.52,
    'H-VVS2-GOOD-POOR-STRONG': 5.52,
    'I-I1-VG-EX-MEDIUM': 5.52,
    'I-I1-EX-VG-MEDIUM': 5.52,
    'I-I2-VG-EX-FAINT': 5.52,
    'I-I2-EX-VG-FAINT': 5.52,
    'K-VS1-VG-VG-STRONG': 5.52,
    'K-VS2-VG-VG-MEDIUM': 5.52,
    'L-SI1-GOOD-EX-NONE': 5.52,
    'L-SI1-EX-GOOD-NONE': 5.52,
    'E-SI2-POOR-VG-STRONG': 5.51,
    'E-SI2-VG-POOR-STRONG': 5.51,
    'F-I1-GOOD-GOOD-FAINT': 5.51,
    'F-I2-GOOD-GOOD-NONE': 5.51,
    'H-VS1-POOR-GOOD-MEDIUM': 5.51,
    'H-VS1-GOOD-POOR-MEDIUM': 5.51,
    'H-VS2-POOR-GOOD-FAINT': 5.51,
    'H-VS2-GOOD-POOR-FAINT': 5.51,
    'J-IF-POOR-POOR-MEDIUM': 5.51,
    'K-VS1-GOOD-EX-STRONG': 5.51,
    'K-VS1-EX-GOOD-STRONG': 5.51,
    'K-VS2-GOOD-EX-MEDIUM': 5.51,
    'K-VS2-EX-GOOD-MEDIUM': 5.51,
    'K-SI1-VG-VG-FAINT': 5.51,
    'K-SI2-VG-VG-NONE': 5.51,
    'M-IF-POOR-EX-STRONG': 5.51,
    'M-IF-GOOD-VG-STRONG': 5.51,
    'M-IF-VG-GOOD-STRONG': 5.51,
    'M-IF-EX-POOR-STRONG': 5.51,
    'E-SI2-GOOD-GOOD-STRONG': 5.5,
    'E-I1-POOR-VG-MEDIUM': 5.5,
    'E-I1-VG-POOR-MEDIUM': 5.5,
    'E-I2-POOR-VG-FAINT': 5.5,
    'E-I2-VG-POOR-FAINT': 5.5,
    'H-SI1-POOR-GOOD-NONE': 5.5,
    'H-SI1-GOOD-POOR-NONE': 5.5,
    'J-VVS1-POOR-POOR-FAINT': 5.5,
    'J-VVS2-POOR-POOR-NONE': 5.5,
    'K-SI1-GOOD-EX-FAINT': 5.5,
    'K-SI1-EX-GOOD-FAINT': 5.5,
    'K-SI2-GOOD-EX-NONE': 5.5,
    'K-SI2-EX-GOOD-NONE': 5.5,
    'M-VVS1-POOR-EX-MEDIUM': 5.5,
    'M-VVS1-GOOD-VG-MEDIUM': 5.5,
    'M-VVS1-VG-GOOD-MEDIUM': 5.5,
    'M-VVS1-EX-POOR-MEDIUM': 5.5,
    'M-VVS2-POOR-EX-FAINT': 5.5,
    'M-VVS2-GOOD-VG-FAINT': 5.5,
    'M-VVS2-VG-GOOD-FAINT': 5.5,
    'M-VVS2-EX-POOR-FAINT': 5.5,
    'E-I1-GOOD-GOOD-MEDIUM': 5.49,
    'E-I2-GOOD-GOOD-FAINT': 5.49,
    'G-VS1-POOR-GOOD-STRONG': 5.49,
    'G-VS1-GOOD-POOR-STRONG': 5.49,
    'G-VS2-POOR-GOOD-MEDIUM': 5.49,
    'G-VS2-GOOD-POOR-MEDIUM': 5.49,
    'H-I1-VG-EX-STRONG': 5.49,
    'H-I1-EX-VG-STRONG': 5.49,
    'H-I2-VG-EX-MEDIUM': 5.49,
    'H-I2-EX-VG-MEDIUM': 5.49,
    'I-IF-POOR-POOR-STRONG': 5.49,
    'J-VS2-VG-VG-STRONG': 5.49,
    'M-VS1-POOR-EX-NONE': 5.49,
    'M-VS1-GOOD-VG-NONE': 5.49,
    'M-VS1-VG-GOOD-NONE': 5.49,
    'M-VS1-EX-POOR-NONE': 5.49,
    'G-SI1-POOR-GOOD-FAINT': 5.48,
    'G-SI1-GOOD-POOR-FAINT': 5.48,
    'G-SI2-POOR-GOOD-NONE': 5.48,
    'G-SI2-GOOD-POOR-NONE': 5.48,
    'I-VVS1-POOR-POOR-MEDIUM': 5.48,
    'I-VVS2-POOR-POOR-FAINT': 5.48,
    'J-VS2-GOOD-EX-STRONG': 5.48,
    'J-VS2-EX-GOOD-STRONG': 5.48,
    'J-SI1-VG-VG-MEDIUM': 5.48,
    'J-SI2-VG-VG-FAINT': 5.48,
    'D-I1-POOR-VG-STRONG': 5.47,
    'D-I1-VG-POOR-STRONG': 5.47,
    'D-I2-POOR-VG-MEDIUM': 5.47,
    'D-I2-VG-POOR-MEDIUM': 5.47,
    'G-I2-VG-EX-STRONG': 5.47,
    'G-I2-EX-VG-STRONG': 5.47,
    'I-VS1-POOR-POOR-NONE': 5.47,
    'J-SI1-GOOD-EX-MEDIUM': 5.47,
    'J-SI1-EX-GOOD-MEDIUM': 5.47,
    'J-SI2-GOOD-EX-FAINT': 5.47,
    'J-SI2-EX-GOOD-FAINT': 5.47,
    'J-I1-VG-VG-NONE': 5.47,
    'L-VVS1-POOR-EX-STRONG': 5.47,
    'L-VVS1-GOOD-VG-STRONG': 5.47,
    'L-VVS1-VG-GOOD-STRONG': 5.47,
    'L-VVS1-EX-POOR-STRONG': 5.47,
    'L-VVS2-POOR-EX-MEDIUM': 5.47,
    'L-VVS2-GOOD-VG-MEDIUM': 5.47,
    'L-VVS2-VG-GOOD-MEDIUM': 5.47,
    'L-VVS2-EX-POOR-MEDIUM': 5.47,
    'D-I1-GOOD-GOOD-STRONG': 5.46,
    'D-I2-GOOD-GOOD-MEDIUM': 5.46,
    'F-VS2-POOR-GOOD-STRONG': 5.46,
    'F-VS2-GOOD-POOR-STRONG': 5.46,
    'I-SI1-VG-VG-STRONG': 5.46,
    'I-SI2-VG-VG-MEDIUM': 5.46,
    'J-I1-GOOD-EX-NONE': 5.46,
    'J-I1-EX-GOOD-NONE': 5.46,
    'L-VS1-POOR-EX-FAINT': 5.46,
    'L-VS1-GOOD-VG-FAINT': 5.46,
    'L-VS1-VG-GOOD-FAINT': 5.46,
    'L-VS1-EX-POOR-FAINT': 5.46,
    'L-VS2-POOR-EX-NONE': 5.46,
    'L-VS2-GOOD-VG-NONE': 5.46,
    'L-VS2-VG-GOOD-NONE': 5.46,
    'L-VS2-EX-POOR-NONE': 5.46,
    'F-SI1-POOR-GOOD-MEDIUM': 5.45,
    'F-SI1-GOOD-POOR-MEDIUM': 5.45,
    'F-SI2-POOR-GOOD-FAINT': 5.45,
    'F-SI2-GOOD-POOR-FAINT': 5.45,
    'H-VVS1-POOR-POOR-STRONG': 5.45,
    'H-VVS2-POOR-POOR-MEDIUM': 5.45,
    'I-SI1-GOOD-EX-STRONG': 5.45,
    'I-SI1-EX-GOOD-STRONG': 5.45,
    'I-SI2-GOOD-EX-MEDIUM': 5.45,
    'I-SI2-EX-GOOD-MEDIUM': 5.45,
    'I-I1-VG-VG-FAINT': 5.45,
    'I-I2-VG-VG-NONE': 5.45,
    'K-VVS2-POOR-EX-STRONG': 5.45,
    'K-VVS2-GOOD-VG-STRONG': 5.45,
    'K-VVS2-VG-GOOD-STRONG': 5.45,
    'K-VVS2-EX-POOR-STRONG': 5.45,
    'F-I1-POOR-GOOD-NONE': 5.44,
    'F-I1-GOOD-POOR-NONE': 5.44,
    'H-VS1-POOR-POOR-FAINT': 5.44,
    'H-VS2-POOR-POOR-NONE': 5.44,
    'I-I1-GOOD-EX-FAINT': 5.44,
    'I-I1-EX-GOOD-FAINT': 5.44,
    'I-I2-GOOD-EX-NONE': 5.44,
    'I-I2-EX-GOOD-NONE': 5.44,
    'K-VS1-POOR-EX-MEDIUM': 5.44,
    'K-VS1-GOOD-VG-MEDIUM': 5.44,
    'K-VS1-VG-GOOD-MEDIUM': 5.44,
    'K-VS1-EX-POOR-MEDIUM': 5.44,
    'K-VS2-POOR-EX-FAINT': 5.44,
    'K-VS2-GOOD-VG-FAINT': 5.44,
    'K-VS2-VG-GOOD-FAINT': 5.44,
    'K-VS2-EX-POOR-FAINT': 5.44,
    'M-IF-POOR-VG-MEDIUM': 5.44,
    'M-IF-VG-POOR-MEDIUM': 5.44,
    'E-SI1-POOR-GOOD-STRONG': 5.43,
    'E-SI1-GOOD-POOR-STRONG': 5.43,
    'E-SI2-POOR-GOOD-MEDIUM': 5.43,
    'E-SI2-GOOD-POOR-MEDIUM': 5.43,
    'G-VVS2-POOR-POOR-STRONG': 5.43,
    'H-SI2-VG-VG-STRONG': 5.43,
    'K-SI1-POOR-EX-NONE': 5.43,
    'K-SI1-GOOD-VG-NONE': 5.43,
    'K-SI1-VG-GOOD-NONE': 5.43,
    'K-SI1-EX-POOR-NONE': 5.43,
    'M-IF-GOOD-GOOD-MEDIUM': 5.43,
    'M-VVS1-POOR-VG-FAINT': 5.43,
    'M-VVS1-VG-POOR-FAINT': 5.43,
    'M-VVS2-POOR-VG-NONE': 5.43,
    'M-VVS2-VG-POOR-NONE': 5.43,
    'E-I1-POOR-GOOD-FAINT': 5.42,
    'E-I1-GOOD-POOR-FAINT': 5.42,
    'E-I2-POOR-GOOD-NONE': 5.42,
    'E-I2-GOOD-POOR-NONE': 5.42,
    'G-VS1-POOR-POOR-MEDIUM': 5.42,
    'G-VS2-POOR-POOR-FAINT': 5.42,
    'H-SI2-GOOD-EX-STRONG': 5.42,
    'H-SI2-EX-GOOD-STRONG': 5.42,
    'H-I1-VG-VG-MEDIUM': 5.42,
    'H-I2-VG-VG-FAINT': 5.42,
    'M-VVS1-GOOD-GOOD-FAINT': 5.42,
    'M-VVS2-GOOD-GOOD-NONE': 5.42,
    'G-SI1-POOR-POOR-NONE': 5.41,
    'H-I1-GOOD-EX-MEDIUM': 5.41,
    'H-I1-EX-GOOD-MEDIUM': 5.41,
    'H-I2-GOOD-EX-FAINT': 5.41,
    'H-I2-EX-GOOD-FAINT': 5.41,
    'J-VS1-POOR-EX-STRONG': 5.41,
    'J-VS1-GOOD-VG-STRONG': 5.41,
    'J-VS1-VG-GOOD-STRONG': 5.41,
    'J-VS1-EX-POOR-STRONG': 5.41,
    'J-VS2-POOR-EX-MEDIUM': 5.41,
    'J-VS2-GOOD-VG-MEDIUM': 5.41,
    'J-VS2-VG-GOOD-MEDIUM': 5.41,
    'J-VS2-EX-POOR-MEDIUM': 5.41,
    'L-IF-POOR-VG-STRONG': 5.41,
    'L-IF-VG-POOR-STRONG': 5.41,
    'M-VS2-EX-EX-STRONG': 5.41,
    'D-SI2-POOR-GOOD-STRONG': 5.4,
    'D-SI2-GOOD-POOR-STRONG': 5.4,
    'G-I1-VG-VG-STRONG': 5.4,
    'G-I2-VG-VG-MEDIUM': 5.4,
    'J-SI1-POOR-EX-FAINT': 5.4,
    'J-SI1-GOOD-VG-FAINT': 5.4,
    'J-SI1-VG-GOOD-FAINT': 5.4,
    'J-SI1-EX-POOR-FAINT': 5.4,
    'J-SI2-POOR-EX-NONE': 5.4,
    'J-SI2-GOOD-VG-NONE': 5.4,
    'J-SI2-VG-GOOD-NONE': 5.4,
    'J-SI2-EX-POOR-NONE': 5.4,
    'L-IF-GOOD-GOOD-STRONG': 5.4,
    'L-VVS1-POOR-VG-MEDIUM': 5.4,
    'L-VVS1-VG-POOR-MEDIUM': 5.4,
    'L-VVS2-POOR-VG-FAINT': 5.4,
    'L-VVS2-VG-POOR-FAINT': 5.4,
    'M-SI1-EX-EX-MEDIUM': 5.4,
    'M-SI2-EX-EX-FAINT': 5.4,
    'D-I1-POOR-GOOD-MEDIUM': 5.39,
    'D-I1-GOOD-POOR-MEDIUM': 5.39,
    'D-I2-POOR-GOOD-FAINT': 5.39,
    'D-I2-GOOD-POOR-FAINT': 5.39,
    'F-VS1-POOR-POOR-STRONG': 5.39,
    'F-VS2-POOR-POOR-MEDIUM': 5.39,
    'G-I1-GOOD-EX-STRONG': 5.39,
    'G-I1-EX-GOOD-STRONG': 5.39,
    'G-I2-GOOD-EX-MEDIUM': 5.39,
    'G-I2-EX-GOOD-MEDIUM': 5.39,
    'I-VS2-POOR-EX-STRONG': 5.39,
    'I-VS2-GOOD-VG-STRONG': 5.39,
    'I-VS2-VG-GOOD-STRONG': 5.39,
    'I-VS2-EX-POOR-STRONG': 5.39,
    'L-VVS1-GOOD-GOOD-MEDIUM': 5.39,
    'L-VVS2-GOOD-GOOD-FAINT': 5.39,
    'L-VS1-POOR-VG-NONE': 5.39,
    'L-VS1-VG-POOR-NONE': 5.39,
    'M-I1-EX-EX-NONE': 5.39,
    'F-SI1-POOR-POOR-FAINT': 5.38,
    'F-SI2-POOR-POOR-NONE': 5.38,
    'I-SI1-POOR-EX-MEDIUM': 5.38,
    'I-SI1-GOOD-VG-MEDIUM': 5.38,
    'I-SI1-VG-GOOD-MEDIUM': 5.38,
    'I-SI1-EX-POOR-MEDIUM': 5.38,
    'I-SI2-POOR-EX-FAINT': 5.38,
    'I-SI2-GOOD-VG-FAINT': 5.38,
    'I-SI2-VG-GOOD-FAINT': 5.38,
    'I-SI2-EX-POOR-FAINT': 5.38,
    'K-VVS1-POOR-VG-STRONG': 5.38,
    'K-VVS1-VG-POOR-STRONG': 5.38,
    'K-VVS2-POOR-VG-MEDIUM': 5.38,
    'K-VVS2-VG-POOR-MEDIUM': 5.38,
    'L-VS1-GOOD-GOOD-NONE': 5.38,
    'E-VS2-POOR-POOR-STRONG': 5.37,
    'F-I2-VG-VG-STRONG': 5.37,
    'I-I1-POOR-EX-NONE': 5.37,
    'I-I1-GOOD-VG-NONE': 5.37,
    'I-I1-VG-GOOD-NONE': 5.37,
    'I-I1-EX-POOR-NONE': 5.37,
    'K-VVS1-GOOD-GOOD-STRONG': 5.37,
    'K-VVS2-GOOD-GOOD-MEDIUM': 5.37,
    'K-VS1-POOR-VG-FAINT': 5.37,
    'K-VS1-VG-POOR-FAINT': 5.37,
    'K-VS2-POOR-VG-NONE': 5.37,
    'K-VS2-VG-POOR-NONE': 5.37,
    'L-SI1-EX-EX-STRONG': 5.37,
    'L-SI2-EX-EX-MEDIUM': 5.37,
    'E-SI1-POOR-POOR-MEDIUM': 5.36,
    'E-SI2-POOR-POOR-FAINT': 5.36,
    'F-I2-GOOD-EX-STRONG': 5.36,
    'F-I2-EX-GOOD-STRONG': 5.36,
    'K-VS1-GOOD-GOOD-FAINT': 5.36,
    'K-VS2-GOOD-GOOD-NONE': 5.36,
    'L-I1-EX-EX-FAINT': 5.36,
    'L-I2-EX-EX-NONE': 5.36,
    'M-IF-POOR-GOOD-FAINT': 5.36,
    'M-IF-GOOD-POOR-FAINT': 5.36,
    'E-I1-POOR-POOR-NONE': 5.35,
    'H-SI1-POOR-EX-STRONG': 5.35,
    'H-SI1-GOOD-VG-STRONG': 5.35,
    'H-SI1-VG-GOOD-STRONG': 5.35,
    'H-SI1-EX-POOR-STRONG': 5.35,
    'H-SI2-POOR-EX-MEDIUM': 5.35,
    'H-SI2-GOOD-VG-MEDIUM': 5.35,
    'H-SI2-VG-GOOD-MEDIUM': 5.35,
    'H-SI2-EX-POOR-MEDIUM': 5.35,
    'J-VVS2-POOR-VG-STRONG': 5.35,
    'J-VVS2-VG-POOR-STRONG': 5.35,
    'K-SI2-EX-EX-STRONG': 5.35,
    'M-VVS1-POOR-GOOD-NONE': 5.35,
    'M-VVS1-GOOD-POOR-NONE': 5.35,
    'H-I1-POOR-EX-FAINT': 5.34,
    'H-I1-GOOD-VG-FAINT': 5.34,
    'H-I1-VG-GOOD-FAINT': 5.34,
    'H-I1-EX-POOR-FAINT': 5.34,
    'H-I2-POOR-EX-NONE': 5.34,
    'H-I2-GOOD-VG-NONE': 5.34,
    'H-I2-VG-GOOD-NONE': 5.34,
    'H-I2-EX-POOR-NONE': 5.34,
    'J-VVS2-GOOD-GOOD-STRONG': 5.34,
    'J-VS1-POOR-VG-MEDIUM': 5.34,
    'J-VS1-VG-POOR-MEDIUM': 5.34,
    'J-VS2-POOR-VG-FAINT': 5.34,
    'J-VS2-VG-POOR-FAINT': 5.34,
    'K-I1-EX-EX-MEDIUM': 5.34,
    'K-I2-EX-EX-FAINT': 5.34,
    'M-VS1-VG-EX-STRONG': 5.34,
    'M-VS1-EX-VG-STRONG': 5.34,
    'M-VS2-VG-EX-MEDIUM': 5.34,
    'M-VS2-EX-VG-MEDIUM': 5.34,
    'D-SI1-POOR-POOR-STRONG': 5.33,
    'D-SI2-POOR-POOR-MEDIUM': 5.33,
    'G-SI2-POOR-EX-STRONG': 5.33,
    'G-SI2-GOOD-VG-STRONG': 5.33,
    'G-SI2-VG-GOOD-STRONG': 5.33,
    'G-SI2-EX-POOR-STRONG': 5.33,
    'J-VS1-GOOD-GOOD-MEDIUM': 5.33,
    'J-VS2-GOOD-GOOD-FAINT': 5.33,
    'J-SI1-POOR-VG-NONE': 5.33,
    'J-SI1-VG-POOR-NONE': 5.33,
    'L-IF-POOR-GOOD-MEDIUM': 5.33,
    'L-IF-GOOD-POOR-MEDIUM': 5.33,
    'M-SI1-VG-EX-FAINT': 5.33,
    'M-SI1-EX-VG-FAINT': 5.33,
    'M-SI2-VG-EX-NONE': 5.33,
    'M-SI2-EX-VG-NONE': 5.33,
    'D-I1-POOR-POOR-FAINT': 5.32,
    'D-I2-POOR-POOR-NONE': 5.32,
    'G-I1-POOR-EX-MEDIUM': 5.32,
    'G-I1-GOOD-VG-MEDIUM': 5.32,
    'G-I1-VG-GOOD-MEDIUM': 5.32,
    'G-I1-EX-POOR-MEDIUM': 5.32,
    'G-I2-POOR-EX-FAINT': 5.32,
    'G-I2-GOOD-VG-FAINT': 5.32,
    'G-I2-VG-GOOD-FAINT': 5.32,
    'G-I2-EX-POOR-FAINT': 5.32,
    'I-VS1-POOR-VG-STRONG': 5.32,
    'I-VS1-VG-POOR-STRONG': 5.32,
    'I-VS2-POOR-VG-MEDIUM': 5.32,
    'I-VS2-VG-POOR-MEDIUM': 5.32,
    'J-SI1-GOOD-GOOD-NONE': 5.32,
    'L-VVS1-POOR-GOOD-FAINT': 5.32,
    'L-VVS1-GOOD-POOR-FAINT': 5.32,
    'L-VVS2-POOR-GOOD-NONE': 5.32,
    'L-VVS2-GOOD-POOR-NONE': 5.32,
    'I-VS1-GOOD-GOOD-STRONG': 5.31,
    'I-VS2-GOOD-GOOD-MEDIUM': 5.31,
    'I-SI1-POOR-VG-FAINT': 5.31,
    'I-SI1-VG-POOR-FAINT': 5.31,
    'I-SI2-POOR-VG-NONE': 5.31,
    'I-SI2-VG-POOR-NONE': 5.31,
    'J-I1-EX-EX-STRONG': 5.31,
    'J-I2-EX-EX-MEDIUM': 5.31,
    'K-IF-POOR-GOOD-STRONG': 5.31,
    'K-IF-GOOD-POOR-STRONG': 5.31,
    'L-VS2-VG-EX-STRONG': 5.31,
    'L-VS2-EX-VG-STRONG': 5.31,
    'I-SI1-GOOD-GOOD-FAINT': 5.3,
    'I-SI2-GOOD-GOOD-NONE': 5.3,
    'K-VVS1-POOR-GOOD-MEDIUM': 5.3,
    'K-VVS1-GOOD-POOR-MEDIUM': 5.3,
    'K-VVS2-POOR-GOOD-FAINT': 5.3,
    'K-VVS2-GOOD-POOR-FAINT': 5.3,
    'L-SI1-VG-EX-MEDIUM': 5.3,
    'L-SI1-EX-VG-MEDIUM': 5.3,
    'L-SI2-VG-EX-FAINT': 5.3,
    'L-SI2-EX-VG-FAINT': 5.3,
    'F-I1-POOR-EX-STRONG': 5.29,
    'F-I1-GOOD-VG-STRONG': 5.29,
    'F-I1-VG-GOOD-STRONG': 5.29,
    'F-I1-EX-POOR-STRONG': 5.29,
    'F-I2-POOR-EX-MEDIUM': 5.29,
    'F-I2-GOOD-VG-MEDIUM': 5.29,
    'F-I2-VG-GOOD-MEDIUM': 5.29,
    'F-I2-EX-POOR-MEDIUM': 5.29,
    'H-VS2-POOR-VG-STRONG': 5.29,
    'H-VS2-VG-POOR-STRONG': 5.29,
    'I-I2-EX-EX-STRONG': 5.29,
    'K-VS1-POOR-GOOD-NONE': 5.29,
    'K-VS1-GOOD-POOR-NONE': 5.29,
    'L-I1-VG-EX-NONE': 5.29,
    'L-I1-EX-VG-NONE': 5.29,
    'M-IF-POOR-POOR-NONE': 5.29,
    'H-VS2-GOOD-GOOD-STRONG': 5.28,
    'H-SI1-POOR-VG-MEDIUM': 5.28,
    'H-SI1-VG-POOR-MEDIUM': 5.28,
    'H-SI2-POOR-VG-FAINT': 5.28,
    'H-SI2-VG-POOR-FAINT': 5.28,
    'K-SI1-VG-EX-STRONG': 5.28,
    'K-SI1-EX-VG-STRONG': 5.28,
    'K-SI2-VG-EX-MEDIUM': 5.28,
    'K-SI2-EX-VG-MEDIUM': 5.28,
    'M-VVS2-VG-VG-STRONG': 5.28,
    'E-I2-POOR-EX-STRONG': 5.27,
    'E-I2-GOOD-VG-STRONG': 5.27,
    'E-I2-VG-GOOD-STRONG': 5.27,
    'E-I2-EX-POOR-STRONG': 5.27,
    'H-SI1-GOOD-GOOD-MEDIUM': 5.27,
    'H-SI2-GOOD-GOOD-FAINT': 5.27,
    'H-I1-POOR-VG-NONE': 5.27,
    'H-I1-VG-POOR-NONE': 5.27,
    'J-VVS1-POOR-GOOD-STRONG': 5.27,
    'J-VVS1-GOOD-POOR-STRONG': 5.27,
    'J-VVS2-POOR-GOOD-MEDIUM': 5.27,
    'J-VVS2-GOOD-POOR-MEDIUM': 5.27,
    'K-I1-VG-EX-FAINT': 5.27,
    'K-I1-EX-VG-FAINT': 5.27,
    'K-I2-VG-EX-NONE': 5.27,
    'K-I2-EX-VG-NONE': 5.27,
    'M-VVS2-GOOD-EX-STRONG': 5.27,
    'M-VVS2-EX-GOOD-STRONG': 5.27,
    'M-VS1-VG-VG-MEDIUM': 5.27,
    'M-VS2-VG-VG-FAINT': 5.27,
    'G-SI1-POOR-VG-STRONG': 5.26,
    'G-SI1-VG-POOR-STRONG': 5.26,
    'G-SI2-POOR-VG-MEDIUM': 5.26,
    'G-SI2-VG-POOR-MEDIUM': 5.26,
    'H-I1-GOOD-GOOD-NONE': 5.26,
    'J-VS1-POOR-GOOD-FAINT': 5.26,
    'J-VS1-GOOD-POOR-FAINT': 5.26,
    'J-VS2-POOR-GOOD-NONE': 5.26,
    'J-VS2-GOOD-POOR-NONE': 5.26,
    'L-IF-POOR-POOR-FAINT': 5.26,
    'M-VS1-GOOD-EX-MEDIUM': 5.26,
    'M-VS1-EX-GOOD-MEDIUM': 5.26,
    'M-VS2-GOOD-EX-FAINT': 5.26,
    'M-VS2-EX-GOOD-FAINT': 5.26,
    'M-SI1-VG-VG-NONE': 5.26,
    'G-SI1-GOOD-GOOD-STRONG': 5.25,
    'G-SI2-GOOD-GOOD-MEDIUM': 5.25,
    'G-I1-POOR-VG-FAINT': 5.25,
    'G-I1-VG-POOR-FAINT': 5.25,
    'G-I2-POOR-VG-NONE': 5.25,
    'G-I2-VG-POOR-NONE': 5.25,
    'I-VVS2-POOR-GOOD-STRONG': 5.25,
    'I-VVS2-GOOD-POOR-STRONG': 5.25,
    'J-SI2-VG-EX-STRONG': 5.25,
    'J-SI2-EX-VG-STRONG': 5.25,
    'L-VVS1-POOR-POOR-NONE': 5.25,
    'M-SI1-GOOD-EX-NONE': 5.25,
    'M-SI1-EX-GOOD-NONE': 5.25,
    'G-I1-GOOD-GOOD-FAINT': 5.24,
    'G-I2-GOOD-GOOD-NONE': 5.24,
    'I-VS1-POOR-GOOD-MEDIUM': 5.24,
    'I-VS1-GOOD-POOR-MEDIUM': 5.24,
    'I-VS2-POOR-GOOD-FAINT': 5.24,
    'I-VS2-GOOD-POOR-FAINT': 5.24,
    'J-I1-VG-EX-MEDIUM': 5.24,
    'J-I1-EX-VG-MEDIUM': 5.24,
    'J-I2-VG-EX-FAINT': 5.24,
    'J-I2-EX-VG-FAINT': 5.24,
    'K-IF-POOR-POOR-MEDIUM': 5.24,
    'L-VS1-VG-VG-STRONG': 5.24,
    'L-VS2-VG-VG-MEDIUM': 5.24,
    'F-SI2-POOR-VG-STRONG': 5.23,
    'F-SI2-VG-POOR-STRONG': 5.23,
    'I-SI1-POOR-GOOD-NONE': 5.23,
    'I-SI1-GOOD-POOR-NONE': 5.23,
    'K-VVS1-POOR-POOR-FAINT': 5.23,
    'K-VVS2-POOR-POOR-NONE': 5.23,
    'L-VS1-GOOD-EX-STRONG': 5.23,
    'L-VS1-EX-GOOD-STRONG': 5.23,
    'L-VS2-GOOD-EX-MEDIUM': 5.23,
    'L-VS2-EX-GOOD-MEDIUM': 5.23,
    'L-SI1-VG-VG-FAINT': 5.23,
    'L-SI2-VG-VG-NONE': 5.23,
    'F-SI2-GOOD-GOOD-STRONG': 5.22,
    'F-I1-POOR-VG-MEDIUM': 5.22,
    'F-I1-VG-POOR-MEDIUM': 5.22,
    'F-I2-POOR-VG-FAINT': 5.22,
    'F-I2-VG-POOR-FAINT': 5.22,
    'I-I1-VG-EX-STRONG': 5.22,
    'I-I1-EX-VG-STRONG': 5.22,
    'I-I2-VG-EX-MEDIUM': 5.22,
    'I-I2-EX-VG-MEDIUM': 5.22,
    'K-VS2-VG-VG-STRONG': 5.22,
    'L-SI1-GOOD-EX-FAINT': 5.22,
    'L-SI1-EX-GOOD-FAINT': 5.22,
    'L-SI2-GOOD-EX-NONE': 5.22,
    'L-SI2-EX-GOOD-NONE': 5.22,
    'F-I1-GOOD-GOOD-MEDIUM': 5.21,
    'F-I2-GOOD-GOOD-FAINT': 5.21,
    'H-VS1-POOR-GOOD-STRONG': 5.21,
    'H-VS1-GOOD-POOR-STRONG': 5.21,
    'H-VS2-POOR-GOOD-MEDIUM': 5.21,
    'H-VS2-GOOD-POOR-MEDIUM': 5.21,
    'J-IF-POOR-POOR-STRONG': 5.21,
    'K-VS2-GOOD-EX-STRONG': 5.21,
    'K-VS2-EX-GOOD-STRONG': 5.21,
    'K-SI1-VG-VG-MEDIUM': 5.21,
    'K-SI2-VG-VG-FAINT': 5.21,
    'E-I1-POOR-VG-STRONG': 5.2,
    'E-I1-VG-POOR-STRONG': 5.2,
    'E-I2-POOR-VG-MEDIUM': 5.2,
    'E-I2-VG-POOR-MEDIUM': 5.2,
    'H-SI1-POOR-GOOD-FAINT': 5.2,
    'H-SI1-GOOD-POOR-FAINT': 5.2,
    'H-SI2-POOR-GOOD-NONE': 5.2,
    'H-SI2-GOOD-POOR-NONE': 5.2,
    'J-VVS1-POOR-POOR-MEDIUM': 5.2,
    'J-VVS2-POOR-POOR-FAINT': 5.2,
    'K-SI1-GOOD-EX-MEDIUM': 5.2,
    'K-SI1-EX-GOOD-MEDIUM': 5.2,
    'K-SI2-GOOD-EX-FAINT': 5.2,
    'K-SI2-EX-GOOD-FAINT': 5.2,
    'K-I1-VG-VG-NONE': 5.2,
    'M-VVS1-POOR-EX-STRONG': 5.2,
    'M-VVS1-GOOD-VG-STRONG': 5.2,
    'M-VVS1-VG-GOOD-STRONG': 5.2,
    'M-VVS1-EX-POOR-STRONG': 5.2,
    'M-VVS2-POOR-EX-MEDIUM': 5.2,
    'M-VVS2-GOOD-VG-MEDIUM': 5.2,
    'M-VVS2-VG-GOOD-MEDIUM': 5.2,
    'M-VVS2-EX-POOR-MEDIUM': 5.2,
    'E-I1-GOOD-GOOD-STRONG': 5.19,
    'E-I2-GOOD-GOOD-MEDIUM': 5.19,
    'G-VS2-POOR-GOOD-STRONG': 5.19,
    'G-VS2-GOOD-POOR-STRONG': 5.19,
    'H-I2-VG-EX-STRONG': 5.19,
    'H-I2-EX-VG-STRONG': 5.19,
    'J-VS1-POOR-POOR-NONE': 5.19,
    'K-I1-GOOD-EX-NONE': 5.19,
    'K-I1-EX-GOOD-NONE': 5.19,
    'M-VS1-POOR-EX-FAINT': 5.19,
    'M-VS1-GOOD-VG-FAINT': 5.19,
    'M-VS1-VG-GOOD-FAINT': 5.19,
    'M-VS1-EX-POOR-FAINT': 5.19,
    'M-VS2-POOR-EX-NONE': 5.19,
    'M-VS2-GOOD-VG-NONE': 5.19,
    'M-VS2-VG-GOOD-NONE': 5.19,
    'M-VS2-EX-POOR-NONE': 5.19,
    'G-SI1-POOR-GOOD-MEDIUM': 5.18,
    'G-SI1-GOOD-POOR-MEDIUM': 5.18,
    'G-SI2-POOR-GOOD-FAINT': 5.18,
    'G-SI2-GOOD-POOR-FAINT': 5.18,
    'I-VVS1-POOR-POOR-STRONG': 5.18,
    'I-VVS2-POOR-POOR-MEDIUM': 5.18,
    'J-SI1-VG-VG-STRONG': 5.18,
    'J-SI2-VG-VG-MEDIUM': 5.18,
    'D-I2-POOR-VG-STRONG': 5.17,
    'D-I2-VG-POOR-STRONG': 5.17,
    'G-I1-POOR-GOOD-NONE': 5.17,
    'G-I1-GOOD-POOR-NONE': 5.17,
    'I-VS1-POOR-POOR-FAINT': 5.17,
    'I-VS2-POOR-POOR-NONE': 5.17,
    'J-SI1-GOOD-EX-STRONG': 5.17,
    'J-SI1-EX-GOOD-STRONG': 5.17,
    'J-SI2-GOOD-EX-MEDIUM': 5.17,
    'J-SI2-EX-GOOD-MEDIUM': 5.17,
    'J-I1-VG-VG-FAINT': 5.17,
    'J-I2-VG-VG-NONE': 5.17,
    'L-VVS2-POOR-EX-STRONG': 5.17,
    'L-VVS2-GOOD-VG-STRONG': 5.17,
    'L-VVS2-VG-GOOD-STRONG': 5.17,
    'L-VVS2-EX-POOR-STRONG': 5.17,
    'D-I2-GOOD-GOOD-STRONG': 5.16,
    'I-SI2-VG-VG-STRONG': 5.16,
    'J-I1-GOOD-EX-FAINT': 5.16,
    'J-I1-EX-GOOD-FAINT': 5.16,
    'J-I2-GOOD-EX-NONE': 5.16,
    'J-I2-EX-GOOD-NONE': 5.16,
    'L-VS1-POOR-EX-MEDIUM': 5.16,
    'L-VS1-GOOD-VG-MEDIUM': 5.16,
    'L-VS1-VG-GOOD-MEDIUM': 5.16,
    'L-VS1-EX-POOR-MEDIUM': 5.16,
    'L-VS2-POOR-EX-FAINT': 5.16,
    'L-VS2-GOOD-VG-FAINT': 5.16,
    'L-VS2-VG-GOOD-FAINT': 5.16,
    'L-VS2-EX-POOR-FAINT': 5.16,
    'F-SI1-POOR-GOOD-STRONG': 5.15,
    'F-SI1-GOOD-POOR-STRONG': 5.15,
    'F-SI2-POOR-GOOD-MEDIUM': 5.15,
    'F-SI2-GOOD-POOR-MEDIUM': 5.15,
    'H-VVS2-POOR-POOR-STRONG': 5.15,
    'I-SI2-GOOD-EX-STRONG': 5.15,
    'I-SI2-EX-GOOD-STRONG': 5.15,
    'I-I1-VG-VG-MEDIUM': 5.15,
    'I-I2-VG-VG-FAINT': 5.15,
    'L-SI1-POOR-EX-NONE': 5.15,
    'L-SI1-GOOD-VG-NONE': 5.15,
    'L-SI1-VG-GOOD-NONE': 5.15,
    'L-SI1-EX-POOR-NONE': 5.15,
    'F-I1-POOR-GOOD-FAINT': 5.14,
    'F-I1-GOOD-POOR-FAINT': 5.14,
    'F-I2-POOR-GOOD-NONE': 5.14,
    'F-I2-GOOD-POOR-NONE': 5.14,
    'H-VS1-POOR-POOR-MEDIUM': 5.14,
    'H-VS2-POOR-POOR-FAINT': 5.14,
    'I-I1-GOOD-EX-MEDIUM': 5.14,
    'I-I1-EX-GOOD-MEDIUM': 5.14,
    'I-I2-GOOD-EX-FAINT': 5.14,
    'I-I2-EX-GOOD-FAINT': 5.14,
    'K-VS1-POOR-EX-STRONG': 5.14,
    'K-VS1-GOOD-VG-STRONG': 5.14,
    'K-VS1-VG-GOOD-STRONG': 5.14,
    'K-VS1-EX-POOR-STRONG': 5.14,
    'K-VS2-POOR-EX-MEDIUM': 5.14,
    'K-VS2-GOOD-VG-MEDIUM': 5.14,
    'K-VS2-VG-GOOD-MEDIUM': 5.14,
    'K-VS2-EX-POOR-MEDIUM': 5.14,
    'M-IF-POOR-VG-STRONG': 5.14,
    'M-IF-VG-POOR-STRONG': 5.14,
    'E-SI2-POOR-GOOD-STRONG': 5.13,
    'E-SI2-GOOD-POOR-STRONG': 5.13,
    'H-SI1-POOR-POOR-NONE': 5.13,
    'K-SI1-POOR-EX-FAINT': 5.13,
    'K-SI1-GOOD-VG-FAINT': 5.13,
    'K-SI1-VG-GOOD-FAINT': 5.13,
    'K-SI1-EX-POOR-FAINT': 5.13,
    'K-SI2-POOR-EX-NONE': 5.13,
    'K-SI2-GOOD-VG-NONE': 5.13,
    'K-SI2-VG-GOOD-NONE': 5.13,
    'K-SI2-EX-POOR-NONE': 5.13,
    'M-IF-GOOD-GOOD-STRONG': 5.13,
    'M-VVS1-POOR-VG-MEDIUM': 5.13,
    'M-VVS1-VG-POOR-MEDIUM': 5.13,
    'M-VVS2-POOR-VG-FAINT': 5.13,
    'M-VVS2-VG-POOR-FAINT': 5.13,
    'E-I1-POOR-GOOD-MEDIUM': 5.12,
    'E-I1-GOOD-POOR-MEDIUM': 5.12,
    'E-I2-POOR-GOOD-FAINT': 5.12,
    'E-I2-GOOD-POOR-FAINT': 5.12,
    'G-VS1-POOR-POOR-STRONG': 5.12,
    'G-VS2-POOR-POOR-MEDIUM': 5.12,
    'H-I1-VG-VG-STRONG': 5.12,
    'H-I2-VG-VG-MEDIUM': 5.12,
    'M-VVS1-GOOD-GOOD-MEDIUM': 5.12,
    'M-VVS2-GOOD-GOOD-FAINT': 5.12,
    'M-VS1-POOR-VG-NONE': 5.12,
    'M-VS1-VG-POOR-NONE': 5.12,
    'G-SI1-POOR-POOR-FAINT': 5.11,
    'G-SI2-POOR-POOR-NONE': 5.11,
    'H-I1-GOOD-EX-STRONG': 5.11,
    'H-I1-EX-GOOD-STRONG': 5.11,
    'H-I2-GOOD-EX-MEDIUM': 5.11,
    'H-I2-EX-GOOD-MEDIUM': 5.11,
    'J-VS2-POOR-EX-STRONG': 5.11,
    'J-VS2-GOOD-VG-STRONG': 5.11,
    'J-VS2-VG-GOOD-STRONG': 5.11,
    'J-VS2-EX-POOR-STRONG': 5.11,
    'M-VS1-GOOD-GOOD-NONE': 5.11,
    'G-I2-VG-VG-STRONG': 5.1,
    'J-SI1-POOR-EX-MEDIUM': 5.1,
    'J-SI1-GOOD-VG-MEDIUM': 5.1,
    'J-SI1-VG-GOOD-MEDIUM': 5.1,
    'J-SI1-EX-POOR-MEDIUM': 5.1,
    'J-SI2-POOR-EX-FAINT': 5.1,
    'J-SI2-GOOD-VG-FAINT': 5.1,
    'J-SI2-VG-GOOD-FAINT': 5.1,
    'J-SI2-EX-POOR-FAINT': 5.1,
    'L-VVS1-POOR-VG-STRONG': 5.1,
    'L-VVS1-VG-POOR-STRONG': 5.1,
    'L-VVS2-POOR-VG-MEDIUM': 5.1,
    'L-VVS2-VG-POOR-MEDIUM': 5.1,
    'M-SI1-EX-EX-STRONG': 5.1,
    'M-SI2-EX-EX-MEDIUM': 5.1,
    'D-I1-POOR-GOOD-STRONG': 5.09,
    'D-I1-GOOD-POOR-STRONG': 5.09,
    'D-I2-POOR-GOOD-MEDIUM': 5.09,
    'D-I2-GOOD-POOR-MEDIUM': 5.09,
    'F-VS2-POOR-POOR-STRONG': 5.09,
    'G-I2-GOOD-EX-STRONG': 5.09,
    'G-I2-EX-GOOD-STRONG': 5.09,
    'J-I1-POOR-EX-NONE': 5.09,
    'J-I1-GOOD-VG-NONE': 5.09,
    'J-I1-VG-GOOD-NONE': 5.09,
    'J-I1-EX-POOR-NONE': 5.09,
    'L-VVS1-GOOD-GOOD-STRONG': 5.09,
    'L-VVS2-GOOD-GOOD-MEDIUM': 5.09,
    'L-VS1-POOR-VG-FAINT': 5.09,
    'L-VS1-VG-POOR-FAINT': 5.09,
    'L-VS2-POOR-VG-NONE': 5.09,
    'L-VS2-VG-POOR-NONE': 5.09,
    'M-I1-EX-EX-FAINT': 5.09,
    'M-I2-EX-EX-NONE': 5.09,
    'F-SI1-POOR-POOR-MEDIUM': 5.08,
    'F-SI2-POOR-POOR-FAINT': 5.08,
    'I-SI1-POOR-EX-STRONG': 5.08,
    'I-SI1-GOOD-VG-STRONG': 5.08,
    'I-SI1-VG-GOOD-STRONG': 5.08,
    'I-SI1-EX-POOR-STRONG': 5.08,
    'I-SI2-POOR-EX-MEDIUM': 5.08,
    'I-SI2-GOOD-VG-MEDIUM': 5.08,
    'I-SI2-VG-GOOD-MEDIUM': 5.08,
    'I-SI2-EX-POOR-MEDIUM': 5.08,
    'K-VVS2-POOR-VG-STRONG': 5.08,
    'K-VVS2-VG-POOR-STRONG': 5.08,
    'L-VS1-GOOD-GOOD-FAINT': 5.08,
    'L-VS2-GOOD-GOOD-NONE': 5.08,
    'F-I1-POOR-POOR-NONE': 5.07,
    'I-I1-POOR-EX-FAINT': 5.07,
    'I-I1-GOOD-VG-FAINT': 5.07,
    'I-I1-VG-GOOD-FAINT': 5.07,
    'I-I1-EX-POOR-FAINT': 5.07,
    'I-I2-POOR-EX-NONE': 5.07,
    'I-I2-GOOD-VG-NONE': 5.07,
    'I-I2-VG-GOOD-NONE': 5.07,
    'I-I2-EX-POOR-NONE': 5.07,
    'K-VVS2-GOOD-GOOD-STRONG': 5.07,
    'K-VS1-POOR-VG-MEDIUM': 5.07,
    'K-VS1-VG-POOR-MEDIUM': 5.07,
    'K-VS2-POOR-VG-FAINT': 5.07,
    'K-VS2-VG-POOR-FAINT': 5.07,
    'L-SI2-EX-EX-STRONG': 5.07,
    'E-SI1-POOR-POOR-STRONG': 5.06,
    'E-SI2-POOR-POOR-MEDIUM': 5.06,
    'K-VS1-GOOD-GOOD-MEDIUM': 5.06,
    'K-VS2-GOOD-GOOD-FAINT': 5.06,
    'K-SI1-POOR-VG-NONE': 5.06,
    'K-SI1-VG-POOR-NONE': 5.06,
    'L-I1-EX-EX-MEDIUM': 5.06,
    'L-I2-EX-EX-FAINT': 5.06,
    'M-IF-POOR-GOOD-MEDIUM': 5.06,
    'M-IF-GOOD-POOR-MEDIUM': 5.06,
    'E-I1-POOR-POOR-FAINT': 5.05,
    'E-I2-POOR-POOR-NONE': 5.05,
    'H-SI2-POOR-EX-STRONG': 5.05,
    'H-SI2-GOOD-VG-STRONG': 5.05,
    'H-SI2-VG-GOOD-STRONG': 5.05,
    'H-SI2-EX-POOR-STRONG': 5.05,
    'K-SI1-GOOD-GOOD-NONE': 5.05,
    'M-VVS1-POOR-GOOD-FAINT': 5.05,
    'M-VVS1-GOOD-POOR-FAINT': 5.05,
    'M-VVS2-POOR-GOOD-NONE': 5.05,
    'M-VVS2-GOOD-POOR-NONE': 5.05,
    'H-I1-POOR-EX-MEDIUM': 5.04,
    'H-I1-GOOD-VG-MEDIUM': 5.04,
    'H-I1-VG-GOOD-MEDIUM': 5.04,
    'H-I1-EX-POOR-MEDIUM': 5.04,
    'H-I2-POOR-EX-FAINT': 5.04,
    'H-I2-GOOD-VG-FAINT': 5.04,
    'H-I2-VG-GOOD-FAINT': 5.04,
    'H-I2-EX-POOR-FAINT': 5.04,
    'J-VS1-POOR-VG-STRONG': 5.04,
    'J-VS1-VG-POOR-STRONG': 5.04,
    'J-VS2-POOR-VG-MEDIUM': 5.04,
    'J-VS2-VG-POOR-MEDIUM': 5.04,
    'K-I1-EX-EX-STRONG': 5.04,
    'K-I2-EX-EX-MEDIUM': 5.04,
    'M-VS2-VG-EX-STRONG': 5.04,
    'M-VS2-EX-VG-STRONG': 5.04,
    'D-SI2-POOR-POOR-STRONG': 5.03,
    'J-VS1-GOOD-GOOD-STRONG': 5.03,
    'J-VS2-GOOD-GOOD-MEDIUM': 5.03,
    'J-SI1-POOR-VG-FAINT': 5.03,
    'J-SI1-VG-POOR-FAINT': 5.03,
    'J-SI2-POOR-VG-NONE': 5.03,
    'J-SI2-VG-POOR-NONE': 5.03,
    'L-IF-POOR-GOOD-STRONG': 5.03,
    'L-IF-GOOD-POOR-STRONG': 5.03,
    'M-SI1-VG-EX-MEDIUM': 5.03,
    'M-SI1-EX-VG-MEDIUM': 5.03,
    'M-SI2-VG-EX-FAINT': 5.03,
    'M-SI2-EX-VG-FAINT': 5.03,
    'D-I1-POOR-POOR-MEDIUM': 5.02,
    'D-I2-POOR-POOR-FAINT': 5.02,
    'G-I1-POOR-EX-STRONG': 5.02,
    'G-I1-GOOD-VG-STRONG': 5.02,
    'G-I1-VG-GOOD-STRONG': 5.02,
    'G-I1-EX-POOR-STRONG': 5.02,
    'G-I2-POOR-EX-MEDIUM': 5.02,
    'G-I2-GOOD-VG-MEDIUM': 5.02,
    'G-I2-VG-GOOD-MEDIUM': 5.02,
    'G-I2-EX-POOR-MEDIUM': 5.02,
    'I-VS2-POOR-VG-STRONG': 5.02,
    'I-VS2-VG-POOR-STRONG': 5.02,
    'J-SI1-GOOD-GOOD-FAINT': 5.02,
    'J-SI2-GOOD-GOOD-NONE': 5.02,
    'L-VVS1-POOR-GOOD-MEDIUM': 5.02,
    'L-VVS1-GOOD-POOR-MEDIUM': 5.02,
    'L-VVS2-POOR-GOOD-FAINT': 5.02,
    'L-VVS2-GOOD-POOR-FAINT': 5.02,
    'M-I1-VG-EX-NONE': 5.02,
    'M-I1-EX-VG-NONE': 5.02,
    'I-VS2-GOOD-GOOD-STRONG': 5.01,
    'I-SI1-POOR-VG-MEDIUM': 5.01,
    'I-SI1-VG-POOR-MEDIUM': 5.01,
    'I-SI2-POOR-VG-FAINT': 5.01,
    'I-SI2-VG-POOR-FAINT': 5.01,
    'J-I2-EX-EX-STRONG': 5.01,
    'L-VS1-POOR-GOOD-NONE': 5.01,
    'L-VS1-GOOD-POOR-NONE': 5.01,
    'I-SI1-GOOD-GOOD-MEDIUM': 5.0,
    'I-SI2-GOOD-GOOD-FAINT': 5.0,
    'I-I1-POOR-VG-NONE': 5.0,
    'I-I1-VG-POOR-NONE': 5.0,
    'K-VVS1-POOR-GOOD-STRONG': 5.0,
    'K-VVS1-GOOD-POOR-STRONG': 5.0,
    'K-VVS2-POOR-GOOD-MEDIUM': 5.0,
    'K-VVS2-GOOD-POOR-MEDIUM': 5.0,
    'L-SI1-VG-EX-STRONG': 5.0,
    'L-SI1-EX-VG-STRONG': 5.0,
    'L-SI2-VG-EX-MEDIUM': 5.0,
    'L-SI2-EX-VG-MEDIUM': 5.0,
    'F-I2-POOR-EX-STRONG': 4.99,
    'F-I2-GOOD-VG-STRONG': 4.99,
    'F-I2-VG-GOOD-STRONG': 4.99,
    'F-I2-EX-POOR-STRONG': 4.99,
    'I-I1-GOOD-GOOD-NONE': 4.99,
    'K-VS1-POOR-GOOD-FAINT': 4.99,
    'K-VS1-GOOD-POOR-FAINT': 4.99,
    'K-VS2-POOR-GOOD-NONE': 4.99,
    'K-VS2-GOOD-POOR-NONE': 4.99,
    'L-I1-VG-EX-FAINT': 4.99,
    'L-I1-EX-VG-FAINT': 4.99,
    'L-I2-VG-EX-NONE': 4.99,
    'L-I2-EX-VG-NONE': 4.99,
    'M-IF-POOR-POOR-FAINT': 4.99,
    'H-SI1-POOR-VG-STRONG': 4.98,
    'H-SI1-VG-POOR-STRONG': 4.98,
    'H-SI2-POOR-VG-MEDIUM': 4.98,
    'H-SI2-VG-POOR-MEDIUM': 4.98,
    'K-SI2-VG-EX-STRONG': 4.98,
    'K-SI2-EX-VG-STRONG': 4.98,
    'M-VVS1-POOR-POOR-NONE': 4.98,
    'H-SI1-GOOD-GOOD-STRONG': 4.97,
    'H-SI2-GOOD-GOOD-MEDIUM': 4.97,
    'H-I1-POOR-VG-FAINT': 4.97,
    'H-I1-VG-POOR-FAINT': 4.97,
    'H-I2-POOR-VG-NONE': 4.97,
    'H-I2-VG-POOR-NONE': 4.97,
    'J-VVS2-POOR-GOOD-STRONG': 4.97,
    'J-VVS2-GOOD-POOR-STRONG': 4.97,
    'K-I1-VG-EX-MEDIUM': 4.97,
    'K-I1-EX-VG-MEDIUM': 4.97,
    'K-I2-VG-EX-FAINT': 4.97,
    'K-I2-EX-VG-FAINT': 4.97,
    'M-VS1-VG-VG-STRONG': 4.97,
    'M-VS2-VG-VG-MEDIUM': 4.97,
    'G-SI2-POOR-VG-STRONG': 4.96,
    'G-SI2-VG-POOR-STRONG': 4.96,
    'H-I1-GOOD-GOOD-FAINT': 4.96,
    'H-I2-GOOD-GOOD-NONE': 4.96,
    'J-VS1-POOR-GOOD-MEDIUM': 4.96,
    'J-VS1-GOOD-POOR-MEDIUM': 4.96,
    'J-VS2-POOR-GOOD-FAINT': 4.96,
    'J-VS2-GOOD-POOR-FAINT': 4.96,
    'L-IF-POOR-POOR-MEDIUM': 4.96,
    'M-VS1-GOOD-EX-STRONG': 4.96,
    'M-VS1-EX-GOOD-STRONG': 4.96,
    'M-VS2-GOOD-EX-MEDIUM': 4.96,
    'M-VS2-EX-GOOD-MEDIUM': 4.96,
    'M-SI1-VG-VG-FAINT': 4.96,
    'M-SI2-VG-VG-NONE': 4.96,
    'G-SI2-GOOD-GOOD-STRONG': 4.95,
    'G-I1-POOR-VG-MEDIUM': 4.95,
    'G-I1-VG-POOR-MEDIUM': 4.95,
    'G-I2-POOR-VG-FAINT': 4.95,
    'G-I2-VG-POOR-FAINT': 4.95,
    'J-SI1-POOR-GOOD-NONE': 4.95,
    'J-SI1-GOOD-POOR-NONE': 4.95,
    'L-VVS1-POOR-POOR-FAINT': 4.95,
    'L-VVS2-POOR-POOR-NONE': 4.95,
    'M-SI1-GOOD-EX-FAINT': 4.95,
    'M-SI1-EX-GOOD-FAINT': 4.95,
    'M-SI2-GOOD-EX-NONE': 4.95,
    'M-SI2-EX-GOOD-NONE': 4.95,
    'G-I1-GOOD-GOOD-MEDIUM': 4.94,
    'G-I2-GOOD-GOOD-FAINT': 4.94,
    'I-VS1-POOR-GOOD-STRONG': 4.94,
    'I-VS1-GOOD-POOR-STRONG': 4.94,
    'I-VS2-POOR-GOOD-MEDIUM': 4.94,
    'I-VS2-GOOD-POOR-MEDIUM': 4.94,
    'J-I1-VG-EX-STRONG': 4.94,
    'J-I1-EX-VG-STRONG': 4.94,
    'J-I2-VG-EX-MEDIUM': 4.94,
    'J-I2-EX-VG-MEDIUM': 4.94,
    'K-IF-POOR-POOR-STRONG': 4.94,
    'L-VS2-VG-VG-STRONG': 4.94,
    'I-SI1-POOR-GOOD-FAINT': 4.93,
    'I-SI1-GOOD-POOR-FAINT': 4.93,
    'I-SI2-POOR-GOOD-NONE': 4.93,
    'I-SI2-GOOD-POOR-NONE': 4.93,
    'K-VVS1-POOR-POOR-MEDIUM': 4.93,
    'K-VVS2-POOR-POOR-FAINT': 4.93,
    'L-VS2-GOOD-EX-STRONG': 4.93,
    'L-VS2-EX-GOOD-STRONG': 4.93,
    'L-SI1-VG-VG-MEDIUM': 4.93,
    'L-SI2-VG-VG-FAINT': 4.93,
    'F-I1-POOR-VG-STRONG': 4.92,
    'F-I1-VG-POOR-STRONG': 4.92,
    'F-I2-POOR-VG-MEDIUM': 4.92,
    'F-I2-VG-POOR-MEDIUM': 4.92,
    'I-I2-VG-EX-STRONG': 4.92,
    'I-I2-EX-VG-STRONG': 4.92,
    'K-VS1-POOR-POOR-NONE': 4.92,
    'L-SI1-GOOD-EX-MEDIUM': 4.92,
    'L-SI1-EX-GOOD-MEDIUM': 4.92,
    'L-SI2-GOOD-EX-FAINT': 4.92,
    'L-SI2-EX-GOOD-FAINT': 4.92,
    'L-I1-VG-VG-NONE': 4.92,
    'F-I1-GOOD-GOOD-STRONG': 4.91,
    'F-I2-GOOD-GOOD-MEDIUM': 4.91,
    'H-VS2-POOR-GOOD-STRONG': 4.91,
    'H-VS2-GOOD-POOR-STRONG': 4.91,
    'K-SI1-VG-VG-STRONG': 4.91,
    'K-SI2-VG-VG-MEDIUM': 4.91,
    'L-I1-GOOD-EX-NONE': 4.91,
    'L-I1-EX-GOOD-NONE': 4.91,
    'E-I2-POOR-VG-STRONG': 4.9,
    'E-I2-VG-POOR-STRONG': 4.9,
    'H-SI1-POOR-GOOD-MEDIUM': 4.9,
    'H-SI1-GOOD-POOR-MEDIUM': 4.9,
    'H-SI2-POOR-GOOD-FAINT': 4.9,
    'H-SI2-GOOD-POOR-FAINT': 4.9,
    'J-VVS1-POOR-POOR-STRONG': 4.9,
    'J-VVS2-POOR-POOR-MEDIUM': 4.9,
    'K-SI1-GOOD-EX-STRONG': 4.9,
    'K-SI1-EX-GOOD-STRONG': 4.9,
    'K-SI2-GOOD-EX-MEDIUM': 4.9,
    'K-SI2-EX-GOOD-MEDIUM': 4.9,
    'K-I1-VG-VG-FAINT': 4.9,
    'K-I2-VG-VG-NONE': 4.9,
    'M-VVS2-POOR-EX-STRONG': 4.9,
    'M-VVS2-GOOD-VG-STRONG': 4.9,
    'M-VVS2-VG-GOOD-STRONG': 4.9,
    'M-VVS2-EX-POOR-STRONG': 4.9,
    'E-I2-GOOD-GOOD-STRONG': 4.89,
    'H-I1-POOR-GOOD-NONE': 4.89,
    'H-I1-GOOD-POOR-NONE': 4.89,
    'J-VS1-POOR-POOR-FAINT': 4.89,
    'J-VS2-POOR-POOR-NONE': 4.89,
    'K-I1-GOOD-EX-FAINT': 4.89,
    'K-I1-EX-GOOD-FAINT': 4.89,
    'K-I2-GOOD-EX-NONE': 4.89,
    'K-I2-EX-GOOD-NONE': 4.89,
    'M-VS1-POOR-EX-MEDIUM': 4.89,
    'M-VS1-GOOD-VG-MEDIUM': 4.89,
    'M-VS1-VG-GOOD-MEDIUM': 4.89,
    'M-VS1-EX-POOR-MEDIUM': 4.89,
    'M-VS2-POOR-EX-FAINT': 4.89,
    'M-VS2-GOOD-VG-FAINT': 4.89,
    'M-VS2-VG-GOOD-FAINT': 4.89,
    'M-VS2-EX-POOR-FAINT': 4.89,
    'G-SI1-POOR-GOOD-STRONG': 4.88,
    'G-SI1-GOOD-POOR-STRONG': 4.88,
    'G-SI2-POOR-GOOD-MEDIUM': 4.88,
    'G-SI2-GOOD-POOR-MEDIUM': 4.88,
    'I-VVS2-POOR-POOR-STRONG': 4.88,
    'J-SI2-VG-VG-STRONG': 4.88,
    'M-SI1-POOR-EX-NONE': 4.88,
    'M-SI1-GOOD-VG-NONE': 4.88,
    'M-SI1-VG-GOOD-NONE': 4.88,
    'M-SI1-EX-POOR-NONE': 4.88,
    'G-I1-POOR-GOOD-FAINT': 4.87,
    'G-I1-GOOD-POOR-FAINT': 4.87,
    'G-I2-POOR-GOOD-NONE': 4.87,
    'G-I2-GOOD-POOR-NONE': 4.87,
    'I-VS1-POOR-POOR-MEDIUM': 4.87,
    'I-VS2-POOR-POOR-FAINT': 4.87,
    'J-SI2-GOOD-EX-STRONG': 4.87,
    'J-SI2-EX-GOOD-STRONG': 4.87,
    'J-I1-VG-VG-MEDIUM': 4.87,
    'J-I2-VG-VG-FAINT': 4.87,
    'I-SI1-POOR-POOR-NONE': 4.86,
    'J-I1-GOOD-EX-MEDIUM': 4.86,
    'J-I1-EX-GOOD-MEDIUM': 4.86,
    'J-I2-GOOD-EX-FAINT': 4.86,
    'J-I2-EX-GOOD-FAINT': 4.86,
    'L-VS1-POOR-EX-STRONG': 4.86,
    'L-VS1-GOOD-VG-STRONG': 4.86,
    'L-VS1-VG-GOOD-STRONG': 4.86,
    'L-VS1-EX-POOR-STRONG': 4.86,
    'L-VS2-POOR-EX-MEDIUM': 4.86,
    'L-VS2-GOOD-VG-MEDIUM': 4.86,
    'L-VS2-VG-GOOD-MEDIUM': 4.86,
    'L-VS2-EX-POOR-MEDIUM': 4.86,
    'F-SI2-POOR-GOOD-STRONG': 4.85,
    'F-SI2-GOOD-POOR-STRONG': 4.85,
    'I-I1-VG-VG-STRONG': 4.85,
    'I-I2-VG-VG-MEDIUM': 4.85,
    'L-SI1-POOR-EX-FAINT': 4.85,
    'L-SI1-GOOD-VG-FAINT': 4.85,
    'L-SI1-VG-GOOD-FAINT': 4.85,
    'L-SI1-EX-POOR-FAINT': 4.85,
    'L-SI2-POOR-EX-NONE': 4.85,
    'L-SI2-GOOD-VG-NONE': 4.85,
    'L-SI2-VG-GOOD-NONE': 4.85,
    'L-SI2-EX-POOR-NONE': 4.85,
    'F-I1-POOR-GOOD-MEDIUM': 4.84,
    'F-I1-GOOD-POOR-MEDIUM': 4.84,
    'F-I2-POOR-GOOD-FAINT': 4.84,
    'F-I2-GOOD-POOR-FAINT': 4.84,
    'H-VS1-POOR-POOR-STRONG': 4.84,
    'H-VS2-POOR-POOR-MEDIUM': 4.84,
    'I-I1-GOOD-EX-STRONG': 4.84,
    'I-I1-EX-GOOD-STRONG': 4.84,
    'I-I2-GOOD-EX-MEDIUM': 4.84,
    'I-I2-EX-GOOD-MEDIUM': 4.84,
    'K-VS2-POOR-EX-STRONG': 4.84,
    'K-VS2-GOOD-VG-STRONG': 4.84,
    'K-VS2-VG-GOOD-STRONG': 4.84,
    'K-VS2-EX-POOR-STRONG': 4.84,
    'H-SI1-POOR-POOR-FAINT': 4.83,
    'H-SI2-POOR-POOR-NONE': 4.83,
    'K-SI1-POOR-EX-MEDIUM': 4.83,
    'K-SI1-GOOD-VG-MEDIUM': 4.83,
    'K-SI1-VG-GOOD-MEDIUM': 4.83,
    'K-SI1-EX-POOR-MEDIUM': 4.83,
    'K-SI2-POOR-EX-FAINT': 4.83,
    'K-SI2-GOOD-VG-FAINT': 4.83,
    'K-SI2-VG-GOOD-FAINT': 4.83,
    'K-SI2-EX-POOR-FAINT': 4.83,
    'M-VVS1-POOR-VG-STRONG': 4.83,
    'M-VVS1-VG-POOR-STRONG': 4.83,
    'M-VVS2-POOR-VG-MEDIUM': 4.83,
    'M-VVS2-VG-POOR-MEDIUM': 4.83,
    'E-I1-POOR-GOOD-STRONG': 4.82,
    'E-I1-GOOD-POOR-STRONG': 4.82,
    'E-I2-POOR-GOOD-MEDIUM': 4.82,
    'E-I2-GOOD-POOR-MEDIUM': 4.82,
    'G-VS2-POOR-POOR-STRONG': 4.82,
    'H-I2-VG-VG-STRONG': 4.82,
    'K-I1-POOR-EX-NONE': 4.82,
    'K-I1-GOOD-VG-NONE': 4.82,
    'K-I1-VG-GOOD-NONE': 4.82,
    'K-I1-EX-POOR-NONE': 4.82,
    'M-VVS1-GOOD-GOOD-STRONG': 4.82,
    'M-VVS2-GOOD-GOOD-MEDIUM': 4.82,
    'M-VS1-POOR-VG-FAINT': 4.82,
    'M-VS1-VG-POOR-FAINT': 4.82,
    'M-VS2-POOR-VG-NONE': 4.82,
    'M-VS2-VG-POOR-NONE': 4.82,
    'G-SI1-POOR-POOR-MEDIUM': 4.81,
    'G-SI2-POOR-POOR-FAINT': 4.81,
    'H-I2-GOOD-EX-STRONG': 4.81,
    'H-I2-EX-GOOD-STRONG': 4.81,
    'M-VS1-GOOD-GOOD-FAINT': 4.81,
    'M-VS2-GOOD-GOOD-NONE': 4.81,
    'G-I1-POOR-POOR-NONE': 4.8,
    'J-SI1-POOR-EX-STRONG': 4.8,
    'J-SI1-GOOD-VG-STRONG': 4.8,
    'J-SI1-VG-GOOD-STRONG': 4.8,
    'J-SI1-EX-POOR-STRONG': 4.8,
    'J-SI2-POOR-EX-MEDIUM': 4.8,
    'J-SI2-GOOD-VG-MEDIUM': 4.8,
    'J-SI2-VG-GOOD-MEDIUM': 4.8,
    'J-SI2-EX-POOR-MEDIUM': 4.8,
    'L-VVS2-POOR-VG-STRONG': 4.8,
    'L-VVS2-VG-POOR-STRONG': 4.8,
    'M-SI2-EX-EX-STRONG': 4.8,
    'D-I2-POOR-GOOD-STRONG': 4.79,
    'D-I2-GOOD-POOR-STRONG': 4.79,
    'J-I1-POOR-EX-FAINT': 4.79,
    'J-I1-GOOD-VG-FAINT': 4.79,
    'J-I1-VG-GOOD-FAINT': 4.79,
    'J-I1-EX-POOR-FAINT': 4.79,
    'J-I2-POOR-EX-NONE': 4.79,
    'J-I2-GOOD-VG-NONE': 4.79,
    'J-I2-VG-GOOD-NONE': 4.79,
    'J-I2-EX-POOR-NONE': 4.79,
    'L-VVS2-GOOD-GOOD-STRONG': 4.79,
    'L-VS1-POOR-VG-MEDIUM': 4.79,
    'L-VS1-VG-POOR-MEDIUM': 4.79,
    'L-VS2-POOR-VG-FAINT': 4.79,
    'L-VS2-VG-POOR-FAINT': 4.79,
    'M-I1-EX-EX-MEDIUM': 4.79,
    'M-I2-EX-EX-FAINT': 4.79,
    'F-SI1-POOR-POOR-STRONG': 4.78,
    'F-SI2-POOR-POOR-MEDIUM': 4.78,
    'I-SI2-POOR-EX-STRONG': 4.78,
    'I-SI2-GOOD-VG-STRONG': 4.78,
    'I-SI2-VG-GOOD-STRONG': 4.78,
    'I-SI2-EX-POOR-STRONG': 4.78,
    'L-VS1-GOOD-GOOD-MEDIUM': 4.78,
    'L-VS2-GOOD-GOOD-FAINT': 4.78,
    'L-SI1-POOR-VG-NONE': 4.78,
    'L-SI1-VG-POOR-NONE': 4.78,
    'F-I1-POOR-POOR-FAINT': 4.77,
    'F-I2-POOR-POOR-NONE': 4.77,
    'I-I1-POOR-EX-MEDIUM': 4.77,
    'I-I1-GOOD-VG-MEDIUM': 4.77,
    'I-I1-VG-GOOD-MEDIUM': 4.77,
    'I-I1-EX-POOR-MEDIUM': 4.77,
    'I-I2-POOR-EX-FAINT': 4.77,
    'I-I2-GOOD-VG-FAINT': 4.77,
    'I-I2-VG-GOOD-FAINT': 4.77,
    'I-I2-EX-POOR-FAINT': 4.77,
    'K-VS1-POOR-VG-STRONG': 4.77,
    'K-VS1-VG-POOR-STRONG': 4.77,
    'K-VS2-POOR-VG-MEDIUM': 4.77,
    'K-VS2-VG-POOR-MEDIUM': 4.77,
    'L-SI1-GOOD-GOOD-NONE': 4.77,
    'E-SI2-POOR-POOR-STRONG': 4.76,
    'K-VS1-GOOD-GOOD-STRONG': 4.76,
    'K-VS2-GOOD-GOOD-MEDIUM': 4.76,
    'K-SI1-POOR-VG-FAINT': 4.76,
    'K-SI1-VG-POOR-FAINT': 4.76,
    'K-SI2-POOR-VG-NONE': 4.76,
    'K-SI2-VG-POOR-NONE': 4.76,
    'L-I1-EX-EX-STRONG': 4.76,
    'L-I2-EX-EX-MEDIUM': 4.76,
    'M-IF-POOR-GOOD-STRONG': 4.76,
    'M-IF-GOOD-POOR-STRONG': 4.76,
    'E-I1-POOR-POOR-MEDIUM': 4.75,
    'E-I2-POOR-POOR-FAINT': 4.75,
    'K-SI1-GOOD-GOOD-FAINT': 4.75,
    'K-SI2-GOOD-GOOD-NONE': 4.75,
    'M-VVS1-POOR-GOOD-MEDIUM': 4.75,
    'M-VVS1-GOOD-POOR-MEDIUM': 4.75,
    'M-VVS2-POOR-GOOD-FAINT': 4.75,
    'M-VVS2-GOOD-POOR-FAINT': 4.75,
    'H-I1-POOR-EX-STRONG': 4.74,
    'H-I1-GOOD-VG-STRONG': 4.74,
    'H-I1-VG-GOOD-STRONG': 4.74,
    'H-I1-EX-POOR-STRONG': 4.74,
    'H-I2-POOR-EX-MEDIUM': 4.74,
    'H-I2-GOOD-VG-MEDIUM': 4.74,
    'H-I2-VG-GOOD-MEDIUM': 4.74,
    'H-I2-EX-POOR-MEDIUM': 4.74,
    'J-VS2-POOR-VG-STRONG': 4.74,
    'J-VS2-VG-POOR-STRONG': 4.74,
    'K-I2-EX-EX-STRONG': 4.74,
    'M-VS1-POOR-GOOD-NONE': 4.74,
    'M-VS1-GOOD-POOR-NONE': 4.74,
    'J-VS2-GOOD-GOOD-STRONG': 4.73,
    'J-SI1-POOR-VG-MEDIUM': 4.73,
    'J-SI1-VG-POOR-MEDIUM': 4.73,
    'J-SI2-POOR-VG-FAINT': 4.73,
    'J-SI2-VG-POOR-FAINT': 4.73,
    'M-SI1-VG-EX-STRONG': 4.73,
    'M-SI1-EX-VG-STRONG': 4.73,
    'M-SI2-VG-EX-MEDIUM': 4.73,
    'M-SI2-EX-VG-MEDIUM': 4.73,
    'D-I1-POOR-POOR-STRONG': 4.72,
    'D-I2-POOR-POOR-MEDIUM': 4.72,
    'G-I2-POOR-EX-STRONG': 4.72,
    'G-I2-GOOD-VG-STRONG': 4.72,
    'G-I2-VG-GOOD-STRONG': 4.72,
    'G-I2-EX-POOR-STRONG': 4.72,
    'J-SI1-GOOD-GOOD-MEDIUM': 4.72,
    'J-SI2-GOOD-GOOD-FAINT': 4.72,
    'J-I1-POOR-VG-NONE': 4.72,
    'J-I1-VG-POOR-NONE': 4.72,
    'L-VVS1-POOR-GOOD-STRONG': 4.72,
    'L-VVS1-GOOD-POOR-STRONG': 4.72,
    'L-VVS2-POOR-GOOD-MEDIUM': 4.72,
    'L-VVS2-GOOD-POOR-MEDIUM': 4.72,
    'M-I1-VG-EX-FAINT': 4.72,
    'M-I1-EX-VG-FAINT': 4.72,
    'M-I2-VG-EX-NONE': 4.72,
    'M-I2-EX-VG-NONE': 4.72,
    'I-SI1-POOR-VG-STRONG': 4.71,
    'I-SI1-VG-POOR-STRONG': 4.71,
    'I-SI2-POOR-VG-MEDIUM': 4.71,
    'I-SI2-VG-POOR-MEDIUM': 4.71,
    'J-I1-GOOD-GOOD-NONE': 4.71,
    'L-VS1-POOR-GOOD-FAINT': 4.71,
    'L-VS1-GOOD-POOR-FAINT': 4.71,
    'L-VS2-POOR-GOOD-NONE': 4.71,
    'L-VS2-GOOD-POOR-NONE': 4.71,
    'I-SI1-GOOD-GOOD-STRONG': 4.7,
    'I-SI2-GOOD-GOOD-MEDIUM': 4.7,
    'I-I1-POOR-VG-FAINT': 4.7,
    'I-I1-VG-POOR-FAINT': 4.7,
    'I-I2-POOR-VG-NONE': 4.7,
    'I-I2-VG-POOR-NONE': 4.7,
    'K-VVS2-POOR-GOOD-STRONG': 4.7,
    'K-VVS2-GOOD-POOR-STRONG': 4.7,
    'L-SI2-VG-EX-STRONG': 4.7,
    'L-SI2-EX-VG-STRONG': 4.7,
    'I-I1-GOOD-GOOD-FAINT': 4.69,
    'I-I2-GOOD-GOOD-NONE': 4.69,
    'K-VS1-POOR-GOOD-MEDIUM': 4.69,
    'K-VS1-GOOD-POOR-MEDIUM': 4.69,
    'K-VS2-POOR-GOOD-FAINT': 4.69,
    'K-VS2-GOOD-POOR-FAINT': 4.69,
    'L-I1-VG-EX-MEDIUM': 4.69,
    'L-I1-EX-VG-MEDIUM': 4.69,
    'L-I2-VG-EX-FAINT': 4.69,
    'L-I2-EX-VG-FAINT': 4.69,
    'M-IF-POOR-POOR-MEDIUM': 4.69,
    'H-SI2-POOR-VG-STRONG': 4.68,
    'H-SI2-VG-POOR-STRONG': 4.68,
    'K-SI1-POOR-GOOD-NONE': 4.68,
    'K-SI1-GOOD-POOR-NONE': 4.68,
    'M-VVS1-POOR-POOR-FAINT': 4.68,
    'M-VVS2-POOR-POOR-NONE': 4.68,
    'H-SI2-GOOD-GOOD-STRONG': 4.67,
    'H-I1-POOR-VG-MEDIUM': 4.67,
    'H-I1-VG-POOR-MEDIUM': 4.67,
    'H-I2-POOR-VG-FAINT': 4.67,
    'H-I2-VG-POOR-FAINT': 4.67,
    'K-I1-VG-EX-STRONG': 4.67,
    'K-I1-EX-VG-STRONG': 4.67,
    'K-I2-VG-EX-MEDIUM': 4.67,
    'K-I2-EX-VG-MEDIUM': 4.67,
    'M-VS2-VG-VG-STRONG': 4.67,
    'H-I1-GOOD-GOOD-MEDIUM': 4.66,
    'H-I2-GOOD-GOOD-FAINT': 4.66,
    'J-VS1-POOR-GOOD-STRONG': 4.66,
    'J-VS1-GOOD-POOR-STRONG': 4.66,
    'J-VS2-POOR-GOOD-MEDIUM': 4.66,
    'J-VS2-GOOD-POOR-MEDIUM': 4.66,
    'L-IF-POOR-POOR-STRONG': 4.66,
    'M-VS2-GOOD-EX-STRONG': 4.66,
    'M-VS2-EX-GOOD-STRONG': 4.66,
    'M-SI1-VG-VG-MEDIUM': 4.66,
    'M-SI2-VG-VG-FAINT': 4.66,
    'G-I1-POOR-VG-STRONG': 4.65,
    'G-I1-VG-POOR-STRONG': 4.65,
    'G-I2-POOR-VG-MEDIUM': 4.65,
    'G-I2-VG-POOR-MEDIUM': 4.65,
    'J-SI1-POOR-GOOD-FAINT': 4.65,
    'J-SI1-GOOD-POOR-FAINT': 4.65,
    'J-SI2-POOR-GOOD-NONE': 4.65,
    'J-SI2-GOOD-POOR-NONE': 4.65,
    'L-VVS1-POOR-POOR-MEDIUM': 4.65,
    'L-VVS2-POOR-POOR-FAINT': 4.65,
    'M-SI1-GOOD-EX-MEDIUM': 4.65,
    'M-SI1-EX-GOOD-MEDIUM': 4.65,
    'M-SI2-GOOD-EX-FAINT': 4.65,
    'M-SI2-EX-GOOD-FAINT': 4.65,
    'M-I1-VG-VG-NONE': 4.65,
    'G-I1-GOOD-GOOD-STRONG': 4.64,
    'G-I2-GOOD-GOOD-MEDIUM': 4.64,
    'I-VS2-POOR-GOOD-STRONG': 4.64,
    'I-VS2-GOOD-POOR-STRONG': 4.64,
    'J-I2-VG-EX-STRONG': 4.64,
    'J-I2-EX-VG-STRONG': 4.64,
    'L-VS1-POOR-POOR-NONE': 4.64,
    'M-I1-GOOD-EX-NONE': 4.64,
    'M-I1-EX-GOOD-NONE': 4.64,
    'I-SI1-POOR-GOOD-MEDIUM': 4.63,
    'I-SI1-GOOD-POOR-MEDIUM': 4.63,
    'I-SI2-POOR-GOOD-FAINT': 4.63,
    'I-SI2-GOOD-POOR-FAINT': 4.63,
    'K-VVS1-POOR-POOR-STRONG': 4.63,
    'K-VVS2-POOR-POOR-MEDIUM': 4.63,
    'L-SI1-VG-VG-STRONG': 4.63,
    'L-SI2-VG-VG-MEDIUM': 4.63,
    'F-I2-POOR-VG-STRONG': 4.62,
    'F-I2-VG-POOR-STRONG': 4.62,
    'I-I1-POOR-GOOD-NONE': 4.62,
    'I-I1-GOOD-POOR-NONE': 4.62,
    'K-VS1-POOR-POOR-FAINT': 4.62,
    'K-VS2-POOR-POOR-NONE': 4.62,
    'L-SI1-GOOD-EX-STRONG': 4.62,
    'L-SI1-EX-GOOD-STRONG': 4.62,
    'L-SI2-GOOD-EX-MEDIUM': 4.62,
    'L-SI2-EX-GOOD-MEDIUM': 4.62,
    'L-I1-VG-VG-FAINT': 4.62,
    'L-I2-VG-VG-NONE': 4.62,
    'F-I2-GOOD-GOOD-STRONG': 4.61,
    'K-SI2-VG-VG-STRONG': 4.61,
    'L-I1-GOOD-EX-FAINT': 4.61,
    'L-I1-EX-GOOD-FAINT': 4.61,
    'L-I2-GOOD-EX-NONE': 4.61,
    'L-I2-EX-GOOD-NONE': 4.61,
    'H-SI1-POOR-GOOD-STRONG': 4.6,
    'H-SI1-GOOD-POOR-STRONG': 4.6,
    'H-SI2-POOR-GOOD-MEDIUM': 4.6,
    'H-SI2-GOOD-POOR-MEDIUM': 4.6,
    'J-VVS2-POOR-POOR-STRONG': 4.6,
    'K-SI2-GOOD-EX-STRONG': 4.6,
    'K-SI2-EX-GOOD-STRONG': 4.6,
    'K-I1-VG-VG-MEDIUM': 4.6,
    'K-I2-VG-VG-FAINT': 4.6,
    'H-I1-POOR-GOOD-FAINT': 4.59,
    'H-I1-GOOD-POOR-FAINT': 4.59,
    'H-I2-POOR-GOOD-NONE': 4.59,
    'H-I2-GOOD-POOR-NONE': 4.59,
    'J-VS1-POOR-POOR-MEDIUM': 4.59,
    'J-VS2-POOR-POOR-FAINT': 4.59,
    'K-I1-GOOD-EX-MEDIUM': 4.59,
    'K-I1-EX-GOOD-MEDIUM': 4.59,
    'K-I2-GOOD-EX-FAINT': 4.59,
    'K-I2-EX-GOOD-FAINT': 4.59,
    'M-VS1-POOR-EX-STRONG': 4.59,
    'M-VS1-GOOD-VG-STRONG': 4.59,
    'M-VS1-VG-GOOD-STRONG': 4.59,
    'M-VS1-EX-POOR-STRONG': 4.59,
    'M-VS2-POOR-EX-MEDIUM': 4.59,
    'M-VS2-GOOD-VG-MEDIUM': 4.59,
    'M-VS2-VG-GOOD-MEDIUM': 4.59,
    'M-VS2-EX-POOR-MEDIUM': 4.59,
    'G-SI2-POOR-GOOD-STRONG': 4.58,
    'G-SI2-GOOD-POOR-STRONG': 4.58,
    'J-SI1-POOR-POOR-NONE': 4.58,
    'M-SI1-POOR-EX-FAINT': 4.58,
    'M-SI1-GOOD-VG-FAINT': 4.58,
    'M-SI1-VG-GOOD-FAINT': 4.58,
    'M-SI1-EX-POOR-FAINT': 4.58,
    'M-SI2-POOR-EX-NONE': 4.58,
    'M-SI2-GOOD-VG-NONE': 4.58,
    'M-SI2-VG-GOOD-NONE': 4.58,
    'M-SI2-EX-POOR-NONE': 4.58,
    'G-I1-POOR-GOOD-MEDIUM': 4.57,
    'G-I1-GOOD-POOR-MEDIUM': 4.57,
    'G-I2-POOR-GOOD-FAINT': 4.57,
    'G-I2-GOOD-POOR-FAINT': 4.57,
    'I-VS1-POOR-POOR-STRONG': 4.57,
    'I-VS2-POOR-POOR-MEDIUM': 4.57,
    'J-I1-VG-VG-STRONG': 4.57,
    'J-I2-VG-VG-MEDIUM': 4.57,
    'I-SI1-POOR-POOR-FAINT': 4.56,
    'I-SI2-POOR-POOR-NONE': 4.56,
    'J-I1-GOOD-EX-STRONG': 4.56,
    'J-I1-EX-GOOD-STRONG': 4.56,
    'J-I2-GOOD-EX-MEDIUM': 4.56,
    'J-I2-EX-GOOD-MEDIUM': 4.56,
    'L-VS2-POOR-EX-STRONG': 4.56,
    'L-VS2-GOOD-VG-STRONG': 4.56,
    'L-VS2-VG-GOOD-STRONG': 4.56,
    'L-VS2-EX-POOR-STRONG': 4.56,
    'I-I2-VG-VG-STRONG': 4.55,
    'L-SI1-POOR-EX-MEDIUM': 4.55,
    'L-SI1-GOOD-VG-MEDIUM': 4.55,
    'L-SI1-VG-GOOD-MEDIUM': 4.55,
    'L-SI1-EX-POOR-MEDIUM': 4.55,
    'L-SI2-POOR-EX-FAINT': 4.55,
    'L-SI2-GOOD-VG-FAINT': 4.55,
    'L-SI2-VG-GOOD-FAINT': 4.55,
    'L-SI2-EX-POOR-FAINT': 4.55,
    'F-I1-POOR-GOOD-STRONG': 4.54,
    'F-I1-GOOD-POOR-STRONG': 4.54,
    'F-I2-POOR-GOOD-MEDIUM': 4.54,
    'F-I2-GOOD-POOR-MEDIUM': 4.54,
    'H-VS2-POOR-POOR-STRONG': 4.54,
    'I-I2-GOOD-EX-STRONG': 4.54,
    'I-I2-EX-GOOD-STRONG': 4.54,
    'L-I1-POOR-EX-NONE': 4.54,
    'L-I1-GOOD-VG-NONE': 4.54,
    'L-I1-VG-GOOD-NONE': 4.54,
    'L-I1-EX-POOR-NONE': 4.54,
    'H-SI1-POOR-POOR-MEDIUM': 4.53,
    'H-SI2-POOR-POOR-FAINT': 4.53,
    'K-SI1-POOR-EX-STRONG': 4.53,
    'K-SI1-GOOD-VG-STRONG': 4.53,
    'K-SI1-VG-GOOD-STRONG': 4.53,
    'K-SI1-EX-POOR-STRONG': 4.53,
    'K-SI2-POOR-EX-MEDIUM': 4.53,
    'K-SI2-GOOD-VG-MEDIUM': 4.53,
    'K-SI2-VG-GOOD-MEDIUM': 4.53,
    'K-SI2-EX-POOR-MEDIUM': 4.53,
    'M-VVS2-POOR-VG-STRONG': 4.53,
    'M-VVS2-VG-POOR-STRONG': 4.53,
    'E-I2-POOR-GOOD-STRONG': 4.52,
    'E-I2-GOOD-POOR-STRONG': 4.52,
    'H-I1-POOR-POOR-NONE': 4.52,
    'K-I1-POOR-EX-FAINT': 4.52,
    'K-I1-GOOD-VG-FAINT': 4.52,
    'K-I1-VG-GOOD-FAINT': 4.52,
    'K-I1-EX-POOR-FAINT': 4.52,
    'K-I2-POOR-EX-NONE': 4.52,
    'K-I2-GOOD-VG-NONE': 4.52,
    'K-I2-VG-GOOD-NONE': 4.52,
    'K-I2-EX-POOR-NONE': 4.52,
    'M-VVS2-GOOD-GOOD-STRONG': 4.52,
    'M-VS1-POOR-VG-MEDIUM': 4.52,
    'M-VS1-VG-POOR-MEDIUM': 4.52,
    'M-VS2-POOR-VG-FAINT': 4.52,
    'M-VS2-VG-POOR-FAINT': 4.52,
    'G-SI1-POOR-POOR-STRONG': 4.51,
    'G-SI2-POOR-POOR-MEDIUM': 4.51,
    'M-VS1-GOOD-GOOD-MEDIUM': 4.51,
    'M-VS2-GOOD-GOOD-FAINT': 4.51,
    'M-SI1-POOR-VG-NONE': 4.51,
    'M-SI1-VG-POOR-NONE': 4.51,
    'G-I1-POOR-POOR-FAINT': 4.5,
    'G-I2-POOR-POOR-NONE': 4.5,
    'J-SI2-POOR-EX-STRONG': 4.5,
    'J-SI2-GOOD-VG-STRONG': 4.5,
    'J-SI2-VG-GOOD-STRONG': 4.5,
    'J-SI2-EX-POOR-STRONG': 4.5,
    'M-SI1-GOOD-GOOD-NONE': 4.5,
    'J-I1-POOR-EX-MEDIUM': 4.49,
    'J-I1-GOOD-VG-MEDIUM': 4.49,
    'J-I1-VG-GOOD-MEDIUM': 4.49,
    'J-I1-EX-POOR-MEDIUM': 4.49,
    'J-I2-POOR-EX-FAINT': 4.49,
    'J-I2-GOOD-VG-FAINT': 4.49,
    'J-I2-VG-GOOD-FAINT': 4.49,
    'J-I2-EX-POOR-FAINT': 4.49,
    'L-VS1-POOR-VG-STRONG': 4.49,
    'L-VS1-VG-POOR-STRONG': 4.49,
    'L-VS2-POOR-VG-MEDIUM': 4.49,
    'L-VS2-VG-POOR-MEDIUM': 4.49,
    'M-I1-EX-EX-STRONG': 4.49,
    'M-I2-EX-EX-MEDIUM': 4.49,
    'F-SI2-POOR-POOR-STRONG': 4.48,
    'L-VS1-GOOD-GOOD-STRONG': 4.48,
    'L-VS2-GOOD-GOOD-MEDIUM': 4.48,
    'L-SI1-POOR-VG-FAINT': 4.48,
    'L-SI1-VG-POOR-FAINT': 4.48,
    'L-SI2-POOR-VG-NONE': 4.48,
    'L-SI2-VG-POOR-NONE': 4.48,
    'F-I1-POOR-POOR-MEDIUM': 4.47,
    'F-I2-POOR-POOR-FAINT': 4.47,
    'I-I1-POOR-EX-STRONG': 4.47,
    'I-I1-GOOD-VG-STRONG': 4.47,
    'I-I1-VG-GOOD-STRONG': 4.47,
    'I-I1-EX-POOR-STRONG': 4.47,
    'I-I2-POOR-EX-MEDIUM': 4.47,
    'I-I2-GOOD-VG-MEDIUM': 4.47,
    'I-I2-VG-GOOD-MEDIUM': 4.47,
    'I-I2-EX-POOR-MEDIUM': 4.47,
    'K-VS2-POOR-VG-STRONG': 4.47,
    'K-VS2-VG-POOR-STRONG': 4.47,
    'L-SI1-GOOD-GOOD-FAINT': 4.47,
    'L-SI2-GOOD-GOOD-NONE': 4.47,
    'K-VS2-GOOD-GOOD-STRONG': 4.46,
    'K-SI1-POOR-VG-MEDIUM': 4.46,
    'K-SI1-VG-POOR-MEDIUM': 4.46,
    'K-SI2-POOR-VG-FAINT': 4.46,
    'K-SI2-VG-POOR-FAINT': 4.46,
    'L-I2-EX-EX-STRONG': 4.46,
    'E-I1-POOR-POOR-STRONG': 4.45,
    'E-I2-POOR-POOR-MEDIUM': 4.45,
    'K-SI1-GOOD-GOOD-MEDIUM': 4.45,
    'K-SI2-GOOD-GOOD-FAINT': 4.45,
    'K-I1-POOR-VG-NONE': 4.45,
    'K-I1-VG-POOR-NONE': 4.45,
    'M-VVS1-POOR-GOOD-STRONG': 4.45,
    'M-VVS1-GOOD-POOR-STRONG': 4.45,
    'M-VVS2-POOR-GOOD-MEDIUM': 4.45,
    'M-VVS2-GOOD-POOR-MEDIUM': 4.45,
    'H-I2-POOR-EX-STRONG': 4.44,
    'H-I2-GOOD-VG-STRONG': 4.44,
    'H-I2-VG-GOOD-STRONG': 4.44,
    'H-I2-EX-POOR-STRONG': 4.44,
    'K-I1-GOOD-GOOD-NONE': 4.44,
    'M-VS1-POOR-GOOD-FAINT': 4.44,
    'M-VS1-GOOD-POOR-FAINT': 4.44,
    'M-VS2-POOR-GOOD-NONE': 4.44,
    'M-VS2-GOOD-POOR-NONE': 4.44,
    'J-SI1-POOR-VG-STRONG': 4.43,
    'J-SI1-VG-POOR-STRONG': 4.43,
    'J-SI2-POOR-VG-MEDIUM': 4.43,
    'J-SI2-VG-POOR-MEDIUM': 4.43,
    'M-SI2-VG-EX-STRONG': 4.43,
    'M-SI2-EX-VG-STRONG': 4.43,
    'D-I2-POOR-POOR-STRONG': 4.42,
    'J-SI1-GOOD-GOOD-STRONG': 4.42,
    'J-SI2-GOOD-GOOD-MEDIUM': 4.42,
    'J-I1-POOR-VG-FAINT': 4.42,
    'J-I1-VG-POOR-FAINT': 4.42,
    'J-I2-POOR-VG-NONE': 4.42,
    'J-I2-VG-POOR-NONE': 4.42,
    'L-VVS2-POOR-GOOD-STRONG': 4.42,
    'L-VVS2-GOOD-POOR-STRONG': 4.42,
    'M-I1-VG-EX-MEDIUM': 4.42,
    'M-I1-EX-VG-MEDIUM': 4.42,
    'M-I2-VG-EX-FAINT': 4.42,
    'M-I2-EX-VG-FAINT': 4.42,
    'I-SI2-POOR-VG-STRONG': 4.41,
    'I-SI2-VG-POOR-STRONG': 4.41,
    'J-I1-GOOD-GOOD-FAINT': 4.41,
    'J-I2-GOOD-GOOD-NONE': 4.41,
    'L-VS1-POOR-GOOD-MEDIUM': 4.41,
    'L-VS1-GOOD-POOR-MEDIUM': 4.41,
    'L-VS2-POOR-GOOD-FAINT': 4.41,
    'L-VS2-GOOD-POOR-FAINT': 4.41,
    'I-SI2-GOOD-GOOD-STRONG': 4.4,
    'I-I1-POOR-VG-MEDIUM': 4.4,
    'I-I1-VG-POOR-MEDIUM': 4.4,
    'I-I2-POOR-VG-FAINT': 4.4,
    'I-I2-VG-POOR-FAINT': 4.4,
    'L-SI1-POOR-GOOD-NONE': 4.4,
    'L-SI1-GOOD-POOR-NONE': 4.4,
    'I-I1-GOOD-GOOD-MEDIUM': 4.39,
    'I-I2-GOOD-GOOD-FAINT': 4.39,
    'K-VS1-POOR-GOOD-STRONG': 4.39,
    'K-VS1-GOOD-POOR-STRONG': 4.39,
    'K-VS2-POOR-GOOD-MEDIUM': 4.39,
    'K-VS2-GOOD-POOR-MEDIUM': 4.39,
    'L-I1-VG-EX-STRONG': 4.39,
    'L-I1-EX-VG-STRONG': 4.39,
    'L-I2-VG-EX-MEDIUM': 4.39,
    'L-I2-EX-VG-MEDIUM': 4.39,
    'M-IF-POOR-POOR-STRONG': 4.39,
    'K-SI1-POOR-GOOD-FAINT': 4.38,
    'K-SI1-GOOD-POOR-FAINT': 4.38,
    'K-SI2-POOR-GOOD-NONE': 4.38,
    'K-SI2-GOOD-POOR-NONE': 4.38,
    'M-VVS1-POOR-POOR-MEDIUM': 4.38,
    'M-VVS2-POOR-POOR-FAINT': 4.38,
    'H-I1-POOR-VG-STRONG': 4.37,
    'H-I1-VG-POOR-STRONG': 4.37,
    'H-I2-POOR-VG-MEDIUM': 4.37,
    'H-I2-VG-POOR-MEDIUM': 4.37,
    'K-I2-VG-EX-STRONG': 4.37,
    'K-I2-EX-VG-STRONG': 4.37,
    'M-VS1-POOR-POOR-NONE': 4.37,
    'H-I1-GOOD-GOOD-STRONG': 4.36,
    'H-I2-GOOD-GOOD-MEDIUM': 4.36,
    'J-VS2-POOR-GOOD-STRONG': 4.36,
    'J-VS2-GOOD-POOR-STRONG': 4.36,
    'M-SI1-VG-VG-STRONG': 4.36,
    'M-SI2-VG-VG-MEDIUM': 4.36,
    'G-I2-POOR-VG-STRONG': 4.35,
    'G-I2-VG-POOR-STRONG': 4.35,
    'J-SI1-POOR-GOOD-MEDIUM': 4.35,
    'J-SI1-GOOD-POOR-MEDIUM': 4.35,
    'J-SI2-POOR-GOOD-FAINT': 4.35,
    'J-SI2-GOOD-POOR-FAINT': 4.35,
    'L-VVS1-POOR-POOR-STRONG': 4.35,
    'L-VVS2-POOR-POOR-MEDIUM': 4.35,
    'M-SI1-GOOD-EX-STRONG': 4.35,
    'M-SI1-EX-GOOD-STRONG': 4.35,
    'M-SI2-GOOD-EX-MEDIUM': 4.35,
    'M-SI2-EX-GOOD-MEDIUM': 4.35,
    'M-I1-VG-VG-FAINT': 4.35,
    'M-I2-VG-VG-NONE': 4.35,
    'G-I2-GOOD-GOOD-STRONG': 4.34,
    'J-I1-POOR-GOOD-NONE': 4.34,
    'J-I1-GOOD-POOR-NONE': 4.34,
    'L-VS1-POOR-POOR-FAINT': 4.34,
    'L-VS2-POOR-POOR-NONE': 4.34,
    'M-I1-GOOD-EX-FAINT': 4.34,
    'M-I1-EX-GOOD-FAINT': 4.34,
    'M-I2-GOOD-EX-NONE': 4.34,
    'M-I2-EX-GOOD-NONE': 4.34,
    'I-SI1-POOR-GOOD-STRONG': 4.33,
    'I-SI1-GOOD-POOR-STRONG': 4.33,
    'I-SI2-POOR-GOOD-MEDIUM': 4.33,
    'I-SI2-GOOD-POOR-MEDIUM': 4.33,
    'K-VVS2-POOR-POOR-STRONG': 4.33,
    'L-SI2-VG-VG-STRONG': 4.33,
    'I-I1-POOR-GOOD-FAINT': 4.32,
    'I-I1-GOOD-POOR-FAINT': 4.32,
    'I-I2-POOR-GOOD-NONE': 4.32,
    'I-I2-GOOD-POOR-NONE': 4.32,
    'K-VS1-POOR-POOR-MEDIUM': 4.32,
    'K-VS2-POOR-POOR-FAINT': 4.32,
    'L-SI2-GOOD-EX-STRONG': 4.32,
    'L-SI2-EX-GOOD-STRONG': 4.32,
    'L-I1-VG-VG-MEDIUM': 4.32,
    'L-I2-VG-VG-FAINT': 4.32,
    'K-SI1-POOR-POOR-NONE': 4.31,
    'L-I1-GOOD-EX-MEDIUM': 4.31,
    'L-I1-EX-GOOD-MEDIUM': 4.31,
    'L-I2-GOOD-EX-FAINT': 4.31,
    'L-I2-EX-GOOD-FAINT': 4.31,
    'H-SI2-POOR-GOOD-STRONG': 4.3,
    'H-SI2-GOOD-POOR-STRONG': 4.3,
    'K-I1-VG-VG-STRONG': 4.3,
    'K-I2-VG-VG-MEDIUM': 4.3,
    'H-I1-POOR-GOOD-MEDIUM': 4.29,
    'H-I1-GOOD-POOR-MEDIUM': 4.29,
    'H-I2-POOR-GOOD-FAINT': 4.29,
    'H-I2-GOOD-POOR-FAINT': 4.29,
    'J-VS1-POOR-POOR-STRONG': 4.29,
    'J-VS2-POOR-POOR-MEDIUM': 4.29,
    'K-I1-GOOD-EX-STRONG': 4.29,
    'K-I1-EX-GOOD-STRONG': 4.29,
    'K-I2-GOOD-EX-MEDIUM': 4.29,
    'K-I2-EX-GOOD-MEDIUM': 4.29,
    'M-VS2-POOR-EX-STRONG': 4.29,
    'M-VS2-GOOD-VG-STRONG': 4.29,
    'M-VS2-VG-GOOD-STRONG': 4.29,
    'M-VS2-EX-POOR-STRONG': 4.29,
    'J-SI1-POOR-POOR-FAINT': 4.28,
    'J-SI2-POOR-POOR-NONE': 4.28,
    'M-SI1-POOR-EX-MEDIUM': 4.28,
    'M-SI1-GOOD-VG-MEDIUM': 4.28,
    'M-SI1-VG-GOOD-MEDIUM': 4.28,
    'M-SI1-EX-POOR-MEDIUM': 4.28,
    'M-SI2-POOR-EX-FAINT': 4.28,
    'M-SI2-GOOD-VG-FAINT': 4.28,
    'M-SI2-VG-GOOD-FAINT': 4.28,
    'M-SI2-EX-POOR-FAINT': 4.28,
    'G-I1-POOR-GOOD-STRONG': 4.27,
    'G-I1-GOOD-POOR-STRONG': 4.27,
    'G-I2-POOR-GOOD-MEDIUM': 4.27,
    'G-I2-GOOD-POOR-MEDIUM': 4.27,
    'I-VS2-POOR-POOR-STRONG': 4.27,
    'J-I2-VG-VG-STRONG': 4.27,
    'M-I1-POOR-EX-NONE': 4.27,
    'M-I1-GOOD-VG-NONE': 4.27,
    'M-I1-VG-GOOD-NONE': 4.27,
    'M-I1-EX-POOR-NONE': 4.27,
    'I-SI1-POOR-POOR-MEDIUM': 4.26,
    'I-SI2-POOR-POOR-FAINT': 4.26,
    'J-I2-GOOD-EX-STRONG': 4.26,
    'J-I2-EX-GOOD-STRONG': 4.26,
    'I-I1-POOR-POOR-NONE': 4.25,
    'L-SI1-POOR-EX-STRONG': 4.25,
    'L-SI1-GOOD-VG-STRONG': 4.25,
    'L-SI1-VG-GOOD-STRONG': 4.25,
    'L-SI1-EX-POOR-STRONG': 4.25,
    'L-SI2-POOR-EX-MEDIUM': 4.25,
    'L-SI2-GOOD-VG-MEDIUM': 4.25,
    'L-SI2-VG-GOOD-MEDIUM': 4.25,
    'L-SI2-EX-POOR-MEDIUM': 4.25,
    'F-I2-POOR-GOOD-STRONG': 4.24,
    'F-I2-GOOD-POOR-STRONG': 4.24,
    'L-I1-POOR-EX-FAINT': 4.24,
    'L-I1-GOOD-VG-FAINT': 4.24,
    'L-I1-VG-GOOD-FAINT': 4.24,
    'L-I1-EX-POOR-FAINT': 4.24,
    'L-I2-POOR-EX-NONE': 4.24,
    'L-I2-GOOD-VG-NONE': 4.24,
    'L-I2-VG-GOOD-NONE': 4.24,
    'L-I2-EX-POOR-NONE': 4.24,
    'H-SI1-POOR-POOR-STRONG': 4.23,
    'H-SI2-POOR-POOR-MEDIUM': 4.23,
    'K-SI2-POOR-EX-STRONG': 4.23,
    'K-SI2-GOOD-VG-STRONG': 4.23,
    'K-SI2-VG-GOOD-STRONG': 4.23,
    'K-SI2-EX-POOR-STRONG': 4.23,
    'H-I1-POOR-POOR-FAINT': 4.22,
    'H-I2-POOR-POOR-NONE': 4.22,
    'K-I1-POOR-EX-MEDIUM': 4.22,
    'K-I1-GOOD-VG-MEDIUM': 4.22,
    'K-I1-VG-GOOD-MEDIUM': 4.22,
    'K-I1-EX-POOR-MEDIUM': 4.22,
    'K-I2-POOR-EX-FAINT': 4.22,
    'K-I2-GOOD-VG-FAINT': 4.22,
    'K-I2-VG-GOOD-FAINT': 4.22,
    'K-I2-EX-POOR-FAINT': 4.22,
    'M-VS1-POOR-VG-STRONG': 4.22,
    'M-VS1-VG-POOR-STRONG': 4.22,
    'M-VS2-POOR-VG-MEDIUM': 4.22,
    'M-VS2-VG-POOR-MEDIUM': 4.22,
    'G-SI2-POOR-POOR-STRONG': 4.21,
    'M-VS1-GOOD-GOOD-STRONG': 4.21,
    'M-VS2-GOOD-GOOD-MEDIUM': 4.21,
    'M-SI1-POOR-VG-FAINT': 4.21,
    'M-SI1-VG-POOR-FAINT': 4.21,
    'M-SI2-POOR-VG-NONE': 4.21,
    'M-SI2-VG-POOR-NONE': 4.21,
    'G-I1-POOR-POOR-MEDIUM': 4.2,
    'G-I2-POOR-POOR-FAINT': 4.2,
    'M-SI1-GOOD-GOOD-FAINT': 4.2,
    'M-SI2-GOOD-GOOD-NONE': 4.2,
    'J-I1-POOR-EX-STRONG': 4.19,
    'J-I1-GOOD-VG-STRONG': 4.19,
    'J-I1-VG-GOOD-STRONG': 4.19,
    'J-I1-EX-POOR-STRONG': 4.19,
    'J-I2-POOR-EX-MEDIUM': 4.19,
    'J-I2-GOOD-VG-MEDIUM': 4.19,
    'J-I2-VG-GOOD-MEDIUM': 4.19,
    'J-I2-EX-POOR-MEDIUM': 4.19,
    'L-VS2-POOR-VG-STRONG': 4.19,
    'L-VS2-VG-POOR-STRONG': 4.19,
    'M-I2-EX-EX-STRONG': 4.19,
    'L-VS2-GOOD-GOOD-STRONG': 4.18,
    'L-SI1-POOR-VG-MEDIUM': 4.18,
    'L-SI1-VG-POOR-MEDIUM': 4.18,
    'L-SI2-POOR-VG-FAINT': 4.18,
    'L-SI2-VG-POOR-FAINT': 4.18,
    'F-I1-POOR-POOR-STRONG': 4.17,
    'F-I2-POOR-POOR-MEDIUM': 4.17,
    'I-I2-POOR-EX-STRONG': 4.17,
    'I-I2-GOOD-VG-STRONG': 4.17,
    'I-I2-VG-GOOD-STRONG': 4.17,
    'I-I2-EX-POOR-STRONG': 4.17,
    'L-SI1-GOOD-GOOD-MEDIUM': 4.17,
    'L-SI2-GOOD-GOOD-FAINT': 4.17,
    'L-I1-POOR-VG-NONE': 4.17,
    'L-I1-VG-POOR-NONE': 4.17,
    'K-SI1-POOR-VG-STRONG': 4.16,
    'K-SI1-VG-POOR-STRONG': 4.16,
    'K-SI2-POOR-VG-MEDIUM': 4.16,
    'K-SI2-VG-POOR-MEDIUM': 4.16,
    'L-I1-GOOD-GOOD-NONE': 4.16,
    'E-I2-POOR-POOR-STRONG': 4.15,
    'K-SI1-GOOD-GOOD-STRONG': 4.15,
    'K-SI2-GOOD-GOOD-MEDIUM': 4.15,
    'K-I1-POOR-VG-FAINT': 4.15,
    'K-I1-VG-POOR-FAINT': 4.15,
    'K-I2-POOR-VG-NONE': 4.15,
    'K-I2-VG-POOR-NONE': 4.15,
    'M-VVS2-POOR-GOOD-STRONG': 4.15,
    'M-VVS2-GOOD-POOR-STRONG': 4.15,
    'K-I1-GOOD-GOOD-FAINT': 4.14,
    'K-I2-GOOD-GOOD-NONE': 4.14,
    'M-VS1-POOR-GOOD-MEDIUM': 4.14,
    'M-VS1-GOOD-POOR-MEDIUM': 4.14,
    'M-VS2-POOR-GOOD-FAINT': 4.14,
    'M-VS2-GOOD-POOR-FAINT': 4.14,
    'J-SI2-POOR-VG-STRONG': 4.13,
    'J-SI2-VG-POOR-STRONG': 4.13,
    'M-SI1-POOR-GOOD-NONE': 4.13,
    'M-SI1-GOOD-POOR-NONE': 4.13,
    'J-SI2-GOOD-GOOD-STRONG': 4.12,
    'J-I1-POOR-VG-MEDIUM': 4.12,
    'J-I1-VG-POOR-MEDIUM': 4.12,
    'J-I2-POOR-VG-FAINT': 4.12,
    'J-I2-VG-POOR-FAINT': 4.12,
    'M-I1-VG-EX-STRONG': 4.12,
    'M-I1-EX-VG-STRONG': 4.12,
    'M-I2-VG-EX-MEDIUM': 4.12,
    'M-I2-EX-VG-MEDIUM': 4.12,
    'J-I1-GOOD-GOOD-MEDIUM': 4.11,
    'J-I2-GOOD-GOOD-FAINT': 4.11,
    'L-VS1-POOR-GOOD-STRONG': 4.11,
    'L-VS1-GOOD-POOR-STRONG': 4.11,
    'L-VS2-POOR-GOOD-MEDIUM': 4.11,
    'L-VS2-GOOD-POOR-MEDIUM': 4.11,
    'I-I1-POOR-VG-STRONG': 4.1,
    'I-I1-VG-POOR-STRONG': 4.1,
    'I-I2-POOR-VG-MEDIUM': 4.1,
    'I-I2-VG-POOR-MEDIUM': 4.1,
    'L-SI1-POOR-GOOD-FAINT': 4.1,
    'L-SI1-GOOD-POOR-FAINT': 4.1,
    'L-SI2-POOR-GOOD-NONE': 4.1,
    'L-SI2-GOOD-POOR-NONE': 4.1,
    'I-I1-GOOD-GOOD-STRONG': 4.09,
    'I-I2-GOOD-GOOD-MEDIUM': 4.09,
    'K-VS2-POOR-GOOD-STRONG': 4.09,
    'K-VS2-GOOD-POOR-STRONG': 4.09,
    'L-I2-VG-EX-STRONG': 4.09,
    'L-I2-EX-VG-STRONG': 4.09,
    'K-SI1-POOR-GOOD-MEDIUM': 4.08,
    'K-SI1-GOOD-POOR-MEDIUM': 4.08,
    'K-SI2-POOR-GOOD-FAINT': 4.08,
    'K-SI2-GOOD-POOR-FAINT': 4.08,
    'M-VVS1-POOR-POOR-STRONG': 4.08,
    'M-VVS2-POOR-POOR-MEDIUM': 4.08,
    'H-I2-POOR-VG-STRONG': 4.07,
    'H-I2-VG-POOR-STRONG': 4.07,
    'K-I1-POOR-GOOD-NONE': 4.07,
    'K-I1-GOOD-POOR-NONE': 4.07,
    'M-VS1-POOR-POOR-FAINT': 4.07,
    'M-VS2-POOR-POOR-NONE': 4.07,
    'H-I2-GOOD-GOOD-STRONG': 4.06,
    'M-SI2-VG-VG-STRONG': 4.06,
    'J-SI1-POOR-GOOD-STRONG': 4.05,
    'J-SI1-GOOD-POOR-STRONG': 4.05,
    'J-SI2-POOR-GOOD-MEDIUM': 4.05,
    'J-SI2-GOOD-POOR-MEDIUM': 4.05,
    'L-VVS2-POOR-POOR-STRONG': 4.05,
    'M-SI2-GOOD-EX-STRONG': 4.05,
    'M-SI2-EX-GOOD-STRONG': 4.05,
    'M-I1-VG-VG-MEDIUM': 4.05,
    'M-I2-VG-VG-FAINT': 4.05,
    'J-I1-POOR-GOOD-FAINT': 4.04,
    'J-I1-GOOD-POOR-FAINT': 4.04,
    'J-I2-POOR-GOOD-NONE': 4.04,
    'J-I2-GOOD-POOR-NONE': 4.04,
    'L-VS1-POOR-POOR-MEDIUM': 4.04,
    'L-VS2-POOR-POOR-FAINT': 4.04,
    'M-I1-GOOD-EX-MEDIUM': 4.04,
    'M-I1-EX-GOOD-MEDIUM': 4.04,
    'M-I2-GOOD-EX-FAINT': 4.04,
    'M-I2-EX-GOOD-FAINT': 4.04,
    'I-SI2-POOR-GOOD-STRONG': 4.03,
    'I-SI2-GOOD-POOR-STRONG': 4.03,
    'L-SI1-POOR-POOR-NONE': 4.03,
    'I-I1-POOR-GOOD-MEDIUM': 4.02,
    'I-I1-GOOD-POOR-MEDIUM': 4.02,
    'I-I2-POOR-GOOD-FAINT': 4.02,
    'I-I2-GOOD-POOR-FAINT': 4.02,
    'K-VS1-POOR-POOR-STRONG': 4.02,
    'K-VS2-POOR-POOR-MEDIUM': 4.02,
    'L-I1-VG-VG-STRONG': 4.02,
    'L-I2-VG-VG-MEDIUM': 4.02,
    'K-SI1-POOR-POOR-FAINT': 4.01,
    'K-SI2-POOR-POOR-NONE': 4.01,
    'L-I1-GOOD-EX-STRONG': 4.01,
    'L-I1-EX-GOOD-STRONG': 4.01,
    'L-I2-GOOD-EX-MEDIUM': 4.01,
    'L-I2-EX-GOOD-MEDIUM': 4.01,
    'K-I2-VG-VG-STRONG': 4.0,
    'H-I1-POOR-GOOD-STRONG': 3.99,
    'H-I1-GOOD-POOR-STRONG': 3.99,
    'H-I2-POOR-GOOD-MEDIUM': 3.99,
    'H-I2-GOOD-POOR-MEDIUM': 3.99,
    'J-VS2-POOR-POOR-STRONG': 3.99,
    'K-I2-GOOD-EX-STRONG': 3.99,
    'K-I2-EX-GOOD-STRONG': 3.99,
    'J-SI1-POOR-POOR-MEDIUM': 3.98,
    'J-SI2-POOR-POOR-FAINT': 3.98,
    'M-SI1-POOR-EX-STRONG': 3.98,
    'M-SI1-GOOD-VG-STRONG': 3.98,
    'M-SI1-VG-GOOD-STRONG': 3.98,
    'M-SI1-EX-POOR-STRONG': 3.98,
    'M-SI2-POOR-EX-MEDIUM': 3.98,
    'M-SI2-GOOD-VG-MEDIUM': 3.98,
    'M-SI2-VG-GOOD-MEDIUM': 3.98,
    'M-SI2-EX-POOR-MEDIUM': 3.98,
    'G-I2-POOR-GOOD-STRONG': 3.97,
    'G-I2-GOOD-POOR-STRONG': 3.97,
    'J-I1-POOR-POOR-NONE': 3.97,
    'M-I1-POOR-EX-FAINT': 3.97,
    'M-I1-GOOD-VG-FAINT': 3.97,
    'M-I1-VG-GOOD-FAINT': 3.97,
    'M-I1-EX-POOR-FAINT': 3.97,
    'M-I2-POOR-EX-NONE': 3.97,
    'M-I2-GOOD-VG-NONE': 3.97,
    'M-I2-VG-GOOD-NONE': 3.97,
    'M-I2-EX-POOR-NONE': 3.97,
    'I-SI1-POOR-POOR-STRONG': 3.96,
    'I-SI2-POOR-POOR-MEDIUM': 3.96,
    'I-I1-POOR-POOR-FAINT': 3.95,
    'I-I2-POOR-POOR-NONE': 3.95,
    'L-SI2-POOR-EX-STRONG': 3.95,
    'L-SI2-GOOD-VG-STRONG': 3.95,
    'L-SI2-VG-GOOD-STRONG': 3.95,
    'L-SI2-EX-POOR-STRONG': 3.95,
    'L-I1-POOR-EX-MEDIUM': 3.94,
    'L-I1-GOOD-VG-MEDIUM': 3.94,
    'L-I1-VG-GOOD-MEDIUM': 3.94,
    'L-I1-EX-POOR-MEDIUM': 3.94,
    'L-I2-POOR-EX-FAINT': 3.94,
    'L-I2-GOOD-VG-FAINT': 3.94,
    'L-I2-VG-GOOD-FAINT': 3.94,
    'L-I2-EX-POOR-FAINT': 3.94,
    'H-SI2-POOR-POOR-STRONG': 3.93,
    'H-I1-POOR-POOR-MEDIUM': 3.92,
    'H-I2-POOR-POOR-FAINT': 3.92,
    'K-I1-POOR-EX-STRONG': 3.92,
    'K-I1-GOOD-VG-STRONG': 3.92,
    'K-I1-VG-GOOD-STRONG': 3.92,
    'K-I1-EX-POOR-STRONG': 3.92,
    'K-I2-POOR-EX-MEDIUM': 3.92,
    'K-I2-GOOD-VG-MEDIUM': 3.92,
    'K-I2-VG-GOOD-MEDIUM': 3.92,
    'K-I2-EX-POOR-MEDIUM': 3.92,
    'M-VS2-POOR-VG-STRONG': 3.92,
    'M-VS2-VG-POOR-STRONG': 3.92,
    'M-VS2-GOOD-GOOD-STRONG': 3.91,
    'M-SI1-POOR-VG-MEDIUM': 3.91,
    'M-SI1-VG-POOR-MEDIUM': 3.91,
    'M-SI2-POOR-VG-FAINT': 3.91,
    'M-SI2-VG-POOR-FAINT': 3.91,
    'G-I1-POOR-POOR-STRONG': 3.9,
    'G-I2-POOR-POOR-MEDIUM': 3.9,
    'M-SI1-GOOD-GOOD-MEDIUM': 3.9,
    'M-SI2-GOOD-GOOD-FAINT': 3.9,
    'M-I1-POOR-VG-NONE': 3.9,
    'M-I1-VG-POOR-NONE': 3.9,
    'J-I2-POOR-EX-STRONG': 3.89,
    'J-I2-GOOD-VG-STRONG': 3.89,
    'J-I2-VG-GOOD-STRONG': 3.89,
    'J-I2-EX-POOR-STRONG': 3.89,
    'M-I1-GOOD-GOOD-NONE': 3.89,
    'L-SI1-POOR-VG-STRONG': 3.88,
    'L-SI1-VG-POOR-STRONG': 3.88,
    'L-SI2-POOR-VG-MEDIUM': 3.88,
    'L-SI2-VG-POOR-MEDIUM': 3.88,
    'F-I2-POOR-POOR-STRONG': 3.87,
    'L-SI1-GOOD-GOOD-STRONG': 3.87,
    'L-SI2-GOOD-GOOD-MEDIUM': 3.87,
    'L-I1-POOR-VG-FAINT': 3.87,
    'L-I1-VG-POOR-FAINT': 3.87,
    'L-I2-POOR-VG-NONE': 3.87,
    'L-I2-VG-POOR-NONE': 3.87,
    'K-SI2-POOR-VG-STRONG': 3.86,
    'K-SI2-VG-POOR-STRONG': 3.86,
    'L-I1-GOOD-GOOD-FAINT': 3.86,
    'L-I2-GOOD-GOOD-NONE': 3.86,
    'K-SI2-GOOD-GOOD-STRONG': 3.85,
    'K-I1-POOR-VG-MEDIUM': 3.85,
    'K-I1-VG-POOR-MEDIUM': 3.85,
    'K-I2-POOR-VG-FAINT': 3.85,
    'K-I2-VG-POOR-FAINT': 3.85,
    'K-I1-GOOD-GOOD-MEDIUM': 3.84,
    'K-I2-GOOD-GOOD-FAINT': 3.84,
    'M-VS1-POOR-GOOD-STRONG': 3.84,
    'M-VS1-GOOD-POOR-STRONG': 3.84,
    'M-VS2-POOR-GOOD-MEDIUM': 3.84,
    'M-VS2-GOOD-POOR-MEDIUM': 3.84,
    'M-SI1-POOR-GOOD-FAINT': 3.83,
    'M-SI1-GOOD-POOR-FAINT': 3.83,
    'M-SI2-POOR-GOOD-NONE': 3.83,
    'M-SI2-GOOD-POOR-NONE': 3.83,
    'J-I1-POOR-VG-STRONG': 3.82,
    'J-I1-VG-POOR-STRONG': 3.82,
    'J-I2-POOR-VG-MEDIUM': 3.82,
    'J-I2-VG-POOR-MEDIUM': 3.82,
    'M-I2-VG-EX-STRONG': 3.82,
    'M-I2-EX-VG-STRONG': 3.82,
    'J-I1-GOOD-GOOD-STRONG': 3.81,
    'J-I2-GOOD-GOOD-MEDIUM': 3.81,
    'L-VS2-POOR-GOOD-STRONG': 3.81,
    'L-VS2-GOOD-POOR-STRONG': 3.81,
    'I-I2-POOR-VG-STRONG': 3.8,
    'I-I2-VG-POOR-STRONG': 3.8,
    'L-SI1-POOR-GOOD-MEDIUM': 3.8,
    'L-SI1-GOOD-POOR-MEDIUM': 3.8,
    'L-SI2-POOR-GOOD-FAINT': 3.8,
    'L-SI2-GOOD-POOR-FAINT': 3.8,
    'I-I2-GOOD-GOOD-STRONG': 3.79,
    'L-I1-POOR-GOOD-NONE': 3.79,
    'L-I1-GOOD-POOR-NONE': 3.79,
    'K-SI1-POOR-GOOD-STRONG': 3.78,
    'K-SI1-GOOD-POOR-STRONG': 3.78,
    'K-SI2-POOR-GOOD-MEDIUM': 3.78,
    'K-SI2-GOOD-POOR-MEDIUM': 3.78,
    'M-VVS2-POOR-POOR-STRONG': 3.78,
    'K-I1-POOR-GOOD-FAINT': 3.77,
    'K-I1-GOOD-POOR-FAINT': 3.77,
    'K-I2-POOR-GOOD-NONE': 3.77,
    'K-I2-GOOD-POOR-NONE': 3.77,
    'M-VS1-POOR-POOR-MEDIUM': 3.77,
    'M-VS2-POOR-POOR-FAINT': 3.77,
    'M-SI1-POOR-POOR-NONE': 3.76,
    'J-SI2-POOR-GOOD-STRONG': 3.75,
    'J-SI2-GOOD-POOR-STRONG': 3.75,
    'M-I1-VG-VG-STRONG': 3.75,
    'M-I2-VG-VG-MEDIUM': 3.75,
    'J-I1-POOR-GOOD-MEDIUM': 3.74,
    'J-I1-GOOD-POOR-MEDIUM': 3.74,
    'J-I2-POOR-GOOD-FAINT': 3.74,
    'J-I2-GOOD-POOR-FAINT': 3.74,
    'L-VS1-POOR-POOR-STRONG': 3.74,
    'L-VS2-POOR-POOR-MEDIUM': 3.74,
    'M-I1-GOOD-EX-STRONG': 3.74,
    'M-I1-EX-GOOD-STRONG': 3.74,
    'M-I2-GOOD-EX-MEDIUM': 3.74,
    'M-I2-EX-GOOD-MEDIUM': 3.74,
    'L-SI1-POOR-POOR-FAINT': 3.73,
    'L-SI2-POOR-POOR-NONE': 3.73,
    'I-I1-POOR-GOOD-STRONG': 3.72,
    'I-I1-GOOD-POOR-STRONG': 3.72,
    'I-I2-POOR-GOOD-MEDIUM': 3.72,
    'I-I2-GOOD-POOR-MEDIUM': 3.72,
    'K-VS2-POOR-POOR-STRONG': 3.72,
    'L-I2-VG-VG-STRONG': 3.72,
    'K-SI1-POOR-POOR-MEDIUM': 3.71,
    'K-SI2-POOR-POOR-FAINT': 3.71,
    'L-I2-GOOD-EX-STRONG': 3.71,
    'L-I2-EX-GOOD-STRONG': 3.71,
    'K-I1-POOR-POOR-NONE': 3.7,
    'H-I2-POOR-GOOD-STRONG': 3.69,
    'H-I2-GOOD-POOR-STRONG': 3.69,
    'J-SI1-POOR-POOR-STRONG': 3.68,
    'J-SI2-POOR-POOR-MEDIUM': 3.68,
    'M-SI2-POOR-EX-STRONG': 3.68,
    'M-SI2-GOOD-VG-STRONG': 3.68,
    'M-SI2-VG-GOOD-STRONG': 3.68,
    'M-SI2-EX-POOR-STRONG': 3.68,
    'J-I1-POOR-POOR-FAINT': 3.67,
    'J-I2-POOR-POOR-NONE': 3.67,
    'M-I1-POOR-EX-MEDIUM': 3.67,
    'M-I1-GOOD-VG-MEDIUM': 3.67,
    'M-I1-VG-GOOD-MEDIUM': 3.67,
    'M-I1-EX-POOR-MEDIUM': 3.67,
    'M-I2-POOR-EX-FAINT': 3.67,
    'M-I2-GOOD-VG-FAINT': 3.67,
    'M-I2-VG-GOOD-FAINT': 3.67,
    'M-I2-EX-POOR-FAINT': 3.67,
    'I-SI2-POOR-POOR-STRONG': 3.66,
    'I-I1-POOR-POOR-MEDIUM': 3.65,
    'I-I2-POOR-POOR-FAINT': 3.65,
    'L-I1-POOR-EX-STRONG': 3.64,
    'L-I1-GOOD-VG-STRONG': 3.64,
    'L-I1-VG-GOOD-STRONG': 3.64,
    'L-I1-EX-POOR-STRONG': 3.64,
    'L-I2-POOR-EX-MEDIUM': 3.64,
    'L-I2-GOOD-VG-MEDIUM': 3.64,
    'L-I2-VG-GOOD-MEDIUM': 3.64,
    'L-I2-EX-POOR-MEDIUM': 3.64,
    'H-I1-POOR-POOR-STRONG': 3.62,
    'H-I2-POOR-POOR-MEDIUM': 3.62,
    'K-I2-POOR-EX-STRONG': 3.62,
    'K-I2-GOOD-VG-STRONG': 3.62,
    'K-I2-VG-GOOD-STRONG': 3.62,
    'K-I2-EX-POOR-STRONG': 3.62,
    'M-SI1-POOR-VG-STRONG': 3.61,
    'M-SI1-VG-POOR-STRONG': 3.61,
    'M-SI2-POOR-VG-MEDIUM': 3.61,
    'M-SI2-VG-POOR-MEDIUM': 3.61,
    'G-I2-POOR-POOR-STRONG': 3.6,
    'M-SI1-GOOD-GOOD-STRONG': 3.6,
    'M-SI2-GOOD-GOOD-MEDIUM': 3.6,
    'M-I1-POOR-VG-FAINT': 3.6,
    'M-I1-VG-POOR-FAINT': 3.6,
    'M-I2-POOR-VG-NONE': 3.6,
    'M-I2-VG-POOR-NONE': 3.6,
    'M-I1-GOOD-GOOD-FAINT': 3.59,
    'M-I2-GOOD-GOOD-NONE': 3.59,
    'L-SI2-POOR-VG-STRONG': 3.58,
    'L-SI2-VG-POOR-STRONG': 3.58,
    'L-SI2-GOOD-GOOD-STRONG': 3.57,
    'L-I1-POOR-VG-MEDIUM': 3.57,
    'L-I1-VG-POOR-MEDIUM': 3.57,
    'L-I2-POOR-VG-FAINT': 3.57,
    'L-I2-VG-POOR-FAINT': 3.57,
    'L-I1-GOOD-GOOD-MEDIUM': 3.56,
    'L-I2-GOOD-GOOD-FAINT': 3.56,
    'K-I1-POOR-VG-STRONG': 3.55,
    'K-I1-VG-POOR-STRONG': 3.55,
    'K-I2-POOR-VG-MEDIUM': 3.55,
    'K-I2-VG-POOR-MEDIUM': 3.55,
    'K-I1-GOOD-GOOD-STRONG': 3.54,
    'K-I2-GOOD-GOOD-MEDIUM': 3.54,
    'M-VS2-POOR-GOOD-STRONG': 3.54,
    'M-VS2-GOOD-POOR-STRONG': 3.54,
    'M-SI1-POOR-GOOD-MEDIUM': 3.53,
    'M-SI1-GOOD-POOR-MEDIUM': 3.53,
    'M-SI2-POOR-GOOD-FAINT': 3.53,
    'M-SI2-GOOD-POOR-FAINT': 3.53,
    'J-I2-POOR-VG-STRONG': 3.52,
    'J-I2-VG-POOR-STRONG': 3.52,
    'M-I1-POOR-GOOD-NONE': 3.52,
    'M-I1-GOOD-POOR-NONE': 3.52,
    'J-I2-GOOD-GOOD-STRONG': 3.51,
    'L-SI1-POOR-GOOD-STRONG': 3.5,
    'L-SI1-GOOD-POOR-STRONG': 3.5,
    'L-SI2-POOR-GOOD-MEDIUM': 3.5,
    'L-SI2-GOOD-POOR-MEDIUM': 3.5,
    'L-I1-POOR-GOOD-FAINT': 3.49,
    'L-I1-GOOD-POOR-FAINT': 3.49,
    'L-I2-POOR-GOOD-NONE': 3.49,
    'L-I2-GOOD-POOR-NONE': 3.49,
    'K-SI2-POOR-GOOD-STRONG': 3.48,
    'K-SI2-GOOD-POOR-STRONG': 3.48,
    'K-I1-POOR-GOOD-MEDIUM': 3.47,
    'K-I1-GOOD-POOR-MEDIUM': 3.47,
    'K-I2-POOR-GOOD-FAINT': 3.47,
    'K-I2-GOOD-POOR-FAINT': 3.47,
    'M-VS1-POOR-POOR-STRONG': 3.47,
    'M-VS2-POOR-POOR-MEDIUM': 3.47,
    'M-SI1-POOR-POOR-FAINT': 3.46,
    'M-SI2-POOR-POOR-NONE': 3.46,
    'M-I2-VG-VG-STRONG': 3.45,
    'J-I1-POOR-GOOD-STRONG': 3.44,
    'J-I1-GOOD-POOR-STRONG': 3.44,
    'J-I2-POOR-GOOD-MEDIUM': 3.44,
    'J-I2-GOOD-POOR-MEDIUM': 3.44,
    'L-VS2-POOR-POOR-STRONG': 3.44,
    'M-I2-GOOD-EX-STRONG': 3.44,
    'M-I2-EX-GOOD-STRONG': 3.44,
    'L-SI1-POOR-POOR-MEDIUM': 3.43,
    'L-SI2-POOR-POOR-FAINT': 3.43,
    'I-I2-POOR-GOOD-STRONG': 3.42,
    'I-I2-GOOD-POOR-STRONG': 3.42,
    'L-I1-POOR-POOR-NONE': 3.42,
    'K-SI1-POOR-POOR-STRONG': 3.41,
    'K-SI2-POOR-POOR-MEDIUM': 3.41,
    'K-I1-POOR-POOR-FAINT': 3.4,
    'K-I2-POOR-POOR-NONE': 3.4,
    'J-SI2-POOR-POOR-STRONG': 3.38,
    'J-I1-POOR-POOR-MEDIUM': 3.37,
    'J-I2-POOR-POOR-FAINT': 3.37,
    'M-I1-POOR-EX-STRONG': 3.37,
    'M-I1-GOOD-VG-STRONG': 3.37,
    'M-I1-VG-GOOD-STRONG': 3.37,
    'M-I1-EX-POOR-STRONG': 3.37,
    'M-I2-POOR-EX-MEDIUM': 3.37,
    'M-I2-GOOD-VG-MEDIUM': 3.37,
    'M-I2-VG-GOOD-MEDIUM': 3.37,
    'M-I2-EX-POOR-MEDIUM': 3.37,
    'I-I1-POOR-POOR-STRONG': 3.35,
    'I-I2-POOR-POOR-MEDIUM': 3.35,
    'L-I2-POOR-EX-STRONG': 3.34,
    'L-I2-GOOD-VG-STRONG': 3.34,
    'L-I2-VG-GOOD-STRONG': 3.34,
    'L-I2-EX-POOR-STRONG': 3.34,
    'H-I2-POOR-POOR-STRONG': 3.32,
    'M-SI2-POOR-VG-STRONG': 3.31,
    'M-SI2-VG-POOR-STRONG': 3.31,
    'M-SI2-GOOD-GOOD-STRONG': 3.3,
    'M-I1-POOR-VG-MEDIUM': 3.3,
    'M-I1-VG-POOR-MEDIUM': 3.3,
    'M-I2-POOR-VG-FAINT': 3.3,
    'M-I2-VG-POOR-FAINT': 3.3,
    'M-I1-GOOD-GOOD-MEDIUM': 3.29,
    'M-I2-GOOD-GOOD-FAINT': 3.29,
    'L-I1-POOR-VG-STRONG': 3.27,
    'L-I1-VG-POOR-STRONG': 3.27,
    'L-I2-POOR-VG-MEDIUM': 3.27,
    'L-I2-VG-POOR-MEDIUM': 3.27,
    'L-I1-GOOD-GOOD-STRONG': 3.26,
    'L-I2-GOOD-GOOD-MEDIUM': 3.26,
    'K-I2-POOR-VG-STRONG': 3.25,
    'K-I2-VG-POOR-STRONG': 3.25,
    'K-I2-GOOD-GOOD-STRONG': 3.24,
    'M-SI1-POOR-GOOD-STRONG': 3.23,
    'M-SI1-GOOD-POOR-STRONG': 3.23,
    'M-SI2-POOR-GOOD-MEDIUM': 3.23,
    'M-SI2-GOOD-POOR-MEDIUM': 3.23,
    'M-I1-POOR-GOOD-FAINT': 3.22,
    'M-I1-GOOD-POOR-FAINT': 3.22,
    'M-I2-POOR-GOOD-NONE': 3.22,
    'M-I2-GOOD-POOR-NONE': 3.22,
    'L-SI2-POOR-GOOD-STRONG': 3.2,
    'L-SI2-GOOD-POOR-STRONG': 3.2,
    'L-I1-POOR-GOOD-MEDIUM': 3.19,
    'L-I1-GOOD-POOR-MEDIUM': 3.19,
    'L-I2-POOR-GOOD-FAINT': 3.19,
    'L-I2-GOOD-POOR-FAINT': 3.19,
    'K-I1-POOR-GOOD-STRONG': 3.17,
    'K-I1-GOOD-POOR-STRONG': 3.17,
    'K-I2-POOR-GOOD-MEDIUM': 3.17,
    'K-I2-GOOD-POOR-MEDIUM': 3.17,
    'M-VS2-POOR-POOR-STRONG': 3.17,
    'M-SI1-POOR-POOR-MEDIUM': 3.16,
    'M-SI2-POOR-POOR-FAINT': 3.16,
    'M-I1-POOR-POOR-NONE': 3.15,
    'J-I2-POOR-GOOD-STRONG': 3.14,
    'J-I2-GOOD-POOR-STRONG': 3.14,
    'L-SI1-POOR-POOR-STRONG': 3.13,
    'L-SI2-POOR-POOR-MEDIUM': 3.13,
    'L-I1-POOR-POOR-FAINT': 3.12,
    'L-I2-POOR-POOR-NONE': 3.12,
    'K-SI2-POOR-POOR-STRONG': 3.11,
    'K-I1-POOR-POOR-MEDIUM': 3.1,
    'K-I2-POOR-POOR-FAINT': 3.1,
    'J-I1-POOR-POOR-STRONG': 3.07,
    'J-I2-POOR-POOR-MEDIUM': 3.07,
    'M-I2-POOR-EX-STRONG': 3.07,
    'M-I2-GOOD-VG-STRONG': 3.07,
    'M-I2-VG-GOOD-STRONG': 3.07,
    'M-I2-EX-POOR-STRONG': 3.07,
    'I-I2-POOR-POOR-STRONG': 3.05,
    'M-I1-POOR-VG-STRONG': 3.0,
    'M-I1-VG-POOR-STRONG': 3.0,
    'M-I2-POOR-VG-MEDIUM': 3.0,
    'M-I2-VG-POOR-MEDIUM': 3.0,
    'M-I1-GOOD-GOOD-STRONG': 2.99,
    'M-I2-GOOD-GOOD-MEDIUM': 2.99,
    'L-I2-POOR-VG-STRONG': 2.97,
    'L-I2-VG-POOR-STRONG': 2.97,
    'L-I2-GOOD-GOOD-STRONG': 2.96,
    'M-SI2-POOR-GOOD-STRONG': 2.93,
    'M-SI2-GOOD-POOR-STRONG': 2.93,
    'M-I1-POOR-GOOD-MEDIUM': 2.92,
    'M-I1-GOOD-POOR-MEDIUM': 2.92,
    'M-I2-POOR-GOOD-FAINT': 2.92,
    'M-I2-GOOD-POOR-FAINT': 2.92,
    'L-I1-POOR-GOOD-STRONG': 2.89,
    'L-I1-GOOD-POOR-STRONG': 2.89,
    'L-I2-POOR-GOOD-MEDIUM': 2.89,
    'L-I2-GOOD-POOR-MEDIUM': 2.89,
    'K-I2-POOR-GOOD-STRONG': 2.87,
    'K-I2-GOOD-POOR-STRONG': 2.87,
    'M-SI1-POOR-POOR-STRONG': 2.86,
    'M-SI2-POOR-POOR-MEDIUM': 2.86,
    'M-I1-POOR-POOR-FAINT': 2.85,
    'M-I2-POOR-POOR-NONE': 2.85,
    'L-SI2-POOR-POOR-STRONG': 2.83,
    'L-I1-POOR-POOR-MEDIUM': 2.82,
    'L-I2-POOR-POOR-FAINT': 2.82,
    'K-I1-POOR-POOR-STRONG': 2.8,
    'K-I2-POOR-POOR-MEDIUM': 2.8,
    'J-I2-POOR-POOR-STRONG': 2.77,
    'M-I2-POOR-VG-STRONG': 2.7,
    'M-I2-VG-POOR-STRONG': 2.7,
    'M-I2-GOOD-GOOD-STRONG': 2.69,
    'M-I1-POOR-GOOD-STRONG': 2.62,
    'M-I1-GOOD-POOR-STRONG': 2.62,
    'M-I2-POOR-GOOD-MEDIUM': 2.62,
    'M-I2-GOOD-POOR-MEDIUM': 2.62,
    'L-I2-POOR-GOOD-STRONG': 2.59,
    'L-I2-GOOD-POOR-STRONG': 2.59,
    'M-SI2-POOR-POOR-STRONG': 2.56,
    'M-I1-POOR-POOR-MEDIUM': 2.55,
    'M-I2-POOR-POOR-FAINT': 2.55,
    'L-I1-POOR-POOR-STRONG': 2.52,
    'L-I2-POOR-POOR-MEDIUM': 2.52,
    'K-I2-POOR-POOR-STRONG': 2.5,
    'M-I2-POOR-GOOD-STRONG': 2.32,
    'M-I2-GOOD-POOR-STRONG': 2.32,
    'M-I1-POOR-POOR-STRONG': 2.25,
    'M-I2-POOR-POOR-MEDIUM': 2.25,
    'L-I2-POOR-POOR-STRONG': 2.22,
    'M-I2-POOR-POOR-STRONG': 1.95
  };

  // ROUND DIAMONDS GRADING TABLE
  // Key format: COLOR-CLARITY-SYMMETRY-POLISH-FLUORESCENCE-CUT
  // Uses individual colors (D, E, F, etc.) and clarities (IF, VVS1, VVS2, etc.)
  window.ROUND_GRADING_TABLE = {
    'D-IF-EX-EX-NONE-EX': 10,
    'D-IF-EX-EX-FAINT-EX': 9.8,
    'E-IF-EX-EX-NONE-EX': 9.8,
    'D-VVS1-EX-EX-NONE-EX': 9.78,
    'D-IF-EX-VG-NONE-EX': 9.75,
    'D-IF-VG-EX-NONE-EX': 9.75,
    'D-IF-EX-EX-MEDIUM-EX': 9.6,
    'E-IF-EX-EX-FAINT-EX': 9.6,
    'F-IF-EX-EX-NONE-EX': 9.6,
    'D-VVS1-EX-EX-FAINT-EX': 9.58,
    'E-VVS1-EX-EX-NONE-EX': 9.58,
    'D-VVS2-EX-EX-NONE-EX': 9.56,
    'D-IF-VG-EX-FAINT-EX': 9.55,
    'D-IF-EX-VG-FAINT-EX': 9.55,
    'E-IF-VG-EX-NONE-EX': 9.55,
    'E-IF-EX-VG-NONE-EX': 9.55,
    'D-VVS1-EX-VG-NONE-EX': 9.53,
    'D-VVS1-VG-EX-NONE-EX': 9.53,
    'D-IF-EX-GOOD-NONE-EX': 9.5,
    'D-IF-VG-VG-NONE-EX': 9.5,
    'D-IF-GOOD-EX-NONE-EX': 9.5,
    'D-IF-EX-EX-STRONG-EX': 9.4,
    'E-IF-EX-EX-MEDIUM-EX': 9.4,
    'F-IF-EX-EX-FAINT-EX': 9.4,
    'G-IF-EX-EX-NONE-EX': 9.4,
    'D-VVS1-EX-EX-MEDIUM-EX': 9.38,
    'E-VVS1-EX-EX-FAINT-EX': 9.38,
    'F-VVS1-EX-EX-NONE-EX': 9.38,
    'D-VVS2-EX-EX-FAINT-EX': 9.36,
    'E-VVS2-EX-EX-NONE-EX': 9.36,
    'D-IF-EX-VG-MEDIUM-EX': 9.35,
    'D-IF-VG-EX-MEDIUM-EX': 9.35,
    'E-IF-EX-VG-FAINT-EX': 9.35,
    'E-IF-VG-EX-FAINT-EX': 9.35,
    'F-IF-VG-EX-NONE-EX': 9.35,
    'F-IF-EX-VG-NONE-EX': 9.35,
    'D-VVS1-EX-VG-FAINT-EX': 9.33,
    'D-VVS1-VG-EX-FAINT-EX': 9.33,
    'D-VS1-EX-EX-NONE-EX': 9.33,
    'E-VVS1-EX-VG-NONE-EX': 9.33,
    'E-VVS1-VG-EX-NONE-EX': 9.33,
    'D-VVS2-VG-EX-NONE-EX': 9.31,
    'D-VVS2-EX-VG-NONE-EX': 9.31,
    'D-IF-VG-VG-FAINT-EX': 9.3,
    'D-IF-GOOD-EX-FAINT-EX': 9.3,
    'D-IF-EX-GOOD-FAINT-EX': 9.3,
    'E-IF-EX-GOOD-NONE-EX': 9.3,
    'E-IF-VG-VG-NONE-EX': 9.3,
    'E-IF-GOOD-EX-NONE-EX': 9.3,
    'D-VVS1-EX-GOOD-NONE-EX': 9.28,
    'D-VVS1-GOOD-EX-NONE-EX': 9.28,
    'D-VVS1-VG-VG-NONE-EX': 9.28,
    'D-IF-EX-EX-NONE-VG': 9.25,
    'D-IF-VG-GOOD-NONE-EX': 9.25,
    'D-IF-GOOD-VG-NONE-EX': 9.25,
    'D-IF-EX-POOR-NONE-EX': 9.25,
    'D-IF-POOR-EX-NONE-EX': 9.25,
    'E-IF-EX-EX-STRONG-EX': 9.2,
    'F-IF-EX-EX-MEDIUM-EX': 9.2,
    'G-IF-EX-EX-FAINT-EX': 9.2,
    'H-IF-EX-EX-NONE-EX': 9.2,
    'D-VVS1-EX-EX-STRONG-EX': 9.18,
    'E-VVS1-EX-EX-MEDIUM-EX': 9.18,
    'F-VVS1-EX-EX-FAINT-EX': 9.18,
    'G-VVS1-EX-EX-NONE-EX': 9.18,
    'D-VVS2-EX-EX-MEDIUM-EX': 9.16,
    'E-VVS2-EX-EX-FAINT-EX': 9.16,
    'F-VVS2-EX-EX-NONE-EX': 9.16,
    'D-IF-EX-VG-STRONG-EX': 9.15,
    'D-IF-VG-EX-STRONG-EX': 9.15,
    'E-IF-EX-VG-MEDIUM-EX': 9.15,
    'E-IF-VG-EX-MEDIUM-EX': 9.15,
    'F-IF-VG-EX-FAINT-EX': 9.15,
    'F-IF-EX-VG-FAINT-EX': 9.15,
    'G-IF-VG-EX-NONE-EX': 9.15,
    'G-IF-EX-VG-NONE-EX': 9.15,
    'D-VS1-EX-EX-FAINT-EX': 9.13,
    'D-VVS1-EX-VG-MEDIUM-EX': 9.13,
    'D-VVS1-VG-EX-MEDIUM-EX': 9.13,
    'E-VS1-EX-EX-NONE-EX': 9.13,
    'E-VVS1-EX-VG-FAINT-EX': 9.13,
    'E-VVS1-VG-EX-FAINT-EX': 9.13,
    'F-VVS1-EX-VG-NONE-EX': 9.13,
    'F-VVS1-VG-EX-NONE-EX': 9.13,
    'D-VS2-EX-EX-NONE-EX': 9.11,
    'D-VVS2-VG-EX-FAINT-EX': 9.11,
    'D-VVS2-EX-VG-FAINT-EX': 9.11,
    'E-VVS2-EX-VG-NONE-EX': 9.11,
    'E-VVS2-VG-EX-NONE-EX': 9.11,
    'D-IF-EX-GOOD-MEDIUM-EX': 9.1,
    'D-IF-VG-VG-MEDIUM-EX': 9.1,
    'D-IF-GOOD-EX-MEDIUM-EX': 9.1,
    'E-IF-GOOD-EX-FAINT-EX': 9.1,
    'E-IF-VG-VG-FAINT-EX': 9.1,
    'E-IF-EX-GOOD-FAINT-EX': 9.1,
    'F-IF-VG-VG-NONE-EX': 9.1,
    'F-IF-EX-GOOD-NONE-EX': 9.1,
    'F-IF-GOOD-EX-NONE-EX': 9.1,
    'D-VVS1-EX-GOOD-FAINT-EX': 9.08,
    'D-VVS1-VG-VG-FAINT-EX': 9.08,
    'D-VVS1-GOOD-EX-FAINT-EX': 9.08,
    'D-VS1-VG-EX-NONE-EX': 9.08,
    'D-VS1-EX-VG-NONE-EX': 9.08,
    'E-VVS1-GOOD-EX-NONE-EX': 9.08,
    'E-VVS1-EX-GOOD-NONE-EX': 9.08,
    'E-VVS1-VG-VG-NONE-EX': 9.08,
    'D-VVS2-GOOD-EX-NONE-EX': 9.06,
    'D-VVS2-VG-VG-NONE-EX': 9.06,
    'D-VVS2-EX-GOOD-NONE-EX': 9.06,
    'D-IF-POOR-EX-FAINT-EX': 9.05,
    'D-IF-GOOD-VG-FAINT-EX': 9.05,
    'D-IF-VG-GOOD-FAINT-EX': 9.05,
    'D-IF-EX-POOR-FAINT-EX': 9.05,
    'D-IF-EX-EX-FAINT-VG': 9.05,
    'E-IF-EX-POOR-NONE-EX': 9.05,
    'E-IF-VG-GOOD-NONE-EX': 9.05,
    'E-IF-GOOD-VG-NONE-EX': 9.05,
    'E-IF-POOR-EX-NONE-EX': 9.05,
    'E-IF-EX-EX-NONE-VG': 9.05,
    'D-VVS1-GOOD-VG-NONE-EX': 9.03,
    'D-VVS1-POOR-EX-NONE-EX': 9.03,
    'D-VVS1-VG-GOOD-NONE-EX': 9.03,
    'D-VVS1-EX-POOR-NONE-EX': 9.03,
    'D-VVS1-EX-EX-NONE-VG': 9.03,
    'D-IF-EX-VG-NONE-VG': 9,
    'D-IF-POOR-VG-NONE-EX': 9,
    'D-IF-GOOD-GOOD-NONE-EX': 9,
    'D-IF-VG-POOR-NONE-EX': 9,
    'D-IF-VG-EX-NONE-VG': 9,
    'F-IF-EX-EX-STRONG-EX': 9,
    'G-IF-EX-EX-MEDIUM-EX': 9,
    'H-IF-EX-EX-FAINT-EX': 9,
    'I-IF-EX-EX-NONE-EX': 9,
    'E-VVS1-EX-EX-STRONG-EX': 8.98,
    'F-VVS1-EX-EX-MEDIUM-EX': 8.98,
    'G-VVS1-EX-EX-FAINT-EX': 8.98,
    'H-VVS1-EX-EX-NONE-EX': 8.98,
    'D-VVS2-EX-EX-STRONG-EX': 8.96,
    'E-VVS2-EX-EX-MEDIUM-EX': 8.96,
    'F-VVS2-EX-EX-FAINT-EX': 8.96,
    'G-VVS2-EX-EX-NONE-EX': 8.96,
    'E-IF-EX-VG-STRONG-EX': 8.95,
    'E-IF-VG-EX-STRONG-EX': 8.95,
    'F-IF-VG-EX-MEDIUM-EX': 8.95,
    'F-IF-EX-VG-MEDIUM-EX': 8.95,
    'G-IF-EX-VG-FAINT-EX': 8.95,
    'G-IF-VG-EX-FAINT-EX': 8.95,
    'H-IF-VG-EX-NONE-EX': 8.95,
    'H-IF-EX-VG-NONE-EX': 8.95,
    'D-VS1-EX-EX-MEDIUM-EX': 8.93,
    'D-VVS1-VG-EX-STRONG-EX': 8.93,
    'D-VVS1-EX-VG-STRONG-EX': 8.93,
    'E-VS1-EX-EX-FAINT-EX': 8.93,
    'E-VVS1-VG-EX-MEDIUM-EX': 8.93,
    'E-VVS1-EX-VG-MEDIUM-EX': 8.93,
    'F-VS1-EX-EX-NONE-EX': 8.93,
    'F-VVS1-VG-EX-FAINT-EX': 8.93,
    'F-VVS1-EX-VG-FAINT-EX': 8.93,
    'G-VVS1-EX-VG-NONE-EX': 8.93,
    'G-VVS1-VG-EX-NONE-EX': 8.93,
    'D-VS2-EX-EX-FAINT-EX': 8.91,
    'D-VVS2-EX-VG-MEDIUM-EX': 8.91,
    'D-VVS2-VG-EX-MEDIUM-EX': 8.91,
    'E-VVS2-EX-VG-FAINT-EX': 8.91,
    'E-VVS2-VG-EX-FAINT-EX': 8.91,
    'E-VS2-EX-EX-NONE-EX': 8.91,
    'F-VVS2-VG-EX-NONE-EX': 8.91,
    'F-VVS2-EX-VG-NONE-EX': 8.91,
    'D-IF-GOOD-EX-STRONG-EX': 8.9,
    'D-IF-EX-GOOD-STRONG-EX': 8.9,
    'D-IF-VG-VG-STRONG-EX': 8.9,
    'E-IF-VG-VG-MEDIUM-EX': 8.9,
    'E-IF-EX-GOOD-MEDIUM-EX': 8.9,
    'E-IF-GOOD-EX-MEDIUM-EX': 8.9,
    'F-IF-GOOD-EX-FAINT-EX': 8.9,
    'F-IF-VG-VG-FAINT-EX': 8.9,
    'F-IF-EX-GOOD-FAINT-EX': 8.9,
    'G-IF-GOOD-EX-NONE-EX': 8.9,
    'G-IF-EX-GOOD-NONE-EX': 8.9,
    'G-IF-VG-VG-NONE-EX': 8.9,
    'D-SI1-EX-EX-NONE-EX': 8.89,
    'D-VS1-EX-VG-FAINT-EX': 8.88,
    'D-VS1-VG-EX-FAINT-EX': 8.88,
    'D-VVS1-EX-GOOD-MEDIUM-EX': 8.88,
    'D-VVS1-GOOD-EX-MEDIUM-EX': 8.88,
    'D-VVS1-VG-VG-MEDIUM-EX': 8.88,
    'E-VVS1-VG-VG-FAINT-EX': 8.88,
    'E-VVS1-GOOD-EX-FAINT-EX': 8.88,
    'E-VS1-VG-EX-NONE-EX': 8.88,
    'E-VS1-EX-VG-NONE-EX': 8.88,
    'E-VVS1-EX-GOOD-FAINT-EX': 8.88,
    'F-VVS1-EX-GOOD-NONE-EX': 8.88,
    'F-VVS1-VG-VG-NONE-EX': 8.88,
    'F-VVS1-GOOD-EX-NONE-EX': 8.88,
    'D-VS2-EX-VG-NONE-EX': 8.86,
    'D-VVS2-EX-GOOD-FAINT-EX': 8.86,
    'D-VVS2-GOOD-EX-FAINT-EX': 8.86,
    'D-VVS2-VG-VG-FAINT-EX': 8.86,
    'D-VS2-VG-EX-NONE-EX': 8.86,
    'E-VVS2-VG-VG-NONE-EX': 8.86,
    'E-VVS2-GOOD-EX-NONE-EX': 8.86,
    'E-VVS2-EX-GOOD-NONE-EX': 8.86,
    'D-IF-EX-POOR-MEDIUM-EX': 8.85,
    'D-IF-VG-GOOD-MEDIUM-EX': 8.85,
    'D-IF-EX-EX-MEDIUM-VG': 8.85,
    'D-IF-GOOD-VG-MEDIUM-EX': 8.85,
    'D-IF-POOR-EX-MEDIUM-EX': 8.85,
    'E-IF-GOOD-VG-FAINT-EX': 8.85,
    'E-IF-POOR-EX-FAINT-EX': 8.85,
    'E-IF-EX-POOR-FAINT-EX': 8.85,
    'E-IF-EX-EX-FAINT-VG': 8.85,
    'E-IF-VG-GOOD-FAINT-EX': 8.85,
    'F-IF-POOR-EX-NONE-EX': 8.85,
    'F-IF-VG-GOOD-NONE-EX': 8.85,
    'F-IF-GOOD-VG-NONE-EX': 8.85,
    'F-IF-EX-POOR-NONE-EX': 8.85,
    'F-IF-EX-EX-NONE-VG': 8.85,
    'D-VS1-GOOD-EX-NONE-EX': 8.83,
    'D-VS1-EX-GOOD-NONE-EX': 8.83,
    'D-VVS1-POOR-EX-FAINT-EX': 8.83,
    'D-VVS1-VG-GOOD-FAINT-EX': 8.83,
    'D-VVS1-EX-POOR-FAINT-EX': 8.83,
    'D-VVS1-EX-EX-FAINT-VG': 8.83,
    'D-VS1-VG-VG-NONE-EX': 8.83,
    'D-VVS1-GOOD-VG-FAINT-EX': 8.83,
    'E-VVS1-VG-GOOD-NONE-EX': 8.83,
    'E-VVS1-EX-EX-NONE-VG': 8.83,
    'E-VVS1-EX-POOR-NONE-EX': 8.83,
    'E-VVS1-GOOD-VG-NONE-EX': 8.83,
    'E-VVS1-POOR-EX-NONE-EX': 8.83,
    'D-VVS2-EX-POOR-NONE-EX': 8.81,
    'D-VVS2-GOOD-VG-NONE-EX': 8.81,
    'D-VVS2-VG-GOOD-NONE-EX': 8.81,
    'D-VVS2-POOR-EX-NONE-EX': 8.81,
    'D-VVS2-EX-EX-NONE-VG': 8.81,
    'D-IF-GOOD-GOOD-FAINT-EX': 8.8,
    'D-IF-EX-VG-FAINT-VG': 8.8,
    'D-IF-POOR-VG-FAINT-EX': 8.8,
    'D-IF-VG-POOR-FAINT-EX': 8.8,
    'D-IF-VG-EX-FAINT-VG': 8.8,
    'E-IF-VG-EX-NONE-VG': 8.8,
    'E-IF-VG-POOR-NONE-EX': 8.8,
    'E-IF-GOOD-GOOD-NONE-EX': 8.8,
    'E-IF-POOR-VG-NONE-EX': 8.8,
    'E-IF-EX-VG-NONE-VG': 8.8,
    'G-IF-EX-EX-STRONG-EX': 8.8,
    'H-IF-EX-EX-MEDIUM-EX': 8.8,
    'I-IF-EX-EX-FAINT-EX': 8.8,
    'J-IF-EX-EX-NONE-EX': 8.8,
    'D-VVS1-VG-POOR-NONE-EX': 8.78,
    'D-VVS1-VG-EX-NONE-VG': 8.78,
    'D-VVS1-GOOD-GOOD-NONE-EX': 8.78,
    'D-VVS1-POOR-VG-NONE-EX': 8.78,
    'D-VVS1-EX-VG-NONE-VG': 8.78,
    'F-VVS1-EX-EX-STRONG-EX': 8.78,
    'G-VVS1-EX-EX-MEDIUM-EX': 8.78,
    'H-VVS1-EX-EX-FAINT-EX': 8.78,
    'I-VVS1-EX-EX-NONE-EX': 8.78,
    'E-VVS2-EX-EX-STRONG-EX': 8.76,
    'F-VVS2-EX-EX-MEDIUM-EX': 8.76,
    'G-VVS2-EX-EX-FAINT-EX': 8.76,
    'H-VVS2-EX-EX-NONE-EX': 8.76,
    'D-IF-EX-GOOD-NONE-VG': 8.75,
    'D-IF-GOOD-EX-NONE-VG': 8.75,
    'D-IF-GOOD-POOR-NONE-EX': 8.75,
    'D-IF-POOR-GOOD-NONE-EX': 8.75,
    'D-IF-VG-VG-NONE-VG': 8.75,
    'F-IF-EX-VG-STRONG-EX': 8.75,
    'F-IF-VG-EX-STRONG-EX': 8.75,
    'G-IF-EX-VG-MEDIUM-EX': 8.75,
    'G-IF-VG-EX-MEDIUM-EX': 8.75,
    'H-IF-VG-EX-FAINT-EX': 8.75,
    'H-IF-EX-VG-FAINT-EX': 8.75,
    'I-IF-EX-VG-NONE-EX': 8.75,
    'I-IF-VG-EX-NONE-EX': 8.75,
    'D-VS1-EX-EX-STRONG-EX': 8.73,
    'E-VVS1-VG-EX-STRONG-EX': 8.73,
    'E-VVS1-EX-VG-STRONG-EX': 8.73,
    'E-VS1-EX-EX-MEDIUM-EX': 8.73,
    'F-VS1-EX-EX-FAINT-EX': 8.73,
    'F-VVS1-EX-VG-MEDIUM-EX': 8.73,
    'F-VVS1-VG-EX-MEDIUM-EX': 8.73,
    'G-VVS1-EX-VG-FAINT-EX': 8.73,
    'G-VVS1-VG-EX-FAINT-EX': 8.73,
    'G-VS1-EX-EX-NONE-EX': 8.73,
    'H-VVS1-EX-VG-NONE-EX': 8.73,
    'H-VVS1-VG-EX-NONE-EX': 8.73,
    'D-VVS2-VG-EX-STRONG-EX': 8.71,
    'D-VS2-EX-EX-MEDIUM-EX': 8.71,
    'D-VVS2-EX-VG-STRONG-EX': 8.71,
    'E-VS2-EX-EX-FAINT-EX': 8.71,
    'E-VVS2-VG-EX-MEDIUM-EX': 8.71,
    'E-VVS2-EX-VG-MEDIUM-EX': 8.71,
    'F-VVS2-VG-EX-FAINT-EX': 8.71,
    'F-VVS2-EX-VG-FAINT-EX': 8.71,
    'F-VS2-EX-EX-NONE-EX': 8.71,
    'G-VVS2-VG-EX-NONE-EX': 8.71,
    'G-VVS2-EX-VG-NONE-EX': 8.71,
    'E-IF-GOOD-EX-STRONG-EX': 8.7,
    'E-IF-VG-VG-STRONG-EX': 8.7,
    'E-IF-EX-GOOD-STRONG-EX': 8.7,
    'F-IF-GOOD-EX-MEDIUM-EX': 8.7,
    'F-IF-EX-GOOD-MEDIUM-EX': 8.7,
    'F-IF-VG-VG-MEDIUM-EX': 8.7,
    'G-IF-VG-VG-FAINT-EX': 8.7,
    'G-IF-GOOD-EX-FAINT-EX': 8.7,
    'G-IF-EX-GOOD-FAINT-EX': 8.7,
    'H-IF-VG-VG-NONE-EX': 8.7,
    'H-IF-EX-GOOD-NONE-EX': 8.7,
    'H-IF-GOOD-EX-NONE-EX': 8.7,
    'D-SI1-EX-EX-FAINT-EX': 8.69,
    'E-SI1-EX-EX-NONE-EX': 8.69,
    'D-VS1-VG-EX-MEDIUM-EX': 8.68,
    'D-VVS1-VG-VG-STRONG-EX': 8.68,
    'D-VS1-EX-VG-MEDIUM-EX': 8.68,
    'D-VVS1-EX-GOOD-STRONG-EX': 8.68,
    'D-VVS1-GOOD-EX-STRONG-EX': 8.68,
    'E-VVS1-GOOD-EX-MEDIUM-EX': 8.68,
    'E-VVS1-VG-VG-MEDIUM-EX': 8.68,
    'E-VS1-VG-EX-FAINT-EX': 8.68,
    'E-VVS1-EX-GOOD-MEDIUM-EX': 8.68,
    'E-VS1-EX-VG-FAINT-EX': 8.68,
    'F-VS1-EX-VG-NONE-EX': 8.68,
    'F-VVS1-GOOD-EX-FAINT-EX': 8.68,
    'F-VS1-VG-EX-NONE-EX': 8.68,
    'F-VVS1-VG-VG-FAINT-EX': 8.68,
    'F-VVS1-EX-GOOD-FAINT-EX': 8.68,
    'G-VVS1-GOOD-EX-NONE-EX': 8.68,
    'G-VVS1-VG-VG-NONE-EX': 8.68,
    'G-VVS1-EX-GOOD-NONE-EX': 8.68,
    'D-SI2-EX-EX-NONE-EX': 8.67,
    'D-VS2-VG-EX-FAINT-EX': 8.66,
    'D-VS2-EX-VG-FAINT-EX': 8.66,
    'D-VVS2-GOOD-EX-MEDIUM-EX': 8.66,
    'D-VVS2-VG-VG-MEDIUM-EX': 8.66,
    'D-VVS2-EX-GOOD-MEDIUM-EX': 8.66,
    'E-VS2-EX-VG-NONE-EX': 8.66,
    'E-VVS2-GOOD-EX-FAINT-EX': 8.66,
    'E-VS2-VG-EX-NONE-EX': 8.66,
    'E-VVS2-VG-VG-FAINT-EX': 8.66,
    'E-VVS2-EX-GOOD-FAINT-EX': 8.66,
    'F-VVS2-VG-VG-NONE-EX': 8.66,
    'F-VVS2-EX-GOOD-NONE-EX': 8.66,
    'F-VVS2-GOOD-EX-NONE-EX': 8.66,
    'D-IF-POOR-EX-STRONG-EX': 8.65,
    'D-IF-EX-POOR-STRONG-EX': 8.65,
    'D-IF-VG-GOOD-STRONG-EX': 8.65,
    'D-IF-GOOD-VG-STRONG-EX': 8.65,
    'D-IF-EX-EX-STRONG-VG': 8.65,
    'E-IF-POOR-EX-MEDIUM-EX': 8.65,
    'E-IF-EX-EX-MEDIUM-VG': 8.65,
    'E-IF-EX-POOR-MEDIUM-EX': 8.65,
    'E-IF-VG-GOOD-MEDIUM-EX': 8.65,
    'E-IF-GOOD-VG-MEDIUM-EX': 8.65,
    'F-IF-EX-EX-FAINT-VG': 8.65,
    'F-IF-POOR-EX-FAINT-EX': 8.65,
    'F-IF-VG-GOOD-FAINT-EX': 8.65,
    'F-IF-GOOD-VG-FAINT-EX': 8.65,
    'F-IF-EX-POOR-FAINT-EX': 8.65,
    'G-IF-VG-GOOD-NONE-EX': 8.65,
    'G-IF-GOOD-VG-NONE-EX': 8.65,
    'G-IF-POOR-EX-NONE-EX': 8.65,
    'G-IF-EX-POOR-NONE-EX': 8.65,
    'G-IF-EX-EX-NONE-VG': 8.65,
    'D-SI1-VG-EX-NONE-EX': 8.64,
    'D-SI1-EX-VG-NONE-EX': 8.64,
    'D-VS1-VG-VG-FAINT-EX': 8.63,
    'D-VS1-GOOD-EX-FAINT-EX': 8.63,
    'D-VVS1-EX-EX-MEDIUM-VG': 8.63,
    'D-VVS1-GOOD-VG-MEDIUM-EX': 8.63,
    'D-VVS1-VG-GOOD-MEDIUM-EX': 8.63,
    'D-VS1-EX-GOOD-FAINT-EX': 8.63,
    'D-VVS1-POOR-EX-MEDIUM-EX': 8.63,
    'D-VVS1-EX-POOR-MEDIUM-EX': 8.63,
    'E-VS1-EX-GOOD-NONE-EX': 8.63,
    'E-VS1-VG-VG-NONE-EX': 8.63,
    'E-VS1-GOOD-EX-NONE-EX': 8.63,
    'E-VVS1-VG-GOOD-FAINT-EX': 8.63,
    'E-VVS1-EX-POOR-FAINT-EX': 8.63,
    'E-VVS1-EX-EX-FAINT-VG': 8.63,
    'E-VVS1-GOOD-VG-FAINT-EX': 8.63,
    'E-VVS1-POOR-EX-FAINT-EX': 8.63,
    'F-VVS1-VG-GOOD-NONE-EX': 8.63,
    'F-VVS1-GOOD-VG-NONE-EX': 8.63,
    'F-VVS1-POOR-EX-NONE-EX': 8.63,
    'F-VVS1-EX-POOR-NONE-EX': 8.63,
    'F-VVS1-EX-EX-NONE-VG': 8.63,
    'D-VVS2-VG-GOOD-FAINT-EX': 8.61,
    'D-VVS2-GOOD-VG-FAINT-EX': 8.61,
    'D-VVS2-EX-EX-FAINT-VG': 8.61,
    'D-VS2-VG-VG-NONE-EX': 8.61,
    'D-VVS2-POOR-EX-FAINT-EX': 8.61,
    'D-VS2-GOOD-EX-NONE-EX': 8.61,
    'D-VVS2-EX-POOR-FAINT-EX': 8.61,
    'D-VS2-EX-GOOD-NONE-EX': 8.61,
    'E-VVS2-VG-GOOD-NONE-EX': 8.61,
    'E-VVS2-GOOD-VG-NONE-EX': 8.61,
    'E-VVS2-EX-POOR-NONE-EX': 8.61,
    'E-VVS2-EX-EX-NONE-VG': 8.61,
    'E-VVS2-POOR-EX-NONE-EX': 8.61,
    'D-IF-GOOD-GOOD-MEDIUM-EX': 8.6,
    'D-IF-VG-EX-MEDIUM-VG': 8.6,
    'D-IF-EX-VG-MEDIUM-VG': 8.6,
    'D-IF-VG-POOR-MEDIUM-EX': 8.6,
    'D-IF-POOR-VG-MEDIUM-EX': 8.6,
    'E-IF-VG-POOR-FAINT-EX': 8.6,
    'E-IF-GOOD-GOOD-FAINT-EX': 8.6,
    'E-IF-POOR-VG-FAINT-EX': 8.6,
    'E-IF-EX-VG-FAINT-VG': 8.6,
    'E-IF-VG-EX-FAINT-VG': 8.6,
    'F-IF-VG-POOR-NONE-EX': 8.6,
    'F-IF-VG-EX-NONE-VG': 8.6,
    'F-IF-EX-VG-NONE-VG': 8.6,
    'F-IF-POOR-VG-NONE-EX': 8.6,
    'F-IF-GOOD-GOOD-NONE-EX': 8.6,
    'H-IF-EX-EX-STRONG-EX': 8.6,
    'I-IF-EX-EX-MEDIUM-EX': 8.6,
    'J-IF-EX-EX-FAINT-EX': 8.6,
    'K-IF-EX-EX-NONE-EX': 8.6,
    'D-VS1-VG-GOOD-NONE-EX': 8.58,
    'D-VVS1-GOOD-GOOD-FAINT-EX': 8.58,
    'D-VS1-EX-EX-NONE-VG': 8.58,
    'D-VS1-GOOD-VG-NONE-EX': 8.58,
    'D-VVS1-EX-VG-FAINT-VG': 8.58,
    'D-VVS1-POOR-VG-FAINT-EX': 8.58,
    'D-VS1-POOR-EX-NONE-EX': 8.58,
    'D-VS1-EX-POOR-NONE-EX': 8.58,
    'D-VVS1-VG-EX-FAINT-VG': 8.58,
    'D-VVS1-VG-POOR-FAINT-EX': 8.58,
    'E-VVS1-VG-EX-NONE-VG': 8.58,
    'E-VVS1-POOR-VG-NONE-EX': 8.58,
    'E-VVS1-VG-POOR-NONE-EX': 8.58,
    'E-VVS1-EX-VG-NONE-VG': 8.58,
    'E-VVS1-GOOD-GOOD-NONE-EX': 8.58,
    'G-VVS1-EX-EX-STRONG-EX': 8.58,
    'H-VVS1-EX-EX-MEDIUM-EX': 8.58,
    'I-VVS1-EX-EX-FAINT-EX': 8.58,
    'J-VVS1-EX-EX-NONE-EX': 8.58,
    'D-VVS2-EX-VG-NONE-VG': 8.56,
    'D-VVS2-GOOD-GOOD-NONE-EX': 8.56,
    'D-VVS2-VG-POOR-NONE-EX': 8.56,
    'D-VVS2-VG-EX-NONE-VG': 8.56,
    'D-VVS2-POOR-VG-NONE-EX': 8.56,
    'F-VVS2-EX-EX-STRONG-EX': 8.56,
    'G-VVS2-EX-EX-MEDIUM-EX': 8.56,
    'H-VVS2-EX-EX-FAINT-EX': 8.56,
    'I-VVS2-EX-EX-NONE-EX': 8.56,
    'D-IF-GOOD-EX-FAINT-VG': 8.55,
    'D-IF-EX-GOOD-FAINT-VG': 8.55,
    'D-IF-POOR-GOOD-FAINT-EX': 8.55,
    'D-IF-VG-VG-FAINT-VG': 8.55,
    'D-IF-GOOD-POOR-FAINT-EX': 8.55,
    'E-IF-POOR-GOOD-NONE-EX': 8.55,
    'E-IF-VG-VG-NONE-VG': 8.55,
    'E-IF-GOOD-POOR-NONE-EX': 8.55,
    'E-IF-EX-GOOD-NONE-VG': 8.55,
    'E-IF-GOOD-EX-NONE-VG': 8.55,
    'G-IF-VG-EX-STRONG-EX': 8.55,
    'G-IF-EX-VG-STRONG-EX': 8.55,
    'H-IF-VG-EX-MEDIUM-EX': 8.55,
    'H-IF-EX-VG-MEDIUM-EX': 8.55,
    'I-IF-VG-EX-FAINT-EX': 8.55,
    'I-IF-EX-VG-FAINT-EX': 8.55,
    'J-IF-VG-EX-NONE-EX': 8.55,
    'J-IF-EX-VG-NONE-EX': 8.55,
    'D-VVS1-GOOD-POOR-NONE-EX': 8.53,
    'D-VVS1-VG-VG-NONE-VG': 8.53,
    'D-VVS1-EX-GOOD-NONE-VG': 8.53,
    'D-VVS1-POOR-GOOD-NONE-EX': 8.53,
    'D-VVS1-GOOD-EX-NONE-VG': 8.53,
    'E-VS1-EX-EX-STRONG-EX': 8.53,
    'F-VVS1-VG-EX-STRONG-EX': 8.53,
    'F-VS1-EX-EX-MEDIUM-EX': 8.53,
    'F-VVS1-EX-VG-STRONG-EX': 8.53,
    'G-VVS1-VG-EX-MEDIUM-EX': 8.53,
    'G-VS1-EX-EX-FAINT-EX': 8.53,
    'G-VVS1-EX-VG-MEDIUM-EX': 8.53,
    'H-VVS1-EX-VG-FAINT-EX': 8.53,
    'H-VS1-EX-EX-NONE-EX': 8.53,
    'H-VVS1-VG-EX-FAINT-EX': 8.53,
    'I-VVS1-EX-VG-NONE-EX': 8.53,
    'I-VVS1-VG-EX-NONE-EX': 8.53,
    'D-VS2-EX-EX-STRONG-EX': 8.51,
    'E-VS2-EX-EX-MEDIUM-EX': 8.51,
    'E-VVS2-EX-VG-STRONG-EX': 8.51,
    'E-VVS2-VG-EX-STRONG-EX': 8.51,
    'F-VS2-EX-EX-FAINT-EX': 8.51,
    'F-VVS2-VG-EX-MEDIUM-EX': 8.51,
    'F-VVS2-EX-VG-MEDIUM-EX': 8.51,
    'G-VVS2-EX-VG-FAINT-EX': 8.51,
    'G-VS2-EX-EX-NONE-EX': 8.51,
    'G-VVS2-VG-EX-FAINT-EX': 8.51,
    'H-VVS2-EX-VG-NONE-EX': 8.51,
    'H-VVS2-VG-EX-NONE-EX': 8.51,
    'D-IF-EX-POOR-NONE-VG': 8.5,
    'D-IF-VG-GOOD-NONE-VG': 8.5,
    'D-IF-POOR-EX-NONE-VG': 8.5,
    'D-IF-GOOD-VG-NONE-VG': 8.5,
    'D-IF-POOR-POOR-NONE-EX': 8.5,
    'D-IF-EX-EX-NONE-GOOD': 8.5,
    'F-IF-EX-GOOD-STRONG-EX': 8.5,
    'F-IF-GOOD-EX-STRONG-EX': 8.5,
    'F-IF-VG-VG-STRONG-EX': 8.5,
    'G-IF-VG-VG-MEDIUM-EX': 8.5,
    'G-IF-EX-GOOD-MEDIUM-EX': 8.5,
    'G-IF-GOOD-EX-MEDIUM-EX': 8.5,
    'H-IF-GOOD-EX-FAINT-EX': 8.5,
    'H-IF-EX-GOOD-FAINT-EX': 8.5,
    'H-IF-VG-VG-FAINT-EX': 8.5,
    'I-IF-VG-VG-NONE-EX': 8.5,
    'I-IF-EX-GOOD-NONE-EX': 8.5,
    'I-IF-GOOD-EX-NONE-EX': 8.5,
    'D-SI1-EX-EX-MEDIUM-EX': 8.49,
    'E-SI1-EX-EX-FAINT-EX': 8.49,
    'F-SI1-EX-EX-NONE-EX': 8.49,
    'D-VS1-VG-EX-STRONG-EX': 8.48,
    'D-VS1-EX-VG-STRONG-EX': 8.48,
    'E-VS1-VG-EX-MEDIUM-EX': 8.48,
    'E-VS1-EX-VG-MEDIUM-EX': 8.48,
    'E-VVS1-GOOD-EX-STRONG-EX': 8.48,
    'E-VVS1-VG-VG-STRONG-EX': 8.48,
    'E-VVS1-EX-GOOD-STRONG-EX': 8.48,
    'F-VVS1-VG-VG-MEDIUM-EX': 8.48,
    'F-VVS1-EX-GOOD-MEDIUM-EX': 8.48,
    'F-VS1-VG-EX-FAINT-EX': 8.48,
    'F-VS1-EX-VG-FAINT-EX': 8.48,
    'F-VVS1-GOOD-EX-MEDIUM-EX': 8.48,
    'G-VVS1-VG-VG-FAINT-EX': 8.48,
    'G-VS1-VG-EX-NONE-EX': 8.48,
    'G-VS1-EX-VG-NONE-EX': 8.48,
    'G-VVS1-EX-GOOD-FAINT-EX': 8.48,
    'G-VVS1-GOOD-EX-FAINT-EX': 8.48,
    'H-VVS1-GOOD-EX-NONE-EX': 8.48,
    'H-VVS1-VG-VG-NONE-EX': 8.48,
    'H-VVS1-EX-GOOD-NONE-EX': 8.48,
    'D-SI2-EX-EX-FAINT-EX': 8.47,
    'E-SI2-EX-EX-NONE-EX': 8.47,
    'D-VVS2-VG-VG-STRONG-EX': 8.46,
    'D-VVS2-EX-GOOD-STRONG-EX': 8.46,
    'D-VVS2-GOOD-EX-STRONG-EX': 8.46,
    'D-VS2-EX-VG-MEDIUM-EX': 8.46,
    'D-VS2-VG-EX-MEDIUM-EX': 8.46,
    'E-VS2-VG-EX-FAINT-EX': 8.46,
    'E-VS2-EX-VG-FAINT-EX': 8.46,
    'E-VVS2-GOOD-EX-MEDIUM-EX': 8.46,
    'E-VVS2-EX-GOOD-MEDIUM-EX': 8.46,
    'E-VVS2-VG-VG-MEDIUM-EX': 8.46,
    'F-VS2-VG-EX-NONE-EX': 8.46,
    'F-VS2-EX-VG-NONE-EX': 8.46,
    'F-VVS2-GOOD-EX-FAINT-EX': 8.46,
    'F-VVS2-EX-GOOD-FAINT-EX': 8.46,
    'F-VVS2-VG-VG-FAINT-EX': 8.46,
    'G-VVS2-VG-VG-NONE-EX': 8.46,
    'G-VVS2-EX-GOOD-NONE-EX': 8.46,
    'G-VVS2-GOOD-EX-NONE-EX': 8.46,
    'E-IF-EX-EX-STRONG-VG': 8.45,
    'E-IF-EX-POOR-STRONG-EX': 8.45,
    'E-IF-VG-GOOD-STRONG-EX': 8.45,
    'E-IF-GOOD-VG-STRONG-EX': 8.45,
    'E-IF-POOR-EX-STRONG-EX': 8.45,
    'F-IF-EX-POOR-MEDIUM-EX': 8.45,
    'F-IF-EX-EX-MEDIUM-VG': 8.45,
    'F-IF-POOR-EX-MEDIUM-EX': 8.45,
    'F-IF-GOOD-VG-MEDIUM-EX': 8.45,
    'F-IF-VG-GOOD-MEDIUM-EX': 8.45,
    'G-IF-VG-GOOD-FAINT-EX': 8.45,
    'G-IF-GOOD-VG-FAINT-EX': 8.45,
    'G-IF-EX-EX-FAINT-VG': 8.45,
    'G-IF-EX-POOR-FAINT-EX': 8.45,
    'G-IF-POOR-EX-FAINT-EX': 8.45,
    'H-IF-EX-POOR-NONE-EX': 8.45,
    'H-IF-EX-EX-NONE-VG': 8.45,
    'H-IF-VG-GOOD-NONE-EX': 8.45,
    'H-IF-POOR-EX-NONE-EX': 8.45,
    'H-IF-GOOD-VG-NONE-EX': 8.45,
    'D-SI1-VG-EX-FAINT-EX': 8.44,
    'D-SI1-EX-VG-FAINT-EX': 8.44,
    'D-I1-EX-EX-NONE-EX': 8.44,
    'E-SI1-VG-EX-NONE-EX': 8.44,
    'E-SI1-EX-VG-NONE-EX': 8.44,
    'D-VVS1-VG-GOOD-STRONG-EX': 8.43,
    'D-VVS1-EX-POOR-STRONG-EX': 8.43,
    'D-VS1-EX-GOOD-MEDIUM-EX': 8.43,
    'D-VVS1-POOR-EX-STRONG-EX': 8.43,
    'D-VVS1-EX-EX-STRONG-VG': 8.43,
    'D-VVS1-GOOD-VG-STRONG-EX': 8.43,
    'D-VS1-GOOD-EX-MEDIUM-EX': 8.43,
    'D-VS1-VG-VG-MEDIUM-EX': 8.43,
    'E-VVS1-EX-POOR-MEDIUM-EX': 8.43,
    'E-VVS1-VG-GOOD-MEDIUM-EX': 8.43,
    'E-VVS1-POOR-EX-MEDIUM-EX': 8.43,
    'E-VVS1-GOOD-VG-MEDIUM-EX': 8.43,
    'E-VVS1-EX-EX-MEDIUM-VG': 8.43,
    'E-VS1-VG-VG-FAINT-EX': 8.43,
    'E-VS1-EX-GOOD-FAINT-EX': 8.43,
    'E-VS1-GOOD-EX-FAINT-EX': 8.43,
    'F-VVS1-POOR-EX-FAINT-EX': 8.43,
    'F-VVS1-GOOD-VG-FAINT-EX': 8.43,
    'F-VVS1-VG-GOOD-FAINT-EX': 8.43,
    'F-VS1-EX-GOOD-NONE-EX': 8.43,
    'F-VVS1-EX-POOR-FAINT-EX': 8.43,
    'F-VVS1-EX-EX-FAINT-VG': 8.43,
    'F-VS1-VG-VG-NONE-EX': 8.43,
    'F-VS1-GOOD-EX-NONE-EX': 8.43,
    'G-VVS1-VG-GOOD-NONE-EX': 8.43,
    'G-VVS1-EX-EX-NONE-VG': 8.43,
    'G-VVS1-GOOD-VG-NONE-EX': 8.43,
    'G-VVS1-POOR-EX-NONE-EX': 8.43,
    'G-VVS1-EX-POOR-NONE-EX': 8.43,
    'D-SI2-VG-EX-NONE-EX': 8.42,
    'D-SI2-EX-VG-NONE-EX': 8.42,
    'D-VS2-EX-GOOD-FAINT-EX': 8.41,
    'D-VVS2-GOOD-VG-MEDIUM-EX': 8.41,
    'D-VVS2-EX-EX-MEDIUM-VG': 8.41,
    'D-VVS2-VG-GOOD-MEDIUM-EX': 8.41,
    'D-VVS2-EX-POOR-MEDIUM-EX': 8.41,
    'D-VS2-VG-VG-FAINT-EX': 8.41,
    'D-VS2-GOOD-EX-FAINT-EX': 8.41,
    'D-VVS2-POOR-EX-MEDIUM-EX': 8.41,
    'E-VS2-EX-GOOD-NONE-EX': 8.41,
    'E-VVS2-POOR-EX-FAINT-EX': 8.41,
    'E-VVS2-GOOD-VG-FAINT-EX': 8.41,
    'E-VVS2-EX-POOR-FAINT-EX': 8.41,
    'E-VVS2-VG-GOOD-FAINT-EX': 8.41,
    'E-VS2-GOOD-EX-NONE-EX': 8.41,
    'E-VVS2-EX-EX-FAINT-VG': 8.41,
    'E-VS2-VG-VG-NONE-EX': 8.41,
    'F-VVS2-VG-GOOD-NONE-EX': 8.41,
    'F-VVS2-GOOD-VG-NONE-EX': 8.41,
    'F-VVS2-EX-EX-NONE-VG': 8.41,
    'F-VVS2-EX-POOR-NONE-EX': 8.41,
    'F-VVS2-POOR-EX-NONE-EX': 8.41,
    'D-IF-VG-POOR-STRONG-EX': 8.4,
    'D-IF-GOOD-GOOD-STRONG-EX': 8.4,
    'D-IF-EX-VG-STRONG-VG': 8.4,
    'D-IF-VG-EX-STRONG-VG': 8.4,
    'D-IF-POOR-VG-STRONG-EX': 8.4,
    'E-IF-EX-VG-MEDIUM-VG': 8.4,
    'E-IF-VG-EX-MEDIUM-VG': 8.4,
    'E-IF-POOR-VG-MEDIUM-EX': 8.4,
    'E-IF-GOOD-GOOD-MEDIUM-EX': 8.4,
    'E-IF-VG-POOR-MEDIUM-EX': 8.4,
    'F-IF-POOR-VG-FAINT-EX': 8.4,
    'F-IF-VG-POOR-FAINT-EX': 8.4,
    'F-IF-EX-VG-FAINT-VG': 8.4,
    'F-IF-VG-EX-FAINT-VG': 8.4,
    'F-IF-GOOD-GOOD-FAINT-EX': 8.4,
    'G-IF-VG-POOR-NONE-EX': 8.4,
    'G-IF-VG-EX-NONE-VG': 8.4,
    'G-IF-GOOD-GOOD-NONE-EX': 8.4,
    'G-IF-POOR-VG-NONE-EX': 8.4,
    'G-IF-EX-VG-NONE-VG': 8.4,
    'I-IF-EX-EX-STRONG-EX': 8.4,
    'J-IF-EX-EX-MEDIUM-EX': 8.4,
    'K-IF-EX-EX-FAINT-EX': 8.4,
    'L-IF-EX-EX-NONE-EX': 8.4,
    'D-SI1-GOOD-EX-NONE-EX': 8.39,
    'D-SI1-VG-VG-NONE-EX': 8.39,
    'D-SI1-EX-GOOD-NONE-EX': 8.39,
    'D-VS1-EX-EX-FAINT-VG': 8.38,
    'D-VS1-VG-GOOD-FAINT-EX': 8.38,
    'D-VS1-EX-POOR-FAINT-EX': 8.38,
    'D-VVS1-EX-VG-MEDIUM-VG': 8.38,
    'D-VVS1-VG-EX-MEDIUM-VG': 8.38,
    'D-VS1-GOOD-VG-FAINT-EX': 8.38,
    'D-VVS1-VG-POOR-MEDIUM-EX': 8.38,
    'D-VVS1-GOOD-GOOD-MEDIUM-EX': 8.38,
    'D-VVS1-POOR-VG-MEDIUM-EX': 8.38,
    'D-VS1-POOR-EX-FAINT-EX': 8.38,
    'E-VS1-VG-GOOD-NONE-EX': 8.38,
    'E-VS1-EX-POOR-NONE-EX': 8.38,
    'E-VS1-GOOD-VG-NONE-EX': 8.38,
    'E-VS1-POOR-EX-NONE-EX': 8.38,
    'E-VVS1-EX-VG-FAINT-VG': 8.38,
    'E-VVS1-VG-EX-FAINT-VG': 8.38,
    'E-VVS1-VG-POOR-FAINT-EX': 8.38,
    'E-VVS1-GOOD-GOOD-FAINT-EX': 8.38,
    'E-VVS1-POOR-VG-FAINT-EX': 8.38,
    'E-VS1-EX-EX-NONE-VG': 8.38,
    'F-VVS1-POOR-VG-NONE-EX': 8.38,
    'F-VVS1-GOOD-GOOD-NONE-EX': 8.38,
    'F-VVS1-EX-VG-NONE-VG': 8.38,
    'F-VVS1-VG-POOR-NONE-EX': 8.38,
    'F-VVS1-VG-EX-NONE-VG': 8.38,
    'H-VVS1-EX-EX-STRONG-EX': 8.38,
    'I-VVS1-EX-EX-MEDIUM-EX': 8.38,
    'J-VVS1-EX-EX-FAINT-EX': 8.38,
    'K-VVS1-EX-EX-NONE-EX': 8.38,
    'D-VS2-EX-EX-NONE-VG': 8.36,
    'D-VVS2-EX-VG-FAINT-VG': 8.36,
    'D-VS2-EX-POOR-NONE-EX': 8.36,
    'D-VVS2-POOR-VG-FAINT-EX': 8.36,
    'D-VS2-POOR-EX-NONE-EX': 8.36,
    'D-VVS2-VG-POOR-FAINT-EX': 8.36,
    'D-VVS2-VG-EX-FAINT-VG': 8.36,
    'D-VS2-GOOD-VG-NONE-EX': 8.36,
    'D-VS2-VG-GOOD-NONE-EX': 8.36,
    'D-VVS2-GOOD-GOOD-FAINT-EX': 8.36,
    'E-VVS2-EX-VG-NONE-VG': 8.36,
    'E-VVS2-VG-EX-NONE-VG': 8.36,
    'E-VVS2-GOOD-GOOD-NONE-EX': 8.36,
    'E-VVS2-POOR-VG-NONE-EX': 8.36,
    'E-VVS2-VG-POOR-NONE-EX': 8.36,
    'G-VVS2-EX-EX-STRONG-EX': 8.36,
    'H-VVS2-EX-EX-MEDIUM-EX': 8.36,
    'I-VVS2-EX-EX-FAINT-EX': 8.36,
    'J-VVS2-EX-EX-NONE-EX': 8.36,
    'D-IF-GOOD-EX-MEDIUM-VG': 8.35,
    'D-IF-POOR-GOOD-MEDIUM-EX': 8.35,
    'D-IF-VG-VG-MEDIUM-VG': 8.35,
    'D-IF-EX-GOOD-MEDIUM-VG': 8.35,
    'D-IF-GOOD-POOR-MEDIUM-EX': 8.35,
    'E-IF-EX-GOOD-FAINT-VG': 8.35,
    'E-IF-VG-VG-FAINT-VG': 8.35,
    'E-IF-GOOD-EX-FAINT-VG': 8.35,
    'E-IF-GOOD-POOR-FAINT-EX': 8.35,
    'E-IF-POOR-GOOD-FAINT-EX': 8.35,
    'F-IF-GOOD-POOR-NONE-EX': 8.35,
    'F-IF-GOOD-EX-NONE-VG': 8.35,
    'F-IF-POOR-GOOD-NONE-EX': 8.35,
    'F-IF-EX-GOOD-NONE-VG': 8.35,
    'F-IF-VG-VG-NONE-VG': 8.35,
    'H-IF-EX-VG-STRONG-EX': 8.35,
    'H-IF-VG-EX-STRONG-EX': 8.35,
    'I-IF-VG-EX-MEDIUM-EX': 8.35,
    'I-IF-EX-VG-MEDIUM-EX': 8.35,
    'J-IF-EX-VG-FAINT-EX': 8.35,
    'J-IF-VG-EX-FAINT-EX': 8.35,
    'K-IF-VG-EX-NONE-EX': 8.35,
    'K-IF-EX-VG-NONE-EX': 8.35,
    'D-VS1-POOR-VG-NONE-EX': 8.33,
    'D-VS1-GOOD-GOOD-NONE-EX': 8.33,
    'D-VVS1-POOR-GOOD-FAINT-EX': 8.33,
    'D-VVS1-EX-GOOD-FAINT-VG': 8.33,
    'D-VVS1-VG-VG-FAINT-VG': 8.33,
    'D-VVS1-GOOD-EX-FAINT-VG': 8.33,
    'D-VVS1-GOOD-POOR-FAINT-EX': 8.33,
    'D-VS1-VG-POOR-NONE-EX': 8.33,
    'D-VS1-EX-VG-NONE-VG': 8.33,
    'D-VS1-VG-EX-NONE-VG': 8.33,
    'E-VVS1-EX-GOOD-NONE-VG': 8.33,
    'E-VVS1-VG-VG-NONE-VG': 8.33,
    'E-VVS1-GOOD-EX-NONE-VG': 8.33,
    'E-VVS1-GOOD-POOR-NONE-EX': 8.33,
    'E-VVS1-POOR-GOOD-NONE-EX': 8.33,
    'F-VS1-EX-EX-STRONG-EX': 8.33,
    'G-VS1-EX-EX-MEDIUM-EX': 8.33,
    'G-VVS1-VG-EX-STRONG-EX': 8.33,
    'G-VVS1-EX-VG-STRONG-EX': 8.33,
    'H-VS1-EX-EX-FAINT-EX': 8.33,
    'H-VVS1-VG-EX-MEDIUM-EX': 8.33,
    'H-VVS1-EX-VG-MEDIUM-EX': 8.33,
    'I-VVS1-EX-VG-FAINT-EX': 8.33,
    'I-VVS1-VG-EX-FAINT-EX': 8.33,
    'I-VS1-EX-EX-NONE-EX': 8.33,
    'J-VVS1-VG-EX-NONE-EX': 8.33,
    'J-VVS1-EX-VG-NONE-EX': 8.33,
    'D-VVS2-POOR-GOOD-NONE-EX': 8.31,
    'D-VVS2-GOOD-POOR-NONE-EX': 8.31,
    'D-VVS2-VG-VG-NONE-VG': 8.31,
    'D-VVS2-GOOD-EX-NONE-VG': 8.31,
    'D-VVS2-EX-GOOD-NONE-VG': 8.31,
    'E-VS2-EX-EX-STRONG-EX': 8.31,
    'F-VVS2-EX-VG-STRONG-EX': 8.31,
    'F-VS2-EX-EX-MEDIUM-EX': 8.31,
    'F-VVS2-VG-EX-STRONG-EX': 8.31,
    'G-VS2-EX-EX-FAINT-EX': 8.31,
    'G-VVS2-EX-VG-MEDIUM-EX': 8.31,
    'G-VVS2-VG-EX-MEDIUM-EX': 8.31,
    'H-VVS2-EX-VG-FAINT-EX': 8.31,
    'H-VS2-EX-EX-NONE-EX': 8.31,
    'H-VVS2-VG-EX-FAINT-EX': 8.31,
    'I-VVS2-VG-EX-NONE-EX': 8.31,
    'I-VVS2-EX-VG-NONE-EX': 8.31,
    'D-IF-EX-POOR-FAINT-VG': 8.3,
    'D-IF-EX-EX-FAINT-GOOD': 8.3,
    'D-IF-VG-GOOD-FAINT-VG': 8.3,
    'D-IF-GOOD-VG-FAINT-VG': 8.3,
    'D-IF-POOR-EX-FAINT-VG': 8.3,
    'D-IF-POOR-POOR-FAINT-EX': 8.3,
    'E-IF-EX-EX-NONE-GOOD': 8.3,
    'E-IF-POOR-EX-NONE-VG': 8.3,
    'E-IF-POOR-POOR-NONE-EX': 8.3,
    'E-IF-GOOD-VG-NONE-VG': 8.3,
    'E-IF-EX-POOR-NONE-VG': 8.3,
    'E-IF-VG-GOOD-NONE-VG': 8.3,
    'G-IF-GOOD-EX-STRONG-EX': 8.3,
    'G-IF-VG-VG-STRONG-EX': 8.3,
    'G-IF-EX-GOOD-STRONG-EX': 8.3,
    'H-IF-EX-GOOD-MEDIUM-EX': 8.3,
    'H-IF-VG-VG-MEDIUM-EX': 8.3,
    'H-IF-GOOD-EX-MEDIUM-EX': 8.3,
    'I-IF-EX-GOOD-FAINT-EX': 8.3,
    'I-IF-VG-VG-FAINT-EX': 8.3,
    'I-IF-GOOD-EX-FAINT-EX': 8.3,
    'J-IF-EX-GOOD-NONE-EX': 8.3,
    'J-IF-VG-VG-NONE-EX': 8.3,
    'J-IF-GOOD-EX-NONE-EX': 8.3,
    'D-SI1-EX-EX-STRONG-EX': 8.29,
    'E-SI1-EX-EX-MEDIUM-EX': 8.29,
    'F-SI1-EX-EX-FAINT-EX': 8.29,
    'G-SI1-EX-EX-NONE-EX': 8.29,
    'D-VVS1-VG-GOOD-NONE-VG': 8.28,
    'D-VVS1-EX-EX-NONE-GOOD': 8.28,
    'D-VVS1-EX-POOR-NONE-VG': 8.28,
    'D-VVS1-GOOD-VG-NONE-VG': 8.28,
    'D-VVS1-POOR-EX-NONE-VG': 8.28,
    'D-VVS1-POOR-POOR-NONE-EX': 8.28,
    'E-VS1-VG-EX-STRONG-EX': 8.28,
    'E-VS1-EX-VG-STRONG-EX': 8.28,
    'F-VVS1-VG-VG-STRONG-EX': 8.28,
    'F-VVS1-GOOD-EX-STRONG-EX': 8.28,
    'F-VVS1-EX-GOOD-STRONG-EX': 8.28,
    'F-VS1-EX-VG-MEDIUM-EX': 8.28,
    'F-VS1-VG-EX-MEDIUM-EX': 8.28,
    'G-VVS1-EX-GOOD-MEDIUM-EX': 8.28,
    'G-VVS1-GOOD-EX-MEDIUM-EX': 8.28,
    'G-VS1-EX-VG-FAINT-EX': 8.28,
    'G-VS1-VG-EX-FAINT-EX': 8.28,
    'G-VVS1-VG-VG-MEDIUM-EX': 8.28,
    'H-VVS1-EX-GOOD-FAINT-EX': 8.28,
    'H-VS1-EX-VG-NONE-EX': 8.28,
    'H-VVS1-VG-VG-FAINT-EX': 8.28,
    'H-VS1-VG-EX-NONE-EX': 8.28,
    'H-VVS1-GOOD-EX-FAINT-EX': 8.28,
    'I-VVS1-EX-GOOD-NONE-EX': 8.28,
    'I-VVS1-VG-VG-NONE-EX': 8.28,
    'I-VVS1-GOOD-EX-NONE-EX': 8.28,
    'D-SI2-EX-EX-MEDIUM-EX': 8.27,
    'E-SI2-EX-EX-FAINT-EX': 8.27,
    'F-SI2-EX-EX-NONE-EX': 8.27,
    'D-VS2-EX-VG-STRONG-EX': 8.26,
    'D-VS2-VG-EX-STRONG-EX': 8.26,
    'E-VS2-VG-EX-MEDIUM-EX': 8.26,
    'E-VS2-EX-VG-MEDIUM-EX': 8.26,
    'E-VVS2-GOOD-EX-STRONG-EX': 8.26,
    'E-VVS2-VG-VG-STRONG-EX': 8.26,
    'E-VVS2-EX-GOOD-STRONG-EX': 8.26,
    'F-VS2-VG-EX-FAINT-EX': 8.26,
    'F-VS2-EX-VG-FAINT-EX': 8.26,
    'F-VVS2-EX-GOOD-MEDIUM-EX': 8.26,
    'F-VVS2-VG-VG-MEDIUM-EX': 8.26,
    'F-VVS2-GOOD-EX-MEDIUM-EX': 8.26,
    'G-VVS2-GOOD-EX-FAINT-EX': 8.26,
    'G-VS2-EX-VG-NONE-EX': 8.26,
    'G-VS2-VG-EX-NONE-EX': 8.26,
    'G-VVS2-EX-GOOD-FAINT-EX': 8.26,
    'G-VVS2-VG-VG-FAINT-EX': 8.26,
    'H-VVS2-GOOD-EX-NONE-EX': 8.26,
    'H-VVS2-VG-VG-NONE-EX': 8.26,
    'H-VVS2-EX-GOOD-NONE-EX': 8.26,
    'D-IF-GOOD-GOOD-NONE-VG': 8.25,
    'D-IF-VG-POOR-NONE-VG': 8.25,
    'D-IF-VG-EX-NONE-GOOD': 8.25,
    'D-IF-EX-VG-NONE-GOOD': 8.25,
    'D-IF-POOR-VG-NONE-VG': 8.25,
    'F-IF-GOOD-VG-STRONG-EX': 8.25,
    'F-IF-VG-GOOD-STRONG-EX': 8.25,
    'F-IF-EX-EX-STRONG-VG': 8.25,
    'F-IF-POOR-EX-STRONG-EX': 8.25,
    'F-IF-EX-POOR-STRONG-EX': 8.25,
    'G-IF-VG-GOOD-MEDIUM-EX': 8.25,
    'G-IF-EX-EX-MEDIUM-VG': 8.25,
    'G-IF-EX-POOR-MEDIUM-EX': 8.25,
    'G-IF-GOOD-VG-MEDIUM-EX': 8.25,
    'G-IF-POOR-EX-MEDIUM-EX': 8.25,
    'H-IF-VG-GOOD-FAINT-EX': 8.25,
    'H-IF-EX-POOR-FAINT-EX': 8.25,
    'H-IF-GOOD-VG-FAINT-EX': 8.25,
    'H-IF-EX-EX-FAINT-VG': 8.25,
    'H-IF-POOR-EX-FAINT-EX': 8.25,
    'I-IF-VG-GOOD-NONE-EX': 8.25,
    'I-IF-GOOD-VG-NONE-EX': 8.25,
    'I-IF-EX-POOR-NONE-EX': 8.25,
    'I-IF-EX-EX-NONE-VG': 8.25,
    'I-IF-POOR-EX-NONE-EX': 8.25,
    'D-I1-EX-EX-FAINT-EX': 8.24,
    'D-SI1-VG-EX-MEDIUM-EX': 8.24,
    'D-SI1-EX-VG-MEDIUM-EX': 8.24,
    'E-SI1-VG-EX-FAINT-EX': 8.24,
    'E-I1-EX-EX-NONE-EX': 8.24,
    'E-SI1-EX-VG-FAINT-EX': 8.24,
    'F-SI1-VG-EX-NONE-EX': 8.24,
    'F-SI1-EX-VG-NONE-EX': 8.24,
    'D-VS1-EX-GOOD-STRONG-EX': 8.23,
    'D-VS1-GOOD-EX-STRONG-EX': 8.23,
    'D-VS1-VG-VG-STRONG-EX': 8.23,
    'E-VVS1-EX-EX-STRONG-VG': 8.23,
    'E-VS1-EX-GOOD-MEDIUM-EX': 8.23,
    'E-VVS1-GOOD-VG-STRONG-EX': 8.23,
    'E-VS1-VG-VG-MEDIUM-EX': 8.23,
    'E-VS1-GOOD-EX-MEDIUM-EX': 8.23,
    'E-VVS1-VG-GOOD-STRONG-EX': 8.23,
    'E-VVS1-EX-POOR-STRONG-EX': 8.23,
    'E-VVS1-POOR-EX-STRONG-EX': 8.23,
    'F-VS1-EX-GOOD-FAINT-EX': 8.23,
    'F-VS1-VG-VG-FAINT-EX': 8.23,
    'F-VVS1-GOOD-VG-MEDIUM-EX': 8.23,
    'F-VVS1-VG-GOOD-MEDIUM-EX': 8.23,
    'F-VVS1-EX-POOR-MEDIUM-EX': 8.23,
    'F-VVS1-EX-EX-MEDIUM-VG': 8.23,
    'F-VVS1-POOR-EX-MEDIUM-EX': 8.23,
    'F-VS1-GOOD-EX-FAINT-EX': 8.23,
    'G-VVS1-POOR-EX-FAINT-EX': 8.23,
    'G-VVS1-EX-POOR-FAINT-EX': 8.23,
    'G-VVS1-EX-EX-FAINT-VG': 8.23,
    'G-VVS1-VG-GOOD-FAINT-EX': 8.23,
    'G-VS1-GOOD-EX-NONE-EX': 8.23,
    'G-VS1-VG-VG-NONE-EX': 8.23,
    'G-VS1-EX-GOOD-NONE-EX': 8.23,
    'G-VVS1-GOOD-VG-FAINT-EX': 8.23,
    'H-VVS1-GOOD-VG-NONE-EX': 8.23,
    'H-VVS1-VG-GOOD-NONE-EX': 8.23,
    'H-VVS1-POOR-EX-NONE-EX': 8.23,
    'H-VVS1-EX-EX-NONE-VG': 8.23,
    'H-VVS1-EX-POOR-NONE-EX': 8.23,
    'D-I2-EX-EX-NONE-EX': 8.22,
    'D-SI2-EX-VG-FAINT-EX': 8.22,
    'D-SI2-VG-EX-FAINT-EX': 8.22,
    'E-SI2-VG-EX-NONE-EX': 8.22,
    'E-SI2-EX-VG-NONE-EX': 8.22,
    'D-VS2-VG-VG-MEDIUM-EX': 8.21,
    'D-VVS2-EX-EX-STRONG-VG': 8.21,
    'D-VVS2-VG-GOOD-STRONG-EX': 8.21,
    'D-VVS2-POOR-EX-STRONG-EX': 8.21,
    'D-VS2-EX-GOOD-MEDIUM-EX': 8.21,
    'D-VVS2-EX-POOR-STRONG-EX': 8.21,
    'D-VS2-GOOD-EX-MEDIUM-EX': 8.21,
    'D-VVS2-GOOD-VG-STRONG-EX': 8.21,
    'E-VS2-EX-GOOD-FAINT-EX': 8.21,
    'E-VVS2-EX-POOR-MEDIUM-EX': 8.21,
    'E-VVS2-POOR-EX-MEDIUM-EX': 8.21,
    'E-VVS2-EX-EX-MEDIUM-VG': 8.21,
    'E-VVS2-VG-GOOD-MEDIUM-EX': 8.21,
    'E-VS2-GOOD-EX-FAINT-EX': 8.21,
    'E-VS2-VG-VG-FAINT-EX': 8.21,
    'E-VVS2-GOOD-VG-MEDIUM-EX': 8.21,
    'F-VS2-EX-GOOD-NONE-EX': 8.21,
    'F-VS2-VG-VG-NONE-EX': 8.21,
    'F-VS2-GOOD-EX-NONE-EX': 8.21,
    'F-VVS2-POOR-EX-FAINT-EX': 8.21,
    'F-VVS2-GOOD-VG-FAINT-EX': 8.21,
    'F-VVS2-VG-GOOD-FAINT-EX': 8.21,
    'F-VVS2-EX-POOR-FAINT-EX': 8.21,
    'F-VVS2-EX-EX-FAINT-VG': 8.21,
    'G-VVS2-VG-GOOD-NONE-EX': 8.21,
    'G-VVS2-GOOD-VG-NONE-EX': 8.21,
    'G-VVS2-EX-POOR-NONE-EX': 8.21,
    'G-VVS2-EX-EX-NONE-VG': 8.21,
    'G-VVS2-POOR-EX-NONE-EX': 8.21,
    'E-IF-EX-VG-STRONG-VG': 8.2,
    'E-IF-GOOD-GOOD-STRONG-EX': 8.2,
    'E-IF-POOR-VG-STRONG-EX': 8.2,
    'E-IF-VG-POOR-STRONG-EX': 8.2,
    'E-IF-VG-EX-STRONG-VG': 8.2,
    'F-IF-EX-VG-MEDIUM-VG': 8.2,
    'F-IF-POOR-VG-MEDIUM-EX': 8.2,
    'F-IF-GOOD-GOOD-MEDIUM-EX': 8.2,
    'F-IF-VG-POOR-MEDIUM-EX': 8.2,
    'F-IF-VG-EX-MEDIUM-VG': 8.2,
    'G-IF-POOR-VG-FAINT-EX': 8.2,
    'G-IF-EX-VG-FAINT-VG': 8.2,
    'G-IF-GOOD-GOOD-FAINT-EX': 8.2,
    'G-IF-VG-POOR-FAINT-EX': 8.2,
    'G-IF-VG-EX-FAINT-VG': 8.2,
    'H-IF-VG-EX-NONE-VG': 8.2,
    'H-IF-EX-VG-NONE-VG': 8.2,
    'H-IF-POOR-VG-NONE-EX': 8.2,
    'H-IF-GOOD-GOOD-NONE-EX': 8.2,
    'H-IF-VG-POOR-NONE-EX': 8.2,
    'J-IF-EX-EX-STRONG-EX': 8.2,
    'K-IF-EX-EX-MEDIUM-EX': 8.2,
    'L-IF-EX-EX-FAINT-EX': 8.2,
    'M-IF-EX-EX-NONE-EX': 8.2,
    'D-I1-EX-VG-NONE-EX': 8.19,
    'D-SI1-VG-VG-FAINT-EX': 8.19,
    'D-SI1-EX-GOOD-FAINT-EX': 8.19,
    'D-SI1-GOOD-EX-FAINT-EX': 8.19,
    'D-I1-VG-EX-NONE-EX': 8.19,
    'E-SI1-VG-VG-NONE-EX': 8.19,
    'E-SI1-GOOD-EX-NONE-EX': 8.19,
    'E-SI1-EX-GOOD-NONE-EX': 8.19,
    'D-VVS1-VG-POOR-STRONG-EX': 8.18,
    'D-VS1-POOR-EX-MEDIUM-EX': 8.18,
    'D-VVS1-POOR-VG-STRONG-EX': 8.18,
    'D-VVS1-GOOD-GOOD-STRONG-EX': 8.18,
    'D-VS1-GOOD-VG-MEDIUM-EX': 8.18,
    'D-VVS1-EX-VG-STRONG-VG': 8.18,
    'D-VVS1-VG-EX-STRONG-VG': 8.18,
    'D-VS1-VG-GOOD-MEDIUM-EX': 8.18,
    'D-VS1-EX-EX-MEDIUM-VG': 8.18,
    'D-VS1-EX-POOR-MEDIUM-EX': 8.18,
    'E-VS1-EX-EX-FAINT-VG': 8.18,
    'E-VS1-EX-POOR-FAINT-EX': 8.18,
    'E-VS1-POOR-EX-FAINT-EX': 8.18,
    'E-VS1-GOOD-VG-FAINT-EX': 8.18,
    'E-VS1-VG-GOOD-FAINT-EX': 8.18,
    'E-VVS1-EX-VG-MEDIUM-VG': 8.18,
    'E-VVS1-VG-EX-MEDIUM-VG': 8.18,
    'E-VVS1-VG-POOR-MEDIUM-EX': 8.18,
    'E-VVS1-POOR-VG-MEDIUM-EX': 8.18,
    'E-VVS1-GOOD-GOOD-MEDIUM-EX': 8.18,
    'F-VVS1-EX-VG-FAINT-VG': 8.18,
    'F-VVS1-VG-EX-FAINT-VG': 8.18,
    'F-VVS1-VG-POOR-FAINT-EX': 8.18,
    'F-VVS1-GOOD-GOOD-FAINT-EX': 8.18,
    'F-VVS1-POOR-VG-FAINT-EX': 8.18,
    'F-VS1-POOR-EX-NONE-EX': 8.18,
    'F-VS1-GOOD-VG-NONE-EX': 8.18,
    'F-VS1-VG-GOOD-NONE-EX': 8.18,
    'F-VS1-EX-POOR-NONE-EX': 8.18,
    'F-VS1-EX-EX-NONE-VG': 8.18,
    'G-VVS1-POOR-VG-NONE-EX': 8.18,
    'G-VVS1-GOOD-GOOD-NONE-EX': 8.18,
    'G-VVS1-VG-POOR-NONE-EX': 8.18,
    'G-VVS1-VG-EX-NONE-VG': 8.18,
    'G-VVS1-EX-VG-NONE-VG': 8.18,
    'I-VVS1-EX-EX-STRONG-EX': 8.18,
    'J-VVS1-EX-EX-MEDIUM-EX': 8.18,
    'K-VVS1-EX-EX-FAINT-EX': 8.18,
    'L-VVS1-EX-EX-NONE-EX': 8.18,
    'D-SI2-EX-GOOD-NONE-EX': 8.17,
    'D-SI2-VG-VG-NONE-EX': 8.17,
    'D-SI2-GOOD-EX-NONE-EX': 8.17,
    'D-VS2-EX-POOR-FAINT-EX': 8.16,
    'D-VS2-EX-EX-FAINT-VG': 8.16,
    'D-VS2-GOOD-VG-FAINT-EX': 8.16,
    'D-VS2-POOR-EX-FAINT-EX': 8.16,
    'D-VS2-VG-GOOD-FAINT-EX': 8.16,
    'D-VVS2-VG-POOR-MEDIUM-EX': 8.16,
    'D-VVS2-GOOD-GOOD-MEDIUM-EX': 8.16,
    'D-VVS2-POOR-VG-MEDIUM-EX': 8.16,
    'D-VVS2-EX-VG-MEDIUM-VG': 8.16,
    'D-VVS2-VG-EX-MEDIUM-VG': 8.16,
    'E-VVS2-GOOD-GOOD-FAINT-EX': 8.16,
    'E-VVS2-VG-POOR-FAINT-EX': 8.16,
    'E-VVS2-VG-EX-FAINT-VG': 8.16,
    'E-VVS2-EX-VG-FAINT-VG': 8.16,
    'E-VS2-POOR-EX-NONE-EX': 8.16,
    'E-VVS2-POOR-VG-FAINT-EX': 8.16,
    'E-VS2-VG-GOOD-NONE-EX': 8.16,
    'E-VS2-EX-EX-NONE-VG': 8.16,
    'E-VS2-EX-POOR-NONE-EX': 8.16,
    'E-VS2-GOOD-VG-NONE-EX': 8.16,
    'F-VVS2-VG-POOR-NONE-EX': 8.16,
    'F-VVS2-EX-VG-NONE-VG': 8.16,
    'F-VVS2-GOOD-GOOD-NONE-EX': 8.16,
    'F-VVS2-POOR-VG-NONE-EX': 8.16,
    'F-VVS2-VG-EX-NONE-VG': 8.16,
    'H-VVS2-EX-EX-STRONG-EX': 8.16,
    'I-VVS2-EX-EX-MEDIUM-EX': 8.16,
    'J-VVS2-EX-EX-FAINT-EX': 8.16,
    'K-VVS2-EX-EX-NONE-EX': 8.16,
    'D-IF-GOOD-POOR-STRONG-EX': 8.15,
    'D-IF-EX-GOOD-STRONG-VG': 8.15,
    'D-IF-POOR-GOOD-STRONG-EX': 8.15,
    'D-IF-VG-VG-STRONG-VG': 8.15,
    'D-IF-GOOD-EX-STRONG-VG': 8.15,
    'E-IF-VG-VG-MEDIUM-VG': 8.15,
    'E-IF-GOOD-POOR-MEDIUM-EX': 8.15,
    'E-IF-GOOD-EX-MEDIUM-VG': 8.15,
    'E-IF-EX-GOOD-MEDIUM-VG': 8.15,
    'E-IF-POOR-GOOD-MEDIUM-EX': 8.15,
    'F-IF-EX-GOOD-FAINT-VG': 8.15,
    'F-IF-POOR-GOOD-FAINT-EX': 8.15,
    'F-IF-VG-VG-FAINT-VG': 8.15,
    'F-IF-GOOD-EX-FAINT-VG': 8.15,
    'F-IF-GOOD-POOR-FAINT-EX': 8.15,
    'G-IF-POOR-GOOD-NONE-EX': 8.15,
    'G-IF-GOOD-POOR-NONE-EX': 8.15,
    'G-IF-VG-VG-NONE-VG': 8.15,
    'G-IF-GOOD-EX-NONE-VG': 8.15,
    'G-IF-EX-GOOD-NONE-VG': 8.15,
    'I-IF-EX-VG-STRONG-EX': 8.15,
    'I-IF-VG-EX-STRONG-EX': 8.15,
    'J-IF-VG-EX-MEDIUM-EX': 8.15,
    'J-IF-EX-VG-MEDIUM-EX': 8.15,
    'K-IF-EX-VG-FAINT-EX': 8.15,
    'K-IF-VG-EX-FAINT-EX': 8.15,
    'L-IF-VG-EX-NONE-EX': 8.15,
    'L-IF-EX-VG-NONE-EX': 8.15,
    'D-SI1-EX-POOR-NONE-EX': 8.14,
    'D-SI1-GOOD-VG-NONE-EX': 8.14,
    'D-SI1-POOR-EX-NONE-EX': 8.14,
    'D-SI1-EX-EX-NONE-VG': 8.14,
    'D-SI1-VG-GOOD-NONE-EX': 8.14,
    'D-VS1-VG-POOR-FAINT-EX': 8.13,
    'D-VS1-POOR-VG-FAINT-EX': 8.13,
    'D-VS1-GOOD-GOOD-FAINT-EX': 8.13,
    'D-VVS1-VG-VG-MEDIUM-VG': 8.13,
    'D-VVS1-EX-GOOD-MEDIUM-VG': 8.13,
    'D-VVS1-GOOD-POOR-MEDIUM-EX': 8.13,
    'D-VVS1-POOR-GOOD-MEDIUM-EX': 8.13,
    'D-VS1-EX-VG-FAINT-VG': 8.13,
    'D-VS1-VG-EX-FAINT-VG': 8.13,
    'D-VVS1-GOOD-EX-MEDIUM-VG': 8.13,
    'E-VVS1-GOOD-EX-FAINT-VG': 8.13,
    'E-VVS1-EX-GOOD-FAINT-VG': 8.13,
    'E-VVS1-POOR-GOOD-FAINT-EX': 8.13,
    'E-VVS1-GOOD-POOR-FAINT-EX': 8.13,
    'E-VVS1-VG-VG-FAINT-VG': 8.13,
    'E-VS1-POOR-VG-NONE-EX': 8.13,
    'E-VS1-GOOD-GOOD-NONE-EX': 8.13,
    'E-VS1-VG-POOR-NONE-EX': 8.13,
    'E-VS1-EX-VG-NONE-VG': 8.13,
    'E-VS1-VG-EX-NONE-VG': 8.13,
    'F-VVS1-POOR-GOOD-NONE-EX': 8.13,
    'F-VVS1-GOOD-POOR-NONE-EX': 8.13,
    'F-VVS1-GOOD-EX-NONE-VG': 8.13,
    'F-VVS1-VG-VG-NONE-VG': 8.13,
    'F-VVS1-EX-GOOD-NONE-VG': 8.13,
    'G-VS1-EX-EX-STRONG-EX': 8.13,
    'H-VS1-EX-EX-MEDIUM-EX': 8.13,
    'H-VVS1-VG-EX-STRONG-EX': 8.13,
    'H-VVS1-EX-VG-STRONG-EX': 8.13,
    'I-VVS1-VG-EX-MEDIUM-EX': 8.13,
    'I-VS1-EX-EX-FAINT-EX': 8.13,
    'I-VVS1-EX-VG-MEDIUM-EX': 8.13,
    'J-VS1-EX-EX-NONE-EX': 8.13,
    'J-VVS1-EX-VG-FAINT-EX': 8.13,
    'J-VVS1-VG-EX-FAINT-EX': 8.13,
    'K-VVS1-VG-EX-NONE-EX': 8.13,
    'K-VVS1-EX-VG-NONE-EX': 8.13,
    'D-VS2-POOR-VG-NONE-EX': 8.11,
    'D-VS2-EX-VG-NONE-VG': 8.11,
    'D-VVS2-POOR-GOOD-FAINT-EX': 8.11,
    'D-VVS2-VG-VG-FAINT-VG': 8.11,
    'D-VS2-GOOD-GOOD-NONE-EX': 8.11,
    'D-VS2-VG-EX-NONE-VG': 8.11,
    'D-VVS2-EX-GOOD-FAINT-VG': 8.11,
    'D-VS2-VG-POOR-NONE-EX': 8.11,
    'D-VVS2-GOOD-EX-FAINT-VG': 8.11,
    'D-VVS2-GOOD-POOR-FAINT-EX': 8.11,
    'E-VVS2-GOOD-EX-NONE-VG': 8.11,
    'E-VVS2-VG-VG-NONE-VG': 8.11,
    'E-VVS2-EX-GOOD-NONE-VG': 8.11,
    'E-VVS2-GOOD-POOR-NONE-EX': 8.11,
    'E-VVS2-POOR-GOOD-NONE-EX': 8.11,
    'F-VS2-EX-EX-STRONG-EX': 8.11,
    'G-VVS2-VG-EX-STRONG-EX': 8.11,
    'G-VS2-EX-EX-MEDIUM-EX': 8.11,
    'G-VVS2-EX-VG-STRONG-EX': 8.11,
    'H-VS2-EX-EX-FAINT-EX': 8.11,
    'H-VVS2-VG-EX-MEDIUM-EX': 8.11,
    'H-VVS2-EX-VG-MEDIUM-EX': 8.11,
    'I-VS2-EX-EX-NONE-EX': 8.11,
    'I-VVS2-VG-EX-FAINT-EX': 8.11,
    'I-VVS2-EX-VG-FAINT-EX': 8.11,
    'J-VVS2-VG-EX-NONE-EX': 8.11,
    'J-VVS2-EX-VG-NONE-EX': 8.11,
    'D-IF-POOR-POOR-MEDIUM-EX': 8.1,
    'D-IF-VG-GOOD-MEDIUM-VG': 8.1,
    'D-IF-POOR-EX-MEDIUM-VG': 8.1,
    'D-IF-EX-POOR-MEDIUM-VG': 8.1,
    'D-IF-EX-EX-MEDIUM-GOOD': 8.1,
    'D-IF-GOOD-VG-MEDIUM-VG': 8.1,
    'E-IF-EX-POOR-FAINT-VG': 8.1,
    'E-IF-POOR-EX-FAINT-VG': 8.1,
    'E-IF-EX-EX-FAINT-GOOD': 8.1,
    'E-IF-POOR-POOR-FAINT-EX': 8.1,
    'E-IF-GOOD-VG-FAINT-VG': 8.1,
    'E-IF-VG-GOOD-FAINT-VG': 8.1,
    'F-IF-POOR-POOR-NONE-EX': 8.1,
    'F-IF-POOR-EX-NONE-VG': 8.1,
    'F-IF-GOOD-VG-NONE-VG': 8.1,
    'F-IF-VG-GOOD-NONE-VG': 8.1,
    'F-IF-EX-POOR-NONE-VG': 8.1,
    'F-IF-EX-EX-NONE-GOOD': 8.1,
    'H-IF-EX-GOOD-STRONG-EX': 8.1,
    'H-IF-GOOD-EX-STRONG-EX': 8.1,
    'H-IF-VG-VG-STRONG-EX': 8.1,
    'I-IF-EX-GOOD-MEDIUM-EX': 8.1,
    'I-IF-GOOD-EX-MEDIUM-EX': 8.1,
    'I-IF-VG-VG-MEDIUM-EX': 8.1,
    'J-IF-EX-GOOD-FAINT-EX': 8.1,
    'J-IF-VG-VG-FAINT-EX': 8.1,
    'J-IF-GOOD-EX-FAINT-EX': 8.1,
    'K-IF-VG-VG-NONE-EX': 8.1,
    'K-IF-EX-GOOD-NONE-EX': 8.1,
    'K-IF-GOOD-EX-NONE-EX': 8.1,
    'E-SI1-EX-EX-STRONG-EX': 8.09,
    'F-SI1-EX-EX-MEDIUM-EX': 8.09,
    'G-SI1-EX-EX-FAINT-EX': 8.09,
    'H-SI1-EX-EX-NONE-EX': 8.09,
    'D-VVS1-POOR-POOR-FAINT-EX': 8.08,
    'D-VVS1-POOR-EX-FAINT-VG': 8.08,
    'D-VS1-GOOD-POOR-NONE-EX': 8.08,
    'D-VVS1-EX-POOR-FAINT-VG': 8.08,
    'D-VS1-GOOD-EX-NONE-VG': 8.08,
    'D-VS1-VG-VG-NONE-VG': 8.08,
    'D-VS1-EX-GOOD-NONE-VG': 8.08,
    'D-VVS1-EX-EX-FAINT-GOOD': 8.08,
    'D-VS1-POOR-GOOD-NONE-EX': 8.08,
    'D-VVS1-GOOD-VG-FAINT-VG': 8.08,
    'D-VVS1-VG-GOOD-FAINT-VG': 8.08,
    'E-VVS1-GOOD-VG-NONE-VG': 8.08,
    'E-VVS1-VG-GOOD-NONE-VG': 8.08,
    'E-VVS1-EX-POOR-NONE-VG': 8.08,
    'E-VVS1-EX-EX-NONE-GOOD': 8.08,
    'E-VVS1-POOR-EX-NONE-VG': 8.08,
    'E-VVS1-POOR-POOR-NONE-EX': 8.08,
    'F-VS1-EX-VG-STRONG-EX': 8.08,
    'F-VS1-VG-EX-STRONG-EX': 8.08,
    'G-VVS1-GOOD-EX-STRONG-EX': 8.08,
    'G-VVS1-VG-VG-STRONG-EX': 8.08,
    'G-VVS1-EX-GOOD-STRONG-EX': 8.08,
    'G-VS1-VG-EX-MEDIUM-EX': 8.08,
    'G-VS1-EX-VG-MEDIUM-EX': 8.08,
    'H-VVS1-GOOD-EX-MEDIUM-EX': 8.08,
    'H-VVS1-EX-GOOD-MEDIUM-EX': 8.08,
    'H-VS1-EX-VG-FAINT-EX': 8.08,
    'H-VS1-VG-EX-FAINT-EX': 8.08,
    'H-VVS1-VG-VG-MEDIUM-EX': 8.08,
    'I-VVS1-GOOD-EX-FAINT-EX': 8.08,
    'I-VVS1-VG-VG-FAINT-EX': 8.08,
    'I-VVS1-EX-GOOD-FAINT-EX': 8.08,
    'I-VS1-EX-VG-NONE-EX': 8.08,
    'I-VS1-VG-EX-NONE-EX': 8.08,
    'J-VVS1-GOOD-EX-NONE-EX': 8.08,
    'J-VVS1-EX-GOOD-NONE-EX': 8.08,
    'J-VVS1-VG-VG-NONE-EX': 8.08,
    'D-SI2-EX-EX-STRONG-EX': 8.07,
    'E-SI2-EX-EX-MEDIUM-EX': 8.07,
    'F-SI2-EX-EX-FAINT-EX': 8.07,
    'G-SI2-EX-EX-NONE-EX': 8.07,
    'D-VVS2-VG-GOOD-NONE-VG': 8.06,
    'D-VVS2-EX-EX-NONE-GOOD': 8.06,
    'D-VVS2-EX-POOR-NONE-VG': 8.06,
    'D-VVS2-POOR-EX-NONE-VG': 8.06,
    'D-VVS2-GOOD-VG-NONE-VG': 8.06,
    'D-VVS2-POOR-POOR-NONE-EX': 8.06,
    'E-VS2-EX-VG-STRONG-EX': 8.06,
    'E-VS2-VG-EX-STRONG-EX': 8.06,
    'F-VVS2-VG-VG-STRONG-EX': 8.06,
    'F-VVS2-GOOD-EX-STRONG-EX': 8.06,
    'F-VVS2-EX-GOOD-STRONG-EX': 8.06,
    'F-VS2-VG-EX-MEDIUM-EX': 8.06,
    'F-VS2-EX-VG-MEDIUM-EX': 8.06,
    'G-VVS2-VG-VG-MEDIUM-EX': 8.06,
    'G-VVS2-GOOD-EX-MEDIUM-EX': 8.06,
    'G-VVS2-EX-GOOD-MEDIUM-EX': 8.06,
    'G-VS2-VG-EX-FAINT-EX': 8.06,
    'G-VS2-EX-VG-FAINT-EX': 8.06,
    'H-VS2-EX-VG-NONE-EX': 8.06,
    'H-VS2-VG-EX-NONE-EX': 8.06,
    'H-VVS2-EX-GOOD-FAINT-EX': 8.06,
    'H-VVS2-VG-VG-FAINT-EX': 8.06,
    'H-VVS2-GOOD-EX-FAINT-EX': 8.06,
    'I-VVS2-GOOD-EX-NONE-EX': 8.06,
    'I-VVS2-VG-VG-NONE-EX': 8.06,
    'I-VVS2-EX-GOOD-NONE-EX': 8.06,
    'D-IF-POOR-VG-FAINT-VG': 8.05,
    'D-IF-GOOD-GOOD-FAINT-VG': 8.05,
    'D-IF-VG-POOR-FAINT-VG': 8.05,
    'D-IF-VG-EX-FAINT-GOOD': 8.05,
    'D-IF-EX-VG-FAINT-GOOD': 8.05,
    'E-IF-POOR-VG-NONE-VG': 8.05,
    'E-IF-GOOD-GOOD-NONE-VG': 8.05,
    'E-IF-VG-POOR-NONE-VG': 8.05,
    'E-IF-EX-VG-NONE-GOOD': 8.05,
    'E-IF-VG-EX-NONE-GOOD': 8.05,
    'G-IF-VG-GOOD-STRONG-EX': 8.05,
    'G-IF-EX-EX-STRONG-VG': 8.05,
    'G-IF-EX-POOR-STRONG-EX': 8.05,
    'G-IF-POOR-EX-STRONG-EX': 8.05,
    'G-IF-GOOD-VG-STRONG-EX': 8.05,
    'H-IF-POOR-EX-MEDIUM-EX': 8.05,
    'H-IF-EX-EX-MEDIUM-VG': 8.05,
    'H-IF-EX-POOR-MEDIUM-EX': 8.05,
    'H-IF-GOOD-VG-MEDIUM-EX': 8.05,
    'H-IF-VG-GOOD-MEDIUM-EX': 8.05,
    'I-IF-VG-GOOD-FAINT-EX': 8.05,
    'I-IF-POOR-EX-FAINT-EX': 8.05,
    'I-IF-EX-EX-FAINT-VG': 8.05,
    'I-IF-GOOD-VG-FAINT-EX': 8.05,
    'I-IF-EX-POOR-FAINT-EX': 8.05,
    'J-IF-EX-EX-NONE-VG': 8.05,
    'J-IF-EX-POOR-NONE-EX': 8.05,
    'J-IF-VG-GOOD-NONE-EX': 8.05,
    'J-IF-GOOD-VG-NONE-EX': 8.05,
    'J-IF-POOR-EX-NONE-EX': 8.05,
    'D-I1-EX-EX-MEDIUM-EX': 8.04,
    'D-SI1-EX-VG-STRONG-EX': 8.04,
    'D-SI1-VG-EX-STRONG-EX': 8.04,
    'E-SI1-VG-EX-MEDIUM-EX': 8.04,
    'E-SI1-EX-VG-MEDIUM-EX': 8.04,
    'E-I1-EX-EX-FAINT-EX': 8.04,
    'F-SI1-EX-VG-FAINT-EX': 8.04,
    'F-SI1-VG-EX-FAINT-EX': 8.04,
    'F-I1-EX-EX-NONE-EX': 8.04,
    'G-SI1-EX-VG-NONE-EX': 8.04,
    'G-SI1-VG-EX-NONE-EX': 8.04,
    'D-VVS1-EX-VG-NONE-GOOD': 8.03,
    'D-VVS1-GOOD-GOOD-NONE-VG': 8.03,
    'D-VVS1-VG-POOR-NONE-VG': 8.03,
    'D-VVS1-VG-EX-NONE-GOOD': 8.03,
    'D-VVS1-POOR-VG-NONE-VG': 8.03,
    'E-VS1-EX-GOOD-STRONG-EX': 8.03,
    'E-VS1-VG-VG-STRONG-EX': 8.03,
    'E-VS1-GOOD-EX-STRONG-EX': 8.03,
    'F-VVS1-EX-EX-STRONG-VG': 8.03,
    'F-VVS1-EX-POOR-STRONG-EX': 8.03,
    'F-VVS1-VG-GOOD-STRONG-EX': 8.03,
    'F-VVS1-GOOD-VG-STRONG-EX': 8.03,
    'F-VVS1-POOR-EX-STRONG-EX': 8.03,
    'F-VS1-VG-VG-MEDIUM-EX': 8.03,
    'F-VS1-EX-GOOD-MEDIUM-EX': 8.03,
    'F-VS1-GOOD-EX-MEDIUM-EX': 8.03,
    'G-VVS1-EX-EX-MEDIUM-VG': 8.03,
    'G-VVS1-EX-POOR-MEDIUM-EX': 8.03,
    'G-VS1-EX-GOOD-FAINT-EX': 8.03,
    'G-VS1-VG-VG-FAINT-EX': 8.03,
    'G-VS1-GOOD-EX-FAINT-EX': 8.03,
    'G-VVS1-POOR-EX-MEDIUM-EX': 8.03,
    'G-VVS1-GOOD-VG-MEDIUM-EX': 8.03,
    'G-VVS1-VG-GOOD-MEDIUM-EX': 8.03,
    'H-VVS1-EX-EX-FAINT-VG': 8.03,
    'H-VVS1-GOOD-VG-FAINT-EX': 8.03,
    'H-VVS1-EX-POOR-FAINT-EX': 8.03,
    'H-VS1-EX-GOOD-NONE-EX': 8.03,
    'H-VS1-VG-VG-NONE-EX': 8.03,
    'H-VS1-GOOD-EX-NONE-EX': 8.03,
    'H-VVS1-POOR-EX-FAINT-EX': 8.03,
    'H-VVS1-VG-GOOD-FAINT-EX': 8.03,
    'I-VVS1-EX-EX-NONE-VG': 8.03,
    'I-VVS1-EX-POOR-NONE-EX': 8.03,
    'I-VVS1-POOR-EX-NONE-EX': 8.03,
    'I-VVS1-GOOD-VG-NONE-EX': 8.03,
    'I-VVS1-VG-GOOD-NONE-EX': 8.03,
    'D-SI2-EX-VG-MEDIUM-EX': 8.02,
    'D-SI2-VG-EX-MEDIUM-EX': 8.02,
    'D-I2-EX-EX-FAINT-EX': 8.02,
    'E-SI2-EX-VG-FAINT-EX': 8.02,
    'E-I2-EX-EX-NONE-EX': 8.02,
    'E-SI2-VG-EX-FAINT-EX': 8.02,
    'F-SI2-VG-EX-NONE-EX': 8.02,
    'F-SI2-EX-VG-NONE-EX': 8.02,
    'D-VS2-GOOD-EX-STRONG-EX': 8.01,
    'D-VS2-VG-VG-STRONG-EX': 8.01,
    'D-VS2-EX-GOOD-STRONG-EX': 8.01,
    'E-VVS2-POOR-EX-STRONG-EX': 8.01,
    'E-VVS2-EX-EX-STRONG-VG': 8.01,
    'E-VVS2-EX-POOR-STRONG-EX': 8.01,
    'E-VVS2-VG-GOOD-STRONG-EX': 8.01,
    'E-VS2-GOOD-EX-MEDIUM-EX': 8.01,
    'E-VS2-VG-VG-MEDIUM-EX': 8.01,
    'E-VS2-EX-GOOD-MEDIUM-EX': 8.01,
    'E-VVS2-GOOD-VG-STRONG-EX': 8.01,
    'F-VVS2-EX-POOR-MEDIUM-EX': 8.01,
    'F-VVS2-EX-EX-MEDIUM-VG': 8.01,
    'F-VS2-GOOD-EX-FAINT-EX': 8.01,
    'F-VVS2-GOOD-VG-MEDIUM-EX': 8.01,
    'F-VVS2-VG-GOOD-MEDIUM-EX': 8.01,
    'F-VVS2-POOR-EX-MEDIUM-EX': 8.01,
    'F-VS2-EX-GOOD-FAINT-EX': 8.01,
    'F-VS2-VG-VG-FAINT-EX': 8.01,
    'G-VVS2-POOR-EX-FAINT-EX': 8.01,
    'G-VS2-EX-GOOD-NONE-EX': 8.01,
    'G-VS2-GOOD-EX-NONE-EX': 8.01,
    'G-VVS2-GOOD-VG-FAINT-EX': 8.01,
    'G-VVS2-VG-GOOD-FAINT-EX': 8.01,
    'G-VVS2-EX-POOR-FAINT-EX': 8.01,
    'G-VVS2-EX-EX-FAINT-VG': 8.01,
    'G-VS2-VG-VG-NONE-EX': 8.01,
    'H-VVS2-POOR-EX-NONE-EX': 8.01,
    'H-VVS2-EX-POOR-NONE-EX': 8.01,
    'H-VVS2-GOOD-VG-NONE-EX': 8.01,
    'H-VVS2-VG-GOOD-NONE-EX': 8.01,
    'H-VVS2-EX-EX-NONE-VG': 8.01,
    'D-IF-EX-GOOD-NONE-GOOD': 8,
    'D-IF-GOOD-POOR-NONE-VG': 8,
    'D-IF-POOR-GOOD-NONE-VG': 8,
    'D-IF-GOOD-EX-NONE-GOOD': 8,
    'D-IF-VG-VG-NONE-GOOD': 8,
    'F-IF-VG-POOR-STRONG-EX': 8,
    'F-IF-VG-EX-STRONG-VG': 8,
    'F-IF-EX-VG-STRONG-VG': 8,
    'F-IF-GOOD-GOOD-STRONG-EX': 8,
    'F-IF-POOR-VG-STRONG-EX': 8,
    'G-IF-POOR-VG-MEDIUM-EX': 8,
    'G-IF-GOOD-GOOD-MEDIUM-EX': 8,
    'G-IF-VG-POOR-MEDIUM-EX': 8,
    'G-IF-VG-EX-MEDIUM-VG': 8,
    'G-IF-EX-VG-MEDIUM-VG': 8,
    'H-IF-VG-EX-FAINT-VG': 8,
    'H-IF-POOR-VG-FAINT-EX': 8,
    'H-IF-GOOD-GOOD-FAINT-EX': 8,
    'H-IF-EX-VG-FAINT-VG': 8,
    'H-IF-VG-POOR-FAINT-EX': 8,
    'I-IF-POOR-VG-NONE-EX': 8,
    'I-IF-EX-VG-NONE-VG': 8,
    'I-IF-VG-EX-NONE-VG': 8,
    'I-IF-GOOD-GOOD-NONE-EX': 8,
    'I-IF-VG-POOR-NONE-EX': 8,
    'K-IF-EX-EX-STRONG-EX': 8,
    'L-IF-EX-EX-MEDIUM-EX': 8,
    'M-IF-EX-EX-FAINT-EX': 8,
    'D-I1-VG-EX-FAINT-EX': 7.99,
    'D-SI1-VG-VG-MEDIUM-EX': 7.99,
    'D-SI1-GOOD-EX-MEDIUM-EX': 7.99,
    'D-I1-EX-VG-FAINT-EX': 7.99,
    'D-SI1-EX-GOOD-MEDIUM-EX': 7.99,
    'E-SI1-GOOD-EX-FAINT-EX': 7.99,
    'E-SI1-EX-GOOD-FAINT-EX': 7.99,
    'E-I1-VG-EX-NONE-EX': 7.99,
    'E-SI1-VG-VG-FAINT-EX': 7.99,
    'E-I1-EX-VG-NONE-EX': 7.99,
    'F-SI1-VG-VG-NONE-EX': 7.99,
    'F-SI1-EX-GOOD-NONE-EX': 7.99,
    'F-SI1-GOOD-EX-NONE-EX': 7.99,
    'D-VS1-VG-GOOD-STRONG-EX': 7.98,
    'D-VS1-EX-EX-STRONG-VG': 7.98,
    'D-VS1-EX-POOR-STRONG-EX': 7.98,
    'D-VS1-POOR-EX-STRONG-EX': 7.98,
    'D-VS1-GOOD-VG-STRONG-EX': 7.98,
    'E-VS1-VG-GOOD-MEDIUM-EX': 7.98,
    'E-VVS1-VG-POOR-STRONG-EX': 7.98,
    'E-VVS1-POOR-VG-STRONG-EX': 7.98,
    'E-VS1-EX-POOR-MEDIUM-EX': 7.98,
    'E-VVS1-GOOD-GOOD-STRONG-EX': 7.98,
    'E-VS1-GOOD-VG-MEDIUM-EX': 7.98,
    'E-VVS1-VG-EX-STRONG-VG': 7.98,
    'E-VS1-POOR-EX-MEDIUM-EX': 7.98,
    'E-VVS1-EX-VG-STRONG-VG': 7.98,
    'E-VS1-EX-EX-MEDIUM-VG': 7.98,
    'F-VVS1-EX-VG-MEDIUM-VG': 7.98,
    'F-VS1-EX-POOR-FAINT-EX': 7.98,
    'F-VS1-VG-GOOD-FAINT-EX': 7.98,
    'F-VVS1-VG-EX-MEDIUM-VG': 7.98,
    'F-VS1-GOOD-VG-FAINT-EX': 7.98,
    'F-VVS1-POOR-VG-MEDIUM-EX': 7.98,
    'F-VVS1-GOOD-GOOD-MEDIUM-EX': 7.98,
    'F-VVS1-VG-POOR-MEDIUM-EX': 7.98,
    'F-VS1-POOR-EX-FAINT-EX': 7.98,
    'F-VS1-EX-EX-FAINT-VG': 7.98,
    'G-VS1-GOOD-VG-NONE-EX': 7.98,
    'G-VS1-POOR-EX-NONE-EX': 7.98,
    'G-VVS1-POOR-VG-FAINT-EX': 7.98,
    'G-VS1-EX-EX-NONE-VG': 7.98,
    'G-VVS1-GOOD-GOOD-FAINT-EX': 7.98,
    'G-VVS1-VG-EX-FAINT-VG': 7.98,
    'G-VVS1-EX-VG-FAINT-VG': 7.98,
    'G-VVS1-VG-POOR-FAINT-EX': 7.98,
    'G-VS1-VG-GOOD-NONE-EX': 7.98,
    'G-VS1-EX-POOR-NONE-EX': 7.98,
    'H-VVS1-POOR-VG-NONE-EX': 7.98,
    'H-VVS1-EX-VG-NONE-VG': 7.98,
    'H-VVS1-VG-POOR-NONE-EX': 7.98,
    'H-VVS1-VG-EX-NONE-VG': 7.98,
    'H-VVS1-GOOD-GOOD-NONE-EX': 7.98,
    'J-VVS1-EX-EX-STRONG-EX': 7.98,
    'K-VVS1-EX-EX-MEDIUM-EX': 7.98,
    'L-VVS1-EX-EX-FAINT-EX': 7.98,
    'M-VVS1-EX-EX-NONE-EX': 7.98,
    'D-SI2-GOOD-EX-FAINT-EX': 7.97,
    'D-I2-EX-VG-NONE-EX': 7.97,
    'D-I2-VG-EX-NONE-EX': 7.97,
    'D-SI2-EX-GOOD-FAINT-EX': 7.97,
    'D-SI2-VG-VG-FAINT-EX': 7.97,
    'E-SI2-VG-VG-NONE-EX': 7.97,
    'E-SI2-EX-GOOD-NONE-EX': 7.97,
    'E-SI2-GOOD-EX-NONE-EX': 7.97,
    'D-VS2-EX-POOR-MEDIUM-EX': 7.96,
    'D-VVS2-EX-VG-STRONG-VG': 7.96,
    'D-VVS2-GOOD-GOOD-STRONG-EX': 7.96,
    'D-VS2-POOR-EX-MEDIUM-EX': 7.96,
    'D-VS2-GOOD-VG-MEDIUM-EX': 7.96,
    'D-VVS2-VG-POOR-STRONG-EX': 7.96,
    'D-VVS2-VG-EX-STRONG-VG': 7.96,
    'D-VVS2-POOR-VG-STRONG-EX': 7.96,
    'D-VS2-VG-GOOD-MEDIUM-EX': 7.96,
    'D-VS2-EX-EX-MEDIUM-VG': 7.96,
    'E-VS2-EX-POOR-FAINT-EX': 7.96,
    'E-VVS2-POOR-VG-MEDIUM-EX': 7.96,
    'E-VVS2-GOOD-GOOD-MEDIUM-EX': 7.96,
    'E-VVS2-EX-VG-MEDIUM-VG': 7.96,
    'E-VS2-VG-GOOD-FAINT-EX': 7.96,
    'E-VVS2-VG-POOR-MEDIUM-EX': 7.96,
    'E-VS2-GOOD-VG-FAINT-EX': 7.96,
    'E-VS2-POOR-EX-FAINT-EX': 7.96,
    'E-VS2-EX-EX-FAINT-VG': 7.96,
    'E-VVS2-VG-EX-MEDIUM-VG': 7.96,
    'F-VS2-POOR-EX-NONE-EX': 7.96,
    'F-VVS2-VG-POOR-FAINT-EX': 7.96,
    'F-VVS2-POOR-VG-FAINT-EX': 7.96,
    'F-VVS2-VG-EX-FAINT-VG': 7.96,
    'F-VS2-VG-GOOD-NONE-EX': 7.96,
    'F-VVS2-GOOD-GOOD-FAINT-EX': 7.96,
    'F-VS2-EX-POOR-NONE-EX': 7.96,
    'F-VVS2-EX-VG-FAINT-VG': 7.96,
    'F-VS2-EX-EX-NONE-VG': 7.96,
    'F-VS2-GOOD-VG-NONE-EX': 7.96,
    'G-VVS2-EX-VG-NONE-VG': 7.96,
    'G-VVS2-POOR-VG-NONE-EX': 7.96,
    'G-VVS2-VG-POOR-NONE-EX': 7.96,
    'G-VVS2-GOOD-GOOD-NONE-EX': 7.96,
    'G-VVS2-VG-EX-NONE-VG': 7.96,
    'I-VVS2-EX-EX-STRONG-EX': 7.96,
    'J-VVS2-EX-EX-MEDIUM-EX': 7.96,
    'K-VVS2-EX-EX-FAINT-EX': 7.96,
    'L-VVS2-EX-EX-NONE-EX': 7.96,
    'E-IF-GOOD-POOR-STRONG-EX': 7.95,
    'E-IF-POOR-GOOD-STRONG-EX': 7.95,
    'E-IF-VG-VG-STRONG-VG': 7.95,
    'E-IF-EX-GOOD-STRONG-VG': 7.95,
    'E-IF-GOOD-EX-STRONG-VG': 7.95,
    'F-IF-POOR-GOOD-MEDIUM-EX': 7.95,
    'F-IF-GOOD-EX-MEDIUM-VG': 7.95,
    'F-IF-GOOD-POOR-MEDIUM-EX': 7.95,
    'F-IF-VG-VG-MEDIUM-VG': 7.95,
    'F-IF-EX-GOOD-MEDIUM-VG': 7.95,
    'G-IF-EX-GOOD-FAINT-VG': 7.95,
    'G-IF-POOR-GOOD-FAINT-EX': 7.95,
    'G-IF-GOOD-EX-FAINT-VG': 7.95,
    'G-IF-VG-VG-FAINT-VG': 7.95,
    'G-IF-GOOD-POOR-FAINT-EX': 7.95,
    'H-IF-GOOD-EX-NONE-VG': 7.95,
    'H-IF-EX-GOOD-NONE-VG': 7.95,
    'H-IF-POOR-GOOD-NONE-EX': 7.95,
    'H-IF-VG-VG-NONE-VG': 7.95,
    'H-IF-GOOD-POOR-NONE-EX': 7.95,
    'J-IF-VG-EX-STRONG-EX': 7.95,
    'J-IF-EX-VG-STRONG-EX': 7.95,
    'K-IF-EX-VG-MEDIUM-EX': 7.95,
    'K-IF-VG-EX-MEDIUM-EX': 7.95,
    'L-IF-VG-EX-FAINT-EX': 7.95,
    'L-IF-EX-VG-FAINT-EX': 7.95,
    'M-IF-EX-VG-NONE-EX': 7.95,
    'M-IF-VG-EX-NONE-EX': 7.95,
    'D-SI1-EX-EX-FAINT-VG': 7.94,
    'D-SI1-VG-GOOD-FAINT-EX': 7.94,
    'D-I1-VG-VG-NONE-EX': 7.94,
    'D-I1-GOOD-EX-NONE-EX': 7.94,
    'D-I1-EX-GOOD-NONE-EX': 7.94,
    'D-SI1-EX-POOR-FAINT-EX': 7.94,
    'D-SI1-POOR-EX-FAINT-EX': 7.94,
    'D-SI1-GOOD-VG-FAINT-EX': 7.94,
    'E-SI1-EX-EX-NONE-VG': 7.94,
    'E-SI1-POOR-EX-NONE-EX': 7.94,
    'E-SI1-GOOD-VG-NONE-EX': 7.94,
    'E-SI1-EX-POOR-NONE-EX': 7.94,
    'E-SI1-VG-GOOD-NONE-EX': 7.94,
    'D-VVS1-VG-VG-STRONG-VG': 7.93,
    'D-VVS1-POOR-GOOD-STRONG-EX': 7.93,
    'D-VVS1-GOOD-POOR-STRONG-EX': 7.93,
    'D-VVS1-GOOD-EX-STRONG-VG': 7.93,
    'D-VS1-POOR-VG-MEDIUM-EX': 7.93,
    'D-VS1-VG-POOR-MEDIUM-EX': 7.93,
    'D-VVS1-EX-GOOD-STRONG-VG': 7.93,
    'D-VS1-VG-EX-MEDIUM-VG': 7.93,
    'D-VS1-GOOD-GOOD-MEDIUM-EX': 7.93,
    'D-VS1-EX-VG-MEDIUM-VG': 7.93,
    'E-VS1-EX-VG-FAINT-VG': 7.93,
    'E-VS1-VG-EX-FAINT-VG': 7.93,
    'E-VS1-VG-POOR-FAINT-EX': 7.93,
    'E-VS1-GOOD-GOOD-FAINT-EX': 7.93,
    'E-VS1-POOR-VG-FAINT-EX': 7.93,
    'E-VVS1-VG-VG-MEDIUM-VG': 7.93,
    'E-VVS1-GOOD-POOR-MEDIUM-EX': 7.93,
    'E-VVS1-POOR-GOOD-MEDIUM-EX': 7.93,
    'E-VVS1-EX-GOOD-MEDIUM-VG': 7.93,
    'E-VVS1-GOOD-EX-MEDIUM-VG': 7.93,
    'F-VVS1-POOR-GOOD-FAINT-EX': 7.93,
    'F-VVS1-EX-GOOD-FAINT-VG': 7.93,
    'F-VVS1-GOOD-EX-FAINT-VG': 7.93,
    'F-VVS1-GOOD-POOR-FAINT-EX': 7.93,
    'F-VVS1-VG-VG-FAINT-VG': 7.93,
    'F-VS1-POOR-VG-NONE-EX': 7.93,
    'F-VS1-VG-POOR-NONE-EX': 7.93,
    'F-VS1-VG-EX-NONE-VG': 7.93,
    'F-VS1-GOOD-GOOD-NONE-EX': 7.93,
    'F-VS1-EX-VG-NONE-VG': 7.93,
    'G-VVS1-VG-VG-NONE-VG': 7.93,
    'G-VVS1-EX-GOOD-NONE-VG': 7.93,
    'G-VVS1-POOR-GOOD-NONE-EX': 7.93,
    'G-VVS1-GOOD-POOR-NONE-EX': 7.93,
    'G-VVS1-GOOD-EX-NONE-VG': 7.93,
    'H-VS1-EX-EX-STRONG-EX': 7.93,
    'I-VS1-EX-EX-MEDIUM-EX': 7.93,
    'I-VVS1-EX-VG-STRONG-EX': 7.93,
    'I-VVS1-VG-EX-STRONG-EX': 7.93,
    'J-VS1-EX-EX-FAINT-EX': 7.93,
    'J-VVS1-EX-VG-MEDIUM-EX': 7.93,
    'J-VVS1-VG-EX-MEDIUM-EX': 7.93,
    'K-VVS1-VG-EX-FAINT-EX': 7.93,
    'K-VVS1-EX-VG-FAINT-EX': 7.93,
    'K-VS1-EX-EX-NONE-EX': 7.93,
    'L-VVS1-VG-EX-NONE-EX': 7.93,
    'L-VVS1-EX-VG-NONE-EX': 7.93,
    'D-SI2-EX-POOR-NONE-EX': 7.92,
    'D-SI2-POOR-EX-NONE-EX': 7.92,
    'D-SI2-GOOD-VG-NONE-EX': 7.92,
    'D-SI2-VG-GOOD-NONE-EX': 7.92,
    'D-SI2-EX-EX-NONE-VG': 7.92,
    'D-VVS2-POOR-GOOD-MEDIUM-EX': 7.91,
    'D-VVS2-GOOD-POOR-MEDIUM-EX': 7.91,
    'D-VS2-VG-POOR-FAINT-EX': 7.91,
    'D-VS2-GOOD-GOOD-FAINT-EX': 7.91,
    'D-VS2-POOR-VG-FAINT-EX': 7.91,
    'D-VS2-EX-VG-FAINT-VG': 7.91,
    'D-VVS2-EX-GOOD-MEDIUM-VG': 7.91,
    'D-VVS2-VG-VG-MEDIUM-VG': 7.91,
    'D-VVS2-GOOD-EX-MEDIUM-VG': 7.91,
    'D-VS2-VG-EX-FAINT-VG': 7.91,
    'E-VS2-VG-EX-NONE-VG': 7.91,
    'E-VS2-VG-POOR-NONE-EX': 7.91,
    'E-VS2-POOR-VG-NONE-EX': 7.91,
    'E-VVS2-VG-VG-FAINT-VG': 7.91,
    'E-VVS2-EX-GOOD-FAINT-VG': 7.91,
    'E-VS2-GOOD-GOOD-NONE-EX': 7.91,
    'E-VVS2-GOOD-POOR-FAINT-EX': 7.91,
    'E-VVS2-POOR-GOOD-FAINT-EX': 7.91,
    'E-VVS2-GOOD-EX-FAINT-VG': 7.91,
    'E-VS2-EX-VG-NONE-VG': 7.91,
    'F-VVS2-EX-GOOD-NONE-VG': 7.91,
    'F-VVS2-VG-VG-NONE-VG': 7.91,
    'F-VVS2-POOR-GOOD-NONE-EX': 7.91,
    'F-VVS2-GOOD-EX-NONE-VG': 7.91,
    'F-VVS2-GOOD-POOR-NONE-EX': 7.91,
    'G-VS2-EX-EX-STRONG-EX': 7.91,
    'H-VVS2-VG-EX-STRONG-EX': 7.91,
    'H-VS2-EX-EX-MEDIUM-EX': 7.91,
    'H-VVS2-EX-VG-STRONG-EX': 7.91,
    'I-VVS2-VG-EX-MEDIUM-EX': 7.91,
    'I-VVS2-EX-VG-MEDIUM-EX': 7.91,
    'I-VS2-EX-EX-FAINT-EX': 7.91,
    'J-VVS2-EX-VG-FAINT-EX': 7.91,
    'J-VVS2-VG-EX-FAINT-EX': 7.91,
    'J-VS2-EX-EX-NONE-EX': 7.91,
    'K-VVS2-VG-EX-NONE-EX': 7.91,
    'K-VVS2-EX-VG-NONE-EX': 7.91,
    'D-IF-GOOD-VG-STRONG-VG': 7.9,
    'D-IF-EX-POOR-STRONG-VG': 7.9,
    'D-IF-POOR-EX-STRONG-VG': 7.9,
    'D-IF-EX-EX-STRONG-GOOD': 7.9,
    'D-IF-VG-GOOD-STRONG-VG': 7.9,
    'D-IF-POOR-POOR-STRONG-EX': 7.9,
    'E-IF-VG-GOOD-MEDIUM-VG': 7.9,
    'E-IF-EX-POOR-MEDIUM-VG': 7.9,
    'E-IF-POOR-EX-MEDIUM-VG': 7.9,
    'E-IF-POOR-POOR-MEDIUM-EX': 7.9,
    'E-IF-EX-EX-MEDIUM-GOOD': 7.9,
    'E-IF-GOOD-VG-MEDIUM-VG': 7.9,
    'F-IF-EX-POOR-FAINT-VG': 7.9,
    'F-IF-VG-GOOD-FAINT-VG': 7.9,
    'F-IF-GOOD-VG-FAINT-VG': 7.9,
    'F-IF-POOR-EX-FAINT-VG': 7.9,
    'F-IF-EX-EX-FAINT-GOOD': 7.9,
    'F-IF-POOR-POOR-FAINT-EX': 7.9,
    'G-IF-POOR-EX-NONE-VG': 7.9,
    'G-IF-GOOD-VG-NONE-VG': 7.9,
    'G-IF-POOR-POOR-NONE-EX': 7.9,
    'G-IF-EX-EX-NONE-GOOD': 7.9,
    'G-IF-VG-GOOD-NONE-VG': 7.9,
    'G-IF-EX-POOR-NONE-VG': 7.9,
    'I-IF-GOOD-EX-STRONG-EX': 7.9,
    'I-IF-EX-GOOD-STRONG-EX': 7.9,
    'I-IF-VG-VG-STRONG-EX': 7.9,
    'J-IF-GOOD-EX-MEDIUM-EX': 7.9,
    'J-IF-EX-GOOD-MEDIUM-EX': 7.9,
    'J-IF-VG-VG-MEDIUM-EX': 7.9,
    'K-IF-EX-GOOD-FAINT-EX': 7.9,
    'K-IF-VG-VG-FAINT-EX': 7.9,
    'K-IF-GOOD-EX-FAINT-EX': 7.9,
    'L-IF-GOOD-EX-NONE-EX': 7.9,
    'L-IF-EX-GOOD-NONE-EX': 7.9,
    'L-IF-VG-VG-NONE-EX': 7.9,
    'D-SI1-VG-POOR-NONE-EX': 7.89,
    'D-SI1-EX-VG-NONE-VG': 7.89,
    'D-SI1-GOOD-GOOD-NONE-EX': 7.89,
    'D-SI1-POOR-VG-NONE-EX': 7.89,
    'D-SI1-VG-EX-NONE-VG': 7.89,
    'F-SI1-EX-EX-STRONG-EX': 7.89,
    'G-SI1-EX-EX-MEDIUM-EX': 7.89,
    'H-SI1-EX-EX-FAINT-EX': 7.89,
    'I-SI1-EX-EX-NONE-EX': 7.89,
    'D-VVS1-POOR-POOR-MEDIUM-EX': 7.88,
    'D-VVS1-GOOD-VG-MEDIUM-VG': 7.88,
    'D-VVS1-EX-EX-MEDIUM-GOOD': 7.88,
    'D-VS1-VG-VG-FAINT-VG': 7.88,
    'D-VVS1-POOR-EX-MEDIUM-VG': 7.88,
    'D-VS1-EX-GOOD-FAINT-VG': 7.88,
    'D-VS1-GOOD-EX-FAINT-VG': 7.88,
    'D-VS1-POOR-GOOD-FAINT-EX': 7.88,
    'D-VVS1-VG-GOOD-MEDIUM-VG': 7.88,
    'D-VVS1-EX-POOR-MEDIUM-VG': 7.88,
    'D-VS1-GOOD-POOR-FAINT-EX': 7.88,
    'E-VS1-EX-GOOD-NONE-VG': 7.88,
    'E-VVS1-EX-EX-FAINT-GOOD': 7.88,
    'E-VVS1-EX-POOR-FAINT-VG': 7.88,
    'E-VS1-POOR-GOOD-NONE-EX': 7.88,
    'E-VVS1-VG-GOOD-FAINT-VG': 7.88,
    'E-VVS1-POOR-POOR-FAINT-EX': 7.88,
    'E-VVS1-POOR-EX-FAINT-VG': 7.88,
    'E-VVS1-GOOD-VG-FAINT-VG': 7.88,
    'E-VS1-GOOD-POOR-NONE-EX': 7.88,
    'E-VS1-GOOD-EX-NONE-VG': 7.88,
    'E-VS1-VG-VG-NONE-VG': 7.88,
    'F-VVS1-EX-POOR-NONE-VG': 7.88,
    'F-VVS1-VG-GOOD-NONE-VG': 7.88,
    'F-VVS1-GOOD-VG-NONE-VG': 7.88,
    'F-VVS1-POOR-POOR-NONE-EX': 7.88,
    'F-VVS1-EX-EX-NONE-GOOD': 7.88,
    'F-VVS1-POOR-EX-NONE-VG': 7.88,
    'G-VS1-VG-EX-STRONG-EX': 7.88,
    'G-VS1-EX-VG-STRONG-EX': 7.88,
    'H-VS1-VG-EX-MEDIUM-EX': 7.88,
    'H-VS1-EX-VG-MEDIUM-EX': 7.88,
    'H-VVS1-VG-VG-STRONG-EX': 7.88,
    'H-VVS1-EX-GOOD-STRONG-EX': 7.88,
    'H-VVS1-GOOD-EX-STRONG-EX': 7.88,
    'I-VVS1-GOOD-EX-MEDIUM-EX': 7.88,
    'I-VS1-EX-VG-FAINT-EX': 7.88,
    'I-VS1-VG-EX-FAINT-EX': 7.88,
    'I-VVS1-EX-GOOD-MEDIUM-EX': 7.88,
    'I-VVS1-VG-VG-MEDIUM-EX': 7.88,
    'J-VS1-EX-VG-NONE-EX': 7.88,
    'J-VVS1-EX-GOOD-FAINT-EX': 7.88,
    'J-VS1-VG-EX-NONE-EX': 7.88,
    'J-VVS1-VG-VG-FAINT-EX': 7.88,
    'J-VVS1-GOOD-EX-FAINT-EX': 7.88,
    'K-VVS1-GOOD-EX-NONE-EX': 7.88,
    'K-VVS1-EX-GOOD-NONE-EX': 7.88,
    'K-VVS1-VG-VG-NONE-EX': 7.88,
    'E-SI2-EX-EX-STRONG-EX': 7.87,
    'F-SI2-EX-EX-MEDIUM-EX': 7.87,
    'G-SI2-EX-EX-FAINT-EX': 7.87,
    'H-SI2-EX-EX-NONE-EX': 7.87,
    'D-VS2-GOOD-POOR-NONE-EX': 7.86,
    'D-VS2-POOR-GOOD-NONE-EX': 7.86,
    'D-VS2-VG-VG-NONE-VG': 7.86,
    'D-VVS2-POOR-EX-FAINT-VG': 7.86,
    'D-VS2-GOOD-EX-NONE-VG': 7.86,
    'D-VS2-EX-GOOD-NONE-VG': 7.86,
    'D-VVS2-EX-POOR-FAINT-VG': 7.86,
    'D-VVS2-EX-EX-FAINT-GOOD': 7.86,
    'D-VVS2-POOR-POOR-FAINT-EX': 7.86,
    'D-VVS2-VG-GOOD-FAINT-VG': 7.86,
    'D-VVS2-GOOD-VG-FAINT-VG': 7.86,
    'E-VVS2-VG-GOOD-NONE-VG': 7.86,
    'E-VVS2-GOOD-VG-NONE-VG': 7.86,
    'E-VVS2-EX-POOR-NONE-VG': 7.86,
    'E-VVS2-EX-EX-NONE-GOOD': 7.86,
    'E-VVS2-POOR-EX-NONE-VG': 7.86,
    'E-VVS2-POOR-POOR-NONE-EX': 7.86,
    'F-VS2-VG-EX-STRONG-EX': 7.86,
    'F-VS2-EX-VG-STRONG-EX': 7.86,
    'G-VS2-VG-EX-MEDIUM-EX': 7.86,
    'G-VVS2-EX-GOOD-STRONG-EX': 7.86,
    'G-VVS2-VG-VG-STRONG-EX': 7.86,
    'G-VVS2-GOOD-EX-STRONG-EX': 7.86,
    'G-VS2-EX-VG-MEDIUM-EX': 7.86,
    'H-VVS2-GOOD-EX-MEDIUM-EX': 7.86,
    'H-VS2-EX-VG-FAINT-EX': 7.86,
    'H-VS2-VG-EX-FAINT-EX': 7.86,
    'H-VVS2-VG-VG-MEDIUM-EX': 7.86,
    'H-VVS2-EX-GOOD-MEDIUM-EX': 7.86,
    'I-VVS2-VG-VG-FAINT-EX': 7.86,
    'I-VS2-VG-EX-NONE-EX': 7.86,
    'I-VVS2-EX-GOOD-FAINT-EX': 7.86,
    'I-VS2-EX-VG-NONE-EX': 7.86,
    'I-VVS2-GOOD-EX-FAINT-EX': 7.86,
    'J-VVS2-GOOD-EX-NONE-EX': 7.86,
    'J-VVS2-EX-GOOD-NONE-EX': 7.86,
    'J-VVS2-VG-VG-NONE-EX': 7.86,
    'D-IF-EX-VG-MEDIUM-GOOD': 7.85,
    'D-IF-VG-EX-MEDIUM-GOOD': 7.85,
    'D-IF-POOR-VG-MEDIUM-VG': 7.85,
    'D-IF-GOOD-GOOD-MEDIUM-VG': 7.85,
    'D-IF-VG-POOR-MEDIUM-VG': 7.85,
    'E-IF-VG-EX-FAINT-GOOD': 7.85,
    'E-IF-VG-POOR-FAINT-VG': 7.85,
    'E-IF-POOR-VG-FAINT-VG': 7.85,
    'E-IF-GOOD-GOOD-FAINT-VG': 7.85,
    'E-IF-EX-VG-FAINT-GOOD': 7.85,
    'F-IF-EX-VG-NONE-GOOD': 7.85,
    'F-IF-VG-EX-NONE-GOOD': 7.85,
    'F-IF-VG-POOR-NONE-VG': 7.85,
    'F-IF-GOOD-GOOD-NONE-VG': 7.85,
    'F-IF-POOR-VG-NONE-VG': 7.85,
    'H-IF-GOOD-VG-STRONG-EX': 7.85,
    'H-IF-POOR-EX-STRONG-EX': 7.85,
    'H-IF-EX-EX-STRONG-VG': 7.85,
    'H-IF-VG-GOOD-STRONG-EX': 7.85,
    'H-IF-EX-POOR-STRONG-EX': 7.85,
    'I-IF-EX-POOR-MEDIUM-EX': 7.85,
    'I-IF-EX-EX-MEDIUM-VG': 7.85,
    'I-IF-VG-GOOD-MEDIUM-EX': 7.85,
    'I-IF-GOOD-VG-MEDIUM-EX': 7.85,
    'I-IF-POOR-EX-MEDIUM-EX': 7.85,
    'J-IF-EX-POOR-FAINT-EX': 7.85,
    'J-IF-EX-EX-FAINT-VG': 7.85,
    'J-IF-POOR-EX-FAINT-EX': 7.85,
    'J-IF-VG-GOOD-FAINT-EX': 7.85,
    'J-IF-GOOD-VG-FAINT-EX': 7.85,
    'K-IF-POOR-EX-NONE-EX': 7.85,
    'K-IF-EX-EX-NONE-VG': 7.85,
    'K-IF-EX-POOR-NONE-EX': 7.85,
    'K-IF-VG-GOOD-NONE-EX': 7.85,
    'K-IF-GOOD-VG-NONE-EX': 7.85,
    'D-I1-EX-EX-STRONG-EX': 7.84,
    'E-SI1-VG-EX-STRONG-EX': 7.84,
    'E-SI1-EX-VG-STRONG-EX': 7.84,
    'E-I1-EX-EX-MEDIUM-EX': 7.84,
    'F-SI1-EX-VG-MEDIUM-EX': 7.84,
    'F-SI1-VG-EX-MEDIUM-EX': 7.84,
    'F-I1-EX-EX-FAINT-EX': 7.84,
    'G-SI1-EX-VG-FAINT-EX': 7.84,
    'G-I1-EX-EX-NONE-EX': 7.84,
    'G-SI1-VG-EX-FAINT-EX': 7.84,
    'H-SI1-VG-EX-NONE-EX': 7.84,
    'H-SI1-EX-VG-NONE-EX': 7.84,
    'D-VS1-EX-POOR-NONE-VG': 7.83,
    'D-VS1-VG-GOOD-NONE-VG': 7.83,
    'D-VS1-GOOD-VG-NONE-VG': 7.83,
    'D-VVS1-EX-VG-FAINT-GOOD': 7.83,
    'D-VS1-POOR-EX-NONE-VG': 7.83,
    'D-VVS1-VG-POOR-FAINT-VG': 7.83,
    'D-VVS1-GOOD-GOOD-FAINT-VG': 7.83,
    'D-VS1-POOR-POOR-NONE-EX': 7.83,
    'D-VVS1-VG-EX-FAINT-GOOD': 7.83,
    'D-VS1-EX-EX-NONE-GOOD': 7.83,
    'D-VVS1-POOR-VG-FAINT-VG': 7.83,
    'E-VVS1-VG-EX-NONE-GOOD': 7.83,
    'E-VVS1-VG-POOR-NONE-VG': 7.83,
    'E-VVS1-GOOD-GOOD-NONE-VG': 7.83,
    'E-VVS1-EX-VG-NONE-GOOD': 7.83,
    'E-VVS1-POOR-VG-NONE-VG': 7.83,
    'F-VS1-VG-VG-STRONG-EX': 7.83,
    'F-VS1-EX-GOOD-STRONG-EX': 7.83,
    'F-VS1-GOOD-EX-STRONG-EX': 7.83,
    'G-VS1-VG-VG-MEDIUM-EX': 7.83,
    'G-VVS1-EX-POOR-STRONG-EX': 7.83,
    'G-VVS1-EX-EX-STRONG-VG': 7.83,
    'G-VVS1-VG-GOOD-STRONG-EX': 7.83,
    'G-VVS1-POOR-EX-STRONG-EX': 7.83,
    'G-VS1-GOOD-EX-MEDIUM-EX': 7.83,
    'G-VS1-EX-GOOD-MEDIUM-EX': 7.83,
    'G-VVS1-GOOD-VG-STRONG-EX': 7.83,
    'H-VS1-GOOD-EX-FAINT-EX': 7.83,
    'H-VS1-EX-GOOD-FAINT-EX': 7.83,
    'H-VVS1-EX-EX-MEDIUM-VG': 7.83,
    'H-VS1-VG-VG-FAINT-EX': 7.83,
    'H-VVS1-VG-GOOD-MEDIUM-EX': 7.83,
    'H-VVS1-GOOD-VG-MEDIUM-EX': 7.83,
    'H-VVS1-POOR-EX-MEDIUM-EX': 7.83,
    'H-VVS1-EX-POOR-MEDIUM-EX': 7.83,
    'I-VS1-VG-VG-NONE-EX': 7.83,
    'I-VVS1-POOR-EX-FAINT-EX': 7.83,
    'I-VS1-EX-GOOD-NONE-EX': 7.83,
    'I-VVS1-VG-GOOD-FAINT-EX': 7.83,
    'I-VVS1-GOOD-VG-FAINT-EX': 7.83,
    'I-VVS1-EX-POOR-FAINT-EX': 7.83,
    'I-VS1-GOOD-EX-NONE-EX': 7.83,
    'I-VVS1-EX-EX-FAINT-VG': 7.83,
    'J-VVS1-EX-EX-NONE-VG': 7.83,
    'J-VVS1-POOR-EX-NONE-EX': 7.83,
    'J-VVS1-GOOD-VG-NONE-EX': 7.83,
    'J-VVS1-VG-GOOD-NONE-EX': 7.83,
    'J-VVS1-EX-POOR-NONE-EX': 7.83,
    'D-SI2-VG-EX-STRONG-EX': 7.82,
    'D-I2-EX-EX-MEDIUM-EX': 7.82,
    'D-SI2-EX-VG-STRONG-EX': 7.82,
    'E-SI2-EX-VG-MEDIUM-EX': 7.82,
    'E-SI2-VG-EX-MEDIUM-EX': 7.82,
    'E-I2-EX-EX-FAINT-EX': 7.82,
    'F-I2-EX-EX-NONE-EX': 7.82,
    'F-SI2-EX-VG-FAINT-EX': 7.82,
    'F-SI2-VG-EX-FAINT-EX': 7.82,
    'G-SI2-VG-EX-NONE-EX': 7.82,
    'G-SI2-EX-VG-NONE-EX': 7.82,
    'D-VVS2-VG-POOR-NONE-VG': 7.81,
    'D-VVS2-GOOD-GOOD-NONE-VG': 7.81,
    'D-VVS2-POOR-VG-NONE-VG': 7.81,
    'D-VVS2-VG-EX-NONE-GOOD': 7.81,
    'D-VVS2-EX-VG-NONE-GOOD': 7.81,
    'E-VS2-GOOD-EX-STRONG-EX': 7.81,
    'E-VS2-VG-VG-STRONG-EX': 7.81,
    'E-VS2-EX-GOOD-STRONG-EX': 7.81,
    'F-VS2-VG-VG-MEDIUM-EX': 7.81,
    'F-VS2-GOOD-EX-MEDIUM-EX': 7.81,
    'F-VS2-EX-GOOD-MEDIUM-EX': 7.81,
    'F-VVS2-EX-EX-STRONG-VG': 7.81,
    'F-VVS2-POOR-EX-STRONG-EX': 7.81,
    'F-VVS2-GOOD-VG-STRONG-EX': 7.81,
    'F-VVS2-VG-GOOD-STRONG-EX': 7.81,
    'F-VVS2-EX-POOR-STRONG-EX': 7.81,
    'G-VS2-EX-GOOD-FAINT-EX': 7.81,
    'G-VS2-VG-VG-FAINT-EX': 7.81,
    'G-VS2-GOOD-EX-FAINT-EX': 7.81,
    'G-VVS2-EX-POOR-MEDIUM-EX': 7.81,
    'G-VVS2-GOOD-VG-MEDIUM-EX': 7.81,
    'G-VVS2-EX-EX-MEDIUM-VG': 7.81,
    'G-VVS2-POOR-EX-MEDIUM-EX': 7.81,
    'G-VVS2-VG-GOOD-MEDIUM-EX': 7.81,
    'H-VVS2-GOOD-VG-FAINT-EX': 7.81,
    'H-VVS2-VG-GOOD-FAINT-EX': 7.81,
    'H-VVS2-EX-POOR-FAINT-EX': 7.81,
    'H-VVS2-EX-EX-FAINT-VG': 7.81,
    'H-VVS2-POOR-EX-FAINT-EX': 7.81,
    'H-VS2-GOOD-EX-NONE-EX': 7.81,
    'H-VS2-VG-VG-NONE-EX': 7.81,
    'H-VS2-EX-GOOD-NONE-EX': 7.81,
    'I-VVS2-VG-GOOD-NONE-EX': 7.81,
    'I-VVS2-POOR-EX-NONE-EX': 7.81,
    'I-VVS2-EX-EX-NONE-VG': 7.81,
    'I-VVS2-GOOD-VG-NONE-EX': 7.81,
    'I-VVS2-EX-POOR-NONE-EX': 7.81,
    'D-IF-VG-VG-FAINT-GOOD': 7.8,
    'D-IF-POOR-GOOD-FAINT-VG': 7.8,
    'D-IF-GOOD-EX-FAINT-GOOD': 7.8,
    'D-IF-EX-GOOD-FAINT-GOOD': 7.8,
    'D-IF-GOOD-POOR-FAINT-VG': 7.8,
    'E-IF-GOOD-EX-NONE-GOOD': 7.8,
    'E-IF-POOR-GOOD-NONE-VG': 7.8,
    'E-IF-GOOD-POOR-NONE-VG': 7.8,
    'E-IF-VG-VG-NONE-GOOD': 7.8,
    'E-IF-EX-GOOD-NONE-GOOD': 7.8,
    'G-IF-POOR-VG-STRONG-EX': 7.8,
    'G-IF-GOOD-GOOD-STRONG-EX': 7.8,
    'G-IF-VG-POOR-STRONG-EX': 7.8,
    'G-IF-VG-EX-STRONG-VG': 7.8,
    'G-IF-EX-VG-STRONG-VG': 7.8,
    'H-IF-GOOD-GOOD-MEDIUM-EX': 7.8,
    'H-IF-POOR-VG-MEDIUM-EX': 7.8,
    'H-IF-EX-VG-MEDIUM-VG': 7.8,
    'H-IF-VG-EX-MEDIUM-VG': 7.8,
    'H-IF-VG-POOR-MEDIUM-EX': 7.8,
    'I-IF-VG-POOR-FAINT-EX': 7.8,
    'I-IF-GOOD-GOOD-FAINT-EX': 7.8,
    'I-IF-EX-VG-FAINT-VG': 7.8,
    'I-IF-VG-EX-FAINT-VG': 7.8,
    'I-IF-POOR-VG-FAINT-EX': 7.8,
    'J-IF-GOOD-GOOD-NONE-EX': 7.8,
    'J-IF-VG-POOR-NONE-EX': 7.8,
    'J-IF-EX-VG-NONE-VG': 7.8,
    'J-IF-VG-EX-NONE-VG': 7.8,
    'J-IF-POOR-VG-NONE-EX': 7.8,
    'L-IF-EX-EX-STRONG-EX': 7.8,
    'M-IF-EX-EX-MEDIUM-EX': 7.8,
    'D-SI1-EX-GOOD-STRONG-EX': 7.79,
    'D-I1-VG-EX-MEDIUM-EX': 7.79,
    'D-I1-EX-VG-MEDIUM-EX': 7.79,
    'D-SI1-VG-VG-STRONG-EX': 7.79,
    'D-SI1-GOOD-EX-STRONG-EX': 7.79,
    'E-I1-VG-EX-FAINT-EX': 7.79,
    'E-SI1-VG-VG-MEDIUM-EX': 7.79,
    'E-SI1-GOOD-EX-MEDIUM-EX': 7.79,
    'E-I1-EX-VG-FAINT-EX': 7.79,
    'E-SI1-EX-GOOD-MEDIUM-EX': 7.79,
    'F-SI1-VG-VG-FAINT-EX': 7.79,
    'F-SI1-EX-GOOD-FAINT-EX': 7.79,
    'F-I1-VG-EX-NONE-EX': 7.79,
    'F-SI1-GOOD-EX-FAINT-EX': 7.79,
    'F-I1-EX-VG-NONE-EX': 7.79,
    'G-SI1-GOOD-EX-NONE-EX': 7.79,
    'G-SI1-VG-VG-NONE-EX': 7.79,
    'G-SI1-EX-GOOD-NONE-EX': 7.79,
    'D-VVS1-EX-GOOD-NONE-GOOD': 7.78,
    'D-VVS1-GOOD-EX-NONE-GOOD': 7.78,
    'D-VVS1-POOR-GOOD-NONE-VG': 7.78,
    'D-VVS1-VG-VG-NONE-GOOD': 7.78,
    'D-VVS1-GOOD-POOR-NONE-VG': 7.78,
    'E-VS1-GOOD-VG-STRONG-EX': 7.78,
    'E-VS1-VG-GOOD-STRONG-EX': 7.78,
    'E-VS1-POOR-EX-STRONG-EX': 7.78,
    'E-VS1-EX-EX-STRONG-VG': 7.78,
    'E-VS1-EX-POOR-STRONG-EX': 7.78,
    'F-VS1-POOR-EX-MEDIUM-EX': 7.78,
    'F-VS1-EX-POOR-MEDIUM-EX': 7.78,
    'F-VS1-VG-GOOD-MEDIUM-EX': 7.78,
    'F-VS1-EX-EX-MEDIUM-VG': 7.78,
    'F-VVS1-EX-VG-STRONG-VG': 7.78,
    'F-VVS1-VG-EX-STRONG-VG': 7.78,
    'F-VS1-GOOD-VG-MEDIUM-EX': 7.78,
    'F-VVS1-VG-POOR-STRONG-EX': 7.78,
    'F-VVS1-GOOD-GOOD-STRONG-EX': 7.78,
    'F-VVS1-POOR-VG-STRONG-EX': 7.78,
    'G-VVS1-POOR-VG-MEDIUM-EX': 7.78,
    'G-VS1-EX-EX-FAINT-VG': 7.78,
    'G-VS1-EX-POOR-FAINT-EX': 7.78,
    'G-VS1-VG-GOOD-FAINT-EX': 7.78,
    'G-VVS1-GOOD-GOOD-MEDIUM-EX': 7.78,
    'G-VS1-GOOD-VG-FAINT-EX': 7.78,
    'G-VVS1-EX-VG-MEDIUM-VG': 7.78,
    'G-VVS1-VG-EX-MEDIUM-VG': 7.78,
    'G-VVS1-VG-POOR-MEDIUM-EX': 7.78,
    'G-VS1-POOR-EX-FAINT-EX': 7.78,
    'H-VVS1-POOR-VG-FAINT-EX': 7.78,
    'H-VS1-EX-POOR-NONE-EX': 7.78,
    'H-VVS1-GOOD-GOOD-FAINT-EX': 7.78,
    'H-VS1-EX-EX-NONE-VG': 7.78,
    'H-VS1-VG-GOOD-NONE-EX': 7.78,
    'H-VVS1-VG-POOR-FAINT-EX': 7.78,
    'H-VVS1-EX-VG-FAINT-VG': 7.78,
    'H-VVS1-VG-EX-FAINT-VG': 7.78,
    'H-VS1-POOR-EX-NONE-EX': 7.78,
    'H-VS1-GOOD-VG-NONE-EX': 7.78,
    'I-VVS1-GOOD-GOOD-NONE-EX': 7.78,
    'I-VVS1-POOR-VG-NONE-EX': 7.78,
    'I-VVS1-VG-POOR-NONE-EX': 7.78,
    'I-VVS1-EX-VG-NONE-VG': 7.78,
    'I-VVS1-VG-EX-NONE-VG': 7.78,
    'K-VVS1-EX-EX-STRONG-EX': 7.78,
    'L-VVS1-EX-EX-MEDIUM-EX': 7.78,
    'M-VVS1-EX-EX-FAINT-EX': 7.78,
    'D-SI2-EX-GOOD-MEDIUM-EX': 7.77,
    'D-SI2-VG-VG-MEDIUM-EX': 7.77,
    'D-SI2-GOOD-EX-MEDIUM-EX': 7.77,
    'D-I2-VG-EX-FAINT-EX': 7.77,
    'D-I2-EX-VG-FAINT-EX': 7.77,
    'E-I2-EX-VG-NONE-EX': 7.77,
    'E-SI2-GOOD-EX-FAINT-EX': 7.77,
    'E-I2-VG-EX-NONE-EX': 7.77,
    'E-SI2-EX-GOOD-FAINT-EX': 7.77,
    'E-SI2-VG-VG-FAINT-EX': 7.77,
    'F-SI2-EX-GOOD-NONE-EX': 7.77,
    'F-SI2-VG-VG-NONE-EX': 7.77,
    'F-SI2-GOOD-EX-NONE-EX': 7.77,
    'D-VS2-EX-POOR-STRONG-EX': 7.76,
    'D-VS2-VG-GOOD-STRONG-EX': 7.76,
    'D-VS2-GOOD-VG-STRONG-EX': 7.76,
    'D-VS2-POOR-EX-STRONG-EX': 7.76,
    'D-VS2-EX-EX-STRONG-VG': 7.76,
    'E-VS2-EX-EX-MEDIUM-VG': 7.76,
    'E-VVS2-VG-EX-STRONG-VG': 7.76,
    'E-VVS2-GOOD-GOOD-STRONG-EX': 7.76,
    'E-VVS2-EX-VG-STRONG-VG': 7.76,
    'E-VVS2-VG-POOR-STRONG-EX': 7.76,
    'E-VVS2-POOR-VG-STRONG-EX': 7.76,
    'E-VS2-VG-GOOD-MEDIUM-EX': 7.76,
    'E-VS2-GOOD-VG-MEDIUM-EX': 7.76,
    'E-VS2-POOR-EX-MEDIUM-EX': 7.76,
    'E-VS2-EX-POOR-MEDIUM-EX': 7.76,
    'F-VS2-VG-GOOD-FAINT-EX': 7.76,
    'F-VVS2-VG-POOR-MEDIUM-EX': 7.76,
    'F-VS2-EX-POOR-FAINT-EX': 7.76,
    'F-VS2-EX-EX-FAINT-VG': 7.76,
    'F-VVS2-EX-VG-MEDIUM-VG': 7.76,
    'F-VVS2-VG-EX-MEDIUM-VG': 7.76,
    'F-VVS2-POOR-VG-MEDIUM-EX': 7.76,
    'F-VVS2-GOOD-GOOD-MEDIUM-EX': 7.76,
    'F-VS2-GOOD-VG-FAINT-EX': 7.76,
    'F-VS2-POOR-EX-FAINT-EX': 7.76,
    'G-VS2-EX-POOR-NONE-EX': 7.76,
    'G-VVS2-VG-EX-FAINT-VG': 7.76,
    'G-VVS2-VG-POOR-FAINT-EX': 7.76,
    'G-VVS2-EX-VG-FAINT-VG': 7.76,
    'G-VVS2-GOOD-GOOD-FAINT-EX': 7.76,
    'G-VVS2-POOR-VG-FAINT-EX': 7.76,
    'G-VS2-EX-EX-NONE-VG': 7.76,
    'G-VS2-POOR-EX-NONE-EX': 7.76,
    'G-VS2-VG-GOOD-NONE-EX': 7.76,
    'G-VS2-GOOD-VG-NONE-EX': 7.76,
    'H-VVS2-GOOD-GOOD-NONE-EX': 7.76,
    'H-VVS2-VG-POOR-NONE-EX': 7.76,
    'H-VVS2-POOR-VG-NONE-EX': 7.76,
    'H-VVS2-VG-EX-NONE-VG': 7.76,
    'H-VVS2-EX-VG-NONE-VG': 7.76,
    'J-VVS2-EX-EX-STRONG-EX': 7.76,
    'K-VVS2-EX-EX-MEDIUM-EX': 7.76,
    'L-VVS2-EX-EX-FAINT-EX': 7.76,
    'M-VVS2-EX-EX-NONE-EX': 7.76,
    'D-IF-VG-GOOD-NONE-GOOD': 7.75,
    'D-IF-POOR-EX-NONE-GOOD': 7.75,
    'D-IF-GOOD-VG-NONE-GOOD': 7.75,
    'D-IF-EX-EX-NONE-POOR': 7.75,
    'D-IF-POOR-POOR-NONE-VG': 7.75,
    'D-IF-EX-POOR-NONE-GOOD': 7.75,
    'F-IF-POOR-GOOD-STRONG-EX': 7.75,
    'F-IF-GOOD-EX-STRONG-VG': 7.75,
    'F-IF-VG-VG-STRONG-VG': 7.75,
    'F-IF-GOOD-POOR-STRONG-EX': 7.75,
    'F-IF-EX-GOOD-STRONG-VG': 7.75,
    'G-IF-VG-VG-MEDIUM-VG': 7.75,
    'G-IF-EX-GOOD-MEDIUM-VG': 7.75,
    'G-IF-POOR-GOOD-MEDIUM-EX': 7.75,
    'G-IF-GOOD-POOR-MEDIUM-EX': 7.75,
    'G-IF-GOOD-EX-MEDIUM-VG': 7.75,
    'H-IF-EX-GOOD-FAINT-VG': 7.75,
    'H-IF-VG-VG-FAINT-VG': 7.75,
    'H-IF-GOOD-POOR-FAINT-EX': 7.75,
    'H-IF-GOOD-EX-FAINT-VG': 7.75,
    'H-IF-POOR-GOOD-FAINT-EX': 7.75,
    'I-IF-EX-GOOD-NONE-VG': 7.75,
    'I-IF-POOR-GOOD-NONE-EX': 7.75,
    'I-IF-VG-VG-NONE-VG': 7.75,
    'I-IF-GOOD-POOR-NONE-EX': 7.75,
    'I-IF-GOOD-EX-NONE-VG': 7.75,
    'K-IF-VG-EX-STRONG-EX': 7.75,
    'K-IF-EX-VG-STRONG-EX': 7.75,
    'L-IF-VG-EX-MEDIUM-EX': 7.75,
    'L-IF-EX-VG-MEDIUM-EX': 7.75,
    'M-IF-EX-VG-FAINT-EX': 7.75,
    'M-IF-VG-EX-FAINT-EX': 7.75,
    'D-SI1-POOR-EX-MEDIUM-EX': 7.74,
    'D-SI1-GOOD-VG-MEDIUM-EX': 7.74,
    'D-I1-VG-VG-FAINT-EX': 7.74,
    'D-I1-EX-GOOD-FAINT-EX': 7.74,
    'D-SI1-VG-GOOD-MEDIUM-EX': 7.74,
    'D-SI1-EX-EX-MEDIUM-VG': 7.74,
    'D-I1-GOOD-EX-FAINT-EX': 7.74,
    'D-SI1-EX-POOR-MEDIUM-EX': 7.74,
    'E-I1-GOOD-EX-NONE-EX': 7.74,
    'E-I1-EX-GOOD-NONE-EX': 7.74,
    'E-I1-VG-VG-NONE-EX': 7.74,
    'E-SI1-POOR-EX-FAINT-EX': 7.74,
    'E-SI1-GOOD-VG-FAINT-EX': 7.74,
    'E-SI1-VG-GOOD-FAINT-EX': 7.74,
    'E-SI1-EX-EX-FAINT-VG': 7.74,
    'E-SI1-EX-POOR-FAINT-EX': 7.74,
    'F-SI1-GOOD-VG-NONE-EX': 7.74,
    'F-SI1-VG-GOOD-NONE-EX': 7.74,
    'F-SI1-EX-EX-NONE-VG': 7.74,
    'F-SI1-POOR-EX-NONE-EX': 7.74,
    'F-SI1-EX-POOR-NONE-EX': 7.74,
    'D-VS1-GOOD-GOOD-STRONG-EX': 7.73,
    'D-VS1-POOR-VG-STRONG-EX': 7.73,
    'D-VS1-VG-EX-STRONG-VG': 7.73,
    'D-VS1-EX-VG-STRONG-VG': 7.73,
    'D-VS1-VG-POOR-STRONG-EX': 7.73,
    'E-VS1-EX-VG-MEDIUM-VG': 7.73,
    'E-VVS1-POOR-GOOD-STRONG-EX': 7.73,
    'E-VVS1-EX-GOOD-STRONG-VG': 7.73,
    'E-VS1-VG-POOR-MEDIUM-EX': 7.73,
    'E-VVS1-VG-VG-STRONG-VG': 7.73,
    'E-VS1-GOOD-GOOD-MEDIUM-EX': 7.73,
    'E-VS1-VG-EX-MEDIUM-VG': 7.73,
    'E-VS1-POOR-VG-MEDIUM-EX': 7.73,
    'E-VVS1-GOOD-EX-STRONG-VG': 7.73,
    'E-VVS1-GOOD-POOR-STRONG-EX': 7.73,
    'F-VS1-EX-VG-FAINT-VG': 7.73,
    'F-VS1-GOOD-GOOD-FAINT-EX': 7.73,
    'F-VS1-POOR-VG-FAINT-EX': 7.73,
    'F-VVS1-VG-VG-MEDIUM-VG': 7.73,
    'F-VVS1-POOR-GOOD-MEDIUM-EX': 7.73,
    'F-VS1-VG-POOR-FAINT-EX': 7.73,
    'F-VS1-VG-EX-FAINT-VG': 7.73,
    'F-VVS1-EX-GOOD-MEDIUM-VG': 7.73,
    'F-VVS1-GOOD-POOR-MEDIUM-EX': 7.73,
    'F-VVS1-GOOD-EX-MEDIUM-VG': 7.73,
    'G-VVS1-POOR-GOOD-FAINT-EX': 7.73,
    'G-VS1-VG-POOR-NONE-EX': 7.73,
    'G-VVS1-VG-VG-FAINT-VG': 7.73,
    'G-VVS1-GOOD-POOR-FAINT-EX': 7.73,
    'G-VVS1-EX-GOOD-FAINT-VG': 7.73,
    'G-VS1-GOOD-GOOD-NONE-EX': 7.73,
    'G-VVS1-GOOD-EX-FAINT-VG': 7.73,
    'G-VS1-EX-VG-NONE-VG': 7.73,
    'G-VS1-VG-EX-NONE-VG': 7.73,
    'G-VS1-POOR-VG-NONE-EX': 7.73,
    'H-VVS1-EX-GOOD-NONE-VG': 7.73,
    'H-VVS1-GOOD-POOR-NONE-EX': 7.73,
    'H-VVS1-POOR-GOOD-NONE-EX': 7.73,
    'H-VVS1-GOOD-EX-NONE-VG': 7.73,
    'H-VVS1-VG-VG-NONE-VG': 7.73,
    'I-VS1-EX-EX-STRONG-EX': 7.73,
    'J-VS1-EX-EX-MEDIUM-EX': 7.73,
    'J-VVS1-EX-VG-STRONG-EX': 7.73,
    'J-VVS1-VG-EX-STRONG-EX': 7.73,
    'K-VVS1-EX-VG-MEDIUM-EX': 7.73,
    'K-VS1-EX-EX-FAINT-EX': 7.73,
    'K-VVS1-VG-EX-MEDIUM-EX': 7.73,
    'L-VVS1-EX-VG-FAINT-EX': 7.73,
    'L-VVS1-VG-EX-FAINT-EX': 7.73,
    'L-VS1-EX-EX-NONE-EX': 7.73,
    'M-VVS1-VG-EX-NONE-EX': 7.73,
    'M-VVS1-EX-VG-NONE-EX': 7.73,
    'D-I2-VG-VG-NONE-EX': 7.72,
    'D-I2-GOOD-EX-NONE-EX': 7.72,
    'D-I2-EX-GOOD-NONE-EX': 7.72,
    'D-SI2-EX-EX-FAINT-VG': 7.72,
    'D-SI2-GOOD-VG-FAINT-EX': 7.72,
    'D-SI2-POOR-EX-FAINT-EX': 7.72,
    'D-SI2-EX-POOR-FAINT-EX': 7.72,
    'D-SI2-VG-GOOD-FAINT-EX': 7.72,
    'E-SI2-GOOD-VG-NONE-EX': 7.72,
    'E-SI2-VG-GOOD-NONE-EX': 7.72,
    'E-SI2-EX-POOR-NONE-EX': 7.72,
    'E-SI2-POOR-EX-NONE-EX': 7.72,
    'E-SI2-EX-EX-NONE-VG': 7.72,
    'D-VS2-POOR-VG-MEDIUM-EX': 7.71,
    'D-VVS2-POOR-GOOD-STRONG-EX': 7.71,
    'D-VS2-VG-POOR-MEDIUM-EX': 7.71,
    'D-VVS2-EX-GOOD-STRONG-VG': 7.71,
    'D-VVS2-VG-VG-STRONG-VG': 7.71,
    'D-VS2-VG-EX-MEDIUM-VG': 7.71,
    'D-VVS2-GOOD-POOR-STRONG-EX': 7.71,
    'D-VS2-GOOD-GOOD-MEDIUM-EX': 7.71,
    'D-VVS2-GOOD-EX-STRONG-VG': 7.71,
    'D-VS2-EX-VG-MEDIUM-VG': 7.71,
    'E-VVS2-POOR-GOOD-MEDIUM-EX': 7.71,
    'E-VS2-EX-VG-FAINT-VG': 7.71,
    'E-VVS2-GOOD-POOR-MEDIUM-EX': 7.71,
    'E-VVS2-EX-GOOD-MEDIUM-VG': 7.71,
    'E-VVS2-VG-VG-MEDIUM-VG': 7.71,
    'E-VS2-VG-EX-FAINT-VG': 7.71,
    'E-VS2-VG-POOR-FAINT-EX': 7.71,
    'E-VS2-GOOD-GOOD-FAINT-EX': 7.71,
    'E-VVS2-GOOD-EX-MEDIUM-VG': 7.71,
    'E-VS2-POOR-VG-FAINT-EX': 7.71,
    'F-VVS2-POOR-GOOD-FAINT-EX': 7.71,
    'F-VVS2-VG-VG-FAINT-VG': 7.71,
    'F-VS2-GOOD-GOOD-NONE-EX': 7.71,
    'F-VVS2-GOOD-POOR-FAINT-EX': 7.71,
    'F-VVS2-EX-GOOD-FAINT-VG': 7.71,
    'F-VS2-VG-POOR-NONE-EX': 7.71,
    'F-VVS2-GOOD-EX-FAINT-VG': 7.71,
    'F-VS2-VG-EX-NONE-VG': 7.71,
    'F-VS2-POOR-VG-NONE-EX': 7.71,
    'F-VS2-EX-VG-NONE-VG': 7.71,
    'G-VVS2-EX-GOOD-NONE-VG': 7.71,
    'G-VVS2-POOR-GOOD-NONE-EX': 7.71,
    'G-VVS2-GOOD-POOR-NONE-EX': 7.71,
    'G-VVS2-VG-VG-NONE-VG': 7.71,
    'G-VVS2-GOOD-EX-NONE-VG': 7.71,
    'H-VS2-EX-EX-STRONG-EX': 7.71,
    'I-VVS2-VG-EX-STRONG-EX': 7.71,
    'I-VS2-EX-EX-MEDIUM-EX': 7.71,
    'I-VVS2-EX-VG-STRONG-EX': 7.71,
    'J-VS2-EX-EX-FAINT-EX': 7.71,
    'J-VVS2-VG-EX-MEDIUM-EX': 7.71,
    'J-VVS2-EX-VG-MEDIUM-EX': 7.71,
    'K-VS2-EX-EX-NONE-EX': 7.71,
    'K-VVS2-VG-EX-FAINT-EX': 7.71,
    'K-VVS2-EX-VG-FAINT-EX': 7.71,
    'L-VVS2-VG-EX-NONE-EX': 7.71,
    'L-VVS2-EX-VG-NONE-EX': 7.71,
    'E-IF-POOR-EX-STRONG-VG': 7.7,
    'E-IF-EX-EX-STRONG-GOOD': 7.7,
    'E-IF-GOOD-VG-STRONG-VG': 7.7,
    'E-IF-VG-GOOD-STRONG-VG': 7.7,
    'E-IF-POOR-POOR-STRONG-EX': 7.7,
    'E-IF-EX-POOR-STRONG-VG': 7.7,
    'F-IF-GOOD-VG-MEDIUM-VG': 7.7,
    'F-IF-POOR-EX-MEDIUM-VG': 7.7,
    'F-IF-POOR-POOR-MEDIUM-EX': 7.7,
    'F-IF-EX-POOR-MEDIUM-VG': 7.7,
    'F-IF-VG-GOOD-MEDIUM-VG': 7.7,
    'F-IF-EX-EX-MEDIUM-GOOD': 7.7,
    'G-IF-POOR-POOR-FAINT-EX': 7.7,
    'G-IF-POOR-EX-FAINT-VG': 7.7,
    'G-IF-GOOD-VG-FAINT-VG': 7.7,
    'G-IF-VG-GOOD-FAINT-VG': 7.7,
    'G-IF-EX-POOR-FAINT-VG': 7.7,
    'G-IF-EX-EX-FAINT-GOOD': 7.7,
    'H-IF-EX-EX-NONE-GOOD': 7.7,
    'H-IF-EX-POOR-NONE-VG': 7.7,
    'H-IF-VG-GOOD-NONE-VG': 7.7,
    'H-IF-GOOD-VG-NONE-VG': 7.7,
    'H-IF-POOR-EX-NONE-VG': 7.7,
    'H-IF-POOR-POOR-NONE-EX': 7.7,
    'J-IF-EX-GOOD-STRONG-EX': 7.7,
    'J-IF-GOOD-EX-STRONG-EX': 7.7,
    'J-IF-VG-VG-STRONG-EX': 7.7,
    'K-IF-GOOD-EX-MEDIUM-EX': 7.7,
    'K-IF-VG-VG-MEDIUM-EX': 7.7,
    'K-IF-EX-GOOD-MEDIUM-EX': 7.7,
    'L-IF-VG-VG-FAINT-EX': 7.7,
    'L-IF-GOOD-EX-FAINT-EX': 7.7,
    'L-IF-EX-GOOD-FAINT-EX': 7.7,
    'M-IF-VG-VG-NONE-EX': 7.7,
    'M-IF-EX-GOOD-NONE-EX': 7.7,
    'M-IF-GOOD-EX-NONE-EX': 7.7,
    'D-I1-GOOD-VG-NONE-EX': 7.69,
    'D-I1-EX-POOR-NONE-EX': 7.69,
    'D-SI1-POOR-VG-FAINT-EX': 7.69,
    'D-SI1-GOOD-GOOD-FAINT-EX': 7.69,
    'D-SI1-EX-VG-FAINT-VG': 7.69,
    'D-SI1-VG-EX-FAINT-VG': 7.69,
    'D-I1-POOR-EX-NONE-EX': 7.69,
    'D-I1-EX-EX-NONE-VG': 7.69,
    'D-I1-VG-GOOD-NONE-EX': 7.69,
    'D-SI1-VG-POOR-FAINT-EX': 7.69,
    'E-SI1-EX-VG-NONE-VG': 7.69,
    'E-SI1-POOR-VG-NONE-EX': 7.69,
    'E-SI1-GOOD-GOOD-NONE-EX': 7.69,
    'E-SI1-VG-EX-NONE-VG': 7.69,
    'E-SI1-VG-POOR-NONE-EX': 7.69,
    'G-SI1-EX-EX-STRONG-EX': 7.69,
    'H-SI1-EX-EX-MEDIUM-EX': 7.69,
    'I-SI1-EX-EX-FAINT-EX': 7.69,
    'J-SI1-EX-EX-NONE-EX': 7.69,
    'D-VVS1-EX-EX-STRONG-GOOD': 7.68,
    'D-VVS1-VG-GOOD-STRONG-VG': 7.68,
    'D-VS1-POOR-GOOD-MEDIUM-EX': 7.68,
    'D-VVS1-GOOD-VG-STRONG-VG': 7.68,
    'D-VS1-EX-GOOD-MEDIUM-VG': 7.68,
    'D-VVS1-POOR-EX-STRONG-VG': 7.68,
    'D-VVS1-POOR-POOR-STRONG-EX': 7.68,
    'D-VVS1-EX-POOR-STRONG-VG': 7.68,
    'D-VS1-GOOD-EX-MEDIUM-VG': 7.68,
    'D-VS1-VG-VG-MEDIUM-VG': 7.68,
    'D-VS1-GOOD-POOR-MEDIUM-EX': 7.68,
    'E-VVS1-EX-EX-MEDIUM-GOOD': 7.68,
    'E-VS1-GOOD-POOR-FAINT-EX': 7.68,
    'E-VS1-GOOD-EX-FAINT-VG': 7.68,
    'E-VVS1-POOR-EX-MEDIUM-VG': 7.68,
    'E-VVS1-POOR-POOR-MEDIUM-EX': 7.68,
    'E-VS1-POOR-GOOD-FAINT-EX': 7.68,
    'E-VVS1-VG-GOOD-MEDIUM-VG': 7.68,
    'E-VS1-VG-VG-FAINT-VG': 7.68,
    'E-VVS1-EX-POOR-MEDIUM-VG': 7.68,
    'E-VVS1-GOOD-VG-MEDIUM-VG': 7.68,
    'E-VS1-EX-GOOD-FAINT-VG': 7.68,
    'F-VVS1-POOR-EX-FAINT-VG': 7.68,
    'F-VVS1-VG-GOOD-FAINT-VG': 7.68,
    'F-VVS1-GOOD-VG-FAINT-VG': 7.68,
    'F-VVS1-POOR-POOR-FAINT-EX': 7.68,
    'F-VVS1-EX-POOR-FAINT-VG': 7.68,
    'F-VVS1-EX-EX-FAINT-GOOD': 7.68,
    'F-VS1-POOR-GOOD-NONE-EX': 7.68,
    'F-VS1-GOOD-EX-NONE-VG': 7.68,
    'F-VS1-EX-GOOD-NONE-VG': 7.68,
    'F-VS1-VG-VG-NONE-VG': 7.68,
    'F-VS1-GOOD-POOR-NONE-EX': 7.68,
    'G-VVS1-EX-POOR-NONE-VG': 7.68,
    'G-VVS1-EX-EX-NONE-GOOD': 7.68,
    'G-VVS1-GOOD-VG-NONE-VG': 7.68,
    'G-VVS1-POOR-POOR-NONE-EX': 7.68,
    'G-VVS1-VG-GOOD-NONE-VG': 7.68,
    'G-VVS1-POOR-EX-NONE-VG': 7.68,
    'H-VS1-VG-EX-STRONG-EX': 7.68,
    'H-VS1-EX-VG-STRONG-EX': 7.68,
    'I-VVS1-GOOD-EX-STRONG-EX': 7.68,
    'I-VS1-EX-VG-MEDIUM-EX': 7.68,
    'I-VS1-VG-EX-MEDIUM-EX': 7.68,
    'I-VVS1-VG-VG-STRONG-EX': 7.68,
    'I-VVS1-EX-GOOD-STRONG-EX': 7.68,
    'J-VVS1-EX-GOOD-MEDIUM-EX': 7.68,
    'J-VVS1-VG-VG-MEDIUM-EX': 7.68,
    'J-VVS1-GOOD-EX-MEDIUM-EX': 7.68,
    'J-VS1-VG-EX-FAINT-EX': 7.68,
    'J-VS1-EX-VG-FAINT-EX': 7.68,
    'K-VS1-EX-VG-NONE-EX': 7.68,
    'K-VS1-VG-EX-NONE-EX': 7.68,
    'K-VVS1-EX-GOOD-FAINT-EX': 7.68,
    'K-VVS1-VG-VG-FAINT-EX': 7.68,
    'K-VVS1-GOOD-EX-FAINT-EX': 7.68,
    'L-VVS1-GOOD-EX-NONE-EX': 7.68,
    'L-VVS1-VG-VG-NONE-EX': 7.68,
    'L-VVS1-EX-GOOD-NONE-EX': 7.68,
    'D-SI2-POOR-VG-NONE-EX': 7.67,
    'D-SI2-VG-EX-NONE-VG': 7.67,
    'D-SI2-EX-VG-NONE-VG': 7.67,
    'D-SI2-VG-POOR-NONE-EX': 7.67,
    'D-SI2-GOOD-GOOD-NONE-EX': 7.67,
    'F-SI2-EX-EX-STRONG-EX': 7.67,
    'G-SI2-EX-EX-MEDIUM-EX': 7.67,
    'H-SI2-EX-EX-FAINT-EX': 7.67,
    'I-SI2-EX-EX-NONE-EX': 7.67,
    'D-VVS2-EX-POOR-MEDIUM-VG': 7.66,
    'D-VS2-GOOD-POOR-FAINT-EX': 7.66,
    'D-VVS2-VG-GOOD-MEDIUM-VG': 7.66,
    'D-VS2-POOR-GOOD-FAINT-EX': 7.66,
    'D-VVS2-POOR-EX-MEDIUM-VG': 7.66,
    'D-VS2-GOOD-EX-FAINT-VG': 7.66,
    'D-VVS2-EX-EX-MEDIUM-GOOD': 7.66,
    'D-VS2-EX-GOOD-FAINT-VG': 7.66,
    'D-VVS2-POOR-POOR-MEDIUM-EX': 7.66,
    'D-VS2-VG-VG-FAINT-VG': 7.66,
    'D-VVS2-GOOD-VG-MEDIUM-VG': 7.66,
    'E-VS2-VG-VG-NONE-VG': 7.66,
    'E-VVS2-POOR-EX-FAINT-VG': 7.66,
    'E-VS2-POOR-GOOD-NONE-EX': 7.66,
    'E-VS2-GOOD-POOR-NONE-EX': 7.66,
    'E-VS2-GOOD-EX-NONE-VG': 7.66,
    'E-VS2-EX-GOOD-NONE-VG': 7.66,
    'E-VVS2-POOR-POOR-FAINT-EX': 7.66,
    'E-VVS2-VG-GOOD-FAINT-VG': 7.66,
    'E-VVS2-EX-EX-FAINT-GOOD': 7.66,
    'E-VVS2-EX-POOR-FAINT-VG': 7.66,
    'E-VVS2-GOOD-VG-FAINT-VG': 7.66,
    'F-VVS2-POOR-POOR-NONE-EX': 7.66,
    'F-VVS2-EX-EX-NONE-GOOD': 7.66,
    'F-VVS2-GOOD-VG-NONE-VG': 7.66,
    'F-VVS2-VG-GOOD-NONE-VG': 7.66,
    'F-VVS2-EX-POOR-NONE-VG': 7.66,
    'F-VVS2-POOR-EX-NONE-VG': 7.66,
    'G-VS2-EX-VG-STRONG-EX': 7.66,
    'G-VS2-VG-EX-STRONG-EX': 7.66,
    'H-VS2-EX-VG-MEDIUM-EX': 7.66,
    'H-VVS2-GOOD-EX-STRONG-EX': 7.66,
    'H-VS2-VG-EX-MEDIUM-EX': 7.66,
    'H-VVS2-VG-VG-STRONG-EX': 7.66,
    'H-VVS2-EX-GOOD-STRONG-EX': 7.66,
    'I-VVS2-VG-VG-MEDIUM-EX': 7.66,
    'I-VVS2-GOOD-EX-MEDIUM-EX': 7.66,
    'I-VVS2-EX-GOOD-MEDIUM-EX': 7.66,
    'I-VS2-VG-EX-FAINT-EX': 7.66,
    'I-VS2-EX-VG-FAINT-EX': 7.66,
    'J-VS2-EX-VG-NONE-EX': 7.66,
    'J-VVS2-GOOD-EX-FAINT-EX': 7.66,
    'J-VVS2-VG-VG-FAINT-EX': 7.66,
    'J-VVS2-EX-GOOD-FAINT-EX': 7.66,
    'J-VS2-VG-EX-NONE-EX': 7.66,
    'K-VVS2-EX-GOOD-NONE-EX': 7.66,
    'K-VVS2-VG-VG-NONE-EX': 7.66,
    'K-VVS2-GOOD-EX-NONE-EX': 7.66,
    'D-IF-VG-POOR-STRONG-VG': 7.65,
    'D-IF-GOOD-GOOD-STRONG-VG': 7.65,
    'D-IF-EX-VG-STRONG-GOOD': 7.65,
    'D-IF-POOR-VG-STRONG-VG': 7.65,
    'D-IF-VG-EX-STRONG-GOOD': 7.65,
    'E-IF-VG-EX-MEDIUM-GOOD': 7.65,
    'E-IF-VG-POOR-MEDIUM-VG': 7.65,
    'E-IF-GOOD-GOOD-MEDIUM-VG': 7.65,
    'E-IF-POOR-VG-MEDIUM-VG': 7.65,
    'E-IF-EX-VG-MEDIUM-GOOD': 7.65,
    'F-IF-GOOD-GOOD-FAINT-VG': 7.65,
    'F-IF-VG-POOR-FAINT-VG': 7.65,
    'F-IF-POOR-VG-FAINT-VG': 7.65,
    'F-IF-EX-VG-FAINT-GOOD': 7.65,
    'F-IF-VG-EX-FAINT-GOOD': 7.65,
    'G-IF-VG-EX-NONE-GOOD': 7.65,
    'G-IF-EX-VG-NONE-GOOD': 7.65,
    'G-IF-VG-POOR-NONE-VG': 7.65,
    'G-IF-POOR-VG-NONE-VG': 7.65,
    'G-IF-GOOD-GOOD-NONE-VG': 7.65,
    'I-IF-EX-EX-STRONG-VG': 7.65,
    'I-IF-VG-GOOD-STRONG-EX': 7.65,
    'I-IF-EX-POOR-STRONG-EX': 7.65,
    'I-IF-POOR-EX-STRONG-EX': 7.65,
    'I-IF-GOOD-VG-STRONG-EX': 7.65,
    'J-IF-GOOD-VG-MEDIUM-EX': 7.65,
    'J-IF-VG-GOOD-MEDIUM-EX': 7.65,
    'J-IF-EX-POOR-MEDIUM-EX': 7.65,
    'J-IF-EX-EX-MEDIUM-VG': 7.65,
    'J-IF-POOR-EX-MEDIUM-EX': 7.65,
    'K-IF-GOOD-VG-FAINT-EX': 7.65,
    'K-IF-EX-EX-FAINT-VG': 7.65,
    'K-IF-EX-POOR-FAINT-EX': 7.65,
    'K-IF-VG-GOOD-FAINT-EX': 7.65,
    'K-IF-POOR-EX-FAINT-EX': 7.65,
    'L-IF-GOOD-VG-NONE-EX': 7.65,
    'L-IF-EX-EX-NONE-VG': 7.65,
    'L-IF-POOR-EX-NONE-EX': 7.65,
    'L-IF-EX-POOR-NONE-EX': 7.65,
    'L-IF-VG-GOOD-NONE-EX': 7.65,
    'D-SI1-GOOD-EX-NONE-VG': 7.64,
    'D-SI1-EX-GOOD-NONE-VG': 7.64,
    'D-SI1-GOOD-POOR-NONE-EX': 7.64,
    'D-SI1-POOR-GOOD-NONE-EX': 7.64,
    'D-SI1-VG-VG-NONE-VG': 7.64,
    'E-I1-EX-EX-STRONG-EX': 7.64,
    'F-I1-EX-EX-MEDIUM-EX': 7.64,
    'F-SI1-EX-VG-STRONG-EX': 7.64,
    'F-SI1-VG-EX-STRONG-EX': 7.64,
    'G-SI1-EX-VG-MEDIUM-EX': 7.64,
    'G-I1-EX-EX-FAINT-EX': 7.64,
    'G-SI1-VG-EX-MEDIUM-EX': 7.64,
    'H-I1-EX-EX-NONE-EX': 7.64,
    'H-SI1-EX-VG-FAINT-EX': 7.64,
    'H-SI1-VG-EX-FAINT-EX': 7.64,
    'I-SI1-EX-VG-NONE-EX': 7.64,
    'I-SI1-VG-EX-NONE-EX': 7.64,
    'D-VVS1-VG-POOR-MEDIUM-VG': 7.63,
    'D-VVS1-VG-EX-MEDIUM-GOOD': 7.63,
    'D-VVS1-EX-VG-MEDIUM-GOOD': 7.63,
    'D-VS1-POOR-EX-FAINT-VG': 7.63,
    'D-VVS1-GOOD-GOOD-MEDIUM-VG': 7.63,
    'D-VS1-GOOD-VG-FAINT-VG': 7.63,
    'D-VVS1-POOR-VG-MEDIUM-VG': 7.63,
    'D-VS1-POOR-POOR-FAINT-EX': 7.63,
    'D-VS1-EX-POOR-FAINT-VG': 7.63,
    'D-VS1-EX-EX-FAINT-GOOD': 7.63,
    'D-VS1-VG-GOOD-FAINT-VG': 7.63,
    'E-VS1-EX-EX-NONE-GOOD': 7.63,
    'E-VVS1-EX-VG-FAINT-GOOD': 7.63,
    'E-VVS1-VG-POOR-FAINT-VG': 7.63,
    'E-VVS1-VG-EX-FAINT-GOOD': 7.63,
    'E-VS1-VG-GOOD-NONE-VG': 7.63,
    'E-VS1-POOR-EX-NONE-VG': 7.63,
    'E-VS1-POOR-POOR-NONE-EX': 7.63,
    'E-VS1-EX-POOR-NONE-VG': 7.63,
    'E-VVS1-POOR-VG-FAINT-VG': 7.63,
    'E-VS1-GOOD-VG-NONE-VG': 7.63,
    'E-VVS1-GOOD-GOOD-FAINT-VG': 7.63,
    'F-VVS1-VG-POOR-NONE-VG': 7.63,
    'F-VVS1-POOR-VG-NONE-VG': 7.63,
    'F-VVS1-VG-EX-NONE-GOOD': 7.63,
    'F-VVS1-EX-VG-NONE-GOOD': 7.63,
    'F-VVS1-GOOD-GOOD-NONE-VG': 7.63,
    'G-VS1-GOOD-EX-STRONG-EX': 7.63,
    'G-VS1-EX-GOOD-STRONG-EX': 7.63,
    'G-VS1-VG-VG-STRONG-EX': 7.63,
    'H-VS1-VG-VG-MEDIUM-EX': 7.63,
    'H-VVS1-POOR-EX-STRONG-EX': 7.63,
    'H-VVS1-VG-GOOD-STRONG-EX': 7.63,
    'H-VS1-EX-GOOD-MEDIUM-EX': 7.63,
    'H-VVS1-EX-POOR-STRONG-EX': 7.63,
    'H-VVS1-GOOD-VG-STRONG-EX': 7.63,
    'H-VVS1-EX-EX-STRONG-VG': 7.63,
    'H-VS1-GOOD-EX-MEDIUM-EX': 7.63,
    'I-VVS1-EX-EX-MEDIUM-VG': 7.63,
    'I-VS1-EX-GOOD-FAINT-EX': 7.63,
    'I-VVS1-POOR-EX-MEDIUM-EX': 7.63,
    'I-VVS1-GOOD-VG-MEDIUM-EX': 7.63,
    'I-VS1-GOOD-EX-FAINT-EX': 7.63,
    'I-VS1-VG-VG-FAINT-EX': 7.63,
    'I-VVS1-VG-GOOD-MEDIUM-EX': 7.63,
    'I-VVS1-EX-POOR-MEDIUM-EX': 7.63,
    'J-VS1-VG-VG-NONE-EX': 7.63,
    'J-VS1-GOOD-EX-NONE-EX': 7.63,
    'J-VVS1-EX-EX-FAINT-VG': 7.63,
    'J-VVS1-VG-GOOD-FAINT-EX': 7.63,
    'J-VVS1-EX-POOR-FAINT-EX': 7.63,
    'J-VS1-EX-GOOD-NONE-EX': 7.63,
    'J-VVS1-POOR-EX-FAINT-EX': 7.63,
    'J-VVS1-GOOD-VG-FAINT-EX': 7.63,
    'K-VVS1-EX-EX-NONE-VG': 7.63,
    'K-VVS1-EX-POOR-NONE-EX': 7.63,
    'K-VVS1-POOR-EX-NONE-EX': 7.63,
    'K-VVS1-GOOD-VG-NONE-EX': 7.63,
    'K-VVS1-VG-GOOD-NONE-EX': 7.63,
    'D-I2-EX-EX-STRONG-EX': 7.62,
    'E-SI2-EX-VG-STRONG-EX': 7.62,
    'E-SI2-VG-EX-STRONG-EX': 7.62,
    'E-I2-EX-EX-MEDIUM-EX': 7.62,
    'F-SI2-VG-EX-MEDIUM-EX': 7.62,
    'F-SI2-EX-VG-MEDIUM-EX': 7.62,
    'F-I2-EX-EX-FAINT-EX': 7.62,
    'G-SI2-EX-VG-FAINT-EX': 7.62,
    'G-I2-EX-EX-NONE-EX': 7.62,
    'G-SI2-VG-EX-FAINT-EX': 7.62,
    'H-SI2-EX-VG-NONE-EX': 7.62,
    'H-SI2-VG-EX-NONE-EX': 7.62,
    'D-VVS2-VG-POOR-FAINT-VG': 7.61,
    'D-VS2-VG-GOOD-NONE-VG': 7.61,
    'D-VS2-GOOD-VG-NONE-VG': 7.61,
    'D-VVS2-EX-VG-FAINT-GOOD': 7.61,
    'D-VVS2-VG-EX-FAINT-GOOD': 7.61,
    'D-VVS2-POOR-VG-FAINT-VG': 7.61,
    'D-VS2-EX-POOR-NONE-VG': 7.61,
    'D-VS2-POOR-POOR-NONE-EX': 7.61,
    'D-VVS2-GOOD-GOOD-FAINT-VG': 7.61,
    'D-VS2-EX-EX-NONE-GOOD': 7.61,
    'D-VS2-POOR-EX-NONE-VG': 7.61,
    'E-VVS2-VG-EX-NONE-GOOD': 7.61,
    'E-VVS2-VG-POOR-NONE-VG': 7.61,
    'E-VVS2-GOOD-GOOD-NONE-VG': 7.61,
    'E-VVS2-POOR-VG-NONE-VG': 7.61,
    'E-VVS2-EX-VG-NONE-GOOD': 7.61,
    'F-VS2-VG-VG-STRONG-EX': 7.61,
    'F-VS2-GOOD-EX-STRONG-EX': 7.61,
    'F-VS2-EX-GOOD-STRONG-EX': 7.61,
    'G-VVS2-GOOD-VG-STRONG-EX': 7.61,
    'G-VS2-GOOD-EX-MEDIUM-EX': 7.61,
    'G-VS2-EX-GOOD-MEDIUM-EX': 7.61,
    'G-VVS2-VG-GOOD-STRONG-EX': 7.61,
    'G-VS2-VG-VG-MEDIUM-EX': 7.61,
    'G-VVS2-EX-POOR-STRONG-EX': 7.61,
    'G-VVS2-EX-EX-STRONG-VG': 7.61,
    'G-VVS2-POOR-EX-STRONG-EX': 7.61,
    'H-VS2-EX-GOOD-FAINT-EX': 7.61,
    'H-VVS2-GOOD-VG-MEDIUM-EX': 7.61,
    'H-VVS2-EX-EX-MEDIUM-VG': 7.61,
    'H-VVS2-EX-POOR-MEDIUM-EX': 7.61,
    'H-VVS2-VG-GOOD-MEDIUM-EX': 7.61,
    'H-VVS2-POOR-EX-MEDIUM-EX': 7.61,
    'H-VS2-GOOD-EX-FAINT-EX': 7.61,
    'H-VS2-VG-VG-FAINT-EX': 7.61,
    'I-VS2-EX-GOOD-NONE-EX': 7.61,
    'I-VS2-GOOD-EX-NONE-EX': 7.61,
    'I-VVS2-GOOD-VG-FAINT-EX': 7.61,
    'I-VS2-VG-VG-NONE-EX': 7.61,
    'I-VVS2-VG-GOOD-FAINT-EX': 7.61,
    'I-VVS2-EX-POOR-FAINT-EX': 7.61,
    'I-VVS2-EX-EX-FAINT-VG': 7.61,
    'I-VVS2-POOR-EX-FAINT-EX': 7.61,
    'J-VVS2-POOR-EX-NONE-EX': 7.61,
    'J-VVS2-GOOD-VG-NONE-EX': 7.61,
    'J-VVS2-VG-GOOD-NONE-EX': 7.61,
    'J-VVS2-EX-POOR-NONE-EX': 7.61,
    'J-VVS2-EX-EX-NONE-VG': 7.61,
    'D-IF-POOR-GOOD-MEDIUM-VG': 7.6,
    'D-IF-GOOD-EX-MEDIUM-GOOD': 7.6,
    'D-IF-VG-VG-MEDIUM-GOOD': 7.6,
    'D-IF-EX-GOOD-MEDIUM-GOOD': 7.6,
    'D-IF-GOOD-POOR-MEDIUM-VG': 7.6,
    'E-IF-POOR-GOOD-FAINT-VG': 7.6,
    'E-IF-EX-GOOD-FAINT-GOOD': 7.6,
    'E-IF-VG-VG-FAINT-GOOD': 7.6,
    'E-IF-GOOD-POOR-FAINT-VG': 7.6,
    'E-IF-GOOD-EX-FAINT-GOOD': 7.6,
    'F-IF-POOR-GOOD-NONE-VG': 7.6,
    'F-IF-GOOD-POOR-NONE-VG': 7.6,
    'F-IF-GOOD-EX-NONE-GOOD': 7.6,
    'F-IF-VG-VG-NONE-GOOD': 7.6,
    'F-IF-EX-GOOD-NONE-GOOD': 7.6,
    'H-IF-POOR-VG-STRONG-EX': 7.6,
    'H-IF-GOOD-GOOD-STRONG-EX': 7.6,
    'H-IF-VG-EX-STRONG-VG': 7.6,
    'H-IF-EX-VG-STRONG-VG': 7.6,
    'H-IF-VG-POOR-STRONG-EX': 7.6,
    'I-IF-EX-VG-MEDIUM-VG': 7.6,
    'I-IF-VG-EX-MEDIUM-VG': 7.6,
    'I-IF-VG-POOR-MEDIUM-EX': 7.6,
    'I-IF-GOOD-GOOD-MEDIUM-EX': 7.6,
    'I-IF-POOR-VG-MEDIUM-EX': 7.6,
    'J-IF-VG-EX-FAINT-VG': 7.6,
    'J-IF-POOR-VG-FAINT-EX': 7.6,
    'J-IF-VG-POOR-FAINT-EX': 7.6,
    'J-IF-GOOD-GOOD-FAINT-EX': 7.6,
    'J-IF-EX-VG-FAINT-VG': 7.6,
    'K-IF-POOR-VG-NONE-EX': 7.6,
    'K-IF-GOOD-GOOD-NONE-EX': 7.6,
    'K-IF-VG-POOR-NONE-EX': 7.6,
    'K-IF-VG-EX-NONE-VG': 7.6,
    'K-IF-EX-VG-NONE-VG': 7.6,
    'M-IF-EX-EX-STRONG-EX': 7.6,
    'D-I1-EX-VG-STRONG-EX': 7.59,
    'D-I1-VG-EX-STRONG-EX': 7.59,
    'E-SI1-VG-VG-STRONG-EX': 7.59,
    'E-SI1-EX-GOOD-STRONG-EX': 7.59,
    'E-SI1-GOOD-EX-STRONG-EX': 7.59,
    'E-I1-VG-EX-MEDIUM-EX': 7.59,
    'E-I1-EX-VG-MEDIUM-EX': 7.59,
    'F-SI1-EX-GOOD-MEDIUM-EX': 7.59,
    'F-SI1-GOOD-EX-MEDIUM-EX': 7.59,
    'F-SI1-VG-VG-MEDIUM-EX': 7.59,
    'F-I1-VG-EX-FAINT-EX': 7.59,
    'F-I1-EX-VG-FAINT-EX': 7.59,
    'G-SI1-EX-GOOD-FAINT-EX': 7.59,
    'G-I1-VG-EX-NONE-EX': 7.59,
    'G-SI1-GOOD-EX-FAINT-EX': 7.59,
    'G-SI1-VG-VG-FAINT-EX': 7.59,
    'G-I1-EX-VG-NONE-EX': 7.59,
    'H-SI1-GOOD-EX-NONE-EX': 7.59,
    'H-SI1-EX-GOOD-NONE-EX': 7.59,
    'H-SI1-VG-VG-NONE-EX': 7.59,
    'D-VS1-EX-VG-NONE-GOOD': 7.58,
    'D-VVS1-GOOD-EX-FAINT-GOOD': 7.58,
    'D-VS1-VG-EX-NONE-GOOD': 7.58,
    'D-VS1-GOOD-GOOD-NONE-VG': 7.58,
    'D-VVS1-EX-GOOD-FAINT-GOOD': 7.58,
    'D-VVS1-VG-VG-FAINT-GOOD': 7.58,
    'D-VVS1-GOOD-POOR-FAINT-VG': 7.58,
    'D-VVS1-POOR-GOOD-FAINT-VG': 7.58,
    'D-VS1-VG-POOR-NONE-VG': 7.58,
    'D-VS1-POOR-VG-NONE-VG': 7.58,
    'E-VVS1-EX-GOOD-NONE-GOOD': 7.58,
    'E-VVS1-VG-VG-NONE-GOOD': 7.58,
    'E-VVS1-GOOD-EX-NONE-GOOD': 7.58,
    'E-VVS1-POOR-GOOD-NONE-VG': 7.58,
    'E-VVS1-GOOD-POOR-NONE-VG': 7.58,
    'F-VS1-GOOD-VG-STRONG-EX': 7.58,
    'F-VS1-POOR-EX-STRONG-EX': 7.58,
    'F-VS1-EX-POOR-STRONG-EX': 7.58,
    'F-VS1-EX-EX-STRONG-VG': 7.58,
    'F-VS1-VG-GOOD-STRONG-EX': 7.58,
    'G-VVS1-VG-EX-STRONG-VG': 7.58,
    'G-VVS1-EX-VG-STRONG-VG': 7.58,
    'G-VS1-POOR-EX-MEDIUM-EX': 7.58,
    'G-VVS1-POOR-VG-STRONG-EX': 7.58,
    'G-VVS1-GOOD-GOOD-STRONG-EX': 7.58,
    'G-VS1-GOOD-VG-MEDIUM-EX': 7.58,
    'G-VS1-EX-EX-MEDIUM-VG': 7.58,
    'G-VS1-VG-GOOD-MEDIUM-EX': 7.58,
    'G-VVS1-VG-POOR-STRONG-EX': 7.58,
    'G-VS1-EX-POOR-MEDIUM-EX': 7.58,
    'H-VVS1-POOR-VG-MEDIUM-EX': 7.58,
    'H-VVS1-GOOD-GOOD-MEDIUM-EX': 7.58,
    'H-VVS1-VG-POOR-MEDIUM-EX': 7.58,
    'H-VS1-VG-GOOD-FAINT-EX': 7.58,
    'H-VVS1-EX-VG-MEDIUM-VG': 7.58,
    'H-VS1-EX-POOR-FAINT-EX': 7.58,
    'H-VS1-EX-EX-FAINT-VG': 7.58,
    'H-VS1-POOR-EX-FAINT-EX': 7.58,
    'H-VVS1-VG-EX-MEDIUM-VG': 7.58,
    'H-VS1-GOOD-VG-FAINT-EX': 7.58,
    'I-VS1-POOR-EX-NONE-EX': 7.58,
    'I-VS1-EX-EX-NONE-VG': 7.58,
    'I-VS1-EX-POOR-NONE-EX': 7.58,
    'I-VS1-VG-GOOD-NONE-EX': 7.58,
    'I-VS1-GOOD-VG-NONE-EX': 7.58,
    'I-VVS1-POOR-VG-FAINT-EX': 7.58,
    'I-VVS1-EX-VG-FAINT-VG': 7.58,
    'I-VVS1-GOOD-GOOD-FAINT-EX': 7.58,
    'I-VVS1-VG-EX-FAINT-VG': 7.58,
    'I-VVS1-VG-POOR-FAINT-EX': 7.58,
    'J-VVS1-EX-VG-NONE-VG': 7.58,
    'J-VVS1-POOR-VG-NONE-EX': 7.58,
    'J-VVS1-VG-POOR-NONE-EX': 7.58,
    'J-VVS1-VG-EX-NONE-VG': 7.58,
    'J-VVS1-GOOD-GOOD-NONE-EX': 7.58,
    'L-VVS1-EX-EX-STRONG-EX': 7.58,
    'M-VVS1-EX-EX-MEDIUM-EX': 7.58,
    'D-SI2-VG-VG-STRONG-EX': 7.57,
    'D-SI2-EX-GOOD-STRONG-EX': 7.57,
    'D-SI2-GOOD-EX-STRONG-EX': 7.57,
    'D-I2-VG-EX-MEDIUM-EX': 7.57,
    'D-I2-EX-VG-MEDIUM-EX': 7.57,
    'E-I2-VG-EX-FAINT-EX': 7.57,
    'E-SI2-VG-VG-MEDIUM-EX': 7.57,
    'E-SI2-EX-GOOD-MEDIUM-EX': 7.57,
    'E-SI2-GOOD-EX-MEDIUM-EX': 7.57,
    'E-I2-EX-VG-FAINT-EX': 7.57,
    'F-SI2-EX-GOOD-FAINT-EX': 7.57,
    'F-SI2-VG-VG-FAINT-EX': 7.57,
    'F-SI2-GOOD-EX-FAINT-EX': 7.57,
    'F-I2-VG-EX-NONE-EX': 7.57,
    'F-I2-EX-VG-NONE-EX': 7.57,
    'G-SI2-VG-VG-NONE-EX': 7.57,
    'G-SI2-EX-GOOD-NONE-EX': 7.57,
    'G-SI2-GOOD-EX-NONE-EX': 7.57,
    'D-VVS2-VG-VG-NONE-GOOD': 7.56,
    'D-VVS2-POOR-GOOD-NONE-VG': 7.56,
    'D-VVS2-EX-GOOD-NONE-GOOD': 7.56,
    'D-VVS2-GOOD-POOR-NONE-VG': 7.56,
    'D-VVS2-GOOD-EX-NONE-GOOD': 7.56,
    'E-VS2-EX-POOR-STRONG-EX': 7.56,
    'E-VS2-GOOD-VG-STRONG-EX': 7.56,
    'E-VS2-POOR-EX-STRONG-EX': 7.56,
    'E-VS2-VG-GOOD-STRONG-EX': 7.56,
    'E-VS2-EX-EX-STRONG-VG': 7.56,
    'F-VS2-EX-POOR-MEDIUM-EX': 7.56,
    'F-VS2-POOR-EX-MEDIUM-EX': 7.56,
    'F-VS2-EX-EX-MEDIUM-VG': 7.56,
    'F-VS2-GOOD-VG-MEDIUM-EX': 7.56,
    'F-VVS2-VG-EX-STRONG-VG': 7.56,
    'F-VS2-VG-GOOD-MEDIUM-EX': 7.56,
    'F-VVS2-GOOD-GOOD-STRONG-EX': 7.56,
    'F-VVS2-POOR-VG-STRONG-EX': 7.56,
    'F-VVS2-EX-VG-STRONG-VG': 7.56,
    'F-VVS2-VG-POOR-STRONG-EX': 7.56,
    'G-VVS2-VG-POOR-MEDIUM-EX': 7.56,
    'G-VVS2-GOOD-GOOD-MEDIUM-EX': 7.56,
    'G-VS2-GOOD-VG-FAINT-EX': 7.56,
    'G-VS2-EX-EX-FAINT-VG': 7.56,
    'G-VS2-VG-GOOD-FAINT-EX': 7.56,
    'G-VVS2-VG-EX-MEDIUM-VG': 7.56,
    'G-VVS2-EX-VG-MEDIUM-VG': 7.56,
    'G-VS2-EX-POOR-FAINT-EX': 7.56,
    'G-VVS2-POOR-VG-MEDIUM-EX': 7.56,
    'G-VS2-POOR-EX-FAINT-EX': 7.56,
    'H-VS2-VG-GOOD-NONE-EX': 7.56,
    'H-VVS2-VG-EX-FAINT-VG': 7.56,
    'H-VVS2-EX-VG-FAINT-VG': 7.56,
    'H-VS2-EX-EX-NONE-VG': 7.56,
    'H-VS2-POOR-EX-NONE-EX': 7.56,
    'H-VVS2-POOR-VG-FAINT-EX': 7.56,
    'H-VS2-GOOD-VG-NONE-EX': 7.56,
    'H-VS2-EX-POOR-NONE-EX': 7.56,
    'H-VVS2-VG-POOR-FAINT-EX': 7.56,
    'H-VVS2-GOOD-GOOD-FAINT-EX': 7.56,
    'I-VVS2-POOR-VG-NONE-EX': 7.56,
    'I-VVS2-VG-POOR-NONE-EX': 7.56,
    'I-VVS2-EX-VG-NONE-VG': 7.56,
    'I-VVS2-VG-EX-NONE-VG': 7.56,
    'I-VVS2-GOOD-GOOD-NONE-EX': 7.56,
    'K-VVS2-EX-EX-STRONG-EX': 7.56,
    'L-VVS2-EX-EX-MEDIUM-EX': 7.56,
    'M-VVS2-EX-EX-FAINT-EX': 7.56,
    'D-IF-VG-GOOD-FAINT-GOOD': 7.55,
    'D-IF-EX-EX-FAINT-POOR': 7.55,
    'D-IF-POOR-POOR-FAINT-VG': 7.55,
    'D-IF-POOR-EX-FAINT-GOOD': 7.55,
    'D-IF-EX-POOR-FAINT-GOOD': 7.55,
    'D-IF-GOOD-VG-FAINT-GOOD': 7.55,
    'E-IF-EX-POOR-NONE-GOOD': 7.55,
    'E-IF-VG-GOOD-NONE-GOOD': 7.55,
    'E-IF-POOR-POOR-NONE-VG': 7.55,
    'E-IF-EX-EX-NONE-POOR': 7.55,
    'E-IF-POOR-EX-NONE-GOOD': 7.55,
    'E-IF-GOOD-VG-NONE-GOOD': 7.55,
    'G-IF-POOR-GOOD-STRONG-EX': 7.55,
    'G-IF-GOOD-EX-STRONG-VG': 7.55,
    'G-IF-GOOD-POOR-STRONG-EX': 7.55,
    'G-IF-EX-GOOD-STRONG-VG': 7.55,
    'G-IF-VG-VG-STRONG-VG': 7.55,
    'H-IF-VG-VG-MEDIUM-VG': 7.55,
    'H-IF-GOOD-POOR-MEDIUM-EX': 7.55,
    'H-IF-EX-GOOD-MEDIUM-VG': 7.55,
    'H-IF-GOOD-EX-MEDIUM-VG': 7.55,
    'H-IF-POOR-GOOD-MEDIUM-EX': 7.55,
    'I-IF-GOOD-EX-FAINT-VG': 7.55,
    'I-IF-VG-VG-FAINT-VG': 7.55,
    'I-IF-GOOD-POOR-FAINT-EX': 7.55,
    'I-IF-EX-GOOD-FAINT-VG': 7.55,
    'I-IF-POOR-GOOD-FAINT-EX': 7.55,
    'J-IF-EX-GOOD-NONE-VG': 7.55,
    'J-IF-POOR-GOOD-NONE-EX': 7.55,
    'J-IF-GOOD-EX-NONE-VG': 7.55,
    'J-IF-VG-VG-NONE-VG': 7.55,
    'J-IF-GOOD-POOR-NONE-EX': 7.55,
    'L-IF-VG-EX-STRONG-EX': 7.55,
    'L-IF-EX-VG-STRONG-EX': 7.55,
    'M-IF-EX-VG-MEDIUM-EX': 7.55,
    'M-IF-VG-EX-MEDIUM-EX': 7.55,
    'D-SI1-GOOD-VG-STRONG-EX': 7.54,
    'D-SI1-EX-POOR-STRONG-EX': 7.54,
    'D-I1-VG-VG-MEDIUM-EX': 7.54,
    'D-I1-GOOD-EX-MEDIUM-EX': 7.54,
    'D-SI1-EX-EX-STRONG-VG': 7.54,
    'D-SI1-VG-GOOD-STRONG-EX': 7.54,
    'D-SI1-POOR-EX-STRONG-EX': 7.54,
    'D-I1-EX-GOOD-MEDIUM-EX': 7.54,
    'E-I1-EX-GOOD-FAINT-EX': 7.54,
    'E-I1-GOOD-EX-FAINT-EX': 7.54,
    'E-SI1-EX-POOR-MEDIUM-EX': 7.54,
    'E-I1-VG-VG-FAINT-EX': 7.54,
    'E-SI1-GOOD-VG-MEDIUM-EX': 7.54,
    'E-SI1-POOR-EX-MEDIUM-EX': 7.54,
    'E-SI1-VG-GOOD-MEDIUM-EX': 7.54,
    'E-SI1-EX-EX-MEDIUM-VG': 7.54,
    'F-I1-VG-VG-NONE-EX': 7.54,
    'F-SI1-VG-GOOD-FAINT-EX': 7.54,
    'F-SI1-EX-EX-FAINT-VG': 7.54,
    'F-SI1-GOOD-VG-FAINT-EX': 7.54,
    'F-I1-GOOD-EX-NONE-EX': 7.54,
    'F-I1-EX-GOOD-NONE-EX': 7.54,
    'F-SI1-POOR-EX-FAINT-EX': 7.54,
    'F-SI1-EX-POOR-FAINT-EX': 7.54,
    'G-SI1-VG-GOOD-NONE-EX': 7.54,
    'G-SI1-EX-POOR-NONE-EX': 7.54,
    'G-SI1-EX-EX-NONE-VG': 7.54,
    'G-SI1-GOOD-VG-NONE-EX': 7.54,
    'G-SI1-POOR-EX-NONE-EX': 7.54,
    'D-VVS1-VG-GOOD-NONE-GOOD': 7.53,
    'D-VVS1-EX-POOR-NONE-GOOD': 7.53,
    'D-VVS1-POOR-EX-NONE-GOOD': 7.53,
    'D-VVS1-POOR-POOR-NONE-VG': 7.53,
    'D-VVS1-EX-EX-NONE-POOR': 7.53,
    'D-VVS1-GOOD-VG-NONE-GOOD': 7.53,
    'E-VS1-GOOD-GOOD-STRONG-EX': 7.53,
    'E-VS1-VG-EX-STRONG-VG': 7.53,
    'E-VS1-EX-VG-STRONG-VG': 7.53,
    'E-VS1-VG-POOR-STRONG-EX': 7.53,
    'E-VS1-POOR-VG-STRONG-EX': 7.53,
    'F-VVS1-GOOD-POOR-STRONG-EX': 7.53,
    'F-VS1-GOOD-GOOD-MEDIUM-EX': 7.53,
    'F-VS1-POOR-VG-MEDIUM-EX': 7.53,
    'F-VVS1-VG-VG-STRONG-VG': 7.53,
    'F-VVS1-EX-GOOD-STRONG-VG': 7.53,
    'F-VS1-VG-EX-MEDIUM-VG': 7.53,
    'F-VS1-EX-VG-MEDIUM-VG': 7.53,
    'F-VVS1-GOOD-EX-STRONG-VG': 7.53,
    'F-VVS1-POOR-GOOD-STRONG-EX': 7.53,
    'F-VS1-VG-POOR-MEDIUM-EX': 7.53,
    'G-VVS1-POOR-GOOD-MEDIUM-EX': 7.53,
    'G-VVS1-GOOD-POOR-MEDIUM-EX': 7.53,
    'G-VS1-VG-EX-FAINT-VG': 7.53,
    'G-VS1-POOR-VG-FAINT-EX': 7.53,
    'G-VS1-VG-POOR-FAINT-EX': 7.53,
    'G-VS1-GOOD-GOOD-FAINT-EX': 7.53,
    'G-VVS1-GOOD-EX-MEDIUM-VG': 7.53,
    'G-VVS1-VG-VG-MEDIUM-VG': 7.53,
    'G-VVS1-EX-GOOD-MEDIUM-VG': 7.53,
    'G-VS1-EX-VG-FAINT-VG': 7.53,
    'H-VVS1-GOOD-EX-FAINT-VG': 7.53,
    'H-VVS1-POOR-GOOD-FAINT-EX': 7.53,
    'H-VS1-POOR-VG-NONE-EX': 7.53,
    'H-VS1-VG-EX-NONE-VG': 7.53,
    'H-VS1-GOOD-GOOD-NONE-EX': 7.53,
    'H-VS1-EX-VG-NONE-VG': 7.53,
    'H-VVS1-EX-GOOD-FAINT-VG': 7.53,
    'H-VS1-VG-POOR-NONE-EX': 7.53,
    'H-VVS1-GOOD-POOR-FAINT-EX': 7.53,
    'H-VVS1-VG-VG-FAINT-VG': 7.53,
    'I-VVS1-VG-VG-NONE-VG': 7.53,
    'I-VVS1-GOOD-EX-NONE-VG': 7.53,
    'I-VVS1-POOR-GOOD-NONE-EX': 7.53,
    'I-VVS1-GOOD-POOR-NONE-EX': 7.53,
    'I-VVS1-EX-GOOD-NONE-VG': 7.53,
    'J-VS1-EX-EX-STRONG-EX': 7.53,
    'K-VS1-EX-EX-MEDIUM-EX': 7.53,
    'K-VVS1-VG-EX-STRONG-EX': 7.53,
    'K-VVS1-EX-VG-STRONG-EX': 7.53,
    'L-VVS1-EX-VG-MEDIUM-EX': 7.53,
    'L-VS1-EX-EX-FAINT-EX': 7.53,
    'L-VVS1-VG-EX-MEDIUM-EX': 7.53,
    'M-VS1-EX-EX-NONE-EX': 7.53,
    'M-VVS1-EX-VG-FAINT-EX': 7.53,
    'M-VVS1-VG-EX-FAINT-EX': 7.53,
    'D-SI2-POOR-EX-MEDIUM-EX': 7.52,
    'D-I2-EX-GOOD-FAINT-EX': 7.52,
    'D-I2-GOOD-EX-FAINT-EX': 7.52,
    'D-SI2-EX-EX-MEDIUM-VG': 7.52,
    'D-I2-VG-VG-FAINT-EX': 7.52,
    'D-SI2-GOOD-VG-MEDIUM-EX': 7.52,
    'D-SI2-EX-POOR-MEDIUM-EX': 7.52,
    'D-SI2-VG-GOOD-MEDIUM-EX': 7.52,
    'E-SI2-EX-EX-FAINT-VG': 7.52,
    'E-SI2-GOOD-VG-FAINT-EX': 7.52,
    'E-SI2-POOR-EX-FAINT-EX': 7.52,
    'E-I2-EX-GOOD-NONE-EX': 7.52,
    'E-I2-GOOD-EX-NONE-EX': 7.52,
    'E-SI2-VG-GOOD-FAINT-EX': 7.52,
    'E-I2-VG-VG-NONE-EX': 7.52,
    'E-SI2-EX-POOR-FAINT-EX': 7.52,
    'F-SI2-GOOD-VG-NONE-EX': 7.52,
    'F-SI2-VG-GOOD-NONE-EX': 7.52,
    'F-SI2-EX-POOR-NONE-EX': 7.52,
    'F-SI2-EX-EX-NONE-VG': 7.52,
    'F-SI2-POOR-EX-NONE-EX': 7.52,
    'D-VS2-EX-VG-STRONG-VG': 7.51,
    'D-VS2-VG-EX-STRONG-VG': 7.51,
    'D-VS2-VG-POOR-STRONG-EX': 7.51,
    'D-VS2-GOOD-GOOD-STRONG-EX': 7.51,
    'D-VS2-POOR-VG-STRONG-EX': 7.51,
    'E-VVS2-VG-VG-STRONG-VG': 7.51,
    'E-VVS2-GOOD-POOR-STRONG-EX': 7.51,
    'E-VVS2-GOOD-EX-STRONG-VG': 7.51,
    'E-VS2-POOR-VG-MEDIUM-EX': 7.51,
    'E-VVS2-POOR-GOOD-STRONG-EX': 7.51,
    'E-VS2-GOOD-GOOD-MEDIUM-EX': 7.51,
    'E-VVS2-EX-GOOD-STRONG-VG': 7.51,
    'E-VS2-VG-POOR-MEDIUM-EX': 7.51,
    'E-VS2-EX-VG-MEDIUM-VG': 7.51,
    'E-VS2-VG-EX-MEDIUM-VG': 7.51,
    'F-VS2-VG-POOR-FAINT-EX': 7.51,
    'F-VS2-GOOD-GOOD-FAINT-EX': 7.51,
    'F-VS2-POOR-VG-FAINT-EX': 7.51,
    'F-VS2-VG-EX-FAINT-VG': 7.51,
    'F-VS2-EX-VG-FAINT-VG': 7.51,
    'F-VVS2-GOOD-EX-MEDIUM-VG': 7.51,
    'F-VVS2-GOOD-POOR-MEDIUM-EX': 7.51,
    'F-VVS2-EX-GOOD-MEDIUM-VG': 7.51,
    'F-VVS2-POOR-GOOD-MEDIUM-EX': 7.51,
    'F-VVS2-VG-VG-MEDIUM-VG': 7.51,
    'G-VVS2-POOR-GOOD-FAINT-EX': 7.51,
    'G-VS2-GOOD-GOOD-NONE-EX': 7.51,
    'G-VS2-POOR-VG-NONE-EX': 7.51,
    'G-VVS2-GOOD-EX-FAINT-VG': 7.51,
    'G-VS2-VG-POOR-NONE-EX': 7.51,
    'G-VS2-VG-EX-NONE-VG': 7.51,
    'G-VVS2-VG-VG-FAINT-VG': 7.51,
    'G-VS2-EX-VG-NONE-VG': 7.51,
    'G-VVS2-EX-GOOD-FAINT-VG': 7.51,
    'G-VVS2-GOOD-POOR-FAINT-EX': 7.51,
    'H-VVS2-EX-GOOD-NONE-VG': 7.51,
    'H-VVS2-VG-VG-NONE-VG': 7.51,
    'H-VVS2-GOOD-EX-NONE-VG': 7.51,
    'H-VVS2-GOOD-POOR-NONE-EX': 7.51,
    'H-VVS2-POOR-GOOD-NONE-EX': 7.51,
    'I-VS2-EX-EX-STRONG-EX': 7.51,
    'J-VS2-EX-EX-MEDIUM-EX': 7.51,
    'J-VVS2-VG-EX-STRONG-EX': 7.51,
    'J-VVS2-EX-VG-STRONG-EX': 7.51,
    'K-VS2-EX-EX-FAINT-EX': 7.51,
    'K-VVS2-EX-VG-MEDIUM-EX': 7.51,
    'K-VVS2-VG-EX-MEDIUM-EX': 7.51,
    'L-VVS2-VG-EX-FAINT-EX': 7.51,
    'L-VVS2-EX-VG-FAINT-EX': 7.51,
    'L-VS2-EX-EX-NONE-EX': 7.51,
    'M-VVS2-VG-EX-NONE-EX': 7.51,
    'M-VVS2-EX-VG-NONE-EX': 7.51,
    'D-IF-VG-EX-NONE-POOR': 7.5,
    'D-IF-VG-POOR-NONE-GOOD': 7.5,
    'D-IF-POOR-VG-NONE-GOOD': 7.5,
    'D-IF-EX-VG-NONE-POOR': 7.5,
    'D-IF-GOOD-GOOD-NONE-GOOD': 7.5,
    'F-IF-EX-POOR-STRONG-VG': 7.5,
    'F-IF-POOR-POOR-STRONG-EX': 7.5,
    'F-IF-EX-EX-STRONG-GOOD': 7.5,
    'F-IF-POOR-EX-STRONG-VG': 7.5,
    'F-IF-GOOD-VG-STRONG-VG': 7.5,
    'F-IF-VG-GOOD-STRONG-VG': 7.5,
    'G-IF-POOR-POOR-MEDIUM-EX': 7.5,
    'G-IF-EX-POOR-MEDIUM-VG': 7.5,
    'G-IF-VG-GOOD-MEDIUM-VG': 7.5,
    'G-IF-GOOD-VG-MEDIUM-VG': 7.5,
    'G-IF-POOR-EX-MEDIUM-VG': 7.5,
    'G-IF-EX-EX-MEDIUM-GOOD': 7.5,
    'H-IF-POOR-POOR-FAINT-EX': 7.5,
    'H-IF-GOOD-VG-FAINT-VG': 7.5,
    'H-IF-VG-GOOD-FAINT-VG': 7.5,
    'H-IF-EX-POOR-FAINT-VG': 7.5,
    'H-IF-POOR-EX-FAINT-VG': 7.5,
    'H-IF-EX-EX-FAINT-GOOD': 7.5,
    'I-IF-GOOD-VG-NONE-VG': 7.5,
    'I-IF-POOR-POOR-NONE-EX': 7.5,
    'I-IF-VG-GOOD-NONE-VG': 7.5,
    'I-IF-EX-POOR-NONE-VG': 7.5,
    'I-IF-EX-EX-NONE-GOOD': 7.5,
    'I-IF-POOR-EX-NONE-VG': 7.5,
    'K-IF-VG-VG-STRONG-EX': 7.5,
    'K-IF-EX-GOOD-STRONG-EX': 7.5,
    'K-IF-GOOD-EX-STRONG-EX': 7.5,
    'L-IF-VG-VG-MEDIUM-EX': 7.5,
    'L-IF-GOOD-EX-MEDIUM-EX': 7.5,
    'L-IF-EX-GOOD-MEDIUM-EX': 7.5,
    'M-IF-VG-VG-FAINT-EX': 7.5,
    'M-IF-EX-GOOD-FAINT-EX': 7.5,
    'M-IF-GOOD-EX-FAINT-EX': 7.5,
    'D-I1-EX-EX-FAINT-VG': 7.49,
    'D-I1-EX-POOR-FAINT-EX': 7.49,
    'D-SI1-VG-EX-MEDIUM-VG': 7.49,
    'D-SI1-VG-POOR-MEDIUM-EX': 7.49,
    'D-SI1-POOR-VG-MEDIUM-EX': 7.49,
    'D-SI1-GOOD-GOOD-MEDIUM-EX': 7.49,
    'D-I1-GOOD-VG-FAINT-EX': 7.49,
    'D-I1-VG-GOOD-FAINT-EX': 7.49,
    'D-SI1-EX-VG-MEDIUM-VG': 7.49,
    'D-I1-POOR-EX-FAINT-EX': 7.49,
    'E-I1-VG-GOOD-NONE-EX': 7.49,
    'E-I1-POOR-EX-NONE-EX': 7.49,
    'E-I1-GOOD-VG-NONE-EX': 7.49,
    'E-I1-EX-POOR-NONE-EX': 7.49,
    'E-SI1-VG-EX-FAINT-VG': 7.49,
    'E-SI1-VG-POOR-FAINT-EX': 7.49,
    'E-SI1-GOOD-GOOD-FAINT-EX': 7.49,
    'E-SI1-EX-VG-FAINT-VG': 7.49,
    'E-I1-EX-EX-NONE-VG': 7.49,
    'E-SI1-POOR-VG-FAINT-EX': 7.49,
    'F-SI1-VG-EX-NONE-VG': 7.49,
    'F-SI1-EX-VG-NONE-VG': 7.49,
    'F-SI1-GOOD-GOOD-NONE-EX': 7.49,
    'F-SI1-VG-POOR-NONE-EX': 7.49,
    'F-SI1-POOR-VG-NONE-EX': 7.49,
    'H-SI1-EX-EX-STRONG-EX': 7.49,
    'I-SI1-EX-EX-MEDIUM-EX': 7.49,
    'J-SI1-EX-EX-FAINT-EX': 7.49,
    'K-SI1-EX-EX-NONE-EX': 7.49,
    'D-VS1-VG-VG-STRONG-VG': 7.48,
    'D-VS1-EX-GOOD-STRONG-VG': 7.48,
    'D-VS1-POOR-GOOD-STRONG-EX': 7.48,
    'D-VS1-GOOD-POOR-STRONG-EX': 7.48,
    'D-VS1-GOOD-EX-STRONG-VG': 7.48,
    'E-VVS1-EX-EX-STRONG-GOOD': 7.48,
    'E-VS1-EX-GOOD-MEDIUM-VG': 7.48,
    'E-VS1-VG-VG-MEDIUM-VG': 7.48,
    'E-VS1-GOOD-POOR-MEDIUM-EX': 7.48,
    'E-VS1-GOOD-EX-MEDIUM-VG': 7.48,
    'E-VVS1-POOR-EX-STRONG-VG': 7.48,
    'E-VVS1-EX-POOR-STRONG-VG': 7.48,
    'E-VVS1-POOR-POOR-STRONG-EX': 7.48,
    'E-VVS1-GOOD-VG-STRONG-VG': 7.48,
    'E-VS1-POOR-GOOD-MEDIUM-EX': 7.48,
    'E-VVS1-VG-GOOD-STRONG-VG': 7.48,
    'F-VVS1-POOR-POOR-MEDIUM-EX': 7.48,
    'F-VVS1-POOR-EX-MEDIUM-VG': 7.48,
    'F-VVS1-EX-EX-MEDIUM-GOOD': 7.48,
    'F-VVS1-EX-POOR-MEDIUM-VG': 7.48,
    'F-VVS1-VG-GOOD-MEDIUM-VG': 7.48,
    'F-VVS1-GOOD-VG-MEDIUM-VG': 7.48,
    'F-VS1-EX-GOOD-FAINT-VG': 7.48,
    'F-VS1-GOOD-EX-FAINT-VG': 7.48,
    'F-VS1-GOOD-POOR-FAINT-EX': 7.48,
    'F-VS1-POOR-GOOD-FAINT-EX': 7.48,
    'F-VS1-VG-VG-FAINT-VG': 7.48,
    'G-VVS1-POOR-EX-FAINT-VG': 7.48,
    'G-VVS1-POOR-POOR-FAINT-EX': 7.48,
    'G-VVS1-GOOD-VG-FAINT-VG': 7.48,
    'G-VVS1-VG-GOOD-FAINT-VG': 7.48,
    'G-VVS1-EX-POOR-FAINT-VG': 7.48,
    'G-VVS1-EX-EX-FAINT-GOOD': 7.48,
    'G-VS1-GOOD-POOR-NONE-EX': 7.48,
    'G-VS1-POOR-GOOD-NONE-EX': 7.48,
    'G-VS1-GOOD-EX-NONE-VG': 7.48,
    'G-VS1-VG-VG-NONE-VG': 7.48,
    'G-VS1-EX-GOOD-NONE-VG': 7.48,
    'H-VVS1-POOR-POOR-NONE-EX': 7.48,
    'H-VVS1-VG-GOOD-NONE-VG': 7.48,
    'H-VVS1-GOOD-VG-NONE-VG': 7.48,
    'H-VVS1-POOR-EX-NONE-VG': 7.48,
    'H-VVS1-EX-POOR-NONE-VG': 7.48,
    'H-VVS1-EX-EX-NONE-GOOD': 7.48,
    'I-VS1-EX-VG-STRONG-EX': 7.48,
    'I-VS1-VG-EX-STRONG-EX': 7.48,
    'J-VVS1-VG-VG-STRONG-EX': 7.48,
    'J-VVS1-GOOD-EX-STRONG-EX': 7.48,
    'J-VVS1-EX-GOOD-STRONG-EX': 7.48,
    'J-VS1-EX-VG-MEDIUM-EX': 7.48,
    'J-VS1-VG-EX-MEDIUM-EX': 7.48,
    'K-VVS1-EX-GOOD-MEDIUM-EX': 7.48,
    'K-VVS1-VG-VG-MEDIUM-EX': 7.48,
    'K-VS1-VG-EX-FAINT-EX': 7.48,
    'K-VS1-EX-VG-FAINT-EX': 7.48,
    'K-VVS1-GOOD-EX-MEDIUM-EX': 7.48,
    'L-VVS1-EX-GOOD-FAINT-EX': 7.48,
    'L-VVS1-VG-VG-FAINT-EX': 7.48,
    'L-VVS1-GOOD-EX-FAINT-EX': 7.48,
    'L-VS1-EX-VG-NONE-EX': 7.48,
    'L-VS1-VG-EX-NONE-EX': 7.48,
    'M-VVS1-VG-VG-NONE-EX': 7.48,
    'M-VVS1-GOOD-EX-NONE-EX': 7.48,
    'M-VVS1-EX-GOOD-NONE-EX': 7.48,
    'D-SI2-GOOD-GOOD-FAINT-EX': 7.47,
    'D-SI2-POOR-VG-FAINT-EX': 7.47,
    'D-I2-POOR-EX-NONE-EX': 7.47,
    'D-I2-EX-POOR-NONE-EX': 7.47,
    'D-SI2-VG-POOR-FAINT-EX': 7.47,
    'D-I2-EX-EX-NONE-VG': 7.47,
    'D-I2-VG-GOOD-NONE-EX': 7.47,
    'D-SI2-EX-VG-FAINT-VG': 7.47,
    'D-SI2-VG-EX-FAINT-VG': 7.47,
    'D-I2-GOOD-VG-NONE-EX': 7.47,
    'E-SI2-EX-VG-NONE-VG': 7.47,
    'E-SI2-GOOD-GOOD-NONE-EX': 7.47,
    'E-SI2-POOR-VG-NONE-EX': 7.47,
    'E-SI2-VG-POOR-NONE-EX': 7.47,
    'E-SI2-VG-EX-NONE-VG': 7.47,
    'G-SI2-EX-EX-STRONG-EX': 7.47,
    'H-SI2-EX-EX-MEDIUM-EX': 7.47,
    'I-SI2-EX-EX-FAINT-EX': 7.47,
    'J-SI2-EX-EX-NONE-EX': 7.47,
    'D-VVS2-POOR-POOR-STRONG-EX': 7.46,
    'D-VVS2-VG-GOOD-STRONG-VG': 7.46,
    'D-VVS2-EX-EX-STRONG-GOOD': 7.46,
    'D-VVS2-EX-POOR-STRONG-VG': 7.46,
    'D-VVS2-GOOD-VG-STRONG-VG': 7.46,
    'D-VVS2-POOR-EX-STRONG-VG': 7.46,
    'D-VS2-VG-VG-MEDIUM-VG': 7.46,
    'D-VS2-GOOD-EX-MEDIUM-VG': 7.46,
    'D-VS2-GOOD-POOR-MEDIUM-EX': 7.46,
    'D-VS2-POOR-GOOD-MEDIUM-EX': 7.46,
    'D-VS2-EX-GOOD-MEDIUM-VG': 7.46,
    'E-VVS2-POOR-POOR-MEDIUM-EX': 7.46,
    'E-VVS2-VG-GOOD-MEDIUM-VG': 7.46,
    'E-VVS2-EX-POOR-MEDIUM-VG': 7.46,
    'E-VVS2-EX-EX-MEDIUM-GOOD': 7.46,
    'E-VVS2-GOOD-VG-MEDIUM-VG': 7.46,
    'E-VS2-EX-GOOD-FAINT-VG': 7.46,
    'E-VS2-VG-VG-FAINT-VG': 7.46,
    'E-VS2-GOOD-EX-FAINT-VG': 7.46,
    'E-VS2-GOOD-POOR-FAINT-EX': 7.46,
    'E-VS2-POOR-GOOD-FAINT-EX': 7.46,
    'E-VVS2-POOR-EX-MEDIUM-VG': 7.46,
    'F-VVS2-GOOD-VG-FAINT-VG': 7.46,
    'F-VVS2-POOR-EX-FAINT-VG': 7.46,
    'F-VS2-VG-VG-NONE-VG': 7.46,
    'F-VS2-GOOD-EX-NONE-VG': 7.46,
    'F-VS2-GOOD-POOR-NONE-EX': 7.46,
    'F-VS2-POOR-GOOD-NONE-EX': 7.46,
    'F-VVS2-VG-GOOD-FAINT-VG': 7.46,
    'F-VS2-EX-GOOD-NONE-VG': 7.46,
    'F-VVS2-EX-POOR-FAINT-VG': 7.46,
    'F-VVS2-EX-EX-FAINT-GOOD': 7.46,
    'F-VVS2-POOR-POOR-FAINT-EX': 7.46,
    'G-VVS2-POOR-POOR-NONE-EX': 7.46,
    'G-VVS2-POOR-EX-NONE-VG': 7.46,
    'G-VVS2-GOOD-VG-NONE-VG': 7.46,
    'G-VVS2-VG-GOOD-NONE-VG': 7.46,
    'G-VVS2-EX-POOR-NONE-VG': 7.46,
    'G-VVS2-EX-EX-NONE-GOOD': 7.46,
    'H-VS2-EX-VG-STRONG-EX': 7.46,
    'H-VS2-VG-EX-STRONG-EX': 7.46,
    'I-VS2-VG-EX-MEDIUM-EX': 7.46,
    'I-VS2-EX-VG-MEDIUM-EX': 7.46,
    'I-VVS2-GOOD-EX-STRONG-EX': 7.46,
    'I-VVS2-EX-GOOD-STRONG-EX': 7.46,
    'I-VVS2-VG-VG-STRONG-EX': 7.46,
    'J-VS2-VG-EX-FAINT-EX': 7.46,
    'J-VVS2-EX-GOOD-MEDIUM-EX': 7.46,
    'J-VVS2-VG-VG-MEDIUM-EX': 7.46,
    'J-VVS2-GOOD-EX-MEDIUM-EX': 7.46,
    'J-VS2-EX-VG-FAINT-EX': 7.46,
    'K-VVS2-EX-GOOD-FAINT-EX': 7.46,
    'K-VVS2-VG-VG-FAINT-EX': 7.46,
    'K-VVS2-GOOD-EX-FAINT-EX': 7.46,
    'K-VS2-VG-EX-NONE-EX': 7.46,
    'K-VS2-EX-VG-NONE-EX': 7.46,
    'L-VVS2-VG-VG-NONE-EX': 7.46,
    'L-VVS2-GOOD-EX-NONE-EX': 7.46,
    'L-VVS2-EX-GOOD-NONE-EX': 7.46,
    'E-IF-EX-VG-STRONG-GOOD': 7.45,
    'E-IF-VG-EX-STRONG-GOOD': 7.45,
    'E-IF-VG-POOR-STRONG-VG': 7.45,
    'E-IF-POOR-VG-STRONG-VG': 7.45,
    'E-IF-GOOD-GOOD-STRONG-VG': 7.45,
    'F-IF-GOOD-GOOD-MEDIUM-VG': 7.45,
    'F-IF-POOR-VG-MEDIUM-VG': 7.45,
    'F-IF-VG-POOR-MEDIUM-VG': 7.45,
    'F-IF-VG-EX-MEDIUM-GOOD': 7.45,
    'F-IF-EX-VG-MEDIUM-GOOD': 7.45,
    'G-IF-GOOD-GOOD-FAINT-VG': 7.45,
    'G-IF-VG-POOR-FAINT-VG': 7.45,
    'G-IF-POOR-VG-FAINT-VG': 7.45,
    'G-IF-VG-EX-FAINT-GOOD': 7.45,
    'G-IF-EX-VG-FAINT-GOOD': 7.45,
    'H-IF-POOR-VG-NONE-VG': 7.45,
    'H-IF-EX-VG-NONE-GOOD': 7.45,
    'H-IF-VG-EX-NONE-GOOD': 7.45,
    'H-IF-VG-POOR-NONE-VG': 7.45,
    'H-IF-GOOD-GOOD-NONE-VG': 7.45,
    'J-IF-GOOD-VG-STRONG-EX': 7.45,
    'J-IF-EX-EX-STRONG-VG': 7.45,
    'J-IF-EX-POOR-STRONG-EX': 7.45,
    'J-IF-VG-GOOD-STRONG-EX': 7.45,
    'J-IF-POOR-EX-STRONG-EX': 7.45,
    'K-IF-POOR-EX-MEDIUM-EX': 7.45,
    'K-IF-EX-EX-MEDIUM-VG': 7.45,
    'K-IF-GOOD-VG-MEDIUM-EX': 7.45,
    'K-IF-EX-POOR-MEDIUM-EX': 7.45,
    'K-IF-VG-GOOD-MEDIUM-EX': 7.45,
    'L-IF-POOR-EX-FAINT-EX': 7.45,
    'L-IF-EX-EX-FAINT-VG': 7.45,
    'L-IF-EX-POOR-FAINT-EX': 7.45,
    'L-IF-VG-GOOD-FAINT-EX': 7.45,
    'L-IF-GOOD-VG-FAINT-EX': 7.45,
    'M-IF-VG-GOOD-NONE-EX': 7.45,
    'M-IF-EX-EX-NONE-VG': 7.45,
    'M-IF-GOOD-VG-NONE-EX': 7.45,
    'M-IF-EX-POOR-NONE-EX': 7.45,
    'M-IF-POOR-EX-NONE-EX': 7.45,
    'D-SI1-POOR-GOOD-FAINT-EX': 7.44,
    'D-SI1-GOOD-POOR-FAINT-EX': 7.44,
    'D-SI1-GOOD-EX-FAINT-VG': 7.44,
    'D-I1-POOR-VG-NONE-EX': 7.44,
    'D-SI1-VG-VG-FAINT-VG': 7.44,
    'D-SI1-EX-GOOD-FAINT-VG': 7.44,
    'D-I1-EX-VG-NONE-VG': 7.44,
    'D-I1-GOOD-GOOD-NONE-EX': 7.44,
    'D-I1-VG-POOR-NONE-EX': 7.44,
    'D-I1-VG-EX-NONE-VG': 7.44,
    'E-SI1-GOOD-POOR-NONE-EX': 7.44,
    'E-SI1-GOOD-EX-NONE-VG': 7.44,
    'E-SI1-EX-GOOD-NONE-VG': 7.44,
    'E-SI1-POOR-GOOD-NONE-EX': 7.44,
    'E-SI1-VG-VG-NONE-VG': 7.44,
    'F-I1-EX-EX-STRONG-EX': 7.44,
    'G-I1-EX-EX-MEDIUM-EX': 7.44,
    'G-SI1-VG-EX-STRONG-EX': 7.44,
    'G-SI1-EX-VG-STRONG-EX': 7.44,
    'H-I1-EX-EX-FAINT-EX': 7.44,
    'H-SI1-VG-EX-MEDIUM-EX': 7.44,
    'H-SI1-EX-VG-MEDIUM-EX': 7.44,
    'I-I1-EX-EX-NONE-EX': 7.44,
    'I-SI1-VG-EX-FAINT-EX': 7.44,
    'I-SI1-EX-VG-FAINT-EX': 7.44,
    'J-SI1-EX-VG-NONE-EX': 7.44,
    'J-SI1-VG-EX-NONE-EX': 7.44,
    'D-VS1-GOOD-VG-MEDIUM-VG': 7.43,
    'D-VVS1-VG-EX-STRONG-GOOD': 7.43,
    'D-VVS1-GOOD-GOOD-STRONG-VG': 7.43,
    'D-VVS1-VG-POOR-STRONG-VG': 7.43,
    'D-VVS1-EX-VG-STRONG-GOOD': 7.43,
    'D-VS1-EX-POOR-MEDIUM-VG': 7.43,
    'D-VVS1-POOR-VG-STRONG-VG': 7.43,
    'D-VS1-EX-EX-MEDIUM-GOOD': 7.43,
    'D-VS1-POOR-EX-MEDIUM-VG': 7.43,
    'D-VS1-VG-GOOD-MEDIUM-VG': 7.43,
    'D-VS1-POOR-POOR-MEDIUM-EX': 7.43,
    'E-VS1-POOR-POOR-FAINT-EX': 7.43,
    'E-VS1-EX-EX-FAINT-GOOD': 7.43,
    'E-VS1-POOR-EX-FAINT-VG': 7.43,
    'E-VVS1-POOR-VG-MEDIUM-VG': 7.43,
    'E-VVS1-GOOD-GOOD-MEDIUM-VG': 7.43,
    'E-VVS1-VG-POOR-MEDIUM-VG': 7.43,
    'E-VS1-GOOD-VG-FAINT-VG': 7.43,
    'E-VS1-EX-POOR-FAINT-VG': 7.43,
    'E-VVS1-VG-EX-MEDIUM-GOOD': 7.43,
    'E-VS1-VG-GOOD-FAINT-VG': 7.43,
    'E-VVS1-EX-VG-MEDIUM-GOOD': 7.43,
    'F-VVS1-POOR-VG-FAINT-VG': 7.43,
    'F-VS1-EX-EX-NONE-GOOD': 7.43,
    'F-VS1-POOR-EX-NONE-VG': 7.43,
    'F-VS1-EX-POOR-NONE-VG': 7.43,
    'F-VVS1-GOOD-GOOD-FAINT-VG': 7.43,
    'F-VS1-VG-GOOD-NONE-VG': 7.43,
    'F-VVS1-VG-POOR-FAINT-VG': 7.43,
    'F-VS1-POOR-POOR-NONE-EX': 7.43,
    'F-VS1-GOOD-VG-NONE-VG': 7.43,
    'F-VVS1-EX-VG-FAINT-GOOD': 7.43,
    'F-VVS1-VG-EX-FAINT-GOOD': 7.43,
    'G-VVS1-EX-VG-NONE-GOOD': 7.43,
    'G-VVS1-VG-POOR-NONE-VG': 7.43,
    'G-VVS1-VG-EX-NONE-GOOD': 7.43,
    'G-VVS1-GOOD-GOOD-NONE-VG': 7.43,
    'G-VVS1-POOR-VG-NONE-VG': 7.43,
    'H-VS1-EX-GOOD-STRONG-EX': 7.43,
    'H-VS1-VG-VG-STRONG-EX': 7.43,
    'H-VS1-GOOD-EX-STRONG-EX': 7.43,
    'I-VS1-VG-VG-MEDIUM-EX': 7.43,
    'I-VS1-GOOD-EX-MEDIUM-EX': 7.43,
    'I-VVS1-EX-POOR-STRONG-EX': 7.43,
    'I-VVS1-GOOD-VG-STRONG-EX': 7.43,
    'I-VS1-EX-GOOD-MEDIUM-EX': 7.43,
    'I-VVS1-EX-EX-STRONG-VG': 7.43,
    'I-VVS1-VG-GOOD-STRONG-EX': 7.43,
    'I-VVS1-POOR-EX-STRONG-EX': 7.43,
    'J-VVS1-POOR-EX-MEDIUM-EX': 7.43,
    'J-VVS1-EX-EX-MEDIUM-VG': 7.43,
    'J-VVS1-EX-POOR-MEDIUM-EX': 7.43,
    'J-VVS1-VG-GOOD-MEDIUM-EX': 7.43,
    'J-VS1-VG-VG-FAINT-EX': 7.43,
    'J-VS1-GOOD-EX-FAINT-EX': 7.43,
    'J-VS1-EX-GOOD-FAINT-EX': 7.43,
    'J-VVS1-GOOD-VG-MEDIUM-EX': 7.43,
    'K-VVS1-EX-POOR-FAINT-EX': 7.43,
    'K-VS1-VG-VG-NONE-EX': 7.43,
    'K-VS1-EX-GOOD-NONE-EX': 7.43,
    'K-VVS1-VG-GOOD-FAINT-EX': 7.43,
    'K-VS1-GOOD-EX-NONE-EX': 7.43,
    'K-VVS1-EX-EX-FAINT-VG': 7.43,
    'K-VVS1-GOOD-VG-FAINT-EX': 7.43,
    'K-VVS1-POOR-EX-FAINT-EX': 7.43,
    'L-VVS1-EX-EX-NONE-VG': 7.43,
    'L-VVS1-EX-POOR-NONE-EX': 7.43,
    'L-VVS1-VG-GOOD-NONE-EX': 7.43,
    'L-VVS1-POOR-EX-NONE-EX': 7.43,
    'L-VVS1-GOOD-VG-NONE-EX': 7.43,
    'D-SI2-VG-VG-NONE-VG': 7.42,
    'D-SI2-GOOD-POOR-NONE-EX': 7.42,
    'D-SI2-EX-GOOD-NONE-VG': 7.42,
    'D-SI2-GOOD-EX-NONE-VG': 7.42,
    'D-SI2-POOR-GOOD-NONE-EX': 7.42,
    'E-I2-EX-EX-STRONG-EX': 7.42,
    'F-I2-EX-EX-MEDIUM-EX': 7.42,
    'F-SI2-VG-EX-STRONG-EX': 7.42,
    'F-SI2-EX-VG-STRONG-EX': 7.42,
    'G-SI2-EX-VG-MEDIUM-EX': 7.42,
    'G-I2-EX-EX-FAINT-EX': 7.42,
    'G-SI2-VG-EX-MEDIUM-EX': 7.42,
    'H-SI2-EX-VG-FAINT-EX': 7.42,
    'H-SI2-VG-EX-FAINT-EX': 7.42,
    'H-I2-EX-EX-NONE-EX': 7.42,
    'I-SI2-EX-VG-NONE-EX': 7.42,
    'I-SI2-VG-EX-NONE-EX': 7.42,
    'D-VVS2-VG-EX-MEDIUM-GOOD': 7.41,
    'D-VS2-GOOD-VG-FAINT-VG': 7.41,
    'D-VS2-EX-EX-FAINT-GOOD': 7.41,
    'D-VVS2-GOOD-GOOD-MEDIUM-VG': 7.41,
    'D-VS2-POOR-EX-FAINT-VG': 7.41,
    'D-VVS2-VG-POOR-MEDIUM-VG': 7.41,
    'D-VS2-EX-POOR-FAINT-VG': 7.41,
    'D-VVS2-EX-VG-MEDIUM-GOOD': 7.41,
    'D-VVS2-POOR-VG-MEDIUM-VG': 7.41,
    'D-VS2-POOR-POOR-FAINT-EX': 7.41,
    'D-VS2-VG-GOOD-FAINT-VG': 7.41,
    'E-VS2-GOOD-VG-NONE-VG': 7.41,
    'E-VS2-VG-GOOD-NONE-VG': 7.41,
    'E-VS2-EX-POOR-NONE-VG': 7.41,
    'E-VVS2-VG-EX-FAINT-GOOD': 7.41,
    'E-VS2-POOR-POOR-NONE-EX': 7.41,
    'E-VVS2-POOR-VG-FAINT-VG': 7.41,
    'E-VVS2-VG-POOR-FAINT-VG': 7.41,
    'E-VVS2-GOOD-GOOD-FAINT-VG': 7.41,
    'E-VS2-EX-EX-NONE-GOOD': 7.41,
    'E-VS2-POOR-EX-NONE-VG': 7.41,
    'E-VVS2-EX-VG-FAINT-GOOD': 7.41,
    'F-VVS2-EX-VG-NONE-GOOD': 7.41,
    'F-VVS2-POOR-VG-NONE-VG': 7.41,
    'F-VVS2-GOOD-GOOD-NONE-VG': 7.41,
    'F-VVS2-VG-POOR-NONE-VG': 7.41,
    'F-VVS2-VG-EX-NONE-GOOD': 7.41,
    'G-VS2-EX-GOOD-STRONG-EX': 7.41,
    'G-VS2-VG-VG-STRONG-EX': 7.41,
    'G-VS2-GOOD-EX-STRONG-EX': 7.41,
    'H-VVS2-EX-EX-STRONG-VG': 7.41,
    'H-VVS2-GOOD-VG-STRONG-EX': 7.41,
    'H-VVS2-POOR-EX-STRONG-EX': 7.41,
    'H-VVS2-VG-GOOD-STRONG-EX': 7.41,
    'H-VVS2-EX-POOR-STRONG-EX': 7.41,
    'H-VS2-GOOD-EX-MEDIUM-EX': 7.41,
    'H-VS2-EX-GOOD-MEDIUM-EX': 7.41,
    'H-VS2-VG-VG-MEDIUM-EX': 7.41,
    'I-VVS2-POOR-EX-MEDIUM-EX': 7.41,
    'I-VS2-VG-VG-FAINT-EX': 7.41,
    'I-VS2-GOOD-EX-FAINT-EX': 7.41,
    'I-VVS2-GOOD-VG-MEDIUM-EX': 7.41,
    'I-VVS2-VG-GOOD-MEDIUM-EX': 7.41,
    'I-VVS2-EX-POOR-MEDIUM-EX': 7.41,
    'I-VVS2-EX-EX-MEDIUM-VG': 7.41,
    'I-VS2-EX-GOOD-FAINT-EX': 7.41,
    'J-VVS2-VG-GOOD-FAINT-EX': 7.41,
    'J-VVS2-EX-EX-FAINT-VG': 7.41,
    'J-VVS2-EX-POOR-FAINT-EX': 7.41,
    'J-VVS2-POOR-EX-FAINT-EX': 7.41,
    'J-VS2-EX-GOOD-NONE-EX': 7.41,
    'J-VS2-VG-VG-NONE-EX': 7.41,
    'J-VVS2-GOOD-VG-FAINT-EX': 7.41,
    'J-VS2-GOOD-EX-NONE-EX': 7.41,
    'K-VVS2-EX-POOR-NONE-EX': 7.41,
    'K-VVS2-GOOD-VG-NONE-EX': 7.41,
    'K-VVS2-VG-GOOD-NONE-EX': 7.41,
    'K-VVS2-EX-EX-NONE-VG': 7.41,
    'K-VVS2-POOR-EX-NONE-EX': 7.41,
    'D-IF-GOOD-POOR-STRONG-VG': 7.4,
    'D-IF-EX-GOOD-STRONG-GOOD': 7.4,
    'D-IF-POOR-GOOD-STRONG-VG': 7.4,
    'D-IF-VG-VG-STRONG-GOOD': 7.4,
    'D-IF-GOOD-EX-STRONG-GOOD': 7.4,
    'E-IF-GOOD-EX-MEDIUM-GOOD': 7.4,
    'E-IF-GOOD-POOR-MEDIUM-VG': 7.4,
    'E-IF-VG-VG-MEDIUM-GOOD': 7.4,
    'E-IF-EX-GOOD-MEDIUM-GOOD': 7.4,
    'E-IF-POOR-GOOD-MEDIUM-VG': 7.4,
    'F-IF-GOOD-POOR-FAINT-VG': 7.4,
    'F-IF-GOOD-EX-FAINT-GOOD': 7.4,
    'F-IF-POOR-GOOD-FAINT-VG': 7.4,
    'F-IF-EX-GOOD-FAINT-GOOD': 7.4,
    'F-IF-VG-VG-FAINT-GOOD': 7.4,
    'G-IF-VG-VG-NONE-GOOD': 7.4,
    'G-IF-GOOD-EX-NONE-GOOD': 7.4,
    'G-IF-GOOD-POOR-NONE-VG': 7.4,
    'G-IF-POOR-GOOD-NONE-VG': 7.4,
    'G-IF-EX-GOOD-NONE-GOOD': 7.4,
    'I-IF-GOOD-GOOD-STRONG-EX': 7.4,
    'I-IF-POOR-VG-STRONG-EX': 7.4,
    'I-IF-VG-POOR-STRONG-EX': 7.4,
    'I-IF-VG-EX-STRONG-VG': 7.4,
    'I-IF-EX-VG-STRONG-VG': 7.4,
    'J-IF-VG-POOR-MEDIUM-EX': 7.4,
    'J-IF-EX-VG-MEDIUM-VG': 7.4,
    'J-IF-VG-EX-MEDIUM-VG': 7.4,
    'J-IF-GOOD-GOOD-MEDIUM-EX': 7.4,
    'J-IF-POOR-VG-MEDIUM-EX': 7.4,
    'K-IF-POOR-VG-FAINT-EX': 7.4,
    'K-IF-EX-VG-FAINT-VG': 7.4,
    'K-IF-VG-EX-FAINT-VG': 7.4,
    'K-IF-VG-POOR-FAINT-EX': 7.4,
    'K-IF-GOOD-GOOD-FAINT-EX': 7.4,
    'L-IF-VG-POOR-NONE-EX': 7.4,
    'L-IF-GOOD-GOOD-NONE-EX': 7.4,
    'L-IF-POOR-VG-NONE-EX': 7.4,
    'L-IF-EX-VG-NONE-VG': 7.4,
    'L-IF-VG-EX-NONE-VG': 7.4,
    'D-SI1-POOR-EX-NONE-VG': 7.39,
    'D-SI1-POOR-POOR-NONE-EX': 7.39,
    'D-SI1-VG-GOOD-NONE-VG': 7.39,
    'D-SI1-EX-EX-NONE-GOOD': 7.39,
    'D-SI1-EX-POOR-NONE-VG': 7.39,
    'D-SI1-GOOD-VG-NONE-VG': 7.39,
    'E-I1-EX-VG-STRONG-EX': 7.39,
    'E-I1-VG-EX-STRONG-EX': 7.39,
    'F-SI1-EX-GOOD-STRONG-EX': 7.39,
    'F-I1-EX-VG-MEDIUM-EX': 7.39,
    'F-I1-VG-EX-MEDIUM-EX': 7.39,
    'F-SI1-VG-VG-STRONG-EX': 7.39,
    'F-SI1-GOOD-EX-STRONG-EX': 7.39,
    'G-I1-EX-VG-FAINT-EX': 7.39,
    'G-I1-VG-EX-FAINT-EX': 7.39,
    'G-SI1-EX-GOOD-MEDIUM-EX': 7.39,
    'G-SI1-GOOD-EX-MEDIUM-EX': 7.39,
    'G-SI1-VG-VG-MEDIUM-EX': 7.39,
    'H-I1-EX-VG-NONE-EX': 7.39,
    'H-I1-VG-EX-NONE-EX': 7.39,
    'H-SI1-EX-GOOD-FAINT-EX': 7.39,
    'H-SI1-VG-VG-FAINT-EX': 7.39,
    'H-SI1-GOOD-EX-FAINT-EX': 7.39,
    'I-SI1-EX-GOOD-NONE-EX': 7.39,
    'I-SI1-GOOD-EX-NONE-EX': 7.39,
    'I-SI1-VG-VG-NONE-EX': 7.39,
    'D-VS1-EX-VG-FAINT-GOOD': 7.38,
    'D-VS1-VG-POOR-FAINT-VG': 7.38,
    'D-VS1-VG-EX-FAINT-GOOD': 7.38,
    'D-VS1-GOOD-GOOD-FAINT-VG': 7.38,
    'D-VVS1-GOOD-POOR-MEDIUM-VG': 7.38,
    'D-VVS1-VG-VG-MEDIUM-GOOD': 7.38,
    'D-VVS1-POOR-GOOD-MEDIUM-VG': 7.38,
    'D-VVS1-GOOD-EX-MEDIUM-GOOD': 7.38,
    'D-VVS1-EX-GOOD-MEDIUM-GOOD': 7.38,
    'D-VS1-POOR-VG-FAINT-VG': 7.38,
    'E-VS1-GOOD-GOOD-NONE-VG': 7.38,
    'E-VS1-POOR-VG-NONE-VG': 7.38,
    'E-VS1-EX-VG-NONE-GOOD': 7.38,
    'E-VS1-VG-POOR-NONE-VG': 7.38,
    'E-VS1-VG-EX-NONE-GOOD': 7.38,
    'E-VVS1-VG-VG-FAINT-GOOD': 7.38,
    'E-VVS1-GOOD-EX-FAINT-GOOD': 7.38,
    'E-VVS1-GOOD-POOR-FAINT-VG': 7.38,
    'E-VVS1-POOR-GOOD-FAINT-VG': 7.38,
    'E-VVS1-EX-GOOD-FAINT-GOOD': 7.38,
    'F-VVS1-GOOD-POOR-NONE-VG': 7.38,
    'F-VVS1-POOR-GOOD-NONE-VG': 7.38,
    'F-VVS1-EX-GOOD-NONE-GOOD': 7.38,
    'F-VVS1-VG-VG-NONE-GOOD': 7.38,
    'F-VVS1-GOOD-EX-NONE-GOOD': 7.38,
    'G-VS1-POOR-EX-STRONG-EX': 7.38,
    'G-VS1-GOOD-VG-STRONG-EX': 7.38,
    'G-VS1-VG-GOOD-STRONG-EX': 7.38,
    'G-VS1-EX-POOR-STRONG-EX': 7.38,
    'G-VS1-EX-EX-STRONG-VG': 7.38,
    'H-VVS1-VG-POOR-STRONG-EX': 7.38,
    'H-VS1-VG-GOOD-MEDIUM-EX': 7.38,
    'H-VVS1-GOOD-GOOD-STRONG-EX': 7.38,
    'H-VVS1-VG-EX-STRONG-VG': 7.38,
    'H-VS1-GOOD-VG-MEDIUM-EX': 7.38,
    'H-VS1-EX-POOR-MEDIUM-EX': 7.38,
    'H-VVS1-POOR-VG-STRONG-EX': 7.38,
    'H-VS1-POOR-EX-MEDIUM-EX': 7.38,
    'H-VS1-EX-EX-MEDIUM-VG': 7.38,
    'H-VVS1-EX-VG-STRONG-VG': 7.38,
    'I-VS1-EX-EX-FAINT-VG': 7.38,
    'I-VS1-EX-POOR-FAINT-EX': 7.38,
    'I-VVS1-EX-VG-MEDIUM-VG': 7.38,
    'I-VVS1-VG-EX-MEDIUM-VG': 7.38,
    'I-VVS1-VG-POOR-MEDIUM-EX': 7.38,
    'I-VVS1-GOOD-GOOD-MEDIUM-EX': 7.38,
    'I-VVS1-POOR-VG-MEDIUM-EX': 7.38,
    'I-VS1-VG-GOOD-FAINT-EX': 7.38,
    'I-VS1-POOR-EX-FAINT-EX': 7.38,
    'I-VS1-GOOD-VG-FAINT-EX': 7.38,
    'J-VVS1-POOR-VG-FAINT-EX': 7.38,
    'J-VVS1-EX-VG-FAINT-VG': 7.38,
    'J-VS1-POOR-EX-NONE-EX': 7.38,
    'J-VS1-GOOD-VG-NONE-EX': 7.38,
    'J-VS1-VG-GOOD-NONE-EX': 7.38,
    'J-VS1-EX-EX-NONE-VG': 7.38,
    'J-VS1-EX-POOR-NONE-EX': 7.38,
    'J-VVS1-GOOD-GOOD-FAINT-EX': 7.38,
    'J-VVS1-VG-POOR-FAINT-EX': 7.38,
    'J-VVS1-VG-EX-FAINT-VG': 7.38,
    'K-VVS1-VG-EX-NONE-VG': 7.38,
    'K-VVS1-EX-VG-NONE-VG': 7.38,
    'K-VVS1-GOOD-GOOD-NONE-EX': 7.38,
    'K-VVS1-POOR-VG-NONE-EX': 7.38,
    'K-VVS1-VG-POOR-NONE-EX': 7.38,
    'M-VVS1-EX-EX-STRONG-EX': 7.38,
    'D-I2-EX-VG-STRONG-EX': 7.37,
    'D-I2-VG-EX-STRONG-EX': 7.37,
    'E-I2-EX-VG-MEDIUM-EX': 7.37,
    'E-SI2-GOOD-EX-STRONG-EX': 7.37,
    'E-SI2-VG-VG-STRONG-EX': 7.37,
    'E-I2-VG-EX-MEDIUM-EX': 7.37,
    'E-SI2-EX-GOOD-STRONG-EX': 7.37,
    'F-I2-VG-EX-FAINT-EX': 7.37,
    'F-SI2-VG-VG-MEDIUM-EX': 7.37,
    'F-SI2-GOOD-EX-MEDIUM-EX': 7.37,
    'F-SI2-EX-GOOD-MEDIUM-EX': 7.37,
    'F-I2-EX-VG-FAINT-EX': 7.37,
    'G-SI2-VG-VG-FAINT-EX': 7.37,
    'G-I2-VG-EX-NONE-EX': 7.37,
    'G-I2-EX-VG-NONE-EX': 7.37,
    'G-SI2-EX-GOOD-FAINT-EX': 7.37,
    'G-SI2-GOOD-EX-FAINT-EX': 7.37,
    'H-SI2-GOOD-EX-NONE-EX': 7.37,
    'H-SI2-EX-GOOD-NONE-EX': 7.37,
    'H-SI2-VG-VG-NONE-EX': 7.37,
    'D-VS2-VG-EX-NONE-GOOD': 7.36,
    'D-VS2-GOOD-GOOD-NONE-VG': 7.36,
    'D-VVS2-POOR-GOOD-FAINT-VG': 7.36,
    'D-VVS2-VG-VG-FAINT-GOOD': 7.36,
    'D-VVS2-EX-GOOD-FAINT-GOOD': 7.36,
    'D-VS2-VG-POOR-NONE-VG': 7.36,
    'D-VS2-POOR-VG-NONE-VG': 7.36,
    'D-VS2-EX-VG-NONE-GOOD': 7.36,
    'D-VVS2-GOOD-POOR-FAINT-VG': 7.36,
    'D-VVS2-GOOD-EX-FAINT-GOOD': 7.36,
    'E-VVS2-EX-GOOD-NONE-GOOD': 7.36,
    'E-VVS2-POOR-GOOD-NONE-VG': 7.36,
    'E-VVS2-VG-VG-NONE-GOOD': 7.36,
    'E-VVS2-GOOD-EX-NONE-GOOD': 7.36,
    'E-VVS2-GOOD-POOR-NONE-VG': 7.36,
    'F-VS2-EX-EX-STRONG-VG': 7.36,
    'F-VS2-VG-GOOD-STRONG-EX': 7.36,
    'F-VS2-EX-POOR-STRONG-EX': 7.36,
    'F-VS2-POOR-EX-STRONG-EX': 7.36,
    'F-VS2-GOOD-VG-STRONG-EX': 7.36,
    'G-VVS2-GOOD-GOOD-STRONG-EX': 7.36,
    'G-VS2-EX-EX-MEDIUM-VG': 7.36,
    'G-VVS2-VG-EX-STRONG-VG': 7.36,
    'G-VS2-EX-POOR-MEDIUM-EX': 7.36,
    'G-VVS2-EX-VG-STRONG-VG': 7.36,
    'G-VS2-VG-GOOD-MEDIUM-EX': 7.36,
    'G-VVS2-VG-POOR-STRONG-EX': 7.36,
    'G-VS2-POOR-EX-MEDIUM-EX': 7.36,
    'G-VS2-GOOD-VG-MEDIUM-EX': 7.36,
    'G-VVS2-POOR-VG-STRONG-EX': 7.36,
    'H-VS2-POOR-EX-FAINT-EX': 7.36,
    'H-VS2-EX-EX-FAINT-VG': 7.36,
    'H-VVS2-GOOD-GOOD-MEDIUM-EX': 7.36,
    'H-VVS2-EX-VG-MEDIUM-VG': 7.36,
    'H-VS2-EX-POOR-FAINT-EX': 7.36,
    'H-VVS2-VG-EX-MEDIUM-VG': 7.36,
    'H-VVS2-VG-POOR-MEDIUM-EX': 7.36,
    'H-VVS2-POOR-VG-MEDIUM-EX': 7.36,
    'H-VS2-VG-GOOD-FAINT-EX': 7.36,
    'H-VS2-GOOD-VG-FAINT-EX': 7.36,
    'I-VS2-EX-POOR-NONE-EX': 7.36,
    'I-VVS2-VG-POOR-FAINT-EX': 7.36,
    'I-VVS2-EX-VG-FAINT-VG': 7.36,
    'I-VVS2-VG-EX-FAINT-VG': 7.36,
    'I-VS2-EX-EX-NONE-VG': 7.36,
    'I-VS2-VG-GOOD-NONE-EX': 7.36,
    'I-VS2-GOOD-VG-NONE-EX': 7.36,
    'I-VS2-POOR-EX-NONE-EX': 7.36,
    'I-VVS2-POOR-VG-FAINT-EX': 7.36,
    'I-VVS2-GOOD-GOOD-FAINT-EX': 7.36,
    'J-VVS2-POOR-VG-NONE-EX': 7.36,
    'J-VVS2-EX-VG-NONE-VG': 7.36,
    'J-VVS2-VG-POOR-NONE-EX': 7.36,
    'J-VVS2-VG-EX-NONE-VG': 7.36,
    'J-VVS2-GOOD-GOOD-NONE-EX': 7.36,
    'L-VVS2-EX-EX-STRONG-EX': 7.36,
    'M-VVS2-EX-EX-MEDIUM-EX': 7.36,
    'D-IF-POOR-EX-MEDIUM-GOOD': 7.35,
    'D-IF-GOOD-VG-MEDIUM-GOOD': 7.35,
    'D-IF-EX-POOR-MEDIUM-GOOD': 7.35,
    'D-IF-POOR-POOR-MEDIUM-VG': 7.35,
    'D-IF-EX-EX-MEDIUM-POOR': 7.35,
    'D-IF-VG-GOOD-MEDIUM-GOOD': 7.35,
    'E-IF-VG-GOOD-FAINT-GOOD': 7.35,
    'E-IF-EX-POOR-FAINT-GOOD': 7.35,
    'E-IF-POOR-POOR-FAINT-VG': 7.35,
    'E-IF-POOR-EX-FAINT-GOOD': 7.35,
    'E-IF-EX-EX-FAINT-POOR': 7.35,
    'E-IF-GOOD-VG-FAINT-GOOD': 7.35,
    'F-IF-GOOD-VG-NONE-GOOD': 7.35,
    'F-IF-VG-GOOD-NONE-GOOD': 7.35,
    'F-IF-EX-POOR-NONE-GOOD': 7.35,
    'F-IF-EX-EX-NONE-POOR': 7.35,
    'F-IF-POOR-POOR-NONE-VG': 7.35,
    'F-IF-POOR-EX-NONE-GOOD': 7.35,
    'H-IF-POOR-GOOD-STRONG-EX': 7.35,
    'H-IF-VG-VG-STRONG-VG': 7.35,
    'H-IF-GOOD-EX-STRONG-VG': 7.35,
    'H-IF-GOOD-POOR-STRONG-EX': 7.35,
    'H-IF-EX-GOOD-STRONG-VG': 7.35,
    'I-IF-POOR-GOOD-MEDIUM-EX': 7.35,
    'I-IF-GOOD-EX-MEDIUM-VG': 7.35,
    'I-IF-GOOD-POOR-MEDIUM-EX': 7.35,
    'I-IF-VG-VG-MEDIUM-VG': 7.35,
    'I-IF-EX-GOOD-MEDIUM-VG': 7.35,
    'J-IF-VG-VG-FAINT-VG': 7.35,
    'J-IF-GOOD-EX-FAINT-VG': 7.35,
    'J-IF-EX-GOOD-FAINT-VG': 7.35,
    'J-IF-POOR-GOOD-FAINT-EX': 7.35,
    'J-IF-GOOD-POOR-FAINT-EX': 7.35,
    'K-IF-POOR-GOOD-NONE-EX': 7.35,
    'K-IF-GOOD-POOR-NONE-EX': 7.35,
    'K-IF-EX-GOOD-NONE-VG': 7.35,
    'K-IF-VG-VG-NONE-VG': 7.35,
    'K-IF-GOOD-EX-NONE-VG': 7.35,
    'M-IF-VG-EX-STRONG-EX': 7.35,
    'M-IF-EX-VG-STRONG-EX': 7.35,
    'D-I1-GOOD-EX-STRONG-EX': 7.34,
    'D-I1-EX-GOOD-STRONG-EX': 7.34,
    'D-I1-VG-VG-STRONG-EX': 7.34,
    'E-SI1-POOR-EX-STRONG-EX': 7.34,
    'E-I1-EX-GOOD-MEDIUM-EX': 7.34,
    'E-SI1-GOOD-VG-STRONG-EX': 7.34,
    'E-I1-VG-VG-MEDIUM-EX': 7.34,
    'E-I1-GOOD-EX-MEDIUM-EX': 7.34,
    'E-SI1-VG-GOOD-STRONG-EX': 7.34,
    'E-SI1-EX-POOR-STRONG-EX': 7.34,
    'E-SI1-EX-EX-STRONG-VG': 7.34,
    'F-I1-GOOD-EX-FAINT-EX': 7.34,
    'F-I1-VG-VG-FAINT-EX': 7.34,
    'F-I1-EX-GOOD-FAINT-EX': 7.34,
    'F-SI1-VG-GOOD-MEDIUM-EX': 7.34,
    'F-SI1-POOR-EX-MEDIUM-EX': 7.34,
    'F-SI1-EX-EX-MEDIUM-VG': 7.34,
    'F-SI1-GOOD-VG-MEDIUM-EX': 7.34,
    'F-SI1-EX-POOR-MEDIUM-EX': 7.34,
    'G-SI1-VG-GOOD-FAINT-EX': 7.34,
    'G-SI1-EX-POOR-FAINT-EX': 7.34,
    'G-SI1-GOOD-VG-FAINT-EX': 7.34,
    'G-SI1-EX-EX-FAINT-VG': 7.34,
    'G-SI1-POOR-EX-FAINT-EX': 7.34,
    'G-I1-GOOD-EX-NONE-EX': 7.34,
    'G-I1-VG-VG-NONE-EX': 7.34,
    'G-I1-EX-GOOD-NONE-EX': 7.34,
    'H-SI1-GOOD-VG-NONE-EX': 7.34,
    'H-SI1-POOR-EX-NONE-EX': 7.34,
    'H-SI1-EX-EX-NONE-VG': 7.34,
    'H-SI1-EX-POOR-NONE-EX': 7.34,
    'H-SI1-VG-GOOD-NONE-EX': 7.34,
    'D-VS1-GOOD-POOR-NONE-VG': 7.33,
    'D-VVS1-EX-EX-FAINT-POOR': 7.33,
    'D-VS1-POOR-GOOD-NONE-VG': 7.33,
    'D-VVS1-GOOD-VG-FAINT-GOOD': 7.33,
    'D-VS1-EX-GOOD-NONE-GOOD': 7.33,
    'D-VVS1-VG-GOOD-FAINT-GOOD': 7.33,
    'D-VS1-VG-VG-NONE-GOOD': 7.33,
    'D-VS1-GOOD-EX-NONE-GOOD': 7.33,
    'D-VVS1-POOR-EX-FAINT-GOOD': 7.33,
    'D-VVS1-POOR-POOR-FAINT-VG': 7.33,
    'D-VVS1-EX-POOR-FAINT-GOOD': 7.33,
    'E-VVS1-EX-EX-NONE-POOR': 7.33,
    'E-VVS1-EX-POOR-NONE-GOOD': 7.33,
    'E-VVS1-VG-GOOD-NONE-GOOD': 7.33,
    'E-VVS1-GOOD-VG-NONE-GOOD': 7.33,
    'E-VVS1-POOR-EX-NONE-GOOD': 7.33,
    'E-VVS1-POOR-POOR-NONE-VG': 7.33,
    'F-VS1-VG-POOR-STRONG-EX': 7.33,
    'F-VS1-VG-EX-STRONG-VG': 7.33,
    'F-VS1-GOOD-GOOD-STRONG-EX': 7.33,
    'F-VS1-EX-VG-STRONG-VG': 7.33,
    'F-VS1-POOR-VG-STRONG-EX': 7.33,
    'G-VVS1-POOR-GOOD-STRONG-EX': 7.33,
    'G-VVS1-GOOD-EX-STRONG-VG': 7.33,
    'G-VVS1-GOOD-POOR-STRONG-EX': 7.33,
    'G-VVS1-VG-VG-STRONG-VG': 7.33,
    'G-VS1-VG-POOR-MEDIUM-EX': 7.33,
    'G-VS1-GOOD-GOOD-MEDIUM-EX': 7.33,
    'G-VS1-VG-EX-MEDIUM-VG': 7.33,
    'G-VS1-EX-VG-MEDIUM-VG': 7.33,
    'G-VS1-POOR-VG-MEDIUM-EX': 7.33,
    'G-VVS1-EX-GOOD-STRONG-VG': 7.33,
    'H-VS1-GOOD-GOOD-FAINT-EX': 7.33,
    'H-VS1-POOR-VG-FAINT-EX': 7.33,
    'H-VS1-EX-VG-FAINT-VG': 7.33,
    'H-VS1-VG-EX-FAINT-VG': 7.33,
    'H-VS1-VG-POOR-FAINT-EX': 7.33,
    'H-VVS1-GOOD-EX-MEDIUM-VG': 7.33,
    'H-VVS1-POOR-GOOD-MEDIUM-EX': 7.33,
    'H-VVS1-GOOD-POOR-MEDIUM-EX': 7.33,
    'H-VVS1-EX-GOOD-MEDIUM-VG': 7.33,
    'H-VVS1-VG-VG-MEDIUM-VG': 7.33,
    'I-VVS1-POOR-GOOD-FAINT-EX': 7.33,
    'I-VS1-EX-VG-NONE-VG': 7.33,
    'I-VS1-VG-EX-NONE-VG': 7.33,
    'I-VS1-VG-POOR-NONE-EX': 7.33,
    'I-VS1-GOOD-GOOD-NONE-EX': 7.33,
    'I-VS1-POOR-VG-NONE-EX': 7.33,
    'I-VVS1-VG-VG-FAINT-VG': 7.33,
    'I-VVS1-GOOD-POOR-FAINT-EX': 7.33,
    'I-VVS1-EX-GOOD-FAINT-VG': 7.33,
    'I-VVS1-GOOD-EX-FAINT-VG': 7.33,
    'J-VVS1-POOR-GOOD-NONE-EX': 7.33,
    'J-VVS1-GOOD-POOR-NONE-EX': 7.33,
    'J-VVS1-GOOD-EX-NONE-VG': 7.33,
    'J-VVS1-VG-VG-NONE-VG': 7.33,
    'J-VVS1-EX-GOOD-NONE-VG': 7.33,
    'K-VS1-EX-EX-STRONG-EX': 7.33,
    'L-VS1-EX-EX-MEDIUM-EX': 7.33,
    'L-VVS1-VG-EX-STRONG-EX': 7.33,
    'L-VVS1-EX-VG-STRONG-EX': 7.33,
    'M-VS1-EX-EX-FAINT-EX': 7.33,
    'M-VVS1-EX-VG-MEDIUM-EX': 7.33,
    'M-VVS1-VG-EX-MEDIUM-EX': 7.33,
    'D-SI2-EX-POOR-STRONG-EX': 7.32,
    'D-SI2-POOR-EX-STRONG-EX': 7.32,
    'D-SI2-VG-GOOD-STRONG-EX': 7.32,
    'D-SI2-EX-EX-STRONG-VG': 7.32,
    'D-I2-EX-GOOD-MEDIUM-EX': 7.32,
    'D-I2-VG-VG-MEDIUM-EX': 7.32,
    'D-I2-GOOD-EX-MEDIUM-EX': 7.32,
    'D-SI2-GOOD-VG-STRONG-EX': 7.32,
    'E-I2-VG-VG-FAINT-EX': 7.32,
    'E-SI2-GOOD-VG-MEDIUM-EX': 7.32,
    'E-SI2-VG-GOOD-MEDIUM-EX': 7.32,
    'E-SI2-EX-EX-MEDIUM-VG': 7.32,
    'E-SI2-POOR-EX-MEDIUM-EX': 7.32,
    'E-I2-EX-GOOD-FAINT-EX': 7.32,
    'E-SI2-EX-POOR-MEDIUM-EX': 7.32,
    'E-I2-GOOD-EX-FAINT-EX': 7.32,
    'F-I2-VG-VG-NONE-EX': 7.32,
    'F-SI2-GOOD-VG-FAINT-EX': 7.32,
    'F-SI2-EX-EX-FAINT-VG': 7.32,
    'F-I2-EX-GOOD-NONE-EX': 7.32,
    'F-SI2-POOR-EX-FAINT-EX': 7.32,
    'F-SI2-VG-GOOD-FAINT-EX': 7.32,
    'F-SI2-EX-POOR-FAINT-EX': 7.32,
    'F-I2-GOOD-EX-NONE-EX': 7.32,
    'G-SI2-VG-GOOD-NONE-EX': 7.32,
    'G-SI2-EX-POOR-NONE-EX': 7.32,
    'G-SI2-GOOD-VG-NONE-EX': 7.32,
    'G-SI2-EX-EX-NONE-VG': 7.32,
    'G-SI2-POOR-EX-NONE-EX': 7.32,
    'D-VVS2-EX-EX-NONE-POOR': 7.31,
    'D-VVS2-VG-GOOD-NONE-GOOD': 7.31,
    'D-VVS2-POOR-EX-NONE-GOOD': 7.31,
    'D-VVS2-POOR-POOR-NONE-VG': 7.31,
    'D-VVS2-EX-POOR-NONE-GOOD': 7.31,
    'D-VVS2-GOOD-VG-NONE-GOOD': 7.31,
    'E-VS2-VG-POOR-STRONG-EX': 7.31,
    'E-VS2-VG-EX-STRONG-VG': 7.31,
    'E-VS2-GOOD-GOOD-STRONG-EX': 7.31,
    'E-VS2-EX-VG-STRONG-VG': 7.31,
    'E-VS2-POOR-VG-STRONG-EX': 7.31,
    'F-VS2-POOR-VG-MEDIUM-EX': 7.31,
    'F-VS2-EX-VG-MEDIUM-VG': 7.31,
    'F-VS2-GOOD-GOOD-MEDIUM-EX': 7.31,
    'F-VS2-VG-EX-MEDIUM-VG': 7.31,
    'F-VS2-VG-POOR-MEDIUM-EX': 7.31,
    'F-VVS2-EX-GOOD-STRONG-VG': 7.31,
    'F-VVS2-VG-VG-STRONG-VG': 7.31,
    'F-VVS2-POOR-GOOD-STRONG-EX': 7.31,
    'F-VVS2-GOOD-POOR-STRONG-EX': 7.31,
    'F-VVS2-GOOD-EX-STRONG-VG': 7.31,
    'G-VS2-GOOD-GOOD-FAINT-EX': 7.31,
    'G-VS2-VG-POOR-FAINT-EX': 7.31,
    'G-VS2-EX-VG-FAINT-VG': 7.31,
    'G-VS2-VG-EX-FAINT-VG': 7.31,
    'G-VVS2-POOR-GOOD-MEDIUM-EX': 7.31,
    'G-VVS2-VG-VG-MEDIUM-VG': 7.31,
    'G-VVS2-GOOD-EX-MEDIUM-VG': 7.31,
    'G-VVS2-GOOD-POOR-MEDIUM-EX': 7.31,
    'G-VVS2-EX-GOOD-MEDIUM-VG': 7.31,
    'G-VS2-POOR-VG-FAINT-EX': 7.31,
    'H-VS2-VG-POOR-NONE-EX': 7.31,
    'H-VS2-VG-EX-NONE-VG': 7.31,
    'H-VVS2-VG-VG-FAINT-VG': 7.31,
    'H-VVS2-GOOD-POOR-FAINT-EX': 7.31,
    'H-VS2-EX-VG-NONE-VG': 7.31,
    'H-VVS2-POOR-GOOD-FAINT-EX': 7.31,
    'H-VVS2-EX-GOOD-FAINT-VG': 7.31,
    'H-VS2-GOOD-GOOD-NONE-EX': 7.31,
    'H-VVS2-GOOD-EX-FAINT-VG': 7.31,
    'H-VS2-POOR-VG-NONE-EX': 7.31,
    'I-VVS2-VG-VG-NONE-VG': 7.31,
    'I-VVS2-EX-GOOD-NONE-VG': 7.31,
    'I-VVS2-GOOD-POOR-NONE-EX': 7.31,
    'I-VVS2-GOOD-EX-NONE-VG': 7.31,
    'I-VVS2-POOR-GOOD-NONE-EX': 7.31,
    'J-VS2-EX-EX-STRONG-EX': 7.31,
    'K-VVS2-EX-VG-STRONG-EX': 7.31,
    'K-VVS2-VG-EX-STRONG-EX': 7.31,
    'K-VS2-EX-EX-MEDIUM-EX': 7.31,
    'L-VVS2-VG-EX-MEDIUM-EX': 7.31,
    'L-VS2-EX-EX-FAINT-EX': 7.31,
    'L-VVS2-EX-VG-MEDIUM-EX': 7.31,
    'M-VS2-EX-EX-NONE-EX': 7.31,
    'M-VVS2-VG-EX-FAINT-EX': 7.31,
    'M-VVS2-EX-VG-FAINT-EX': 7.31,
    'D-IF-POOR-VG-FAINT-GOOD': 7.3,
    'D-IF-VG-POOR-FAINT-GOOD': 7.3,
    'D-IF-GOOD-GOOD-FAINT-GOOD': 7.3,
    'D-IF-VG-EX-FAINT-POOR': 7.3,
    'D-IF-EX-VG-FAINT-POOR': 7.3,
    'E-IF-VG-EX-NONE-POOR': 7.3,
    'E-IF-VG-POOR-NONE-GOOD': 7.3,
    'E-IF-GOOD-GOOD-NONE-GOOD': 7.3,
    'E-IF-POOR-VG-NONE-GOOD': 7.3,
    'E-IF-EX-VG-NONE-POOR': 7.3,
    'G-IF-VG-GOOD-STRONG-VG': 7.3,
    'G-IF-GOOD-VG-STRONG-VG': 7.3,
    'G-IF-POOR-POOR-STRONG-EX': 7.3,
    'G-IF-POOR-EX-STRONG-VG': 7.3,
    'G-IF-EX-POOR-STRONG-VG': 7.3,
    'G-IF-EX-EX-STRONG-GOOD': 7.3,
    'H-IF-VG-GOOD-MEDIUM-VG': 7.3,
    'H-IF-POOR-EX-MEDIUM-VG': 7.3,
    'H-IF-POOR-POOR-MEDIUM-EX': 7.3,
    'H-IF-EX-POOR-MEDIUM-VG': 7.3,
    'H-IF-EX-EX-MEDIUM-GOOD': 7.3,
    'H-IF-GOOD-VG-MEDIUM-VG': 7.3,
    'I-IF-POOR-POOR-FAINT-EX': 7.3,
    'I-IF-VG-GOOD-FAINT-VG': 7.3,
    'I-IF-EX-POOR-FAINT-VG': 7.3,
    'I-IF-GOOD-VG-FAINT-VG': 7.3,
    'I-IF-POOR-EX-FAINT-VG': 7.3,
    'I-IF-EX-EX-FAINT-GOOD': 7.3,
    'J-IF-EX-EX-NONE-GOOD': 7.3,
    'J-IF-EX-POOR-NONE-VG': 7.3,
    'J-IF-VG-GOOD-NONE-VG': 7.3,
    'J-IF-GOOD-VG-NONE-VG': 7.3,
    'J-IF-POOR-EX-NONE-VG': 7.3,
    'J-IF-POOR-POOR-NONE-EX': 7.3,
    'L-IF-EX-GOOD-STRONG-EX': 7.3,
    'L-IF-VG-VG-STRONG-EX': 7.3,
    'L-IF-GOOD-EX-STRONG-EX': 7.3,
    'M-IF-EX-GOOD-MEDIUM-EX': 7.3,
    'M-IF-GOOD-EX-MEDIUM-EX': 7.3,
    'M-IF-VG-VG-MEDIUM-EX': 7.3,
    'D-I1-EX-EX-MEDIUM-VG': 7.29,
    'D-I1-GOOD-VG-MEDIUM-EX': 7.29,
    'D-I1-EX-POOR-MEDIUM-EX': 7.29,
    'D-I1-VG-GOOD-MEDIUM-EX': 7.29,
    'D-SI1-GOOD-GOOD-STRONG-EX': 7.29,
    'D-SI1-EX-VG-STRONG-VG': 7.29,
    'D-SI1-VG-EX-STRONG-VG': 7.29,
    'D-SI1-VG-POOR-STRONG-EX': 7.29,
    'D-SI1-POOR-VG-STRONG-EX': 7.29,
    'D-I1-POOR-EX-MEDIUM-EX': 7.29,
    'E-SI1-VG-EX-MEDIUM-VG': 7.29,
    'E-I1-VG-GOOD-FAINT-EX': 7.29,
    'E-SI1-EX-VG-MEDIUM-VG': 7.29,
    'E-SI1-VG-POOR-MEDIUM-EX': 7.29,
    'E-I1-EX-EX-FAINT-VG': 7.29,
    'E-I1-POOR-EX-FAINT-EX': 7.29,
    'E-SI1-POOR-VG-MEDIUM-EX': 7.29,
    'E-I1-GOOD-VG-FAINT-EX': 7.29,
    'E-SI1-GOOD-GOOD-MEDIUM-EX': 7.29,
    'E-I1-EX-POOR-FAINT-EX': 7.29,
    'F-SI1-GOOD-GOOD-FAINT-EX': 7.29,
    'F-SI1-POOR-VG-FAINT-EX': 7.29,
    'F-I1-GOOD-VG-NONE-EX': 7.29,
    'F-I1-VG-GOOD-NONE-EX': 7.29,
    'F-I1-EX-POOR-NONE-EX': 7.29,
    'F-I1-EX-EX-NONE-VG': 7.29,
    'F-I1-POOR-EX-NONE-EX': 7.29,
    'F-SI1-VG-POOR-FAINT-EX': 7.29,
    'F-SI1-EX-VG-FAINT-VG': 7.29,
    'F-SI1-VG-EX-FAINT-VG': 7.29,
    'G-SI1-POOR-VG-NONE-EX': 7.29,
    'G-SI1-GOOD-GOOD-NONE-EX': 7.29,
    'G-SI1-VG-POOR-NONE-EX': 7.29,
    'G-SI1-VG-EX-NONE-VG': 7.29,
    'G-SI1-EX-VG-NONE-VG': 7.29,
    'I-SI1-EX-EX-STRONG-EX': 7.29,
    'J-SI1-EX-EX-MEDIUM-EX': 7.29,
    'K-SI1-EX-EX-FAINT-EX': 7.29,
    'L-SI1-EX-EX-NONE-EX': 7.29,
    'D-VVS1-EX-VG-NONE-POOR': 7.28,
    'D-VVS1-VG-POOR-NONE-GOOD': 7.28,
    'D-VVS1-GOOD-GOOD-NONE-GOOD': 7.28,
    'D-VVS1-VG-EX-NONE-POOR': 7.28,
    'D-VVS1-POOR-VG-NONE-GOOD': 7.28,
    'E-VS1-GOOD-POOR-STRONG-EX': 7.28,
    'E-VS1-GOOD-EX-STRONG-VG': 7.28,
    'E-VS1-VG-VG-STRONG-VG': 7.28,
    'E-VS1-POOR-GOOD-STRONG-EX': 7.28,
    'E-VS1-EX-GOOD-STRONG-VG': 7.28,
    'F-VS1-EX-GOOD-MEDIUM-VG': 7.28,
    'F-VS1-GOOD-POOR-MEDIUM-EX': 7.28,
    'F-VVS1-EX-EX-STRONG-GOOD': 7.28,
    'F-VVS1-POOR-POOR-STRONG-EX': 7.28,
    'F-VVS1-EX-POOR-STRONG-VG': 7.28,
    'F-VVS1-VG-GOOD-STRONG-VG': 7.28,
    'F-VS1-VG-VG-MEDIUM-VG': 7.28,
    'F-VVS1-GOOD-VG-STRONG-VG': 7.28,
    'F-VS1-POOR-GOOD-MEDIUM-EX': 7.28,
    'F-VS1-GOOD-EX-MEDIUM-VG': 7.28,
    'F-VVS1-POOR-EX-STRONG-VG': 7.28,
    'G-VVS1-GOOD-VG-MEDIUM-VG': 7.28,
    'G-VS1-POOR-GOOD-FAINT-EX': 7.28,
    'G-VS1-VG-VG-FAINT-VG': 7.28,
    'G-VS1-EX-GOOD-FAINT-VG': 7.28,
    'G-VS1-GOOD-EX-FAINT-VG': 7.28,
    'G-VVS1-POOR-EX-MEDIUM-VG': 7.28,
    'G-VS1-GOOD-POOR-FAINT-EX': 7.28,
    'G-VVS1-POOR-POOR-MEDIUM-EX': 7.28,
    'G-VVS1-EX-POOR-MEDIUM-VG': 7.28,
    'G-VVS1-VG-GOOD-MEDIUM-VG': 7.28,
    'G-VVS1-EX-EX-MEDIUM-GOOD': 7.28,
    'H-VVS1-EX-POOR-FAINT-VG': 7.28,
    'H-VS1-POOR-GOOD-NONE-EX': 7.28,
    'H-VS1-GOOD-EX-NONE-VG': 7.28,
    'H-VVS1-POOR-POOR-FAINT-EX': 7.28,
    'H-VS1-EX-GOOD-NONE-VG': 7.28,
    'H-VVS1-GOOD-VG-FAINT-VG': 7.28,
    'H-VS1-GOOD-POOR-NONE-EX': 7.28,
    'H-VVS1-POOR-EX-FAINT-VG': 7.28,
    'H-VVS1-VG-GOOD-FAINT-VG': 7.28,
    'H-VS1-VG-VG-NONE-VG': 7.28,
    'H-VVS1-EX-EX-FAINT-GOOD': 7.28,
    'I-VVS1-GOOD-VG-NONE-VG': 7.28,
    'I-VVS1-POOR-EX-NONE-VG': 7.28,
    'I-VVS1-VG-GOOD-NONE-VG': 7.28,
    'I-VVS1-EX-POOR-NONE-VG': 7.28,
    'I-VVS1-POOR-POOR-NONE-EX': 7.28,
    'I-VVS1-EX-EX-NONE-GOOD': 7.28,
    'J-VS1-VG-EX-STRONG-EX': 7.28,
    'J-VS1-EX-VG-STRONG-EX': 7.28,
    'K-VVS1-EX-GOOD-STRONG-EX': 7.28,
    'K-VVS1-VG-VG-STRONG-EX': 7.28,
    'K-VVS1-GOOD-EX-STRONG-EX': 7.28,
    'K-VS1-VG-EX-MEDIUM-EX': 7.28,
    'K-VS1-EX-VG-MEDIUM-EX': 7.28,
    'L-VS1-EX-VG-FAINT-EX': 7.28,
    'L-VS1-VG-EX-FAINT-EX': 7.28,
    'L-VVS1-VG-VG-MEDIUM-EX': 7.28,
    'L-VVS1-GOOD-EX-MEDIUM-EX': 7.28,
    'L-VVS1-EX-GOOD-MEDIUM-EX': 7.28,
    'M-VVS1-GOOD-EX-FAINT-EX': 7.28,
    'M-VVS1-EX-GOOD-FAINT-EX': 7.28,
    'M-VVS1-VG-VG-FAINT-EX': 7.28,
    'M-VS1-EX-VG-NONE-EX': 7.28,
    'M-VS1-VG-EX-NONE-EX': 7.28,
    'D-I2-VG-GOOD-FAINT-EX': 7.27,
    'D-SI2-VG-EX-MEDIUM-VG': 7.27,
    'D-SI2-POOR-VG-MEDIUM-EX': 7.27,
    'D-I2-EX-POOR-FAINT-EX': 7.27,
    'D-I2-EX-EX-FAINT-VG': 7.27,
    'D-SI2-GOOD-GOOD-MEDIUM-EX': 7.27,
    'D-I2-GOOD-VG-FAINT-EX': 7.27,
    'D-SI2-VG-POOR-MEDIUM-EX': 7.27,
    'D-SI2-EX-VG-MEDIUM-VG': 7.27,
    'D-I2-POOR-EX-FAINT-EX': 7.27,
    'E-I2-POOR-EX-NONE-EX': 7.27,
    'E-I2-EX-EX-NONE-VG': 7.27,
    'E-I2-EX-POOR-NONE-EX': 7.27,
    'E-SI2-VG-EX-FAINT-VG': 7.27,
    'E-SI2-EX-VG-FAINT-VG': 7.27,
    'E-I2-GOOD-VG-NONE-EX': 7.27,
    'E-SI2-VG-POOR-FAINT-EX': 7.27,
    'E-I2-VG-GOOD-NONE-EX': 7.27,
    'E-SI2-GOOD-GOOD-FAINT-EX': 7.27,
    'E-SI2-POOR-VG-FAINT-EX': 7.27,
    'F-SI2-EX-VG-NONE-VG': 7.27,
    'F-SI2-VG-EX-NONE-VG': 7.27,
    'F-SI2-POOR-VG-NONE-EX': 7.27,
    'F-SI2-VG-POOR-NONE-EX': 7.27,
    'F-SI2-GOOD-GOOD-NONE-EX': 7.27,
    'H-SI2-EX-EX-STRONG-EX': 7.27,
    'I-SI2-EX-EX-MEDIUM-EX': 7.27,
    'J-SI2-EX-EX-FAINT-EX': 7.27,
    'K-SI2-EX-EX-NONE-EX': 7.27,
    'D-VS2-VG-VG-STRONG-VG': 7.26,
    'D-VS2-GOOD-EX-STRONG-VG': 7.26,
    'D-VS2-POOR-GOOD-STRONG-EX': 7.26,
    'D-VS2-EX-GOOD-STRONG-VG': 7.26,
    'D-VS2-GOOD-POOR-STRONG-EX': 7.26,
    'E-VVS2-EX-POOR-STRONG-VG': 7.26,
    'E-VS2-GOOD-POOR-MEDIUM-EX': 7.26,
    'E-VS2-GOOD-EX-MEDIUM-VG': 7.26,
    'E-VVS2-POOR-POOR-STRONG-EX': 7.26,
    'E-VS2-POOR-GOOD-MEDIUM-EX': 7.26,
    'E-VS2-VG-VG-MEDIUM-VG': 7.26,
    'E-VVS2-VG-GOOD-STRONG-VG': 7.26,
    'E-VS2-EX-GOOD-MEDIUM-VG': 7.26,
    'E-VVS2-GOOD-VG-STRONG-VG': 7.26,
    'E-VVS2-EX-EX-STRONG-GOOD': 7.26,
    'E-VVS2-POOR-EX-STRONG-VG': 7.26,
    'F-VVS2-POOR-POOR-MEDIUM-EX': 7.26,
    'F-VVS2-EX-EX-MEDIUM-GOOD': 7.26,
    'F-VVS2-EX-POOR-MEDIUM-VG': 7.26,
    'F-VVS2-VG-GOOD-MEDIUM-VG': 7.26,
    'F-VVS2-POOR-EX-MEDIUM-VG': 7.26,
    'F-VVS2-GOOD-VG-MEDIUM-VG': 7.26,
    'F-VS2-GOOD-POOR-FAINT-EX': 7.26,
    'F-VS2-POOR-GOOD-FAINT-EX': 7.26,
    'F-VS2-EX-GOOD-FAINT-VG': 7.26,
    'F-VS2-VG-VG-FAINT-VG': 7.26,
    'F-VS2-GOOD-EX-FAINT-VG': 7.26,
    'G-VVS2-EX-POOR-FAINT-VG': 7.26,
    'G-VVS2-GOOD-VG-FAINT-VG': 7.26,
    'G-VVS2-POOR-EX-FAINT-VG': 7.26,
    'G-VVS2-POOR-POOR-FAINT-EX': 7.26,
    'G-VVS2-EX-EX-FAINT-GOOD': 7.26,
    'G-VVS2-VG-GOOD-FAINT-VG': 7.26,
    'G-VS2-GOOD-POOR-NONE-EX': 7.26,
    'G-VS2-POOR-GOOD-NONE-EX': 7.26,
    'G-VS2-VG-VG-NONE-VG': 7.26,
    'G-VS2-GOOD-EX-NONE-VG': 7.26,
    'G-VS2-EX-GOOD-NONE-VG': 7.26,
    'H-VVS2-POOR-EX-NONE-VG': 7.26,
    'H-VVS2-GOOD-VG-NONE-VG': 7.26,
    'H-VVS2-VG-GOOD-NONE-VG': 7.26,
    'H-VVS2-EX-POOR-NONE-VG': 7.26,
    'H-VVS2-EX-EX-NONE-GOOD': 7.26,
    'H-VVS2-POOR-POOR-NONE-EX': 7.26,
    'I-VS2-EX-VG-STRONG-EX': 7.26,
    'I-VS2-VG-EX-STRONG-EX': 7.26,
    'J-VVS2-EX-GOOD-STRONG-EX': 7.26,
    'J-VS2-VG-EX-MEDIUM-EX': 7.26,
    'J-VVS2-GOOD-EX-STRONG-EX': 7.26,
    'J-VVS2-VG-VG-STRONG-EX': 7.26,
    'J-VS2-EX-VG-MEDIUM-EX': 7.26,
    'K-VVS2-EX-GOOD-MEDIUM-EX': 7.26,
    'K-VVS2-VG-VG-MEDIUM-EX': 7.26,
    'K-VVS2-GOOD-EX-MEDIUM-EX': 7.26,
    'K-VS2-EX-VG-FAINT-EX': 7.26,
    'K-VS2-VG-EX-FAINT-EX': 7.26,
    'L-VVS2-EX-GOOD-FAINT-EX': 7.26,
    'L-VS2-EX-VG-NONE-EX': 7.26,
    'L-VS2-VG-EX-NONE-EX': 7.26,
    'L-VVS2-GOOD-EX-FAINT-EX': 7.26,
    'L-VVS2-VG-VG-FAINT-EX': 7.26,
    'M-VVS2-VG-VG-NONE-EX': 7.26,
    'M-VVS2-GOOD-EX-NONE-EX': 7.26,
    'M-VVS2-EX-GOOD-NONE-EX': 7.26,
    'D-IF-GOOD-POOR-NONE-GOOD': 7.25,
    'D-IF-GOOD-EX-NONE-POOR': 7.25,
    'D-IF-POOR-GOOD-NONE-GOOD': 7.25,
    'D-IF-EX-GOOD-NONE-POOR': 7.25,
    'D-IF-VG-VG-NONE-POOR': 7.25,
    'F-IF-GOOD-GOOD-STRONG-VG': 7.25,
    'F-IF-POOR-VG-STRONG-VG': 7.25,
    'F-IF-VG-POOR-STRONG-VG': 7.25,
    'F-IF-EX-VG-STRONG-GOOD': 7.25,
    'F-IF-VG-EX-STRONG-GOOD': 7.25,
    'G-IF-VG-EX-MEDIUM-GOOD': 7.25,
    'G-IF-EX-VG-MEDIUM-GOOD': 7.25,
    'G-IF-GOOD-GOOD-MEDIUM-VG': 7.25,
    'G-IF-POOR-VG-MEDIUM-VG': 7.25,
    'G-IF-VG-POOR-MEDIUM-VG': 7.25,
    'H-IF-VG-POOR-FAINT-VG': 7.25,
    'H-IF-VG-EX-FAINT-GOOD': 7.25,
    'H-IF-EX-VG-FAINT-GOOD': 7.25,
    'H-IF-GOOD-GOOD-FAINT-VG': 7.25,
    'H-IF-POOR-VG-FAINT-VG': 7.25,
    'I-IF-EX-VG-NONE-GOOD': 7.25,
    'I-IF-VG-POOR-NONE-VG': 7.25,
    'I-IF-GOOD-GOOD-NONE-VG': 7.25,
    'I-IF-POOR-VG-NONE-VG': 7.25,
    'I-IF-VG-EX-NONE-GOOD': 7.25,
    'K-IF-EX-POOR-STRONG-EX': 7.25,
    'K-IF-EX-EX-STRONG-VG': 7.25,
    'K-IF-VG-GOOD-STRONG-EX': 7.25,
    'K-IF-POOR-EX-STRONG-EX': 7.25,
    'K-IF-GOOD-VG-STRONG-EX': 7.25,
    'L-IF-VG-GOOD-MEDIUM-EX': 7.25,
    'L-IF-EX-EX-MEDIUM-VG': 7.25,
    'L-IF-GOOD-VG-MEDIUM-EX': 7.25,
    'L-IF-POOR-EX-MEDIUM-EX': 7.25,
    'L-IF-EX-POOR-MEDIUM-EX': 7.25,
    'M-IF-EX-POOR-FAINT-EX': 7.25,
    'M-IF-VG-GOOD-FAINT-EX': 7.25,
    'M-IF-EX-EX-FAINT-VG': 7.25,
    'M-IF-GOOD-VG-FAINT-EX': 7.25,
    'M-IF-POOR-EX-FAINT-EX': 7.25,
    'D-I1-VG-EX-FAINT-VG': 7.24,
    'D-I1-POOR-VG-FAINT-EX': 7.24,
    'D-I1-GOOD-GOOD-FAINT-EX': 7.24,
    'D-I1-VG-POOR-FAINT-EX': 7.24,
    'D-SI1-GOOD-EX-MEDIUM-VG': 7.24,
    'D-SI1-VG-VG-MEDIUM-VG': 7.24,
    'D-SI1-GOOD-POOR-MEDIUM-EX': 7.24,
    'D-SI1-EX-GOOD-MEDIUM-VG': 7.24,
    'D-I1-EX-VG-FAINT-VG': 7.24,
    'D-SI1-POOR-GOOD-MEDIUM-EX': 7.24,
    'E-I1-POOR-VG-NONE-EX': 7.24,
    'E-I1-GOOD-GOOD-NONE-EX': 7.24,
    'E-I1-VG-POOR-NONE-EX': 7.24,
    'E-I1-EX-VG-NONE-VG': 7.24,
    'E-I1-VG-EX-NONE-VG': 7.24,
    'E-SI1-POOR-GOOD-FAINT-EX': 7.24,
    'E-SI1-GOOD-POOR-FAINT-EX': 7.24,
    'E-SI1-VG-VG-FAINT-VG': 7.24,
    'E-SI1-GOOD-EX-FAINT-VG': 7.24,
    'E-SI1-EX-GOOD-FAINT-VG': 7.24,
    'F-SI1-VG-VG-NONE-VG': 7.24,
    'F-SI1-EX-GOOD-NONE-VG': 7.24,
    'F-SI1-GOOD-POOR-NONE-EX': 7.24,
    'F-SI1-POOR-GOOD-NONE-EX': 7.24,
    'F-SI1-GOOD-EX-NONE-VG': 7.24,
    'G-I1-EX-EX-STRONG-EX': 7.24,
    'H-I1-EX-EX-MEDIUM-EX': 7.24,
    'H-SI1-VG-EX-STRONG-EX': 7.24,
    'H-SI1-EX-VG-STRONG-EX': 7.24,
    'I-SI1-VG-EX-MEDIUM-EX': 7.24,
    'I-SI1-EX-VG-MEDIUM-EX': 7.24,
    'I-I1-EX-EX-FAINT-EX': 7.24,
    'J-SI1-EX-VG-FAINT-EX': 7.24,
    'J-SI1-VG-EX-FAINT-EX': 7.24,
    'J-I1-EX-EX-NONE-EX': 7.24,
    'K-SI1-VG-EX-NONE-EX': 7.24,
    'K-SI1-EX-VG-NONE-EX': 7.24,
    'D-VS1-POOR-POOR-STRONG-EX': 7.23,
    'D-VS1-EX-EX-STRONG-GOOD': 7.23,
    'D-VS1-GOOD-VG-STRONG-VG': 7.23,
    'D-VS1-POOR-EX-STRONG-VG': 7.23,
    'D-VS1-EX-POOR-STRONG-VG': 7.23,
    'D-VS1-VG-GOOD-STRONG-VG': 7.23,
    'E-VVS1-VG-EX-STRONG-GOOD': 7.23,
    'E-VVS1-EX-VG-STRONG-GOOD': 7.23,
    'E-VVS1-GOOD-GOOD-STRONG-VG': 7.23,
    'E-VS1-GOOD-VG-MEDIUM-VG': 7.23,
    'E-VVS1-POOR-VG-STRONG-VG': 7.23,
    'E-VVS1-VG-POOR-STRONG-VG': 7.23,
    'E-VS1-POOR-POOR-MEDIUM-EX': 7.23,
    'E-VS1-POOR-EX-MEDIUM-VG': 7.23,
    'E-VS1-VG-GOOD-MEDIUM-VG': 7.23,
    'E-VS1-EX-EX-MEDIUM-GOOD': 7.23,
    'E-VS1-EX-POOR-MEDIUM-VG': 7.23,
    'F-VVS1-GOOD-GOOD-MEDIUM-VG': 7.23,
    'F-VS1-EX-EX-FAINT-GOOD': 7.23,
    'F-VS1-POOR-POOR-FAINT-EX': 7.23,
    'F-VVS1-EX-VG-MEDIUM-GOOD': 7.23,
    'F-VS1-POOR-EX-FAINT-VG': 7.23,
    'F-VVS1-VG-EX-MEDIUM-GOOD': 7.23,
    'F-VS1-GOOD-VG-FAINT-VG': 7.23,
    'F-VVS1-VG-POOR-MEDIUM-VG': 7.23,
    'F-VS1-VG-GOOD-FAINT-VG': 7.23,
    'F-VS1-EX-POOR-FAINT-VG': 7.23,
    'F-VVS1-POOR-VG-MEDIUM-VG': 7.23,
    'G-VS1-POOR-POOR-NONE-EX': 7.23,
    'G-VS1-POOR-EX-NONE-VG': 7.23,
    'G-VS1-GOOD-VG-NONE-VG': 7.23,
    'G-VS1-VG-GOOD-NONE-VG': 7.23,
    'G-VS1-EX-POOR-NONE-VG': 7.23,
    'G-VS1-EX-EX-NONE-GOOD': 7.23,
    'G-VVS1-VG-EX-FAINT-GOOD': 7.23,
    'G-VVS1-VG-POOR-FAINT-VG': 7.23,
    'G-VVS1-GOOD-GOOD-FAINT-VG': 7.23,
    'G-VVS1-POOR-VG-FAINT-VG': 7.23,
    'G-VVS1-EX-VG-FAINT-GOOD': 7.23,
    'H-VVS1-VG-POOR-NONE-VG': 7.23,
    'H-VVS1-VG-EX-NONE-GOOD': 7.23,
    'H-VVS1-POOR-VG-NONE-VG': 7.23,
    'H-VVS1-GOOD-GOOD-NONE-VG': 7.23,
    'H-VVS1-EX-VG-NONE-GOOD': 7.23,
    'I-VS1-EX-GOOD-STRONG-EX': 7.23,
    'I-VS1-GOOD-EX-STRONG-EX': 7.23,
    'I-VS1-VG-VG-STRONG-EX': 7.23,
    'J-VS1-VG-VG-MEDIUM-EX': 7.23,
    'J-VS1-EX-GOOD-MEDIUM-EX': 7.23,
    'J-VS1-GOOD-EX-MEDIUM-EX': 7.23,
    'J-VVS1-EX-EX-STRONG-VG': 7.23,
    'J-VVS1-EX-POOR-STRONG-EX': 7.23,
    'J-VVS1-GOOD-VG-STRONG-EX': 7.23,
    'J-VVS1-POOR-EX-STRONG-EX': 7.23,
    'J-VVS1-VG-GOOD-STRONG-EX': 7.23,
    'K-VVS1-GOOD-VG-MEDIUM-EX': 7.23,
    'K-VS1-EX-GOOD-FAINT-EX': 7.23,
    'K-VVS1-EX-POOR-MEDIUM-EX': 7.23,
    'K-VVS1-VG-GOOD-MEDIUM-EX': 7.23,
    'K-VVS1-EX-EX-MEDIUM-VG': 7.23,
    'K-VS1-GOOD-EX-FAINT-EX': 7.23,
    'K-VS1-VG-VG-FAINT-EX': 7.23,
    'K-VVS1-POOR-EX-MEDIUM-EX': 7.23,
    'L-VVS1-VG-GOOD-FAINT-EX': 7.23,
    'L-VVS1-EX-POOR-FAINT-EX': 7.23,
    'L-VVS1-EX-EX-FAINT-VG': 7.23,
    'L-VVS1-GOOD-VG-FAINT-EX': 7.23,
    'L-VS1-GOOD-EX-NONE-EX': 7.23,
    'L-VS1-VG-VG-NONE-EX': 7.23,
    'L-VS1-EX-GOOD-NONE-EX': 7.23,
    'L-VVS1-POOR-EX-FAINT-EX': 7.23,
    'M-VVS1-GOOD-VG-NONE-EX': 7.23,
    'M-VVS1-VG-GOOD-NONE-EX': 7.23,
    'M-VVS1-POOR-EX-NONE-EX': 7.23,
    'M-VVS1-EX-POOR-NONE-EX': 7.23,
    'M-VVS1-EX-EX-NONE-VG': 7.23,
    'D-SI2-GOOD-POOR-FAINT-EX': 7.22,
    'D-SI2-POOR-GOOD-FAINT-EX': 7.22,
    'D-I2-VG-EX-NONE-VG': 7.22,
    'D-I2-VG-POOR-NONE-EX': 7.22,
    'D-SI2-GOOD-EX-FAINT-VG': 7.22,
    'D-I2-EX-VG-NONE-VG': 7.22,
    'D-SI2-VG-VG-FAINT-VG': 7.22,
    'D-SI2-EX-GOOD-FAINT-VG': 7.22,
    'D-I2-GOOD-GOOD-NONE-EX': 7.22,
    'D-I2-POOR-VG-NONE-EX': 7.22,
    'E-SI2-EX-GOOD-NONE-VG': 7.22,
    'E-SI2-GOOD-EX-NONE-VG': 7.22,
    'E-SI2-GOOD-POOR-NONE-EX': 7.22,
    'E-SI2-POOR-GOOD-NONE-EX': 7.22,
    'E-SI2-VG-VG-NONE-VG': 7.22,
    'F-I2-EX-EX-STRONG-EX': 7.22,
    'G-SI2-VG-EX-STRONG-EX': 7.22,
    'G-SI2-EX-VG-STRONG-EX': 7.22,
    'G-I2-EX-EX-MEDIUM-EX': 7.22,
    'H-SI2-VG-EX-MEDIUM-EX': 7.22,
    'H-I2-EX-EX-FAINT-EX': 7.22,
    'H-SI2-EX-VG-MEDIUM-EX': 7.22,
    'I-I2-EX-EX-NONE-EX': 7.22,
    'I-SI2-EX-VG-FAINT-EX': 7.22,
    'I-SI2-VG-EX-FAINT-EX': 7.22,
    'J-SI2-VG-EX-NONE-EX': 7.22,
    'J-SI2-EX-VG-NONE-EX': 7.22,
    'D-VVS2-VG-EX-STRONG-GOOD': 7.21,
    'D-VS2-VG-GOOD-MEDIUM-VG': 7.21,
    'D-VS2-EX-POOR-MEDIUM-VG': 7.21,
    'D-VS2-EX-EX-MEDIUM-GOOD': 7.21,
    'D-VVS2-EX-VG-STRONG-GOOD': 7.21,
    'D-VS2-POOR-POOR-MEDIUM-EX': 7.21,
    'D-VVS2-POOR-VG-STRONG-VG': 7.21,
    'D-VS2-POOR-EX-MEDIUM-VG': 7.21,
    'D-VS2-GOOD-VG-MEDIUM-VG': 7.21,
    'D-VVS2-VG-POOR-STRONG-VG': 7.21,
    'D-VVS2-GOOD-GOOD-STRONG-VG': 7.21,
    'E-VVS2-VG-POOR-MEDIUM-VG': 7.21,
    'E-VS2-POOR-POOR-FAINT-EX': 7.21,
    'E-VVS2-GOOD-GOOD-MEDIUM-VG': 7.21,
    'E-VS2-EX-POOR-FAINT-VG': 7.21,
    'E-VVS2-VG-EX-MEDIUM-GOOD': 7.21,
    'E-VS2-VG-GOOD-FAINT-VG': 7.21,
    'E-VVS2-EX-VG-MEDIUM-GOOD': 7.21,
    'E-VS2-GOOD-VG-FAINT-VG': 7.21,
    'E-VS2-EX-EX-FAINT-GOOD': 7.21,
    'E-VS2-POOR-EX-FAINT-VG': 7.21,
    'E-VVS2-POOR-VG-MEDIUM-VG': 7.21,
    'F-VVS2-VG-EX-FAINT-GOOD': 7.21,
    'F-VVS2-EX-VG-FAINT-GOOD': 7.21,
    'F-VVS2-VG-POOR-FAINT-VG': 7.21,
    'F-VVS2-POOR-VG-FAINT-VG': 7.21,
    'F-VVS2-GOOD-GOOD-FAINT-VG': 7.21,
    'F-VS2-POOR-POOR-NONE-EX': 7.21,
    'F-VS2-EX-POOR-NONE-VG': 7.21,
    'F-VS2-EX-EX-NONE-GOOD': 7.21,
    'F-VS2-GOOD-VG-NONE-VG': 7.21,
    'F-VS2-VG-GOOD-NONE-VG': 7.21,
    'F-VS2-POOR-EX-NONE-VG': 7.21,
    'G-VVS2-POOR-VG-NONE-VG': 7.21,
    'G-VVS2-EX-VG-NONE-GOOD': 7.21,
    'G-VVS2-GOOD-GOOD-NONE-VG': 7.21,
    'G-VVS2-VG-EX-NONE-GOOD': 7.21,
    'G-VVS2-VG-POOR-NONE-VG': 7.21,
    'H-VS2-EX-GOOD-STRONG-EX': 7.21,
    'H-VS2-VG-VG-STRONG-EX': 7.21,
    'H-VS2-GOOD-EX-STRONG-EX': 7.21,
    'I-VVS2-EX-EX-STRONG-VG': 7.21,
    'I-VS2-EX-GOOD-MEDIUM-EX': 7.21,
    'I-VVS2-EX-POOR-STRONG-EX': 7.21,
    'I-VS2-VG-VG-MEDIUM-EX': 7.21,
    'I-VS2-GOOD-EX-MEDIUM-EX': 7.21,
    'I-VVS2-POOR-EX-STRONG-EX': 7.21,
    'I-VVS2-VG-GOOD-STRONG-EX': 7.21,
    'I-VVS2-GOOD-VG-STRONG-EX': 7.21,
    'J-VVS2-VG-GOOD-MEDIUM-EX': 7.21,
    'J-VVS2-EX-EX-MEDIUM-VG': 7.21,
    'J-VVS2-GOOD-VG-MEDIUM-EX': 7.21,
    'J-VVS2-EX-POOR-MEDIUM-EX': 7.21,
    'J-VS2-EX-GOOD-FAINT-EX': 7.21,
    'J-VS2-VG-VG-FAINT-EX': 7.21,
    'J-VS2-GOOD-EX-FAINT-EX': 7.21,
    'J-VVS2-POOR-EX-MEDIUM-EX': 7.21,
    'K-VVS2-POOR-EX-FAINT-EX': 7.21,
    'K-VVS2-EX-EX-FAINT-VG': 7.21,
    'K-VVS2-GOOD-VG-FAINT-EX': 7.21,
    'K-VVS2-VG-GOOD-FAINT-EX': 7.21,
    'K-VVS2-EX-POOR-FAINT-EX': 7.21,
    'K-VS2-EX-GOOD-NONE-EX': 7.21,
    'K-VS2-GOOD-EX-NONE-EX': 7.21,
    'K-VS2-VG-VG-NONE-EX': 7.21,
    'L-VVS2-GOOD-VG-NONE-EX': 7.21,
    'L-VVS2-POOR-EX-NONE-EX': 7.21,
    'L-VVS2-EX-POOR-NONE-EX': 7.21,
    'L-VVS2-VG-GOOD-NONE-EX': 7.21,
    'L-VVS2-EX-EX-NONE-VG': 7.21,
    'E-IF-GOOD-EX-STRONG-GOOD': 7.2,
    'E-IF-GOOD-POOR-STRONG-VG': 7.2,
    'E-IF-POOR-GOOD-STRONG-VG': 7.2,
    'E-IF-VG-VG-STRONG-GOOD': 7.2,
    'E-IF-EX-GOOD-STRONG-GOOD': 7.2,
    'F-IF-VG-VG-MEDIUM-GOOD': 7.2,
    'F-IF-POOR-GOOD-MEDIUM-VG': 7.2,
    'F-IF-GOOD-POOR-MEDIUM-VG': 7.2,
    'F-IF-EX-GOOD-MEDIUM-GOOD': 7.2,
    'F-IF-GOOD-EX-MEDIUM-GOOD': 7.2,
    'G-IF-EX-GOOD-FAINT-GOOD': 7.2,
    'G-IF-VG-VG-FAINT-GOOD': 7.2,
    'G-IF-GOOD-POOR-FAINT-VG': 7.2,
    'G-IF-POOR-GOOD-FAINT-VG': 7.2,
    'G-IF-GOOD-EX-FAINT-GOOD': 7.2,
    'H-IF-EX-GOOD-NONE-GOOD': 7.2,
    'H-IF-VG-VG-NONE-GOOD': 7.2,
    'H-IF-GOOD-EX-NONE-GOOD': 7.2,
    'H-IF-POOR-GOOD-NONE-VG': 7.2,
    'H-IF-GOOD-POOR-NONE-VG': 7.2,
    'J-IF-GOOD-GOOD-STRONG-EX': 7.2,
    'J-IF-VG-EX-STRONG-VG': 7.2,
    'J-IF-EX-VG-STRONG-VG': 7.2,
    'J-IF-POOR-VG-STRONG-EX': 7.2,
    'J-IF-VG-POOR-STRONG-EX': 7.2,
    'K-IF-POOR-VG-MEDIUM-EX': 7.2,
    'K-IF-EX-VG-MEDIUM-VG': 7.2,
    'K-IF-VG-EX-MEDIUM-VG': 7.2,
    'K-IF-VG-POOR-MEDIUM-EX': 7.2,
    'K-IF-GOOD-GOOD-MEDIUM-EX': 7.2,
    'L-IF-VG-POOR-FAINT-EX': 7.2,
    'L-IF-POOR-VG-FAINT-EX': 7.2,
    'L-IF-GOOD-GOOD-FAINT-EX': 7.2,
    'L-IF-VG-EX-FAINT-VG': 7.2,
    'L-IF-EX-VG-FAINT-VG': 7.2,
    'M-IF-VG-POOR-NONE-EX': 7.2,
    'M-IF-VG-EX-NONE-VG': 7.2,
    'M-IF-EX-VG-NONE-VG': 7.2,
    'M-IF-POOR-VG-NONE-EX': 7.2,
    'M-IF-GOOD-GOOD-NONE-EX': 7.2,
    'D-I1-GOOD-EX-NONE-VG': 7.19,
    'D-SI1-EX-POOR-FAINT-VG': 7.19,
    'D-SI1-VG-GOOD-FAINT-VG': 7.19,
    'D-SI1-POOR-POOR-FAINT-EX': 7.19,
    'D-I1-GOOD-POOR-NONE-EX': 7.19,
    'D-I1-POOR-GOOD-NONE-EX': 7.19,
    'D-SI1-GOOD-VG-FAINT-VG': 7.19,
    'D-I1-VG-VG-NONE-VG': 7.19,
    'D-I1-EX-GOOD-NONE-VG': 7.19,
    'D-SI1-POOR-EX-FAINT-VG': 7.19,
    'D-SI1-EX-EX-FAINT-GOOD': 7.19,
    'E-SI1-EX-EX-NONE-GOOD': 7.19,
    'E-SI1-GOOD-VG-NONE-VG': 7.19,
    'E-SI1-EX-POOR-NONE-VG': 7.19,
    'E-SI1-VG-GOOD-NONE-VG': 7.19,
    'E-SI1-POOR-EX-NONE-VG': 7.19,
    'E-SI1-POOR-POOR-NONE-EX': 7.19,
    'F-I1-EX-VG-STRONG-EX': 7.19,
    'F-I1-VG-EX-STRONG-EX': 7.19,
    'G-I1-VG-EX-MEDIUM-EX': 7.19,
    'G-I1-EX-VG-MEDIUM-EX': 7.19,
    'G-SI1-EX-GOOD-STRONG-EX': 7.19,
    'G-SI1-GOOD-EX-STRONG-EX': 7.19,
    'G-SI1-VG-VG-STRONG-EX': 7.19,
    'H-SI1-VG-VG-MEDIUM-EX': 7.19,
    'H-SI1-GOOD-EX-MEDIUM-EX': 7.19,
    'H-SI1-EX-GOOD-MEDIUM-EX': 7.19,
    'H-I1-VG-EX-FAINT-EX': 7.19,
    'H-I1-EX-VG-FAINT-EX': 7.19,
    'I-I1-VG-EX-NONE-EX': 7.19,
    'I-SI1-GOOD-EX-FAINT-EX': 7.19,
    'I-SI1-VG-VG-FAINT-EX': 7.19,
    'I-I1-EX-VG-NONE-EX': 7.19,
    'I-SI1-EX-GOOD-FAINT-EX': 7.19,
    'J-SI1-GOOD-EX-NONE-EX': 7.19,
    'J-SI1-VG-VG-NONE-EX': 7.19,
    'J-SI1-EX-GOOD-NONE-EX': 7.19,
    'D-VS1-POOR-VG-MEDIUM-VG': 7.18,
    'D-VVS1-GOOD-EX-STRONG-GOOD': 7.18,
    'D-VS1-EX-VG-MEDIUM-GOOD': 7.18,
    'D-VVS1-VG-VG-STRONG-GOOD': 7.18,
    'D-VVS1-EX-GOOD-STRONG-GOOD': 7.18,
    'D-VS1-VG-EX-MEDIUM-GOOD': 7.18,
    'D-VS1-GOOD-GOOD-MEDIUM-VG': 7.18,
    'D-VVS1-POOR-GOOD-STRONG-VG': 7.18,
    'D-VVS1-GOOD-POOR-STRONG-VG': 7.18,
    'D-VS1-VG-POOR-MEDIUM-VG': 7.18,
    'E-VVS1-VG-VG-MEDIUM-GOOD': 7.18,
    'E-VVS1-POOR-GOOD-MEDIUM-VG': 7.18,
    'E-VVS1-GOOD-POOR-MEDIUM-VG': 7.18,
    'E-VS1-POOR-VG-FAINT-VG': 7.18,
    'E-VS1-VG-POOR-FAINT-VG': 7.18,
    'E-VVS1-EX-GOOD-MEDIUM-GOOD': 7.18,
    'E-VVS1-GOOD-EX-MEDIUM-GOOD': 7.18,
    'E-VS1-VG-EX-FAINT-GOOD': 7.18,
    'E-VS1-EX-VG-FAINT-GOOD': 7.18,
    'E-VS1-GOOD-GOOD-FAINT-VG': 7.18,
    'F-VS1-VG-POOR-NONE-VG': 7.18,
    'F-VVS1-GOOD-POOR-FAINT-VG': 7.18,
    'F-VVS1-GOOD-EX-FAINT-GOOD': 7.18,
    'F-VS1-GOOD-GOOD-NONE-VG': 7.18,
    'F-VS1-VG-EX-NONE-GOOD': 7.18,
    'F-VVS1-VG-VG-FAINT-GOOD': 7.18,
    'F-VVS1-EX-GOOD-FAINT-GOOD': 7.18,
    'F-VS1-EX-VG-NONE-GOOD': 7.18,
    'F-VS1-POOR-VG-NONE-VG': 7.18,
    'F-VVS1-POOR-GOOD-FAINT-VG': 7.18,
    'G-VVS1-POOR-GOOD-NONE-VG': 7.18,
    'G-VVS1-VG-VG-NONE-GOOD': 7.18,
    'G-VVS1-GOOD-POOR-NONE-VG': 7.18,
    'G-VVS1-EX-GOOD-NONE-GOOD': 7.18,
    'G-VVS1-GOOD-EX-NONE-GOOD': 7.18,
    'H-VS1-EX-POOR-STRONG-EX': 7.18,
    'H-VS1-VG-GOOD-STRONG-EX': 7.18,
    'H-VS1-EX-EX-STRONG-VG': 7.18,
    'H-VS1-GOOD-VG-STRONG-EX': 7.18,
    'H-VS1-POOR-EX-STRONG-EX': 7.18,
    'I-VVS1-GOOD-GOOD-STRONG-EX': 7.18,
    'I-VVS1-VG-POOR-STRONG-EX': 7.18,
    'I-VVS1-POOR-VG-STRONG-EX': 7.18,
    'I-VVS1-VG-EX-STRONG-VG': 7.18,
    'I-VS1-EX-EX-MEDIUM-VG': 7.18,
    'I-VS1-EX-POOR-MEDIUM-EX': 7.18,
    'I-VS1-VG-GOOD-MEDIUM-EX': 7.18,
    'I-VS1-GOOD-VG-MEDIUM-EX': 7.18,
    'I-VS1-POOR-EX-MEDIUM-EX': 7.18,
    'I-VVS1-EX-VG-STRONG-VG': 7.18,
    'J-VVS1-VG-POOR-MEDIUM-EX': 7.18,
    'J-VS1-VG-GOOD-FAINT-EX': 7.18,
    'J-VS1-POOR-EX-FAINT-EX': 7.18,
    'J-VS1-GOOD-VG-FAINT-EX': 7.18,
    'J-VS1-EX-POOR-FAINT-EX': 7.18,
    'J-VVS1-EX-VG-MEDIUM-VG': 7.18,
    'J-VS1-EX-EX-FAINT-VG': 7.18,
    'J-VVS1-GOOD-GOOD-MEDIUM-EX': 7.18,
    'J-VVS1-VG-EX-MEDIUM-VG': 7.18,
    'J-VVS1-POOR-VG-MEDIUM-EX': 7.18,
    'K-VVS1-VG-POOR-FAINT-EX': 7.18,
    'K-VVS1-POOR-VG-FAINT-EX': 7.18,
    'K-VVS1-GOOD-GOOD-FAINT-EX': 7.18,
    'K-VVS1-EX-VG-FAINT-VG': 7.18,
    'K-VVS1-VG-EX-FAINT-VG': 7.18,
    'K-VS1-POOR-EX-NONE-EX': 7.18,
    'K-VS1-GOOD-VG-NONE-EX': 7.18,
    'K-VS1-VG-GOOD-NONE-EX': 7.18,
    'K-VS1-EX-POOR-NONE-EX': 7.18,
    'K-VS1-EX-EX-NONE-VG': 7.18,
    'L-VVS1-GOOD-GOOD-NONE-EX': 7.18,
    'L-VVS1-POOR-VG-NONE-EX': 7.18,
    'L-VVS1-EX-VG-NONE-VG': 7.18,
    'L-VVS1-VG-EX-NONE-VG': 7.18,
    'L-VVS1-VG-POOR-NONE-EX': 7.18,
    'D-SI2-EX-POOR-NONE-VG': 7.17,
    'D-SI2-VG-GOOD-NONE-VG': 7.17,
    'D-SI2-POOR-POOR-NONE-EX': 7.17,
    'D-SI2-EX-EX-NONE-GOOD': 7.17,
    'D-SI2-POOR-EX-NONE-VG': 7.17,
    'D-SI2-GOOD-VG-NONE-VG': 7.17,
    'E-I2-VG-EX-STRONG-EX': 7.17,
    'E-I2-EX-VG-STRONG-EX': 7.17,
    'F-SI2-EX-GOOD-STRONG-EX': 7.17,
    'F-SI2-VG-VG-STRONG-EX': 7.17,
    'F-I2-VG-EX-MEDIUM-EX': 7.17,
    'F-SI2-GOOD-EX-STRONG-EX': 7.17,
    'F-I2-EX-VG-MEDIUM-EX': 7.17,
    'G-SI2-GOOD-EX-MEDIUM-EX': 7.17,
    'G-I2-EX-VG-FAINT-EX': 7.17,
    'G-SI2-EX-GOOD-MEDIUM-EX': 7.17,
    'G-SI2-VG-VG-MEDIUM-EX': 7.17,
    'G-I2-VG-EX-FAINT-EX': 7.17,
    'H-SI2-VG-VG-FAINT-EX': 7.17,
    'H-I2-VG-EX-NONE-EX': 7.17,
    'H-SI2-EX-GOOD-FAINT-EX': 7.17,
    'H-I2-EX-VG-NONE-EX': 7.17,
    'H-SI2-GOOD-EX-FAINT-EX': 7.17,
    'I-SI2-EX-GOOD-NONE-EX': 7.17,
    'I-SI2-VG-VG-NONE-EX': 7.17,
    'I-SI2-GOOD-EX-NONE-EX': 7.17,
    'D-VVS2-GOOD-POOR-MEDIUM-VG': 7.16,
    'D-VS2-VG-EX-FAINT-GOOD': 7.16,
    'D-VS2-VG-POOR-FAINT-VG': 7.16,
    'D-VVS2-VG-VG-MEDIUM-GOOD': 7.16,
    'D-VVS2-POOR-GOOD-MEDIUM-VG': 7.16,
    'D-VVS2-EX-GOOD-MEDIUM-GOOD': 7.16,
    'D-VVS2-GOOD-EX-MEDIUM-GOOD': 7.16,
    'D-VS2-EX-VG-FAINT-GOOD': 7.16,
    'D-VS2-GOOD-GOOD-FAINT-VG': 7.16,
    'D-VS2-POOR-VG-FAINT-VG': 7.16,
    'E-VVS2-VG-VG-FAINT-GOOD': 7.16,
    'E-VVS2-EX-GOOD-FAINT-GOOD': 7.16,
    'E-VVS2-POOR-GOOD-FAINT-VG': 7.16,
    'E-VVS2-GOOD-POOR-FAINT-VG': 7.16,
    'E-VVS2-GOOD-EX-FAINT-GOOD': 7.16,
    'E-VS2-VG-EX-NONE-GOOD': 7.16,
    'E-VS2-POOR-VG-NONE-VG': 7.16,
    'E-VS2-EX-VG-NONE-GOOD': 7.16,
    'E-VS2-GOOD-GOOD-NONE-VG': 7.16,
    'E-VS2-VG-POOR-NONE-VG': 7.16,
    'F-VVS2-EX-GOOD-NONE-GOOD': 7.16,
    'F-VVS2-VG-VG-NONE-GOOD': 7.16,
    'F-VVS2-GOOD-EX-NONE-GOOD': 7.16,
    'F-VVS2-GOOD-POOR-NONE-VG': 7.16,
    'F-VVS2-POOR-GOOD-NONE-VG': 7.16,
    'G-VS2-EX-POOR-STRONG-EX': 7.16,
    'G-VS2-VG-GOOD-STRONG-EX': 7.16,
    'G-VS2-POOR-EX-STRONG-EX': 7.16,
    'G-VS2-EX-EX-STRONG-VG': 7.16,
    'G-VS2-GOOD-VG-STRONG-EX': 7.16,
    'H-VVS2-EX-VG-STRONG-VG': 7.16,
    'H-VS2-VG-GOOD-MEDIUM-EX': 7.16,
    'H-VS2-POOR-EX-MEDIUM-EX': 7.16,
    'H-VVS2-VG-EX-STRONG-VG': 7.16,
    'H-VVS2-GOOD-GOOD-STRONG-EX': 7.16,
    'H-VS2-GOOD-VG-MEDIUM-EX': 7.16,
    'H-VS2-EX-EX-MEDIUM-VG': 7.16,
    'H-VVS2-POOR-VG-STRONG-EX': 7.16,
    'H-VS2-EX-POOR-MEDIUM-EX': 7.16,
    'H-VVS2-VG-POOR-STRONG-EX': 7.16,
    'I-VVS2-VG-POOR-MEDIUM-EX': 7.16,
    'I-VVS2-GOOD-GOOD-MEDIUM-EX': 7.16,
    'I-VS2-VG-GOOD-FAINT-EX': 7.16,
    'I-VS2-GOOD-VG-FAINT-EX': 7.16,
    'I-VVS2-POOR-VG-MEDIUM-EX': 7.16,
    'I-VVS2-EX-VG-MEDIUM-VG': 7.16,
    'I-VVS2-VG-EX-MEDIUM-VG': 7.16,
    'I-VS2-EX-EX-FAINT-VG': 7.16,
    'I-VS2-POOR-EX-FAINT-EX': 7.16,
    'I-VS2-EX-POOR-FAINT-EX': 7.16,
    'J-VS2-GOOD-VG-NONE-EX': 7.16,
    'J-VS2-VG-GOOD-NONE-EX': 7.16,
    'J-VS2-POOR-EX-NONE-EX': 7.16,
    'J-VS2-EX-POOR-NONE-EX': 7.16,
    'J-VVS2-VG-EX-FAINT-VG': 7.16,
    'J-VVS2-POOR-VG-FAINT-EX': 7.16,
    'J-VVS2-GOOD-GOOD-FAINT-EX': 7.16,
    'J-VS2-EX-EX-NONE-VG': 7.16,
    'J-VVS2-VG-POOR-FAINT-EX': 7.16,
    'J-VVS2-EX-VG-FAINT-VG': 7.16,
    'K-VVS2-POOR-VG-NONE-EX': 7.16,
    'K-VVS2-GOOD-GOOD-NONE-EX': 7.16,
    'K-VVS2-VG-POOR-NONE-EX': 7.16,
    'K-VVS2-VG-EX-NONE-VG': 7.16,
    'K-VVS2-EX-VG-NONE-VG': 7.16,
    'M-VVS2-EX-EX-STRONG-EX': 7.16,
    'D-IF-EX-POOR-STRONG-GOOD': 7.15,
    'D-IF-POOR-EX-STRONG-GOOD': 7.15,
    'D-IF-POOR-POOR-STRONG-VG': 7.15,
    'D-IF-EX-EX-STRONG-POOR': 7.15,
    'D-IF-GOOD-VG-STRONG-GOOD': 7.15,
    'D-IF-VG-GOOD-STRONG-GOOD': 7.15,
    'E-IF-GOOD-VG-MEDIUM-GOOD': 7.15,
    'E-IF-POOR-EX-MEDIUM-GOOD': 7.15,
    'E-IF-POOR-POOR-MEDIUM-VG': 7.15,
    'E-IF-EX-EX-MEDIUM-POOR': 7.15,
    'E-IF-EX-POOR-MEDIUM-GOOD': 7.15,
    'E-IF-VG-GOOD-MEDIUM-GOOD': 7.15,
    'F-IF-VG-GOOD-FAINT-GOOD': 7.15,
    'F-IF-EX-POOR-FAINT-GOOD': 7.15,
    'F-IF-POOR-EX-FAINT-GOOD': 7.15,
    'F-IF-EX-EX-FAINT-POOR': 7.15,
    'F-IF-GOOD-VG-FAINT-GOOD': 7.15,
    'F-IF-POOR-POOR-FAINT-VG': 7.15,
    'G-IF-EX-POOR-NONE-GOOD': 7.15,
    'G-IF-POOR-POOR-NONE-VG': 7.15,
    'G-IF-VG-GOOD-NONE-GOOD': 7.15,
    'G-IF-GOOD-VG-NONE-GOOD': 7.15,
    'G-IF-POOR-EX-NONE-GOOD': 7.15,
    'G-IF-EX-EX-NONE-POOR': 7.15,
    'I-IF-GOOD-EX-STRONG-VG': 7.15,
    'I-IF-GOOD-POOR-STRONG-EX': 7.15,
    'I-IF-POOR-GOOD-STRONG-EX': 7.15,
    'I-IF-VG-VG-STRONG-VG': 7.15,
    'I-IF-EX-GOOD-STRONG-VG': 7.15,
    'J-IF-GOOD-EX-MEDIUM-VG': 7.15,
    'J-IF-GOOD-POOR-MEDIUM-EX': 7.15,
    'J-IF-EX-GOOD-MEDIUM-VG': 7.15,
    'J-IF-VG-VG-MEDIUM-VG': 7.15,
    'J-IF-POOR-GOOD-MEDIUM-EX': 7.15,
    'K-IF-GOOD-POOR-FAINT-EX': 7.15,
    'K-IF-POOR-GOOD-FAINT-EX': 7.15,
    'K-IF-VG-VG-FAINT-VG': 7.15,
    'K-IF-GOOD-EX-FAINT-VG': 7.15,
    'K-IF-EX-GOOD-FAINT-VG': 7.15,
    'L-IF-POOR-GOOD-NONE-EX': 7.15,
    'L-IF-VG-VG-NONE-VG': 7.15,
    'L-IF-GOOD-EX-NONE-VG': 7.15,
    'L-IF-EX-GOOD-NONE-VG': 7.15,
    'L-IF-GOOD-POOR-NONE-EX': 7.15,
    'D-SI1-VG-EX-NONE-GOOD': 7.14,
    'D-SI1-POOR-VG-NONE-VG': 7.14,
    'D-SI1-GOOD-GOOD-NONE-VG': 7.14,
    'D-SI1-EX-VG-NONE-GOOD': 7.14,
    'D-SI1-VG-POOR-NONE-VG': 7.14,
    'E-I1-EX-GOOD-STRONG-EX': 7.14,
    'E-I1-VG-VG-STRONG-EX': 7.14,
    'E-I1-GOOD-EX-STRONG-EX': 7.14,
    'F-SI1-EX-POOR-STRONG-EX': 7.14,
    'F-I1-GOOD-EX-MEDIUM-EX': 7.14,
    'F-I1-VG-VG-MEDIUM-EX': 7.14,
    'F-I1-EX-GOOD-MEDIUM-EX': 7.14,
    'F-SI1-EX-EX-STRONG-VG': 7.14,
    'F-SI1-GOOD-VG-STRONG-EX': 7.14,
    'F-SI1-POOR-EX-STRONG-EX': 7.14,
    'F-SI1-VG-GOOD-STRONG-EX': 7.14,
    'G-SI1-EX-POOR-MEDIUM-EX': 7.14,
    'G-SI1-GOOD-VG-MEDIUM-EX': 7.14,
    'G-SI1-EX-EX-MEDIUM-VG': 7.14,
    'G-SI1-VG-GOOD-MEDIUM-EX': 7.14,
    'G-SI1-POOR-EX-MEDIUM-EX': 7.14,
    'G-I1-VG-VG-FAINT-EX': 7.14,
    'G-I1-GOOD-EX-FAINT-EX': 7.14,
    'G-I1-EX-GOOD-FAINT-EX': 7.14,
    'H-I1-EX-GOOD-NONE-EX': 7.14,
    'H-I1-VG-VG-NONE-EX': 7.14,
    'H-SI1-VG-GOOD-FAINT-EX': 7.14,
    'H-SI1-GOOD-VG-FAINT-EX': 7.14,
    'H-SI1-POOR-EX-FAINT-EX': 7.14,
    'H-SI1-EX-POOR-FAINT-EX': 7.14,
    'H-I1-GOOD-EX-NONE-EX': 7.14,
    'H-SI1-EX-EX-FAINT-VG': 7.14,
    'I-SI1-EX-EX-NONE-VG': 7.14,
    'I-SI1-EX-POOR-NONE-EX': 7.14,
    'I-SI1-VG-GOOD-NONE-EX': 7.14,
    'I-SI1-GOOD-VG-NONE-EX': 7.14,
    'I-SI1-POOR-EX-NONE-EX': 7.14,
    'D-VVS1-VG-GOOD-MEDIUM-GOOD': 7.13,
    'D-VS1-POOR-GOOD-FAINT-VG': 7.13,
    'D-VVS1-POOR-EX-MEDIUM-GOOD': 7.13,
    'D-VS1-GOOD-POOR-FAINT-VG': 7.13,
    'D-VVS1-EX-EX-MEDIUM-POOR': 7.13,
    'D-VVS1-EX-POOR-MEDIUM-GOOD': 7.13,
    'D-VS1-EX-GOOD-FAINT-GOOD': 7.13,
    'D-VVS1-GOOD-VG-MEDIUM-GOOD': 7.13,
    'D-VVS1-POOR-POOR-MEDIUM-VG': 7.13,
    'D-VS1-GOOD-EX-FAINT-GOOD': 7.13,
    'D-VS1-VG-VG-FAINT-GOOD': 7.13,
    'E-VS1-POOR-GOOD-NONE-VG': 7.13,
    'E-VS1-VG-VG-NONE-GOOD': 7.13,
    'E-VS1-GOOD-EX-NONE-GOOD': 7.13,
    'E-VS1-GOOD-POOR-NONE-VG': 7.13,
    'E-VVS1-VG-GOOD-FAINT-GOOD': 7.13,
    'E-VVS1-EX-EX-FAINT-POOR': 7.13,
    'E-VS1-EX-GOOD-NONE-GOOD': 7.13,
    'E-VVS1-EX-POOR-FAINT-GOOD': 7.13,
    'E-VVS1-GOOD-VG-FAINT-GOOD': 7.13,
    'E-VVS1-POOR-EX-FAINT-GOOD': 7.13,
    'E-VVS1-POOR-POOR-FAINT-VG': 7.13,
    'F-VVS1-EX-EX-NONE-POOR': 7.13,
    'F-VVS1-GOOD-VG-NONE-GOOD': 7.13,
    'F-VVS1-POOR-EX-NONE-GOOD': 7.13,
    'F-VVS1-POOR-POOR-NONE-VG': 7.13,
    'F-VVS1-EX-POOR-NONE-GOOD': 7.13,
    'F-VVS1-VG-GOOD-NONE-GOOD': 7.13,
    'G-VS1-POOR-VG-STRONG-EX': 7.13,
    'G-VS1-GOOD-GOOD-STRONG-EX': 7.13,
    'G-VS1-VG-POOR-STRONG-EX': 7.13,
    'G-VS1-VG-EX-STRONG-VG': 7.13,
    'G-VS1-EX-VG-STRONG-VG': 7.13,
    'H-VVS1-GOOD-POOR-STRONG-EX': 7.13,
    'H-VVS1-GOOD-EX-STRONG-VG': 7.13,
    'H-VVS1-VG-VG-STRONG-VG': 7.13,
    'H-VVS1-EX-GOOD-STRONG-VG': 7.13,
    'H-VS1-VG-POOR-MEDIUM-EX': 7.13,
    'H-VS1-GOOD-GOOD-MEDIUM-EX': 7.13,
    'H-VS1-EX-VG-MEDIUM-VG': 7.13,
    'H-VS1-POOR-VG-MEDIUM-EX': 7.13,
    'H-VVS1-POOR-GOOD-STRONG-EX': 7.13,
    'H-VS1-VG-EX-MEDIUM-VG': 7.13,
    'I-VS1-VG-POOR-FAINT-EX': 7.13,
    'I-VS1-GOOD-GOOD-FAINT-EX': 7.13,
    'I-VS1-POOR-VG-FAINT-EX': 7.13,
    'I-VVS1-POOR-GOOD-MEDIUM-EX': 7.13,
    'I-VVS1-GOOD-POOR-MEDIUM-EX': 7.13,
    'I-VVS1-GOOD-EX-MEDIUM-VG': 7.13,
    'I-VVS1-VG-VG-MEDIUM-VG': 7.13,
    'I-VVS1-EX-GOOD-MEDIUM-VG': 7.13,
    'I-VS1-VG-EX-FAINT-VG': 7.13,
    'I-VS1-EX-VG-FAINT-VG': 7.13,
    'J-VVS1-POOR-GOOD-FAINT-EX': 7.13,
    'J-VVS1-VG-VG-FAINT-VG': 7.13,
    'J-VVS1-EX-GOOD-FAINT-VG': 7.13,
    'J-VS1-EX-VG-NONE-VG': 7.13,
    'J-VS1-VG-EX-NONE-VG': 7.13,
    'J-VS1-VG-POOR-NONE-EX': 7.13,
    'J-VS1-GOOD-GOOD-NONE-EX': 7.13,
    'J-VS1-POOR-VG-NONE-EX': 7.13,
    'J-VVS1-GOOD-POOR-FAINT-EX': 7.13,
    'J-VVS1-GOOD-EX-FAINT-VG': 7.13,
    'K-VVS1-GOOD-EX-NONE-VG': 7.13,
    'K-VVS1-VG-VG-NONE-VG': 7.13,
    'K-VVS1-EX-GOOD-NONE-VG': 7.13,
    'K-VVS1-GOOD-POOR-NONE-EX': 7.13,
    'K-VVS1-POOR-GOOD-NONE-EX': 7.13,
    'L-VS1-EX-EX-STRONG-EX': 7.13,
    'M-VS1-EX-EX-MEDIUM-EX': 7.13,
    'M-VVS1-EX-VG-STRONG-EX': 7.13,
    'M-VVS1-VG-EX-STRONG-EX': 7.13,
    'D-I2-GOOD-EX-STRONG-EX': 7.12,
    'D-I2-EX-GOOD-STRONG-EX': 7.12,
    'D-I2-VG-VG-STRONG-EX': 7.12,
    'E-I2-VG-VG-MEDIUM-EX': 7.12,
    'E-I2-GOOD-EX-MEDIUM-EX': 7.12,
    'E-I2-EX-GOOD-MEDIUM-EX': 7.12,
    'E-SI2-POOR-EX-STRONG-EX': 7.12,
    'E-SI2-GOOD-VG-STRONG-EX': 7.12,
    'E-SI2-VG-GOOD-STRONG-EX': 7.12,
    'E-SI2-EX-POOR-STRONG-EX': 7.12,
    'E-SI2-EX-EX-STRONG-VG': 7.12,
    'F-SI2-GOOD-VG-MEDIUM-EX': 7.12,
    'F-I2-EX-GOOD-FAINT-EX': 7.12,
    'F-SI2-EX-POOR-MEDIUM-EX': 7.12,
    'F-SI2-POOR-EX-MEDIUM-EX': 7.12,
    'F-I2-GOOD-EX-FAINT-EX': 7.12,
    'F-SI2-EX-EX-MEDIUM-VG': 7.12,
    'F-I2-VG-VG-FAINT-EX': 7.12,
    'F-SI2-VG-GOOD-MEDIUM-EX': 7.12,
    'G-SI2-VG-GOOD-FAINT-EX': 7.12,
    'G-SI2-EX-POOR-FAINT-EX': 7.12,
    'G-SI2-EX-EX-FAINT-VG': 7.12,
    'G-SI2-POOR-EX-FAINT-EX': 7.12,
    'G-SI2-GOOD-VG-FAINT-EX': 7.12,
    'G-I2-EX-GOOD-NONE-EX': 7.12,
    'G-I2-GOOD-EX-NONE-EX': 7.12,
    'G-I2-VG-VG-NONE-EX': 7.12,
    'H-SI2-GOOD-VG-NONE-EX': 7.12,
    'H-SI2-POOR-EX-NONE-EX': 7.12,
    'H-SI2-VG-GOOD-NONE-EX': 7.12,
    'H-SI2-EX-POOR-NONE-EX': 7.12,
    'H-SI2-EX-EX-NONE-VG': 7.12,
    'D-VVS2-GOOD-VG-FAINT-GOOD': 7.11,
    'D-VVS2-VG-GOOD-FAINT-GOOD': 7.11,
    'D-VVS2-EX-EX-FAINT-POOR': 7.11,
    'D-VVS2-EX-POOR-FAINT-GOOD': 7.11,
    'D-VVS2-POOR-EX-FAINT-GOOD': 7.11,
    'D-VVS2-POOR-POOR-FAINT-VG': 7.11,
    'D-VS2-VG-VG-NONE-GOOD': 7.11,
    'D-VS2-GOOD-POOR-NONE-VG': 7.11,
    'D-VS2-POOR-GOOD-NONE-VG': 7.11,
    'D-VS2-GOOD-EX-NONE-GOOD': 7.11,
    'D-VS2-EX-GOOD-NONE-GOOD': 7.11,
    'E-VVS2-VG-GOOD-NONE-GOOD': 7.11,
    'E-VVS2-EX-EX-NONE-POOR': 7.11,
    'E-VVS2-POOR-EX-NONE-GOOD': 7.11,
    'E-VVS2-GOOD-VG-NONE-GOOD': 7.11,
    'E-VVS2-EX-POOR-NONE-GOOD': 7.11,
    'E-VVS2-POOR-POOR-NONE-VG': 7.11,
    'F-VS2-VG-EX-STRONG-VG': 7.11,
    'F-VS2-EX-VG-STRONG-VG': 7.11,
    'F-VS2-GOOD-GOOD-STRONG-EX': 7.11,
    'F-VS2-POOR-VG-STRONG-EX': 7.11,
    'F-VS2-VG-POOR-STRONG-EX': 7.11,
    'G-VS2-GOOD-GOOD-MEDIUM-EX': 7.11,
    'G-VS2-VG-POOR-MEDIUM-EX': 7.11,
    'G-VS2-VG-EX-MEDIUM-VG': 7.11,
    'G-VS2-EX-VG-MEDIUM-VG': 7.11,
    'G-VVS2-EX-GOOD-STRONG-VG': 7.11,
    'G-VVS2-POOR-GOOD-STRONG-EX': 7.11,
    'G-VVS2-GOOD-POOR-STRONG-EX': 7.11,
    'G-VVS2-GOOD-EX-STRONG-VG': 7.11,
    'G-VVS2-VG-VG-STRONG-VG': 7.11,
    'G-VS2-POOR-VG-MEDIUM-EX': 7.11,
    'H-VVS2-EX-GOOD-MEDIUM-VG': 7.11,
    'H-VVS2-VG-VG-MEDIUM-VG': 7.11,
    'H-VS2-POOR-VG-FAINT-EX': 7.11,
    'H-VVS2-GOOD-EX-MEDIUM-VG': 7.11,
    'H-VS2-GOOD-GOOD-FAINT-EX': 7.11,
    'H-VVS2-GOOD-POOR-MEDIUM-EX': 7.11,
    'H-VS2-VG-POOR-FAINT-EX': 7.11,
    'H-VS2-VG-EX-FAINT-VG': 7.11,
    'H-VVS2-POOR-GOOD-MEDIUM-EX': 7.11,
    'H-VS2-EX-VG-FAINT-VG': 7.11,
    'I-VS2-EX-VG-NONE-VG': 7.11,
    'I-VS2-VG-POOR-NONE-EX': 7.11,
    'I-VS2-GOOD-GOOD-NONE-EX': 7.11,
    'I-VS2-VG-EX-NONE-VG': 7.11,
    'I-VS2-POOR-VG-NONE-EX': 7.11,
    'I-VVS2-POOR-GOOD-FAINT-EX': 7.11,
    'I-VVS2-GOOD-POOR-FAINT-EX': 7.11,
    'I-VVS2-GOOD-EX-FAINT-VG': 7.11,
    'I-VVS2-VG-VG-FAINT-VG': 7.11,
    'I-VVS2-EX-GOOD-FAINT-VG': 7.11,
    'J-VVS2-POOR-GOOD-NONE-EX': 7.11,
    'J-VVS2-GOOD-POOR-NONE-EX': 7.11,
    'J-VVS2-GOOD-EX-NONE-VG': 7.11,
    'J-VVS2-VG-VG-NONE-VG': 7.11,
    'J-VVS2-EX-GOOD-NONE-VG': 7.11,
    'K-VS2-EX-EX-STRONG-EX': 7.11,
    'L-VS2-EX-EX-MEDIUM-EX': 7.11,
    'L-VVS2-VG-EX-STRONG-EX': 7.11,
    'L-VVS2-EX-VG-STRONG-EX': 7.11,
    'M-VVS2-EX-VG-MEDIUM-EX': 7.11,
    'M-VS2-EX-EX-FAINT-EX': 7.11,
    'M-VVS2-VG-EX-MEDIUM-EX': 7.11,
    'D-IF-EX-VG-MEDIUM-POOR': 7.1,
    'D-IF-VG-POOR-MEDIUM-GOOD': 7.1,
    'D-IF-GOOD-GOOD-MEDIUM-GOOD': 7.1,
    'D-IF-POOR-VG-MEDIUM-GOOD': 7.1,
    'D-IF-VG-EX-MEDIUM-POOR': 7.1,
    'E-IF-VG-EX-FAINT-POOR': 7.1,
    'E-IF-VG-POOR-FAINT-GOOD': 7.1,
    'E-IF-EX-VG-FAINT-POOR': 7.1,
    'E-IF-GOOD-GOOD-FAINT-GOOD': 7.1,
    'E-IF-POOR-VG-FAINT-GOOD': 7.1,
    'F-IF-GOOD-GOOD-NONE-GOOD': 7.1,
    'F-IF-VG-POOR-NONE-GOOD': 7.1,
    'F-IF-VG-EX-NONE-POOR': 7.1,
    'F-IF-POOR-VG-NONE-GOOD': 7.1,
    'F-IF-EX-VG-NONE-POOR': 7.1,
    'H-IF-EX-EX-STRONG-GOOD': 7.1,
    'H-IF-POOR-EX-STRONG-VG': 7.1,
    'H-IF-POOR-POOR-STRONG-EX': 7.1,
    'H-IF-GOOD-VG-STRONG-VG': 7.1,
    'H-IF-VG-GOOD-STRONG-VG': 7.1,
    'H-IF-EX-POOR-STRONG-VG': 7.1,
    'I-IF-VG-GOOD-MEDIUM-VG': 7.1,
    'I-IF-GOOD-VG-MEDIUM-VG': 7.1,
    'I-IF-POOR-POOR-MEDIUM-EX': 7.1,
    'I-IF-POOR-EX-MEDIUM-VG': 7.1,
    'I-IF-EX-EX-MEDIUM-GOOD': 7.1,
    'I-IF-EX-POOR-MEDIUM-VG': 7.1,
    'J-IF-POOR-EX-FAINT-VG': 7.1,
    'J-IF-GOOD-VG-FAINT-VG': 7.1,
    'J-IF-VG-GOOD-FAINT-VG': 7.1,
    'J-IF-EX-POOR-FAINT-VG': 7.1,
    'J-IF-EX-EX-FAINT-GOOD': 7.1,
    'J-IF-POOR-POOR-FAINT-EX': 7.1,
    'K-IF-EX-EX-NONE-GOOD': 7.1,
    'K-IF-POOR-EX-NONE-VG': 7.1,
    'K-IF-VG-GOOD-NONE-VG': 7.1,
    'K-IF-EX-POOR-NONE-VG': 7.1,
    'K-IF-POOR-POOR-NONE-EX': 7.1,
    'K-IF-GOOD-VG-NONE-VG': 7.1,
    'M-IF-GOOD-EX-STRONG-EX': 7.1,
    'M-IF-EX-GOOD-STRONG-EX': 7.1,
    'M-IF-VG-VG-STRONG-EX': 7.1,
    'D-I1-VG-GOOD-STRONG-EX': 7.09,
    'D-I1-GOOD-VG-STRONG-EX': 7.09,
    'D-I1-POOR-EX-STRONG-EX': 7.09,
    'D-I1-EX-EX-STRONG-VG': 7.09,
    'D-I1-EX-POOR-STRONG-EX': 7.09,
    'E-SI1-POOR-VG-STRONG-EX': 7.09,
    'E-SI1-GOOD-GOOD-STRONG-EX': 7.09,
    'E-I1-EX-POOR-MEDIUM-EX': 7.09,
    'E-SI1-VG-POOR-STRONG-EX': 7.09,
    'E-I1-VG-GOOD-MEDIUM-EX': 7.09,
    'E-SI1-EX-VG-STRONG-VG': 7.09,
    'E-I1-POOR-EX-MEDIUM-EX': 7.09,
    'E-SI1-VG-EX-STRONG-VG': 7.09,
    'E-I1-EX-EX-MEDIUM-VG': 7.09,
    'E-I1-GOOD-VG-MEDIUM-EX': 7.09,
    'F-SI1-EX-VG-MEDIUM-VG': 7.09,
    'F-I1-VG-GOOD-FAINT-EX': 7.09,
    'F-I1-POOR-EX-FAINT-EX': 7.09,
    'F-I1-EX-EX-FAINT-VG': 7.09,
    'F-I1-EX-POOR-FAINT-EX': 7.09,
    'F-SI1-GOOD-GOOD-MEDIUM-EX': 7.09,
    'F-SI1-VG-POOR-MEDIUM-EX': 7.09,
    'F-I1-GOOD-VG-FAINT-EX': 7.09,
    'F-SI1-VG-EX-MEDIUM-VG': 7.09,
    'F-SI1-POOR-VG-MEDIUM-EX': 7.09,
    'G-I1-GOOD-VG-NONE-EX': 7.09,
    'G-SI1-VG-EX-FAINT-VG': 7.09,
    'G-SI1-POOR-VG-FAINT-EX': 7.09,
    'G-I1-EX-POOR-NONE-EX': 7.09,
    'G-SI1-VG-POOR-FAINT-EX': 7.09,
    'G-SI1-EX-VG-FAINT-VG': 7.09,
    'G-I1-VG-GOOD-NONE-EX': 7.09,
    'G-I1-EX-EX-NONE-VG': 7.09,
    'G-I1-POOR-EX-NONE-EX': 7.09,
    'G-SI1-GOOD-GOOD-FAINT-EX': 7.09,
    'H-SI1-VG-EX-NONE-VG': 7.09,
    'H-SI1-EX-VG-NONE-VG': 7.09,
    'H-SI1-POOR-VG-NONE-EX': 7.09,
    'H-SI1-VG-POOR-NONE-EX': 7.09,
    'H-SI1-GOOD-GOOD-NONE-EX': 7.09,
    'J-SI1-EX-EX-STRONG-EX': 7.09,
    'K-SI1-EX-EX-MEDIUM-EX': 7.09,
    'L-SI1-EX-EX-FAINT-EX': 7.09,
    'M-SI1-EX-EX-NONE-EX': 7.09,
    'D-VS1-EX-POOR-NONE-GOOD': 7.08,
    'D-VS1-POOR-POOR-NONE-VG': 7.08,
    'D-VS1-GOOD-VG-NONE-GOOD': 7.08,
    'D-VVS1-VG-EX-FAINT-POOR': 7.08,
    'D-VVS1-POOR-VG-FAINT-GOOD': 7.08,
    'D-VVS1-VG-POOR-FAINT-GOOD': 7.08,
    'D-VVS1-EX-VG-FAINT-POOR': 7.08,
    'D-VS1-VG-GOOD-NONE-GOOD': 7.08,
    'D-VS1-EX-EX-NONE-POOR': 7.08,
    'D-VVS1-GOOD-GOOD-FAINT-GOOD': 7.08,
    'D-VS1-POOR-EX-NONE-GOOD': 7.08,
    'E-VVS1-VG-POOR-NONE-GOOD': 7.08,
    'E-VVS1-GOOD-GOOD-NONE-GOOD': 7.08,
    'E-VVS1-EX-VG-NONE-POOR': 7.08,
    'E-VVS1-POOR-VG-NONE-GOOD': 7.08,
    'E-VVS1-VG-EX-NONE-POOR': 7.08,
    'F-VS1-GOOD-POOR-STRONG-EX': 7.08,
    'F-VS1-POOR-GOOD-STRONG-EX': 7.08,
    'F-VS1-VG-VG-STRONG-VG': 7.08,
    'F-VS1-GOOD-EX-STRONG-VG': 7.08,
    'F-VS1-EX-GOOD-STRONG-VG': 7.08,
    'G-VVS1-GOOD-VG-STRONG-VG': 7.08,
    'G-VS1-GOOD-POOR-MEDIUM-EX': 7.08,
    'G-VVS1-POOR-EX-STRONG-VG': 7.08,
    'G-VS1-POOR-GOOD-MEDIUM-EX': 7.08,
    'G-VS1-GOOD-EX-MEDIUM-VG': 7.08,
    'G-VVS1-POOR-POOR-STRONG-EX': 7.08,
    'G-VVS1-EX-POOR-STRONG-VG': 7.08,
    'G-VVS1-EX-EX-STRONG-GOOD': 7.08,
    'G-VS1-VG-VG-MEDIUM-VG': 7.08,
    'G-VS1-EX-GOOD-MEDIUM-VG': 7.08,
    'G-VVS1-VG-GOOD-STRONG-VG': 7.08,
    'H-VS1-VG-VG-FAINT-VG': 7.08,
    'H-VS1-GOOD-POOR-FAINT-EX': 7.08,
    'H-VVS1-GOOD-VG-MEDIUM-VG': 7.08,
    'H-VVS1-POOR-EX-MEDIUM-VG': 7.08,
    'H-VS1-POOR-GOOD-FAINT-EX': 7.08,
    'H-VVS1-EX-POOR-MEDIUM-VG': 7.08,
    'H-VVS1-VG-GOOD-MEDIUM-VG': 7.08,
    'H-VVS1-EX-EX-MEDIUM-GOOD': 7.08,
    'H-VS1-GOOD-EX-FAINT-VG': 7.08,
    'H-VVS1-POOR-POOR-MEDIUM-EX': 7.08,
    'H-VS1-EX-GOOD-FAINT-VG': 7.08,
    'I-VS1-VG-VG-NONE-VG': 7.08,
    'I-VVS1-EX-POOR-FAINT-VG': 7.08,
    'I-VS1-EX-GOOD-NONE-VG': 7.08,
    'I-VVS1-EX-EX-FAINT-GOOD': 7.08,
    'I-VS1-POOR-GOOD-NONE-EX': 7.08,
    'I-VVS1-POOR-POOR-FAINT-EX': 7.08,
    'I-VS1-GOOD-POOR-NONE-EX': 7.08,
    'I-VVS1-GOOD-VG-FAINT-VG': 7.08,
    'I-VS1-GOOD-EX-NONE-VG': 7.08,
    'I-VVS1-POOR-EX-FAINT-VG': 7.08,
    'I-VVS1-VG-GOOD-FAINT-VG': 7.08,
    'J-VVS1-GOOD-VG-NONE-VG': 7.08,
    'J-VVS1-VG-GOOD-NONE-VG': 7.08,
    'J-VVS1-POOR-POOR-NONE-EX': 7.08,
    'J-VVS1-EX-EX-NONE-GOOD': 7.08,
    'J-VVS1-EX-POOR-NONE-VG': 7.08,
    'J-VVS1-POOR-EX-NONE-VG': 7.08,
    'K-VS1-VG-EX-STRONG-EX': 7.08,
    'K-VS1-EX-VG-STRONG-EX': 7.08,
    'L-VS1-EX-VG-MEDIUM-EX': 7.08,
    'L-VVS1-VG-VG-STRONG-EX': 7.08,
    'L-VS1-VG-EX-MEDIUM-EX': 7.08,
    'L-VVS1-EX-GOOD-STRONG-EX': 7.08,
    'L-VVS1-GOOD-EX-STRONG-EX': 7.08,
    'M-VVS1-GOOD-EX-MEDIUM-EX': 7.08,
    'M-VS1-VG-EX-FAINT-EX': 7.08,
    'M-VVS1-VG-VG-MEDIUM-EX': 7.08,
    'M-VS1-EX-VG-FAINT-EX': 7.08,
    'M-VVS1-EX-GOOD-MEDIUM-EX': 7.08,
    'D-SI2-POOR-VG-STRONG-EX': 7.07,
    'D-I2-EX-EX-MEDIUM-VG': 7.07,
    'D-I2-EX-POOR-MEDIUM-EX': 7.07,
    'D-I2-VG-GOOD-MEDIUM-EX': 7.07,
    'D-SI2-VG-EX-STRONG-VG': 7.07,
    'D-I2-GOOD-VG-MEDIUM-EX': 7.07,
    'D-SI2-VG-POOR-STRONG-EX': 7.07,
    'D-SI2-GOOD-GOOD-STRONG-EX': 7.07,
    'D-SI2-EX-VG-STRONG-VG': 7.07,
    'D-I2-POOR-EX-MEDIUM-EX': 7.07,
    'E-SI2-GOOD-GOOD-MEDIUM-EX': 7.07,
    'E-SI2-EX-VG-MEDIUM-VG': 7.07,
    'E-I2-EX-POOR-FAINT-EX': 7.07,
    'E-I2-VG-GOOD-FAINT-EX': 7.07,
    'E-I2-GOOD-VG-FAINT-EX': 7.07,
    'E-I2-POOR-EX-FAINT-EX': 7.07,
    'E-SI2-POOR-VG-MEDIUM-EX': 7.07,
    'E-SI2-VG-EX-MEDIUM-VG': 7.07,
    'E-SI2-VG-POOR-MEDIUM-EX': 7.07,
    'E-I2-EX-EX-FAINT-VG': 7.07,
    'F-I2-GOOD-VG-NONE-EX': 7.07,
    'F-I2-EX-POOR-NONE-EX': 7.07,
    'F-I2-EX-EX-NONE-VG': 7.07,
    'F-I2-VG-GOOD-NONE-EX': 7.07,
    'F-I2-POOR-EX-NONE-EX': 7.07,
    'F-SI2-VG-EX-FAINT-VG': 7.07,
    'F-SI2-GOOD-GOOD-FAINT-EX': 7.07,
    'F-SI2-POOR-VG-FAINT-EX': 7.07,
    'F-SI2-VG-POOR-FAINT-EX': 7.07,
    'F-SI2-EX-VG-FAINT-VG': 7.07,
    'G-SI2-GOOD-GOOD-NONE-EX': 7.07,
    'G-SI2-POOR-VG-NONE-EX': 7.07,
    'G-SI2-VG-POOR-NONE-EX': 7.07,
    'G-SI2-VG-EX-NONE-VG': 7.07,
    'G-SI2-EX-VG-NONE-VG': 7.07,
    'I-SI2-EX-EX-STRONG-EX': 7.07,
    'J-SI2-EX-EX-MEDIUM-EX': 7.07,
    'K-SI2-EX-EX-FAINT-EX': 7.07,
    'L-SI2-EX-EX-NONE-EX': 7.07,
    'D-VVS2-VG-POOR-NONE-GOOD': 7.06,
    'D-VVS2-POOR-VG-NONE-GOOD': 7.06,
    'D-VVS2-VG-EX-NONE-POOR': 7.06,
    'D-VVS2-GOOD-GOOD-NONE-GOOD': 7.06,
    'D-VVS2-EX-VG-NONE-POOR': 7.06,
    'E-VS2-POOR-GOOD-STRONG-EX': 7.06,
    'E-VS2-GOOD-EX-STRONG-VG': 7.06,
    'E-VS2-VG-VG-STRONG-VG': 7.06,
    'E-VS2-EX-GOOD-STRONG-VG': 7.06,
    'E-VS2-GOOD-POOR-STRONG-EX': 7.06,
    'F-VVS2-EX-EX-STRONG-GOOD': 7.06,
    'F-VS2-VG-VG-MEDIUM-VG': 7.06,
    'F-VS2-EX-GOOD-MEDIUM-VG': 7.06,
    'F-VS2-GOOD-EX-MEDIUM-VG': 7.06,
    'F-VS2-POOR-GOOD-MEDIUM-EX': 7.06,
    'F-VVS2-EX-POOR-STRONG-VG': 7.06,
    'F-VVS2-VG-GOOD-STRONG-VG': 7.06,
    'F-VS2-GOOD-POOR-MEDIUM-EX': 7.06,
    'F-VVS2-POOR-EX-STRONG-VG': 7.06,
    'F-VVS2-POOR-POOR-STRONG-EX': 7.06,
    'F-VVS2-GOOD-VG-STRONG-VG': 7.06,
    'G-VVS2-GOOD-VG-MEDIUM-VG': 7.06,
    'G-VVS2-EX-EX-MEDIUM-GOOD': 7.06,
    'G-VVS2-EX-POOR-MEDIUM-VG': 7.06,
    'G-VVS2-VG-GOOD-MEDIUM-VG': 7.06,
    'G-VS2-GOOD-POOR-FAINT-EX': 7.06,
    'G-VS2-EX-GOOD-FAINT-VG': 7.06,
    'G-VS2-VG-VG-FAINT-VG': 7.06,
    'G-VS2-GOOD-EX-FAINT-VG': 7.06,
    'G-VVS2-POOR-EX-MEDIUM-VG': 7.06,
    'G-VS2-POOR-GOOD-FAINT-EX': 7.06,
    'G-VVS2-POOR-POOR-MEDIUM-EX': 7.06,
    'H-VVS2-POOR-POOR-FAINT-EX': 7.06,
    'H-VVS2-EX-POOR-FAINT-VG': 7.06,
    'H-VS2-EX-GOOD-NONE-VG': 7.06,
    'H-VVS2-EX-EX-FAINT-GOOD': 7.06,
    'H-VVS2-POOR-EX-FAINT-VG': 7.06,
    'H-VVS2-GOOD-VG-FAINT-VG': 7.06,
    'H-VS2-VG-VG-NONE-VG': 7.06,
    'H-VVS2-VG-GOOD-FAINT-VG': 7.06,
    'H-VS2-GOOD-EX-NONE-VG': 7.06,
    'H-VS2-GOOD-POOR-NONE-EX': 7.06,
    'H-VS2-POOR-GOOD-NONE-EX': 7.06,
    'I-VVS2-EX-EX-NONE-GOOD': 7.06,
    'I-VVS2-EX-POOR-NONE-VG': 7.06,
    'I-VVS2-VG-GOOD-NONE-VG': 7.06,
    'I-VVS2-GOOD-VG-NONE-VG': 7.06,
    'I-VVS2-POOR-EX-NONE-VG': 7.06,
    'I-VVS2-POOR-POOR-NONE-EX': 7.06,
    'J-VS2-EX-VG-STRONG-EX': 7.06,
    'J-VS2-VG-EX-STRONG-EX': 7.06,
    'K-VVS2-EX-GOOD-STRONG-EX': 7.06,
    'K-VVS2-VG-VG-STRONG-EX': 7.06,
    'K-VVS2-GOOD-EX-STRONG-EX': 7.06,
    'K-VS2-VG-EX-MEDIUM-EX': 7.06,
    'K-VS2-EX-VG-MEDIUM-EX': 7.06,
    'L-VVS2-VG-VG-MEDIUM-EX': 7.06,
    'L-VS2-EX-VG-FAINT-EX': 7.06,
    'L-VVS2-EX-GOOD-MEDIUM-EX': 7.06,
    'L-VVS2-GOOD-EX-MEDIUM-EX': 7.06,
    'L-VS2-VG-EX-FAINT-EX': 7.06,
    'M-VS2-EX-VG-NONE-EX': 7.06,
    'M-VS2-VG-EX-NONE-EX': 7.06,
    'M-VVS2-GOOD-EX-FAINT-EX': 7.06,
    'M-VVS2-EX-GOOD-FAINT-EX': 7.06,
    'M-VVS2-VG-VG-FAINT-EX': 7.06,
    'D-IF-VG-VG-FAINT-POOR': 7.05,
    'D-IF-EX-GOOD-FAINT-POOR': 7.05,
    'D-IF-POOR-GOOD-FAINT-GOOD': 7.05,
    'D-IF-GOOD-EX-FAINT-POOR': 7.05,
    'D-IF-GOOD-POOR-FAINT-GOOD': 7.05,
    'E-IF-VG-VG-NONE-POOR': 7.05,
    'E-IF-EX-GOOD-NONE-POOR': 7.05,
    'E-IF-GOOD-EX-NONE-POOR': 7.05,
    'E-IF-GOOD-POOR-NONE-GOOD': 7.05,
    'E-IF-POOR-GOOD-NONE-GOOD': 7.05,
    'G-IF-VG-EX-STRONG-GOOD': 7.05,
    'G-IF-EX-VG-STRONG-GOOD': 7.05,
    'G-IF-POOR-VG-STRONG-VG': 7.05,
    'G-IF-VG-POOR-STRONG-VG': 7.05,
    'G-IF-GOOD-GOOD-STRONG-VG': 7.05,
    'H-IF-POOR-VG-MEDIUM-VG': 7.05,
    'H-IF-VG-EX-MEDIUM-GOOD': 7.05,
    'H-IF-GOOD-GOOD-MEDIUM-VG': 7.05,
    'H-IF-EX-VG-MEDIUM-GOOD': 7.05,
    'H-IF-VG-POOR-MEDIUM-VG': 7.05,
    'I-IF-EX-VG-FAINT-GOOD': 7.05,
    'I-IF-GOOD-GOOD-FAINT-VG': 7.05,
    'I-IF-VG-EX-FAINT-GOOD': 7.05,
    'I-IF-VG-POOR-FAINT-VG': 7.05,
    'I-IF-POOR-VG-FAINT-VG': 7.05,
    'J-IF-POOR-VG-NONE-VG': 7.05,
    'J-IF-VG-EX-NONE-GOOD': 7.05,
    'J-IF-VG-POOR-NONE-VG': 7.05,
    'J-IF-EX-VG-NONE-GOOD': 7.05,
    'J-IF-GOOD-GOOD-NONE-VG': 7.05,
    'L-IF-VG-GOOD-STRONG-EX': 7.05,
    'L-IF-GOOD-VG-STRONG-EX': 7.05,
    'L-IF-EX-EX-STRONG-VG': 7.05,
    'L-IF-EX-POOR-STRONG-EX': 7.05,
    'L-IF-POOR-EX-STRONG-EX': 7.05,
    'M-IF-POOR-EX-MEDIUM-EX': 7.05,
    'M-IF-GOOD-VG-MEDIUM-EX': 7.05,
    'M-IF-VG-GOOD-MEDIUM-EX': 7.05,
    'M-IF-EX-POOR-MEDIUM-EX': 7.05,
    'M-IF-EX-EX-MEDIUM-VG': 7.05,
    'D-SI1-EX-GOOD-STRONG-VG': 7.04,
    'D-I1-EX-VG-MEDIUM-VG': 7.04,
    'D-I1-VG-POOR-MEDIUM-EX': 7.04,
    'D-I1-VG-EX-MEDIUM-VG': 7.04,
    'D-I1-POOR-VG-MEDIUM-EX': 7.04,
    'D-SI1-POOR-GOOD-STRONG-EX': 7.04,
    'D-SI1-GOOD-POOR-STRONG-EX': 7.04,
    'D-I1-GOOD-GOOD-MEDIUM-EX': 7.04,
    'D-SI1-GOOD-EX-STRONG-VG': 7.04,
    'D-SI1-VG-VG-STRONG-VG': 7.04,
    'E-SI1-GOOD-EX-MEDIUM-VG': 7.04,
    'E-I1-VG-EX-FAINT-VG': 7.04,
    'E-SI1-VG-VG-MEDIUM-VG': 7.04,
    'E-I1-VG-POOR-FAINT-EX': 7.04,
    'E-SI1-EX-GOOD-MEDIUM-VG': 7.04,
    'E-SI1-GOOD-POOR-MEDIUM-EX': 7.04,
    'E-I1-POOR-VG-FAINT-EX': 7.04,
    'E-I1-EX-VG-FAINT-VG': 7.04,
    'E-I1-GOOD-GOOD-FAINT-EX': 7.04,
    'E-SI1-POOR-GOOD-MEDIUM-EX': 7.04,
    'F-I1-POOR-VG-NONE-EX': 7.04,
    'F-SI1-VG-VG-FAINT-VG': 7.04,
    'F-SI1-GOOD-EX-FAINT-VG': 7.04,
    'F-SI1-GOOD-POOR-FAINT-EX': 7.04,
    'F-I1-VG-POOR-NONE-EX': 7.04,
    'F-SI1-POOR-GOOD-FAINT-EX': 7.04,
    'F-I1-GOOD-GOOD-NONE-EX': 7.04,
    'F-SI1-EX-GOOD-FAINT-VG': 7.04,
    'F-I1-VG-EX-NONE-VG': 7.04,
    'F-I1-EX-VG-NONE-VG': 7.04,
    'G-SI1-POOR-GOOD-NONE-EX': 7.04,
    'G-SI1-VG-VG-NONE-VG': 7.04,
    'G-SI1-GOOD-POOR-NONE-EX': 7.04,
    'G-SI1-EX-GOOD-NONE-VG': 7.04,
    'G-SI1-GOOD-EX-NONE-VG': 7.04,
    'H-I1-EX-EX-STRONG-EX': 7.04,
    'I-SI1-VG-EX-STRONG-EX': 7.04,
    'I-SI1-EX-VG-STRONG-EX': 7.04,
    'I-I1-EX-EX-MEDIUM-EX': 7.04,
    'J-SI1-VG-EX-MEDIUM-EX': 7.04,
    'J-I1-EX-EX-FAINT-EX': 7.04,
    'J-SI1-EX-VG-MEDIUM-EX': 7.04,
    'K-I1-EX-EX-NONE-EX': 7.04,
    'K-SI1-EX-VG-FAINT-EX': 7.04,
    'K-SI1-VG-EX-FAINT-EX': 7.04,
    'L-SI1-VG-EX-NONE-EX': 7.04,
    'L-SI1-EX-VG-NONE-EX': 7.04,
    'D-VVS1-VG-VG-NONE-POOR': 7.03,
    'D-VVS1-EX-GOOD-NONE-POOR': 7.03,
    'D-VVS1-GOOD-EX-NONE-POOR': 7.03,
    'D-VVS1-POOR-GOOD-NONE-GOOD': 7.03,
    'D-VVS1-GOOD-POOR-NONE-GOOD': 7.03,
    'E-VS1-POOR-EX-STRONG-VG': 7.03,
    'E-VS1-EX-POOR-STRONG-VG': 7.03,
    'E-VS1-EX-EX-STRONG-GOOD': 7.03,
    'E-VS1-VG-GOOD-STRONG-VG': 7.03,
    'E-VS1-GOOD-VG-STRONG-VG': 7.03,
    'E-VS1-POOR-POOR-STRONG-EX': 7.03,
    'F-VS1-POOR-POOR-MEDIUM-EX': 7.03,
    'F-VS1-POOR-EX-MEDIUM-VG': 7.03,
    'F-VVS1-VG-EX-STRONG-GOOD': 7.03,
    'F-VS1-GOOD-VG-MEDIUM-VG': 7.03,
    'F-VVS1-EX-VG-STRONG-GOOD': 7.03,
    'F-VVS1-VG-POOR-STRONG-VG': 7.03,
    'F-VS1-EX-POOR-MEDIUM-VG': 7.03,
    'F-VS1-EX-EX-MEDIUM-GOOD': 7.03,
    'F-VVS1-POOR-VG-STRONG-VG': 7.03,
    'F-VVS1-GOOD-GOOD-STRONG-VG': 7.03,
    'F-VS1-VG-GOOD-MEDIUM-VG': 7.03,
    'G-VVS1-VG-EX-MEDIUM-GOOD': 7.03,
    'G-VS1-EX-POOR-FAINT-VG': 7.03,
    'G-VS1-GOOD-VG-FAINT-VG': 7.03,
    'G-VVS1-EX-VG-MEDIUM-GOOD': 7.03,
    'G-VS1-POOR-POOR-FAINT-EX': 7.03,
    'G-VS1-VG-GOOD-FAINT-VG': 7.03,
    'G-VVS1-GOOD-GOOD-MEDIUM-VG': 7.03,
    'G-VS1-POOR-EX-FAINT-VG': 7.03,
    'G-VS1-EX-EX-FAINT-GOOD': 7.03,
    'G-VVS1-POOR-VG-MEDIUM-VG': 7.03,
    'G-VVS1-VG-POOR-MEDIUM-VG': 7.03,
    'H-VS1-GOOD-VG-NONE-VG': 7.03,
    'H-VS1-EX-POOR-NONE-VG': 7.03,
    'H-VS1-EX-EX-NONE-GOOD': 7.03,
    'H-VS1-POOR-POOR-NONE-EX': 7.03,
    'H-VS1-POOR-EX-NONE-VG': 7.03,
    'H-VS1-VG-GOOD-NONE-VG': 7.03,
    'H-VVS1-EX-VG-FAINT-GOOD': 7.03,
    'H-VVS1-POOR-VG-FAINT-VG': 7.03,
    'H-VVS1-GOOD-GOOD-FAINT-VG': 7.03,
    'H-VVS1-VG-POOR-FAINT-VG': 7.03,
    'H-VVS1-VG-EX-FAINT-GOOD': 7.03,
    'I-VVS1-POOR-VG-NONE-VG': 7.03,
    'I-VVS1-VG-POOR-NONE-VG': 7.03,
    'I-VVS1-VG-EX-NONE-GOOD': 7.03,
    'I-VVS1-GOOD-GOOD-NONE-VG': 7.03,
    'I-VVS1-EX-VG-NONE-GOOD': 7.03,
    'J-VS1-VG-VG-STRONG-EX': 7.03,
    'J-VS1-EX-GOOD-STRONG-EX': 7.03,
    'J-VS1-GOOD-EX-STRONG-EX': 7.03,
    'K-VS1-EX-GOOD-MEDIUM-EX': 7.03,
    'K-VS1-GOOD-EX-MEDIUM-EX': 7.03,
    'K-VS1-VG-VG-MEDIUM-EX': 7.03,
    'K-VVS1-POOR-EX-STRONG-EX': 7.03,
    'K-VVS1-GOOD-VG-STRONG-EX': 7.03,
    'K-VVS1-EX-POOR-STRONG-EX': 7.03,
    'K-VVS1-VG-GOOD-STRONG-EX': 7.03,
    'K-VVS1-EX-EX-STRONG-VG': 7.03,
    'L-VS1-VG-VG-FAINT-EX': 7.03,
    'L-VS1-GOOD-EX-FAINT-EX': 7.03,
    'L-VS1-EX-GOOD-FAINT-EX': 7.03,
    'L-VVS1-POOR-EX-MEDIUM-EX': 7.03,
    'L-VVS1-GOOD-VG-MEDIUM-EX': 7.03,
    'L-VVS1-EX-POOR-MEDIUM-EX': 7.03,
    'L-VVS1-EX-EX-MEDIUM-VG': 7.03,
    'L-VVS1-VG-GOOD-MEDIUM-EX': 7.03,
    'M-VVS1-EX-EX-FAINT-VG': 7.03,
    'M-VS1-EX-GOOD-NONE-EX': 7.03,
    'M-VVS1-EX-POOR-FAINT-EX': 7.03,
    'M-VVS1-VG-GOOD-FAINT-EX': 7.03,
    'M-VVS1-POOR-EX-FAINT-EX': 7.03,
    'M-VVS1-GOOD-VG-FAINT-EX': 7.03,
    'M-VS1-GOOD-EX-NONE-EX': 7.03,
    'M-VS1-VG-VG-NONE-EX': 7.03,
    'D-I2-EX-VG-FAINT-VG': 7.02,
    'D-SI2-POOR-GOOD-MEDIUM-EX': 7.02,
    'D-SI2-VG-VG-MEDIUM-VG': 7.02,
    'D-SI2-GOOD-POOR-MEDIUM-EX': 7.02,
    'D-I2-VG-POOR-FAINT-EX': 7.02,
    'D-SI2-EX-GOOD-MEDIUM-VG': 7.02,
    'D-I2-POOR-VG-FAINT-EX': 7.02,
    'D-SI2-GOOD-EX-MEDIUM-VG': 7.02,
    'D-I2-GOOD-GOOD-FAINT-EX': 7.02,
    'D-I2-VG-EX-FAINT-VG': 7.02,
    'E-I2-VG-EX-NONE-VG': 7.02,
    'E-I2-EX-VG-NONE-VG': 7.02,
    'E-I2-VG-POOR-NONE-EX': 7.02,
    'E-I2-POOR-VG-NONE-EX': 7.02,
    'E-SI2-GOOD-EX-FAINT-VG': 7.02,
    'E-SI2-VG-VG-FAINT-VG': 7.02,
    'E-SI2-GOOD-POOR-FAINT-EX': 7.02,
    'E-SI2-POOR-GOOD-FAINT-EX': 7.02,
    'E-I2-GOOD-GOOD-NONE-EX': 7.02,
    'E-SI2-EX-GOOD-FAINT-VG': 7.02,
    'F-SI2-GOOD-EX-NONE-VG': 7.02,
    'F-SI2-VG-VG-NONE-VG': 7.02,
    'F-SI2-POOR-GOOD-NONE-EX': 7.02,
    'F-SI2-GOOD-POOR-NONE-EX': 7.02,
    'F-SI2-EX-GOOD-NONE-VG': 7.02,
    'G-I2-EX-EX-STRONG-EX': 7.02,
    'H-SI2-EX-VG-STRONG-EX': 7.02,
    'H-I2-EX-EX-MEDIUM-EX': 7.02,
    'H-SI2-VG-EX-STRONG-EX': 7.02,
    'I-SI2-VG-EX-MEDIUM-EX': 7.02,
    'I-I2-EX-EX-FAINT-EX': 7.02,
    'I-SI2-EX-VG-MEDIUM-EX': 7.02,
    'J-I2-EX-EX-NONE-EX': 7.02,
    'J-SI2-VG-EX-FAINT-EX': 7.02,
    'J-SI2-EX-VG-FAINT-EX': 7.02,
    'K-SI2-VG-EX-NONE-EX': 7.02,
    'K-SI2-EX-VG-NONE-EX': 7.02,
    'D-VS2-POOR-POOR-STRONG-EX': 7.01,
    'D-VS2-VG-GOOD-STRONG-VG': 7.01,
    'D-VS2-POOR-EX-STRONG-VG': 7.01,
    'D-VS2-GOOD-VG-STRONG-VG': 7.01,
    'D-VS2-EX-POOR-STRONG-VG': 7.01,
    'D-VS2-EX-EX-STRONG-GOOD': 7.01,
    'E-VVS2-VG-POOR-STRONG-VG': 7.01,
    'E-VVS2-GOOD-GOOD-STRONG-VG': 7.01,
    'E-VVS2-EX-VG-STRONG-GOOD': 7.01,
    'E-VVS2-POOR-VG-STRONG-VG': 7.01,
    'E-VS2-POOR-POOR-MEDIUM-EX': 7.01,
    'E-VS2-EX-POOR-MEDIUM-VG': 7.01,
    'E-VS2-EX-EX-MEDIUM-GOOD': 7.01,
    'E-VS2-VG-GOOD-MEDIUM-VG': 7.01,
    'E-VS2-GOOD-VG-MEDIUM-VG': 7.01,
    'E-VS2-POOR-EX-MEDIUM-VG': 7.01,
    'E-VVS2-VG-EX-STRONG-GOOD': 7.01,
    'F-VS2-VG-GOOD-FAINT-VG': 7.01,
    'F-VS2-POOR-EX-FAINT-VG': 7.01,
    'F-VVS2-VG-POOR-MEDIUM-VG': 7.01,
    'F-VVS2-EX-VG-MEDIUM-GOOD': 7.01,
    'F-VS2-EX-EX-FAINT-GOOD': 7.01,
    'F-VVS2-VG-EX-MEDIUM-GOOD': 7.01,
    'F-VS2-EX-POOR-FAINT-VG': 7.01,
    'F-VS2-GOOD-VG-FAINT-VG': 7.01,
    'F-VS2-POOR-POOR-FAINT-EX': 7.01,
    'F-VVS2-GOOD-GOOD-MEDIUM-VG': 7.01,
    'F-VVS2-POOR-VG-MEDIUM-VG': 7.01,
    'G-VS2-POOR-POOR-NONE-EX': 7.01,
    'G-VS2-POOR-EX-NONE-VG': 7.01,
    'G-VVS2-VG-EX-FAINT-GOOD': 7.01,
    'G-VS2-VG-GOOD-NONE-VG': 7.01,
    'G-VVS2-VG-POOR-FAINT-VG': 7.01,
    'G-VS2-EX-POOR-NONE-VG': 7.01,
    'G-VVS2-EX-VG-FAINT-GOOD': 7.01,
    'G-VS2-GOOD-VG-NONE-VG': 7.01,
    'G-VVS2-GOOD-GOOD-FAINT-VG': 7.01,
    'G-VS2-EX-EX-NONE-GOOD': 7.01,
    'G-VVS2-POOR-VG-FAINT-VG': 7.01,
    'H-VVS2-GOOD-GOOD-NONE-VG': 7.01,
    'H-VVS2-VG-POOR-NONE-VG': 7.01,
    'H-VVS2-VG-EX-NONE-GOOD': 7.01,
    'H-VVS2-EX-VG-NONE-GOOD': 7.01,
    'H-VVS2-POOR-VG-NONE-VG': 7.01,
    'I-VS2-GOOD-EX-STRONG-EX': 7.01,
    'I-VS2-EX-GOOD-STRONG-EX': 7.01,
    'I-VS2-VG-VG-STRONG-EX': 7.01,
    'J-VS2-GOOD-EX-MEDIUM-EX': 7.01,
    'J-VVS2-POOR-EX-STRONG-EX': 7.01,
    'J-VVS2-GOOD-VG-STRONG-EX': 7.01,
    'J-VS2-VG-VG-MEDIUM-EX': 7.01,
    'J-VVS2-EX-EX-STRONG-VG': 7.01,
    'J-VVS2-VG-GOOD-STRONG-EX': 7.01,
    'J-VVS2-EX-POOR-STRONG-EX': 7.01,
    'J-VS2-EX-GOOD-MEDIUM-EX': 7.01,
    'K-VS2-VG-VG-FAINT-EX': 7.01,
    'K-VS2-GOOD-EX-FAINT-EX': 7.01,
    'K-VVS2-EX-POOR-MEDIUM-EX': 7.01,
    'K-VVS2-VG-GOOD-MEDIUM-EX': 7.01,
    'K-VVS2-EX-EX-MEDIUM-VG': 7.01,
    'K-VVS2-GOOD-VG-MEDIUM-EX': 7.01,
    'K-VVS2-POOR-EX-MEDIUM-EX': 7.01,
    'K-VS2-EX-GOOD-FAINT-EX': 7.01,
    'L-VVS2-POOR-EX-FAINT-EX': 7.01,
    'L-VVS2-VG-GOOD-FAINT-EX': 7.01,
    'L-VVS2-GOOD-VG-FAINT-EX': 7.01,
    'L-VVS2-EX-POOR-FAINT-EX': 7.01,
    'L-VVS2-EX-EX-FAINT-VG': 7.01,
    'L-VS2-EX-GOOD-NONE-EX': 7.01,
    'L-VS2-VG-VG-NONE-EX': 7.01,
    'L-VS2-GOOD-EX-NONE-EX': 7.01,
    'M-VVS2-EX-POOR-NONE-EX': 7.01,
    'M-VVS2-GOOD-VG-NONE-EX': 7.01,
    'M-VVS2-VG-GOOD-NONE-EX': 7.01,
    'M-VVS2-EX-EX-NONE-VG': 7.01,
    'M-VVS2-POOR-EX-NONE-EX': 7.01,
    'D-IF-GOOD-VG-NONE-POOR': 7,
    'D-IF-POOR-EX-NONE-POOR': 7,
    'D-IF-POOR-POOR-NONE-GOOD': 7,
    'D-IF-VG-GOOD-NONE-POOR': 7,
    'D-IF-EX-POOR-NONE-POOR': 7,
    'F-IF-GOOD-POOR-STRONG-VG': 7,
    'F-IF-POOR-GOOD-STRONG-VG': 7,
    'F-IF-EX-GOOD-STRONG-GOOD': 7,
    'F-IF-VG-VG-STRONG-GOOD': 7,
    'F-IF-GOOD-EX-STRONG-GOOD': 7,
    'G-IF-GOOD-POOR-MEDIUM-VG': 7,
    'G-IF-POOR-GOOD-MEDIUM-VG': 7,
    'G-IF-VG-VG-MEDIUM-GOOD': 7,
    'G-IF-GOOD-EX-MEDIUM-GOOD': 7,
    'G-IF-EX-GOOD-MEDIUM-GOOD': 7,
    'H-IF-VG-VG-FAINT-GOOD': 7,
    'H-IF-POOR-GOOD-FAINT-VG': 7,
    'H-IF-GOOD-POOR-FAINT-VG': 7,
    'H-IF-EX-GOOD-FAINT-GOOD': 7,
    'H-IF-GOOD-EX-FAINT-GOOD': 7,
    'I-IF-POOR-GOOD-NONE-VG': 7,
    'I-IF-EX-GOOD-NONE-GOOD': 7,
    'I-IF-GOOD-EX-NONE-GOOD': 7,
    'I-IF-GOOD-POOR-NONE-VG': 7,
    'I-IF-VG-VG-NONE-GOOD': 7,
    'K-IF-GOOD-GOOD-STRONG-EX': 7,
    'K-IF-POOR-VG-STRONG-EX': 7,
    'K-IF-EX-VG-STRONG-VG': 7,
    'K-IF-VG-POOR-STRONG-EX': 7,
    'K-IF-VG-EX-STRONG-VG': 7,
    'L-IF-EX-VG-MEDIUM-VG': 7,
    'L-IF-VG-EX-MEDIUM-VG': 7,
    'L-IF-GOOD-GOOD-MEDIUM-EX': 7,
    'L-IF-POOR-VG-MEDIUM-EX': 7,
    'L-IF-VG-POOR-MEDIUM-EX': 7,
    'M-IF-EX-VG-FAINT-VG': 7,
    'M-IF-VG-EX-FAINT-VG': 7,
    'M-IF-VG-POOR-FAINT-EX': 7,
    'M-IF-GOOD-GOOD-FAINT-EX': 7,
    'M-IF-POOR-VG-FAINT-EX': 7,
    'D-I1-VG-VG-FAINT-VG': 6.99,
    'D-SI1-POOR-EX-MEDIUM-VG': 6.99,
    'D-SI1-POOR-POOR-MEDIUM-EX': 6.99,
    'D-I1-GOOD-POOR-FAINT-EX': 6.99,
    'D-SI1-GOOD-VG-MEDIUM-VG': 6.99,
    'D-I1-EX-GOOD-FAINT-VG': 6.99,
    'D-I1-GOOD-EX-FAINT-VG': 6.99,
    'D-SI1-EX-EX-MEDIUM-GOOD': 6.99,
    'D-SI1-EX-POOR-MEDIUM-VG': 6.99,
    'D-I1-POOR-GOOD-FAINT-EX': 6.99,
    'D-SI1-VG-GOOD-MEDIUM-VG': 6.99,
    'E-I1-GOOD-EX-NONE-VG': 6.99,
    'E-I1-EX-GOOD-NONE-VG': 6.99,
    'E-SI1-EX-POOR-FAINT-VG': 6.99,
    'E-SI1-GOOD-VG-FAINT-VG': 6.99,
    'E-I1-VG-VG-NONE-VG': 6.99,
    'E-SI1-EX-EX-FAINT-GOOD': 6.99,
    'E-SI1-POOR-POOR-FAINT-EX': 6.99,
    'E-I1-POOR-GOOD-NONE-EX': 6.99,
    'E-SI1-VG-GOOD-FAINT-VG': 6.99,
    'E-SI1-POOR-EX-FAINT-VG': 6.99,
    'E-I1-GOOD-POOR-NONE-EX': 6.99,
    'F-SI1-EX-POOR-NONE-VG': 6.99,
    'F-SI1-VG-GOOD-NONE-VG': 6.99,
    'F-SI1-EX-EX-NONE-GOOD': 6.99,
    'F-SI1-GOOD-VG-NONE-VG': 6.99,
    'F-SI1-POOR-POOR-NONE-EX': 6.99,
    'F-SI1-POOR-EX-NONE-VG': 6.99,
    'G-I1-EX-VG-STRONG-EX': 6.99,
    'G-I1-VG-EX-STRONG-EX': 6.99,
    'H-SI1-EX-GOOD-STRONG-EX': 6.99,
    'H-I1-VG-EX-MEDIUM-EX': 6.99,
    'H-I1-EX-VG-MEDIUM-EX': 6.99,
    'H-SI1-GOOD-EX-STRONG-EX': 6.99,
    'H-SI1-VG-VG-STRONG-EX': 6.99,
    'I-SI1-GOOD-EX-MEDIUM-EX': 6.99,
    'I-SI1-EX-GOOD-MEDIUM-EX': 6.99,
    'I-SI1-VG-VG-MEDIUM-EX': 6.99,
    'I-I1-EX-VG-FAINT-EX': 6.99,
    'I-I1-VG-EX-FAINT-EX': 6.99,
    'J-SI1-VG-VG-FAINT-EX': 6.99,
    'J-I1-EX-VG-NONE-EX': 6.99,
    'J-SI1-GOOD-EX-FAINT-EX': 6.99,
    'J-I1-VG-EX-NONE-EX': 6.99,
    'J-SI1-EX-GOOD-FAINT-EX': 6.99,
    'K-SI1-GOOD-EX-NONE-EX': 6.99,
    'K-SI1-VG-VG-NONE-EX': 6.99,
    'K-SI1-EX-GOOD-NONE-EX': 6.99,
    'D-VS1-VG-POOR-STRONG-VG': 6.98,
    'D-VS1-VG-EX-STRONG-GOOD': 6.98,
    'D-VS1-POOR-VG-STRONG-VG': 6.98,
    'D-VS1-GOOD-GOOD-STRONG-VG': 6.98,
    'D-VS1-EX-VG-STRONG-GOOD': 6.98,
    'E-VS1-POOR-VG-MEDIUM-VG': 6.98,
    'E-VS1-GOOD-GOOD-MEDIUM-VG': 6.98,
    'E-VVS1-GOOD-POOR-STRONG-VG': 6.98,
    'E-VVS1-GOOD-EX-STRONG-GOOD': 6.98,
    'E-VS1-EX-VG-MEDIUM-GOOD': 6.98,
    'E-VVS1-EX-GOOD-STRONG-GOOD': 6.98,
    'E-VS1-VG-EX-MEDIUM-GOOD': 6.98,
    'E-VVS1-VG-VG-STRONG-GOOD': 6.98,
    'E-VVS1-POOR-GOOD-STRONG-VG': 6.98,
    'E-VS1-VG-POOR-MEDIUM-VG': 6.98,
    'F-VVS1-EX-GOOD-MEDIUM-GOOD': 6.98,
    'F-VS1-GOOD-GOOD-FAINT-VG': 6.98,
    'F-VS1-POOR-VG-FAINT-VG': 6.98,
    'F-VVS1-POOR-GOOD-MEDIUM-VG': 6.98,
    'F-VVS1-GOOD-EX-MEDIUM-GOOD': 6.98,
    'F-VVS1-VG-VG-MEDIUM-GOOD': 6.98,
    'F-VVS1-GOOD-POOR-MEDIUM-VG': 6.98,
    'F-VS1-VG-EX-FAINT-GOOD': 6.98,
    'F-VS1-VG-POOR-FAINT-VG': 6.98,
    'F-VS1-EX-VG-FAINT-GOOD': 6.98,
    'G-VS1-POOR-VG-NONE-VG': 6.98,
    'G-VS1-VG-EX-NONE-GOOD': 6.98,
    'G-VS1-EX-VG-NONE-GOOD': 6.98,
    'G-VS1-GOOD-GOOD-NONE-VG': 6.98,
    'G-VVS1-POOR-GOOD-FAINT-VG': 6.98,
    'G-VVS1-GOOD-POOR-FAINT-VG': 6.98,
    'G-VVS1-GOOD-EX-FAINT-GOOD': 6.98,
    'G-VVS1-VG-VG-FAINT-GOOD': 6.98,
    'G-VVS1-EX-GOOD-FAINT-GOOD': 6.98,
    'G-VS1-VG-POOR-NONE-VG': 6.98,
    'H-VVS1-POOR-GOOD-NONE-VG': 6.98,
    'H-VVS1-EX-GOOD-NONE-GOOD': 6.98,
    'H-VVS1-VG-VG-NONE-GOOD': 6.98,
    'H-VVS1-GOOD-EX-NONE-GOOD': 6.98,
    'H-VVS1-GOOD-POOR-NONE-VG': 6.98,
    'I-VS1-GOOD-VG-STRONG-EX': 6.98,
    'I-VS1-POOR-EX-STRONG-EX': 6.98,
    'I-VS1-EX-POOR-STRONG-EX': 6.98,
    'I-VS1-EX-EX-STRONG-VG': 6.98,
    'I-VS1-VG-GOOD-STRONG-EX': 6.98,
    'J-VVS1-VG-EX-STRONG-VG': 6.98,
    'J-VVS1-EX-VG-STRONG-VG': 6.98,
    'J-VVS1-VG-POOR-STRONG-EX': 6.98,
    'J-VVS1-GOOD-GOOD-STRONG-EX': 6.98,
    'J-VS1-EX-POOR-MEDIUM-EX': 6.98,
    'J-VS1-POOR-EX-MEDIUM-EX': 6.98,
    'J-VS1-EX-EX-MEDIUM-VG': 6.98,
    'J-VVS1-POOR-VG-STRONG-EX': 6.98,
    'J-VS1-GOOD-VG-MEDIUM-EX': 6.98,
    'J-VS1-VG-GOOD-MEDIUM-EX': 6.98,
    'K-VVS1-EX-VG-MEDIUM-VG': 6.98,
    'K-VVS1-VG-POOR-MEDIUM-EX': 6.98,
    'K-VVS1-VG-EX-MEDIUM-VG': 6.98,
    'K-VVS1-POOR-VG-MEDIUM-EX': 6.98,
    'K-VS1-POOR-EX-FAINT-EX': 6.98,
    'K-VS1-EX-EX-FAINT-VG': 6.98,
    'K-VS1-EX-POOR-FAINT-EX': 6.98,
    'K-VVS1-GOOD-GOOD-MEDIUM-EX': 6.98,
    'K-VS1-VG-GOOD-FAINT-EX': 6.98,
    'K-VS1-GOOD-VG-FAINT-EX': 6.98,
    'L-VVS1-EX-VG-FAINT-VG': 6.98,
    'L-VVS1-VG-POOR-FAINT-EX': 6.98,
    'L-VVS1-VG-EX-FAINT-VG': 6.98,
    'L-VVS1-GOOD-GOOD-FAINT-EX': 6.98,
    'L-VS1-EX-POOR-NONE-EX': 6.98,
    'L-VS1-VG-GOOD-NONE-EX': 6.98,
    'L-VS1-GOOD-VG-NONE-EX': 6.98,
    'L-VS1-POOR-EX-NONE-EX': 6.98,
    'L-VS1-EX-EX-NONE-VG': 6.98,
    'L-VVS1-POOR-VG-FAINT-EX': 6.98,
    'M-VVS1-VG-EX-NONE-VG': 6.98,
    'M-VVS1-VG-POOR-NONE-EX': 6.98,
    'M-VVS1-POOR-VG-NONE-EX': 6.98,
    'M-VVS1-EX-VG-NONE-VG': 6.98,
    'M-VVS1-GOOD-GOOD-NONE-EX': 6.98,
    'D-I2-VG-VG-NONE-VG': 6.97,
    'D-SI2-POOR-POOR-FAINT-EX': 6.97,
    'D-SI2-EX-EX-FAINT-GOOD': 6.97,
    'D-SI2-POOR-EX-FAINT-VG': 6.97,
    'D-I2-EX-GOOD-NONE-VG': 6.97,
    'D-SI2-GOOD-VG-FAINT-VG': 6.97,
    'D-I2-POOR-GOOD-NONE-EX': 6.97,
    'D-I2-GOOD-POOR-NONE-EX': 6.97,
    'D-I2-GOOD-EX-NONE-VG': 6.97,
    'D-SI2-EX-POOR-FAINT-VG': 6.97,
    'D-SI2-VG-GOOD-FAINT-VG': 6.97,
    'E-SI2-EX-EX-NONE-GOOD': 6.97,
    'E-SI2-VG-GOOD-NONE-VG': 6.97,
    'E-SI2-POOR-POOR-NONE-EX': 6.97,
    'E-SI2-POOR-EX-NONE-VG': 6.97,
    'E-SI2-GOOD-VG-NONE-VG': 6.97,
    'E-SI2-EX-POOR-NONE-VG': 6.97,
    'F-I2-VG-EX-STRONG-EX': 6.97,
    'F-I2-EX-VG-STRONG-EX': 6.97,
    'G-SI2-VG-VG-STRONG-EX': 6.97,
    'G-SI2-GOOD-EX-STRONG-EX': 6.97,
    'G-I2-VG-EX-MEDIUM-EX': 6.97,
    'G-I2-EX-VG-MEDIUM-EX': 6.97,
    'G-SI2-EX-GOOD-STRONG-EX': 6.97,
    'H-I2-VG-EX-FAINT-EX': 6.97,
    'H-I2-EX-VG-FAINT-EX': 6.97,
    'H-SI2-GOOD-EX-MEDIUM-EX': 6.97,
    'H-SI2-VG-VG-MEDIUM-EX': 6.97,
    'H-SI2-EX-GOOD-MEDIUM-EX': 6.97,
    'I-SI2-EX-GOOD-FAINT-EX': 6.97,
    'I-I2-VG-EX-NONE-EX': 6.97,
    'I-SI2-VG-VG-FAINT-EX': 6.97,
    'I-I2-EX-VG-NONE-EX': 6.97,
    'I-SI2-GOOD-EX-FAINT-EX': 6.97,
    'J-SI2-EX-GOOD-NONE-EX': 6.97,
    'J-SI2-VG-VG-NONE-EX': 6.97,
    'J-SI2-GOOD-EX-NONE-EX': 6.97,
    'D-VS2-POOR-VG-MEDIUM-VG': 6.96,
    'D-VS2-GOOD-GOOD-MEDIUM-VG': 6.96,
    'D-VVS2-POOR-GOOD-STRONG-VG': 6.96,
    'D-VVS2-GOOD-EX-STRONG-GOOD': 6.96,
    'D-VS2-VG-POOR-MEDIUM-VG': 6.96,
    'D-VVS2-EX-GOOD-STRONG-GOOD': 6.96,
    'D-VVS2-VG-VG-STRONG-GOOD': 6.96,
    'D-VS2-EX-VG-MEDIUM-GOOD': 6.96,
    'D-VS2-VG-EX-MEDIUM-GOOD': 6.96,
    'D-VVS2-GOOD-POOR-STRONG-VG': 6.96,
    'E-VVS2-POOR-GOOD-MEDIUM-VG': 6.96,
    'E-VVS2-GOOD-EX-MEDIUM-GOOD': 6.96,
    'E-VVS2-EX-GOOD-MEDIUM-GOOD': 6.96,
    'E-VVS2-GOOD-POOR-MEDIUM-VG': 6.96,
    'E-VS2-EX-VG-FAINT-GOOD': 6.96,
    'E-VVS2-VG-VG-MEDIUM-GOOD': 6.96,
    'E-VS2-POOR-VG-FAINT-VG': 6.96,
    'E-VS2-VG-EX-FAINT-GOOD': 6.96,
    'E-VS2-VG-POOR-FAINT-VG': 6.96,
    'E-VS2-GOOD-GOOD-FAINT-VG': 6.96,
    'F-VS2-VG-EX-NONE-GOOD': 6.96,
    'F-VVS2-GOOD-EX-FAINT-GOOD': 6.96,
    'F-VVS2-VG-VG-FAINT-GOOD': 6.96,
    'F-VVS2-EX-GOOD-FAINT-GOOD': 6.96,
    'F-VS2-EX-VG-NONE-GOOD': 6.96,
    'F-VS2-VG-POOR-NONE-VG': 6.96,
    'F-VVS2-GOOD-POOR-FAINT-VG': 6.96,
    'F-VVS2-POOR-GOOD-FAINT-VG': 6.96,
    'F-VS2-POOR-VG-NONE-VG': 6.96,
    'F-VS2-GOOD-GOOD-NONE-VG': 6.96,
    'G-VVS2-VG-VG-NONE-GOOD': 6.96,
    'G-VVS2-GOOD-EX-NONE-GOOD': 6.96,
    'G-VVS2-EX-GOOD-NONE-GOOD': 6.96,
    'G-VVS2-POOR-GOOD-NONE-VG': 6.96,
    'G-VVS2-GOOD-POOR-NONE-VG': 6.96,
    'H-VS2-POOR-EX-STRONG-EX': 6.96,
    'H-VS2-EX-EX-STRONG-VG': 6.96,
    'H-VS2-EX-POOR-STRONG-EX': 6.96,
    'H-VS2-VG-GOOD-STRONG-EX': 6.96,
    'H-VS2-GOOD-VG-STRONG-EX': 6.96,
    'I-VVS2-GOOD-GOOD-STRONG-EX': 6.96,
    'I-VVS2-VG-EX-STRONG-VG': 6.96,
    'I-VVS2-VG-POOR-STRONG-EX': 6.96,
    'I-VVS2-EX-VG-STRONG-VG': 6.96,
    'I-VVS2-POOR-VG-STRONG-EX': 6.96,
    'I-VS2-EX-POOR-MEDIUM-EX': 6.96,
    'I-VS2-GOOD-VG-MEDIUM-EX': 6.96,
    'I-VS2-POOR-EX-MEDIUM-EX': 6.96,
    'I-VS2-VG-GOOD-MEDIUM-EX': 6.96,
    'I-VS2-EX-EX-MEDIUM-VG': 6.96,
    'J-VS2-EX-EX-FAINT-VG': 6.96,
    'J-VVS2-EX-VG-MEDIUM-VG': 6.96,
    'J-VS2-EX-POOR-FAINT-EX': 6.96,
    'J-VVS2-VG-EX-MEDIUM-VG': 6.96,
    'J-VS2-GOOD-VG-FAINT-EX': 6.96,
    'J-VS2-VG-GOOD-FAINT-EX': 6.96,
    'J-VVS2-POOR-VG-MEDIUM-EX': 6.96,
    'J-VS2-POOR-EX-FAINT-EX': 6.96,
    'J-VVS2-VG-POOR-MEDIUM-EX': 6.96,
    'J-VVS2-GOOD-GOOD-MEDIUM-EX': 6.96,
    'K-VS2-VG-GOOD-NONE-EX': 6.96,
    'K-VS2-EX-POOR-NONE-EX': 6.96,
    'K-VS2-EX-EX-NONE-VG': 6.96,
    'K-VVS2-EX-VG-FAINT-VG': 6.96,
    'K-VVS2-VG-EX-FAINT-VG': 6.96,
    'K-VS2-POOR-EX-NONE-EX': 6.96,
    'K-VS2-GOOD-VG-NONE-EX': 6.96,
    'K-VVS2-VG-POOR-FAINT-EX': 6.96,
    'K-VVS2-GOOD-GOOD-FAINT-EX': 6.96,
    'K-VVS2-POOR-VG-FAINT-EX': 6.96,
    'L-VVS2-EX-VG-NONE-VG': 6.96,
    'L-VVS2-VG-EX-NONE-VG': 6.96,
    'L-VVS2-POOR-VG-NONE-EX': 6.96,
    'L-VVS2-GOOD-GOOD-NONE-EX': 6.96,
    'L-VVS2-VG-POOR-NONE-EX': 6.96,
    'E-IF-EX-EX-STRONG-POOR': 6.95,
    'E-IF-EX-POOR-STRONG-GOOD': 6.95,
    'E-IF-VG-GOOD-STRONG-GOOD': 6.95,
    'E-IF-GOOD-VG-STRONG-GOOD': 6.95,
    'E-IF-POOR-EX-STRONG-GOOD': 6.95,
    'E-IF-POOR-POOR-STRONG-VG': 6.95,
    'F-IF-VG-GOOD-MEDIUM-GOOD': 6.95,
    'F-IF-POOR-POOR-MEDIUM-VG': 6.95,
    'F-IF-POOR-EX-MEDIUM-GOOD': 6.95,
    'F-IF-GOOD-VG-MEDIUM-GOOD': 6.95,
    'F-IF-EX-EX-MEDIUM-POOR': 6.95,
    'F-IF-EX-POOR-MEDIUM-GOOD': 6.95,
    'G-IF-EX-EX-FAINT-POOR': 6.95,
    'G-IF-EX-POOR-FAINT-GOOD': 6.95,
    'G-IF-VG-GOOD-FAINT-GOOD': 6.95,
    'G-IF-GOOD-VG-FAINT-GOOD': 6.95,
    'G-IF-POOR-EX-FAINT-GOOD': 6.95,
    'G-IF-POOR-POOR-FAINT-VG': 6.95,
    'H-IF-POOR-EX-NONE-GOOD': 6.95,
    'H-IF-GOOD-VG-NONE-GOOD': 6.95,
    'H-IF-VG-GOOD-NONE-GOOD': 6.95,
    'H-IF-EX-EX-NONE-POOR': 6.95,
    'H-IF-POOR-POOR-NONE-VG': 6.95,
    'H-IF-EX-POOR-NONE-GOOD': 6.95,
    'J-IF-POOR-GOOD-STRONG-EX': 6.95,
    'J-IF-EX-GOOD-STRONG-VG': 6.95,
    'J-IF-VG-VG-STRONG-VG': 6.95,
    'J-IF-GOOD-EX-STRONG-VG': 6.95,
    'J-IF-GOOD-POOR-STRONG-EX': 6.95,
    'K-IF-GOOD-EX-MEDIUM-VG': 6.95,
    'K-IF-EX-GOOD-MEDIUM-VG': 6.95,
    'K-IF-VG-VG-MEDIUM-VG': 6.95,
    'K-IF-POOR-GOOD-MEDIUM-EX': 6.95,
    'K-IF-GOOD-POOR-MEDIUM-EX': 6.95,
    'L-IF-EX-GOOD-FAINT-VG': 6.95,
    'L-IF-POOR-GOOD-FAINT-EX': 6.95,
    'L-IF-GOOD-POOR-FAINT-EX': 6.95,
    'L-IF-VG-VG-FAINT-VG': 6.95,
    'L-IF-GOOD-EX-FAINT-VG': 6.95,
    'M-IF-GOOD-POOR-NONE-EX': 6.95,
    'M-IF-EX-GOOD-NONE-VG': 6.95,
    'M-IF-VG-VG-NONE-VG': 6.95,
    'M-IF-GOOD-EX-NONE-VG': 6.95,
    'M-IF-POOR-GOOD-NONE-EX': 6.95,
    'D-I1-POOR-EX-NONE-VG': 6.94,
    'D-I1-POOR-POOR-NONE-EX': 6.94,
    'D-I1-EX-EX-NONE-GOOD': 6.94,
    'D-I1-GOOD-VG-NONE-VG': 6.94,
    'D-I1-VG-GOOD-NONE-VG': 6.94,
    'D-I1-EX-POOR-NONE-VG': 6.94,
    'D-SI1-VG-EX-FAINT-GOOD': 6.94,
    'D-SI1-EX-VG-FAINT-GOOD': 6.94,
    'D-SI1-VG-POOR-FAINT-VG': 6.94,
    'D-SI1-GOOD-GOOD-FAINT-VG': 6.94,
    'D-SI1-POOR-VG-FAINT-VG': 6.94,
    'E-SI1-VG-POOR-NONE-VG': 6.94,
    'E-SI1-GOOD-GOOD-NONE-VG': 6.94,
    'E-SI1-POOR-VG-NONE-VG': 6.94,
    'E-SI1-VG-EX-NONE-GOOD': 6.94,
    'E-SI1-EX-VG-NONE-GOOD': 6.94,
    'F-I1-EX-GOOD-STRONG-EX': 6.94,
    'F-I1-GOOD-EX-STRONG-EX': 6.94,
    'F-I1-VG-VG-STRONG-EX': 6.94,
    'G-I1-GOOD-EX-MEDIUM-EX': 6.94,
    'G-I1-VG-VG-MEDIUM-EX': 6.94,
    'G-SI1-VG-GOOD-STRONG-EX': 6.94,
    'G-SI1-EX-POOR-STRONG-EX': 6.94,
    'G-SI1-GOOD-VG-STRONG-EX': 6.94,
    'G-SI1-POOR-EX-STRONG-EX': 6.94,
    'G-SI1-EX-EX-STRONG-VG': 6.94,
    'G-I1-EX-GOOD-MEDIUM-EX': 6.94,
    'H-SI1-EX-EX-MEDIUM-VG': 6.94,
    'H-SI1-GOOD-VG-MEDIUM-EX': 6.94,
    'H-I1-EX-GOOD-FAINT-EX': 6.94,
    'H-SI1-POOR-EX-MEDIUM-EX': 6.94,
    'H-SI1-VG-GOOD-MEDIUM-EX': 6.94,
    'H-I1-VG-VG-FAINT-EX': 6.94,
    'H-SI1-EX-POOR-MEDIUM-EX': 6.94,
    'H-I1-GOOD-EX-FAINT-EX': 6.94,
    'I-SI1-EX-EX-FAINT-VG': 6.94,
    'I-SI1-GOOD-VG-FAINT-EX': 6.94,
    'I-SI1-POOR-EX-FAINT-EX': 6.94,
    'I-SI1-VG-GOOD-FAINT-EX': 6.94,
    'I-I1-GOOD-EX-NONE-EX': 6.94,
    'I-I1-EX-GOOD-NONE-EX': 6.94,
    'I-I1-VG-VG-NONE-EX': 6.94,
    'I-SI1-EX-POOR-FAINT-EX': 6.94,
    'J-SI1-EX-POOR-NONE-EX': 6.94,
    'J-SI1-EX-EX-NONE-VG': 6.94,
    'J-SI1-VG-GOOD-NONE-EX': 6.94,
    'J-SI1-POOR-EX-NONE-EX': 6.94,
    'J-SI1-GOOD-VG-NONE-EX': 6.94,
    'D-VVS1-GOOD-VG-STRONG-GOOD': 6.93,
    'D-VS1-GOOD-POOR-MEDIUM-VG': 6.93,
    'D-VS1-EX-GOOD-MEDIUM-GOOD': 6.93,
    'D-VVS1-POOR-POOR-STRONG-VG': 6.93,
    'D-VS1-VG-VG-MEDIUM-GOOD': 6.93,
    'D-VS1-GOOD-EX-MEDIUM-GOOD': 6.93,
    'D-VS1-POOR-GOOD-MEDIUM-VG': 6.93,
    'D-VVS1-VG-GOOD-STRONG-GOOD': 6.93,
    'D-VVS1-POOR-EX-STRONG-GOOD': 6.93,
    'D-VVS1-EX-POOR-STRONG-GOOD': 6.93,
    'D-VVS1-EX-EX-STRONG-POOR': 6.93,
    'E-VVS1-EX-EX-MEDIUM-POOR': 6.93,
    'E-VVS1-VG-GOOD-MEDIUM-GOOD': 6.93,
    'E-VVS1-GOOD-VG-MEDIUM-GOOD': 6.93,
    'E-VVS1-POOR-EX-MEDIUM-GOOD': 6.93,
    'E-VS1-GOOD-POOR-FAINT-VG': 6.93,
    'E-VVS1-POOR-POOR-MEDIUM-VG': 6.93,
    'E-VS1-GOOD-EX-FAINT-GOOD': 6.93,
    'E-VVS1-EX-POOR-MEDIUM-GOOD': 6.93,
    'E-VS1-EX-GOOD-FAINT-GOOD': 6.93,
    'E-VS1-VG-VG-FAINT-GOOD': 6.93,
    'E-VS1-POOR-GOOD-FAINT-VG': 6.93,
    'F-VVS1-POOR-POOR-FAINT-VG': 6.93,
    'F-VVS1-POOR-EX-FAINT-GOOD': 6.93,
    'F-VVS1-GOOD-VG-FAINT-GOOD': 6.93,
    'F-VS1-GOOD-POOR-NONE-VG': 6.93,
    'F-VVS1-EX-EX-FAINT-POOR': 6.93,
    'F-VS1-EX-GOOD-NONE-GOOD': 6.93,
    'F-VS1-VG-VG-NONE-GOOD': 6.93,
    'F-VS1-POOR-GOOD-NONE-VG': 6.93,
    'F-VS1-GOOD-EX-NONE-GOOD': 6.93,
    'F-VVS1-VG-GOOD-FAINT-GOOD': 6.93,
    'F-VVS1-EX-POOR-FAINT-GOOD': 6.93,
    'G-VVS1-POOR-EX-NONE-GOOD': 6.93,
    'G-VVS1-GOOD-VG-NONE-GOOD': 6.93,
    'G-VVS1-VG-GOOD-NONE-GOOD': 6.93,
    'G-VVS1-EX-POOR-NONE-GOOD': 6.93,
    'G-VVS1-EX-EX-NONE-POOR': 6.93,
    'G-VVS1-POOR-POOR-NONE-VG': 6.93,
    'H-VS1-EX-VG-STRONG-VG': 6.93,
    'H-VS1-VG-EX-STRONG-VG': 6.93,
    'H-VS1-VG-POOR-STRONG-EX': 6.93,
    'H-VS1-GOOD-GOOD-STRONG-EX': 6.93,
    'H-VS1-POOR-VG-STRONG-EX': 6.93,
    'I-VVS1-POOR-GOOD-STRONG-EX': 6.93,
    'I-VVS1-GOOD-POOR-STRONG-EX': 6.93,
    'I-VVS1-GOOD-EX-STRONG-VG': 6.93,
    'I-VVS1-VG-VG-STRONG-VG': 6.93,
    'I-VVS1-EX-GOOD-STRONG-VG': 6.93,
    'I-VS1-POOR-VG-MEDIUM-EX': 6.93,
    'I-VS1-GOOD-GOOD-MEDIUM-EX': 6.93,
    'I-VS1-VG-POOR-MEDIUM-EX': 6.93,
    'I-VS1-VG-EX-MEDIUM-VG': 6.93,
    'I-VS1-EX-VG-MEDIUM-VG': 6.93,
    'J-VVS1-VG-VG-MEDIUM-VG': 6.93,
    'J-VVS1-GOOD-EX-MEDIUM-VG': 6.93,
    'J-VS1-POOR-VG-FAINT-EX': 6.93,
    'J-VS1-GOOD-GOOD-FAINT-EX': 6.93,
    'J-VS1-VG-POOR-FAINT-EX': 6.93,
    'J-VS1-VG-EX-FAINT-VG': 6.93,
    'J-VS1-EX-VG-FAINT-VG': 6.93,
    'J-VVS1-EX-GOOD-MEDIUM-VG': 6.93,
    'J-VVS1-GOOD-POOR-MEDIUM-EX': 6.93,
    'J-VVS1-POOR-GOOD-MEDIUM-EX': 6.93,
    'K-VS1-EX-VG-NONE-VG': 6.93,
    'K-VS1-VG-EX-NONE-VG': 6.93,
    'K-VS1-VG-POOR-NONE-EX': 6.93,
    'K-VS1-GOOD-GOOD-NONE-EX': 6.93,
    'K-VS1-POOR-VG-NONE-EX': 6.93,
    'K-VVS1-GOOD-POOR-FAINT-EX': 6.93,
    'K-VVS1-POOR-GOOD-FAINT-EX': 6.93,
    'K-VVS1-GOOD-EX-FAINT-VG': 6.93,
    'K-VVS1-EX-GOOD-FAINT-VG': 6.93,
    'K-VVS1-VG-VG-FAINT-VG': 6.93,
    'L-VVS1-GOOD-EX-NONE-VG': 6.93,
    'L-VVS1-GOOD-POOR-NONE-EX': 6.93,
    'L-VVS1-EX-GOOD-NONE-VG': 6.93,
    'L-VVS1-VG-VG-NONE-VG': 6.93,
    'L-VVS1-POOR-GOOD-NONE-EX': 6.93,
    'M-VS1-EX-EX-STRONG-EX': 6.93,
    'D-SI2-EX-VG-NONE-GOOD': 6.92,
    'D-SI2-GOOD-GOOD-NONE-VG': 6.92,
    'D-SI2-POOR-VG-NONE-VG': 6.92,
    'D-SI2-VG-EX-NONE-GOOD': 6.92,
    'D-SI2-VG-POOR-NONE-VG': 6.92,
    'E-I2-EX-GOOD-STRONG-EX': 6.92,
    'E-I2-VG-VG-STRONG-EX': 6.92,
    'E-I2-GOOD-EX-STRONG-EX': 6.92,
    'F-SI2-GOOD-VG-STRONG-EX': 6.92,
    'F-SI2-POOR-EX-STRONG-EX': 6.92,
    'F-SI2-VG-GOOD-STRONG-EX': 6.92,
    'F-I2-GOOD-EX-MEDIUM-EX': 6.92,
    'F-I2-EX-GOOD-MEDIUM-EX': 6.92,
    'F-I2-VG-VG-MEDIUM-EX': 6.92,
    'F-SI2-EX-EX-STRONG-VG': 6.92,
    'F-SI2-EX-POOR-STRONG-EX': 6.92,
    'G-I2-EX-GOOD-FAINT-EX': 6.92,
    'G-SI2-VG-GOOD-MEDIUM-EX': 6.92,
    'G-I2-GOOD-EX-FAINT-EX': 6.92,
    'G-SI2-GOOD-VG-MEDIUM-EX': 6.92,
    'G-I2-VG-VG-FAINT-EX': 6.92,
    'G-SI2-POOR-EX-MEDIUM-EX': 6.92,
    'G-SI2-EX-POOR-MEDIUM-EX': 6.92,
    'G-SI2-EX-EX-MEDIUM-VG': 6.92,
    'H-SI2-EX-EX-FAINT-VG': 6.92,
    'H-I2-VG-VG-NONE-EX': 6.92,
    'H-SI2-EX-POOR-FAINT-EX': 6.92,
    'H-I2-GOOD-EX-NONE-EX': 6.92,
    'H-I2-EX-GOOD-NONE-EX': 6.92,
    'H-SI2-GOOD-VG-FAINT-EX': 6.92,
    'H-SI2-POOR-EX-FAINT-EX': 6.92,
    'H-SI2-VG-GOOD-FAINT-EX': 6.92,
    'I-SI2-POOR-EX-NONE-EX': 6.92,
    'I-SI2-EX-EX-NONE-VG': 6.92,
    'I-SI2-VG-GOOD-NONE-EX': 6.92,
    'I-SI2-EX-POOR-NONE-EX': 6.92,
    'I-SI2-GOOD-VG-NONE-EX': 6.92,
    'D-VS2-POOR-GOOD-FAINT-VG': 6.91,
    'D-VS2-GOOD-POOR-FAINT-VG': 6.91,
    'D-VVS2-POOR-POOR-MEDIUM-VG': 6.91,
    'D-VS2-VG-VG-FAINT-GOOD': 6.91,
    'D-VS2-GOOD-EX-FAINT-GOOD': 6.91,
    'D-VVS2-GOOD-VG-MEDIUM-GOOD': 6.91,
    'D-VVS2-EX-EX-MEDIUM-POOR': 6.91,
    'D-VVS2-POOR-EX-MEDIUM-GOOD': 6.91,
    'D-VS2-EX-GOOD-FAINT-GOOD': 6.91,
    'D-VVS2-VG-GOOD-MEDIUM-GOOD': 6.91,
    'D-VVS2-EX-POOR-MEDIUM-GOOD': 6.91,
    'E-VVS2-EX-POOR-FAINT-GOOD': 6.91,
    'E-VS2-EX-GOOD-NONE-GOOD': 6.91,
    'E-VVS2-POOR-POOR-FAINT-VG': 6.91,
    'E-VS2-POOR-GOOD-NONE-VG': 6.91,
    'E-VS2-GOOD-POOR-NONE-VG': 6.91,
    'E-VS2-GOOD-EX-NONE-GOOD': 6.91,
    'E-VVS2-EX-EX-FAINT-POOR': 6.91,
    'E-VS2-VG-VG-NONE-GOOD': 6.91,
    'E-VVS2-VG-GOOD-FAINT-GOOD': 6.91,
    'E-VVS2-POOR-EX-FAINT-GOOD': 6.91,
    'E-VVS2-GOOD-VG-FAINT-GOOD': 6.91,
    'F-VVS2-GOOD-VG-NONE-GOOD': 6.91,
    'F-VVS2-VG-GOOD-NONE-GOOD': 6.91,
    'F-VVS2-POOR-POOR-NONE-VG': 6.91,
    'F-VVS2-POOR-EX-NONE-GOOD': 6.91,
    'F-VVS2-EX-POOR-NONE-GOOD': 6.91,
    'F-VVS2-EX-EX-NONE-POOR': 6.91,
    'G-VS2-EX-VG-STRONG-VG': 6.91,
    'G-VS2-POOR-VG-STRONG-EX': 6.91,
    'G-VS2-GOOD-GOOD-STRONG-EX': 6.91,
    'G-VS2-VG-EX-STRONG-VG': 6.91,
    'G-VS2-VG-POOR-STRONG-EX': 6.91,
    'H-VVS2-EX-GOOD-STRONG-VG': 6.91,
    'H-VVS2-POOR-GOOD-STRONG-EX': 6.91,
    'H-VVS2-GOOD-POOR-STRONG-EX': 6.91,
    'H-VVS2-GOOD-EX-STRONG-VG': 6.91,
    'H-VVS2-VG-VG-STRONG-VG': 6.91,
    'H-VS2-POOR-VG-MEDIUM-EX': 6.91,
    'H-VS2-GOOD-GOOD-MEDIUM-EX': 6.91,
    'H-VS2-EX-VG-MEDIUM-VG': 6.91,
    'H-VS2-VG-EX-MEDIUM-VG': 6.91,
    'H-VS2-VG-POOR-MEDIUM-EX': 6.91,
    'I-VVS2-GOOD-POOR-MEDIUM-EX': 6.91,
    'I-VVS2-POOR-GOOD-MEDIUM-EX': 6.91,
    'I-VVS2-VG-VG-MEDIUM-VG': 6.91,
    'I-VVS2-EX-GOOD-MEDIUM-VG': 6.91,
    'I-VVS2-GOOD-EX-MEDIUM-VG': 6.91,
    'I-VS2-POOR-VG-FAINT-EX': 6.91,
    'I-VS2-EX-VG-FAINT-VG': 6.91,
    'I-VS2-GOOD-GOOD-FAINT-EX': 6.91,
    'I-VS2-VG-EX-FAINT-VG': 6.91,
    'I-VS2-VG-POOR-FAINT-EX': 6.91,
    'J-VVS2-EX-GOOD-FAINT-VG': 6.91,
    'J-VVS2-VG-VG-FAINT-VG': 6.91,
    'J-VVS2-POOR-GOOD-FAINT-EX': 6.91,
    'J-VVS2-GOOD-POOR-FAINT-EX': 6.91,
    'J-VVS2-GOOD-EX-FAINT-VG': 6.91,
    'J-VS2-EX-VG-NONE-VG': 6.91,
    'J-VS2-VG-EX-NONE-VG': 6.91,
    'J-VS2-VG-POOR-NONE-EX': 6.91,
    'J-VS2-GOOD-GOOD-NONE-EX': 6.91,
    'J-VS2-POOR-VG-NONE-EX': 6.91,
    'K-VVS2-POOR-GOOD-NONE-EX': 6.91,
    'K-VVS2-GOOD-POOR-NONE-EX': 6.91,
    'K-VVS2-EX-GOOD-NONE-VG': 6.91,
    'K-VVS2-VG-VG-NONE-VG': 6.91,
    'K-VVS2-GOOD-EX-NONE-VG': 6.91,
    'L-VS2-EX-EX-STRONG-EX': 6.91,
    'M-VVS2-EX-VG-STRONG-EX': 6.91,
    'M-VS2-EX-EX-MEDIUM-EX': 6.91,
    'M-VVS2-VG-EX-STRONG-EX': 6.91,
    'D-IF-GOOD-GOOD-STRONG-GOOD': 6.9,
    'D-IF-POOR-VG-STRONG-GOOD': 6.9,
    'D-IF-EX-VG-STRONG-POOR': 6.9,
    'D-IF-VG-EX-STRONG-POOR': 6.9,
    'D-IF-VG-POOR-STRONG-GOOD': 6.9,
    'E-IF-EX-VG-MEDIUM-POOR': 6.9,
    'E-IF-VG-EX-MEDIUM-POOR': 6.9,
    'E-IF-VG-POOR-MEDIUM-GOOD': 6.9,
    'E-IF-GOOD-GOOD-MEDIUM-GOOD': 6.9,
    'E-IF-POOR-VG-MEDIUM-GOOD': 6.9,
    'F-IF-EX-VG-FAINT-POOR': 6.9,
    'F-IF-POOR-VG-FAINT-GOOD': 6.9,
    'F-IF-VG-EX-FAINT-POOR': 6.9,
    'F-IF-GOOD-GOOD-FAINT-GOOD': 6.9,
    'F-IF-VG-POOR-FAINT-GOOD': 6.9,
    'G-IF-EX-VG-NONE-POOR': 6.9,
    'G-IF-VG-POOR-NONE-GOOD': 6.9,
    'G-IF-VG-EX-NONE-POOR': 6.9,
    'G-IF-GOOD-GOOD-NONE-GOOD': 6.9,
    'G-IF-POOR-VG-NONE-GOOD': 6.9,
    'I-IF-POOR-POOR-STRONG-EX': 6.9,
    'I-IF-GOOD-VG-STRONG-VG': 6.9,
    'I-IF-EX-POOR-STRONG-VG': 6.9,
    'I-IF-VG-GOOD-STRONG-VG': 6.9,
    'I-IF-POOR-EX-STRONG-VG': 6.9,
    'I-IF-EX-EX-STRONG-GOOD': 6.9,
    'J-IF-EX-POOR-MEDIUM-VG': 6.9,
    'J-IF-EX-EX-MEDIUM-GOOD': 6.9,
    'J-IF-VG-GOOD-MEDIUM-VG': 6.9,
    'J-IF-GOOD-VG-MEDIUM-VG': 6.9,
    'J-IF-POOR-EX-MEDIUM-VG': 6.9,
    'J-IF-POOR-POOR-MEDIUM-EX': 6.9,
    'K-IF-VG-GOOD-FAINT-VG': 6.9,
    'K-IF-EX-EX-FAINT-GOOD': 6.9,
    'K-IF-EX-POOR-FAINT-VG': 6.9,
    'K-IF-GOOD-VG-FAINT-VG': 6.9,
    'K-IF-POOR-POOR-FAINT-EX': 6.9,
    'K-IF-POOR-EX-FAINT-VG': 6.9,
    'L-IF-POOR-POOR-NONE-EX': 6.9,
    'L-IF-EX-EX-NONE-GOOD': 6.9,
    'L-IF-EX-POOR-NONE-VG': 6.9,
    'L-IF-GOOD-VG-NONE-VG': 6.9,
    'L-IF-POOR-EX-NONE-VG': 6.9,
    'L-IF-VG-GOOD-NONE-VG': 6.9,
    'D-SI1-POOR-GOOD-NONE-VG': 6.89,
    'D-SI1-GOOD-POOR-NONE-VG': 6.89,
    'D-SI1-GOOD-EX-NONE-GOOD': 6.89,
    'D-SI1-VG-VG-NONE-GOOD': 6.89,
    'D-SI1-EX-GOOD-NONE-GOOD': 6.89,
    'E-I1-GOOD-VG-STRONG-EX': 6.89,
    'E-I1-EX-POOR-STRONG-EX': 6.89,
    'E-I1-EX-EX-STRONG-VG': 6.89,
    'E-I1-VG-GOOD-STRONG-EX': 6.89,
    'E-I1-POOR-EX-STRONG-EX': 6.89,
    'F-SI1-VG-EX-STRONG-VG': 6.89,
    'F-SI1-EX-VG-STRONG-VG': 6.89,
    'F-I1-EX-POOR-MEDIUM-EX': 6.89,
    'F-I1-VG-GOOD-MEDIUM-EX': 6.89,
    'F-I1-GOOD-VG-MEDIUM-EX': 6.89,
    'F-I1-POOR-EX-MEDIUM-EX': 6.89,
    'F-SI1-POOR-VG-STRONG-EX': 6.89,
    'F-I1-EX-EX-MEDIUM-VG': 6.89,
    'F-SI1-GOOD-GOOD-STRONG-EX': 6.89,
    'F-SI1-VG-POOR-STRONG-EX': 6.89,
    'G-SI1-VG-POOR-MEDIUM-EX': 6.89,
    'G-I1-EX-EX-FAINT-VG': 6.89,
    'G-I1-EX-POOR-FAINT-EX': 6.89,
    'G-I1-GOOD-VG-FAINT-EX': 6.89,
    'G-I1-VG-GOOD-FAINT-EX': 6.89,
    'G-I1-POOR-EX-FAINT-EX': 6.89,
    'G-SI1-EX-VG-MEDIUM-VG': 6.89,
    'G-SI1-POOR-VG-MEDIUM-EX': 6.89,
    'G-SI1-VG-EX-MEDIUM-VG': 6.89,
    'G-SI1-GOOD-GOOD-MEDIUM-EX': 6.89,
    'H-SI1-EX-VG-FAINT-VG': 6.89,
    'H-SI1-VG-POOR-FAINT-EX': 6.89,
    'H-I1-EX-POOR-NONE-EX': 6.89,
    'H-SI1-VG-EX-FAINT-VG': 6.89,
    'H-SI1-GOOD-GOOD-FAINT-EX': 6.89,
    'H-SI1-POOR-VG-FAINT-EX': 6.89,
    'H-I1-EX-EX-NONE-VG': 6.89,
    'H-I1-VG-GOOD-NONE-EX': 6.89,
    'H-I1-GOOD-VG-NONE-EX': 6.89,
    'H-I1-POOR-EX-NONE-EX': 6.89,
    'I-SI1-GOOD-GOOD-NONE-EX': 6.89,
    'I-SI1-POOR-VG-NONE-EX': 6.89,
    'I-SI1-VG-EX-NONE-VG': 6.89,
    'I-SI1-VG-POOR-NONE-EX': 6.89,
    'I-SI1-EX-VG-NONE-VG': 6.89,
    'K-SI1-EX-EX-STRONG-EX': 6.89,
    'L-SI1-EX-EX-MEDIUM-EX': 6.89,
    'M-SI1-EX-EX-FAINT-EX': 6.89,
    'D-VS1-POOR-EX-FAINT-GOOD': 6.88,
    'D-VVS1-GOOD-GOOD-MEDIUM-GOOD': 6.88,
    'D-VVS1-VG-POOR-MEDIUM-GOOD': 6.88,
    'D-VVS1-VG-EX-MEDIUM-POOR': 6.88,
    'D-VVS1-EX-VG-MEDIUM-POOR': 6.88,
    'D-VS1-VG-GOOD-FAINT-GOOD': 6.88,
    'D-VVS1-POOR-VG-MEDIUM-GOOD': 6.88,
    'D-VS1-GOOD-VG-FAINT-GOOD': 6.88,
    'D-VS1-POOR-POOR-FAINT-VG': 6.88,
    'D-VS1-EX-EX-FAINT-POOR': 6.88,
    'D-VS1-EX-POOR-FAINT-GOOD': 6.88,
    'E-VVS1-VG-EX-FAINT-POOR': 6.88,
    'E-VS1-VG-GOOD-NONE-GOOD': 6.88,
    'E-VS1-POOR-EX-NONE-GOOD': 6.88,
    'E-VS1-EX-POOR-NONE-GOOD': 6.88,
    'E-VVS1-POOR-VG-FAINT-GOOD': 6.88,
    'E-VVS1-EX-VG-FAINT-POOR': 6.88,
    'E-VVS1-VG-POOR-FAINT-GOOD': 6.88,
    'E-VVS1-GOOD-GOOD-FAINT-GOOD': 6.88,
    'E-VS1-POOR-POOR-NONE-VG': 6.88,
    'E-VS1-EX-EX-NONE-POOR': 6.88,
    'E-VS1-GOOD-VG-NONE-GOOD': 6.88,
    'F-VVS1-EX-VG-NONE-POOR': 6.88,
    'F-VVS1-POOR-VG-NONE-GOOD': 6.88,
    'F-VVS1-VG-EX-NONE-POOR': 6.88,
    'F-VVS1-GOOD-GOOD-NONE-GOOD': 6.88,
    'F-VVS1-VG-POOR-NONE-GOOD': 6.88,
    'G-VS1-EX-GOOD-STRONG-VG': 6.88,
    'G-VS1-VG-VG-STRONG-VG': 6.88,
    'G-VS1-GOOD-POOR-STRONG-EX': 6.88,
    'G-VS1-POOR-GOOD-STRONG-EX': 6.88,
    'G-VS1-GOOD-EX-STRONG-VG': 6.88,
    'H-VS1-POOR-GOOD-MEDIUM-EX': 6.88,
    'H-VS1-VG-VG-MEDIUM-VG': 6.88,
    'H-VS1-EX-GOOD-MEDIUM-VG': 6.88,
    'H-VS1-GOOD-EX-MEDIUM-VG': 6.88,
    'H-VS1-GOOD-POOR-MEDIUM-EX': 6.88,
    'H-VVS1-POOR-POOR-STRONG-EX': 6.88,
    'H-VVS1-GOOD-VG-STRONG-VG': 6.88,
    'H-VVS1-VG-GOOD-STRONG-VG': 6.88,
    'H-VVS1-EX-POOR-STRONG-VG': 6.88,
    'H-VVS1-EX-EX-STRONG-GOOD': 6.88,
    'H-VVS1-POOR-EX-STRONG-VG': 6.88,
    'I-VVS1-EX-POOR-MEDIUM-VG': 6.88,
    'I-VS1-POOR-GOOD-FAINT-EX': 6.88,
    'I-VVS1-VG-GOOD-MEDIUM-VG': 6.88,
    'I-VVS1-EX-EX-MEDIUM-GOOD': 6.88,
    'I-VVS1-POOR-POOR-MEDIUM-EX': 6.88,
    'I-VVS1-POOR-EX-MEDIUM-VG': 6.88,
    'I-VVS1-GOOD-VG-MEDIUM-VG': 6.88,
    'I-VS1-GOOD-POOR-FAINT-EX': 6.88,
    'I-VS1-EX-GOOD-FAINT-VG': 6.88,
    'I-VS1-GOOD-EX-FAINT-VG': 6.88,
    'I-VS1-VG-VG-FAINT-VG': 6.88,
    'J-VS1-POOR-GOOD-NONE-EX': 6.88,
    'J-VS1-EX-GOOD-NONE-VG': 6.88,
    'J-VVS1-GOOD-VG-FAINT-VG': 6.88,
    'J-VVS1-EX-EX-FAINT-GOOD': 6.88,
    'J-VVS1-POOR-POOR-FAINT-EX': 6.88,
    'J-VS1-GOOD-POOR-NONE-EX': 6.88,
    'J-VVS1-POOR-EX-FAINT-VG': 6.88,
    'J-VS1-GOOD-EX-NONE-VG': 6.88,
    'J-VVS1-EX-POOR-FAINT-VG': 6.88,
    'J-VVS1-VG-GOOD-FAINT-VG': 6.88,
    'J-VS1-VG-VG-NONE-VG': 6.88,
    'K-VVS1-GOOD-VG-NONE-VG': 6.88,
    'K-VVS1-EX-POOR-NONE-VG': 6.88,
    'K-VVS1-EX-EX-NONE-GOOD': 6.88,
    'K-VVS1-POOR-EX-NONE-VG': 6.88,
    'K-VVS1-POOR-POOR-NONE-EX': 6.88,
    'K-VVS1-VG-GOOD-NONE-VG': 6.88,
    'L-VS1-EX-VG-STRONG-EX': 6.88,
    'L-VS1-VG-EX-STRONG-EX': 6.88,
    'M-VS1-EX-VG-MEDIUM-EX': 6.88,
    'M-VS1-VG-EX-MEDIUM-EX': 6.88,
    'M-VVS1-GOOD-EX-STRONG-EX': 6.88,
    'M-VVS1-VG-VG-STRONG-EX': 6.88,
    'M-VVS1-EX-GOOD-STRONG-EX': 6.88,
    'D-I2-EX-EX-STRONG-VG': 6.87,
    'D-I2-GOOD-VG-STRONG-EX': 6.87,
    'D-I2-EX-POOR-STRONG-EX': 6.87,
    'D-I2-VG-GOOD-STRONG-EX': 6.87,
    'D-I2-POOR-EX-STRONG-EX': 6.87,
    'E-I2-GOOD-VG-MEDIUM-EX': 6.87,
    'E-SI2-VG-EX-STRONG-VG': 6.87,
    'E-SI2-VG-POOR-STRONG-EX': 6.87,
    'E-SI2-POOR-VG-STRONG-EX': 6.87,
    'E-I2-POOR-EX-MEDIUM-EX': 6.87,
    'E-SI2-GOOD-GOOD-STRONG-EX': 6.87,
    'E-I2-VG-GOOD-MEDIUM-EX': 6.87,
    'E-SI2-EX-VG-STRONG-VG': 6.87,
    'E-I2-EX-POOR-MEDIUM-EX': 6.87,
    'E-I2-EX-EX-MEDIUM-VG': 6.87,
    'F-I2-VG-GOOD-FAINT-EX': 6.87,
    'F-I2-EX-EX-FAINT-VG': 6.87,
    'F-I2-EX-POOR-FAINT-EX': 6.87,
    'F-SI2-POOR-VG-MEDIUM-EX': 6.87,
    'F-SI2-GOOD-GOOD-MEDIUM-EX': 6.87,
    'F-SI2-VG-POOR-MEDIUM-EX': 6.87,
    'F-SI2-VG-EX-MEDIUM-VG': 6.87,
    'F-SI2-EX-VG-MEDIUM-VG': 6.87,
    'F-I2-GOOD-VG-FAINT-EX': 6.87,
    'F-I2-POOR-EX-FAINT-EX': 6.87,
    'G-I2-GOOD-VG-NONE-EX': 6.87,
    'G-SI2-GOOD-GOOD-FAINT-EX': 6.87,
    'G-SI2-VG-POOR-FAINT-EX': 6.87,
    'G-I2-POOR-EX-NONE-EX': 6.87,
    'G-SI2-VG-EX-FAINT-VG': 6.87,
    'G-SI2-EX-VG-FAINT-VG': 6.87,
    'G-SI2-POOR-VG-FAINT-EX': 6.87,
    'G-I2-EX-POOR-NONE-EX': 6.87,
    'G-I2-EX-EX-NONE-VG': 6.87,
    'G-I2-VG-GOOD-NONE-EX': 6.87,
    'H-SI2-POOR-VG-NONE-EX': 6.87,
    'H-SI2-GOOD-GOOD-NONE-EX': 6.87,
    'H-SI2-EX-VG-NONE-VG': 6.87,
    'H-SI2-VG-EX-NONE-VG': 6.87,
    'H-SI2-VG-POOR-NONE-EX': 6.87,
    'J-SI2-EX-EX-STRONG-EX': 6.87,
    'K-SI2-EX-EX-MEDIUM-EX': 6.87,
    'L-SI2-EX-EX-FAINT-EX': 6.87,
    'M-SI2-EX-EX-NONE-EX': 6.87,
    'D-VS2-POOR-EX-NONE-GOOD': 6.86,
    'D-VVS2-VG-EX-FAINT-POOR': 6.86,
    'D-VS2-POOR-POOR-NONE-VG': 6.86,
    'D-VS2-EX-POOR-NONE-GOOD': 6.86,
    'D-VVS2-EX-VG-FAINT-POOR': 6.86,
    'D-VVS2-GOOD-GOOD-FAINT-GOOD': 6.86,
    'D-VS2-VG-GOOD-NONE-GOOD': 6.86,
    'D-VVS2-POOR-VG-FAINT-GOOD': 6.86,
    'D-VS2-GOOD-VG-NONE-GOOD': 6.86,
    'D-VVS2-VG-POOR-FAINT-GOOD': 6.86,
    'D-VS2-EX-EX-NONE-POOR': 6.86,
    'E-VVS2-GOOD-GOOD-NONE-GOOD': 6.86,
    'E-VVS2-VG-POOR-NONE-GOOD': 6.86,
    'E-VVS2-POOR-VG-NONE-GOOD': 6.86,
    'E-VVS2-VG-EX-NONE-POOR': 6.86,
    'E-VVS2-EX-VG-NONE-POOR': 6.86,
    'F-VS2-POOR-GOOD-STRONG-EX': 6.86,
    'F-VS2-GOOD-EX-STRONG-VG': 6.86,
    'F-VS2-VG-VG-STRONG-VG': 6.86,
    'F-VS2-EX-GOOD-STRONG-VG': 6.86,
    'F-VS2-GOOD-POOR-STRONG-EX': 6.86,
    'G-VVS2-EX-EX-STRONG-GOOD': 6.86,
    'G-VS2-GOOD-EX-MEDIUM-VG': 6.86,
    'G-VVS2-GOOD-VG-STRONG-VG': 6.86,
    'G-VVS2-EX-POOR-STRONG-VG': 6.86,
    'G-VS2-VG-VG-MEDIUM-VG': 6.86,
    'G-VS2-GOOD-POOR-MEDIUM-EX': 6.86,
    'G-VVS2-POOR-POOR-STRONG-EX': 6.86,
    'G-VS2-POOR-GOOD-MEDIUM-EX': 6.86,
    'G-VVS2-POOR-EX-STRONG-VG': 6.86,
    'G-VS2-EX-GOOD-MEDIUM-VG': 6.86,
    'G-VVS2-VG-GOOD-STRONG-VG': 6.86,
    'H-VS2-VG-VG-FAINT-VG': 6.86,
    'H-VVS2-GOOD-VG-MEDIUM-VG': 6.86,
    'H-VS2-EX-GOOD-FAINT-VG': 6.86,
    'H-VS2-GOOD-EX-FAINT-VG': 6.86,
    'H-VVS2-VG-GOOD-MEDIUM-VG': 6.86,
    'H-VS2-POOR-GOOD-FAINT-EX': 6.86,
    'H-VS2-GOOD-POOR-FAINT-EX': 6.86,
    'H-VVS2-POOR-POOR-MEDIUM-EX': 6.86,
    'H-VVS2-EX-EX-MEDIUM-GOOD': 6.86,
    'H-VVS2-POOR-EX-MEDIUM-VG': 6.86,
    'H-VVS2-EX-POOR-MEDIUM-VG': 6.86,
    'I-VVS2-POOR-POOR-FAINT-EX': 6.86,
    'I-VS2-GOOD-POOR-NONE-EX': 6.86,
    'I-VS2-POOR-GOOD-NONE-EX': 6.86,
    'I-VS2-EX-GOOD-NONE-VG': 6.86,
    'I-VS2-VG-VG-NONE-VG': 6.86,
    'I-VS2-GOOD-EX-NONE-VG': 6.86,
    'I-VVS2-EX-EX-FAINT-GOOD': 6.86,
    'I-VVS2-POOR-EX-FAINT-VG': 6.86,
    'I-VVS2-EX-POOR-FAINT-VG': 6.86,
    'I-VVS2-VG-GOOD-FAINT-VG': 6.86,
    'I-VVS2-GOOD-VG-FAINT-VG': 6.86,
    'J-VVS2-EX-POOR-NONE-VG': 6.86,
    'J-VVS2-POOR-EX-NONE-VG': 6.86,
    'J-VVS2-POOR-POOR-NONE-EX': 6.86,
    'J-VVS2-GOOD-VG-NONE-VG': 6.86,
    'J-VVS2-VG-GOOD-NONE-VG': 6.86,
    'J-VVS2-EX-EX-NONE-GOOD': 6.86,
    'K-VS2-VG-EX-STRONG-EX': 6.86,
    'K-VS2-EX-VG-STRONG-EX': 6.86,
    'L-VVS2-VG-VG-STRONG-EX': 6.86,
    'L-VS2-VG-EX-MEDIUM-EX': 6.86,
    'L-VS2-EX-VG-MEDIUM-EX': 6.86,
    'L-VVS2-GOOD-EX-STRONG-EX': 6.86,
    'L-VVS2-EX-GOOD-STRONG-EX': 6.86,
    'M-VVS2-GOOD-EX-MEDIUM-EX': 6.86,
    'M-VS2-VG-EX-FAINT-EX': 6.86,
    'M-VVS2-EX-GOOD-MEDIUM-EX': 6.86,
    'M-VVS2-VG-VG-MEDIUM-EX': 6.86,
    'M-VS2-EX-VG-FAINT-EX': 6.86,
    'D-IF-VG-VG-MEDIUM-POOR': 6.85,
    'D-IF-EX-GOOD-MEDIUM-POOR': 6.85,
    'D-IF-GOOD-EX-MEDIUM-POOR': 6.85,
    'D-IF-GOOD-POOR-MEDIUM-GOOD': 6.85,
    'D-IF-POOR-GOOD-MEDIUM-GOOD': 6.85,
    'E-IF-EX-GOOD-FAINT-POOR': 6.85,
    'E-IF-VG-VG-FAINT-POOR': 6.85,
    'E-IF-GOOD-POOR-FAINT-GOOD': 6.85,
    'E-IF-GOOD-EX-FAINT-POOR': 6.85,
    'E-IF-POOR-GOOD-FAINT-GOOD': 6.85,
    'F-IF-GOOD-EX-NONE-POOR': 6.85,
    'F-IF-GOOD-POOR-NONE-GOOD': 6.85,
    'F-IF-VG-VG-NONE-POOR': 6.85,
    'F-IF-EX-GOOD-NONE-POOR': 6.85,
    'F-IF-POOR-GOOD-NONE-GOOD': 6.85,
    'H-IF-VG-EX-STRONG-GOOD': 6.85,
    'H-IF-POOR-VG-STRONG-VG': 6.85,
    'H-IF-EX-VG-STRONG-GOOD': 6.85,
    'H-IF-GOOD-GOOD-STRONG-VG': 6.85,
    'H-IF-VG-POOR-STRONG-VG': 6.85,
    'I-IF-VG-EX-MEDIUM-GOOD': 6.85,
    'I-IF-POOR-VG-MEDIUM-VG': 6.85,
    'I-IF-GOOD-GOOD-MEDIUM-VG': 6.85,
    'I-IF-VG-POOR-MEDIUM-VG': 6.85,
    'I-IF-EX-VG-MEDIUM-GOOD': 6.85,
    'J-IF-GOOD-GOOD-FAINT-VG': 6.85,
    'J-IF-VG-POOR-FAINT-VG': 6.85,
    'J-IF-VG-EX-FAINT-GOOD': 6.85,
    'J-IF-EX-VG-FAINT-GOOD': 6.85,
    'J-IF-POOR-VG-FAINT-VG': 6.85,
    'K-IF-POOR-VG-NONE-VG': 6.85,
    'K-IF-GOOD-GOOD-NONE-VG': 6.85,
    'K-IF-VG-POOR-NONE-VG': 6.85,
    'K-IF-VG-EX-NONE-GOOD': 6.85,
    'K-IF-EX-VG-NONE-GOOD': 6.85,
    'M-IF-POOR-EX-STRONG-EX': 6.85,
    'M-IF-GOOD-VG-STRONG-EX': 6.85,
    'M-IF-EX-POOR-STRONG-EX': 6.85,
    'M-IF-EX-EX-STRONG-VG': 6.85,
    'M-IF-VG-GOOD-STRONG-EX': 6.85,
    'D-I1-POOR-VG-STRONG-EX': 6.84,
    'D-I1-EX-VG-STRONG-VG': 6.84,
    'D-I1-GOOD-GOOD-STRONG-EX': 6.84,
    'D-I1-VG-EX-STRONG-VG': 6.84,
    'D-I1-VG-POOR-STRONG-EX': 6.84,
    'E-I1-GOOD-GOOD-MEDIUM-EX': 6.84,
    'E-SI1-GOOD-EX-STRONG-VG': 6.84,
    'E-I1-POOR-VG-MEDIUM-EX': 6.84,
    'E-I1-VG-POOR-MEDIUM-EX': 6.84,
    'E-SI1-GOOD-POOR-STRONG-EX': 6.84,
    'E-SI1-VG-VG-STRONG-VG': 6.84,
    'E-I1-EX-VG-MEDIUM-VG': 6.84,
    'E-I1-VG-EX-MEDIUM-VG': 6.84,
    'E-SI1-POOR-GOOD-STRONG-EX': 6.84,
    'E-SI1-EX-GOOD-STRONG-VG': 6.84,
    'F-SI1-EX-GOOD-MEDIUM-VG': 6.84,
    'F-SI1-POOR-GOOD-MEDIUM-EX': 6.84,
    'F-I1-POOR-VG-FAINT-EX': 6.84,
    'F-I1-GOOD-GOOD-FAINT-EX': 6.84,
    'F-SI1-GOOD-EX-MEDIUM-VG': 6.84,
    'F-I1-EX-VG-FAINT-VG': 6.84,
    'F-I1-VG-POOR-FAINT-EX': 6.84,
    'F-SI1-VG-VG-MEDIUM-VG': 6.84,
    'F-I1-VG-EX-FAINT-VG': 6.84,
    'F-SI1-GOOD-POOR-MEDIUM-EX': 6.84,
    'G-I1-VG-POOR-NONE-EX': 6.84,
    'G-SI1-POOR-GOOD-FAINT-EX': 6.84,
    'G-SI1-EX-GOOD-FAINT-VG': 6.84,
    'G-I1-POOR-VG-NONE-EX': 6.84,
    'G-SI1-GOOD-POOR-FAINT-EX': 6.84,
    'G-I1-GOOD-GOOD-NONE-EX': 6.84,
    'G-SI1-GOOD-EX-FAINT-VG': 6.84,
    'G-I1-VG-EX-NONE-VG': 6.84,
    'G-SI1-VG-VG-FAINT-VG': 6.84,
    'G-I1-EX-VG-NONE-VG': 6.84,
    'H-SI1-VG-VG-NONE-VG': 6.84,
    'H-SI1-EX-GOOD-NONE-VG': 6.84,
    'H-SI1-GOOD-EX-NONE-VG': 6.84,
    'H-SI1-GOOD-POOR-NONE-EX': 6.84,
    'H-SI1-POOR-GOOD-NONE-EX': 6.84,
    'I-I1-EX-EX-STRONG-EX': 6.84,
    'J-SI1-EX-VG-STRONG-EX': 6.84,
    'J-SI1-VG-EX-STRONG-EX': 6.84,
    'J-I1-EX-EX-MEDIUM-EX': 6.84,
    'K-SI1-VG-EX-MEDIUM-EX': 6.84,
    'K-I1-EX-EX-FAINT-EX': 6.84,
    'K-SI1-EX-VG-MEDIUM-EX': 6.84,
    'L-SI1-EX-VG-FAINT-EX': 6.84,
    'L-I1-EX-EX-NONE-EX': 6.84,
    'L-SI1-VG-EX-FAINT-EX': 6.84,
    'M-SI1-EX-VG-NONE-EX': 6.84,
    'M-SI1-VG-EX-NONE-EX': 6.84,
    'D-VVS1-GOOD-POOR-FAINT-GOOD': 6.83,
    'D-VVS1-POOR-GOOD-FAINT-GOOD': 6.83,
    'D-VS1-VG-EX-NONE-POOR': 6.83,
    'D-VS1-EX-VG-NONE-POOR': 6.83,
    'D-VVS1-EX-GOOD-FAINT-POOR': 6.83,
    'D-VVS1-VG-VG-FAINT-POOR': 6.83,
    'D-VS1-GOOD-GOOD-NONE-GOOD': 6.83,
    'D-VS1-VG-POOR-NONE-GOOD': 6.83,
    'D-VVS1-GOOD-EX-FAINT-POOR': 6.83,
    'D-VS1-POOR-VG-NONE-GOOD': 6.83,
    'E-VVS1-GOOD-POOR-NONE-GOOD': 6.83,
    'E-VVS1-POOR-GOOD-NONE-GOOD': 6.83,
    'E-VVS1-GOOD-EX-NONE-POOR': 6.83,
    'E-VVS1-VG-VG-NONE-POOR': 6.83,
    'E-VVS1-EX-GOOD-NONE-POOR': 6.83,
    'F-VS1-VG-GOOD-STRONG-VG': 6.83,
    'F-VS1-GOOD-VG-STRONG-VG': 6.83,
    'F-VS1-EX-POOR-STRONG-VG': 6.83,
    'F-VS1-EX-EX-STRONG-GOOD': 6.83,
    'F-VS1-POOR-EX-STRONG-VG': 6.83,
    'F-VS1-POOR-POOR-STRONG-EX': 6.83,
    'G-VS1-EX-EX-MEDIUM-GOOD': 6.83,
    'G-VVS1-EX-VG-STRONG-GOOD': 6.83,
    'G-VS1-EX-POOR-MEDIUM-VG': 6.83,
    'G-VVS1-POOR-VG-STRONG-VG': 6.83,
    'G-VS1-POOR-EX-MEDIUM-VG': 6.83,
    'G-VS1-POOR-POOR-MEDIUM-EX': 6.83,
    'G-VVS1-VG-POOR-STRONG-VG': 6.83,
    'G-VS1-VG-GOOD-MEDIUM-VG': 6.83,
    'G-VVS1-VG-EX-STRONG-GOOD': 6.83,
    'G-VVS1-GOOD-GOOD-STRONG-VG': 6.83,
    'G-VS1-GOOD-VG-MEDIUM-VG': 6.83,
    'H-VS1-GOOD-VG-FAINT-VG': 6.83,
    'H-VVS1-EX-VG-MEDIUM-GOOD': 6.83,
    'H-VS1-POOR-POOR-FAINT-EX': 6.83,
    'H-VVS1-VG-POOR-MEDIUM-VG': 6.83,
    'H-VS1-EX-EX-FAINT-GOOD': 6.83,
    'H-VS1-POOR-EX-FAINT-VG': 6.83,
    'H-VS1-EX-POOR-FAINT-VG': 6.83,
    'H-VVS1-VG-EX-MEDIUM-GOOD': 6.83,
    'H-VVS1-POOR-VG-MEDIUM-VG': 6.83,
    'H-VVS1-GOOD-GOOD-MEDIUM-VG': 6.83,
    'H-VS1-VG-GOOD-FAINT-VG': 6.83,
    'I-VS1-POOR-POOR-NONE-EX': 6.83,
    'I-VVS1-GOOD-GOOD-FAINT-VG': 6.83,
    'I-VVS1-VG-EX-FAINT-GOOD': 6.83,
    'I-VVS1-EX-VG-FAINT-GOOD': 6.83,
    'I-VS1-POOR-EX-NONE-VG': 6.83,
    'I-VVS1-POOR-VG-FAINT-VG': 6.83,
    'I-VS1-EX-EX-NONE-GOOD': 6.83,
    'I-VS1-EX-POOR-NONE-VG': 6.83,
    'I-VS1-GOOD-VG-NONE-VG': 6.83,
    'I-VVS1-VG-POOR-FAINT-VG': 6.83,
    'I-VS1-VG-GOOD-NONE-VG': 6.83,
    'J-VVS1-EX-VG-NONE-GOOD': 6.83,
    'J-VVS1-POOR-VG-NONE-VG': 6.83,
    'J-VVS1-GOOD-GOOD-NONE-VG': 6.83,
    'J-VVS1-VG-POOR-NONE-VG': 6.83,
    'J-VVS1-VG-EX-NONE-GOOD': 6.83,
    'K-VS1-VG-VG-STRONG-EX': 6.83,
    'K-VS1-GOOD-EX-STRONG-EX': 6.83,
    'K-VS1-EX-GOOD-STRONG-EX': 6.83,
    'L-VVS1-GOOD-VG-STRONG-EX': 6.83,
    'L-VS1-GOOD-EX-MEDIUM-EX': 6.83,
    'L-VVS1-EX-EX-STRONG-VG': 6.83,
    'L-VVS1-POOR-EX-STRONG-EX': 6.83,
    'L-VS1-VG-VG-MEDIUM-EX': 6.83,
    'L-VS1-EX-GOOD-MEDIUM-EX': 6.83,
    'L-VVS1-VG-GOOD-STRONG-EX': 6.83,
    'L-VVS1-EX-POOR-STRONG-EX': 6.83,
    'M-VVS1-POOR-EX-MEDIUM-EX': 6.83,
    'M-VVS1-VG-GOOD-MEDIUM-EX': 6.83,
    'M-VVS1-EX-EX-MEDIUM-VG': 6.83,
    'M-VS1-GOOD-EX-FAINT-EX': 6.83,
    'M-VVS1-EX-POOR-MEDIUM-EX': 6.83,
    'M-VVS1-GOOD-VG-MEDIUM-EX': 6.83,
    'M-VS1-EX-GOOD-FAINT-EX': 6.83,
    'M-VS1-VG-VG-FAINT-EX': 6.83,
    'D-I2-GOOD-GOOD-MEDIUM-EX': 6.82,
    'D-I2-POOR-VG-MEDIUM-EX': 6.82,
    'D-SI2-POOR-GOOD-STRONG-EX': 6.82,
    'D-SI2-GOOD-POOR-STRONG-EX': 6.82,
    'D-I2-EX-VG-MEDIUM-VG': 6.82,
    'D-I2-VG-EX-MEDIUM-VG': 6.82,
    'D-I2-VG-POOR-MEDIUM-EX': 6.82,
    'D-SI2-VG-VG-STRONG-VG': 6.82,
    'D-SI2-EX-GOOD-STRONG-VG': 6.82,
    'D-SI2-GOOD-EX-STRONG-VG': 6.82,
    'E-SI2-VG-VG-MEDIUM-VG': 6.82,
    'E-I2-VG-POOR-FAINT-EX': 6.82,
    'E-I2-EX-VG-FAINT-VG': 6.82,
    'E-SI2-EX-GOOD-MEDIUM-VG': 6.82,
    'E-SI2-GOOD-EX-MEDIUM-VG': 6.82,
    'E-SI2-GOOD-POOR-MEDIUM-EX': 6.82,
    'E-I2-POOR-VG-FAINT-EX': 6.82,
    'E-SI2-POOR-GOOD-MEDIUM-EX': 6.82,
    'E-I2-VG-EX-FAINT-VG': 6.82,
    'E-I2-GOOD-GOOD-FAINT-EX': 6.82,
    'F-I2-POOR-VG-NONE-EX': 6.82,
    'F-SI2-EX-GOOD-FAINT-VG': 6.82,
    'F-I2-EX-VG-NONE-VG': 6.82,
    'F-SI2-POOR-GOOD-FAINT-EX': 6.82,
    'F-SI2-GOOD-POOR-FAINT-EX': 6.82,
    'F-SI2-GOOD-EX-FAINT-VG': 6.82,
    'F-SI2-VG-VG-FAINT-VG': 6.82,
    'F-I2-VG-EX-NONE-VG': 6.82,
    'F-I2-GOOD-GOOD-NONE-EX': 6.82,
    'F-I2-VG-POOR-NONE-EX': 6.82,
    'G-SI2-GOOD-EX-NONE-VG': 6.82,
    'G-SI2-VG-VG-NONE-VG': 6.82,
    'G-SI2-POOR-GOOD-NONE-EX': 6.82,
    'G-SI2-GOOD-POOR-NONE-EX': 6.82,
    'G-SI2-EX-GOOD-NONE-VG': 6.82,
    'H-I2-EX-EX-STRONG-EX': 6.82,
    'I-SI2-VG-EX-STRONG-EX': 6.82,
    'I-SI2-EX-VG-STRONG-EX': 6.82,
    'I-I2-EX-EX-MEDIUM-EX': 6.82,
    'J-I2-EX-EX-FAINT-EX': 6.82,
    'J-SI2-VG-EX-MEDIUM-EX': 6.82,
    'J-SI2-EX-VG-MEDIUM-EX': 6.82,
    'K-I2-EX-EX-NONE-EX': 6.82,
    'K-SI2-VG-EX-FAINT-EX': 6.82,
    'K-SI2-EX-VG-FAINT-EX': 6.82,
    'L-SI2-EX-VG-NONE-EX': 6.82,
    'L-SI2-VG-EX-NONE-EX': 6.82,
    'D-VVS2-GOOD-EX-NONE-POOR': 6.81,
    'D-VVS2-EX-GOOD-NONE-POOR': 6.81,
    'D-VVS2-POOR-GOOD-NONE-GOOD': 6.81,
    'D-VVS2-GOOD-POOR-NONE-GOOD': 6.81,
    'D-VVS2-VG-VG-NONE-POOR': 6.81,
    'E-VS2-EX-POOR-STRONG-VG': 6.81,
    'E-VS2-VG-GOOD-STRONG-VG': 6.81,
    'E-VS2-POOR-EX-STRONG-VG': 6.81,
    'E-VS2-GOOD-VG-STRONG-VG': 6.81,
    'E-VS2-POOR-POOR-STRONG-EX': 6.81,
    'E-VS2-EX-EX-STRONG-GOOD': 6.81,
    'F-VVS2-VG-EX-STRONG-GOOD': 6.81,
    'F-VVS2-POOR-VG-STRONG-VG': 6.81,
    'F-VVS2-EX-VG-STRONG-GOOD': 6.81,
    'F-VVS2-GOOD-GOOD-STRONG-VG': 6.81,
    'F-VVS2-VG-POOR-STRONG-VG': 6.81,
    'F-VS2-EX-EX-MEDIUM-GOOD': 6.81,
    'F-VS2-POOR-EX-MEDIUM-VG': 6.81,
    'F-VS2-VG-GOOD-MEDIUM-VG': 6.81,
    'F-VS2-POOR-POOR-MEDIUM-EX': 6.81,
    'F-VS2-EX-POOR-MEDIUM-VG': 6.81,
    'F-VS2-GOOD-VG-MEDIUM-VG': 6.81,
    'G-VS2-POOR-EX-FAINT-VG': 6.81,
    'G-VVS2-POOR-VG-MEDIUM-VG': 6.81,
    'G-VS2-EX-EX-FAINT-GOOD': 6.81,
    'G-VS2-GOOD-VG-FAINT-VG': 6.81,
    'G-VS2-POOR-POOR-FAINT-EX': 6.81,
    'G-VS2-EX-POOR-FAINT-VG': 6.81,
    'G-VVS2-GOOD-GOOD-MEDIUM-VG': 6.81,
    'G-VS2-VG-GOOD-FAINT-VG': 6.81,
    'G-VVS2-VG-POOR-MEDIUM-VG': 6.81,
    'G-VVS2-EX-VG-MEDIUM-GOOD': 6.81,
    'G-VVS2-VG-EX-MEDIUM-GOOD': 6.81,
    'H-VS2-VG-GOOD-NONE-VG': 6.81,
    'H-VS2-EX-POOR-NONE-VG': 6.81,
    'H-VS2-EX-EX-NONE-GOOD': 6.81,
    'H-VVS2-GOOD-GOOD-FAINT-VG': 6.81,
    'H-VS2-POOR-EX-NONE-VG': 6.81,
    'H-VVS2-EX-VG-FAINT-GOOD': 6.81,
    'H-VS2-POOR-POOR-NONE-EX': 6.81,
    'H-VVS2-POOR-VG-FAINT-VG': 6.81,
    'H-VS2-GOOD-VG-NONE-VG': 6.81,
    'H-VVS2-VG-EX-FAINT-GOOD': 6.81,
    'H-VVS2-VG-POOR-FAINT-VG': 6.81,
    'I-VVS2-POOR-VG-NONE-VG': 6.81,
    'I-VVS2-GOOD-GOOD-NONE-VG': 6.81,
    'I-VVS2-VG-POOR-NONE-VG': 6.81,
    'I-VVS2-VG-EX-NONE-GOOD': 6.81,
    'I-VVS2-EX-VG-NONE-GOOD': 6.81,
    'J-VS2-GOOD-EX-STRONG-EX': 6.81,
    'J-VS2-VG-VG-STRONG-EX': 6.81,
    'J-VS2-EX-GOOD-STRONG-EX': 6.81,
    'K-VVS2-EX-POOR-STRONG-EX': 6.81,
    'K-VVS2-EX-EX-STRONG-VG': 6.81,
    'K-VVS2-GOOD-VG-STRONG-EX': 6.81,
    'K-VVS2-POOR-EX-STRONG-EX': 6.81,
    'K-VVS2-VG-GOOD-STRONG-EX': 6.81,
    'K-VS2-EX-GOOD-MEDIUM-EX': 6.81,
    'K-VS2-VG-VG-MEDIUM-EX': 6.81,
    'K-VS2-GOOD-EX-MEDIUM-EX': 6.81,
    'L-VVS2-POOR-EX-MEDIUM-EX': 6.81,
    'L-VVS2-EX-EX-MEDIUM-VG': 6.81,
    'L-VS2-GOOD-EX-FAINT-EX': 6.81,
    'L-VS2-VG-VG-FAINT-EX': 6.81,
    'L-VS2-EX-GOOD-FAINT-EX': 6.81,
    'L-VVS2-GOOD-VG-MEDIUM-EX': 6.81,
    'L-VVS2-EX-POOR-MEDIUM-EX': 6.81,
    'L-VVS2-VG-GOOD-MEDIUM-EX': 6.81,
    'M-VS2-VG-VG-NONE-EX': 6.81,
    'M-VVS2-EX-EX-FAINT-VG': 6.81,
    'M-VVS2-GOOD-VG-FAINT-EX': 6.81,
    'M-VVS2-VG-GOOD-FAINT-EX': 6.81,
    'M-VS2-GOOD-EX-NONE-EX': 6.81,
    'M-VVS2-EX-POOR-FAINT-EX': 6.81,
    'M-VS2-EX-GOOD-NONE-EX': 6.81,
    'M-VVS2-POOR-EX-FAINT-EX': 6.81,
    'D-IF-EX-POOR-FAINT-POOR': 6.8,
    'D-IF-GOOD-VG-FAINT-POOR': 6.8,
    'D-IF-POOR-EX-FAINT-POOR': 6.8,
    'D-IF-POOR-POOR-FAINT-GOOD': 6.8,
    'D-IF-VG-GOOD-FAINT-POOR': 6.8,
    'E-IF-VG-GOOD-NONE-POOR': 6.8,
    'E-IF-GOOD-VG-NONE-POOR': 6.8,
    'E-IF-POOR-POOR-NONE-GOOD': 6.8,
    'E-IF-EX-POOR-NONE-POOR': 6.8,
    'E-IF-POOR-EX-NONE-POOR': 6.8,
    'G-IF-GOOD-POOR-STRONG-VG': 6.8,
    'G-IF-VG-VG-STRONG-GOOD': 6.8,
    'G-IF-POOR-GOOD-STRONG-VG': 6.8,
    'G-IF-EX-GOOD-STRONG-GOOD': 6.8,
    'G-IF-GOOD-EX-STRONG-GOOD': 6.8,
    'H-IF-VG-VG-MEDIUM-GOOD': 6.8,
    'H-IF-EX-GOOD-MEDIUM-GOOD': 6.8,
    'H-IF-GOOD-POOR-MEDIUM-VG': 6.8,
    'H-IF-POOR-GOOD-MEDIUM-VG': 6.8,
    'H-IF-GOOD-EX-MEDIUM-GOOD': 6.8,
    'I-IF-GOOD-EX-FAINT-GOOD': 6.8,
    'I-IF-VG-VG-FAINT-GOOD': 6.8,
    'I-IF-EX-GOOD-FAINT-GOOD': 6.8,
    'I-IF-POOR-GOOD-FAINT-VG': 6.8,
    'I-IF-GOOD-POOR-FAINT-VG': 6.8,
    'J-IF-POOR-GOOD-NONE-VG': 6.8,
    'J-IF-EX-GOOD-NONE-GOOD': 6.8,
    'J-IF-GOOD-POOR-NONE-VG': 6.8,
    'J-IF-VG-VG-NONE-GOOD': 6.8,
    'J-IF-GOOD-EX-NONE-GOOD': 6.8,
    'L-IF-GOOD-GOOD-STRONG-EX': 6.8,
    'L-IF-POOR-VG-STRONG-EX': 6.8,
    'L-IF-VG-EX-STRONG-VG': 6.8,
    'L-IF-EX-VG-STRONG-VG': 6.8,
    'L-IF-VG-POOR-STRONG-EX': 6.8,
    'M-IF-VG-EX-MEDIUM-VG': 6.8,
    'M-IF-POOR-VG-MEDIUM-EX': 6.8,
    'M-IF-EX-VG-MEDIUM-VG': 6.8,
    'M-IF-GOOD-GOOD-MEDIUM-EX': 6.8,
    'M-IF-VG-POOR-MEDIUM-EX': 6.8,
    'D-SI1-GOOD-VG-STRONG-VG': 6.79,
    'D-SI1-POOR-EX-STRONG-VG': 6.79,
    'D-SI1-POOR-POOR-STRONG-EX': 6.79,
    'D-SI1-VG-GOOD-STRONG-VG': 6.79,
    'D-SI1-EX-EX-STRONG-GOOD': 6.79,
    'D-I1-GOOD-EX-MEDIUM-VG': 6.79,
    'D-SI1-EX-POOR-STRONG-VG': 6.79,
    'D-I1-GOOD-POOR-MEDIUM-EX': 6.79,
    'D-I1-POOR-GOOD-MEDIUM-EX': 6.79,
    'D-I1-EX-GOOD-MEDIUM-VG': 6.79,
    'D-I1-VG-VG-MEDIUM-VG': 6.79,
    'E-I1-EX-GOOD-FAINT-VG': 6.79,
    'E-I1-GOOD-EX-FAINT-VG': 6.79,
    'E-SI1-GOOD-VG-MEDIUM-VG': 6.79,
    'E-SI1-VG-GOOD-MEDIUM-VG': 6.79,
    'E-SI1-EX-EX-MEDIUM-GOOD': 6.79,
    'E-SI1-EX-POOR-MEDIUM-VG': 6.79,
    'E-I1-VG-VG-FAINT-VG': 6.79,
    'E-SI1-POOR-EX-MEDIUM-VG': 6.79,
    'E-I1-POOR-GOOD-FAINT-EX': 6.79,
    'E-SI1-POOR-POOR-MEDIUM-EX': 6.79,
    'E-I1-GOOD-POOR-FAINT-EX': 6.79,
    'F-I1-VG-VG-NONE-VG': 6.79,
    'F-SI1-EX-EX-FAINT-GOOD': 6.79,
    'F-I1-GOOD-EX-NONE-VG': 6.79,
    'F-I1-EX-GOOD-NONE-VG': 6.79,
    'F-SI1-EX-POOR-FAINT-VG': 6.79,
    'F-SI1-GOOD-VG-FAINT-VG': 6.79,
    'F-SI1-POOR-EX-FAINT-VG': 6.79,
    'F-I1-POOR-GOOD-NONE-EX': 6.79,
    'F-SI1-VG-GOOD-FAINT-VG': 6.79,
    'F-I1-GOOD-POOR-NONE-EX': 6.79,
    'F-SI1-POOR-POOR-FAINT-EX': 6.79,
    'G-SI1-POOR-POOR-NONE-EX': 6.79,
    'G-SI1-GOOD-VG-NONE-VG': 6.79,
    'G-SI1-EX-POOR-NONE-VG': 6.79,
    'G-SI1-POOR-EX-NONE-VG': 6.79,
    'G-SI1-EX-EX-NONE-GOOD': 6.79,
    'G-SI1-VG-GOOD-NONE-VG': 6.79,
    'H-I1-VG-EX-STRONG-EX': 6.79,
    'H-I1-EX-VG-STRONG-EX': 6.79,
    'I-I1-EX-VG-MEDIUM-EX': 6.79,
    'I-SI1-GOOD-EX-STRONG-EX': 6.79,
    'I-SI1-VG-VG-STRONG-EX': 6.79,
    'I-SI1-EX-GOOD-STRONG-EX': 6.79,
    'I-I1-VG-EX-MEDIUM-EX': 6.79,
    'J-I1-VG-EX-FAINT-EX': 6.79,
    'J-SI1-GOOD-EX-MEDIUM-EX': 6.79,
    'J-SI1-VG-VG-MEDIUM-EX': 6.79,
    'J-SI1-EX-GOOD-MEDIUM-EX': 6.79,
    'J-I1-EX-VG-FAINT-EX': 6.79,
    'K-I1-VG-EX-NONE-EX': 6.79,
    'K-SI1-EX-GOOD-FAINT-EX': 6.79,
    'K-SI1-VG-VG-FAINT-EX': 6.79,
    'K-I1-EX-VG-NONE-EX': 6.79,
    'K-SI1-GOOD-EX-FAINT-EX': 6.79,
    'L-SI1-EX-GOOD-NONE-EX': 6.79,
    'L-SI1-GOOD-EX-NONE-EX': 6.79,
    'L-SI1-VG-VG-NONE-EX': 6.79,
    'D-VVS1-GOOD-VG-NONE-POOR': 6.78,
    'D-VVS1-EX-POOR-NONE-POOR': 6.78,
    'D-VVS1-POOR-EX-NONE-POOR': 6.78,
    'D-VVS1-POOR-POOR-NONE-GOOD': 6.78,
    'D-VVS1-VG-GOOD-NONE-POOR': 6.78,
    'E-VS1-GOOD-GOOD-STRONG-VG': 6.78,
    'E-VS1-VG-EX-STRONG-GOOD': 6.78,
    'E-VS1-VG-POOR-STRONG-VG': 6.78,
    'E-VS1-EX-VG-STRONG-GOOD': 6.78,
    'E-VS1-POOR-VG-STRONG-VG': 6.78,
    'F-VS1-VG-EX-MEDIUM-GOOD': 6.78,
    'F-VS1-VG-POOR-MEDIUM-VG': 6.78,
    'F-VVS1-GOOD-EX-STRONG-GOOD': 6.78,
    'F-VS1-GOOD-GOOD-MEDIUM-VG': 6.78,
    'F-VS1-EX-VG-MEDIUM-GOOD': 6.78,
    'F-VVS1-GOOD-POOR-STRONG-VG': 6.78,
    'F-VVS1-EX-GOOD-STRONG-GOOD': 6.78,
    'F-VVS1-POOR-GOOD-STRONG-VG': 6.78,
    'F-VVS1-VG-VG-STRONG-GOOD': 6.78,
    'F-VS1-POOR-VG-MEDIUM-VG': 6.78,
    'G-VS1-GOOD-GOOD-FAINT-VG': 6.78,
    'G-VS1-POOR-VG-FAINT-VG': 6.78,
    'G-VVS1-GOOD-POOR-MEDIUM-VG': 6.78,
    'G-VVS1-VG-VG-MEDIUM-GOOD': 6.78,
    'G-VS1-VG-EX-FAINT-GOOD': 6.78,
    'G-VVS1-GOOD-EX-MEDIUM-GOOD': 6.78,
    'G-VVS1-EX-GOOD-MEDIUM-GOOD': 6.78,
    'G-VS1-VG-POOR-FAINT-VG': 6.78,
    'G-VS1-EX-VG-FAINT-GOOD': 6.78,
    'G-VVS1-POOR-GOOD-MEDIUM-VG': 6.78,
    'H-VS1-VG-POOR-NONE-VG': 6.78,
    'H-VS1-VG-EX-NONE-GOOD': 6.78,
    'H-VS1-EX-VG-NONE-GOOD': 6.78,
    'H-VVS1-GOOD-EX-FAINT-GOOD': 6.78,
    'H-VS1-POOR-VG-NONE-VG': 6.78,
    'H-VVS1-GOOD-POOR-FAINT-VG': 6.78,
    'H-VVS1-EX-GOOD-FAINT-GOOD': 6.78,
    'H-VVS1-POOR-GOOD-FAINT-VG': 6.78,
    'H-VVS1-VG-VG-FAINT-GOOD': 6.78,
    'H-VS1-GOOD-GOOD-NONE-VG': 6.78,
    'I-VVS1-GOOD-POOR-NONE-VG': 6.78,
    'I-VVS1-GOOD-EX-NONE-GOOD': 6.78,
    'I-VVS1-POOR-GOOD-NONE-VG': 6.78,
    'I-VVS1-VG-VG-NONE-GOOD': 6.78,
    'I-VVS1-EX-GOOD-NONE-GOOD': 6.78,
    'J-VS1-EX-EX-STRONG-VG': 6.78,
    'J-VS1-POOR-EX-STRONG-EX': 6.78,
    'J-VS1-VG-GOOD-STRONG-EX': 6.78,
    'J-VS1-GOOD-VG-STRONG-EX': 6.78,
    'J-VS1-EX-POOR-STRONG-EX': 6.78,
    'K-VVS1-POOR-VG-STRONG-EX': 6.78,
    'K-VVS1-GOOD-GOOD-STRONG-EX': 6.78,
    'K-VS1-EX-EX-MEDIUM-VG': 6.78,
    'K-VS1-VG-GOOD-MEDIUM-EX': 6.78,
    'K-VS1-GOOD-VG-MEDIUM-EX': 6.78,
    'K-VVS1-EX-VG-STRONG-VG': 6.78,
    'K-VVS1-VG-POOR-STRONG-EX': 6.78,
    'K-VS1-POOR-EX-MEDIUM-EX': 6.78,
    'K-VVS1-VG-EX-STRONG-VG': 6.78,
    'K-VS1-EX-POOR-MEDIUM-EX': 6.78,
    'L-VS1-POOR-EX-FAINT-EX': 6.78,
    'L-VVS1-VG-EX-MEDIUM-VG': 6.78,
    'L-VVS1-EX-VG-MEDIUM-VG': 6.78,
    'L-VS1-EX-POOR-FAINT-EX': 6.78,
    'L-VVS1-VG-POOR-MEDIUM-EX': 6.78,
    'L-VS1-EX-EX-FAINT-VG': 6.78,
    'L-VVS1-GOOD-GOOD-MEDIUM-EX': 6.78,
    'L-VVS1-POOR-VG-MEDIUM-EX': 6.78,
    'L-VS1-VG-GOOD-FAINT-EX': 6.78,
    'L-VS1-GOOD-VG-FAINT-EX': 6.78,
    'M-VVS1-EX-VG-FAINT-VG': 6.78,
    'M-VVS1-POOR-VG-FAINT-EX': 6.78,
    'M-VS1-VG-GOOD-NONE-EX': 6.78,
    'M-VVS1-GOOD-GOOD-FAINT-EX': 6.78,
    'M-VVS1-VG-EX-FAINT-VG': 6.78,
    'M-VVS1-VG-POOR-FAINT-EX': 6.78,
    'M-VS1-POOR-EX-NONE-EX': 6.78,
    'M-VS1-EX-POOR-NONE-EX': 6.78,
    'M-VS1-GOOD-VG-NONE-EX': 6.78,
    'M-VS1-EX-EX-NONE-VG': 6.78,
    'D-SI2-EX-EX-MEDIUM-GOOD': 6.77,
    'D-SI2-EX-POOR-MEDIUM-VG': 6.77,
    'D-I2-POOR-GOOD-FAINT-EX': 6.77,
    'D-SI2-VG-GOOD-MEDIUM-VG': 6.77,
    'D-I2-GOOD-POOR-FAINT-EX': 6.77,
    'D-I2-GOOD-EX-FAINT-VG': 6.77,
    'D-SI2-POOR-POOR-MEDIUM-EX': 6.77,
    'D-I2-VG-VG-FAINT-VG': 6.77,
    'D-SI2-GOOD-VG-MEDIUM-VG': 6.77,
    'D-I2-EX-GOOD-FAINT-VG': 6.77,
    'D-SI2-POOR-EX-MEDIUM-VG': 6.77,
    'E-SI2-POOR-POOR-FAINT-EX': 6.77,
    'E-SI2-VG-GOOD-FAINT-VG': 6.77,
    'E-I2-VG-VG-NONE-VG': 6.77,
    'E-I2-EX-GOOD-NONE-VG': 6.77,
    'E-SI2-GOOD-VG-FAINT-VG': 6.77,
    'E-I2-GOOD-POOR-NONE-EX': 6.77,
    'E-SI2-EX-EX-FAINT-GOOD': 6.77,
    'E-SI2-EX-POOR-FAINT-VG': 6.77,
    'E-I2-GOOD-EX-NONE-VG': 6.77,
    'E-I2-POOR-GOOD-NONE-EX': 6.77,
    'E-SI2-POOR-EX-FAINT-VG': 6.77,
    'F-SI2-EX-POOR-NONE-VG': 6.77,
    'F-SI2-EX-EX-NONE-GOOD': 6.77,
    'F-SI2-POOR-EX-NONE-VG': 6.77,
    'F-SI2-VG-GOOD-NONE-VG': 6.77,
    'F-SI2-POOR-POOR-NONE-EX': 6.77,
    'F-SI2-GOOD-VG-NONE-VG': 6.77,
    'G-I2-VG-EX-STRONG-EX': 6.77,
    'G-I2-EX-VG-STRONG-EX': 6.77,
    'H-SI2-EX-GOOD-STRONG-EX': 6.77,
    'H-I2-EX-VG-MEDIUM-EX': 6.77,
    'H-SI2-VG-VG-STRONG-EX': 6.77,
    'H-I2-VG-EX-MEDIUM-EX': 6.77,
    'H-SI2-GOOD-EX-STRONG-EX': 6.77,
    'I-SI2-GOOD-EX-MEDIUM-EX': 6.77,
    'I-I2-VG-EX-FAINT-EX': 6.77,
    'I-SI2-VG-VG-MEDIUM-EX': 6.77,
    'I-SI2-EX-GOOD-MEDIUM-EX': 6.77,
    'I-I2-EX-VG-FAINT-EX': 6.77,
    'J-I2-EX-VG-NONE-EX': 6.77,
    'J-I2-VG-EX-NONE-EX': 6.77,
    'J-SI2-GOOD-EX-FAINT-EX': 6.77,
    'J-SI2-VG-VG-FAINT-EX': 6.77,
    'J-SI2-EX-GOOD-FAINT-EX': 6.77,
    'K-SI2-VG-VG-NONE-EX': 6.77,
    'K-SI2-EX-GOOD-NONE-EX': 6.77,
    'K-SI2-GOOD-EX-NONE-EX': 6.77,
    'D-VS2-VG-EX-STRONG-GOOD': 6.76,
    'D-VS2-EX-VG-STRONG-GOOD': 6.76,
    'D-VS2-VG-POOR-STRONG-VG': 6.76,
    'D-VS2-GOOD-GOOD-STRONG-VG': 6.76,
    'D-VS2-POOR-VG-STRONG-VG': 6.76,
    'E-VS2-VG-EX-MEDIUM-GOOD': 6.76,
    'E-VVS2-VG-VG-STRONG-GOOD': 6.76,
    'E-VS2-GOOD-GOOD-MEDIUM-VG': 6.76,
    'E-VS2-POOR-VG-MEDIUM-VG': 6.76,
    'E-VS2-EX-VG-MEDIUM-GOOD': 6.76,
    'E-VVS2-EX-GOOD-STRONG-GOOD': 6.76,
    'E-VVS2-GOOD-EX-STRONG-GOOD': 6.76,
    'E-VVS2-POOR-GOOD-STRONG-VG': 6.76,
    'E-VVS2-GOOD-POOR-STRONG-VG': 6.76,
    'E-VS2-VG-POOR-MEDIUM-VG': 6.76,
    'F-VS2-POOR-VG-FAINT-VG': 6.76,
    'F-VS2-EX-VG-FAINT-GOOD': 6.76,
    'F-VS2-VG-EX-FAINT-GOOD': 6.76,
    'F-VVS2-GOOD-POOR-MEDIUM-VG': 6.76,
    'F-VVS2-GOOD-EX-MEDIUM-GOOD': 6.76,
    'F-VVS2-EX-GOOD-MEDIUM-GOOD': 6.76,
    'F-VVS2-POOR-GOOD-MEDIUM-VG': 6.76,
    'F-VS2-VG-POOR-FAINT-VG': 6.76,
    'F-VS2-GOOD-GOOD-FAINT-VG': 6.76,
    'F-VVS2-VG-VG-MEDIUM-GOOD': 6.76,
    'G-VVS2-VG-VG-FAINT-GOOD': 6.76,
    'G-VS2-POOR-VG-NONE-VG': 6.76,
    'G-VVS2-POOR-GOOD-FAINT-VG': 6.76,
    'G-VVS2-EX-GOOD-FAINT-GOOD': 6.76,
    'G-VS2-EX-VG-NONE-GOOD': 6.76,
    'G-VS2-GOOD-GOOD-NONE-VG': 6.76,
    'G-VS2-VG-POOR-NONE-VG': 6.76,
    'G-VS2-VG-EX-NONE-GOOD': 6.76,
    'G-VVS2-GOOD-EX-FAINT-GOOD': 6.76,
    'G-VVS2-GOOD-POOR-FAINT-VG': 6.76,
    'H-VVS2-EX-GOOD-NONE-GOOD': 6.76,
    'H-VVS2-VG-VG-NONE-GOOD': 6.76,
    'H-VVS2-GOOD-EX-NONE-GOOD': 6.76,
    'H-VVS2-POOR-GOOD-NONE-VG': 6.76,
    'H-VVS2-GOOD-POOR-NONE-VG': 6.76,
    'I-VS2-GOOD-VG-STRONG-EX': 6.76,
    'I-VS2-VG-GOOD-STRONG-EX': 6.76,
    'I-VS2-EX-POOR-STRONG-EX': 6.76,
    'I-VS2-POOR-EX-STRONG-EX': 6.76,
    'I-VS2-EX-EX-STRONG-VG': 6.76,
    'J-VVS2-POOR-VG-STRONG-EX': 6.76,
    'J-VS2-EX-EX-MEDIUM-VG': 6.76,
    'J-VVS2-VG-POOR-STRONG-EX': 6.76,
    'J-VS2-VG-GOOD-MEDIUM-EX': 6.76,
    'J-VS2-POOR-EX-MEDIUM-EX': 6.76,
    'J-VVS2-EX-VG-STRONG-VG': 6.76,
    'J-VS2-EX-POOR-MEDIUM-EX': 6.76,
    'J-VVS2-VG-EX-STRONG-VG': 6.76,
    'J-VS2-GOOD-VG-MEDIUM-EX': 6.76,
    'J-VVS2-GOOD-GOOD-STRONG-EX': 6.76,
    'K-VVS2-VG-POOR-MEDIUM-EX': 6.76,
    'K-VS2-EX-EX-FAINT-VG': 6.76,
    'K-VVS2-EX-VG-MEDIUM-VG': 6.76,
    'K-VS2-EX-POOR-FAINT-EX': 6.76,
    'K-VVS2-POOR-VG-MEDIUM-EX': 6.76,
    'K-VVS2-VG-EX-MEDIUM-VG': 6.76,
    'K-VS2-VG-GOOD-FAINT-EX': 6.76,
    'K-VVS2-GOOD-GOOD-MEDIUM-EX': 6.76,
    'K-VS2-POOR-EX-FAINT-EX': 6.76,
    'K-VS2-GOOD-VG-FAINT-EX': 6.76,
    'L-VVS2-VG-POOR-FAINT-EX': 6.76,
    'L-VS2-POOR-EX-NONE-EX': 6.76,
    'L-VVS2-GOOD-GOOD-FAINT-EX': 6.76,
    'L-VS2-EX-EX-NONE-VG': 6.76,
    'L-VS2-EX-POOR-NONE-EX': 6.76,
    'L-VVS2-POOR-VG-FAINT-EX': 6.76,
    'L-VS2-GOOD-VG-NONE-EX': 6.76,
    'L-VVS2-EX-VG-FAINT-VG': 6.76,
    'L-VVS2-VG-EX-FAINT-VG': 6.76,
    'L-VS2-VG-GOOD-NONE-EX': 6.76,
    'M-VVS2-GOOD-GOOD-NONE-EX': 6.76,
    'M-VVS2-POOR-VG-NONE-EX': 6.76,
    'M-VVS2-VG-POOR-NONE-EX': 6.76,
    'M-VVS2-VG-EX-NONE-VG': 6.76,
    'M-VVS2-EX-VG-NONE-VG': 6.76,
    'D-IF-VG-POOR-NONE-POOR': 6.75,
    'D-IF-GOOD-GOOD-NONE-POOR': 6.75,
    'D-IF-POOR-VG-NONE-POOR': 6.75,
    'F-IF-POOR-EX-STRONG-GOOD': 6.75,
    'F-IF-EX-EX-STRONG-POOR': 6.75,
    'F-IF-GOOD-VG-STRONG-GOOD': 6.75,
    'F-IF-VG-GOOD-STRONG-GOOD': 6.75,
    'F-IF-EX-POOR-STRONG-GOOD': 6.75,
    'F-IF-POOR-POOR-STRONG-VG': 6.75,
    'G-IF-EX-EX-MEDIUM-POOR': 6.75,
    'G-IF-GOOD-VG-MEDIUM-GOOD': 6.75,
    'G-IF-VG-GOOD-MEDIUM-GOOD': 6.75,
    'G-IF-POOR-POOR-MEDIUM-VG': 6.75,
    'G-IF-EX-POOR-MEDIUM-GOOD': 6.75,
    'G-IF-POOR-EX-MEDIUM-GOOD': 6.75,
    'H-IF-POOR-EX-FAINT-GOOD': 6.75,
    'H-IF-EX-EX-FAINT-POOR': 6.75,
    'H-IF-VG-GOOD-FAINT-GOOD': 6.75,
    'H-IF-GOOD-VG-FAINT-GOOD': 6.75,
    'H-IF-POOR-POOR-FAINT-VG': 6.75,
    'H-IF-EX-POOR-FAINT-GOOD': 6.75,
    'I-IF-POOR-POOR-NONE-VG': 6.75,
    'I-IF-EX-POOR-NONE-GOOD': 6.75,
    'I-IF-POOR-EX-NONE-GOOD': 6.75,
    'I-IF-GOOD-VG-NONE-GOOD': 6.75,
    'I-IF-EX-EX-NONE-POOR': 6.75,
    'I-IF-VG-GOOD-NONE-GOOD': 6.75,
    'K-IF-POOR-GOOD-STRONG-EX': 6.75,
    'K-IF-EX-GOOD-STRONG-VG': 6.75,
    'K-IF-GOOD-POOR-STRONG-EX': 6.75,
    'K-IF-VG-VG-STRONG-VG': 6.75,
    'K-IF-GOOD-EX-STRONG-VG': 6.75,
    'L-IF-GOOD-EX-MEDIUM-VG': 6.75,
    'L-IF-GOOD-POOR-MEDIUM-EX': 6.75,
    'L-IF-POOR-GOOD-MEDIUM-EX': 6.75,
    'L-IF-EX-GOOD-MEDIUM-VG': 6.75,
    'L-IF-VG-VG-MEDIUM-VG': 6.75,
    'M-IF-VG-VG-FAINT-VG': 6.75,
    'M-IF-POOR-GOOD-FAINT-EX': 6.75,
    'M-IF-GOOD-EX-FAINT-VG': 6.75,
    'M-IF-EX-GOOD-FAINT-VG': 6.75,
    'M-IF-GOOD-POOR-FAINT-EX': 6.75,
    'D-I1-GOOD-VG-FAINT-VG': 6.74,
    'D-SI1-EX-VG-MEDIUM-GOOD': 6.74,
    'D-SI1-VG-POOR-MEDIUM-VG': 6.74,
    'D-I1-POOR-POOR-FAINT-EX': 6.74,
    'D-SI1-VG-EX-MEDIUM-GOOD': 6.74,
    'D-I1-POOR-EX-FAINT-VG': 6.74,
    'D-I1-VG-GOOD-FAINT-VG': 6.74,
    'D-I1-EX-POOR-FAINT-VG': 6.74,
    'D-I1-EX-EX-FAINT-GOOD': 6.74,
    'D-SI1-POOR-VG-MEDIUM-VG': 6.74,
    'D-SI1-GOOD-GOOD-MEDIUM-VG': 6.74,
    'E-SI1-VG-POOR-FAINT-VG': 6.74,
    'E-SI1-GOOD-GOOD-FAINT-VG': 6.74,
    'E-I1-VG-GOOD-NONE-VG': 6.74,
    'E-SI1-POOR-VG-FAINT-VG': 6.74,
    'E-SI1-VG-EX-FAINT-GOOD': 6.74,
    'E-I1-POOR-POOR-NONE-EX': 6.74,
    'E-I1-GOOD-VG-NONE-VG': 6.74,
    'E-I1-EX-POOR-NONE-VG': 6.74,
    'E-I1-POOR-EX-NONE-VG': 6.74,
    'E-I1-EX-EX-NONE-GOOD': 6.74,
    'E-SI1-EX-VG-FAINT-GOOD': 6.74,
    'F-SI1-POOR-VG-NONE-VG': 6.74,
    'F-SI1-EX-VG-NONE-GOOD': 6.74,
    'F-SI1-VG-POOR-NONE-VG': 6.74,
    'F-SI1-GOOD-GOOD-NONE-VG': 6.74,
    'F-SI1-VG-EX-NONE-GOOD': 6.74,
    'G-I1-GOOD-EX-STRONG-EX': 6.74,
    'G-I1-VG-VG-STRONG-EX': 6.74,
    'G-I1-EX-GOOD-STRONG-EX': 6.74,
    'H-I1-GOOD-EX-MEDIUM-EX': 6.74,
    'H-SI1-GOOD-VG-STRONG-EX': 6.74,
    'H-SI1-POOR-EX-STRONG-EX': 6.74,
    'H-I1-VG-VG-MEDIUM-EX': 6.74,
    'H-SI1-VG-GOOD-STRONG-EX': 6.74,
    'H-I1-EX-GOOD-MEDIUM-EX': 6.74,
    'H-SI1-EX-POOR-STRONG-EX': 6.74,
    'H-SI1-EX-EX-STRONG-VG': 6.74,
    'I-SI1-GOOD-VG-MEDIUM-EX': 6.74,
    'I-SI1-POOR-EX-MEDIUM-EX': 6.74,
    'I-I1-VG-VG-FAINT-EX': 6.74,
    'I-I1-EX-GOOD-FAINT-EX': 6.74,
    'I-I1-GOOD-EX-FAINT-EX': 6.74,
    'I-SI1-EX-POOR-MEDIUM-EX': 6.74,
    'I-SI1-EX-EX-MEDIUM-VG': 6.74,
    'I-SI1-VG-GOOD-MEDIUM-EX': 6.74,
    'J-I1-EX-GOOD-NONE-EX': 6.74,
    'J-I1-VG-VG-NONE-EX': 6.74,
    'J-SI1-GOOD-VG-FAINT-EX': 6.74,
    'J-SI1-POOR-EX-FAINT-EX': 6.74,
    'J-I1-GOOD-EX-NONE-EX': 6.74,
    'J-SI1-VG-GOOD-FAINT-EX': 6.74,
    'J-SI1-EX-POOR-FAINT-EX': 6.74,
    'J-SI1-EX-EX-FAINT-VG': 6.74,
    'K-SI1-GOOD-VG-NONE-EX': 6.74,
    'K-SI1-EX-EX-NONE-VG': 6.74,
    'K-SI1-EX-POOR-NONE-EX': 6.74,
    'K-SI1-POOR-EX-NONE-EX': 6.74,
    'K-SI1-VG-GOOD-NONE-EX': 6.74,
    'D-VS1-GOOD-EX-STRONG-GOOD': 6.73,
    'D-VS1-EX-GOOD-STRONG-GOOD': 6.73,
    'D-VS1-VG-VG-STRONG-GOOD': 6.73,
    'D-VS1-GOOD-POOR-STRONG-VG': 6.73,
    'D-VS1-POOR-GOOD-STRONG-VG': 6.73,
    'E-VS1-EX-GOOD-MEDIUM-GOOD': 6.73,
    'E-VVS1-VG-GOOD-STRONG-GOOD': 6.73,
    'E-VVS1-GOOD-VG-STRONG-GOOD': 6.73,
    'E-VS1-VG-VG-MEDIUM-GOOD': 6.73,
    'E-VS1-POOR-GOOD-MEDIUM-VG': 6.73,
    'E-VS1-GOOD-EX-MEDIUM-GOOD': 6.73,
    'E-VVS1-POOR-EX-STRONG-GOOD': 6.73,
    'E-VS1-GOOD-POOR-MEDIUM-VG': 6.73,
    'E-VVS1-EX-EX-STRONG-POOR': 6.73,
    'E-VVS1-EX-POOR-STRONG-GOOD': 6.73,
    'E-VVS1-POOR-POOR-STRONG-VG': 6.73,
    'F-VS1-POOR-GOOD-FAINT-VG': 6.73,
    'F-VS1-VG-VG-FAINT-GOOD': 6.73,
    'F-VS1-GOOD-EX-FAINT-GOOD': 6.73,
    'F-VVS1-EX-EX-MEDIUM-POOR': 6.73,
    'F-VS1-EX-GOOD-FAINT-GOOD': 6.73,
    'F-VVS1-EX-POOR-MEDIUM-GOOD': 6.73,
    'F-VVS1-POOR-EX-MEDIUM-GOOD': 6.73,
    'F-VVS1-VG-GOOD-MEDIUM-GOOD': 6.73,
    'F-VVS1-GOOD-VG-MEDIUM-GOOD': 6.73,
    'F-VS1-GOOD-POOR-FAINT-VG': 6.73,
    'F-VVS1-POOR-POOR-MEDIUM-VG': 6.73,
    'G-VVS1-EX-EX-FAINT-POOR': 6.73,
    'G-VVS1-EX-POOR-FAINT-GOOD': 6.73,
    'G-VVS1-POOR-POOR-FAINT-VG': 6.73,
    'G-VS1-POOR-GOOD-NONE-VG': 6.73,
    'G-VVS1-VG-GOOD-FAINT-GOOD': 6.73,
    'G-VS1-EX-GOOD-NONE-GOOD': 6.73,
    'G-VVS1-GOOD-VG-FAINT-GOOD': 6.73,
    'G-VS1-GOOD-EX-NONE-GOOD': 6.73,
    'G-VVS1-POOR-EX-FAINT-GOOD': 6.73,
    'G-VS1-GOOD-POOR-NONE-VG': 6.73,
    'G-VS1-VG-VG-NONE-GOOD': 6.73,
    'H-VVS1-VG-GOOD-NONE-GOOD': 6.73,
    'H-VVS1-EX-POOR-NONE-GOOD': 6.73,
    'H-VVS1-EX-EX-NONE-POOR': 6.73,
    'H-VVS1-POOR-EX-NONE-GOOD': 6.73,
    'H-VVS1-POOR-POOR-NONE-VG': 6.73,
    'H-VVS1-GOOD-VG-NONE-GOOD': 6.73,
    'I-VS1-POOR-VG-STRONG-EX': 6.73,
    'I-VS1-GOOD-GOOD-STRONG-EX': 6.73,
    'I-VS1-VG-POOR-STRONG-EX': 6.73,
    'I-VS1-VG-EX-STRONG-VG': 6.73,
    'I-VS1-EX-VG-STRONG-VG': 6.73,
    'J-VVS1-GOOD-EX-STRONG-VG': 6.73,
    'J-VS1-VG-EX-MEDIUM-VG': 6.73,
    'J-VVS1-EX-GOOD-STRONG-VG': 6.73,
    'J-VVS1-GOOD-POOR-STRONG-EX': 6.73,
    'J-VS1-GOOD-GOOD-MEDIUM-EX': 6.73,
    'J-VVS1-POOR-GOOD-STRONG-EX': 6.73,
    'J-VS1-POOR-VG-MEDIUM-EX': 6.73,
    'J-VS1-VG-POOR-MEDIUM-EX': 6.73,
    'J-VVS1-VG-VG-STRONG-VG': 6.73,
    'J-VS1-EX-VG-MEDIUM-VG': 6.73,
    'K-VVS1-GOOD-EX-MEDIUM-VG': 6.73,
    'K-VVS1-GOOD-POOR-MEDIUM-EX': 6.73,
    'K-VVS1-POOR-GOOD-MEDIUM-EX': 6.73,
    'K-VS1-POOR-VG-FAINT-EX': 6.73,
    'K-VS1-VG-EX-FAINT-VG': 6.73,
    'K-VS1-VG-POOR-FAINT-EX': 6.73,
    'K-VS1-GOOD-GOOD-FAINT-EX': 6.73,
    'K-VS1-EX-VG-FAINT-VG': 6.73,
    'K-VVS1-VG-VG-MEDIUM-VG': 6.73,
    'K-VVS1-EX-GOOD-MEDIUM-VG': 6.73,
    'L-VVS1-POOR-GOOD-FAINT-EX': 6.73,
    'L-VS1-EX-VG-NONE-VG': 6.73,
    'L-VS1-GOOD-GOOD-NONE-EX': 6.73,
    'L-VVS1-GOOD-POOR-FAINT-EX': 6.73,
    'L-VS1-VG-EX-NONE-VG': 6.73,
    'L-VVS1-EX-GOOD-FAINT-VG': 6.73,
    'L-VVS1-GOOD-EX-FAINT-VG': 6.73,
    'L-VS1-POOR-VG-NONE-EX': 6.73,
    'L-VS1-VG-POOR-NONE-EX': 6.73,
    'L-VVS1-VG-VG-FAINT-VG': 6.73,
    'M-VVS1-VG-VG-NONE-VG': 6.73,
    'M-VVS1-POOR-GOOD-NONE-EX': 6.73,
    'M-VVS1-GOOD-EX-NONE-VG': 6.73,
    'M-VVS1-EX-GOOD-NONE-VG': 6.73,
    'M-VVS1-GOOD-POOR-NONE-EX': 6.73,
    'D-I2-EX-EX-NONE-GOOD': 6.72,
    'D-I2-POOR-EX-NONE-VG': 6.72,
    'D-I2-GOOD-VG-NONE-VG': 6.72,
    'D-I2-VG-GOOD-NONE-VG': 6.72,
    'D-I2-POOR-POOR-NONE-EX': 6.72,
    'D-I2-EX-POOR-NONE-VG': 6.72,
    'D-SI2-VG-POOR-FAINT-VG': 6.72,
    'D-SI2-VG-EX-FAINT-GOOD': 6.72,
    'D-SI2-POOR-VG-FAINT-VG': 6.72,
    'D-SI2-EX-VG-FAINT-GOOD': 6.72,
    'D-SI2-GOOD-GOOD-FAINT-VG': 6.72,
    'E-SI2-EX-VG-NONE-GOOD': 6.72,
    'E-SI2-VG-EX-NONE-GOOD': 6.72,
    'E-SI2-VG-POOR-NONE-VG': 6.72,
    'E-SI2-POOR-VG-NONE-VG': 6.72,
    'E-SI2-GOOD-GOOD-NONE-VG': 6.72,
    'F-I2-GOOD-EX-STRONG-EX': 6.72,
    'F-I2-EX-GOOD-STRONG-EX': 6.72,
    'F-I2-VG-VG-STRONG-EX': 6.72,
    'G-I2-EX-GOOD-MEDIUM-EX': 6.72,
    'G-I2-VG-VG-MEDIUM-EX': 6.72,
    'G-I2-GOOD-EX-MEDIUM-EX': 6.72,
    'G-SI2-EX-EX-STRONG-VG': 6.72,
    'G-SI2-GOOD-VG-STRONG-EX': 6.72,
    'G-SI2-POOR-EX-STRONG-EX': 6.72,
    'G-SI2-VG-GOOD-STRONG-EX': 6.72,
    'G-SI2-EX-POOR-STRONG-EX': 6.72,
    'H-I2-GOOD-EX-FAINT-EX': 6.72,
    'H-SI2-EX-EX-MEDIUM-VG': 6.72,
    'H-SI2-POOR-EX-MEDIUM-EX': 6.72,
    'H-SI2-VG-GOOD-MEDIUM-EX': 6.72,
    'H-I2-EX-GOOD-FAINT-EX': 6.72,
    'H-I2-VG-VG-FAINT-EX': 6.72,
    'H-SI2-EX-POOR-MEDIUM-EX': 6.72,
    'H-SI2-GOOD-VG-MEDIUM-EX': 6.72,
    'I-I2-VG-VG-NONE-EX': 6.72,
    'I-I2-GOOD-EX-NONE-EX': 6.72,
    'I-SI2-GOOD-VG-FAINT-EX': 6.72,
    'I-I2-EX-GOOD-NONE-EX': 6.72,
    'I-SI2-EX-EX-FAINT-VG': 6.72,
    'I-SI2-VG-GOOD-FAINT-EX': 6.72,
    'I-SI2-EX-POOR-FAINT-EX': 6.72,
    'I-SI2-POOR-EX-FAINT-EX': 6.72,
    'J-SI2-VG-GOOD-NONE-EX': 6.72,
    'J-SI2-EX-POOR-NONE-EX': 6.72,
    'J-SI2-EX-EX-NONE-VG': 6.72,
    'J-SI2-POOR-EX-NONE-EX': 6.72,
    'J-SI2-GOOD-VG-NONE-EX': 6.72,
    'D-VVS2-POOR-POOR-STRONG-VG': 6.71,
    'D-VVS2-POOR-EX-STRONG-GOOD': 6.71,
    'D-VS2-GOOD-POOR-MEDIUM-VG': 6.71,
    'D-VS2-POOR-GOOD-MEDIUM-VG': 6.71,
    'D-VS2-GOOD-EX-MEDIUM-GOOD': 6.71,
    'D-VVS2-VG-GOOD-STRONG-GOOD': 6.71,
    'D-VVS2-EX-EX-STRONG-POOR': 6.71,
    'D-VVS2-GOOD-VG-STRONG-GOOD': 6.71,
    'D-VVS2-EX-POOR-STRONG-GOOD': 6.71,
    'D-VS2-VG-VG-MEDIUM-GOOD': 6.71,
    'D-VS2-EX-GOOD-MEDIUM-GOOD': 6.71,
    'E-VS2-GOOD-EX-FAINT-GOOD': 6.71,
    'E-VVS2-GOOD-VG-MEDIUM-GOOD': 6.71,
    'E-VVS2-POOR-EX-MEDIUM-GOOD': 6.71,
    'E-VS2-POOR-GOOD-FAINT-VG': 6.71,
    'E-VVS2-EX-EX-MEDIUM-POOR': 6.71,
    'E-VS2-GOOD-POOR-FAINT-VG': 6.71,
    'E-VS2-VG-VG-FAINT-GOOD': 6.71,
    'E-VVS2-EX-POOR-MEDIUM-GOOD': 6.71,
    'E-VS2-EX-GOOD-FAINT-GOOD': 6.71,
    'E-VVS2-VG-GOOD-MEDIUM-GOOD': 6.71,
    'E-VVS2-POOR-POOR-MEDIUM-VG': 6.71,
    'F-VS2-GOOD-POOR-NONE-VG': 6.71,
    'F-VVS2-VG-GOOD-FAINT-GOOD': 6.71,
    'F-VVS2-EX-POOR-FAINT-GOOD': 6.71,
    'F-VS2-POOR-GOOD-NONE-VG': 6.71,
    'F-VS2-GOOD-EX-NONE-GOOD': 6.71,
    'F-VVS2-EX-EX-FAINT-POOR': 6.71,
    'F-VS2-VG-VG-NONE-GOOD': 6.71,
    'F-VS2-EX-GOOD-NONE-GOOD': 6.71,
    'F-VVS2-GOOD-VG-FAINT-GOOD': 6.71,
    'F-VVS2-POOR-POOR-FAINT-VG': 6.71,
    'F-VVS2-POOR-EX-FAINT-GOOD': 6.71,
    'G-VVS2-GOOD-VG-NONE-GOOD': 6.71,
    'G-VVS2-POOR-EX-NONE-GOOD': 6.71,
    'G-VVS2-POOR-POOR-NONE-VG': 6.71,
    'G-VVS2-VG-GOOD-NONE-GOOD': 6.71,
    'G-VVS2-EX-POOR-NONE-GOOD': 6.71,
    'G-VVS2-EX-EX-NONE-POOR': 6.71,
    'H-VS2-VG-POOR-STRONG-EX': 6.71,
    'H-VS2-VG-EX-STRONG-VG': 6.71,
    'H-VS2-EX-VG-STRONG-VG': 6.71,
    'H-VS2-POOR-VG-STRONG-EX': 6.71,
    'H-VS2-GOOD-GOOD-STRONG-EX': 6.71,
    'I-VVS2-EX-GOOD-STRONG-VG': 6.71,
    'I-VS2-EX-VG-MEDIUM-VG': 6.71,
    'I-VVS2-GOOD-EX-STRONG-VG': 6.71,
    'I-VVS2-POOR-GOOD-STRONG-EX': 6.71,
    'I-VVS2-VG-VG-STRONG-VG': 6.71,
    'I-VS2-VG-EX-MEDIUM-VG': 6.71,
    'I-VVS2-GOOD-POOR-STRONG-EX': 6.71,
    'I-VS2-POOR-VG-MEDIUM-EX': 6.71,
    'I-VS2-GOOD-GOOD-MEDIUM-EX': 6.71,
    'I-VS2-VG-POOR-MEDIUM-EX': 6.71,
    'J-VS2-VG-EX-FAINT-VG': 6.71,
    'J-VVS2-GOOD-POOR-MEDIUM-EX': 6.71,
    'J-VS2-VG-POOR-FAINT-EX': 6.71,
    'J-VS2-EX-VG-FAINT-VG': 6.71,
    'J-VVS2-POOR-GOOD-MEDIUM-EX': 6.71,
    'J-VS2-POOR-VG-FAINT-EX': 6.71,
    'J-VVS2-VG-VG-MEDIUM-VG': 6.71,
    'J-VVS2-GOOD-EX-MEDIUM-VG': 6.71,
    'J-VVS2-EX-GOOD-MEDIUM-VG': 6.71,
    'J-VS2-GOOD-GOOD-FAINT-EX': 6.71,
    'K-VS2-VG-EX-NONE-VG': 6.71,
    'K-VS2-VG-POOR-NONE-EX': 6.71,
    'K-VS2-EX-VG-NONE-VG': 6.71,
    'K-VS2-GOOD-GOOD-NONE-EX': 6.71,
    'K-VVS2-GOOD-EX-FAINT-VG': 6.71,
    'K-VVS2-POOR-GOOD-FAINT-EX': 6.71,
    'K-VS2-POOR-VG-NONE-EX': 6.71,
    'K-VVS2-GOOD-POOR-FAINT-EX': 6.71,
    'K-VVS2-EX-GOOD-FAINT-VG': 6.71,
    'K-VVS2-VG-VG-FAINT-VG': 6.71,
    'L-VVS2-EX-GOOD-NONE-VG': 6.71,
    'L-VVS2-POOR-GOOD-NONE-EX': 6.71,
    'L-VVS2-GOOD-POOR-NONE-EX': 6.71,
    'L-VVS2-VG-VG-NONE-VG': 6.71,
    'L-VVS2-GOOD-EX-NONE-VG': 6.71,
    'M-VS2-EX-EX-STRONG-EX': 6.71,
    'E-IF-VG-POOR-STRONG-GOOD': 6.7,
    'E-IF-POOR-VG-STRONG-GOOD': 6.7,
    'E-IF-GOOD-GOOD-STRONG-GOOD': 6.7,
    'E-IF-VG-EX-STRONG-POOR': 6.7,
    'E-IF-EX-VG-STRONG-POOR': 6.7,
    'F-IF-EX-VG-MEDIUM-POOR': 6.7,
    'F-IF-VG-POOR-MEDIUM-GOOD': 6.7,
    'F-IF-GOOD-GOOD-MEDIUM-GOOD': 6.7,
    'F-IF-VG-EX-MEDIUM-POOR': 6.7,
    'F-IF-POOR-VG-MEDIUM-GOOD': 6.7,
    'G-IF-GOOD-GOOD-FAINT-GOOD': 6.7,
    'G-IF-EX-VG-FAINT-POOR': 6.7,
    'G-IF-VG-EX-FAINT-POOR': 6.7,
    'G-IF-VG-POOR-FAINT-GOOD': 6.7,
    'G-IF-POOR-VG-FAINT-GOOD': 6.7,
    'H-IF-VG-EX-NONE-POOR': 6.7,
    'H-IF-EX-VG-NONE-POOR': 6.7,
    'H-IF-GOOD-GOOD-NONE-GOOD': 6.7,
    'H-IF-POOR-VG-NONE-GOOD': 6.7,
    'H-IF-VG-POOR-NONE-GOOD': 6.7,
    'J-IF-POOR-EX-STRONG-VG': 6.7,
    'J-IF-POOR-POOR-STRONG-EX': 6.7,
    'J-IF-EX-POOR-STRONG-VG': 6.7,
    'J-IF-EX-EX-STRONG-GOOD': 6.7,
    'J-IF-GOOD-VG-STRONG-VG': 6.7,
    'J-IF-VG-GOOD-STRONG-VG': 6.7,
    'K-IF-EX-POOR-MEDIUM-VG': 6.7,
    'K-IF-POOR-EX-MEDIUM-VG': 6.7,
    'K-IF-GOOD-VG-MEDIUM-VG': 6.7,
    'K-IF-POOR-POOR-MEDIUM-EX': 6.7,
    'K-IF-VG-GOOD-MEDIUM-VG': 6.7,
    'K-IF-EX-EX-MEDIUM-GOOD': 6.7,
    'L-IF-POOR-POOR-FAINT-EX': 6.7,
    'L-IF-VG-GOOD-FAINT-VG': 6.7,
    'L-IF-POOR-EX-FAINT-VG': 6.7,
    'L-IF-EX-POOR-FAINT-VG': 6.7,
    'L-IF-GOOD-VG-FAINT-VG': 6.7,
    'L-IF-EX-EX-FAINT-GOOD': 6.7,
    'M-IF-EX-EX-NONE-GOOD': 6.7,
    'M-IF-VG-GOOD-NONE-VG': 6.7,
    'M-IF-POOR-EX-NONE-VG': 6.7,
    'M-IF-POOR-POOR-NONE-EX': 6.7,
    'M-IF-EX-POOR-NONE-VG': 6.7,
    'M-IF-GOOD-VG-NONE-VG': 6.7,
    'D-I1-VG-POOR-NONE-VG': 6.69,
    'D-I1-GOOD-GOOD-NONE-VG': 6.69,
    'D-I1-POOR-VG-NONE-VG': 6.69,
    'D-SI1-GOOD-EX-FAINT-GOOD': 6.69,
    'D-SI1-VG-VG-FAINT-GOOD': 6.69,
    'D-SI1-EX-GOOD-FAINT-GOOD': 6.69,
    'D-SI1-POOR-GOOD-FAINT-VG': 6.69,
    'D-SI1-GOOD-POOR-FAINT-VG': 6.69,
    'D-I1-EX-VG-NONE-GOOD': 6.69,
    'D-I1-VG-EX-NONE-GOOD': 6.69,
    'E-SI1-GOOD-EX-NONE-GOOD': 6.69,
    'E-SI1-GOOD-POOR-NONE-VG': 6.69,
    'E-SI1-POOR-GOOD-NONE-VG': 6.69,
    'E-SI1-VG-VG-NONE-GOOD': 6.69,
    'E-SI1-EX-GOOD-NONE-GOOD': 6.69,
    'F-I1-EX-EX-STRONG-VG': 6.69,
    'F-I1-POOR-EX-STRONG-EX': 6.69,
    'F-I1-GOOD-VG-STRONG-EX': 6.69,
    'F-I1-VG-GOOD-STRONG-EX': 6.69,
    'F-I1-EX-POOR-STRONG-EX': 6.69,
    'G-I1-POOR-EX-MEDIUM-EX': 6.69,
    'G-SI1-POOR-VG-STRONG-EX': 6.69,
    'G-I1-EX-POOR-MEDIUM-EX': 6.69,
    'G-SI1-EX-VG-STRONG-VG': 6.69,
    'G-I1-EX-EX-MEDIUM-VG': 6.69,
    'G-SI1-VG-POOR-STRONG-EX': 6.69,
    'G-I1-VG-GOOD-MEDIUM-EX': 6.69,
    'G-SI1-VG-EX-STRONG-VG': 6.69,
    'G-I1-GOOD-VG-MEDIUM-EX': 6.69,
    'G-SI1-GOOD-GOOD-STRONG-EX': 6.69,
    'H-I1-EX-POOR-FAINT-EX': 6.69,
    'H-I1-VG-GOOD-FAINT-EX': 6.69,
    'H-I1-POOR-EX-FAINT-EX': 6.69,
    'H-I1-GOOD-VG-FAINT-EX': 6.69,
    'H-I1-EX-EX-FAINT-VG': 6.69,
    'H-SI1-VG-POOR-MEDIUM-EX': 6.69,
    'H-SI1-EX-VG-MEDIUM-VG': 6.69,
    'H-SI1-GOOD-GOOD-MEDIUM-EX': 6.69,
    'H-SI1-POOR-VG-MEDIUM-EX': 6.69,
    'H-SI1-VG-EX-MEDIUM-VG': 6.69,
    'I-I1-POOR-EX-NONE-EX': 6.69,
    'I-I1-EX-POOR-NONE-EX': 6.69,
    'I-I1-VG-GOOD-NONE-EX': 6.69,
    'I-I1-GOOD-VG-NONE-EX': 6.69,
    'I-I1-EX-EX-NONE-VG': 6.69,
    'I-SI1-VG-POOR-FAINT-EX': 6.69,
    'I-SI1-GOOD-GOOD-FAINT-EX': 6.69,
    'I-SI1-POOR-VG-FAINT-EX': 6.69,
    'I-SI1-EX-VG-FAINT-VG': 6.69,
    'I-SI1-VG-EX-FAINT-VG': 6.69,
    'J-SI1-EX-VG-NONE-VG': 6.69,
    'J-SI1-GOOD-GOOD-NONE-EX': 6.69,
    'J-SI1-VG-POOR-NONE-EX': 6.69,
    'J-SI1-POOR-VG-NONE-EX': 6.69,
    'J-SI1-VG-EX-NONE-VG': 6.69,
    'L-SI1-EX-EX-STRONG-EX': 6.69,
    'M-SI1-EX-EX-MEDIUM-EX': 6.69,
    'D-VS1-EX-EX-MEDIUM-POOR': 6.68,
    'D-VS1-GOOD-VG-MEDIUM-GOOD': 6.68,
    'D-VVS1-EX-VG-STRONG-POOR': 6.68,
    'D-VVS1-GOOD-GOOD-STRONG-GOOD': 6.68,
    'D-VVS1-VG-POOR-STRONG-GOOD': 6.68,
    'D-VS1-POOR-EX-MEDIUM-GOOD': 6.68,
    'D-VVS1-POOR-VG-STRONG-GOOD': 6.68,
    'D-VS1-VG-GOOD-MEDIUM-GOOD': 6.68,
    'D-VS1-EX-POOR-MEDIUM-GOOD': 6.68,
    'D-VS1-POOR-POOR-MEDIUM-VG': 6.68,
    'D-VVS1-VG-EX-STRONG-POOR': 6.68,
    'E-VVS1-GOOD-GOOD-MEDIUM-GOOD': 6.68,
    'E-VS1-POOR-EX-FAINT-GOOD': 6.68,
    'E-VS1-POOR-POOR-FAINT-VG': 6.68,
    'E-VVS1-VG-EX-MEDIUM-POOR': 6.68,
    'E-VS1-GOOD-VG-FAINT-GOOD': 6.68,
    'E-VVS1-EX-VG-MEDIUM-POOR': 6.68,
    'E-VS1-VG-GOOD-FAINT-GOOD': 6.68,
    'E-VVS1-VG-POOR-MEDIUM-GOOD': 6.68,
    'E-VS1-EX-POOR-FAINT-GOOD': 6.68,
    'E-VVS1-POOR-VG-MEDIUM-GOOD': 6.68,
    'E-VS1-EX-EX-FAINT-POOR': 6.68,
    'F-VS1-EX-POOR-NONE-GOOD': 6.68,
    'F-VS1-POOR-POOR-NONE-VG': 6.68,
    'F-VS1-VG-GOOD-NONE-GOOD': 6.68,
    'F-VS1-POOR-EX-NONE-GOOD': 6.68,
    'F-VS1-GOOD-VG-NONE-GOOD': 6.68,
    'F-VVS1-VG-POOR-FAINT-GOOD': 6.68,
    'F-VVS1-VG-EX-FAINT-POOR': 6.68,
    'F-VVS1-POOR-VG-FAINT-GOOD': 6.68,
    'F-VVS1-GOOD-GOOD-FAINT-GOOD': 6.68,
    'F-VS1-EX-EX-NONE-POOR': 6.68,
    'F-VVS1-EX-VG-FAINT-POOR': 6.68,
    'G-VVS1-VG-POOR-NONE-GOOD': 6.68,
    'G-VVS1-GOOD-GOOD-NONE-GOOD': 6.68,
    'G-VVS1-POOR-VG-NONE-GOOD': 6.68,
    'G-VVS1-EX-VG-NONE-POOR': 6.68,
    'G-VVS1-VG-EX-NONE-POOR': 6.68,
    'H-VS1-GOOD-POOR-STRONG-EX': 6.68,
    'H-VS1-POOR-GOOD-STRONG-EX': 6.68,
    'H-VS1-EX-GOOD-STRONG-VG': 6.68,
    'H-VS1-GOOD-EX-STRONG-VG': 6.68,
    'H-VS1-VG-VG-STRONG-VG': 6.68,
    'I-VVS1-POOR-EX-STRONG-VG': 6.68,
    'I-VS1-VG-VG-MEDIUM-VG': 6.68,
    'I-VVS1-GOOD-VG-STRONG-VG': 6.68,
    'I-VS1-POOR-GOOD-MEDIUM-EX': 6.68,
    'I-VVS1-POOR-POOR-STRONG-EX': 6.68,
    'I-VS1-GOOD-POOR-MEDIUM-EX': 6.68,
    'I-VVS1-EX-EX-STRONG-GOOD': 6.68,
    'I-VS1-GOOD-EX-MEDIUM-VG': 6.68,
    'I-VS1-EX-GOOD-MEDIUM-VG': 6.68,
    'I-VVS1-EX-POOR-STRONG-VG': 6.68,
    'I-VVS1-VG-GOOD-STRONG-VG': 6.68,
    'J-VVS1-GOOD-VG-MEDIUM-VG': 6.68,
    'J-VVS1-EX-EX-MEDIUM-GOOD': 6.68,
    'J-VS1-GOOD-EX-FAINT-VG': 6.68,
    'J-VS1-VG-VG-FAINT-VG': 6.68,
    'J-VVS1-EX-POOR-MEDIUM-VG': 6.68,
    'J-VS1-EX-GOOD-FAINT-VG': 6.68,
    'J-VS1-POOR-GOOD-FAINT-EX': 6.68,
    'J-VVS1-POOR-EX-MEDIUM-VG': 6.68,
    'J-VS1-GOOD-POOR-FAINT-EX': 6.68,
    'J-VVS1-POOR-POOR-MEDIUM-EX': 6.68,
    'J-VVS1-VG-GOOD-MEDIUM-VG': 6.68,
    'K-VS1-EX-GOOD-NONE-VG': 6.68,
    'K-VVS1-EX-POOR-FAINT-VG': 6.68,
    'K-VVS1-EX-EX-FAINT-GOOD': 6.68,
    'K-VVS1-VG-GOOD-FAINT-VG': 6.68,
    'K-VVS1-POOR-EX-FAINT-VG': 6.68,
    'K-VS1-POOR-GOOD-NONE-EX': 6.68,
    'K-VVS1-GOOD-VG-FAINT-VG': 6.68,
    'K-VS1-GOOD-POOR-NONE-EX': 6.68,
    'K-VS1-VG-VG-NONE-VG': 6.68,
    'K-VS1-GOOD-EX-NONE-VG': 6.68,
    'K-VVS1-POOR-POOR-FAINT-EX': 6.68,
    'L-VVS1-EX-EX-NONE-GOOD': 6.68,
    'L-VVS1-EX-POOR-NONE-VG': 6.68,
    'L-VVS1-GOOD-VG-NONE-VG': 6.68,
    'L-VVS1-POOR-EX-NONE-VG': 6.68,
    'L-VVS1-POOR-POOR-NONE-EX': 6.68,
    'L-VVS1-VG-GOOD-NONE-VG': 6.68,
    'M-VS1-EX-VG-STRONG-EX': 6.68,
    'M-VS1-VG-EX-STRONG-EX': 6.68,
    'D-SI2-GOOD-EX-NONE-GOOD': 6.67,
    'D-SI2-VG-VG-NONE-GOOD': 6.67,
    'D-SI2-GOOD-POOR-NONE-VG': 6.67,
    'D-SI2-EX-GOOD-NONE-GOOD': 6.67,
    'D-SI2-POOR-GOOD-NONE-VG': 6.67,
    'E-I2-GOOD-VG-STRONG-EX': 6.67,
    'E-I2-VG-GOOD-STRONG-EX': 6.67,
    'E-I2-POOR-EX-STRONG-EX': 6.67,
    'E-I2-EX-EX-STRONG-VG': 6.67,
    'E-I2-EX-POOR-STRONG-EX': 6.67,
    'F-I2-EX-POOR-MEDIUM-EX': 6.67,
    'F-I2-EX-EX-MEDIUM-VG': 6.67,
    'F-SI2-POOR-VG-STRONG-EX': 6.67,
    'F-I2-VG-GOOD-MEDIUM-EX': 6.67,
    'F-I2-POOR-EX-MEDIUM-EX': 6.67,
    'F-SI2-GOOD-GOOD-STRONG-EX': 6.67,
    'F-SI2-EX-VG-STRONG-VG': 6.67,
    'F-SI2-VG-POOR-STRONG-EX': 6.67,
    'F-SI2-VG-EX-STRONG-VG': 6.67,
    'F-I2-GOOD-VG-MEDIUM-EX': 6.67,
    'G-SI2-VG-EX-MEDIUM-VG': 6.67,
    'G-SI2-VG-POOR-MEDIUM-EX': 6.67,
    'G-SI2-GOOD-GOOD-MEDIUM-EX': 6.67,
    'G-SI2-EX-VG-MEDIUM-VG': 6.67,
    'G-SI2-POOR-VG-MEDIUM-EX': 6.67,
    'G-I2-EX-EX-FAINT-VG': 6.67,
    'G-I2-EX-POOR-FAINT-EX': 6.67,
    'G-I2-VG-GOOD-FAINT-EX': 6.67,
    'G-I2-POOR-EX-FAINT-EX': 6.67,
    'G-I2-GOOD-VG-FAINT-EX': 6.67,
    'H-I2-EX-EX-NONE-VG': 6.67,
    'H-I2-EX-POOR-NONE-EX': 6.67,
    'H-I2-VG-GOOD-NONE-EX': 6.67,
    'H-I2-GOOD-VG-NONE-EX': 6.67,
    'H-I2-POOR-EX-NONE-EX': 6.67,
    'H-SI2-POOR-VG-FAINT-EX': 6.67,
    'H-SI2-GOOD-GOOD-FAINT-EX': 6.67,
    'H-SI2-VG-POOR-FAINT-EX': 6.67,
    'H-SI2-VG-EX-FAINT-VG': 6.67,
    'H-SI2-EX-VG-FAINT-VG': 6.67,
    'I-SI2-EX-VG-NONE-VG': 6.67,
    'I-SI2-VG-EX-NONE-VG': 6.67,
    'I-SI2-POOR-VG-NONE-EX': 6.67,
    'I-SI2-GOOD-GOOD-NONE-EX': 6.67,
    'I-SI2-VG-POOR-NONE-EX': 6.67,
    'K-SI2-EX-EX-STRONG-EX': 6.67,
    'L-SI2-EX-EX-MEDIUM-EX': 6.67,
    'M-SI2-EX-EX-FAINT-EX': 6.67,
    'D-VVS2-POOR-VG-MEDIUM-GOOD': 6.66,
    'D-VVS2-GOOD-GOOD-MEDIUM-GOOD': 6.66,
    'D-VS2-POOR-POOR-FAINT-VG': 6.66,
    'D-VVS2-VG-EX-MEDIUM-POOR': 6.66,
    'D-VVS2-EX-VG-MEDIUM-POOR': 6.66,
    'D-VS2-VG-GOOD-FAINT-GOOD': 6.66,
    'D-VS2-EX-EX-FAINT-POOR': 6.66,
    'D-VVS2-VG-POOR-MEDIUM-GOOD': 6.66,
    'D-VS2-GOOD-VG-FAINT-GOOD': 6.66,
    'D-VS2-POOR-EX-FAINT-GOOD': 6.66,
    'D-VS2-EX-POOR-FAINT-GOOD': 6.66,
    'E-VS2-POOR-POOR-NONE-VG': 6.66,
    'E-VVS2-EX-VG-FAINT-POOR': 6.66,
    'E-VVS2-GOOD-GOOD-FAINT-GOOD': 6.66,
    'E-VS2-EX-POOR-NONE-GOOD': 6.66,
    'E-VVS2-VG-EX-FAINT-POOR': 6.66,
    'E-VVS2-VG-POOR-FAINT-GOOD': 6.66,
    'E-VS2-VG-GOOD-NONE-GOOD': 6.66,
    'E-VS2-EX-EX-NONE-POOR': 6.66,
    'E-VS2-GOOD-VG-NONE-GOOD': 6.66,
    'E-VS2-POOR-EX-NONE-GOOD': 6.66,
    'E-VVS2-POOR-VG-FAINT-GOOD': 6.66,
    'F-VVS2-POOR-VG-NONE-GOOD': 6.66,
    'F-VVS2-GOOD-GOOD-NONE-GOOD': 6.66,
    'F-VVS2-EX-VG-NONE-POOR': 6.66,
    'F-VVS2-VG-EX-NONE-POOR': 6.66,
    'F-VVS2-VG-POOR-NONE-GOOD': 6.66,
    'G-VS2-GOOD-EX-STRONG-VG': 6.66,
    'G-VS2-VG-VG-STRONG-VG': 6.66,
    'G-VS2-EX-GOOD-STRONG-VG': 6.66,
    'G-VS2-GOOD-POOR-STRONG-EX': 6.66,
    'G-VS2-POOR-GOOD-STRONG-EX': 6.66,
    'H-VVS2-EX-POOR-STRONG-VG': 6.66,
    'H-VS2-VG-VG-MEDIUM-VG': 6.66,
    'H-VS2-EX-GOOD-MEDIUM-VG': 6.66,
    'H-VS2-GOOD-POOR-MEDIUM-EX': 6.66,
    'H-VS2-POOR-GOOD-MEDIUM-EX': 6.66,
    'H-VS2-GOOD-EX-MEDIUM-VG': 6.66,
    'H-VVS2-VG-GOOD-STRONG-VG': 6.66,
    'H-VVS2-GOOD-VG-STRONG-VG': 6.66,
    'H-VVS2-POOR-EX-STRONG-VG': 6.66,
    'H-VVS2-POOR-POOR-STRONG-EX': 6.66,
    'H-VVS2-EX-EX-STRONG-GOOD': 6.66,
    'I-VVS2-POOR-EX-MEDIUM-VG': 6.66,
    'I-VVS2-POOR-POOR-MEDIUM-EX': 6.66,
    'I-VVS2-EX-POOR-MEDIUM-VG': 6.66,
    'I-VVS2-EX-EX-MEDIUM-GOOD': 6.66,
    'I-VVS2-VG-GOOD-MEDIUM-VG': 6.66,
    'I-VVS2-GOOD-VG-MEDIUM-VG': 6.66,
    'I-VS2-GOOD-POOR-FAINT-EX': 6.66,
    'I-VS2-GOOD-EX-FAINT-VG': 6.66,
    'I-VS2-POOR-GOOD-FAINT-EX': 6.66,
    'I-VS2-VG-VG-FAINT-VG': 6.66,
    'I-VS2-EX-GOOD-FAINT-VG': 6.66,
    'J-VS2-EX-GOOD-NONE-VG': 6.66,
    'J-VS2-VG-VG-NONE-VG': 6.66,
    'J-VVS2-EX-EX-FAINT-GOOD': 6.66,
    'J-VS2-POOR-GOOD-NONE-EX': 6.66,
    'J-VVS2-EX-POOR-FAINT-VG': 6.66,
    'J-VS2-GOOD-EX-NONE-VG': 6.66,
    'J-VS2-GOOD-POOR-NONE-EX': 6.66,
    'J-VVS2-VG-GOOD-FAINT-VG': 6.66,
    'J-VVS2-POOR-EX-FAINT-VG': 6.66,
    'J-VVS2-GOOD-VG-FAINT-VG': 6.66,
    'J-VVS2-POOR-POOR-FAINT-EX': 6.66,
    'K-VVS2-GOOD-VG-NONE-VG': 6.66,
    'K-VVS2-POOR-POOR-NONE-EX': 6.66,
    'K-VVS2-POOR-EX-NONE-VG': 6.66,
    'K-VVS2-VG-GOOD-NONE-VG': 6.66,
    'K-VVS2-EX-POOR-NONE-VG': 6.66,
    'K-VVS2-EX-EX-NONE-GOOD': 6.66,
    'L-VS2-EX-VG-STRONG-EX': 6.66,
    'L-VS2-VG-EX-STRONG-EX': 6.66,
    'M-VVS2-GOOD-EX-STRONG-EX': 6.66,
    'M-VVS2-EX-GOOD-STRONG-EX': 6.66,
    'M-VS2-EX-VG-MEDIUM-EX': 6.66,
    'M-VVS2-VG-VG-STRONG-EX': 6.66,
    'M-VS2-VG-EX-MEDIUM-EX': 6.66,
    'D-IF-VG-VG-STRONG-POOR': 6.65,
    'D-IF-EX-GOOD-STRONG-POOR': 6.65,
    'D-IF-GOOD-POOR-STRONG-GOOD': 6.65,
    'D-IF-POOR-GOOD-STRONG-GOOD': 6.65,
    'D-IF-GOOD-EX-STRONG-POOR': 6.65,
    'E-IF-VG-VG-MEDIUM-POOR': 6.65,
    'E-IF-GOOD-POOR-MEDIUM-GOOD': 6.65,
    'E-IF-EX-GOOD-MEDIUM-POOR': 6.65,
    'E-IF-GOOD-EX-MEDIUM-POOR': 6.65,
    'E-IF-POOR-GOOD-MEDIUM-GOOD': 6.65,
    'F-IF-VG-VG-FAINT-POOR': 6.65,
    'F-IF-POOR-GOOD-FAINT-GOOD': 6.65,
    'F-IF-GOOD-EX-FAINT-POOR': 6.65,
    'F-IF-EX-GOOD-FAINT-POOR': 6.65,
    'F-IF-GOOD-POOR-FAINT-GOOD': 6.65,
    'G-IF-POOR-GOOD-NONE-GOOD': 6.65,
    'G-IF-GOOD-POOR-NONE-GOOD': 6.65,
    'G-IF-GOOD-EX-NONE-POOR': 6.65,
    'G-IF-VG-VG-NONE-POOR': 6.65,
    'G-IF-EX-GOOD-NONE-POOR': 6.65,
    'I-IF-VG-POOR-STRONG-VG': 6.65,
    'I-IF-VG-EX-STRONG-GOOD': 6.65,
    'I-IF-GOOD-GOOD-STRONG-VG': 6.65,
    'I-IF-EX-VG-STRONG-GOOD': 6.65,
    'I-IF-POOR-VG-STRONG-VG': 6.65,
    'J-IF-GOOD-GOOD-MEDIUM-VG': 6.65,
    'J-IF-VG-EX-MEDIUM-GOOD': 6.65,
    'J-IF-EX-VG-MEDIUM-GOOD': 6.65,
    'J-IF-POOR-VG-MEDIUM-VG': 6.65,
    'J-IF-VG-POOR-MEDIUM-VG': 6.65,
    'K-IF-GOOD-GOOD-FAINT-VG': 6.65,
    'K-IF-POOR-VG-FAINT-VG': 6.65,
    'K-IF-EX-VG-FAINT-GOOD': 6.65,
    'K-IF-VG-EX-FAINT-GOOD': 6.65,
    'K-IF-VG-POOR-FAINT-VG': 6.65,
    'L-IF-EX-VG-NONE-GOOD': 6.65,
    'L-IF-VG-EX-NONE-GOOD': 6.65,
    'L-IF-VG-POOR-NONE-VG': 6.65,
    'L-IF-POOR-VG-NONE-VG': 6.65,
    'L-IF-GOOD-GOOD-NONE-VG': 6.65,
    'D-SI1-POOR-EX-NONE-GOOD': 6.64,
    'D-SI1-EX-POOR-NONE-GOOD': 6.64,
    'D-SI1-VG-GOOD-NONE-GOOD': 6.64,
    'D-SI1-GOOD-VG-NONE-GOOD': 6.64,
    'D-SI1-POOR-POOR-NONE-VG': 6.64,
    'D-SI1-EX-EX-NONE-POOR': 6.64,
    'E-I1-VG-EX-STRONG-VG': 6.64,
    'E-I1-EX-VG-STRONG-VG': 6.64,
    'E-I1-POOR-VG-STRONG-EX': 6.64,
    'E-I1-GOOD-GOOD-STRONG-EX': 6.64,
    'E-I1-VG-POOR-STRONG-EX': 6.64,
    'F-I1-EX-VG-MEDIUM-VG': 6.64,
    'F-I1-VG-POOR-MEDIUM-EX': 6.64,
    'F-I1-GOOD-GOOD-MEDIUM-EX': 6.64,
    'F-SI1-POOR-GOOD-STRONG-EX': 6.64,
    'F-SI1-GOOD-POOR-STRONG-EX': 6.64,
    'F-SI1-GOOD-EX-STRONG-VG': 6.64,
    'F-I1-VG-EX-MEDIUM-VG': 6.64,
    'F-SI1-VG-VG-STRONG-VG': 6.64,
    'F-SI1-EX-GOOD-STRONG-VG': 6.64,
    'F-I1-POOR-VG-MEDIUM-EX': 6.64,
    'G-SI1-POOR-GOOD-MEDIUM-EX': 6.64,
    'G-SI1-GOOD-POOR-MEDIUM-EX': 6.64,
    'G-SI1-EX-GOOD-MEDIUM-VG': 6.64,
    'G-I1-EX-VG-FAINT-VG': 6.64,
    'G-SI1-GOOD-EX-MEDIUM-VG': 6.64,
    'G-I1-VG-POOR-FAINT-EX': 6.64,
    'G-SI1-VG-VG-MEDIUM-VG': 6.64,
    'G-I1-VG-EX-FAINT-VG': 6.64,
    'G-I1-GOOD-GOOD-FAINT-EX': 6.64,
    'G-I1-POOR-VG-FAINT-EX': 6.64,
    'H-SI1-GOOD-EX-FAINT-VG': 6.64,
    'H-SI1-GOOD-POOR-FAINT-EX': 6.64,
    'H-I1-POOR-VG-NONE-EX': 6.64,
    'H-I1-VG-EX-NONE-VG': 6.64,
    'H-I1-VG-POOR-NONE-EX': 6.64,
    'H-I1-GOOD-GOOD-NONE-EX': 6.64,
    'H-I1-EX-VG-NONE-VG': 6.64,
    'H-SI1-EX-GOOD-FAINT-VG': 6.64,
    'H-SI1-VG-VG-FAINT-VG': 6.64,
    'H-SI1-POOR-GOOD-FAINT-EX': 6.64,
    'I-SI1-EX-GOOD-NONE-VG': 6.64,
    'I-SI1-VG-VG-NONE-VG': 6.64,
    'I-SI1-GOOD-EX-NONE-VG': 6.64,
    'I-SI1-GOOD-POOR-NONE-EX': 6.64,
    'I-SI1-POOR-GOOD-NONE-EX': 6.64,
    'J-I1-EX-EX-STRONG-EX': 6.64,
    'K-SI1-EX-VG-STRONG-EX': 6.64,
    'K-SI1-VG-EX-STRONG-EX': 6.64,
    'K-I1-EX-EX-MEDIUM-EX': 6.64,
    'L-SI1-EX-VG-MEDIUM-EX': 6.64,
    'L-I1-EX-EX-FAINT-EX': 6.64,
    'L-SI1-VG-EX-MEDIUM-EX': 6.64,
    'M-SI1-EX-VG-FAINT-EX': 6.64,
    'M-I1-EX-EX-NONE-EX': 6.64,
    'M-SI1-VG-EX-FAINT-EX': 6.64,
    'D-VVS1-GOOD-EX-MEDIUM-POOR': 6.63,
    'D-VVS1-VG-VG-MEDIUM-POOR': 6.63,
    'D-VS1-POOR-VG-FAINT-GOOD': 6.63,
    'D-VVS1-EX-GOOD-MEDIUM-POOR': 6.63,
    'D-VS1-GOOD-GOOD-FAINT-GOOD': 6.63,
    'D-VS1-VG-POOR-FAINT-GOOD': 6.63,
    'D-VVS1-GOOD-POOR-MEDIUM-GOOD': 6.63,
    'D-VVS1-POOR-GOOD-MEDIUM-GOOD': 6.63,
    'D-VS1-EX-VG-FAINT-POOR': 6.63,
    'D-VS1-VG-EX-FAINT-POOR': 6.63,
    'E-VS1-VG-POOR-NONE-GOOD': 6.63,
    'E-VS1-EX-VG-NONE-POOR': 6.63,
    'E-VS1-VG-EX-NONE-POOR': 6.63,
    'E-VVS1-GOOD-POOR-FAINT-GOOD': 6.63,
    'E-VVS1-EX-GOOD-FAINT-POOR': 6.63,
    'E-VVS1-POOR-GOOD-FAINT-GOOD': 6.63,
    'E-VS1-GOOD-GOOD-NONE-GOOD': 6.63,
    'E-VS1-POOR-VG-NONE-GOOD': 6.63,
    'E-VVS1-GOOD-EX-FAINT-POOR': 6.63,
    'E-VVS1-VG-VG-FAINT-POOR': 6.63,
    'F-VVS1-VG-VG-NONE-POOR': 6.63,
    'F-VVS1-POOR-GOOD-NONE-GOOD': 6.63,
    'F-VVS1-GOOD-EX-NONE-POOR': 6.63,
    'F-VVS1-GOOD-POOR-NONE-GOOD': 6.63,
    'F-VVS1-EX-GOOD-NONE-POOR': 6.63,
    'G-VS1-VG-GOOD-STRONG-VG': 6.63,
    'G-VS1-GOOD-VG-STRONG-VG': 6.63,
    'G-VS1-EX-POOR-STRONG-VG': 6.63,
    'G-VS1-EX-EX-STRONG-GOOD': 6.63,
    'G-VS1-POOR-EX-STRONG-VG': 6.63,
    'G-VS1-POOR-POOR-STRONG-EX': 6.63,
    'H-VVS1-GOOD-GOOD-STRONG-VG': 6.63,
    'H-VVS1-POOR-VG-STRONG-VG': 6.63,
    'H-VVS1-EX-VG-STRONG-GOOD': 6.63,
    'H-VS1-GOOD-VG-MEDIUM-VG': 6.63,
    'H-VS1-VG-GOOD-MEDIUM-VG': 6.63,
    'H-VS1-POOR-EX-MEDIUM-VG': 6.63,
    'H-VS1-POOR-POOR-MEDIUM-EX': 6.63,
    'H-VS1-EX-POOR-MEDIUM-VG': 6.63,
    'H-VVS1-VG-POOR-STRONG-VG': 6.63,
    'H-VS1-EX-EX-MEDIUM-GOOD': 6.63,
    'H-VVS1-VG-EX-STRONG-GOOD': 6.63,
    'I-VS1-POOR-EX-FAINT-VG': 6.63,
    'I-VS1-GOOD-VG-FAINT-VG': 6.63,
    'I-VS1-POOR-POOR-FAINT-EX': 6.63,
    'I-VVS1-EX-VG-MEDIUM-GOOD': 6.63,
    'I-VVS1-POOR-VG-MEDIUM-VG': 6.63,
    'I-VS1-EX-EX-FAINT-GOOD': 6.63,
    'I-VS1-EX-POOR-FAINT-VG': 6.63,
    'I-VVS1-VG-POOR-MEDIUM-VG': 6.63,
    'I-VVS1-VG-EX-MEDIUM-GOOD': 6.63,
    'I-VVS1-GOOD-GOOD-MEDIUM-VG': 6.63,
    'I-VS1-VG-GOOD-FAINT-VG': 6.63,
    'J-VVS1-POOR-VG-FAINT-VG': 6.63,
    'J-VS1-POOR-POOR-NONE-EX': 6.63,
    'J-VS1-POOR-EX-NONE-VG': 6.63,
    'J-VVS1-GOOD-GOOD-FAINT-VG': 6.63,
    'J-VVS1-EX-VG-FAINT-GOOD': 6.63,
    'J-VS1-EX-EX-NONE-GOOD': 6.63,
    'J-VS1-VG-GOOD-NONE-VG': 6.63,
    'J-VS1-EX-POOR-NONE-VG': 6.63,
    'J-VVS1-VG-EX-FAINT-GOOD': 6.63,
    'J-VS1-GOOD-VG-NONE-VG': 6.63,
    'J-VVS1-VG-POOR-FAINT-VG': 6.63,
    'K-VVS1-POOR-VG-NONE-VG': 6.63,
    'K-VVS1-GOOD-GOOD-NONE-VG': 6.63,
    'K-VVS1-VG-POOR-NONE-VG': 6.63,
    'K-VVS1-VG-EX-NONE-GOOD': 6.63,
    'K-VVS1-EX-VG-NONE-GOOD': 6.63,
    'L-VS1-EX-GOOD-STRONG-EX': 6.63,
    'L-VS1-VG-VG-STRONG-EX': 6.63,
    'L-VS1-GOOD-EX-STRONG-EX': 6.63,
    'M-VVS1-EX-EX-STRONG-VG': 6.63,
    'M-VVS1-GOOD-VG-STRONG-EX': 6.63,
    'M-VVS1-VG-GOOD-STRONG-EX': 6.63,
    'M-VS1-VG-VG-MEDIUM-EX': 6.63,
    'M-VVS1-POOR-EX-STRONG-EX': 6.63,
    'M-VS1-GOOD-EX-MEDIUM-EX': 6.63,
    'M-VS1-EX-GOOD-MEDIUM-EX': 6.63,
    'M-VVS1-EX-POOR-STRONG-EX': 6.63,
    'D-I2-VG-EX-STRONG-VG': 6.62,
    'D-I2-VG-POOR-STRONG-EX': 6.62,
    'D-I2-GOOD-GOOD-STRONG-EX': 6.62,
    'D-I2-POOR-VG-STRONG-EX': 6.62,
    'D-I2-EX-VG-STRONG-VG': 6.62,
    'E-SI2-EX-GOOD-STRONG-VG': 6.62,
    'E-I2-VG-POOR-MEDIUM-EX': 6.62,
    'E-I2-GOOD-GOOD-MEDIUM-EX': 6.62,
    'E-SI2-GOOD-EX-STRONG-VG': 6.62,
    'E-I2-POOR-VG-MEDIUM-EX': 6.62,
    'E-SI2-GOOD-POOR-STRONG-EX': 6.62,
    'E-SI2-POOR-GOOD-STRONG-EX': 6.62,
    'E-I2-VG-EX-MEDIUM-VG': 6.62,
    'E-I2-EX-VG-MEDIUM-VG': 6.62,
    'E-SI2-VG-VG-STRONG-VG': 6.62,
    'F-SI2-EX-GOOD-MEDIUM-VG': 6.62,
    'F-SI2-VG-VG-MEDIUM-VG': 6.62,
    'F-SI2-GOOD-EX-MEDIUM-VG': 6.62,
    'F-SI2-POOR-GOOD-MEDIUM-EX': 6.62,
    'F-SI2-GOOD-POOR-MEDIUM-EX': 6.62,
    'F-I2-GOOD-GOOD-FAINT-EX': 6.62,
    'F-I2-VG-POOR-FAINT-EX': 6.62,
    'F-I2-VG-EX-FAINT-VG': 6.62,
    'F-I2-EX-VG-FAINT-VG': 6.62,
    'F-I2-POOR-VG-FAINT-EX': 6.62,
    'G-I2-VG-EX-NONE-VG': 6.62,
    'G-I2-EX-VG-NONE-VG': 6.62,
    'G-SI2-POOR-GOOD-FAINT-EX': 6.62,
    'G-SI2-EX-GOOD-FAINT-VG': 6.62,
    'G-SI2-VG-VG-FAINT-VG': 6.62,
    'G-SI2-GOOD-POOR-FAINT-EX': 6.62,
    'G-SI2-GOOD-EX-FAINT-VG': 6.62,
    'G-I2-VG-POOR-NONE-EX': 6.62,
    'G-I2-GOOD-GOOD-NONE-EX': 6.62,
    'G-I2-POOR-VG-NONE-EX': 6.62,
    'H-SI2-POOR-GOOD-NONE-EX': 6.62,
    'H-SI2-GOOD-POOR-NONE-EX': 6.62,
    'H-SI2-VG-VG-NONE-VG': 6.62,
    'H-SI2-GOOD-EX-NONE-VG': 6.62,
    'H-SI2-EX-GOOD-NONE-VG': 6.62,
    'I-I2-EX-EX-STRONG-EX': 6.62,
    'J-SI2-EX-VG-STRONG-EX': 6.62,
    'J-SI2-VG-EX-STRONG-EX': 6.62,
    'J-I2-EX-EX-MEDIUM-EX': 6.62,
    'K-I2-EX-EX-FAINT-EX': 6.62,
    'K-SI2-EX-VG-MEDIUM-EX': 6.62,
    'K-SI2-VG-EX-MEDIUM-EX': 6.62,
    'L-I2-EX-EX-NONE-EX': 6.62,
    'L-SI2-VG-EX-FAINT-EX': 6.62,
    'L-SI2-EX-VG-FAINT-EX': 6.62,
    'M-SI2-VG-EX-NONE-EX': 6.62,
    'M-SI2-EX-VG-NONE-EX': 6.62,
    'D-VS2-EX-VG-NONE-POOR': 6.61,
    'D-VS2-VG-EX-NONE-POOR': 6.61,
    'D-VVS2-POOR-GOOD-FAINT-GOOD': 6.61,
    'D-VS2-POOR-VG-NONE-GOOD': 6.61,
    'D-VS2-VG-POOR-NONE-GOOD': 6.61,
    'D-VS2-GOOD-GOOD-NONE-GOOD': 6.61,
    'D-VVS2-EX-GOOD-FAINT-POOR': 6.61,
    'D-VVS2-GOOD-POOR-FAINT-GOOD': 6.61,
    'D-VVS2-GOOD-EX-FAINT-POOR': 6.61,
    'D-VVS2-VG-VG-FAINT-POOR': 6.61,
    'E-VVS2-EX-GOOD-NONE-POOR': 6.61,
    'E-VVS2-VG-VG-NONE-POOR': 6.61,
    'E-VVS2-GOOD-POOR-NONE-GOOD': 6.61,
    'E-VVS2-POOR-GOOD-NONE-GOOD': 6.61,
    'E-VVS2-GOOD-EX-NONE-POOR': 6.61,
    'F-VS2-EX-EX-STRONG-GOOD': 6.61,
    'F-VS2-POOR-POOR-STRONG-EX': 6.61,
    'F-VS2-EX-POOR-STRONG-VG': 6.61,
    'F-VS2-VG-GOOD-STRONG-VG': 6.61,
    'F-VS2-GOOD-VG-STRONG-VG': 6.61,
    'F-VS2-POOR-EX-STRONG-VG': 6.61,
    'G-VS2-POOR-EX-MEDIUM-VG': 6.61,
    'G-VS2-VG-GOOD-MEDIUM-VG': 6.61,
    'G-VVS2-GOOD-GOOD-STRONG-VG': 6.61,
    'G-VS2-POOR-POOR-MEDIUM-EX': 6.61,
    'G-VS2-GOOD-VG-MEDIUM-VG': 6.61,
    'G-VVS2-POOR-VG-STRONG-VG': 6.61,
    'G-VVS2-VG-POOR-STRONG-VG': 6.61,
    'G-VS2-EX-POOR-MEDIUM-VG': 6.61,
    'G-VVS2-VG-EX-STRONG-GOOD': 6.61,
    'G-VVS2-EX-VG-STRONG-GOOD': 6.61,
    'G-VS2-EX-EX-MEDIUM-GOOD': 6.61,
    'H-VVS2-EX-VG-MEDIUM-GOOD': 6.61,
    'H-VS2-POOR-POOR-FAINT-EX': 6.61,
    'H-VS2-POOR-EX-FAINT-VG': 6.61,
    'H-VVS2-VG-EX-MEDIUM-GOOD': 6.61,
    'H-VS2-GOOD-VG-FAINT-VG': 6.61,
    'H-VS2-EX-EX-FAINT-GOOD': 6.61,
    'H-VS2-VG-GOOD-FAINT-VG': 6.61,
    'H-VVS2-POOR-VG-MEDIUM-VG': 6.61,
    'H-VVS2-VG-POOR-MEDIUM-VG': 6.61,
    'H-VVS2-GOOD-GOOD-MEDIUM-VG': 6.61,
    'H-VS2-EX-POOR-FAINT-VG': 6.61,
    'I-VVS2-POOR-VG-FAINT-VG': 6.61,
    'I-VS2-EX-EX-NONE-GOOD': 6.61,
    'I-VS2-EX-POOR-NONE-VG': 6.61,
    'I-VVS2-GOOD-GOOD-FAINT-VG': 6.61,
    'I-VVS2-VG-POOR-FAINT-VG': 6.61,
    'I-VVS2-VG-EX-FAINT-GOOD': 6.61,
    'I-VVS2-EX-VG-FAINT-GOOD': 6.61,
    'I-VS2-VG-GOOD-NONE-VG': 6.61,
    'I-VS2-POOR-POOR-NONE-EX': 6.61,
    'I-VS2-POOR-EX-NONE-VG': 6.61,
    'I-VS2-GOOD-VG-NONE-VG': 6.61,
    'J-VVS2-VG-POOR-NONE-VG': 6.61,
    'J-VVS2-EX-VG-NONE-GOOD': 6.61,
    'J-VVS2-POOR-VG-NONE-VG': 6.61,
    'J-VVS2-VG-EX-NONE-GOOD': 6.61,
    'J-VVS2-GOOD-GOOD-NONE-VG': 6.61,
    'K-VS2-EX-GOOD-STRONG-EX': 6.61,
    'K-VS2-GOOD-EX-STRONG-EX': 6.61,
    'K-VS2-VG-VG-STRONG-EX': 6.61,
    'L-VVS2-VG-GOOD-STRONG-EX': 6.61,
    'L-VVS2-EX-POOR-STRONG-EX': 6.61,
    'L-VS2-VG-VG-MEDIUM-EX': 6.61,
    'L-VS2-GOOD-EX-MEDIUM-EX': 6.61,
    'L-VVS2-EX-EX-STRONG-VG': 6.61,
    'L-VVS2-POOR-EX-STRONG-EX': 6.61,
    'L-VS2-EX-GOOD-MEDIUM-EX': 6.61,
    'L-VVS2-GOOD-VG-STRONG-EX': 6.61,
    'M-VVS2-VG-GOOD-MEDIUM-EX': 6.61,
    'M-VVS2-GOOD-VG-MEDIUM-EX': 6.61,
    'M-VVS2-POOR-EX-MEDIUM-EX': 6.61,
    'M-VVS2-EX-POOR-MEDIUM-EX': 6.61,
    'M-VVS2-EX-EX-MEDIUM-VG': 6.61,
    'M-VS2-VG-VG-FAINT-EX': 6.61,
    'M-VS2-GOOD-EX-FAINT-EX': 6.61,
    'M-VS2-EX-GOOD-FAINT-EX': 6.61,
    'D-IF-POOR-EX-MEDIUM-POOR': 6.6,
    'D-IF-EX-POOR-MEDIUM-POOR': 6.6,
    'D-IF-GOOD-VG-MEDIUM-POOR': 6.6,
    'D-IF-VG-GOOD-MEDIUM-POOR': 6.6,
    'D-IF-POOR-POOR-MEDIUM-GOOD': 6.6,
    'E-IF-VG-GOOD-FAINT-POOR': 6.6,
    'E-IF-GOOD-VG-FAINT-POOR': 6.6,
    'E-IF-EX-POOR-FAINT-POOR': 6.6,
    'E-IF-POOR-EX-FAINT-POOR': 6.6,
    'E-IF-POOR-POOR-FAINT-GOOD': 6.6,
    'F-IF-EX-POOR-NONE-POOR': 6.6,
    'F-IF-VG-GOOD-NONE-POOR': 6.6,
    'F-IF-POOR-EX-NONE-POOR': 6.6,
    'F-IF-GOOD-VG-NONE-POOR': 6.6,
    'F-IF-POOR-POOR-NONE-GOOD': 6.6,
    'H-IF-POOR-GOOD-STRONG-VG': 6.6,
    'H-IF-GOOD-POOR-STRONG-VG': 6.6,
    'H-IF-GOOD-EX-STRONG-GOOD': 6.6,
    'H-IF-VG-VG-STRONG-GOOD': 6.6,
    'H-IF-EX-GOOD-STRONG-GOOD': 6.6,
    'I-IF-VG-VG-MEDIUM-GOOD': 6.6,
    'I-IF-POOR-GOOD-MEDIUM-VG': 6.6,
    'I-IF-GOOD-POOR-MEDIUM-VG': 6.6,
    'I-IF-GOOD-EX-MEDIUM-GOOD': 6.6,
    'I-IF-EX-GOOD-MEDIUM-GOOD': 6.6,
    'J-IF-EX-GOOD-FAINT-GOOD': 6.6,
    'J-IF-GOOD-EX-FAINT-GOOD': 6.6,
    'J-IF-VG-VG-FAINT-GOOD': 6.6,
    'J-IF-POOR-GOOD-FAINT-VG': 6.6,
    'J-IF-GOOD-POOR-FAINT-VG': 6.6,
    'K-IF-GOOD-EX-NONE-GOOD': 6.6,
    'K-IF-POOR-GOOD-NONE-VG': 6.6,
    'K-IF-GOOD-POOR-NONE-VG': 6.6,
    'K-IF-VG-VG-NONE-GOOD': 6.6,
    'K-IF-EX-GOOD-NONE-GOOD': 6.6,
    'M-IF-POOR-VG-STRONG-EX': 6.6,
    'M-IF-EX-VG-STRONG-VG': 6.6,
    'M-IF-VG-EX-STRONG-VG': 6.6,
    'M-IF-VG-POOR-STRONG-EX': 6.6,
    'M-IF-GOOD-GOOD-STRONG-EX': 6.6,
    'D-I1-POOR-GOOD-STRONG-EX': 6.59,
    'D-I1-VG-VG-STRONG-VG': 6.59,
    'D-I1-GOOD-EX-STRONG-VG': 6.59,
    'D-I1-GOOD-POOR-STRONG-EX': 6.59,
    'D-I1-EX-GOOD-STRONG-VG': 6.59,
    'E-SI1-POOR-POOR-STRONG-EX': 6.59,
    'E-I1-VG-VG-MEDIUM-VG': 6.59,
    'E-SI1-EX-POOR-STRONG-VG': 6.59,
    'E-SI1-EX-EX-STRONG-GOOD': 6.59,
    'E-SI1-POOR-EX-STRONG-VG': 6.59,
    'E-SI1-VG-GOOD-STRONG-VG': 6.59,
    'E-SI1-GOOD-VG-STRONG-VG': 6.59,
    'E-I1-EX-GOOD-MEDIUM-VG': 6.59,
    'E-I1-GOOD-POOR-MEDIUM-EX': 6.59,
    'E-I1-POOR-GOOD-MEDIUM-EX': 6.59,
    'E-I1-GOOD-EX-MEDIUM-VG': 6.59,
    'F-SI1-POOR-POOR-MEDIUM-EX': 6.59,
    'F-SI1-EX-POOR-MEDIUM-VG': 6.59,
    'F-SI1-EX-EX-MEDIUM-GOOD': 6.59,
    'F-SI1-VG-GOOD-MEDIUM-VG': 6.59,
    'F-SI1-POOR-EX-MEDIUM-VG': 6.59,
    'F-SI1-GOOD-VG-MEDIUM-VG': 6.59,
    'F-I1-GOOD-POOR-FAINT-EX': 6.59,
    'F-I1-EX-GOOD-FAINT-VG': 6.59,
    'F-I1-GOOD-EX-FAINT-VG': 6.59,
    'F-I1-VG-VG-FAINT-VG': 6.59,
    'F-I1-POOR-GOOD-FAINT-EX': 6.59,
    'G-SI1-GOOD-VG-FAINT-VG': 6.59,
    'G-SI1-VG-GOOD-FAINT-VG': 6.59,
    'G-SI1-EX-POOR-FAINT-VG': 6.59,
    'G-SI1-POOR-EX-FAINT-VG': 6.59,
    'G-I1-VG-VG-NONE-VG': 6.59,
    'G-I1-GOOD-EX-NONE-VG': 6.59,
    'G-I1-GOOD-POOR-NONE-EX': 6.59,
    'G-SI1-POOR-POOR-FAINT-EX': 6.59,
    'G-SI1-EX-EX-FAINT-GOOD': 6.59,
    'G-I1-EX-GOOD-NONE-VG': 6.59,
    'G-I1-POOR-GOOD-NONE-EX': 6.59,
    'H-SI1-POOR-EX-NONE-VG': 6.59,
    'H-SI1-GOOD-VG-NONE-VG': 6.59,
    'H-SI1-VG-GOOD-NONE-VG': 6.59,
    'H-SI1-EX-POOR-NONE-VG': 6.59,
    'H-SI1-EX-EX-NONE-GOOD': 6.59,
    'H-SI1-POOR-POOR-NONE-EX': 6.59,
    'I-I1-VG-EX-STRONG-EX': 6.59,
    'I-I1-EX-VG-STRONG-EX': 6.59,
    'J-SI1-GOOD-EX-STRONG-EX': 6.59,
    'J-SI1-EX-GOOD-STRONG-EX': 6.59,
    'J-SI1-VG-VG-STRONG-EX': 6.59,
    'J-I1-EX-VG-MEDIUM-EX': 6.59,
    'J-I1-VG-EX-MEDIUM-EX': 6.59,
    'K-SI1-EX-GOOD-MEDIUM-EX': 6.59,
    'K-SI1-GOOD-EX-MEDIUM-EX': 6.59,
    'K-I1-VG-EX-FAINT-EX': 6.59,
    'K-I1-EX-VG-FAINT-EX': 6.59,
    'K-SI1-VG-VG-MEDIUM-EX': 6.59,
    'L-I1-EX-VG-NONE-EX': 6.59,
    'L-I1-VG-EX-NONE-EX': 6.59,
    'L-SI1-GOOD-EX-FAINT-EX': 6.59,
    'L-SI1-VG-VG-FAINT-EX': 6.59,
    'L-SI1-EX-GOOD-FAINT-EX': 6.59,
    'M-SI1-VG-VG-NONE-EX': 6.59,
    'M-SI1-GOOD-EX-NONE-EX': 6.59,
    'M-SI1-EX-GOOD-NONE-EX': 6.59,
    'D-VS1-VG-VG-NONE-POOR': 6.58,
    'D-VS1-GOOD-EX-NONE-POOR': 6.58,
    'D-VVS1-EX-POOR-FAINT-POOR': 6.58,
    'D-VS1-EX-GOOD-NONE-POOR': 6.58,
    'D-VS1-POOR-GOOD-NONE-GOOD': 6.58,
    'D-VVS1-VG-GOOD-FAINT-POOR': 6.58,
    'D-VVS1-POOR-EX-FAINT-POOR': 6.58,
    'D-VVS1-GOOD-VG-FAINT-POOR': 6.58,
    'D-VVS1-POOR-POOR-FAINT-GOOD': 6.58,
    'D-VS1-GOOD-POOR-NONE-GOOD': 6.58,
    'E-VVS1-EX-POOR-NONE-POOR': 6.58,
    'E-VVS1-POOR-POOR-NONE-GOOD': 6.58,
    'E-VVS1-GOOD-VG-NONE-POOR': 6.58,
    'E-VVS1-POOR-EX-NONE-POOR': 6.58,
    'E-VVS1-VG-GOOD-NONE-POOR': 6.58,
    'F-VS1-POOR-VG-STRONG-VG': 6.58,
    'F-VS1-EX-VG-STRONG-GOOD': 6.58,
    'F-VS1-GOOD-GOOD-STRONG-VG': 6.58,
    'F-VS1-VG-POOR-STRONG-VG': 6.58,
    'F-VS1-VG-EX-STRONG-GOOD': 6.58,
    'G-VVS1-GOOD-EX-STRONG-GOOD': 6.58,
    'G-VVS1-VG-VG-STRONG-GOOD': 6.58,
    'G-VS1-VG-EX-MEDIUM-GOOD': 6.58,
    'G-VS1-EX-VG-MEDIUM-GOOD': 6.58,
    'G-VVS1-GOOD-POOR-STRONG-VG': 6.58,
    'G-VVS1-POOR-GOOD-STRONG-VG': 6.58,
    'G-VS1-GOOD-GOOD-MEDIUM-VG': 6.58,
    'G-VS1-POOR-VG-MEDIUM-VG': 6.58,
    'G-VS1-VG-POOR-MEDIUM-VG': 6.58,
    'G-VVS1-EX-GOOD-STRONG-GOOD': 6.58,
    'H-VVS1-GOOD-POOR-MEDIUM-VG': 6.58,
    'H-VVS1-EX-GOOD-MEDIUM-GOOD': 6.58,
    'H-VS1-VG-EX-FAINT-GOOD': 6.58,
    'H-VVS1-GOOD-EX-MEDIUM-GOOD': 6.58,
    'H-VS1-VG-POOR-FAINT-VG': 6.58,
    'H-VS1-EX-VG-FAINT-GOOD': 6.58,
    'H-VS1-POOR-VG-FAINT-VG': 6.58,
    'H-VS1-GOOD-GOOD-FAINT-VG': 6.58,
    'H-VVS1-VG-VG-MEDIUM-GOOD': 6.58,
    'H-VVS1-POOR-GOOD-MEDIUM-VG': 6.58,
    'I-VVS1-EX-GOOD-FAINT-GOOD': 6.58,
    'I-VVS1-POOR-GOOD-FAINT-VG': 6.58,
    'I-VVS1-GOOD-POOR-FAINT-VG': 6.58,
    'I-VVS1-GOOD-EX-FAINT-GOOD': 6.58,
    'I-VS1-POOR-VG-NONE-VG': 6.58,
    'I-VVS1-VG-VG-FAINT-GOOD': 6.58,
    'I-VS1-VG-EX-NONE-GOOD': 6.58,
    'I-VS1-EX-VG-NONE-GOOD': 6.58,
    'I-VS1-VG-POOR-NONE-VG': 6.58,
    'I-VS1-GOOD-GOOD-NONE-VG': 6.58,
    'J-VVS1-GOOD-POOR-NONE-VG': 6.58,
    'J-VVS1-GOOD-EX-NONE-GOOD': 6.58,
    'J-VVS1-VG-VG-NONE-GOOD': 6.58,
    'J-VVS1-EX-GOOD-NONE-GOOD': 6.58,
    'J-VVS1-POOR-GOOD-NONE-VG': 6.58,
    'K-VS1-EX-EX-STRONG-VG': 6.58,
    'K-VS1-GOOD-VG-STRONG-EX': 6.58,
    'K-VS1-EX-POOR-STRONG-EX': 6.58,
    'K-VS1-VG-GOOD-STRONG-EX': 6.58,
    'K-VS1-POOR-EX-STRONG-EX': 6.58,
    'L-VVS1-POOR-VG-STRONG-EX': 6.58,
    'L-VS1-EX-POOR-MEDIUM-EX': 6.58,
    'L-VS1-EX-EX-MEDIUM-VG': 6.58,
    'L-VVS1-VG-EX-STRONG-VG': 6.58,
    'L-VVS1-EX-VG-STRONG-VG': 6.58,
    'L-VS1-POOR-EX-MEDIUM-EX': 6.58,
    'L-VS1-VG-GOOD-MEDIUM-EX': 6.58,
    'L-VS1-GOOD-VG-MEDIUM-EX': 6.58,
    'L-VVS1-VG-POOR-STRONG-EX': 6.58,
    'L-VVS1-GOOD-GOOD-STRONG-EX': 6.58,
    'M-VVS1-VG-EX-MEDIUM-VG': 6.58,
    'M-VVS1-VG-POOR-MEDIUM-EX': 6.58,
    'M-VS1-EX-POOR-FAINT-EX': 6.58,
    'M-VS1-POOR-EX-FAINT-EX': 6.58,
    'M-VS1-GOOD-VG-FAINT-EX': 6.58,
    'M-VS1-VG-GOOD-FAINT-EX': 6.58,
    'M-VVS1-EX-VG-MEDIUM-VG': 6.58,
    'M-VS1-EX-EX-FAINT-VG': 6.58,
    'M-VVS1-GOOD-GOOD-MEDIUM-EX': 6.58,
    'M-VVS1-POOR-VG-MEDIUM-EX': 6.58,
    'D-SI2-VG-GOOD-STRONG-VG': 6.57,
    'D-SI2-GOOD-VG-STRONG-VG': 6.57,
    'D-SI2-POOR-EX-STRONG-VG': 6.57,
    'D-SI2-POOR-POOR-STRONG-EX': 6.57,
    'D-I2-POOR-GOOD-MEDIUM-EX': 6.57,
    'D-I2-GOOD-POOR-MEDIUM-EX': 6.57,
    'D-I2-VG-VG-MEDIUM-VG': 6.57,
    'D-I2-GOOD-EX-MEDIUM-VG': 6.57,
    'D-I2-EX-GOOD-MEDIUM-VG': 6.57,
    'D-SI2-EX-EX-STRONG-GOOD': 6.57,
    'D-SI2-EX-POOR-STRONG-VG': 6.57,
    'E-SI2-POOR-POOR-MEDIUM-EX': 6.57,
    'E-I2-POOR-GOOD-FAINT-EX': 6.57,
    'E-SI2-GOOD-VG-MEDIUM-VG': 6.57,
    'E-SI2-EX-POOR-MEDIUM-VG': 6.57,
    'E-I2-GOOD-POOR-FAINT-EX': 6.57,
    'E-SI2-EX-EX-MEDIUM-GOOD': 6.57,
    'E-I2-EX-GOOD-FAINT-VG': 6.57,
    'E-SI2-VG-GOOD-MEDIUM-VG': 6.57,
    'E-I2-GOOD-EX-FAINT-VG': 6.57,
    'E-SI2-POOR-EX-MEDIUM-VG': 6.57,
    'E-I2-VG-VG-FAINT-VG': 6.57,
    'F-I2-VG-VG-NONE-VG': 6.57,
    'F-I2-GOOD-POOR-NONE-EX': 6.57,
    'F-I2-GOOD-EX-NONE-VG': 6.57,
    'F-I2-POOR-GOOD-NONE-EX': 6.57,
    'F-I2-EX-GOOD-NONE-VG': 6.57,
    'F-SI2-EX-POOR-FAINT-VG': 6.57,
    'F-SI2-VG-GOOD-FAINT-VG': 6.57,
    'F-SI2-GOOD-VG-FAINT-VG': 6.57,
    'F-SI2-POOR-POOR-FAINT-EX': 6.57,
    'F-SI2-POOR-EX-FAINT-VG': 6.57,
    'F-SI2-EX-EX-FAINT-GOOD': 6.57,
    'G-SI2-POOR-POOR-NONE-EX': 6.57,
    'G-SI2-VG-GOOD-NONE-VG': 6.57,
    'G-SI2-EX-POOR-NONE-VG': 6.57,
    'G-SI2-EX-EX-NONE-GOOD': 6.57,
    'G-SI2-GOOD-VG-NONE-VG': 6.57,
    'G-SI2-POOR-EX-NONE-VG': 6.57,
    'H-I2-EX-VG-STRONG-EX': 6.57,
    'H-I2-VG-EX-STRONG-EX': 6.57,
    'I-SI2-GOOD-EX-STRONG-EX': 6.57,
    'I-SI2-EX-GOOD-STRONG-EX': 6.57,
    'I-SI2-VG-VG-STRONG-EX': 6.57,
    'I-I2-EX-VG-MEDIUM-EX': 6.57,
    'I-I2-VG-EX-MEDIUM-EX': 6.57,
    'J-SI2-EX-GOOD-MEDIUM-EX': 6.57,
    'J-SI2-VG-VG-MEDIUM-EX': 6.57,
    'J-SI2-GOOD-EX-MEDIUM-EX': 6.57,
    'J-I2-VG-EX-FAINT-EX': 6.57,
    'J-I2-EX-VG-FAINT-EX': 6.57,
    'K-I2-EX-VG-NONE-EX': 6.57,
    'K-SI2-GOOD-EX-FAINT-EX': 6.57,
    'K-SI2-EX-GOOD-FAINT-EX': 6.57,
    'K-I2-VG-EX-NONE-EX': 6.57,
    'K-SI2-VG-VG-FAINT-EX': 6.57,
    'L-SI2-VG-VG-NONE-EX': 6.57,
    'L-SI2-GOOD-EX-NONE-EX': 6.57,
    'L-SI2-EX-GOOD-NONE-EX': 6.57,
    'D-VVS2-POOR-POOR-NONE-GOOD': 6.56,
    'D-VVS2-VG-GOOD-NONE-POOR': 6.56,
    'D-VVS2-POOR-EX-NONE-POOR': 6.56,
    'D-VVS2-GOOD-VG-NONE-POOR': 6.56,
    'D-VVS2-EX-POOR-NONE-POOR': 6.56,
    'E-VS2-EX-VG-STRONG-GOOD': 6.56,
    'E-VS2-VG-EX-STRONG-GOOD': 6.56,
    'E-VS2-POOR-VG-STRONG-VG': 6.56,
    'E-VS2-GOOD-GOOD-STRONG-VG': 6.56,
    'E-VS2-VG-POOR-STRONG-VG': 6.56,
    'F-VS2-GOOD-GOOD-MEDIUM-VG': 6.56,
    'F-VS2-POOR-VG-MEDIUM-VG': 6.56,
    'F-VVS2-POOR-GOOD-STRONG-VG': 6.56,
    'F-VS2-VG-EX-MEDIUM-GOOD': 6.56,
    'F-VVS2-EX-GOOD-STRONG-GOOD': 6.56,
    'F-VS2-EX-VG-MEDIUM-GOOD': 6.56,
    'F-VVS2-GOOD-POOR-STRONG-VG': 6.56,
    'F-VVS2-VG-VG-STRONG-GOOD': 6.56,
    'F-VS2-VG-POOR-MEDIUM-VG': 6.56,
    'F-VVS2-GOOD-EX-STRONG-GOOD': 6.56,
    'G-VVS2-VG-VG-MEDIUM-GOOD': 6.56,
    'G-VVS2-GOOD-EX-MEDIUM-GOOD': 6.56,
    'G-VVS2-EX-GOOD-MEDIUM-GOOD': 6.56,
    'G-VS2-POOR-VG-FAINT-VG': 6.56,
    'G-VS2-VG-EX-FAINT-GOOD': 6.56,
    'G-VVS2-GOOD-POOR-MEDIUM-VG': 6.56,
    'G-VS2-EX-VG-FAINT-GOOD': 6.56,
    'G-VVS2-POOR-GOOD-MEDIUM-VG': 6.56,
    'G-VS2-GOOD-GOOD-FAINT-VG': 6.56,
    'G-VS2-VG-POOR-FAINT-VG': 6.56,
    'H-VVS2-GOOD-EX-FAINT-GOOD': 6.56,
    'H-VVS2-EX-GOOD-FAINT-GOOD': 6.56,
    'H-VVS2-VG-VG-FAINT-GOOD': 6.56,
    'H-VS2-EX-VG-NONE-GOOD': 6.56,
    'H-VVS2-GOOD-POOR-FAINT-VG': 6.56,
    'H-VS2-VG-EX-NONE-GOOD': 6.56,
    'H-VVS2-POOR-GOOD-FAINT-VG': 6.56,
    'H-VS2-VG-POOR-NONE-VG': 6.56,
    'H-VS2-POOR-VG-NONE-VG': 6.56,
    'H-VS2-GOOD-GOOD-NONE-VG': 6.56,
    'I-VVS2-POOR-GOOD-NONE-VG': 6.56,
    'I-VVS2-GOOD-POOR-NONE-VG': 6.56,
    'I-VVS2-GOOD-EX-NONE-GOOD': 6.56,
    'I-VVS2-EX-GOOD-NONE-GOOD': 6.56,
    'I-VVS2-VG-VG-NONE-GOOD': 6.56,
    'J-VS2-EX-POOR-STRONG-EX': 6.56,
    'J-VS2-VG-GOOD-STRONG-EX': 6.56,
    'J-VS2-EX-EX-STRONG-VG': 6.56,
    'J-VS2-POOR-EX-STRONG-EX': 6.56,
    'J-VS2-GOOD-VG-STRONG-EX': 6.56,
    'K-VS2-POOR-EX-MEDIUM-EX': 6.56,
    'K-VS2-EX-EX-MEDIUM-VG': 6.56,
    'K-VS2-GOOD-VG-MEDIUM-EX': 6.56,
    'K-VS2-EX-POOR-MEDIUM-EX': 6.56,
    'K-VS2-VG-GOOD-MEDIUM-EX': 6.56,
    'K-VVS2-EX-VG-STRONG-VG': 6.56,
    'K-VVS2-POOR-VG-STRONG-EX': 6.56,
    'K-VVS2-VG-EX-STRONG-VG': 6.56,
    'K-VVS2-GOOD-GOOD-STRONG-EX': 6.56,
    'K-VVS2-VG-POOR-STRONG-EX': 6.56,
    'L-VVS2-EX-VG-MEDIUM-VG': 6.56,
    'L-VVS2-POOR-VG-MEDIUM-EX': 6.56,
    'L-VVS2-GOOD-GOOD-MEDIUM-EX': 6.56,
    'L-VS2-EX-EX-FAINT-VG': 6.56,
    'L-VS2-POOR-EX-FAINT-EX': 6.56,
    'L-VVS2-VG-POOR-MEDIUM-EX': 6.56,
    'L-VS2-VG-GOOD-FAINT-EX': 6.56,
    'L-VS2-GOOD-VG-FAINT-EX': 6.56,
    'L-VS2-EX-POOR-FAINT-EX': 6.56,
    'L-VVS2-VG-EX-MEDIUM-VG': 6.56,
    'M-VS2-VG-GOOD-NONE-EX': 6.56,
    'M-VVS2-VG-POOR-FAINT-EX': 6.56,
    'M-VVS2-GOOD-GOOD-FAINT-EX': 6.56,
    'M-VVS2-POOR-VG-FAINT-EX': 6.56,
    'M-VS2-POOR-EX-NONE-EX': 6.56,
    'M-VS2-EX-EX-NONE-VG': 6.56,
    'M-VVS2-EX-VG-FAINT-VG': 6.56,
    'M-VVS2-VG-EX-FAINT-VG': 6.56,
    'M-VS2-GOOD-VG-NONE-EX': 6.56,
    'M-VS2-EX-POOR-NONE-EX': 6.56,
    'D-IF-GOOD-GOOD-FAINT-POOR': 6.55,
    'D-IF-POOR-VG-FAINT-POOR': 6.55,
    'D-IF-VG-POOR-FAINT-POOR': 6.55,
    'E-IF-GOOD-GOOD-NONE-POOR': 6.55,
    'E-IF-VG-POOR-NONE-POOR': 6.55,
    'E-IF-POOR-VG-NONE-POOR': 6.55,
    'G-IF-GOOD-VG-STRONG-GOOD': 6.55,
    'G-IF-EX-EX-STRONG-POOR': 6.55,
    'G-IF-VG-GOOD-STRONG-GOOD': 6.55,
    'G-IF-EX-POOR-STRONG-GOOD': 6.55,
    'G-IF-POOR-POOR-STRONG-VG': 6.55,
    'G-IF-POOR-EX-STRONG-GOOD': 6.55,
    'H-IF-VG-GOOD-MEDIUM-GOOD': 6.55,
    'H-IF-POOR-POOR-MEDIUM-VG': 6.55,
    'H-IF-POOR-EX-MEDIUM-GOOD': 6.55,
    'H-IF-EX-EX-MEDIUM-POOR': 6.55,
    'H-IF-GOOD-VG-MEDIUM-GOOD': 6.55,
    'H-IF-EX-POOR-MEDIUM-GOOD': 6.55,
    'I-IF-GOOD-VG-FAINT-GOOD': 6.55,
    'I-IF-POOR-POOR-FAINT-VG': 6.55,
    'I-IF-POOR-EX-FAINT-GOOD': 6.55,
    'I-IF-VG-GOOD-FAINT-GOOD': 6.55,
    'I-IF-EX-POOR-FAINT-GOOD': 6.55,
    'I-IF-EX-EX-FAINT-POOR': 6.55,
    'J-IF-EX-EX-NONE-POOR': 6.55,
    'J-IF-EX-POOR-NONE-GOOD': 6.55,
    'J-IF-POOR-POOR-NONE-VG': 6.55,
    'J-IF-GOOD-VG-NONE-GOOD': 6.55,
    'J-IF-POOR-EX-NONE-GOOD': 6.55,
    'J-IF-VG-GOOD-NONE-GOOD': 6.55,
    'L-IF-GOOD-POOR-STRONG-EX': 6.55,
    'L-IF-POOR-GOOD-STRONG-EX': 6.55,
    'L-IF-EX-GOOD-STRONG-VG': 6.55,
    'L-IF-GOOD-EX-STRONG-VG': 6.55,
    'L-IF-VG-VG-STRONG-VG': 6.55,
    'M-IF-POOR-GOOD-MEDIUM-EX': 6.55,
    'M-IF-EX-GOOD-MEDIUM-VG': 6.55,
    'M-IF-GOOD-POOR-MEDIUM-EX': 6.55,
    'M-IF-VG-VG-MEDIUM-VG': 6.55,
    'M-IF-GOOD-EX-MEDIUM-VG': 6.55,
    'D-I1-EX-EX-MEDIUM-GOOD': 6.54,
    'D-I1-EX-POOR-MEDIUM-VG': 6.54,
    'D-I1-VG-GOOD-MEDIUM-VG': 6.54,
    'D-I1-POOR-EX-MEDIUM-VG': 6.54,
    'D-I1-POOR-POOR-MEDIUM-EX': 6.54,
    'D-SI1-EX-VG-STRONG-GOOD': 6.54,
    'D-SI1-VG-EX-STRONG-GOOD': 6.54,
    'D-SI1-POOR-VG-STRONG-VG': 6.54,
    'D-SI1-GOOD-GOOD-STRONG-VG': 6.54,
    'D-SI1-VG-POOR-STRONG-VG': 6.54,
    'D-I1-GOOD-VG-MEDIUM-VG': 6.54,
    'E-I1-POOR-EX-FAINT-VG': 6.54,
    'E-I1-EX-EX-FAINT-GOOD': 6.54,
    'E-I1-EX-POOR-FAINT-VG': 6.54,
    'E-SI1-POOR-VG-MEDIUM-VG': 6.54,
    'E-SI1-GOOD-GOOD-MEDIUM-VG': 6.54,
    'E-SI1-VG-POOR-MEDIUM-VG': 6.54,
    'E-I1-VG-GOOD-FAINT-VG': 6.54,
    'E-SI1-VG-EX-MEDIUM-GOOD': 6.54,
    'E-I1-GOOD-VG-FAINT-VG': 6.54,
    'E-SI1-EX-VG-MEDIUM-GOOD': 6.54,
    'E-I1-POOR-POOR-FAINT-EX': 6.54,
    'F-SI1-EX-VG-FAINT-GOOD': 6.54,
    'F-SI1-VG-EX-FAINT-GOOD': 6.54,
    'F-SI1-VG-POOR-FAINT-VG': 6.54,
    'F-SI1-GOOD-GOOD-FAINT-VG': 6.54,
    'F-SI1-POOR-VG-FAINT-VG': 6.54,
    'F-I1-EX-EX-NONE-GOOD': 6.54,
    'F-I1-EX-POOR-NONE-VG': 6.54,
    'F-I1-VG-GOOD-NONE-VG': 6.54,
    'F-I1-GOOD-VG-NONE-VG': 6.54,
    'F-I1-POOR-EX-NONE-VG': 6.54,
    'F-I1-POOR-POOR-NONE-EX': 6.54,
    'G-SI1-VG-POOR-NONE-VG': 6.54,
    'G-SI1-VG-EX-NONE-GOOD': 6.54,
    'G-SI1-POOR-VG-NONE-VG': 6.54,
    'G-SI1-EX-VG-NONE-GOOD': 6.54,
    'G-SI1-GOOD-GOOD-NONE-VG': 6.54,
    'H-I1-EX-GOOD-STRONG-EX': 6.54,
    'H-I1-GOOD-EX-STRONG-EX': 6.54,
    'H-I1-VG-VG-STRONG-EX': 6.54,
    'I-SI1-GOOD-VG-STRONG-EX': 6.54,
    'I-SI1-VG-GOOD-STRONG-EX': 6.54,
    'I-I1-EX-GOOD-MEDIUM-EX': 6.54,
    'I-SI1-POOR-EX-STRONG-EX': 6.54,
    'I-I1-GOOD-EX-MEDIUM-EX': 6.54,
    'I-I1-VG-VG-MEDIUM-EX': 6.54,
    'I-SI1-EX-EX-STRONG-VG': 6.54,
    'I-SI1-EX-POOR-STRONG-EX': 6.54,
    'J-SI1-EX-POOR-MEDIUM-EX': 6.54,
    'J-SI1-VG-GOOD-MEDIUM-EX': 6.54,
    'J-SI1-GOOD-VG-MEDIUM-EX': 6.54,
    'J-SI1-POOR-EX-MEDIUM-EX': 6.54,
    'J-SI1-EX-EX-MEDIUM-VG': 6.54,
    'J-I1-GOOD-EX-FAINT-EX': 6.54,
    'J-I1-VG-VG-FAINT-EX': 6.54,
    'J-I1-EX-GOOD-FAINT-EX': 6.54,
    'K-I1-VG-VG-NONE-EX': 6.54,
    'K-SI1-GOOD-VG-FAINT-EX': 6.54,
    'K-I1-EX-GOOD-NONE-EX': 6.54,
    'K-I1-GOOD-EX-NONE-EX': 6.54,
    'K-SI1-EX-EX-FAINT-VG': 6.54,
    'K-SI1-EX-POOR-FAINT-EX': 6.54,
    'K-SI1-VG-GOOD-FAINT-EX': 6.54,
    'K-SI1-POOR-EX-FAINT-EX': 6.54,
    'L-SI1-VG-GOOD-NONE-EX': 6.54,
    'L-SI1-EX-EX-NONE-VG': 6.54,
    'L-SI1-EX-POOR-NONE-EX': 6.54,
    'L-SI1-POOR-EX-NONE-EX': 6.54,
    'L-SI1-GOOD-VG-NONE-EX': 6.54,
    'D-VVS1-VG-POOR-NONE-POOR': 6.53,
    'D-VVS1-GOOD-GOOD-NONE-POOR': 6.53,
    'D-VVS1-POOR-VG-NONE-POOR': 6.53,
    'E-VS1-VG-VG-STRONG-GOOD': 6.53,
    'E-VS1-POOR-GOOD-STRONG-VG': 6.53,
    'E-VS1-GOOD-EX-STRONG-GOOD': 6.53,
    'E-VS1-GOOD-POOR-STRONG-VG': 6.53,
    'E-VS1-EX-GOOD-STRONG-GOOD': 6.53,
    'F-VVS1-POOR-POOR-STRONG-VG': 6.53,
    'F-VVS1-VG-GOOD-STRONG-GOOD': 6.53,
    'F-VVS1-POOR-EX-STRONG-GOOD': 6.53,
    'F-VVS1-GOOD-VG-STRONG-GOOD': 6.53,
    'F-VVS1-EX-POOR-STRONG-GOOD': 6.53,
    'F-VS1-GOOD-POOR-MEDIUM-VG': 6.53,
    'F-VS1-GOOD-EX-MEDIUM-GOOD': 6.53,
    'F-VS1-VG-VG-MEDIUM-GOOD': 6.53,
    'F-VS1-EX-GOOD-MEDIUM-GOOD': 6.53,
    'F-VS1-POOR-GOOD-MEDIUM-VG': 6.53,
    'F-VVS1-EX-EX-STRONG-POOR': 6.53,
    'G-VS1-GOOD-EX-FAINT-GOOD': 6.53,
    'G-VS1-VG-VG-FAINT-GOOD': 6.53,
    'G-VS1-EX-GOOD-FAINT-GOOD': 6.53,
    'G-VS1-POOR-GOOD-FAINT-VG': 6.53,
    'G-VS1-GOOD-POOR-FAINT-VG': 6.53,
    'G-VVS1-GOOD-VG-MEDIUM-GOOD': 6.53,
    'G-VVS1-POOR-POOR-MEDIUM-VG': 6.53,
    'G-VVS1-POOR-EX-MEDIUM-GOOD': 6.53,
    'G-VVS1-EX-EX-MEDIUM-POOR': 6.53,
    'G-VVS1-VG-GOOD-MEDIUM-GOOD': 6.53,
    'G-VVS1-EX-POOR-MEDIUM-GOOD': 6.53,
    'H-VS1-POOR-GOOD-NONE-VG': 6.53,
    'H-VS1-GOOD-POOR-NONE-VG': 6.53,
    'H-VS1-GOOD-EX-NONE-GOOD': 6.53,
    'H-VS1-VG-VG-NONE-GOOD': 6.53,
    'H-VS1-EX-GOOD-NONE-GOOD': 6.53,
    'H-VVS1-EX-EX-FAINT-POOR': 6.53,
    'H-VVS1-EX-POOR-FAINT-GOOD': 6.53,
    'H-VVS1-VG-GOOD-FAINT-GOOD': 6.53,
    'H-VVS1-POOR-POOR-FAINT-VG': 6.53,
    'H-VVS1-GOOD-VG-FAINT-GOOD': 6.53,
    'H-VVS1-POOR-EX-FAINT-GOOD': 6.53,
    'I-VVS1-EX-EX-NONE-POOR': 6.53,
    'I-VVS1-POOR-POOR-NONE-VG': 6.53,
    'I-VVS1-POOR-EX-NONE-GOOD': 6.53,
    'I-VVS1-GOOD-VG-NONE-GOOD': 6.53,
    'I-VVS1-VG-GOOD-NONE-GOOD': 6.53,
    'I-VVS1-EX-POOR-NONE-GOOD': 6.53,
    'J-VS1-GOOD-GOOD-STRONG-EX': 6.53,
    'J-VS1-POOR-VG-STRONG-EX': 6.53,
    'J-VS1-VG-POOR-STRONG-EX': 6.53,
    'J-VS1-VG-EX-STRONG-VG': 6.53,
    'J-VS1-EX-VG-STRONG-VG': 6.53,
    'K-VS1-EX-VG-MEDIUM-VG': 6.53,
    'K-VS1-VG-EX-MEDIUM-VG': 6.53,
    'K-VS1-VG-POOR-MEDIUM-EX': 6.53,
    'K-VS1-GOOD-GOOD-MEDIUM-EX': 6.53,
    'K-VS1-POOR-VG-MEDIUM-EX': 6.53,
    'K-VVS1-POOR-GOOD-STRONG-EX': 6.53,
    'K-VVS1-EX-GOOD-STRONG-VG': 6.53,
    'K-VVS1-VG-VG-STRONG-VG': 6.53,
    'K-VVS1-GOOD-EX-STRONG-VG': 6.53,
    'K-VVS1-GOOD-POOR-STRONG-EX': 6.53,
    'L-VS1-VG-POOR-FAINT-EX': 6.53,
    'L-VS1-VG-EX-FAINT-VG': 6.53,
    'L-VS1-EX-VG-FAINT-VG': 6.53,
    'L-VVS1-POOR-GOOD-MEDIUM-EX': 6.53,
    'L-VVS1-EX-GOOD-MEDIUM-VG': 6.53,
    'L-VVS1-GOOD-POOR-MEDIUM-EX': 6.53,
    'L-VVS1-VG-VG-MEDIUM-VG': 6.53,
    'L-VS1-POOR-VG-FAINT-EX': 6.53,
    'L-VVS1-GOOD-EX-MEDIUM-VG': 6.53,
    'L-VS1-GOOD-GOOD-FAINT-EX': 6.53,
    'M-VS1-POOR-VG-NONE-EX': 6.53,
    'M-VVS1-EX-GOOD-FAINT-VG': 6.53,
    'M-VVS1-VG-VG-FAINT-VG': 6.53,
    'M-VVS1-GOOD-EX-FAINT-VG': 6.53,
    'M-VS1-VG-EX-NONE-VG': 6.53,
    'M-VVS1-POOR-GOOD-FAINT-EX': 6.53,
    'M-VS1-GOOD-GOOD-NONE-EX': 6.53,
    'M-VS1-EX-VG-NONE-VG': 6.53,
    'M-VVS1-GOOD-POOR-FAINT-EX': 6.53,
    'M-VS1-VG-POOR-NONE-EX': 6.53,
    'D-SI2-EX-VG-MEDIUM-GOOD': 6.52,
    'D-SI2-GOOD-GOOD-MEDIUM-VG': 6.52,
    'D-I2-GOOD-VG-FAINT-VG': 6.52,
    'D-SI2-VG-EX-MEDIUM-GOOD': 6.52,
    'D-SI2-VG-POOR-MEDIUM-VG': 6.52,
    'D-I2-VG-GOOD-FAINT-VG': 6.52,
    'D-I2-POOR-EX-FAINT-VG': 6.52,
    'D-SI2-POOR-VG-MEDIUM-VG': 6.52,
    'D-I2-EX-POOR-FAINT-VG': 6.52,
    'D-I2-POOR-POOR-FAINT-EX': 6.52,
    'D-I2-EX-EX-FAINT-GOOD': 6.52,
    'E-SI2-EX-VG-FAINT-GOOD': 6.52,
    'E-SI2-GOOD-GOOD-FAINT-VG': 6.52,
    'E-SI2-VG-POOR-FAINT-VG': 6.52,
    'E-SI2-VG-EX-FAINT-GOOD': 6.52,
    'E-I2-EX-POOR-NONE-VG': 6.52,
    'E-I2-VG-GOOD-NONE-VG': 6.52,
    'E-I2-GOOD-VG-NONE-VG': 6.52,
    'E-I2-POOR-POOR-NONE-EX': 6.52,
    'E-I2-POOR-EX-NONE-VG': 6.52,
    'E-I2-EX-EX-NONE-GOOD': 6.52,
    'E-SI2-POOR-VG-FAINT-VG': 6.52,
    'F-SI2-VG-EX-NONE-GOOD': 6.52,
    'F-SI2-EX-VG-NONE-GOOD': 6.52,
    'F-SI2-POOR-VG-NONE-VG': 6.52,
    'F-SI2-VG-POOR-NONE-VG': 6.52,
    'F-SI2-GOOD-GOOD-NONE-VG': 6.52,
    'G-I2-VG-VG-STRONG-EX': 6.52,
    'G-I2-EX-GOOD-STRONG-EX': 6.52,
    'G-I2-GOOD-EX-STRONG-EX': 6.52,
    'H-SI2-POOR-EX-STRONG-EX': 6.52,
    'H-SI2-GOOD-VG-STRONG-EX': 6.52,
    'H-SI2-VG-GOOD-STRONG-EX': 6.52,
    'H-SI2-EX-POOR-STRONG-EX': 6.52,
    'H-SI2-EX-EX-STRONG-VG': 6.52,
    'H-I2-GOOD-EX-MEDIUM-EX': 6.52,
    'H-I2-VG-VG-MEDIUM-EX': 6.52,
    'H-I2-EX-GOOD-MEDIUM-EX': 6.52,
    'I-I2-GOOD-EX-FAINT-EX': 6.52,
    'I-SI2-VG-GOOD-MEDIUM-EX': 6.52,
    'I-SI2-POOR-EX-MEDIUM-EX': 6.52,
    'I-SI2-GOOD-VG-MEDIUM-EX': 6.52,
    'I-SI2-EX-POOR-MEDIUM-EX': 6.52,
    'I-I2-EX-GOOD-FAINT-EX': 6.52,
    'I-SI2-EX-EX-MEDIUM-VG': 6.52,
    'I-I2-VG-VG-FAINT-EX': 6.52,
    'J-I2-GOOD-EX-NONE-EX': 6.52,
    'J-SI2-EX-POOR-FAINT-EX': 6.52,
    'J-SI2-EX-EX-FAINT-VG': 6.52,
    'J-I2-EX-GOOD-NONE-EX': 6.52,
    'J-I2-VG-VG-NONE-EX': 6.52,
    'J-SI2-GOOD-VG-FAINT-EX': 6.52,
    'J-SI2-VG-GOOD-FAINT-EX': 6.52,
    'J-SI2-POOR-EX-FAINT-EX': 6.52,
    'K-SI2-EX-POOR-NONE-EX': 6.52,
    'K-SI2-EX-EX-NONE-VG': 6.52,
    'K-SI2-VG-GOOD-NONE-EX': 6.52,
    'K-SI2-GOOD-VG-NONE-EX': 6.52,
    'K-SI2-POOR-EX-NONE-EX': 6.52,
    'D-VS2-GOOD-POOR-STRONG-VG': 6.51,
    'D-VS2-VG-VG-STRONG-GOOD': 6.51,
    'D-VS2-GOOD-EX-STRONG-GOOD': 6.51,
    'D-VS2-POOR-GOOD-STRONG-VG': 6.51,
    'D-VS2-EX-GOOD-STRONG-GOOD': 6.51,
    'E-VS2-GOOD-EX-MEDIUM-GOOD': 6.51,
    'E-VS2-POOR-GOOD-MEDIUM-VG': 6.51,
    'E-VVS2-POOR-POOR-STRONG-VG': 6.51,
    'E-VS2-GOOD-POOR-MEDIUM-VG': 6.51,
    'E-VVS2-EX-EX-STRONG-POOR': 6.51,
    'E-VVS2-GOOD-VG-STRONG-GOOD': 6.51,
    'E-VVS2-POOR-EX-STRONG-GOOD': 6.51,
    'E-VS2-VG-VG-MEDIUM-GOOD': 6.51,
    'E-VVS2-EX-POOR-STRONG-GOOD': 6.51,
    'E-VVS2-VG-GOOD-STRONG-GOOD': 6.51,
    'E-VS2-EX-GOOD-MEDIUM-GOOD': 6.51,
    'F-VS2-EX-GOOD-FAINT-GOOD': 6.51,
    'F-VS2-VG-VG-FAINT-GOOD': 6.51,
    'F-VS2-GOOD-EX-FAINT-GOOD': 6.51,
    'F-VS2-GOOD-POOR-FAINT-VG': 6.51,
    'F-VS2-POOR-GOOD-FAINT-VG': 6.51,
    'F-VVS2-EX-POOR-MEDIUM-GOOD': 6.51,
    'F-VVS2-EX-EX-MEDIUM-POOR': 6.51,
    'F-VVS2-VG-GOOD-MEDIUM-GOOD': 6.51,
    'F-VVS2-POOR-POOR-MEDIUM-VG': 6.51,
    'F-VVS2-POOR-EX-MEDIUM-GOOD': 6.51,
    'F-VVS2-GOOD-VG-MEDIUM-GOOD': 6.51,
    'G-VS2-EX-GOOD-NONE-GOOD': 6.51,
    'G-VS2-GOOD-EX-NONE-GOOD': 6.51,
    'G-VS2-GOOD-POOR-NONE-VG': 6.51,
    'G-VVS2-POOR-EX-FAINT-GOOD': 6.51,
    'G-VVS2-VG-GOOD-FAINT-GOOD': 6.51,
    'G-VVS2-EX-POOR-FAINT-GOOD': 6.51,
    'G-VS2-VG-VG-NONE-GOOD': 6.51,
    'G-VS2-POOR-GOOD-NONE-VG': 6.51,
    'G-VVS2-POOR-POOR-FAINT-VG': 6.51,
    'G-VVS2-GOOD-VG-FAINT-GOOD': 6.51,
    'G-VVS2-EX-EX-FAINT-POOR': 6.51,
    'H-VVS2-GOOD-VG-NONE-GOOD': 6.51,
    'H-VVS2-VG-GOOD-NONE-GOOD': 6.51,
    'H-VVS2-EX-EX-NONE-POOR': 6.51,
    'H-VVS2-EX-POOR-NONE-GOOD': 6.51,
    'H-VVS2-POOR-POOR-NONE-VG': 6.51,
    'H-VVS2-POOR-EX-NONE-GOOD': 6.51,
    'I-VS2-EX-VG-STRONG-VG': 6.51,
    'I-VS2-POOR-VG-STRONG-EX': 6.51,
    'I-VS2-VG-POOR-STRONG-EX': 6.51,
    'I-VS2-VG-EX-STRONG-VG': 6.51,
    'I-VS2-GOOD-GOOD-STRONG-EX': 6.51,
    'J-VVS2-POOR-GOOD-STRONG-EX': 6.51,
    'J-VVS2-GOOD-POOR-STRONG-EX': 6.51,
    'J-VVS2-GOOD-EX-STRONG-VG': 6.51,
    'J-VVS2-VG-VG-STRONG-VG': 6.51,
    'J-VVS2-EX-GOOD-STRONG-VG': 6.51,
    'J-VS2-EX-VG-MEDIUM-VG': 6.51,
    'J-VS2-VG-EX-MEDIUM-VG': 6.51,
    'J-VS2-VG-POOR-MEDIUM-EX': 6.51,
    'J-VS2-GOOD-GOOD-MEDIUM-EX': 6.51,
    'J-VS2-POOR-VG-MEDIUM-EX': 6.51,
    'K-VVS2-VG-VG-MEDIUM-VG': 6.51,
    'K-VVS2-GOOD-EX-MEDIUM-VG': 6.51,
    'K-VVS2-EX-GOOD-MEDIUM-VG': 6.51,
    'K-VVS2-GOOD-POOR-MEDIUM-EX': 6.51,
    'K-VS2-EX-VG-FAINT-VG': 6.51,
    'K-VVS2-POOR-GOOD-MEDIUM-EX': 6.51,
    'K-VS2-VG-EX-FAINT-VG': 6.51,
    'K-VS2-POOR-VG-FAINT-EX': 6.51,
    'K-VS2-VG-POOR-FAINT-EX': 6.51,
    'K-VS2-GOOD-GOOD-FAINT-EX': 6.51,
    'L-VVS2-GOOD-POOR-FAINT-EX': 6.51,
    'L-VS2-VG-POOR-NONE-EX': 6.51,
    'L-VS2-EX-VG-NONE-VG': 6.51,
    'L-VS2-VG-EX-NONE-VG': 6.51,
    'L-VVS2-EX-GOOD-FAINT-VG': 6.51,
    'L-VVS2-VG-VG-FAINT-VG': 6.51,
    'L-VVS2-POOR-GOOD-FAINT-EX': 6.51,
    'L-VS2-GOOD-GOOD-NONE-EX': 6.51,
    'L-VVS2-GOOD-EX-FAINT-VG': 6.51,
    'L-VS2-POOR-VG-NONE-EX': 6.51,
    'M-VVS2-POOR-GOOD-NONE-EX': 6.51,
    'M-VVS2-GOOD-POOR-NONE-EX': 6.51,
    'M-VVS2-EX-GOOD-NONE-VG': 6.51,
    'M-VVS2-GOOD-EX-NONE-VG': 6.51,
    'M-VVS2-VG-VG-NONE-VG': 6.51,
    'D-IF-GOOD-POOR-NONE-POOR': 6.5,
    'D-IF-POOR-GOOD-NONE-POOR': 6.5,
    'F-IF-EX-VG-STRONG-POOR': 6.5,
    'F-IF-GOOD-GOOD-STRONG-GOOD': 6.5,
    'F-IF-POOR-VG-STRONG-GOOD': 6.5,
    'F-IF-VG-POOR-STRONG-GOOD': 6.5,
    'F-IF-VG-EX-STRONG-POOR': 6.5,
    'G-IF-GOOD-GOOD-MEDIUM-GOOD': 6.5,
    'G-IF-EX-VG-MEDIUM-POOR': 6.5,
    'G-IF-VG-POOR-MEDIUM-GOOD': 6.5,
    'G-IF-POOR-VG-MEDIUM-GOOD': 6.5,
    'G-IF-VG-EX-MEDIUM-POOR': 6.5,
    'H-IF-POOR-VG-FAINT-GOOD': 6.5,
    'H-IF-EX-VG-FAINT-POOR': 6.5,
    'H-IF-VG-EX-FAINT-POOR': 6.5,
    'H-IF-VG-POOR-FAINT-GOOD': 6.5,
    'H-IF-GOOD-GOOD-FAINT-GOOD': 6.5,
    'I-IF-VG-EX-NONE-POOR': 6.5,
    'I-IF-VG-POOR-NONE-GOOD': 6.5,
    'I-IF-EX-VG-NONE-POOR': 6.5,
    'I-IF-GOOD-GOOD-NONE-GOOD': 6.5,
    'I-IF-POOR-VG-NONE-GOOD': 6.5,
    'K-IF-GOOD-VG-STRONG-VG': 6.5,
    'K-IF-POOR-POOR-STRONG-EX': 6.5,
    'K-IF-POOR-EX-STRONG-VG': 6.5,
    'K-IF-VG-GOOD-STRONG-VG': 6.5,
    'K-IF-EX-POOR-STRONG-VG': 6.5,
    'K-IF-EX-EX-STRONG-GOOD': 6.5,
    'L-IF-POOR-POOR-MEDIUM-EX': 6.5,
    'L-IF-EX-EX-MEDIUM-GOOD': 6.5,
    'L-IF-EX-POOR-MEDIUM-VG': 6.5,
    'L-IF-GOOD-VG-MEDIUM-VG': 6.5,
    'L-IF-POOR-EX-MEDIUM-VG': 6.5,
    'L-IF-VG-GOOD-MEDIUM-VG': 6.5,
    'M-IF-POOR-EX-FAINT-VG': 6.5,
    'M-IF-VG-GOOD-FAINT-VG': 6.5,
    'M-IF-GOOD-VG-FAINT-VG': 6.5,
    'M-IF-EX-POOR-FAINT-VG': 6.5,
    'M-IF-POOR-POOR-FAINT-EX': 6.5,
    'M-IF-EX-EX-FAINT-GOOD': 6.5,
    'D-I1-GOOD-GOOD-FAINT-VG': 6.49,
    'D-SI1-EX-GOOD-MEDIUM-GOOD': 6.49,
    'D-I1-POOR-VG-FAINT-VG': 6.49,
    'D-SI1-VG-VG-MEDIUM-GOOD': 6.49,
    'D-SI1-GOOD-POOR-MEDIUM-VG': 6.49,
    'D-SI1-GOOD-EX-MEDIUM-GOOD': 6.49,
    'D-SI1-POOR-GOOD-MEDIUM-VG': 6.49,
    'D-I1-VG-POOR-FAINT-VG': 6.49,
    'D-I1-VG-EX-FAINT-GOOD': 6.49,
    'D-I1-EX-VG-FAINT-GOOD': 6.49,
    'E-I1-VG-POOR-NONE-VG': 6.49,
    'E-SI1-GOOD-EX-FAINT-GOOD': 6.49,
    'E-SI1-VG-VG-FAINT-GOOD': 6.49,
    'E-SI1-EX-GOOD-FAINT-GOOD': 6.49,
    'E-SI1-GOOD-POOR-FAINT-VG': 6.49,
    'E-I1-POOR-VG-NONE-VG': 6.49,
    'E-I1-GOOD-GOOD-NONE-VG': 6.49,
    'E-SI1-POOR-GOOD-FAINT-VG': 6.49,
    'E-I1-EX-VG-NONE-GOOD': 6.49,
    'E-I1-VG-EX-NONE-GOOD': 6.49,
    'F-SI1-POOR-GOOD-NONE-VG': 6.49,
    'F-SI1-GOOD-POOR-NONE-VG': 6.49,
    'F-SI1-GOOD-EX-NONE-GOOD': 6.49,
    'F-SI1-VG-VG-NONE-GOOD': 6.49,
    'F-SI1-EX-GOOD-NONE-GOOD': 6.49,
    'G-I1-POOR-EX-STRONG-EX': 6.49,
    'G-I1-EX-POOR-STRONG-EX': 6.49,
    'G-I1-VG-GOOD-STRONG-EX': 6.49,
    'G-I1-EX-EX-STRONG-VG': 6.49,
    'G-I1-GOOD-VG-STRONG-EX': 6.49,
    'H-SI1-GOOD-GOOD-STRONG-EX': 6.49,
    'H-I1-VG-GOOD-MEDIUM-EX': 6.49,
    'H-I1-EX-EX-MEDIUM-VG': 6.49,
    'H-I1-EX-POOR-MEDIUM-EX': 6.49,
    'H-SI1-EX-VG-STRONG-VG': 6.49,
    'H-SI1-VG-POOR-STRONG-EX': 6.49,
    'H-I1-POOR-EX-MEDIUM-EX': 6.49,
    'H-SI1-POOR-VG-STRONG-EX': 6.49,
    'H-I1-GOOD-VG-MEDIUM-EX': 6.49,
    'H-SI1-VG-EX-STRONG-VG': 6.49,
    'I-I1-VG-GOOD-FAINT-EX': 6.49,
    'I-I1-EX-POOR-FAINT-EX': 6.49,
    'I-SI1-VG-EX-MEDIUM-VG': 6.49,
    'I-SI1-GOOD-GOOD-MEDIUM-EX': 6.49,
    'I-SI1-EX-VG-MEDIUM-VG': 6.49,
    'I-I1-POOR-EX-FAINT-EX': 6.49,
    'I-I1-GOOD-VG-FAINT-EX': 6.49,
    'I-SI1-VG-POOR-MEDIUM-EX': 6.49,
    'I-SI1-POOR-VG-MEDIUM-EX': 6.49,
    'I-I1-EX-EX-FAINT-VG': 6.49,
    'J-I1-POOR-EX-NONE-EX': 6.49,
    'J-I1-GOOD-VG-NONE-EX': 6.49,
    'J-I1-EX-POOR-NONE-EX': 6.49,
    'J-SI1-EX-VG-FAINT-VG': 6.49,
    'J-I1-EX-EX-NONE-VG': 6.49,
    'J-SI1-POOR-VG-FAINT-EX': 6.49,
    'J-SI1-GOOD-GOOD-FAINT-EX': 6.49,
    'J-SI1-VG-POOR-FAINT-EX': 6.49,
    'J-SI1-VG-EX-FAINT-VG': 6.49,
    'J-I1-VG-GOOD-NONE-EX': 6.49,
    'K-SI1-GOOD-GOOD-NONE-EX': 6.49,
    'K-SI1-VG-POOR-NONE-EX': 6.49,
    'K-SI1-VG-EX-NONE-VG': 6.49,
    'K-SI1-EX-VG-NONE-VG': 6.49,
    'K-SI1-POOR-VG-NONE-EX': 6.49,
    'M-SI1-EX-EX-STRONG-EX': 6.49,
    'D-VS1-VG-GOOD-STRONG-GOOD': 6.48,
    'D-VS1-GOOD-VG-STRONG-GOOD': 6.48,
    'D-VS1-POOR-EX-STRONG-GOOD': 6.48,
    'D-VS1-POOR-POOR-STRONG-VG': 6.48,
    'D-VS1-EX-EX-STRONG-POOR': 6.48,
    'D-VS1-EX-POOR-STRONG-GOOD': 6.48,
    'E-VS1-EX-EX-MEDIUM-POOR': 6.48,
    'E-VVS1-GOOD-GOOD-STRONG-GOOD': 6.48,
    'E-VS1-POOR-EX-MEDIUM-GOOD': 6.48,
    'E-VS1-VG-GOOD-MEDIUM-GOOD': 6.48,
    'E-VS1-EX-POOR-MEDIUM-GOOD': 6.48,
    'E-VS1-POOR-POOR-MEDIUM-VG': 6.48,
    'E-VVS1-POOR-VG-STRONG-GOOD': 6.48,
    'E-VVS1-VG-POOR-STRONG-GOOD': 6.48,
    'E-VVS1-EX-VG-STRONG-POOR': 6.48,
    'E-VVS1-VG-EX-STRONG-POOR': 6.48,
    'E-VS1-GOOD-VG-MEDIUM-GOOD': 6.48,
    'F-VS1-VG-GOOD-FAINT-GOOD': 6.48,
    'F-VS1-EX-EX-FAINT-POOR': 6.48,
    'F-VS1-EX-POOR-FAINT-GOOD': 6.48,
    'F-VS1-GOOD-VG-FAINT-GOOD': 6.48,
    'F-VS1-POOR-EX-FAINT-GOOD': 6.48,
    'F-VS1-POOR-POOR-FAINT-VG': 6.48,
    'F-VVS1-POOR-VG-MEDIUM-GOOD': 6.48,
    'F-VVS1-GOOD-GOOD-MEDIUM-GOOD': 6.48,
    'F-VVS1-EX-VG-MEDIUM-POOR': 6.48,
    'F-VVS1-VG-EX-MEDIUM-POOR': 6.48,
    'F-VVS1-VG-POOR-MEDIUM-GOOD': 6.48,
    'G-VS1-POOR-POOR-NONE-VG': 6.48,
    'G-VVS1-POOR-VG-FAINT-GOOD': 6.48,
    'G-VVS1-EX-VG-FAINT-POOR': 6.48,
    'G-VVS1-GOOD-GOOD-FAINT-GOOD': 6.48,
    'G-VVS1-VG-POOR-FAINT-GOOD': 6.48,
    'G-VVS1-VG-EX-FAINT-POOR': 6.48,
    'G-VS1-EX-EX-NONE-POOR': 6.48,
    'G-VS1-EX-POOR-NONE-GOOD': 6.48,
    'G-VS1-POOR-EX-NONE-GOOD': 6.48,
    'G-VS1-VG-GOOD-NONE-GOOD': 6.48,
    'G-VS1-GOOD-VG-NONE-GOOD': 6.48,
    'H-VVS1-GOOD-GOOD-NONE-GOOD': 6.48,
    'H-VVS1-EX-VG-NONE-POOR': 6.48,
    'H-VVS1-VG-EX-NONE-POOR': 6.48,
    'H-VVS1-POOR-VG-NONE-GOOD': 6.48,
    'H-VVS1-VG-POOR-NONE-GOOD': 6.48,
    'I-VS1-EX-GOOD-STRONG-VG': 6.48,
    'I-VS1-GOOD-EX-STRONG-VG': 6.48,
    'I-VS1-GOOD-POOR-STRONG-EX': 6.48,
    'I-VS1-POOR-GOOD-STRONG-EX': 6.48,
    'I-VS1-VG-VG-STRONG-VG': 6.48,
    'J-VVS1-POOR-EX-STRONG-VG': 6.48,
    'J-VVS1-VG-GOOD-STRONG-VG': 6.48,
    'J-VVS1-POOR-POOR-STRONG-EX': 6.48,
    'J-VVS1-GOOD-VG-STRONG-VG': 6.48,
    'J-VS1-POOR-GOOD-MEDIUM-EX': 6.48,
    'J-VS1-GOOD-POOR-MEDIUM-EX': 6.48,
    'J-VS1-EX-GOOD-MEDIUM-VG': 6.48,
    'J-VS1-VG-VG-MEDIUM-VG': 6.48,
    'J-VS1-GOOD-EX-MEDIUM-VG': 6.48,
    'J-VVS1-EX-POOR-STRONG-VG': 6.48,
    'J-VVS1-EX-EX-STRONG-GOOD': 6.48,
    'K-VS1-POOR-GOOD-FAINT-EX': 6.48,
    'K-VS1-GOOD-POOR-FAINT-EX': 6.48,
    'K-VS1-GOOD-EX-FAINT-VG': 6.48,
    'K-VS1-VG-VG-FAINT-VG': 6.48,
    'K-VS1-EX-GOOD-FAINT-VG': 6.48,
    'K-VVS1-EX-EX-MEDIUM-GOOD': 6.48,
    'K-VVS1-POOR-POOR-MEDIUM-EX': 6.48,
    'K-VVS1-GOOD-VG-MEDIUM-VG': 6.48,
    'K-VVS1-POOR-EX-MEDIUM-VG': 6.48,
    'K-VVS1-VG-GOOD-MEDIUM-VG': 6.48,
    'K-VVS1-EX-POOR-MEDIUM-VG': 6.48,
    'L-VVS1-VG-GOOD-FAINT-VG': 6.48,
    'L-VVS1-EX-EX-FAINT-GOOD': 6.48,
    'L-VVS1-EX-POOR-FAINT-VG': 6.48,
    'L-VS1-VG-VG-NONE-VG': 6.48,
    'L-VS1-POOR-GOOD-NONE-EX': 6.48,
    'L-VS1-EX-GOOD-NONE-VG': 6.48,
    'L-VVS1-POOR-POOR-FAINT-EX': 6.48,
    'L-VS1-GOOD-EX-NONE-VG': 6.48,
    'L-VS1-GOOD-POOR-NONE-EX': 6.48,
    'L-VVS1-GOOD-VG-FAINT-VG': 6.48,
    'L-VVS1-POOR-EX-FAINT-VG': 6.48,
    'M-VVS1-VG-GOOD-NONE-VG': 6.48,
    'M-VVS1-EX-EX-NONE-GOOD': 6.48,
    'M-VVS1-EX-POOR-NONE-VG': 6.48,
    'M-VVS1-GOOD-VG-NONE-VG': 6.48,
    'M-VVS1-POOR-EX-NONE-VG': 6.48,
    'M-VVS1-POOR-POOR-NONE-EX': 6.48,
    'D-I2-VG-POOR-NONE-VG': 6.47,
    'D-I2-VG-EX-NONE-GOOD': 6.47,
    'D-I2-POOR-VG-NONE-VG': 6.47,
    'D-I2-EX-VG-NONE-GOOD': 6.47,
    'D-SI2-GOOD-POOR-FAINT-VG': 6.47,
    'D-SI2-GOOD-EX-FAINT-GOOD': 6.47,
    'D-SI2-EX-GOOD-FAINT-GOOD': 6.47,
    'D-SI2-VG-VG-FAINT-GOOD': 6.47,
    'D-I2-GOOD-GOOD-NONE-VG': 6.47,
    'D-SI2-POOR-GOOD-FAINT-VG': 6.47,
    'E-SI2-GOOD-EX-NONE-GOOD': 6.47,
    'E-SI2-EX-GOOD-NONE-GOOD': 6.47,
    'E-SI2-GOOD-POOR-NONE-VG': 6.47,
    'E-SI2-VG-VG-NONE-GOOD': 6.47,
    'E-SI2-POOR-GOOD-NONE-VG': 6.47,
    'F-I2-EX-EX-STRONG-VG': 6.47,
    'F-I2-POOR-EX-STRONG-EX': 6.47,
    'F-I2-VG-GOOD-STRONG-EX': 6.47,
    'F-I2-GOOD-VG-STRONG-EX': 6.47,
    'F-I2-EX-POOR-STRONG-EX': 6.47,
    'G-I2-VG-GOOD-MEDIUM-EX': 6.47,
    'G-I2-GOOD-VG-MEDIUM-EX': 6.47,
    'G-SI2-POOR-VG-STRONG-EX': 6.47,
    'G-I2-POOR-EX-MEDIUM-EX': 6.47,
    'G-I2-EX-POOR-MEDIUM-EX': 6.47,
    'G-I2-EX-EX-MEDIUM-VG': 6.47,
    'G-SI2-EX-VG-STRONG-VG': 6.47,
    'G-SI2-GOOD-GOOD-STRONG-EX': 6.47,
    'G-SI2-VG-POOR-STRONG-EX': 6.47,
    'G-SI2-VG-EX-STRONG-VG': 6.47,
    'H-I2-POOR-EX-FAINT-EX': 6.47,
    'H-I2-GOOD-VG-FAINT-EX': 6.47,
    'H-I2-EX-EX-FAINT-VG': 6.47,
    'H-I2-VG-GOOD-FAINT-EX': 6.47,
    'H-I2-EX-POOR-FAINT-EX': 6.47,
    'H-SI2-POOR-VG-MEDIUM-EX': 6.47,
    'H-SI2-GOOD-GOOD-MEDIUM-EX': 6.47,
    'H-SI2-VG-POOR-MEDIUM-EX': 6.47,
    'H-SI2-VG-EX-MEDIUM-VG': 6.47,
    'H-SI2-EX-VG-MEDIUM-VG': 6.47,
    'I-SI2-POOR-VG-FAINT-EX': 6.47,
    'I-I2-VG-GOOD-NONE-EX': 6.47,
    'I-I2-EX-EX-NONE-VG': 6.47,
    'I-I2-EX-POOR-NONE-EX': 6.47,
    'I-I2-POOR-EX-NONE-EX': 6.47,
    'I-I2-GOOD-VG-NONE-EX': 6.47,
    'I-SI2-GOOD-GOOD-FAINT-EX': 6.47,
    'I-SI2-VG-POOR-FAINT-EX': 6.47,
    'I-SI2-VG-EX-FAINT-VG': 6.47,
    'I-SI2-EX-VG-FAINT-VG': 6.47,
    'J-SI2-VG-EX-NONE-VG': 6.47,
    'J-SI2-EX-VG-NONE-VG': 6.47,
    'J-SI2-VG-POOR-NONE-EX': 6.47,
    'J-SI2-GOOD-GOOD-NONE-EX': 6.47,
    'J-SI2-POOR-VG-NONE-EX': 6.47,
    'L-SI2-EX-EX-STRONG-EX': 6.47,
    'M-SI2-EX-EX-MEDIUM-EX': 6.47,
    'D-VS2-POOR-POOR-MEDIUM-VG': 6.46,
    'D-VVS2-EX-VG-STRONG-POOR': 6.46,
    'D-VVS2-VG-POOR-STRONG-GOOD': 6.46,
    'D-VS2-EX-EX-MEDIUM-POOR': 6.46,
    'D-VS2-EX-POOR-MEDIUM-GOOD': 6.46,
    'D-VS2-POOR-EX-MEDIUM-GOOD': 6.46,
    'D-VS2-VG-GOOD-MEDIUM-GOOD': 6.46,
    'D-VS2-GOOD-VG-MEDIUM-GOOD': 6.46,
    'D-VVS2-GOOD-GOOD-STRONG-GOOD': 6.46,
    'D-VVS2-VG-EX-STRONG-POOR': 6.46,
    'D-VVS2-POOR-VG-STRONG-GOOD': 6.46,
    'E-VVS2-VG-EX-MEDIUM-POOR': 6.46,
    'E-VVS2-VG-POOR-MEDIUM-GOOD': 6.46,
    'E-VS2-GOOD-VG-FAINT-GOOD': 6.46,
    'E-VS2-POOR-EX-FAINT-GOOD': 6.46,
    'E-VVS2-EX-VG-MEDIUM-POOR': 6.46,
    'E-VS2-POOR-POOR-FAINT-VG': 6.46,
    'E-VVS2-GOOD-GOOD-MEDIUM-GOOD': 6.46,
    'E-VS2-EX-EX-FAINT-POOR': 6.46,
    'E-VS2-VG-GOOD-FAINT-GOOD': 6.46,
    'E-VS2-EX-POOR-FAINT-GOOD': 6.46,
    'E-VVS2-POOR-VG-MEDIUM-GOOD': 6.46,
    'F-VS2-EX-EX-NONE-POOR': 6.46,
    'F-VS2-EX-POOR-NONE-GOOD': 6.46,
    'F-VVS2-VG-POOR-FAINT-GOOD': 6.46,
    'F-VVS2-EX-VG-FAINT-POOR': 6.46,
    'F-VVS2-VG-EX-FAINT-POOR': 6.46,
    'F-VVS2-GOOD-GOOD-FAINT-GOOD': 6.46,
    'F-VS2-POOR-POOR-NONE-VG': 6.46,
    'F-VS2-VG-GOOD-NONE-GOOD': 6.46,
    'F-VS2-GOOD-VG-NONE-GOOD': 6.46,
    'F-VS2-POOR-EX-NONE-GOOD': 6.46,
    'F-VVS2-POOR-VG-FAINT-GOOD': 6.46,
    'G-VVS2-VG-EX-NONE-POOR': 6.46,
    'G-VVS2-POOR-VG-NONE-GOOD': 6.46,
    'G-VVS2-GOOD-GOOD-NONE-GOOD': 6.46,
    'G-VVS2-VG-POOR-NONE-GOOD': 6.46,
    'G-VVS2-EX-VG-NONE-POOR': 6.46,
    'H-VS2-POOR-GOOD-STRONG-EX': 6.46,
    'H-VS2-GOOD-POOR-STRONG-EX': 6.46,
    'H-VS2-GOOD-EX-STRONG-VG': 6.46,
    'H-VS2-VG-VG-STRONG-VG': 6.46,
    'H-VS2-EX-GOOD-STRONG-VG': 6.46,
    'I-VVS2-POOR-EX-STRONG-VG': 6.46,
    'I-VS2-VG-VG-MEDIUM-VG': 6.46,
    'I-VVS2-POOR-POOR-STRONG-EX': 6.46,
    'I-VVS2-EX-EX-STRONG-GOOD': 6.46,
    'I-VVS2-EX-POOR-STRONG-VG': 6.46,
    'I-VVS2-VG-GOOD-STRONG-VG': 6.46,
    'I-VVS2-GOOD-VG-STRONG-VG': 6.46,
    'I-VS2-EX-GOOD-MEDIUM-VG': 6.46,
    'I-VS2-GOOD-POOR-MEDIUM-EX': 6.46,
    'I-VS2-POOR-GOOD-MEDIUM-EX': 6.46,
    'I-VS2-GOOD-EX-MEDIUM-VG': 6.46,
    'J-VS2-EX-GOOD-FAINT-VG': 6.46,
    'J-VS2-VG-VG-FAINT-VG': 6.46,
    'J-VVS2-POOR-POOR-MEDIUM-EX': 6.46,
    'J-VS2-POOR-GOOD-FAINT-EX': 6.46,
    'J-VS2-GOOD-POOR-FAINT-EX': 6.46,
    'J-VS2-GOOD-EX-FAINT-VG': 6.46,
    'J-VVS2-GOOD-VG-MEDIUM-VG': 6.46,
    'J-VVS2-VG-GOOD-MEDIUM-VG': 6.46,
    'J-VVS2-EX-POOR-MEDIUM-VG': 6.46,
    'J-VVS2-EX-EX-MEDIUM-GOOD': 6.46,
    'J-VVS2-POOR-EX-MEDIUM-VG': 6.46,
    'K-VS2-POOR-GOOD-NONE-EX': 6.46,
    'K-VS2-GOOD-POOR-NONE-EX': 6.46,
    'K-VS2-GOOD-EX-NONE-VG': 6.46,
    'K-VVS2-EX-EX-FAINT-GOOD': 6.46,
    'K-VVS2-EX-POOR-FAINT-VG': 6.46,
    'K-VVS2-VG-GOOD-FAINT-VG': 6.46,
    'K-VVS2-GOOD-VG-FAINT-VG': 6.46,
    'K-VVS2-POOR-EX-FAINT-VG': 6.46,
    'K-VS2-EX-GOOD-NONE-VG': 6.46,
    'K-VVS2-POOR-POOR-FAINT-EX': 6.46,
    'K-VS2-VG-VG-NONE-VG': 6.46,
    'L-VVS2-GOOD-VG-NONE-VG': 6.46,
    'L-VVS2-EX-POOR-NONE-VG': 6.46,
    'L-VVS2-EX-EX-NONE-GOOD': 6.46,
    'L-VVS2-POOR-POOR-NONE-EX': 6.46,
    'L-VVS2-VG-GOOD-NONE-VG': 6.46,
    'L-VVS2-POOR-EX-NONE-VG': 6.46,
    'M-VS2-EX-VG-STRONG-EX': 6.46,
    'M-VS2-VG-EX-STRONG-EX': 6.46,
    'E-IF-POOR-GOOD-STRONG-GOOD': 6.45,
    'E-IF-GOOD-EX-STRONG-POOR': 6.45,
    'E-IF-GOOD-POOR-STRONG-GOOD': 6.45,
    'E-IF-EX-GOOD-STRONG-POOR': 6.45,
    'E-IF-VG-VG-STRONG-POOR': 6.45,
    'F-IF-VG-VG-MEDIUM-POOR': 6.45,
    'F-IF-POOR-GOOD-MEDIUM-GOOD': 6.45,
    'F-IF-EX-GOOD-MEDIUM-POOR': 6.45,
    'F-IF-GOOD-POOR-MEDIUM-GOOD': 6.45,
    'F-IF-GOOD-EX-MEDIUM-POOR': 6.45,
    'G-IF-VG-VG-FAINT-POOR': 6.45,
    'G-IF-GOOD-POOR-FAINT-GOOD': 6.45,
    'G-IF-EX-GOOD-FAINT-POOR': 6.45,
    'G-IF-GOOD-EX-FAINT-POOR': 6.45,
    'G-IF-POOR-GOOD-FAINT-GOOD': 6.45,
    'H-IF-EX-GOOD-NONE-POOR': 6.45,
    'H-IF-VG-VG-NONE-POOR': 6.45,
    'H-IF-POOR-GOOD-NONE-GOOD': 6.45,
    'H-IF-GOOD-POOR-NONE-GOOD': 6.45,
    'H-IF-GOOD-EX-NONE-POOR': 6.45,
    'J-IF-EX-VG-STRONG-GOOD': 6.45,
    'J-IF-POOR-VG-STRONG-VG': 6.45,
    'J-IF-VG-POOR-STRONG-VG': 6.45,
    'J-IF-GOOD-GOOD-STRONG-VG': 6.45,
    'J-IF-VG-EX-STRONG-GOOD': 6.45,
    'K-IF-VG-POOR-MEDIUM-VG': 6.45,
    'K-IF-POOR-VG-MEDIUM-VG': 6.45,
    'K-IF-GOOD-GOOD-MEDIUM-VG': 6.45,
    'K-IF-EX-VG-MEDIUM-GOOD': 6.45,
    'K-IF-VG-EX-MEDIUM-GOOD': 6.45,
    'L-IF-GOOD-GOOD-FAINT-VG': 6.45,
    'L-IF-POOR-VG-FAINT-VG': 6.45,
    'L-IF-EX-VG-FAINT-GOOD': 6.45,
    'L-IF-VG-POOR-FAINT-VG': 6.45,
    'L-IF-VG-EX-FAINT-GOOD': 6.45,
    'M-IF-POOR-VG-NONE-VG': 6.45,
    'M-IF-VG-POOR-NONE-VG': 6.45,
    'M-IF-GOOD-GOOD-NONE-VG': 6.45,
    'M-IF-VG-EX-NONE-GOOD': 6.45,
    'M-IF-EX-VG-NONE-GOOD': 6.45,
    'D-I1-GOOD-EX-NONE-GOOD': 6.44,
    'D-I1-GOOD-POOR-NONE-VG': 6.44,
    'D-I1-POOR-GOOD-NONE-VG': 6.44,
    'D-I1-EX-GOOD-NONE-GOOD': 6.44,
    'D-I1-VG-VG-NONE-GOOD': 6.44,
    'D-SI1-POOR-POOR-FAINT-VG': 6.44,
    'D-SI1-GOOD-VG-FAINT-GOOD': 6.44,
    'D-SI1-POOR-EX-FAINT-GOOD': 6.44,
    'D-SI1-VG-GOOD-FAINT-GOOD': 6.44,
    'D-SI1-EX-EX-FAINT-POOR': 6.44,
    'D-SI1-EX-POOR-FAINT-GOOD': 6.44,
    'E-SI1-EX-EX-NONE-POOR': 6.44,
    'E-SI1-POOR-EX-NONE-GOOD': 6.44,
    'E-SI1-EX-POOR-NONE-GOOD': 6.44,
    'E-SI1-VG-GOOD-NONE-GOOD': 6.44,
    'E-SI1-POOR-POOR-NONE-VG': 6.44,
    'E-SI1-GOOD-VG-NONE-GOOD': 6.44,
    'F-I1-EX-VG-STRONG-VG': 6.44,
    'F-I1-VG-EX-STRONG-VG': 6.44,
    'F-I1-VG-POOR-STRONG-EX': 6.44,
    'F-I1-GOOD-GOOD-STRONG-EX': 6.44,
    'F-I1-POOR-VG-STRONG-EX': 6.44,
    'G-I1-POOR-VG-MEDIUM-EX': 6.44,
    'G-I1-EX-VG-MEDIUM-VG': 6.44,
    'G-I1-VG-EX-MEDIUM-VG': 6.44,
    'G-I1-VG-POOR-MEDIUM-EX': 6.44,
    'G-I1-GOOD-GOOD-MEDIUM-EX': 6.44,
    'G-SI1-GOOD-EX-STRONG-VG': 6.44,
    'G-SI1-VG-VG-STRONG-VG': 6.44,
    'G-SI1-EX-GOOD-STRONG-VG': 6.44,
    'G-SI1-GOOD-POOR-STRONG-EX': 6.44,
    'G-SI1-POOR-GOOD-STRONG-EX': 6.44,
    'H-SI1-GOOD-EX-MEDIUM-VG': 6.44,
    'H-SI1-VG-VG-MEDIUM-VG': 6.44,
    'H-SI1-EX-GOOD-MEDIUM-VG': 6.44,
    'H-I1-POOR-VG-FAINT-EX': 6.44,
    'H-I1-GOOD-GOOD-FAINT-EX': 6.44,
    'H-I1-VG-POOR-FAINT-EX': 6.44,
    'H-I1-VG-EX-FAINT-VG': 6.44,
    'H-I1-EX-VG-FAINT-VG': 6.44,
    'H-SI1-GOOD-POOR-MEDIUM-EX': 6.44,
    'H-SI1-POOR-GOOD-MEDIUM-EX': 6.44,
    'I-I1-VG-EX-NONE-VG': 6.44,
    'I-I1-VG-POOR-NONE-EX': 6.44,
    'I-I1-GOOD-GOOD-NONE-EX': 6.44,
    'I-SI1-POOR-GOOD-FAINT-EX': 6.44,
    'I-I1-POOR-VG-NONE-EX': 6.44,
    'I-SI1-GOOD-POOR-FAINT-EX': 6.44,
    'I-SI1-GOOD-EX-FAINT-VG': 6.44,
    'I-SI1-VG-VG-FAINT-VG': 6.44,
    'I-SI1-EX-GOOD-FAINT-VG': 6.44,
    'I-I1-EX-VG-NONE-VG': 6.44,
    'J-SI1-EX-GOOD-NONE-VG': 6.44,
    'J-SI1-VG-VG-NONE-VG': 6.44,
    'J-SI1-GOOD-EX-NONE-VG': 6.44,
    'J-SI1-GOOD-POOR-NONE-EX': 6.44,
    'J-SI1-POOR-GOOD-NONE-EX': 6.44,
    'K-I1-EX-EX-STRONG-EX': 6.44,
    'L-SI1-VG-EX-STRONG-EX': 6.44,
    'L-SI1-EX-VG-STRONG-EX': 6.44,
    'L-I1-EX-EX-MEDIUM-EX': 6.44,
    'M-SI1-EX-VG-MEDIUM-EX': 6.44,
    'M-SI1-VG-EX-MEDIUM-EX': 6.44,
    'M-I1-EX-EX-FAINT-EX': 6.44,
    'D-VS1-VG-EX-MEDIUM-POOR': 6.43,
    'D-VS1-EX-VG-MEDIUM-POOR': 6.43,
    'D-VS1-GOOD-GOOD-MEDIUM-GOOD': 6.43,
    'D-VS1-VG-POOR-MEDIUM-GOOD': 6.43,
    'D-VVS1-GOOD-EX-STRONG-POOR': 6.43,
    'D-VVS1-EX-GOOD-STRONG-POOR': 6.43,
    'D-VVS1-VG-VG-STRONG-POOR': 6.43,
    'D-VVS1-GOOD-POOR-STRONG-GOOD': 6.43,
    'D-VS1-POOR-VG-MEDIUM-GOOD': 6.43,
    'D-VVS1-POOR-GOOD-STRONG-GOOD': 6.43,
    'E-VVS1-EX-GOOD-MEDIUM-POOR': 6.43,
    'E-VVS1-POOR-GOOD-MEDIUM-GOOD': 6.43,
    'E-VVS1-GOOD-POOR-MEDIUM-GOOD': 6.43,
    'E-VVS1-GOOD-EX-MEDIUM-POOR': 6.43,
    'E-VVS1-VG-VG-MEDIUM-POOR': 6.43,
    'E-VS1-VG-POOR-FAINT-GOOD': 6.43,
    'E-VS1-VG-EX-FAINT-POOR': 6.43,
    'E-VS1-EX-VG-FAINT-POOR': 6.43,
    'E-VS1-POOR-VG-FAINT-GOOD': 6.43,
    'E-VS1-GOOD-GOOD-FAINT-GOOD': 6.43,
    'F-VS1-GOOD-GOOD-NONE-GOOD': 6.43,
    'F-VVS1-GOOD-POOR-FAINT-GOOD': 6.43,
    'F-VVS1-POOR-GOOD-FAINT-GOOD': 6.43,
    'F-VS1-VG-POOR-NONE-GOOD': 6.43,
    'F-VS1-VG-EX-NONE-POOR': 6.43,
    'F-VS1-POOR-VG-NONE-GOOD': 6.43,
    'F-VVS1-EX-GOOD-FAINT-POOR': 6.43,
    'F-VVS1-VG-VG-FAINT-POOR': 6.43,
    'F-VVS1-GOOD-EX-FAINT-POOR': 6.43,
    'F-VS1-EX-VG-NONE-POOR': 6.43,
    'G-VVS1-GOOD-EX-NONE-POOR': 6.43,
    'G-VVS1-POOR-GOOD-NONE-GOOD': 6.43,
    'G-VVS1-GOOD-POOR-NONE-GOOD': 6.43,
    'G-VVS1-EX-GOOD-NONE-POOR': 6.43,
    'G-VVS1-VG-VG-NONE-POOR': 6.43,
    'H-VS1-POOR-POOR-STRONG-EX': 6.43,
    'H-VS1-EX-EX-STRONG-GOOD': 6.43,
    'H-VS1-EX-POOR-STRONG-VG': 6.43,
    'H-VS1-VG-GOOD-STRONG-VG': 6.43,
    'H-VS1-POOR-EX-STRONG-VG': 6.43,
    'H-VS1-GOOD-VG-STRONG-VG': 6.43,
    'I-VVS1-EX-VG-STRONG-GOOD': 6.43,
    'I-VS1-POOR-POOR-MEDIUM-EX': 6.43,
    'I-VS1-POOR-EX-MEDIUM-VG': 6.43,
    'I-VS1-GOOD-VG-MEDIUM-VG': 6.43,
    'I-VS1-VG-GOOD-MEDIUM-VG': 6.43,
    'I-VS1-EX-POOR-MEDIUM-VG': 6.43,
    'I-VS1-EX-EX-MEDIUM-GOOD': 6.43,
    'I-VVS1-VG-EX-STRONG-GOOD': 6.43,
    'I-VVS1-VG-POOR-STRONG-VG': 6.43,
    'I-VVS1-GOOD-GOOD-STRONG-VG': 6.43,
    'I-VVS1-POOR-VG-STRONG-VG': 6.43,
    'J-VS1-POOR-EX-FAINT-VG': 6.43,
    'J-VVS1-POOR-VG-MEDIUM-VG': 6.43,
    'J-VS1-EX-EX-FAINT-GOOD': 6.43,
    'J-VS1-EX-POOR-FAINT-VG': 6.43,
    'J-VS1-POOR-POOR-FAINT-EX': 6.43,
    'J-VS1-VG-GOOD-FAINT-VG': 6.43,
    'J-VVS1-EX-VG-MEDIUM-GOOD': 6.43,
    'J-VVS1-GOOD-GOOD-MEDIUM-VG': 6.43,
    'J-VVS1-VG-POOR-MEDIUM-VG': 6.43,
    'J-VVS1-VG-EX-MEDIUM-GOOD': 6.43,
    'J-VS1-GOOD-VG-FAINT-VG': 6.43,
    'K-VS1-POOR-POOR-NONE-EX': 6.43,
    'K-VS1-GOOD-VG-NONE-VG': 6.43,
    'K-VS1-POOR-EX-NONE-VG': 6.43,
    'K-VS1-VG-GOOD-NONE-VG': 6.43,
    'K-VS1-EX-POOR-NONE-VG': 6.43,
    'K-VS1-EX-EX-NONE-GOOD': 6.43,
    'K-VVS1-EX-VG-FAINT-GOOD': 6.43,
    'K-VVS1-VG-EX-FAINT-GOOD': 6.43,
    'K-VVS1-VG-POOR-FAINT-VG': 6.43,
    'K-VVS1-POOR-VG-FAINT-VG': 6.43,
    'K-VVS1-GOOD-GOOD-FAINT-VG': 6.43,
    'L-VVS1-VG-POOR-NONE-VG': 6.43,
    'L-VVS1-POOR-VG-NONE-VG': 6.43,
    'L-VVS1-GOOD-GOOD-NONE-VG': 6.43,
    'L-VVS1-EX-VG-NONE-GOOD': 6.43,
    'L-VVS1-VG-EX-NONE-GOOD': 6.43,
    'M-VS1-EX-GOOD-STRONG-EX': 6.43,
    'M-VS1-VG-VG-STRONG-EX': 6.43,
    'M-VS1-GOOD-EX-STRONG-EX': 6.43,
    'D-SI2-GOOD-VG-NONE-GOOD': 6.42,
    'D-SI2-EX-EX-NONE-POOR': 6.42,
    'D-SI2-EX-POOR-NONE-GOOD': 6.42,
    'D-SI2-VG-GOOD-NONE-GOOD': 6.42,
    'D-SI2-POOR-EX-NONE-GOOD': 6.42,
    'D-SI2-POOR-POOR-NONE-VG': 6.42,
    'E-I2-POOR-VG-STRONG-EX': 6.42,
    'E-I2-GOOD-GOOD-STRONG-EX': 6.42,
    'E-I2-EX-VG-STRONG-VG': 6.42,
    'E-I2-VG-POOR-STRONG-EX': 6.42,
    'E-I2-VG-EX-STRONG-VG': 6.42,
    'F-I2-VG-POOR-MEDIUM-EX': 6.42,
    'F-I2-GOOD-GOOD-MEDIUM-EX': 6.42,
    'F-I2-POOR-VG-MEDIUM-EX': 6.42,
    'F-I2-VG-EX-MEDIUM-VG': 6.42,
    'F-SI2-EX-GOOD-STRONG-VG': 6.42,
    'F-SI2-POOR-GOOD-STRONG-EX': 6.42,
    'F-SI2-VG-VG-STRONG-VG': 6.42,
    'F-SI2-GOOD-POOR-STRONG-EX': 6.42,
    'F-I2-EX-VG-MEDIUM-VG': 6.42,
    'F-SI2-GOOD-EX-STRONG-VG': 6.42,
    'G-I2-GOOD-GOOD-FAINT-EX': 6.42,
    'G-SI2-EX-GOOD-MEDIUM-VG': 6.42,
    'G-SI2-VG-VG-MEDIUM-VG': 6.42,
    'G-I2-EX-VG-FAINT-VG': 6.42,
    'G-I2-VG-POOR-FAINT-EX': 6.42,
    'G-I2-POOR-VG-FAINT-EX': 6.42,
    'G-SI2-GOOD-POOR-MEDIUM-EX': 6.42,
    'G-SI2-GOOD-EX-MEDIUM-VG': 6.42,
    'G-I2-VG-EX-FAINT-VG': 6.42,
    'G-SI2-POOR-GOOD-MEDIUM-EX': 6.42,
    'H-I2-VG-POOR-NONE-EX': 6.42,
    'H-SI2-GOOD-EX-FAINT-VG': 6.42,
    'H-I2-GOOD-GOOD-NONE-EX': 6.42,
    'H-I2-POOR-VG-NONE-EX': 6.42,
    'H-SI2-VG-VG-FAINT-VG': 6.42,
    'H-SI2-GOOD-POOR-FAINT-EX': 6.42,
    'H-I2-VG-EX-NONE-VG': 6.42,
    'H-SI2-POOR-GOOD-FAINT-EX': 6.42,
    'H-I2-EX-VG-NONE-VG': 6.42,
    'H-SI2-EX-GOOD-FAINT-VG': 6.42,
    'I-SI2-POOR-GOOD-NONE-EX': 6.42,
    'I-SI2-GOOD-EX-NONE-VG': 6.42,
    'I-SI2-VG-VG-NONE-VG': 6.42,
    'I-SI2-EX-GOOD-NONE-VG': 6.42,
    'I-SI2-GOOD-POOR-NONE-EX': 6.42,
    'J-I2-EX-EX-STRONG-EX': 6.42,
    'K-SI2-EX-VG-STRONG-EX': 6.42,
    'K-SI2-VG-EX-STRONG-EX': 6.42,
    'K-I2-EX-EX-MEDIUM-EX': 6.42,
    'L-SI2-EX-VG-MEDIUM-EX': 6.42,
    'L-SI2-VG-EX-MEDIUM-EX': 6.42,
    'L-I2-EX-EX-FAINT-EX': 6.42,
    'M-I2-EX-EX-NONE-EX': 6.42,
    'M-SI2-EX-VG-FAINT-EX': 6.42,
    'M-SI2-VG-EX-FAINT-EX': 6.42,
    'D-VVS2-POOR-GOOD-MEDIUM-GOOD': 6.41,
    'D-VVS2-GOOD-EX-MEDIUM-POOR': 6.41,
    'D-VVS2-VG-VG-MEDIUM-POOR': 6.41,
    'D-VVS2-EX-GOOD-MEDIUM-POOR': 6.41,
    'D-VVS2-GOOD-POOR-MEDIUM-GOOD': 6.41,
    'D-VS2-VG-POOR-FAINT-GOOD': 6.41,
    'D-VS2-POOR-VG-FAINT-GOOD': 6.41,
    'D-VS2-GOOD-GOOD-FAINT-GOOD': 6.41,
    'D-VS2-VG-EX-FAINT-POOR': 6.41,
    'D-VS2-EX-VG-FAINT-POOR': 6.41,
    'E-VVS2-GOOD-POOR-FAINT-GOOD': 6.41,
    'E-VS2-EX-VG-NONE-POOR': 6.41,
    'E-VS2-VG-EX-NONE-POOR': 6.41,
    'E-VS2-POOR-VG-NONE-GOOD': 6.41,
    'E-VVS2-POOR-GOOD-FAINT-GOOD': 6.41,
    'E-VS2-GOOD-GOOD-NONE-GOOD': 6.41,
    'E-VVS2-EX-GOOD-FAINT-POOR': 6.41,
    'E-VVS2-VG-VG-FAINT-POOR': 6.41,
    'E-VVS2-GOOD-EX-FAINT-POOR': 6.41,
    'E-VS2-VG-POOR-NONE-GOOD': 6.41,
    'F-VVS2-EX-GOOD-NONE-POOR': 6.41,
    'F-VVS2-POOR-GOOD-NONE-GOOD': 6.41,
    'F-VVS2-GOOD-POOR-NONE-GOOD': 6.41,
    'F-VVS2-GOOD-EX-NONE-POOR': 6.41,
    'F-VVS2-VG-VG-NONE-POOR': 6.41,
    'G-VS2-VG-GOOD-STRONG-VG': 6.41,
    'G-VS2-GOOD-VG-STRONG-VG': 6.41,
    'G-VS2-EX-POOR-STRONG-VG': 6.41,
    'G-VS2-POOR-POOR-STRONG-EX': 6.41,
    'G-VS2-POOR-EX-STRONG-VG': 6.41,
    'G-VS2-EX-EX-STRONG-GOOD': 6.41,
    'H-VVS2-EX-VG-STRONG-GOOD': 6.41,
    'H-VS2-GOOD-VG-MEDIUM-VG': 6.41,
    'H-VS2-EX-POOR-MEDIUM-VG': 6.41,
    'H-VVS2-VG-POOR-STRONG-VG': 6.41,
    'H-VVS2-GOOD-GOOD-STRONG-VG': 6.41,
    'H-VS2-EX-EX-MEDIUM-GOOD': 6.41,
    'H-VS2-VG-GOOD-MEDIUM-VG': 6.41,
    'H-VS2-POOR-POOR-MEDIUM-EX': 6.41,
    'H-VVS2-VG-EX-STRONG-GOOD': 6.41,
    'H-VVS2-POOR-VG-STRONG-VG': 6.41,
    'H-VS2-POOR-EX-MEDIUM-VG': 6.41,
    'I-VS2-POOR-EX-FAINT-VG': 6.41,
    'I-VS2-GOOD-VG-FAINT-VG': 6.41,
    'I-VS2-VG-GOOD-FAINT-VG': 6.41,
    'I-VS2-EX-POOR-FAINT-VG': 6.41,
    'I-VS2-EX-EX-FAINT-GOOD': 6.41,
    'I-VVS2-POOR-VG-MEDIUM-VG': 6.41,
    'I-VVS2-VG-POOR-MEDIUM-VG': 6.41,
    'I-VVS2-VG-EX-MEDIUM-GOOD': 6.41,
    'I-VVS2-EX-VG-MEDIUM-GOOD': 6.41,
    'I-VS2-POOR-POOR-FAINT-EX': 6.41,
    'I-VVS2-GOOD-GOOD-MEDIUM-VG': 6.41,
    'J-VS2-POOR-EX-NONE-VG': 6.41,
    'J-VS2-GOOD-VG-NONE-VG': 6.41,
    'J-VVS2-EX-VG-FAINT-GOOD': 6.41,
    'J-VS2-VG-GOOD-NONE-VG': 6.41,
    'J-VVS2-VG-EX-FAINT-GOOD': 6.41,
    'J-VS2-EX-POOR-NONE-VG': 6.41,
    'J-VS2-EX-EX-NONE-GOOD': 6.41,
    'J-VVS2-VG-POOR-FAINT-VG': 6.41,
    'J-VVS2-GOOD-GOOD-FAINT-VG': 6.41,
    'J-VVS2-POOR-VG-FAINT-VG': 6.41,
    'J-VS2-POOR-POOR-NONE-EX': 6.41,
    'K-VVS2-POOR-VG-NONE-VG': 6.41,
    'K-VVS2-EX-VG-NONE-GOOD': 6.41,
    'K-VVS2-VG-EX-NONE-GOOD': 6.41,
    'K-VVS2-VG-POOR-NONE-VG': 6.41,
    'K-VVS2-GOOD-GOOD-NONE-VG': 6.41,
    'L-VS2-VG-VG-STRONG-EX': 6.41,
    'L-VS2-EX-GOOD-STRONG-EX': 6.41,
    'L-VS2-GOOD-EX-STRONG-EX': 6.41,
    'M-VS2-GOOD-EX-MEDIUM-EX': 6.41,
    'M-VVS2-EX-EX-STRONG-VG': 6.41,
    'M-VS2-VG-VG-MEDIUM-EX': 6.41,
    'M-VVS2-POOR-EX-STRONG-EX': 6.41,
    'M-VVS2-GOOD-VG-STRONG-EX': 6.41,
    'M-VVS2-VG-GOOD-STRONG-EX': 6.41,
    'M-VVS2-EX-POOR-STRONG-EX': 6.41,
    'M-VS2-EX-GOOD-MEDIUM-EX': 6.41,
    'D-IF-POOR-POOR-STRONG-GOOD': 6.4,
    'D-IF-EX-POOR-STRONG-POOR': 6.4,
    'D-IF-VG-GOOD-STRONG-POOR': 6.4,
    'D-IF-POOR-EX-STRONG-POOR': 6.4,
    'D-IF-GOOD-VG-STRONG-POOR': 6.4,
    'E-IF-EX-POOR-MEDIUM-POOR': 6.4,
    'E-IF-GOOD-VG-MEDIUM-POOR': 6.4,
    'E-IF-POOR-EX-MEDIUM-POOR': 6.4,
    'E-IF-POOR-POOR-MEDIUM-GOOD': 6.4,
    'E-IF-VG-GOOD-MEDIUM-POOR': 6.4,
    'F-IF-EX-POOR-FAINT-POOR': 6.4,
    'F-IF-POOR-POOR-FAINT-GOOD': 6.4,
    'F-IF-POOR-EX-FAINT-POOR': 6.4,
    'F-IF-VG-GOOD-FAINT-POOR': 6.4,
    'F-IF-GOOD-VG-FAINT-POOR': 6.4,
    'G-IF-GOOD-VG-NONE-POOR': 6.4,
    'G-IF-VG-GOOD-NONE-POOR': 6.4,
    'G-IF-EX-POOR-NONE-POOR': 6.4,
    'G-IF-POOR-EX-NONE-POOR': 6.4,
    'G-IF-POOR-POOR-NONE-GOOD': 6.4,
    'I-IF-POOR-GOOD-STRONG-VG': 6.4,
    'I-IF-EX-GOOD-STRONG-GOOD': 6.4,
    'I-IF-VG-VG-STRONG-GOOD': 6.4,
    'I-IF-GOOD-POOR-STRONG-VG': 6.4,
    'I-IF-GOOD-EX-STRONG-GOOD': 6.4,
    'J-IF-POOR-GOOD-MEDIUM-VG': 6.4,
    'J-IF-VG-VG-MEDIUM-GOOD': 6.4,
    'J-IF-GOOD-EX-MEDIUM-GOOD': 6.4,
    'J-IF-EX-GOOD-MEDIUM-GOOD': 6.4,
    'J-IF-GOOD-POOR-MEDIUM-VG': 6.4,
    'K-IF-EX-GOOD-FAINT-GOOD': 6.4,
    'K-IF-VG-VG-FAINT-GOOD': 6.4,
    'K-IF-GOOD-EX-FAINT-GOOD': 6.4,
    'K-IF-GOOD-POOR-FAINT-VG': 6.4,
    'K-IF-POOR-GOOD-FAINT-VG': 6.4,
    'L-IF-EX-GOOD-NONE-GOOD': 6.4,
    'L-IF-GOOD-POOR-NONE-VG': 6.4,
    'L-IF-GOOD-EX-NONE-GOOD': 6.4,
    'L-IF-VG-VG-NONE-GOOD': 6.4,
    'L-IF-POOR-GOOD-NONE-VG': 6.4,
    'D-SI1-POOR-VG-NONE-GOOD': 6.39,
    'D-SI1-GOOD-GOOD-NONE-GOOD': 6.39,
    'D-SI1-VG-EX-NONE-POOR': 6.39,
    'D-SI1-VG-POOR-NONE-GOOD': 6.39,
    'D-SI1-EX-VG-NONE-POOR': 6.39,
    'E-I1-EX-GOOD-STRONG-VG': 6.39,
    'E-I1-GOOD-POOR-STRONG-EX': 6.39,
    'E-I1-POOR-GOOD-STRONG-EX': 6.39,
    'E-I1-GOOD-EX-STRONG-VG': 6.39,
    'E-I1-VG-VG-STRONG-VG': 6.39,
    'F-SI1-VG-GOOD-STRONG-VG': 6.39,
    'F-SI1-EX-POOR-STRONG-VG': 6.39,
    'F-SI1-EX-EX-STRONG-GOOD': 6.39,
    'F-SI1-POOR-POOR-STRONG-EX': 6.39,
    'F-SI1-POOR-EX-STRONG-VG': 6.39,
    'F-SI1-GOOD-VG-STRONG-VG': 6.39,
    'F-I1-GOOD-POOR-MEDIUM-EX': 6.39,
    'F-I1-POOR-GOOD-MEDIUM-EX': 6.39,
    'F-I1-VG-VG-MEDIUM-VG': 6.39,
    'F-I1-EX-GOOD-MEDIUM-VG': 6.39,
    'F-I1-GOOD-EX-MEDIUM-VG': 6.39,
    'G-I1-EX-GOOD-FAINT-VG': 6.39,
    'G-I1-GOOD-POOR-FAINT-EX': 6.39,
    'G-I1-POOR-GOOD-FAINT-EX': 6.39,
    'G-I1-GOOD-EX-FAINT-VG': 6.39,
    'G-I1-VG-VG-FAINT-VG': 6.39,
    'G-SI1-EX-EX-MEDIUM-GOOD': 6.39,
    'G-SI1-VG-GOOD-MEDIUM-VG': 6.39,
    'G-SI1-POOR-EX-MEDIUM-VG': 6.39,
    'G-SI1-GOOD-VG-MEDIUM-VG': 6.39,
    'G-SI1-EX-POOR-MEDIUM-VG': 6.39,
    'G-SI1-POOR-POOR-MEDIUM-EX': 6.39,
    'H-I1-EX-GOOD-NONE-VG': 6.39,
    'H-I1-VG-VG-NONE-VG': 6.39,
    'H-I1-GOOD-EX-NONE-VG': 6.39,
    'H-I1-POOR-GOOD-NONE-EX': 6.39,
    'H-I1-GOOD-POOR-NONE-EX': 6.39,
    'H-SI1-EX-POOR-FAINT-VG': 6.39,
    'H-SI1-POOR-EX-FAINT-VG': 6.39,
    'H-SI1-VG-GOOD-FAINT-VG': 6.39,
    'H-SI1-POOR-POOR-FAINT-EX': 6.39,
    'H-SI1-GOOD-VG-FAINT-VG': 6.39,
    'H-SI1-EX-EX-FAINT-GOOD': 6.39,
    'I-SI1-POOR-EX-NONE-VG': 6.39,
    'I-SI1-EX-EX-NONE-GOOD': 6.39,
    'I-SI1-EX-POOR-NONE-VG': 6.39,
    'I-SI1-VG-GOOD-NONE-VG': 6.39,
    'I-SI1-POOR-POOR-NONE-EX': 6.39,
    'I-SI1-GOOD-VG-NONE-VG': 6.39,
    'J-I1-EX-VG-STRONG-EX': 6.39,
    'J-I1-VG-EX-STRONG-EX': 6.39,
    'K-SI1-GOOD-EX-STRONG-EX': 6.39,
    'K-I1-EX-VG-MEDIUM-EX': 6.39,
    'K-I1-VG-EX-MEDIUM-EX': 6.39,
    'K-SI1-EX-GOOD-STRONG-EX': 6.39,
    'K-SI1-VG-VG-STRONG-EX': 6.39,
    'L-I1-VG-EX-FAINT-EX': 6.39,
    'L-SI1-EX-GOOD-MEDIUM-EX': 6.39,
    'L-I1-EX-VG-FAINT-EX': 6.39,
    'L-SI1-VG-VG-MEDIUM-EX': 6.39,
    'L-SI1-GOOD-EX-MEDIUM-EX': 6.39,
    'M-SI1-EX-GOOD-FAINT-EX': 6.39,
    'M-I1-VG-EX-NONE-EX': 6.39,
    'M-SI1-VG-VG-FAINT-EX': 6.39,
    'M-SI1-GOOD-EX-FAINT-EX': 6.39,
    'M-I1-EX-VG-NONE-EX': 6.39,
    'D-VVS1-GOOD-VG-MEDIUM-POOR': 6.38,
    'D-VS1-VG-VG-FAINT-POOR': 6.38,
    'D-VS1-EX-GOOD-FAINT-POOR': 6.38,
    'D-VS1-GOOD-EX-FAINT-POOR': 6.38,
    'D-VVS1-POOR-POOR-MEDIUM-GOOD': 6.38,
    'D-VVS1-EX-POOR-MEDIUM-POOR': 6.38,
    'D-VS1-GOOD-POOR-FAINT-GOOD': 6.38,
    'D-VVS1-VG-GOOD-MEDIUM-POOR': 6.38,
    'D-VVS1-POOR-EX-MEDIUM-POOR': 6.38,
    'D-VS1-POOR-GOOD-FAINT-GOOD': 6.38,
    'E-VS1-EX-GOOD-NONE-POOR': 6.38,
    'E-VVS1-VG-GOOD-FAINT-POOR': 6.38,
    'E-VVS1-GOOD-VG-FAINT-POOR': 6.38,
    'E-VVS1-POOR-POOR-FAINT-GOOD': 6.38,
    'E-VVS1-POOR-EX-FAINT-POOR': 6.38,
    'E-VS1-VG-VG-NONE-POOR': 6.38,
    'E-VS1-GOOD-EX-NONE-POOR': 6.38,
    'E-VS1-GOOD-POOR-NONE-GOOD': 6.38,
    'E-VVS1-EX-POOR-FAINT-POOR': 6.38,
    'E-VS1-POOR-GOOD-NONE-GOOD': 6.38,
    'F-VVS1-EX-POOR-NONE-POOR': 6.38,
    'F-VVS1-POOR-EX-NONE-POOR': 6.38,
    'F-VVS1-POOR-POOR-NONE-GOOD': 6.38,
    'F-VVS1-VG-GOOD-NONE-POOR': 6.38,
    'F-VVS1-GOOD-VG-NONE-POOR': 6.38,
    'G-VS1-GOOD-GOOD-STRONG-VG': 6.38,
    'G-VS1-POOR-VG-STRONG-VG': 6.38,
    'G-VS1-VG-POOR-STRONG-VG': 6.38,
    'G-VS1-VG-EX-STRONG-GOOD': 6.38,
    'G-VS1-EX-VG-STRONG-GOOD': 6.38,
    'H-VVS1-GOOD-EX-STRONG-GOOD': 6.38,
    'H-VVS1-GOOD-POOR-STRONG-VG': 6.38,
    'H-VVS1-POOR-GOOD-STRONG-VG': 6.38,
    'H-VVS1-EX-GOOD-STRONG-GOOD': 6.38,
    'H-VVS1-VG-VG-STRONG-GOOD': 6.38,
    'H-VS1-POOR-VG-MEDIUM-VG': 6.38,
    'H-VS1-GOOD-GOOD-MEDIUM-VG': 6.38,
    'H-VS1-VG-EX-MEDIUM-GOOD': 6.38,
    'H-VS1-VG-POOR-MEDIUM-VG': 6.38,
    'H-VS1-EX-VG-MEDIUM-GOOD': 6.38,
    'I-VS1-VG-POOR-FAINT-VG': 6.38,
    'I-VS1-VG-EX-FAINT-GOOD': 6.38,
    'I-VS1-EX-VG-FAINT-GOOD': 6.38,
    'I-VS1-GOOD-GOOD-FAINT-VG': 6.38,
    'I-VS1-POOR-VG-FAINT-VG': 6.38,
    'I-VVS1-VG-VG-MEDIUM-GOOD': 6.38,
    'I-VVS1-POOR-GOOD-MEDIUM-VG': 6.38,
    'I-VVS1-EX-GOOD-MEDIUM-GOOD': 6.38,
    'I-VVS1-GOOD-POOR-MEDIUM-VG': 6.38,
    'I-VVS1-GOOD-EX-MEDIUM-GOOD': 6.38,
    'J-VVS1-GOOD-POOR-FAINT-VG': 6.38,
    'J-VVS1-GOOD-EX-FAINT-GOOD': 6.38,
    'J-VVS1-VG-VG-FAINT-GOOD': 6.38,
    'J-VVS1-EX-GOOD-FAINT-GOOD': 6.38,
    'J-VVS1-POOR-GOOD-FAINT-VG': 6.38,
    'J-VS1-POOR-VG-NONE-VG': 6.38,
    'J-VS1-VG-POOR-NONE-VG': 6.38,
    'J-VS1-GOOD-GOOD-NONE-VG': 6.38,
    'J-VS1-EX-VG-NONE-GOOD': 6.38,
    'J-VS1-VG-EX-NONE-GOOD': 6.38,
    'K-VVS1-VG-VG-NONE-GOOD': 6.38,
    'K-VVS1-EX-GOOD-NONE-GOOD': 6.38,
    'K-VVS1-POOR-GOOD-NONE-VG': 6.38,
    'K-VVS1-GOOD-EX-NONE-GOOD': 6.38,
    'K-VVS1-GOOD-POOR-NONE-VG': 6.38,
    'L-VS1-POOR-EX-STRONG-EX': 6.38,
    'L-VS1-EX-POOR-STRONG-EX': 6.38,
    'L-VS1-VG-GOOD-STRONG-EX': 6.38,
    'L-VS1-GOOD-VG-STRONG-EX': 6.38,
    'L-VS1-EX-EX-STRONG-VG': 6.38,
    'M-VVS1-VG-EX-STRONG-VG': 6.38,
    'M-VS1-VG-GOOD-MEDIUM-EX': 6.38,
    'M-VS1-POOR-EX-MEDIUM-EX': 6.38,
    'M-VS1-GOOD-VG-MEDIUM-EX': 6.38,
    'M-VVS1-GOOD-GOOD-STRONG-EX': 6.38,
    'M-VVS1-POOR-VG-STRONG-EX': 6.38,
    'M-VVS1-EX-VG-STRONG-VG': 6.38,
    'M-VVS1-VG-POOR-STRONG-EX': 6.38,
    'M-VS1-EX-POOR-MEDIUM-EX': 6.38,
    'M-VS1-EX-EX-MEDIUM-VG': 6.38,
    'D-I2-GOOD-POOR-STRONG-EX': 6.37,
    'D-I2-POOR-GOOD-STRONG-EX': 6.37,
    'D-I2-EX-GOOD-STRONG-VG': 6.37,
    'D-I2-GOOD-EX-STRONG-VG': 6.37,
    'D-I2-VG-VG-STRONG-VG': 6.37,
    'E-SI2-POOR-POOR-STRONG-EX': 6.37,
    'E-SI2-EX-EX-STRONG-GOOD': 6.37,
    'E-SI2-GOOD-VG-STRONG-VG': 6.37,
    'E-SI2-VG-GOOD-STRONG-VG': 6.37,
    'E-I2-GOOD-EX-MEDIUM-VG': 6.37,
    'E-I2-GOOD-POOR-MEDIUM-EX': 6.37,
    'E-I2-POOR-GOOD-MEDIUM-EX': 6.37,
    'E-SI2-POOR-EX-STRONG-VG': 6.37,
    'E-I2-EX-GOOD-MEDIUM-VG': 6.37,
    'E-I2-VG-VG-MEDIUM-VG': 6.37,
    'E-SI2-EX-POOR-STRONG-VG': 6.37,
    'F-I2-GOOD-POOR-FAINT-EX': 6.37,
    'F-I2-EX-GOOD-FAINT-VG': 6.37,
    'F-SI2-POOR-POOR-MEDIUM-EX': 6.37,
    'F-I2-GOOD-EX-FAINT-VG': 6.37,
    'F-SI2-VG-GOOD-MEDIUM-VG': 6.37,
    'F-SI2-POOR-EX-MEDIUM-VG': 6.37,
    'F-SI2-GOOD-VG-MEDIUM-VG': 6.37,
    'F-I2-VG-VG-FAINT-VG': 6.37,
    'F-SI2-EX-EX-MEDIUM-GOOD': 6.37,
    'F-SI2-EX-POOR-MEDIUM-VG': 6.37,
    'F-I2-POOR-GOOD-FAINT-EX': 6.37,
    'G-I2-VG-VG-NONE-VG': 6.37,
    'G-I2-EX-GOOD-NONE-VG': 6.37,
    'G-SI2-EX-EX-FAINT-GOOD': 6.37,
    'G-SI2-GOOD-VG-FAINT-VG': 6.37,
    'G-I2-GOOD-POOR-NONE-EX': 6.37,
    'G-SI2-POOR-EX-FAINT-VG': 6.37,
    'G-I2-GOOD-EX-NONE-VG': 6.37,
    'G-SI2-VG-GOOD-FAINT-VG': 6.37,
    'G-SI2-EX-POOR-FAINT-VG': 6.37,
    'G-SI2-POOR-POOR-FAINT-EX': 6.37,
    'G-I2-POOR-GOOD-NONE-EX': 6.37,
    'H-SI2-GOOD-VG-NONE-VG': 6.37,
    'H-SI2-VG-GOOD-NONE-VG': 6.37,
    'H-SI2-EX-POOR-NONE-VG': 6.37,
    'H-SI2-EX-EX-NONE-GOOD': 6.37,
    'H-SI2-POOR-POOR-NONE-EX': 6.37,
    'H-SI2-POOR-EX-NONE-VG': 6.37,
    'I-I2-VG-EX-STRONG-EX': 6.37,
    'I-I2-EX-VG-STRONG-EX': 6.37,
    'J-I2-VG-EX-MEDIUM-EX': 6.37,
    'J-SI2-GOOD-EX-STRONG-EX': 6.37,
    'J-I2-EX-VG-MEDIUM-EX': 6.37,
    'J-SI2-EX-GOOD-STRONG-EX': 6.37,
    'J-SI2-VG-VG-STRONG-EX': 6.37,
    'K-SI2-GOOD-EX-MEDIUM-EX': 6.37,
    'K-I2-EX-VG-FAINT-EX': 6.37,
    'K-I2-VG-EX-FAINT-EX': 6.37,
    'K-SI2-VG-VG-MEDIUM-EX': 6.37,
    'K-SI2-EX-GOOD-MEDIUM-EX': 6.37,
    'L-I2-EX-VG-NONE-EX': 6.37,
    'L-SI2-VG-VG-FAINT-EX': 6.37,
    'L-SI2-GOOD-EX-FAINT-EX': 6.37,
    'L-SI2-EX-GOOD-FAINT-EX': 6.37,
    'L-I2-VG-EX-NONE-EX': 6.37,
    'M-SI2-VG-VG-NONE-EX': 6.37,
    'M-SI2-EX-GOOD-NONE-EX': 6.37,
    'M-SI2-GOOD-EX-NONE-EX': 6.37,
    'D-VS2-GOOD-POOR-NONE-GOOD': 6.36,
    'D-VS2-POOR-GOOD-NONE-GOOD': 6.36,
    'D-VS2-VG-VG-NONE-POOR': 6.36,
    'D-VS2-GOOD-EX-NONE-POOR': 6.36,
    'D-VS2-EX-GOOD-NONE-POOR': 6.36,
    'D-VVS2-EX-POOR-FAINT-POOR': 6.36,
    'D-VVS2-VG-GOOD-FAINT-POOR': 6.36,
    'D-VVS2-GOOD-VG-FAINT-POOR': 6.36,
    'D-VVS2-POOR-POOR-FAINT-GOOD': 6.36,
    'D-VVS2-POOR-EX-FAINT-POOR': 6.36,
    'E-VVS2-EX-POOR-NONE-POOR': 6.36,
    'E-VVS2-GOOD-VG-NONE-POOR': 6.36,
    'E-VVS2-POOR-EX-NONE-POOR': 6.36,
    'E-VVS2-VG-GOOD-NONE-POOR': 6.36,
    'E-VVS2-POOR-POOR-NONE-GOOD': 6.36,
    'F-VS2-GOOD-GOOD-STRONG-VG': 6.36,
    'F-VS2-VG-EX-STRONG-GOOD': 6.36,
    'F-VS2-VG-POOR-STRONG-VG': 6.36,
    'F-VS2-POOR-VG-STRONG-VG': 6.36,
    'F-VS2-EX-VG-STRONG-GOOD': 6.36,
    'G-VS2-VG-EX-MEDIUM-GOOD': 6.36,
    'G-VVS2-EX-GOOD-STRONG-GOOD': 6.36,
    'G-VVS2-VG-VG-STRONG-GOOD': 6.36,
    'G-VVS2-GOOD-EX-STRONG-GOOD': 6.36,
    'G-VS2-EX-VG-MEDIUM-GOOD': 6.36,
    'G-VVS2-POOR-GOOD-STRONG-VG': 6.36,
    'G-VVS2-GOOD-POOR-STRONG-VG': 6.36,
    'G-VS2-VG-POOR-MEDIUM-VG': 6.36,
    'G-VS2-GOOD-GOOD-MEDIUM-VG': 6.36,
    'G-VS2-POOR-VG-MEDIUM-VG': 6.36,
    'H-VVS2-EX-GOOD-MEDIUM-GOOD': 6.36,
    'H-VVS2-VG-VG-MEDIUM-GOOD': 6.36,
    'H-VS2-EX-VG-FAINT-GOOD': 6.36,
    'H-VVS2-GOOD-POOR-MEDIUM-VG': 6.36,
    'H-VS2-VG-POOR-FAINT-VG': 6.36,
    'H-VVS2-GOOD-EX-MEDIUM-GOOD': 6.36,
    'H-VVS2-POOR-GOOD-MEDIUM-VG': 6.36,
    'H-VS2-VG-EX-FAINT-GOOD': 6.36,
    'H-VS2-POOR-VG-FAINT-VG': 6.36,
    'H-VS2-GOOD-GOOD-FAINT-VG': 6.36,
    'I-VVS2-POOR-GOOD-FAINT-VG': 6.36,
    'I-VVS2-GOOD-POOR-FAINT-VG': 6.36,
    'I-VVS2-GOOD-EX-FAINT-GOOD': 6.36,
    'I-VVS2-EX-GOOD-FAINT-GOOD': 6.36,
    'I-VVS2-VG-VG-FAINT-GOOD': 6.36,
    'I-VS2-EX-VG-NONE-GOOD': 6.36,
    'I-VS2-VG-EX-NONE-GOOD': 6.36,
    'I-VS2-VG-POOR-NONE-VG': 6.36,
    'I-VS2-GOOD-GOOD-NONE-VG': 6.36,
    'I-VS2-POOR-VG-NONE-VG': 6.36,
    'J-VVS2-GOOD-POOR-NONE-VG': 6.36,
    'J-VVS2-GOOD-EX-NONE-GOOD': 6.36,
    'J-VVS2-VG-VG-NONE-GOOD': 6.36,
    'J-VVS2-EX-GOOD-NONE-GOOD': 6.36,
    'J-VVS2-POOR-GOOD-NONE-VG': 6.36,
    'K-VS2-GOOD-VG-STRONG-EX': 6.36,
    'K-VS2-POOR-EX-STRONG-EX': 6.36,
    'K-VS2-VG-GOOD-STRONG-EX': 6.36,
    'K-VS2-EX-EX-STRONG-VG': 6.36,
    'K-VS2-EX-POOR-STRONG-EX': 6.36,
    'L-VS2-VG-GOOD-MEDIUM-EX': 6.36,
    'L-VVS2-VG-POOR-STRONG-EX': 6.36,
    'L-VS2-GOOD-VG-MEDIUM-EX': 6.36,
    'L-VVS2-GOOD-GOOD-STRONG-EX': 6.36,
    'L-VS2-POOR-EX-MEDIUM-EX': 6.36,
    'L-VVS2-POOR-VG-STRONG-EX': 6.36,
    'L-VS2-EX-POOR-MEDIUM-EX': 6.36,
    'L-VVS2-VG-EX-STRONG-VG': 6.36,
    'L-VS2-EX-EX-MEDIUM-VG': 6.36,
    'L-VVS2-EX-VG-STRONG-VG': 6.36,
    'M-VS2-POOR-EX-FAINT-EX': 6.36,
    'M-VVS2-POOR-VG-MEDIUM-EX': 6.36,
    'M-VVS2-GOOD-GOOD-MEDIUM-EX': 6.36,
    'M-VS2-GOOD-VG-FAINT-EX': 6.36,
    'M-VVS2-VG-POOR-MEDIUM-EX': 6.36,
    'M-VS2-VG-GOOD-FAINT-EX': 6.36,
    'M-VVS2-VG-EX-MEDIUM-VG': 6.36,
    'M-VS2-EX-EX-FAINT-VG': 6.36,
    'M-VVS2-EX-VG-MEDIUM-VG': 6.36,
    'M-VS2-EX-POOR-FAINT-EX': 6.36,
    'D-IF-VG-POOR-MEDIUM-POOR': 6.35,
    'D-IF-POOR-VG-MEDIUM-POOR': 6.35,
    'D-IF-GOOD-GOOD-MEDIUM-POOR': 6.35,
    'E-IF-GOOD-GOOD-FAINT-POOR': 6.35,
    'E-IF-POOR-VG-FAINT-POOR': 6.35,
    'E-IF-VG-POOR-FAINT-POOR': 6.35,
    'F-IF-GOOD-GOOD-NONE-POOR': 6.35,
    'F-IF-POOR-VG-NONE-POOR': 6.35,
    'F-IF-VG-POOR-NONE-POOR': 6.35,
    'H-IF-EX-EX-STRONG-POOR': 6.35,
    'H-IF-GOOD-VG-STRONG-GOOD': 6.35,
    'H-IF-POOR-POOR-STRONG-VG': 6.35,
    'H-IF-EX-POOR-STRONG-GOOD': 6.35,
    'H-IF-POOR-EX-STRONG-GOOD': 6.35,
    'H-IF-VG-GOOD-STRONG-GOOD': 6.35,
    'I-IF-VG-GOOD-MEDIUM-GOOD': 6.35,
    'I-IF-EX-POOR-MEDIUM-GOOD': 6.35,
    'I-IF-EX-EX-MEDIUM-POOR': 6.35,
    'I-IF-GOOD-VG-MEDIUM-GOOD': 6.35,
    'I-IF-POOR-EX-MEDIUM-GOOD': 6.35,
    'I-IF-POOR-POOR-MEDIUM-VG': 6.35,
    'J-IF-EX-EX-FAINT-POOR': 6.35,
    'J-IF-GOOD-VG-FAINT-GOOD': 6.35,
    'J-IF-POOR-POOR-FAINT-VG': 6.35,
    'J-IF-VG-GOOD-FAINT-GOOD': 6.35,
    'J-IF-EX-POOR-FAINT-GOOD': 6.35,
    'J-IF-POOR-EX-FAINT-GOOD': 6.35,
    'K-IF-EX-EX-NONE-POOR': 6.35,
    'K-IF-POOR-EX-NONE-GOOD': 6.35,
    'K-IF-EX-POOR-NONE-GOOD': 6.35,
    'K-IF-POOR-POOR-NONE-VG': 6.35,
    'K-IF-VG-GOOD-NONE-GOOD': 6.35,
    'K-IF-GOOD-VG-NONE-GOOD': 6.35,
    'M-IF-GOOD-EX-STRONG-VG': 6.35,
    'M-IF-POOR-GOOD-STRONG-EX': 6.35,
    'M-IF-GOOD-POOR-STRONG-EX': 6.35,
    'M-IF-VG-VG-STRONG-VG': 6.35,
    'M-IF-EX-GOOD-STRONG-VG': 6.35,
    'D-I1-POOR-POOR-STRONG-EX': 6.34,
    'D-I1-GOOD-VG-STRONG-VG': 6.34,
    'D-I1-POOR-EX-STRONG-VG': 6.34,
    'D-I1-EX-EX-STRONG-GOOD': 6.34,
    'D-I1-EX-POOR-STRONG-VG': 6.34,
    'D-I1-VG-GOOD-STRONG-VG': 6.34,
    'E-I1-POOR-EX-MEDIUM-VG': 6.34,
    'E-SI1-VG-EX-STRONG-GOOD': 6.34,
    'E-I1-POOR-POOR-MEDIUM-EX': 6.34,
    'E-SI1-EX-VG-STRONG-GOOD': 6.34,
    'E-SI1-VG-POOR-STRONG-VG': 6.34,
    'E-SI1-GOOD-GOOD-STRONG-VG': 6.34,
    'E-SI1-POOR-VG-STRONG-VG': 6.34,
    'E-I1-VG-GOOD-MEDIUM-VG': 6.34,
    'E-I1-GOOD-VG-MEDIUM-VG': 6.34,
    'E-I1-EX-POOR-MEDIUM-VG': 6.34,
    'E-I1-EX-EX-MEDIUM-GOOD': 6.34,
    'F-I1-GOOD-VG-FAINT-VG': 6.34,
    'F-SI1-POOR-VG-MEDIUM-VG': 6.34,
    'F-I1-POOR-POOR-FAINT-EX': 6.34,
    'F-SI1-EX-VG-MEDIUM-GOOD': 6.34,
    'F-SI1-VG-EX-MEDIUM-GOOD': 6.34,
    'F-I1-EX-POOR-FAINT-VG': 6.34,
    'F-SI1-GOOD-GOOD-MEDIUM-VG': 6.34,
    'F-SI1-VG-POOR-MEDIUM-VG': 6.34,
    'F-I1-EX-EX-FAINT-GOOD': 6.34,
    'F-I1-POOR-EX-FAINT-VG': 6.34,
    'F-I1-VG-GOOD-FAINT-VG': 6.34,
    'G-I1-EX-EX-NONE-GOOD': 6.34,
    'G-I1-VG-GOOD-NONE-VG': 6.34,
    'G-I1-POOR-POOR-NONE-EX': 6.34,
    'G-I1-GOOD-VG-NONE-VG': 6.34,
    'G-I1-EX-POOR-NONE-VG': 6.34,
    'G-I1-POOR-EX-NONE-VG': 6.34,
    'G-SI1-GOOD-GOOD-FAINT-VG': 6.34,
    'G-SI1-POOR-VG-FAINT-VG': 6.34,
    'G-SI1-EX-VG-FAINT-GOOD': 6.34,
    'G-SI1-VG-POOR-FAINT-VG': 6.34,
    'G-SI1-VG-EX-FAINT-GOOD': 6.34,
    'H-SI1-EX-VG-NONE-GOOD': 6.34,
    'H-SI1-GOOD-GOOD-NONE-VG': 6.34,
    'H-SI1-VG-POOR-NONE-VG': 6.34,
    'H-SI1-VG-EX-NONE-GOOD': 6.34,
    'H-SI1-POOR-VG-NONE-VG': 6.34,
    'I-I1-VG-VG-STRONG-EX': 6.34,
    'I-I1-GOOD-EX-STRONG-EX': 6.34,
    'I-I1-EX-GOOD-STRONG-EX': 6.34,
    'J-I1-VG-VG-MEDIUM-EX': 6.34,
    'J-I1-EX-GOOD-MEDIUM-EX': 6.34,
    'J-SI1-EX-POOR-STRONG-EX': 6.34,
    'J-SI1-EX-EX-STRONG-VG': 6.34,
    'J-SI1-VG-GOOD-STRONG-EX': 6.34,
    'J-I1-GOOD-EX-MEDIUM-EX': 6.34,
    'J-SI1-GOOD-VG-STRONG-EX': 6.34,
    'J-SI1-POOR-EX-STRONG-EX': 6.34,
    'K-SI1-POOR-EX-MEDIUM-EX': 6.34,
    'K-I1-GOOD-EX-FAINT-EX': 6.34,
    'K-I1-EX-GOOD-FAINT-EX': 6.34,
    'K-SI1-GOOD-VG-MEDIUM-EX': 6.34,
    'K-SI1-EX-EX-MEDIUM-VG': 6.34,
    'K-I1-VG-VG-FAINT-EX': 6.34,
    'K-SI1-VG-GOOD-MEDIUM-EX': 6.34,
    'K-SI1-EX-POOR-MEDIUM-EX': 6.34,
    'L-I1-EX-GOOD-NONE-EX': 6.34,
    'L-SI1-VG-GOOD-FAINT-EX': 6.34,
    'L-SI1-EX-POOR-FAINT-EX': 6.34,
    'L-I1-VG-VG-NONE-EX': 6.34,
    'L-SI1-POOR-EX-FAINT-EX': 6.34,
    'L-SI1-GOOD-VG-FAINT-EX': 6.34,
    'L-SI1-EX-EX-FAINT-VG': 6.34,
    'L-I1-GOOD-EX-NONE-EX': 6.34,
    'M-SI1-GOOD-VG-NONE-EX': 6.34,
    'M-SI1-POOR-EX-NONE-EX': 6.34,
    'M-SI1-VG-GOOD-NONE-EX': 6.34,
    'M-SI1-EX-POOR-NONE-EX': 6.34,
    'M-SI1-EX-EX-NONE-VG': 6.34,
    'D-VS1-VG-GOOD-NONE-POOR': 6.33,
    'D-VS1-EX-POOR-NONE-POOR': 6.33,
    'D-VVS1-VG-POOR-FAINT-POOR': 6.33,
    'D-VS1-POOR-POOR-NONE-GOOD': 6.33,
    'D-VS1-GOOD-VG-NONE-POOR': 6.33,
    'D-VVS1-GOOD-GOOD-FAINT-POOR': 6.33,
    'D-VVS1-POOR-VG-FAINT-POOR': 6.33,
    'D-VS1-POOR-EX-NONE-POOR': 6.33,
    'E-VVS1-VG-POOR-NONE-POOR': 6.33,
    'E-VVS1-POOR-VG-NONE-POOR': 6.33,
    'E-VVS1-GOOD-GOOD-NONE-POOR': 6.33,
    'F-VS1-GOOD-EX-STRONG-GOOD': 6.33,
    'F-VS1-VG-VG-STRONG-GOOD': 6.33,
    'F-VS1-EX-GOOD-STRONG-GOOD': 6.33,
    'F-VS1-GOOD-POOR-STRONG-VG': 6.33,
    'F-VS1-POOR-GOOD-STRONG-VG': 6.33,
    'G-VVS1-GOOD-VG-STRONG-GOOD': 6.33,
    'G-VS1-GOOD-EX-MEDIUM-GOOD': 6.33,
    'G-VS1-GOOD-POOR-MEDIUM-VG': 6.33,
    'G-VVS1-POOR-POOR-STRONG-VG': 6.33,
    'G-VS1-POOR-GOOD-MEDIUM-VG': 6.33,
    'G-VVS1-EX-POOR-STRONG-GOOD': 6.33,
    'G-VVS1-POOR-EX-STRONG-GOOD': 6.33,
    'G-VS1-EX-GOOD-MEDIUM-GOOD': 6.33,
    'G-VS1-VG-VG-MEDIUM-GOOD': 6.33,
    'G-VVS1-EX-EX-STRONG-POOR': 6.33,
    'G-VVS1-VG-GOOD-STRONG-GOOD': 6.33,
    'H-VS1-GOOD-EX-FAINT-GOOD': 6.33,
    'H-VS1-EX-GOOD-FAINT-GOOD': 6.33,
    'H-VS1-VG-VG-FAINT-GOOD': 6.33,
    'H-VVS1-VG-GOOD-MEDIUM-GOOD': 6.33,
    'H-VVS1-POOR-EX-MEDIUM-GOOD': 6.33,
    'H-VVS1-GOOD-VG-MEDIUM-GOOD': 6.33,
    'H-VVS1-EX-EX-MEDIUM-POOR': 6.33,
    'H-VS1-POOR-GOOD-FAINT-VG': 6.33,
    'H-VS1-GOOD-POOR-FAINT-VG': 6.33,
    'H-VVS1-POOR-POOR-MEDIUM-VG': 6.33,
    'H-VVS1-EX-POOR-MEDIUM-GOOD': 6.33,
    'I-VVS1-POOR-EX-FAINT-GOOD': 6.33,
    'I-VVS1-POOR-POOR-FAINT-VG': 6.33,
    'I-VVS1-GOOD-VG-FAINT-GOOD': 6.33,
    'I-VS1-EX-GOOD-NONE-GOOD': 6.33,
    'I-VS1-VG-VG-NONE-GOOD': 6.33,
    'I-VS1-GOOD-EX-NONE-GOOD': 6.33,
    'I-VS1-GOOD-POOR-NONE-VG': 6.33,
    'I-VS1-POOR-GOOD-NONE-VG': 6.33,
    'I-VVS1-VG-GOOD-FAINT-GOOD': 6.33,
    'I-VVS1-EX-POOR-FAINT-GOOD': 6.33,
    'I-VVS1-EX-EX-FAINT-POOR': 6.33,
    'J-VVS1-POOR-POOR-NONE-VG': 6.33,
    'J-VVS1-POOR-EX-NONE-GOOD': 6.33,
    'J-VVS1-VG-GOOD-NONE-GOOD': 6.33,
    'J-VVS1-EX-POOR-NONE-GOOD': 6.33,
    'J-VVS1-GOOD-VG-NONE-GOOD': 6.33,
    'J-VVS1-EX-EX-NONE-POOR': 6.33,
    'K-VS1-VG-POOR-STRONG-EX': 6.33,
    'K-VS1-POOR-VG-STRONG-EX': 6.33,
    'K-VS1-GOOD-GOOD-STRONG-EX': 6.33,
    'K-VS1-EX-VG-STRONG-VG': 6.33,
    'K-VS1-VG-EX-STRONG-VG': 6.33,
    'L-VS1-VG-EX-MEDIUM-VG': 6.33,
    'L-VS1-VG-POOR-MEDIUM-EX': 6.33,
    'L-VS1-EX-VG-MEDIUM-VG': 6.33,
    'L-VVS1-EX-GOOD-STRONG-VG': 6.33,
    'L-VVS1-VG-VG-STRONG-VG': 6.33,
    'L-VS1-GOOD-GOOD-MEDIUM-EX': 6.33,
    'L-VS1-POOR-VG-MEDIUM-EX': 6.33,
    'L-VVS1-GOOD-POOR-STRONG-EX': 6.33,
    'L-VVS1-POOR-GOOD-STRONG-EX': 6.33,
    'L-VVS1-GOOD-EX-STRONG-VG': 6.33,
    'M-VS1-VG-POOR-FAINT-EX': 6.33,
    'M-VS1-GOOD-GOOD-FAINT-EX': 6.33,
    'M-VS1-EX-VG-FAINT-VG': 6.33,
    'M-VVS1-EX-GOOD-MEDIUM-VG': 6.33,
    'M-VVS1-POOR-GOOD-MEDIUM-EX': 6.33,
    'M-VS1-POOR-VG-FAINT-EX': 6.33,
    'M-VVS1-VG-VG-MEDIUM-VG': 6.33,
    'M-VVS1-GOOD-POOR-MEDIUM-EX': 6.33,
    'M-VS1-VG-EX-FAINT-VG': 6.33,
    'M-VVS1-GOOD-EX-MEDIUM-VG': 6.33,
    'D-I2-EX-POOR-MEDIUM-VG': 6.32,
    'D-I2-EX-EX-MEDIUM-GOOD': 6.32,
    'D-I2-POOR-POOR-MEDIUM-EX': 6.32,
    'D-I2-VG-GOOD-MEDIUM-VG': 6.32,
    'D-I2-GOOD-VG-MEDIUM-VG': 6.32,
    'D-SI2-GOOD-GOOD-STRONG-VG': 6.32,
    'D-SI2-VG-POOR-STRONG-VG': 6.32,
    'D-SI2-VG-EX-STRONG-GOOD': 6.32,
    'D-SI2-EX-VG-STRONG-GOOD': 6.32,
    'D-SI2-POOR-VG-STRONG-VG': 6.32,
    'D-I2-POOR-EX-MEDIUM-VG': 6.32,
    'E-I2-VG-GOOD-FAINT-VG': 6.32,
    'E-I2-EX-POOR-FAINT-VG': 6.32,
    'E-SI2-VG-POOR-MEDIUM-VG': 6.32,
    'E-I2-GOOD-VG-FAINT-VG': 6.32,
    'E-SI2-VG-EX-MEDIUM-GOOD': 6.32,
    'E-SI2-GOOD-GOOD-MEDIUM-VG': 6.32,
    'E-SI2-POOR-VG-MEDIUM-VG': 6.32,
    'E-SI2-EX-VG-MEDIUM-GOOD': 6.32,
    'E-I2-EX-EX-FAINT-GOOD': 6.32,
    'E-I2-POOR-EX-FAINT-VG': 6.32,
    'E-I2-POOR-POOR-FAINT-EX': 6.32,
    'F-SI2-VG-EX-FAINT-GOOD': 6.32,
    'F-SI2-VG-POOR-FAINT-VG': 6.32,
    'F-I2-POOR-POOR-NONE-EX': 6.32,
    'F-I2-EX-POOR-NONE-VG': 6.32,
    'F-I2-POOR-EX-NONE-VG': 6.32,
    'F-SI2-POOR-VG-FAINT-VG': 6.32,
    'F-SI2-GOOD-GOOD-FAINT-VG': 6.32,
    'F-I2-EX-EX-NONE-GOOD': 6.32,
    'F-I2-VG-GOOD-NONE-VG': 6.32,
    'F-I2-GOOD-VG-NONE-VG': 6.32,
    'F-SI2-EX-VG-FAINT-GOOD': 6.32,
    'G-SI2-GOOD-GOOD-NONE-VG': 6.32,
    'G-SI2-VG-EX-NONE-GOOD': 6.32,
    'G-SI2-POOR-VG-NONE-VG': 6.32,
    'G-SI2-EX-VG-NONE-GOOD': 6.32,
    'G-SI2-VG-POOR-NONE-VG': 6.32,
    'H-I2-EX-GOOD-STRONG-EX': 6.32,
    'H-I2-VG-VG-STRONG-EX': 6.32,
    'H-I2-GOOD-EX-STRONG-EX': 6.32,
    'I-SI2-GOOD-VG-STRONG-EX': 6.32,
    'I-SI2-VG-GOOD-STRONG-EX': 6.32,
    'I-SI2-EX-POOR-STRONG-EX': 6.32,
    'I-SI2-EX-EX-STRONG-VG': 6.32,
    'I-SI2-POOR-EX-STRONG-EX': 6.32,
    'I-I2-GOOD-EX-MEDIUM-EX': 6.32,
    'I-I2-VG-VG-MEDIUM-EX': 6.32,
    'I-I2-EX-GOOD-MEDIUM-EX': 6.32,
    'J-SI2-GOOD-VG-MEDIUM-EX': 6.32,
    'J-SI2-VG-GOOD-MEDIUM-EX': 6.32,
    'J-SI2-EX-POOR-MEDIUM-EX': 6.32,
    'J-SI2-EX-EX-MEDIUM-VG': 6.32,
    'J-SI2-POOR-EX-MEDIUM-EX': 6.32,
    'J-I2-EX-GOOD-FAINT-EX': 6.32,
    'J-I2-VG-VG-FAINT-EX': 6.32,
    'J-I2-GOOD-EX-FAINT-EX': 6.32,
    'K-SI2-EX-EX-FAINT-VG': 6.32,
    'K-SI2-GOOD-VG-FAINT-EX': 6.32,
    'K-I2-EX-GOOD-NONE-EX': 6.32,
    'K-SI2-EX-POOR-FAINT-EX': 6.32,
    'K-I2-GOOD-EX-NONE-EX': 6.32,
    'K-I2-VG-VG-NONE-EX': 6.32,
    'K-SI2-POOR-EX-FAINT-EX': 6.32,
    'K-SI2-VG-GOOD-FAINT-EX': 6.32,
    'L-SI2-POOR-EX-NONE-EX': 6.32,
    'L-SI2-GOOD-VG-NONE-EX': 6.32,
    'L-SI2-VG-GOOD-NONE-EX': 6.32,
    'L-SI2-EX-EX-NONE-VG': 6.32,
    'L-SI2-EX-POOR-NONE-EX': 6.32,
    'D-VVS2-POOR-VG-NONE-POOR': 6.31,
    'D-VVS2-GOOD-GOOD-NONE-POOR': 6.31,
    'D-VVS2-VG-POOR-NONE-POOR': 6.31,
    'E-VS2-GOOD-POOR-STRONG-VG': 6.31,
    'E-VS2-GOOD-EX-STRONG-GOOD': 6.31,
    'E-VS2-POOR-GOOD-STRONG-VG': 6.31,
    'E-VS2-VG-VG-STRONG-GOOD': 6.31,
    'E-VS2-EX-GOOD-STRONG-GOOD': 6.31,
    'F-VS2-POOR-GOOD-MEDIUM-VG': 6.31,
    'F-VVS2-EX-EX-STRONG-POOR': 6.31,
    'F-VS2-EX-GOOD-MEDIUM-GOOD': 6.31,
    'F-VS2-VG-VG-MEDIUM-GOOD': 6.31,
    'F-VS2-GOOD-POOR-MEDIUM-VG': 6.31,
    'F-VVS2-EX-POOR-STRONG-GOOD': 6.31,
    'F-VVS2-VG-GOOD-STRONG-GOOD': 6.31,
    'F-VVS2-POOR-POOR-STRONG-VG': 6.31,
    'F-VS2-GOOD-EX-MEDIUM-GOOD': 6.31,
    'F-VVS2-POOR-EX-STRONG-GOOD': 6.31,
    'F-VVS2-GOOD-VG-STRONG-GOOD': 6.31,
    'G-VS2-GOOD-POOR-FAINT-VG': 6.31,
    'G-VS2-EX-GOOD-FAINT-GOOD': 6.31,
    'G-VVS2-EX-POOR-MEDIUM-GOOD': 6.31,
    'G-VS2-POOR-GOOD-FAINT-VG': 6.31,
    'G-VS2-VG-VG-FAINT-GOOD': 6.31,
    'G-VVS2-EX-EX-MEDIUM-POOR': 6.31,
    'G-VS2-GOOD-EX-FAINT-GOOD': 6.31,
    'G-VVS2-POOR-EX-MEDIUM-GOOD': 6.31,
    'G-VVS2-VG-GOOD-MEDIUM-GOOD': 6.31,
    'G-VVS2-GOOD-VG-MEDIUM-GOOD': 6.31,
    'G-VVS2-POOR-POOR-MEDIUM-VG': 6.31,
    'H-VS2-GOOD-EX-NONE-GOOD': 6.31,
    'H-VVS2-POOR-POOR-FAINT-VG': 6.31,
    'H-VS2-VG-VG-NONE-GOOD': 6.31,
    'H-VS2-EX-GOOD-NONE-GOOD': 6.31,
    'H-VS2-POOR-GOOD-NONE-VG': 6.31,
    'H-VS2-GOOD-POOR-NONE-VG': 6.31,
    'H-VVS2-VG-GOOD-FAINT-GOOD': 6.31,
    'H-VVS2-EX-POOR-FAINT-GOOD': 6.31,
    'H-VVS2-EX-EX-FAINT-POOR': 6.31,
    'H-VVS2-POOR-EX-FAINT-GOOD': 6.31,
    'H-VVS2-GOOD-VG-FAINT-GOOD': 6.31,
    'I-VVS2-POOR-POOR-NONE-VG': 6.31,
    'I-VVS2-POOR-EX-NONE-GOOD': 6.31,
    'I-VVS2-GOOD-VG-NONE-GOOD': 6.31,
    'I-VVS2-VG-GOOD-NONE-GOOD': 6.31,
    'I-VVS2-EX-POOR-NONE-GOOD': 6.31,
    'I-VVS2-EX-EX-NONE-POOR': 6.31,
    'J-VS2-VG-POOR-STRONG-EX': 6.31,
    'J-VS2-VG-EX-STRONG-VG': 6.31,
    'J-VS2-EX-VG-STRONG-VG': 6.31,
    'J-VS2-GOOD-GOOD-STRONG-EX': 6.31,
    'J-VS2-POOR-VG-STRONG-EX': 6.31,
    'K-VVS2-VG-VG-STRONG-VG': 6.31,
    'K-VVS2-GOOD-POOR-STRONG-EX': 6.31,
    'K-VVS2-GOOD-EX-STRONG-VG': 6.31,
    'K-VS2-EX-VG-MEDIUM-VG': 6.31,
    'K-VVS2-POOR-GOOD-STRONG-EX': 6.31,
    'K-VS2-VG-EX-MEDIUM-VG': 6.31,
    'K-VS2-GOOD-GOOD-MEDIUM-EX': 6.31,
    'K-VS2-VG-POOR-MEDIUM-EX': 6.31,
    'K-VS2-POOR-VG-MEDIUM-EX': 6.31,
    'K-VVS2-EX-GOOD-STRONG-VG': 6.31,
    'L-VS2-EX-VG-FAINT-VG': 6.31,
    'L-VVS2-GOOD-EX-MEDIUM-VG': 6.31,
    'L-VS2-VG-EX-FAINT-VG': 6.31,
    'L-VS2-VG-POOR-FAINT-EX': 6.31,
    'L-VVS2-EX-GOOD-MEDIUM-VG': 6.31,
    'L-VS2-GOOD-GOOD-FAINT-EX': 6.31,
    'L-VVS2-GOOD-POOR-MEDIUM-EX': 6.31,
    'L-VS2-POOR-VG-FAINT-EX': 6.31,
    'L-VVS2-VG-VG-MEDIUM-VG': 6.31,
    'L-VVS2-POOR-GOOD-MEDIUM-EX': 6.31,
    'M-VVS2-EX-GOOD-FAINT-VG': 6.31,
    'M-VVS2-VG-VG-FAINT-VG': 6.31,
    'M-VS2-EX-VG-NONE-VG': 6.31,
    'M-VS2-VG-EX-NONE-VG': 6.31,
    'M-VS2-VG-POOR-NONE-EX': 6.31,
    'M-VVS2-GOOD-EX-FAINT-VG': 6.31,
    'M-VS2-GOOD-GOOD-NONE-EX': 6.31,
    'M-VVS2-POOR-GOOD-FAINT-EX': 6.31,
    'M-VS2-POOR-VG-NONE-EX': 6.31,
    'M-VVS2-GOOD-POOR-FAINT-EX': 6.31,
    'D-IF-GOOD-POOR-FAINT-POOR': 6.3,
    'D-IF-POOR-GOOD-FAINT-POOR': 6.3,
    'E-IF-GOOD-POOR-NONE-POOR': 6.3,
    'E-IF-POOR-GOOD-NONE-POOR': 6.3,
    'G-IF-VG-POOR-STRONG-GOOD': 6.3,
    'G-IF-EX-VG-STRONG-POOR': 6.3,
    'G-IF-POOR-VG-STRONG-GOOD': 6.3,
    'G-IF-VG-EX-STRONG-POOR': 6.3,
    'G-IF-GOOD-GOOD-STRONG-GOOD': 6.3,
    'H-IF-POOR-VG-MEDIUM-GOOD': 6.3,
    'H-IF-GOOD-GOOD-MEDIUM-GOOD': 6.3,
    'H-IF-EX-VG-MEDIUM-POOR': 6.3,
    'H-IF-VG-EX-MEDIUM-POOR': 6.3,
    'H-IF-VG-POOR-MEDIUM-GOOD': 6.3,
    'I-IF-POOR-VG-FAINT-GOOD': 6.3,
    'I-IF-GOOD-GOOD-FAINT-GOOD': 6.3,
    'I-IF-VG-POOR-FAINT-GOOD': 6.3,
    'I-IF-VG-EX-FAINT-POOR': 6.3,
    'I-IF-EX-VG-FAINT-POOR': 6.3,
    'J-IF-POOR-VG-NONE-GOOD': 6.3,
    'J-IF-GOOD-GOOD-NONE-GOOD': 6.3,
    'J-IF-EX-VG-NONE-POOR': 6.3,
    'J-IF-VG-EX-NONE-POOR': 6.3,
    'J-IF-VG-POOR-NONE-GOOD': 6.3,
    'L-IF-POOR-POOR-STRONG-EX': 6.3,
    'L-IF-EX-EX-STRONG-GOOD': 6.3,
    'L-IF-EX-POOR-STRONG-VG': 6.3,
    'L-IF-VG-GOOD-STRONG-VG': 6.3,
    'L-IF-GOOD-VG-STRONG-VG': 6.3,
    'L-IF-POOR-EX-STRONG-VG': 6.3,
    'M-IF-VG-GOOD-MEDIUM-VG': 6.3,
    'M-IF-GOOD-VG-MEDIUM-VG': 6.3,
    'M-IF-POOR-EX-MEDIUM-VG': 6.3,
    'M-IF-EX-POOR-MEDIUM-VG': 6.3,
    'M-IF-POOR-POOR-MEDIUM-EX': 6.3,
    'M-IF-EX-EX-MEDIUM-GOOD': 6.3,
    'D-SI1-VG-VG-STRONG-GOOD': 6.29,
    'D-SI1-GOOD-EX-STRONG-GOOD': 6.29,
    'D-SI1-EX-GOOD-STRONG-GOOD': 6.29,
    'D-I1-GOOD-GOOD-MEDIUM-VG': 6.29,
    'D-SI1-GOOD-POOR-STRONG-VG': 6.29,
    'D-I1-VG-POOR-MEDIUM-VG': 6.29,
    'D-I1-VG-EX-MEDIUM-GOOD': 6.29,
    'D-I1-EX-VG-MEDIUM-GOOD': 6.29,
    'D-SI1-POOR-GOOD-STRONG-VG': 6.29,
    'D-I1-POOR-VG-MEDIUM-VG': 6.29,
    'E-SI1-EX-GOOD-MEDIUM-GOOD': 6.29,
    'E-SI1-VG-VG-MEDIUM-GOOD': 6.29,
    'E-I1-EX-VG-FAINT-GOOD': 6.29,
    'E-I1-GOOD-GOOD-FAINT-VG': 6.29,
    'E-I1-VG-POOR-FAINT-VG': 6.29,
    'E-SI1-GOOD-EX-MEDIUM-GOOD': 6.29,
    'E-I1-POOR-VG-FAINT-VG': 6.29,
    'E-I1-VG-EX-FAINT-GOOD': 6.29,
    'E-SI1-GOOD-POOR-MEDIUM-VG': 6.29,
    'E-SI1-POOR-GOOD-MEDIUM-VG': 6.29,
    'F-SI1-GOOD-POOR-FAINT-VG': 6.29,
    'F-SI1-GOOD-EX-FAINT-GOOD': 6.29,
    'F-I1-POOR-VG-NONE-VG': 6.29,
    'F-SI1-VG-VG-FAINT-GOOD': 6.29,
    'F-SI1-POOR-GOOD-FAINT-VG': 6.29,
    'F-SI1-EX-GOOD-FAINT-GOOD': 6.29,
    'F-I1-GOOD-GOOD-NONE-VG': 6.29,
    'F-I1-EX-VG-NONE-GOOD': 6.29,
    'F-I1-VG-POOR-NONE-VG': 6.29,
    'F-I1-VG-EX-NONE-GOOD': 6.29,
    'G-SI1-VG-VG-NONE-GOOD': 6.29,
    'G-SI1-GOOD-EX-NONE-GOOD': 6.29,
    'G-SI1-EX-GOOD-NONE-GOOD': 6.29,
    'G-SI1-GOOD-POOR-NONE-VG': 6.29,
    'G-SI1-POOR-GOOD-NONE-VG': 6.29,
    'H-I1-EX-EX-STRONG-VG': 6.29,
    'H-I1-EX-POOR-STRONG-EX': 6.29,
    'H-I1-POOR-EX-STRONG-EX': 6.29,
    'H-I1-GOOD-VG-STRONG-EX': 6.29,
    'H-I1-VG-GOOD-STRONG-EX': 6.29,
    'I-I1-VG-GOOD-MEDIUM-EX': 6.29,
    'I-I1-EX-POOR-MEDIUM-EX': 6.29,
    'I-I1-EX-EX-MEDIUM-VG': 6.29,
    'I-SI1-VG-POOR-STRONG-EX': 6.29,
    'I-I1-GOOD-VG-MEDIUM-EX': 6.29,
    'I-SI1-GOOD-GOOD-STRONG-EX': 6.29,
    'I-SI1-VG-EX-STRONG-VG': 6.29,
    'I-I1-POOR-EX-MEDIUM-EX': 6.29,
    'I-SI1-POOR-VG-STRONG-EX': 6.29,
    'I-SI1-EX-VG-STRONG-VG': 6.29,
    'J-I1-GOOD-VG-FAINT-EX': 6.29,
    'J-I1-EX-EX-FAINT-VG': 6.29,
    'J-I1-POOR-EX-FAINT-EX': 6.29,
    'J-I1-EX-POOR-FAINT-EX': 6.29,
    'J-I1-VG-GOOD-FAINT-EX': 6.29,
    'J-SI1-POOR-VG-MEDIUM-EX': 6.29,
    'J-SI1-EX-VG-MEDIUM-VG': 6.29,
    'J-SI1-GOOD-GOOD-MEDIUM-EX': 6.29,
    'J-SI1-VG-EX-MEDIUM-VG': 6.29,
    'J-SI1-VG-POOR-MEDIUM-EX': 6.29,
    'K-SI1-EX-VG-FAINT-VG': 6.29,
    'K-SI1-VG-EX-FAINT-VG': 6.29,
    'K-I1-EX-EX-NONE-VG': 6.29,
    'K-SI1-VG-POOR-FAINT-EX': 6.29,
    'K-SI1-POOR-VG-FAINT-EX': 6.29,
    'K-SI1-GOOD-GOOD-FAINT-EX': 6.29,
    'K-I1-GOOD-VG-NONE-EX': 6.29,
    'K-I1-VG-GOOD-NONE-EX': 6.29,
    'K-I1-POOR-EX-NONE-EX': 6.29,
    'K-I1-EX-POOR-NONE-EX': 6.29,
    'L-SI1-GOOD-GOOD-NONE-EX': 6.29,
    'L-SI1-VG-POOR-NONE-EX': 6.29,
    'L-SI1-POOR-VG-NONE-EX': 6.29,
    'L-SI1-EX-VG-NONE-VG': 6.29,
    'L-SI1-VG-EX-NONE-VG': 6.29,
    'D-VVS1-GOOD-POOR-NONE-POOR': 6.28,
    'D-VVS1-POOR-GOOD-NONE-POOR': 6.28,
    'E-VS1-POOR-POOR-STRONG-VG': 6.28,
    'E-VS1-POOR-EX-STRONG-GOOD': 6.28,
    'E-VS1-GOOD-VG-STRONG-GOOD': 6.28,
    'E-VS1-VG-GOOD-STRONG-GOOD': 6.28,
    'E-VS1-EX-EX-STRONG-POOR': 6.28,
    'E-VS1-EX-POOR-STRONG-GOOD': 6.28,
    'F-VVS1-EX-VG-STRONG-POOR': 6.28,
    'F-VS1-POOR-POOR-MEDIUM-VG': 6.28,
    'F-VS1-POOR-EX-MEDIUM-GOOD': 6.28,
    'F-VS1-EX-EX-MEDIUM-POOR': 6.28,
    'F-VS1-EX-POOR-MEDIUM-GOOD': 6.28,
    'F-VS1-VG-GOOD-MEDIUM-GOOD': 6.28,
    'F-VS1-GOOD-VG-MEDIUM-GOOD': 6.28,
    'F-VVS1-VG-EX-STRONG-POOR': 6.28,
    'F-VVS1-VG-POOR-STRONG-GOOD': 6.28,
    'F-VVS1-GOOD-GOOD-STRONG-GOOD': 6.28,
    'F-VVS1-POOR-VG-STRONG-GOOD': 6.28,
    'G-VS1-GOOD-VG-FAINT-GOOD': 6.28,
    'G-VS1-VG-GOOD-FAINT-GOOD': 6.28,
    'G-VS1-EX-POOR-FAINT-GOOD': 6.28,
    'G-VS1-EX-EX-FAINT-POOR': 6.28,
    'G-VVS1-VG-POOR-MEDIUM-GOOD': 6.28,
    'G-VVS1-GOOD-GOOD-MEDIUM-GOOD': 6.28,
    'G-VS1-POOR-EX-FAINT-GOOD': 6.28,
    'G-VVS1-EX-VG-MEDIUM-POOR': 6.28,
    'G-VVS1-VG-EX-MEDIUM-POOR': 6.28,
    'G-VS1-POOR-POOR-FAINT-VG': 6.28,
    'G-VVS1-POOR-VG-MEDIUM-GOOD': 6.28,
    'H-VVS1-POOR-VG-FAINT-GOOD': 6.28,
    'H-VS1-EX-EX-NONE-POOR': 6.28,
    'H-VS1-POOR-POOR-NONE-VG': 6.28,
    'H-VS1-POOR-EX-NONE-GOOD': 6.28,
    'H-VS1-GOOD-VG-NONE-GOOD': 6.28,
    'H-VS1-VG-GOOD-NONE-GOOD': 6.28,
    'H-VS1-EX-POOR-NONE-GOOD': 6.28,
    'H-VVS1-GOOD-GOOD-FAINT-GOOD': 6.28,
    'H-VVS1-EX-VG-FAINT-POOR': 6.28,
    'H-VVS1-VG-EX-FAINT-POOR': 6.28,
    'H-VVS1-VG-POOR-FAINT-GOOD': 6.28,
    'I-VVS1-POOR-VG-NONE-GOOD': 6.28,
    'I-VVS1-GOOD-GOOD-NONE-GOOD': 6.28,
    'I-VVS1-VG-POOR-NONE-GOOD': 6.28,
    'I-VVS1-VG-EX-NONE-POOR': 6.28,
    'I-VVS1-EX-VG-NONE-POOR': 6.28,
    'J-VS1-EX-GOOD-STRONG-VG': 6.28,
    'J-VS1-VG-VG-STRONG-VG': 6.28,
    'J-VS1-GOOD-EX-STRONG-VG': 6.28,
    'J-VS1-GOOD-POOR-STRONG-EX': 6.28,
    'J-VS1-POOR-GOOD-STRONG-EX': 6.28,
    'K-VS1-POOR-GOOD-MEDIUM-EX': 6.28,
    'K-VS1-GOOD-POOR-MEDIUM-EX': 6.28,
    'K-VS1-EX-GOOD-MEDIUM-VG': 6.28,
    'K-VVS1-EX-POOR-STRONG-VG': 6.28,
    'K-VVS1-EX-EX-STRONG-GOOD': 6.28,
    'K-VS1-VG-VG-MEDIUM-VG': 6.28,
    'K-VS1-GOOD-EX-MEDIUM-VG': 6.28,
    'K-VVS1-VG-GOOD-STRONG-VG': 6.28,
    'K-VVS1-POOR-POOR-STRONG-EX': 6.28,
    'K-VVS1-POOR-EX-STRONG-VG': 6.28,
    'K-VVS1-GOOD-VG-STRONG-VG': 6.28,
    'L-VVS1-POOR-POOR-MEDIUM-EX': 6.28,
    'L-VVS1-POOR-EX-MEDIUM-VG': 6.28,
    'L-VVS1-GOOD-VG-MEDIUM-VG': 6.28,
    'L-VVS1-EX-EX-MEDIUM-GOOD': 6.28,
    'L-VS1-POOR-GOOD-FAINT-EX': 6.28,
    'L-VS1-GOOD-POOR-FAINT-EX': 6.28,
    'L-VS1-GOOD-EX-FAINT-VG': 6.28,
    'L-VS1-VG-VG-FAINT-VG': 6.28,
    'L-VS1-EX-GOOD-FAINT-VG': 6.28,
    'L-VVS1-EX-POOR-MEDIUM-VG': 6.28,
    'L-VVS1-VG-GOOD-MEDIUM-VG': 6.28,
    'M-VVS1-POOR-POOR-FAINT-EX': 6.28,
    'M-VVS1-EX-EX-FAINT-GOOD': 6.28,
    'M-VS1-GOOD-EX-NONE-VG': 6.28,
    'M-VS1-GOOD-POOR-NONE-EX': 6.28,
    'M-VS1-POOR-GOOD-NONE-EX': 6.28,
    'M-VVS1-POOR-EX-FAINT-VG': 6.28,
    'M-VVS1-GOOD-VG-FAINT-VG': 6.28,
    'M-VS1-VG-VG-NONE-VG': 6.28,
    'M-VVS1-EX-POOR-FAINT-VG': 6.28,
    'M-VVS1-VG-GOOD-FAINT-VG': 6.28,
    'M-VS1-EX-GOOD-NONE-VG': 6.28,
    'D-I2-EX-VG-FAINT-GOOD': 6.27,
    'D-I2-VG-EX-FAINT-GOOD': 6.27,
    'D-I2-VG-POOR-FAINT-VG': 6.27,
    'D-I2-GOOD-GOOD-FAINT-VG': 6.27,
    'D-I2-POOR-VG-FAINT-VG': 6.27,
    'D-SI2-POOR-GOOD-MEDIUM-VG': 6.27,
    'D-SI2-GOOD-POOR-MEDIUM-VG': 6.27,
    'D-SI2-GOOD-EX-MEDIUM-GOOD': 6.27,
    'D-SI2-VG-VG-MEDIUM-GOOD': 6.27,
    'D-SI2-EX-GOOD-MEDIUM-GOOD': 6.27,
    'E-I2-POOR-VG-NONE-VG': 6.27,
    'E-I2-GOOD-GOOD-NONE-VG': 6.27,
    'E-I2-VG-POOR-NONE-VG': 6.27,
    'E-I2-VG-EX-NONE-GOOD': 6.27,
    'E-I2-EX-VG-NONE-GOOD': 6.27,
    'E-SI2-POOR-GOOD-FAINT-VG': 6.27,
    'E-SI2-EX-GOOD-FAINT-GOOD': 6.27,
    'E-SI2-VG-VG-FAINT-GOOD': 6.27,
    'E-SI2-GOOD-EX-FAINT-GOOD': 6.27,
    'E-SI2-GOOD-POOR-FAINT-VG': 6.27,
    'F-SI2-POOR-GOOD-NONE-VG': 6.27,
    'F-SI2-GOOD-POOR-NONE-VG': 6.27,
    'F-SI2-GOOD-EX-NONE-GOOD': 6.27,
    'F-SI2-VG-VG-NONE-GOOD': 6.27,
    'F-SI2-EX-GOOD-NONE-GOOD': 6.27,
    'G-I2-POOR-EX-STRONG-EX': 6.27,
    'G-I2-GOOD-VG-STRONG-EX': 6.27,
    'G-I2-VG-GOOD-STRONG-EX': 6.27,
    'G-I2-EX-POOR-STRONG-EX': 6.27,
    'G-I2-EX-EX-STRONG-VG': 6.27,
    'H-I2-EX-EX-MEDIUM-VG': 6.27,
    'H-I2-EX-POOR-MEDIUM-EX': 6.27,
    'H-I2-VG-GOOD-MEDIUM-EX': 6.27,
    'H-I2-GOOD-VG-MEDIUM-EX': 6.27,
    'H-I2-POOR-EX-MEDIUM-EX': 6.27,
    'H-SI2-VG-EX-STRONG-VG': 6.27,
    'H-SI2-POOR-VG-STRONG-EX': 6.27,
    'H-SI2-VG-POOR-STRONG-EX': 6.27,
    'H-SI2-EX-VG-STRONG-VG': 6.27,
    'H-SI2-GOOD-GOOD-STRONG-EX': 6.27,
    'I-I2-EX-EX-FAINT-VG': 6.27,
    'I-I2-EX-POOR-FAINT-EX': 6.27,
    'I-I2-VG-GOOD-FAINT-EX': 6.27,
    'I-I2-GOOD-VG-FAINT-EX': 6.27,
    'I-I2-POOR-EX-FAINT-EX': 6.27,
    'I-SI2-EX-VG-MEDIUM-VG': 6.27,
    'I-SI2-VG-EX-MEDIUM-VG': 6.27,
    'I-SI2-VG-POOR-MEDIUM-EX': 6.27,
    'I-SI2-GOOD-GOOD-MEDIUM-EX': 6.27,
    'I-SI2-POOR-VG-MEDIUM-EX': 6.27,
    'J-SI2-EX-VG-FAINT-VG': 6.27,
    'J-I2-POOR-EX-NONE-EX': 6.27,
    'J-I2-GOOD-VG-NONE-EX': 6.27,
    'J-I2-VG-GOOD-NONE-EX': 6.27,
    'J-I2-EX-POOR-NONE-EX': 6.27,
    'J-I2-EX-EX-NONE-VG': 6.27,
    'J-SI2-VG-POOR-FAINT-EX': 6.27,
    'J-SI2-GOOD-GOOD-FAINT-EX': 6.27,
    'J-SI2-POOR-VG-FAINT-EX': 6.27,
    'J-SI2-VG-EX-FAINT-VG': 6.27,
    'K-SI2-VG-POOR-NONE-EX': 6.27,
    'K-SI2-EX-VG-NONE-VG': 6.27,
    'K-SI2-VG-EX-NONE-VG': 6.27,
    'K-SI2-POOR-VG-NONE-EX': 6.27,
    'K-SI2-GOOD-GOOD-NONE-EX': 6.27,
    'M-SI2-EX-EX-STRONG-EX': 6.27,
    'D-VS2-VG-GOOD-STRONG-GOOD': 6.26,
    'D-VS2-POOR-POOR-STRONG-VG': 6.26,
    'D-VS2-GOOD-VG-STRONG-GOOD': 6.26,
    'D-VS2-POOR-EX-STRONG-GOOD': 6.26,
    'D-VS2-EX-POOR-STRONG-GOOD': 6.26,
    'D-VS2-EX-EX-STRONG-POOR': 6.26,
    'E-VVS2-VG-EX-STRONG-POOR': 6.26,
    'E-VVS2-EX-VG-STRONG-POOR': 6.26,
    'E-VVS2-VG-POOR-STRONG-GOOD': 6.26,
    'E-VS2-POOR-EX-MEDIUM-GOOD': 6.26,
    'E-VS2-EX-POOR-MEDIUM-GOOD': 6.26,
    'E-VS2-GOOD-VG-MEDIUM-GOOD': 6.26,
    'E-VS2-POOR-POOR-MEDIUM-VG': 6.26,
    'E-VVS2-GOOD-GOOD-STRONG-GOOD': 6.26,
    'E-VVS2-POOR-VG-STRONG-GOOD': 6.26,
    'E-VS2-VG-GOOD-MEDIUM-GOOD': 6.26,
    'E-VS2-EX-EX-MEDIUM-POOR': 6.26,
    'F-VVS2-EX-VG-MEDIUM-POOR': 6.26,
    'F-VVS2-VG-EX-MEDIUM-POOR': 6.26,
    'F-VVS2-VG-POOR-MEDIUM-GOOD': 6.26,
    'F-VVS2-GOOD-GOOD-MEDIUM-GOOD': 6.26,
    'F-VVS2-POOR-VG-MEDIUM-GOOD': 6.26,
    'F-VS2-POOR-EX-FAINT-GOOD': 6.26,
    'F-VS2-VG-GOOD-FAINT-GOOD': 6.26,
    'F-VS2-EX-POOR-FAINT-GOOD': 6.26,
    'F-VS2-EX-EX-FAINT-POOR': 6.26,
    'F-VS2-GOOD-VG-FAINT-GOOD': 6.26,
    'F-VS2-POOR-POOR-FAINT-VG': 6.26,
    'G-VVS2-POOR-VG-FAINT-GOOD': 6.26,
    'G-VVS2-VG-POOR-FAINT-GOOD': 6.26,
    'G-VS2-POOR-POOR-NONE-VG': 6.26,
    'G-VS2-EX-POOR-NONE-GOOD': 6.26,
    'G-VVS2-VG-EX-FAINT-POOR': 6.26,
    'G-VS2-VG-GOOD-NONE-GOOD': 6.26,
    'G-VS2-GOOD-VG-NONE-GOOD': 6.26,
    'G-VVS2-GOOD-GOOD-FAINT-GOOD': 6.26,
    'G-VS2-EX-EX-NONE-POOR': 6.26,
    'G-VS2-POOR-EX-NONE-GOOD': 6.26,
    'G-VVS2-EX-VG-FAINT-POOR': 6.26,
    'H-VVS2-GOOD-GOOD-NONE-GOOD': 6.26,
    'H-VVS2-EX-VG-NONE-POOR': 6.26,
    'H-VVS2-VG-POOR-NONE-GOOD': 6.26,
    'H-VVS2-VG-EX-NONE-POOR': 6.26,
    'H-VVS2-POOR-VG-NONE-GOOD': 6.26,
    'I-VS2-POOR-GOOD-STRONG-EX': 6.26,
    'I-VS2-GOOD-POOR-STRONG-EX': 6.26,
    'I-VS2-GOOD-EX-STRONG-VG': 6.26,
    'I-VS2-VG-VG-STRONG-VG': 6.26,
    'I-VS2-EX-GOOD-STRONG-VG': 6.26,
    'J-VVS2-EX-EX-STRONG-GOOD': 6.26,
    'J-VVS2-POOR-POOR-STRONG-EX': 6.26,
    'J-VVS2-POOR-EX-STRONG-VG': 6.26,
    'J-VVS2-GOOD-VG-STRONG-VG': 6.26,
    'J-VVS2-VG-GOOD-STRONG-VG': 6.26,
    'J-VVS2-EX-POOR-STRONG-VG': 6.26,
    'J-VS2-EX-GOOD-MEDIUM-VG': 6.26,
    'J-VS2-VG-VG-MEDIUM-VG': 6.26,
    'J-VS2-GOOD-EX-MEDIUM-VG': 6.26,
    'J-VS2-GOOD-POOR-MEDIUM-EX': 6.26,
    'J-VS2-POOR-GOOD-MEDIUM-EX': 6.26,
    'K-VS2-VG-VG-FAINT-VG': 6.26,
    'K-VVS2-POOR-POOR-MEDIUM-EX': 6.26,
    'K-VS2-POOR-GOOD-FAINT-EX': 6.26,
    'K-VS2-EX-GOOD-FAINT-VG': 6.26,
    'K-VS2-GOOD-POOR-FAINT-EX': 6.26,
    'K-VVS2-EX-EX-MEDIUM-GOOD': 6.26,
    'K-VVS2-EX-POOR-MEDIUM-VG': 6.26,
    'K-VVS2-VG-GOOD-MEDIUM-VG': 6.26,
    'K-VVS2-GOOD-VG-MEDIUM-VG': 6.26,
    'K-VS2-GOOD-EX-FAINT-VG': 6.26,
    'K-VVS2-POOR-EX-MEDIUM-VG': 6.26,
    'L-VVS2-EX-EX-FAINT-GOOD': 6.26,
    'L-VVS2-EX-POOR-FAINT-VG': 6.26,
    'L-VS2-GOOD-POOR-NONE-EX': 6.26,
    'L-VS2-GOOD-EX-NONE-VG': 6.26,
    'L-VVS2-POOR-EX-FAINT-VG': 6.26,
    'L-VVS2-GOOD-VG-FAINT-VG': 6.26,
    'L-VVS2-VG-GOOD-FAINT-VG': 6.26,
    'L-VS2-VG-VG-NONE-VG': 6.26,
    'L-VS2-EX-GOOD-NONE-VG': 6.26,
    'L-VS2-POOR-GOOD-NONE-EX': 6.26,
    'L-VVS2-POOR-POOR-FAINT-EX': 6.26,
    'M-VVS2-VG-GOOD-NONE-VG': 6.26,
    'M-VVS2-POOR-POOR-NONE-EX': 6.26,
    'M-VVS2-EX-POOR-NONE-VG': 6.26,
    'M-VVS2-POOR-EX-NONE-VG': 6.26,
    'M-VVS2-EX-EX-NONE-GOOD': 6.26,
    'M-VVS2-GOOD-VG-NONE-VG': 6.26,
    'D-IF-POOR-POOR-NONE-POOR': 6.25,
    'F-IF-EX-GOOD-STRONG-POOR': 6.25,
    'F-IF-POOR-GOOD-STRONG-GOOD': 6.25,
    'F-IF-GOOD-POOR-STRONG-GOOD': 6.25,
    'F-IF-GOOD-EX-STRONG-POOR': 6.25,
    'F-IF-VG-VG-STRONG-POOR': 6.25,
    'G-IF-EX-GOOD-MEDIUM-POOR': 6.25,
    'G-IF-GOOD-POOR-MEDIUM-GOOD': 6.25,
    'G-IF-POOR-GOOD-MEDIUM-GOOD': 6.25,
    'G-IF-VG-VG-MEDIUM-POOR': 6.25,
    'G-IF-GOOD-EX-MEDIUM-POOR': 6.25,
    'H-IF-VG-VG-FAINT-POOR': 6.25,
    'H-IF-GOOD-POOR-FAINT-GOOD': 6.25,
    'H-IF-EX-GOOD-FAINT-POOR': 6.25,
    'H-IF-GOOD-EX-FAINT-POOR': 6.25,
    'H-IF-POOR-GOOD-FAINT-GOOD': 6.25,
    'I-IF-VG-VG-NONE-POOR': 6.25,
    'I-IF-EX-GOOD-NONE-POOR': 6.25,
    'I-IF-GOOD-EX-NONE-POOR': 6.25,
    'I-IF-GOOD-POOR-NONE-GOOD': 6.25,
    'I-IF-POOR-GOOD-NONE-GOOD': 6.25,
    'K-IF-GOOD-GOOD-STRONG-VG': 6.25,
    'K-IF-POOR-VG-STRONG-VG': 6.25,
    'K-IF-VG-POOR-STRONG-VG': 6.25,
    'K-IF-EX-VG-STRONG-GOOD': 6.25,
    'K-IF-VG-EX-STRONG-GOOD': 6.25,
    'L-IF-EX-VG-MEDIUM-GOOD': 6.25,
    'L-IF-GOOD-GOOD-MEDIUM-VG': 6.25,
    'L-IF-VG-EX-MEDIUM-GOOD': 6.25,
    'L-IF-VG-POOR-MEDIUM-VG': 6.25,
    'L-IF-POOR-VG-MEDIUM-VG': 6.25,
    'M-IF-EX-VG-FAINT-GOOD': 6.25,
    'M-IF-GOOD-GOOD-FAINT-VG': 6.25,
    'M-IF-POOR-VG-FAINT-VG': 6.25,
    'M-IF-VG-POOR-FAINT-VG': 6.25,
    'M-IF-VG-EX-FAINT-GOOD': 6.25,
    'D-SI1-GOOD-VG-MEDIUM-GOOD': 6.24,
    'D-SI1-POOR-POOR-MEDIUM-VG': 6.24,
    'D-SI1-EX-EX-MEDIUM-POOR': 6.24,
    'D-SI1-EX-POOR-MEDIUM-GOOD': 6.24,
    'D-SI1-VG-GOOD-MEDIUM-GOOD': 6.24,
    'D-SI1-POOR-EX-MEDIUM-GOOD': 6.24,
    'D-I1-EX-GOOD-FAINT-GOOD': 6.24,
    'D-I1-VG-VG-FAINT-GOOD': 6.24,
    'D-I1-GOOD-EX-FAINT-GOOD': 6.24,
    'D-I1-GOOD-POOR-FAINT-VG': 6.24,
    'D-I1-POOR-GOOD-FAINT-VG': 6.24,
    'E-I1-GOOD-EX-NONE-GOOD': 6.24,
    'E-I1-VG-VG-NONE-GOOD': 6.24,
    'E-I1-GOOD-POOR-NONE-VG': 6.24,
    'E-I1-EX-GOOD-NONE-GOOD': 6.24,
    'E-I1-POOR-GOOD-NONE-VG': 6.24,
    'E-SI1-POOR-POOR-FAINT-VG': 6.24,
    'E-SI1-POOR-EX-FAINT-GOOD': 6.24,
    'E-SI1-GOOD-VG-FAINT-GOOD': 6.24,
    'E-SI1-EX-EX-FAINT-POOR': 6.24,
    'E-SI1-EX-POOR-FAINT-GOOD': 6.24,
    'E-SI1-VG-GOOD-FAINT-GOOD': 6.24,
    'F-SI1-VG-GOOD-NONE-GOOD': 6.24,
    'F-SI1-GOOD-VG-NONE-GOOD': 6.24,
    'F-SI1-POOR-EX-NONE-GOOD': 6.24,
    'F-SI1-POOR-POOR-NONE-VG': 6.24,
    'F-SI1-EX-POOR-NONE-GOOD': 6.24,
    'F-SI1-EX-EX-NONE-POOR': 6.24,
    'G-I1-POOR-VG-STRONG-EX': 6.24,
    'G-I1-GOOD-GOOD-STRONG-EX': 6.24,
    'G-I1-VG-POOR-STRONG-EX': 6.24,
    'G-I1-VG-EX-STRONG-VG': 6.24,
    'G-I1-EX-VG-STRONG-VG': 6.24,
    'H-SI1-GOOD-EX-STRONG-VG': 6.24,
    'H-SI1-EX-GOOD-STRONG-VG': 6.24,
    'H-SI1-VG-VG-STRONG-VG': 6.24,
    'H-SI1-POOR-GOOD-STRONG-EX': 6.24,
    'H-SI1-GOOD-POOR-STRONG-EX': 6.24,
    'H-I1-POOR-VG-MEDIUM-EX': 6.24,
    'H-I1-GOOD-GOOD-MEDIUM-EX': 6.24,
    'H-I1-VG-POOR-MEDIUM-EX': 6.24,
    'H-I1-VG-EX-MEDIUM-VG': 6.24,
    'H-I1-EX-VG-MEDIUM-VG': 6.24,
    'I-I1-POOR-VG-FAINT-EX': 6.24,
    'I-I1-GOOD-GOOD-FAINT-EX': 6.24,
    'I-I1-VG-POOR-FAINT-EX': 6.24,
    'I-I1-VG-EX-FAINT-VG': 6.24,
    'I-I1-EX-VG-FAINT-VG': 6.24,
    'I-SI1-EX-GOOD-MEDIUM-VG': 6.24,
    'I-SI1-VG-VG-MEDIUM-VG': 6.24,
    'I-SI1-GOOD-EX-MEDIUM-VG': 6.24,
    'I-SI1-GOOD-POOR-MEDIUM-EX': 6.24,
    'I-SI1-POOR-GOOD-MEDIUM-EX': 6.24,
    'J-SI1-VG-VG-FAINT-VG': 6.24,
    'J-I1-POOR-VG-NONE-EX': 6.24,
    'J-I1-GOOD-GOOD-NONE-EX': 6.24,
    'J-I1-VG-POOR-NONE-EX': 6.24,
    'J-I1-VG-EX-NONE-VG': 6.24,
    'J-I1-EX-VG-NONE-VG': 6.24,
    'J-SI1-EX-GOOD-FAINT-VG': 6.24,
    'J-SI1-GOOD-EX-FAINT-VG': 6.24,
    'J-SI1-GOOD-POOR-FAINT-EX': 6.24,
    'J-SI1-POOR-GOOD-FAINT-EX': 6.24,
    'K-SI1-POOR-GOOD-NONE-EX': 6.24,
    'K-SI1-GOOD-POOR-NONE-EX': 6.24,
    'K-SI1-GOOD-EX-NONE-VG': 6.24,
    'K-SI1-EX-GOOD-NONE-VG': 6.24,
    'K-SI1-VG-VG-NONE-VG': 6.24,
    'L-I1-EX-EX-STRONG-EX': 6.24,
    'M-I1-EX-EX-MEDIUM-EX': 6.24,
    'M-SI1-VG-EX-STRONG-EX': 6.24,
    'M-SI1-EX-VG-STRONG-EX': 6.24,
    'D-VS1-GOOD-GOOD-STRONG-GOOD': 6.23,
    'D-VS1-POOR-VG-STRONG-GOOD': 6.23,
    'D-VS1-VG-POOR-STRONG-GOOD': 6.23,
    'D-VS1-EX-VG-STRONG-POOR': 6.23,
    'D-VS1-VG-EX-STRONG-POOR': 6.23,
    'E-VVS1-VG-VG-STRONG-POOR': 6.23,
    'E-VVS1-EX-GOOD-STRONG-POOR': 6.23,
    'E-VS1-POOR-VG-MEDIUM-GOOD': 6.23,
    'E-VS1-GOOD-GOOD-MEDIUM-GOOD': 6.23,
    'E-VVS1-GOOD-EX-STRONG-POOR': 6.23,
    'E-VVS1-GOOD-POOR-STRONG-GOOD': 6.23,
    'E-VS1-EX-VG-MEDIUM-POOR': 6.23,
    'E-VS1-VG-POOR-MEDIUM-GOOD': 6.23,
    'E-VVS1-POOR-GOOD-STRONG-GOOD': 6.23,
    'E-VS1-VG-EX-MEDIUM-POOR': 6.23,
    'F-VVS1-EX-GOOD-MEDIUM-POOR': 6.23,
    'F-VVS1-VG-VG-MEDIUM-POOR': 6.23,
    'F-VVS1-GOOD-EX-MEDIUM-POOR': 6.23,
    'F-VVS1-GOOD-POOR-MEDIUM-GOOD': 6.23,
    'F-VVS1-POOR-GOOD-MEDIUM-GOOD': 6.23,
    'F-VS1-EX-VG-FAINT-POOR': 6.23,
    'F-VS1-VG-EX-FAINT-POOR': 6.23,
    'F-VS1-VG-POOR-FAINT-GOOD': 6.23,
    'F-VS1-GOOD-GOOD-FAINT-GOOD': 6.23,
    'F-VS1-POOR-VG-FAINT-GOOD': 6.23,
    'G-VS1-POOR-VG-NONE-GOOD': 6.23,
    'G-VVS1-GOOD-POOR-FAINT-GOOD': 6.23,
    'G-VS1-VG-POOR-NONE-GOOD': 6.23,
    'G-VS1-EX-VG-NONE-POOR': 6.23,
    'G-VVS1-GOOD-EX-FAINT-POOR': 6.23,
    'G-VVS1-EX-GOOD-FAINT-POOR': 6.23,
    'G-VS1-VG-EX-NONE-POOR': 6.23,
    'G-VS1-GOOD-GOOD-NONE-GOOD': 6.23,
    'G-VVS1-VG-VG-FAINT-POOR': 6.23,
    'G-VVS1-POOR-GOOD-FAINT-GOOD': 6.23,
    'H-VVS1-POOR-GOOD-NONE-GOOD': 6.23,
    'H-VVS1-GOOD-POOR-NONE-GOOD': 6.23,
    'H-VVS1-GOOD-EX-NONE-POOR': 6.23,
    'H-VVS1-VG-VG-NONE-POOR': 6.23,
    'H-VVS1-EX-GOOD-NONE-POOR': 6.23,
    'I-VS1-EX-EX-STRONG-GOOD': 6.23,
    'I-VS1-EX-POOR-STRONG-VG': 6.23,
    'I-VS1-VG-GOOD-STRONG-VG': 6.23,
    'I-VS1-POOR-POOR-STRONG-EX': 6.23,
    'I-VS1-POOR-EX-STRONG-VG': 6.23,
    'I-VS1-GOOD-VG-STRONG-VG': 6.23,
    'J-VVS1-EX-VG-STRONG-GOOD': 6.23,
    'J-VVS1-VG-EX-STRONG-GOOD': 6.23,
    'J-VVS1-VG-POOR-STRONG-VG': 6.23,
    'J-VVS1-GOOD-GOOD-STRONG-VG': 6.23,
    'J-VVS1-POOR-VG-STRONG-VG': 6.23,
    'J-VS1-POOR-POOR-MEDIUM-EX': 6.23,
    'J-VS1-POOR-EX-MEDIUM-VG': 6.23,
    'J-VS1-GOOD-VG-MEDIUM-VG': 6.23,
    'J-VS1-VG-GOOD-MEDIUM-VG': 6.23,
    'J-VS1-EX-POOR-MEDIUM-VG': 6.23,
    'J-VS1-EX-EX-MEDIUM-GOOD': 6.23,
    'K-VS1-VG-GOOD-FAINT-VG': 6.23,
    'K-VVS1-GOOD-GOOD-MEDIUM-VG': 6.23,
    'K-VVS1-POOR-VG-MEDIUM-VG': 6.23,
    'K-VS1-EX-POOR-FAINT-VG': 6.23,
    'K-VVS1-VG-POOR-MEDIUM-VG': 6.23,
    'K-VVS1-VG-EX-MEDIUM-GOOD': 6.23,
    'K-VVS1-EX-VG-MEDIUM-GOOD': 6.23,
    'K-VS1-EX-EX-FAINT-GOOD': 6.23,
    'K-VS1-POOR-EX-FAINT-VG': 6.23,
    'K-VS1-POOR-POOR-FAINT-EX': 6.23,
    'K-VS1-GOOD-VG-FAINT-VG': 6.23,
    'L-VS1-POOR-POOR-NONE-EX': 6.23,
    'L-VS1-POOR-EX-NONE-VG': 6.23,
    'L-VS1-EX-EX-NONE-GOOD': 6.23,
    'L-VS1-EX-POOR-NONE-VG': 6.23,
    'L-VS1-VG-GOOD-NONE-VG': 6.23,
    'L-VS1-GOOD-VG-NONE-VG': 6.23,
    'L-VVS1-POOR-VG-FAINT-VG': 6.23,
    'L-VVS1-VG-POOR-FAINT-VG': 6.23,
    'L-VVS1-GOOD-GOOD-FAINT-VG': 6.23,
    'L-VVS1-EX-VG-FAINT-GOOD': 6.23,
    'L-VVS1-VG-EX-FAINT-GOOD': 6.23,
    'M-VVS1-POOR-VG-NONE-VG': 6.23,
    'M-VVS1-GOOD-GOOD-NONE-VG': 6.23,
    'M-VVS1-VG-POOR-NONE-VG': 6.23,
    'M-VVS1-VG-EX-NONE-GOOD': 6.23,
    'M-VVS1-EX-VG-NONE-GOOD': 6.23,
    'D-SI2-POOR-POOR-FAINT-VG': 6.22,
    'D-I2-EX-GOOD-NONE-GOOD': 6.22,
    'D-SI2-POOR-EX-FAINT-GOOD': 6.22,
    'D-SI2-EX-EX-FAINT-POOR': 6.22,
    'D-I2-GOOD-POOR-NONE-VG': 6.22,
    'D-I2-GOOD-EX-NONE-GOOD': 6.22,
    'D-I2-VG-VG-NONE-GOOD': 6.22,
    'D-SI2-VG-GOOD-FAINT-GOOD': 6.22,
    'D-SI2-GOOD-VG-FAINT-GOOD': 6.22,
    'D-I2-POOR-GOOD-NONE-VG': 6.22,
    'D-SI2-EX-POOR-FAINT-GOOD': 6.22,
    'E-SI2-VG-GOOD-NONE-GOOD': 6.22,
    'E-SI2-GOOD-VG-NONE-GOOD': 6.22,
    'E-SI2-POOR-EX-NONE-GOOD': 6.22,
    'E-SI2-POOR-POOR-NONE-VG': 6.22,
    'E-SI2-EX-POOR-NONE-GOOD': 6.22,
    'E-SI2-EX-EX-NONE-POOR': 6.22,
    'F-I2-GOOD-GOOD-STRONG-EX': 6.22,
    'F-I2-POOR-VG-STRONG-EX': 6.22,
    'F-I2-EX-VG-STRONG-VG': 6.22,
    'F-I2-VG-POOR-STRONG-EX': 6.22,
    'F-I2-VG-EX-STRONG-VG': 6.22,
    'G-I2-EX-VG-MEDIUM-VG': 6.22,
    'G-SI2-VG-VG-STRONG-VG': 6.22,
    'G-SI2-POOR-GOOD-STRONG-EX': 6.22,
    'G-I2-VG-EX-MEDIUM-VG': 6.22,
    'G-I2-POOR-VG-MEDIUM-EX': 6.22,
    'G-I2-GOOD-GOOD-MEDIUM-EX': 6.22,
    'G-SI2-GOOD-POOR-STRONG-EX': 6.22,
    'G-I2-VG-POOR-MEDIUM-EX': 6.22,
    'G-SI2-EX-GOOD-STRONG-VG': 6.22,
    'G-SI2-GOOD-EX-STRONG-VG': 6.22,
    'H-SI2-EX-GOOD-MEDIUM-VG': 6.22,
    'H-SI2-GOOD-POOR-MEDIUM-EX': 6.22,
    'H-I2-VG-POOR-FAINT-EX': 6.22,
    'H-SI2-GOOD-EX-MEDIUM-VG': 6.22,
    'H-I2-EX-VG-FAINT-VG': 6.22,
    'H-I2-VG-EX-FAINT-VG': 6.22,
    'H-SI2-POOR-GOOD-MEDIUM-EX': 6.22,
    'H-SI2-VG-VG-MEDIUM-VG': 6.22,
    'H-I2-POOR-VG-FAINT-EX': 6.22,
    'H-I2-GOOD-GOOD-FAINT-EX': 6.22,
    'I-SI2-GOOD-POOR-FAINT-EX': 6.22,
    'I-SI2-POOR-GOOD-FAINT-EX': 6.22,
    'I-I2-VG-EX-NONE-VG': 6.22,
    'I-I2-GOOD-GOOD-NONE-EX': 6.22,
    'I-SI2-EX-GOOD-FAINT-VG': 6.22,
    'I-I2-POOR-VG-NONE-EX': 6.22,
    'I-SI2-VG-VG-FAINT-VG': 6.22,
    'I-I2-VG-POOR-NONE-EX': 6.22,
    'I-I2-EX-VG-NONE-VG': 6.22,
    'I-SI2-GOOD-EX-FAINT-VG': 6.22,
    'J-SI2-VG-VG-NONE-VG': 6.22,
    'J-SI2-EX-GOOD-NONE-VG': 6.22,
    'J-SI2-GOOD-EX-NONE-VG': 6.22,
    'J-SI2-GOOD-POOR-NONE-EX': 6.22,
    'J-SI2-POOR-GOOD-NONE-EX': 6.22,
    'K-I2-EX-EX-STRONG-EX': 6.22,
    'L-I2-EX-EX-MEDIUM-EX': 6.22,
    'L-SI2-EX-VG-STRONG-EX': 6.22,
    'L-SI2-VG-EX-STRONG-EX': 6.22,
    'M-SI2-VG-EX-MEDIUM-EX': 6.22,
    'M-I2-EX-EX-FAINT-EX': 6.22,
    'M-SI2-EX-VG-MEDIUM-EX': 6.22,
    'D-VS2-POOR-VG-MEDIUM-GOOD': 6.21,
    'D-VVS2-GOOD-EX-STRONG-POOR': 6.21,
    'D-VVS2-VG-VG-STRONG-POOR': 6.21,
    'D-VVS2-POOR-GOOD-STRONG-GOOD': 6.21,
    'D-VS2-GOOD-GOOD-MEDIUM-GOOD': 6.21,
    'D-VS2-EX-VG-MEDIUM-POOR': 6.21,
    'D-VS2-VG-EX-MEDIUM-POOR': 6.21,
    'D-VVS2-GOOD-POOR-STRONG-GOOD': 6.21,
    'D-VVS2-EX-GOOD-STRONG-POOR': 6.21,
    'D-VS2-VG-POOR-MEDIUM-GOOD': 6.21,
    'E-VS2-VG-POOR-FAINT-GOOD': 6.21,
    'E-VS2-EX-VG-FAINT-POOR': 6.21,
    'E-VS2-POOR-VG-FAINT-GOOD': 6.21,
    'E-VS2-GOOD-GOOD-FAINT-GOOD': 6.21,
    'E-VS2-VG-EX-FAINT-POOR': 6.21,
    'E-VVS2-EX-GOOD-MEDIUM-POOR': 6.21,
    'E-VVS2-GOOD-POOR-MEDIUM-GOOD': 6.21,
    'E-VVS2-GOOD-EX-MEDIUM-POOR': 6.21,
    'E-VVS2-POOR-GOOD-MEDIUM-GOOD': 6.21,
    'E-VVS2-VG-VG-MEDIUM-POOR': 6.21,
    'F-VS2-VG-POOR-NONE-GOOD': 6.21,
    'F-VVS2-GOOD-EX-FAINT-POOR': 6.21,
    'F-VS2-GOOD-GOOD-NONE-GOOD': 6.21,
    'F-VVS2-EX-GOOD-FAINT-POOR': 6.21,
    'F-VVS2-VG-VG-FAINT-POOR': 6.21,
    'F-VS2-POOR-VG-NONE-GOOD': 6.21,
    'F-VS2-VG-EX-NONE-POOR': 6.21,
    'F-VS2-EX-VG-NONE-POOR': 6.21,
    'F-VVS2-POOR-GOOD-FAINT-GOOD': 6.21,
    'F-VVS2-GOOD-POOR-FAINT-GOOD': 6.21,
    'G-VVS2-VG-VG-NONE-POOR': 6.21,
    'G-VVS2-GOOD-EX-NONE-POOR': 6.21,
    'G-VVS2-GOOD-POOR-NONE-GOOD': 6.21,
    'G-VVS2-EX-GOOD-NONE-POOR': 6.21,
    'G-VVS2-POOR-GOOD-NONE-GOOD': 6.21,
    'H-VS2-POOR-POOR-STRONG-EX': 6.21,
    'H-VS2-EX-EX-STRONG-GOOD': 6.21,
    'H-VS2-POOR-EX-STRONG-VG': 6.21,
    'H-VS2-GOOD-VG-STRONG-VG': 6.21,
    'H-VS2-EX-POOR-STRONG-VG': 6.21,
    'H-VS2-VG-GOOD-STRONG-VG': 6.21,
    'I-VVS2-EX-VG-STRONG-GOOD': 6.21,
    'I-VVS2-GOOD-GOOD-STRONG-VG': 6.21,
    'I-VVS2-VG-EX-STRONG-GOOD': 6.21,
    'I-VVS2-VG-POOR-STRONG-VG': 6.21,
    'I-VVS2-POOR-VG-STRONG-VG': 6.21,
    'I-VS2-VG-GOOD-MEDIUM-VG': 6.21,
    'I-VS2-POOR-EX-MEDIUM-VG': 6.21,
    'I-VS2-GOOD-VG-MEDIUM-VG': 6.21,
    'I-VS2-EX-POOR-MEDIUM-VG': 6.21,
    'I-VS2-EX-EX-MEDIUM-GOOD': 6.21,
    'I-VS2-POOR-POOR-MEDIUM-EX': 6.21,
    'J-VS2-POOR-POOR-FAINT-EX': 6.21,
    'J-VS2-POOR-EX-FAINT-VG': 6.21,
    'J-VVS2-VG-POOR-MEDIUM-VG': 6.21,
    'J-VVS2-EX-VG-MEDIUM-GOOD': 6.21,
    'J-VVS2-VG-EX-MEDIUM-GOOD': 6.21,
    'J-VS2-EX-EX-FAINT-GOOD': 6.21,
    'J-VVS2-POOR-VG-MEDIUM-VG': 6.21,
    'J-VS2-GOOD-VG-FAINT-VG': 6.21,
    'J-VS2-VG-GOOD-FAINT-VG': 6.21,
    'J-VS2-EX-POOR-FAINT-VG': 6.21,
    'J-VVS2-GOOD-GOOD-MEDIUM-VG': 6.21,
    'K-VS2-GOOD-VG-NONE-VG': 6.21,
    'K-VS2-VG-GOOD-NONE-VG': 6.21,
    'K-VVS2-VG-POOR-FAINT-VG': 6.21,
    'K-VVS2-POOR-VG-FAINT-VG': 6.21,
    'K-VVS2-GOOD-GOOD-FAINT-VG': 6.21,
    'K-VS2-POOR-POOR-NONE-EX': 6.21,
    'K-VS2-POOR-EX-NONE-VG': 6.21,
    'K-VS2-EX-EX-NONE-GOOD': 6.21,
    'K-VVS2-VG-EX-FAINT-GOOD': 6.21,
    'K-VS2-EX-POOR-NONE-VG': 6.21,
    'K-VVS2-EX-VG-FAINT-GOOD': 6.21,
    'L-VVS2-GOOD-GOOD-NONE-VG': 6.21,
    'L-VVS2-POOR-VG-NONE-VG': 6.21,
    'L-VVS2-EX-VG-NONE-GOOD': 6.21,
    'L-VVS2-VG-EX-NONE-GOOD': 6.21,
    'L-VVS2-VG-POOR-NONE-VG': 6.21,
    'M-VS2-EX-GOOD-STRONG-EX': 6.21,
    'M-VS2-VG-VG-STRONG-EX': 6.21,
    'M-VS2-GOOD-EX-STRONG-EX': 6.21,
    'E-IF-GOOD-VG-STRONG-POOR': 6.2,
    'E-IF-VG-GOOD-STRONG-POOR': 6.2,
    'E-IF-POOR-POOR-STRONG-GOOD': 6.2,
    'E-IF-EX-POOR-STRONG-POOR': 6.2,
    'E-IF-POOR-EX-STRONG-POOR': 6.2,
    'F-IF-VG-GOOD-MEDIUM-POOR': 6.2,
    'F-IF-POOR-EX-MEDIUM-POOR': 6.2,
    'F-IF-GOOD-VG-MEDIUM-POOR': 6.2,
    'F-IF-EX-POOR-MEDIUM-POOR': 6.2,
    'F-IF-POOR-POOR-MEDIUM-GOOD': 6.2,
    'G-IF-GOOD-VG-FAINT-POOR': 6.2,
    'G-IF-EX-POOR-FAINT-POOR': 6.2,
    'G-IF-POOR-EX-FAINT-POOR': 6.2,
    'G-IF-POOR-POOR-FAINT-GOOD': 6.2,
    'G-IF-VG-GOOD-FAINT-POOR': 6.2,
    'H-IF-EX-POOR-NONE-POOR': 6.2,
    'H-IF-VG-GOOD-NONE-POOR': 6.2,
    'H-IF-POOR-EX-NONE-POOR': 6.2,
    'H-IF-GOOD-VG-NONE-POOR': 6.2,
    'H-IF-POOR-POOR-NONE-GOOD': 6.2,
    'J-IF-EX-GOOD-STRONG-GOOD': 6.2,
    'J-IF-GOOD-POOR-STRONG-VG': 6.2,
    'J-IF-POOR-GOOD-STRONG-VG': 6.2,
    'J-IF-VG-VG-STRONG-GOOD': 6.2,
    'J-IF-GOOD-EX-STRONG-GOOD': 6.2,
    'K-IF-GOOD-EX-MEDIUM-GOOD': 6.2,
    'K-IF-VG-VG-MEDIUM-GOOD': 6.2,
    'K-IF-POOR-GOOD-MEDIUM-VG': 6.2,
    'K-IF-GOOD-POOR-MEDIUM-VG': 6.2,
    'K-IF-EX-GOOD-MEDIUM-GOOD': 6.2,
    'L-IF-EX-GOOD-FAINT-GOOD': 6.2,
    'L-IF-GOOD-POOR-FAINT-VG': 6.2,
    'L-IF-GOOD-EX-FAINT-GOOD': 6.2,
    'L-IF-POOR-GOOD-FAINT-VG': 6.2,
    'L-IF-VG-VG-FAINT-GOOD': 6.2,
    'M-IF-VG-VG-NONE-GOOD': 6.2,
    'M-IF-EX-GOOD-NONE-GOOD': 6.2,
    'M-IF-POOR-GOOD-NONE-VG': 6.2,
    'M-IF-GOOD-POOR-NONE-VG': 6.2,
    'M-IF-GOOD-EX-NONE-GOOD': 6.2,
    'D-I1-POOR-POOR-NONE-VG': 6.19,
    'D-I1-GOOD-VG-NONE-GOOD': 6.19,
    'D-SI1-POOR-VG-FAINT-GOOD': 6.19,
    'D-SI1-VG-EX-FAINT-POOR': 6.19,
    'D-I1-POOR-EX-NONE-GOOD': 6.19,
    'D-I1-VG-GOOD-NONE-GOOD': 6.19,
    'D-I1-EX-POOR-NONE-GOOD': 6.19,
    'D-SI1-VG-POOR-FAINT-GOOD': 6.19,
    'D-I1-EX-EX-NONE-POOR': 6.19,
    'D-SI1-GOOD-GOOD-FAINT-GOOD': 6.19,
    'D-SI1-EX-VG-FAINT-POOR': 6.19,
    'E-SI1-POOR-VG-NONE-GOOD': 6.19,
    'E-SI1-VG-POOR-NONE-GOOD': 6.19,
    'E-SI1-EX-VG-NONE-POOR': 6.19,
    'E-SI1-GOOD-GOOD-NONE-GOOD': 6.19,
    'E-SI1-VG-EX-NONE-POOR': 6.19,
    'F-I1-VG-VG-STRONG-VG': 6.19,
    'F-I1-POOR-GOOD-STRONG-EX': 6.19,
    'F-I1-GOOD-POOR-STRONG-EX': 6.19,
    'F-I1-GOOD-EX-STRONG-VG': 6.19,
    'F-I1-EX-GOOD-STRONG-VG': 6.19,
    'G-SI1-VG-GOOD-STRONG-VG': 6.19,
    'G-I1-EX-GOOD-MEDIUM-VG': 6.19,
    'G-SI1-POOR-POOR-STRONG-EX': 6.19,
    'G-SI1-EX-EX-STRONG-GOOD': 6.19,
    'G-SI1-EX-POOR-STRONG-VG': 6.19,
    'G-I1-GOOD-EX-MEDIUM-VG': 6.19,
    'G-I1-POOR-GOOD-MEDIUM-EX': 6.19,
    'G-SI1-GOOD-VG-STRONG-VG': 6.19,
    'G-I1-GOOD-POOR-MEDIUM-EX': 6.19,
    'G-I1-VG-VG-MEDIUM-VG': 6.19,
    'G-SI1-POOR-EX-STRONG-VG': 6.19,
    'H-I1-EX-GOOD-FAINT-VG': 6.19,
    'H-I1-VG-VG-FAINT-VG': 6.19,
    'H-I1-GOOD-POOR-FAINT-EX': 6.19,
    'H-I1-POOR-GOOD-FAINT-EX': 6.19,
    'H-I1-GOOD-EX-FAINT-VG': 6.19,
    'H-SI1-EX-POOR-MEDIUM-VG': 6.19,
    'H-SI1-EX-EX-MEDIUM-GOOD': 6.19,
    'H-SI1-VG-GOOD-MEDIUM-VG': 6.19,
    'H-SI1-POOR-POOR-MEDIUM-EX': 6.19,
    'H-SI1-POOR-EX-MEDIUM-VG': 6.19,
    'H-SI1-GOOD-VG-MEDIUM-VG': 6.19,
    'I-SI1-POOR-EX-FAINT-VG': 6.19,
    'I-I1-GOOD-POOR-NONE-EX': 6.19,
    'I-SI1-GOOD-VG-FAINT-VG': 6.19,
    'I-SI1-POOR-POOR-FAINT-EX': 6.19,
    'I-SI1-VG-GOOD-FAINT-VG': 6.19,
    'I-SI1-EX-POOR-FAINT-VG': 6.19,
    'I-SI1-EX-EX-FAINT-GOOD': 6.19,
    'I-I1-POOR-GOOD-NONE-EX': 6.19,
    'I-I1-GOOD-EX-NONE-VG': 6.19,
    'I-I1-VG-VG-NONE-VG': 6.19,
    'I-I1-EX-GOOD-NONE-VG': 6.19,
    'J-SI1-POOR-POOR-NONE-EX': 6.19,
    'J-SI1-VG-GOOD-NONE-VG': 6.19,
    'J-SI1-EX-POOR-NONE-VG': 6.19,
    'J-SI1-EX-EX-NONE-GOOD': 6.19,
    'J-SI1-GOOD-VG-NONE-VG': 6.19,
    'J-SI1-POOR-EX-NONE-VG': 6.19,
    'K-I1-VG-EX-STRONG-EX': 6.19,
    'K-I1-EX-VG-STRONG-EX': 6.19,
    'L-SI1-GOOD-EX-STRONG-EX': 6.19,
    'L-SI1-VG-VG-STRONG-EX': 6.19,
    'L-I1-EX-VG-MEDIUM-EX': 6.19,
    'L-SI1-EX-GOOD-STRONG-EX': 6.19,
    'L-I1-VG-EX-MEDIUM-EX': 6.19,
    'M-SI1-EX-GOOD-MEDIUM-EX': 6.19,
    'M-SI1-GOOD-EX-MEDIUM-EX': 6.19,
    'M-SI1-VG-VG-MEDIUM-EX': 6.19,
    'M-I1-VG-EX-FAINT-EX': 6.19,
    'M-I1-EX-VG-FAINT-EX': 6.19,
    'D-VS1-GOOD-POOR-MEDIUM-GOOD': 6.18,
    'D-VS1-EX-GOOD-MEDIUM-POOR': 6.18,
    'D-VVS1-POOR-POOR-STRONG-GOOD': 6.18,
    'D-VVS1-VG-GOOD-STRONG-POOR': 6.18,
    'D-VVS1-GOOD-VG-STRONG-POOR': 6.18,
    'D-VS1-VG-VG-MEDIUM-POOR': 6.18,
    'D-VS1-GOOD-EX-MEDIUM-POOR': 6.18,
    'D-VVS1-EX-POOR-STRONG-POOR': 6.18,
    'D-VS1-POOR-GOOD-MEDIUM-GOOD': 6.18,
    'D-VVS1-POOR-EX-STRONG-POOR': 6.18,
    'E-VVS1-POOR-EX-MEDIUM-POOR': 6.18,
    'E-VS1-POOR-GOOD-FAINT-GOOD': 6.18,
    'E-VVS1-VG-GOOD-MEDIUM-POOR': 6.18,
    'E-VVS1-POOR-POOR-MEDIUM-GOOD': 6.18,
    'E-VS1-VG-VG-FAINT-POOR': 6.18,
    'E-VS1-EX-GOOD-FAINT-POOR': 6.18,
    'E-VS1-GOOD-EX-FAINT-POOR': 6.18,
    'E-VS1-GOOD-POOR-FAINT-GOOD': 6.18,
    'E-VVS1-EX-POOR-MEDIUM-POOR': 6.18,
    'E-VVS1-GOOD-VG-MEDIUM-POOR': 6.18,
    'F-VVS1-POOR-EX-FAINT-POOR': 6.18,
    'F-VS1-GOOD-POOR-NONE-GOOD': 6.18,
    'F-VVS1-EX-POOR-FAINT-POOR': 6.18,
    'F-VS1-GOOD-EX-NONE-POOR': 6.18,
    'F-VVS1-VG-GOOD-FAINT-POOR': 6.18,
    'F-VS1-POOR-GOOD-NONE-GOOD': 6.18,
    'F-VVS1-GOOD-VG-FAINT-POOR': 6.18,
    'F-VS1-VG-VG-NONE-POOR': 6.18,
    'F-VS1-EX-GOOD-NONE-POOR': 6.18,
    'F-VVS1-POOR-POOR-FAINT-GOOD': 6.18,
    'G-VVS1-POOR-EX-NONE-POOR': 6.18,
    'G-VVS1-VG-GOOD-NONE-POOR': 6.18,
    'G-VVS1-GOOD-VG-NONE-POOR': 6.18,
    'G-VVS1-POOR-POOR-NONE-GOOD': 6.18,
    'G-VVS1-EX-POOR-NONE-POOR': 6.18,
    'H-VS1-GOOD-GOOD-STRONG-VG': 6.18,
    'H-VS1-POOR-VG-STRONG-VG': 6.18,
    'H-VS1-EX-VG-STRONG-GOOD': 6.18,
    'H-VS1-VG-EX-STRONG-GOOD': 6.18,
    'H-VS1-VG-POOR-STRONG-VG': 6.18,
    'I-VS1-POOR-VG-MEDIUM-VG': 6.18,
    'I-VS1-GOOD-GOOD-MEDIUM-VG': 6.18,
    'I-VS1-VG-EX-MEDIUM-GOOD': 6.18,
    'I-VVS1-EX-GOOD-STRONG-GOOD': 6.18,
    'I-VVS1-VG-VG-STRONG-GOOD': 6.18,
    'I-VS1-EX-VG-MEDIUM-GOOD': 6.18,
    'I-VS1-VG-POOR-MEDIUM-VG': 6.18,
    'I-VVS1-GOOD-POOR-STRONG-VG': 6.18,
    'I-VVS1-POOR-GOOD-STRONG-VG': 6.18,
    'I-VVS1-GOOD-EX-STRONG-GOOD': 6.18,
    'J-VVS1-GOOD-EX-MEDIUM-GOOD': 6.18,
    'J-VVS1-POOR-GOOD-MEDIUM-VG': 6.18,
    'J-VVS1-GOOD-POOR-MEDIUM-VG': 6.18,
    'J-VS1-GOOD-GOOD-FAINT-VG': 6.18,
    'J-VS1-EX-VG-FAINT-GOOD': 6.18,
    'J-VS1-VG-POOR-FAINT-VG': 6.18,
    'J-VVS1-EX-GOOD-MEDIUM-GOOD': 6.18,
    'J-VS1-VG-EX-FAINT-GOOD': 6.18,
    'J-VVS1-VG-VG-MEDIUM-GOOD': 6.18,
    'J-VS1-POOR-VG-FAINT-VG': 6.18,
    'K-VS1-VG-POOR-NONE-VG': 6.18,
    'K-VVS1-VG-VG-FAINT-GOOD': 6.18,
    'K-VVS1-GOOD-EX-FAINT-GOOD': 6.18,
    'K-VS1-GOOD-GOOD-NONE-VG': 6.18,
    'K-VVS1-GOOD-POOR-FAINT-VG': 6.18,
    'K-VS1-EX-VG-NONE-GOOD': 6.18,
    'K-VS1-VG-EX-NONE-GOOD': 6.18,
    'K-VVS1-EX-GOOD-FAINT-GOOD': 6.18,
    'K-VVS1-POOR-GOOD-FAINT-VG': 6.18,
    'K-VS1-POOR-VG-NONE-VG': 6.18,
    'L-VVS1-VG-VG-NONE-GOOD': 6.18,
    'L-VVS1-GOOD-EX-NONE-GOOD': 6.18,
    'L-VVS1-POOR-GOOD-NONE-VG': 6.18,
    'L-VVS1-EX-GOOD-NONE-GOOD': 6.18,
    'L-VVS1-GOOD-POOR-NONE-VG': 6.18,
    'M-VS1-GOOD-VG-STRONG-EX': 6.18,
    'M-VS1-VG-GOOD-STRONG-EX': 6.18,
    'M-VS1-POOR-EX-STRONG-EX': 6.18,
    'M-VS1-EX-EX-STRONG-VG': 6.18,
    'M-VS1-EX-POOR-STRONG-EX': 6.18,
    'D-SI2-EX-VG-NONE-POOR': 6.17,
    'D-SI2-POOR-VG-NONE-GOOD': 6.17,
    'D-SI2-VG-EX-NONE-POOR': 6.17,
    'D-SI2-GOOD-GOOD-NONE-GOOD': 6.17,
    'D-SI2-VG-POOR-NONE-GOOD': 6.17,
    'E-I2-EX-GOOD-STRONG-VG': 6.17,
    'E-I2-POOR-GOOD-STRONG-EX': 6.17,
    'E-I2-VG-VG-STRONG-VG': 6.17,
    'E-I2-GOOD-EX-STRONG-VG': 6.17,
    'E-I2-GOOD-POOR-STRONG-EX': 6.17,
    'F-SI2-POOR-POOR-STRONG-EX': 6.17,
    'F-I2-EX-GOOD-MEDIUM-VG': 6.17,
    'F-I2-GOOD-EX-MEDIUM-VG': 6.17,
    'F-I2-POOR-GOOD-MEDIUM-EX': 6.17,
    'F-SI2-POOR-EX-STRONG-VG': 6.17,
    'F-SI2-GOOD-VG-STRONG-VG': 6.17,
    'F-SI2-VG-GOOD-STRONG-VG': 6.17,
    'F-I2-GOOD-POOR-MEDIUM-EX': 6.17,
    'F-I2-VG-VG-MEDIUM-VG': 6.17,
    'F-SI2-EX-POOR-STRONG-VG': 6.17,
    'F-SI2-EX-EX-STRONG-GOOD': 6.17,
    'G-SI2-POOR-EX-MEDIUM-VG': 6.17,
    'G-I2-EX-GOOD-FAINT-VG': 6.17,
    'G-I2-GOOD-EX-FAINT-VG': 6.17,
    'G-I2-GOOD-POOR-FAINT-EX': 6.17,
    'G-SI2-EX-EX-MEDIUM-GOOD': 6.17,
    'G-SI2-GOOD-VG-MEDIUM-VG': 6.17,
    'G-SI2-POOR-POOR-MEDIUM-EX': 6.17,
    'G-I2-VG-VG-FAINT-VG': 6.17,
    'G-I2-POOR-GOOD-FAINT-EX': 6.17,
    'G-SI2-EX-POOR-MEDIUM-VG': 6.17,
    'G-SI2-VG-GOOD-MEDIUM-VG': 6.17,
    'H-SI2-GOOD-VG-FAINT-VG': 6.17,
    'H-SI2-VG-GOOD-FAINT-VG': 6.17,
    'H-SI2-EX-POOR-FAINT-VG': 6.17,
    'H-I2-EX-GOOD-NONE-VG': 6.17,
    'H-SI2-POOR-EX-FAINT-VG': 6.17,
    'H-I2-POOR-GOOD-NONE-EX': 6.17,
    'H-I2-GOOD-POOR-NONE-EX': 6.17,
    'H-SI2-EX-EX-FAINT-GOOD': 6.17,
    'H-I2-GOOD-EX-NONE-VG': 6.17,
    'H-SI2-POOR-POOR-FAINT-EX': 6.17,
    'H-I2-VG-VG-NONE-VG': 6.17,
    'I-SI2-EX-POOR-NONE-VG': 6.17,
    'I-SI2-POOR-EX-NONE-VG': 6.17,
    'I-SI2-GOOD-VG-NONE-VG': 6.17,
    'I-SI2-VG-GOOD-NONE-VG': 6.17,
    'I-SI2-EX-EX-NONE-GOOD': 6.17,
    'I-SI2-POOR-POOR-NONE-EX': 6.17,
    'J-I2-EX-VG-STRONG-EX': 6.17,
    'J-I2-VG-EX-STRONG-EX': 6.17,
    'K-SI2-VG-VG-STRONG-EX': 6.17,
    'K-I2-EX-VG-MEDIUM-EX': 6.17,
    'K-I2-VG-EX-MEDIUM-EX': 6.17,
    'K-SI2-GOOD-EX-STRONG-EX': 6.17,
    'K-SI2-EX-GOOD-STRONG-EX': 6.17,
    'L-SI2-EX-GOOD-MEDIUM-EX': 6.17,
    'L-I2-VG-EX-FAINT-EX': 6.17,
    'L-SI2-VG-VG-MEDIUM-EX': 6.17,
    'L-SI2-GOOD-EX-MEDIUM-EX': 6.17,
    'L-I2-EX-VG-FAINT-EX': 6.17,
    'M-I2-VG-EX-NONE-EX': 6.17,
    'M-SI2-GOOD-EX-FAINT-EX': 6.17,
    'M-SI2-EX-GOOD-FAINT-EX': 6.17,
    'M-SI2-VG-VG-FAINT-EX': 6.17,
    'M-I2-EX-VG-NONE-EX': 6.17,
    'D-VS2-VG-VG-FAINT-POOR': 6.16,
    'D-VS2-EX-GOOD-FAINT-POOR': 6.16,
    'D-VVS2-EX-POOR-MEDIUM-POOR': 6.16,
    'D-VVS2-GOOD-VG-MEDIUM-POOR': 6.16,
    'D-VS2-GOOD-POOR-FAINT-GOOD': 6.16,
    'D-VS2-POOR-GOOD-FAINT-GOOD': 6.16,
    'D-VVS2-POOR-EX-MEDIUM-POOR': 6.16,
    'D-VS2-GOOD-EX-FAINT-POOR': 6.16,
    'D-VVS2-POOR-POOR-MEDIUM-GOOD': 6.16,
    'D-VVS2-VG-GOOD-MEDIUM-POOR': 6.16,
    'E-VS2-POOR-GOOD-NONE-GOOD': 6.16,
    'E-VS2-VG-VG-NONE-POOR': 6.16,
    'E-VVS2-GOOD-VG-FAINT-POOR': 6.16,
    'E-VS2-GOOD-POOR-NONE-GOOD': 6.16,
    'E-VS2-EX-GOOD-NONE-POOR': 6.16,
    'E-VS2-GOOD-EX-NONE-POOR': 6.16,
    'E-VVS2-VG-GOOD-FAINT-POOR': 6.16,
    'E-VVS2-POOR-POOR-FAINT-GOOD': 6.16,
    'E-VVS2-EX-POOR-FAINT-POOR': 6.16,
    'E-VVS2-POOR-EX-FAINT-POOR': 6.16,
    'F-VVS2-POOR-EX-NONE-POOR': 6.16,
    'F-VVS2-EX-POOR-NONE-POOR': 6.16,
    'F-VVS2-POOR-POOR-NONE-GOOD': 6.16,
    'F-VVS2-GOOD-VG-NONE-POOR': 6.16,
    'F-VVS2-VG-GOOD-NONE-POOR': 6.16,
    'G-VS2-VG-POOR-STRONG-VG': 6.16,
    'G-VS2-VG-EX-STRONG-GOOD': 6.16,
    'G-VS2-POOR-VG-STRONG-VG': 6.16,
    'G-VS2-GOOD-GOOD-STRONG-VG': 6.16,
    'G-VS2-EX-VG-STRONG-GOOD': 6.16,
    'H-VS2-EX-VG-MEDIUM-GOOD': 6.16,
    'H-VVS2-POOR-GOOD-STRONG-VG': 6.16,
    'H-VVS2-EX-GOOD-STRONG-GOOD': 6.16,
    'H-VS2-VG-POOR-MEDIUM-VG': 6.16,
    'H-VVS2-GOOD-POOR-STRONG-VG': 6.16,
    'H-VVS2-GOOD-EX-STRONG-GOOD': 6.16,
    'H-VVS2-VG-VG-STRONG-GOOD': 6.16,
    'H-VS2-VG-EX-MEDIUM-GOOD': 6.16,
    'H-VS2-GOOD-GOOD-MEDIUM-VG': 6.16,
    'H-VS2-POOR-VG-MEDIUM-VG': 6.16,
    'I-VVS2-GOOD-POOR-MEDIUM-VG': 6.16,
    'I-VVS2-EX-GOOD-MEDIUM-GOOD': 6.16,
    'I-VVS2-VG-VG-MEDIUM-GOOD': 6.16,
    'I-VVS2-GOOD-EX-MEDIUM-GOOD': 6.16,
    'I-VVS2-POOR-GOOD-MEDIUM-VG': 6.16,
    'I-VS2-EX-VG-FAINT-GOOD': 6.16,
    'I-VS2-VG-POOR-FAINT-VG': 6.16,
    'I-VS2-GOOD-GOOD-FAINT-VG': 6.16,
    'I-VS2-POOR-VG-FAINT-VG': 6.16,
    'I-VS2-VG-EX-FAINT-GOOD': 6.16,
    'J-VS2-POOR-VG-NONE-VG': 6.16,
    'J-VVS2-GOOD-EX-FAINT-GOOD': 6.16,
    'J-VVS2-POOR-GOOD-FAINT-VG': 6.16,
    'J-VS2-VG-EX-NONE-GOOD': 6.16,
    'J-VS2-EX-VG-NONE-GOOD': 6.16,
    'J-VVS2-GOOD-POOR-FAINT-VG': 6.16,
    'J-VS2-GOOD-GOOD-NONE-VG': 6.16,
    'J-VVS2-VG-VG-FAINT-GOOD': 6.16,
    'J-VVS2-EX-GOOD-FAINT-GOOD': 6.16,
    'J-VS2-VG-POOR-NONE-VG': 6.16,
    'K-VVS2-VG-VG-NONE-GOOD': 6.16,
    'K-VVS2-EX-GOOD-NONE-GOOD': 6.16,
    'K-VVS2-GOOD-EX-NONE-GOOD': 6.16,
    'K-VVS2-POOR-GOOD-NONE-VG': 6.16,
    'K-VVS2-GOOD-POOR-NONE-VG': 6.16,
    'L-VS2-EX-EX-STRONG-VG': 6.16,
    'L-VS2-EX-POOR-STRONG-EX': 6.16,
    'L-VS2-GOOD-VG-STRONG-EX': 6.16,
    'L-VS2-POOR-EX-STRONG-EX': 6.16,
    'L-VS2-VG-GOOD-STRONG-EX': 6.16,
    'M-VS2-GOOD-VG-MEDIUM-EX': 6.16,
    'M-VVS2-POOR-VG-STRONG-EX': 6.16,
    'M-VS2-VG-GOOD-MEDIUM-EX': 6.16,
    'M-VVS2-VG-EX-STRONG-VG': 6.16,
    'M-VVS2-EX-VG-STRONG-VG': 6.16,
    'M-VS2-EX-POOR-MEDIUM-EX': 6.16,
    'M-VVS2-VG-POOR-STRONG-EX': 6.16,
    'M-VVS2-GOOD-GOOD-STRONG-EX': 6.16,
    'M-VS2-EX-EX-MEDIUM-VG': 6.16,
    'M-VS2-POOR-EX-MEDIUM-EX': 6.16,
    'D-IF-POOR-VG-STRONG-POOR': 6.15,
    'D-IF-GOOD-GOOD-STRONG-POOR': 6.15,
    'D-IF-VG-POOR-STRONG-POOR': 6.15,
    'E-IF-POOR-VG-MEDIUM-POOR': 6.15,
    'E-IF-VG-POOR-MEDIUM-POOR': 6.15,
    'E-IF-GOOD-GOOD-MEDIUM-POOR': 6.15,
    'F-IF-VG-POOR-FAINT-POOR': 6.15,
    'F-IF-POOR-VG-FAINT-POOR': 6.15,
    'F-IF-GOOD-GOOD-FAINT-POOR': 6.15,
    'G-IF-POOR-VG-NONE-POOR': 6.15,
    'G-IF-VG-POOR-NONE-POOR': 6.15,
    'G-IF-GOOD-GOOD-NONE-POOR': 6.15,
    'I-IF-EX-POOR-STRONG-GOOD': 6.15,
    'I-IF-POOR-POOR-STRONG-VG': 6.15,
    'I-IF-VG-GOOD-STRONG-GOOD': 6.15,
    'I-IF-POOR-EX-STRONG-GOOD': 6.15,
    'I-IF-GOOD-VG-STRONG-GOOD': 6.15,
    'I-IF-EX-EX-STRONG-POOR': 6.15,
    'J-IF-POOR-POOR-MEDIUM-VG': 6.15,
    'J-IF-VG-GOOD-MEDIUM-GOOD': 6.15,
    'J-IF-GOOD-VG-MEDIUM-GOOD': 6.15,
    'J-IF-EX-EX-MEDIUM-POOR': 6.15,
    'J-IF-EX-POOR-MEDIUM-GOOD': 6.15,
    'J-IF-POOR-EX-MEDIUM-GOOD': 6.15,
    'K-IF-EX-POOR-FAINT-GOOD': 6.15,
    'K-IF-EX-EX-FAINT-POOR': 6.15,
    'K-IF-POOR-EX-FAINT-GOOD': 6.15,
    'K-IF-VG-GOOD-FAINT-GOOD': 6.15,
    'K-IF-POOR-POOR-FAINT-VG': 6.15,
    'K-IF-GOOD-VG-FAINT-GOOD': 6.15,
    'L-IF-POOR-POOR-NONE-VG': 6.15,
    'L-IF-POOR-EX-NONE-GOOD': 6.15,
    'L-IF-VG-GOOD-NONE-GOOD': 6.15,
    'L-IF-EX-POOR-NONE-GOOD': 6.15,
    'L-IF-GOOD-VG-NONE-GOOD': 6.15,
    'L-IF-EX-EX-NONE-POOR': 6.15,
    'D-SI1-GOOD-POOR-NONE-GOOD': 6.14,
    'D-SI1-VG-VG-NONE-POOR': 6.14,
    'D-SI1-POOR-GOOD-NONE-GOOD': 6.14,
    'D-SI1-GOOD-EX-NONE-POOR': 6.14,
    'D-SI1-EX-GOOD-NONE-POOR': 6.14,
    'E-I1-POOR-POOR-STRONG-EX': 6.14,
    'E-I1-EX-EX-STRONG-GOOD': 6.14,
    'E-I1-VG-GOOD-STRONG-VG': 6.14,
    'E-I1-GOOD-VG-STRONG-VG': 6.14,
    'E-I1-EX-POOR-STRONG-VG': 6.14,
    'E-I1-POOR-EX-STRONG-VG': 6.14,
    'F-SI1-POOR-VG-STRONG-VG': 6.14,
    'F-I1-EX-POOR-MEDIUM-VG': 6.14,
    'F-I1-VG-GOOD-MEDIUM-VG': 6.14,
    'F-I1-GOOD-VG-MEDIUM-VG': 6.14,
    'F-SI1-GOOD-GOOD-STRONG-VG': 6.14,
    'F-SI1-EX-VG-STRONG-GOOD': 6.14,
    'F-I1-POOR-POOR-MEDIUM-EX': 6.14,
    'F-SI1-VG-EX-STRONG-GOOD': 6.14,
    'F-SI1-VG-POOR-STRONG-VG': 6.14,
    'F-I1-EX-EX-MEDIUM-GOOD': 6.14,
    'F-I1-POOR-EX-MEDIUM-VG': 6.14,
    'G-SI1-GOOD-GOOD-MEDIUM-VG': 6.14,
    'G-I1-VG-GOOD-FAINT-VG': 6.14,
    'G-I1-POOR-POOR-FAINT-EX': 6.14,
    'G-I1-EX-EX-FAINT-GOOD': 6.14,
    'G-I1-EX-POOR-FAINT-VG': 6.14,
    'G-SI1-VG-POOR-MEDIUM-VG': 6.14,
    'G-SI1-EX-VG-MEDIUM-GOOD': 6.14,
    'G-SI1-VG-EX-MEDIUM-GOOD': 6.14,
    'G-SI1-POOR-VG-MEDIUM-VG': 6.14,
    'G-I1-POOR-EX-FAINT-VG': 6.14,
    'G-I1-GOOD-VG-FAINT-VG': 6.14,
    'H-I1-POOR-EX-NONE-VG': 6.14,
    'H-I1-GOOD-VG-NONE-VG': 6.14,
    'H-SI1-POOR-VG-FAINT-VG': 6.14,
    'H-SI1-GOOD-GOOD-FAINT-VG': 6.14,
    'H-I1-POOR-POOR-NONE-EX': 6.14,
    'H-I1-VG-GOOD-NONE-VG': 6.14,
    'H-SI1-VG-EX-FAINT-GOOD': 6.14,
    'H-SI1-EX-VG-FAINT-GOOD': 6.14,
    'H-I1-EX-EX-NONE-GOOD': 6.14,
    'H-I1-EX-POOR-NONE-VG': 6.14,
    'H-SI1-VG-POOR-FAINT-VG': 6.14,
    'I-SI1-EX-VG-NONE-GOOD': 6.14,
    'I-SI1-VG-EX-NONE-GOOD': 6.14,
    'I-SI1-POOR-VG-NONE-VG': 6.14,
    'I-SI1-GOOD-GOOD-NONE-VG': 6.14,
    'I-SI1-VG-POOR-NONE-VG': 6.14,
    'J-I1-EX-GOOD-STRONG-EX': 6.14,
    'J-I1-GOOD-EX-STRONG-EX': 6.14,
    'J-I1-VG-VG-STRONG-EX': 6.14,
    'K-I1-GOOD-EX-MEDIUM-EX': 6.14,
    'K-SI1-VG-GOOD-STRONG-EX': 6.14,
    'K-I1-VG-VG-MEDIUM-EX': 6.14,
    'K-SI1-EX-POOR-STRONG-EX': 6.14,
    'K-I1-EX-GOOD-MEDIUM-EX': 6.14,
    'K-SI1-POOR-EX-STRONG-EX': 6.14,
    'K-SI1-GOOD-VG-STRONG-EX': 6.14,
    'K-SI1-EX-EX-STRONG-VG': 6.14,
    'L-I1-VG-VG-FAINT-EX': 6.14,
    'L-I1-EX-GOOD-FAINT-EX': 6.14,
    'L-SI1-VG-GOOD-MEDIUM-EX': 6.14,
    'L-SI1-GOOD-VG-MEDIUM-EX': 6.14,
    'L-SI1-POOR-EX-MEDIUM-EX': 6.14,
    'L-I1-GOOD-EX-FAINT-EX': 6.14,
    'L-SI1-EX-EX-MEDIUM-VG': 6.14,
    'L-SI1-EX-POOR-MEDIUM-EX': 6.14,
    'M-I1-GOOD-EX-NONE-EX': 6.14,
    'M-SI1-GOOD-VG-FAINT-EX': 6.14,
    'M-SI1-VG-GOOD-FAINT-EX': 6.14,
    'M-SI1-POOR-EX-FAINT-EX': 6.14,
    'M-I1-EX-GOOD-NONE-EX': 6.14,
    'M-SI1-EX-POOR-FAINT-EX': 6.14,
    'M-SI1-EX-EX-FAINT-VG': 6.14,
    'M-I1-VG-VG-NONE-EX': 6.14,
    'D-VS1-EX-POOR-FAINT-POOR': 6.13,
    'D-VVS1-VG-POOR-MEDIUM-POOR': 6.13,
    'D-VVS1-POOR-VG-MEDIUM-POOR': 6.13,
    'D-VS1-POOR-EX-FAINT-POOR': 6.13,
    'D-VS1-GOOD-VG-FAINT-POOR': 6.13,
    'D-VS1-POOR-POOR-FAINT-GOOD': 6.13,
    'D-VVS1-GOOD-GOOD-MEDIUM-POOR': 6.13,
    'D-VS1-VG-GOOD-FAINT-POOR': 6.13,
    'E-VS1-VG-GOOD-NONE-POOR': 6.13,
    'E-VVS1-POOR-VG-FAINT-POOR': 6.13,
    'E-VS1-POOR-POOR-NONE-GOOD': 6.13,
    'E-VVS1-VG-POOR-FAINT-POOR': 6.13,
    'E-VS1-EX-POOR-NONE-POOR': 6.13,
    'E-VS1-GOOD-VG-NONE-POOR': 6.13,
    'E-VS1-POOR-EX-NONE-POOR': 6.13,
    'E-VVS1-GOOD-GOOD-FAINT-POOR': 6.13,
    'F-VVS1-POOR-VG-NONE-POOR': 6.13,
    'F-VVS1-VG-POOR-NONE-POOR': 6.13,
    'F-VVS1-GOOD-GOOD-NONE-POOR': 6.13,
    'G-VS1-EX-GOOD-STRONG-GOOD': 6.13,
    'G-VS1-GOOD-POOR-STRONG-VG': 6.13,
    'G-VS1-POOR-GOOD-STRONG-VG': 6.13,
    'G-VS1-VG-VG-STRONG-GOOD': 6.13,
    'G-VS1-GOOD-EX-STRONG-GOOD': 6.13,
    'H-VS1-POOR-GOOD-MEDIUM-VG': 6.13,
    'H-VVS1-EX-EX-STRONG-POOR': 6.13,
    'H-VS1-EX-GOOD-MEDIUM-GOOD': 6.13,
    'H-VVS1-POOR-EX-STRONG-GOOD': 6.13,
    'H-VVS1-VG-GOOD-STRONG-GOOD': 6.13,
    'H-VS1-VG-VG-MEDIUM-GOOD': 6.13,
    'H-VS1-GOOD-EX-MEDIUM-GOOD': 6.13,
    'H-VVS1-GOOD-VG-STRONG-GOOD': 6.13,
    'H-VVS1-EX-POOR-STRONG-GOOD': 6.13,
    'H-VS1-GOOD-POOR-MEDIUM-VG': 6.13,
    'H-VVS1-POOR-POOR-STRONG-VG': 6.13,
    'I-VVS1-GOOD-VG-MEDIUM-GOOD': 6.13,
    'I-VVS1-POOR-EX-MEDIUM-GOOD': 6.13,
    'I-VVS1-EX-POOR-MEDIUM-GOOD': 6.13,
    'I-VVS1-POOR-POOR-MEDIUM-VG': 6.13,
    'I-VS1-GOOD-EX-FAINT-GOOD': 6.13,
    'I-VVS1-EX-EX-MEDIUM-POOR': 6.13,
    'I-VS1-POOR-GOOD-FAINT-VG': 6.13,
    'I-VVS1-VG-GOOD-MEDIUM-GOOD': 6.13,
    'I-VS1-VG-VG-FAINT-GOOD': 6.13,
    'I-VS1-EX-GOOD-FAINT-GOOD': 6.13,
    'I-VS1-GOOD-POOR-FAINT-VG': 6.13,
    'J-VVS1-POOR-POOR-FAINT-VG': 6.13,
    'J-VVS1-VG-GOOD-FAINT-GOOD': 6.13,
    'J-VVS1-GOOD-VG-FAINT-GOOD': 6.13,
    'J-VVS1-POOR-EX-FAINT-GOOD': 6.13,
    'J-VS1-EX-GOOD-NONE-GOOD': 6.13,
    'J-VVS1-EX-EX-FAINT-POOR': 6.13,
    'J-VS1-VG-VG-NONE-GOOD': 6.13,
    'J-VVS1-EX-POOR-FAINT-GOOD': 6.13,
    'J-VS1-POOR-GOOD-NONE-VG': 6.13,
    'J-VS1-GOOD-EX-NONE-GOOD': 6.13,
    'J-VS1-GOOD-POOR-NONE-VG': 6.13,
    'K-VVS1-POOR-POOR-NONE-VG': 6.13,
    'K-VVS1-GOOD-VG-NONE-GOOD': 6.13,
    'K-VVS1-VG-GOOD-NONE-GOOD': 6.13,
    'K-VVS1-POOR-EX-NONE-GOOD': 6.13,
    'K-VVS1-EX-POOR-NONE-GOOD': 6.13,
    'K-VVS1-EX-EX-NONE-POOR': 6.13,
    'L-VS1-GOOD-GOOD-STRONG-EX': 6.13,
    'L-VS1-VG-POOR-STRONG-EX': 6.13,
    'L-VS1-POOR-VG-STRONG-EX': 6.13,
    'L-VS1-EX-VG-STRONG-VG': 6.13,
    'L-VS1-VG-EX-STRONG-VG': 6.13,
    'M-VVS1-VG-VG-STRONG-VG': 6.13,
    'M-VVS1-EX-GOOD-STRONG-VG': 6.13,
    'M-VS1-GOOD-GOOD-MEDIUM-EX': 6.13,
    'M-VVS1-POOR-GOOD-STRONG-EX': 6.13,
    'M-VS1-POOR-VG-MEDIUM-EX': 6.13,
    'M-VVS1-GOOD-EX-STRONG-VG': 6.13,
    'M-VS1-EX-VG-MEDIUM-VG': 6.13,
    'M-VS1-VG-POOR-MEDIUM-EX': 6.13,
    'M-VS1-VG-EX-MEDIUM-VG': 6.13,
    'M-VVS1-GOOD-POOR-STRONG-EX': 6.13,
    'D-I2-EX-EX-STRONG-GOOD': 6.12,
    'D-I2-VG-GOOD-STRONG-VG': 6.12,
    'D-I2-EX-POOR-STRONG-VG': 6.12,
    'D-I2-GOOD-VG-STRONG-VG': 6.12,
    'D-I2-POOR-POOR-STRONG-EX': 6.12,
    'D-I2-POOR-EX-STRONG-VG': 6.12,
    'E-I2-POOR-EX-MEDIUM-VG': 6.12,
    'E-I2-VG-GOOD-MEDIUM-VG': 6.12,
    'E-I2-GOOD-VG-MEDIUM-VG': 6.12,
    'E-SI2-VG-EX-STRONG-GOOD': 6.12,
    'E-I2-EX-EX-MEDIUM-GOOD': 6.12,
    'E-I2-EX-POOR-MEDIUM-VG': 6.12,
    'E-SI2-EX-VG-STRONG-GOOD': 6.12,
    'E-SI2-VG-POOR-STRONG-VG': 6.12,
    'E-SI2-GOOD-GOOD-STRONG-VG': 6.12,
    'E-SI2-POOR-VG-STRONG-VG': 6.12,
    'E-I2-POOR-POOR-MEDIUM-EX': 6.12,
    'F-I2-POOR-EX-FAINT-VG': 6.12,
    'F-I2-POOR-POOR-FAINT-EX': 6.12,
    'F-SI2-VG-POOR-MEDIUM-VG': 6.12,
    'F-SI2-VG-EX-MEDIUM-GOOD': 6.12,
    'F-SI2-EX-VG-MEDIUM-GOOD': 6.12,
    'F-SI2-GOOD-GOOD-MEDIUM-VG': 6.12,
    'F-SI2-POOR-VG-MEDIUM-VG': 6.12,
    'F-I2-GOOD-VG-FAINT-VG': 6.12,
    'F-I2-EX-EX-FAINT-GOOD': 6.12,
    'F-I2-EX-POOR-FAINT-VG': 6.12,
    'F-I2-VG-GOOD-FAINT-VG': 6.12,
    'G-I2-GOOD-VG-NONE-VG': 6.12,
    'G-I2-VG-GOOD-NONE-VG': 6.12,
    'G-I2-EX-POOR-NONE-VG': 6.12,
    'G-SI2-GOOD-GOOD-FAINT-VG': 6.12,
    'G-I2-EX-EX-NONE-GOOD': 6.12,
    'G-SI2-VG-POOR-FAINT-VG': 6.12,
    'G-SI2-POOR-VG-FAINT-VG': 6.12,
    'G-I2-POOR-POOR-NONE-EX': 6.12,
    'G-I2-POOR-EX-NONE-VG': 6.12,
    'G-SI2-EX-VG-FAINT-GOOD': 6.12,
    'G-SI2-VG-EX-FAINT-GOOD': 6.12,
    'H-SI2-EX-VG-NONE-GOOD': 6.12,
    'H-SI2-VG-EX-NONE-GOOD': 6.12,
    'H-SI2-VG-POOR-NONE-VG': 6.12,
    'H-SI2-GOOD-GOOD-NONE-VG': 6.12,
    'H-SI2-POOR-VG-NONE-VG': 6.12,
    'I-I2-EX-GOOD-STRONG-EX': 6.12,
    'I-I2-VG-VG-STRONG-EX': 6.12,
    'I-I2-GOOD-EX-STRONG-EX': 6.12,
    'J-SI2-EX-EX-STRONG-VG': 6.12,
    'J-SI2-POOR-EX-STRONG-EX': 6.12,
    'J-SI2-EX-POOR-STRONG-EX': 6.12,
    'J-SI2-VG-GOOD-STRONG-EX': 6.12,
    'J-SI2-GOOD-VG-STRONG-EX': 6.12,
    'J-I2-GOOD-EX-MEDIUM-EX': 6.12,
    'J-I2-EX-GOOD-MEDIUM-EX': 6.12,
    'J-I2-VG-VG-MEDIUM-EX': 6.12,
    'K-SI2-EX-EX-MEDIUM-VG': 6.12,
    'K-I2-VG-VG-FAINT-EX': 6.12,
    'K-I2-EX-GOOD-FAINT-EX': 6.12,
    'K-SI2-EX-POOR-MEDIUM-EX': 6.12,
    'K-SI2-VG-GOOD-MEDIUM-EX': 6.12,
    'K-I2-GOOD-EX-FAINT-EX': 6.12,
    'K-SI2-GOOD-VG-MEDIUM-EX': 6.12,
    'K-SI2-POOR-EX-MEDIUM-EX': 6.12,
    'L-I2-VG-VG-NONE-EX': 6.12,
    'L-I2-EX-GOOD-NONE-EX': 6.12,
    'L-I2-GOOD-EX-NONE-EX': 6.12,
    'L-SI2-GOOD-VG-FAINT-EX': 6.12,
    'L-SI2-POOR-EX-FAINT-EX': 6.12,
    'L-SI2-VG-GOOD-FAINT-EX': 6.12,
    'L-SI2-EX-POOR-FAINT-EX': 6.12,
    'L-SI2-EX-EX-FAINT-VG': 6.12,
    'M-SI2-EX-EX-NONE-VG': 6.12,
    'M-SI2-POOR-EX-NONE-EX': 6.12,
    'M-SI2-GOOD-VG-NONE-EX': 6.12,
    'M-SI2-EX-POOR-NONE-EX': 6.12,
    'M-SI2-VG-GOOD-NONE-EX': 6.12,
    'D-VVS2-VG-POOR-FAINT-POOR': 6.11,
    'D-VVS2-GOOD-GOOD-FAINT-POOR': 6.11,
    'D-VS2-POOR-POOR-NONE-GOOD': 6.11,
    'D-VS2-EX-POOR-NONE-POOR': 6.11,
    'D-VVS2-POOR-VG-FAINT-POOR': 6.11,
    'D-VS2-VG-GOOD-NONE-POOR': 6.11,
    'D-VS2-GOOD-VG-NONE-POOR': 6.11,
    'D-VS2-POOR-EX-NONE-POOR': 6.11,
    'E-VVS2-GOOD-GOOD-NONE-POOR': 6.11,
    'E-VVS2-VG-POOR-NONE-POOR': 6.11,
    'E-VVS2-POOR-VG-NONE-POOR': 6.11,
    'F-VS2-EX-GOOD-STRONG-GOOD': 6.11,
    'F-VS2-VG-VG-STRONG-GOOD': 6.11,
    'F-VS2-GOOD-EX-STRONG-GOOD': 6.11,
    'F-VS2-GOOD-POOR-STRONG-VG': 6.11,
    'F-VS2-POOR-GOOD-STRONG-VG': 6.11,
    'G-VVS2-POOR-EX-STRONG-GOOD': 6.11,
    'G-VVS2-EX-POOR-STRONG-GOOD': 6.11,
    'G-VVS2-GOOD-VG-STRONG-GOOD': 6.11,
    'G-VVS2-VG-GOOD-STRONG-GOOD': 6.11,
    'G-VS2-EX-GOOD-MEDIUM-GOOD': 6.11,
    'G-VS2-GOOD-POOR-MEDIUM-VG': 6.11,
    'G-VS2-VG-VG-MEDIUM-GOOD': 6.11,
    'G-VS2-GOOD-EX-MEDIUM-GOOD': 6.11,
    'G-VVS2-POOR-POOR-STRONG-VG': 6.11,
    'G-VVS2-EX-EX-STRONG-POOR': 6.11,
    'G-VS2-POOR-GOOD-MEDIUM-VG': 6.11,
    'H-VS2-POOR-GOOD-FAINT-VG': 6.11,
    'H-VS2-GOOD-POOR-FAINT-VG': 6.11,
    'H-VS2-EX-GOOD-FAINT-GOOD': 6.11,
    'H-VS2-GOOD-EX-FAINT-GOOD': 6.11,
    'H-VS2-VG-VG-FAINT-GOOD': 6.11,
    'H-VVS2-POOR-EX-MEDIUM-GOOD': 6.11,
    'H-VVS2-EX-EX-MEDIUM-POOR': 6.11,
    'H-VVS2-EX-POOR-MEDIUM-GOOD': 6.11,
    'H-VVS2-POOR-POOR-MEDIUM-VG': 6.11,
    'H-VVS2-VG-GOOD-MEDIUM-GOOD': 6.11,
    'H-VVS2-GOOD-VG-MEDIUM-GOOD': 6.11,
    'I-VVS2-EX-EX-FAINT-POOR': 6.11,
    'I-VVS2-POOR-POOR-FAINT-VG': 6.11,
    'I-VVS2-EX-POOR-FAINT-GOOD': 6.11,
    'I-VVS2-VG-GOOD-FAINT-GOOD': 6.11,
    'I-VVS2-POOR-EX-FAINT-GOOD': 6.11,
    'I-VVS2-GOOD-VG-FAINT-GOOD': 6.11,
    'I-VS2-GOOD-EX-NONE-GOOD': 6.11,
    'I-VS2-VG-VG-NONE-GOOD': 6.11,
    'I-VS2-EX-GOOD-NONE-GOOD': 6.11,
    'I-VS2-GOOD-POOR-NONE-VG': 6.11,
    'I-VS2-POOR-GOOD-NONE-VG': 6.11,
    'J-VVS2-GOOD-VG-NONE-GOOD': 6.11,
    'J-VVS2-VG-GOOD-NONE-GOOD': 6.11,
    'J-VVS2-EX-POOR-NONE-GOOD': 6.11,
    'J-VVS2-EX-EX-NONE-POOR': 6.11,
    'J-VVS2-POOR-EX-NONE-GOOD': 6.11,
    'J-VVS2-POOR-POOR-NONE-VG': 6.11,
    'K-VS2-EX-VG-STRONG-VG': 6.11,
    'K-VS2-VG-EX-STRONG-VG': 6.11,
    'K-VS2-VG-POOR-STRONG-EX': 6.11,
    'K-VS2-POOR-VG-STRONG-EX': 6.11,
    'K-VS2-GOOD-GOOD-STRONG-EX': 6.11,
    'L-VS2-GOOD-GOOD-MEDIUM-EX': 6.11,
    'L-VS2-VG-EX-MEDIUM-VG': 6.11,
    'L-VS2-VG-POOR-MEDIUM-EX': 6.11,
    'L-VS2-EX-VG-MEDIUM-VG': 6.11,
    'L-VS2-POOR-VG-MEDIUM-EX': 6.11,
    'L-VVS2-GOOD-POOR-STRONG-EX': 6.11,
    'L-VVS2-EX-GOOD-STRONG-VG': 6.11,
    'L-VVS2-GOOD-EX-STRONG-VG': 6.11,
    'L-VVS2-VG-VG-STRONG-VG': 6.11,
    'L-VVS2-POOR-GOOD-STRONG-EX': 6.11,
    'M-VVS2-VG-VG-MEDIUM-VG': 6.11,
    'M-VVS2-GOOD-EX-MEDIUM-VG': 6.11,
    'M-VVS2-POOR-GOOD-MEDIUM-EX': 6.11,
    'M-VS2-VG-EX-FAINT-VG': 6.11,
    'M-VVS2-GOOD-POOR-MEDIUM-EX': 6.11,
    'M-VVS2-EX-GOOD-MEDIUM-VG': 6.11,
    'M-VS2-EX-VG-FAINT-VG': 6.11,
    'M-VS2-VG-POOR-FAINT-EX': 6.11,
    'M-VS2-POOR-VG-FAINT-EX': 6.11,
    'M-VS2-GOOD-GOOD-FAINT-EX': 6.11,
    'D-IF-GOOD-POOR-MEDIUM-POOR': 6.1,
    'D-IF-POOR-GOOD-MEDIUM-POOR': 6.1,
    'E-IF-POOR-GOOD-FAINT-POOR': 6.1,
    'E-IF-GOOD-POOR-FAINT-POOR': 6.1,
    'F-IF-POOR-GOOD-NONE-POOR': 6.1,
    'F-IF-GOOD-POOR-NONE-POOR': 6.1,
    'H-IF-POOR-VG-STRONG-GOOD': 6.1,
    'H-IF-VG-POOR-STRONG-GOOD': 6.1,
    'H-IF-EX-VG-STRONG-POOR': 6.1,
    'H-IF-GOOD-GOOD-STRONG-GOOD': 6.1,
    'H-IF-VG-EX-STRONG-POOR': 6.1,
    'I-IF-POOR-VG-MEDIUM-GOOD': 6.1,
    'I-IF-EX-VG-MEDIUM-POOR': 6.1,
    'I-IF-VG-POOR-MEDIUM-GOOD': 6.1,
    'I-IF-VG-EX-MEDIUM-POOR': 6.1,
    'I-IF-GOOD-GOOD-MEDIUM-GOOD': 6.1,
    'J-IF-POOR-VG-FAINT-GOOD': 6.1,
    'J-IF-GOOD-GOOD-FAINT-GOOD': 6.1,
    'J-IF-EX-VG-FAINT-POOR': 6.1,
    'J-IF-VG-EX-FAINT-POOR': 6.1,
    'J-IF-VG-POOR-FAINT-GOOD': 6.1,
    'K-IF-GOOD-GOOD-NONE-GOOD': 6.1,
    'K-IF-VG-POOR-NONE-GOOD': 6.1,
    'K-IF-VG-EX-NONE-POOR': 6.1,
    'K-IF-EX-VG-NONE-POOR': 6.1,
    'K-IF-POOR-VG-NONE-GOOD': 6.1,
    'M-IF-VG-GOOD-STRONG-VG': 6.1,
    'M-IF-EX-EX-STRONG-GOOD': 6.1,
    'M-IF-POOR-EX-STRONG-VG': 6.1,
    'M-IF-EX-POOR-STRONG-VG': 6.1,
    'M-IF-GOOD-VG-STRONG-VG': 6.1,
    'M-IF-POOR-POOR-STRONG-EX': 6.1,
    'D-I1-POOR-VG-STRONG-VG': 6.09,
    'D-I1-GOOD-GOOD-STRONG-VG': 6.09,
    'D-I1-VG-POOR-STRONG-VG': 6.09,
    'D-I1-VG-EX-STRONG-GOOD': 6.09,
    'D-I1-EX-VG-STRONG-GOOD': 6.09,
    'E-I1-EX-VG-MEDIUM-GOOD': 6.09,
    'E-I1-GOOD-GOOD-MEDIUM-VG': 6.09,
    'E-SI1-POOR-GOOD-STRONG-VG': 6.09,
    'E-I1-VG-POOR-MEDIUM-VG': 6.09,
    'E-SI1-GOOD-POOR-STRONG-VG': 6.09,
    'E-I1-VG-EX-MEDIUM-GOOD': 6.09,
    'E-SI1-VG-VG-STRONG-GOOD': 6.09,
    'E-SI1-EX-GOOD-STRONG-GOOD': 6.09,
    'E-I1-POOR-VG-MEDIUM-VG': 6.09,
    'E-SI1-GOOD-EX-STRONG-GOOD': 6.09,
    'F-I1-VG-EX-FAINT-GOOD': 6.09,
    'F-SI1-POOR-GOOD-MEDIUM-VG': 6.09,
    'F-I1-POOR-VG-FAINT-VG': 6.09,
    'F-I1-GOOD-GOOD-FAINT-VG': 6.09,
    'F-I1-EX-VG-FAINT-GOOD': 6.09,
    'F-SI1-GOOD-POOR-MEDIUM-VG': 6.09,
    'F-SI1-GOOD-EX-MEDIUM-GOOD': 6.09,
    'F-SI1-VG-VG-MEDIUM-GOOD': 6.09,
    'F-I1-VG-POOR-FAINT-VG': 6.09,
    'F-SI1-EX-GOOD-MEDIUM-GOOD': 6.09,
    'G-SI1-VG-VG-FAINT-GOOD': 6.09,
    'G-I1-POOR-VG-NONE-VG': 6.09,
    'G-SI1-EX-GOOD-FAINT-GOOD': 6.09,
    'G-SI1-GOOD-POOR-FAINT-VG': 6.09,
    'G-I1-VG-EX-NONE-GOOD': 6.09,
    'G-I1-VG-POOR-NONE-VG': 6.09,
    'G-SI1-GOOD-EX-FAINT-GOOD': 6.09,
    'G-I1-EX-VG-NONE-GOOD': 6.09,
    'G-I1-GOOD-GOOD-NONE-VG': 6.09,
    'G-SI1-POOR-GOOD-FAINT-VG': 6.09,
    'H-SI1-POOR-GOOD-NONE-VG': 6.09,
    'H-SI1-GOOD-POOR-NONE-VG': 6.09,
    'H-SI1-EX-GOOD-NONE-GOOD': 6.09,
    'H-SI1-VG-VG-NONE-GOOD': 6.09,
    'H-SI1-GOOD-EX-NONE-GOOD': 6.09,
    'I-I1-EX-EX-STRONG-VG': 6.09,
    'I-I1-EX-POOR-STRONG-EX': 6.09,
    'I-I1-GOOD-VG-STRONG-EX': 6.09,
    'I-I1-POOR-EX-STRONG-EX': 6.09,
    'I-I1-VG-GOOD-STRONG-EX': 6.09,
    'J-I1-GOOD-VG-MEDIUM-EX': 6.09,
    'J-I1-POOR-EX-MEDIUM-EX': 6.09,
    'J-SI1-VG-EX-STRONG-VG': 6.09,
    'J-I1-VG-GOOD-MEDIUM-EX': 6.09,
    'J-SI1-VG-POOR-STRONG-EX': 6.09,
    'J-SI1-GOOD-GOOD-STRONG-EX': 6.09,
    'J-SI1-POOR-VG-STRONG-EX': 6.09,
    'J-SI1-EX-VG-STRONG-VG': 6.09,
    'J-I1-EX-POOR-MEDIUM-EX': 6.09,
    'J-I1-EX-EX-MEDIUM-VG': 6.09,
    'K-I1-GOOD-VG-FAINT-EX': 6.09,
    'K-SI1-VG-POOR-MEDIUM-EX': 6.09,
    'K-I1-EX-EX-FAINT-VG': 6.09,
    'K-SI1-POOR-VG-MEDIUM-EX': 6.09,
    'K-I1-POOR-EX-FAINT-EX': 6.09,
    'K-SI1-GOOD-GOOD-MEDIUM-EX': 6.09,
    'K-SI1-VG-EX-MEDIUM-VG': 6.09,
    'K-SI1-EX-VG-MEDIUM-VG': 6.09,
    'K-I1-VG-GOOD-FAINT-EX': 6.09,
    'K-I1-EX-POOR-FAINT-EX': 6.09,
    'L-I1-POOR-EX-NONE-EX': 6.09,
    'L-SI1-VG-POOR-FAINT-EX': 6.09,
    'L-SI1-EX-VG-FAINT-VG': 6.09,
    'L-SI1-VG-EX-FAINT-VG': 6.09,
    'L-SI1-POOR-VG-FAINT-EX': 6.09,
    'L-SI1-GOOD-GOOD-FAINT-EX': 6.09,
    'L-I1-EX-EX-NONE-VG': 6.09,
    'L-I1-EX-POOR-NONE-EX': 6.09,
    'L-I1-VG-GOOD-NONE-EX': 6.09,
    'L-I1-GOOD-VG-NONE-EX': 6.09,
    'M-SI1-POOR-VG-NONE-EX': 6.09,
    'M-SI1-EX-VG-NONE-VG': 6.09,
    'M-SI1-VG-EX-NONE-VG': 6.09,
    'M-SI1-VG-POOR-NONE-EX': 6.09,
    'M-SI1-GOOD-GOOD-NONE-EX': 6.09,
    'D-VVS1-GOOD-POOR-FAINT-POOR': 6.08,
    'D-VVS1-POOR-GOOD-FAINT-POOR': 6.08,
    'D-VS1-GOOD-GOOD-NONE-POOR': 6.08,
    'D-VS1-POOR-VG-NONE-POOR': 6.08,
    'D-VS1-VG-POOR-NONE-POOR': 6.08,
    'E-VVS1-POOR-GOOD-NONE-POOR': 6.08,
    'E-VVS1-GOOD-POOR-NONE-POOR': 6.08,
    'F-VS1-POOR-POOR-STRONG-VG': 6.08,
    'F-VS1-POOR-EX-STRONG-GOOD': 6.08,
    'F-VS1-VG-GOOD-STRONG-GOOD': 6.08,
    'F-VS1-EX-POOR-STRONG-GOOD': 6.08,
    'F-VS1-GOOD-VG-STRONG-GOOD': 6.08,
    'F-VS1-EX-EX-STRONG-POOR': 6.08,
    'G-VS1-POOR-POOR-MEDIUM-VG': 6.08,
    'G-VVS1-POOR-VG-STRONG-GOOD': 6.08,
    'G-VVS1-VG-POOR-STRONG-GOOD': 6.08,
    'G-VVS1-EX-VG-STRONG-POOR': 6.08,
    'G-VVS1-GOOD-GOOD-STRONG-GOOD': 6.08,
    'G-VS1-POOR-EX-MEDIUM-GOOD': 6.08,
    'G-VVS1-VG-EX-STRONG-POOR': 6.08,
    'G-VS1-GOOD-VG-MEDIUM-GOOD': 6.08,
    'G-VS1-EX-POOR-MEDIUM-GOOD': 6.08,
    'G-VS1-VG-GOOD-MEDIUM-GOOD': 6.08,
    'G-VS1-EX-EX-MEDIUM-POOR': 6.08,
    'H-VS1-POOR-EX-FAINT-GOOD': 6.08,
    'H-VS1-EX-POOR-FAINT-GOOD': 6.08,
    'H-VS1-VG-GOOD-FAINT-GOOD': 6.08,
    'H-VS1-GOOD-VG-FAINT-GOOD': 6.08,
    'H-VVS1-EX-VG-MEDIUM-POOR': 6.08,
    'H-VVS1-GOOD-GOOD-MEDIUM-GOOD': 6.08,
    'H-VVS1-VG-POOR-MEDIUM-GOOD': 6.08,
    'H-VVS1-VG-EX-MEDIUM-POOR': 6.08,
    'H-VS1-POOR-POOR-FAINT-VG': 6.08,
    'H-VVS1-POOR-VG-MEDIUM-GOOD': 6.08,
    'H-VS1-EX-EX-FAINT-POOR': 6.08,
    'I-VVS1-VG-EX-FAINT-POOR': 6.08,
    'I-VVS1-EX-VG-FAINT-POOR': 6.08,
    'I-VVS1-POOR-VG-FAINT-GOOD': 6.08,
    'I-VVS1-GOOD-GOOD-FAINT-GOOD': 6.08,
    'I-VVS1-VG-POOR-FAINT-GOOD': 6.08,
    'I-VS1-POOR-POOR-NONE-VG': 6.08,
    'I-VS1-EX-POOR-NONE-GOOD': 6.08,
    'I-VS1-VG-GOOD-NONE-GOOD': 6.08,
    'I-VS1-GOOD-VG-NONE-GOOD': 6.08,
    'I-VS1-POOR-EX-NONE-GOOD': 6.08,
    'I-VS1-EX-EX-NONE-POOR': 6.08,
    'J-VVS1-EX-VG-NONE-POOR': 6.08,
    'J-VVS1-VG-EX-NONE-POOR': 6.08,
    'J-VVS1-VG-POOR-NONE-GOOD': 6.08,
    'J-VVS1-GOOD-GOOD-NONE-GOOD': 6.08,
    'J-VVS1-POOR-VG-NONE-GOOD': 6.08,
    'K-VS1-GOOD-EX-STRONG-VG': 6.08,
    'K-VS1-VG-VG-STRONG-VG': 6.08,
    'K-VS1-GOOD-POOR-STRONG-EX': 6.08,
    'K-VS1-POOR-GOOD-STRONG-EX': 6.08,
    'K-VS1-EX-GOOD-STRONG-VG': 6.08,
    'L-VVS1-POOR-POOR-STRONG-EX': 6.08,
    'L-VVS1-EX-EX-STRONG-GOOD': 6.08,
    'L-VVS1-EX-POOR-STRONG-VG': 6.08,
    'L-VVS1-POOR-EX-STRONG-VG': 6.08,
    'L-VS1-POOR-GOOD-MEDIUM-EX': 6.08,
    'L-VVS1-VG-GOOD-STRONG-VG': 6.08,
    'L-VS1-VG-VG-MEDIUM-VG': 6.08,
    'L-VS1-EX-GOOD-MEDIUM-VG': 6.08,
    'L-VS1-GOOD-EX-MEDIUM-VG': 6.08,
    'L-VVS1-GOOD-VG-STRONG-VG': 6.08,
    'L-VS1-GOOD-POOR-MEDIUM-EX': 6.08,
    'M-VS1-GOOD-POOR-FAINT-EX': 6.08,
    'M-VS1-VG-VG-FAINT-VG': 6.08,
    'M-VVS1-GOOD-VG-MEDIUM-VG': 6.08,
    'M-VS1-EX-GOOD-FAINT-VG': 6.08,
    'M-VS1-GOOD-EX-FAINT-VG': 6.08,
    'M-VVS1-EX-POOR-MEDIUM-VG': 6.08,
    'M-VVS1-EX-EX-MEDIUM-GOOD': 6.08,
    'M-VVS1-POOR-POOR-MEDIUM-EX': 6.08,
    'M-VVS1-POOR-EX-MEDIUM-VG': 6.08,
    'M-VVS1-VG-GOOD-MEDIUM-VG': 6.08,
    'M-VS1-POOR-GOOD-FAINT-EX': 6.08,
    'D-I2-VG-EX-MEDIUM-GOOD': 6.07,
    'D-I2-POOR-VG-MEDIUM-VG': 6.07,
    'D-SI2-GOOD-EX-STRONG-GOOD': 6.07,
    'D-I2-GOOD-GOOD-MEDIUM-VG': 6.07,
    'D-I2-VG-POOR-MEDIUM-VG': 6.07,
    'D-SI2-VG-VG-STRONG-GOOD': 6.07,
    'D-SI2-EX-GOOD-STRONG-GOOD': 6.07,
    'D-SI2-GOOD-POOR-STRONG-VG': 6.07,
    'D-SI2-POOR-GOOD-STRONG-VG': 6.07,
    'D-I2-EX-VG-MEDIUM-GOOD': 6.07,
    'E-SI2-EX-GOOD-MEDIUM-GOOD': 6.07,
    'E-SI2-VG-VG-MEDIUM-GOOD': 6.07,
    'E-I2-VG-EX-FAINT-GOOD': 6.07,
    'E-I2-GOOD-GOOD-FAINT-VG': 6.07,
    'E-I2-EX-VG-FAINT-GOOD': 6.07,
    'E-SI2-GOOD-EX-MEDIUM-GOOD': 6.07,
    'E-I2-POOR-VG-FAINT-VG': 6.07,
    'E-SI2-POOR-GOOD-MEDIUM-VG': 6.07,
    'E-SI2-GOOD-POOR-MEDIUM-VG': 6.07,
    'E-I2-VG-POOR-FAINT-VG': 6.07,
    'F-I2-VG-POOR-NONE-VG': 6.07,
    'F-I2-EX-VG-NONE-GOOD': 6.07,
    'F-I2-VG-EX-NONE-GOOD': 6.07,
    'F-SI2-VG-VG-FAINT-GOOD': 6.07,
    'F-SI2-GOOD-EX-FAINT-GOOD': 6.07,
    'F-SI2-GOOD-POOR-FAINT-VG': 6.07,
    'F-SI2-POOR-GOOD-FAINT-VG': 6.07,
    'F-SI2-EX-GOOD-FAINT-GOOD': 6.07,
    'F-I2-POOR-VG-NONE-VG': 6.07,
    'F-I2-GOOD-GOOD-NONE-VG': 6.07,
    'G-SI2-VG-VG-NONE-GOOD': 6.07,
    'G-SI2-GOOD-EX-NONE-GOOD': 6.07,
    'G-SI2-GOOD-POOR-NONE-VG': 6.07,
    'G-SI2-POOR-GOOD-NONE-VG': 6.07,
    'G-SI2-EX-GOOD-NONE-GOOD': 6.07,
    'H-I2-POOR-EX-STRONG-EX': 6.07,
    'H-I2-GOOD-VG-STRONG-EX': 6.07,
    'H-I2-EX-EX-STRONG-VG': 6.07,
    'H-I2-VG-GOOD-STRONG-EX': 6.07,
    'H-I2-EX-POOR-STRONG-EX': 6.07,
    'I-I2-EX-POOR-MEDIUM-EX': 6.07,
    'I-SI2-POOR-VG-STRONG-EX': 6.07,
    'I-SI2-VG-EX-STRONG-VG': 6.07,
    'I-SI2-EX-VG-STRONG-VG': 6.07,
    'I-I2-GOOD-VG-MEDIUM-EX': 6.07,
    'I-I2-POOR-EX-MEDIUM-EX': 6.07,
    'I-I2-VG-GOOD-MEDIUM-EX': 6.07,
    'I-SI2-GOOD-GOOD-STRONG-EX': 6.07,
    'I-SI2-VG-POOR-STRONG-EX': 6.07,
    'I-I2-EX-EX-MEDIUM-VG': 6.07,
    'J-I2-EX-EX-FAINT-VG': 6.07,
    'J-I2-VG-GOOD-FAINT-EX': 6.07,
    'J-SI2-VG-POOR-MEDIUM-EX': 6.07,
    'J-I2-GOOD-VG-FAINT-EX': 6.07,
    'J-SI2-GOOD-GOOD-MEDIUM-EX': 6.07,
    'J-SI2-POOR-VG-MEDIUM-EX': 6.07,
    'J-SI2-EX-VG-MEDIUM-VG': 6.07,
    'J-SI2-VG-EX-MEDIUM-VG': 6.07,
    'J-I2-EX-POOR-FAINT-EX': 6.07,
    'J-I2-POOR-EX-FAINT-EX': 6.07,
    'K-I2-EX-POOR-NONE-EX': 6.07,
    'K-SI2-VG-POOR-FAINT-EX': 6.07,
    'K-I2-VG-GOOD-NONE-EX': 6.07,
    'K-I2-GOOD-VG-NONE-EX': 6.07,
    'K-SI2-VG-EX-FAINT-VG': 6.07,
    'K-SI2-EX-VG-FAINT-VG': 6.07,
    'K-SI2-GOOD-GOOD-FAINT-EX': 6.07,
    'K-I2-EX-EX-NONE-VG': 6.07,
    'K-SI2-POOR-VG-FAINT-EX': 6.07,
    'K-I2-POOR-EX-NONE-EX': 6.07,
    'L-SI2-VG-EX-NONE-VG': 6.07,
    'L-SI2-VG-POOR-NONE-EX': 6.07,
    'L-SI2-EX-VG-NONE-VG': 6.07,
    'L-SI2-GOOD-GOOD-NONE-EX': 6.07,
    'L-SI2-POOR-VG-NONE-EX': 6.07,
    'D-VVS2-GOOD-POOR-NONE-POOR': 6.06,
    'D-VVS2-POOR-GOOD-NONE-POOR': 6.06,
    'E-VS2-POOR-EX-STRONG-GOOD': 6.06,
    'E-VS2-VG-GOOD-STRONG-GOOD': 6.06,
    'E-VS2-EX-EX-STRONG-POOR': 6.06,
    'E-VS2-GOOD-VG-STRONG-GOOD': 6.06,
    'E-VS2-POOR-POOR-STRONG-VG': 6.06,
    'E-VS2-EX-POOR-STRONG-GOOD': 6.06,
    'F-VS2-EX-POOR-MEDIUM-GOOD': 6.06,
    'F-VVS2-VG-EX-STRONG-POOR': 6.06,
    'F-VS2-EX-EX-MEDIUM-POOR': 6.06,
    'F-VVS2-VG-POOR-STRONG-GOOD': 6.06,
    'F-VVS2-EX-VG-STRONG-POOR': 6.06,
    'F-VS2-VG-GOOD-MEDIUM-GOOD': 6.06,
    'F-VS2-POOR-POOR-MEDIUM-VG': 6.06,
    'F-VS2-POOR-EX-MEDIUM-GOOD': 6.06,
    'F-VS2-GOOD-VG-MEDIUM-GOOD': 6.06,
    'F-VVS2-GOOD-GOOD-STRONG-GOOD': 6.06,
    'F-VVS2-POOR-VG-STRONG-GOOD': 6.06,
    'G-VVS2-VG-EX-MEDIUM-POOR': 6.06,
    'G-VS2-POOR-EX-FAINT-GOOD': 6.06,
    'G-VVS2-VG-POOR-MEDIUM-GOOD': 6.06,
    'G-VS2-VG-GOOD-FAINT-GOOD': 6.06,
    'G-VS2-POOR-POOR-FAINT-VG': 6.06,
    'G-VVS2-POOR-VG-MEDIUM-GOOD': 6.06,
    'G-VVS2-GOOD-GOOD-MEDIUM-GOOD': 6.06,
    'G-VVS2-EX-VG-MEDIUM-POOR': 6.06,
    'G-VS2-EX-POOR-FAINT-GOOD': 6.06,
    'G-VS2-EX-EX-FAINT-POOR': 6.06,
    'G-VS2-GOOD-VG-FAINT-GOOD': 6.06,
    'H-VS2-EX-EX-NONE-POOR': 6.06,
    'H-VVS2-VG-EX-FAINT-POOR': 6.06,
    'H-VS2-POOR-EX-NONE-GOOD': 6.06,
    'H-VS2-POOR-POOR-NONE-VG': 6.06,
    'H-VVS2-VG-POOR-FAINT-GOOD': 6.06,
    'H-VS2-EX-POOR-NONE-GOOD': 6.06,
    'H-VVS2-GOOD-GOOD-FAINT-GOOD': 6.06,
    'H-VVS2-POOR-VG-FAINT-GOOD': 6.06,
    'H-VS2-VG-GOOD-NONE-GOOD': 6.06,
    'H-VS2-GOOD-VG-NONE-GOOD': 6.06,
    'H-VVS2-EX-VG-FAINT-POOR': 6.06,
    'I-VVS2-GOOD-GOOD-NONE-GOOD': 6.06,
    'I-VVS2-POOR-VG-NONE-GOOD': 6.06,
    'I-VVS2-EX-VG-NONE-POOR': 6.06,
    'I-VVS2-VG-POOR-NONE-GOOD': 6.06,
    'I-VVS2-VG-EX-NONE-POOR': 6.06,
    'J-VS2-POOR-GOOD-STRONG-EX': 6.06,
    'J-VS2-VG-VG-STRONG-VG': 6.06,
    'J-VS2-EX-GOOD-STRONG-VG': 6.06,
    'J-VS2-GOOD-EX-STRONG-VG': 6.06,
    'J-VS2-GOOD-POOR-STRONG-EX': 6.06,
    'K-VS2-POOR-GOOD-MEDIUM-EX': 6.06,
    'K-VS2-GOOD-POOR-MEDIUM-EX': 6.06,
    'K-VS2-GOOD-EX-MEDIUM-VG': 6.06,
    'K-VVS2-GOOD-VG-STRONG-VG': 6.06,
    'K-VVS2-POOR-EX-STRONG-VG': 6.06,
    'K-VVS2-POOR-POOR-STRONG-EX': 6.06,
    'K-VS2-EX-GOOD-MEDIUM-VG': 6.06,
    'K-VS2-VG-VG-MEDIUM-VG': 6.06,
    'K-VVS2-EX-EX-STRONG-GOOD': 6.06,
    'K-VVS2-VG-GOOD-STRONG-VG': 6.06,
    'K-VVS2-EX-POOR-STRONG-VG': 6.06,
    'L-VVS2-EX-POOR-MEDIUM-VG': 6.06,
    'L-VVS2-VG-GOOD-MEDIUM-VG': 6.06,
    'L-VS2-GOOD-POOR-FAINT-EX': 6.06,
    'L-VS2-GOOD-EX-FAINT-VG': 6.06,
    'L-VS2-VG-VG-FAINT-VG': 6.06,
    'L-VS2-EX-GOOD-FAINT-VG': 6.06,
    'L-VVS2-EX-EX-MEDIUM-GOOD': 6.06,
    'L-VS2-POOR-GOOD-FAINT-EX': 6.06,
    'L-VVS2-GOOD-VG-MEDIUM-VG': 6.06,
    'L-VVS2-POOR-EX-MEDIUM-VG': 6.06,
    'L-VVS2-POOR-POOR-MEDIUM-EX': 6.06,
    'M-VVS2-POOR-POOR-FAINT-EX': 6.06,
    'M-VS2-POOR-GOOD-NONE-EX': 6.06,
    'M-VVS2-VG-GOOD-FAINT-VG': 6.06,
    'M-VS2-GOOD-POOR-NONE-EX': 6.06,
    'M-VS2-EX-GOOD-NONE-VG': 6.06,
    'M-VVS2-GOOD-VG-FAINT-VG': 6.06,
    'M-VVS2-EX-POOR-FAINT-VG': 6.06,
    'M-VS2-GOOD-EX-NONE-VG': 6.06,
    'M-VVS2-POOR-EX-FAINT-VG': 6.06,
    'M-VS2-VG-VG-NONE-VG': 6.06,
    'M-VVS2-EX-EX-FAINT-GOOD': 6.06,
    'D-IF-POOR-POOR-FAINT-POOR': 6.05,
    'E-IF-POOR-POOR-NONE-POOR': 6.05,
    'G-IF-VG-VG-STRONG-POOR': 6.05,
    'G-IF-POOR-GOOD-STRONG-GOOD': 6.05,
    'G-IF-GOOD-EX-STRONG-POOR': 6.05,
    'G-IF-GOOD-POOR-STRONG-GOOD': 6.05,
    'G-IF-EX-GOOD-STRONG-POOR': 6.05,
    'H-IF-GOOD-EX-MEDIUM-POOR': 6.05,
    'H-IF-GOOD-POOR-MEDIUM-GOOD': 6.05,
    'H-IF-POOR-GOOD-MEDIUM-GOOD': 6.05,
    'H-IF-EX-GOOD-MEDIUM-POOR': 6.05,
    'H-IF-VG-VG-MEDIUM-POOR': 6.05,
    'I-IF-EX-GOOD-FAINT-POOR': 6.05,
    'I-IF-VG-VG-FAINT-POOR': 6.05,
    'I-IF-GOOD-EX-FAINT-POOR': 6.05,
    'I-IF-GOOD-POOR-FAINT-GOOD': 6.05,
    'I-IF-POOR-GOOD-FAINT-GOOD': 6.05,
    'J-IF-VG-VG-NONE-POOR': 6.05,
    'J-IF-POOR-GOOD-NONE-GOOD': 6.05,
    'J-IF-EX-GOOD-NONE-POOR': 6.05,
    'J-IF-GOOD-POOR-NONE-GOOD': 6.05,
    'J-IF-GOOD-EX-NONE-POOR': 6.05,
    'L-IF-GOOD-GOOD-STRONG-VG': 6.05,
    'L-IF-POOR-VG-STRONG-VG': 6.05,
    'L-IF-VG-EX-STRONG-GOOD': 6.05,
    'L-IF-VG-POOR-STRONG-VG': 6.05,
    'L-IF-EX-VG-STRONG-GOOD': 6.05,
    'M-IF-GOOD-GOOD-MEDIUM-VG': 6.05,
    'M-IF-VG-EX-MEDIUM-GOOD': 6.05,
    'M-IF-VG-POOR-MEDIUM-VG': 6.05,
    'M-IF-POOR-VG-MEDIUM-VG': 6.05,
    'M-IF-EX-VG-MEDIUM-GOOD': 6.05,
    'D-SI1-EX-POOR-STRONG-GOOD': 6.04,
    'D-SI1-POOR-EX-STRONG-GOOD': 6.04,
    'D-SI1-POOR-POOR-STRONG-VG': 6.04,
    'D-I1-GOOD-EX-MEDIUM-GOOD': 6.04,
    'D-I1-EX-GOOD-MEDIUM-GOOD': 6.04,
    'D-I1-VG-VG-MEDIUM-GOOD': 6.04,
    'D-I1-GOOD-POOR-MEDIUM-VG': 6.04,
    'D-SI1-GOOD-VG-STRONG-GOOD': 6.04,
    'D-SI1-EX-EX-STRONG-POOR': 6.04,
    'D-I1-POOR-GOOD-MEDIUM-VG': 6.04,
    'D-SI1-VG-GOOD-STRONG-GOOD': 6.04,
    'E-I1-GOOD-POOR-FAINT-VG': 6.04,
    'E-SI1-POOR-POOR-MEDIUM-VG': 6.04,
    'E-SI1-EX-EX-MEDIUM-POOR': 6.04,
    'E-SI1-VG-GOOD-MEDIUM-GOOD': 6.04,
    'E-I1-GOOD-EX-FAINT-GOOD': 6.04,
    'E-SI1-GOOD-VG-MEDIUM-GOOD': 6.04,
    'E-SI1-EX-POOR-MEDIUM-GOOD': 6.04,
    'E-I1-EX-GOOD-FAINT-GOOD': 6.04,
    'E-SI1-POOR-EX-MEDIUM-GOOD': 6.04,
    'E-I1-VG-VG-FAINT-GOOD': 6.04,
    'E-I1-POOR-GOOD-FAINT-VG': 6.04,
    'F-SI1-VG-GOOD-FAINT-GOOD': 6.04,
    'F-SI1-POOR-EX-FAINT-GOOD': 6.04,
    'F-SI1-EX-EX-FAINT-POOR': 6.04,
    'F-I1-GOOD-POOR-NONE-VG': 6.04,
    'F-SI1-GOOD-VG-FAINT-GOOD': 6.04,
    'F-I1-EX-GOOD-NONE-GOOD': 6.04,
    'F-I1-VG-VG-NONE-GOOD': 6.04,
    'F-I1-POOR-GOOD-NONE-VG': 6.04,
    'F-SI1-POOR-POOR-FAINT-VG': 6.04,
    'F-SI1-EX-POOR-FAINT-GOOD': 6.04,
    'F-I1-GOOD-EX-NONE-GOOD': 6.04,
    'G-SI1-EX-EX-NONE-POOR': 6.04,
    'G-SI1-VG-GOOD-NONE-GOOD': 6.04,
    'G-SI1-POOR-EX-NONE-GOOD': 6.04,
    'G-SI1-POOR-POOR-NONE-VG': 6.04,
    'G-SI1-GOOD-VG-NONE-GOOD': 6.04,
    'G-SI1-EX-POOR-NONE-GOOD': 6.04,
    'H-I1-VG-POOR-STRONG-EX': 6.04,
    'H-I1-VG-EX-STRONG-VG': 6.04,
    'H-I1-EX-VG-STRONG-VG': 6.04,
    'H-I1-POOR-VG-STRONG-EX': 6.04,
    'H-I1-GOOD-GOOD-STRONG-EX': 6.04,
    'I-I1-GOOD-GOOD-MEDIUM-EX': 6.04,
    'I-I1-VG-EX-MEDIUM-VG': 6.04,
    'I-SI1-GOOD-EX-STRONG-VG': 6.04,
    'I-I1-POOR-VG-MEDIUM-EX': 6.04,
    'I-SI1-EX-GOOD-STRONG-VG': 6.04,
    'I-SI1-VG-VG-STRONG-VG': 6.04,
    'I-SI1-POOR-GOOD-STRONG-EX': 6.04,
    'I-SI1-GOOD-POOR-STRONG-EX': 6.04,
    'I-I1-EX-VG-MEDIUM-VG': 6.04,
    'I-I1-VG-POOR-MEDIUM-EX': 6.04,
    'J-SI1-GOOD-EX-MEDIUM-VG': 6.04,
    'J-I1-VG-POOR-FAINT-EX': 6.04,
    'J-SI1-VG-VG-MEDIUM-VG': 6.04,
    'J-SI1-EX-GOOD-MEDIUM-VG': 6.04,
    'J-I1-VG-EX-FAINT-VG': 6.04,
    'J-I1-EX-VG-FAINT-VG': 6.04,
    'J-SI1-GOOD-POOR-MEDIUM-EX': 6.04,
    'J-SI1-POOR-GOOD-MEDIUM-EX': 6.04,
    'J-I1-POOR-VG-FAINT-EX': 6.04,
    'J-I1-GOOD-GOOD-FAINT-EX': 6.04,
    'K-SI1-GOOD-EX-FAINT-VG': 6.04,
    'K-I1-EX-VG-NONE-VG': 6.04,
    'K-I1-VG-EX-NONE-VG': 6.04,
    'K-SI1-POOR-GOOD-FAINT-EX': 6.04,
    'K-I1-GOOD-GOOD-NONE-EX': 6.04,
    'K-I1-POOR-VG-NONE-EX': 6.04,
    'K-SI1-GOOD-POOR-FAINT-EX': 6.04,
    'K-I1-VG-POOR-NONE-EX': 6.04,
    'K-SI1-EX-GOOD-FAINT-VG': 6.04,
    'K-SI1-VG-VG-FAINT-VG': 6.04,
    'L-SI1-POOR-GOOD-NONE-EX': 6.04,
    'L-SI1-VG-VG-NONE-VG': 6.04,
    'L-SI1-EX-GOOD-NONE-VG': 6.04,
    'L-SI1-GOOD-POOR-NONE-EX': 6.04,
    'L-SI1-GOOD-EX-NONE-VG': 6.04,
    'M-I1-EX-EX-STRONG-EX': 6.04,
    'D-VVS1-POOR-POOR-NONE-POOR': 6.03,
    'E-VS1-VG-EX-STRONG-POOR': 6.03,
    'E-VS1-EX-VG-STRONG-POOR': 6.03,
    'E-VS1-GOOD-GOOD-STRONG-GOOD': 6.03,
    'E-VS1-VG-POOR-STRONG-GOOD': 6.03,
    'E-VS1-POOR-VG-STRONG-GOOD': 6.03,
    'F-VVS1-GOOD-EX-STRONG-POOR': 6.03,
    'F-VS1-GOOD-GOOD-MEDIUM-GOOD': 6.03,
    'F-VVS1-VG-VG-STRONG-POOR': 6.03,
    'F-VVS1-POOR-GOOD-STRONG-GOOD': 6.03,
    'F-VS1-VG-POOR-MEDIUM-GOOD': 6.03,
    'F-VS1-VG-EX-MEDIUM-POOR': 6.03,
    'F-VVS1-GOOD-POOR-STRONG-GOOD': 6.03,
    'F-VVS1-EX-GOOD-STRONG-POOR': 6.03,
    'F-VS1-EX-VG-MEDIUM-POOR': 6.03,
    'F-VS1-POOR-VG-MEDIUM-GOOD': 6.03,
    'G-VVS1-EX-GOOD-MEDIUM-POOR': 6.03,
    'G-VS1-GOOD-GOOD-FAINT-GOOD': 6.03,
    'G-VS1-POOR-VG-FAINT-GOOD': 6.03,
    'G-VS1-VG-POOR-FAINT-GOOD': 6.03,
    'G-VVS1-GOOD-EX-MEDIUM-POOR': 6.03,
    'G-VVS1-POOR-GOOD-MEDIUM-GOOD': 6.03,
    'G-VS1-EX-VG-FAINT-POOR': 6.03,
    'G-VVS1-VG-VG-MEDIUM-POOR': 6.03,
    'G-VVS1-GOOD-POOR-MEDIUM-GOOD': 6.03,
    'G-VS1-VG-EX-FAINT-POOR': 6.03,
    'H-VS1-GOOD-GOOD-NONE-GOOD': 6.03,
    'H-VS1-VG-EX-NONE-POOR': 6.03,
    'H-VVS1-GOOD-EX-FAINT-POOR': 6.03,
    'H-VS1-VG-POOR-NONE-GOOD': 6.03,
    'H-VVS1-POOR-GOOD-FAINT-GOOD': 6.03,
    'H-VVS1-GOOD-POOR-FAINT-GOOD': 6.03,
    'H-VVS1-EX-GOOD-FAINT-POOR': 6.03,
    'H-VS1-POOR-VG-NONE-GOOD': 6.03,
    'H-VVS1-VG-VG-FAINT-POOR': 6.03,
    'H-VS1-EX-VG-NONE-POOR': 6.03,
    'I-VVS1-POOR-GOOD-NONE-GOOD': 6.03,
    'I-VVS1-GOOD-POOR-NONE-GOOD': 6.03,
    'I-VVS1-EX-GOOD-NONE-POOR': 6.03,
    'I-VVS1-GOOD-EX-NONE-POOR': 6.03,
    'I-VVS1-VG-VG-NONE-POOR': 6.03,
    'J-VS1-GOOD-VG-STRONG-VG': 6.03,
    'J-VS1-EX-EX-STRONG-GOOD': 6.03,
    'J-VS1-VG-GOOD-STRONG-VG': 6.03,
    'J-VS1-POOR-POOR-STRONG-EX': 6.03,
    'J-VS1-EX-POOR-STRONG-VG': 6.03,
    'J-VS1-POOR-EX-STRONG-VG': 6.03,
    'K-VVS1-VG-EX-STRONG-GOOD': 6.03,
    'K-VVS1-EX-VG-STRONG-GOOD': 6.03,
    'K-VS1-EX-POOR-MEDIUM-VG': 6.03,
    'K-VS1-POOR-EX-MEDIUM-VG': 6.03,
    'K-VVS1-GOOD-GOOD-STRONG-VG': 6.03,
    'K-VVS1-POOR-VG-STRONG-VG': 6.03,
    'K-VVS1-VG-POOR-STRONG-VG': 6.03,
    'K-VS1-GOOD-VG-MEDIUM-VG': 6.03,
    'K-VS1-EX-EX-MEDIUM-GOOD': 6.03,
    'K-VS1-POOR-POOR-MEDIUM-EX': 6.03,
    'K-VS1-VG-GOOD-MEDIUM-VG': 6.03,
    'L-VVS1-VG-POOR-MEDIUM-VG': 6.03,
    'L-VVS1-POOR-VG-MEDIUM-VG': 6.03,
    'L-VS1-GOOD-VG-FAINT-VG': 6.03,
    'L-VS1-POOR-POOR-FAINT-EX': 6.03,
    'L-VS1-POOR-EX-FAINT-VG': 6.03,
    'L-VS1-VG-GOOD-FAINT-VG': 6.03,
    'L-VVS1-GOOD-GOOD-MEDIUM-VG': 6.03,
    'L-VS1-EX-EX-FAINT-GOOD': 6.03,
    'L-VVS1-VG-EX-MEDIUM-GOOD': 6.03,
    'L-VS1-EX-POOR-FAINT-VG': 6.03,
    'L-VVS1-EX-VG-MEDIUM-GOOD': 6.03,
    'M-VVS1-VG-POOR-FAINT-VG': 6.03,
    'M-VVS1-VG-EX-FAINT-GOOD': 6.03,
    'M-VS1-EX-EX-NONE-GOOD': 6.03,
    'M-VVS1-POOR-VG-FAINT-VG': 6.03,
    'M-VS1-POOR-POOR-NONE-EX': 6.03,
    'M-VS1-EX-POOR-NONE-VG': 6.03,
    'M-VS1-VG-GOOD-NONE-VG': 6.03,
    'M-VS1-POOR-EX-NONE-VG': 6.03,
    'M-VS1-GOOD-VG-NONE-VG': 6.03,
    'M-VVS1-GOOD-GOOD-FAINT-VG': 6.03,
    'M-VVS1-EX-VG-FAINT-GOOD': 6.03,
    'D-I2-EX-GOOD-FAINT-GOOD': 6.02,
    'D-SI2-EX-POOR-MEDIUM-GOOD': 6.02,
    'D-I2-GOOD-POOR-FAINT-VG': 6.02,
    'D-SI2-GOOD-VG-MEDIUM-GOOD': 6.02,
    'D-I2-POOR-GOOD-FAINT-VG': 6.02,
    'D-I2-GOOD-EX-FAINT-GOOD': 6.02,
    'D-SI2-POOR-POOR-MEDIUM-VG': 6.02,
    'D-SI2-POOR-EX-MEDIUM-GOOD': 6.02,
    'D-SI2-VG-GOOD-MEDIUM-GOOD': 6.02,
    'D-I2-VG-VG-FAINT-GOOD': 6.02,
    'D-SI2-EX-EX-MEDIUM-POOR': 6.02,
    'E-I2-VG-VG-NONE-GOOD': 6.02,
    'E-I2-GOOD-EX-NONE-GOOD': 6.02,
    'E-I2-GOOD-POOR-NONE-VG': 6.02,
    'E-SI2-POOR-EX-FAINT-GOOD': 6.02,
    'E-SI2-EX-POOR-FAINT-GOOD': 6.02,
    'E-SI2-POOR-POOR-FAINT-VG': 6.02,
    'E-I2-POOR-GOOD-NONE-VG': 6.02,
    'E-SI2-EX-EX-FAINT-POOR': 6.02,
    'E-I2-EX-GOOD-NONE-GOOD': 6.02,
    'E-SI2-GOOD-VG-FAINT-GOOD': 6.02,
    'E-SI2-VG-GOOD-FAINT-GOOD': 6.02,
    'F-SI2-GOOD-VG-NONE-GOOD': 6.02,
    'F-SI2-POOR-EX-NONE-GOOD': 6.02,
    'F-SI2-EX-EX-NONE-POOR': 6.02,
    'F-SI2-VG-GOOD-NONE-GOOD': 6.02,
    'F-SI2-EX-POOR-NONE-GOOD': 6.02,
    'F-SI2-POOR-POOR-NONE-VG': 6.02,
    'G-I2-EX-VG-STRONG-VG': 6.02,
    'G-I2-VG-EX-STRONG-VG': 6.02,
    'G-I2-VG-POOR-STRONG-EX': 6.02,
    'G-I2-POOR-VG-STRONG-EX': 6.02,
    'G-I2-GOOD-GOOD-STRONG-EX': 6.02,
    'H-SI2-POOR-GOOD-STRONG-EX': 6.02,
    'H-I2-EX-VG-MEDIUM-VG': 6.02,
    'H-I2-VG-EX-MEDIUM-VG': 6.02,
    'H-SI2-EX-GOOD-STRONG-VG': 6.02,
    'H-SI2-GOOD-POOR-STRONG-EX': 6.02,
    'H-SI2-GOOD-EX-STRONG-VG': 6.02,
    'H-I2-GOOD-GOOD-MEDIUM-EX': 6.02,
    'H-SI2-VG-VG-STRONG-VG': 6.02,
    'H-I2-POOR-VG-MEDIUM-EX': 6.02,
    'H-I2-VG-POOR-MEDIUM-EX': 6.02,
    'I-SI2-EX-GOOD-MEDIUM-VG': 6.02,
    'I-SI2-POOR-GOOD-MEDIUM-EX': 6.02,
    'I-SI2-GOOD-POOR-MEDIUM-EX': 6.02,
    'I-SI2-VG-VG-MEDIUM-VG': 6.02,
    'I-I2-EX-VG-FAINT-VG': 6.02,
    'I-I2-GOOD-GOOD-FAINT-EX': 6.02,
    'I-I2-VG-POOR-FAINT-EX': 6.02,
    'I-I2-POOR-VG-FAINT-EX': 6.02,
    'I-I2-VG-EX-FAINT-VG': 6.02,
    'I-SI2-GOOD-EX-MEDIUM-VG': 6.02,
    'J-SI2-EX-GOOD-FAINT-VG': 6.02,
    'J-I2-VG-EX-NONE-VG': 6.02,
    'J-I2-POOR-VG-NONE-EX': 6.02,
    'J-SI2-GOOD-POOR-FAINT-EX': 6.02,
    'J-I2-GOOD-GOOD-NONE-EX': 6.02,
    'J-SI2-POOR-GOOD-FAINT-EX': 6.02,
    'J-SI2-GOOD-EX-FAINT-VG': 6.02,
    'J-I2-EX-VG-NONE-VG': 6.02,
    'J-SI2-VG-VG-FAINT-VG': 6.02,
    'J-I2-VG-POOR-NONE-EX': 6.02,
    'K-SI2-VG-VG-NONE-VG': 6.02,
    'K-SI2-POOR-GOOD-NONE-EX': 6.02,
    'K-SI2-GOOD-POOR-NONE-EX': 6.02,
    'K-SI2-GOOD-EX-NONE-VG': 6.02,
    'K-SI2-EX-GOOD-NONE-VG': 6.02,
    'L-I2-EX-EX-STRONG-EX': 6.02,
    'M-SI2-EX-VG-STRONG-EX': 6.02,
    'M-SI2-VG-EX-STRONG-EX': 6.02,
    'M-I2-EX-EX-MEDIUM-EX': 6.02,
    'D-VS2-VG-POOR-STRONG-GOOD': 6.01,
    'D-VS2-VG-EX-STRONG-POOR': 6.01,
    'D-VS2-EX-VG-STRONG-POOR': 6.01,
    'D-VS2-GOOD-GOOD-STRONG-GOOD': 6.01,
    'D-VS2-POOR-VG-STRONG-GOOD': 6.01,
    'E-VS2-VG-EX-MEDIUM-POOR': 6.01,
    'E-VVS2-GOOD-POOR-STRONG-GOOD': 6.01,
    'E-VS2-EX-VG-MEDIUM-POOR': 6.01,
    'E-VS2-GOOD-GOOD-MEDIUM-GOOD': 6.01,
    'E-VS2-POOR-VG-MEDIUM-GOOD': 6.01,
    'E-VS2-VG-POOR-MEDIUM-GOOD': 6.01,
    'E-VVS2-GOOD-EX-STRONG-POOR': 6.01,
    'E-VVS2-EX-GOOD-STRONG-POOR': 6.01,
    'E-VVS2-POOR-GOOD-STRONG-GOOD': 6.01,
    'E-VVS2-VG-VG-STRONG-POOR': 6.01,
    'F-VS2-VG-EX-FAINT-POOR': 6.01,
    'F-VVS2-EX-GOOD-MEDIUM-POOR': 6.01,
    'F-VS2-POOR-VG-FAINT-GOOD': 6.01,
    'F-VVS2-GOOD-POOR-MEDIUM-GOOD': 6.01,
    'F-VS2-VG-POOR-FAINT-GOOD': 6.01,
    'F-VVS2-GOOD-EX-MEDIUM-POOR': 6.01,
    'F-VS2-GOOD-GOOD-FAINT-GOOD': 6.01,
    'F-VVS2-POOR-GOOD-MEDIUM-GOOD': 6.01,
    'F-VS2-EX-VG-FAINT-POOR': 6.01,
    'F-VVS2-VG-VG-MEDIUM-POOR': 6.01,
    'G-VS2-VG-POOR-NONE-GOOD': 6.01,
    'G-VS2-POOR-VG-NONE-GOOD': 6.01,
    'G-VVS2-GOOD-EX-FAINT-POOR': 6.01,
    'G-VVS2-EX-GOOD-FAINT-POOR': 6.01,
    'G-VVS2-POOR-GOOD-FAINT-GOOD': 6.01,
    'G-VVS2-GOOD-POOR-FAINT-GOOD': 6.01,
    'G-VS2-GOOD-GOOD-NONE-GOOD': 6.01,
    'G-VVS2-VG-VG-FAINT-POOR': 6.01,
    'G-VS2-EX-VG-NONE-POOR': 6.01,
    'G-VS2-VG-EX-NONE-POOR': 6.01,
    'H-VVS2-GOOD-EX-NONE-POOR': 6.01,
    'H-VVS2-POOR-GOOD-NONE-GOOD': 6.01,
    'H-VVS2-GOOD-POOR-NONE-GOOD': 6.01,
    'H-VVS2-EX-GOOD-NONE-POOR': 6.01,
    'H-VVS2-VG-VG-NONE-POOR': 6.01,
    'I-VS2-EX-EX-STRONG-GOOD': 6.01,
    'I-VS2-POOR-EX-STRONG-VG': 6.01,
    'I-VS2-EX-POOR-STRONG-VG': 6.01,
    'I-VS2-GOOD-VG-STRONG-VG': 6.01,
    'I-VS2-POOR-POOR-STRONG-EX': 6.01,
    'I-VS2-VG-GOOD-STRONG-VG': 6.01,
    'J-VS2-POOR-EX-MEDIUM-VG': 6.01,
    'J-VVS2-VG-POOR-STRONG-VG': 6.01,
    'J-VVS2-GOOD-GOOD-STRONG-VG': 6.01,
    'J-VS2-VG-GOOD-MEDIUM-VG': 6.01,
    'J-VVS2-EX-VG-STRONG-GOOD': 6.01,
    'J-VS2-EX-POOR-MEDIUM-VG': 6.01,
    'J-VS2-EX-EX-MEDIUM-GOOD': 6.01,
    'J-VS2-POOR-POOR-MEDIUM-EX': 6.01,
    'J-VVS2-POOR-VG-STRONG-VG': 6.01,
    'J-VS2-GOOD-VG-MEDIUM-VG': 6.01,
    'J-VVS2-VG-EX-STRONG-GOOD': 6.01,
    'K-VS2-GOOD-VG-FAINT-VG': 6.01,
    'K-VS2-POOR-EX-FAINT-VG': 6.01,
    'K-VVS2-GOOD-GOOD-MEDIUM-VG': 6.01,
    'K-VVS2-POOR-VG-MEDIUM-VG': 6.01,
    'K-VS2-EX-POOR-FAINT-VG': 6.01,
    'K-VVS2-VG-EX-MEDIUM-GOOD': 6.01,
    'K-VS2-VG-GOOD-FAINT-VG': 6.01,
    'K-VS2-EX-EX-FAINT-GOOD': 6.01,
    'K-VVS2-VG-POOR-MEDIUM-VG': 6.01,
    'K-VS2-POOR-POOR-FAINT-EX': 6.01,
    'K-VVS2-EX-VG-MEDIUM-GOOD': 6.01,
    'L-VVS2-VG-POOR-FAINT-VG': 6.01,
    'L-VVS2-EX-VG-FAINT-GOOD': 6.01,
    'L-VS2-VG-GOOD-NONE-VG': 6.01,
    'L-VS2-POOR-POOR-NONE-EX': 6.01,
    'L-VS2-POOR-EX-NONE-VG': 6.01,
    'L-VS2-GOOD-VG-NONE-VG': 6.01,
    'L-VS2-EX-EX-NONE-GOOD': 6.01,
    'L-VS2-EX-POOR-NONE-VG': 6.01,
    'L-VVS2-VG-EX-FAINT-GOOD': 6.01,
    'L-VVS2-GOOD-GOOD-FAINT-VG': 6.01,
    'L-VVS2-POOR-VG-FAINT-VG': 6.01,
    'M-VVS2-VG-POOR-NONE-VG': 6.01,
    'M-VVS2-VG-EX-NONE-GOOD': 6.01,
    'M-VVS2-EX-VG-NONE-GOOD': 6.01,
    'M-VVS2-POOR-VG-NONE-VG': 6.01,
    'M-VVS2-GOOD-GOOD-NONE-VG': 6.01,
    'F-IF-EX-POOR-STRONG-POOR': 6,
    'F-IF-POOR-EX-STRONG-POOR': 6,
    'F-IF-GOOD-VG-STRONG-POOR': 6,
    'F-IF-VG-GOOD-STRONG-POOR': 6,
    'F-IF-POOR-POOR-STRONG-GOOD': 6,
    'G-IF-POOR-POOR-MEDIUM-GOOD': 6,
    'G-IF-EX-POOR-MEDIUM-POOR': 6,
    'G-IF-VG-GOOD-MEDIUM-POOR': 6,
    'G-IF-GOOD-VG-MEDIUM-POOR': 6,
    'G-IF-POOR-EX-MEDIUM-POOR': 6,
    'H-IF-VG-GOOD-FAINT-POOR': 6,
    'H-IF-EX-POOR-FAINT-POOR': 6,
    'H-IF-POOR-EX-FAINT-POOR': 6,
    'H-IF-GOOD-VG-FAINT-POOR': 6,
    'H-IF-POOR-POOR-FAINT-GOOD': 6,
    'I-IF-EX-POOR-NONE-POOR': 6,
    'I-IF-VG-GOOD-NONE-POOR': 6,
    'I-IF-GOOD-VG-NONE-POOR': 6,
    'I-IF-POOR-POOR-NONE-GOOD': 6,
    'I-IF-POOR-EX-NONE-POOR': 6,
    'K-IF-POOR-GOOD-STRONG-VG': 6,
    'K-IF-GOOD-EX-STRONG-GOOD': 6,
    'K-IF-VG-VG-STRONG-GOOD': 6,
    'K-IF-EX-GOOD-STRONG-GOOD': 6,
    'K-IF-GOOD-POOR-STRONG-VG': 6,
    'L-IF-POOR-GOOD-MEDIUM-VG': 6,
    'L-IF-GOOD-EX-MEDIUM-GOOD': 6,
    'L-IF-VG-VG-MEDIUM-GOOD': 6,
    'L-IF-GOOD-POOR-MEDIUM-VG': 6,
    'L-IF-EX-GOOD-MEDIUM-GOOD': 6,
    'M-IF-GOOD-POOR-FAINT-VG': 6,
    'M-IF-VG-VG-FAINT-GOOD': 6,
    'M-IF-POOR-GOOD-FAINT-VG': 6,
    'M-IF-GOOD-EX-FAINT-GOOD': 6,
    'M-IF-EX-GOOD-FAINT-GOOD': 6,
    'D-I1-EX-EX-FAINT-POOR': 5.99,
    'D-I1-EX-POOR-FAINT-GOOD': 5.99,
    'D-SI1-POOR-VG-MEDIUM-GOOD': 5.99,
    'D-SI1-GOOD-GOOD-MEDIUM-GOOD': 5.99,
    'D-I1-VG-GOOD-FAINT-GOOD': 5.99,
    'D-I1-GOOD-VG-FAINT-GOOD': 5.99,
    'D-I1-POOR-POOR-FAINT-VG': 5.99,
    'D-I1-POOR-EX-FAINT-GOOD': 5.99,
    'D-SI1-EX-VG-MEDIUM-POOR': 5.99,
    'D-SI1-VG-POOR-MEDIUM-GOOD': 5.99,
    'D-SI1-VG-EX-MEDIUM-POOR': 5.99,
    'E-I1-POOR-EX-NONE-GOOD': 5.99,
    'E-I1-GOOD-VG-NONE-GOOD': 5.99,
    'E-I1-VG-GOOD-NONE-GOOD': 5.99,
    'E-I1-POOR-POOR-NONE-VG': 5.99,
    'E-I1-EX-POOR-NONE-GOOD': 5.99,
    'E-SI1-POOR-VG-FAINT-GOOD': 5.99,
    'E-SI1-VG-EX-FAINT-POOR': 5.99,
    'E-SI1-EX-VG-FAINT-POOR': 5.99,
    'E-I1-EX-EX-NONE-POOR': 5.99,
    'E-SI1-GOOD-GOOD-FAINT-GOOD': 5.99,
    'E-SI1-VG-POOR-FAINT-GOOD': 5.99,
    'F-SI1-VG-EX-NONE-POOR': 5.99,
    'F-SI1-POOR-VG-NONE-GOOD': 5.99,
    'F-SI1-VG-POOR-NONE-GOOD': 5.99,
    'F-SI1-EX-VG-NONE-POOR': 5.99,
    'F-SI1-GOOD-GOOD-NONE-GOOD': 5.99,
    'G-I1-GOOD-POOR-STRONG-EX': 5.99,
    'G-I1-POOR-GOOD-STRONG-EX': 5.99,
    'G-I1-EX-GOOD-STRONG-VG': 5.99,
    'G-I1-VG-VG-STRONG-VG': 5.99,
    'G-I1-GOOD-EX-STRONG-VG': 5.99,
    'H-SI1-VG-GOOD-STRONG-VG': 5.99,
    'H-SI1-GOOD-VG-STRONG-VG': 5.99,
    'H-SI1-POOR-EX-STRONG-VG': 5.99,
    'H-SI1-POOR-POOR-STRONG-EX': 5.99,
    'H-I1-POOR-GOOD-MEDIUM-EX': 5.99,
    'H-SI1-EX-EX-STRONG-GOOD': 5.99,
    'H-SI1-EX-POOR-STRONG-VG': 5.99,
    'H-I1-GOOD-POOR-MEDIUM-EX': 5.99,
    'H-I1-EX-GOOD-MEDIUM-VG': 5.99,
    'H-I1-VG-VG-MEDIUM-VG': 5.99,
    'H-I1-GOOD-EX-MEDIUM-VG': 5.99,
    'I-SI1-POOR-POOR-MEDIUM-EX': 5.99,
    'I-SI1-VG-GOOD-MEDIUM-VG': 5.99,
    'I-I1-GOOD-POOR-FAINT-EX': 5.99,
    'I-SI1-EX-POOR-MEDIUM-VG': 5.99,
    'I-SI1-POOR-EX-MEDIUM-VG': 5.99,
    'I-I1-GOOD-EX-FAINT-VG': 5.99,
    'I-I1-VG-VG-FAINT-VG': 5.99,
    'I-SI1-GOOD-VG-MEDIUM-VG': 5.99,
    'I-I1-EX-GOOD-FAINT-VG': 5.99,
    'I-I1-POOR-GOOD-FAINT-EX': 5.99,
    'I-SI1-EX-EX-MEDIUM-GOOD': 5.99,
    'J-SI1-EX-POOR-FAINT-VG': 5.99,
    'J-I1-POOR-GOOD-NONE-EX': 5.99,
    'J-SI1-GOOD-VG-FAINT-VG': 5.99,
    'J-SI1-VG-GOOD-FAINT-VG': 5.99,
    'J-SI1-POOR-POOR-FAINT-EX': 5.99,
    'J-I1-GOOD-POOR-NONE-EX': 5.99,
    'J-SI1-EX-EX-FAINT-GOOD': 5.99,
    'J-SI1-POOR-EX-FAINT-VG': 5.99,
    'J-I1-EX-GOOD-NONE-VG': 5.99,
    'J-I1-VG-VG-NONE-VG': 5.99,
    'J-I1-GOOD-EX-NONE-VG': 5.99,
    'K-SI1-GOOD-VG-NONE-VG': 5.99,
    'K-SI1-VG-GOOD-NONE-VG': 5.99,
    'K-SI1-EX-POOR-NONE-VG': 5.99,
    'K-SI1-POOR-EX-NONE-VG': 5.99,
    'K-SI1-POOR-POOR-NONE-EX': 5.99,
    'K-SI1-EX-EX-NONE-GOOD': 5.99,
    'L-I1-VG-EX-STRONG-EX': 5.99,
    'L-I1-EX-VG-STRONG-EX': 5.99,
    'M-SI1-VG-VG-STRONG-EX': 5.99,
    'M-SI1-GOOD-EX-STRONG-EX': 5.99,
    'M-SI1-EX-GOOD-STRONG-EX': 5.99,
    'M-I1-VG-EX-MEDIUM-EX': 5.99,
    'M-I1-EX-VG-MEDIUM-EX': 5.99,
    'D-VS1-GOOD-POOR-STRONG-GOOD': 5.98,
    'D-VS1-POOR-GOOD-STRONG-GOOD': 5.98,
    'D-VS1-EX-GOOD-STRONG-POOR': 5.98,
    'D-VS1-GOOD-EX-STRONG-POOR': 5.98,
    'D-VS1-VG-VG-STRONG-POOR': 5.98,
    'E-VS1-GOOD-EX-MEDIUM-POOR': 5.98,
    'E-VS1-GOOD-POOR-MEDIUM-GOOD': 5.98,
    'E-VVS1-EX-POOR-STRONG-POOR': 5.98,
    'E-VS1-POOR-GOOD-MEDIUM-GOOD': 5.98,
    'E-VVS1-GOOD-VG-STRONG-POOR': 5.98,
    'E-VVS1-POOR-EX-STRONG-POOR': 5.98,
    'E-VS1-VG-VG-MEDIUM-POOR': 5.98,
    'E-VS1-EX-GOOD-MEDIUM-POOR': 5.98,
    'E-VVS1-POOR-POOR-STRONG-GOOD': 5.98,
    'E-VVS1-VG-GOOD-STRONG-POOR': 5.98,
    'F-VVS1-EX-POOR-MEDIUM-POOR': 5.98,
    'F-VS1-EX-GOOD-FAINT-POOR': 5.98,
    'F-VS1-VG-VG-FAINT-POOR': 5.98,
    'F-VS1-GOOD-EX-FAINT-POOR': 5.98,
    'F-VS1-GOOD-POOR-FAINT-GOOD': 5.98,
    'F-VS1-POOR-GOOD-FAINT-GOOD': 5.98,
    'F-VVS1-VG-GOOD-MEDIUM-POOR': 5.98,
    'F-VVS1-GOOD-VG-MEDIUM-POOR': 5.98,
    'F-VVS1-POOR-EX-MEDIUM-POOR': 5.98,
    'F-VVS1-POOR-POOR-MEDIUM-GOOD': 5.98,
    'G-VVS1-POOR-POOR-FAINT-GOOD': 5.98,
    'G-VS1-POOR-GOOD-NONE-GOOD': 5.98,
    'G-VS1-GOOD-POOR-NONE-GOOD': 5.98,
    'G-VVS1-POOR-EX-FAINT-POOR': 5.98,
    'G-VVS1-GOOD-VG-FAINT-POOR': 5.98,
    'G-VVS1-VG-GOOD-FAINT-POOR': 5.98,
    'G-VS1-VG-VG-NONE-POOR': 5.98,
    'G-VVS1-EX-POOR-FAINT-POOR': 5.98,
    'G-VS1-GOOD-EX-NONE-POOR': 5.98,
    'G-VS1-EX-GOOD-NONE-POOR': 5.98,
    'H-VVS1-GOOD-VG-NONE-POOR': 5.98,
    'H-VVS1-POOR-POOR-NONE-GOOD': 5.98,
    'H-VVS1-POOR-EX-NONE-POOR': 5.98,
    'H-VVS1-VG-GOOD-NONE-POOR': 5.98,
    'H-VVS1-EX-POOR-NONE-POOR': 5.98,
    'I-VS1-VG-EX-STRONG-GOOD': 5.98,
    'I-VS1-VG-POOR-STRONG-VG': 5.98,
    'I-VS1-EX-VG-STRONG-GOOD': 5.98,
    'I-VS1-GOOD-GOOD-STRONG-VG': 5.98,
    'I-VS1-POOR-VG-STRONG-VG': 5.98,
    'J-VS1-VG-EX-MEDIUM-GOOD': 5.98,
    'J-VVS1-POOR-GOOD-STRONG-VG': 5.98,
    'J-VS1-EX-VG-MEDIUM-GOOD': 5.98,
    'J-VVS1-GOOD-POOR-STRONG-VG': 5.98,
    'J-VVS1-VG-VG-STRONG-GOOD': 5.98,
    'J-VS1-VG-POOR-MEDIUM-VG': 5.98,
    'J-VS1-POOR-VG-MEDIUM-VG': 5.98,
    'J-VS1-GOOD-GOOD-MEDIUM-VG': 5.98,
    'J-VVS1-EX-GOOD-STRONG-GOOD': 5.98,
    'J-VVS1-GOOD-EX-STRONG-GOOD': 5.98,
    'K-VS1-POOR-VG-FAINT-VG': 5.98,
    'K-VS1-GOOD-GOOD-FAINT-VG': 5.98,
    'K-VS1-EX-VG-FAINT-GOOD': 5.98,
    'K-VS1-VG-EX-FAINT-GOOD': 5.98,
    'K-VS1-VG-POOR-FAINT-VG': 5.98,
    'K-VVS1-POOR-GOOD-MEDIUM-VG': 5.98,
    'K-VVS1-GOOD-POOR-MEDIUM-VG': 5.98,
    'K-VVS1-EX-GOOD-MEDIUM-GOOD': 5.98,
    'K-VVS1-VG-VG-MEDIUM-GOOD': 5.98,
    'K-VVS1-GOOD-EX-MEDIUM-GOOD': 5.98,
    'L-VVS1-GOOD-EX-FAINT-GOOD': 5.98,
    'L-VVS1-POOR-GOOD-FAINT-VG': 5.98,
    'L-VS1-EX-VG-NONE-GOOD': 5.98,
    'L-VS1-VG-EX-NONE-GOOD': 5.98,
    'L-VVS1-VG-VG-FAINT-GOOD': 5.98,
    'L-VS1-VG-POOR-NONE-VG': 5.98,
    'L-VS1-GOOD-GOOD-NONE-VG': 5.98,
    'L-VVS1-EX-GOOD-FAINT-GOOD': 5.98,
    'L-VS1-POOR-VG-NONE-VG': 5.98,
    'L-VVS1-GOOD-POOR-FAINT-VG': 5.98,
    'M-VVS1-EX-GOOD-NONE-GOOD': 5.98,
    'M-VVS1-GOOD-EX-NONE-GOOD': 5.98,
    'M-VVS1-VG-VG-NONE-GOOD': 5.98,
    'M-VVS1-GOOD-POOR-NONE-VG': 5.98,
    'M-VVS1-POOR-GOOD-NONE-VG': 5.98,
    'D-I2-GOOD-VG-NONE-GOOD': 5.97,
    'D-SI2-EX-VG-FAINT-POOR': 5.97,
    'D-I2-POOR-POOR-NONE-VG': 5.97,
    'D-I2-POOR-EX-NONE-GOOD': 5.97,
    'D-SI2-VG-EX-FAINT-POOR': 5.97,
    'D-SI2-POOR-VG-FAINT-GOOD': 5.97,
    'D-I2-EX-EX-NONE-POOR': 5.97,
    'D-I2-EX-POOR-NONE-GOOD': 5.97,
    'D-I2-VG-GOOD-NONE-GOOD': 5.97,
    'D-SI2-VG-POOR-FAINT-GOOD': 5.97,
    'D-SI2-GOOD-GOOD-FAINT-GOOD': 5.97,
    'E-SI2-EX-VG-NONE-POOR': 5.97,
    'E-SI2-VG-EX-NONE-POOR': 5.97,
    'E-SI2-VG-POOR-NONE-GOOD': 5.97,
    'E-SI2-GOOD-GOOD-NONE-GOOD': 5.97,
    'E-SI2-POOR-VG-NONE-GOOD': 5.97,
    'F-I2-EX-GOOD-STRONG-VG': 5.97,
    'F-I2-POOR-GOOD-STRONG-EX': 5.97,
    'F-I2-GOOD-POOR-STRONG-EX': 5.97,
    'F-I2-VG-VG-STRONG-VG': 5.97,
    'F-I2-GOOD-EX-STRONG-VG': 5.97,
    'G-I2-GOOD-EX-MEDIUM-VG': 5.97,
    'G-SI2-VG-GOOD-STRONG-VG': 5.97,
    'G-SI2-POOR-EX-STRONG-VG': 5.97,
    'G-I2-VG-VG-MEDIUM-VG': 5.97,
    'G-I2-EX-GOOD-MEDIUM-VG': 5.97,
    'G-SI2-GOOD-VG-STRONG-VG': 5.97,
    'G-SI2-EX-POOR-STRONG-VG': 5.97,
    'G-SI2-POOR-POOR-STRONG-EX': 5.97,
    'G-SI2-EX-EX-STRONG-GOOD': 5.97,
    'G-I2-POOR-GOOD-MEDIUM-EX': 5.97,
    'G-I2-GOOD-POOR-MEDIUM-EX': 5.97,
    'H-I2-EX-GOOD-FAINT-VG': 5.97,
    'H-I2-VG-VG-FAINT-VG': 5.97,
    'H-I2-GOOD-EX-FAINT-VG': 5.97,
    'H-I2-GOOD-POOR-FAINT-EX': 5.97,
    'H-I2-POOR-GOOD-FAINT-EX': 5.97,
    'H-SI2-POOR-POOR-MEDIUM-EX': 5.97,
    'H-SI2-EX-POOR-MEDIUM-VG': 5.97,
    'H-SI2-EX-EX-MEDIUM-GOOD': 5.97,
    'H-SI2-POOR-EX-MEDIUM-VG': 5.97,
    'H-SI2-GOOD-VG-MEDIUM-VG': 5.97,
    'H-SI2-VG-GOOD-MEDIUM-VG': 5.97,
    'I-I2-GOOD-EX-NONE-VG': 5.97,
    'I-SI2-EX-EX-FAINT-GOOD': 5.97,
    'I-SI2-GOOD-VG-FAINT-VG': 5.97,
    'I-I2-GOOD-POOR-NONE-EX': 5.97,
    'I-SI2-EX-POOR-FAINT-VG': 5.97,
    'I-SI2-VG-GOOD-FAINT-VG': 5.97,
    'I-I2-POOR-GOOD-NONE-EX': 5.97,
    'I-SI2-POOR-POOR-FAINT-EX': 5.97,
    'I-SI2-POOR-EX-FAINT-VG': 5.97,
    'I-I2-EX-GOOD-NONE-VG': 5.97,
    'I-I2-VG-VG-NONE-VG': 5.97,
    'J-SI2-EX-EX-NONE-GOOD': 5.97,
    'J-SI2-GOOD-VG-NONE-VG': 5.97,
    'J-SI2-VG-GOOD-NONE-VG': 5.97,
    'J-SI2-EX-POOR-NONE-VG': 5.97,
    'J-SI2-POOR-EX-NONE-VG': 5.97,
    'J-SI2-POOR-POOR-NONE-EX': 5.97,
    'K-I2-VG-EX-STRONG-EX': 5.97,
    'K-I2-EX-VG-STRONG-EX': 5.97,
    'L-SI2-EX-GOOD-STRONG-EX': 5.97,
    'L-I2-VG-EX-MEDIUM-EX': 5.97,
    'L-SI2-VG-VG-STRONG-EX': 5.97,
    'L-SI2-GOOD-EX-STRONG-EX': 5.97,
    'L-I2-EX-VG-MEDIUM-EX': 5.97,
    'M-SI2-GOOD-EX-MEDIUM-EX': 5.97,
    'M-I2-VG-EX-FAINT-EX': 5.97,
    'M-I2-EX-VG-FAINT-EX': 5.97,
    'M-SI2-VG-VG-MEDIUM-EX': 5.97,
    'M-SI2-EX-GOOD-MEDIUM-EX': 5.97,
    'D-VS2-GOOD-POOR-MEDIUM-GOOD': 5.96,
    'D-VS2-POOR-GOOD-MEDIUM-GOOD': 5.96,
    'D-VVS2-POOR-EX-STRONG-POOR': 5.96,
    'D-VS2-VG-VG-MEDIUM-POOR': 5.96,
    'D-VS2-GOOD-EX-MEDIUM-POOR': 5.96,
    'D-VS2-EX-GOOD-MEDIUM-POOR': 5.96,
    'D-VVS2-POOR-POOR-STRONG-GOOD': 5.96,
    'D-VVS2-EX-POOR-STRONG-POOR': 5.96,
    'D-VVS2-VG-GOOD-STRONG-POOR': 5.96,
    'D-VVS2-GOOD-VG-STRONG-POOR': 5.96,
    'E-VVS2-POOR-POOR-MEDIUM-GOOD': 5.96,
    'E-VS2-POOR-GOOD-FAINT-GOOD': 5.96,
    'E-VVS2-EX-POOR-MEDIUM-POOR': 5.96,
    'E-VS2-GOOD-POOR-FAINT-GOOD': 5.96,
    'E-VVS2-VG-GOOD-MEDIUM-POOR': 5.96,
    'E-VS2-EX-GOOD-FAINT-POOR': 5.96,
    'E-VS2-GOOD-EX-FAINT-POOR': 5.96,
    'E-VS2-VG-VG-FAINT-POOR': 5.96,
    'E-VVS2-POOR-EX-MEDIUM-POOR': 5.96,
    'E-VVS2-GOOD-VG-MEDIUM-POOR': 5.96,
    'F-VVS2-EX-POOR-FAINT-POOR': 5.96,
    'F-VS2-GOOD-POOR-NONE-GOOD': 5.96,
    'F-VVS2-POOR-EX-FAINT-POOR': 5.96,
    'F-VS2-POOR-GOOD-NONE-GOOD': 5.96,
    'F-VVS2-GOOD-VG-FAINT-POOR': 5.96,
    'F-VVS2-POOR-POOR-FAINT-GOOD': 5.96,
    'F-VVS2-VG-GOOD-FAINT-POOR': 5.96,
    'F-VS2-EX-GOOD-NONE-POOR': 5.96,
    'F-VS2-GOOD-EX-NONE-POOR': 5.96,
    'F-VS2-VG-VG-NONE-POOR': 5.96,
    'G-VVS2-EX-POOR-NONE-POOR': 5.96,
    'G-VVS2-POOR-POOR-NONE-GOOD': 5.96,
    'G-VVS2-VG-GOOD-NONE-POOR': 5.96,
    'G-VVS2-POOR-EX-NONE-POOR': 5.96,
    'G-VVS2-GOOD-VG-NONE-POOR': 5.96,
    'H-VS2-EX-VG-STRONG-GOOD': 5.96,
    'H-VS2-VG-POOR-STRONG-VG': 5.96,
    'H-VS2-GOOD-GOOD-STRONG-VG': 5.96,
    'H-VS2-VG-EX-STRONG-GOOD': 5.96,
    'H-VS2-POOR-VG-STRONG-VG': 5.96,
    'I-VVS2-POOR-GOOD-STRONG-VG': 5.96,
    'I-VS2-VG-POOR-MEDIUM-VG': 5.96,
    'I-VS2-GOOD-GOOD-MEDIUM-VG': 5.96,
    'I-VS2-VG-EX-MEDIUM-GOOD': 5.96,
    'I-VS2-POOR-VG-MEDIUM-VG': 5.96,
    'I-VVS2-VG-VG-STRONG-GOOD': 5.96,
    'I-VVS2-EX-GOOD-STRONG-GOOD': 5.96,
    'I-VS2-EX-VG-MEDIUM-GOOD': 5.96,
    'I-VVS2-GOOD-POOR-STRONG-VG': 5.96,
    'I-VVS2-GOOD-EX-STRONG-GOOD': 5.96,
    'J-VVS2-GOOD-POOR-MEDIUM-VG': 5.96,
    'J-VVS2-POOR-GOOD-MEDIUM-VG': 5.96,
    'J-VS2-POOR-VG-FAINT-VG': 5.96,
    'J-VS2-VG-POOR-FAINT-VG': 5.96,
    'J-VS2-VG-EX-FAINT-GOOD': 5.96,
    'J-VS2-EX-VG-FAINT-GOOD': 5.96,
    'J-VVS2-GOOD-EX-MEDIUM-GOOD': 5.96,
    'J-VVS2-EX-GOOD-MEDIUM-GOOD': 5.96,
    'J-VS2-GOOD-GOOD-FAINT-VG': 5.96,
    'J-VVS2-VG-VG-MEDIUM-GOOD': 5.96,
    'K-VS2-VG-POOR-NONE-VG': 5.96,
    'K-VS2-GOOD-GOOD-NONE-VG': 5.96,
    'K-VVS2-GOOD-EX-FAINT-GOOD': 5.96,
    'K-VVS2-POOR-GOOD-FAINT-VG': 5.96,
    'K-VVS2-GOOD-POOR-FAINT-VG': 5.96,
    'K-VS2-EX-VG-NONE-GOOD': 5.96,
    'K-VS2-POOR-VG-NONE-VG': 5.96,
    'K-VVS2-EX-GOOD-FAINT-GOOD': 5.96,
    'K-VS2-VG-EX-NONE-GOOD': 5.96,
    'K-VVS2-VG-VG-FAINT-GOOD': 5.96,
    'L-VVS2-POOR-GOOD-NONE-VG': 5.96,
    'L-VVS2-GOOD-EX-NONE-GOOD': 5.96,
    'L-VVS2-GOOD-POOR-NONE-VG': 5.96,
    'L-VVS2-VG-VG-NONE-GOOD': 5.96,
    'L-VVS2-EX-GOOD-NONE-GOOD': 5.96,
    'M-VS2-EX-POOR-STRONG-EX': 5.96,
    'M-VS2-POOR-EX-STRONG-EX': 5.96,
    'M-VS2-VG-GOOD-STRONG-EX': 5.96,
    'M-VS2-GOOD-VG-STRONG-EX': 5.96,
    'M-VS2-EX-EX-STRONG-VG': 5.96,
    'E-IF-VG-POOR-STRONG-POOR': 5.95,
    'E-IF-POOR-VG-STRONG-POOR': 5.95,
    'E-IF-GOOD-GOOD-STRONG-POOR': 5.95,
    'F-IF-POOR-VG-MEDIUM-POOR': 5.95,
    'F-IF-VG-POOR-MEDIUM-POOR': 5.95,
    'F-IF-GOOD-GOOD-MEDIUM-POOR': 5.95,
    'G-IF-VG-POOR-FAINT-POOR': 5.95,
    'G-IF-GOOD-GOOD-FAINT-POOR': 5.95,
    'G-IF-POOR-VG-FAINT-POOR': 5.95,
    'H-IF-VG-POOR-NONE-POOR': 5.95,
    'H-IF-GOOD-GOOD-NONE-POOR': 5.95,
    'H-IF-POOR-VG-NONE-POOR': 5.95,
    'J-IF-POOR-EX-STRONG-GOOD': 5.95,
    'J-IF-EX-EX-STRONG-POOR': 5.95,
    'J-IF-POOR-POOR-STRONG-VG': 5.95,
    'J-IF-GOOD-VG-STRONG-GOOD': 5.95,
    'J-IF-EX-POOR-STRONG-GOOD': 5.95,
    'J-IF-VG-GOOD-STRONG-GOOD': 5.95,
    'K-IF-GOOD-VG-MEDIUM-GOOD': 5.95,
    'K-IF-EX-POOR-MEDIUM-GOOD': 5.95,
    'K-IF-VG-GOOD-MEDIUM-GOOD': 5.95,
    'K-IF-POOR-EX-MEDIUM-GOOD': 5.95,
    'K-IF-POOR-POOR-MEDIUM-VG': 5.95,
    'K-IF-EX-EX-MEDIUM-POOR': 5.95,
    'L-IF-EX-POOR-FAINT-GOOD': 5.95,
    'L-IF-GOOD-VG-FAINT-GOOD': 5.95,
    'L-IF-EX-EX-FAINT-POOR': 5.95,
    'L-IF-POOR-POOR-FAINT-VG': 5.95,
    'L-IF-POOR-EX-FAINT-GOOD': 5.95,
    'L-IF-VG-GOOD-FAINT-GOOD': 5.95,
    'M-IF-EX-EX-NONE-POOR': 5.95,
    'M-IF-EX-POOR-NONE-GOOD': 5.95,
    'M-IF-GOOD-VG-NONE-GOOD': 5.95,
    'M-IF-POOR-EX-NONE-GOOD': 5.95,
    'M-IF-VG-GOOD-NONE-GOOD': 5.95,
    'M-IF-POOR-POOR-NONE-VG': 5.95,
    'D-SI1-POOR-GOOD-FAINT-GOOD': 5.94,
    'D-SI1-EX-GOOD-FAINT-POOR': 5.94,
    'D-SI1-GOOD-POOR-FAINT-GOOD': 5.94,
    'D-SI1-GOOD-EX-FAINT-POOR': 5.94,
    'D-SI1-VG-VG-FAINT-POOR': 5.94,
    'D-I1-GOOD-GOOD-NONE-GOOD': 5.94,
    'D-I1-EX-VG-NONE-POOR': 5.94,
    'D-I1-VG-POOR-NONE-GOOD': 5.94,
    'D-I1-POOR-VG-NONE-GOOD': 5.94,
    'D-I1-VG-EX-NONE-POOR': 5.94,
    'E-SI1-POOR-GOOD-NONE-GOOD': 5.94,
    'E-SI1-EX-GOOD-NONE-POOR': 5.94,
    'E-SI1-VG-VG-NONE-POOR': 5.94,
    'E-SI1-GOOD-POOR-NONE-GOOD': 5.94,
    'E-SI1-GOOD-EX-NONE-POOR': 5.94,
    'F-I1-EX-POOR-STRONG-VG': 5.94,
    'F-I1-POOR-EX-STRONG-VG': 5.94,
    'F-I1-GOOD-VG-STRONG-VG': 5.94,
    'F-I1-VG-GOOD-STRONG-VG': 5.94,
    'F-I1-EX-EX-STRONG-GOOD': 5.94,
    'F-I1-POOR-POOR-STRONG-EX': 5.94,
    'G-I1-EX-EX-MEDIUM-GOOD': 5.94,
    'G-I1-POOR-EX-MEDIUM-VG': 5.94,
    'G-I1-POOR-POOR-MEDIUM-EX': 5.94,
    'G-I1-EX-POOR-MEDIUM-VG': 5.94,
    'G-I1-GOOD-VG-MEDIUM-VG': 5.94,
    'G-I1-VG-GOOD-MEDIUM-VG': 5.94,
    'G-SI1-VG-POOR-STRONG-VG': 5.94,
    'G-SI1-GOOD-GOOD-STRONG-VG': 5.94,
    'G-SI1-POOR-VG-STRONG-VG': 5.94,
    'G-SI1-EX-VG-STRONG-GOOD': 5.94,
    'G-SI1-VG-EX-STRONG-GOOD': 5.94,
    'H-SI1-EX-VG-MEDIUM-GOOD': 5.94,
    'H-I1-EX-EX-FAINT-GOOD': 5.94,
    'H-SI1-VG-POOR-MEDIUM-VG': 5.94,
    'H-SI1-GOOD-GOOD-MEDIUM-VG': 5.94,
    'H-SI1-POOR-VG-MEDIUM-VG': 5.94,
    'H-I1-GOOD-VG-FAINT-VG': 5.94,
    'H-I1-EX-POOR-FAINT-VG': 5.94,
    'H-I1-VG-GOOD-FAINT-VG': 5.94,
    'H-I1-POOR-EX-FAINT-VG': 5.94,
    'H-SI1-VG-EX-MEDIUM-GOOD': 5.94,
    'H-I1-POOR-POOR-FAINT-EX': 5.94,
    'I-SI1-EX-VG-FAINT-GOOD': 5.94,
    'I-I1-EX-POOR-NONE-VG': 5.94,
    'I-SI1-POOR-VG-FAINT-VG': 5.94,
    'I-I1-POOR-EX-NONE-VG': 5.94,
    'I-I1-GOOD-VG-NONE-VG': 5.94,
    'I-I1-EX-EX-NONE-GOOD': 5.94,
    'I-SI1-VG-EX-FAINT-GOOD': 5.94,
    'I-SI1-VG-POOR-FAINT-VG': 5.94,
    'I-I1-VG-GOOD-NONE-VG': 5.94,
    'I-SI1-GOOD-GOOD-FAINT-VG': 5.94,
    'I-I1-POOR-POOR-NONE-EX': 5.94,
    'J-SI1-EX-VG-NONE-GOOD': 5.94,
    'J-SI1-VG-EX-NONE-GOOD': 5.94,
    'J-SI1-GOOD-GOOD-NONE-VG': 5.94,
    'J-SI1-POOR-VG-NONE-VG': 5.94,
    'J-SI1-VG-POOR-NONE-VG': 5.94,
    'K-I1-EX-GOOD-STRONG-EX': 5.94,
    'K-I1-VG-VG-STRONG-EX': 5.94,
    'K-I1-GOOD-EX-STRONG-EX': 5.94,
    'L-I1-VG-VG-MEDIUM-EX': 5.94,
    'L-I1-EX-GOOD-MEDIUM-EX': 5.94,
    'L-I1-GOOD-EX-MEDIUM-EX': 5.94,
    'L-SI1-EX-EX-STRONG-VG': 5.94,
    'L-SI1-VG-GOOD-STRONG-EX': 5.94,
    'L-SI1-POOR-EX-STRONG-EX': 5.94,
    'L-SI1-EX-POOR-STRONG-EX': 5.94,
    'L-SI1-GOOD-VG-STRONG-EX': 5.94,
    'M-I1-VG-VG-FAINT-EX': 5.94,
    'M-SI1-EX-EX-MEDIUM-VG': 5.94,
    'M-SI1-EX-POOR-MEDIUM-EX': 5.94,
    'M-I1-GOOD-EX-FAINT-EX': 5.94,
    'M-I1-EX-GOOD-FAINT-EX': 5.94,
    'M-SI1-GOOD-VG-MEDIUM-EX': 5.94,
    'M-SI1-POOR-EX-MEDIUM-EX': 5.94,
    'M-SI1-VG-GOOD-MEDIUM-EX': 5.94,
    'D-VS1-EX-POOR-MEDIUM-POOR': 5.93,
    'D-VVS1-GOOD-GOOD-STRONG-POOR': 5.93,
    'D-VS1-VG-GOOD-MEDIUM-POOR': 5.93,
    'D-VVS1-VG-POOR-STRONG-POOR': 5.93,
    'D-VS1-POOR-EX-MEDIUM-POOR': 5.93,
    'D-VVS1-POOR-VG-STRONG-POOR': 5.93,
    'D-VS1-POOR-POOR-MEDIUM-GOOD': 5.93,
    'D-VS1-GOOD-VG-MEDIUM-POOR': 5.93,
    'E-VVS1-GOOD-GOOD-MEDIUM-POOR': 5.93,
    'E-VVS1-POOR-VG-MEDIUM-POOR': 5.93,
    'E-VVS1-VG-POOR-MEDIUM-POOR': 5.93,
    'E-VS1-GOOD-VG-FAINT-POOR': 5.93,
    'E-VS1-EX-POOR-FAINT-POOR': 5.93,
    'E-VS1-VG-GOOD-FAINT-POOR': 5.93,
    'E-VS1-POOR-POOR-FAINT-GOOD': 5.93,
    'E-VS1-POOR-EX-FAINT-POOR': 5.93,
    'F-VVS1-POOR-VG-FAINT-POOR': 5.93,
    'F-VVS1-GOOD-GOOD-FAINT-POOR': 5.93,
    'F-VS1-GOOD-VG-NONE-POOR': 5.93,
    'F-VVS1-VG-POOR-FAINT-POOR': 5.93,
    'F-VS1-POOR-POOR-NONE-GOOD': 5.93,
    'F-VS1-EX-POOR-NONE-POOR': 5.93,
    'F-VS1-VG-GOOD-NONE-POOR': 5.93,
    'F-VS1-POOR-EX-NONE-POOR': 5.93,
    'G-VVS1-VG-POOR-NONE-POOR': 5.93,
    'G-VVS1-GOOD-GOOD-NONE-POOR': 5.93,
    'G-VVS1-POOR-VG-NONE-POOR': 5.93,
    'H-VS1-EX-GOOD-STRONG-GOOD': 5.93,
    'H-VS1-POOR-GOOD-STRONG-VG': 5.93,
    'H-VS1-GOOD-POOR-STRONG-VG': 5.93,
    'H-VS1-VG-VG-STRONG-GOOD': 5.93,
    'H-VS1-GOOD-EX-STRONG-GOOD': 5.93,
    'I-VVS1-POOR-EX-STRONG-GOOD': 5.93,
    'I-VVS1-POOR-POOR-STRONG-VG': 5.93,
    'I-VVS1-VG-GOOD-STRONG-GOOD': 5.93,
    'I-VS1-VG-VG-MEDIUM-GOOD': 5.93,
    'I-VVS1-EX-POOR-STRONG-GOOD': 5.93,
    'I-VS1-GOOD-EX-MEDIUM-GOOD': 5.93,
    'I-VS1-GOOD-POOR-MEDIUM-VG': 5.93,
    'I-VVS1-EX-EX-STRONG-POOR': 5.93,
    'I-VS1-POOR-GOOD-MEDIUM-VG': 5.93,
    'I-VS1-EX-GOOD-MEDIUM-GOOD': 5.93,
    'I-VVS1-GOOD-VG-STRONG-GOOD': 5.93,
    'J-VS1-GOOD-EX-FAINT-GOOD': 5.93,
    'J-VVS1-EX-POOR-MEDIUM-GOOD': 5.93,
    'J-VVS1-GOOD-VG-MEDIUM-GOOD': 5.93,
    'J-VVS1-POOR-POOR-MEDIUM-VG': 5.93,
    'J-VVS1-POOR-EX-MEDIUM-GOOD': 5.93,
    'J-VS1-GOOD-POOR-FAINT-VG': 5.93,
    'J-VVS1-VG-GOOD-MEDIUM-GOOD': 5.93,
    'J-VS1-POOR-GOOD-FAINT-VG': 5.93,
    'J-VS1-EX-GOOD-FAINT-GOOD': 5.93,
    'J-VVS1-EX-EX-MEDIUM-POOR': 5.93,
    'J-VS1-VG-VG-FAINT-GOOD': 5.93,
    'K-VS1-GOOD-POOR-NONE-VG': 5.93,
    'K-VS1-POOR-GOOD-NONE-VG': 5.93,
    'K-VS1-GOOD-EX-NONE-GOOD': 5.93,
    'K-VVS1-POOR-EX-FAINT-GOOD': 5.93,
    'K-VVS1-GOOD-VG-FAINT-GOOD': 5.93,
    'K-VVS1-VG-GOOD-FAINT-GOOD': 5.93,
    'K-VVS1-EX-POOR-FAINT-GOOD': 5.93,
    'K-VVS1-POOR-POOR-FAINT-VG': 5.93,
    'K-VVS1-EX-EX-FAINT-POOR': 5.93,
    'K-VS1-EX-GOOD-NONE-GOOD': 5.93,
    'K-VS1-VG-VG-NONE-GOOD': 5.93,
    'L-VVS1-POOR-POOR-NONE-VG': 5.93,
    'L-VVS1-VG-GOOD-NONE-GOOD': 5.93,
    'L-VVS1-GOOD-VG-NONE-GOOD': 5.93,
    'L-VVS1-POOR-EX-NONE-GOOD': 5.93,
    'L-VVS1-EX-EX-NONE-POOR': 5.93,
    'L-VVS1-EX-POOR-NONE-GOOD': 5.93,
    'M-VS1-POOR-VG-STRONG-EX': 5.93,
    'M-VS1-GOOD-GOOD-STRONG-EX': 5.93,
    'M-VS1-EX-VG-STRONG-VG': 5.93,
    'M-VS1-VG-POOR-STRONG-EX': 5.93,
    'M-VS1-VG-EX-STRONG-VG': 5.93,
    'D-SI2-EX-GOOD-NONE-POOR': 5.92,
    'D-SI2-VG-VG-NONE-POOR': 5.92,
    'D-SI2-GOOD-EX-NONE-POOR': 5.92,
    'D-SI2-GOOD-POOR-NONE-GOOD': 5.92,
    'D-SI2-POOR-GOOD-NONE-GOOD': 5.92,
    'E-I2-GOOD-VG-STRONG-VG': 5.92,
    'E-I2-POOR-POOR-STRONG-EX': 5.92,
    'E-I2-POOR-EX-STRONG-VG': 5.92,
    'E-I2-EX-POOR-STRONG-VG': 5.92,
    'E-I2-EX-EX-STRONG-GOOD': 5.92,
    'E-I2-VG-GOOD-STRONG-VG': 5.92,
    'F-SI2-VG-POOR-STRONG-VG': 5.92,
    'F-I2-EX-EX-MEDIUM-GOOD': 5.92,
    'F-I2-EX-POOR-MEDIUM-VG': 5.92,
    'F-SI2-GOOD-GOOD-STRONG-VG': 5.92,
    'F-I2-POOR-EX-MEDIUM-VG': 5.92,
    'F-I2-GOOD-VG-MEDIUM-VG': 5.92,
    'F-SI2-POOR-VG-STRONG-VG': 5.92,
    'F-I2-POOR-POOR-MEDIUM-EX': 5.92,
    'F-I2-VG-GOOD-MEDIUM-VG': 5.92,
    'F-SI2-VG-EX-STRONG-GOOD': 5.92,
    'F-SI2-EX-VG-STRONG-GOOD': 5.92,
    'G-SI2-VG-EX-MEDIUM-GOOD': 5.92,
    'G-I2-EX-POOR-FAINT-VG': 5.92,
    'G-I2-POOR-POOR-FAINT-EX': 5.92,
    'G-SI2-GOOD-GOOD-MEDIUM-VG': 5.92,
    'G-SI2-EX-VG-MEDIUM-GOOD': 5.92,
    'G-I2-POOR-EX-FAINT-VG': 5.92,
    'G-I2-VG-GOOD-FAINT-VG': 5.92,
    'G-I2-GOOD-VG-FAINT-VG': 5.92,
    'G-SI2-VG-POOR-MEDIUM-VG': 5.92,
    'G-I2-EX-EX-FAINT-GOOD': 5.92,
    'G-SI2-POOR-VG-MEDIUM-VG': 5.92,
    'H-I2-POOR-POOR-NONE-EX': 5.92,
    'H-I2-EX-POOR-NONE-VG': 5.92,
    'H-I2-EX-EX-NONE-GOOD': 5.92,
    'H-SI2-EX-VG-FAINT-GOOD': 5.92,
    'H-SI2-VG-EX-FAINT-GOOD': 5.92,
    'H-SI2-VG-POOR-FAINT-VG': 5.92,
    'H-SI2-GOOD-GOOD-FAINT-VG': 5.92,
    'H-SI2-POOR-VG-FAINT-VG': 5.92,
    'H-I2-VG-GOOD-NONE-VG': 5.92,
    'H-I2-POOR-EX-NONE-VG': 5.92,
    'H-I2-GOOD-VG-NONE-VG': 5.92,
    'I-SI2-EX-VG-NONE-GOOD': 5.92,
    'I-SI2-VG-EX-NONE-GOOD': 5.92,
    'I-SI2-VG-POOR-NONE-VG': 5.92,
    'I-SI2-POOR-VG-NONE-VG': 5.92,
    'I-SI2-GOOD-GOOD-NONE-VG': 5.92,
    'J-I2-VG-VG-STRONG-EX': 5.92,
    'J-I2-EX-GOOD-STRONG-EX': 5.92,
    'J-I2-GOOD-EX-STRONG-EX': 5.92,
    'K-I2-EX-GOOD-MEDIUM-EX': 5.92,
    'K-SI2-EX-EX-STRONG-VG': 5.92,
    'K-I2-VG-VG-MEDIUM-EX': 5.92,
    'K-I2-GOOD-EX-MEDIUM-EX': 5.92,
    'K-SI2-GOOD-VG-STRONG-EX': 5.92,
    'K-SI2-POOR-EX-STRONG-EX': 5.92,
    'K-SI2-VG-GOOD-STRONG-EX': 5.92,
    'K-SI2-EX-POOR-STRONG-EX': 5.92,
    'L-SI2-EX-POOR-MEDIUM-EX': 5.92,
    'L-SI2-POOR-EX-MEDIUM-EX': 5.92,
    'L-SI2-GOOD-VG-MEDIUM-EX': 5.92,
    'L-I2-GOOD-EX-FAINT-EX': 5.92,
    'L-I2-VG-VG-FAINT-EX': 5.92,
    'L-I2-EX-GOOD-FAINT-EX': 5.92,
    'L-SI2-EX-EX-MEDIUM-VG': 5.92,
    'L-SI2-VG-GOOD-MEDIUM-EX': 5.92,
    'M-SI2-EX-EX-FAINT-VG': 5.92,
    'M-SI2-POOR-EX-FAINT-EX': 5.92,
    'M-I2-GOOD-EX-NONE-EX': 5.92,
    'M-SI2-EX-POOR-FAINT-EX': 5.92,
    'M-SI2-VG-GOOD-FAINT-EX': 5.92,
    'M-I2-VG-VG-NONE-EX': 5.92,
    'M-SI2-GOOD-VG-FAINT-EX': 5.92,
    'M-I2-EX-GOOD-NONE-EX': 5.92,
    'D-VS2-VG-GOOD-FAINT-POOR': 5.91,
    'D-VS2-EX-POOR-FAINT-POOR': 5.91,
    'D-VVS2-POOR-VG-MEDIUM-POOR': 5.91,
    'D-VVS2-GOOD-GOOD-MEDIUM-POOR': 5.91,
    'D-VS2-POOR-EX-FAINT-POOR': 5.91,
    'D-VVS2-VG-POOR-MEDIUM-POOR': 5.91,
    'D-VS2-POOR-POOR-FAINT-GOOD': 5.91,
    'D-VS2-GOOD-VG-FAINT-POOR': 5.91,
    'E-VS2-EX-POOR-NONE-POOR': 5.91,
    'E-VS2-GOOD-VG-NONE-POOR': 5.91,
    'E-VS2-POOR-POOR-NONE-GOOD': 5.91,
    'E-VVS2-GOOD-GOOD-FAINT-POOR': 5.91,
    'E-VVS2-POOR-VG-FAINT-POOR': 5.91,
    'E-VS2-POOR-EX-NONE-POOR': 5.91,
    'E-VS2-VG-GOOD-NONE-POOR': 5.91,
    'E-VVS2-VG-POOR-FAINT-POOR': 5.91,
    'F-VVS2-GOOD-GOOD-NONE-POOR': 5.91,
    'F-VVS2-POOR-VG-NONE-POOR': 5.91,
    'F-VVS2-VG-POOR-NONE-POOR': 5.91,
    'G-VS2-VG-VG-STRONG-GOOD': 5.91,
    'G-VS2-POOR-GOOD-STRONG-VG': 5.91,
    'G-VS2-EX-GOOD-STRONG-GOOD': 5.91,
    'G-VS2-GOOD-EX-STRONG-GOOD': 5.91,
    'G-VS2-GOOD-POOR-STRONG-VG': 5.91,
    'H-VS2-POOR-GOOD-MEDIUM-VG': 5.91,
    'H-VS2-GOOD-EX-MEDIUM-GOOD': 5.91,
    'H-VS2-VG-VG-MEDIUM-GOOD': 5.91,
    'H-VS2-EX-GOOD-MEDIUM-GOOD': 5.91,
    'H-VS2-GOOD-POOR-MEDIUM-VG': 5.91,
    'H-VVS2-POOR-EX-STRONG-GOOD': 5.91,
    'H-VVS2-VG-GOOD-STRONG-GOOD': 5.91,
    'H-VVS2-POOR-POOR-STRONG-VG': 5.91,
    'H-VVS2-GOOD-VG-STRONG-GOOD': 5.91,
    'H-VVS2-EX-POOR-STRONG-GOOD': 5.91,
    'H-VVS2-EX-EX-STRONG-POOR': 5.91,
    'I-VS2-VG-VG-FAINT-GOOD': 5.91,
    'I-VVS2-EX-POOR-MEDIUM-GOOD': 5.91,
    'I-VS2-GOOD-EX-FAINT-GOOD': 5.91,
    'I-VVS2-EX-EX-MEDIUM-POOR': 5.91,
    'I-VVS2-POOR-POOR-MEDIUM-VG': 5.91,
    'I-VVS2-POOR-EX-MEDIUM-GOOD': 5.91,
    'I-VS2-EX-GOOD-FAINT-GOOD': 5.91,
    'I-VVS2-GOOD-VG-MEDIUM-GOOD': 5.91,
    'I-VVS2-VG-GOOD-MEDIUM-GOOD': 5.91,
    'I-VS2-GOOD-POOR-FAINT-VG': 5.91,
    'I-VS2-POOR-GOOD-FAINT-VG': 5.91,
    'J-VVS2-POOR-POOR-FAINT-VG': 5.91,
    'J-VVS2-EX-POOR-FAINT-GOOD': 5.91,
    'J-VVS2-VG-GOOD-FAINT-GOOD': 5.91,
    'J-VVS2-POOR-EX-FAINT-GOOD': 5.91,
    'J-VVS2-GOOD-VG-FAINT-GOOD': 5.91,
    'J-VVS2-EX-EX-FAINT-POOR': 5.91,
    'J-VS2-GOOD-POOR-NONE-VG': 5.91,
    'J-VS2-EX-GOOD-NONE-GOOD': 5.91,
    'J-VS2-VG-VG-NONE-GOOD': 5.91,
    'J-VS2-POOR-GOOD-NONE-VG': 5.91,
    'J-VS2-GOOD-EX-NONE-GOOD': 5.91,
    'K-VVS2-POOR-POOR-NONE-VG': 5.91,
    'K-VVS2-POOR-EX-NONE-GOOD': 5.91,
    'K-VVS2-EX-POOR-NONE-GOOD': 5.91,
    'K-VVS2-GOOD-VG-NONE-GOOD': 5.91,
    'K-VVS2-VG-GOOD-NONE-GOOD': 5.91,
    'K-VVS2-EX-EX-NONE-POOR': 5.91,
    'L-VS2-EX-VG-STRONG-VG': 5.91,
    'L-VS2-VG-POOR-STRONG-EX': 5.91,
    'L-VS2-GOOD-GOOD-STRONG-EX': 5.91,
    'L-VS2-POOR-VG-STRONG-EX': 5.91,
    'L-VS2-VG-EX-STRONG-VG': 5.91,
    'M-VVS2-VG-VG-STRONG-VG': 5.91,
    'M-VVS2-EX-GOOD-STRONG-VG': 5.91,
    'M-VVS2-GOOD-EX-STRONG-VG': 5.91,
    'M-VVS2-POOR-GOOD-STRONG-EX': 5.91,
    'M-VS2-VG-EX-MEDIUM-VG': 5.91,
    'M-VS2-VG-POOR-MEDIUM-EX': 5.91,
    'M-VS2-EX-VG-MEDIUM-VG': 5.91,
    'M-VS2-GOOD-GOOD-MEDIUM-EX': 5.91,
    'M-VVS2-GOOD-POOR-STRONG-EX': 5.91,
    'M-VS2-POOR-VG-MEDIUM-EX': 5.91,
    'D-IF-GOOD-POOR-STRONG-POOR': 5.9,
    'D-IF-POOR-GOOD-STRONG-POOR': 5.9,
    'E-IF-POOR-GOOD-MEDIUM-POOR': 5.9,
    'E-IF-GOOD-POOR-MEDIUM-POOR': 5.9,
    'F-IF-GOOD-POOR-FAINT-POOR': 5.9,
    'F-IF-POOR-GOOD-FAINT-POOR': 5.9,
    'G-IF-GOOD-POOR-NONE-POOR': 5.9,
    'G-IF-POOR-GOOD-NONE-POOR': 5.9,
    'I-IF-VG-POOR-STRONG-GOOD': 5.9,
    'I-IF-POOR-VG-STRONG-GOOD': 5.9,
    'I-IF-GOOD-GOOD-STRONG-GOOD': 5.9,
    'I-IF-VG-EX-STRONG-POOR': 5.9,
    'I-IF-EX-VG-STRONG-POOR': 5.9,
    'J-IF-POOR-VG-MEDIUM-GOOD': 5.9,
    'J-IF-GOOD-GOOD-MEDIUM-GOOD': 5.9,
    'J-IF-VG-POOR-MEDIUM-GOOD': 5.9,
    'J-IF-VG-EX-MEDIUM-POOR': 5.9,
    'J-IF-EX-VG-MEDIUM-POOR': 5.9,
    'K-IF-VG-EX-FAINT-POOR': 5.9,
    'K-IF-VG-POOR-FAINT-GOOD': 5.9,
    'K-IF-POOR-VG-FAINT-GOOD': 5.9,
    'K-IF-GOOD-GOOD-FAINT-GOOD': 5.9,
    'K-IF-EX-VG-FAINT-POOR': 5.9,
    'L-IF-EX-VG-NONE-POOR': 5.9,
    'L-IF-VG-EX-NONE-POOR': 5.9,
    'L-IF-VG-POOR-NONE-GOOD': 5.9,
    'L-IF-POOR-VG-NONE-GOOD': 5.9,
    'L-IF-GOOD-GOOD-NONE-GOOD': 5.9,
    'D-SI1-VG-GOOD-NONE-POOR': 5.89,
    'D-SI1-GOOD-VG-NONE-POOR': 5.89,
    'D-SI1-POOR-POOR-NONE-GOOD': 5.89,
    'D-SI1-EX-POOR-NONE-POOR': 5.89,
    'D-SI1-POOR-EX-NONE-POOR': 5.89,
    'E-I1-VG-EX-STRONG-GOOD': 5.89,
    'E-I1-EX-VG-STRONG-GOOD': 5.89,
    'E-I1-VG-POOR-STRONG-VG': 5.89,
    'E-I1-POOR-VG-STRONG-VG': 5.89,
    'E-I1-GOOD-GOOD-STRONG-VG': 5.89,
    'F-I1-EX-VG-MEDIUM-GOOD': 5.89,
    'F-SI1-GOOD-POOR-STRONG-VG': 5.89,
    'F-I1-POOR-VG-MEDIUM-VG': 5.89,
    'F-I1-VG-EX-MEDIUM-GOOD': 5.89,
    'F-SI1-EX-GOOD-STRONG-GOOD': 5.89,
    'F-I1-GOOD-GOOD-MEDIUM-VG': 5.89,
    'F-I1-VG-POOR-MEDIUM-VG': 5.89,
    'F-SI1-GOOD-EX-STRONG-GOOD': 5.89,
    'F-SI1-POOR-GOOD-STRONG-VG': 5.89,
    'F-SI1-VG-VG-STRONG-GOOD': 5.89,
    'G-I1-EX-VG-FAINT-GOOD': 5.89,
    'G-SI1-EX-GOOD-MEDIUM-GOOD': 5.89,
    'G-SI1-VG-VG-MEDIUM-GOOD': 5.89,
    'G-SI1-POOR-GOOD-MEDIUM-VG': 5.89,
    'G-I1-VG-POOR-FAINT-VG': 5.89,
    'G-I1-GOOD-GOOD-FAINT-VG': 5.89,
    'G-SI1-GOOD-POOR-MEDIUM-VG': 5.89,
    'G-I1-VG-EX-FAINT-GOOD': 5.89,
    'G-I1-POOR-VG-FAINT-VG': 5.89,
    'G-SI1-GOOD-EX-MEDIUM-GOOD': 5.89,
    'H-SI1-EX-GOOD-FAINT-GOOD': 5.89,
    'H-SI1-POOR-GOOD-FAINT-VG': 5.89,
    'H-SI1-VG-VG-FAINT-GOOD': 5.89,
    'H-SI1-GOOD-POOR-FAINT-VG': 5.89,
    'H-I1-POOR-VG-NONE-VG': 5.89,
    'H-SI1-GOOD-EX-FAINT-GOOD': 5.89,
    'H-I1-VG-POOR-NONE-VG': 5.89,
    'H-I1-VG-EX-NONE-GOOD': 5.89,
    'H-I1-EX-VG-NONE-GOOD': 5.89,
    'H-I1-GOOD-GOOD-NONE-VG': 5.89,
    'I-SI1-EX-GOOD-NONE-GOOD': 5.89,
    'I-SI1-GOOD-POOR-NONE-VG': 5.89,
    'I-SI1-POOR-GOOD-NONE-VG': 5.89,
    'I-SI1-VG-VG-NONE-GOOD': 5.89,
    'I-SI1-GOOD-EX-NONE-GOOD': 5.89,
    'J-I1-POOR-EX-STRONG-EX': 5.89,
    'J-I1-GOOD-VG-STRONG-EX': 5.89,
    'J-I1-EX-POOR-STRONG-EX': 5.89,
    'J-I1-EX-EX-STRONG-VG': 5.89,
    'J-I1-VG-GOOD-STRONG-EX': 5.89,
    'K-I1-EX-POOR-MEDIUM-EX': 5.89,
    'K-I1-POOR-EX-MEDIUM-EX': 5.89,
    'K-SI1-GOOD-GOOD-STRONG-EX': 5.89,
    'K-SI1-VG-EX-STRONG-VG': 5.89,
    'K-SI1-POOR-VG-STRONG-EX': 5.89,
    'K-I1-VG-GOOD-MEDIUM-EX': 5.89,
    'K-SI1-VG-POOR-STRONG-EX': 5.89,
    'K-I1-GOOD-VG-MEDIUM-EX': 5.89,
    'K-I1-EX-EX-MEDIUM-VG': 5.89,
    'K-SI1-EX-VG-STRONG-VG': 5.89,
    'L-I1-VG-GOOD-FAINT-EX': 5.89,
    'L-I1-EX-POOR-FAINT-EX': 5.89,
    'L-SI1-VG-EX-MEDIUM-VG': 5.89,
    'L-I1-GOOD-VG-FAINT-EX': 5.89,
    'L-SI1-EX-VG-MEDIUM-VG': 5.89,
    'L-SI1-POOR-VG-MEDIUM-EX': 5.89,
    'L-I1-EX-EX-FAINT-VG': 5.89,
    'L-I1-POOR-EX-FAINT-EX': 5.89,
    'L-SI1-GOOD-GOOD-MEDIUM-EX': 5.89,
    'L-SI1-VG-POOR-MEDIUM-EX': 5.89,
    'M-SI1-POOR-VG-FAINT-EX': 5.89,
    'M-I1-VG-GOOD-NONE-EX': 5.89,
    'M-I1-EX-POOR-NONE-EX': 5.89,
    'M-I1-EX-EX-NONE-VG': 5.89,
    'M-I1-POOR-EX-NONE-EX': 5.89,
    'M-SI1-EX-VG-FAINT-VG': 5.89,
    'M-SI1-VG-EX-FAINT-VG': 5.89,
    'M-I1-GOOD-VG-NONE-EX': 5.89,
    'M-SI1-VG-POOR-FAINT-EX': 5.89,
    'M-SI1-GOOD-GOOD-FAINT-EX': 5.89,
    'D-VS1-GOOD-GOOD-FAINT-POOR': 5.88,
    'D-VVS1-POOR-GOOD-MEDIUM-POOR': 5.88,
    'D-VVS1-GOOD-POOR-MEDIUM-POOR': 5.88,
    'D-VS1-POOR-VG-FAINT-POOR': 5.88,
    'D-VS1-VG-POOR-FAINT-POOR': 5.88,
    'E-VVS1-GOOD-POOR-FAINT-POOR': 5.88,
    'E-VS1-VG-POOR-NONE-POOR': 5.88,
    'E-VVS1-POOR-GOOD-FAINT-POOR': 5.88,
    'E-VS1-GOOD-GOOD-NONE-POOR': 5.88,
    'E-VS1-POOR-VG-NONE-POOR': 5.88,
    'F-VVS1-POOR-GOOD-NONE-POOR': 5.88,
    'F-VVS1-GOOD-POOR-NONE-POOR': 5.88,
    'G-VS1-GOOD-VG-STRONG-GOOD': 5.88,
    'G-VS1-POOR-POOR-STRONG-VG': 5.88,
    'G-VS1-POOR-EX-STRONG-GOOD': 5.88,
    'G-VS1-VG-GOOD-STRONG-GOOD': 5.88,
    'G-VS1-EX-POOR-STRONG-GOOD': 5.88,
    'G-VS1-EX-EX-STRONG-POOR': 5.88,
    'H-VVS1-EX-VG-STRONG-POOR': 5.88,
    'H-VVS1-GOOD-GOOD-STRONG-GOOD': 5.88,
    'H-VS1-POOR-EX-MEDIUM-GOOD': 5.88,
    'H-VVS1-VG-EX-STRONG-POOR': 5.88,
    'H-VVS1-POOR-VG-STRONG-GOOD': 5.88,
    'H-VVS1-VG-POOR-STRONG-GOOD': 5.88,
    'H-VS1-POOR-POOR-MEDIUM-VG': 5.88,
    'H-VS1-VG-GOOD-MEDIUM-GOOD': 5.88,
    'H-VS1-EX-POOR-MEDIUM-GOOD': 5.88,
    'H-VS1-EX-EX-MEDIUM-POOR': 5.88,
    'H-VS1-GOOD-VG-MEDIUM-GOOD': 5.88,
    'I-VS1-VG-GOOD-FAINT-GOOD': 5.88,
    'I-VS1-GOOD-VG-FAINT-GOOD': 5.88,
    'I-VVS1-GOOD-GOOD-MEDIUM-GOOD': 5.88,
    'I-VVS1-POOR-VG-MEDIUM-GOOD': 5.88,
    'I-VS1-EX-POOR-FAINT-GOOD': 5.88,
    'I-VVS1-VG-POOR-MEDIUM-GOOD': 5.88,
    'I-VVS1-EX-VG-MEDIUM-POOR': 5.88,
    'I-VS1-POOR-EX-FAINT-GOOD': 5.88,
    'I-VVS1-VG-EX-MEDIUM-POOR': 5.88,
    'I-VS1-POOR-POOR-FAINT-VG': 5.88,
    'I-VS1-EX-EX-FAINT-POOR': 5.88,
    'J-VVS1-EX-VG-FAINT-POOR': 5.88,
    'J-VS1-POOR-POOR-NONE-VG': 5.88,
    'J-VS1-POOR-EX-NONE-GOOD': 5.88,
    'J-VS1-GOOD-VG-NONE-GOOD': 5.88,
    'J-VVS1-VG-EX-FAINT-POOR': 5.88,
    'J-VS1-EX-EX-NONE-POOR': 5.88,
    'J-VVS1-VG-POOR-FAINT-GOOD': 5.88,
    'J-VS1-EX-POOR-NONE-GOOD': 5.88,
    'J-VVS1-POOR-VG-FAINT-GOOD': 5.88,
    'J-VS1-VG-GOOD-NONE-GOOD': 5.88,
    'J-VVS1-GOOD-GOOD-FAINT-GOOD': 5.88,
    'K-VVS1-EX-VG-NONE-POOR': 5.88,
    'K-VVS1-VG-EX-NONE-POOR': 5.88,
    'K-VVS1-VG-POOR-NONE-GOOD': 5.88,
    'K-VVS1-GOOD-GOOD-NONE-GOOD': 5.88,
    'K-VVS1-POOR-VG-NONE-GOOD': 5.88,
    'L-VS1-EX-GOOD-STRONG-VG': 5.88,
    'L-VS1-POOR-GOOD-STRONG-EX': 5.88,
    'L-VS1-VG-VG-STRONG-VG': 5.88,
    'L-VS1-GOOD-POOR-STRONG-EX': 5.88,
    'L-VS1-GOOD-EX-STRONG-VG': 5.88,
    'M-VVS1-GOOD-VG-STRONG-VG': 5.88,
    'M-VS1-EX-GOOD-MEDIUM-VG': 5.88,
    'M-VVS1-EX-POOR-STRONG-VG': 5.88,
    'M-VVS1-EX-EX-STRONG-GOOD': 5.88,
    'M-VS1-GOOD-POOR-MEDIUM-EX': 5.88,
    'M-VVS1-POOR-POOR-STRONG-EX': 5.88,
    'M-VS1-GOOD-EX-MEDIUM-VG': 5.88,
    'M-VS1-VG-VG-MEDIUM-VG': 5.88,
    'M-VS1-POOR-GOOD-MEDIUM-EX': 5.88,
    'M-VVS1-POOR-EX-STRONG-VG': 5.88,
    'M-VVS1-VG-GOOD-STRONG-VG': 5.88,
    'D-I2-GOOD-GOOD-STRONG-VG': 5.87,
    'D-I2-POOR-VG-STRONG-VG': 5.87,
    'D-I2-VG-EX-STRONG-GOOD': 5.87,
    'D-I2-VG-POOR-STRONG-VG': 5.87,
    'D-I2-EX-VG-STRONG-GOOD': 5.87,
    'E-I2-GOOD-GOOD-MEDIUM-VG': 5.87,
    'E-SI2-POOR-GOOD-STRONG-VG': 5.87,
    'E-SI2-GOOD-EX-STRONG-GOOD': 5.87,
    'E-I2-VG-POOR-MEDIUM-VG': 5.87,
    'E-SI2-VG-VG-STRONG-GOOD': 5.87,
    'E-I2-EX-VG-MEDIUM-GOOD': 5.87,
    'E-SI2-GOOD-POOR-STRONG-VG': 5.87,
    'E-I2-POOR-VG-MEDIUM-VG': 5.87,
    'E-SI2-EX-GOOD-STRONG-GOOD': 5.87,
    'E-I2-VG-EX-MEDIUM-GOOD': 5.87,
    'F-SI2-POOR-GOOD-MEDIUM-VG': 5.87,
    'F-I2-EX-VG-FAINT-GOOD': 5.87,
    'F-SI2-EX-GOOD-MEDIUM-GOOD': 5.87,
    'F-I2-VG-EX-FAINT-GOOD': 5.87,
    'F-I2-VG-POOR-FAINT-VG': 5.87,
    'F-SI2-GOOD-EX-MEDIUM-GOOD': 5.87,
    'F-SI2-VG-VG-MEDIUM-GOOD': 5.87,
    'F-I2-GOOD-GOOD-FAINT-VG': 5.87,
    'F-I2-POOR-VG-FAINT-VG': 5.87,
    'F-SI2-GOOD-POOR-MEDIUM-VG': 5.87,
    'G-I2-POOR-VG-NONE-VG': 5.87,
    'G-SI2-GOOD-EX-FAINT-GOOD': 5.87,
    'G-SI2-POOR-GOOD-FAINT-VG': 5.87,
    'G-SI2-GOOD-POOR-FAINT-VG': 5.87,
    'G-SI2-VG-VG-FAINT-GOOD': 5.87,
    'G-I2-VG-EX-NONE-GOOD': 5.87,
    'G-I2-GOOD-GOOD-NONE-VG': 5.87,
    'G-SI2-EX-GOOD-FAINT-GOOD': 5.87,
    'G-I2-VG-POOR-NONE-VG': 5.87,
    'G-I2-EX-VG-NONE-GOOD': 5.87,
    'H-SI2-EX-GOOD-NONE-GOOD': 5.87,
    'H-SI2-VG-VG-NONE-GOOD': 5.87,
    'H-SI2-GOOD-POOR-NONE-VG': 5.87,
    'H-SI2-GOOD-EX-NONE-GOOD': 5.87,
    'H-SI2-POOR-GOOD-NONE-VG': 5.87,
    'I-I2-EX-EX-STRONG-VG': 5.87,
    'I-I2-EX-POOR-STRONG-EX': 5.87,
    'I-I2-GOOD-VG-STRONG-EX': 5.87,
    'I-I2-VG-GOOD-STRONG-EX': 5.87,
    'I-I2-POOR-EX-STRONG-EX': 5.87,
    'J-I2-VG-GOOD-MEDIUM-EX': 5.87,
    'J-I2-EX-POOR-MEDIUM-EX': 5.87,
    'J-SI2-POOR-VG-STRONG-EX': 5.87,
    'J-SI2-VG-POOR-STRONG-EX': 5.87,
    'J-SI2-GOOD-GOOD-STRONG-EX': 5.87,
    'J-SI2-EX-VG-STRONG-VG': 5.87,
    'J-SI2-VG-EX-STRONG-VG': 5.87,
    'J-I2-GOOD-VG-MEDIUM-EX': 5.87,
    'J-I2-EX-EX-MEDIUM-VG': 5.87,
    'J-I2-POOR-EX-MEDIUM-EX': 5.87,
    'K-I2-GOOD-VG-FAINT-EX': 5.87,
    'K-SI2-EX-VG-MEDIUM-VG': 5.87,
    'K-I2-POOR-EX-FAINT-EX': 5.87,
    'K-SI2-VG-EX-MEDIUM-VG': 5.87,
    'K-I2-VG-GOOD-FAINT-EX': 5.87,
    'K-SI2-GOOD-GOOD-MEDIUM-EX': 5.87,
    'K-I2-EX-POOR-FAINT-EX': 5.87,
    'K-SI2-VG-POOR-MEDIUM-EX': 5.87,
    'K-SI2-POOR-VG-MEDIUM-EX': 5.87,
    'K-I2-EX-EX-FAINT-VG': 5.87,
    'L-I2-POOR-EX-NONE-EX': 5.87,
    'L-I2-EX-EX-NONE-VG': 5.87,
    'L-SI2-POOR-VG-FAINT-EX': 5.87,
    'L-I2-VG-GOOD-NONE-EX': 5.87,
    'L-SI2-VG-POOR-FAINT-EX': 5.87,
    'L-SI2-EX-VG-FAINT-VG': 5.87,
    'L-I2-GOOD-VG-NONE-EX': 5.87,
    'L-SI2-VG-EX-FAINT-VG': 5.87,
    'L-SI2-GOOD-GOOD-FAINT-EX': 5.87,
    'L-I2-EX-POOR-NONE-EX': 5.87,
    'M-SI2-EX-VG-NONE-VG': 5.87,
    'M-SI2-POOR-VG-NONE-EX': 5.87,
    'M-SI2-VG-EX-NONE-VG': 5.87,
    'M-SI2-GOOD-GOOD-NONE-EX': 5.87,
    'M-SI2-VG-POOR-NONE-EX': 5.87,
    'D-VVS2-POOR-GOOD-FAINT-POOR': 5.86,
    'D-VS2-VG-POOR-NONE-POOR': 5.86,
    'D-VVS2-GOOD-POOR-FAINT-POOR': 5.86,
    'D-VS2-GOOD-GOOD-NONE-POOR': 5.86,
    'D-VS2-POOR-VG-NONE-POOR': 5.86,
    'E-VVS2-GOOD-POOR-NONE-POOR': 5.86,
    'E-VVS2-POOR-GOOD-NONE-POOR': 5.86,
    'F-VS2-POOR-POOR-STRONG-VG': 5.86,
    'F-VS2-EX-EX-STRONG-POOR': 5.86,
    'F-VS2-VG-GOOD-STRONG-GOOD': 5.86,
    'F-VS2-GOOD-VG-STRONG-GOOD': 5.86,
    'F-VS2-EX-POOR-STRONG-GOOD': 5.86,
    'F-VS2-POOR-EX-STRONG-GOOD': 5.86,
    'G-VVS2-VG-POOR-STRONG-GOOD': 5.86,
    'G-VVS2-VG-EX-STRONG-POOR': 5.86,
    'G-VS2-POOR-EX-MEDIUM-GOOD': 5.86,
    'G-VS2-GOOD-VG-MEDIUM-GOOD': 5.86,
    'G-VS2-EX-EX-MEDIUM-POOR': 5.86,
    'G-VS2-POOR-POOR-MEDIUM-VG': 5.86,
    'G-VS2-EX-POOR-MEDIUM-GOOD': 5.86,
    'G-VVS2-POOR-VG-STRONG-GOOD': 5.86,
    'G-VS2-VG-GOOD-MEDIUM-GOOD': 5.86,
    'G-VVS2-EX-VG-STRONG-POOR': 5.86,
    'G-VVS2-GOOD-GOOD-STRONG-GOOD': 5.86,
    'H-VVS2-GOOD-GOOD-MEDIUM-GOOD': 5.86,
    'H-VVS2-POOR-VG-MEDIUM-GOOD': 5.86,
    'H-VS2-POOR-POOR-FAINT-VG': 5.86,
    'H-VS2-POOR-EX-FAINT-GOOD': 5.86,
    'H-VVS2-VG-POOR-MEDIUM-GOOD': 5.86,
    'H-VVS2-EX-VG-MEDIUM-POOR': 5.86,
    'H-VVS2-VG-EX-MEDIUM-POOR': 5.86,
    'H-VS2-EX-EX-FAINT-POOR': 5.86,
    'H-VS2-GOOD-VG-FAINT-GOOD': 5.86,
    'H-VS2-VG-GOOD-FAINT-GOOD': 5.86,
    'H-VS2-EX-POOR-FAINT-GOOD': 5.86,
    'I-VVS2-VG-POOR-FAINT-GOOD': 5.86,
    'I-VVS2-POOR-VG-FAINT-GOOD': 5.86,
    'I-VVS2-GOOD-GOOD-FAINT-GOOD': 5.86,
    'I-VVS2-EX-VG-FAINT-POOR': 5.86,
    'I-VVS2-VG-EX-FAINT-POOR': 5.86,
    'I-VS2-EX-EX-NONE-POOR': 5.86,
    'I-VS2-GOOD-VG-NONE-GOOD': 5.86,
    'I-VS2-VG-GOOD-NONE-GOOD': 5.86,
    'I-VS2-POOR-POOR-NONE-VG': 5.86,
    'I-VS2-POOR-EX-NONE-GOOD': 5.86,
    'I-VS2-EX-POOR-NONE-GOOD': 5.86,
    'J-VVS2-VG-POOR-NONE-GOOD': 5.86,
    'J-VVS2-VG-EX-NONE-POOR': 5.86,
    'J-VVS2-EX-VG-NONE-POOR': 5.86,
    'J-VVS2-POOR-VG-NONE-GOOD': 5.86,
    'J-VVS2-GOOD-GOOD-NONE-GOOD': 5.86,
    'K-VS2-GOOD-EX-STRONG-VG': 5.86,
    'K-VS2-POOR-GOOD-STRONG-EX': 5.86,
    'K-VS2-GOOD-POOR-STRONG-EX': 5.86,
    'K-VS2-EX-GOOD-STRONG-VG': 5.86,
    'K-VS2-VG-VG-STRONG-VG': 5.86,
    'L-VS2-GOOD-EX-MEDIUM-VG': 5.86,
    'L-VS2-EX-GOOD-MEDIUM-VG': 5.86,
    'L-VVS2-POOR-POOR-STRONG-EX': 5.86,
    'L-VS2-VG-VG-MEDIUM-VG': 5.86,
    'L-VS2-POOR-GOOD-MEDIUM-EX': 5.86,
    'L-VS2-GOOD-POOR-MEDIUM-EX': 5.86,
    'L-VVS2-EX-EX-STRONG-GOOD': 5.86,
    'L-VVS2-GOOD-VG-STRONG-VG': 5.86,
    'L-VVS2-POOR-EX-STRONG-VG': 5.86,
    'L-VVS2-EX-POOR-STRONG-VG': 5.86,
    'L-VVS2-VG-GOOD-STRONG-VG': 5.86,
    'M-VVS2-EX-EX-MEDIUM-GOOD': 5.86,
    'M-VVS2-VG-GOOD-MEDIUM-VG': 5.86,
    'M-VS2-POOR-GOOD-FAINT-EX': 5.86,
    'M-VVS2-GOOD-VG-MEDIUM-VG': 5.86,
    'M-VS2-EX-GOOD-FAINT-VG': 5.86,
    'M-VS2-VG-VG-FAINT-VG': 5.86,
    'M-VVS2-POOR-EX-MEDIUM-VG': 5.86,
    'M-VS2-GOOD-POOR-FAINT-EX': 5.86,
    'M-VS2-GOOD-EX-FAINT-VG': 5.86,
    'M-VVS2-POOR-POOR-MEDIUM-EX': 5.86,
    'M-VVS2-EX-POOR-MEDIUM-VG': 5.86,
    'D-IF-POOR-POOR-MEDIUM-POOR': 5.85,
    'E-IF-POOR-POOR-FAINT-POOR': 5.85,
    'F-IF-POOR-POOR-NONE-POOR': 5.85,
    'H-IF-POOR-GOOD-STRONG-GOOD': 5.85,
    'H-IF-GOOD-POOR-STRONG-GOOD': 5.85,
    'H-IF-VG-VG-STRONG-POOR': 5.85,
    'H-IF-EX-GOOD-STRONG-POOR': 5.85,
    'H-IF-GOOD-EX-STRONG-POOR': 5.85,
    'I-IF-VG-VG-MEDIUM-POOR': 5.85,
    'I-IF-POOR-GOOD-MEDIUM-GOOD': 5.85,
    'I-IF-EX-GOOD-MEDIUM-POOR': 5.85,
    'I-IF-GOOD-POOR-MEDIUM-GOOD': 5.85,
    'I-IF-GOOD-EX-MEDIUM-POOR': 5.85,
    'J-IF-EX-GOOD-FAINT-POOR': 5.85,
    'J-IF-VG-VG-FAINT-POOR': 5.85,
    'J-IF-POOR-GOOD-FAINT-GOOD': 5.85,
    'J-IF-GOOD-POOR-FAINT-GOOD': 5.85,
    'J-IF-GOOD-EX-FAINT-POOR': 5.85,
    'K-IF-GOOD-EX-NONE-POOR': 5.85,
    'K-IF-GOOD-POOR-NONE-GOOD': 5.85,
    'K-IF-POOR-GOOD-NONE-GOOD': 5.85,
    'K-IF-EX-GOOD-NONE-POOR': 5.85,
    'K-IF-VG-VG-NONE-POOR': 5.85,
    'M-IF-EX-VG-STRONG-GOOD': 5.85,
    'M-IF-VG-POOR-STRONG-VG': 5.85,
    'M-IF-POOR-VG-STRONG-VG': 5.85,
    'M-IF-VG-EX-STRONG-GOOD': 5.85,
    'M-IF-GOOD-GOOD-STRONG-VG': 5.85,
    'D-I1-GOOD-EX-STRONG-GOOD': 5.84,
    'D-I1-POOR-GOOD-STRONG-VG': 5.84,
    'D-I1-GOOD-POOR-STRONG-VG': 5.84,
    'D-I1-VG-VG-STRONG-GOOD': 5.84,
    'D-I1-EX-GOOD-STRONG-GOOD': 5.84,
    'E-SI1-VG-GOOD-STRONG-GOOD': 5.84,
    'E-I1-EX-GOOD-MEDIUM-GOOD': 5.84,
    'E-SI1-POOR-POOR-STRONG-VG': 5.84,
    'E-I1-GOOD-POOR-MEDIUM-VG': 5.84,
    'E-SI1-EX-EX-STRONG-POOR': 5.84,
    'E-I1-POOR-GOOD-MEDIUM-VG': 5.84,
    'E-SI1-POOR-EX-STRONG-GOOD': 5.84,
    'E-I1-VG-VG-MEDIUM-GOOD': 5.84,
    'E-I1-GOOD-EX-MEDIUM-GOOD': 5.84,
    'E-SI1-GOOD-VG-STRONG-GOOD': 5.84,
    'E-SI1-EX-POOR-STRONG-GOOD': 5.84,
    'F-I1-GOOD-POOR-FAINT-VG': 5.84,
    'F-I1-GOOD-EX-FAINT-GOOD': 5.84,
    'F-I1-VG-VG-FAINT-GOOD': 5.84,
    'F-I1-EX-GOOD-FAINT-GOOD': 5.84,
    'F-I1-POOR-GOOD-FAINT-VG': 5.84,
    'F-SI1-EX-EX-MEDIUM-POOR': 5.84,
    'F-SI1-POOR-EX-MEDIUM-GOOD': 5.84,
    'F-SI1-POOR-POOR-MEDIUM-VG': 5.84,
    'F-SI1-GOOD-VG-MEDIUM-GOOD': 5.84,
    'F-SI1-EX-POOR-MEDIUM-GOOD': 5.84,
    'F-SI1-VG-GOOD-MEDIUM-GOOD': 5.84,
    'G-SI1-EX-POOR-FAINT-GOOD': 5.84,
    'G-I1-POOR-GOOD-NONE-VG': 5.84,
    'G-I1-GOOD-EX-NONE-GOOD': 5.84,
    'G-SI1-EX-EX-FAINT-POOR': 5.84,
    'G-SI1-POOR-POOR-FAINT-VG': 5.84,
    'G-I1-EX-GOOD-NONE-GOOD': 5.84,
    'G-SI1-VG-GOOD-FAINT-GOOD': 5.84,
    'G-I1-VG-VG-NONE-GOOD': 5.84,
    'G-SI1-GOOD-VG-FAINT-GOOD': 5.84,
    'G-I1-GOOD-POOR-NONE-VG': 5.84,
    'G-SI1-POOR-EX-FAINT-GOOD': 5.84,
    'H-SI1-POOR-POOR-NONE-VG': 5.84,
    'H-SI1-POOR-EX-NONE-GOOD': 5.84,
    'H-SI1-GOOD-VG-NONE-GOOD': 5.84,
    'H-SI1-VG-GOOD-NONE-GOOD': 5.84,
    'H-SI1-EX-POOR-NONE-GOOD': 5.84,
    'H-SI1-EX-EX-NONE-POOR': 5.84,
    'I-I1-EX-VG-STRONG-VG': 5.84,
    'I-I1-VG-POOR-STRONG-EX': 5.84,
    'I-I1-GOOD-GOOD-STRONG-EX': 5.84,
    'I-I1-POOR-VG-STRONG-EX': 5.84,
    'I-I1-VG-EX-STRONG-VG': 5.84,
    'J-SI1-VG-VG-STRONG-VG': 5.84,
    'J-SI1-GOOD-POOR-STRONG-EX': 5.84,
    'J-SI1-POOR-GOOD-STRONG-EX': 5.84,
    'J-SI1-EX-GOOD-STRONG-VG': 5.84,
    'J-SI1-GOOD-EX-STRONG-VG': 5.84,
    'J-I1-GOOD-GOOD-MEDIUM-EX': 5.84,
    'J-I1-POOR-VG-MEDIUM-EX': 5.84,
    'J-I1-VG-POOR-MEDIUM-EX': 5.84,
    'J-I1-EX-VG-MEDIUM-VG': 5.84,
    'J-I1-VG-EX-MEDIUM-VG': 5.84,
    'K-SI1-VG-VG-MEDIUM-VG': 5.84,
    'K-SI1-EX-GOOD-MEDIUM-VG': 5.84,
    'K-SI1-GOOD-POOR-MEDIUM-EX': 5.84,
    'K-SI1-GOOD-EX-MEDIUM-VG': 5.84,
    'K-SI1-POOR-GOOD-MEDIUM-EX': 5.84,
    'K-I1-VG-EX-FAINT-VG': 5.84,
    'K-I1-POOR-VG-FAINT-EX': 5.84,
    'K-I1-EX-VG-FAINT-VG': 5.84,
    'K-I1-GOOD-GOOD-FAINT-EX': 5.84,
    'K-I1-VG-POOR-FAINT-EX': 5.84,
    'L-I1-VG-POOR-NONE-EX': 5.84,
    'L-I1-GOOD-GOOD-NONE-EX': 5.84,
    'L-I1-EX-VG-NONE-VG': 5.84,
    'L-SI1-GOOD-POOR-FAINT-EX': 5.84,
    'L-I1-VG-EX-NONE-VG': 5.84,
    'L-I1-POOR-VG-NONE-EX': 5.84,
    'L-SI1-GOOD-EX-FAINT-VG': 5.84,
    'L-SI1-EX-GOOD-FAINT-VG': 5.84,
    'L-SI1-VG-VG-FAINT-VG': 5.84,
    'L-SI1-POOR-GOOD-FAINT-EX': 5.84,
    'M-SI1-GOOD-EX-NONE-VG': 5.84,
    'M-SI1-POOR-GOOD-NONE-EX': 5.84,
    'M-SI1-VG-VG-NONE-VG': 5.84,
    'M-SI1-EX-GOOD-NONE-VG': 5.84,
    'M-SI1-GOOD-POOR-NONE-EX': 5.84,
    'D-VS1-GOOD-POOR-NONE-POOR': 5.83,
    'D-VS1-POOR-GOOD-NONE-POOR': 5.83,
    'D-VVS1-POOR-POOR-FAINT-POOR': 5.83,
    'E-VVS1-POOR-POOR-NONE-POOR': 5.83,
    'F-VS1-VG-POOR-STRONG-GOOD': 5.83,
    'F-VS1-GOOD-GOOD-STRONG-GOOD': 5.83,
    'F-VS1-POOR-VG-STRONG-GOOD': 5.83,
    'F-VS1-VG-EX-STRONG-POOR': 5.83,
    'F-VS1-EX-VG-STRONG-POOR': 5.83,
    'G-VVS1-EX-GOOD-STRONG-POOR': 5.83,
    'G-VS1-VG-EX-MEDIUM-POOR': 5.83,
    'G-VS1-POOR-VG-MEDIUM-GOOD': 5.83,
    'G-VS1-EX-VG-MEDIUM-POOR': 5.83,
    'G-VVS1-POOR-GOOD-STRONG-GOOD': 5.83,
    'G-VS1-GOOD-GOOD-MEDIUM-GOOD': 5.83,
    'G-VS1-VG-POOR-MEDIUM-GOOD': 5.83,
    'G-VVS1-GOOD-POOR-STRONG-GOOD': 5.83,
    'G-VVS1-GOOD-EX-STRONG-POOR': 5.83,
    'G-VVS1-VG-VG-STRONG-POOR': 5.83,
    'H-VS1-VG-POOR-FAINT-GOOD': 5.83,
    'H-VVS1-POOR-GOOD-MEDIUM-GOOD': 5.83,
    'H-VS1-GOOD-GOOD-FAINT-GOOD': 5.83,
    'H-VS1-POOR-VG-FAINT-GOOD': 5.83,
    'H-VVS1-VG-VG-MEDIUM-POOR': 5.83,
    'H-VVS1-EX-GOOD-MEDIUM-POOR': 5.83,
    'H-VVS1-GOOD-POOR-MEDIUM-GOOD': 5.83,
    'H-VS1-VG-EX-FAINT-POOR': 5.83,
    'H-VS1-EX-VG-FAINT-POOR': 5.83,
    'H-VVS1-GOOD-EX-MEDIUM-POOR': 5.83,
    'I-VVS1-GOOD-POOR-FAINT-GOOD': 5.83,
    'I-VS1-EX-VG-NONE-POOR': 5.83,
    'I-VVS1-VG-VG-FAINT-POOR': 5.83,
    'I-VVS1-EX-GOOD-FAINT-POOR': 5.83,
    'I-VVS1-POOR-GOOD-FAINT-GOOD': 5.83,
    'I-VVS1-GOOD-EX-FAINT-POOR': 5.83,
    'I-VS1-VG-EX-NONE-POOR': 5.83,
    'I-VS1-GOOD-GOOD-NONE-GOOD': 5.83,
    'I-VS1-POOR-VG-NONE-GOOD': 5.83,
    'I-VS1-VG-POOR-NONE-GOOD': 5.83,
    'J-VVS1-GOOD-EX-NONE-POOR': 5.83,
    'J-VVS1-POOR-GOOD-NONE-GOOD': 5.83,
    'J-VVS1-GOOD-POOR-NONE-GOOD': 5.83,
    'J-VVS1-EX-GOOD-NONE-POOR': 5.83,
    'J-VVS1-VG-VG-NONE-POOR': 5.83,
    'K-VS1-POOR-POOR-STRONG-EX': 5.83,
    'K-VS1-EX-EX-STRONG-GOOD': 5.83,
    'K-VS1-EX-POOR-STRONG-VG': 5.83,
    'K-VS1-VG-GOOD-STRONG-VG': 5.83,
    'K-VS1-POOR-EX-STRONG-VG': 5.83,
    'K-VS1-GOOD-VG-STRONG-VG': 5.83,
    'L-VVS1-GOOD-GOOD-STRONG-VG': 5.83,
    'L-VS1-VG-GOOD-MEDIUM-VG': 5.83,
    'L-VVS1-EX-VG-STRONG-GOOD': 5.83,
    'L-VVS1-POOR-VG-STRONG-VG': 5.83,
    'L-VS1-EX-POOR-MEDIUM-VG': 5.83,
    'L-VVS1-VG-POOR-STRONG-VG': 5.83,
    'L-VS1-EX-EX-MEDIUM-GOOD': 5.83,
    'L-VS1-POOR-POOR-MEDIUM-EX': 5.83,
    'L-VS1-POOR-EX-MEDIUM-VG': 5.83,
    'L-VVS1-VG-EX-STRONG-GOOD': 5.83,
    'L-VS1-GOOD-VG-MEDIUM-VG': 5.83,
    'M-VS1-POOR-EX-FAINT-VG': 5.83,
    'M-VVS1-VG-POOR-MEDIUM-VG': 5.83,
    'M-VVS1-EX-VG-MEDIUM-GOOD': 5.83,
    'M-VVS1-VG-EX-MEDIUM-GOOD': 5.83,
    'M-VS1-POOR-POOR-FAINT-EX': 5.83,
    'M-VS1-EX-POOR-FAINT-VG': 5.83,
    'M-VS1-GOOD-VG-FAINT-VG': 5.83,
    'M-VVS1-POOR-VG-MEDIUM-VG': 5.83,
    'M-VS1-EX-EX-FAINT-GOOD': 5.83,
    'M-VVS1-GOOD-GOOD-MEDIUM-VG': 5.83,
    'M-VS1-VG-GOOD-FAINT-VG': 5.83,
    'D-SI2-EX-POOR-STRONG-GOOD': 5.82,
    'D-I2-VG-VG-MEDIUM-GOOD': 5.82,
    'D-I2-POOR-GOOD-MEDIUM-VG': 5.82,
    'D-I2-EX-GOOD-MEDIUM-GOOD': 5.82,
    'D-SI2-GOOD-VG-STRONG-GOOD': 5.82,
    'D-I2-GOOD-POOR-MEDIUM-VG': 5.82,
    'D-I2-GOOD-EX-MEDIUM-GOOD': 5.82,
    'D-SI2-VG-GOOD-STRONG-GOOD': 5.82,
    'D-SI2-POOR-POOR-STRONG-VG': 5.82,
    'D-SI2-EX-EX-STRONG-POOR': 5.82,
    'D-SI2-POOR-EX-STRONG-GOOD': 5.82,
    'E-I2-EX-GOOD-FAINT-GOOD': 5.82,
    'E-SI2-GOOD-VG-MEDIUM-GOOD': 5.82,
    'E-SI2-POOR-EX-MEDIUM-GOOD': 5.82,
    'E-I2-POOR-GOOD-FAINT-VG': 5.82,
    'E-SI2-EX-EX-MEDIUM-POOR': 5.82,
    'E-SI2-EX-POOR-MEDIUM-GOOD': 5.82,
    'E-SI2-VG-GOOD-MEDIUM-GOOD': 5.82,
    'E-I2-GOOD-EX-FAINT-GOOD': 5.82,
    'E-I2-VG-VG-FAINT-GOOD': 5.82,
    'E-SI2-POOR-POOR-MEDIUM-VG': 5.82,
    'E-I2-GOOD-POOR-FAINT-VG': 5.82,
    'F-SI2-EX-POOR-FAINT-GOOD': 5.82,
    'F-I2-POOR-GOOD-NONE-VG': 5.82,
    'F-SI2-GOOD-VG-FAINT-GOOD': 5.82,
    'F-SI2-VG-GOOD-FAINT-GOOD': 5.82,
    'F-SI2-POOR-EX-FAINT-GOOD': 5.82,
    'F-I2-GOOD-EX-NONE-GOOD': 5.82,
    'F-I2-GOOD-POOR-NONE-VG': 5.82,
    'F-I2-EX-GOOD-NONE-GOOD': 5.82,
    'F-SI2-POOR-POOR-FAINT-VG': 5.82,
    'F-I2-VG-VG-NONE-GOOD': 5.82,
    'F-SI2-EX-EX-FAINT-POOR': 5.82,
    'G-SI2-EX-POOR-NONE-GOOD': 5.82,
    'G-SI2-EX-EX-NONE-POOR': 5.82,
    'G-SI2-POOR-POOR-NONE-VG': 5.82,
    'G-SI2-VG-GOOD-NONE-GOOD': 5.82,
    'G-SI2-POOR-EX-NONE-GOOD': 5.82,
    'G-SI2-GOOD-VG-NONE-GOOD': 5.82,
    'H-I2-POOR-VG-STRONG-EX': 5.82,
    'H-I2-VG-POOR-STRONG-EX': 5.82,
    'H-I2-VG-EX-STRONG-VG': 5.82,
    'H-I2-GOOD-GOOD-STRONG-EX': 5.82,
    'H-I2-EX-VG-STRONG-VG': 5.82,
    'I-SI2-GOOD-EX-STRONG-VG': 5.82,
    'I-I2-VG-POOR-MEDIUM-EX': 5.82,
    'I-I2-EX-VG-MEDIUM-VG': 5.82,
    'I-SI2-VG-VG-STRONG-VG': 5.82,
    'I-SI2-EX-GOOD-STRONG-VG': 5.82,
    'I-I2-VG-EX-MEDIUM-VG': 5.82,
    'I-I2-POOR-VG-MEDIUM-EX': 5.82,
    'I-I2-GOOD-GOOD-MEDIUM-EX': 5.82,
    'I-SI2-POOR-GOOD-STRONG-EX': 5.82,
    'I-SI2-GOOD-POOR-STRONG-EX': 5.82,
    'J-I2-GOOD-GOOD-FAINT-EX': 5.82,
    'J-I2-VG-POOR-FAINT-EX': 5.82,
    'J-SI2-POOR-GOOD-MEDIUM-EX': 5.82,
    'J-SI2-VG-VG-MEDIUM-VG': 5.82,
    'J-I2-VG-EX-FAINT-VG': 5.82,
    'J-SI2-EX-GOOD-MEDIUM-VG': 5.82,
    'J-SI2-GOOD-EX-MEDIUM-VG': 5.82,
    'J-SI2-GOOD-POOR-MEDIUM-EX': 5.82,
    'J-I2-POOR-VG-FAINT-EX': 5.82,
    'J-I2-EX-VG-FAINT-VG': 5.82,
    'K-I2-VG-EX-NONE-VG': 5.82,
    'K-SI2-POOR-GOOD-FAINT-EX': 5.82,
    'K-SI2-GOOD-POOR-FAINT-EX': 5.82,
    'K-SI2-GOOD-EX-FAINT-VG': 5.82,
    'K-I2-EX-VG-NONE-VG': 5.82,
    'K-I2-GOOD-GOOD-NONE-EX': 5.82,
    'K-I2-VG-POOR-NONE-EX': 5.82,
    'K-SI2-EX-GOOD-FAINT-VG': 5.82,
    'K-I2-POOR-VG-NONE-EX': 5.82,
    'K-SI2-VG-VG-FAINT-VG': 5.82,
    'L-SI2-GOOD-POOR-NONE-EX': 5.82,
    'L-SI2-GOOD-EX-NONE-VG': 5.82,
    'L-SI2-POOR-GOOD-NONE-EX': 5.82,
    'L-SI2-EX-GOOD-NONE-VG': 5.82,
    'L-SI2-VG-VG-NONE-VG': 5.82,
    'M-I2-EX-EX-STRONG-EX': 5.82,
    'D-VVS2-POOR-POOR-NONE-POOR': 5.81,
    'E-VS2-VG-EX-STRONG-POOR': 5.81,
    'E-VS2-GOOD-GOOD-STRONG-GOOD': 5.81,
    'E-VS2-POOR-VG-STRONG-GOOD': 5.81,
    'E-VS2-VG-POOR-STRONG-GOOD': 5.81,
    'E-VS2-EX-VG-STRONG-POOR': 5.81,
    'F-VVS2-GOOD-EX-STRONG-POOR': 5.81,
    'F-VVS2-EX-GOOD-STRONG-POOR': 5.81,
    'F-VS2-EX-VG-MEDIUM-POOR': 5.81,
    'F-VVS2-VG-VG-STRONG-POOR': 5.81,
    'F-VS2-VG-EX-MEDIUM-POOR': 5.81,
    'F-VS2-GOOD-GOOD-MEDIUM-GOOD': 5.81,
    'F-VS2-POOR-VG-MEDIUM-GOOD': 5.81,
    'F-VVS2-POOR-GOOD-STRONG-GOOD': 5.81,
    'F-VVS2-GOOD-POOR-STRONG-GOOD': 5.81,
    'F-VS2-VG-POOR-MEDIUM-GOOD': 5.81,
    'G-VS2-GOOD-GOOD-FAINT-GOOD': 5.81,
    'G-VVS2-EX-GOOD-MEDIUM-POOR': 5.81,
    'G-VS2-EX-VG-FAINT-POOR': 5.81,
    'G-VVS2-GOOD-EX-MEDIUM-POOR': 5.81,
    'G-VS2-VG-EX-FAINT-POOR': 5.81,
    'G-VS2-POOR-VG-FAINT-GOOD': 5.81,
    'G-VVS2-GOOD-POOR-MEDIUM-GOOD': 5.81,
    'G-VS2-VG-POOR-FAINT-GOOD': 5.81,
    'G-VVS2-VG-VG-MEDIUM-POOR': 5.81,
    'G-VVS2-POOR-GOOD-MEDIUM-GOOD': 5.81,
    'H-VS2-VG-POOR-NONE-GOOD': 5.81,
    'H-VS2-GOOD-GOOD-NONE-GOOD': 5.81,
    'H-VS2-VG-EX-NONE-POOR': 5.81,
    'H-VS2-EX-VG-NONE-POOR': 5.81,
    'H-VS2-POOR-VG-NONE-GOOD': 5.81,
    'H-VVS2-VG-VG-FAINT-POOR': 5.81,
    'H-VVS2-EX-GOOD-FAINT-POOR': 5.81,
    'H-VVS2-POOR-GOOD-FAINT-GOOD': 5.81,
    'H-VVS2-GOOD-POOR-FAINT-GOOD': 5.81,
    'H-VVS2-GOOD-EX-FAINT-POOR': 5.81,
    'I-VVS2-GOOD-POOR-NONE-GOOD': 5.81,
    'I-VVS2-POOR-GOOD-NONE-GOOD': 5.81,
    'I-VVS2-VG-VG-NONE-POOR': 5.81,
    'I-VVS2-EX-GOOD-NONE-POOR': 5.81,
    'I-VVS2-GOOD-EX-NONE-POOR': 5.81,
    'J-VS2-POOR-EX-STRONG-VG': 5.81,
    'J-VS2-EX-POOR-STRONG-VG': 5.81,
    'J-VS2-VG-GOOD-STRONG-VG': 5.81,
    'J-VS2-GOOD-VG-STRONG-VG': 5.81,
    'J-VS2-EX-EX-STRONG-GOOD': 5.81,
    'J-VS2-POOR-POOR-STRONG-EX': 5.81,
    'K-VS2-GOOD-VG-MEDIUM-VG': 5.81,
    'K-VVS2-POOR-VG-STRONG-VG': 5.81,
    'K-VVS2-GOOD-GOOD-STRONG-VG': 5.81,
    'K-VS2-POOR-POOR-MEDIUM-EX': 5.81,
    'K-VVS2-VG-EX-STRONG-GOOD': 5.81,
    'K-VVS2-EX-VG-STRONG-GOOD': 5.81,
    'K-VVS2-VG-POOR-STRONG-VG': 5.81,
    'K-VS2-EX-POOR-MEDIUM-VG': 5.81,
    'K-VS2-POOR-EX-MEDIUM-VG': 5.81,
    'K-VS2-VG-GOOD-MEDIUM-VG': 5.81,
    'K-VS2-EX-EX-MEDIUM-GOOD': 5.81,
    'L-VVS2-POOR-VG-MEDIUM-VG': 5.81,
    'L-VS2-VG-GOOD-FAINT-VG': 5.81,
    'L-VVS2-GOOD-GOOD-MEDIUM-VG': 5.81,
    'L-VS2-EX-EX-FAINT-GOOD': 5.81,
    'L-VVS2-VG-POOR-MEDIUM-VG': 5.81,
    'L-VS2-EX-POOR-FAINT-VG': 5.81,
    'L-VVS2-VG-EX-MEDIUM-GOOD': 5.81,
    'L-VVS2-EX-VG-MEDIUM-GOOD': 5.81,
    'L-VS2-POOR-EX-FAINT-VG': 5.81,
    'L-VS2-POOR-POOR-FAINT-EX': 5.81,
    'L-VS2-GOOD-VG-FAINT-VG': 5.81,
    'M-VS2-GOOD-VG-NONE-VG': 5.81,
    'M-VVS2-GOOD-GOOD-FAINT-VG': 5.81,
    'M-VVS2-VG-EX-FAINT-GOOD': 5.81,
    'M-VS2-VG-GOOD-NONE-VG': 5.81,
    'M-VS2-EX-EX-NONE-GOOD': 5.81,
    'M-VS2-EX-POOR-NONE-VG': 5.81,
    'M-VS2-POOR-POOR-NONE-EX': 5.81,
    'M-VVS2-VG-POOR-FAINT-VG': 5.81,
    'M-VVS2-POOR-VG-FAINT-VG': 5.81,
    'M-VS2-POOR-EX-NONE-VG': 5.81,
    'M-VVS2-EX-VG-FAINT-GOOD': 5.81,
    'G-IF-GOOD-VG-STRONG-POOR': 5.8,
    'G-IF-EX-POOR-STRONG-POOR': 5.8,
    'G-IF-VG-GOOD-STRONG-POOR': 5.8,
    'G-IF-POOR-POOR-STRONG-GOOD': 5.8,
    'G-IF-POOR-EX-STRONG-POOR': 5.8,
    'H-IF-GOOD-VG-MEDIUM-POOR': 5.8,
    'H-IF-VG-GOOD-MEDIUM-POOR': 5.8,
    'H-IF-EX-POOR-MEDIUM-POOR': 5.8,
    'H-IF-POOR-EX-MEDIUM-POOR': 5.8,
    'H-IF-POOR-POOR-MEDIUM-GOOD': 5.8,
    'I-IF-GOOD-VG-FAINT-POOR': 5.8,
    'I-IF-POOR-POOR-FAINT-GOOD': 5.8,
    'I-IF-EX-POOR-FAINT-POOR': 5.8,
    'I-IF-VG-GOOD-FAINT-POOR': 5.8,
    'I-IF-POOR-EX-FAINT-POOR': 5.8,
    'J-IF-POOR-POOR-NONE-GOOD': 5.8,
    'J-IF-EX-POOR-NONE-POOR': 5.8,
    'J-IF-GOOD-VG-NONE-POOR': 5.8,
    'J-IF-POOR-EX-NONE-POOR': 5.8,
    'J-IF-VG-GOOD-NONE-POOR': 5.8,
    'L-IF-VG-VG-STRONG-GOOD': 5.8,
    'L-IF-EX-GOOD-STRONG-GOOD': 5.8,
    'L-IF-POOR-GOOD-STRONG-VG': 5.8,
    'L-IF-GOOD-POOR-STRONG-VG': 5.8,
    'L-IF-GOOD-EX-STRONG-GOOD': 5.8,
    'M-IF-VG-VG-MEDIUM-GOOD': 5.8,
    'M-IF-GOOD-POOR-MEDIUM-VG': 5.8,
    'M-IF-POOR-GOOD-MEDIUM-VG': 5.8,
    'M-IF-GOOD-EX-MEDIUM-GOOD': 5.8,
    'M-IF-EX-GOOD-MEDIUM-GOOD': 5.8,
    'D-SI1-VG-EX-STRONG-POOR': 5.79,
    'D-I1-EX-EX-MEDIUM-POOR': 5.79,
    'D-I1-EX-POOR-MEDIUM-GOOD': 5.79,
    'D-SI1-GOOD-GOOD-STRONG-GOOD': 5.79,
    'D-I1-POOR-EX-MEDIUM-GOOD': 5.79,
    'D-SI1-POOR-VG-STRONG-GOOD': 5.79,
    'D-I1-VG-GOOD-MEDIUM-GOOD': 5.79,
    'D-I1-POOR-POOR-MEDIUM-VG': 5.79,
    'D-I1-GOOD-VG-MEDIUM-GOOD': 5.79,
    'D-SI1-EX-VG-STRONG-POOR': 5.79,
    'D-SI1-VG-POOR-STRONG-GOOD': 5.79,
    'E-I1-EX-EX-FAINT-POOR': 5.79,
    'E-I1-VG-GOOD-FAINT-GOOD': 5.79,
    'E-I1-EX-POOR-FAINT-GOOD': 5.79,
    'E-I1-GOOD-VG-FAINT-GOOD': 5.79,
    'E-SI1-VG-EX-MEDIUM-POOR': 5.79,
    'E-I1-POOR-EX-FAINT-GOOD': 5.79,
    'E-SI1-VG-POOR-MEDIUM-GOOD': 5.79,
    'E-I1-POOR-POOR-FAINT-VG': 5.79,
    'E-SI1-POOR-VG-MEDIUM-GOOD': 5.79,
    'E-SI1-GOOD-GOOD-MEDIUM-GOOD': 5.79,
    'E-SI1-EX-VG-MEDIUM-POOR': 5.79,
    'F-SI1-VG-EX-FAINT-POOR': 5.79,
    'F-I1-EX-EX-NONE-POOR': 5.79,
    'F-SI1-VG-POOR-FAINT-GOOD': 5.79,
    'F-SI1-EX-VG-FAINT-POOR': 5.79,
    'F-I1-POOR-EX-NONE-GOOD': 5.79,
    'F-I1-GOOD-VG-NONE-GOOD': 5.79,
    'F-I1-POOR-POOR-NONE-VG': 5.79,
    'F-I1-VG-GOOD-NONE-GOOD': 5.79,
    'F-I1-EX-POOR-NONE-GOOD': 5.79,
    'F-SI1-GOOD-GOOD-FAINT-GOOD': 5.79,
    'F-SI1-POOR-VG-FAINT-GOOD': 5.79,
    'G-SI1-VG-POOR-NONE-GOOD': 5.79,
    'G-SI1-GOOD-GOOD-NONE-GOOD': 5.79,
    'G-SI1-EX-VG-NONE-POOR': 5.79,
    'G-SI1-VG-EX-NONE-POOR': 5.79,
    'G-SI1-POOR-VG-NONE-GOOD': 5.79,
    'H-I1-VG-VG-STRONG-VG': 5.79,
    'H-I1-GOOD-EX-STRONG-VG': 5.79,
    'H-I1-EX-GOOD-STRONG-VG': 5.79,
    'H-I1-POOR-GOOD-STRONG-EX': 5.79,
    'H-I1-GOOD-POOR-STRONG-EX': 5.79,
    'I-SI1-POOR-EX-STRONG-VG': 5.79,
    'I-SI1-POOR-POOR-STRONG-EX': 5.79,
    'I-SI1-VG-GOOD-STRONG-VG': 5.79,
    'I-SI1-GOOD-VG-STRONG-VG': 5.79,
    'I-SI1-EX-POOR-STRONG-VG': 5.79,
    'I-I1-POOR-GOOD-MEDIUM-EX': 5.79,
    'I-I1-GOOD-EX-MEDIUM-VG': 5.79,
    'I-I1-GOOD-POOR-MEDIUM-EX': 5.79,
    'I-I1-VG-VG-MEDIUM-VG': 5.79,
    'I-SI1-EX-EX-STRONG-GOOD': 5.79,
    'I-I1-EX-GOOD-MEDIUM-VG': 5.79,
    'J-SI1-POOR-POOR-MEDIUM-EX': 5.79,
    'J-SI1-POOR-EX-MEDIUM-VG': 5.79,
    'J-SI1-EX-POOR-MEDIUM-VG': 5.79,
    'J-SI1-GOOD-VG-MEDIUM-VG': 5.79,
    'J-SI1-VG-GOOD-MEDIUM-VG': 5.79,
    'J-SI1-EX-EX-MEDIUM-GOOD': 5.79,
    'J-I1-VG-VG-FAINT-VG': 5.79,
    'J-I1-GOOD-EX-FAINT-VG': 5.79,
    'J-I1-EX-GOOD-FAINT-VG': 5.79,
    'J-I1-GOOD-POOR-FAINT-EX': 5.79,
    'J-I1-POOR-GOOD-FAINT-EX': 5.79,
    'K-I1-GOOD-POOR-NONE-EX': 5.79,
    'K-I1-POOR-GOOD-NONE-EX': 5.79,
    'K-I1-GOOD-EX-NONE-VG': 5.79,
    'K-I1-VG-VG-NONE-VG': 5.79,
    'K-I1-EX-GOOD-NONE-VG': 5.79,
    'K-SI1-POOR-POOR-FAINT-EX': 5.79,
    'K-SI1-POOR-EX-FAINT-VG': 5.79,
    'K-SI1-GOOD-VG-FAINT-VG': 5.79,
    'K-SI1-VG-GOOD-FAINT-VG': 5.79,
    'K-SI1-EX-POOR-FAINT-VG': 5.79,
    'K-SI1-EX-EX-FAINT-GOOD': 5.79,
    'L-SI1-POOR-POOR-NONE-EX': 5.79,
    'L-SI1-POOR-EX-NONE-VG': 5.79,
    'L-SI1-EX-EX-NONE-GOOD': 5.79,
    'L-SI1-GOOD-VG-NONE-VG': 5.79,
    'L-SI1-EX-POOR-NONE-VG': 5.79,
    'L-SI1-VG-GOOD-NONE-VG': 5.79,
    'M-I1-EX-VG-STRONG-EX': 5.79,
    'M-I1-VG-EX-STRONG-EX': 5.79,
    'E-VS1-EX-GOOD-STRONG-POOR': 5.78,
    'E-VS1-VG-VG-STRONG-POOR': 5.78,
    'E-VS1-GOOD-EX-STRONG-POOR': 5.78,
    'E-VS1-GOOD-POOR-STRONG-GOOD': 5.78,
    'E-VS1-POOR-GOOD-STRONG-GOOD': 5.78,
    'F-VS1-GOOD-EX-MEDIUM-POOR': 5.78,
    'F-VS1-VG-VG-MEDIUM-POOR': 5.78,
    'F-VS1-POOR-GOOD-MEDIUM-GOOD': 5.78,
    'F-VVS1-GOOD-VG-STRONG-POOR': 5.78,
    'F-VS1-EX-GOOD-MEDIUM-POOR': 5.78,
    'F-VS1-GOOD-POOR-MEDIUM-GOOD': 5.78,
    'F-VVS1-EX-POOR-STRONG-POOR': 5.78,
    'F-VVS1-VG-GOOD-STRONG-POOR': 5.78,
    'F-VVS1-POOR-EX-STRONG-POOR': 5.78,
    'F-VVS1-POOR-POOR-STRONG-GOOD': 5.78,
    'G-VS1-GOOD-EX-FAINT-POOR': 5.78,
    'G-VVS1-GOOD-VG-MEDIUM-POOR': 5.78,
    'G-VVS1-VG-GOOD-MEDIUM-POOR': 5.78,
    'G-VVS1-EX-POOR-MEDIUM-POOR': 5.78,
    'G-VVS1-POOR-EX-MEDIUM-POOR': 5.78,
    'G-VS1-VG-VG-FAINT-POOR': 5.78,
    'G-VVS1-POOR-POOR-MEDIUM-GOOD': 5.78,
    'G-VS1-EX-GOOD-FAINT-POOR': 5.78,
    'G-VS1-GOOD-POOR-FAINT-GOOD': 5.78,
    'G-VS1-POOR-GOOD-FAINT-GOOD': 5.78,
    'H-VVS1-GOOD-VG-FAINT-POOR': 5.78,
    'H-VS1-GOOD-POOR-NONE-GOOD': 5.78,
    'H-VVS1-POOR-POOR-FAINT-GOOD': 5.78,
    'H-VS1-GOOD-EX-NONE-POOR': 5.78,
    'H-VS1-POOR-GOOD-NONE-GOOD': 5.78,
    'H-VS1-VG-VG-NONE-POOR': 5.78,
    'H-VVS1-POOR-EX-FAINT-POOR': 5.78,
    'H-VS1-EX-GOOD-NONE-POOR': 5.78,
    'H-VVS1-VG-GOOD-FAINT-POOR': 5.78,
    'H-VVS1-EX-POOR-FAINT-POOR': 5.78,
    'I-VVS1-EX-POOR-NONE-POOR': 5.78,
    'I-VVS1-POOR-EX-NONE-POOR': 5.78,
    'I-VVS1-POOR-POOR-NONE-GOOD': 5.78,
    'I-VVS1-GOOD-VG-NONE-POOR': 5.78,
    'I-VVS1-VG-GOOD-NONE-POOR': 5.78,
    'J-VS1-VG-EX-STRONG-GOOD': 5.78,
    'J-VS1-EX-VG-STRONG-GOOD': 5.78,
    'J-VS1-GOOD-GOOD-STRONG-VG': 5.78,
    'J-VS1-VG-POOR-STRONG-VG': 5.78,
    'J-VS1-POOR-VG-STRONG-VG': 5.78,
    'K-VS1-VG-EX-MEDIUM-GOOD': 5.78,
    'K-VS1-VG-POOR-MEDIUM-VG': 5.78,
    'K-VS1-GOOD-GOOD-MEDIUM-VG': 5.78,
    'K-VS1-POOR-VG-MEDIUM-VG': 5.78,
    'K-VS1-EX-VG-MEDIUM-GOOD': 5.78,
    'K-VVS1-POOR-GOOD-STRONG-VG': 5.78,
    'K-VVS1-GOOD-POOR-STRONG-VG': 5.78,
    'K-VVS1-GOOD-EX-STRONG-GOOD': 5.78,
    'K-VVS1-EX-GOOD-STRONG-GOOD': 5.78,
    'K-VVS1-VG-VG-STRONG-GOOD': 5.78,
    'L-VVS1-POOR-GOOD-MEDIUM-VG': 5.78,
    'L-VVS1-GOOD-EX-MEDIUM-GOOD': 5.78,
    'L-VS1-POOR-VG-FAINT-VG': 5.78,
    'L-VS1-GOOD-GOOD-FAINT-VG': 5.78,
    'L-VS1-EX-VG-FAINT-GOOD': 5.78,
    'L-VS1-VG-EX-FAINT-GOOD': 5.78,
    'L-VS1-VG-POOR-FAINT-VG': 5.78,
    'L-VVS1-VG-VG-MEDIUM-GOOD': 5.78,
    'L-VVS1-GOOD-POOR-MEDIUM-VG': 5.78,
    'L-VVS1-EX-GOOD-MEDIUM-GOOD': 5.78,
    'M-VVS1-VG-VG-FAINT-GOOD': 5.78,
    'M-VVS1-GOOD-POOR-FAINT-VG': 5.78,
    'M-VVS1-EX-GOOD-FAINT-GOOD': 5.78,
    'M-VVS1-POOR-GOOD-FAINT-VG': 5.78,
    'M-VVS1-GOOD-EX-FAINT-GOOD': 5.78,
    'M-VS1-POOR-VG-NONE-VG': 5.78,
    'M-VS1-GOOD-GOOD-NONE-VG': 5.78,
    'M-VS1-EX-VG-NONE-GOOD': 5.78,
    'M-VS1-VG-EX-NONE-GOOD': 5.78,
    'M-VS1-VG-POOR-NONE-VG': 5.78,
    'D-I2-EX-EX-FAINT-POOR': 5.77,
    'D-I2-GOOD-VG-FAINT-GOOD': 5.77,
    'D-I2-VG-GOOD-FAINT-GOOD': 5.77,
    'D-SI2-EX-VG-MEDIUM-POOR': 5.77,
    'D-I2-EX-POOR-FAINT-GOOD': 5.77,
    'D-SI2-VG-EX-MEDIUM-POOR': 5.77,
    'D-SI2-VG-POOR-MEDIUM-GOOD': 5.77,
    'D-I2-POOR-POOR-FAINT-VG': 5.77,
    'D-SI2-GOOD-GOOD-MEDIUM-GOOD': 5.77,
    'D-I2-POOR-EX-FAINT-GOOD': 5.77,
    'D-SI2-POOR-VG-MEDIUM-GOOD': 5.77,
    'E-SI2-GOOD-GOOD-FAINT-GOOD': 5.77,
    'E-I2-POOR-EX-NONE-GOOD': 5.77,
    'E-I2-EX-POOR-NONE-GOOD': 5.77,
    'E-I2-VG-GOOD-NONE-GOOD': 5.77,
    'E-SI2-VG-POOR-FAINT-GOOD': 5.77,
    'E-I2-GOOD-VG-NONE-GOOD': 5.77,
    'E-SI2-POOR-VG-FAINT-GOOD': 5.77,
    'E-I2-EX-EX-NONE-POOR': 5.77,
    'E-SI2-EX-VG-FAINT-POOR': 5.77,
    'E-I2-POOR-POOR-NONE-VG': 5.77,
    'E-SI2-VG-EX-FAINT-POOR': 5.77,
    'F-SI2-EX-VG-NONE-POOR': 5.77,
    'F-SI2-POOR-VG-NONE-GOOD': 5.77,
    'F-SI2-GOOD-GOOD-NONE-GOOD': 5.77,
    'F-SI2-VG-POOR-NONE-GOOD': 5.77,
    'F-SI2-VG-EX-NONE-POOR': 5.77,
    'G-I2-GOOD-EX-STRONG-VG': 5.77,
    'G-I2-GOOD-POOR-STRONG-EX': 5.77,
    'G-I2-POOR-GOOD-STRONG-EX': 5.77,
    'G-I2-VG-VG-STRONG-VG': 5.77,
    'G-I2-EX-GOOD-STRONG-VG': 5.77,
    'H-SI2-VG-GOOD-STRONG-VG': 5.77,
    'H-SI2-GOOD-VG-STRONG-VG': 5.77,
    'H-I2-EX-GOOD-MEDIUM-VG': 5.77,
    'H-I2-VG-VG-MEDIUM-VG': 5.77,
    'H-I2-GOOD-EX-MEDIUM-VG': 5.77,
    'H-SI2-POOR-POOR-STRONG-EX': 5.77,
    'H-SI2-POOR-EX-STRONG-VG': 5.77,
    'H-I2-GOOD-POOR-MEDIUM-EX': 5.77,
    'H-SI2-EX-EX-STRONG-GOOD': 5.77,
    'H-SI2-EX-POOR-STRONG-VG': 5.77,
    'H-I2-POOR-GOOD-MEDIUM-EX': 5.77,
    'I-SI2-EX-EX-MEDIUM-GOOD': 5.77,
    'I-SI2-VG-GOOD-MEDIUM-VG': 5.77,
    'I-I2-GOOD-EX-FAINT-VG': 5.77,
    'I-SI2-EX-POOR-MEDIUM-VG': 5.77,
    'I-SI2-GOOD-VG-MEDIUM-VG': 5.77,
    'I-SI2-POOR-EX-MEDIUM-VG': 5.77,
    'I-I2-EX-GOOD-FAINT-VG': 5.77,
    'I-SI2-POOR-POOR-MEDIUM-EX': 5.77,
    'I-I2-POOR-GOOD-FAINT-EX': 5.77,
    'I-I2-GOOD-POOR-FAINT-EX': 5.77,
    'I-I2-VG-VG-FAINT-VG': 5.77,
    'J-I2-GOOD-POOR-NONE-EX': 5.77,
    'J-I2-POOR-GOOD-NONE-EX': 5.77,
    'J-SI2-POOR-POOR-FAINT-EX': 5.77,
    'J-I2-EX-GOOD-NONE-VG': 5.77,
    'J-I2-VG-VG-NONE-VG': 5.77,
    'J-I2-GOOD-EX-NONE-VG': 5.77,
    'J-SI2-GOOD-VG-FAINT-VG': 5.77,
    'J-SI2-EX-EX-FAINT-GOOD': 5.77,
    'J-SI2-EX-POOR-FAINT-VG': 5.77,
    'J-SI2-VG-GOOD-FAINT-VG': 5.77,
    'J-SI2-POOR-EX-FAINT-VG': 5.77,
    'K-SI2-EX-POOR-NONE-VG': 5.77,
    'K-SI2-VG-GOOD-NONE-VG': 5.77,
    'K-SI2-POOR-EX-NONE-VG': 5.77,
    'K-SI2-GOOD-VG-NONE-VG': 5.77,
    'K-SI2-EX-EX-NONE-GOOD': 5.77,
    'K-SI2-POOR-POOR-NONE-EX': 5.77,
    'L-I2-VG-EX-STRONG-EX': 5.77,
    'L-I2-EX-VG-STRONG-EX': 5.77,
    'M-SI2-EX-GOOD-STRONG-EX': 5.77,
    'M-SI2-GOOD-EX-STRONG-EX': 5.77,
    'M-I2-EX-VG-MEDIUM-EX': 5.77,
    'M-I2-VG-EX-MEDIUM-EX': 5.77,
    'M-SI2-VG-VG-STRONG-EX': 5.77,
    'D-VS2-VG-VG-STRONG-POOR': 5.76,
    'D-VS2-EX-GOOD-STRONG-POOR': 5.76,
    'D-VS2-GOOD-EX-STRONG-POOR': 5.76,
    'D-VS2-POOR-GOOD-STRONG-GOOD': 5.76,
    'D-VS2-GOOD-POOR-STRONG-GOOD': 5.76,
    'E-VS2-GOOD-POOR-MEDIUM-GOOD': 5.76,
    'E-VVS2-POOR-POOR-STRONG-GOOD': 5.76,
    'E-VS2-POOR-GOOD-MEDIUM-GOOD': 5.76,
    'E-VVS2-EX-POOR-STRONG-POOR': 5.76,
    'E-VS2-GOOD-EX-MEDIUM-POOR': 5.76,
    'E-VVS2-GOOD-VG-STRONG-POOR': 5.76,
    'E-VVS2-VG-GOOD-STRONG-POOR': 5.76,
    'E-VS2-VG-VG-MEDIUM-POOR': 5.76,
    'E-VVS2-POOR-EX-STRONG-POOR': 5.76,
    'E-VS2-EX-GOOD-MEDIUM-POOR': 5.76,
    'F-VS2-EX-GOOD-FAINT-POOR': 5.76,
    'F-VS2-VG-VG-FAINT-POOR': 5.76,
    'F-VS2-POOR-GOOD-FAINT-GOOD': 5.76,
    'F-VS2-GOOD-EX-FAINT-POOR': 5.76,
    'F-VS2-GOOD-POOR-FAINT-GOOD': 5.76,
    'F-VVS2-GOOD-VG-MEDIUM-POOR': 5.76,
    'F-VVS2-POOR-POOR-MEDIUM-GOOD': 5.76,
    'F-VVS2-POOR-EX-MEDIUM-POOR': 5.76,
    'F-VVS2-EX-POOR-MEDIUM-POOR': 5.76,
    'F-VVS2-VG-GOOD-MEDIUM-POOR': 5.76,
    'G-VVS2-EX-POOR-FAINT-POOR': 5.76,
    'G-VVS2-GOOD-VG-FAINT-POOR': 5.76,
    'G-VVS2-VG-GOOD-FAINT-POOR': 5.76,
    'G-VS2-EX-GOOD-NONE-POOR': 5.76,
    'G-VS2-GOOD-EX-NONE-POOR': 5.76,
    'G-VS2-VG-VG-NONE-POOR': 5.76,
    'G-VS2-GOOD-POOR-NONE-GOOD': 5.76,
    'G-VS2-POOR-GOOD-NONE-GOOD': 5.76,
    'G-VVS2-POOR-EX-FAINT-POOR': 5.76,
    'G-VVS2-POOR-POOR-FAINT-GOOD': 5.76,
    'H-VVS2-POOR-POOR-NONE-GOOD': 5.76,
    'H-VVS2-VG-GOOD-NONE-POOR': 5.76,
    'H-VVS2-EX-POOR-NONE-POOR': 5.76,
    'H-VVS2-GOOD-VG-NONE-POOR': 5.76,
    'H-VVS2-POOR-EX-NONE-POOR': 5.76,
    'I-VS2-VG-POOR-STRONG-VG': 5.76,
    'I-VS2-VG-EX-STRONG-GOOD': 5.76,
    'I-VS2-EX-VG-STRONG-GOOD': 5.76,
    'I-VS2-GOOD-GOOD-STRONG-VG': 5.76,
    'I-VS2-POOR-VG-STRONG-VG': 5.76,
    'J-VS2-EX-VG-MEDIUM-GOOD': 5.76,
    'J-VS2-VG-EX-MEDIUM-GOOD': 5.76,
    'J-VS2-GOOD-GOOD-MEDIUM-VG': 5.76,
    'J-VS2-VG-POOR-MEDIUM-VG': 5.76,
    'J-VS2-POOR-VG-MEDIUM-VG': 5.76,
    'J-VVS2-EX-GOOD-STRONG-GOOD': 5.76,
    'J-VVS2-VG-VG-STRONG-GOOD': 5.76,
    'J-VVS2-GOOD-EX-STRONG-GOOD': 5.76,
    'J-VVS2-POOR-GOOD-STRONG-VG': 5.76,
    'J-VVS2-GOOD-POOR-STRONG-VG': 5.76,
    'K-VS2-POOR-VG-FAINT-VG': 5.76,
    'K-VS2-VG-POOR-FAINT-VG': 5.76,
    'K-VS2-GOOD-GOOD-FAINT-VG': 5.76,
    'K-VS2-EX-VG-FAINT-GOOD': 5.76,
    'K-VS2-VG-EX-FAINT-GOOD': 5.76,
    'K-VVS2-GOOD-POOR-MEDIUM-VG': 5.76,
    'K-VVS2-POOR-GOOD-MEDIUM-VG': 5.76,
    'K-VVS2-GOOD-EX-MEDIUM-GOOD': 5.76,
    'K-VVS2-EX-GOOD-MEDIUM-GOOD': 5.76,
    'K-VVS2-VG-VG-MEDIUM-GOOD': 5.76,
    'L-VVS2-EX-GOOD-FAINT-GOOD': 5.76,
    'L-VVS2-POOR-GOOD-FAINT-VG': 5.76,
    'L-VVS2-GOOD-POOR-FAINT-VG': 5.76,
    'L-VVS2-GOOD-EX-FAINT-GOOD': 5.76,
    'L-VVS2-VG-VG-FAINT-GOOD': 5.76,
    'L-VS2-VG-EX-NONE-GOOD': 5.76,
    'L-VS2-POOR-VG-NONE-VG': 5.76,
    'L-VS2-VG-POOR-NONE-VG': 5.76,
    'L-VS2-EX-VG-NONE-GOOD': 5.76,
    'L-VS2-GOOD-GOOD-NONE-VG': 5.76,
    'M-VVS2-EX-GOOD-NONE-GOOD': 5.76,
    'M-VVS2-VG-VG-NONE-GOOD': 5.76,
    'M-VVS2-GOOD-POOR-NONE-VG': 5.76,
    'M-VVS2-GOOD-EX-NONE-GOOD': 5.76,
    'M-VVS2-POOR-GOOD-NONE-VG': 5.76,
    'F-IF-VG-POOR-STRONG-POOR': 5.75,
    'F-IF-GOOD-GOOD-STRONG-POOR': 5.75,
    'F-IF-POOR-VG-STRONG-POOR': 5.75,
    'G-IF-POOR-VG-MEDIUM-POOR': 5.75,
    'G-IF-GOOD-GOOD-MEDIUM-POOR': 5.75,
    'G-IF-VG-POOR-MEDIUM-POOR': 5.75,
    'H-IF-POOR-VG-FAINT-POOR': 5.75,
    'H-IF-GOOD-GOOD-FAINT-POOR': 5.75,
    'H-IF-VG-POOR-FAINT-POOR': 5.75,
    'I-IF-GOOD-GOOD-NONE-POOR': 5.75,
    'I-IF-VG-POOR-NONE-POOR': 5.75,
    'I-IF-POOR-VG-NONE-POOR': 5.75,
    'K-IF-VG-GOOD-STRONG-GOOD': 5.75,
    'K-IF-GOOD-VG-STRONG-GOOD': 5.75,
    'K-IF-EX-POOR-STRONG-GOOD': 5.75,
    'K-IF-POOR-EX-STRONG-GOOD': 5.75,
    'K-IF-POOR-POOR-STRONG-VG': 5.75,
    'K-IF-EX-EX-STRONG-POOR': 5.75,
    'L-IF-POOR-EX-MEDIUM-GOOD': 5.75,
    'L-IF-VG-GOOD-MEDIUM-GOOD': 5.75,
    'L-IF-EX-EX-MEDIUM-POOR': 5.75,
    'L-IF-POOR-POOR-MEDIUM-VG': 5.75,
    'L-IF-EX-POOR-MEDIUM-GOOD': 5.75,
    'L-IF-GOOD-VG-MEDIUM-GOOD': 5.75,
    'M-IF-POOR-EX-FAINT-GOOD': 5.75,
    'M-IF-GOOD-VG-FAINT-GOOD': 5.75,
    'M-IF-VG-GOOD-FAINT-GOOD': 5.75,
    'M-IF-EX-POOR-FAINT-GOOD': 5.75,
    'M-IF-EX-EX-FAINT-POOR': 5.75,
    'M-IF-POOR-POOR-FAINT-VG': 5.75,
    'D-SI1-VG-VG-MEDIUM-POOR': 5.74,
    'D-SI1-EX-GOOD-MEDIUM-POOR': 5.74,
    'D-I1-POOR-VG-FAINT-GOOD': 5.74,
    'D-SI1-GOOD-POOR-MEDIUM-GOOD': 5.74,
    'D-SI1-POOR-GOOD-MEDIUM-GOOD': 5.74,
    'D-I1-VG-EX-FAINT-POOR': 5.74,
    'D-I1-EX-VG-FAINT-POOR': 5.74,
    'D-I1-VG-POOR-FAINT-GOOD': 5.74,
    'D-SI1-GOOD-EX-MEDIUM-POOR': 5.74,
    'D-I1-GOOD-GOOD-FAINT-GOOD': 5.74,
    'E-SI1-POOR-GOOD-FAINT-GOOD': 5.74,
    'E-SI1-GOOD-POOR-FAINT-GOOD': 5.74,
    'E-SI1-VG-VG-FAINT-POOR': 5.74,
    'E-I1-VG-EX-NONE-POOR': 5.74,
    'E-SI1-GOOD-EX-FAINT-POOR': 5.74,
    'E-SI1-EX-GOOD-FAINT-POOR': 5.74,
    'E-I1-GOOD-GOOD-NONE-GOOD': 5.74,
    'E-I1-POOR-VG-NONE-GOOD': 5.74,
    'E-I1-VG-POOR-NONE-GOOD': 5.74,
    'E-I1-EX-VG-NONE-POOR': 5.74,
    'F-SI1-GOOD-POOR-NONE-GOOD': 5.74,
    'F-SI1-GOOD-EX-NONE-POOR': 5.74,
    'F-SI1-EX-GOOD-NONE-POOR': 5.74,
    'F-SI1-VG-VG-NONE-POOR': 5.74,
    'F-SI1-POOR-GOOD-NONE-GOOD': 5.74,
    'G-I1-VG-GOOD-STRONG-VG': 5.74,
    'G-I1-EX-EX-STRONG-GOOD': 5.74,
    'G-I1-EX-POOR-STRONG-VG': 5.74,
    'G-I1-GOOD-VG-STRONG-VG': 5.74,
    'G-I1-POOR-POOR-STRONG-EX': 5.74,
    'G-I1-POOR-EX-STRONG-VG': 5.74,
    'H-I1-POOR-EX-MEDIUM-VG': 5.74,
    'H-I1-GOOD-VG-MEDIUM-VG': 5.74,
    'H-SI1-POOR-VG-STRONG-VG': 5.74,
    'H-SI1-GOOD-GOOD-STRONG-VG': 5.74,
    'H-I1-VG-GOOD-MEDIUM-VG': 5.74,
    'H-SI1-VG-POOR-STRONG-VG': 5.74,
    'H-I1-POOR-POOR-MEDIUM-EX': 5.74,
    'H-SI1-VG-EX-STRONG-GOOD': 5.74,
    'H-I1-EX-EX-MEDIUM-GOOD': 5.74,
    'H-SI1-EX-VG-STRONG-GOOD': 5.74,
    'H-I1-EX-POOR-MEDIUM-VG': 5.74,
    'I-SI1-VG-POOR-MEDIUM-VG': 5.74,
    'I-SI1-EX-VG-MEDIUM-GOOD': 5.74,
    'I-I1-POOR-POOR-FAINT-EX': 5.74,
    'I-SI1-VG-EX-MEDIUM-GOOD': 5.74,
    'I-SI1-POOR-VG-MEDIUM-VG': 5.74,
    'I-SI1-GOOD-GOOD-MEDIUM-VG': 5.74,
    'I-I1-EX-POOR-FAINT-VG': 5.74,
    'I-I1-GOOD-VG-FAINT-VG': 5.74,
    'I-I1-VG-GOOD-FAINT-VG': 5.74,
    'I-I1-EX-EX-FAINT-GOOD': 5.74,
    'I-I1-POOR-EX-FAINT-VG': 5.74,
    'J-I1-POOR-POOR-NONE-EX': 5.74,
    'J-I1-POOR-EX-NONE-VG': 5.74,
    'J-SI1-EX-VG-FAINT-GOOD': 5.74,
    'J-SI1-VG-EX-FAINT-GOOD': 5.74,
    'J-I1-GOOD-VG-NONE-VG': 5.74,
    'J-SI1-POOR-VG-FAINT-VG': 5.74,
    'J-SI1-GOOD-GOOD-FAINT-VG': 5.74,
    'J-I1-VG-GOOD-NONE-VG': 5.74,
    'J-I1-EX-POOR-NONE-VG': 5.74,
    'J-I1-EX-EX-NONE-GOOD': 5.74,
    'J-SI1-VG-POOR-FAINT-VG': 5.74,
    'K-SI1-POOR-VG-NONE-VG': 5.74,
    'K-SI1-EX-VG-NONE-GOOD': 5.74,
    'K-SI1-VG-EX-NONE-GOOD': 5.74,
    'K-SI1-VG-POOR-NONE-VG': 5.74,
    'K-SI1-GOOD-GOOD-NONE-VG': 5.74,
    'L-I1-VG-VG-STRONG-EX': 5.74,
    'L-I1-GOOD-EX-STRONG-EX': 5.74,
    'L-I1-EX-GOOD-STRONG-EX': 5.74,
    'M-SI1-GOOD-VG-STRONG-EX': 5.74,
    'M-SI1-EX-POOR-STRONG-EX': 5.74,
    'M-SI1-EX-EX-STRONG-VG': 5.74,
    'M-I1-VG-VG-MEDIUM-EX': 5.74,
    'M-SI1-POOR-EX-STRONG-EX': 5.74,
    'M-SI1-VG-GOOD-STRONG-EX': 5.74,
    'M-I1-GOOD-EX-MEDIUM-EX': 5.74,
    'M-I1-EX-GOOD-MEDIUM-EX': 5.74,
    'D-VS1-EX-POOR-STRONG-POOR': 5.73,
    'D-VS1-VG-GOOD-STRONG-POOR': 5.73,
    'D-VS1-GOOD-VG-STRONG-POOR': 5.73,
    'D-VS1-POOR-POOR-STRONG-GOOD': 5.73,
    'D-VS1-POOR-EX-STRONG-POOR': 5.73,
    'E-VVS1-VG-POOR-STRONG-POOR': 5.73,
    'E-VVS1-GOOD-GOOD-STRONG-POOR': 5.73,
    'E-VS1-GOOD-VG-MEDIUM-POOR': 5.73,
    'E-VS1-EX-POOR-MEDIUM-POOR': 5.73,
    'E-VS1-VG-GOOD-MEDIUM-POOR': 5.73,
    'E-VVS1-POOR-VG-STRONG-POOR': 5.73,
    'E-VS1-POOR-EX-MEDIUM-POOR': 5.73,
    'E-VS1-POOR-POOR-MEDIUM-GOOD': 5.73,
    'F-VS1-EX-POOR-FAINT-POOR': 5.73,
    'F-VS1-POOR-POOR-FAINT-GOOD': 5.73,
    'F-VVS1-GOOD-GOOD-MEDIUM-POOR': 5.73,
    'F-VVS1-POOR-VG-MEDIUM-POOR': 5.73,
    'F-VS1-GOOD-VG-FAINT-POOR': 5.73,
    'F-VS1-POOR-EX-FAINT-POOR': 5.73,
    'F-VVS1-VG-POOR-MEDIUM-POOR': 5.73,
    'F-VS1-VG-GOOD-FAINT-POOR': 5.73,
    'G-VS1-VG-GOOD-NONE-POOR': 5.73,
    'G-VS1-EX-POOR-NONE-POOR': 5.73,
    'G-VS1-POOR-EX-NONE-POOR': 5.73,
    'G-VVS1-GOOD-GOOD-FAINT-POOR': 5.73,
    'G-VS1-GOOD-VG-NONE-POOR': 5.73,
    'G-VVS1-POOR-VG-FAINT-POOR': 5.73,
    'G-VS1-POOR-POOR-NONE-GOOD': 5.73,
    'G-VVS1-VG-POOR-FAINT-POOR': 5.73,
    'H-VVS1-GOOD-GOOD-NONE-POOR': 5.73,
    'H-VVS1-POOR-VG-NONE-POOR': 5.73,
    'H-VVS1-VG-POOR-NONE-POOR': 5.73,
    'I-VS1-GOOD-POOR-STRONG-VG': 5.73,
    'I-VS1-EX-GOOD-STRONG-GOOD': 5.73,
    'I-VS1-POOR-GOOD-STRONG-VG': 5.73,
    'I-VS1-VG-VG-STRONG-GOOD': 5.73,
    'I-VS1-GOOD-EX-STRONG-GOOD': 5.73,
    'J-VS1-POOR-GOOD-MEDIUM-VG': 5.73,
    'J-VS1-GOOD-EX-MEDIUM-GOOD': 5.73,
    'J-VVS1-POOR-POOR-STRONG-VG': 5.73,
    'J-VVS1-POOR-EX-STRONG-GOOD': 5.73,
    'J-VVS1-EX-POOR-STRONG-GOOD': 5.73,
    'J-VS1-EX-GOOD-MEDIUM-GOOD': 5.73,
    'J-VVS1-EX-EX-STRONG-POOR': 5.73,
    'J-VS1-VG-VG-MEDIUM-GOOD': 5.73,
    'J-VVS1-GOOD-VG-STRONG-GOOD': 5.73,
    'J-VVS1-VG-GOOD-STRONG-GOOD': 5.73,
    'J-VS1-GOOD-POOR-MEDIUM-VG': 5.73,
    'K-VVS1-POOR-EX-MEDIUM-GOOD': 5.73,
    'K-VVS1-EX-POOR-MEDIUM-GOOD': 5.73,
    'K-VVS1-EX-EX-MEDIUM-POOR': 5.73,
    'K-VVS1-POOR-POOR-MEDIUM-VG': 5.73,
    'K-VVS1-VG-GOOD-MEDIUM-GOOD': 5.73,
    'K-VVS1-GOOD-VG-MEDIUM-GOOD': 5.73,
    'K-VS1-EX-GOOD-FAINT-GOOD': 5.73,
    'K-VS1-VG-VG-FAINT-GOOD': 5.73,
    'K-VS1-GOOD-EX-FAINT-GOOD': 5.73,
    'K-VS1-GOOD-POOR-FAINT-VG': 5.73,
    'K-VS1-POOR-GOOD-FAINT-VG': 5.73,
    'L-VS1-GOOD-EX-NONE-GOOD': 5.73,
    'L-VS1-VG-VG-NONE-GOOD': 5.73,
    'L-VS1-EX-GOOD-NONE-GOOD': 5.73,
    'L-VS1-GOOD-POOR-NONE-VG': 5.73,
    'L-VVS1-POOR-POOR-FAINT-VG': 5.73,
    'L-VS1-POOR-GOOD-NONE-VG': 5.73,
    'L-VVS1-POOR-EX-FAINT-GOOD': 5.73,
    'L-VVS1-VG-GOOD-FAINT-GOOD': 5.73,
    'L-VVS1-EX-POOR-FAINT-GOOD': 5.73,
    'L-VVS1-EX-EX-FAINT-POOR': 5.73,
    'L-VVS1-GOOD-VG-FAINT-GOOD': 5.73,
    'M-VVS1-VG-GOOD-NONE-GOOD': 5.73,
    'M-VVS1-EX-POOR-NONE-GOOD': 5.73,
    'M-VVS1-GOOD-VG-NONE-GOOD': 5.73,
    'M-VVS1-EX-EX-NONE-POOR': 5.73,
    'M-VVS1-POOR-EX-NONE-GOOD': 5.73,
    'M-VVS1-POOR-POOR-NONE-VG': 5.73,
    'D-SI2-GOOD-POOR-FAINT-GOOD': 5.72,
    'D-SI2-POOR-GOOD-FAINT-GOOD': 5.72,
    'D-I2-POOR-VG-NONE-GOOD': 5.72,
    'D-SI2-VG-VG-FAINT-POOR': 5.72,
    'D-SI2-GOOD-EX-FAINT-POOR': 5.72,
    'D-I2-VG-EX-NONE-POOR': 5.72,
    'D-SI2-EX-GOOD-FAINT-POOR': 5.72,
    'D-I2-GOOD-GOOD-NONE-GOOD': 5.72,
    'D-I2-VG-POOR-NONE-GOOD': 5.72,
    'D-I2-EX-VG-NONE-POOR': 5.72,
    'E-SI2-GOOD-EX-NONE-POOR': 5.72,
    'E-SI2-GOOD-POOR-NONE-GOOD': 5.72,
    'E-SI2-EX-GOOD-NONE-POOR': 5.72,
    'E-SI2-VG-VG-NONE-POOR': 5.72,
    'E-SI2-POOR-GOOD-NONE-GOOD': 5.72,
    'F-I2-POOR-EX-STRONG-VG': 5.72,
    'F-I2-POOR-POOR-STRONG-EX': 5.72,
    'F-I2-EX-EX-STRONG-GOOD': 5.72,
    'F-I2-EX-POOR-STRONG-VG': 5.72,
    'F-I2-VG-GOOD-STRONG-VG': 5.72,
    'F-I2-GOOD-VG-STRONG-VG': 5.72,
    'G-SI2-GOOD-GOOD-STRONG-VG': 5.72,
    'G-SI2-VG-POOR-STRONG-VG': 5.72,
    'G-I2-VG-GOOD-MEDIUM-VG': 5.72,
    'G-I2-EX-POOR-MEDIUM-VG': 5.72,
    'G-SI2-VG-EX-STRONG-GOOD': 5.72,
    'G-I2-POOR-POOR-MEDIUM-EX': 5.72,
    'G-SI2-EX-VG-STRONG-GOOD': 5.72,
    'G-I2-POOR-EX-MEDIUM-VG': 5.72,
    'G-I2-GOOD-VG-MEDIUM-VG': 5.72,
    'G-I2-EX-EX-MEDIUM-GOOD': 5.72,
    'G-SI2-POOR-VG-STRONG-VG': 5.72,
    'H-I2-EX-EX-FAINT-GOOD': 5.72,
    'H-I2-EX-POOR-FAINT-VG': 5.72,
    'H-SI2-EX-VG-MEDIUM-GOOD': 5.72,
    'H-SI2-VG-POOR-MEDIUM-VG': 5.72,
    'H-SI2-GOOD-GOOD-MEDIUM-VG': 5.72,
    'H-SI2-VG-EX-MEDIUM-GOOD': 5.72,
    'H-SI2-POOR-VG-MEDIUM-VG': 5.72,
    'H-I2-POOR-POOR-FAINT-EX': 5.72,
    'H-I2-POOR-EX-FAINT-VG': 5.72,
    'H-I2-GOOD-VG-FAINT-VG': 5.72,
    'H-I2-VG-GOOD-FAINT-VG': 5.72,
    'I-SI2-EX-VG-FAINT-GOOD': 5.72,
    'I-SI2-VG-POOR-FAINT-VG': 5.72,
    'I-SI2-POOR-VG-FAINT-VG': 5.72,
    'I-SI2-GOOD-GOOD-FAINT-VG': 5.72,
    'I-I2-POOR-POOR-NONE-EX': 5.72,
    'I-SI2-VG-EX-FAINT-GOOD': 5.72,
    'I-I2-POOR-EX-NONE-VG': 5.72,
    'I-I2-VG-GOOD-NONE-VG': 5.72,
    'I-I2-EX-POOR-NONE-VG': 5.72,
    'I-I2-EX-EX-NONE-GOOD': 5.72,
    'I-I2-GOOD-VG-NONE-VG': 5.72,
    'J-SI2-VG-POOR-NONE-VG': 5.72,
    'J-SI2-POOR-VG-NONE-VG': 5.72,
    'J-SI2-VG-EX-NONE-GOOD': 5.72,
    'J-SI2-EX-VG-NONE-GOOD': 5.72,
    'J-SI2-GOOD-GOOD-NONE-VG': 5.72,
    'K-I2-VG-VG-STRONG-EX': 5.72,
    'K-I2-EX-GOOD-STRONG-EX': 5.72,
    'K-I2-GOOD-EX-STRONG-EX': 5.72,
    'L-SI2-POOR-EX-STRONG-EX': 5.72,
    'L-I2-GOOD-EX-MEDIUM-EX': 5.72,
    'L-I2-EX-GOOD-MEDIUM-EX': 5.72,
    'L-SI2-EX-EX-STRONG-VG': 5.72,
    'L-I2-VG-VG-MEDIUM-EX': 5.72,
    'L-SI2-GOOD-VG-STRONG-EX': 5.72,
    'L-SI2-EX-POOR-STRONG-EX': 5.72,
    'L-SI2-VG-GOOD-STRONG-EX': 5.72,
    'M-SI2-GOOD-VG-MEDIUM-EX': 5.72,
    'M-I2-VG-VG-FAINT-EX': 5.72,
    'M-I2-EX-GOOD-FAINT-EX': 5.72,
    'M-I2-GOOD-EX-FAINT-EX': 5.72,
    'M-SI2-POOR-EX-MEDIUM-EX': 5.72,
    'M-SI2-EX-EX-MEDIUM-VG': 5.72,
    'M-SI2-VG-GOOD-MEDIUM-EX': 5.72,
    'M-SI2-EX-POOR-MEDIUM-EX': 5.72,
    'D-VVS2-GOOD-GOOD-STRONG-POOR': 5.71,
    'D-VVS2-VG-POOR-STRONG-POOR': 5.71,
    'D-VS2-VG-GOOD-MEDIUM-POOR': 5.71,
    'D-VS2-POOR-EX-MEDIUM-POOR': 5.71,
    'D-VS2-POOR-POOR-MEDIUM-GOOD': 5.71,
    'D-VVS2-POOR-VG-STRONG-POOR': 5.71,
    'D-VS2-EX-POOR-MEDIUM-POOR': 5.71,
    'D-VS2-GOOD-VG-MEDIUM-POOR': 5.71,
    'E-VS2-POOR-EX-FAINT-POOR': 5.71,
    'E-VVS2-GOOD-GOOD-MEDIUM-POOR': 5.71,
    'E-VS2-GOOD-VG-FAINT-POOR': 5.71,
    'E-VS2-EX-POOR-FAINT-POOR': 5.71,
    'E-VVS2-POOR-VG-MEDIUM-POOR': 5.71,
    'E-VS2-VG-GOOD-FAINT-POOR': 5.71,
    'E-VS2-POOR-POOR-FAINT-GOOD': 5.71,
    'E-VVS2-VG-POOR-MEDIUM-POOR': 5.71,
    'F-VS2-POOR-POOR-NONE-GOOD': 5.71,
    'F-VS2-GOOD-VG-NONE-POOR': 5.71,
    'F-VS2-VG-GOOD-NONE-POOR': 5.71,
    'F-VVS2-POOR-VG-FAINT-POOR': 5.71,
    'F-VVS2-GOOD-GOOD-FAINT-POOR': 5.71,
    'F-VVS2-VG-POOR-FAINT-POOR': 5.71,
    'F-VS2-EX-POOR-NONE-POOR': 5.71,
    'F-VS2-POOR-EX-NONE-POOR': 5.71,
    'G-VVS2-GOOD-GOOD-NONE-POOR': 5.71,
    'G-VVS2-POOR-VG-NONE-POOR': 5.71,
    'G-VVS2-VG-POOR-NONE-POOR': 5.71,
    'H-VS2-VG-VG-STRONG-GOOD': 5.71,
    'H-VS2-GOOD-POOR-STRONG-VG': 5.71,
    'H-VS2-EX-GOOD-STRONG-GOOD': 5.71,
    'H-VS2-POOR-GOOD-STRONG-VG': 5.71,
    'H-VS2-GOOD-EX-STRONG-GOOD': 5.71,
    'I-VS2-POOR-GOOD-MEDIUM-VG': 5.71,
    'I-VS2-GOOD-POOR-MEDIUM-VG': 5.71,
    'I-VVS2-EX-EX-STRONG-POOR': 5.71,
    'I-VVS2-EX-POOR-STRONG-GOOD': 5.71,
    'I-VS2-GOOD-EX-MEDIUM-GOOD': 5.71,
    'I-VVS2-POOR-POOR-STRONG-VG': 5.71,
    'I-VVS2-POOR-EX-STRONG-GOOD': 5.71,
    'I-VS2-EX-GOOD-MEDIUM-GOOD': 5.71,
    'I-VS2-VG-VG-MEDIUM-GOOD': 5.71,
    'I-VVS2-GOOD-VG-STRONG-GOOD': 5.71,
    'I-VVS2-VG-GOOD-STRONG-GOOD': 5.71,
    'J-VVS2-POOR-POOR-MEDIUM-VG': 5.71,
    'J-VS2-POOR-GOOD-FAINT-VG': 5.71,
    'J-VVS2-POOR-EX-MEDIUM-GOOD': 5.71,
    'J-VVS2-EX-POOR-MEDIUM-GOOD': 5.71,
    'J-VS2-VG-VG-FAINT-GOOD': 5.71,
    'J-VS2-GOOD-POOR-FAINT-VG': 5.71,
    'J-VS2-EX-GOOD-FAINT-GOOD': 5.71,
    'J-VVS2-EX-EX-MEDIUM-POOR': 5.71,
    'J-VVS2-GOOD-VG-MEDIUM-GOOD': 5.71,
    'J-VVS2-VG-GOOD-MEDIUM-GOOD': 5.71,
    'J-VS2-GOOD-EX-FAINT-GOOD': 5.71,
    'K-VVS2-POOR-POOR-FAINT-VG': 5.71,
    'K-VVS2-POOR-EX-FAINT-GOOD': 5.71,
    'K-VS2-GOOD-EX-NONE-GOOD': 5.71,
    'K-VVS2-GOOD-VG-FAINT-GOOD': 5.71,
    'K-VS2-VG-VG-NONE-GOOD': 5.71,
    'K-VVS2-VG-GOOD-FAINT-GOOD': 5.71,
    'K-VS2-GOOD-POOR-NONE-VG': 5.71,
    'K-VVS2-EX-EX-FAINT-POOR': 5.71,
    'K-VS2-POOR-GOOD-NONE-VG': 5.71,
    'K-VS2-EX-GOOD-NONE-GOOD': 5.71,
    'K-VVS2-EX-POOR-FAINT-GOOD': 5.71,
    'L-VVS2-POOR-POOR-NONE-VG': 5.71,
    'L-VVS2-EX-EX-NONE-POOR': 5.71,
    'L-VVS2-EX-POOR-NONE-GOOD': 5.71,
    'L-VVS2-VG-GOOD-NONE-GOOD': 5.71,
    'L-VVS2-GOOD-VG-NONE-GOOD': 5.71,
    'L-VVS2-POOR-EX-NONE-GOOD': 5.71,
    'M-VS2-VG-EX-STRONG-VG': 5.71,
    'M-VS2-GOOD-GOOD-STRONG-EX': 5.71,
    'M-VS2-VG-POOR-STRONG-EX': 5.71,
    'M-VS2-POOR-VG-STRONG-EX': 5.71,
    'M-VS2-EX-VG-STRONG-VG': 5.71,
    'E-IF-POOR-GOOD-STRONG-POOR': 5.7,
    'E-IF-GOOD-POOR-STRONG-POOR': 5.7,
    'F-IF-POOR-GOOD-MEDIUM-POOR': 5.7,
    'F-IF-GOOD-POOR-MEDIUM-POOR': 5.7,
    'G-IF-GOOD-POOR-FAINT-POOR': 5.7,
    'G-IF-POOR-GOOD-FAINT-POOR': 5.7,
    'H-IF-GOOD-POOR-NONE-POOR': 5.7,
    'H-IF-POOR-GOOD-NONE-POOR': 5.7,
    'J-IF-EX-VG-STRONG-POOR': 5.7,
    'J-IF-POOR-VG-STRONG-GOOD': 5.7,
    'J-IF-GOOD-GOOD-STRONG-GOOD': 5.7,
    'J-IF-VG-POOR-STRONG-GOOD': 5.7,
    'J-IF-VG-EX-STRONG-POOR': 5.7,
    'K-IF-EX-VG-MEDIUM-POOR': 5.7,
    'K-IF-POOR-VG-MEDIUM-GOOD': 5.7,
    'K-IF-GOOD-GOOD-MEDIUM-GOOD': 5.7,
    'K-IF-VG-POOR-MEDIUM-GOOD': 5.7,
    'K-IF-VG-EX-MEDIUM-POOR': 5.7,
    'L-IF-EX-VG-FAINT-POOR': 5.7,
    'L-IF-GOOD-GOOD-FAINT-GOOD': 5.7,
    'L-IF-POOR-VG-FAINT-GOOD': 5.7,
    'L-IF-VG-EX-FAINT-POOR': 5.7,
    'L-IF-VG-POOR-FAINT-GOOD': 5.7,
    'M-IF-POOR-VG-NONE-GOOD': 5.7,
    'M-IF-EX-VG-NONE-POOR': 5.7,
    'M-IF-VG-POOR-NONE-GOOD': 5.7,
    'M-IF-GOOD-GOOD-NONE-GOOD': 5.7,
    'M-IF-VG-EX-NONE-POOR': 5.7,
    'D-SI1-POOR-POOR-FAINT-GOOD': 5.69,
    'D-SI1-POOR-EX-FAINT-POOR': 5.69,
    'D-SI1-EX-POOR-FAINT-POOR': 5.69,
    'D-I1-GOOD-POOR-NONE-GOOD': 5.69,
    'D-I1-GOOD-EX-NONE-POOR': 5.69,
    'D-I1-VG-VG-NONE-POOR': 5.69,
    'D-I1-EX-GOOD-NONE-POOR': 5.69,
    'D-SI1-GOOD-VG-FAINT-POOR': 5.69,
    'D-I1-POOR-GOOD-NONE-GOOD': 5.69,
    'D-SI1-VG-GOOD-FAINT-POOR': 5.69,
    'E-SI1-EX-POOR-NONE-POOR': 5.69,
    'E-SI1-VG-GOOD-NONE-POOR': 5.69,
    'E-SI1-GOOD-VG-NONE-POOR': 5.69,
    'E-SI1-POOR-EX-NONE-POOR': 5.69,
    'E-SI1-POOR-POOR-NONE-GOOD': 5.69,
    'F-I1-EX-VG-STRONG-GOOD': 5.69,
    'F-I1-VG-EX-STRONG-GOOD': 5.69,
    'F-I1-VG-POOR-STRONG-VG': 5.69,
    'F-I1-GOOD-GOOD-STRONG-VG': 5.69,
    'F-I1-POOR-VG-STRONG-VG': 5.69,
    'G-SI1-POOR-GOOD-STRONG-VG': 5.69,
    'G-SI1-VG-VG-STRONG-GOOD': 5.69,
    'G-SI1-GOOD-EX-STRONG-GOOD': 5.69,
    'G-SI1-GOOD-POOR-STRONG-VG': 5.69,
    'G-SI1-EX-GOOD-STRONG-GOOD': 5.69,
    'G-I1-VG-POOR-MEDIUM-VG': 5.69,
    'G-I1-VG-EX-MEDIUM-GOOD': 5.69,
    'G-I1-POOR-VG-MEDIUM-VG': 5.69,
    'G-I1-GOOD-GOOD-MEDIUM-VG': 5.69,
    'G-I1-EX-VG-MEDIUM-GOOD': 5.69,
    'H-I1-VG-EX-FAINT-GOOD': 5.69,
    'H-SI1-VG-VG-MEDIUM-GOOD': 5.69,
    'H-SI1-EX-GOOD-MEDIUM-GOOD': 5.69,
    'H-I1-EX-VG-FAINT-GOOD': 5.69,
    'H-I1-VG-POOR-FAINT-VG': 5.69,
    'H-I1-POOR-VG-FAINT-VG': 5.69,
    'H-I1-GOOD-GOOD-FAINT-VG': 5.69,
    'H-SI1-POOR-GOOD-MEDIUM-VG': 5.69,
    'H-SI1-GOOD-POOR-MEDIUM-VG': 5.69,
    'H-SI1-GOOD-EX-MEDIUM-GOOD': 5.69,
    'I-I1-VG-POOR-NONE-VG': 5.69,
    'I-I1-VG-EX-NONE-GOOD': 5.69,
    'I-I1-POOR-VG-NONE-VG': 5.69,
    'I-I1-GOOD-GOOD-NONE-VG': 5.69,
    'I-I1-EX-VG-NONE-GOOD': 5.69,
    'I-SI1-VG-VG-FAINT-GOOD': 5.69,
    'I-SI1-EX-GOOD-FAINT-GOOD': 5.69,
    'I-SI1-GOOD-EX-FAINT-GOOD': 5.69,
    'I-SI1-POOR-GOOD-FAINT-VG': 5.69,
    'I-SI1-GOOD-POOR-FAINT-VG': 5.69,
    'J-SI1-POOR-GOOD-NONE-VG': 5.69,
    'J-SI1-GOOD-POOR-NONE-VG': 5.69,
    'J-SI1-GOOD-EX-NONE-GOOD': 5.69,
    'J-SI1-VG-VG-NONE-GOOD': 5.69,
    'J-SI1-EX-GOOD-NONE-GOOD': 5.69,
    'K-I1-EX-EX-STRONG-VG': 5.69,
    'K-I1-EX-POOR-STRONG-EX': 5.69,
    'K-I1-VG-GOOD-STRONG-EX': 5.69,
    'K-I1-GOOD-VG-STRONG-EX': 5.69,
    'K-I1-POOR-EX-STRONG-EX': 5.69,
    'L-I1-POOR-EX-MEDIUM-EX': 5.69,
    'L-I1-EX-EX-MEDIUM-VG': 5.69,
    'L-I1-EX-POOR-MEDIUM-EX': 5.69,
    'L-I1-VG-GOOD-MEDIUM-EX': 5.69,
    'L-I1-GOOD-VG-MEDIUM-EX': 5.69,
    'L-SI1-VG-EX-STRONG-VG': 5.69,
    'L-SI1-VG-POOR-STRONG-EX': 5.69,
    'L-SI1-GOOD-GOOD-STRONG-EX': 5.69,
    'L-SI1-POOR-VG-STRONG-EX': 5.69,
    'L-SI1-EX-VG-STRONG-VG': 5.69,
    'M-I1-VG-GOOD-FAINT-EX': 5.69,
    'M-I1-EX-EX-FAINT-VG': 5.69,
    'M-I1-GOOD-VG-FAINT-EX': 5.69,
    'M-I1-EX-POOR-FAINT-EX': 5.69,
    'M-I1-POOR-EX-FAINT-EX': 5.69,
    'M-SI1-EX-VG-MEDIUM-VG': 5.69,
    'M-SI1-VG-EX-MEDIUM-VG': 5.69,
    'M-SI1-VG-POOR-MEDIUM-EX': 5.69,
    'M-SI1-GOOD-GOOD-MEDIUM-EX': 5.69,
    'M-SI1-POOR-VG-MEDIUM-EX': 5.69,
    'D-VS1-POOR-VG-MEDIUM-POOR': 5.68,
    'D-VS1-GOOD-GOOD-MEDIUM-POOR': 5.68,
    'D-VS1-VG-POOR-MEDIUM-POOR': 5.68,
    'D-VVS1-GOOD-POOR-STRONG-POOR': 5.68,
    'D-VVS1-POOR-GOOD-STRONG-POOR': 5.68,
    'E-VVS1-GOOD-POOR-MEDIUM-POOR': 5.68,
    'E-VVS1-POOR-GOOD-MEDIUM-POOR': 5.68,
    'E-VS1-POOR-VG-FAINT-POOR': 5.68,
    'E-VS1-GOOD-GOOD-FAINT-POOR': 5.68,
    'E-VS1-VG-POOR-FAINT-POOR': 5.68,
    'F-VS1-POOR-VG-NONE-POOR': 5.68,
    'F-VS1-VG-POOR-NONE-POOR': 5.68,
    'F-VS1-GOOD-GOOD-NONE-POOR': 5.68,
    'F-VVS1-GOOD-POOR-FAINT-POOR': 5.68,
    'F-VVS1-POOR-GOOD-FAINT-POOR': 5.68,
    'G-VVS1-POOR-GOOD-NONE-POOR': 5.68,
    'G-VVS1-GOOD-POOR-NONE-POOR': 5.68,
    'H-VS1-POOR-EX-STRONG-GOOD': 5.68,
    'H-VS1-GOOD-VG-STRONG-GOOD': 5.68,
    'H-VS1-POOR-POOR-STRONG-VG': 5.68,
    'H-VS1-EX-POOR-STRONG-GOOD': 5.68,
    'H-VS1-VG-GOOD-STRONG-GOOD': 5.68,
    'H-VS1-EX-EX-STRONG-POOR': 5.68,
    'I-VS1-EX-POOR-MEDIUM-GOOD': 5.68,
    'I-VS1-EX-EX-MEDIUM-POOR': 5.68,
    'I-VS1-VG-GOOD-MEDIUM-GOOD': 5.68,
    'I-VS1-GOOD-VG-MEDIUM-GOOD': 5.68,
    'I-VS1-POOR-EX-MEDIUM-GOOD': 5.68,
    'I-VS1-POOR-POOR-MEDIUM-VG': 5.68,
    'I-VVS1-VG-POOR-STRONG-GOOD': 5.68,
    'I-VVS1-POOR-VG-STRONG-GOOD': 5.68,
    'I-VVS1-GOOD-GOOD-STRONG-GOOD': 5.68,
    'I-VVS1-VG-EX-STRONG-POOR': 5.68,
    'I-VVS1-EX-VG-STRONG-POOR': 5.68,
    'J-VVS1-GOOD-GOOD-MEDIUM-GOOD': 5.68,
    'J-VVS1-POOR-VG-MEDIUM-GOOD': 5.68,
    'J-VVS1-EX-VG-MEDIUM-POOR': 5.68,
    'J-VVS1-VG-EX-MEDIUM-POOR': 5.68,
    'J-VVS1-VG-POOR-MEDIUM-GOOD': 5.68,
    'J-VS1-EX-EX-FAINT-POOR': 5.68,
    'J-VS1-EX-POOR-FAINT-GOOD': 5.68,
    'J-VS1-VG-GOOD-FAINT-GOOD': 5.68,
    'J-VS1-POOR-EX-FAINT-GOOD': 5.68,
    'J-VS1-GOOD-VG-FAINT-GOOD': 5.68,
    'J-VS1-POOR-POOR-FAINT-VG': 5.68,
    'K-VVS1-VG-EX-FAINT-POOR': 5.68,
    'K-VVS1-VG-POOR-FAINT-GOOD': 5.68,
    'K-VVS1-GOOD-GOOD-FAINT-GOOD': 5.68,
    'K-VVS1-EX-VG-FAINT-POOR': 5.68,
    'K-VVS1-POOR-VG-FAINT-GOOD': 5.68,
    'K-VS1-POOR-POOR-NONE-VG': 5.68,
    'K-VS1-POOR-EX-NONE-GOOD': 5.68,
    'K-VS1-GOOD-VG-NONE-GOOD': 5.68,
    'K-VS1-VG-GOOD-NONE-GOOD': 5.68,
    'K-VS1-EX-POOR-NONE-GOOD': 5.68,
    'K-VS1-EX-EX-NONE-POOR': 5.68,
    'L-VVS1-POOR-VG-NONE-GOOD': 5.68,
    'L-VVS1-GOOD-GOOD-NONE-GOOD': 5.68,
    'L-VVS1-VG-POOR-NONE-GOOD': 5.68,
    'L-VVS1-VG-EX-NONE-POOR': 5.68,
    'L-VVS1-EX-VG-NONE-POOR': 5.68,
    'M-VS1-POOR-GOOD-STRONG-EX': 5.68,
    'M-VS1-GOOD-POOR-STRONG-EX': 5.68,
    'M-VS1-VG-VG-STRONG-VG': 5.68,
    'M-VS1-GOOD-EX-STRONG-VG': 5.68,
    'M-VS1-EX-GOOD-STRONG-VG': 5.68,
    'D-SI2-GOOD-VG-NONE-POOR': 5.67,
    'D-SI2-VG-GOOD-NONE-POOR': 5.67,
    'D-SI2-EX-POOR-NONE-POOR': 5.67,
    'D-SI2-POOR-EX-NONE-POOR': 5.67,
    'D-SI2-POOR-POOR-NONE-GOOD': 5.67,
    'E-I2-POOR-VG-STRONG-VG': 5.67,
    'E-I2-EX-VG-STRONG-GOOD': 5.67,
    'E-I2-GOOD-GOOD-STRONG-VG': 5.67,
    'E-I2-VG-POOR-STRONG-VG': 5.67,
    'E-I2-VG-EX-STRONG-GOOD': 5.67,
    'F-I2-VG-EX-MEDIUM-GOOD': 5.67,
    'F-I2-VG-POOR-MEDIUM-VG': 5.67,
    'F-I2-GOOD-GOOD-MEDIUM-VG': 5.67,
    'F-I2-POOR-VG-MEDIUM-VG': 5.67,
    'F-SI2-POOR-GOOD-STRONG-VG': 5.67,
    'F-SI2-GOOD-POOR-STRONG-VG': 5.67,
    'F-SI2-GOOD-EX-STRONG-GOOD': 5.67,
    'F-SI2-VG-VG-STRONG-GOOD': 5.67,
    'F-SI2-EX-GOOD-STRONG-GOOD': 5.67,
    'F-I2-EX-VG-MEDIUM-GOOD': 5.67,
    'G-SI2-VG-VG-MEDIUM-GOOD': 5.67,
    'G-SI2-POOR-GOOD-MEDIUM-VG': 5.67,
    'G-SI2-GOOD-POOR-MEDIUM-VG': 5.67,
    'G-I2-POOR-VG-FAINT-VG': 5.67,
    'G-I2-EX-VG-FAINT-GOOD': 5.67,
    'G-I2-GOOD-GOOD-FAINT-VG': 5.67,
    'G-I2-VG-POOR-FAINT-VG': 5.67,
    'G-I2-VG-EX-FAINT-GOOD': 5.67,
    'G-SI2-EX-GOOD-MEDIUM-GOOD': 5.67,
    'G-SI2-GOOD-EX-MEDIUM-GOOD': 5.67,
    'H-SI2-POOR-GOOD-FAINT-VG': 5.67,
    'H-SI2-GOOD-POOR-FAINT-VG': 5.67,
    'H-SI2-GOOD-EX-FAINT-GOOD': 5.67,
    'H-SI2-VG-VG-FAINT-GOOD': 5.67,
    'H-I2-POOR-VG-NONE-VG': 5.67,
    'H-I2-GOOD-GOOD-NONE-VG': 5.67,
    'H-I2-EX-VG-NONE-GOOD': 5.67,
    'H-I2-VG-EX-NONE-GOOD': 5.67,
    'H-I2-VG-POOR-NONE-VG': 5.67,
    'H-SI2-EX-GOOD-FAINT-GOOD': 5.67,
    'I-SI2-EX-GOOD-NONE-GOOD': 5.67,
    'I-SI2-GOOD-POOR-NONE-VG': 5.67,
    'I-SI2-VG-VG-NONE-GOOD': 5.67,
    'I-SI2-POOR-GOOD-NONE-VG': 5.67,
    'I-SI2-GOOD-EX-NONE-GOOD': 5.67,
    'J-I2-VG-GOOD-STRONG-EX': 5.67,
    'J-I2-EX-POOR-STRONG-EX': 5.67,
    'J-I2-GOOD-VG-STRONG-EX': 5.67,
    'J-I2-POOR-EX-STRONG-EX': 5.67,
    'J-I2-EX-EX-STRONG-VG': 5.67,
    'K-I2-POOR-EX-MEDIUM-EX': 5.67,
    'K-I2-GOOD-VG-MEDIUM-EX': 5.67,
    'K-I2-EX-EX-MEDIUM-VG': 5.67,
    'K-I2-EX-POOR-MEDIUM-EX': 5.67,
    'K-I2-VG-GOOD-MEDIUM-EX': 5.67,
    'K-SI2-VG-EX-STRONG-VG': 5.67,
    'K-SI2-VG-POOR-STRONG-EX': 5.67,
    'K-SI2-GOOD-GOOD-STRONG-EX': 5.67,
    'K-SI2-POOR-VG-STRONG-EX': 5.67,
    'K-SI2-EX-VG-STRONG-VG': 5.67,
    'L-SI2-GOOD-GOOD-MEDIUM-EX': 5.67,
    'L-SI2-EX-VG-MEDIUM-VG': 5.67,
    'L-SI2-VG-EX-MEDIUM-VG': 5.67,
    'L-SI2-VG-POOR-MEDIUM-EX': 5.67,
    'L-SI2-POOR-VG-MEDIUM-EX': 5.67,
    'L-I2-GOOD-VG-FAINT-EX': 5.67,
    'L-I2-EX-POOR-FAINT-EX': 5.67,
    'L-I2-EX-EX-FAINT-VG': 5.67,
    'L-I2-VG-GOOD-FAINT-EX': 5.67,
    'L-I2-POOR-EX-FAINT-EX': 5.67,
    'M-SI2-VG-EX-FAINT-VG': 5.67,
    'M-I2-POOR-EX-NONE-EX': 5.67,
    'M-I2-GOOD-VG-NONE-EX': 5.67,
    'M-SI2-POOR-VG-FAINT-EX': 5.67,
    'M-SI2-EX-VG-FAINT-VG': 5.67,
    'M-I2-EX-POOR-NONE-EX': 5.67,
    'M-I2-EX-EX-NONE-VG': 5.67,
    'M-I2-VG-GOOD-NONE-EX': 5.67,
    'M-SI2-VG-POOR-FAINT-EX': 5.67,
    'M-SI2-GOOD-GOOD-FAINT-EX': 5.67,
    'D-VS2-GOOD-GOOD-FAINT-POOR': 5.66,
    'D-VS2-POOR-VG-FAINT-POOR': 5.66,
    'D-VS2-VG-POOR-FAINT-POOR': 5.66,
    'D-VVS2-POOR-GOOD-MEDIUM-POOR': 5.66,
    'D-VVS2-GOOD-POOR-MEDIUM-POOR': 5.66,
    'E-VVS2-GOOD-POOR-FAINT-POOR': 5.66,
    'E-VS2-POOR-VG-NONE-POOR': 5.66,
    'E-VVS2-POOR-GOOD-FAINT-POOR': 5.66,
    'E-VS2-VG-POOR-NONE-POOR': 5.66,
    'E-VS2-GOOD-GOOD-NONE-POOR': 5.66,
    'F-VVS2-POOR-GOOD-NONE-POOR': 5.66,
    'F-VVS2-GOOD-POOR-NONE-POOR': 5.66,
    'G-VS2-POOR-POOR-STRONG-VG': 5.66,
    'G-VS2-VG-GOOD-STRONG-GOOD': 5.66,
    'G-VS2-GOOD-VG-STRONG-GOOD': 5.66,
    'G-VS2-POOR-EX-STRONG-GOOD': 5.66,
    'G-VS2-EX-EX-STRONG-POOR': 5.66,
    'G-VS2-EX-POOR-STRONG-GOOD': 5.66,
    'H-VS2-GOOD-VG-MEDIUM-GOOD': 5.66,
    'H-VVS2-VG-EX-STRONG-POOR': 5.66,
    'H-VS2-EX-POOR-MEDIUM-GOOD': 5.66,
    'H-VS2-POOR-EX-MEDIUM-GOOD': 5.66,
    'H-VS2-POOR-POOR-MEDIUM-VG': 5.66,
    'H-VS2-EX-EX-MEDIUM-POOR': 5.66,
    'H-VVS2-EX-VG-STRONG-POOR': 5.66,
    'H-VS2-VG-GOOD-MEDIUM-GOOD': 5.66,
    'H-VVS2-GOOD-GOOD-STRONG-GOOD': 5.66,
    'H-VVS2-VG-POOR-STRONG-GOOD': 5.66,
    'H-VVS2-POOR-VG-STRONG-GOOD': 5.66,
    'I-VS2-EX-POOR-FAINT-GOOD': 5.66,
    'I-VS2-VG-GOOD-FAINT-GOOD': 5.66,
    'I-VS2-POOR-EX-FAINT-GOOD': 5.66,
    'I-VS2-POOR-POOR-FAINT-VG': 5.66,
    'I-VVS2-POOR-VG-MEDIUM-GOOD': 5.66,
    'I-VVS2-GOOD-GOOD-MEDIUM-GOOD': 5.66,
    'I-VVS2-VG-POOR-MEDIUM-GOOD': 5.66,
    'I-VVS2-VG-EX-MEDIUM-POOR': 5.66,
    'I-VVS2-EX-VG-MEDIUM-POOR': 5.66,
    'I-VS2-GOOD-VG-FAINT-GOOD': 5.66,
    'I-VS2-EX-EX-FAINT-POOR': 5.66,
    'J-VVS2-GOOD-GOOD-FAINT-GOOD': 5.66,
    'J-VVS2-VG-POOR-FAINT-GOOD': 5.66,
    'J-VVS2-VG-EX-FAINT-POOR': 5.66,
    'J-VS2-POOR-EX-NONE-GOOD': 5.66,
    'J-VVS2-EX-VG-FAINT-POOR': 5.66,
    'J-VVS2-POOR-VG-FAINT-GOOD': 5.66,
    'J-VS2-POOR-POOR-NONE-VG': 5.66,
    'J-VS2-GOOD-VG-NONE-GOOD': 5.66,
    'J-VS2-EX-EX-NONE-POOR': 5.66,
    'J-VS2-VG-GOOD-NONE-GOOD': 5.66,
    'J-VS2-EX-POOR-NONE-GOOD': 5.66,
    'K-VVS2-EX-VG-NONE-POOR': 5.66,
    'K-VVS2-VG-EX-NONE-POOR': 5.66,
    'K-VVS2-VG-POOR-NONE-GOOD': 5.66,
    'K-VVS2-GOOD-GOOD-NONE-GOOD': 5.66,
    'K-VVS2-POOR-VG-NONE-GOOD': 5.66,
    'L-VS2-VG-VG-STRONG-VG': 5.66,
    'L-VS2-GOOD-POOR-STRONG-EX': 5.66,
    'L-VS2-GOOD-EX-STRONG-VG': 5.66,
    'L-VS2-POOR-GOOD-STRONG-EX': 5.66,
    'L-VS2-EX-GOOD-STRONG-VG': 5.66,
    'M-VS2-VG-VG-MEDIUM-VG': 5.66,
    'M-VS2-POOR-GOOD-MEDIUM-EX': 5.66,
    'M-VVS2-EX-POOR-STRONG-VG': 5.66,
    'M-VVS2-POOR-POOR-STRONG-EX': 5.66,
    'M-VVS2-POOR-EX-STRONG-VG': 5.66,
    'M-VVS2-GOOD-VG-STRONG-VG': 5.66,
    'M-VVS2-EX-EX-STRONG-GOOD': 5.66,
    'M-VVS2-VG-GOOD-STRONG-VG': 5.66,
    'M-VS2-GOOD-EX-MEDIUM-VG': 5.66,
    'M-VS2-EX-GOOD-MEDIUM-VG': 5.66,
    'M-VS2-GOOD-POOR-MEDIUM-EX': 5.66,
    'D-IF-POOR-POOR-STRONG-POOR': 5.65,
    'E-IF-POOR-POOR-MEDIUM-POOR': 5.65,
    'F-IF-POOR-POOR-FAINT-POOR': 5.65,
    'G-IF-POOR-POOR-NONE-POOR': 5.65,
    'I-IF-EX-GOOD-STRONG-POOR': 5.65,
    'I-IF-VG-VG-STRONG-POOR': 5.65,
    'I-IF-GOOD-POOR-STRONG-GOOD': 5.65,
    'I-IF-POOR-GOOD-STRONG-GOOD': 5.65,
    'I-IF-GOOD-EX-STRONG-POOR': 5.65,
    'J-IF-EX-GOOD-MEDIUM-POOR': 5.65,
    'J-IF-VG-VG-MEDIUM-POOR': 5.65,
    'J-IF-POOR-GOOD-MEDIUM-GOOD': 5.65,
    'J-IF-GOOD-EX-MEDIUM-POOR': 5.65,
    'J-IF-GOOD-POOR-MEDIUM-GOOD': 5.65,
    'K-IF-GOOD-POOR-FAINT-GOOD': 5.65,
    'K-IF-EX-GOOD-FAINT-POOR': 5.65,
    'K-IF-POOR-GOOD-FAINT-GOOD': 5.65,
    'K-IF-GOOD-EX-FAINT-POOR': 5.65,
    'K-IF-VG-VG-FAINT-POOR': 5.65,
    'L-IF-GOOD-EX-NONE-POOR': 5.65,
    'L-IF-VG-VG-NONE-POOR': 5.65,
    'L-IF-EX-GOOD-NONE-POOR': 5.65,
    'L-IF-POOR-GOOD-NONE-GOOD': 5.65,
    'L-IF-GOOD-POOR-NONE-GOOD': 5.65,
    'D-SI1-GOOD-GOOD-NONE-POOR': 5.64,
    'D-SI1-POOR-VG-NONE-POOR': 5.64,
    'D-SI1-VG-POOR-NONE-POOR': 5.64,
    'E-I1-POOR-GOOD-STRONG-VG': 5.64,
    'E-I1-GOOD-POOR-STRONG-VG': 5.64,
    'E-I1-EX-GOOD-STRONG-GOOD': 5.64,
    'E-I1-VG-VG-STRONG-GOOD': 5.64,
    'E-I1-GOOD-EX-STRONG-GOOD': 5.64,
    'F-SI1-POOR-EX-STRONG-GOOD': 5.64,
    'F-I1-GOOD-POOR-MEDIUM-VG': 5.64,
    'F-SI1-POOR-POOR-STRONG-VG': 5.64,
    'F-I1-GOOD-EX-MEDIUM-GOOD': 5.64,
    'F-I1-VG-VG-MEDIUM-GOOD': 5.64,
    'F-I1-POOR-GOOD-MEDIUM-VG': 5.64,
    'F-I1-EX-GOOD-MEDIUM-GOOD': 5.64,
    'F-SI1-EX-EX-STRONG-POOR': 5.64,
    'F-SI1-EX-POOR-STRONG-GOOD': 5.64,
    'F-SI1-GOOD-VG-STRONG-GOOD': 5.64,
    'F-SI1-VG-GOOD-STRONG-GOOD': 5.64,
    'G-SI1-VG-GOOD-MEDIUM-GOOD': 5.64,
    'G-SI1-EX-POOR-MEDIUM-GOOD': 5.64,
    'G-SI1-POOR-POOR-MEDIUM-VG': 5.64,
    'G-SI1-POOR-EX-MEDIUM-GOOD': 5.64,
    'G-I1-POOR-GOOD-FAINT-VG': 5.64,
    'G-I1-VG-VG-FAINT-GOOD': 5.64,
    'G-SI1-EX-EX-MEDIUM-POOR': 5.64,
    'G-I1-GOOD-EX-FAINT-GOOD': 5.64,
    'G-SI1-GOOD-VG-MEDIUM-GOOD': 5.64,
    'G-I1-GOOD-POOR-FAINT-VG': 5.64,
    'G-I1-EX-GOOD-FAINT-GOOD': 5.64,
    'H-I1-VG-VG-NONE-GOOD': 5.64,
    'H-I1-GOOD-EX-NONE-GOOD': 5.64,
    'H-I1-GOOD-POOR-NONE-VG': 5.64,
    'H-I1-POOR-GOOD-NONE-VG': 5.64,
    'H-SI1-EX-EX-FAINT-POOR': 5.64,
    'H-SI1-GOOD-VG-FAINT-GOOD': 5.64,
    'H-SI1-POOR-EX-FAINT-GOOD': 5.64,
    'H-SI1-EX-POOR-FAINT-GOOD': 5.64,
    'H-SI1-VG-GOOD-FAINT-GOOD': 5.64,
    'H-SI1-POOR-POOR-FAINT-VG': 5.64,
    'H-I1-EX-GOOD-NONE-GOOD': 5.64,
    'I-SI1-EX-POOR-NONE-GOOD': 5.64,
    'I-SI1-EX-EX-NONE-POOR': 5.64,
    'I-SI1-POOR-POOR-NONE-VG': 5.64,
    'I-SI1-VG-GOOD-NONE-GOOD': 5.64,
    'I-SI1-POOR-EX-NONE-GOOD': 5.64,
    'I-SI1-GOOD-VG-NONE-GOOD': 5.64,
    'J-I1-VG-POOR-STRONG-EX': 5.64,
    'J-I1-POOR-VG-STRONG-EX': 5.64,
    'J-I1-GOOD-GOOD-STRONG-EX': 5.64,
    'J-I1-VG-EX-STRONG-VG': 5.64,
    'J-I1-EX-VG-STRONG-VG': 5.64,
    'K-I1-POOR-VG-MEDIUM-EX': 5.64,
    'K-I1-GOOD-GOOD-MEDIUM-EX': 5.64,
    'K-I1-VG-POOR-MEDIUM-EX': 5.64,
    'K-I1-VG-EX-MEDIUM-VG': 5.64,
    'K-I1-EX-VG-MEDIUM-VG': 5.64,
    'K-SI1-POOR-GOOD-STRONG-EX': 5.64,
    'K-SI1-EX-GOOD-STRONG-VG': 5.64,
    'K-SI1-GOOD-EX-STRONG-VG': 5.64,
    'K-SI1-VG-VG-STRONG-VG': 5.64,
    'K-SI1-GOOD-POOR-STRONG-EX': 5.64,
    'L-SI1-GOOD-POOR-MEDIUM-EX': 5.64,
    'L-I1-EX-VG-FAINT-VG': 5.64,
    'L-I1-VG-EX-FAINT-VG': 5.64,
    'L-I1-VG-POOR-FAINT-EX': 5.64,
    'L-I1-GOOD-GOOD-FAINT-EX': 5.64,
    'L-I1-POOR-VG-FAINT-EX': 5.64,
    'L-SI1-EX-GOOD-MEDIUM-VG': 5.64,
    'L-SI1-VG-VG-MEDIUM-VG': 5.64,
    'L-SI1-POOR-GOOD-MEDIUM-EX': 5.64,
    'L-SI1-GOOD-EX-MEDIUM-VG': 5.64,
    'M-I1-VG-POOR-NONE-EX': 5.64,
    'M-SI1-POOR-GOOD-FAINT-EX': 5.64,
    'M-SI1-GOOD-EX-FAINT-VG': 5.64,
    'M-SI1-GOOD-POOR-FAINT-EX': 5.64,
    'M-I1-POOR-VG-NONE-EX': 5.64,
    'M-I1-GOOD-GOOD-NONE-EX': 5.64,
    'M-SI1-VG-VG-FAINT-VG': 5.64,
    'M-I1-VG-EX-NONE-VG': 5.64,
    'M-SI1-EX-GOOD-FAINT-VG': 5.64,
    'M-I1-EX-VG-NONE-VG': 5.64,
    'D-VVS1-POOR-POOR-MEDIUM-POOR': 5.63,
    'D-VS1-POOR-GOOD-FAINT-POOR': 5.63,
    'D-VS1-GOOD-POOR-FAINT-POOR': 5.63,
    'E-VS1-POOR-GOOD-NONE-POOR': 5.63,
    'E-VS1-GOOD-POOR-NONE-POOR': 5.63,
    'E-VVS1-POOR-POOR-FAINT-POOR': 5.63,
    'F-VVS1-POOR-POOR-NONE-POOR': 5.63,
    'G-VS1-EX-VG-STRONG-POOR': 5.63,
    'G-VS1-VG-EX-STRONG-POOR': 5.63,
    'G-VS1-POOR-VG-STRONG-GOOD': 5.63,
    'G-VS1-GOOD-GOOD-STRONG-GOOD': 5.63,
    'G-VS1-VG-POOR-STRONG-GOOD': 5.63,
    'H-VS1-VG-EX-MEDIUM-POOR': 5.63,
    'H-VS1-EX-VG-MEDIUM-POOR': 5.63,
    'H-VS1-VG-POOR-MEDIUM-GOOD': 5.63,
    'H-VS1-POOR-VG-MEDIUM-GOOD': 5.63,
    'H-VS1-GOOD-GOOD-MEDIUM-GOOD': 5.63,
    'H-VVS1-GOOD-EX-STRONG-POOR': 5.63,
    'H-VVS1-VG-VG-STRONG-POOR': 5.63,
    'H-VVS1-EX-GOOD-STRONG-POOR': 5.63,
    'H-VVS1-POOR-GOOD-STRONG-GOOD': 5.63,
    'H-VVS1-GOOD-POOR-STRONG-GOOD': 5.63,
    'I-VS1-POOR-VG-FAINT-GOOD': 5.63,
    'I-VS1-GOOD-GOOD-FAINT-GOOD': 5.63,
    'I-VVS1-EX-GOOD-MEDIUM-POOR': 5.63,
    'I-VS1-VG-POOR-FAINT-GOOD': 5.63,
    'I-VS1-VG-EX-FAINT-POOR': 5.63,
    'I-VS1-EX-VG-FAINT-POOR': 5.63,
    'I-VVS1-POOR-GOOD-MEDIUM-GOOD': 5.63,
    'I-VVS1-GOOD-POOR-MEDIUM-GOOD': 5.63,
    'I-VVS1-GOOD-EX-MEDIUM-POOR': 5.63,
    'I-VVS1-VG-VG-MEDIUM-POOR': 5.63,
    'J-VVS1-EX-GOOD-FAINT-POOR': 5.63,
    'J-VS1-POOR-VG-NONE-GOOD': 5.63,
    'J-VVS1-VG-VG-FAINT-POOR': 5.63,
    'J-VVS1-GOOD-EX-FAINT-POOR': 5.63,
    'J-VS1-GOOD-GOOD-NONE-GOOD': 5.63,
    'J-VS1-EX-VG-NONE-POOR': 5.63,
    'J-VS1-VG-EX-NONE-POOR': 5.63,
    'J-VVS1-POOR-GOOD-FAINT-GOOD': 5.63,
    'J-VS1-VG-POOR-NONE-GOOD': 5.63,
    'J-VVS1-GOOD-POOR-FAINT-GOOD': 5.63,
    'K-VVS1-GOOD-POOR-NONE-GOOD': 5.63,
    'K-VVS1-POOR-GOOD-NONE-GOOD': 5.63,
    'K-VVS1-GOOD-EX-NONE-POOR': 5.63,
    'K-VVS1-EX-GOOD-NONE-POOR': 5.63,
    'K-VVS1-VG-VG-NONE-POOR': 5.63,
    'L-VS1-GOOD-VG-STRONG-VG': 5.63,
    'L-VS1-POOR-EX-STRONG-VG': 5.63,
    'L-VS1-EX-POOR-STRONG-VG': 5.63,
    'L-VS1-VG-GOOD-STRONG-VG': 5.63,
    'L-VS1-POOR-POOR-STRONG-EX': 5.63,
    'L-VS1-EX-EX-STRONG-GOOD': 5.63,
    'M-VVS1-GOOD-GOOD-STRONG-VG': 5.63,
    'M-VVS1-EX-VG-STRONG-GOOD': 5.63,
    'M-VVS1-VG-EX-STRONG-GOOD': 5.63,
    'M-VVS1-VG-POOR-STRONG-VG': 5.63,
    'M-VS1-POOR-EX-MEDIUM-VG': 5.63,
    'M-VS1-VG-GOOD-MEDIUM-VG': 5.63,
    'M-VS1-GOOD-VG-MEDIUM-VG': 5.63,
    'M-VVS1-POOR-VG-STRONG-VG': 5.63,
    'M-VS1-POOR-POOR-MEDIUM-EX': 5.63,
    'M-VS1-EX-POOR-MEDIUM-VG': 5.63,
    'M-VS1-EX-EX-MEDIUM-GOOD': 5.63,
    'D-I2-POOR-GOOD-STRONG-VG': 5.62,
    'D-I2-GOOD-POOR-STRONG-VG': 5.62,
    'D-I2-GOOD-EX-STRONG-GOOD': 5.62,
    'D-I2-EX-GOOD-STRONG-GOOD': 5.62,
    'D-I2-VG-VG-STRONG-GOOD': 5.62,
    'E-SI2-POOR-EX-STRONG-GOOD': 5.62,
    'E-SI2-POOR-POOR-STRONG-VG': 5.62,
    'E-I2-EX-GOOD-MEDIUM-GOOD': 5.62,
    'E-I2-POOR-GOOD-MEDIUM-VG': 5.62,
    'E-SI2-GOOD-VG-STRONG-GOOD': 5.62,
    'E-SI2-VG-GOOD-STRONG-GOOD': 5.62,
    'E-I2-VG-VG-MEDIUM-GOOD': 5.62,
    'E-SI2-EX-EX-STRONG-POOR': 5.62,
    'E-I2-GOOD-EX-MEDIUM-GOOD': 5.62,
    'E-SI2-EX-POOR-STRONG-GOOD': 5.62,
    'E-I2-GOOD-POOR-MEDIUM-VG': 5.62,
    'F-SI2-VG-GOOD-MEDIUM-GOOD': 5.62,
    'F-SI2-POOR-EX-MEDIUM-GOOD': 5.62,
    'F-SI2-EX-EX-MEDIUM-POOR': 5.62,
    'F-SI2-EX-POOR-MEDIUM-GOOD': 5.62,
    'F-SI2-POOR-POOR-MEDIUM-VG': 5.62,
    'F-SI2-GOOD-VG-MEDIUM-GOOD': 5.62,
    'F-I2-GOOD-POOR-FAINT-VG': 5.62,
    'F-I2-GOOD-EX-FAINT-GOOD': 5.62,
    'F-I2-EX-GOOD-FAINT-GOOD': 5.62,
    'F-I2-VG-VG-FAINT-GOOD': 5.62,
    'F-I2-POOR-GOOD-FAINT-VG': 5.62,
    'G-I2-EX-GOOD-NONE-GOOD': 5.62,
    'G-I2-VG-VG-NONE-GOOD': 5.62,
    'G-I2-GOOD-POOR-NONE-VG': 5.62,
    'G-SI2-GOOD-VG-FAINT-GOOD': 5.62,
    'G-I2-POOR-GOOD-NONE-VG': 5.62,
    'G-SI2-POOR-EX-FAINT-GOOD': 5.62,
    'G-I2-GOOD-EX-NONE-GOOD': 5.62,
    'G-SI2-EX-POOR-FAINT-GOOD': 5.62,
    'G-SI2-VG-GOOD-FAINT-GOOD': 5.62,
    'G-SI2-EX-EX-FAINT-POOR': 5.62,
    'G-SI2-POOR-POOR-FAINT-VG': 5.62,
    'H-SI2-EX-POOR-NONE-GOOD': 5.62,
    'H-SI2-VG-GOOD-NONE-GOOD': 5.62,
    'H-SI2-GOOD-VG-NONE-GOOD': 5.62,
    'H-SI2-POOR-POOR-NONE-VG': 5.62,
    'H-SI2-EX-EX-NONE-POOR': 5.62,
    'H-SI2-POOR-EX-NONE-GOOD': 5.62,
    'I-I2-VG-EX-STRONG-VG': 5.62,
    'I-I2-EX-VG-STRONG-VG': 5.62,
    'I-I2-VG-POOR-STRONG-EX': 5.62,
    'I-I2-POOR-VG-STRONG-EX': 5.62,
    'I-I2-GOOD-GOOD-STRONG-EX': 5.62,
    'J-I2-VG-EX-MEDIUM-VG': 5.62,
    'J-SI2-GOOD-EX-STRONG-VG': 5.62,
    'J-SI2-POOR-GOOD-STRONG-EX': 5.62,
    'J-SI2-GOOD-POOR-STRONG-EX': 5.62,
    'J-I2-POOR-VG-MEDIUM-EX': 5.62,
    'J-I2-GOOD-GOOD-MEDIUM-EX': 5.62,
    'J-I2-VG-POOR-MEDIUM-EX': 5.62,
    'J-I2-EX-VG-MEDIUM-VG': 5.62,
    'J-SI2-VG-VG-STRONG-VG': 5.62,
    'J-SI2-EX-GOOD-STRONG-VG': 5.62,
    'K-SI2-GOOD-POOR-MEDIUM-EX': 5.62,
    'K-SI2-POOR-GOOD-MEDIUM-EX': 5.62,
    'K-SI2-EX-GOOD-MEDIUM-VG': 5.62,
    'K-I2-VG-POOR-FAINT-EX': 5.62,
    'K-I2-GOOD-GOOD-FAINT-EX': 5.62,
    'K-I2-POOR-VG-FAINT-EX': 5.62,
    'K-I2-VG-EX-FAINT-VG': 5.62,
    'K-I2-EX-VG-FAINT-VG': 5.62,
    'K-SI2-GOOD-EX-MEDIUM-VG': 5.62,
    'K-SI2-VG-VG-MEDIUM-VG': 5.62,
    'L-SI2-EX-GOOD-FAINT-VG': 5.62,
    'L-SI2-GOOD-POOR-FAINT-EX': 5.62,
    'L-SI2-VG-VG-FAINT-VG': 5.62,
    'L-I2-VG-POOR-NONE-EX': 5.62,
    'L-SI2-GOOD-EX-FAINT-VG': 5.62,
    'L-I2-VG-EX-NONE-VG': 5.62,
    'L-SI2-POOR-GOOD-FAINT-EX': 5.62,
    'L-I2-GOOD-GOOD-NONE-EX': 5.62,
    'L-I2-POOR-VG-NONE-EX': 5.62,
    'L-I2-EX-VG-NONE-VG': 5.62,
    'M-SI2-POOR-GOOD-NONE-EX': 5.62,
    'M-SI2-VG-VG-NONE-VG': 5.62,
    'M-SI2-EX-GOOD-NONE-VG': 5.62,
    'M-SI2-GOOD-POOR-NONE-EX': 5.62,
    'M-SI2-GOOD-EX-NONE-VG': 5.62,
    'D-VS2-POOR-GOOD-NONE-POOR': 5.61,
    'D-VS2-GOOD-POOR-NONE-POOR': 5.61,
    'D-VVS2-POOR-POOR-FAINT-POOR': 5.61,
    'E-VVS2-POOR-POOR-NONE-POOR': 5.61,
    'F-VS2-POOR-VG-STRONG-GOOD': 5.61,
    'F-VS2-GOOD-GOOD-STRONG-GOOD': 5.61,
    'F-VS2-VG-EX-STRONG-POOR': 5.61,
    'F-VS2-EX-VG-STRONG-POOR': 5.61,
    'F-VS2-VG-POOR-STRONG-GOOD': 5.61,
    'G-VS2-VG-POOR-MEDIUM-GOOD': 5.61,
    'G-VS2-EX-VG-MEDIUM-POOR': 5.61,
    'G-VS2-GOOD-GOOD-MEDIUM-GOOD': 5.61,
    'G-VVS2-POOR-GOOD-STRONG-GOOD': 5.61,
    'G-VS2-POOR-VG-MEDIUM-GOOD': 5.61,
    'G-VVS2-GOOD-POOR-STRONG-GOOD': 5.61,
    'G-VS2-VG-EX-MEDIUM-POOR': 5.61,
    'G-VVS2-GOOD-EX-STRONG-POOR': 5.61,
    'G-VVS2-VG-VG-STRONG-POOR': 5.61,
    'G-VVS2-EX-GOOD-STRONG-POOR': 5.61,
    'H-VVS2-VG-VG-MEDIUM-POOR': 5.61,
    'H-VVS2-GOOD-EX-MEDIUM-POOR': 5.61,
    'H-VVS2-POOR-GOOD-MEDIUM-GOOD': 5.61,
    'H-VVS2-GOOD-POOR-MEDIUM-GOOD': 5.61,
    'H-VS2-VG-POOR-FAINT-GOOD': 5.61,
    'H-VS2-POOR-VG-FAINT-GOOD': 5.61,
    'H-VS2-GOOD-GOOD-FAINT-GOOD': 5.61,
    'H-VS2-VG-EX-FAINT-POOR': 5.61,
    'H-VS2-EX-VG-FAINT-POOR': 5.61,
    'H-VVS2-EX-GOOD-MEDIUM-POOR': 5.61,
    'I-VVS2-EX-GOOD-FAINT-POOR': 5.61,
    'I-VS2-POOR-VG-NONE-GOOD': 5.61,
    'I-VVS2-POOR-GOOD-FAINT-GOOD': 5.61,
    'I-VS2-GOOD-GOOD-NONE-GOOD': 5.61,
    'I-VS2-VG-POOR-NONE-GOOD': 5.61,
    'I-VS2-VG-EX-NONE-POOR': 5.61,
    'I-VS2-EX-VG-NONE-POOR': 5.61,
    'I-VVS2-GOOD-POOR-FAINT-GOOD': 5.61,
    'I-VVS2-GOOD-EX-FAINT-POOR': 5.61,
    'I-VVS2-VG-VG-FAINT-POOR': 5.61,
    'J-VVS2-VG-VG-NONE-POOR': 5.61,
    'J-VVS2-EX-GOOD-NONE-POOR': 5.61,
    'J-VVS2-GOOD-EX-NONE-POOR': 5.61,
    'J-VVS2-GOOD-POOR-NONE-GOOD': 5.61,
    'J-VVS2-POOR-GOOD-NONE-GOOD': 5.61,
    'K-VS2-GOOD-VG-STRONG-VG': 5.61,
    'K-VS2-POOR-EX-STRONG-VG': 5.61,
    'K-VS2-POOR-POOR-STRONG-EX': 5.61,
    'K-VS2-VG-GOOD-STRONG-VG': 5.61,
    'K-VS2-EX-POOR-STRONG-VG': 5.61,
    'K-VS2-EX-EX-STRONG-GOOD': 5.61,
    'L-VVS2-EX-VG-STRONG-GOOD': 5.61,
    'L-VVS2-VG-EX-STRONG-GOOD': 5.61,
    'L-VS2-POOR-POOR-MEDIUM-EX': 5.61,
    'L-VS2-POOR-EX-MEDIUM-VG': 5.61,
    'L-VVS2-POOR-VG-STRONG-VG': 5.61,
    'L-VS2-EX-EX-MEDIUM-GOOD': 5.61,
    'L-VVS2-VG-POOR-STRONG-VG': 5.61,
    'L-VS2-EX-POOR-MEDIUM-VG': 5.61,
    'L-VS2-GOOD-VG-MEDIUM-VG': 5.61,
    'L-VVS2-GOOD-GOOD-STRONG-VG': 5.61,
    'L-VS2-VG-GOOD-MEDIUM-VG': 5.61,
    'M-VVS2-EX-VG-MEDIUM-GOOD': 5.61,
    'M-VVS2-VG-POOR-MEDIUM-VG': 5.61,
    'M-VVS2-POOR-VG-MEDIUM-VG': 5.61,
    'M-VVS2-GOOD-GOOD-MEDIUM-VG': 5.61,
    'M-VVS2-VG-EX-MEDIUM-GOOD': 5.61,
    'M-VS2-EX-EX-FAINT-GOOD': 5.61,
    'M-VS2-VG-GOOD-FAINT-VG': 5.61,
    'M-VS2-POOR-POOR-FAINT-EX': 5.61,
    'M-VS2-EX-POOR-FAINT-VG': 5.61,
    'M-VS2-POOR-EX-FAINT-VG': 5.61,
    'M-VS2-GOOD-VG-FAINT-VG': 5.61,
    'H-IF-EX-POOR-STRONG-POOR': 5.6,
    'H-IF-VG-GOOD-STRONG-POOR': 5.6,
    'H-IF-GOOD-VG-STRONG-POOR': 5.6,
    'H-IF-POOR-EX-STRONG-POOR': 5.6,
    'H-IF-POOR-POOR-STRONG-GOOD': 5.6,
    'I-IF-EX-POOR-MEDIUM-POOR': 5.6,
    'I-IF-VG-GOOD-MEDIUM-POOR': 5.6,
    'I-IF-GOOD-VG-MEDIUM-POOR': 5.6,
    'I-IF-POOR-EX-MEDIUM-POOR': 5.6,
    'I-IF-POOR-POOR-MEDIUM-GOOD': 5.6,
    'J-IF-POOR-EX-FAINT-POOR': 5.6,
    'J-IF-POOR-POOR-FAINT-GOOD': 5.6,
    'J-IF-GOOD-VG-FAINT-POOR': 5.6,
    'J-IF-EX-POOR-FAINT-POOR': 5.6,
    'J-IF-VG-GOOD-FAINT-POOR': 5.6,
    'K-IF-POOR-POOR-NONE-GOOD': 5.6,
    'K-IF-GOOD-VG-NONE-POOR': 5.6,
    'K-IF-POOR-EX-NONE-POOR': 5.6,
    'K-IF-EX-POOR-NONE-POOR': 5.6,
    'K-IF-VG-GOOD-NONE-POOR': 5.6,
    'M-IF-GOOD-POOR-STRONG-VG': 5.6,
    'M-IF-EX-GOOD-STRONG-GOOD': 5.6,
    'M-IF-GOOD-EX-STRONG-GOOD': 5.6,
    'M-IF-POOR-GOOD-STRONG-VG': 5.6,
    'M-IF-VG-VG-STRONG-GOOD': 5.6,
    'D-I1-EX-POOR-STRONG-GOOD': 5.59,
    'D-I1-EX-EX-STRONG-POOR': 5.59,
    'D-I1-POOR-EX-STRONG-GOOD': 5.59,
    'D-I1-POOR-POOR-STRONG-VG': 5.59,
    'D-I1-GOOD-VG-STRONG-GOOD': 5.59,
    'D-I1-VG-GOOD-STRONG-GOOD': 5.59,
    'E-I1-EX-POOR-MEDIUM-GOOD': 5.59,
    'E-SI1-GOOD-GOOD-STRONG-GOOD': 5.59,
    'E-SI1-POOR-VG-STRONG-GOOD': 5.59,
    'E-SI1-VG-POOR-STRONG-GOOD': 5.59,
    'E-SI1-EX-VG-STRONG-POOR': 5.59,
    'E-I1-EX-EX-MEDIUM-POOR': 5.59,
    'E-SI1-VG-EX-STRONG-POOR': 5.59,
    'E-I1-GOOD-VG-MEDIUM-GOOD': 5.59,
    'E-I1-VG-GOOD-MEDIUM-GOOD': 5.59,
    'E-I1-POOR-POOR-MEDIUM-VG': 5.59,
    'E-I1-POOR-EX-MEDIUM-GOOD': 5.59,
    'F-I1-GOOD-VG-FAINT-GOOD': 5.59,
    'F-I1-EX-EX-FAINT-POOR': 5.59,
    'F-I1-EX-POOR-FAINT-GOOD': 5.59,
    'F-I1-VG-GOOD-FAINT-GOOD': 5.59,
    'F-I1-POOR-EX-FAINT-GOOD': 5.59,
    'F-SI1-POOR-VG-MEDIUM-GOOD': 5.59,
    'F-SI1-VG-POOR-MEDIUM-GOOD': 5.59,
    'F-SI1-VG-EX-MEDIUM-POOR': 5.59,
    'F-SI1-GOOD-GOOD-MEDIUM-GOOD': 5.59,
    'F-I1-POOR-POOR-FAINT-VG': 5.59,
    'F-SI1-EX-VG-MEDIUM-POOR': 5.59,
    'G-SI1-EX-VG-FAINT-POOR': 5.59,
    'G-I1-EX-EX-NONE-POOR': 5.59,
    'G-I1-EX-POOR-NONE-GOOD': 5.59,
    'G-SI1-VG-EX-FAINT-POOR': 5.59,
    'G-I1-POOR-POOR-NONE-VG': 5.59,
    'G-I1-POOR-EX-NONE-GOOD': 5.59,
    'G-I1-GOOD-VG-NONE-GOOD': 5.59,
    'G-I1-VG-GOOD-NONE-GOOD': 5.59,
    'G-SI1-VG-POOR-FAINT-GOOD': 5.59,
    'G-SI1-POOR-VG-FAINT-GOOD': 5.59,
    'G-SI1-GOOD-GOOD-FAINT-GOOD': 5.59,
    'H-SI1-GOOD-GOOD-NONE-GOOD': 5.59,
    'H-SI1-VG-POOR-NONE-GOOD': 5.59,
    'H-SI1-VG-EX-NONE-POOR': 5.59,
    'H-SI1-EX-VG-NONE-POOR': 5.59,
    'H-SI1-POOR-VG-NONE-GOOD': 5.59,
    'I-I1-GOOD-EX-STRONG-VG': 5.59,
    'I-I1-VG-VG-STRONG-VG': 5.59,
    'I-I1-EX-GOOD-STRONG-VG': 5.59,
    'I-I1-POOR-GOOD-STRONG-EX': 5.59,
    'I-I1-GOOD-POOR-STRONG-EX': 5.59,
    'J-SI1-EX-POOR-STRONG-VG': 5.59,
    'J-SI1-VG-GOOD-STRONG-VG': 5.59,
    'J-I1-GOOD-POOR-MEDIUM-EX': 5.59,
    'J-I1-VG-VG-MEDIUM-VG': 5.59,
    'J-I1-GOOD-EX-MEDIUM-VG': 5.59,
    'J-SI1-EX-EX-STRONG-GOOD': 5.59,
    'J-I1-EX-GOOD-MEDIUM-VG': 5.59,
    'J-I1-POOR-GOOD-MEDIUM-EX': 5.59,
    'J-SI1-POOR-POOR-STRONG-EX': 5.59,
    'J-SI1-POOR-EX-STRONG-VG': 5.59,
    'J-SI1-GOOD-VG-STRONG-VG': 5.59,
    'K-I1-VG-VG-FAINT-VG': 5.59,
    'K-I1-GOOD-EX-FAINT-VG': 5.59,
    'K-I1-GOOD-POOR-FAINT-EX': 5.59,
    'K-I1-POOR-GOOD-FAINT-EX': 5.59,
    'K-I1-EX-GOOD-FAINT-VG': 5.59,
    'K-SI1-POOR-EX-MEDIUM-VG': 5.59,
    'K-SI1-GOOD-VG-MEDIUM-VG': 5.59,
    'K-SI1-VG-GOOD-MEDIUM-VG': 5.59,
    'K-SI1-EX-POOR-MEDIUM-VG': 5.59,
    'K-SI1-EX-EX-MEDIUM-GOOD': 5.59,
    'K-SI1-POOR-POOR-MEDIUM-EX': 5.59,
    'L-I1-POOR-GOOD-NONE-EX': 5.59,
    'L-I1-VG-VG-NONE-VG': 5.59,
    'L-I1-GOOD-POOR-NONE-EX': 5.59,
    'L-I1-EX-GOOD-NONE-VG': 5.59,
    'L-I1-GOOD-EX-NONE-VG': 5.59,
    'L-SI1-EX-EX-FAINT-GOOD': 5.59,
    'L-SI1-GOOD-VG-FAINT-VG': 5.59,
    'L-SI1-POOR-EX-FAINT-VG': 5.59,
    'L-SI1-POOR-POOR-FAINT-EX': 5.59,
    'L-SI1-EX-POOR-FAINT-VG': 5.59,
    'L-SI1-VG-GOOD-FAINT-VG': 5.59,
    'M-SI1-EX-EX-NONE-GOOD': 5.59,
    'M-SI1-EX-POOR-NONE-VG': 5.59,
    'M-SI1-VG-GOOD-NONE-VG': 5.59,
    'M-SI1-GOOD-VG-NONE-VG': 5.59,
    'M-SI1-POOR-EX-NONE-VG': 5.59,
    'M-SI1-POOR-POOR-NONE-EX': 5.59,
    'D-VS1-POOR-POOR-NONE-POOR': 5.58,
    'F-VS1-POOR-GOOD-STRONG-GOOD': 5.58,
    'F-VS1-GOOD-POOR-STRONG-GOOD': 5.58,
    'F-VS1-GOOD-EX-STRONG-POOR': 5.58,
    'F-VS1-VG-VG-STRONG-POOR': 5.58,
    'F-VS1-EX-GOOD-STRONG-POOR': 5.58,
    'G-VVS1-VG-GOOD-STRONG-POOR': 5.58,
    'G-VVS1-POOR-EX-STRONG-POOR': 5.58,
    'G-VVS1-GOOD-VG-STRONG-POOR': 5.58,
    'G-VS1-GOOD-EX-MEDIUM-POOR': 5.58,
    'G-VS1-EX-GOOD-MEDIUM-POOR': 5.58,
    'G-VS1-GOOD-POOR-MEDIUM-GOOD': 5.58,
    'G-VS1-VG-VG-MEDIUM-POOR': 5.58,
    'G-VVS1-POOR-POOR-STRONG-GOOD': 5.58,
    'G-VS1-POOR-GOOD-MEDIUM-GOOD': 5.58,
    'G-VVS1-EX-POOR-STRONG-POOR': 5.58,
    'H-VVS1-POOR-POOR-MEDIUM-GOOD': 5.58,
    'H-VS1-POOR-GOOD-FAINT-GOOD': 5.58,
    'H-VVS1-POOR-EX-MEDIUM-POOR': 5.58,
    'H-VVS1-GOOD-VG-MEDIUM-POOR': 5.58,
    'H-VVS1-EX-POOR-MEDIUM-POOR': 5.58,
    'H-VVS1-VG-GOOD-MEDIUM-POOR': 5.58,
    'H-VS1-GOOD-POOR-FAINT-GOOD': 5.58,
    'H-VS1-VG-VG-FAINT-POOR': 5.58,
    'H-VS1-GOOD-EX-FAINT-POOR': 5.58,
    'H-VS1-EX-GOOD-FAINT-POOR': 5.58,
    'I-VS1-EX-GOOD-NONE-POOR': 5.58,
    'I-VS1-VG-VG-NONE-POOR': 5.58,
    'I-VS1-GOOD-EX-NONE-POOR': 5.58,
    'I-VS1-GOOD-POOR-NONE-GOOD': 5.58,
    'I-VS1-POOR-GOOD-NONE-GOOD': 5.58,
    'I-VVS1-EX-POOR-FAINT-POOR': 5.58,
    'I-VVS1-VG-GOOD-FAINT-POOR': 5.58,
    'I-VVS1-GOOD-VG-FAINT-POOR': 5.58,
    'I-VVS1-POOR-EX-FAINT-POOR': 5.58,
    'I-VVS1-POOR-POOR-FAINT-GOOD': 5.58,
    'J-VVS1-POOR-POOR-NONE-GOOD': 5.58,
    'J-VVS1-POOR-EX-NONE-POOR': 5.58,
    'J-VVS1-GOOD-VG-NONE-POOR': 5.58,
    'J-VVS1-VG-GOOD-NONE-POOR': 5.58,
    'J-VVS1-EX-POOR-NONE-POOR': 5.58,
    'K-VS1-GOOD-GOOD-STRONG-VG': 5.58,
    'K-VS1-POOR-VG-STRONG-VG': 5.58,
    'K-VS1-EX-VG-STRONG-GOOD': 5.58,
    'K-VS1-VG-EX-STRONG-GOOD': 5.58,
    'K-VS1-VG-POOR-STRONG-VG': 5.58,
    'L-VVS1-GOOD-POOR-STRONG-VG': 5.58,
    'L-VVS1-POOR-GOOD-STRONG-VG': 5.58,
    'L-VVS1-VG-VG-STRONG-GOOD': 5.58,
    'L-VVS1-GOOD-EX-STRONG-GOOD': 5.58,
    'L-VVS1-EX-GOOD-STRONG-GOOD': 5.58,
    'L-VS1-EX-VG-MEDIUM-GOOD': 5.58,
    'L-VS1-VG-EX-MEDIUM-GOOD': 5.58,
    'L-VS1-GOOD-GOOD-MEDIUM-VG': 5.58,
    'L-VS1-POOR-VG-MEDIUM-VG': 5.58,
    'L-VS1-VG-POOR-MEDIUM-VG': 5.58,
    'M-VVS1-EX-GOOD-MEDIUM-GOOD': 5.58,
    'M-VVS1-GOOD-EX-MEDIUM-GOOD': 5.58,
    'M-VVS1-POOR-GOOD-MEDIUM-VG': 5.58,
    'M-VVS1-VG-VG-MEDIUM-GOOD': 5.58,
    'M-VVS1-GOOD-POOR-MEDIUM-VG': 5.58,
    'M-VS1-GOOD-GOOD-FAINT-VG': 5.58,
    'M-VS1-POOR-VG-FAINT-VG': 5.58,
    'M-VS1-VG-POOR-FAINT-VG': 5.58,
    'M-VS1-VG-EX-FAINT-GOOD': 5.58,
    'M-VS1-EX-VG-FAINT-GOOD': 5.58,
    'D-I2-EX-EX-MEDIUM-POOR': 5.57,
    'D-I2-EX-POOR-MEDIUM-GOOD': 5.57,
    'D-I2-VG-GOOD-MEDIUM-GOOD': 5.57,
    'D-I2-GOOD-VG-MEDIUM-GOOD': 5.57,
    'D-I2-POOR-POOR-MEDIUM-VG': 5.57,
    'D-SI2-VG-POOR-STRONG-GOOD': 5.57,
    'D-SI2-GOOD-GOOD-STRONG-GOOD': 5.57,
    'D-SI2-POOR-VG-STRONG-GOOD': 5.57,
    'D-I2-POOR-EX-MEDIUM-GOOD': 5.57,
    'D-SI2-EX-VG-STRONG-POOR': 5.57,
    'D-SI2-VG-EX-STRONG-POOR': 5.57,
    'E-I2-GOOD-VG-FAINT-GOOD': 5.57,
    'E-SI2-GOOD-GOOD-MEDIUM-GOOD': 5.57,
    'E-I2-POOR-POOR-FAINT-VG': 5.57,
    'E-I2-POOR-EX-FAINT-GOOD': 5.57,
    'E-I2-VG-GOOD-FAINT-GOOD': 5.57,
    'E-SI2-EX-VG-MEDIUM-POOR': 5.57,
    'E-SI2-VG-EX-MEDIUM-POOR': 5.57,
    'E-I2-EX-EX-FAINT-POOR': 5.57,
    'E-SI2-VG-POOR-MEDIUM-GOOD': 5.57,
    'E-I2-EX-POOR-FAINT-GOOD': 5.57,
    'E-SI2-POOR-VG-MEDIUM-GOOD': 5.57,
    'F-SI2-VG-POOR-FAINT-GOOD': 5.57,
    'F-SI2-POOR-VG-FAINT-GOOD': 5.57,
    'F-SI2-VG-EX-FAINT-POOR': 5.57,
    'F-SI2-EX-VG-FAINT-POOR': 5.57,
    'F-I2-EX-EX-NONE-POOR': 5.57,
    'F-I2-EX-POOR-NONE-GOOD': 5.57,
    'F-I2-VG-GOOD-NONE-GOOD': 5.57,
    'F-I2-GOOD-VG-NONE-GOOD': 5.57,
    'F-I2-POOR-EX-NONE-GOOD': 5.57,
    'F-I2-POOR-POOR-NONE-VG': 5.57,
    'F-SI2-GOOD-GOOD-FAINT-GOOD': 5.57,
    'G-SI2-EX-VG-NONE-POOR': 5.57,
    'G-SI2-VG-EX-NONE-POOR': 5.57,
    'G-SI2-VG-POOR-NONE-GOOD': 5.57,
    'G-SI2-GOOD-GOOD-NONE-GOOD': 5.57,
    'G-SI2-POOR-VG-NONE-GOOD': 5.57,
    'H-I2-POOR-GOOD-STRONG-EX': 5.57,
    'H-I2-GOOD-EX-STRONG-VG': 5.57,
    'H-I2-VG-VG-STRONG-VG': 5.57,
    'H-I2-EX-GOOD-STRONG-VG': 5.57,
    'H-I2-GOOD-POOR-STRONG-EX': 5.57,
    'I-I2-EX-GOOD-MEDIUM-VG': 5.57,
    'I-I2-VG-VG-MEDIUM-VG': 5.57,
    'I-I2-POOR-GOOD-MEDIUM-EX': 5.57,
    'I-I2-GOOD-EX-MEDIUM-VG': 5.57,
    'I-I2-GOOD-POOR-MEDIUM-EX': 5.57,
    'I-SI2-VG-GOOD-STRONG-VG': 5.57,
    'I-SI2-EX-POOR-STRONG-VG': 5.57,
    'I-SI2-GOOD-VG-STRONG-VG': 5.57,
    'I-SI2-POOR-EX-STRONG-VG': 5.57,
    'I-SI2-POOR-POOR-STRONG-EX': 5.57,
    'I-SI2-EX-EX-STRONG-GOOD': 5.57,
    'J-I2-EX-GOOD-FAINT-VG': 5.57,
    'J-I2-GOOD-EX-FAINT-VG': 5.57,
    'J-I2-VG-VG-FAINT-VG': 5.57,
    'J-SI2-POOR-EX-MEDIUM-VG': 5.57,
    'J-SI2-GOOD-VG-MEDIUM-VG': 5.57,
    'J-SI2-VG-GOOD-MEDIUM-VG': 5.57,
    'J-SI2-EX-POOR-MEDIUM-VG': 5.57,
    'J-SI2-EX-EX-MEDIUM-GOOD': 5.57,
    'J-SI2-POOR-POOR-MEDIUM-EX': 5.57,
    'J-I2-POOR-GOOD-FAINT-EX': 5.57,
    'J-I2-GOOD-POOR-FAINT-EX': 5.57,
    'K-SI2-GOOD-VG-FAINT-VG': 5.57,
    'K-SI2-POOR-EX-FAINT-VG': 5.57,
    'K-SI2-POOR-POOR-FAINT-EX': 5.57,
    'K-SI2-VG-GOOD-FAINT-VG': 5.57,
    'K-SI2-EX-POOR-FAINT-VG': 5.57,
    'K-I2-GOOD-EX-NONE-VG': 5.57,
    'K-I2-VG-VG-NONE-VG': 5.57,
    'K-I2-EX-GOOD-NONE-VG': 5.57,
    'K-I2-POOR-GOOD-NONE-EX': 5.57,
    'K-I2-GOOD-POOR-NONE-EX': 5.57,
    'K-SI2-EX-EX-FAINT-GOOD': 5.57,
    'L-SI2-EX-EX-NONE-GOOD': 5.57,
    'L-SI2-VG-GOOD-NONE-VG': 5.57,
    'L-SI2-GOOD-VG-NONE-VG': 5.57,
    'L-SI2-EX-POOR-NONE-VG': 5.57,
    'L-SI2-POOR-EX-NONE-VG': 5.57,
    'L-SI2-POOR-POOR-NONE-EX': 5.57,
    'M-I2-EX-VG-STRONG-EX': 5.57,
    'M-I2-VG-EX-STRONG-EX': 5.57,
    'E-VS2-GOOD-POOR-STRONG-GOOD': 5.56,
    'E-VS2-POOR-GOOD-STRONG-GOOD': 5.56,
    'E-VS2-EX-GOOD-STRONG-POOR': 5.56,
    'E-VS2-VG-VG-STRONG-POOR': 5.56,
    'E-VS2-GOOD-EX-STRONG-POOR': 5.56,
    'F-VS2-EX-GOOD-MEDIUM-POOR': 5.56,
    'F-VVS2-GOOD-VG-STRONG-POOR': 5.56,
    'F-VS2-POOR-GOOD-MEDIUM-GOOD': 5.56,
    'F-VVS2-VG-GOOD-STRONG-POOR': 5.56,
    'F-VVS2-POOR-EX-STRONG-POOR': 5.56,
    'F-VVS2-POOR-POOR-STRONG-GOOD': 5.56,
    'F-VS2-GOOD-POOR-MEDIUM-GOOD': 5.56,
    'F-VS2-GOOD-EX-MEDIUM-POOR': 5.56,
    'F-VVS2-EX-POOR-STRONG-POOR': 5.56,
    'F-VS2-VG-VG-MEDIUM-POOR': 5.56,
    'G-VS2-EX-GOOD-FAINT-POOR': 5.56,
    'G-VVS2-VG-GOOD-MEDIUM-POOR': 5.56,
    'G-VS2-GOOD-POOR-FAINT-GOOD': 5.56,
    'G-VVS2-EX-POOR-MEDIUM-POOR': 5.56,
    'G-VVS2-POOR-EX-MEDIUM-POOR': 5.56,
    'G-VS2-VG-VG-FAINT-POOR': 5.56,
    'G-VS2-POOR-GOOD-FAINT-GOOD': 5.56,
    'G-VVS2-POOR-POOR-MEDIUM-GOOD': 5.56,
    'G-VS2-GOOD-EX-FAINT-POOR': 5.56,
    'G-VVS2-GOOD-VG-MEDIUM-POOR': 5.56,
    'H-VS2-VG-VG-NONE-POOR': 5.56,
    'H-VS2-EX-GOOD-NONE-POOR': 5.56,
    'H-VS2-GOOD-POOR-NONE-GOOD': 5.56,
    'H-VS2-GOOD-EX-NONE-POOR': 5.56,
    'H-VS2-POOR-GOOD-NONE-GOOD': 5.56,
    'H-VVS2-EX-POOR-FAINT-POOR': 5.56,
    'H-VVS2-GOOD-VG-FAINT-POOR': 5.56,
    'H-VVS2-VG-GOOD-FAINT-POOR': 5.56,
    'H-VVS2-POOR-EX-FAINT-POOR': 5.56,
    'H-VVS2-POOR-POOR-FAINT-GOOD': 5.56,
    'I-VVS2-GOOD-VG-NONE-POOR': 5.56,
    'I-VVS2-VG-GOOD-NONE-POOR': 5.56,
    'I-VVS2-EX-POOR-NONE-POOR': 5.56,
    'I-VVS2-POOR-POOR-NONE-GOOD': 5.56,
    'I-VVS2-POOR-EX-NONE-POOR': 5.56,
    'J-VS2-VG-POOR-STRONG-VG': 5.56,
    'J-VS2-GOOD-GOOD-STRONG-VG': 5.56,
    'J-VS2-VG-EX-STRONG-GOOD': 5.56,
    'J-VS2-EX-VG-STRONG-GOOD': 5.56,
    'J-VS2-POOR-VG-STRONG-VG': 5.56,
    'K-VVS2-GOOD-EX-STRONG-GOOD': 5.56,
    'K-VVS2-VG-VG-STRONG-GOOD': 5.56,
    'K-VVS2-GOOD-POOR-STRONG-VG': 5.56,
    'K-VVS2-EX-GOOD-STRONG-GOOD': 5.56,
    'K-VS2-POOR-VG-MEDIUM-VG': 5.56,
    'K-VS2-GOOD-GOOD-MEDIUM-VG': 5.56,
    'K-VS2-EX-VG-MEDIUM-GOOD': 5.56,
    'K-VS2-VG-EX-MEDIUM-GOOD': 5.56,
    'K-VS2-VG-POOR-MEDIUM-VG': 5.56,
    'K-VVS2-POOR-GOOD-STRONG-VG': 5.56,
    'L-VS2-VG-EX-FAINT-GOOD': 5.56,
    'L-VS2-EX-VG-FAINT-GOOD': 5.56,
    'L-VVS2-POOR-GOOD-MEDIUM-VG': 5.56,
    'L-VVS2-GOOD-POOR-MEDIUM-VG': 5.56,
    'L-VS2-VG-POOR-FAINT-VG': 5.56,
    'L-VS2-POOR-VG-FAINT-VG': 5.56,
    'L-VVS2-VG-VG-MEDIUM-GOOD': 5.56,
    'L-VS2-GOOD-GOOD-FAINT-VG': 5.56,
    'L-VVS2-EX-GOOD-MEDIUM-GOOD': 5.56,
    'L-VVS2-GOOD-EX-MEDIUM-GOOD': 5.56,
    'M-VS2-POOR-VG-NONE-VG': 5.56,
    'M-VVS2-VG-VG-FAINT-GOOD': 5.56,
    'M-VVS2-GOOD-EX-FAINT-GOOD': 5.56,
    'M-VVS2-GOOD-POOR-FAINT-VG': 5.56,
    'M-VVS2-EX-GOOD-FAINT-GOOD': 5.56,
    'M-VS2-VG-POOR-NONE-VG': 5.56,
    'M-VS2-EX-VG-NONE-GOOD': 5.56,
    'M-VS2-VG-EX-NONE-GOOD': 5.56,
    'M-VS2-GOOD-GOOD-NONE-VG': 5.56,
    'M-VVS2-POOR-GOOD-FAINT-VG': 5.56,
    'G-IF-GOOD-GOOD-STRONG-POOR': 5.55,
    'G-IF-VG-POOR-STRONG-POOR': 5.55,
    'G-IF-POOR-VG-STRONG-POOR': 5.55,
    'H-IF-POOR-VG-MEDIUM-POOR': 5.55,
    'H-IF-GOOD-GOOD-MEDIUM-POOR': 5.55,
    'H-IF-VG-POOR-MEDIUM-POOR': 5.55,
    'I-IF-GOOD-GOOD-FAINT-POOR': 5.55,
    'I-IF-VG-POOR-FAINT-POOR': 5.55,
    'I-IF-POOR-VG-FAINT-POOR': 5.55,
    'J-IF-POOR-VG-NONE-POOR': 5.55,
    'J-IF-VG-POOR-NONE-POOR': 5.55,
    'J-IF-GOOD-GOOD-NONE-POOR': 5.55,
    'L-IF-POOR-EX-STRONG-GOOD': 5.55,
    'L-IF-VG-GOOD-STRONG-GOOD': 5.55,
    'L-IF-EX-EX-STRONG-POOR': 5.55,
    'L-IF-GOOD-VG-STRONG-GOOD': 5.55,
    'L-IF-EX-POOR-STRONG-GOOD': 5.55,
    'L-IF-POOR-POOR-STRONG-VG': 5.55,
    'M-IF-EX-POOR-MEDIUM-GOOD': 5.55,
    'M-IF-POOR-POOR-MEDIUM-VG': 5.55,
    'M-IF-EX-EX-MEDIUM-POOR': 5.55,
    'M-IF-POOR-EX-MEDIUM-GOOD': 5.55,
    'M-IF-GOOD-VG-MEDIUM-GOOD': 5.55,
    'M-IF-VG-GOOD-MEDIUM-GOOD': 5.55,
    'D-I1-POOR-VG-MEDIUM-GOOD': 5.54,
    'D-SI1-POOR-GOOD-STRONG-GOOD': 5.54,
    'D-SI1-EX-GOOD-STRONG-POOR': 5.54,
    'D-SI1-GOOD-EX-STRONG-POOR': 5.54,
    'D-I1-VG-EX-MEDIUM-POOR': 5.54,
    'D-I1-VG-POOR-MEDIUM-GOOD': 5.54,
    'D-SI1-VG-VG-STRONG-POOR': 5.54,
    'D-I1-EX-VG-MEDIUM-POOR': 5.54,
    'D-I1-GOOD-GOOD-MEDIUM-GOOD': 5.54,
    'D-SI1-GOOD-POOR-STRONG-GOOD': 5.54,
    'E-I1-EX-VG-FAINT-POOR': 5.54,
    'E-SI1-GOOD-EX-MEDIUM-POOR': 5.54,
    'E-SI1-EX-GOOD-MEDIUM-POOR': 5.54,
    'E-SI1-GOOD-POOR-MEDIUM-GOOD': 5.54,
    'E-I1-VG-EX-FAINT-POOR': 5.54,
    'E-SI1-VG-VG-MEDIUM-POOR': 5.54,
    'E-I1-POOR-VG-FAINT-GOOD': 5.54,
    'E-I1-GOOD-GOOD-FAINT-GOOD': 5.54,
    'E-I1-VG-POOR-FAINT-GOOD': 5.54,
    'E-SI1-POOR-GOOD-MEDIUM-GOOD': 5.54,
    'F-I1-EX-VG-NONE-POOR': 5.54,
    'F-I1-POOR-VG-NONE-GOOD': 5.54,
    'F-SI1-POOR-GOOD-FAINT-GOOD': 5.54,
    'F-SI1-GOOD-POOR-FAINT-GOOD': 5.54,
    'F-I1-VG-EX-NONE-POOR': 5.54,
    'F-SI1-VG-VG-FAINT-POOR': 5.54,
    'F-SI1-GOOD-EX-FAINT-POOR': 5.54,
    'F-SI1-EX-GOOD-FAINT-POOR': 5.54,
    'F-I1-GOOD-GOOD-NONE-GOOD': 5.54,
    'F-I1-VG-POOR-NONE-GOOD': 5.54,
    'G-SI1-EX-GOOD-NONE-POOR': 5.54,
    'G-SI1-GOOD-POOR-NONE-GOOD': 5.54,
    'G-SI1-POOR-GOOD-NONE-GOOD': 5.54,
    'G-SI1-VG-VG-NONE-POOR': 5.54,
    'G-SI1-GOOD-EX-NONE-POOR': 5.54,
    'H-I1-GOOD-VG-STRONG-VG': 5.54,
    'H-I1-POOR-EX-STRONG-VG': 5.54,
    'H-I1-POOR-POOR-STRONG-EX': 5.54,
    'H-I1-VG-GOOD-STRONG-VG': 5.54,
    'H-I1-EX-POOR-STRONG-VG': 5.54,
    'H-I1-EX-EX-STRONG-GOOD': 5.54,
    'I-SI1-POOR-VG-STRONG-VG': 5.54,
    'I-I1-EX-EX-MEDIUM-GOOD': 5.54,
    'I-SI1-VG-EX-STRONG-GOOD': 5.54,
    'I-SI1-VG-POOR-STRONG-VG': 5.54,
    'I-SI1-EX-VG-STRONG-GOOD': 5.54,
    'I-SI1-GOOD-GOOD-STRONG-VG': 5.54,
    'I-I1-POOR-POOR-MEDIUM-EX': 5.54,
    'I-I1-GOOD-VG-MEDIUM-VG': 5.54,
    'I-I1-POOR-EX-MEDIUM-VG': 5.54,
    'I-I1-EX-POOR-MEDIUM-VG': 5.54,
    'I-I1-VG-GOOD-MEDIUM-VG': 5.54,
    'J-I1-EX-EX-FAINT-GOOD': 5.54,
    'J-SI1-VG-POOR-MEDIUM-VG': 5.54,
    'J-I1-POOR-POOR-FAINT-EX': 5.54,
    'J-SI1-EX-VG-MEDIUM-GOOD': 5.54,
    'J-I1-POOR-EX-FAINT-VG': 5.54,
    'J-I1-GOOD-VG-FAINT-VG': 5.54,
    'J-I1-VG-GOOD-FAINT-VG': 5.54,
    'J-I1-EX-POOR-FAINT-VG': 5.54,
    'J-SI1-GOOD-GOOD-MEDIUM-VG': 5.54,
    'J-SI1-VG-EX-MEDIUM-GOOD': 5.54,
    'J-SI1-POOR-VG-MEDIUM-VG': 5.54,
    'K-SI1-GOOD-GOOD-FAINT-VG': 5.54,
    'K-I1-VG-GOOD-NONE-VG': 5.54,
    'K-SI1-POOR-VG-FAINT-VG': 5.54,
    'K-I1-EX-EX-NONE-GOOD': 5.54,
    'K-I1-EX-POOR-NONE-VG': 5.54,
    'K-I1-GOOD-VG-NONE-VG': 5.54,
    'K-I1-POOR-POOR-NONE-EX': 5.54,
    'K-SI1-VG-EX-FAINT-GOOD': 5.54,
    'K-I1-POOR-EX-NONE-VG': 5.54,
    'K-SI1-EX-VG-FAINT-GOOD': 5.54,
    'K-SI1-VG-POOR-FAINT-VG': 5.54,
    'L-SI1-GOOD-GOOD-NONE-VG': 5.54,
    'L-SI1-VG-POOR-NONE-VG': 5.54,
    'L-SI1-VG-EX-NONE-GOOD': 5.54,
    'L-SI1-EX-VG-NONE-GOOD': 5.54,
    'L-SI1-POOR-VG-NONE-VG': 5.54,
    'M-I1-EX-GOOD-STRONG-EX': 5.54,
    'M-I1-GOOD-EX-STRONG-EX': 5.54,
    'M-I1-VG-VG-STRONG-EX': 5.54,
    'E-VS1-POOR-POOR-STRONG-GOOD': 5.53,
    'E-VS1-EX-POOR-STRONG-POOR': 5.53,
    'E-VS1-POOR-EX-STRONG-POOR': 5.53,
    'E-VS1-GOOD-VG-STRONG-POOR': 5.53,
    'E-VS1-VG-GOOD-STRONG-POOR': 5.53,
    'F-VS1-EX-POOR-MEDIUM-POOR': 5.53,
    'F-VS1-POOR-POOR-MEDIUM-GOOD': 5.53,
    'F-VS1-POOR-EX-MEDIUM-POOR': 5.53,
    'F-VS1-VG-GOOD-MEDIUM-POOR': 5.53,
    'F-VS1-GOOD-VG-MEDIUM-POOR': 5.53,
    'F-VVS1-GOOD-GOOD-STRONG-POOR': 5.53,
    'F-VVS1-POOR-VG-STRONG-POOR': 5.53,
    'F-VVS1-VG-POOR-STRONG-POOR': 5.53,
    'G-VS1-POOR-POOR-FAINT-GOOD': 5.53,
    'G-VVS1-POOR-VG-MEDIUM-POOR': 5.53,
    'G-VVS1-GOOD-GOOD-MEDIUM-POOR': 5.53,
    'G-VVS1-VG-POOR-MEDIUM-POOR': 5.53,
    'G-VS1-GOOD-VG-FAINT-POOR': 5.53,
    'G-VS1-EX-POOR-FAINT-POOR': 5.53,
    'G-VS1-VG-GOOD-FAINT-POOR': 5.53,
    'G-VS1-POOR-EX-FAINT-POOR': 5.53,
    'H-VS1-GOOD-VG-NONE-POOR': 5.53,
    'H-VS1-VG-GOOD-NONE-POOR': 5.53,
    'H-VS1-POOR-EX-NONE-POOR': 5.53,
    'H-VVS1-GOOD-GOOD-FAINT-POOR': 5.53,
    'H-VS1-POOR-POOR-NONE-GOOD': 5.53,
    'H-VVS1-VG-POOR-FAINT-POOR': 5.53,
    'H-VVS1-POOR-VG-FAINT-POOR': 5.53,
    'H-VS1-EX-POOR-NONE-POOR': 5.53,
    'I-VVS1-POOR-VG-NONE-POOR': 5.53,
    'I-VVS1-GOOD-GOOD-NONE-POOR': 5.53,
    'I-VVS1-VG-POOR-NONE-POOR': 5.53,
    'J-VS1-GOOD-POOR-STRONG-VG': 5.53,
    'J-VS1-POOR-GOOD-STRONG-VG': 5.53,
    'J-VS1-GOOD-EX-STRONG-GOOD': 5.53,
    'J-VS1-VG-VG-STRONG-GOOD': 5.53,
    'J-VS1-EX-GOOD-STRONG-GOOD': 5.53,
    'K-VS1-GOOD-EX-MEDIUM-GOOD': 5.53,
    'K-VS1-EX-GOOD-MEDIUM-GOOD': 5.53,
    'K-VS1-VG-VG-MEDIUM-GOOD': 5.53,
    'K-VS1-POOR-GOOD-MEDIUM-VG': 5.53,
    'K-VS1-GOOD-POOR-MEDIUM-VG': 5.53,
    'K-VVS1-POOR-POOR-STRONG-VG': 5.53,
    'K-VVS1-POOR-EX-STRONG-GOOD': 5.53,
    'K-VVS1-EX-POOR-STRONG-GOOD': 5.53,
    'K-VVS1-EX-EX-STRONG-POOR': 5.53,
    'K-VVS1-GOOD-VG-STRONG-GOOD': 5.53,
    'K-VVS1-VG-GOOD-STRONG-GOOD': 5.53,
    'L-VVS1-GOOD-VG-MEDIUM-GOOD': 5.53,
    'L-VVS1-EX-EX-MEDIUM-POOR': 5.53,
    'L-VVS1-VG-GOOD-MEDIUM-GOOD': 5.53,
    'L-VVS1-EX-POOR-MEDIUM-GOOD': 5.53,
    'L-VS1-POOR-GOOD-FAINT-VG': 5.53,
    'L-VS1-GOOD-POOR-FAINT-VG': 5.53,
    'L-VS1-VG-VG-FAINT-GOOD': 5.53,
    'L-VVS1-POOR-EX-MEDIUM-GOOD': 5.53,
    'L-VS1-EX-GOOD-FAINT-GOOD': 5.53,
    'L-VVS1-POOR-POOR-MEDIUM-VG': 5.53,
    'L-VS1-GOOD-EX-FAINT-GOOD': 5.53,
    'M-VVS1-GOOD-VG-FAINT-GOOD': 5.53,
    'M-VVS1-VG-GOOD-FAINT-GOOD': 5.53,
    'M-VVS1-EX-POOR-FAINT-GOOD': 5.53,
    'M-VVS1-POOR-POOR-FAINT-VG': 5.53,
    'M-VVS1-POOR-EX-FAINT-GOOD': 5.53,
    'M-VVS1-EX-EX-FAINT-POOR': 5.53,
    'M-VS1-VG-VG-NONE-GOOD': 5.53,
    'M-VS1-GOOD-POOR-NONE-VG': 5.53,
    'M-VS1-GOOD-EX-NONE-GOOD': 5.53,
    'M-VS1-POOR-GOOD-NONE-VG': 5.53,
    'M-VS1-EX-GOOD-NONE-GOOD': 5.53,
    'D-I2-VG-EX-FAINT-POOR': 5.52,
    'D-I2-VG-POOR-FAINT-GOOD': 5.52,
    'D-SI2-VG-VG-MEDIUM-POOR': 5.52,
    'D-SI2-GOOD-EX-MEDIUM-POOR': 5.52,
    'D-SI2-GOOD-POOR-MEDIUM-GOOD': 5.52,
    'D-SI2-POOR-GOOD-MEDIUM-GOOD': 5.52,
    'D-SI2-EX-GOOD-MEDIUM-POOR': 5.52,
    'D-I2-EX-VG-FAINT-POOR': 5.52,
    'D-I2-GOOD-GOOD-FAINT-GOOD': 5.52,
    'D-I2-POOR-VG-FAINT-GOOD': 5.52,
    'E-SI2-VG-VG-FAINT-POOR': 5.52,
    'E-I2-GOOD-GOOD-NONE-GOOD': 5.52,
    'E-I2-VG-EX-NONE-POOR': 5.52,
    'E-SI2-GOOD-EX-FAINT-POOR': 5.52,
    'E-SI2-GOOD-POOR-FAINT-GOOD': 5.52,
    'E-I2-POOR-VG-NONE-GOOD': 5.52,
    'E-SI2-POOR-GOOD-FAINT-GOOD': 5.52,
    'E-I2-VG-POOR-NONE-GOOD': 5.52,
    'E-SI2-EX-GOOD-FAINT-POOR': 5.52,
    'E-I2-EX-VG-NONE-POOR': 5.52,
    'F-SI2-GOOD-EX-NONE-POOR': 5.52,
    'F-SI2-POOR-GOOD-NONE-GOOD': 5.52,
    'F-SI2-GOOD-POOR-NONE-GOOD': 5.52,
    'F-SI2-EX-GOOD-NONE-POOR': 5.52,
    'F-SI2-VG-VG-NONE-POOR': 5.52,
    'G-I2-EX-EX-STRONG-GOOD': 5.52,
    'G-I2-EX-POOR-STRONG-VG': 5.52,
    'G-I2-POOR-EX-STRONG-VG': 5.52,
    'G-I2-POOR-POOR-STRONG-EX': 5.52,
    'G-I2-GOOD-VG-STRONG-VG': 5.52,
    'G-I2-VG-GOOD-STRONG-VG': 5.52,
    'H-SI2-VG-POOR-STRONG-VG': 5.52,
    'H-SI2-VG-EX-STRONG-GOOD': 5.52,
    'H-I2-EX-EX-MEDIUM-GOOD': 5.52,
    'H-I2-POOR-POOR-MEDIUM-EX': 5.52,
    'H-I2-POOR-EX-MEDIUM-VG': 5.52,
    'H-I2-GOOD-VG-MEDIUM-VG': 5.52,
    'H-SI2-POOR-VG-STRONG-VG': 5.52,
    'H-I2-VG-GOOD-MEDIUM-VG': 5.52,
    'H-SI2-GOOD-GOOD-STRONG-VG': 5.52,
    'H-I2-EX-POOR-MEDIUM-VG': 5.52,
    'H-SI2-EX-VG-STRONG-GOOD': 5.52,
    'I-SI2-VG-POOR-MEDIUM-VG': 5.52,
    'I-I2-POOR-EX-FAINT-VG': 5.52,
    'I-I2-POOR-POOR-FAINT-EX': 5.52,
    'I-SI2-GOOD-GOOD-MEDIUM-VG': 5.52,
    'I-SI2-POOR-VG-MEDIUM-VG': 5.52,
    'I-I2-VG-GOOD-FAINT-VG': 5.52,
    'I-SI2-VG-EX-MEDIUM-GOOD': 5.52,
    'I-SI2-EX-VG-MEDIUM-GOOD': 5.52,
    'I-I2-EX-POOR-FAINT-VG': 5.52,
    'I-I2-EX-EX-FAINT-GOOD': 5.52,
    'I-I2-GOOD-VG-FAINT-VG': 5.52,
    'J-SI2-POOR-VG-FAINT-VG': 5.52,
    'J-SI2-GOOD-GOOD-FAINT-VG': 5.52,
    'J-SI2-EX-VG-FAINT-GOOD': 5.52,
    'J-SI2-VG-EX-FAINT-GOOD': 5.52,
    'J-SI2-VG-POOR-FAINT-VG': 5.52,
    'J-I2-POOR-POOR-NONE-EX': 5.52,
    'J-I2-POOR-EX-NONE-VG': 5.52,
    'J-I2-GOOD-VG-NONE-VG': 5.52,
    'J-I2-VG-GOOD-NONE-VG': 5.52,
    'J-I2-EX-POOR-NONE-VG': 5.52,
    'J-I2-EX-EX-NONE-GOOD': 5.52,
    'K-SI2-GOOD-GOOD-NONE-VG': 5.52,
    'K-SI2-POOR-VG-NONE-VG': 5.52,
    'K-SI2-VG-EX-NONE-GOOD': 5.52,
    'K-SI2-VG-POOR-NONE-VG': 5.52,
    'K-SI2-EX-VG-NONE-GOOD': 5.52,
    'L-I2-VG-VG-STRONG-EX': 5.52,
    'L-I2-GOOD-EX-STRONG-EX': 5.52,
    'L-I2-EX-GOOD-STRONG-EX': 5.52,
    'M-I2-VG-VG-MEDIUM-EX': 5.52,
    'M-I2-EX-GOOD-MEDIUM-EX': 5.52,
    'M-SI2-EX-EX-STRONG-VG': 5.52,
    'M-SI2-POOR-EX-STRONG-EX': 5.52,
    'M-SI2-GOOD-VG-STRONG-EX': 5.52,
    'M-SI2-EX-POOR-STRONG-EX': 5.52,
    'M-SI2-VG-GOOD-STRONG-EX': 5.52,
    'M-I2-GOOD-EX-MEDIUM-EX': 5.52,
    'D-VS2-POOR-POOR-STRONG-GOOD': 5.51,
    'D-VS2-VG-GOOD-STRONG-POOR': 5.51,
    'D-VS2-EX-POOR-STRONG-POOR': 5.51,
    'D-VS2-POOR-EX-STRONG-POOR': 5.51,
    'D-VS2-GOOD-VG-STRONG-POOR': 5.51,
    'E-VS2-POOR-POOR-MEDIUM-GOOD': 5.51,
    'E-VVS2-GOOD-GOOD-STRONG-POOR': 5.51,
    'E-VVS2-POOR-VG-STRONG-POOR': 5.51,
    'E-VS2-POOR-EX-MEDIUM-POOR': 5.51,
    'E-VS2-GOOD-VG-MEDIUM-POOR': 5.51,
    'E-VS2-EX-POOR-MEDIUM-POOR': 5.51,
    'E-VS2-VG-GOOD-MEDIUM-POOR': 5.51,
    'E-VVS2-VG-POOR-STRONG-POOR': 5.51,
    'F-VVS2-GOOD-GOOD-MEDIUM-POOR': 5.51,
    'F-VS2-EX-POOR-FAINT-POOR': 5.51,
    'F-VS2-VG-GOOD-FAINT-POOR': 5.51,
    'F-VS2-POOR-EX-FAINT-POOR': 5.51,
    'F-VVS2-POOR-VG-MEDIUM-POOR': 5.51,
    'F-VS2-POOR-POOR-FAINT-GOOD': 5.51,
    'F-VVS2-VG-POOR-MEDIUM-POOR': 5.51,
    'F-VS2-GOOD-VG-FAINT-POOR': 5.51,
    'G-VVS2-POOR-VG-FAINT-POOR': 5.51,
    'G-VS2-GOOD-VG-NONE-POOR': 5.51,
    'G-VS2-EX-POOR-NONE-POOR': 5.51,
    'G-VVS2-VG-POOR-FAINT-POOR': 5.51,
    'G-VS2-VG-GOOD-NONE-POOR': 5.51,
    'G-VVS2-GOOD-GOOD-FAINT-POOR': 5.51,
    'G-VS2-POOR-EX-NONE-POOR': 5.51,
    'G-VS2-POOR-POOR-NONE-GOOD': 5.51,
    'H-VVS2-POOR-VG-NONE-POOR': 5.51,
    'H-VVS2-VG-POOR-NONE-POOR': 5.51,
    'H-VVS2-GOOD-GOOD-NONE-POOR': 5.51,
    'I-VS2-GOOD-EX-STRONG-GOOD': 5.51,
    'I-VS2-POOR-GOOD-STRONG-VG': 5.51,
    'I-VS2-GOOD-POOR-STRONG-VG': 5.51,
    'I-VS2-VG-VG-STRONG-GOOD': 5.51,
    'I-VS2-EX-GOOD-STRONG-GOOD': 5.51,
    'J-VVS2-POOR-POOR-STRONG-VG': 5.51,
    'J-VS2-EX-GOOD-MEDIUM-GOOD': 5.51,
    'J-VVS2-POOR-EX-STRONG-GOOD': 5.51,
    'J-VVS2-VG-GOOD-STRONG-GOOD': 5.51,
    'J-VVS2-EX-POOR-STRONG-GOOD': 5.51,
    'J-VVS2-EX-EX-STRONG-POOR': 5.51,
    'J-VVS2-GOOD-VG-STRONG-GOOD': 5.51,
    'J-VS2-POOR-GOOD-MEDIUM-VG': 5.51,
    'J-VS2-GOOD-POOR-MEDIUM-VG': 5.51,
    'J-VS2-GOOD-EX-MEDIUM-GOOD': 5.51,
    'J-VS2-VG-VG-MEDIUM-GOOD': 5.51,
    'K-VVS2-POOR-POOR-MEDIUM-VG': 5.51,
    'K-VS2-VG-VG-FAINT-GOOD': 5.51,
    'K-VVS2-GOOD-VG-MEDIUM-GOOD': 5.51,
    'K-VS2-GOOD-POOR-FAINT-VG': 5.51,
    'K-VVS2-VG-GOOD-MEDIUM-GOOD': 5.51,
    'K-VS2-GOOD-EX-FAINT-GOOD': 5.51,
    'K-VS2-EX-GOOD-FAINT-GOOD': 5.51,
    'K-VVS2-POOR-EX-MEDIUM-GOOD': 5.51,
    'K-VVS2-EX-EX-MEDIUM-POOR': 5.51,
    'K-VS2-POOR-GOOD-FAINT-VG': 5.51,
    'K-VVS2-EX-POOR-MEDIUM-GOOD': 5.51,
    'L-VS2-EX-GOOD-NONE-GOOD': 5.51,
    'L-VS2-GOOD-EX-NONE-GOOD': 5.51,
    'L-VS2-VG-VG-NONE-GOOD': 5.51,
    'L-VVS2-GOOD-VG-FAINT-GOOD': 5.51,
    'L-VVS2-POOR-POOR-FAINT-VG': 5.51,
    'L-VVS2-POOR-EX-FAINT-GOOD': 5.51,
    'L-VS2-GOOD-POOR-NONE-VG': 5.51,
    'L-VVS2-VG-GOOD-FAINT-GOOD': 5.51,
    'L-VVS2-EX-POOR-FAINT-GOOD': 5.51,
    'L-VS2-POOR-GOOD-NONE-VG': 5.51,
    'L-VVS2-EX-EX-FAINT-POOR': 5.51,
    'M-VVS2-EX-POOR-NONE-GOOD': 5.51,
    'M-VVS2-VG-GOOD-NONE-GOOD': 5.51,
    'M-VVS2-POOR-POOR-NONE-VG': 5.51,
    'M-VVS2-EX-EX-NONE-POOR': 5.51,
    'M-VVS2-POOR-EX-NONE-GOOD': 5.51,
    'M-VVS2-GOOD-VG-NONE-GOOD': 5.51,
    'F-IF-GOOD-POOR-STRONG-POOR': 5.5,
    'F-IF-POOR-GOOD-STRONG-POOR': 5.5,
    'G-IF-POOR-GOOD-MEDIUM-POOR': 5.5,
    'G-IF-GOOD-POOR-MEDIUM-POOR': 5.5,
    'H-IF-GOOD-POOR-FAINT-POOR': 5.5,
    'H-IF-POOR-GOOD-FAINT-POOR': 5.5,
    'I-IF-POOR-GOOD-NONE-POOR': 5.5,
    'I-IF-GOOD-POOR-NONE-POOR': 5.5,
    'K-IF-GOOD-GOOD-STRONG-GOOD': 5.5,
    'K-IF-EX-VG-STRONG-POOR': 5.5,
    'K-IF-POOR-VG-STRONG-GOOD': 5.5,
    'K-IF-VG-EX-STRONG-POOR': 5.5,
    'K-IF-VG-POOR-STRONG-GOOD': 5.5,
    'L-IF-EX-VG-MEDIUM-POOR': 5.5,
    'L-IF-VG-POOR-MEDIUM-GOOD': 5.5,
    'L-IF-GOOD-GOOD-MEDIUM-GOOD': 5.5,
    'L-IF-POOR-VG-MEDIUM-GOOD': 5.5,
    'L-IF-VG-EX-MEDIUM-POOR': 5.5,
    'M-IF-VG-POOR-FAINT-GOOD': 5.5,
    'M-IF-EX-VG-FAINT-POOR': 5.5,
    'M-IF-VG-EX-FAINT-POOR': 5.5,
    'M-IF-GOOD-GOOD-FAINT-GOOD': 5.5,
    'M-IF-POOR-VG-FAINT-GOOD': 5.5,
    'D-SI1-EX-POOR-MEDIUM-POOR': 5.49,
    'D-I1-GOOD-EX-FAINT-POOR': 5.49,
    'D-SI1-VG-GOOD-MEDIUM-POOR': 5.49,
    'D-SI1-POOR-POOR-MEDIUM-GOOD': 5.49,
    'D-I1-VG-VG-FAINT-POOR': 5.49,
    'D-I1-GOOD-POOR-FAINT-GOOD': 5.49,
    'D-I1-POOR-GOOD-FAINT-GOOD': 5.49,
    'D-SI1-POOR-EX-MEDIUM-POOR': 5.49,
    'D-SI1-GOOD-VG-MEDIUM-POOR': 5.49,
    'D-I1-EX-GOOD-FAINT-POOR': 5.49,
    'E-I1-EX-GOOD-NONE-POOR': 5.49,
    'E-SI1-GOOD-VG-FAINT-POOR': 5.49,
    'E-SI1-POOR-EX-FAINT-POOR': 5.49,
    'E-SI1-EX-POOR-FAINT-POOR': 5.49,
    'E-SI1-VG-GOOD-FAINT-POOR': 5.49,
    'E-I1-VG-VG-NONE-POOR': 5.49,
    'E-I1-GOOD-POOR-NONE-GOOD': 5.49,
    'E-I1-GOOD-EX-NONE-POOR': 5.49,
    'E-SI1-POOR-POOR-FAINT-GOOD': 5.49,
    'E-I1-POOR-GOOD-NONE-GOOD': 5.49,
    'F-SI1-POOR-EX-NONE-POOR': 5.49,
    'F-SI1-EX-POOR-NONE-POOR': 5.49,
    'F-SI1-POOR-POOR-NONE-GOOD': 5.49,
    'F-SI1-VG-GOOD-NONE-POOR': 5.49,
    'F-SI1-GOOD-VG-NONE-POOR': 5.49,
    'G-I1-POOR-VG-STRONG-VG': 5.49,
    'G-I1-VG-POOR-STRONG-VG': 5.49,
    'G-I1-EX-VG-STRONG-GOOD': 5.49,
    'G-I1-VG-EX-STRONG-GOOD': 5.49,
    'G-I1-GOOD-GOOD-STRONG-VG': 5.49,
    'H-SI1-VG-VG-STRONG-GOOD': 5.49,
    'H-SI1-GOOD-EX-STRONG-GOOD': 5.49,
    'H-SI1-POOR-GOOD-STRONG-VG': 5.49,
    'H-SI1-EX-GOOD-STRONG-GOOD': 5.49,
    'H-SI1-GOOD-POOR-STRONG-VG': 5.49,
    'H-I1-GOOD-GOOD-MEDIUM-VG': 5.49,
    'H-I1-EX-VG-MEDIUM-GOOD': 5.49,
    'H-I1-VG-POOR-MEDIUM-VG': 5.49,
    'H-I1-VG-EX-MEDIUM-GOOD': 5.49,
    'H-I1-POOR-VG-MEDIUM-VG': 5.49,
    'I-I1-VG-POOR-FAINT-VG': 5.49,
    'I-I1-GOOD-GOOD-FAINT-VG': 5.49,
    'I-I1-POOR-VG-FAINT-VG': 5.49,
    'I-SI1-GOOD-POOR-MEDIUM-VG': 5.49,
    'I-SI1-GOOD-EX-MEDIUM-GOOD': 5.49,
    'I-I1-VG-EX-FAINT-GOOD': 5.49,
    'I-I1-EX-VG-FAINT-GOOD': 5.49,
    'I-SI1-EX-GOOD-MEDIUM-GOOD': 5.49,
    'I-SI1-VG-VG-MEDIUM-GOOD': 5.49,
    'I-SI1-POOR-GOOD-MEDIUM-VG': 5.49,
    'J-I1-POOR-VG-NONE-VG': 5.49,
    'J-I1-VG-EX-NONE-GOOD': 5.49,
    'J-I1-VG-POOR-NONE-VG': 5.49,
    'J-I1-GOOD-GOOD-NONE-VG': 5.49,
    'J-I1-EX-VG-NONE-GOOD': 5.49,
    'J-SI1-POOR-GOOD-FAINT-VG': 5.49,
    'J-SI1-EX-GOOD-FAINT-GOOD': 5.49,
    'J-SI1-GOOD-POOR-FAINT-VG': 5.49,
    'J-SI1-GOOD-EX-FAINT-GOOD': 5.49,
    'J-SI1-VG-VG-FAINT-GOOD': 5.49,
    'K-SI1-GOOD-POOR-NONE-VG': 5.49,
    'K-SI1-VG-VG-NONE-GOOD': 5.49,
    'K-SI1-GOOD-EX-NONE-GOOD': 5.49,
    'K-SI1-POOR-GOOD-NONE-VG': 5.49,
    'K-SI1-EX-GOOD-NONE-GOOD': 5.49,
    'L-I1-POOR-EX-STRONG-EX': 5.49,
    'L-I1-GOOD-VG-STRONG-EX': 5.49,
    'L-I1-EX-EX-STRONG-VG': 5.49,
    'L-I1-VG-GOOD-STRONG-EX': 5.49,
    'L-I1-EX-POOR-STRONG-EX': 5.49,
    'M-SI1-VG-EX-STRONG-VG': 5.49,
    'M-SI1-POOR-VG-STRONG-EX': 5.49,
    'M-I1-GOOD-VG-MEDIUM-EX': 5.49,
    'M-I1-POOR-EX-MEDIUM-EX': 5.49,
    'M-SI1-VG-POOR-STRONG-EX': 5.49,
    'M-I1-EX-EX-MEDIUM-VG': 5.49,
    'M-SI1-EX-VG-STRONG-VG': 5.49,
    'M-SI1-GOOD-GOOD-STRONG-EX': 5.49,
    'M-I1-VG-GOOD-MEDIUM-EX': 5.49,
    'M-I1-EX-POOR-MEDIUM-EX': 5.49,
    'D-VS1-GOOD-GOOD-STRONG-POOR': 5.48,
    'D-VS1-POOR-VG-STRONG-POOR': 5.48,
    'D-VS1-VG-POOR-STRONG-POOR': 5.48,
    'E-VS1-GOOD-GOOD-MEDIUM-POOR': 5.48,
    'E-VS1-VG-POOR-MEDIUM-POOR': 5.48,
    'E-VVS1-GOOD-POOR-STRONG-POOR': 5.48,
    'E-VS1-POOR-VG-MEDIUM-POOR': 5.48,
    'E-VVS1-POOR-GOOD-STRONG-POOR': 5.48,
    'F-VVS1-GOOD-POOR-MEDIUM-POOR': 5.48,
    'F-VS1-GOOD-GOOD-FAINT-POOR': 5.48,
    'F-VVS1-POOR-GOOD-MEDIUM-POOR': 5.48,
    'F-VS1-VG-POOR-FAINT-POOR': 5.48,
    'F-VS1-POOR-VG-FAINT-POOR': 5.48,
    'G-VS1-GOOD-GOOD-NONE-POOR': 5.48,
    'G-VVS1-GOOD-POOR-FAINT-POOR': 5.48,
    'G-VS1-POOR-VG-NONE-POOR': 5.48,
    'G-VS1-VG-POOR-NONE-POOR': 5.48,
    'G-VVS1-POOR-GOOD-FAINT-POOR': 5.48,
    'H-VVS1-GOOD-POOR-NONE-POOR': 5.48,
    'H-VVS1-POOR-GOOD-NONE-POOR': 5.48,
    'I-VS1-EX-POOR-STRONG-GOOD': 5.48,
    'I-VS1-EX-EX-STRONG-POOR': 5.48,
    'I-VS1-VG-GOOD-STRONG-GOOD': 5.48,
    'I-VS1-POOR-POOR-STRONG-VG': 5.48,
    'I-VS1-GOOD-VG-STRONG-GOOD': 5.48,
    'I-VS1-POOR-EX-STRONG-GOOD': 5.48,
    'J-VVS1-GOOD-GOOD-STRONG-GOOD': 5.48,
    'J-VVS1-POOR-VG-STRONG-GOOD': 5.48,
    'J-VVS1-EX-VG-STRONG-POOR': 5.48,
    'J-VS1-EX-POOR-MEDIUM-GOOD': 5.48,
    'J-VS1-EX-EX-MEDIUM-POOR': 5.48,
    'J-VS1-GOOD-VG-MEDIUM-GOOD': 5.48,
    'J-VVS1-VG-POOR-STRONG-GOOD': 5.48,
    'J-VS1-VG-GOOD-MEDIUM-GOOD': 5.48,
    'J-VS1-POOR-EX-MEDIUM-GOOD': 5.48,
    'J-VVS1-VG-EX-STRONG-POOR': 5.48,
    'J-VS1-POOR-POOR-MEDIUM-VG': 5.48,
    'K-VS1-EX-POOR-FAINT-GOOD': 5.48,
    'K-VVS1-VG-EX-MEDIUM-POOR': 5.48,
    'K-VS1-EX-EX-FAINT-POOR': 5.48,
    'K-VVS1-GOOD-GOOD-MEDIUM-GOOD': 5.48,
    'K-VVS1-POOR-VG-MEDIUM-GOOD': 5.48,
    'K-VVS1-VG-POOR-MEDIUM-GOOD': 5.48,
    'K-VS1-GOOD-VG-FAINT-GOOD': 5.48,
    'K-VS1-POOR-POOR-FAINT-VG': 5.48,
    'K-VS1-POOR-EX-FAINT-GOOD': 5.48,
    'K-VVS1-EX-VG-MEDIUM-POOR': 5.48,
    'K-VS1-VG-GOOD-FAINT-GOOD': 5.48,
    'L-VVS1-VG-POOR-FAINT-GOOD': 5.48,
    'L-VS1-POOR-EX-NONE-GOOD': 5.48,
    'L-VVS1-GOOD-GOOD-FAINT-GOOD': 5.48,
    'L-VVS1-POOR-VG-FAINT-GOOD': 5.48,
    'L-VS1-POOR-POOR-NONE-VG': 5.48,
    'L-VS1-EX-EX-NONE-POOR': 5.48,
    'L-VVS1-EX-VG-FAINT-POOR': 5.48,
    'L-VS1-EX-POOR-NONE-GOOD': 5.48,
    'L-VVS1-VG-EX-FAINT-POOR': 5.48,
    'L-VS1-GOOD-VG-NONE-GOOD': 5.48,
    'L-VS1-VG-GOOD-NONE-GOOD': 5.48,
    'M-VVS1-POOR-VG-NONE-GOOD': 5.48,
    'M-VVS1-GOOD-GOOD-NONE-GOOD': 5.48,
    'M-VVS1-VG-EX-NONE-POOR': 5.48,
    'M-VVS1-EX-VG-NONE-POOR': 5.48,
    'M-VVS1-VG-POOR-NONE-GOOD': 5.48,
    'D-I2-POOR-GOOD-NONE-GOOD': 5.47,
    'D-SI2-VG-GOOD-FAINT-POOR': 5.47,
    'D-I2-EX-GOOD-NONE-POOR': 5.47,
    'D-I2-GOOD-POOR-NONE-GOOD': 5.47,
    'D-SI2-EX-POOR-FAINT-POOR': 5.47,
    'D-SI2-GOOD-VG-FAINT-POOR': 5.47,
    'D-I2-VG-VG-NONE-POOR': 5.47,
    'D-SI2-POOR-POOR-FAINT-GOOD': 5.47,
    'D-SI2-POOR-EX-FAINT-POOR': 5.47,
    'D-I2-GOOD-EX-NONE-POOR': 5.47,
    'E-SI2-GOOD-VG-NONE-POOR': 5.47,
    'E-SI2-POOR-POOR-NONE-GOOD': 5.47,
    'E-SI2-VG-GOOD-NONE-POOR': 5.47,
    'E-SI2-EX-POOR-NONE-POOR': 5.47,
    'E-SI2-POOR-EX-NONE-POOR': 5.47,
    'F-I2-GOOD-GOOD-STRONG-VG': 5.47,
    'F-I2-VG-POOR-STRONG-VG': 5.47,
    'F-I2-POOR-VG-STRONG-VG': 5.47,
    'F-I2-VG-EX-STRONG-GOOD': 5.47,
    'F-I2-EX-VG-STRONG-GOOD': 5.47,
    'G-SI2-VG-VG-STRONG-GOOD': 5.47,
    'G-SI2-EX-GOOD-STRONG-GOOD': 5.47,
    'G-I2-VG-POOR-MEDIUM-VG': 5.47,
    'G-SI2-POOR-GOOD-STRONG-VG': 5.47,
    'G-SI2-GOOD-POOR-STRONG-VG': 5.47,
    'G-I2-GOOD-GOOD-MEDIUM-VG': 5.47,
    'G-SI2-GOOD-EX-STRONG-GOOD': 5.47,
    'G-I2-POOR-VG-MEDIUM-VG': 5.47,
    'G-I2-VG-EX-MEDIUM-GOOD': 5.47,
    'G-I2-EX-VG-MEDIUM-GOOD': 5.47,
    'H-SI2-EX-GOOD-MEDIUM-GOOD': 5.47,
    'H-SI2-VG-VG-MEDIUM-GOOD': 5.47,
    'H-I2-EX-VG-FAINT-GOOD': 5.47,
    'H-SI2-GOOD-EX-MEDIUM-GOOD': 5.47,
    'H-SI2-GOOD-POOR-MEDIUM-VG': 5.47,
    'H-I2-GOOD-GOOD-FAINT-VG': 5.47,
    'H-I2-POOR-VG-FAINT-VG': 5.47,
    'H-I2-VG-EX-FAINT-GOOD': 5.47,
    'H-SI2-POOR-GOOD-MEDIUM-VG': 5.47,
    'H-I2-VG-POOR-FAINT-VG': 5.47,
    'I-SI2-GOOD-POOR-FAINT-VG': 5.47,
    'I-I2-VG-EX-NONE-GOOD': 5.47,
    'I-SI2-EX-GOOD-FAINT-GOOD': 5.47,
    'I-SI2-VG-VG-FAINT-GOOD': 5.47,
    'I-I2-GOOD-GOOD-NONE-VG': 5.47,
    'I-I2-VG-POOR-NONE-VG': 5.47,
    'I-SI2-GOOD-EX-FAINT-GOOD': 5.47,
    'I-I2-POOR-VG-NONE-VG': 5.47,
    'I-I2-EX-VG-NONE-GOOD': 5.47,
    'I-SI2-POOR-GOOD-FAINT-VG': 5.47,
    'J-SI2-EX-GOOD-NONE-GOOD': 5.47,
    'J-SI2-GOOD-POOR-NONE-VG': 5.47,
    'J-SI2-GOOD-EX-NONE-GOOD': 5.47,
    'J-SI2-POOR-GOOD-NONE-VG': 5.47,
    'J-SI2-VG-VG-NONE-GOOD': 5.47,
    'K-I2-VG-GOOD-STRONG-EX': 5.47,
    'K-I2-EX-POOR-STRONG-EX': 5.47,
    'K-I2-GOOD-VG-STRONG-EX': 5.47,
    'K-I2-POOR-EX-STRONG-EX': 5.47,
    'K-I2-EX-EX-STRONG-VG': 5.47,
    'L-I2-EX-EX-MEDIUM-VG': 5.47,
    'L-I2-EX-POOR-MEDIUM-EX': 5.47,
    'L-SI2-GOOD-GOOD-STRONG-EX': 5.47,
    'L-I2-VG-GOOD-MEDIUM-EX': 5.47,
    'L-SI2-POOR-VG-STRONG-EX': 5.47,
    'L-SI2-VG-EX-STRONG-VG': 5.47,
    'L-SI2-VG-POOR-STRONG-EX': 5.47,
    'L-I2-POOR-EX-MEDIUM-EX': 5.47,
    'L-SI2-EX-VG-STRONG-VG': 5.47,
    'L-I2-GOOD-VG-MEDIUM-EX': 5.47,
    'M-I2-EX-POOR-FAINT-EX': 5.47,
    'M-I2-VG-GOOD-FAINT-EX': 5.47,
    'M-SI2-VG-EX-MEDIUM-VG': 5.47,
    'M-I2-EX-EX-FAINT-VG': 5.47,
    'M-SI2-EX-VG-MEDIUM-VG': 5.47,
    'M-I2-POOR-EX-FAINT-EX': 5.47,
    'M-SI2-POOR-VG-MEDIUM-EX': 5.47,
    'M-SI2-VG-POOR-MEDIUM-EX': 5.47,
    'M-I2-GOOD-VG-FAINT-EX': 5.47,
    'M-SI2-GOOD-GOOD-MEDIUM-EX': 5.47,
    'D-VS2-VG-POOR-MEDIUM-POOR': 5.46,
    'D-VVS2-GOOD-POOR-STRONG-POOR': 5.46,
    'D-VVS2-POOR-GOOD-STRONG-POOR': 5.46,
    'D-VS2-POOR-VG-MEDIUM-POOR': 5.46,
    'D-VS2-GOOD-GOOD-MEDIUM-POOR': 5.46,
    'E-VVS2-POOR-GOOD-MEDIUM-POOR': 5.46,
    'E-VVS2-GOOD-POOR-MEDIUM-POOR': 5.46,
    'E-VS2-GOOD-GOOD-FAINT-POOR': 5.46,
    'E-VS2-VG-POOR-FAINT-POOR': 5.46,
    'E-VS2-POOR-VG-FAINT-POOR': 5.46,
    'F-VVS2-GOOD-POOR-FAINT-POOR': 5.46,
    'F-VS2-GOOD-GOOD-NONE-POOR': 5.46,
    'F-VS2-POOR-VG-NONE-POOR': 5.46,
    'F-VVS2-POOR-GOOD-FAINT-POOR': 5.46,
    'F-VS2-VG-POOR-NONE-POOR': 5.46,
    'G-VVS2-GOOD-POOR-NONE-POOR': 5.46,
    'G-VVS2-POOR-GOOD-NONE-POOR': 5.46,
    'H-VS2-POOR-POOR-STRONG-VG': 5.46,
    'H-VS2-GOOD-VG-STRONG-GOOD': 5.46,
    'H-VS2-EX-POOR-STRONG-GOOD': 5.46,
    'H-VS2-VG-GOOD-STRONG-GOOD': 5.46,
    'H-VS2-EX-EX-STRONG-POOR': 5.46,
    'H-VS2-POOR-EX-STRONG-GOOD': 5.46,
    'I-VVS2-VG-EX-STRONG-POOR': 5.46,
    'I-VVS2-VG-POOR-STRONG-GOOD': 5.46,
    'I-VS2-GOOD-VG-MEDIUM-GOOD': 5.46,
    'I-VVS2-POOR-VG-STRONG-GOOD': 5.46,
    'I-VVS2-GOOD-GOOD-STRONG-GOOD': 5.46,
    'I-VS2-VG-GOOD-MEDIUM-GOOD': 5.46,
    'I-VS2-POOR-EX-MEDIUM-GOOD': 5.46,
    'I-VS2-EX-POOR-MEDIUM-GOOD': 5.46,
    'I-VVS2-EX-VG-STRONG-POOR': 5.46,
    'I-VS2-POOR-POOR-MEDIUM-VG': 5.46,
    'I-VS2-EX-EX-MEDIUM-POOR': 5.46,
    'J-VS2-EX-EX-FAINT-POOR': 5.46,
    'J-VS2-VG-GOOD-FAINT-GOOD': 5.46,
    'J-VVS2-GOOD-GOOD-MEDIUM-GOOD': 5.46,
    'J-VS2-POOR-POOR-FAINT-VG': 5.46,
    'J-VVS2-POOR-VG-MEDIUM-GOOD': 5.46,
    'J-VS2-EX-POOR-FAINT-GOOD': 5.46,
    'J-VVS2-VG-EX-MEDIUM-POOR': 5.46,
    'J-VVS2-VG-POOR-MEDIUM-GOOD': 5.46,
    'J-VVS2-EX-VG-MEDIUM-POOR': 5.46,
    'J-VS2-POOR-EX-FAINT-GOOD': 5.46,
    'J-VS2-GOOD-VG-FAINT-GOOD': 5.46,
    'K-VS2-POOR-EX-NONE-GOOD': 5.46,
    'K-VS2-POOR-POOR-NONE-VG': 5.46,
    'K-VS2-GOOD-VG-NONE-GOOD': 5.46,
    'K-VVS2-VG-EX-FAINT-POOR': 5.46,
    'K-VVS2-GOOD-GOOD-FAINT-GOOD': 5.46,
    'K-VVS2-VG-POOR-FAINT-GOOD': 5.46,
    'K-VS2-VG-GOOD-NONE-GOOD': 5.46,
    'K-VVS2-POOR-VG-FAINT-GOOD': 5.46,
    'K-VS2-EX-EX-NONE-POOR': 5.46,
    'K-VS2-EX-POOR-NONE-GOOD': 5.46,
    'K-VVS2-EX-VG-FAINT-POOR': 5.46,
    'L-VVS2-GOOD-GOOD-NONE-GOOD': 5.46,
    'L-VVS2-POOR-VG-NONE-GOOD': 5.46,
    'L-VVS2-VG-EX-NONE-POOR': 5.46,
    'L-VVS2-VG-POOR-NONE-GOOD': 5.46,
    'L-VVS2-EX-VG-NONE-POOR': 5.46,
    'M-VS2-GOOD-EX-STRONG-VG': 5.46,
    'M-VS2-EX-GOOD-STRONG-VG': 5.46,
    'M-VS2-GOOD-POOR-STRONG-EX': 5.46,
    'M-VS2-VG-VG-STRONG-VG': 5.46,
    'M-VS2-POOR-GOOD-STRONG-EX': 5.46,
    'E-IF-POOR-POOR-STRONG-POOR': 5.45,
    'F-IF-POOR-POOR-MEDIUM-POOR': 5.45,
    'G-IF-POOR-POOR-FAINT-POOR': 5.45,
    'H-IF-POOR-POOR-NONE-POOR': 5.45,
    'J-IF-GOOD-EX-STRONG-POOR': 5.45,
    'J-IF-VG-VG-STRONG-POOR': 5.45,
    'J-IF-EX-GOOD-STRONG-POOR': 5.45,
    'J-IF-POOR-GOOD-STRONG-GOOD': 5.45,
    'J-IF-GOOD-POOR-STRONG-GOOD': 5.45,
    'K-IF-GOOD-EX-MEDIUM-POOR': 5.45,
    'K-IF-GOOD-POOR-MEDIUM-GOOD': 5.45,
    'K-IF-VG-VG-MEDIUM-POOR': 5.45,
    'K-IF-EX-GOOD-MEDIUM-POOR': 5.45,
    'K-IF-POOR-GOOD-MEDIUM-GOOD': 5.45,
    'L-IF-GOOD-EX-FAINT-POOR': 5.45,
    'L-IF-VG-VG-FAINT-POOR': 5.45,
    'L-IF-EX-GOOD-FAINT-POOR': 5.45,
    'L-IF-POOR-GOOD-FAINT-GOOD': 5.45,
    'L-IF-GOOD-POOR-FAINT-GOOD': 5.45,
    'M-IF-EX-GOOD-NONE-POOR': 5.45,
    'M-IF-VG-VG-NONE-POOR': 5.45,
    'M-IF-GOOD-EX-NONE-POOR': 5.45,
    'M-IF-GOOD-POOR-NONE-GOOD': 5.45,
    'M-IF-POOR-GOOD-NONE-GOOD': 5.45,
    'D-SI1-VG-POOR-FAINT-POOR': 5.44,
    'D-I1-VG-GOOD-NONE-POOR': 5.44,
    'D-I1-GOOD-VG-NONE-POOR': 5.44,
    'D-I1-EX-POOR-NONE-POOR': 5.44,
    'D-SI1-GOOD-GOOD-FAINT-POOR': 5.44,
    'D-SI1-POOR-VG-FAINT-POOR': 5.44,
    'D-I1-POOR-POOR-NONE-GOOD': 5.44,
    'D-I1-POOR-EX-NONE-POOR': 5.44,
    'E-SI1-VG-POOR-NONE-POOR': 5.44,
    'E-SI1-GOOD-GOOD-NONE-POOR': 5.44,
    'E-SI1-POOR-VG-NONE-POOR': 5.44,
    'F-I1-GOOD-POOR-STRONG-VG': 5.44,
    'F-I1-POOR-GOOD-STRONG-VG': 5.44,
    'F-I1-GOOD-EX-STRONG-GOOD': 5.44,
    'F-I1-VG-VG-STRONG-GOOD': 5.44,
    'F-I1-EX-GOOD-STRONG-GOOD': 5.44,
    'G-I1-EX-GOOD-MEDIUM-GOOD': 5.44,
    'G-SI1-EX-EX-STRONG-POOR': 5.44,
    'G-SI1-VG-GOOD-STRONG-GOOD': 5.44,
    'G-I1-GOOD-POOR-MEDIUM-VG': 5.44,
    'G-I1-POOR-GOOD-MEDIUM-VG': 5.44,
    'G-I1-VG-VG-MEDIUM-GOOD': 5.44,
    'G-I1-GOOD-EX-MEDIUM-GOOD': 5.44,
    'G-SI1-EX-POOR-STRONG-GOOD': 5.44,
    'G-SI1-POOR-POOR-STRONG-VG': 5.44,
    'G-SI1-GOOD-VG-STRONG-GOOD': 5.44,
    'G-SI1-POOR-EX-STRONG-GOOD': 5.44,
    'H-I1-POOR-GOOD-FAINT-VG': 5.44,
    'H-I1-GOOD-POOR-FAINT-VG': 5.44,
    'H-I1-GOOD-EX-FAINT-GOOD': 5.44,
    'H-I1-VG-VG-FAINT-GOOD': 5.44,
    'H-I1-EX-GOOD-FAINT-GOOD': 5.44,
    'H-SI1-GOOD-VG-MEDIUM-GOOD': 5.44,
    'H-SI1-EX-EX-MEDIUM-POOR': 5.44,
    'H-SI1-POOR-EX-MEDIUM-GOOD': 5.44,
    'H-SI1-EX-POOR-MEDIUM-GOOD': 5.44,
    'H-SI1-POOR-POOR-MEDIUM-VG': 5.44,
    'H-SI1-VG-GOOD-MEDIUM-GOOD': 5.44,
    'I-I1-GOOD-POOR-NONE-VG': 5.44,
    'I-I1-POOR-GOOD-NONE-VG': 5.44,
    'I-SI1-EX-POOR-FAINT-GOOD': 5.44,
    'I-SI1-VG-GOOD-FAINT-GOOD': 5.44,
    'I-I1-GOOD-EX-NONE-GOOD': 5.44,
    'I-SI1-POOR-POOR-FAINT-VG': 5.44,
    'I-SI1-GOOD-VG-FAINT-GOOD': 5.44,
    'I-SI1-POOR-EX-FAINT-GOOD': 5.44,
    'I-I1-VG-VG-NONE-GOOD': 5.44,
    'I-I1-EX-GOOD-NONE-GOOD': 5.44,
    'I-SI1-EX-EX-FAINT-POOR': 5.44,
    'J-SI1-POOR-POOR-NONE-VG': 5.44,
    'J-SI1-POOR-EX-NONE-GOOD': 5.44,
    'J-SI1-EX-POOR-NONE-GOOD': 5.44,
    'J-SI1-EX-EX-NONE-POOR': 5.44,
    'J-SI1-GOOD-VG-NONE-GOOD': 5.44,
    'J-SI1-VG-GOOD-NONE-GOOD': 5.44,
    'K-I1-POOR-VG-STRONG-EX': 5.44,
    'K-I1-VG-POOR-STRONG-EX': 5.44,
    'K-I1-GOOD-GOOD-STRONG-EX': 5.44,
    'K-I1-VG-EX-STRONG-VG': 5.44,
    'K-I1-EX-VG-STRONG-VG': 5.44,
    'L-I1-VG-EX-MEDIUM-VG': 5.44,
    'L-I1-EX-VG-MEDIUM-VG': 5.44,
    'L-I1-POOR-VG-MEDIUM-EX': 5.44,
    'L-SI1-POOR-GOOD-STRONG-EX': 5.44,
    'L-SI1-GOOD-EX-STRONG-VG': 5.44,
    'L-SI1-VG-VG-STRONG-VG': 5.44,
    'L-SI1-GOOD-POOR-STRONG-EX': 5.44,
    'L-I1-GOOD-GOOD-MEDIUM-EX': 5.44,
    'L-I1-VG-POOR-MEDIUM-EX': 5.44,
    'L-SI1-EX-GOOD-STRONG-VG': 5.44,
    'M-SI1-VG-VG-MEDIUM-VG': 5.44,
    'M-SI1-EX-GOOD-MEDIUM-VG': 5.44,
    'M-SI1-POOR-GOOD-MEDIUM-EX': 5.44,
    'M-I1-POOR-VG-FAINT-EX': 5.44,
    'M-I1-GOOD-GOOD-FAINT-EX': 5.44,
    'M-I1-VG-POOR-FAINT-EX': 5.44,
    'M-I1-EX-VG-FAINT-VG': 5.44,
    'M-SI1-GOOD-EX-MEDIUM-VG': 5.44,
    'M-SI1-GOOD-POOR-MEDIUM-EX': 5.44,
    'M-I1-VG-EX-FAINT-VG': 5.44,
    'D-VS1-GOOD-POOR-MEDIUM-POOR': 5.43,
    'D-VS1-POOR-GOOD-MEDIUM-POOR': 5.43,
    'D-VVS1-POOR-POOR-STRONG-POOR': 5.43,
    'E-VS1-POOR-GOOD-FAINT-POOR': 5.43,
    'E-VS1-GOOD-POOR-FAINT-POOR': 5.43,
    'E-VVS1-POOR-POOR-MEDIUM-POOR': 5.43,
    'F-VS1-POOR-GOOD-NONE-POOR': 5.43,
    'F-VS1-GOOD-POOR-NONE-POOR': 5.43,
    'F-VVS1-POOR-POOR-FAINT-POOR': 5.43,
    'G-VVS1-POOR-POOR-NONE-POOR': 5.43,
    'H-VS1-VG-EX-STRONG-POOR': 5.43,
    'H-VS1-VG-POOR-STRONG-GOOD': 5.43,
    'H-VS1-GOOD-GOOD-STRONG-GOOD': 5.43,
    'H-VS1-POOR-VG-STRONG-GOOD': 5.43,
    'H-VS1-EX-VG-STRONG-POOR': 5.43,
    'I-VS1-GOOD-GOOD-MEDIUM-GOOD': 5.43,
    'I-VS1-POOR-VG-MEDIUM-GOOD': 5.43,
    'I-VS1-EX-VG-MEDIUM-POOR': 5.43,
    'I-VVS1-EX-GOOD-STRONG-POOR': 5.43,
    'I-VS1-VG-EX-MEDIUM-POOR': 5.43,
    'I-VS1-VG-POOR-MEDIUM-GOOD': 5.43,
    'I-VVS1-VG-VG-STRONG-POOR': 5.43,
    'I-VVS1-GOOD-EX-STRONG-POOR': 5.43,
    'I-VVS1-GOOD-POOR-STRONG-GOOD': 5.43,
    'I-VVS1-POOR-GOOD-STRONG-GOOD': 5.43,
    'J-VVS1-VG-VG-MEDIUM-POOR': 5.43,
    'J-VVS1-GOOD-EX-MEDIUM-POOR': 5.43,
    'J-VVS1-EX-GOOD-MEDIUM-POOR': 5.43,
    'J-VS1-POOR-VG-FAINT-GOOD': 5.43,
    'J-VS1-EX-VG-FAINT-POOR': 5.43,
    'J-VS1-VG-POOR-FAINT-GOOD': 5.43,
    'J-VS1-GOOD-GOOD-FAINT-GOOD': 5.43,
    'J-VVS1-GOOD-POOR-MEDIUM-GOOD': 5.43,
    'J-VVS1-POOR-GOOD-MEDIUM-GOOD': 5.43,
    'J-VS1-VG-EX-FAINT-POOR': 5.43,
    'K-VS1-VG-EX-NONE-POOR': 5.43,
    'K-VS1-EX-VG-NONE-POOR': 5.43,
    'K-VS1-VG-POOR-NONE-GOOD': 5.43,
    'K-VS1-GOOD-GOOD-NONE-GOOD': 5.43,
    'K-VS1-POOR-VG-NONE-GOOD': 5.43,
    'K-VVS1-GOOD-POOR-FAINT-GOOD': 5.43,
    'K-VVS1-GOOD-EX-FAINT-POOR': 5.43,
    'K-VVS1-VG-VG-FAINT-POOR': 5.43,
    'K-VVS1-EX-GOOD-FAINT-POOR': 5.43,
    'K-VVS1-POOR-GOOD-FAINT-GOOD': 5.43,
    'L-VVS1-POOR-GOOD-NONE-GOOD': 5.43,
    'L-VVS1-GOOD-POOR-NONE-GOOD': 5.43,
    'L-VVS1-GOOD-EX-NONE-POOR': 5.43,
    'L-VVS1-VG-VG-NONE-POOR': 5.43,
    'L-VVS1-EX-GOOD-NONE-POOR': 5.43,
    'M-VS1-POOR-EX-STRONG-VG': 5.43,
    'M-VS1-POOR-POOR-STRONG-EX': 5.43,
    'M-VS1-EX-EX-STRONG-GOOD': 5.43,
    'M-VS1-EX-POOR-STRONG-VG': 5.43,
    'M-VS1-GOOD-VG-STRONG-VG': 5.43,
    'M-VS1-VG-GOOD-STRONG-VG': 5.43,
    'D-SI2-VG-POOR-NONE-POOR': 5.42,
    'D-SI2-GOOD-GOOD-NONE-POOR': 5.42,
    'D-SI2-POOR-VG-NONE-POOR': 5.42,
    'E-I2-VG-VG-STRONG-GOOD': 5.42,
    'E-I2-GOOD-EX-STRONG-GOOD': 5.42,
    'E-I2-EX-GOOD-STRONG-GOOD': 5.42,
    'E-I2-POOR-GOOD-STRONG-VG': 5.42,
    'E-I2-GOOD-POOR-STRONG-VG': 5.42,
    'F-I2-VG-VG-MEDIUM-GOOD': 5.42,
    'F-I2-EX-GOOD-MEDIUM-GOOD': 5.42,
    'F-I2-GOOD-POOR-MEDIUM-VG': 5.42,
    'F-I2-POOR-GOOD-MEDIUM-VG': 5.42,
    'F-I2-GOOD-EX-MEDIUM-GOOD': 5.42,
    'F-SI2-POOR-POOR-STRONG-VG': 5.42,
    'F-SI2-EX-POOR-STRONG-GOOD': 5.42,
    'F-SI2-EX-EX-STRONG-POOR': 5.42,
    'F-SI2-VG-GOOD-STRONG-GOOD': 5.42,
    'F-SI2-POOR-EX-STRONG-GOOD': 5.42,
    'F-SI2-GOOD-VG-STRONG-GOOD': 5.42,
    'G-I2-POOR-GOOD-FAINT-VG': 5.42,
    'G-I2-GOOD-POOR-FAINT-VG': 5.42,
    'G-SI2-EX-EX-MEDIUM-POOR': 5.42,
    'G-SI2-EX-POOR-MEDIUM-GOOD': 5.42,
    'G-SI2-VG-GOOD-MEDIUM-GOOD': 5.42,
    'G-SI2-GOOD-VG-MEDIUM-GOOD': 5.42,
    'G-SI2-POOR-EX-MEDIUM-GOOD': 5.42,
    'G-SI2-POOR-POOR-MEDIUM-VG': 5.42,
    'G-I2-GOOD-EX-FAINT-GOOD': 5.42,
    'G-I2-EX-GOOD-FAINT-GOOD': 5.42,
    'G-I2-VG-VG-FAINT-GOOD': 5.42,
    'H-SI2-EX-POOR-FAINT-GOOD': 5.42,
    'H-SI2-VG-GOOD-FAINT-GOOD': 5.42,
    'H-SI2-GOOD-VG-FAINT-GOOD': 5.42,
    'H-SI2-POOR-EX-FAINT-GOOD': 5.42,
    'H-SI2-POOR-POOR-FAINT-VG': 5.42,
    'H-SI2-EX-EX-FAINT-POOR': 5.42,
    'H-I2-GOOD-EX-NONE-GOOD': 5.42,
    'H-I2-POOR-GOOD-NONE-VG': 5.42,
    'H-I2-GOOD-POOR-NONE-VG': 5.42,
    'H-I2-EX-GOOD-NONE-GOOD': 5.42,
    'H-I2-VG-VG-NONE-GOOD': 5.42,
    'I-SI2-EX-EX-NONE-POOR': 5.42,
    'I-SI2-EX-POOR-NONE-GOOD': 5.42,
    'I-SI2-VG-GOOD-NONE-GOOD': 5.42,
    'I-SI2-GOOD-VG-NONE-GOOD': 5.42,
    'I-SI2-POOR-EX-NONE-GOOD': 5.42,
    'I-SI2-POOR-POOR-NONE-VG': 5.42,
    'J-I2-EX-VG-STRONG-VG': 5.42,
    'J-I2-VG-EX-STRONG-VG': 5.42,
    'J-I2-VG-POOR-STRONG-EX': 5.42,
    'J-I2-GOOD-GOOD-STRONG-EX': 5.42,
    'J-I2-POOR-VG-STRONG-EX': 5.42,
    'K-SI2-GOOD-POOR-STRONG-EX': 5.42,
    'K-SI2-POOR-GOOD-STRONG-EX': 5.42,
    'K-SI2-EX-GOOD-STRONG-VG': 5.42,
    'K-SI2-VG-VG-STRONG-VG': 5.42,
    'K-SI2-GOOD-EX-STRONG-VG': 5.42,
    'K-I2-POOR-VG-MEDIUM-EX': 5.42,
    'K-I2-VG-POOR-MEDIUM-EX': 5.42,
    'K-I2-GOOD-GOOD-MEDIUM-EX': 5.42,
    'K-I2-EX-VG-MEDIUM-VG': 5.42,
    'K-I2-VG-EX-MEDIUM-VG': 5.42,
    'L-I2-EX-VG-FAINT-VG': 5.42,
    'L-I2-VG-EX-FAINT-VG': 5.42,
    'L-I2-POOR-VG-FAINT-EX': 5.42,
    'L-I2-GOOD-GOOD-FAINT-EX': 5.42,
    'L-SI2-POOR-GOOD-MEDIUM-EX': 5.42,
    'L-I2-VG-POOR-FAINT-EX': 5.42,
    'L-SI2-GOOD-POOR-MEDIUM-EX': 5.42,
    'L-SI2-VG-VG-MEDIUM-VG': 5.42,
    'L-SI2-EX-GOOD-MEDIUM-VG': 5.42,
    'L-SI2-GOOD-EX-MEDIUM-VG': 5.42,
    'M-I2-EX-VG-NONE-VG': 5.42,
    'M-I2-VG-EX-NONE-VG': 5.42,
    'M-SI2-EX-GOOD-FAINT-VG': 5.42,
    'M-SI2-GOOD-EX-FAINT-VG': 5.42,
    'M-SI2-GOOD-POOR-FAINT-EX': 5.42,
    'M-SI2-POOR-GOOD-FAINT-EX': 5.42,
    'M-SI2-VG-VG-FAINT-VG': 5.42,
    'M-I2-POOR-VG-NONE-EX': 5.42,
    'M-I2-GOOD-GOOD-NONE-EX': 5.42,
    'M-I2-VG-POOR-NONE-EX': 5.42,
    'D-VS2-POOR-GOOD-FAINT-POOR': 5.41,
    'D-VVS2-POOR-POOR-MEDIUM-POOR': 5.41,
    'D-VS2-GOOD-POOR-FAINT-POOR': 5.41,
    'E-VS2-POOR-GOOD-NONE-POOR': 5.41,
    'E-VS2-GOOD-POOR-NONE-POOR': 5.41,
    'E-VVS2-POOR-POOR-FAINT-POOR': 5.41,
    'F-VVS2-POOR-POOR-NONE-POOR': 5.41,
    'G-VS2-EX-VG-STRONG-POOR': 5.41,
    'G-VS2-VG-EX-STRONG-POOR': 5.41,
    'G-VS2-POOR-VG-STRONG-GOOD': 5.41,
    'G-VS2-GOOD-GOOD-STRONG-GOOD': 5.41,
    'G-VS2-VG-POOR-STRONG-GOOD': 5.41,
    'H-VS2-EX-VG-MEDIUM-POOR': 5.41,
    'H-VVS2-POOR-GOOD-STRONG-GOOD': 5.41,
    'H-VVS2-GOOD-POOR-STRONG-GOOD': 5.41,
    'H-VVS2-GOOD-EX-STRONG-POOR': 5.41,
    'H-VVS2-VG-VG-STRONG-POOR': 5.41,
    'H-VVS2-EX-GOOD-STRONG-POOR': 5.41,
    'H-VS2-VG-EX-MEDIUM-POOR': 5.41,
    'H-VS2-VG-POOR-MEDIUM-GOOD': 5.41,
    'H-VS2-GOOD-GOOD-MEDIUM-GOOD': 5.41,
    'H-VS2-POOR-VG-MEDIUM-GOOD': 5.41,
    'I-VVS2-POOR-GOOD-MEDIUM-GOOD': 5.41,
    'I-VS2-EX-VG-FAINT-POOR': 5.41,
    'I-VS2-VG-POOR-FAINT-GOOD': 5.41,
    'I-VVS2-EX-GOOD-MEDIUM-POOR': 5.41,
    'I-VS2-GOOD-GOOD-FAINT-GOOD': 5.41,
    'I-VVS2-GOOD-EX-MEDIUM-POOR': 5.41,
    'I-VVS2-GOOD-POOR-MEDIUM-GOOD': 5.41,
    'I-VS2-POOR-VG-FAINT-GOOD': 5.41,
    'I-VVS2-VG-VG-MEDIUM-POOR': 5.41,
    'I-VS2-VG-EX-FAINT-POOR': 5.41,
    'J-VS2-EX-VG-NONE-POOR': 5.41,
    'J-VS2-POOR-VG-NONE-GOOD': 5.41,
    'J-VS2-GOOD-GOOD-NONE-GOOD': 5.41,
    'J-VVS2-GOOD-EX-FAINT-POOR': 5.41,
    'J-VVS2-EX-GOOD-FAINT-POOR': 5.41,
    'J-VVS2-VG-VG-FAINT-POOR': 5.41,
    'J-VS2-VG-EX-NONE-POOR': 5.41,
    'J-VVS2-GOOD-POOR-FAINT-GOOD': 5.41,
    'J-VVS2-POOR-GOOD-FAINT-GOOD': 5.41,
    'J-VS2-VG-POOR-NONE-GOOD': 5.41,
    'K-VVS2-VG-VG-NONE-POOR': 5.41,
    'K-VVS2-GOOD-POOR-NONE-GOOD': 5.41,
    'K-VVS2-POOR-GOOD-NONE-GOOD': 5.41,
    'K-VVS2-EX-GOOD-NONE-POOR': 5.41,
    'K-VVS2-GOOD-EX-NONE-POOR': 5.41,
    'L-VS2-POOR-POOR-STRONG-EX': 5.41,
    'L-VS2-EX-EX-STRONG-GOOD': 5.41,
    'L-VS2-POOR-EX-STRONG-VG': 5.41,
    'L-VS2-GOOD-VG-STRONG-VG': 5.41,
    'L-VS2-VG-GOOD-STRONG-VG': 5.41,
    'L-VS2-EX-POOR-STRONG-VG': 5.41,
    'M-VVS2-VG-EX-STRONG-GOOD': 5.41,
    'M-VVS2-POOR-VG-STRONG-VG': 5.41,
    'M-VVS2-GOOD-GOOD-STRONG-VG': 5.41,
    'M-VVS2-VG-POOR-STRONG-VG': 5.41,
    'M-VS2-GOOD-VG-MEDIUM-VG': 5.41,
    'M-VVS2-EX-VG-STRONG-GOOD': 5.41,
    'M-VS2-EX-EX-MEDIUM-GOOD': 5.41,
    'M-VS2-POOR-POOR-MEDIUM-EX': 5.41,
    'M-VS2-POOR-EX-MEDIUM-VG': 5.41,
    'M-VS2-VG-GOOD-MEDIUM-VG': 5.41,
    'M-VS2-EX-POOR-MEDIUM-VG': 5.41,
    'I-IF-POOR-POOR-STRONG-GOOD': 5.4,
    'I-IF-POOR-EX-STRONG-POOR': 5.4,
    'I-IF-GOOD-VG-STRONG-POOR': 5.4,
    'I-IF-EX-POOR-STRONG-POOR': 5.4,
    'I-IF-VG-GOOD-STRONG-POOR': 5.4,
    'J-IF-VG-GOOD-MEDIUM-POOR': 5.4,
    'J-IF-GOOD-VG-MEDIUM-POOR': 5.4,
    'J-IF-POOR-EX-MEDIUM-POOR': 5.4,
    'J-IF-EX-POOR-MEDIUM-POOR': 5.4,
    'J-IF-POOR-POOR-MEDIUM-GOOD': 5.4,
    'K-IF-VG-GOOD-FAINT-POOR': 5.4,
    'K-IF-POOR-POOR-FAINT-GOOD': 5.4,
    'K-IF-POOR-EX-FAINT-POOR': 5.4,
    'K-IF-GOOD-VG-FAINT-POOR': 5.4,
    'K-IF-EX-POOR-FAINT-POOR': 5.4,
    'L-IF-POOR-POOR-NONE-GOOD': 5.4,
    'L-IF-POOR-EX-NONE-POOR': 5.4,
    'L-IF-GOOD-VG-NONE-POOR': 5.4,
    'L-IF-VG-GOOD-NONE-POOR': 5.4,
    'L-IF-EX-POOR-NONE-POOR': 5.4,
    'D-SI1-POOR-GOOD-NONE-POOR': 5.39,
    'D-SI1-GOOD-POOR-NONE-POOR': 5.39,
    'E-I1-GOOD-VG-STRONG-GOOD': 5.39,
    'E-I1-EX-EX-STRONG-POOR': 5.39,
    'E-I1-POOR-POOR-STRONG-VG': 5.39,
    'E-I1-EX-POOR-STRONG-GOOD': 5.39,
    'E-I1-VG-GOOD-STRONG-GOOD': 5.39,
    'E-I1-POOR-EX-STRONG-GOOD': 5.39,
    'F-SI1-GOOD-GOOD-STRONG-GOOD': 5.39,
    'F-SI1-EX-VG-STRONG-POOR': 5.39,
    'F-I1-EX-EX-MEDIUM-POOR': 5.39,
    'F-SI1-POOR-VG-STRONG-GOOD': 5.39,
    'F-I1-POOR-EX-MEDIUM-GOOD': 5.39,
    'F-I1-EX-POOR-MEDIUM-GOOD': 5.39,
    'F-I1-GOOD-VG-MEDIUM-GOOD': 5.39,
    'F-I1-VG-GOOD-MEDIUM-GOOD': 5.39,
    'F-I1-POOR-POOR-MEDIUM-VG': 5.39,
    'F-SI1-VG-POOR-STRONG-GOOD': 5.39,
    'F-SI1-VG-EX-STRONG-POOR': 5.39,
    'G-I1-GOOD-VG-FAINT-GOOD': 5.39,
    'G-I1-POOR-POOR-FAINT-VG': 5.39,
    'G-SI1-EX-VG-MEDIUM-POOR': 5.39,
    'G-I1-POOR-EX-FAINT-GOOD': 5.39,
    'G-I1-EX-EX-FAINT-POOR': 5.39,
    'G-SI1-VG-POOR-MEDIUM-GOOD': 5.39,
    'G-SI1-POOR-VG-MEDIUM-GOOD': 5.39,
    'G-SI1-GOOD-GOOD-MEDIUM-GOOD': 5.39,
    'G-I1-EX-POOR-FAINT-GOOD': 5.39,
    'G-I1-VG-GOOD-FAINT-GOOD': 5.39,
    'G-SI1-VG-EX-MEDIUM-POOR': 5.39,
    'H-I1-EX-POOR-NONE-GOOD': 5.39,
    'H-I1-VG-GOOD-NONE-GOOD': 5.39,
    'H-I1-GOOD-VG-NONE-GOOD': 5.39,
    'H-I1-POOR-EX-NONE-GOOD': 5.39,
    'H-I1-POOR-POOR-NONE-VG': 5.39,
    'H-I1-EX-EX-NONE-POOR': 5.39,
    'H-SI1-POOR-VG-FAINT-GOOD': 5.39,
    'H-SI1-GOOD-GOOD-FAINT-GOOD': 5.39,
    'H-SI1-VG-EX-FAINT-POOR': 5.39,
    'H-SI1-VG-POOR-FAINT-GOOD': 5.39,
    'H-SI1-EX-VG-FAINT-POOR': 5.39,
    'I-SI1-EX-VG-NONE-POOR': 5.39,
    'I-SI1-POOR-VG-NONE-GOOD': 5.39,
    'I-SI1-GOOD-GOOD-NONE-GOOD': 5.39,
    'I-SI1-VG-EX-NONE-POOR': 5.39,
    'I-SI1-VG-POOR-NONE-GOOD': 5.39,
    'J-I1-EX-GOOD-STRONG-VG': 5.39,
    'J-I1-VG-VG-STRONG-VG': 5.39,
    'J-I1-GOOD-EX-STRONG-VG': 5.39,
    'J-I1-GOOD-POOR-STRONG-EX': 5.39,
    'J-I1-POOR-GOOD-STRONG-EX': 5.39,
    'K-I1-POOR-GOOD-MEDIUM-EX': 5.39,
    'K-I1-GOOD-POOR-MEDIUM-EX': 5.39,
    'K-SI1-POOR-POOR-STRONG-EX': 5.39,
    'K-SI1-POOR-EX-STRONG-VG': 5.39,
    'K-SI1-EX-POOR-STRONG-VG': 5.39,
    'K-I1-VG-VG-MEDIUM-VG': 5.39,
    'K-I1-EX-GOOD-MEDIUM-VG': 5.39,
    'K-SI1-VG-GOOD-STRONG-VG': 5.39,
    'K-SI1-GOOD-VG-STRONG-VG': 5.39,
    'K-SI1-EX-EX-STRONG-GOOD': 5.39,
    'K-I1-GOOD-EX-MEDIUM-VG': 5.39,
    'L-I1-VG-VG-FAINT-VG': 5.39,
    'L-SI1-VG-GOOD-MEDIUM-VG': 5.39,
    'L-I1-GOOD-EX-FAINT-VG': 5.39,
    'L-I1-EX-GOOD-FAINT-VG': 5.39,
    'L-SI1-EX-EX-MEDIUM-GOOD': 5.39,
    'L-I1-GOOD-POOR-FAINT-EX': 5.39,
    'L-I1-POOR-GOOD-FAINT-EX': 5.39,
    'L-SI1-POOR-EX-MEDIUM-VG': 5.39,
    'L-SI1-GOOD-VG-MEDIUM-VG': 5.39,
    'L-SI1-POOR-POOR-MEDIUM-EX': 5.39,
    'L-SI1-EX-POOR-MEDIUM-VG': 5.39,
    'M-SI1-POOR-EX-FAINT-VG': 5.39,
    'M-I1-GOOD-POOR-NONE-EX': 5.39,
    'M-I1-EX-GOOD-NONE-VG': 5.39,
    'M-SI1-POOR-POOR-FAINT-EX': 5.39,
    'M-SI1-GOOD-VG-FAINT-VG': 5.39,
    'M-I1-POOR-GOOD-NONE-EX': 5.39,
    'M-SI1-VG-GOOD-FAINT-VG': 5.39,
    'M-SI1-EX-EX-FAINT-GOOD': 5.39,
    'M-SI1-EX-POOR-FAINT-VG': 5.39,
    'M-I1-VG-VG-NONE-VG': 5.39,
    'M-I1-GOOD-EX-NONE-VG': 5.39,
    'D-VS1-POOR-POOR-FAINT-POOR': 5.38,
    'E-VS1-POOR-POOR-NONE-POOR': 5.38,
    'G-VS1-VG-VG-STRONG-POOR': 5.38,
    'G-VS1-POOR-GOOD-STRONG-GOOD': 5.38,
    'G-VS1-GOOD-POOR-STRONG-GOOD': 5.38,
    'G-VS1-EX-GOOD-STRONG-POOR': 5.38,
    'G-VS1-GOOD-EX-STRONG-POOR': 5.38,
    'H-VVS1-POOR-EX-STRONG-POOR': 5.38,
    'H-VS1-EX-GOOD-MEDIUM-POOR': 5.38,
    'H-VS1-VG-VG-MEDIUM-POOR': 5.38,
    'H-VS1-GOOD-EX-MEDIUM-POOR': 5.38,
    'H-VS1-GOOD-POOR-MEDIUM-GOOD': 5.38,
    'H-VS1-POOR-GOOD-MEDIUM-GOOD': 5.38,
    'H-VVS1-VG-GOOD-STRONG-POOR': 5.38,
    'H-VVS1-EX-POOR-STRONG-POOR': 5.38,
    'H-VVS1-POOR-POOR-STRONG-GOOD': 5.38,
    'H-VVS1-GOOD-VG-STRONG-POOR': 5.38,
    'I-VS1-GOOD-POOR-FAINT-GOOD': 5.38,
    'I-VS1-POOR-GOOD-FAINT-GOOD': 5.38,
    'I-VS1-GOOD-EX-FAINT-POOR': 5.38,
    'I-VS1-VG-VG-FAINT-POOR': 5.38,
    'I-VVS1-POOR-POOR-MEDIUM-GOOD': 5.38,
    'I-VS1-EX-GOOD-FAINT-POOR': 5.38,
    'I-VVS1-POOR-EX-MEDIUM-POOR': 5.38,
    'I-VVS1-VG-GOOD-MEDIUM-POOR': 5.38,
    'I-VVS1-EX-POOR-MEDIUM-POOR': 5.38,
    'I-VVS1-GOOD-VG-MEDIUM-POOR': 5.38,
    'J-VVS1-POOR-POOR-FAINT-GOOD': 5.38,
    'J-VS1-GOOD-POOR-NONE-GOOD': 5.38,
    'J-VS1-GOOD-EX-NONE-POOR': 5.38,
    'J-VVS1-POOR-EX-FAINT-POOR': 5.38,
    'J-VVS1-GOOD-VG-FAINT-POOR': 5.38,
    'J-VVS1-VG-GOOD-FAINT-POOR': 5.38,
    'J-VVS1-EX-POOR-FAINT-POOR': 5.38,
    'J-VS1-VG-VG-NONE-POOR': 5.38,
    'J-VS1-POOR-GOOD-NONE-GOOD': 5.38,
    'J-VS1-EX-GOOD-NONE-POOR': 5.38,
    'K-VVS1-POOR-EX-NONE-POOR': 5.38,
    'K-VVS1-POOR-POOR-NONE-GOOD': 5.38,
    'K-VVS1-GOOD-VG-NONE-POOR': 5.38,
    'K-VVS1-EX-POOR-NONE-POOR': 5.38,
    'K-VVS1-VG-GOOD-NONE-POOR': 5.38,
    'L-VS1-GOOD-GOOD-STRONG-VG': 5.38,
    'L-VS1-POOR-VG-STRONG-VG': 5.38,
    'L-VS1-VG-POOR-STRONG-VG': 5.38,
    'L-VS1-EX-VG-STRONG-GOOD': 5.38,
    'L-VS1-VG-EX-STRONG-GOOD': 5.38,
    'M-VVS1-VG-VG-STRONG-GOOD': 5.38,
    'M-VVS1-GOOD-POOR-STRONG-VG': 5.38,
    'M-VS1-EX-VG-MEDIUM-GOOD': 5.38,
    'M-VVS1-POOR-GOOD-STRONG-VG': 5.38,
    'M-VS1-GOOD-GOOD-MEDIUM-VG': 5.38,
    'M-VVS1-GOOD-EX-STRONG-GOOD': 5.38,
    'M-VS1-VG-POOR-MEDIUM-VG': 5.38,
    'M-VVS1-EX-GOOD-STRONG-GOOD': 5.38,
    'M-VS1-VG-EX-MEDIUM-GOOD': 5.38,
    'M-VS1-POOR-VG-MEDIUM-VG': 5.38,
    'D-I2-POOR-EX-STRONG-GOOD': 5.37,
    'D-I2-GOOD-VG-STRONG-GOOD': 5.37,
    'D-I2-POOR-POOR-STRONG-VG': 5.37,
    'D-I2-EX-EX-STRONG-POOR': 5.37,
    'D-I2-EX-POOR-STRONG-GOOD': 5.37,
    'D-I2-VG-GOOD-STRONG-GOOD': 5.37,
    'E-I2-EX-POOR-MEDIUM-GOOD': 5.37,
    'E-I2-EX-EX-MEDIUM-POOR': 5.37,
    'E-I2-GOOD-VG-MEDIUM-GOOD': 5.37,
    'E-I2-POOR-POOR-MEDIUM-VG': 5.37,
    'E-SI2-EX-VG-STRONG-POOR': 5.37,
    'E-I2-VG-GOOD-MEDIUM-GOOD': 5.37,
    'E-SI2-VG-EX-STRONG-POOR': 5.37,
    'E-SI2-VG-POOR-STRONG-GOOD': 5.37,
    'E-SI2-GOOD-GOOD-STRONG-GOOD': 5.37,
    'E-I2-POOR-EX-MEDIUM-GOOD': 5.37,
    'E-SI2-POOR-VG-STRONG-GOOD': 5.37,
    'F-SI2-GOOD-GOOD-MEDIUM-GOOD': 5.37,
    'F-SI2-VG-POOR-MEDIUM-GOOD': 5.37,
    'F-SI2-VG-EX-MEDIUM-POOR': 5.37,
    'F-SI2-POOR-VG-MEDIUM-GOOD': 5.37,
    'F-I2-EX-EX-FAINT-POOR': 5.37,
    'F-SI2-EX-VG-MEDIUM-POOR': 5.37,
    'F-I2-POOR-EX-FAINT-GOOD': 5.37,
    'F-I2-GOOD-VG-FAINT-GOOD': 5.37,
    'F-I2-VG-GOOD-FAINT-GOOD': 5.37,
    'F-I2-EX-POOR-FAINT-GOOD': 5.37,
    'F-I2-POOR-POOR-FAINT-VG': 5.37,
    'G-I2-POOR-EX-NONE-GOOD': 5.37,
    'G-I2-VG-GOOD-NONE-GOOD': 5.37,
    'G-SI2-POOR-VG-FAINT-GOOD': 5.37,
    'G-I2-EX-POOR-NONE-GOOD': 5.37,
    'G-I2-GOOD-VG-NONE-GOOD': 5.37,
    'G-I2-EX-EX-NONE-POOR': 5.37,
    'G-SI2-EX-VG-FAINT-POOR': 5.37,
    'G-SI2-VG-EX-FAINT-POOR': 5.37,
    'G-SI2-GOOD-GOOD-FAINT-GOOD': 5.37,
    'G-SI2-VG-POOR-FAINT-GOOD': 5.37,
    'G-I2-POOR-POOR-NONE-VG': 5.37,
    'H-SI2-EX-VG-NONE-POOR': 5.37,
    'H-SI2-POOR-VG-NONE-GOOD': 5.37,
    'H-SI2-GOOD-GOOD-NONE-GOOD': 5.37,
    'H-SI2-VG-POOR-NONE-GOOD': 5.37,
    'H-SI2-VG-EX-NONE-POOR': 5.37,
    'I-I2-EX-GOOD-STRONG-VG': 5.37,
    'I-I2-VG-VG-STRONG-VG': 5.37,
    'I-I2-GOOD-EX-STRONG-VG': 5.37,
    'I-I2-GOOD-POOR-STRONG-EX': 5.37,
    'I-I2-POOR-GOOD-STRONG-EX': 5.37,
    'J-I2-VG-VG-MEDIUM-VG': 5.37,
    'J-I2-EX-GOOD-MEDIUM-VG': 5.37,
    'J-I2-POOR-GOOD-MEDIUM-EX': 5.37,
    'J-SI2-POOR-EX-STRONG-VG': 5.37,
    'J-SI2-VG-GOOD-STRONG-VG': 5.37,
    'J-I2-GOOD-EX-MEDIUM-VG': 5.37,
    'J-SI2-EX-POOR-STRONG-VG': 5.37,
    'J-SI2-GOOD-VG-STRONG-VG': 5.37,
    'J-I2-GOOD-POOR-MEDIUM-EX': 5.37,
    'J-SI2-EX-EX-STRONG-GOOD': 5.37,
    'J-SI2-POOR-POOR-STRONG-EX': 5.37,
    'K-I2-POOR-GOOD-FAINT-EX': 5.37,
    'K-I2-GOOD-EX-FAINT-VG': 5.37,
    'K-I2-VG-VG-FAINT-VG': 5.37,
    'K-I2-EX-GOOD-FAINT-VG': 5.37,
    'K-I2-GOOD-POOR-FAINT-EX': 5.37,
    'K-SI2-EX-EX-MEDIUM-GOOD': 5.37,
    'K-SI2-EX-POOR-MEDIUM-VG': 5.37,
    'K-SI2-POOR-POOR-MEDIUM-EX': 5.37,
    'K-SI2-VG-GOOD-MEDIUM-VG': 5.37,
    'K-SI2-GOOD-VG-MEDIUM-VG': 5.37,
    'K-SI2-POOR-EX-MEDIUM-VG': 5.37,
    'L-SI2-GOOD-VG-FAINT-VG': 5.37,
    'L-I2-VG-VG-NONE-VG': 5.37,
    'L-I2-POOR-GOOD-NONE-EX': 5.37,
    'L-SI2-VG-GOOD-FAINT-VG': 5.37,
    'L-I2-GOOD-EX-NONE-VG': 5.37,
    'L-SI2-POOR-POOR-FAINT-EX': 5.37,
    'L-I2-GOOD-POOR-NONE-EX': 5.37,
    'L-I2-EX-GOOD-NONE-VG': 5.37,
    'L-SI2-POOR-EX-FAINT-VG': 5.37,
    'L-SI2-EX-POOR-FAINT-VG': 5.37,
    'L-SI2-EX-EX-FAINT-GOOD': 5.37,
    'M-SI2-EX-POOR-NONE-VG': 5.37,
    'M-SI2-POOR-POOR-NONE-EX': 5.37,
    'M-SI2-POOR-EX-NONE-VG': 5.37,
    'M-SI2-GOOD-VG-NONE-VG': 5.37,
    'M-SI2-EX-EX-NONE-GOOD': 5.37,
    'M-SI2-VG-GOOD-NONE-VG': 5.37,
    'D-VS2-POOR-POOR-NONE-POOR': 5.36,
    'F-VS2-EX-GOOD-STRONG-POOR': 5.36,
    'F-VS2-GOOD-EX-STRONG-POOR': 5.36,
    'F-VS2-POOR-GOOD-STRONG-GOOD': 5.36,
    'F-VS2-GOOD-POOR-STRONG-GOOD': 5.36,
    'F-VS2-VG-VG-STRONG-POOR': 5.36,
    'G-VS2-POOR-GOOD-MEDIUM-GOOD': 5.36,
    'G-VVS2-GOOD-VG-STRONG-POOR': 5.36,
    'G-VS2-GOOD-POOR-MEDIUM-GOOD': 5.36,
    'G-VVS2-POOR-EX-STRONG-POOR': 5.36,
    'G-VS2-EX-GOOD-MEDIUM-POOR': 5.36,
    'G-VVS2-VG-GOOD-STRONG-POOR': 5.36,
    'G-VVS2-EX-POOR-STRONG-POOR': 5.36,
    'G-VVS2-POOR-POOR-STRONG-GOOD': 5.36,
    'G-VS2-GOOD-EX-MEDIUM-POOR': 5.36,
    'G-VS2-VG-VG-MEDIUM-POOR': 5.36,
    'H-VS2-EX-GOOD-FAINT-POOR': 5.36,
    'H-VVS2-EX-POOR-MEDIUM-POOR': 5.36,
    'H-VVS2-VG-GOOD-MEDIUM-POOR': 5.36,
    'H-VS2-VG-VG-FAINT-POOR': 5.36,
    'H-VS2-POOR-GOOD-FAINT-GOOD': 5.36,
    'H-VS2-GOOD-EX-FAINT-POOR': 5.36,
    'H-VS2-GOOD-POOR-FAINT-GOOD': 5.36,
    'H-VVS2-GOOD-VG-MEDIUM-POOR': 5.36,
    'H-VVS2-POOR-EX-MEDIUM-POOR': 5.36,
    'H-VVS2-POOR-POOR-MEDIUM-GOOD': 5.36,
    'I-VVS2-EX-POOR-FAINT-POOR': 5.36,
    'I-VVS2-POOR-POOR-FAINT-GOOD': 5.36,
    'I-VS2-VG-VG-NONE-POOR': 5.36,
    'I-VVS2-POOR-EX-FAINT-POOR': 5.36,
    'I-VS2-POOR-GOOD-NONE-GOOD': 5.36,
    'I-VVS2-VG-GOOD-FAINT-POOR': 5.36,
    'I-VS2-GOOD-POOR-NONE-GOOD': 5.36,
    'I-VS2-GOOD-EX-NONE-POOR': 5.36,
    'I-VVS2-GOOD-VG-FAINT-POOR': 5.36,
    'I-VS2-EX-GOOD-NONE-POOR': 5.36,
    'J-VVS2-EX-POOR-NONE-POOR': 5.36,
    'J-VVS2-GOOD-VG-NONE-POOR': 5.36,
    'J-VVS2-POOR-POOR-NONE-GOOD': 5.36,
    'J-VVS2-POOR-EX-NONE-POOR': 5.36,
    'J-VVS2-VG-GOOD-NONE-POOR': 5.36,
    'K-VS2-VG-POOR-STRONG-VG': 5.36,
    'K-VS2-EX-VG-STRONG-GOOD': 5.36,
    'K-VS2-VG-EX-STRONG-GOOD': 5.36,
    'K-VS2-GOOD-GOOD-STRONG-VG': 5.36,
    'K-VS2-POOR-VG-STRONG-VG': 5.36,
    'L-VS2-VG-EX-MEDIUM-GOOD': 5.36,
    'L-VVS2-GOOD-POOR-STRONG-VG': 5.36,
    'L-VVS2-EX-GOOD-STRONG-GOOD': 5.36,
    'L-VS2-EX-VG-MEDIUM-GOOD': 5.36,
    'L-VVS2-POOR-GOOD-STRONG-VG': 5.36,
    'L-VS2-VG-POOR-MEDIUM-VG': 5.36,
    'L-VVS2-GOOD-EX-STRONG-GOOD': 5.36,
    'L-VVS2-VG-VG-STRONG-GOOD': 5.36,
    'L-VS2-GOOD-GOOD-MEDIUM-VG': 5.36,
    'L-VS2-POOR-VG-MEDIUM-VG': 5.36,
    'M-VVS2-GOOD-POOR-MEDIUM-VG': 5.36,
    'M-VS2-EX-VG-FAINT-GOOD': 5.36,
    'M-VS2-POOR-VG-FAINT-VG': 5.36,
    'M-VVS2-GOOD-EX-MEDIUM-GOOD': 5.36,
    'M-VS2-VG-POOR-FAINT-VG': 5.36,
    'M-VVS2-EX-GOOD-MEDIUM-GOOD': 5.36,
    'M-VVS2-VG-VG-MEDIUM-GOOD': 5.36,
    'M-VS2-GOOD-GOOD-FAINT-VG': 5.36,
    'M-VVS2-POOR-GOOD-MEDIUM-VG': 5.36,
    'M-VS2-VG-EX-FAINT-GOOD': 5.36,
    'H-IF-VG-POOR-STRONG-POOR': 5.35,
    'H-IF-POOR-VG-STRONG-POOR': 5.35,
    'H-IF-GOOD-GOOD-STRONG-POOR': 5.35,
    'I-IF-POOR-VG-MEDIUM-POOR': 5.35,
    'I-IF-GOOD-GOOD-MEDIUM-POOR': 5.35,
    'I-IF-VG-POOR-MEDIUM-POOR': 5.35,
    'J-IF-GOOD-GOOD-FAINT-POOR': 5.35,
    'J-IF-POOR-VG-FAINT-POOR': 5.35,
    'J-IF-VG-POOR-FAINT-POOR': 5.35,
    'K-IF-VG-POOR-NONE-POOR': 5.35,
    'K-IF-GOOD-GOOD-NONE-POOR': 5.35,
    'K-IF-POOR-VG-NONE-POOR': 5.35,
    'M-IF-EX-EX-STRONG-POOR': 5.35,
    'M-IF-POOR-POOR-STRONG-VG': 5.35,
    'M-IF-GOOD-VG-STRONG-GOOD': 5.35,
    'M-IF-EX-POOR-STRONG-GOOD': 5.35,
    'M-IF-POOR-EX-STRONG-GOOD': 5.35,
    'M-IF-VG-GOOD-STRONG-GOOD': 5.35,
    'D-I1-EX-VG-STRONG-POOR': 5.34,
    'D-I1-VG-POOR-STRONG-GOOD': 5.34,
    'D-I1-POOR-VG-STRONG-GOOD': 5.34,
    'D-I1-VG-EX-STRONG-POOR': 5.34,
    'D-I1-GOOD-GOOD-STRONG-GOOD': 5.34,
    'E-I1-POOR-VG-MEDIUM-GOOD': 5.34,
    'E-SI1-GOOD-EX-STRONG-POOR': 5.34,
    'E-SI1-EX-GOOD-STRONG-POOR': 5.34,
    'E-SI1-VG-VG-STRONG-POOR': 5.34,
    'E-SI1-GOOD-POOR-STRONG-GOOD': 5.34,
    'E-I1-VG-POOR-MEDIUM-GOOD': 5.34,
    'E-I1-VG-EX-MEDIUM-POOR': 5.34,
    'E-I1-GOOD-GOOD-MEDIUM-GOOD': 5.34,
    'E-I1-EX-VG-MEDIUM-POOR': 5.34,
    'E-SI1-POOR-GOOD-STRONG-GOOD': 5.34,
    'F-SI1-GOOD-POOR-MEDIUM-GOOD': 5.34,
    'F-SI1-POOR-GOOD-MEDIUM-GOOD': 5.34,
    'F-I1-VG-POOR-FAINT-GOOD': 5.34,
    'F-I1-VG-EX-FAINT-POOR': 5.34,
    'F-SI1-EX-GOOD-MEDIUM-POOR': 5.34,
    'F-SI1-GOOD-EX-MEDIUM-POOR': 5.34,
    'F-SI1-VG-VG-MEDIUM-POOR': 5.34,
    'F-I1-POOR-VG-FAINT-GOOD': 5.34,
    'F-I1-EX-VG-FAINT-POOR': 5.34,
    'F-I1-GOOD-GOOD-FAINT-GOOD': 5.34,
    'G-I1-POOR-VG-NONE-GOOD': 5.34,
    'G-I1-VG-EX-NONE-POOR': 5.34,
    'G-I1-VG-POOR-NONE-GOOD': 5.34,
    'G-I1-GOOD-GOOD-NONE-GOOD': 5.34,
    'G-SI1-GOOD-EX-FAINT-POOR': 5.34,
    'G-I1-EX-VG-NONE-POOR': 5.34,
    'G-SI1-EX-GOOD-FAINT-POOR': 5.34,
    'G-SI1-POOR-GOOD-FAINT-GOOD': 5.34,
    'G-SI1-VG-VG-FAINT-POOR': 5.34,
    'G-SI1-GOOD-POOR-FAINT-GOOD': 5.34,
    'H-SI1-VG-VG-NONE-POOR': 5.34,
    'H-SI1-EX-GOOD-NONE-POOR': 5.34,
    'H-SI1-POOR-GOOD-NONE-GOOD': 5.34,
    'H-SI1-GOOD-EX-NONE-POOR': 5.34,
    'H-SI1-GOOD-POOR-NONE-GOOD': 5.34,
    'I-I1-EX-EX-STRONG-GOOD': 5.34,
    'I-I1-POOR-EX-STRONG-VG': 5.34,
    'I-I1-GOOD-VG-STRONG-VG': 5.34,
    'I-I1-EX-POOR-STRONG-VG': 5.34,
    'I-I1-VG-GOOD-STRONG-VG': 5.34,
    'I-I1-POOR-POOR-STRONG-EX': 5.34,
    'J-I1-EX-EX-MEDIUM-GOOD': 5.34,
    'J-SI1-GOOD-GOOD-STRONG-VG': 5.34,
    'J-I1-EX-POOR-MEDIUM-VG': 5.34,
    'J-I1-POOR-EX-MEDIUM-VG': 5.34,
    'J-SI1-POOR-VG-STRONG-VG': 5.34,
    'J-I1-POOR-POOR-MEDIUM-EX': 5.34,
    'J-SI1-VG-POOR-STRONG-VG': 5.34,
    'J-SI1-VG-EX-STRONG-GOOD': 5.34,
    'J-I1-VG-GOOD-MEDIUM-VG': 5.34,
    'J-I1-GOOD-VG-MEDIUM-VG': 5.34,
    'J-SI1-EX-VG-STRONG-GOOD': 5.34,
    'K-SI1-VG-EX-MEDIUM-GOOD': 5.34,
    'K-I1-POOR-POOR-FAINT-EX': 5.34,
    'K-SI1-EX-VG-MEDIUM-GOOD': 5.34,
    'K-I1-EX-EX-FAINT-GOOD': 5.34,
    'K-SI1-GOOD-GOOD-MEDIUM-VG': 5.34,
    'K-I1-VG-GOOD-FAINT-VG': 5.34,
    'K-I1-EX-POOR-FAINT-VG': 5.34,
    'K-I1-POOR-EX-FAINT-VG': 5.34,
    'K-I1-GOOD-VG-FAINT-VG': 5.34,
    'K-SI1-VG-POOR-MEDIUM-VG': 5.34,
    'K-SI1-POOR-VG-MEDIUM-VG': 5.34,
    'L-I1-VG-GOOD-NONE-VG': 5.34,
    'L-I1-EX-EX-NONE-GOOD': 5.34,
    'L-SI1-VG-EX-FAINT-GOOD': 5.34,
    'L-SI1-VG-POOR-FAINT-VG': 5.34,
    'L-I1-EX-POOR-NONE-VG': 5.34,
    'L-SI1-GOOD-GOOD-FAINT-VG': 5.34,
    'L-SI1-EX-VG-FAINT-GOOD': 5.34,
    'L-I1-GOOD-VG-NONE-VG': 5.34,
    'L-SI1-POOR-VG-FAINT-VG': 5.34,
    'L-I1-POOR-POOR-NONE-EX': 5.34,
    'L-I1-POOR-EX-NONE-VG': 5.34,
    'M-SI1-EX-VG-NONE-GOOD': 5.34,
    'M-SI1-GOOD-GOOD-NONE-VG': 5.34,
    'M-SI1-POOR-VG-NONE-VG': 5.34,
    'M-SI1-VG-POOR-NONE-VG': 5.34,
    'M-SI1-VG-EX-NONE-GOOD': 5.34,
    'F-VS1-POOR-POOR-STRONG-GOOD': 5.33,
    'F-VS1-EX-POOR-STRONG-POOR': 5.33,
    'F-VS1-VG-GOOD-STRONG-POOR': 5.33,
    'F-VS1-GOOD-VG-STRONG-POOR': 5.33,
    'F-VS1-POOR-EX-STRONG-POOR': 5.33,
    'G-VS1-EX-POOR-MEDIUM-POOR': 5.33,
    'G-VVS1-GOOD-GOOD-STRONG-POOR': 5.33,
    'G-VS1-POOR-POOR-MEDIUM-GOOD': 5.33,
    'G-VS1-GOOD-VG-MEDIUM-POOR': 5.33,
    'G-VS1-POOR-EX-MEDIUM-POOR': 5.33,
    'G-VVS1-POOR-VG-STRONG-POOR': 5.33,
    'G-VVS1-VG-POOR-STRONG-POOR': 5.33,
    'G-VS1-VG-GOOD-MEDIUM-POOR': 5.33,
    'H-VS1-EX-POOR-FAINT-POOR': 5.33,
    'H-VS1-POOR-POOR-FAINT-GOOD': 5.33,
    'H-VS1-GOOD-VG-FAINT-POOR': 5.33,
    'H-VS1-POOR-EX-FAINT-POOR': 5.33,
    'H-VVS1-GOOD-GOOD-MEDIUM-POOR': 5.33,
    'H-VVS1-VG-POOR-MEDIUM-POOR': 5.33,
    'H-VVS1-POOR-VG-MEDIUM-POOR': 5.33,
    'H-VS1-VG-GOOD-FAINT-POOR': 5.33,
    'I-VS1-GOOD-VG-NONE-POOR': 5.33,
    'I-VS1-POOR-EX-NONE-POOR': 5.33,
    'I-VVS1-VG-POOR-FAINT-POOR': 5.33,
    'I-VS1-VG-GOOD-NONE-POOR': 5.33,
    'I-VS1-POOR-POOR-NONE-GOOD': 5.33,
    'I-VS1-EX-POOR-NONE-POOR': 5.33,
    'I-VVS1-GOOD-GOOD-FAINT-POOR': 5.33,
    'I-VVS1-POOR-VG-FAINT-POOR': 5.33,
    'J-VVS1-POOR-VG-NONE-POOR': 5.33,
    'J-VVS1-VG-POOR-NONE-POOR': 5.33,
    'J-VVS1-GOOD-GOOD-NONE-POOR': 5.33,
    'K-VS1-GOOD-POOR-STRONG-VG': 5.33,
    'K-VS1-VG-VG-STRONG-GOOD': 5.33,
    'K-VS1-GOOD-EX-STRONG-GOOD': 5.33,
    'K-VS1-EX-GOOD-STRONG-GOOD': 5.33,
    'K-VS1-POOR-GOOD-STRONG-VG': 5.33,
    'L-VS1-EX-GOOD-MEDIUM-GOOD': 5.33,
    'L-VS1-GOOD-POOR-MEDIUM-VG': 5.33,
    'L-VVS1-GOOD-VG-STRONG-GOOD': 5.33,
    'L-VVS1-POOR-EX-STRONG-GOOD': 5.33,
    'L-VS1-POOR-GOOD-MEDIUM-VG': 5.33,
    'L-VVS1-EX-EX-STRONG-POOR': 5.33,
    'L-VVS1-EX-POOR-STRONG-GOOD': 5.33,
    'L-VVS1-VG-GOOD-STRONG-GOOD': 5.33,
    'L-VS1-VG-VG-MEDIUM-GOOD': 5.33,
    'L-VS1-GOOD-EX-MEDIUM-GOOD': 5.33,
    'L-VVS1-POOR-POOR-STRONG-VG': 5.33,
    'M-VVS1-VG-GOOD-MEDIUM-GOOD': 5.33,
    'M-VS1-EX-GOOD-FAINT-GOOD': 5.33,
    'M-VVS1-POOR-POOR-MEDIUM-VG': 5.33,
    'M-VS1-GOOD-EX-FAINT-GOOD': 5.33,
    'M-VVS1-EX-POOR-MEDIUM-GOOD': 5.33,
    'M-VS1-POOR-GOOD-FAINT-VG': 5.33,
    'M-VVS1-EX-EX-MEDIUM-POOR': 5.33,
    'M-VS1-GOOD-POOR-FAINT-VG': 5.33,
    'M-VVS1-POOR-EX-MEDIUM-GOOD': 5.33,
    'M-VS1-VG-VG-FAINT-GOOD': 5.33,
    'M-VVS1-GOOD-VG-MEDIUM-GOOD': 5.33,
    'D-I2-POOR-VG-MEDIUM-GOOD': 5.32,
    'D-I2-GOOD-GOOD-MEDIUM-GOOD': 5.32,
    'D-SI2-EX-GOOD-STRONG-POOR': 5.32,
    'D-I2-VG-POOR-MEDIUM-GOOD': 5.32,
    'D-I2-VG-EX-MEDIUM-POOR': 5.32,
    'D-SI2-POOR-GOOD-STRONG-GOOD': 5.32,
    'D-SI2-VG-VG-STRONG-POOR': 5.32,
    'D-SI2-GOOD-EX-STRONG-POOR': 5.32,
    'D-I2-EX-VG-MEDIUM-POOR': 5.32,
    'D-SI2-GOOD-POOR-STRONG-GOOD': 5.32,
    'E-I2-VG-POOR-FAINT-GOOD': 5.32,
    'E-I2-GOOD-GOOD-FAINT-GOOD': 5.32,
    'E-I2-POOR-VG-FAINT-GOOD': 5.32,
    'E-I2-EX-VG-FAINT-POOR': 5.32,
    'E-SI2-VG-VG-MEDIUM-POOR': 5.32,
    'E-SI2-GOOD-EX-MEDIUM-POOR': 5.32,
    'E-I2-VG-EX-FAINT-POOR': 5.32,
    'E-SI2-GOOD-POOR-MEDIUM-GOOD': 5.32,
    'E-SI2-EX-GOOD-MEDIUM-POOR': 5.32,
    'E-SI2-POOR-GOOD-MEDIUM-GOOD': 5.32,
    'F-SI2-VG-VG-FAINT-POOR': 5.32,
    'F-I2-VG-EX-NONE-POOR': 5.32,
    'F-I2-EX-VG-NONE-POOR': 5.32,
    'F-SI2-POOR-GOOD-FAINT-GOOD': 5.32,
    'F-SI2-GOOD-POOR-FAINT-GOOD': 5.32,
    'F-SI2-EX-GOOD-FAINT-POOR': 5.32,
    'F-I2-VG-POOR-NONE-GOOD': 5.32,
    'F-SI2-GOOD-EX-FAINT-POOR': 5.32,
    'F-I2-GOOD-GOOD-NONE-GOOD': 5.32,
    'F-I2-POOR-VG-NONE-GOOD': 5.32,
    'G-SI2-EX-GOOD-NONE-POOR': 5.32,
    'G-SI2-VG-VG-NONE-POOR': 5.32,
    'G-SI2-POOR-GOOD-NONE-GOOD': 5.32,
    'G-SI2-GOOD-POOR-NONE-GOOD': 5.32,
    'G-SI2-GOOD-EX-NONE-POOR': 5.32,
    'H-I2-EX-EX-STRONG-GOOD': 5.32,
    'H-I2-GOOD-VG-STRONG-VG': 5.32,
    'H-I2-POOR-EX-STRONG-VG': 5.32,
    'H-I2-POOR-POOR-STRONG-EX': 5.32,
    'H-I2-EX-POOR-STRONG-VG': 5.32,
    'H-I2-VG-GOOD-STRONG-VG': 5.32,
    'I-I2-EX-EX-MEDIUM-GOOD': 5.32,
    'I-I2-POOR-EX-MEDIUM-VG': 5.32,
    'I-SI2-VG-POOR-STRONG-VG': 5.32,
    'I-I2-GOOD-VG-MEDIUM-VG': 5.32,
    'I-I2-POOR-POOR-MEDIUM-EX': 5.32,
    'I-SI2-VG-EX-STRONG-GOOD': 5.32,
    'I-SI2-EX-VG-STRONG-GOOD': 5.32,
    'I-SI2-POOR-VG-STRONG-VG': 5.32,
    'I-SI2-GOOD-GOOD-STRONG-VG': 5.32,
    'I-I2-EX-POOR-MEDIUM-VG': 5.32,
    'I-I2-VG-GOOD-MEDIUM-VG': 5.32,
    'J-I2-POOR-EX-FAINT-VG': 5.32,
    'J-I2-GOOD-VG-FAINT-VG': 5.32,
    'J-I2-EX-POOR-FAINT-VG': 5.32,
    'J-I2-EX-EX-FAINT-GOOD': 5.32,
    'J-I2-VG-GOOD-FAINT-VG': 5.32,
    'J-SI2-EX-VG-MEDIUM-GOOD': 5.32,
    'J-I2-POOR-POOR-FAINT-EX': 5.32,
    'J-SI2-VG-EX-MEDIUM-GOOD': 5.32,
    'J-SI2-GOOD-GOOD-MEDIUM-VG': 5.32,
    'J-SI2-VG-POOR-MEDIUM-VG': 5.32,
    'J-SI2-POOR-VG-MEDIUM-VG': 5.32,
    'K-SI2-VG-EX-FAINT-GOOD': 5.32,
    'K-SI2-EX-VG-FAINT-GOOD': 5.32,
    'K-I2-GOOD-VG-NONE-VG': 5.32,
    'K-I2-VG-GOOD-NONE-VG': 5.32,
    'K-SI2-GOOD-GOOD-FAINT-VG': 5.32,
    'K-I2-EX-POOR-NONE-VG': 5.32,
    'K-SI2-POOR-VG-FAINT-VG': 5.32,
    'K-I2-EX-EX-NONE-GOOD': 5.32,
    'K-I2-POOR-POOR-NONE-EX': 5.32,
    'K-SI2-VG-POOR-FAINT-VG': 5.32,
    'K-I2-POOR-EX-NONE-VG': 5.32,
    'L-SI2-GOOD-GOOD-NONE-VG': 5.32,
    'L-SI2-VG-POOR-NONE-VG': 5.32,
    'L-SI2-EX-VG-NONE-GOOD': 5.32,
    'L-SI2-VG-EX-NONE-GOOD': 5.32,
    'L-SI2-POOR-VG-NONE-VG': 5.32,
    'M-I2-GOOD-EX-STRONG-EX': 5.32,
    'M-I2-VG-VG-STRONG-EX': 5.32,
    'M-I2-EX-GOOD-STRONG-EX': 5.32,
    'E-VS2-POOR-EX-STRONG-POOR': 5.31,
    'E-VS2-POOR-POOR-STRONG-GOOD': 5.31,
    'E-VS2-EX-POOR-STRONG-POOR': 5.31,
    'E-VS2-VG-GOOD-STRONG-POOR': 5.31,
    'E-VS2-GOOD-VG-STRONG-POOR': 5.31,
    'F-VVS2-VG-POOR-STRONG-POOR': 5.31,
    'F-VVS2-GOOD-GOOD-STRONG-POOR': 5.31,
    'F-VS2-VG-GOOD-MEDIUM-POOR': 5.31,
    'F-VS2-POOR-POOR-MEDIUM-GOOD': 5.31,
    'F-VS2-POOR-EX-MEDIUM-POOR': 5.31,
    'F-VS2-GOOD-VG-MEDIUM-POOR': 5.31,
    'F-VVS2-POOR-VG-STRONG-POOR': 5.31,
    'F-VS2-EX-POOR-MEDIUM-POOR': 5.31,
    'G-VS2-GOOD-VG-FAINT-POOR': 5.31,
    'G-VS2-VG-GOOD-FAINT-POOR': 5.31,
    'G-VS2-POOR-POOR-FAINT-GOOD': 5.31,
    'G-VS2-POOR-EX-FAINT-POOR': 5.31,
    'G-VVS2-POOR-VG-MEDIUM-POOR': 5.31,
    'G-VS2-EX-POOR-FAINT-POOR': 5.31,
    'G-VVS2-VG-POOR-MEDIUM-POOR': 5.31,
    'G-VVS2-GOOD-GOOD-MEDIUM-POOR': 5.31,
    'H-VS2-POOR-EX-NONE-POOR': 5.31,
    'H-VS2-GOOD-VG-NONE-POOR': 5.31,
    'H-VS2-VG-GOOD-NONE-POOR': 5.31,
    'H-VS2-EX-POOR-NONE-POOR': 5.31,
    'H-VVS2-VG-POOR-FAINT-POOR': 5.31,
    'H-VVS2-GOOD-GOOD-FAINT-POOR': 5.31,
    'H-VVS2-POOR-VG-FAINT-POOR': 5.31,
    'H-VS2-POOR-POOR-NONE-GOOD': 5.31,
    'I-VVS2-VG-POOR-NONE-POOR': 5.31,
    'I-VVS2-GOOD-GOOD-NONE-POOR': 5.31,
    'I-VVS2-POOR-VG-NONE-POOR': 5.31,
    'J-VS2-EX-GOOD-STRONG-GOOD': 5.31,
    'J-VS2-VG-VG-STRONG-GOOD': 5.31,
    'J-VS2-GOOD-EX-STRONG-GOOD': 5.31,
    'J-VS2-GOOD-POOR-STRONG-VG': 5.31,
    'J-VS2-POOR-GOOD-STRONG-VG': 5.31,
    'K-VVS2-POOR-POOR-STRONG-VG': 5.31,
    'K-VVS2-POOR-EX-STRONG-GOOD': 5.31,
    'K-VVS2-GOOD-VG-STRONG-GOOD': 5.31,
    'K-VS2-GOOD-EX-MEDIUM-GOOD': 5.31,
    'K-VS2-VG-VG-MEDIUM-GOOD': 5.31,
    'K-VVS2-VG-GOOD-STRONG-GOOD': 5.31,
    'K-VS2-EX-GOOD-MEDIUM-GOOD': 5.31,
    'K-VVS2-EX-POOR-STRONG-GOOD': 5.31,
    'K-VS2-GOOD-POOR-MEDIUM-VG': 5.31,
    'K-VVS2-EX-EX-STRONG-POOR': 5.31,
    'K-VS2-POOR-GOOD-MEDIUM-VG': 5.31,
    'L-VS2-GOOD-POOR-FAINT-VG': 5.31,
    'L-VS2-POOR-GOOD-FAINT-VG': 5.31,
    'L-VVS2-VG-GOOD-MEDIUM-GOOD': 5.31,
    'L-VVS2-EX-POOR-MEDIUM-GOOD': 5.31,
    'L-VVS2-EX-EX-MEDIUM-POOR': 5.31,
    'L-VS2-GOOD-EX-FAINT-GOOD': 5.31,
    'L-VVS2-GOOD-VG-MEDIUM-GOOD': 5.31,
    'L-VVS2-POOR-EX-MEDIUM-GOOD': 5.31,
    'L-VVS2-POOR-POOR-MEDIUM-VG': 5.31,
    'L-VS2-VG-VG-FAINT-GOOD': 5.31,
    'L-VS2-EX-GOOD-FAINT-GOOD': 5.31,
    'M-VS2-VG-VG-NONE-GOOD': 5.31,
    'M-VVS2-POOR-POOR-FAINT-VG': 5.31,
    'M-VS2-EX-GOOD-NONE-GOOD': 5.31,
    'M-VS2-POOR-GOOD-NONE-VG': 5.31,
    'M-VS2-GOOD-POOR-NONE-VG': 5.31,
    'M-VVS2-EX-EX-FAINT-POOR': 5.31,
    'M-VS2-GOOD-EX-NONE-GOOD': 5.31,
    'M-VVS2-POOR-EX-FAINT-GOOD': 5.31,
    'M-VVS2-GOOD-VG-FAINT-GOOD': 5.31,
    'M-VVS2-VG-GOOD-FAINT-GOOD': 5.31,
    'M-VVS2-EX-POOR-FAINT-GOOD': 5.31,
    'G-IF-GOOD-POOR-STRONG-POOR': 5.3,
    'G-IF-POOR-GOOD-STRONG-POOR': 5.3,
    'H-IF-GOOD-POOR-MEDIUM-POOR': 5.3,
    'H-IF-POOR-GOOD-MEDIUM-POOR': 5.3,
    'I-IF-POOR-GOOD-FAINT-POOR': 5.3,
    'I-IF-GOOD-POOR-FAINT-POOR': 5.3,
    'J-IF-GOOD-POOR-NONE-POOR': 5.3,
    'J-IF-POOR-GOOD-NONE-POOR': 5.3,
    'L-IF-GOOD-GOOD-STRONG-GOOD': 5.3,
    'L-IF-POOR-VG-STRONG-GOOD': 5.3,
    'L-IF-EX-VG-STRONG-POOR': 5.3,
    'L-IF-VG-POOR-STRONG-GOOD': 5.3,
    'L-IF-VG-EX-STRONG-POOR': 5.3,
    'M-IF-POOR-VG-MEDIUM-GOOD': 5.3,
    'M-IF-VG-EX-MEDIUM-POOR': 5.3,
    'M-IF-GOOD-GOOD-MEDIUM-GOOD': 5.3,
    'M-IF-VG-POOR-MEDIUM-GOOD': 5.3,
    'M-IF-EX-VG-MEDIUM-POOR': 5.3,
    'D-I1-VG-VG-MEDIUM-POOR': 5.29,
    'D-I1-GOOD-EX-MEDIUM-POOR': 5.29,
    'D-I1-GOOD-POOR-MEDIUM-GOOD': 5.29,
    'D-I1-POOR-GOOD-MEDIUM-GOOD': 5.29,
    'D-SI1-EX-POOR-STRONG-POOR': 5.29,
    'D-SI1-GOOD-VG-STRONG-POOR': 5.29,
    'D-I1-EX-GOOD-MEDIUM-POOR': 5.29,
    'D-SI1-VG-GOOD-STRONG-POOR': 5.29,
    'D-SI1-POOR-POOR-STRONG-GOOD': 5.29,
    'D-SI1-POOR-EX-STRONG-POOR': 5.29,
    'E-I1-VG-VG-FAINT-POOR': 5.29,
    'E-I1-POOR-GOOD-FAINT-GOOD': 5.29,
    'E-I1-GOOD-POOR-FAINT-GOOD': 5.29,
    'E-I1-GOOD-EX-FAINT-POOR': 5.29,
    'E-I1-EX-GOOD-FAINT-POOR': 5.29,
    'E-SI1-GOOD-VG-MEDIUM-POOR': 5.29,
    'E-SI1-POOR-EX-MEDIUM-POOR': 5.29,
    'E-SI1-POOR-POOR-MEDIUM-GOOD': 5.29,
    'E-SI1-EX-POOR-MEDIUM-POOR': 5.29,
    'E-SI1-VG-GOOD-MEDIUM-POOR': 5.29,
    'F-SI1-POOR-EX-FAINT-POOR': 5.29,
    'F-I1-POOR-GOOD-NONE-GOOD': 5.29,
    'F-I1-GOOD-POOR-NONE-GOOD': 5.29,
    'F-I1-GOOD-EX-NONE-POOR': 5.29,
    'F-I1-EX-GOOD-NONE-POOR': 5.29,
    'F-I1-VG-VG-NONE-POOR': 5.29,
    'F-SI1-GOOD-VG-FAINT-POOR': 5.29,
    'F-SI1-VG-GOOD-FAINT-POOR': 5.29,
    'F-SI1-EX-POOR-FAINT-POOR': 5.29,
    'F-SI1-POOR-POOR-FAINT-GOOD': 5.29,
    'G-SI1-EX-POOR-NONE-POOR': 5.29,
    'G-SI1-POOR-POOR-NONE-GOOD': 5.29,
    'G-SI1-POOR-EX-NONE-POOR': 5.29,
    'G-SI1-GOOD-VG-NONE-POOR': 5.29,
    'G-SI1-VG-GOOD-NONE-POOR': 5.29,
    'H-I1-GOOD-GOOD-STRONG-VG': 5.29,
    'H-I1-POOR-VG-STRONG-VG': 5.29,
    'H-I1-VG-POOR-STRONG-VG': 5.29,
    'H-I1-VG-EX-STRONG-GOOD': 5.29,
    'H-I1-EX-VG-STRONG-GOOD': 5.29,
    'I-I1-POOR-VG-MEDIUM-VG': 5.29,
    'I-I1-GOOD-GOOD-MEDIUM-VG': 5.29,
    'I-I1-VG-POOR-MEDIUM-VG': 5.29,
    'I-I1-VG-EX-MEDIUM-GOOD': 5.29,
    'I-I1-EX-VG-MEDIUM-GOOD': 5.29,
    'I-SI1-EX-GOOD-STRONG-GOOD': 5.29,
    'I-SI1-GOOD-EX-STRONG-GOOD': 5.29,
    'I-SI1-VG-VG-STRONG-GOOD': 5.29,
    'I-SI1-GOOD-POOR-STRONG-VG': 5.29,
    'I-SI1-POOR-GOOD-STRONG-VG': 5.29,
    'J-I1-POOR-VG-FAINT-VG': 5.29,
    'J-I1-VG-POOR-FAINT-VG': 5.29,
    'J-SI1-GOOD-EX-MEDIUM-GOOD': 5.29,
    'J-SI1-EX-GOOD-MEDIUM-GOOD': 5.29,
    'J-I1-GOOD-GOOD-FAINT-VG': 5.29,
    'J-I1-EX-VG-FAINT-GOOD': 5.29,
    'J-I1-VG-EX-FAINT-GOOD': 5.29,
    'J-SI1-POOR-GOOD-MEDIUM-VG': 5.29,
    'J-SI1-GOOD-POOR-MEDIUM-VG': 5.29,
    'J-SI1-VG-VG-MEDIUM-GOOD': 5.29,
    'K-I1-EX-VG-NONE-GOOD': 5.29,
    'K-I1-VG-POOR-NONE-VG': 5.29,
    'K-I1-VG-EX-NONE-GOOD': 5.29,
    'K-SI1-EX-GOOD-FAINT-GOOD': 5.29,
    'K-SI1-POOR-GOOD-FAINT-VG': 5.29,
    'K-SI1-VG-VG-FAINT-GOOD': 5.29,
    'K-SI1-GOOD-POOR-FAINT-VG': 5.29,
    'K-I1-GOOD-GOOD-NONE-VG': 5.29,
    'K-I1-POOR-VG-NONE-VG': 5.29,
    'K-SI1-GOOD-EX-FAINT-GOOD': 5.29,
    'L-SI1-GOOD-POOR-NONE-VG': 5.29,
    'L-SI1-GOOD-EX-NONE-GOOD': 5.29,
    'L-SI1-POOR-GOOD-NONE-VG': 5.29,
    'L-SI1-VG-VG-NONE-GOOD': 5.29,
    'L-SI1-EX-GOOD-NONE-GOOD': 5.29,
    'M-I1-VG-GOOD-STRONG-EX': 5.29,
    'M-I1-POOR-EX-STRONG-EX': 5.29,
    'M-I1-GOOD-VG-STRONG-EX': 5.29,
    'M-I1-EX-POOR-STRONG-EX': 5.29,
    'M-I1-EX-EX-STRONG-VG': 5.29,
    'E-VS1-POOR-VG-STRONG-POOR': 5.28,
    'E-VS1-GOOD-GOOD-STRONG-POOR': 5.28,
    'E-VS1-VG-POOR-STRONG-POOR': 5.28,
    'F-VS1-GOOD-GOOD-MEDIUM-POOR': 5.28,
    'F-VS1-VG-POOR-MEDIUM-POOR': 5.28,
    'F-VS1-POOR-VG-MEDIUM-POOR': 5.28,
    'F-VVS1-GOOD-POOR-STRONG-POOR': 5.28,
    'F-VVS1-POOR-GOOD-STRONG-POOR': 5.28,
    'G-VVS1-GOOD-POOR-MEDIUM-POOR': 5.28,
    'G-VS1-POOR-VG-FAINT-POOR': 5.28,
    'G-VS1-VG-POOR-FAINT-POOR': 5.28,
    'G-VVS1-POOR-GOOD-MEDIUM-POOR': 5.28,
    'G-VS1-GOOD-GOOD-FAINT-POOR': 5.28,
    'H-VS1-GOOD-GOOD-NONE-POOR': 5.28,
    'H-VS1-POOR-VG-NONE-POOR': 5.28,
    'H-VS1-VG-POOR-NONE-POOR': 5.28,
    'H-VVS1-POOR-GOOD-FAINT-POOR': 5.28,
    'H-VVS1-GOOD-POOR-FAINT-POOR': 5.28,
    'I-VVS1-POOR-GOOD-NONE-POOR': 5.28,
    'I-VVS1-GOOD-POOR-NONE-POOR': 5.28,
    'J-VS1-GOOD-VG-STRONG-GOOD': 5.28,
    'J-VS1-VG-GOOD-STRONG-GOOD': 5.28,
    'J-VS1-EX-EX-STRONG-POOR': 5.28,
    'J-VS1-POOR-POOR-STRONG-VG': 5.28,
    'J-VS1-EX-POOR-STRONG-GOOD': 5.28,
    'J-VS1-POOR-EX-STRONG-GOOD': 5.28,
    'K-VS1-EX-EX-MEDIUM-POOR': 5.28,
    'K-VVS1-EX-VG-STRONG-POOR': 5.28,
    'K-VS1-EX-POOR-MEDIUM-GOOD': 5.28,
    'K-VVS1-VG-EX-STRONG-POOR': 5.28,
    'K-VS1-POOR-POOR-MEDIUM-VG': 5.28,
    'K-VS1-POOR-EX-MEDIUM-GOOD': 5.28,
    'K-VS1-GOOD-VG-MEDIUM-GOOD': 5.28,
    'K-VVS1-POOR-VG-STRONG-GOOD': 5.28,
    'K-VVS1-GOOD-GOOD-STRONG-GOOD': 5.28,
    'K-VS1-VG-GOOD-MEDIUM-GOOD': 5.28,
    'K-VVS1-VG-POOR-STRONG-GOOD': 5.28,
    'L-VS1-EX-EX-FAINT-POOR': 5.28,
    'L-VS1-VG-GOOD-FAINT-GOOD': 5.28,
    'L-VVS1-VG-POOR-MEDIUM-GOOD': 5.28,
    'L-VS1-EX-POOR-FAINT-GOOD': 5.28,
    'L-VS1-GOOD-VG-FAINT-GOOD': 5.28,
    'L-VVS1-GOOD-GOOD-MEDIUM-GOOD': 5.28,
    'L-VVS1-POOR-VG-MEDIUM-GOOD': 5.28,
    'L-VVS1-VG-EX-MEDIUM-POOR': 5.28,
    'L-VVS1-EX-VG-MEDIUM-POOR': 5.28,
    'L-VS1-POOR-EX-FAINT-GOOD': 5.28,
    'L-VS1-POOR-POOR-FAINT-VG': 5.28,
    'M-VS1-EX-POOR-NONE-GOOD': 5.28,
    'M-VS1-VG-GOOD-NONE-GOOD': 5.28,
    'M-VS1-GOOD-VG-NONE-GOOD': 5.28,
    'M-VVS1-VG-EX-FAINT-POOR': 5.28,
    'M-VS1-POOR-EX-NONE-GOOD': 5.28,
    'M-VS1-POOR-POOR-NONE-VG': 5.28,
    'M-VVS1-GOOD-GOOD-FAINT-GOOD': 5.28,
    'M-VVS1-POOR-VG-FAINT-GOOD': 5.28,
    'M-VVS1-VG-POOR-FAINT-GOOD': 5.28,
    'M-VVS1-EX-VG-FAINT-POOR': 5.28,
    'M-VS1-EX-EX-NONE-POOR': 5.28,
    'D-SI2-POOR-POOR-MEDIUM-GOOD': 5.27,
    'D-SI2-POOR-EX-MEDIUM-POOR': 5.27,
    'D-SI2-GOOD-VG-MEDIUM-POOR': 5.27,
    'D-I2-GOOD-POOR-FAINT-GOOD': 5.27,
    'D-I2-VG-VG-FAINT-POOR': 5.27,
    'D-SI2-EX-POOR-MEDIUM-POOR': 5.27,
    'D-I2-EX-GOOD-FAINT-POOR': 5.27,
    'D-I2-POOR-GOOD-FAINT-GOOD': 5.27,
    'D-I2-GOOD-EX-FAINT-POOR': 5.27,
    'D-SI2-VG-GOOD-MEDIUM-POOR': 5.27,
    'E-SI2-EX-POOR-FAINT-POOR': 5.27,
    'E-SI2-GOOD-VG-FAINT-POOR': 5.27,
    'E-I2-POOR-GOOD-NONE-GOOD': 5.27,
    'E-SI2-VG-GOOD-FAINT-POOR': 5.27,
    'E-SI2-POOR-EX-FAINT-POOR': 5.27,
    'E-SI2-POOR-POOR-FAINT-GOOD': 5.27,
    'E-I2-GOOD-EX-NONE-POOR': 5.27,
    'E-I2-EX-GOOD-NONE-POOR': 5.27,
    'E-I2-GOOD-POOR-NONE-GOOD': 5.27,
    'E-I2-VG-VG-NONE-POOR': 5.27,
    'F-SI2-POOR-POOR-NONE-GOOD': 5.27,
    'F-SI2-GOOD-VG-NONE-POOR': 5.27,
    'F-SI2-POOR-EX-NONE-POOR': 5.27,
    'F-SI2-VG-GOOD-NONE-POOR': 5.27,
    'F-SI2-EX-POOR-NONE-POOR': 5.27,
    'G-I2-EX-VG-STRONG-GOOD': 5.27,
    'G-I2-VG-EX-STRONG-GOOD': 5.27,
    'G-I2-GOOD-GOOD-STRONG-VG': 5.27,
    'G-I2-POOR-VG-STRONG-VG': 5.27,
    'G-I2-VG-POOR-STRONG-VG': 5.27,
    'H-I2-GOOD-GOOD-MEDIUM-VG': 5.27,
    'H-I2-POOR-VG-MEDIUM-VG': 5.27,
    'H-I2-VG-POOR-MEDIUM-VG': 5.27,
    'H-I2-EX-VG-MEDIUM-GOOD': 5.27,
    'H-I2-VG-EX-MEDIUM-GOOD': 5.27,
    'H-SI2-VG-VG-STRONG-GOOD': 5.27,
    'H-SI2-EX-GOOD-STRONG-GOOD': 5.27,
    'H-SI2-GOOD-EX-STRONG-GOOD': 5.27,
    'H-SI2-GOOD-POOR-STRONG-VG': 5.27,
    'H-SI2-POOR-GOOD-STRONG-VG': 5.27,
    'I-SI2-GOOD-POOR-MEDIUM-VG': 5.27,
    'I-I2-VG-POOR-FAINT-VG': 5.27,
    'I-SI2-POOR-GOOD-MEDIUM-VG': 5.27,
    'I-I2-GOOD-GOOD-FAINT-VG': 5.27,
    'I-I2-POOR-VG-FAINT-VG': 5.27,
    'I-I2-EX-VG-FAINT-GOOD': 5.27,
    'I-SI2-GOOD-EX-MEDIUM-GOOD': 5.27,
    'I-SI2-EX-GOOD-MEDIUM-GOOD': 5.27,
    'I-SI2-VG-VG-MEDIUM-GOOD': 5.27,
    'I-I2-VG-EX-FAINT-GOOD': 5.27,
    'J-SI2-EX-GOOD-FAINT-GOOD': 5.27,
    'J-I2-GOOD-GOOD-NONE-VG': 5.27,
    'J-SI2-VG-VG-FAINT-GOOD': 5.27,
    'J-I2-POOR-VG-NONE-VG': 5.27,
    'J-SI2-POOR-GOOD-FAINT-VG': 5.27,
    'J-I2-VG-EX-NONE-GOOD': 5.27,
    'J-I2-EX-VG-NONE-GOOD': 5.27,
    'J-SI2-GOOD-EX-FAINT-GOOD': 5.27,
    'J-SI2-GOOD-POOR-FAINT-VG': 5.27,
    'J-I2-VG-POOR-NONE-VG': 5.27,
    'K-SI2-VG-VG-NONE-GOOD': 5.27,
    'K-SI2-GOOD-EX-NONE-GOOD': 5.27,
    'K-SI2-POOR-GOOD-NONE-VG': 5.27,
    'K-SI2-GOOD-POOR-NONE-VG': 5.27,
    'K-SI2-EX-GOOD-NONE-GOOD': 5.27,
    'L-I2-EX-EX-STRONG-VG': 5.27,
    'L-I2-VG-GOOD-STRONG-EX': 5.27,
    'L-I2-EX-POOR-STRONG-EX': 5.27,
    'L-I2-GOOD-VG-STRONG-EX': 5.27,
    'L-I2-POOR-EX-STRONG-EX': 5.27,
    'M-SI2-POOR-VG-STRONG-EX': 5.27,
    'M-I2-VG-GOOD-MEDIUM-EX': 5.27,
    'M-SI2-VG-EX-STRONG-VG': 5.27,
    'M-I2-EX-POOR-MEDIUM-EX': 5.27,
    'M-I2-GOOD-VG-MEDIUM-EX': 5.27,
    'M-SI2-GOOD-GOOD-STRONG-EX': 5.27,
    'M-I2-POOR-EX-MEDIUM-EX': 5.27,
    'M-SI2-VG-POOR-STRONG-EX': 5.27,
    'M-I2-EX-EX-MEDIUM-VG': 5.27,
    'M-SI2-EX-VG-STRONG-VG': 5.27,
    'D-VS2-GOOD-GOOD-STRONG-POOR': 5.26,
    'D-VS2-POOR-VG-STRONG-POOR': 5.26,
    'D-VS2-VG-POOR-STRONG-POOR': 5.26,
    'E-VS2-POOR-VG-MEDIUM-POOR': 5.26,
    'E-VS2-VG-POOR-MEDIUM-POOR': 5.26,
    'E-VS2-GOOD-GOOD-MEDIUM-POOR': 5.26,
    'E-VVS2-GOOD-POOR-STRONG-POOR': 5.26,
    'E-VVS2-POOR-GOOD-STRONG-POOR': 5.26,
    'F-VS2-GOOD-GOOD-FAINT-POOR': 5.26,
    'F-VS2-VG-POOR-FAINT-POOR': 5.26,
    'F-VS2-POOR-VG-FAINT-POOR': 5.26,
    'F-VVS2-GOOD-POOR-MEDIUM-POOR': 5.26,
    'F-VVS2-POOR-GOOD-MEDIUM-POOR': 5.26,
    'G-VS2-GOOD-GOOD-NONE-POOR': 5.26,
    'G-VVS2-GOOD-POOR-FAINT-POOR': 5.26,
    'G-VVS2-POOR-GOOD-FAINT-POOR': 5.26,
    'G-VS2-POOR-VG-NONE-POOR': 5.26,
    'G-VS2-VG-POOR-NONE-POOR': 5.26,
    'H-VVS2-GOOD-POOR-NONE-POOR': 5.26,
    'H-VVS2-POOR-GOOD-NONE-POOR': 5.26,
    'I-VS2-GOOD-VG-STRONG-GOOD': 5.26,
    'I-VS2-POOR-EX-STRONG-GOOD': 5.26,
    'I-VS2-POOR-POOR-STRONG-VG': 5.26,
    'I-VS2-EX-EX-STRONG-POOR': 5.26,
    'I-VS2-EX-POOR-STRONG-GOOD': 5.26,
    'I-VS2-VG-GOOD-STRONG-GOOD': 5.26,
    'J-VS2-POOR-EX-MEDIUM-GOOD': 5.26,
    'J-VS2-EX-EX-MEDIUM-POOR': 5.26,
    'J-VVS2-VG-EX-STRONG-POOR': 5.26,
    'J-VVS2-POOR-VG-STRONG-GOOD': 5.26,
    'J-VS2-POOR-POOR-MEDIUM-VG': 5.26,
    'J-VVS2-EX-VG-STRONG-POOR': 5.26,
    'J-VS2-GOOD-VG-MEDIUM-GOOD': 5.26,
    'J-VS2-EX-POOR-MEDIUM-GOOD': 5.26,
    'J-VVS2-GOOD-GOOD-STRONG-GOOD': 5.26,
    'J-VVS2-VG-POOR-STRONG-GOOD': 5.26,
    'J-VS2-VG-GOOD-MEDIUM-GOOD': 5.26,
    'K-VS2-POOR-EX-FAINT-GOOD': 5.26,
    'K-VS2-GOOD-VG-FAINT-GOOD': 5.26,
    'K-VVS2-GOOD-GOOD-MEDIUM-GOOD': 5.26,
    'K-VS2-VG-GOOD-FAINT-GOOD': 5.26,
    'K-VVS2-VG-POOR-MEDIUM-GOOD': 5.26,
    'K-VVS2-EX-VG-MEDIUM-POOR': 5.26,
    'K-VS2-EX-POOR-FAINT-GOOD': 5.26,
    'K-VVS2-VG-EX-MEDIUM-POOR': 5.26,
    'K-VS2-POOR-POOR-FAINT-VG': 5.26,
    'K-VVS2-POOR-VG-MEDIUM-GOOD': 5.26,
    'K-VS2-EX-EX-FAINT-POOR': 5.26,
    'L-VS2-POOR-POOR-NONE-VG': 5.26,
    'L-VVS2-GOOD-GOOD-FAINT-GOOD': 5.26,
    'L-VS2-EX-POOR-NONE-GOOD': 5.26,
    'L-VS2-VG-GOOD-NONE-GOOD': 5.26,
    'L-VS2-GOOD-VG-NONE-GOOD': 5.26,
    'L-VS2-EX-EX-NONE-POOR': 5.26,
    'L-VS2-POOR-EX-NONE-GOOD': 5.26,
    'L-VVS2-POOR-VG-FAINT-GOOD': 5.26,
    'L-VVS2-EX-VG-FAINT-POOR': 5.26,
    'L-VVS2-VG-POOR-FAINT-GOOD': 5.26,
    'L-VVS2-VG-EX-FAINT-POOR': 5.26,
    'M-VVS2-GOOD-GOOD-NONE-GOOD': 5.26,
    'M-VVS2-VG-POOR-NONE-GOOD': 5.26,
    'M-VVS2-EX-VG-NONE-POOR': 5.26,
    'M-VVS2-POOR-VG-NONE-GOOD': 5.26,
    'M-VVS2-VG-EX-NONE-POOR': 5.26,
    'F-IF-POOR-POOR-STRONG-POOR': 5.25,
    'G-IF-POOR-POOR-MEDIUM-POOR': 5.25,
    'H-IF-POOR-POOR-FAINT-POOR': 5.25,
    'I-IF-POOR-POOR-NONE-POOR': 5.25,
    'K-IF-GOOD-EX-STRONG-POOR': 5.25,
    'K-IF-VG-VG-STRONG-POOR': 5.25,
    'K-IF-GOOD-POOR-STRONG-GOOD': 5.25,
    'K-IF-EX-GOOD-STRONG-POOR': 5.25,
    'K-IF-POOR-GOOD-STRONG-GOOD': 5.25,
    'L-IF-EX-GOOD-MEDIUM-POOR': 5.25,
    'L-IF-POOR-GOOD-MEDIUM-GOOD': 5.25,
    'L-IF-GOOD-EX-MEDIUM-POOR': 5.25,
    'L-IF-VG-VG-MEDIUM-POOR': 5.25,
    'L-IF-GOOD-POOR-MEDIUM-GOOD': 5.25,
    'M-IF-GOOD-EX-FAINT-POOR': 5.25,
    'M-IF-VG-VG-FAINT-POOR': 5.25,
    'M-IF-GOOD-POOR-FAINT-GOOD': 5.25,
    'M-IF-EX-GOOD-FAINT-POOR': 5.25,
    'M-IF-POOR-GOOD-FAINT-GOOD': 5.25,
    'D-I1-EX-POOR-FAINT-POOR': 5.24,
    'D-I1-VG-GOOD-FAINT-POOR': 5.24,
    'D-I1-GOOD-VG-FAINT-POOR': 5.24,
    'D-SI1-GOOD-GOOD-MEDIUM-POOR': 5.24,
    'D-SI1-VG-POOR-MEDIUM-POOR': 5.24,
    'D-I1-POOR-POOR-FAINT-GOOD': 5.24,
    'D-SI1-POOR-VG-MEDIUM-POOR': 5.24,
    'D-I1-POOR-EX-FAINT-POOR': 5.24,
    'E-SI1-POOR-VG-FAINT-POOR': 5.24,
    'E-SI1-GOOD-GOOD-FAINT-POOR': 5.24,
    'E-I1-VG-GOOD-NONE-POOR': 5.24,
    'E-I1-GOOD-VG-NONE-POOR': 5.24,
    'E-I1-POOR-EX-NONE-POOR': 5.24,
    'E-I1-POOR-POOR-NONE-GOOD': 5.24,
    'E-SI1-VG-POOR-FAINT-POOR': 5.24,
    'E-I1-EX-POOR-NONE-POOR': 5.24,
    'F-SI1-GOOD-GOOD-NONE-POOR': 5.24,
    'F-SI1-POOR-VG-NONE-POOR': 5.24,
    'F-SI1-VG-POOR-NONE-POOR': 5.24,
    'G-I1-GOOD-EX-STRONG-GOOD': 5.24,
    'G-I1-GOOD-POOR-STRONG-VG': 5.24,
    'G-I1-POOR-GOOD-STRONG-VG': 5.24,
    'G-I1-VG-VG-STRONG-GOOD': 5.24,
    'G-I1-EX-GOOD-STRONG-GOOD': 5.24,
    'H-SI1-GOOD-VG-STRONG-GOOD': 5.24,
    'H-SI1-VG-GOOD-STRONG-GOOD': 5.24,
    'H-SI1-POOR-POOR-STRONG-VG': 5.24,
    'H-SI1-EX-POOR-STRONG-GOOD': 5.24,
    'H-SI1-POOR-EX-STRONG-GOOD': 5.24,
    'H-SI1-EX-EX-STRONG-POOR': 5.24,
    'H-I1-EX-GOOD-MEDIUM-GOOD': 5.24,
    'H-I1-VG-VG-MEDIUM-GOOD': 5.24,
    'H-I1-GOOD-EX-MEDIUM-GOOD': 5.24,
    'H-I1-GOOD-POOR-MEDIUM-VG': 5.24,
    'H-I1-POOR-GOOD-MEDIUM-VG': 5.24,
    'I-I1-VG-VG-FAINT-GOOD': 5.24,
    'I-I1-EX-GOOD-FAINT-GOOD': 5.24,
    'I-SI1-GOOD-VG-MEDIUM-GOOD': 5.24,
    'I-I1-GOOD-EX-FAINT-GOOD': 5.24,
    'I-SI1-POOR-POOR-MEDIUM-VG': 5.24,
    'I-SI1-VG-GOOD-MEDIUM-GOOD': 5.24,
    'I-SI1-POOR-EX-MEDIUM-GOOD': 5.24,
    'I-SI1-EX-POOR-MEDIUM-GOOD': 5.24,
    'I-SI1-EX-EX-MEDIUM-POOR': 5.24,
    'I-I1-GOOD-POOR-FAINT-VG': 5.24,
    'I-I1-POOR-GOOD-FAINT-VG': 5.24,
    'J-SI1-EX-EX-FAINT-POOR': 5.24,
    'J-SI1-EX-POOR-FAINT-GOOD': 5.24,
    'J-SI1-VG-GOOD-FAINT-GOOD': 5.24,
    'J-SI1-GOOD-VG-FAINT-GOOD': 5.24,
    'J-SI1-POOR-POOR-FAINT-VG': 5.24,
    'J-SI1-POOR-EX-FAINT-GOOD': 5.24,
    'J-I1-GOOD-EX-NONE-GOOD': 5.24,
    'J-I1-GOOD-POOR-NONE-VG': 5.24,
    'J-I1-EX-GOOD-NONE-GOOD': 5.24,
    'J-I1-POOR-GOOD-NONE-VG': 5.24,
    'J-I1-VG-VG-NONE-GOOD': 5.24,
    'K-SI1-POOR-EX-NONE-GOOD': 5.24,
    'K-SI1-GOOD-VG-NONE-GOOD': 5.24,
    'K-SI1-VG-GOOD-NONE-GOOD': 5.24,
    'K-SI1-EX-POOR-NONE-GOOD': 5.24,
    'K-SI1-EX-EX-NONE-POOR': 5.24,
    'K-SI1-POOR-POOR-NONE-VG': 5.24,
    'L-I1-GOOD-GOOD-STRONG-EX': 5.24,
    'L-I1-EX-VG-STRONG-VG': 5.24,
    'L-I1-VG-EX-STRONG-VG': 5.24,
    'L-I1-VG-POOR-STRONG-EX': 5.24,
    'L-I1-POOR-VG-STRONG-EX': 5.24,
    'M-I1-POOR-VG-MEDIUM-EX': 5.24,
    'M-I1-EX-VG-MEDIUM-VG': 5.24,
    'M-I1-VG-EX-MEDIUM-VG': 5.24,
    'M-SI1-EX-GOOD-STRONG-VG': 5.24,
    'M-I1-GOOD-GOOD-MEDIUM-EX': 5.24,
    'M-SI1-VG-VG-STRONG-VG': 5.24,
    'M-I1-VG-POOR-MEDIUM-EX': 5.24,
    'M-SI1-GOOD-EX-STRONG-VG': 5.24,
    'M-SI1-GOOD-POOR-STRONG-EX': 5.24,
    'M-SI1-POOR-GOOD-STRONG-EX': 5.24,
    'D-VS1-POOR-GOOD-STRONG-POOR': 5.23,
    'D-VS1-GOOD-POOR-STRONG-POOR': 5.23,
    'E-VS1-GOOD-POOR-MEDIUM-POOR': 5.23,
    'E-VS1-POOR-GOOD-MEDIUM-POOR': 5.23,
    'E-VVS1-POOR-POOR-STRONG-POOR': 5.23,
    'F-VS1-POOR-GOOD-FAINT-POOR': 5.23,
    'F-VS1-GOOD-POOR-FAINT-POOR': 5.23,
    'F-VVS1-POOR-POOR-MEDIUM-POOR': 5.23,
    'G-VS1-GOOD-POOR-NONE-POOR': 5.23,
    'G-VVS1-POOR-POOR-FAINT-POOR': 5.23,
    'G-VS1-POOR-GOOD-NONE-POOR': 5.23,
    'H-VVS1-POOR-POOR-NONE-POOR': 5.23,
    'I-VS1-POOR-VG-STRONG-GOOD': 5.23,
    'I-VS1-GOOD-GOOD-STRONG-GOOD': 5.23,
    'I-VS1-VG-POOR-STRONG-GOOD': 5.23,
    'I-VS1-VG-EX-STRONG-POOR': 5.23,
    'I-VS1-EX-VG-STRONG-POOR': 5.23,
    'J-VVS1-EX-GOOD-STRONG-POOR': 5.23,
    'J-VVS1-GOOD-POOR-STRONG-GOOD': 5.23,
    'J-VVS1-POOR-GOOD-STRONG-GOOD': 5.23,
    'J-VVS1-VG-VG-STRONG-POOR': 5.23,
    'J-VS1-GOOD-GOOD-MEDIUM-GOOD': 5.23,
    'J-VS1-VG-POOR-MEDIUM-GOOD': 5.23,
    'J-VS1-VG-EX-MEDIUM-POOR': 5.23,
    'J-VVS1-GOOD-EX-STRONG-POOR': 5.23,
    'J-VS1-EX-VG-MEDIUM-POOR': 5.23,
    'J-VS1-POOR-VG-MEDIUM-GOOD': 5.23,
    'K-VVS1-POOR-GOOD-MEDIUM-GOOD': 5.23,
    'K-VS1-POOR-VG-FAINT-GOOD': 5.23,
    'K-VS1-GOOD-GOOD-FAINT-GOOD': 5.23,
    'K-VS1-EX-VG-FAINT-POOR': 5.23,
    'K-VS1-VG-EX-FAINT-POOR': 5.23,
    'K-VS1-VG-POOR-FAINT-GOOD': 5.23,
    'K-VVS1-GOOD-POOR-MEDIUM-GOOD': 5.23,
    'K-VVS1-EX-GOOD-MEDIUM-POOR': 5.23,
    'K-VVS1-VG-VG-MEDIUM-POOR': 5.23,
    'K-VVS1-GOOD-EX-MEDIUM-POOR': 5.23,
    'L-VVS1-VG-VG-FAINT-POOR': 5.23,
    'L-VVS1-GOOD-EX-FAINT-POOR': 5.23,
    'L-VVS1-GOOD-POOR-FAINT-GOOD': 5.23,
    'L-VVS1-EX-GOOD-FAINT-POOR': 5.23,
    'L-VVS1-POOR-GOOD-FAINT-GOOD': 5.23,
    'L-VS1-EX-VG-NONE-POOR': 5.23,
    'L-VS1-VG-EX-NONE-POOR': 5.23,
    'L-VS1-GOOD-GOOD-NONE-GOOD': 5.23,
    'L-VS1-VG-POOR-NONE-GOOD': 5.23,
    'L-VS1-POOR-VG-NONE-GOOD': 5.23,
    'M-VVS1-GOOD-POOR-NONE-GOOD': 5.23,
    'M-VVS1-EX-GOOD-NONE-POOR': 5.23,
    'M-VVS1-VG-VG-NONE-POOR': 5.23,
    'M-VVS1-GOOD-EX-NONE-POOR': 5.23,
    'M-VVS1-POOR-GOOD-NONE-GOOD': 5.23,
    'D-I2-GOOD-VG-NONE-POOR': 5.22,
    'D-I2-EX-POOR-NONE-POOR': 5.22,
    'D-I2-VG-GOOD-NONE-POOR': 5.22,
    'D-SI2-VG-POOR-FAINT-POOR': 5.22,
    'D-SI2-GOOD-GOOD-FAINT-POOR': 5.22,
    'D-I2-POOR-POOR-NONE-GOOD': 5.22,
    'D-I2-POOR-EX-NONE-POOR': 5.22,
    'D-SI2-POOR-VG-FAINT-POOR': 5.22,
    'E-SI2-POOR-VG-NONE-POOR': 5.22,
    'E-SI2-GOOD-GOOD-NONE-POOR': 5.22,
    'E-SI2-VG-POOR-NONE-POOR': 5.22,
    'F-I2-POOR-GOOD-STRONG-VG': 5.22,
    'F-I2-GOOD-POOR-STRONG-VG': 5.22,
    'F-I2-GOOD-EX-STRONG-GOOD': 5.22,
    'F-I2-VG-VG-STRONG-GOOD': 5.22,
    'F-I2-EX-GOOD-STRONG-GOOD': 5.22,
    'G-SI2-EX-EX-STRONG-POOR': 5.22,
    'G-I2-POOR-GOOD-MEDIUM-VG': 5.22,
    'G-SI2-VG-GOOD-STRONG-GOOD': 5.22,
    'G-I2-EX-GOOD-MEDIUM-GOOD': 5.22,
    'G-I2-GOOD-POOR-MEDIUM-VG': 5.22,
    'G-SI2-EX-POOR-STRONG-GOOD': 5.22,
    'G-SI2-POOR-POOR-STRONG-VG': 5.22,
    'G-SI2-POOR-EX-STRONG-GOOD': 5.22,
    'G-I2-VG-VG-MEDIUM-GOOD': 5.22,
    'G-SI2-GOOD-VG-STRONG-GOOD': 5.22,
    'G-I2-GOOD-EX-MEDIUM-GOOD': 5.22,
    'H-SI2-VG-GOOD-MEDIUM-GOOD': 5.22,
    'H-SI2-GOOD-VG-MEDIUM-GOOD': 5.22,
    'H-SI2-POOR-EX-MEDIUM-GOOD': 5.22,
    'H-SI2-EX-EX-MEDIUM-POOR': 5.22,
    'H-SI2-POOR-POOR-MEDIUM-VG': 5.22,
    'H-I2-POOR-GOOD-FAINT-VG': 5.22,
    'H-SI2-EX-POOR-MEDIUM-GOOD': 5.22,
    'H-I2-EX-GOOD-FAINT-GOOD': 5.22,
    'H-I2-GOOD-POOR-FAINT-VG': 5.22,
    'H-I2-VG-VG-FAINT-GOOD': 5.22,
    'H-I2-GOOD-EX-FAINT-GOOD': 5.22,
    'I-I2-POOR-GOOD-NONE-VG': 5.22,
    'I-SI2-EX-POOR-FAINT-GOOD': 5.22,
    'I-SI2-VG-GOOD-FAINT-GOOD': 5.22,
    'I-SI2-EX-EX-FAINT-POOR': 5.22,
    'I-SI2-GOOD-VG-FAINT-GOOD': 5.22,
    'I-SI2-POOR-EX-FAINT-GOOD': 5.22,
    'I-I2-GOOD-EX-NONE-GOOD': 5.22,
    'I-SI2-POOR-POOR-FAINT-VG': 5.22,
    'I-I2-VG-VG-NONE-GOOD': 5.22,
    'I-I2-EX-GOOD-NONE-GOOD': 5.22,
    'I-I2-GOOD-POOR-NONE-VG': 5.22,
    'J-SI2-EX-POOR-NONE-GOOD': 5.22,
    'J-SI2-POOR-EX-NONE-GOOD': 5.22,
    'J-SI2-EX-EX-NONE-POOR': 5.22,
    'J-SI2-VG-GOOD-NONE-GOOD': 5.22,
    'J-SI2-GOOD-VG-NONE-GOOD': 5.22,
    'J-SI2-POOR-POOR-NONE-VG': 5.22,
    'K-I2-EX-VG-STRONG-VG': 5.22,
    'K-I2-VG-POOR-STRONG-EX': 5.22,
    'K-I2-VG-EX-STRONG-VG': 5.22,
    'K-I2-GOOD-GOOD-STRONG-EX': 5.22,
    'K-I2-POOR-VG-STRONG-EX': 5.22,
    'L-I2-VG-POOR-MEDIUM-EX': 5.22,
    'L-SI2-GOOD-EX-STRONG-VG': 5.22,
    'L-SI2-VG-VG-STRONG-VG': 5.22,
    'L-I2-POOR-VG-MEDIUM-EX': 5.22,
    'L-I2-GOOD-GOOD-MEDIUM-EX': 5.22,
    'L-SI2-EX-GOOD-STRONG-VG': 5.22,
    'L-SI2-GOOD-POOR-STRONG-EX': 5.22,
    'L-I2-VG-EX-MEDIUM-VG': 5.22,
    'L-I2-EX-VG-MEDIUM-VG': 5.22,
    'L-SI2-POOR-GOOD-STRONG-EX': 5.22,
    'M-SI2-VG-VG-MEDIUM-VG': 5.22,
    'M-I2-EX-VG-FAINT-VG': 5.22,
    'M-I2-GOOD-GOOD-FAINT-EX': 5.22,
    'M-I2-VG-POOR-FAINT-EX': 5.22,
    'M-SI2-EX-GOOD-MEDIUM-VG': 5.22,
    'M-SI2-GOOD-EX-MEDIUM-VG': 5.22,
    'M-I2-VG-EX-FAINT-VG': 5.22,
    'M-I2-POOR-VG-FAINT-EX': 5.22,
    'M-SI2-POOR-GOOD-MEDIUM-EX': 5.22,
    'M-SI2-GOOD-POOR-MEDIUM-EX': 5.22,
    'D-VS2-POOR-GOOD-MEDIUM-POOR': 5.21,
    'D-VVS2-POOR-POOR-STRONG-POOR': 5.21,
    'D-VS2-GOOD-POOR-MEDIUM-POOR': 5.21,
    'E-VS2-GOOD-POOR-FAINT-POOR': 5.21,
    'E-VVS2-POOR-POOR-MEDIUM-POOR': 5.21,
    'E-VS2-POOR-GOOD-FAINT-POOR': 5.21,
    'F-VS2-POOR-GOOD-NONE-POOR': 5.21,
    'F-VS2-GOOD-POOR-NONE-POOR': 5.21,
    'F-VVS2-POOR-POOR-FAINT-POOR': 5.21,
    'G-VVS2-POOR-POOR-NONE-POOR': 5.21,
    'H-VS2-POOR-VG-STRONG-GOOD': 5.21,
    'H-VS2-GOOD-GOOD-STRONG-GOOD': 5.21,
    'H-VS2-VG-EX-STRONG-POOR': 5.21,
    'H-VS2-VG-POOR-STRONG-GOOD': 5.21,
    'H-VS2-EX-VG-STRONG-POOR': 5.21,
    'I-VVS2-VG-VG-STRONG-POOR': 5.21,
    'I-VVS2-POOR-GOOD-STRONG-GOOD': 5.21,
    'I-VVS2-GOOD-POOR-STRONG-GOOD': 5.21,
    'I-VS2-POOR-VG-MEDIUM-GOOD': 5.21,
    'I-VS2-GOOD-GOOD-MEDIUM-GOOD': 5.21,
    'I-VS2-VG-POOR-MEDIUM-GOOD': 5.21,
    'I-VS2-VG-EX-MEDIUM-POOR': 5.21,
    'I-VS2-EX-VG-MEDIUM-POOR': 5.21,
    'I-VVS2-EX-GOOD-STRONG-POOR': 5.21,
    'I-VVS2-GOOD-EX-STRONG-POOR': 5.21,
    'J-VS2-POOR-VG-FAINT-GOOD': 5.21,
    'J-VVS2-GOOD-EX-MEDIUM-POOR': 5.21,
    'J-VS2-GOOD-GOOD-FAINT-GOOD': 5.21,
    'J-VVS2-EX-GOOD-MEDIUM-POOR': 5.21,
    'J-VVS2-POOR-GOOD-MEDIUM-GOOD': 5.21,
    'J-VVS2-VG-VG-MEDIUM-POOR': 5.21,
    'J-VS2-VG-EX-FAINT-POOR': 5.21,
    'J-VS2-EX-VG-FAINT-POOR': 5.21,
    'J-VS2-VG-POOR-FAINT-GOOD': 5.21,
    'J-VVS2-GOOD-POOR-MEDIUM-GOOD': 5.21,
    'K-VS2-POOR-VG-NONE-GOOD': 5.21,
    'K-VS2-VG-POOR-NONE-GOOD': 5.21,
    'K-VS2-EX-VG-NONE-POOR': 5.21,
    'K-VS2-VG-EX-NONE-POOR': 5.21,
    'K-VS2-GOOD-GOOD-NONE-GOOD': 5.21,
    'K-VVS2-EX-GOOD-FAINT-POOR': 5.21,
    'K-VVS2-VG-VG-FAINT-POOR': 5.21,
    'K-VVS2-GOOD-EX-FAINT-POOR': 5.21,
    'K-VVS2-GOOD-POOR-FAINT-GOOD': 5.21,
    'K-VVS2-POOR-GOOD-FAINT-GOOD': 5.21,
    'L-VVS2-POOR-GOOD-NONE-GOOD': 5.21,
    'L-VVS2-VG-VG-NONE-POOR': 5.21,
    'L-VVS2-GOOD-EX-NONE-POOR': 5.21,
    'L-VVS2-EX-GOOD-NONE-POOR': 5.21,
    'L-VVS2-GOOD-POOR-NONE-GOOD': 5.21,
    'M-VS2-EX-EX-STRONG-GOOD': 5.21,
    'M-VS2-POOR-EX-STRONG-VG': 5.21,
    'M-VS2-GOOD-VG-STRONG-VG': 5.21,
    'M-VS2-POOR-POOR-STRONG-EX': 5.21,
    'M-VS2-VG-GOOD-STRONG-VG': 5.21,
    'M-VS2-EX-POOR-STRONG-VG': 5.21,
    'J-IF-POOR-POOR-STRONG-GOOD': 5.2,
    'J-IF-EX-POOR-STRONG-POOR': 5.2,
    'J-IF-VG-GOOD-STRONG-POOR': 5.2,
    'J-IF-GOOD-VG-STRONG-POOR': 5.2,
    'J-IF-POOR-EX-STRONG-POOR': 5.2,
    'K-IF-VG-GOOD-MEDIUM-POOR': 5.2,
    'K-IF-EX-POOR-MEDIUM-POOR': 5.2,
    'K-IF-POOR-EX-MEDIUM-POOR': 5.2,
    'K-IF-POOR-POOR-MEDIUM-GOOD': 5.2,
    'K-IF-GOOD-VG-MEDIUM-POOR': 5.2,
    'L-IF-GOOD-VG-FAINT-POOR': 5.2,
    'L-IF-EX-POOR-FAINT-POOR': 5.2,
    'L-IF-POOR-POOR-FAINT-GOOD': 5.2,
    'L-IF-VG-GOOD-FAINT-POOR': 5.2,
    'L-IF-POOR-EX-FAINT-POOR': 5.2,
    'M-IF-VG-GOOD-NONE-POOR': 5.2,
    'M-IF-POOR-EX-NONE-POOR': 5.2,
    'M-IF-POOR-POOR-NONE-GOOD': 5.2,
    'M-IF-GOOD-VG-NONE-POOR': 5.2,
    'M-IF-EX-POOR-NONE-POOR': 5.2,
    'D-I1-VG-POOR-NONE-POOR': 5.19,
    'D-I1-GOOD-GOOD-NONE-POOR': 5.19,
    'D-SI1-GOOD-POOR-FAINT-POOR': 5.19,
    'D-SI1-POOR-GOOD-FAINT-POOR': 5.19,
    'D-I1-POOR-VG-NONE-POOR': 5.19,
    'E-SI1-GOOD-POOR-NONE-POOR': 5.19,
    'E-SI1-POOR-GOOD-NONE-POOR': 5.19,
    'F-I1-POOR-EX-STRONG-GOOD': 5.19,
    'F-I1-POOR-POOR-STRONG-VG': 5.19,
    'F-I1-GOOD-VG-STRONG-GOOD': 5.19,
    'F-I1-VG-GOOD-STRONG-GOOD': 5.19,
    'F-I1-EX-POOR-STRONG-GOOD': 5.19,
    'F-I1-EX-EX-STRONG-POOR': 5.19,
    'G-SI1-VG-POOR-STRONG-GOOD': 5.19,
    'G-SI1-VG-EX-STRONG-POOR': 5.19,
    'G-SI1-GOOD-GOOD-STRONG-GOOD': 5.19,
    'G-I1-VG-GOOD-MEDIUM-GOOD': 5.19,
    'G-I1-POOR-POOR-MEDIUM-VG': 5.19,
    'G-I1-POOR-EX-MEDIUM-GOOD': 5.19,
    'G-I1-GOOD-VG-MEDIUM-GOOD': 5.19,
    'G-SI1-EX-VG-STRONG-POOR': 5.19,
    'G-SI1-POOR-VG-STRONG-GOOD': 5.19,
    'G-I1-EX-EX-MEDIUM-POOR': 5.19,
    'G-I1-EX-POOR-MEDIUM-GOOD': 5.19,
    'H-I1-VG-GOOD-FAINT-GOOD': 5.19,
    'H-I1-EX-POOR-FAINT-GOOD': 5.19,
    'H-I1-POOR-POOR-FAINT-VG': 5.19,
    'H-I1-POOR-EX-FAINT-GOOD': 5.19,
    'H-I1-GOOD-VG-FAINT-GOOD': 5.19,
    'H-I1-EX-EX-FAINT-POOR': 5.19,
    'H-SI1-VG-EX-MEDIUM-POOR': 5.19,
    'H-SI1-EX-VG-MEDIUM-POOR': 5.19,
    'H-SI1-VG-POOR-MEDIUM-GOOD': 5.19,
    'H-SI1-GOOD-GOOD-MEDIUM-GOOD': 5.19,
    'H-SI1-POOR-VG-MEDIUM-GOOD': 5.19,
    'I-SI1-POOR-VG-FAINT-GOOD': 5.19,
    'I-SI1-VG-EX-FAINT-POOR': 5.19,
    'I-I1-VG-GOOD-NONE-GOOD': 5.19,
    'I-I1-POOR-POOR-NONE-VG': 5.19,
    'I-SI1-EX-VG-FAINT-POOR': 5.19,
    'I-I1-EX-POOR-NONE-GOOD': 5.19,
    'I-SI1-GOOD-GOOD-FAINT-GOOD': 5.19,
    'I-SI1-VG-POOR-FAINT-GOOD': 5.19,
    'I-I1-EX-EX-NONE-POOR': 5.19,
    'I-I1-POOR-EX-NONE-GOOD': 5.19,
    'I-I1-GOOD-VG-NONE-GOOD': 5.19,
    'J-SI1-POOR-VG-NONE-GOOD': 5.19,
    'J-SI1-GOOD-GOOD-NONE-GOOD': 5.19,
    'J-SI1-EX-VG-NONE-POOR': 5.19,
    'J-SI1-VG-EX-NONE-POOR': 5.19,
    'J-SI1-VG-POOR-NONE-GOOD': 5.19,
    'K-I1-EX-GOOD-STRONG-VG': 5.19,
    'K-I1-VG-VG-STRONG-VG': 5.19,
    'K-I1-POOR-GOOD-STRONG-EX': 5.19,
    'K-I1-GOOD-EX-STRONG-VG': 5.19,
    'K-I1-GOOD-POOR-STRONG-EX': 5.19,
    'L-I1-EX-GOOD-MEDIUM-VG': 5.19,
    'L-I1-GOOD-POOR-MEDIUM-EX': 5.19,
    'L-SI1-GOOD-VG-STRONG-VG': 5.19,
    'L-SI1-POOR-POOR-STRONG-EX': 5.19,
    'L-I1-VG-VG-MEDIUM-VG': 5.19,
    'L-I1-POOR-GOOD-MEDIUM-EX': 5.19,
    'L-SI1-EX-POOR-STRONG-VG': 5.19,
    'L-SI1-EX-EX-STRONG-GOOD': 5.19,
    'L-I1-GOOD-EX-MEDIUM-VG': 5.19,
    'L-SI1-VG-GOOD-STRONG-VG': 5.19,
    'L-SI1-POOR-EX-STRONG-VG': 5.19,
    'M-SI1-VG-GOOD-MEDIUM-VG': 5.19,
    'M-SI1-EX-EX-MEDIUM-GOOD': 5.19,
    'M-I1-GOOD-POOR-FAINT-EX': 5.19,
    'M-I1-POOR-GOOD-FAINT-EX': 5.19,
    'M-SI1-EX-POOR-MEDIUM-VG': 5.19,
    'M-SI1-GOOD-VG-MEDIUM-VG': 5.19,
    'M-I1-VG-VG-FAINT-VG': 5.19,
    'M-SI1-POOR-EX-MEDIUM-VG': 5.19,
    'M-I1-GOOD-EX-FAINT-VG': 5.19,
    'M-I1-EX-GOOD-FAINT-VG': 5.19,
    'M-SI1-POOR-POOR-MEDIUM-EX': 5.19,
    'D-VS1-POOR-POOR-MEDIUM-POOR': 5.18,
    'E-VS1-POOR-POOR-FAINT-POOR': 5.18,
    'F-VS1-POOR-POOR-NONE-POOR': 5.18,
    'H-VS1-POOR-GOOD-STRONG-GOOD': 5.18,
    'H-VS1-GOOD-EX-STRONG-POOR': 5.18,
    'H-VS1-GOOD-POOR-STRONG-GOOD': 5.18,
    'H-VS1-VG-VG-STRONG-POOR': 5.18,
    'H-VS1-EX-GOOD-STRONG-POOR': 5.18,
    'I-VVS1-EX-POOR-STRONG-POOR': 5.18,
    'I-VVS1-GOOD-VG-STRONG-POOR': 5.18,
    'I-VVS1-POOR-POOR-STRONG-GOOD': 5.18,
    'I-VVS1-POOR-EX-STRONG-POOR': 5.18,
    'I-VS1-POOR-GOOD-MEDIUM-GOOD': 5.18,
    'I-VVS1-VG-GOOD-STRONG-POOR': 5.18,
    'I-VS1-VG-VG-MEDIUM-POOR': 5.18,
    'I-VS1-GOOD-EX-MEDIUM-POOR': 5.18,
    'I-VS1-EX-GOOD-MEDIUM-POOR': 5.18,
    'I-VS1-GOOD-POOR-MEDIUM-GOOD': 5.18,
    'J-VS1-POOR-GOOD-FAINT-GOOD': 5.18,
    'J-VVS1-POOR-POOR-MEDIUM-GOOD': 5.18,
    'J-VS1-EX-GOOD-FAINT-POOR': 5.18,
    'J-VVS1-VG-GOOD-MEDIUM-POOR': 5.18,
    'J-VS1-GOOD-POOR-FAINT-GOOD': 5.18,
    'J-VS1-GOOD-EX-FAINT-POOR': 5.18,
    'J-VVS1-POOR-EX-MEDIUM-POOR': 5.18,
    'J-VVS1-GOOD-VG-MEDIUM-POOR': 5.18,
    'J-VVS1-EX-POOR-MEDIUM-POOR': 5.18,
    'J-VS1-VG-VG-FAINT-POOR': 5.18,
    'K-VVS1-VG-GOOD-FAINT-POOR': 5.18,
    'K-VVS1-EX-POOR-FAINT-POOR': 5.18,
    'K-VVS1-POOR-POOR-FAINT-GOOD': 5.18,
    'K-VVS1-GOOD-VG-FAINT-POOR': 5.18,
    'K-VVS1-POOR-EX-FAINT-POOR': 5.18,
    'K-VS1-GOOD-EX-NONE-POOR': 5.18,
    'K-VS1-GOOD-POOR-NONE-GOOD': 5.18,
    'K-VS1-EX-GOOD-NONE-POOR': 5.18,
    'K-VS1-VG-VG-NONE-POOR': 5.18,
    'K-VS1-POOR-GOOD-NONE-GOOD': 5.18,
    'L-VVS1-POOR-POOR-NONE-GOOD': 5.18,
    'L-VVS1-POOR-EX-NONE-POOR': 5.18,
    'L-VVS1-GOOD-VG-NONE-POOR': 5.18,
    'L-VVS1-EX-POOR-NONE-POOR': 5.18,
    'L-VVS1-VG-GOOD-NONE-POOR': 5.18,
    'M-VS1-VG-POOR-STRONG-VG': 5.18,
    'M-VS1-VG-EX-STRONG-GOOD': 5.18,
    'M-VS1-EX-VG-STRONG-GOOD': 5.18,
    'M-VS1-POOR-VG-STRONG-VG': 5.18,
    'M-VS1-GOOD-GOOD-STRONG-VG': 5.18,
    'D-SI2-POOR-GOOD-NONE-POOR': 5.17,
    'D-SI2-GOOD-POOR-NONE-POOR': 5.17,
    'E-I2-VG-GOOD-STRONG-GOOD': 5.17,
    'E-I2-POOR-POOR-STRONG-VG': 5.17,
    'E-I2-EX-POOR-STRONG-GOOD': 5.17,
    'E-I2-POOR-EX-STRONG-GOOD': 5.17,
    'E-I2-GOOD-VG-STRONG-GOOD': 5.17,
    'E-I2-EX-EX-STRONG-POOR': 5.17,
    'F-I2-POOR-EX-MEDIUM-GOOD': 5.17,
    'F-I2-GOOD-VG-MEDIUM-GOOD': 5.17,
    'F-SI2-GOOD-GOOD-STRONG-GOOD': 5.17,
    'F-SI2-VG-EX-STRONG-POOR': 5.17,
    'F-I2-VG-GOOD-MEDIUM-GOOD': 5.17,
    'F-SI2-EX-VG-STRONG-POOR': 5.17,
    'F-SI2-VG-POOR-STRONG-GOOD': 5.17,
    'F-I2-EX-EX-MEDIUM-POOR': 5.17,
    'F-I2-POOR-POOR-MEDIUM-VG': 5.17,
    'F-SI2-POOR-VG-STRONG-GOOD': 5.17,
    'F-I2-EX-POOR-MEDIUM-GOOD': 5.17,
    'G-I2-VG-GOOD-FAINT-GOOD': 5.17,
    'G-I2-POOR-EX-FAINT-GOOD': 5.17,
    'G-I2-GOOD-VG-FAINT-GOOD': 5.17,
    'G-SI2-VG-POOR-MEDIUM-GOOD': 5.17,
    'G-I2-EX-POOR-FAINT-GOOD': 5.17,
    'G-SI2-EX-VG-MEDIUM-POOR': 5.17,
    'G-SI2-VG-EX-MEDIUM-POOR': 5.17,
    'G-I2-EX-EX-FAINT-POOR': 5.17,
    'G-I2-POOR-POOR-FAINT-VG': 5.17,
    'G-SI2-GOOD-GOOD-MEDIUM-GOOD': 5.17,
    'G-SI2-POOR-VG-MEDIUM-GOOD': 5.17,
    'H-SI2-POOR-VG-FAINT-GOOD': 5.17,
    'H-SI2-VG-POOR-FAINT-GOOD': 5.17,
    'H-I2-GOOD-VG-NONE-GOOD': 5.17,
    'H-SI2-GOOD-GOOD-FAINT-GOOD': 5.17,
    'H-SI2-VG-EX-FAINT-POOR': 5.17,
    'H-I2-POOR-POOR-NONE-VG': 5.17,
    'H-I2-POOR-EX-NONE-GOOD': 5.17,
    'H-I2-EX-EX-NONE-POOR': 5.17,
    'H-SI2-EX-VG-FAINT-POOR': 5.17,
    'H-I2-VG-GOOD-NONE-GOOD': 5.17,
    'H-I2-EX-POOR-NONE-GOOD': 5.17,
    'I-SI2-GOOD-GOOD-NONE-GOOD': 5.17,
    'I-SI2-VG-POOR-NONE-GOOD': 5.17,
    'I-SI2-EX-VG-NONE-POOR': 5.17,
    'I-SI2-POOR-VG-NONE-GOOD': 5.17,
    'I-SI2-VG-EX-NONE-POOR': 5.17,
    'J-I2-EX-GOOD-STRONG-VG': 5.17,
    'J-I2-GOOD-POOR-STRONG-EX': 5.17,
    'J-I2-VG-VG-STRONG-VG': 5.17,
    'J-I2-GOOD-EX-STRONG-VG': 5.17,
    'J-I2-POOR-GOOD-STRONG-EX': 5.17,
    'K-SI2-GOOD-VG-STRONG-VG': 5.17,
    'K-I2-VG-VG-MEDIUM-VG': 5.17,
    'K-I2-GOOD-POOR-MEDIUM-EX': 5.17,
    'K-SI2-EX-EX-STRONG-GOOD': 5.17,
    'K-SI2-VG-GOOD-STRONG-VG': 5.17,
    'K-I2-GOOD-EX-MEDIUM-VG': 5.17,
    'K-SI2-EX-POOR-STRONG-VG': 5.17,
    'K-SI2-POOR-EX-STRONG-VG': 5.17,
    'K-SI2-POOR-POOR-STRONG-EX': 5.17,
    'K-I2-POOR-GOOD-MEDIUM-EX': 5.17,
    'K-I2-EX-GOOD-MEDIUM-VG': 5.17,
    'L-I2-VG-VG-FAINT-VG': 5.17,
    'L-SI2-GOOD-VG-MEDIUM-VG': 5.17,
    'L-SI2-POOR-POOR-MEDIUM-EX': 5.17,
    'L-I2-POOR-GOOD-FAINT-EX': 5.17,
    'L-I2-GOOD-POOR-FAINT-EX': 5.17,
    'L-SI2-POOR-EX-MEDIUM-VG': 5.17,
    'L-I2-GOOD-EX-FAINT-VG': 5.17,
    'L-SI2-EX-EX-MEDIUM-GOOD': 5.17,
    'L-I2-EX-GOOD-FAINT-VG': 5.17,
    'L-SI2-EX-POOR-MEDIUM-VG': 5.17,
    'L-SI2-VG-GOOD-MEDIUM-VG': 5.17,
    'M-I2-VG-VG-NONE-VG': 5.17,
    'M-I2-POOR-GOOD-NONE-EX': 5.17,
    'M-I2-GOOD-EX-NONE-VG': 5.17,
    'M-SI2-GOOD-VG-FAINT-VG': 5.17,
    'M-SI2-POOR-POOR-FAINT-EX': 5.17,
    'M-SI2-EX-EX-FAINT-GOOD': 5.17,
    'M-I2-EX-GOOD-NONE-VG': 5.17,
    'M-SI2-VG-GOOD-FAINT-VG': 5.17,
    'M-SI2-EX-POOR-FAINT-VG': 5.17,
    'M-I2-GOOD-POOR-NONE-EX': 5.17,
    'M-SI2-POOR-EX-FAINT-VG': 5.17,
    'D-VS2-POOR-POOR-FAINT-POOR': 5.16,
    'E-VS2-POOR-POOR-NONE-POOR': 5.16,
    'G-VS2-EX-GOOD-STRONG-POOR': 5.16,
    'G-VS2-POOR-GOOD-STRONG-GOOD': 5.16,
    'G-VS2-GOOD-EX-STRONG-POOR': 5.16,
    'G-VS2-VG-VG-STRONG-POOR': 5.16,
    'G-VS2-GOOD-POOR-STRONG-GOOD': 5.16,
    'H-VVS2-POOR-EX-STRONG-POOR': 5.16,
    'H-VVS2-EX-POOR-STRONG-POOR': 5.16,
    'H-VS2-EX-GOOD-MEDIUM-POOR': 5.16,
    'H-VVS2-GOOD-VG-STRONG-POOR': 5.16,
    'H-VVS2-VG-GOOD-STRONG-POOR': 5.16,
    'H-VS2-GOOD-EX-MEDIUM-POOR': 5.16,
    'H-VS2-POOR-GOOD-MEDIUM-GOOD': 5.16,
    'H-VS2-VG-VG-MEDIUM-POOR': 5.16,
    'H-VS2-GOOD-POOR-MEDIUM-GOOD': 5.16,
    'H-VVS2-POOR-POOR-STRONG-GOOD': 5.16,
    'I-VS2-EX-GOOD-FAINT-POOR': 5.16,
    'I-VS2-VG-VG-FAINT-POOR': 5.16,
    'I-VS2-GOOD-EX-FAINT-POOR': 5.16,
    'I-VS2-GOOD-POOR-FAINT-GOOD': 5.16,
    'I-VVS2-POOR-POOR-MEDIUM-GOOD': 5.16,
    'I-VS2-POOR-GOOD-FAINT-GOOD': 5.16,
    'I-VVS2-EX-POOR-MEDIUM-POOR': 5.16,
    'I-VVS2-GOOD-VG-MEDIUM-POOR': 5.16,
    'I-VVS2-VG-GOOD-MEDIUM-POOR': 5.16,
    'I-VVS2-POOR-EX-MEDIUM-POOR': 5.16,
    'J-VS2-EX-GOOD-NONE-POOR': 5.16,
    'J-VS2-VG-VG-NONE-POOR': 5.16,
    'J-VVS2-VG-GOOD-FAINT-POOR': 5.16,
    'J-VS2-GOOD-EX-NONE-POOR': 5.16,
    'J-VVS2-POOR-EX-FAINT-POOR': 5.16,
    'J-VVS2-POOR-POOR-FAINT-GOOD': 5.16,
    'J-VVS2-EX-POOR-FAINT-POOR': 5.16,
    'J-VVS2-GOOD-VG-FAINT-POOR': 5.16,
    'J-VS2-POOR-GOOD-NONE-GOOD': 5.16,
    'J-VS2-GOOD-POOR-NONE-GOOD': 5.16,
    'K-VVS2-GOOD-VG-NONE-POOR': 5.16,
    'K-VVS2-POOR-POOR-NONE-GOOD': 5.16,
    'K-VVS2-POOR-EX-NONE-POOR': 5.16,
    'K-VVS2-VG-GOOD-NONE-POOR': 5.16,
    'K-VVS2-EX-POOR-NONE-POOR': 5.16,
    'L-VS2-POOR-VG-STRONG-VG': 5.16,
    'L-VS2-VG-EX-STRONG-GOOD': 5.16,
    'L-VS2-GOOD-GOOD-STRONG-VG': 5.16,
    'L-VS2-EX-VG-STRONG-GOOD': 5.16,
    'L-VS2-VG-POOR-STRONG-VG': 5.16,
    'M-VVS2-VG-VG-STRONG-GOOD': 5.16,
    'M-VS2-EX-VG-MEDIUM-GOOD': 5.16,
    'M-VVS2-EX-GOOD-STRONG-GOOD': 5.16,
    'M-VVS2-POOR-GOOD-STRONG-VG': 5.16,
    'M-VVS2-GOOD-EX-STRONG-GOOD': 5.16,
    'M-VS2-VG-EX-MEDIUM-GOOD': 5.16,
    'M-VS2-GOOD-GOOD-MEDIUM-VG': 5.16,
    'M-VVS2-GOOD-POOR-STRONG-VG': 5.16,
    'M-VS2-VG-POOR-MEDIUM-VG': 5.16,
    'M-VS2-POOR-VG-MEDIUM-VG': 5.16,
    'I-IF-VG-POOR-STRONG-POOR': 5.15,
    'I-IF-GOOD-GOOD-STRONG-POOR': 5.15,
    'I-IF-POOR-VG-STRONG-POOR': 5.15,
    'J-IF-GOOD-GOOD-MEDIUM-POOR': 5.15,
    'J-IF-VG-POOR-MEDIUM-POOR': 5.15,
    'J-IF-POOR-VG-MEDIUM-POOR': 5.15,
    'K-IF-POOR-VG-FAINT-POOR': 5.15,
    'K-IF-GOOD-GOOD-FAINT-POOR': 5.15,
    'K-IF-VG-POOR-FAINT-POOR': 5.15,
    'L-IF-GOOD-GOOD-NONE-POOR': 5.15,
    'L-IF-VG-POOR-NONE-POOR': 5.15,
    'L-IF-POOR-VG-NONE-POOR': 5.15,
    'D-SI1-POOR-POOR-NONE-POOR': 5.14,
    'E-I1-VG-POOR-STRONG-GOOD': 5.14,
    'E-I1-POOR-VG-STRONG-GOOD': 5.14,
    'E-I1-EX-VG-STRONG-POOR': 5.14,
    'E-I1-GOOD-GOOD-STRONG-GOOD': 5.14,
    'E-I1-VG-EX-STRONG-POOR': 5.14,
    'F-I1-POOR-VG-MEDIUM-GOOD': 5.14,
    'F-SI1-VG-VG-STRONG-POOR': 5.14,
    'F-SI1-GOOD-POOR-STRONG-GOOD': 5.14,
    'F-I1-EX-VG-MEDIUM-POOR': 5.14,
    'F-I1-GOOD-GOOD-MEDIUM-GOOD': 5.14,
    'F-SI1-GOOD-EX-STRONG-POOR': 5.14,
    'F-I1-VG-EX-MEDIUM-POOR': 5.14,
    'F-SI1-POOR-GOOD-STRONG-GOOD': 5.14,
    'F-SI1-EX-GOOD-STRONG-POOR': 5.14,
    'F-I1-VG-POOR-MEDIUM-GOOD': 5.14,
    'G-SI1-GOOD-EX-MEDIUM-POOR': 5.14,
    'G-I1-VG-POOR-FAINT-GOOD': 5.14,
    'G-SI1-GOOD-POOR-MEDIUM-GOOD': 5.14,
    'G-I1-GOOD-GOOD-FAINT-GOOD': 5.14,
    'G-I1-VG-EX-FAINT-POOR': 5.14,
    'G-SI1-VG-VG-MEDIUM-POOR': 5.14,
    'G-SI1-EX-GOOD-MEDIUM-POOR': 5.14,
    'G-I1-POOR-VG-FAINT-GOOD': 5.14,
    'G-SI1-POOR-GOOD-MEDIUM-GOOD': 5.14,
    'G-I1-EX-VG-FAINT-POOR': 5.14,
    'H-SI1-POOR-GOOD-FAINT-GOOD': 5.14,
    'H-I1-EX-VG-NONE-POOR': 5.14,
    'H-SI1-GOOD-EX-FAINT-POOR': 5.14,
    'H-I1-POOR-VG-NONE-GOOD': 5.14,
    'H-I1-GOOD-GOOD-NONE-GOOD': 5.14,
    'H-SI1-GOOD-POOR-FAINT-GOOD': 5.14,
    'H-SI1-EX-GOOD-FAINT-POOR': 5.14,
    'H-SI1-VG-VG-FAINT-POOR': 5.14,
    'H-I1-VG-EX-NONE-POOR': 5.14,
    'H-I1-VG-POOR-NONE-GOOD': 5.14,
    'I-SI1-EX-GOOD-NONE-POOR': 5.14,
    'I-SI1-GOOD-EX-NONE-POOR': 5.14,
    'I-SI1-GOOD-POOR-NONE-GOOD': 5.14,
    'I-SI1-VG-VG-NONE-POOR': 5.14,
    'I-SI1-POOR-GOOD-NONE-GOOD': 5.14,
    'J-I1-POOR-EX-STRONG-VG': 5.14,
    'J-I1-EX-POOR-STRONG-VG': 5.14,
    'J-I1-GOOD-VG-STRONG-VG': 5.14,
    'J-I1-POOR-POOR-STRONG-EX': 5.14,
    'J-I1-VG-GOOD-STRONG-VG': 5.14,
    'J-I1-EX-EX-STRONG-GOOD': 5.14,
    'K-I1-EX-EX-MEDIUM-GOOD': 5.14,
    'K-SI1-GOOD-GOOD-STRONG-VG': 5.14,
    'K-SI1-POOR-VG-STRONG-VG': 5.14,
    'K-I1-GOOD-VG-MEDIUM-VG': 5.14,
    'K-SI1-VG-POOR-STRONG-VG': 5.14,
    'K-I1-POOR-POOR-MEDIUM-EX': 5.14,
    'K-I1-VG-GOOD-MEDIUM-VG': 5.14,
    'K-SI1-VG-EX-STRONG-GOOD': 5.14,
    'K-SI1-EX-VG-STRONG-GOOD': 5.14,
    'K-I1-EX-POOR-MEDIUM-VG': 5.14,
    'K-I1-POOR-EX-MEDIUM-VG': 5.14,
    'L-SI1-GOOD-GOOD-MEDIUM-VG': 5.14,
    'L-SI1-POOR-VG-MEDIUM-VG': 5.14,
    'L-SI1-VG-POOR-MEDIUM-VG': 5.14,
    'L-I1-POOR-EX-FAINT-VG': 5.14,
    'L-I1-GOOD-VG-FAINT-VG': 5.14,
    'L-I1-VG-GOOD-FAINT-VG': 5.14,
    'L-SI1-EX-VG-MEDIUM-GOOD': 5.14,
    'L-I1-POOR-POOR-FAINT-EX': 5.14,
    'L-I1-EX-POOR-FAINT-VG': 5.14,
    'L-I1-EX-EX-FAINT-GOOD': 5.14,
    'L-SI1-VG-EX-MEDIUM-GOOD': 5.14,
    'M-SI1-POOR-VG-FAINT-VG': 5.14,
    'M-I1-VG-GOOD-NONE-VG': 5.14,
    'M-I1-EX-EX-NONE-GOOD': 5.14,
    'M-I1-EX-POOR-NONE-VG': 5.14,
    'M-SI1-VG-POOR-FAINT-VG': 5.14,
    'M-SI1-EX-VG-FAINT-GOOD': 5.14,
    'M-SI1-VG-EX-FAINT-GOOD': 5.14,
    'M-I1-GOOD-VG-NONE-VG': 5.14,
    'M-I1-POOR-EX-NONE-VG': 5.14,
    'M-SI1-GOOD-GOOD-FAINT-VG': 5.14,
    'M-I1-POOR-POOR-NONE-EX': 5.14,
    'G-VS1-POOR-POOR-STRONG-GOOD': 5.13,
    'G-VS1-VG-GOOD-STRONG-POOR': 5.13,
    'G-VS1-EX-POOR-STRONG-POOR': 5.13,
    'G-VS1-GOOD-VG-STRONG-POOR': 5.13,
    'G-VS1-POOR-EX-STRONG-POOR': 5.13,
    'H-VS1-VG-GOOD-MEDIUM-POOR': 5.13,
    'H-VS1-POOR-POOR-MEDIUM-GOOD': 5.13,
    'H-VVS1-POOR-VG-STRONG-POOR': 5.13,
    'H-VS1-EX-POOR-MEDIUM-POOR': 5.13,
    'H-VS1-POOR-EX-MEDIUM-POOR': 5.13,
    'H-VVS1-GOOD-GOOD-STRONG-POOR': 5.13,
    'H-VS1-GOOD-VG-MEDIUM-POOR': 5.13,
    'H-VVS1-VG-POOR-STRONG-POOR': 5.13,
    'I-VS1-GOOD-VG-FAINT-POOR': 5.13,
    'I-VS1-POOR-EX-FAINT-POOR': 5.13,
    'I-VVS1-POOR-VG-MEDIUM-POOR': 5.13,
    'I-VVS1-VG-POOR-MEDIUM-POOR': 5.13,
    'I-VS1-VG-GOOD-FAINT-POOR': 5.13,
    'I-VVS1-GOOD-GOOD-MEDIUM-POOR': 5.13,
    'I-VS1-EX-POOR-FAINT-POOR': 5.13,
    'I-VS1-POOR-POOR-FAINT-GOOD': 5.13,
    'J-VS1-POOR-POOR-NONE-GOOD': 5.13,
    'J-VS1-VG-GOOD-NONE-POOR': 5.13,
    'J-VS1-POOR-EX-NONE-POOR': 5.13,
    'J-VVS1-VG-POOR-FAINT-POOR': 5.13,
    'J-VVS1-GOOD-GOOD-FAINT-POOR': 5.13,
    'J-VS1-EX-POOR-NONE-POOR': 5.13,
    'J-VS1-GOOD-VG-NONE-POOR': 5.13,
    'J-VVS1-POOR-VG-FAINT-POOR': 5.13,
    'K-VVS1-POOR-VG-NONE-POOR': 5.13,
    'K-VVS1-VG-POOR-NONE-POOR': 5.13,
    'K-VVS1-GOOD-GOOD-NONE-POOR': 5.13,
    'L-VS1-POOR-GOOD-STRONG-VG': 5.13,
    'L-VS1-GOOD-EX-STRONG-GOOD': 5.13,
    'L-VS1-VG-VG-STRONG-GOOD': 5.13,
    'L-VS1-GOOD-POOR-STRONG-VG': 5.13,
    'L-VS1-EX-GOOD-STRONG-GOOD': 5.13,
    'M-VVS1-POOR-POOR-STRONG-VG': 5.13,
    'M-VS1-VG-VG-MEDIUM-GOOD': 5.13,
    'M-VVS1-EX-POOR-STRONG-GOOD': 5.13,
    'M-VVS1-EX-EX-STRONG-POOR': 5.13,
    'M-VVS1-VG-GOOD-STRONG-GOOD': 5.13,
    'M-VS1-EX-GOOD-MEDIUM-GOOD': 5.13,
    'M-VS1-GOOD-EX-MEDIUM-GOOD': 5.13,
    'M-VS1-GOOD-POOR-MEDIUM-VG': 5.13,
    'M-VS1-POOR-GOOD-MEDIUM-VG': 5.13,
    'M-VVS1-POOR-EX-STRONG-GOOD': 5.13,
    'M-VVS1-GOOD-VG-STRONG-GOOD': 5.13,
    'D-I2-VG-EX-STRONG-POOR': 5.12,
    'D-I2-VG-POOR-STRONG-GOOD': 5.12,
    'D-I2-GOOD-GOOD-STRONG-GOOD': 5.12,
    'D-I2-EX-VG-STRONG-POOR': 5.12,
    'D-I2-POOR-VG-STRONG-GOOD': 5.12,
    'E-I2-POOR-VG-MEDIUM-GOOD': 5.12,
    'E-SI2-GOOD-EX-STRONG-POOR': 5.12,
    'E-I2-GOOD-GOOD-MEDIUM-GOOD': 5.12,
    'E-I2-VG-EX-MEDIUM-POOR': 5.12,
    'E-SI2-VG-VG-STRONG-POOR': 5.12,
    'E-SI2-POOR-GOOD-STRONG-GOOD': 5.12,
    'E-I2-VG-POOR-MEDIUM-GOOD': 5.12,
    'E-SI2-GOOD-POOR-STRONG-GOOD': 5.12,
    'E-SI2-EX-GOOD-STRONG-POOR': 5.12,
    'E-I2-EX-VG-MEDIUM-POOR': 5.12,
    'F-I2-VG-POOR-FAINT-GOOD': 5.12,
    'F-I2-VG-EX-FAINT-POOR': 5.12,
    'F-I2-EX-VG-FAINT-POOR': 5.12,
    'F-I2-GOOD-GOOD-FAINT-GOOD': 5.12,
    'F-I2-POOR-VG-FAINT-GOOD': 5.12,
    'F-SI2-EX-GOOD-MEDIUM-POOR': 5.12,
    'F-SI2-GOOD-POOR-MEDIUM-GOOD': 5.12,
    'F-SI2-GOOD-EX-MEDIUM-POOR': 5.12,
    'F-SI2-POOR-GOOD-MEDIUM-GOOD': 5.12,
    'F-SI2-VG-VG-MEDIUM-POOR': 5.12,
    'G-SI2-POOR-GOOD-FAINT-GOOD': 5.12,
    'G-SI2-GOOD-POOR-FAINT-GOOD': 5.12,
    'G-I2-EX-VG-NONE-POOR': 5.12,
    'G-I2-VG-EX-NONE-POOR': 5.12,
    'G-SI2-EX-GOOD-FAINT-POOR': 5.12,
    'G-SI2-GOOD-EX-FAINT-POOR': 5.12,
    'G-I2-VG-POOR-NONE-GOOD': 5.12,
    'G-I2-POOR-VG-NONE-GOOD': 5.12,
    'G-I2-GOOD-GOOD-NONE-GOOD': 5.12,
    'G-SI2-VG-VG-FAINT-POOR': 5.12,
    'H-SI2-VG-VG-NONE-POOR': 5.12,
    'H-SI2-GOOD-EX-NONE-POOR': 5.12,
    'H-SI2-EX-GOOD-NONE-POOR': 5.12,
    'H-SI2-GOOD-POOR-NONE-GOOD': 5.12,
    'H-SI2-POOR-GOOD-NONE-GOOD': 5.12,
    'I-I2-POOR-POOR-STRONG-EX': 5.12,
    'I-I2-GOOD-VG-STRONG-VG': 5.12,
    'I-I2-POOR-EX-STRONG-VG': 5.12,
    'I-I2-EX-POOR-STRONG-VG': 5.12,
    'I-I2-EX-EX-STRONG-GOOD': 5.12,
    'I-I2-VG-GOOD-STRONG-VG': 5.12,
    'J-I2-POOR-POOR-MEDIUM-EX': 5.12,
    'J-I2-POOR-EX-MEDIUM-VG': 5.12,
    'J-I2-GOOD-VG-MEDIUM-VG': 5.12,
    'J-I2-VG-GOOD-MEDIUM-VG': 5.12,
    'J-I2-EX-POOR-MEDIUM-VG': 5.12,
    'J-I2-EX-EX-MEDIUM-GOOD': 5.12,
    'J-SI2-VG-POOR-STRONG-VG': 5.12,
    'J-SI2-POOR-VG-STRONG-VG': 5.12,
    'J-SI2-GOOD-GOOD-STRONG-VG': 5.12,
    'J-SI2-VG-EX-STRONG-GOOD': 5.12,
    'J-SI2-EX-VG-STRONG-GOOD': 5.12,
    'K-I2-VG-GOOD-FAINT-VG': 5.12,
    'K-I2-EX-POOR-FAINT-VG': 5.12,
    'K-SI2-VG-POOR-MEDIUM-VG': 5.12,
    'K-I2-POOR-POOR-FAINT-EX': 5.12,
    'K-I2-GOOD-VG-FAINT-VG': 5.12,
    'K-SI2-VG-EX-MEDIUM-GOOD': 5.12,
    'K-I2-POOR-EX-FAINT-VG': 5.12,
    'K-SI2-GOOD-GOOD-MEDIUM-VG': 5.12,
    'K-SI2-POOR-VG-MEDIUM-VG': 5.12,
    'K-I2-EX-EX-FAINT-GOOD': 5.12,
    'K-SI2-EX-VG-MEDIUM-GOOD': 5.12,
    'L-I2-POOR-POOR-NONE-EX': 5.12,
    'L-I2-POOR-EX-NONE-VG': 5.12,
    'L-I2-GOOD-VG-NONE-VG': 5.12,
    'L-I2-VG-GOOD-NONE-VG': 5.12,
    'L-I2-EX-POOR-NONE-VG': 5.12,
    'L-I2-EX-EX-NONE-GOOD': 5.12,
    'L-SI2-EX-VG-FAINT-GOOD': 5.12,
    'L-SI2-VG-EX-FAINT-GOOD': 5.12,
    'L-SI2-VG-POOR-FAINT-VG': 5.12,
    'L-SI2-GOOD-GOOD-FAINT-VG': 5.12,
    'L-SI2-POOR-VG-FAINT-VG': 5.12,
    'M-SI2-GOOD-GOOD-NONE-VG': 5.12,
    'M-SI2-POOR-VG-NONE-VG': 5.12,
    'M-SI2-VG-POOR-NONE-VG': 5.12,
    'M-SI2-VG-EX-NONE-GOOD': 5.12,
    'M-SI2-EX-VG-NONE-GOOD': 5.12,
    'F-VS2-EX-POOR-STRONG-POOR': 5.11,
    'F-VS2-GOOD-VG-STRONG-POOR': 5.11,
    'F-VS2-VG-GOOD-STRONG-POOR': 5.11,
    'F-VS2-POOR-EX-STRONG-POOR': 5.11,
    'F-VS2-POOR-POOR-STRONG-GOOD': 5.11,
    'G-VS2-EX-POOR-MEDIUM-POOR': 5.11,
    'G-VVS2-VG-POOR-STRONG-POOR': 5.11,
    'G-VS2-GOOD-VG-MEDIUM-POOR': 5.11,
    'G-VS2-POOR-EX-MEDIUM-POOR': 5.11,
    'G-VS2-VG-GOOD-MEDIUM-POOR': 5.11,
    'G-VVS2-GOOD-GOOD-STRONG-POOR': 5.11,
    'G-VVS2-POOR-VG-STRONG-POOR': 5.11,
    'G-VS2-POOR-POOR-MEDIUM-GOOD': 5.11,
    'H-VS2-GOOD-VG-FAINT-POOR': 5.11,
    'H-VS2-POOR-EX-FAINT-POOR': 5.11,
    'H-VVS2-VG-POOR-MEDIUM-POOR': 5.11,
    'H-VS2-VG-GOOD-FAINT-POOR': 5.11,
    'H-VVS2-GOOD-GOOD-MEDIUM-POOR': 5.11,
    'H-VS2-EX-POOR-FAINT-POOR': 5.11,
    'H-VS2-POOR-POOR-FAINT-GOOD': 5.11,
    'H-VVS2-POOR-VG-MEDIUM-POOR': 5.11,
    'I-VVS2-POOR-VG-FAINT-POOR': 5.11,
    'I-VVS2-GOOD-GOOD-FAINT-POOR': 5.11,
    'I-VS2-POOR-POOR-NONE-GOOD': 5.11,
    'I-VS2-POOR-EX-NONE-POOR': 5.11,
    'I-VS2-GOOD-VG-NONE-POOR': 5.11,
    'I-VS2-VG-GOOD-NONE-POOR': 5.11,
    'I-VS2-EX-POOR-NONE-POOR': 5.11,
    'I-VVS2-VG-POOR-FAINT-POOR': 5.11,
    'J-VVS2-VG-POOR-NONE-POOR': 5.11,
    'J-VVS2-GOOD-GOOD-NONE-POOR': 5.11,
    'J-VVS2-POOR-VG-NONE-POOR': 5.11,
    'K-VS2-GOOD-EX-STRONG-GOOD': 5.11,
    'K-VS2-POOR-GOOD-STRONG-VG': 5.11,
    'K-VS2-GOOD-POOR-STRONG-VG': 5.11,
    'K-VS2-VG-VG-STRONG-GOOD': 5.11,
    'K-VS2-EX-GOOD-STRONG-GOOD': 5.11,
    'L-VVS2-VG-GOOD-STRONG-GOOD': 5.11,
    'L-VS2-GOOD-EX-MEDIUM-GOOD': 5.11,
    'L-VVS2-GOOD-VG-STRONG-GOOD': 5.11,
    'L-VVS2-POOR-EX-STRONG-GOOD': 5.11,
    'L-VS2-VG-VG-MEDIUM-GOOD': 5.11,
    'L-VS2-GOOD-POOR-MEDIUM-VG': 5.11,
    'L-VVS2-EX-POOR-STRONG-GOOD': 5.11,
    'L-VVS2-EX-EX-STRONG-POOR': 5.11,
    'L-VVS2-POOR-POOR-STRONG-VG': 5.11,
    'L-VS2-EX-GOOD-MEDIUM-GOOD': 5.11,
    'L-VS2-POOR-GOOD-MEDIUM-VG': 5.11,
    'M-VS2-POOR-GOOD-FAINT-VG': 5.11,
    'M-VS2-VG-VG-FAINT-GOOD': 5.11,
    'M-VVS2-EX-EX-MEDIUM-POOR': 5.11,
    'M-VS2-GOOD-EX-FAINT-GOOD': 5.11,
    'M-VS2-EX-GOOD-FAINT-GOOD': 5.11,
    'M-VS2-GOOD-POOR-FAINT-VG': 5.11,
    'M-VVS2-GOOD-VG-MEDIUM-GOOD': 5.11,
    'M-VVS2-EX-POOR-MEDIUM-GOOD': 5.11,
    'M-VVS2-POOR-POOR-MEDIUM-VG': 5.11,
    'M-VVS2-VG-GOOD-MEDIUM-GOOD': 5.11,
    'M-VVS2-POOR-EX-MEDIUM-GOOD': 5.11,
    'H-IF-GOOD-POOR-STRONG-POOR': 5.1,
    'H-IF-POOR-GOOD-STRONG-POOR': 5.1,
    'I-IF-POOR-GOOD-MEDIUM-POOR': 5.1,
    'I-IF-GOOD-POOR-MEDIUM-POOR': 5.1,
    'J-IF-GOOD-POOR-FAINT-POOR': 5.1,
    'J-IF-POOR-GOOD-FAINT-POOR': 5.1,
    'K-IF-GOOD-POOR-NONE-POOR': 5.1,
    'K-IF-POOR-GOOD-NONE-POOR': 5.1,
    'M-IF-POOR-VG-STRONG-GOOD': 5.1,
    'M-IF-VG-POOR-STRONG-GOOD': 5.1,
    'M-IF-GOOD-GOOD-STRONG-GOOD': 5.1,
    'M-IF-VG-EX-STRONG-POOR': 5.1,
    'M-IF-EX-VG-STRONG-POOR': 5.1,
    'D-I1-GOOD-EX-STRONG-POOR': 5.09,
    'D-I1-POOR-GOOD-STRONG-GOOD': 5.09,
    'D-I1-GOOD-POOR-STRONG-GOOD': 5.09,
    'D-I1-VG-VG-STRONG-POOR': 5.09,
    'D-I1-EX-GOOD-STRONG-POOR': 5.09,
    'E-SI1-EX-POOR-STRONG-POOR': 5.09,
    'E-I1-GOOD-EX-MEDIUM-POOR': 5.09,
    'E-SI1-POOR-EX-STRONG-POOR': 5.09,
    'E-I1-POOR-GOOD-MEDIUM-GOOD': 5.09,
    'E-I1-GOOD-POOR-MEDIUM-GOOD': 5.09,
    'E-SI1-POOR-POOR-STRONG-GOOD': 5.09,
    'E-SI1-GOOD-VG-STRONG-POOR': 5.09,
    'E-I1-EX-GOOD-MEDIUM-POOR': 5.09,
    'E-I1-VG-VG-MEDIUM-POOR': 5.09,
    'E-SI1-VG-GOOD-STRONG-POOR': 5.09,
    'F-I1-POOR-GOOD-FAINT-GOOD': 5.09,
    'F-SI1-GOOD-VG-MEDIUM-POOR': 5.09,
    'F-I1-GOOD-POOR-FAINT-GOOD': 5.09,
    'F-SI1-VG-GOOD-MEDIUM-POOR': 5.09,
    'F-SI1-EX-POOR-MEDIUM-POOR': 5.09,
    'F-SI1-POOR-POOR-MEDIUM-GOOD': 5.09,
    'F-SI1-POOR-EX-MEDIUM-POOR': 5.09,
    'F-I1-VG-VG-FAINT-POOR': 5.09,
    'F-I1-GOOD-EX-FAINT-POOR': 5.09,
    'F-I1-EX-GOOD-FAINT-POOR': 5.09,
    'G-I1-POOR-GOOD-NONE-GOOD': 5.09,
    'G-SI1-POOR-EX-FAINT-POOR': 5.09,
    'G-I1-EX-GOOD-NONE-POOR': 5.09,
    'G-SI1-POOR-POOR-FAINT-GOOD': 5.09,
    'G-I1-VG-VG-NONE-POOR': 5.09,
    'G-I1-GOOD-EX-NONE-POOR': 5.09,
    'G-I1-GOOD-POOR-NONE-GOOD': 5.09,
    'G-SI1-GOOD-VG-FAINT-POOR': 5.09,
    'G-SI1-VG-GOOD-FAINT-POOR': 5.09,
    'G-SI1-EX-POOR-FAINT-POOR': 5.09,
    'H-SI1-GOOD-VG-NONE-POOR': 5.09,
    'H-SI1-EX-POOR-NONE-POOR': 5.09,
    'H-SI1-VG-GOOD-NONE-POOR': 5.09,
    'H-SI1-POOR-POOR-NONE-GOOD': 5.09,
    'H-SI1-POOR-EX-NONE-POOR': 5.09,
    'I-I1-EX-VG-STRONG-GOOD': 5.09,
    'I-I1-VG-POOR-STRONG-VG': 5.09,
    'I-I1-VG-EX-STRONG-GOOD': 5.09,
    'I-I1-GOOD-GOOD-STRONG-VG': 5.09,
    'I-I1-POOR-VG-STRONG-VG': 5.09,
    'J-I1-POOR-VG-MEDIUM-VG': 5.09,
    'J-I1-GOOD-GOOD-MEDIUM-VG': 5.09,
    'J-I1-VG-POOR-MEDIUM-VG': 5.09,
    'J-I1-VG-EX-MEDIUM-GOOD': 5.09,
    'J-I1-EX-VG-MEDIUM-GOOD': 5.09,
    'J-SI1-EX-GOOD-STRONG-GOOD': 5.09,
    'J-SI1-GOOD-POOR-STRONG-VG': 5.09,
    'J-SI1-POOR-GOOD-STRONG-VG': 5.09,
    'J-SI1-GOOD-EX-STRONG-GOOD': 5.09,
    'J-SI1-VG-VG-STRONG-GOOD': 5.09,
    'K-SI1-GOOD-POOR-MEDIUM-VG': 5.09,
    'K-SI1-POOR-GOOD-MEDIUM-VG': 5.09,
    'K-SI1-VG-VG-MEDIUM-GOOD': 5.09,
    'K-SI1-EX-GOOD-MEDIUM-GOOD': 5.09,
    'K-SI1-GOOD-EX-MEDIUM-GOOD': 5.09,
    'K-I1-POOR-VG-FAINT-VG': 5.09,
    'K-I1-EX-VG-FAINT-GOOD': 5.09,
    'K-I1-GOOD-GOOD-FAINT-VG': 5.09,
    'K-I1-VG-POOR-FAINT-VG': 5.09,
    'K-I1-VG-EX-FAINT-GOOD': 5.09,
    'L-SI1-EX-GOOD-FAINT-GOOD': 5.09,
    'L-SI1-VG-VG-FAINT-GOOD': 5.09,
    'L-SI1-POOR-GOOD-FAINT-VG': 5.09,
    'L-SI1-GOOD-POOR-FAINT-VG': 5.09,
    'L-SI1-GOOD-EX-FAINT-GOOD': 5.09,
    'L-I1-POOR-VG-NONE-VG': 5.09,
    'L-I1-GOOD-GOOD-NONE-VG': 5.09,
    'L-I1-VG-POOR-NONE-VG': 5.09,
    'L-I1-VG-EX-NONE-GOOD': 5.09,
    'L-I1-EX-VG-NONE-GOOD': 5.09,
    'M-SI1-GOOD-POOR-NONE-VG': 5.09,
    'M-SI1-EX-GOOD-NONE-GOOD': 5.09,
    'M-SI1-VG-VG-NONE-GOOD': 5.09,
    'M-SI1-POOR-GOOD-NONE-VG': 5.09,
    'M-SI1-GOOD-EX-NONE-GOOD': 5.09,
    'F-VS1-GOOD-GOOD-STRONG-POOR': 5.08,
    'F-VS1-VG-POOR-STRONG-POOR': 5.08,
    'F-VS1-POOR-VG-STRONG-POOR': 5.08,
    'G-VVS1-POOR-GOOD-STRONG-POOR': 5.08,
    'G-VVS1-GOOD-POOR-STRONG-POOR': 5.08,
    'G-VS1-VG-POOR-MEDIUM-POOR': 5.08,
    'G-VS1-GOOD-GOOD-MEDIUM-POOR': 5.08,
    'G-VS1-POOR-VG-MEDIUM-POOR': 5.08,
    'H-VVS1-POOR-GOOD-MEDIUM-POOR': 5.08,
    'H-VVS1-GOOD-POOR-MEDIUM-POOR': 5.08,
    'H-VS1-GOOD-GOOD-FAINT-POOR': 5.08,
    'H-VS1-VG-POOR-FAINT-POOR': 5.08,
    'H-VS1-POOR-VG-FAINT-POOR': 5.08,
    'I-VVS1-POOR-GOOD-FAINT-POOR': 5.08,
    'I-VVS1-GOOD-POOR-FAINT-POOR': 5.08,
    'I-VS1-POOR-VG-NONE-POOR': 5.08,
    'I-VS1-GOOD-GOOD-NONE-POOR': 5.08,
    'I-VS1-VG-POOR-NONE-POOR': 5.08,
    'J-VVS1-GOOD-POOR-NONE-POOR': 5.08,
    'J-VVS1-POOR-GOOD-NONE-POOR': 5.08,
    'K-VS1-VG-GOOD-STRONG-GOOD': 5.08,
    'K-VS1-EX-EX-STRONG-POOR': 5.08,
    'K-VS1-EX-POOR-STRONG-GOOD': 5.08,
    'K-VS1-POOR-POOR-STRONG-VG': 5.08,
    'K-VS1-POOR-EX-STRONG-GOOD': 5.08,
    'K-VS1-GOOD-VG-STRONG-GOOD': 5.08,
    'L-VS1-VG-GOOD-MEDIUM-GOOD': 5.08,
    'L-VS1-GOOD-VG-MEDIUM-GOOD': 5.08,
    'L-VS1-POOR-POOR-MEDIUM-VG': 5.08,
    'L-VS1-POOR-EX-MEDIUM-GOOD': 5.08,
    'L-VVS1-VG-EX-STRONG-POOR': 5.08,
    'L-VVS1-VG-POOR-STRONG-GOOD': 5.08,
    'L-VVS1-GOOD-GOOD-STRONG-GOOD': 5.08,
    'L-VVS1-POOR-VG-STRONG-GOOD': 5.08,
    'L-VVS1-EX-VG-STRONG-POOR': 5.08,
    'L-VS1-EX-POOR-MEDIUM-GOOD': 5.08,
    'L-VS1-EX-EX-MEDIUM-POOR': 5.08,
    'M-VS1-POOR-POOR-FAINT-VG': 5.08,
    'M-VS1-EX-POOR-FAINT-GOOD': 5.08,
    'M-VVS1-VG-POOR-MEDIUM-GOOD': 5.08,
    'M-VS1-POOR-EX-FAINT-GOOD': 5.08,
    'M-VS1-VG-GOOD-FAINT-GOOD': 5.08,
    'M-VS1-EX-EX-FAINT-POOR': 5.08,
    'M-VS1-GOOD-VG-FAINT-GOOD': 5.08,
    'M-VVS1-GOOD-GOOD-MEDIUM-GOOD': 5.08,
    'M-VVS1-POOR-VG-MEDIUM-GOOD': 5.08,
    'M-VVS1-VG-EX-MEDIUM-POOR': 5.08,
    'M-VVS1-EX-VG-MEDIUM-POOR': 5.08,
    'D-SI2-POOR-POOR-STRONG-GOOD': 5.07,
    'D-SI2-GOOD-VG-STRONG-POOR': 5.07,
    'D-SI2-POOR-EX-STRONG-POOR': 5.07,
    'D-I2-EX-GOOD-MEDIUM-POOR': 5.07,
    'D-I2-VG-VG-MEDIUM-POOR': 5.07,
    'D-I2-GOOD-EX-MEDIUM-POOR': 5.07,
    'D-I2-POOR-GOOD-MEDIUM-GOOD': 5.07,
    'D-I2-GOOD-POOR-MEDIUM-GOOD': 5.07,
    'D-SI2-EX-POOR-STRONG-POOR': 5.07,
    'D-SI2-VG-GOOD-STRONG-POOR': 5.07,
    'E-SI2-EX-POOR-MEDIUM-POOR': 5.07,
    'E-SI2-VG-GOOD-MEDIUM-POOR': 5.07,
    'E-I2-VG-VG-FAINT-POOR': 5.07,
    'E-I2-EX-GOOD-FAINT-POOR': 5.07,
    'E-I2-GOOD-EX-FAINT-POOR': 5.07,
    'E-I2-GOOD-POOR-FAINT-GOOD': 5.07,
    'E-I2-POOR-GOOD-FAINT-GOOD': 5.07,
    'E-SI2-POOR-EX-MEDIUM-POOR': 5.07,
    'E-SI2-POOR-POOR-MEDIUM-GOOD': 5.07,
    'E-SI2-GOOD-VG-MEDIUM-POOR': 5.07,
    'F-SI2-POOR-POOR-FAINT-GOOD': 5.07,
    'F-I2-VG-VG-NONE-POOR': 5.07,
    'F-I2-EX-GOOD-NONE-POOR': 5.07,
    'F-I2-GOOD-EX-NONE-POOR': 5.07,
    'F-SI2-EX-POOR-FAINT-POOR': 5.07,
    'F-I2-GOOD-POOR-NONE-GOOD': 5.07,
    'F-I2-POOR-GOOD-NONE-GOOD': 5.07,
    'F-SI2-GOOD-VG-FAINT-POOR': 5.07,
    'F-SI2-VG-GOOD-FAINT-POOR': 5.07,
    'F-SI2-POOR-EX-FAINT-POOR': 5.07,
    'G-SI2-VG-GOOD-NONE-POOR': 5.07,
    'G-SI2-GOOD-VG-NONE-POOR': 5.07,
    'G-SI2-POOR-EX-NONE-POOR': 5.07,
    'G-SI2-POOR-POOR-NONE-GOOD': 5.07,
    'G-SI2-EX-POOR-NONE-POOR': 5.07,
    'H-I2-POOR-VG-STRONG-VG': 5.07,
    'H-I2-GOOD-GOOD-STRONG-VG': 5.07,
    'H-I2-VG-POOR-STRONG-VG': 5.07,
    'H-I2-VG-EX-STRONG-GOOD': 5.07,
    'H-I2-EX-VG-STRONG-GOOD': 5.07,
    'I-I2-VG-POOR-MEDIUM-VG': 5.07,
    'I-SI2-GOOD-EX-STRONG-GOOD': 5.07,
    'I-I2-EX-VG-MEDIUM-GOOD': 5.07,
    'I-I2-VG-EX-MEDIUM-GOOD': 5.07,
    'I-SI2-GOOD-POOR-STRONG-VG': 5.07,
    'I-SI2-EX-GOOD-STRONG-GOOD': 5.07,
    'I-SI2-POOR-GOOD-STRONG-VG': 5.07,
    'I-SI2-VG-VG-STRONG-GOOD': 5.07,
    'I-I2-GOOD-GOOD-MEDIUM-VG': 5.07,
    'I-I2-POOR-VG-MEDIUM-VG': 5.07,
    'J-I2-POOR-VG-FAINT-VG': 5.07,
    'J-SI2-POOR-GOOD-MEDIUM-VG': 5.07,
    'J-SI2-GOOD-POOR-MEDIUM-VG': 5.07,
    'J-SI2-GOOD-EX-MEDIUM-GOOD': 5.07,
    'J-I2-GOOD-GOOD-FAINT-VG': 5.07,
    'J-I2-VG-POOR-FAINT-VG': 5.07,
    'J-SI2-VG-VG-MEDIUM-GOOD': 5.07,
    'J-I2-EX-VG-FAINT-GOOD': 5.07,
    'J-SI2-EX-GOOD-MEDIUM-GOOD': 5.07,
    'J-I2-VG-EX-FAINT-GOOD': 5.07,
    'K-I2-EX-VG-NONE-GOOD': 5.07,
    'K-SI2-POOR-GOOD-FAINT-VG': 5.07,
    'K-SI2-GOOD-POOR-FAINT-VG': 5.07,
    'K-I2-VG-EX-NONE-GOOD': 5.07,
    'K-SI2-GOOD-EX-FAINT-GOOD': 5.07,
    'K-SI2-EX-GOOD-FAINT-GOOD': 5.07,
    'K-I2-VG-POOR-NONE-VG': 5.07,
    'K-SI2-VG-VG-FAINT-GOOD': 5.07,
    'K-I2-GOOD-GOOD-NONE-VG': 5.07,
    'K-I2-POOR-VG-NONE-VG': 5.07,
    'L-SI2-POOR-GOOD-NONE-VG': 5.07,
    'L-SI2-GOOD-POOR-NONE-VG': 5.07,
    'L-SI2-GOOD-EX-NONE-GOOD': 5.07,
    'L-SI2-VG-VG-NONE-GOOD': 5.07,
    'L-SI2-EX-GOOD-NONE-GOOD': 5.07,
    'M-I2-EX-EX-STRONG-VG': 5.07,
    'M-I2-GOOD-VG-STRONG-EX': 5.07,
    'M-I2-POOR-EX-STRONG-EX': 5.07,
    'M-I2-EX-POOR-STRONG-EX': 5.07,
    'M-I2-VG-GOOD-STRONG-EX': 5.07,
    'E-VS2-VG-POOR-STRONG-POOR': 5.06,
    'E-VS2-POOR-VG-STRONG-POOR': 5.06,
    'E-VS2-GOOD-GOOD-STRONG-POOR': 5.06,
    'F-VS2-VG-POOR-MEDIUM-POOR': 5.06,
    'F-VS2-GOOD-GOOD-MEDIUM-POOR': 5.06,
    'F-VS2-POOR-VG-MEDIUM-POOR': 5.06,
    'F-VVS2-GOOD-POOR-STRONG-POOR': 5.06,
    'F-VVS2-POOR-GOOD-STRONG-POOR': 5.06,
    'G-VS2-VG-POOR-FAINT-POOR': 5.06,
    'G-VVS2-POOR-GOOD-MEDIUM-POOR': 5.06,
    'G-VVS2-GOOD-POOR-MEDIUM-POOR': 5.06,
    'G-VS2-POOR-VG-FAINT-POOR': 5.06,
    'G-VS2-GOOD-GOOD-FAINT-POOR': 5.06,
    'H-VS2-POOR-VG-NONE-POOR': 5.06,
    'H-VS2-VG-POOR-NONE-POOR': 5.06,
    'H-VS2-GOOD-GOOD-NONE-POOR': 5.06,
    'H-VVS2-GOOD-POOR-FAINT-POOR': 5.06,
    'H-VVS2-POOR-GOOD-FAINT-POOR': 5.06,
    'I-VVS2-GOOD-POOR-NONE-POOR': 5.06,
    'I-VVS2-POOR-GOOD-NONE-POOR': 5.06,
    'J-VS2-VG-GOOD-STRONG-GOOD': 5.06,
    'J-VS2-EX-EX-STRONG-POOR': 5.06,
    'J-VS2-POOR-POOR-STRONG-VG': 5.06,
    'J-VS2-POOR-EX-STRONG-GOOD': 5.06,
    'J-VS2-EX-POOR-STRONG-GOOD': 5.06,
    'J-VS2-GOOD-VG-STRONG-GOOD': 5.06,
    'K-VVS2-POOR-VG-STRONG-GOOD': 5.06,
    'K-VS2-EX-EX-MEDIUM-POOR': 5.06,
    'K-VS2-POOR-EX-MEDIUM-GOOD': 5.06,
    'K-VVS2-VG-EX-STRONG-POOR': 5.06,
    'K-VVS2-EX-VG-STRONG-POOR': 5.06,
    'K-VS2-POOR-POOR-MEDIUM-VG': 5.06,
    'K-VS2-EX-POOR-MEDIUM-GOOD': 5.06,
    'K-VS2-GOOD-VG-MEDIUM-GOOD': 5.06,
    'K-VVS2-VG-POOR-STRONG-GOOD': 5.06,
    'K-VS2-VG-GOOD-MEDIUM-GOOD': 5.06,
    'K-VVS2-GOOD-GOOD-STRONG-GOOD': 5.06,
    'L-VS2-EX-POOR-FAINT-GOOD': 5.06,
    'L-VS2-VG-GOOD-FAINT-GOOD': 5.06,
    'L-VS2-GOOD-VG-FAINT-GOOD': 5.06,
    'L-VVS2-VG-EX-MEDIUM-POOR': 5.06,
    'L-VS2-EX-EX-FAINT-POOR': 5.06,
    'L-VVS2-VG-POOR-MEDIUM-GOOD': 5.06,
    'L-VVS2-EX-VG-MEDIUM-POOR': 5.06,
    'L-VVS2-POOR-VG-MEDIUM-GOOD': 5.06,
    'L-VS2-POOR-POOR-FAINT-VG': 5.06,
    'L-VVS2-GOOD-GOOD-MEDIUM-GOOD': 5.06,
    'L-VS2-POOR-EX-FAINT-GOOD': 5.06,
    'M-VVS2-VG-EX-FAINT-POOR': 5.06,
    'M-VVS2-VG-POOR-FAINT-GOOD': 5.06,
    'M-VS2-POOR-POOR-NONE-VG': 5.06,
    'M-VVS2-EX-VG-FAINT-POOR': 5.06,
    'M-VS2-VG-GOOD-NONE-GOOD': 5.06,
    'M-VVS2-POOR-VG-FAINT-GOOD': 5.06,
    'M-VS2-POOR-EX-NONE-GOOD': 5.06,
    'M-VVS2-GOOD-GOOD-FAINT-GOOD': 5.06,
    'M-VS2-EX-POOR-NONE-GOOD': 5.06,
    'M-VS2-GOOD-VG-NONE-GOOD': 5.06,
    'M-VS2-EX-EX-NONE-POOR': 5.06,
    'G-IF-POOR-POOR-STRONG-POOR': 5.05,
    'H-IF-POOR-POOR-MEDIUM-POOR': 5.05,
    'I-IF-POOR-POOR-FAINT-POOR': 5.05,
    'J-IF-POOR-POOR-NONE-POOR': 5.05,
    'L-IF-EX-GOOD-STRONG-POOR': 5.05,
    'L-IF-VG-VG-STRONG-POOR': 5.05,
    'L-IF-GOOD-POOR-STRONG-GOOD': 5.05,
    'L-IF-GOOD-EX-STRONG-POOR': 5.05,
    'L-IF-POOR-GOOD-STRONG-GOOD': 5.05,
    'M-IF-VG-VG-MEDIUM-POOR': 5.05,
    'M-IF-EX-GOOD-MEDIUM-POOR': 5.05,
    'M-IF-GOOD-EX-MEDIUM-POOR': 5.05,
    'M-IF-GOOD-POOR-MEDIUM-GOOD': 5.05,
    'M-IF-POOR-GOOD-MEDIUM-GOOD': 5.05,
    'D-SI1-POOR-VG-STRONG-POOR': 5.04,
    'D-SI1-VG-POOR-STRONG-POOR': 5.04,
    'D-I1-GOOD-VG-MEDIUM-POOR': 5.04,
    'D-I1-POOR-POOR-MEDIUM-GOOD': 5.04,
    'D-I1-EX-POOR-MEDIUM-POOR': 5.04,
    'D-SI1-GOOD-GOOD-STRONG-POOR': 5.04,
    'D-I1-VG-GOOD-MEDIUM-POOR': 5.04,
    'D-I1-POOR-EX-MEDIUM-POOR': 5.04,
    'E-I1-EX-POOR-FAINT-POOR': 5.04,
    'E-I1-VG-GOOD-FAINT-POOR': 5.04,
    'E-SI1-GOOD-GOOD-MEDIUM-POOR': 5.04,
    'E-SI1-POOR-VG-MEDIUM-POOR': 5.04,
    'E-SI1-VG-POOR-MEDIUM-POOR': 5.04,
    'E-I1-GOOD-VG-FAINT-POOR': 5.04,
    'E-I1-POOR-POOR-FAINT-GOOD': 5.04,
    'E-I1-POOR-EX-FAINT-POOR': 5.04,
    'F-SI1-VG-POOR-FAINT-POOR': 5.04,
    'F-I1-VG-GOOD-NONE-POOR': 5.04,
    'F-I1-GOOD-VG-NONE-POOR': 5.04,
    'F-I1-POOR-EX-NONE-POOR': 5.04,
    'F-I1-EX-POOR-NONE-POOR': 5.04,
    'F-SI1-GOOD-GOOD-FAINT-POOR': 5.04,
    'F-I1-POOR-POOR-NONE-GOOD': 5.04,
    'F-SI1-POOR-VG-FAINT-POOR': 5.04,
    'G-SI1-VG-POOR-NONE-POOR': 5.04,
    'G-SI1-POOR-VG-NONE-POOR': 5.04,
    'G-SI1-GOOD-GOOD-NONE-POOR': 5.04,
    'H-I1-EX-GOOD-STRONG-GOOD': 5.04,
    'H-I1-POOR-GOOD-STRONG-VG': 5.04,
    'H-I1-GOOD-POOR-STRONG-VG': 5.04,
    'H-I1-GOOD-EX-STRONG-GOOD': 5.04,
    'H-I1-VG-VG-STRONG-GOOD': 5.04,
    'I-I1-POOR-GOOD-MEDIUM-VG': 5.04,
    'I-I1-VG-VG-MEDIUM-GOOD': 5.04,
    'I-I1-GOOD-POOR-MEDIUM-VG': 5.04,
    'I-I1-GOOD-EX-MEDIUM-GOOD': 5.04,
    'I-SI1-EX-POOR-STRONG-GOOD': 5.04,
    'I-SI1-EX-EX-STRONG-POOR': 5.04,
    'I-SI1-VG-GOOD-STRONG-GOOD': 5.04,
    'I-SI1-GOOD-VG-STRONG-GOOD': 5.04,
    'I-SI1-POOR-EX-STRONG-GOOD': 5.04,
    'I-SI1-POOR-POOR-STRONG-VG': 5.04,
    'I-I1-EX-GOOD-MEDIUM-GOOD': 5.04,
    'J-I1-GOOD-EX-FAINT-GOOD': 5.04,
    'J-I1-GOOD-POOR-FAINT-VG': 5.04,
    'J-I1-POOR-GOOD-FAINT-VG': 5.04,
    'J-I1-EX-GOOD-FAINT-GOOD': 5.04,
    'J-SI1-POOR-POOR-MEDIUM-VG': 5.04,
    'J-SI1-POOR-EX-MEDIUM-GOOD': 5.04,
    'J-SI1-GOOD-VG-MEDIUM-GOOD': 5.04,
    'J-SI1-VG-GOOD-MEDIUM-GOOD': 5.04,
    'J-SI1-EX-POOR-MEDIUM-GOOD': 5.04,
    'J-SI1-EX-EX-MEDIUM-POOR': 5.04,
    'J-I1-VG-VG-FAINT-GOOD': 5.04,
    'K-SI1-POOR-POOR-FAINT-VG': 5.04,
    'K-SI1-EX-EX-FAINT-POOR': 5.04,
    'K-SI1-POOR-EX-FAINT-GOOD': 5.04,
    'K-SI1-VG-GOOD-FAINT-GOOD': 5.04,
    'K-SI1-GOOD-VG-FAINT-GOOD': 5.04,
    'K-SI1-EX-POOR-FAINT-GOOD': 5.04,
    'K-I1-EX-GOOD-NONE-GOOD': 5.04,
    'K-I1-VG-VG-NONE-GOOD': 5.04,
    'K-I1-GOOD-EX-NONE-GOOD': 5.04,
    'K-I1-POOR-GOOD-NONE-VG': 5.04,
    'K-I1-GOOD-POOR-NONE-VG': 5.04,
    'L-SI1-EX-EX-NONE-POOR': 5.04,
    'L-SI1-EX-POOR-NONE-GOOD': 5.04,
    'L-SI1-VG-GOOD-NONE-GOOD': 5.04,
    'L-SI1-GOOD-VG-NONE-GOOD': 5.04,
    'L-SI1-POOR-EX-NONE-GOOD': 5.04,
    'L-SI1-POOR-POOR-NONE-VG': 5.04,
    'M-I1-VG-EX-STRONG-VG': 5.04,
    'M-I1-EX-VG-STRONG-VG': 5.04,
    'M-I1-POOR-VG-STRONG-EX': 5.04,
    'M-I1-VG-POOR-STRONG-EX': 5.04,
    'M-I1-GOOD-GOOD-STRONG-EX': 5.04,
    'E-VS1-GOOD-POOR-STRONG-POOR': 5.03,
    'E-VS1-POOR-GOOD-STRONG-POOR': 5.03,
    'F-VS1-GOOD-POOR-MEDIUM-POOR': 5.03,
    'F-VS1-POOR-GOOD-MEDIUM-POOR': 5.03,
    'F-VVS1-POOR-POOR-STRONG-POOR': 5.03,
    'G-VVS1-POOR-POOR-MEDIUM-POOR': 5.03,
    'G-VS1-POOR-GOOD-FAINT-POOR': 5.03,
    'G-VS1-GOOD-POOR-FAINT-POOR': 5.03,
    'H-VS1-GOOD-POOR-NONE-POOR': 5.03,
    'H-VS1-POOR-GOOD-NONE-POOR': 5.03,
    'H-VVS1-POOR-POOR-FAINT-POOR': 5.03,
    'I-VVS1-POOR-POOR-NONE-POOR': 5.03,
    'J-VS1-VG-POOR-STRONG-GOOD': 5.03,
    'J-VS1-VG-EX-STRONG-POOR': 5.03,
    'J-VS1-EX-VG-STRONG-POOR': 5.03,
    'J-VS1-GOOD-GOOD-STRONG-GOOD': 5.03,
    'J-VS1-POOR-VG-STRONG-GOOD': 5.03,
    'K-VS1-VG-POOR-MEDIUM-GOOD': 5.03,
    'K-VS1-GOOD-GOOD-MEDIUM-GOOD': 5.03,
    'K-VVS1-POOR-GOOD-STRONG-GOOD': 5.03,
    'K-VVS1-GOOD-POOR-STRONG-GOOD': 5.03,
    'K-VVS1-GOOD-EX-STRONG-POOR': 5.03,
    'K-VVS1-EX-GOOD-STRONG-POOR': 5.03,
    'K-VVS1-VG-VG-STRONG-POOR': 5.03,
    'K-VS1-POOR-VG-MEDIUM-GOOD': 5.03,
    'K-VS1-VG-EX-MEDIUM-POOR': 5.03,
    'K-VS1-EX-VG-MEDIUM-POOR': 5.03,
    'L-VVS1-GOOD-POOR-MEDIUM-GOOD': 5.03,
    'L-VS1-VG-POOR-FAINT-GOOD': 5.03,
    'L-VS1-VG-EX-FAINT-POOR': 5.03,
    'L-VS1-EX-VG-FAINT-POOR': 5.03,
    'L-VVS1-VG-VG-MEDIUM-POOR': 5.03,
    'L-VVS1-EX-GOOD-MEDIUM-POOR': 5.03,
    'L-VS1-POOR-VG-FAINT-GOOD': 5.03,
    'L-VVS1-POOR-GOOD-MEDIUM-GOOD': 5.03,
    'L-VVS1-GOOD-EX-MEDIUM-POOR': 5.03,
    'L-VS1-GOOD-GOOD-FAINT-GOOD': 5.03,
    'M-VVS1-GOOD-EX-FAINT-POOR': 5.03,
    'M-VVS1-VG-VG-FAINT-POOR': 5.03,
    'M-VVS1-EX-GOOD-FAINT-POOR': 5.03,
    'M-VS1-VG-POOR-NONE-GOOD': 5.03,
    'M-VS1-EX-VG-NONE-POOR': 5.03,
    'M-VVS1-POOR-GOOD-FAINT-GOOD': 5.03,
    'M-VVS1-GOOD-POOR-FAINT-GOOD': 5.03,
    'M-VS1-VG-EX-NONE-POOR': 5.03,
    'M-VS1-POOR-VG-NONE-GOOD': 5.03,
    'M-VS1-GOOD-GOOD-NONE-GOOD': 5.03,
    'D-I2-VG-GOOD-FAINT-POOR': 5.02,
    'D-I2-POOR-EX-FAINT-POOR': 5.02,
    'D-I2-POOR-POOR-FAINT-GOOD': 5.02,
    'D-I2-GOOD-VG-FAINT-POOR': 5.02,
    'D-SI2-GOOD-GOOD-MEDIUM-POOR': 5.02,
    'D-SI2-VG-POOR-MEDIUM-POOR': 5.02,
    'D-SI2-POOR-VG-MEDIUM-POOR': 5.02,
    'D-I2-EX-POOR-FAINT-POOR': 5.02,
    'E-SI2-GOOD-GOOD-FAINT-POOR': 5.02,
    'E-SI2-VG-POOR-FAINT-POOR': 5.02,
    'E-I2-GOOD-VG-NONE-POOR': 5.02,
    'E-I2-POOR-EX-NONE-POOR': 5.02,
    'E-SI2-POOR-VG-FAINT-POOR': 5.02,
    'E-I2-POOR-POOR-NONE-GOOD': 5.02,
    'E-I2-VG-GOOD-NONE-POOR': 5.02,
    'E-I2-EX-POOR-NONE-POOR': 5.02,
    'F-SI2-GOOD-GOOD-NONE-POOR': 5.02,
    'F-SI2-VG-POOR-NONE-POOR': 5.02,
    'F-SI2-POOR-VG-NONE-POOR': 5.02,
    'G-I2-POOR-GOOD-STRONG-VG': 5.02,
    'G-I2-VG-VG-STRONG-GOOD': 5.02,
    'G-I2-GOOD-POOR-STRONG-VG': 5.02,
    'G-I2-GOOD-EX-STRONG-GOOD': 5.02,
    'G-I2-EX-GOOD-STRONG-GOOD': 5.02,
    'H-SI2-GOOD-VG-STRONG-GOOD': 5.02,
    'H-SI2-POOR-EX-STRONG-GOOD': 5.02,
    'H-SI2-VG-GOOD-STRONG-GOOD': 5.02,
    'H-I2-GOOD-POOR-MEDIUM-VG': 5.02,
    'H-SI2-EX-EX-STRONG-POOR': 5.02,
    'H-I2-GOOD-EX-MEDIUM-GOOD': 5.02,
    'H-I2-VG-VG-MEDIUM-GOOD': 5.02,
    'H-SI2-POOR-POOR-STRONG-VG': 5.02,
    'H-I2-EX-GOOD-MEDIUM-GOOD': 5.02,
    'H-I2-POOR-GOOD-MEDIUM-VG': 5.02,
    'H-SI2-EX-POOR-STRONG-GOOD': 5.02,
    'I-I2-GOOD-EX-FAINT-GOOD': 5.02,
    'I-I2-GOOD-POOR-FAINT-VG': 5.02,
    'I-I2-VG-VG-FAINT-GOOD': 5.02,
    'I-SI2-EX-POOR-MEDIUM-GOOD': 5.02,
    'I-I2-EX-GOOD-FAINT-GOOD': 5.02,
    'I-SI2-VG-GOOD-MEDIUM-GOOD': 5.02,
    'I-SI2-GOOD-VG-MEDIUM-GOOD': 5.02,
    'I-I2-POOR-GOOD-FAINT-VG': 5.02,
    'I-SI2-POOR-POOR-MEDIUM-VG': 5.02,
    'I-SI2-POOR-EX-MEDIUM-GOOD': 5.02,
    'I-SI2-EX-EX-MEDIUM-POOR': 5.02,
    'J-SI2-EX-POOR-FAINT-GOOD': 5.02,
    'J-I2-GOOD-POOR-NONE-VG': 5.02,
    'J-SI2-EX-EX-FAINT-POOR': 5.02,
    'J-SI2-VG-GOOD-FAINT-GOOD': 5.02,
    'J-SI2-GOOD-VG-FAINT-GOOD': 5.02,
    'J-I2-VG-VG-NONE-GOOD': 5.02,
    'J-I2-GOOD-EX-NONE-GOOD': 5.02,
    'J-I2-EX-GOOD-NONE-GOOD': 5.02,
    'J-SI2-POOR-EX-FAINT-GOOD': 5.02,
    'J-I2-POOR-GOOD-NONE-VG': 5.02,
    'J-SI2-POOR-POOR-FAINT-VG': 5.02,
    'K-SI2-EX-EX-NONE-POOR': 5.02,
    'K-SI2-POOR-EX-NONE-GOOD': 5.02,
    'K-SI2-EX-POOR-NONE-GOOD': 5.02,
    'K-SI2-VG-GOOD-NONE-GOOD': 5.02,
    'K-SI2-GOOD-VG-NONE-GOOD': 5.02,
    'K-SI2-POOR-POOR-NONE-VG': 5.02,
    'L-I2-POOR-VG-STRONG-EX': 5.02,
    'L-I2-EX-VG-STRONG-VG': 5.02,
    'L-I2-GOOD-GOOD-STRONG-EX': 5.02,
    'L-I2-VG-POOR-STRONG-EX': 5.02,
    'L-I2-VG-EX-STRONG-VG': 5.02,
    'M-SI2-GOOD-POOR-STRONG-EX': 5.02,
    'M-SI2-GOOD-EX-STRONG-VG': 5.02,
    'M-SI2-POOR-GOOD-STRONG-EX': 5.02,
    'M-I2-EX-VG-MEDIUM-VG': 5.02,
    'M-I2-GOOD-GOOD-MEDIUM-EX': 5.02,
    'M-I2-VG-POOR-MEDIUM-EX': 5.02,
    'M-I2-VG-EX-MEDIUM-VG': 5.02,
    'M-SI2-VG-VG-STRONG-VG': 5.02,
    'M-SI2-EX-GOOD-STRONG-VG': 5.02,
    'M-I2-POOR-VG-MEDIUM-EX': 5.02,
    'D-VS2-GOOD-POOR-STRONG-POOR': 5.01,
    'D-VS2-POOR-GOOD-STRONG-POOR': 5.01,
    'E-VS2-POOR-GOOD-MEDIUM-POOR': 5.01,
    'E-VVS2-POOR-POOR-STRONG-POOR': 5.01,
    'E-VS2-GOOD-POOR-MEDIUM-POOR': 5.01,
    'F-VVS2-POOR-POOR-MEDIUM-POOR': 5.01,
    'F-VS2-POOR-GOOD-FAINT-POOR': 5.01,
    'F-VS2-GOOD-POOR-FAINT-POOR': 5.01,
    'G-VS2-POOR-GOOD-NONE-POOR': 5.01,
    'G-VVS2-POOR-POOR-FAINT-POOR': 5.01,
    'G-VS2-GOOD-POOR-NONE-POOR': 5.01,
    'H-VVS2-POOR-POOR-NONE-POOR': 5.01,
    'I-VS2-GOOD-GOOD-STRONG-GOOD': 5.01,
    'I-VS2-VG-EX-STRONG-POOR': 5.01,
    'I-VS2-POOR-VG-STRONG-GOOD': 5.01,
    'I-VS2-EX-VG-STRONG-POOR': 5.01,
    'I-VS2-VG-POOR-STRONG-GOOD': 5.01,
    'J-VVS2-VG-VG-STRONG-POOR': 5.01,
    'J-VVS2-GOOD-EX-STRONG-POOR': 5.01,
    'J-VVS2-EX-GOOD-STRONG-POOR': 5.01,
    'J-VS2-EX-VG-MEDIUM-POOR': 5.01,
    'J-VVS2-POOR-GOOD-STRONG-GOOD': 5.01,
    'J-VS2-VG-POOR-MEDIUM-GOOD': 5.01,
    'J-VS2-POOR-VG-MEDIUM-GOOD': 5.01,
    'J-VS2-GOOD-GOOD-MEDIUM-GOOD': 5.01,
    'J-VS2-VG-EX-MEDIUM-POOR': 5.01,
    'J-VVS2-GOOD-POOR-STRONG-GOOD': 5.01,
    'K-VS2-POOR-VG-FAINT-GOOD': 5.01,
    'K-VVS2-GOOD-POOR-MEDIUM-GOOD': 5.01,
    'K-VVS2-GOOD-EX-MEDIUM-POOR': 5.01,
    'K-VVS2-EX-GOOD-MEDIUM-POOR': 5.01,
    'K-VVS2-POOR-GOOD-MEDIUM-GOOD': 5.01,
    'K-VS2-GOOD-GOOD-FAINT-GOOD': 5.01,
    'K-VS2-VG-POOR-FAINT-GOOD': 5.01,
    'K-VVS2-VG-VG-MEDIUM-POOR': 5.01,
    'K-VS2-EX-VG-FAINT-POOR': 5.01,
    'K-VS2-VG-EX-FAINT-POOR': 5.01,
    'L-VS2-VG-EX-NONE-POOR': 5.01,
    'L-VS2-EX-VG-NONE-POOR': 5.01,
    'L-VVS2-GOOD-EX-FAINT-POOR': 5.01,
    'L-VVS2-GOOD-POOR-FAINT-GOOD': 5.01,
    'L-VVS2-VG-VG-FAINT-POOR': 5.01,
    'L-VS2-VG-POOR-NONE-GOOD': 5.01,
    'L-VS2-GOOD-GOOD-NONE-GOOD': 5.01,
    'L-VVS2-POOR-GOOD-FAINT-GOOD': 5.01,
    'L-VVS2-EX-GOOD-FAINT-POOR': 5.01,
    'L-VS2-POOR-VG-NONE-GOOD': 5.01,
    'M-VVS2-POOR-GOOD-NONE-GOOD': 5.01,
    'M-VVS2-VG-VG-NONE-POOR': 5.01,
    'M-VVS2-EX-GOOD-NONE-POOR': 5.01,
    'M-VVS2-GOOD-POOR-NONE-GOOD': 5.01,
    'M-VVS2-GOOD-EX-NONE-POOR': 5.01,
    'K-IF-EX-POOR-STRONG-POOR': 5,
    'K-IF-POOR-EX-STRONG-POOR': 5,
    'K-IF-VG-GOOD-STRONG-POOR': 5,
    'K-IF-GOOD-VG-STRONG-POOR': 5,
    'K-IF-POOR-POOR-STRONG-GOOD': 5,
    'L-IF-POOR-POOR-MEDIUM-GOOD': 5,
    'L-IF-GOOD-VG-MEDIUM-POOR': 5,
    'L-IF-EX-POOR-MEDIUM-POOR': 5,
    'L-IF-POOR-EX-MEDIUM-POOR': 5,
    'L-IF-VG-GOOD-MEDIUM-POOR': 5,
    'M-IF-POOR-EX-FAINT-POOR': 5,
    'M-IF-EX-POOR-FAINT-POOR': 5,
    'M-IF-VG-GOOD-FAINT-POOR': 5,
    'M-IF-POOR-POOR-FAINT-GOOD': 5,
    'M-IF-GOOD-VG-FAINT-POOR': 5,
    'D-SI1-GOOD-POOR-MEDIUM-POOR': 4.99,
    'D-I1-VG-POOR-FAINT-POOR': 4.99,
    'D-I1-GOOD-GOOD-FAINT-POOR': 4.99,
    'D-SI1-POOR-GOOD-MEDIUM-POOR': 4.99,
    'D-I1-POOR-VG-FAINT-POOR': 4.99,
    'E-I1-GOOD-GOOD-NONE-POOR': 4.99,
    'E-SI1-GOOD-POOR-FAINT-POOR': 4.99,
    'E-I1-VG-POOR-NONE-POOR': 4.99,
    'E-SI1-POOR-GOOD-FAINT-POOR': 4.99,
    'E-I1-POOR-VG-NONE-POOR': 4.99,
    'F-SI1-GOOD-POOR-NONE-POOR': 4.99,
    'F-SI1-POOR-GOOD-NONE-POOR': 4.99,
    'G-I1-VG-GOOD-STRONG-GOOD': 4.99,
    'G-I1-POOR-POOR-STRONG-VG': 4.99,
    'G-I1-EX-POOR-STRONG-GOOD': 4.99,
    'G-I1-EX-EX-STRONG-POOR': 4.99,
    'G-I1-POOR-EX-STRONG-GOOD': 4.99,
    'G-I1-GOOD-VG-STRONG-GOOD': 4.99,
    'H-I1-POOR-EX-MEDIUM-GOOD': 4.99,
    'H-SI1-POOR-VG-STRONG-GOOD': 4.99,
    'H-SI1-VG-POOR-STRONG-GOOD': 4.99,
    'H-SI1-GOOD-GOOD-STRONG-GOOD': 4.99,
    'H-I1-EX-EX-MEDIUM-POOR': 4.99,
    'H-I1-POOR-POOR-MEDIUM-VG': 4.99,
    'H-I1-VG-GOOD-MEDIUM-GOOD': 4.99,
    'H-SI1-EX-VG-STRONG-POOR': 4.99,
    'H-I1-EX-POOR-MEDIUM-GOOD': 4.99,
    'H-SI1-VG-EX-STRONG-POOR': 4.99,
    'H-I1-GOOD-VG-MEDIUM-GOOD': 4.99,
    'I-SI1-GOOD-GOOD-MEDIUM-GOOD': 4.99,
    'I-I1-EX-POOR-FAINT-GOOD': 4.99,
    'I-I1-EX-EX-FAINT-POOR': 4.99,
    'I-SI1-POOR-VG-MEDIUM-GOOD': 4.99,
    'I-I1-POOR-POOR-FAINT-VG': 4.99,
    'I-SI1-EX-VG-MEDIUM-POOR': 4.99,
    'I-I1-VG-GOOD-FAINT-GOOD': 4.99,
    'I-I1-GOOD-VG-FAINT-GOOD': 4.99,
    'I-I1-POOR-EX-FAINT-GOOD': 4.99,
    'I-SI1-VG-POOR-MEDIUM-GOOD': 4.99,
    'I-SI1-VG-EX-MEDIUM-POOR': 4.99,
    'J-I1-POOR-EX-NONE-GOOD': 4.99,
    'J-SI1-VG-EX-FAINT-POOR': 4.99,
    'J-I1-POOR-POOR-NONE-VG': 4.99,
    'J-SI1-POOR-VG-FAINT-GOOD': 4.99,
    'J-SI1-VG-POOR-FAINT-GOOD': 4.99,
    'J-I1-VG-GOOD-NONE-GOOD': 4.99,
    'J-SI1-EX-VG-FAINT-POOR': 4.99,
    'J-I1-GOOD-VG-NONE-GOOD': 4.99,
    'J-I1-EX-POOR-NONE-GOOD': 4.99,
    'J-I1-EX-EX-NONE-POOR': 4.99,
    'J-SI1-GOOD-GOOD-FAINT-GOOD': 4.99,
    'K-SI1-GOOD-GOOD-NONE-GOOD': 4.99,
    'K-SI1-POOR-VG-NONE-GOOD': 4.99,
    'K-SI1-VG-EX-NONE-POOR': 4.99,
    'K-SI1-EX-VG-NONE-POOR': 4.99,
    'K-SI1-VG-POOR-NONE-GOOD': 4.99,
    'L-I1-GOOD-EX-STRONG-VG': 4.99,
    'L-I1-GOOD-POOR-STRONG-EX': 4.99,
    'L-I1-EX-GOOD-STRONG-VG': 4.99,
    'L-I1-VG-VG-STRONG-VG': 4.99,
    'L-I1-POOR-GOOD-STRONG-EX': 4.99,
    'M-SI1-EX-EX-STRONG-GOOD': 4.99,
    'M-I1-EX-GOOD-MEDIUM-VG': 4.99,
    'M-SI1-GOOD-VG-STRONG-VG': 4.99,
    'M-SI1-EX-POOR-STRONG-VG': 4.99,
    'M-I1-GOOD-EX-MEDIUM-VG': 4.99,
    'M-SI1-POOR-EX-STRONG-VG': 4.99,
    'M-SI1-VG-GOOD-STRONG-VG': 4.99,
    'M-I1-GOOD-POOR-MEDIUM-EX': 4.99,
    'M-SI1-POOR-POOR-STRONG-EX': 4.99,
    'M-I1-VG-VG-MEDIUM-VG': 4.99,
    'M-I1-POOR-GOOD-MEDIUM-EX': 4.99,
    'D-VS1-POOR-POOR-STRONG-POOR': 4.98,
    'E-VS1-POOR-POOR-MEDIUM-POOR': 4.98,
    'F-VS1-POOR-POOR-FAINT-POOR': 4.98,
    'G-VS1-POOR-POOR-NONE-POOR': 4.98,
    'I-VS1-EX-GOOD-STRONG-POOR': 4.98,
    'I-VS1-POOR-GOOD-STRONG-GOOD': 4.98,
    'I-VS1-GOOD-POOR-STRONG-GOOD': 4.98,
    'I-VS1-GOOD-EX-STRONG-POOR': 4.98,
    'I-VS1-VG-VG-STRONG-POOR': 4.98,
    'J-VS1-POOR-GOOD-MEDIUM-GOOD': 4.98,
    'J-VS1-GOOD-POOR-MEDIUM-GOOD': 4.98,
    'J-VVS1-POOR-POOR-STRONG-GOOD': 4.98,
    'J-VS1-VG-VG-MEDIUM-POOR': 4.98,
    'J-VVS1-VG-GOOD-STRONG-POOR': 4.98,
    'J-VS1-EX-GOOD-MEDIUM-POOR': 4.98,
    'J-VVS1-GOOD-VG-STRONG-POOR': 4.98,
    'J-VVS1-POOR-EX-STRONG-POOR': 4.98,
    'J-VVS1-EX-POOR-STRONG-POOR': 4.98,
    'J-VS1-GOOD-EX-MEDIUM-POOR': 4.98,
    'K-VVS1-GOOD-VG-MEDIUM-POOR': 4.98,
    'K-VVS1-POOR-POOR-MEDIUM-GOOD': 4.98,
    'K-VVS1-EX-POOR-MEDIUM-POOR': 4.98,
    'K-VVS1-VG-GOOD-MEDIUM-POOR': 4.98,
    'K-VS1-POOR-GOOD-FAINT-GOOD': 4.98,
    'K-VS1-VG-VG-FAINT-POOR': 4.98,
    'K-VVS1-POOR-EX-MEDIUM-POOR': 4.98,
    'K-VS1-GOOD-POOR-FAINT-GOOD': 4.98,
    'K-VS1-GOOD-EX-FAINT-POOR': 4.98,
    'K-VS1-EX-GOOD-FAINT-POOR': 4.98,
    'L-VVS1-POOR-EX-FAINT-POOR': 4.98,
    'L-VVS1-POOR-POOR-FAINT-GOOD': 4.98,
    'L-VS1-POOR-GOOD-NONE-GOOD': 4.98,
    'L-VVS1-GOOD-VG-FAINT-POOR': 4.98,
    'L-VS1-GOOD-POOR-NONE-GOOD': 4.98,
    'L-VS1-VG-VG-NONE-POOR': 4.98,
    'L-VVS1-EX-POOR-FAINT-POOR': 4.98,
    'L-VVS1-VG-GOOD-FAINT-POOR': 4.98,
    'L-VS1-EX-GOOD-NONE-POOR': 4.98,
    'L-VS1-GOOD-EX-NONE-POOR': 4.98,
    'M-VVS1-POOR-POOR-NONE-GOOD': 4.98,
    'M-VVS1-VG-GOOD-NONE-POOR': 4.98,
    'M-VVS1-GOOD-VG-NONE-POOR': 4.98,
    'M-VVS1-POOR-EX-NONE-POOR': 4.98,
    'M-VVS1-EX-POOR-NONE-POOR': 4.98,
    'D-I2-POOR-VG-NONE-POOR': 4.97,
    'D-SI2-POOR-GOOD-FAINT-POOR': 4.97,
    'D-I2-GOOD-GOOD-NONE-POOR': 4.97,
    'D-I2-VG-POOR-NONE-POOR': 4.97,
    'D-SI2-GOOD-POOR-FAINT-POOR': 4.97,
    'E-SI2-POOR-GOOD-NONE-POOR': 4.97,
    'E-SI2-GOOD-POOR-NONE-POOR': 4.97,
    'F-I2-EX-POOR-STRONG-GOOD': 4.97,
    'F-I2-GOOD-VG-STRONG-GOOD': 4.97,
    'F-I2-EX-EX-STRONG-POOR': 4.97,
    'F-I2-VG-GOOD-STRONG-GOOD': 4.97,
    'F-I2-POOR-EX-STRONG-GOOD': 4.97,
    'F-I2-POOR-POOR-STRONG-VG': 4.97,
    'G-I2-POOR-POOR-MEDIUM-VG': 4.97,
    'G-SI2-VG-EX-STRONG-POOR': 4.97,
    'G-I2-VG-GOOD-MEDIUM-GOOD': 4.97,
    'G-I2-POOR-EX-MEDIUM-GOOD': 4.97,
    'G-I2-GOOD-VG-MEDIUM-GOOD': 4.97,
    'G-SI2-POOR-VG-STRONG-GOOD': 4.97,
    'G-I2-EX-EX-MEDIUM-POOR': 4.97,
    'G-SI2-EX-VG-STRONG-POOR': 4.97,
    'G-I2-EX-POOR-MEDIUM-GOOD': 4.97,
    'G-SI2-GOOD-GOOD-STRONG-GOOD': 4.97,
    'G-SI2-VG-POOR-STRONG-GOOD': 4.97,
    'H-I2-EX-EX-FAINT-POOR': 4.97,
    'H-I2-EX-POOR-FAINT-GOOD': 4.97,
    'H-SI2-EX-VG-MEDIUM-POOR': 4.97,
    'H-I2-POOR-POOR-FAINT-VG': 4.97,
    'H-I2-POOR-EX-FAINT-GOOD': 4.97,
    'H-I2-GOOD-VG-FAINT-GOOD': 4.97,
    'H-SI2-VG-POOR-MEDIUM-GOOD': 4.97,
    'H-SI2-POOR-VG-MEDIUM-GOOD': 4.97,
    'H-SI2-GOOD-GOOD-MEDIUM-GOOD': 4.97,
    'H-SI2-VG-EX-MEDIUM-POOR': 4.97,
    'H-I2-VG-GOOD-FAINT-GOOD': 4.97,
    'I-I2-EX-EX-NONE-POOR': 4.97,
    'I-I2-POOR-POOR-NONE-VG': 4.97,
    'I-I2-POOR-EX-NONE-GOOD': 4.97,
    'I-SI2-EX-VG-FAINT-POOR': 4.97,
    'I-SI2-POOR-VG-FAINT-GOOD': 4.97,
    'I-SI2-VG-EX-FAINT-POOR': 4.97,
    'I-I2-VG-GOOD-NONE-GOOD': 4.97,
    'I-SI2-VG-POOR-FAINT-GOOD': 4.97,
    'I-SI2-GOOD-GOOD-FAINT-GOOD': 4.97,
    'I-I2-GOOD-VG-NONE-GOOD': 4.97,
    'I-I2-EX-POOR-NONE-GOOD': 4.97,
    'J-SI2-EX-VG-NONE-POOR': 4.97,
    'J-SI2-VG-EX-NONE-POOR': 4.97,
    'J-SI2-VG-POOR-NONE-GOOD': 4.97,
    'J-SI2-GOOD-GOOD-NONE-GOOD': 4.97,
    'J-SI2-POOR-VG-NONE-GOOD': 4.97,
    'K-I2-POOR-GOOD-STRONG-EX': 4.97,
    'K-I2-EX-GOOD-STRONG-VG': 4.97,
    'K-I2-VG-VG-STRONG-VG': 4.97,
    'K-I2-GOOD-EX-STRONG-VG': 4.97,
    'K-I2-GOOD-POOR-STRONG-EX': 4.97,
    'L-SI2-EX-POOR-STRONG-VG': 4.97,
    'L-SI2-POOR-EX-STRONG-VG': 4.97,
    'L-SI2-GOOD-VG-STRONG-VG': 4.97,
    'L-SI2-EX-EX-STRONG-GOOD': 4.97,
    'L-SI2-VG-GOOD-STRONG-VG': 4.97,
    'L-I2-VG-VG-MEDIUM-VG': 4.97,
    'L-I2-GOOD-EX-MEDIUM-VG': 4.97,
    'L-I2-GOOD-POOR-MEDIUM-EX': 4.97,
    'L-I2-POOR-GOOD-MEDIUM-EX': 4.97,
    'L-I2-EX-GOOD-MEDIUM-VG': 4.97,
    'L-SI2-POOR-POOR-STRONG-EX': 4.97,
    'M-I2-VG-VG-FAINT-VG': 4.97,
    'M-I2-GOOD-EX-FAINT-VG': 4.97,
    'M-SI2-EX-EX-MEDIUM-GOOD': 4.97,
    'M-SI2-POOR-EX-MEDIUM-VG': 4.97,
    'M-I2-GOOD-POOR-FAINT-EX': 4.97,
    'M-I2-POOR-GOOD-FAINT-EX': 4.97,
    'M-SI2-GOOD-VG-MEDIUM-VG': 4.97,
    'M-SI2-VG-GOOD-MEDIUM-VG': 4.97,
    'M-SI2-EX-POOR-MEDIUM-VG': 4.97,
    'M-I2-EX-GOOD-FAINT-VG': 4.97,
    'M-SI2-POOR-POOR-MEDIUM-EX': 4.97,
    'D-VS2-POOR-POOR-MEDIUM-POOR': 4.96,
    'E-VS2-POOR-POOR-FAINT-POOR': 4.96,
    'F-VS2-POOR-POOR-NONE-POOR': 4.96,
    'H-VS2-POOR-GOOD-STRONG-GOOD': 4.96,
    'H-VS2-VG-VG-STRONG-POOR': 4.96,
    'H-VS2-GOOD-POOR-STRONG-GOOD': 4.96,
    'H-VS2-GOOD-EX-STRONG-POOR': 4.96,
    'H-VS2-EX-GOOD-STRONG-POOR': 4.96,
    'I-VS2-GOOD-POOR-MEDIUM-GOOD': 4.96,
    'I-VS2-POOR-GOOD-MEDIUM-GOOD': 4.96,
    'I-VS2-EX-GOOD-MEDIUM-POOR': 4.96,
    'I-VS2-VG-VG-MEDIUM-POOR': 4.96,
    'I-VS2-GOOD-EX-MEDIUM-POOR': 4.96,
    'I-VVS2-POOR-POOR-STRONG-GOOD': 4.96,
    'I-VVS2-POOR-EX-STRONG-POOR': 4.96,
    'I-VVS2-GOOD-VG-STRONG-POOR': 4.96,
    'I-VVS2-VG-GOOD-STRONG-POOR': 4.96,
    'I-VVS2-EX-POOR-STRONG-POOR': 4.96,
    'J-VS2-GOOD-POOR-FAINT-GOOD': 4.96,
    'J-VS2-POOR-GOOD-FAINT-GOOD': 4.96,
    'J-VS2-GOOD-EX-FAINT-POOR': 4.96,
    'J-VS2-VG-VG-FAINT-POOR': 4.96,
    'J-VS2-EX-GOOD-FAINT-POOR': 4.96,
    'J-VVS2-VG-GOOD-MEDIUM-POOR': 4.96,
    'J-VVS2-GOOD-VG-MEDIUM-POOR': 4.96,
    'J-VVS2-POOR-EX-MEDIUM-POOR': 4.96,
    'J-VVS2-POOR-POOR-MEDIUM-GOOD': 4.96,
    'J-VVS2-EX-POOR-MEDIUM-POOR': 4.96,
    'K-VVS2-POOR-POOR-FAINT-GOOD': 4.96,
    'K-VVS2-POOR-EX-FAINT-POOR': 4.96,
    'K-VS2-POOR-GOOD-NONE-GOOD': 4.96,
    'K-VS2-GOOD-POOR-NONE-GOOD': 4.96,
    'K-VVS2-EX-POOR-FAINT-POOR': 4.96,
    'K-VS2-GOOD-EX-NONE-POOR': 4.96,
    'K-VVS2-VG-GOOD-FAINT-POOR': 4.96,
    'K-VS2-EX-GOOD-NONE-POOR': 4.96,
    'K-VS2-VG-VG-NONE-POOR': 4.96,
    'K-VVS2-GOOD-VG-FAINT-POOR': 4.96,
    'L-VVS2-EX-POOR-NONE-POOR': 4.96,
    'L-VVS2-POOR-POOR-NONE-GOOD': 4.96,
    'L-VVS2-POOR-EX-NONE-POOR': 4.96,
    'L-VVS2-VG-GOOD-NONE-POOR': 4.96,
    'L-VVS2-GOOD-VG-NONE-POOR': 4.96,
    'M-VS2-POOR-VG-STRONG-VG': 4.96,
    'M-VS2-GOOD-GOOD-STRONG-VG': 4.96,
    'M-VS2-VG-POOR-STRONG-VG': 4.96,
    'M-VS2-VG-EX-STRONG-GOOD': 4.96,
    'M-VS2-EX-VG-STRONG-GOOD': 4.96,
    'J-IF-VG-POOR-STRONG-POOR': 4.95,
    'J-IF-GOOD-GOOD-STRONG-POOR': 4.95,
    'J-IF-POOR-VG-STRONG-POOR': 4.95,
    'K-IF-POOR-VG-MEDIUM-POOR': 4.95,
    'K-IF-GOOD-GOOD-MEDIUM-POOR': 4.95,
    'K-IF-VG-POOR-MEDIUM-POOR': 4.95,
    'L-IF-POOR-VG-FAINT-POOR': 4.95,
    'L-IF-GOOD-GOOD-FAINT-POOR': 4.95,
    'L-IF-VG-POOR-FAINT-POOR': 4.95,
    'M-IF-POOR-VG-NONE-POOR': 4.95,
    'M-IF-VG-POOR-NONE-POOR': 4.95,
    'M-IF-GOOD-GOOD-NONE-POOR': 4.95,
    'D-I1-POOR-GOOD-NONE-POOR': 4.94,
    'D-SI1-POOR-POOR-FAINT-POOR': 4.94,
    'D-I1-GOOD-POOR-NONE-POOR': 4.94,
    'E-SI1-POOR-POOR-NONE-POOR': 4.94,
    'F-I1-VG-EX-STRONG-POOR': 4.94,
    'F-I1-POOR-VG-STRONG-GOOD': 4.94,
    'F-I1-GOOD-GOOD-STRONG-GOOD': 4.94,
    'F-I1-VG-POOR-STRONG-GOOD': 4.94,
    'F-I1-EX-VG-STRONG-POOR': 4.94,
    'G-SI1-GOOD-EX-STRONG-POOR': 4.94,
    'G-I1-POOR-VG-MEDIUM-GOOD': 4.94,
    'G-I1-GOOD-GOOD-MEDIUM-GOOD': 4.94,
    'G-SI1-VG-VG-STRONG-POOR': 4.94,
    'G-I1-VG-POOR-MEDIUM-GOOD': 4.94,
    'G-SI1-POOR-GOOD-STRONG-GOOD': 4.94,
    'G-SI1-GOOD-POOR-STRONG-GOOD': 4.94,
    'G-SI1-EX-GOOD-STRONG-POOR': 4.94,
    'G-I1-VG-EX-MEDIUM-POOR': 4.94,
    'G-I1-EX-VG-MEDIUM-POOR': 4.94,
    'H-I1-VG-EX-FAINT-POOR': 4.94,
    'H-I1-VG-POOR-FAINT-GOOD': 4.94,
    'H-SI1-VG-VG-MEDIUM-POOR': 4.94,
    'H-SI1-EX-GOOD-MEDIUM-POOR': 4.94,
    'H-SI1-GOOD-EX-MEDIUM-POOR': 4.94,
    'H-I1-EX-VG-FAINT-POOR': 4.94,
    'H-SI1-POOR-GOOD-MEDIUM-GOOD': 4.94,
    'H-I1-GOOD-GOOD-FAINT-GOOD': 4.94,
    'H-SI1-GOOD-POOR-MEDIUM-GOOD': 4.94,
    'H-I1-POOR-VG-FAINT-GOOD': 4.94,
    'I-I1-POOR-VG-NONE-GOOD': 4.94,
    'I-I1-EX-VG-NONE-POOR': 4.94,
    'I-I1-VG-EX-NONE-POOR': 4.94,
    'I-I1-VG-POOR-NONE-GOOD': 4.94,
    'I-I1-GOOD-GOOD-NONE-GOOD': 4.94,
    'I-SI1-POOR-GOOD-FAINT-GOOD': 4.94,
    'I-SI1-VG-VG-FAINT-POOR': 4.94,
    'I-SI1-EX-GOOD-FAINT-POOR': 4.94,
    'I-SI1-GOOD-EX-FAINT-POOR': 4.94,
    'I-SI1-GOOD-POOR-FAINT-GOOD': 4.94,
    'J-SI1-GOOD-EX-NONE-POOR': 4.94,
    'J-SI1-VG-VG-NONE-POOR': 4.94,
    'J-SI1-POOR-GOOD-NONE-GOOD': 4.94,
    'J-SI1-GOOD-POOR-NONE-GOOD': 4.94,
    'J-SI1-EX-GOOD-NONE-POOR': 4.94,
    'K-I1-GOOD-VG-STRONG-VG': 4.94,
    'K-I1-POOR-EX-STRONG-VG': 4.94,
    'K-I1-EX-EX-STRONG-GOOD': 4.94,
    'K-I1-EX-POOR-STRONG-VG': 4.94,
    'K-I1-VG-GOOD-STRONG-VG': 4.94,
    'K-I1-POOR-POOR-STRONG-EX': 4.94,
    'L-I1-VG-GOOD-MEDIUM-VG': 4.94,
    'L-I1-EX-POOR-MEDIUM-VG': 4.94,
    'L-I1-EX-EX-MEDIUM-GOOD': 4.94,
    'L-SI1-POOR-VG-STRONG-VG': 4.94,
    'L-SI1-GOOD-GOOD-STRONG-VG': 4.94,
    'L-SI1-VG-POOR-STRONG-VG': 4.94,
    'L-SI1-VG-EX-STRONG-GOOD': 4.94,
    'L-SI1-EX-VG-STRONG-GOOD': 4.94,
    'L-I1-POOR-POOR-MEDIUM-EX': 4.94,
    'L-I1-POOR-EX-MEDIUM-VG': 4.94,
    'L-I1-GOOD-VG-MEDIUM-VG': 4.94,
    'M-I1-EX-POOR-FAINT-VG': 4.94,
    'M-I1-POOR-EX-FAINT-VG': 4.94,
    'M-I1-POOR-POOR-FAINT-EX': 4.94,
    'M-SI1-GOOD-GOOD-MEDIUM-VG': 4.94,
    'M-SI1-VG-EX-MEDIUM-GOOD': 4.94,
    'M-I1-GOOD-VG-FAINT-VG': 4.94,
    'M-I1-VG-GOOD-FAINT-VG': 4.94,
    'M-I1-EX-EX-FAINT-GOOD': 4.94,
    'M-SI1-POOR-VG-MEDIUM-VG': 4.94,
    'M-SI1-VG-POOR-MEDIUM-VG': 4.94,
    'M-SI1-EX-VG-MEDIUM-GOOD': 4.94,
    'H-VS1-POOR-EX-STRONG-POOR': 4.93,
    'H-VS1-EX-POOR-STRONG-POOR': 4.93,
    'H-VS1-VG-GOOD-STRONG-POOR': 4.93,
    'H-VS1-POOR-POOR-STRONG-GOOD': 4.93,
    'H-VS1-GOOD-VG-STRONG-POOR': 4.93,
    'I-VS1-GOOD-VG-MEDIUM-POOR': 4.93,
    'I-VS1-EX-POOR-MEDIUM-POOR': 4.93,
    'I-VS1-VG-GOOD-MEDIUM-POOR': 4.93,
    'I-VS1-POOR-EX-MEDIUM-POOR': 4.93,
    'I-VVS1-VG-POOR-STRONG-POOR': 4.93,
    'I-VVS1-GOOD-GOOD-STRONG-POOR': 4.93,
    'I-VVS1-POOR-VG-STRONG-POOR': 4.93,
    'I-VS1-POOR-POOR-MEDIUM-GOOD': 4.93,
    'J-VS1-EX-POOR-FAINT-POOR': 4.93,
    'J-VS1-POOR-POOR-FAINT-GOOD': 4.93,
    'J-VS1-GOOD-VG-FAINT-POOR': 4.93,
    'J-VS1-POOR-EX-FAINT-POOR': 4.93,
    'J-VS1-VG-GOOD-FAINT-POOR': 4.93,
    'J-VVS1-POOR-VG-MEDIUM-POOR': 4.93,
    'J-VVS1-GOOD-GOOD-MEDIUM-POOR': 4.93,
    'J-VVS1-VG-POOR-MEDIUM-POOR': 4.93,
    'K-VVS1-VG-POOR-FAINT-POOR': 4.93,
    'K-VVS1-GOOD-GOOD-FAINT-POOR': 4.93,
    'K-VVS1-POOR-VG-FAINT-POOR': 4.93,
    'K-VS1-GOOD-VG-NONE-POOR': 4.93,
    'K-VS1-VG-GOOD-NONE-POOR': 4.93,
    'K-VS1-POOR-EX-NONE-POOR': 4.93,
    'K-VS1-EX-POOR-NONE-POOR': 4.93,
    'K-VS1-POOR-POOR-NONE-GOOD': 4.93,
    'L-VVS1-GOOD-GOOD-NONE-POOR': 4.93,
    'L-VVS1-POOR-VG-NONE-POOR': 4.93,
    'L-VVS1-VG-POOR-NONE-POOR': 4.93,
    'M-VS1-POOR-GOOD-STRONG-VG': 4.93,
    'M-VS1-GOOD-EX-STRONG-GOOD': 4.93,
    'M-VS1-EX-GOOD-STRONG-GOOD': 4.93,
    'M-VS1-VG-VG-STRONG-GOOD': 4.93,
    'M-VS1-GOOD-POOR-STRONG-VG': 4.93,
    'D-SI2-POOR-POOR-NONE-POOR': 4.92,
    'E-I2-POOR-VG-STRONG-GOOD': 4.92,
    'E-I2-VG-POOR-STRONG-GOOD': 4.92,
    'E-I2-GOOD-GOOD-STRONG-GOOD': 4.92,
    'E-I2-EX-VG-STRONG-POOR': 4.92,
    'E-I2-VG-EX-STRONG-POOR': 4.92,
    'F-I2-POOR-VG-MEDIUM-GOOD': 4.92,
    'F-SI2-EX-GOOD-STRONG-POOR': 4.92,
    'F-I2-VG-POOR-MEDIUM-GOOD': 4.92,
    'F-SI2-POOR-GOOD-STRONG-GOOD': 4.92,
    'F-SI2-VG-VG-STRONG-POOR': 4.92,
    'F-I2-EX-VG-MEDIUM-POOR': 4.92,
    'F-I2-VG-EX-MEDIUM-POOR': 4.92,
    'F-SI2-GOOD-POOR-STRONG-GOOD': 4.92,
    'F-I2-GOOD-GOOD-MEDIUM-GOOD': 4.92,
    'F-SI2-GOOD-EX-STRONG-POOR': 4.92,
    'G-I2-GOOD-GOOD-FAINT-GOOD': 4.92,
    'G-I2-POOR-VG-FAINT-GOOD': 4.92,
    'G-SI2-GOOD-POOR-MEDIUM-GOOD': 4.92,
    'G-SI2-POOR-GOOD-MEDIUM-GOOD': 4.92,
    'G-I2-VG-POOR-FAINT-GOOD': 4.92,
    'G-I2-VG-EX-FAINT-POOR': 4.92,
    'G-I2-EX-VG-FAINT-POOR': 4.92,
    'G-SI2-GOOD-EX-MEDIUM-POOR': 4.92,
    'G-SI2-VG-VG-MEDIUM-POOR': 4.92,
    'G-SI2-EX-GOOD-MEDIUM-POOR': 4.92,
    'H-SI2-EX-GOOD-FAINT-POOR': 4.92,
    'H-I2-GOOD-GOOD-NONE-GOOD': 4.92,
    'H-I2-VG-POOR-NONE-GOOD': 4.92,
    'H-I2-VG-EX-NONE-POOR': 4.92,
    'H-SI2-VG-VG-FAINT-POOR': 4.92,
    'H-I2-EX-VG-NONE-POOR': 4.92,
    'H-SI2-POOR-GOOD-FAINT-GOOD': 4.92,
    'H-SI2-GOOD-POOR-FAINT-GOOD': 4.92,
    'H-I2-POOR-VG-NONE-GOOD': 4.92,
    'H-SI2-GOOD-EX-FAINT-POOR': 4.92,
    'I-SI2-EX-GOOD-NONE-POOR': 4.92,
    'I-SI2-VG-VG-NONE-POOR': 4.92,
    'I-SI2-POOR-GOOD-NONE-GOOD': 4.92,
    'I-SI2-GOOD-POOR-NONE-GOOD': 4.92,
    'I-SI2-GOOD-EX-NONE-POOR': 4.92,
    'J-I2-VG-GOOD-STRONG-VG': 4.92,
    'J-I2-EX-EX-STRONG-GOOD': 4.92,
    'J-I2-EX-POOR-STRONG-VG': 4.92,
    'J-I2-POOR-EX-STRONG-VG': 4.92,
    'J-I2-POOR-POOR-STRONG-EX': 4.92,
    'J-I2-GOOD-VG-STRONG-VG': 4.92,
    'K-I2-POOR-POOR-MEDIUM-EX': 4.92,
    'K-I2-EX-EX-MEDIUM-GOOD': 4.92,
    'K-I2-EX-POOR-MEDIUM-VG': 4.92,
    'K-SI2-POOR-VG-STRONG-VG': 4.92,
    'K-I2-POOR-EX-MEDIUM-VG': 4.92,
    'K-SI2-EX-VG-STRONG-GOOD': 4.92,
    'K-SI2-GOOD-GOOD-STRONG-VG': 4.92,
    'K-SI2-VG-POOR-STRONG-VG': 4.92,
    'K-I2-GOOD-VG-MEDIUM-VG': 4.92,
    'K-SI2-VG-EX-STRONG-GOOD': 4.92,
    'K-I2-VG-GOOD-MEDIUM-VG': 4.92,
    'L-SI2-GOOD-GOOD-MEDIUM-VG': 4.92,
    'L-SI2-POOR-VG-MEDIUM-VG': 4.92,
    'L-I2-EX-POOR-FAINT-VG': 4.92,
    'L-I2-EX-EX-FAINT-GOOD': 4.92,
    'L-SI2-VG-POOR-MEDIUM-VG': 4.92,
    'L-SI2-EX-VG-MEDIUM-GOOD': 4.92,
    'L-SI2-VG-EX-MEDIUM-GOOD': 4.92,
    'L-I2-VG-GOOD-FAINT-VG': 4.92,
    'L-I2-POOR-EX-FAINT-VG': 4.92,
    'L-I2-POOR-POOR-FAINT-EX': 4.92,
    'L-I2-GOOD-VG-FAINT-VG': 4.92,
    'M-SI2-VG-POOR-FAINT-VG': 4.92,
    'M-I2-EX-EX-NONE-GOOD': 4.92,
    'M-I2-EX-POOR-NONE-VG': 4.92,
    'M-I2-VG-GOOD-NONE-VG': 4.92,
    'M-I2-GOOD-VG-NONE-VG': 4.92,
    'M-I2-POOR-EX-NONE-VG': 4.92,
    'M-SI2-VG-EX-FAINT-GOOD': 4.92,
    'M-I2-POOR-POOR-NONE-EX': 4.92,
    'M-SI2-EX-VG-FAINT-GOOD': 4.92,
    'M-SI2-POOR-VG-FAINT-VG': 4.92,
    'M-SI2-GOOD-GOOD-FAINT-VG': 4.92,
    'G-VS2-EX-POOR-STRONG-POOR': 4.91,
    'G-VS2-GOOD-VG-STRONG-POOR': 4.91,
    'G-VS2-POOR-EX-STRONG-POOR': 4.91,
    'G-VS2-POOR-POOR-STRONG-GOOD': 4.91,
    'G-VS2-VG-GOOD-STRONG-POOR': 4.91,
    'H-VS2-VG-GOOD-MEDIUM-POOR': 4.91,
    'H-VS2-POOR-POOR-MEDIUM-GOOD': 4.91,
    'H-VS2-POOR-EX-MEDIUM-POOR': 4.91,
    'H-VS2-EX-POOR-MEDIUM-POOR': 4.91,
    'H-VVS2-VG-POOR-STRONG-POOR': 4.91,
    'H-VVS2-GOOD-GOOD-STRONG-POOR': 4.91,
    'H-VS2-GOOD-VG-MEDIUM-POOR': 4.91,
    'H-VVS2-POOR-VG-STRONG-POOR': 4.91,
    'I-VVS2-GOOD-GOOD-MEDIUM-POOR': 4.91,
    'I-VS2-EX-POOR-FAINT-POOR': 4.91,
    'I-VS2-GOOD-VG-FAINT-POOR': 4.91,
    'I-VS2-POOR-EX-FAINT-POOR': 4.91,
    'I-VVS2-VG-POOR-MEDIUM-POOR': 4.91,
    'I-VS2-VG-GOOD-FAINT-POOR': 4.91,
    'I-VVS2-POOR-VG-MEDIUM-POOR': 4.91,
    'I-VS2-POOR-POOR-FAINT-GOOD': 4.91,
    'J-VS2-EX-POOR-NONE-POOR': 4.91,
    'J-VVS2-GOOD-GOOD-FAINT-POOR': 4.91,
    'J-VVS2-POOR-VG-FAINT-POOR': 4.91,
    'J-VS2-POOR-EX-NONE-POOR': 4.91,
    'J-VS2-GOOD-VG-NONE-POOR': 4.91,
    'J-VS2-POOR-POOR-NONE-GOOD': 4.91,
    'J-VS2-VG-GOOD-NONE-POOR': 4.91,
    'J-VVS2-VG-POOR-FAINT-POOR': 4.91,
    'K-VVS2-POOR-VG-NONE-POOR': 4.91,
    'K-VVS2-GOOD-GOOD-NONE-POOR': 4.91,
    'K-VVS2-VG-POOR-NONE-POOR': 4.91,
    'L-VS2-GOOD-EX-STRONG-GOOD': 4.91,
    'L-VS2-EX-GOOD-STRONG-GOOD': 4.91,
    'L-VS2-GOOD-POOR-STRONG-VG': 4.91,
    'L-VS2-POOR-GOOD-STRONG-VG': 4.91,
    'L-VS2-VG-VG-STRONG-GOOD': 4.91,
    'M-VS2-VG-VG-MEDIUM-GOOD': 4.91,
    'M-VVS2-VG-GOOD-STRONG-GOOD': 4.91,
    'M-VS2-EX-GOOD-MEDIUM-GOOD': 4.91,
    'M-VVS2-GOOD-VG-STRONG-GOOD': 4.91,
    'M-VS2-POOR-GOOD-MEDIUM-VG': 4.91,
    'M-VS2-GOOD-EX-MEDIUM-GOOD': 4.91,
    'M-VVS2-POOR-EX-STRONG-GOOD': 4.91,
    'M-VVS2-EX-POOR-STRONG-GOOD': 4.91,
    'M-VVS2-POOR-POOR-STRONG-VG': 4.91,
    'M-VS2-GOOD-POOR-MEDIUM-VG': 4.91,
    'M-VVS2-EX-EX-STRONG-POOR': 4.91,
    'I-IF-POOR-GOOD-STRONG-POOR': 4.9,
    'I-IF-GOOD-POOR-STRONG-POOR': 4.9,
    'J-IF-POOR-GOOD-MEDIUM-POOR': 4.9,
    'J-IF-GOOD-POOR-MEDIUM-POOR': 4.9,
    'K-IF-GOOD-POOR-FAINT-POOR': 4.9,
    'K-IF-POOR-GOOD-FAINT-POOR': 4.9,
    'L-IF-GOOD-POOR-NONE-POOR': 4.9,
    'L-IF-POOR-GOOD-NONE-POOR': 4.9,
    'E-I1-VG-VG-STRONG-POOR': 4.89,
    'E-I1-GOOD-POOR-STRONG-GOOD': 4.89,
    'E-I1-GOOD-EX-STRONG-POOR': 4.89,
    'E-I1-POOR-GOOD-STRONG-GOOD': 4.89,
    'E-I1-EX-GOOD-STRONG-POOR': 4.89,
    'F-SI1-POOR-POOR-STRONG-GOOD': 4.89,
    'F-SI1-GOOD-VG-STRONG-POOR': 4.89,
    'F-SI1-EX-POOR-STRONG-POOR': 4.89,
    'F-I1-EX-GOOD-MEDIUM-POOR': 4.89,
    'F-SI1-VG-GOOD-STRONG-POOR': 4.89,
    'F-SI1-POOR-EX-STRONG-POOR': 4.89,
    'F-I1-GOOD-EX-MEDIUM-POOR': 4.89,
    'F-I1-VG-VG-MEDIUM-POOR': 4.89,
    'F-I1-POOR-GOOD-MEDIUM-GOOD': 4.89,
    'F-I1-GOOD-POOR-MEDIUM-GOOD': 4.89,
    'G-I1-POOR-GOOD-FAINT-GOOD': 4.89,
    'G-SI1-POOR-EX-MEDIUM-POOR': 4.89,
    'G-SI1-POOR-POOR-MEDIUM-GOOD': 4.89,
    'G-SI1-VG-GOOD-MEDIUM-POOR': 4.89,
    'G-SI1-EX-POOR-MEDIUM-POOR': 4.89,
    'G-I1-GOOD-EX-FAINT-POOR': 4.89,
    'G-I1-EX-GOOD-FAINT-POOR': 4.89,
    'G-I1-GOOD-POOR-FAINT-GOOD': 4.89,
    'G-I1-VG-VG-FAINT-POOR': 4.89,
    'G-SI1-GOOD-VG-MEDIUM-POOR': 4.89,
    'H-I1-POOR-GOOD-NONE-GOOD': 4.89,
    'H-SI1-POOR-POOR-FAINT-GOOD': 4.89,
    'H-SI1-GOOD-VG-FAINT-POOR': 4.89,
    'H-SI1-POOR-EX-FAINT-POOR': 4.89,
    'H-I1-GOOD-POOR-NONE-GOOD': 4.89,
    'H-I1-GOOD-EX-NONE-POOR': 4.89,
    'H-SI1-EX-POOR-FAINT-POOR': 4.89,
    'H-SI1-VG-GOOD-FAINT-POOR': 4.89,
    'H-I1-VG-VG-NONE-POOR': 4.89,
    'H-I1-EX-GOOD-NONE-POOR': 4.89,
    'I-SI1-POOR-EX-NONE-POOR': 4.89,
    'I-SI1-EX-POOR-NONE-POOR': 4.89,
    'I-SI1-GOOD-VG-NONE-POOR': 4.89,
    'I-SI1-POOR-POOR-NONE-GOOD': 4.89,
    'I-SI1-VG-GOOD-NONE-POOR': 4.89,
    'J-I1-GOOD-GOOD-STRONG-VG': 4.89,
    'J-I1-EX-VG-STRONG-GOOD': 4.89,
    'J-I1-VG-POOR-STRONG-VG': 4.89,
    'J-I1-POOR-VG-STRONG-VG': 4.89,
    'J-I1-VG-EX-STRONG-GOOD': 4.89,
    'K-SI1-VG-VG-STRONG-GOOD': 4.89,
    'K-SI1-POOR-GOOD-STRONG-VG': 4.89,
    'K-SI1-GOOD-EX-STRONG-GOOD': 4.89,
    'K-SI1-EX-GOOD-STRONG-GOOD': 4.89,
    'K-SI1-GOOD-POOR-STRONG-VG': 4.89,
    'K-I1-VG-POOR-MEDIUM-VG': 4.89,
    'K-I1-POOR-VG-MEDIUM-VG': 4.89,
    'K-I1-GOOD-GOOD-MEDIUM-VG': 4.89,
    'K-I1-VG-EX-MEDIUM-GOOD': 4.89,
    'K-I1-EX-VG-MEDIUM-GOOD': 4.89,
    'L-SI1-VG-VG-MEDIUM-GOOD': 4.89,
    'L-SI1-EX-GOOD-MEDIUM-GOOD': 4.89,
    'L-I1-POOR-VG-FAINT-VG': 4.89,
    'L-SI1-GOOD-POOR-MEDIUM-VG': 4.89,
    'L-I1-VG-EX-FAINT-GOOD': 4.89,
    'L-I1-VG-POOR-FAINT-VG': 4.89,
    'L-SI1-GOOD-EX-MEDIUM-GOOD': 4.89,
    'L-I1-EX-VG-FAINT-GOOD': 4.89,
    'L-I1-GOOD-GOOD-FAINT-VG': 4.89,
    'L-SI1-POOR-GOOD-MEDIUM-VG': 4.89,
    'M-SI1-POOR-GOOD-FAINT-VG': 4.89,
    'M-I1-VG-EX-NONE-GOOD': 4.89,
    'M-I1-EX-VG-NONE-GOOD': 4.89,
    'M-I1-POOR-VG-NONE-VG': 4.89,
    'M-SI1-GOOD-POOR-FAINT-VG': 4.89,
    'M-SI1-VG-VG-FAINT-GOOD': 4.89,
    'M-SI1-GOOD-EX-FAINT-GOOD': 4.89,
    'M-SI1-EX-GOOD-FAINT-GOOD': 4.89,
    'M-I1-VG-POOR-NONE-VG': 4.89,
    'M-I1-GOOD-GOOD-NONE-VG': 4.89,
    'G-VS1-POOR-VG-STRONG-POOR': 4.88,
    'G-VS1-GOOD-GOOD-STRONG-POOR': 4.88,
    'G-VS1-VG-POOR-STRONG-POOR': 4.88,
    'H-VS1-VG-POOR-MEDIUM-POOR': 4.88,
    'H-VVS1-GOOD-POOR-STRONG-POOR': 4.88,
    'H-VS1-GOOD-GOOD-MEDIUM-POOR': 4.88,
    'H-VS1-POOR-VG-MEDIUM-POOR': 4.88,
    'H-VVS1-POOR-GOOD-STRONG-POOR': 4.88,
    'I-VVS1-GOOD-POOR-MEDIUM-POOR': 4.88,
    'I-VVS1-POOR-GOOD-MEDIUM-POOR': 4.88,
    'I-VS1-POOR-VG-FAINT-POOR': 4.88,
    'I-VS1-GOOD-GOOD-FAINT-POOR': 4.88,
    'I-VS1-VG-POOR-FAINT-POOR': 4.88,
    'J-VS1-POOR-VG-NONE-POOR': 4.88,
    'J-VVS1-GOOD-POOR-FAINT-POOR': 4.88,
    'J-VS1-VG-POOR-NONE-POOR': 4.88,
    'J-VS1-GOOD-GOOD-NONE-POOR': 4.88,
    'J-VVS1-POOR-GOOD-FAINT-POOR': 4.88,
    'K-VVS1-POOR-GOOD-NONE-POOR': 4.88,
    'K-VVS1-GOOD-POOR-NONE-POOR': 4.88,
    'L-VS1-POOR-POOR-STRONG-VG': 4.88,
    'L-VS1-EX-POOR-STRONG-GOOD': 4.88,
    'L-VS1-VG-GOOD-STRONG-GOOD': 4.88,
    'L-VS1-EX-EX-STRONG-POOR': 4.88,
    'L-VS1-POOR-EX-STRONG-GOOD': 4.88,
    'L-VS1-GOOD-VG-STRONG-GOOD': 4.88,
    'M-VVS1-EX-VG-STRONG-POOR': 4.88,
    'M-VS1-EX-POOR-MEDIUM-GOOD': 4.88,
    'M-VS1-EX-EX-MEDIUM-POOR': 4.88,
    'M-VS1-POOR-POOR-MEDIUM-VG': 4.88,
    'M-VVS1-VG-POOR-STRONG-GOOD': 4.88,
    'M-VVS1-POOR-VG-STRONG-GOOD': 4.88,
    'M-VS1-GOOD-VG-MEDIUM-GOOD': 4.88,
    'M-VVS1-GOOD-GOOD-STRONG-GOOD': 4.88,
    'M-VVS1-VG-EX-STRONG-POOR': 4.88,
    'M-VS1-VG-GOOD-MEDIUM-GOOD': 4.88,
    'M-VS1-POOR-EX-MEDIUM-GOOD': 4.88,
    'D-I2-VG-VG-STRONG-POOR': 4.87,
    'D-I2-EX-GOOD-STRONG-POOR': 4.87,
    'D-I2-GOOD-EX-STRONG-POOR': 4.87,
    'D-I2-GOOD-POOR-STRONG-GOOD': 4.87,
    'D-I2-POOR-GOOD-STRONG-GOOD': 4.87,
    'E-SI2-GOOD-VG-STRONG-POOR': 4.87,
    'E-SI2-POOR-EX-STRONG-POOR': 4.87,
    'E-I2-POOR-GOOD-MEDIUM-GOOD': 4.87,
    'E-I2-GOOD-POOR-MEDIUM-GOOD': 4.87,
    'E-SI2-VG-GOOD-STRONG-POOR': 4.87,
    'E-I2-GOOD-EX-MEDIUM-POOR': 4.87,
    'E-I2-VG-VG-MEDIUM-POOR': 4.87,
    'E-I2-EX-GOOD-MEDIUM-POOR': 4.87,
    'E-SI2-POOR-POOR-STRONG-GOOD': 4.87,
    'E-SI2-EX-POOR-STRONG-POOR': 4.87,
    'F-SI2-GOOD-VG-MEDIUM-POOR': 4.87,
    'F-I2-VG-VG-FAINT-POOR': 4.87,
    'F-SI2-VG-GOOD-MEDIUM-POOR': 4.87,
    'F-SI2-EX-POOR-MEDIUM-POOR': 4.87,
    'F-SI2-POOR-EX-MEDIUM-POOR': 4.87,
    'F-I2-GOOD-POOR-FAINT-GOOD': 4.87,
    'F-I2-POOR-GOOD-FAINT-GOOD': 4.87,
    'F-SI2-POOR-POOR-MEDIUM-GOOD': 4.87,
    'F-I2-EX-GOOD-FAINT-POOR': 4.87,
    'F-I2-GOOD-EX-FAINT-POOR': 4.87,
    'G-I2-EX-GOOD-NONE-POOR': 4.87,
    'G-I2-VG-VG-NONE-POOR': 4.87,
    'G-SI2-POOR-POOR-FAINT-GOOD': 4.87,
    'G-I2-POOR-GOOD-NONE-GOOD': 4.87,
    'G-SI2-VG-GOOD-FAINT-POOR': 4.87,
    'G-SI2-EX-POOR-FAINT-POOR': 4.87,
    'G-SI2-GOOD-VG-FAINT-POOR': 4.87,
    'G-SI2-POOR-EX-FAINT-POOR': 4.87,
    'G-I2-GOOD-POOR-NONE-GOOD': 4.87,
    'G-I2-GOOD-EX-NONE-POOR': 4.87,
    'H-SI2-GOOD-VG-NONE-POOR': 4.87,
    'H-SI2-VG-GOOD-NONE-POOR': 4.87,
    'H-SI2-POOR-EX-NONE-POOR': 4.87,
    'H-SI2-EX-POOR-NONE-POOR': 4.87,
    'H-SI2-POOR-POOR-NONE-GOOD': 4.87,
    'I-I2-GOOD-GOOD-STRONG-VG': 4.87,
    'I-I2-POOR-VG-STRONG-VG': 4.87,
    'I-I2-VG-POOR-STRONG-VG': 4.87,
    'I-I2-VG-EX-STRONG-GOOD': 4.87,
    'I-I2-EX-VG-STRONG-GOOD': 4.87,
    'J-I2-POOR-VG-MEDIUM-VG': 4.87,
    'J-I2-GOOD-GOOD-MEDIUM-VG': 4.87,
    'J-SI2-EX-GOOD-STRONG-GOOD': 4.87,
    'J-SI2-VG-VG-STRONG-GOOD': 4.87,
    'J-I2-VG-POOR-MEDIUM-VG': 4.87,
    'J-SI2-GOOD-EX-STRONG-GOOD': 4.87,
    'J-SI2-GOOD-POOR-STRONG-VG': 4.87,
    'J-I2-EX-VG-MEDIUM-GOOD': 4.87,
    'J-I2-VG-EX-MEDIUM-GOOD': 4.87,
    'J-SI2-POOR-GOOD-STRONG-VG': 4.87,
    'K-I2-POOR-VG-FAINT-VG': 4.87,
    'K-I2-GOOD-GOOD-FAINT-VG': 4.87,
    'K-I2-VG-POOR-FAINT-VG': 4.87,
    'K-SI2-GOOD-EX-MEDIUM-GOOD': 4.87,
    'K-SI2-POOR-GOOD-MEDIUM-VG': 4.87,
    'K-SI2-GOOD-POOR-MEDIUM-VG': 4.87,
    'K-SI2-EX-GOOD-MEDIUM-GOOD': 4.87,
    'K-SI2-VG-VG-MEDIUM-GOOD': 4.87,
    'K-I2-VG-EX-FAINT-GOOD': 4.87,
    'K-I2-EX-VG-FAINT-GOOD': 4.87,
    'L-I2-VG-EX-NONE-GOOD': 4.87,
    'L-I2-GOOD-GOOD-NONE-VG': 4.87,
    'L-I2-EX-VG-NONE-GOOD': 4.87,
    'L-I2-VG-POOR-NONE-VG': 4.87,
    'L-I2-POOR-VG-NONE-VG': 4.87,
    'L-SI2-EX-GOOD-FAINT-GOOD': 4.87,
    'L-SI2-VG-VG-FAINT-GOOD': 4.87,
    'L-SI2-GOOD-EX-FAINT-GOOD': 4.87,
    'L-SI2-GOOD-POOR-FAINT-VG': 4.87,
    'L-SI2-POOR-GOOD-FAINT-VG': 4.87,
    'M-SI2-POOR-GOOD-NONE-VG': 4.87,
    'M-SI2-GOOD-POOR-NONE-VG': 4.87,
    'M-SI2-GOOD-EX-NONE-GOOD': 4.87,
    'M-SI2-VG-VG-NONE-GOOD': 4.87,
    'M-SI2-EX-GOOD-NONE-GOOD': 4.87,
    'F-VS2-POOR-VG-STRONG-POOR': 4.86,
    'F-VS2-VG-POOR-STRONG-POOR': 4.86,
    'F-VS2-GOOD-GOOD-STRONG-POOR': 4.86,
    'G-VS2-GOOD-GOOD-MEDIUM-POOR': 4.86,
    'G-VVS2-GOOD-POOR-STRONG-POOR': 4.86,
    'G-VVS2-POOR-GOOD-STRONG-POOR': 4.86,
    'G-VS2-POOR-VG-MEDIUM-POOR': 4.86,
    'G-VS2-VG-POOR-MEDIUM-POOR': 4.86,
    'H-VVS2-GOOD-POOR-MEDIUM-POOR': 4.86,
    'H-VVS2-POOR-GOOD-MEDIUM-POOR': 4.86,
    'H-VS2-GOOD-GOOD-FAINT-POOR': 4.86,
    'H-VS2-VG-POOR-FAINT-POOR': 4.86,
    'H-VS2-POOR-VG-FAINT-POOR': 4.86,
    'I-VS2-POOR-VG-NONE-POOR': 4.86,
    'I-VVS2-GOOD-POOR-FAINT-POOR': 4.86,
    'I-VS2-VG-POOR-NONE-POOR': 4.86,
    'I-VS2-GOOD-GOOD-NONE-POOR': 4.86,
    'I-VVS2-POOR-GOOD-FAINT-POOR': 4.86,
    'J-VVS2-POOR-GOOD-NONE-POOR': 4.86,
    'J-VVS2-GOOD-POOR-NONE-POOR': 4.86,
    'K-VS2-EX-POOR-STRONG-GOOD': 4.86,
    'K-VS2-EX-EX-STRONG-POOR': 4.86,
    'K-VS2-POOR-POOR-STRONG-VG': 4.86,
    'K-VS2-VG-GOOD-STRONG-GOOD': 4.86,
    'K-VS2-POOR-EX-STRONG-GOOD': 4.86,
    'K-VS2-GOOD-VG-STRONG-GOOD': 4.86,
    'L-VVS2-VG-POOR-STRONG-GOOD': 4.86,
    'L-VVS2-EX-VG-STRONG-POOR': 4.86,
    'L-VS2-POOR-POOR-MEDIUM-VG': 4.86,
    'L-VVS2-POOR-VG-STRONG-GOOD': 4.86,
    'L-VVS2-VG-EX-STRONG-POOR': 4.86,
    'L-VS2-EX-EX-MEDIUM-POOR': 4.86,
    'L-VS2-EX-POOR-MEDIUM-GOOD': 4.86,
    'L-VS2-VG-GOOD-MEDIUM-GOOD': 4.86,
    'L-VS2-GOOD-VG-MEDIUM-GOOD': 4.86,
    'L-VVS2-GOOD-GOOD-STRONG-GOOD': 4.86,
    'L-VS2-POOR-EX-MEDIUM-GOOD': 4.86,
    'M-VVS2-GOOD-GOOD-MEDIUM-GOOD': 4.86,
    'M-VVS2-VG-POOR-MEDIUM-GOOD': 4.86,
    'M-VVS2-POOR-VG-MEDIUM-GOOD': 4.86,
    'M-VS2-EX-EX-FAINT-POOR': 4.86,
    'M-VVS2-EX-VG-MEDIUM-POOR': 4.86,
    'M-VS2-POOR-EX-FAINT-GOOD': 4.86,
    'M-VS2-GOOD-VG-FAINT-GOOD': 4.86,
    'M-VS2-EX-POOR-FAINT-GOOD': 4.86,
    'M-VS2-VG-GOOD-FAINT-GOOD': 4.86,
    'M-VS2-POOR-POOR-FAINT-VG': 4.86,
    'M-VVS2-VG-EX-MEDIUM-POOR': 4.86,
    'H-IF-POOR-POOR-STRONG-POOR': 4.85,
    'I-IF-POOR-POOR-MEDIUM-POOR': 4.85,
    'J-IF-POOR-POOR-FAINT-POOR': 4.85,
    'K-IF-POOR-POOR-NONE-POOR': 4.85,
    'M-IF-GOOD-POOR-STRONG-GOOD': 4.85,
    'M-IF-GOOD-EX-STRONG-POOR': 4.85,
    'M-IF-POOR-GOOD-STRONG-GOOD': 4.85,
    'M-IF-EX-GOOD-STRONG-POOR': 4.85,
    'M-IF-VG-VG-STRONG-POOR': 4.85,
    'D-I1-GOOD-VG-STRONG-POOR': 4.84,
    'D-I1-VG-GOOD-STRONG-POOR': 4.84,
    'D-I1-POOR-EX-STRONG-POOR': 4.84,
    'D-I1-POOR-POOR-STRONG-GOOD': 4.84,
    'D-I1-EX-POOR-STRONG-POOR': 4.84,
    'E-I1-VG-GOOD-MEDIUM-POOR': 4.84,
    'E-SI1-POOR-VG-STRONG-POOR': 4.84,
    'E-I1-GOOD-VG-MEDIUM-POOR': 4.84,
    'E-I1-POOR-POOR-MEDIUM-GOOD': 4.84,
    'E-I1-EX-POOR-MEDIUM-POOR': 4.84,
    'E-I1-POOR-EX-MEDIUM-POOR': 4.84,
    'E-SI1-GOOD-GOOD-STRONG-POOR': 4.84,
    'E-SI1-VG-POOR-STRONG-POOR': 4.84,
    'F-I1-GOOD-VG-FAINT-POOR': 4.84,
    'F-I1-POOR-POOR-FAINT-GOOD': 4.84,
    'F-I1-VG-GOOD-FAINT-POOR': 4.84,
    'F-I1-POOR-EX-FAINT-POOR': 4.84,
    'F-I1-EX-POOR-FAINT-POOR': 4.84,
    'F-SI1-VG-POOR-MEDIUM-POOR': 4.84,
    'F-SI1-GOOD-GOOD-MEDIUM-POOR': 4.84,
    'F-SI1-POOR-VG-MEDIUM-POOR': 4.84,
    'G-I1-VG-GOOD-NONE-POOR': 4.84,
    'G-I1-POOR-EX-NONE-POOR': 4.84,
    'G-I1-EX-POOR-NONE-POOR': 4.84,
    'G-I1-GOOD-VG-NONE-POOR': 4.84,
    'G-SI1-VG-POOR-FAINT-POOR': 4.84,
    'G-SI1-GOOD-GOOD-FAINT-POOR': 4.84,
    'G-SI1-POOR-VG-FAINT-POOR': 4.84,
    'G-I1-POOR-POOR-NONE-GOOD': 4.84,
    'H-SI1-VG-POOR-NONE-POOR': 4.84,
    'H-SI1-GOOD-GOOD-NONE-POOR': 4.84,
    'H-SI1-POOR-VG-NONE-POOR': 4.84,
    'I-I1-GOOD-EX-STRONG-GOOD': 4.84,
    'I-I1-VG-VG-STRONG-GOOD': 4.84,
    'I-I1-EX-GOOD-STRONG-GOOD': 4.84,
    'I-I1-GOOD-POOR-STRONG-VG': 4.84,
    'I-I1-POOR-GOOD-STRONG-VG': 4.84,
    'J-SI1-EX-POOR-STRONG-GOOD': 4.84,
    'J-SI1-EX-EX-STRONG-POOR': 4.84,
    'J-SI1-POOR-EX-STRONG-GOOD': 4.84,
    'J-SI1-POOR-POOR-STRONG-VG': 4.84,
    'J-SI1-GOOD-VG-STRONG-GOOD': 4.84,
    'J-SI1-VG-GOOD-STRONG-GOOD': 4.84,
    'J-I1-POOR-GOOD-MEDIUM-VG': 4.84,
    'J-I1-GOOD-POOR-MEDIUM-VG': 4.84,
    'J-I1-VG-VG-MEDIUM-GOOD': 4.84,
    'J-I1-EX-GOOD-MEDIUM-GOOD': 4.84,
    'J-I1-GOOD-EX-MEDIUM-GOOD': 4.84,
    'K-I1-EX-GOOD-FAINT-GOOD': 4.84,
    'K-I1-VG-VG-FAINT-GOOD': 4.84,
    'K-I1-POOR-GOOD-FAINT-VG': 4.84,
    'K-I1-GOOD-POOR-FAINT-VG': 4.84,
    'K-I1-GOOD-EX-FAINT-GOOD': 4.84,
    'K-SI1-EX-EX-MEDIUM-POOR': 4.84,
    'K-SI1-POOR-POOR-MEDIUM-VG': 4.84,
    'K-SI1-EX-POOR-MEDIUM-GOOD': 4.84,
    'K-SI1-VG-GOOD-MEDIUM-GOOD': 4.84,
    'K-SI1-GOOD-VG-MEDIUM-GOOD': 4.84,
    'K-SI1-POOR-EX-MEDIUM-GOOD': 4.84,
    'L-I1-GOOD-EX-NONE-GOOD': 4.84,
    'L-I1-VG-VG-NONE-GOOD': 4.84,
    'L-I1-GOOD-POOR-NONE-VG': 4.84,
    'L-I1-POOR-GOOD-NONE-VG': 4.84,
    'L-I1-EX-GOOD-NONE-GOOD': 4.84,
    'L-SI1-EX-EX-FAINT-POOR': 4.84,
    'L-SI1-EX-POOR-FAINT-GOOD': 4.84,
    'L-SI1-VG-GOOD-FAINT-GOOD': 4.84,
    'L-SI1-GOOD-VG-FAINT-GOOD': 4.84,
    'L-SI1-POOR-EX-FAINT-GOOD': 4.84,
    'L-SI1-POOR-POOR-FAINT-VG': 4.84,
    'M-SI1-EX-EX-NONE-POOR': 4.84,
    'M-SI1-GOOD-VG-NONE-GOOD': 4.84,
    'M-SI1-VG-GOOD-NONE-GOOD': 4.84,
    'M-SI1-EX-POOR-NONE-GOOD': 4.84,
    'M-SI1-POOR-POOR-NONE-VG': 4.84,
    'M-SI1-POOR-EX-NONE-GOOD': 4.84,
    'F-VS1-POOR-GOOD-STRONG-POOR': 4.83,
    'F-VS1-GOOD-POOR-STRONG-POOR': 4.83,
    'G-VS1-POOR-GOOD-MEDIUM-POOR': 4.83,
    'G-VS1-GOOD-POOR-MEDIUM-POOR': 4.83,
    'G-VVS1-POOR-POOR-STRONG-POOR': 4.83,
    'H-VVS1-POOR-POOR-MEDIUM-POOR': 4.83,
    'H-VS1-GOOD-POOR-FAINT-POOR': 4.83,
    'H-VS1-POOR-GOOD-FAINT-POOR': 4.83,
    'I-VS1-GOOD-POOR-NONE-POOR': 4.83,
    'I-VVS1-POOR-POOR-FAINT-POOR': 4.83,
    'I-VS1-POOR-GOOD-NONE-POOR': 4.83,
    'J-VVS1-POOR-POOR-NONE-POOR': 4.83,
    'K-VS1-EX-VG-STRONG-POOR': 4.83,
    'K-VS1-GOOD-GOOD-STRONG-GOOD': 4.83,
    'K-VS1-POOR-VG-STRONG-GOOD': 4.83,
    'K-VS1-VG-EX-STRONG-POOR': 4.83,
    'K-VS1-VG-POOR-STRONG-GOOD': 4.83,
    'L-VS1-VG-EX-MEDIUM-POOR': 4.83,
    'L-VS1-VG-POOR-MEDIUM-GOOD': 4.83,
    'L-VS1-EX-VG-MEDIUM-POOR': 4.83,
    'L-VS1-POOR-VG-MEDIUM-GOOD': 4.83,
    'L-VS1-GOOD-GOOD-MEDIUM-GOOD': 4.83,
    'L-VVS1-POOR-GOOD-STRONG-GOOD': 4.83,
    'L-VVS1-GOOD-POOR-STRONG-GOOD': 4.83,
    'L-VVS1-GOOD-EX-STRONG-POOR': 4.83,
    'L-VVS1-VG-VG-STRONG-POOR': 4.83,
    'L-VVS1-EX-GOOD-STRONG-POOR': 4.83,
    'M-VS1-POOR-VG-FAINT-GOOD': 4.83,
    'M-VS1-VG-POOR-FAINT-GOOD': 4.83,
    'M-VVS1-POOR-GOOD-MEDIUM-GOOD': 4.83,
    'M-VS1-GOOD-GOOD-FAINT-GOOD': 4.83,
    'M-VS1-EX-VG-FAINT-POOR': 4.83,
    'M-VS1-VG-EX-FAINT-POOR': 4.83,
    'M-VVS1-GOOD-POOR-MEDIUM-GOOD': 4.83,
    'M-VVS1-GOOD-EX-MEDIUM-POOR': 4.83,
    'M-VVS1-EX-GOOD-MEDIUM-POOR': 4.83,
    'M-VVS1-VG-VG-MEDIUM-POOR': 4.83,
    'D-SI2-POOR-VG-STRONG-POOR': 4.82,
    'D-I2-GOOD-VG-MEDIUM-POOR': 4.82,
    'D-I2-EX-POOR-MEDIUM-POOR': 4.82,
    'D-I2-POOR-EX-MEDIUM-POOR': 4.82,
    'D-I2-POOR-POOR-MEDIUM-GOOD': 4.82,
    'D-SI2-VG-POOR-STRONG-POOR': 4.82,
    'D-I2-VG-GOOD-MEDIUM-POOR': 4.82,
    'D-SI2-GOOD-GOOD-STRONG-POOR': 4.82,
    'E-SI2-POOR-VG-MEDIUM-POOR': 4.82,
    'E-SI2-GOOD-GOOD-MEDIUM-POOR': 4.82,
    'E-I2-POOR-POOR-FAINT-GOOD': 4.82,
    'E-I2-EX-POOR-FAINT-POOR': 4.82,
    'E-I2-VG-GOOD-FAINT-POOR': 4.82,
    'E-I2-GOOD-VG-FAINT-POOR': 4.82,
    'E-SI2-VG-POOR-MEDIUM-POOR': 4.82,
    'E-I2-POOR-EX-FAINT-POOR': 4.82,
    'F-I2-GOOD-VG-NONE-POOR': 4.82,
    'F-I2-EX-POOR-NONE-POOR': 4.82,
    'F-SI2-POOR-VG-FAINT-POOR': 4.82,
    'F-SI2-GOOD-GOOD-FAINT-POOR': 4.82,
    'F-SI2-VG-POOR-FAINT-POOR': 4.82,
    'F-I2-POOR-POOR-NONE-GOOD': 4.82,
    'F-I2-POOR-EX-NONE-POOR': 4.82,
    'F-I2-VG-GOOD-NONE-POOR': 4.82,
    'G-SI2-POOR-VG-NONE-POOR': 4.82,
    'G-SI2-GOOD-GOOD-NONE-POOR': 4.82,
    'G-SI2-VG-POOR-NONE-POOR': 4.82,
    'H-I2-EX-GOOD-STRONG-GOOD': 4.82,
    'H-I2-GOOD-EX-STRONG-GOOD': 4.82,
    'H-I2-GOOD-POOR-STRONG-VG': 4.82,
    'H-I2-POOR-GOOD-STRONG-VG': 4.82,
    'H-I2-VG-VG-STRONG-GOOD': 4.82,
    'I-I2-GOOD-POOR-MEDIUM-VG': 4.82,
    'I-I2-GOOD-EX-MEDIUM-GOOD': 4.82,
    'I-I2-VG-VG-MEDIUM-GOOD': 4.82,
    'I-I2-EX-GOOD-MEDIUM-GOOD': 4.82,
    'I-I2-POOR-GOOD-MEDIUM-VG': 4.82,
    'I-SI2-GOOD-VG-STRONG-GOOD': 4.82,
    'I-SI2-VG-GOOD-STRONG-GOOD': 4.82,
    'I-SI2-EX-POOR-STRONG-GOOD': 4.82,
    'I-SI2-POOR-POOR-STRONG-VG': 4.82,
    'I-SI2-EX-EX-STRONG-POOR': 4.82,
    'I-SI2-POOR-EX-STRONG-GOOD': 4.82,
    'J-I2-POOR-GOOD-FAINT-VG': 4.82,
    'J-I2-GOOD-POOR-FAINT-VG': 4.82,
    'J-I2-GOOD-EX-FAINT-GOOD': 4.82,
    'J-I2-VG-VG-FAINT-GOOD': 4.82,
    'J-I2-EX-GOOD-FAINT-GOOD': 4.82,
    'J-SI2-POOR-EX-MEDIUM-GOOD': 4.82,
    'J-SI2-GOOD-VG-MEDIUM-GOOD': 4.82,
    'J-SI2-VG-GOOD-MEDIUM-GOOD': 4.82,
    'J-SI2-EX-POOR-MEDIUM-GOOD': 4.82,
    'J-SI2-EX-EX-MEDIUM-POOR': 4.82,
    'J-SI2-POOR-POOR-MEDIUM-VG': 4.82,
    'K-I2-EX-GOOD-NONE-GOOD': 4.82,
    'K-I2-VG-VG-NONE-GOOD': 4.82,
    'K-I2-POOR-GOOD-NONE-VG': 4.82,
    'K-I2-GOOD-POOR-NONE-VG': 4.82,
    'K-SI2-EX-EX-FAINT-POOR': 4.82,
    'K-SI2-POOR-POOR-FAINT-VG': 4.82,
    'K-SI2-POOR-EX-FAINT-GOOD': 4.82,
    'K-I2-GOOD-EX-NONE-GOOD': 4.82,
    'K-SI2-GOOD-VG-FAINT-GOOD': 4.82,
    'K-SI2-VG-GOOD-FAINT-GOOD': 4.82,
    'K-SI2-EX-POOR-FAINT-GOOD': 4.82,
    'L-SI2-GOOD-VG-NONE-GOOD': 4.82,
    'L-SI2-EX-EX-NONE-POOR': 4.82,
    'L-SI2-POOR-EX-NONE-GOOD': 4.82,
    'L-SI2-EX-POOR-NONE-GOOD': 4.82,
    'L-SI2-POOR-POOR-NONE-VG': 4.82,
    'L-SI2-VG-GOOD-NONE-GOOD': 4.82,
    'M-I2-VG-EX-STRONG-VG': 4.82,
    'M-I2-GOOD-GOOD-STRONG-EX': 4.82,
    'M-I2-POOR-VG-STRONG-EX': 4.82,
    'M-I2-VG-POOR-STRONG-EX': 4.82,
    'M-I2-EX-VG-STRONG-VG': 4.82,
    'E-VS2-GOOD-POOR-STRONG-POOR': 4.81,
    'E-VS2-POOR-GOOD-STRONG-POOR': 4.81,
    'F-VVS2-POOR-POOR-STRONG-POOR': 4.81,
    'F-VS2-GOOD-POOR-MEDIUM-POOR': 4.81,
    'F-VS2-POOR-GOOD-MEDIUM-POOR': 4.81,
    'G-VS2-GOOD-POOR-FAINT-POOR': 4.81,
    'G-VS2-POOR-GOOD-FAINT-POOR': 4.81,
    'G-VVS2-POOR-POOR-MEDIUM-POOR': 4.81,
    'H-VS2-POOR-GOOD-NONE-POOR': 4.81,
    'H-VS2-GOOD-POOR-NONE-POOR': 4.81,
    'H-VVS2-POOR-POOR-FAINT-POOR': 4.81,
    'I-VVS2-POOR-POOR-NONE-POOR': 4.81,
    'J-VS2-EX-VG-STRONG-POOR': 4.81,
    'J-VS2-VG-EX-STRONG-POOR': 4.81,
    'J-VS2-VG-POOR-STRONG-GOOD': 4.81,
    'J-VS2-GOOD-GOOD-STRONG-GOOD': 4.81,
    'J-VS2-POOR-VG-STRONG-GOOD': 4.81,
    'K-VS2-POOR-VG-MEDIUM-GOOD': 4.81,
    'K-VVS2-POOR-GOOD-STRONG-GOOD': 4.81,
    'K-VVS2-GOOD-POOR-STRONG-GOOD': 4.81,
    'K-VVS2-GOOD-EX-STRONG-POOR': 4.81,
    'K-VVS2-VG-VG-STRONG-POOR': 4.81,
    'K-VVS2-EX-GOOD-STRONG-POOR': 4.81,
    'K-VS2-EX-VG-MEDIUM-POOR': 4.81,
    'K-VS2-VG-EX-MEDIUM-POOR': 4.81,
    'K-VS2-VG-POOR-MEDIUM-GOOD': 4.81,
    'K-VS2-GOOD-GOOD-MEDIUM-GOOD': 4.81,
    'L-VVS2-EX-GOOD-MEDIUM-POOR': 4.81,
    'L-VVS2-VG-VG-MEDIUM-POOR': 4.81,
    'L-VVS2-GOOD-EX-MEDIUM-POOR': 4.81,
    'L-VS2-GOOD-GOOD-FAINT-GOOD': 4.81,
    'L-VS2-POOR-VG-FAINT-GOOD': 4.81,
    'L-VS2-VG-POOR-FAINT-GOOD': 4.81,
    'L-VVS2-GOOD-POOR-MEDIUM-GOOD': 4.81,
    'L-VVS2-POOR-GOOD-MEDIUM-GOOD': 4.81,
    'L-VS2-VG-EX-FAINT-POOR': 4.81,
    'L-VS2-EX-VG-FAINT-POOR': 4.81,
    'M-VS2-VG-POOR-NONE-GOOD': 4.81,
    'M-VVS2-EX-GOOD-FAINT-POOR': 4.81,
    'M-VS2-POOR-VG-NONE-GOOD': 4.81,
    'M-VS2-GOOD-GOOD-NONE-GOOD': 4.81,
    'M-VVS2-GOOD-POOR-FAINT-GOOD': 4.81,
    'M-VS2-VG-EX-NONE-POOR': 4.81,
    'M-VVS2-VG-VG-FAINT-POOR': 4.81,
    'M-VVS2-GOOD-EX-FAINT-POOR': 4.81,
    'M-VS2-EX-VG-NONE-POOR': 4.81,
    'M-VVS2-POOR-GOOD-FAINT-GOOD': 4.81,
    'L-IF-POOR-POOR-STRONG-GOOD': 4.8,
    'L-IF-POOR-EX-STRONG-POOR': 4.8,
    'L-IF-EX-POOR-STRONG-POOR': 4.8,
    'L-IF-VG-GOOD-STRONG-POOR': 4.8,
    'L-IF-GOOD-VG-STRONG-POOR': 4.8,
    'M-IF-GOOD-VG-MEDIUM-POOR': 4.8,
    'M-IF-VG-GOOD-MEDIUM-POOR': 4.8,
    'M-IF-POOR-EX-MEDIUM-POOR': 4.8,
    'M-IF-POOR-POOR-MEDIUM-GOOD': 4.8,
    'M-IF-EX-POOR-MEDIUM-POOR': 4.8,
    'D-I1-POOR-VG-MEDIUM-POOR': 4.79,
    'D-I1-VG-POOR-MEDIUM-POOR': 4.79,
    'D-I1-GOOD-GOOD-MEDIUM-POOR': 4.79,
    'D-SI1-GOOD-POOR-STRONG-POOR': 4.79,
    'D-SI1-POOR-GOOD-STRONG-POOR': 4.79,
    'E-I1-VG-POOR-FAINT-POOR': 4.79,
    'E-SI1-GOOD-POOR-MEDIUM-POOR': 4.79,
    'E-SI1-POOR-GOOD-MEDIUM-POOR': 4.79,
    'E-I1-GOOD-GOOD-FAINT-POOR': 4.79,
    'E-I1-POOR-VG-FAINT-POOR': 4.79,
    'F-I1-POOR-VG-NONE-POOR': 4.79,
    'F-I1-GOOD-GOOD-NONE-POOR': 4.79,
    'F-I1-VG-POOR-NONE-POOR': 4.79,
    'F-SI1-GOOD-POOR-FAINT-POOR': 4.79,
    'F-SI1-POOR-GOOD-FAINT-POOR': 4.79,
    'G-SI1-GOOD-POOR-NONE-POOR': 4.79,
    'G-SI1-POOR-GOOD-NONE-POOR': 4.79,
    'H-I1-EX-POOR-STRONG-GOOD': 4.79,
    'H-I1-EX-EX-STRONG-POOR': 4.79,
    'H-I1-POOR-POOR-STRONG-VG': 4.79,
    'H-I1-POOR-EX-STRONG-GOOD': 4.79,
    'H-I1-GOOD-VG-STRONG-GOOD': 4.79,
    'H-I1-VG-GOOD-STRONG-GOOD': 4.79,
    'I-SI1-EX-VG-STRONG-POOR': 4.79,
    'I-SI1-VG-EX-STRONG-POOR': 4.79,
    'I-SI1-VG-POOR-STRONG-GOOD': 4.79,
    'I-SI1-GOOD-GOOD-STRONG-GOOD': 4.79,
    'I-SI1-POOR-VG-STRONG-GOOD': 4.79,
    'I-I1-VG-GOOD-MEDIUM-GOOD': 4.79,
    'I-I1-POOR-POOR-MEDIUM-VG': 4.79,
    'I-I1-EX-EX-MEDIUM-POOR': 4.79,
    'I-I1-EX-POOR-MEDIUM-GOOD': 4.79,
    'I-I1-GOOD-VG-MEDIUM-GOOD': 4.79,
    'I-I1-POOR-EX-MEDIUM-GOOD': 4.79,
    'J-I1-EX-EX-FAINT-POOR': 4.79,
    'J-SI1-VG-EX-MEDIUM-POOR': 4.79,
    'J-SI1-EX-VG-MEDIUM-POOR': 4.79,
    'J-I1-EX-POOR-FAINT-GOOD': 4.79,
    'J-I1-VG-GOOD-FAINT-GOOD': 4.79,
    'J-I1-GOOD-VG-FAINT-GOOD': 4.79,
    'J-I1-POOR-EX-FAINT-GOOD': 4.79,
    'J-SI1-VG-POOR-MEDIUM-GOOD': 4.79,
    'J-SI1-GOOD-GOOD-MEDIUM-GOOD': 4.79,
    'J-I1-POOR-POOR-FAINT-VG': 4.79,
    'J-SI1-POOR-VG-MEDIUM-GOOD': 4.79,
    'K-I1-POOR-POOR-NONE-VG': 4.79,
    'K-I1-POOR-EX-NONE-GOOD': 4.79,
    'K-I1-EX-EX-NONE-POOR': 4.79,
    'K-I1-EX-POOR-NONE-GOOD': 4.79,
    'K-I1-VG-GOOD-NONE-GOOD': 4.79,
    'K-I1-GOOD-VG-NONE-GOOD': 4.79,
    'K-SI1-EX-VG-FAINT-POOR': 4.79,
    'K-SI1-VG-POOR-FAINT-GOOD': 4.79,
    'K-SI1-VG-EX-FAINT-POOR': 4.79,
    'K-SI1-GOOD-GOOD-FAINT-GOOD': 4.79,
    'K-SI1-POOR-VG-FAINT-GOOD': 4.79,
    'L-SI1-POOR-VG-NONE-GOOD': 4.79,
    'L-SI1-VG-POOR-NONE-GOOD': 4.79,
    'L-SI1-VG-EX-NONE-POOR': 4.79,
    'L-SI1-EX-VG-NONE-POOR': 4.79,
    'L-SI1-GOOD-GOOD-NONE-GOOD': 4.79,
    'M-I1-EX-GOOD-STRONG-VG': 4.79,
    'M-I1-GOOD-POOR-STRONG-EX': 4.79,
    'M-I1-POOR-GOOD-STRONG-EX': 4.79,
    'M-I1-VG-VG-STRONG-VG': 4.79,
    'M-I1-GOOD-EX-STRONG-VG': 4.79,
    'E-VS1-POOR-POOR-STRONG-POOR': 4.78,
    'F-VS1-POOR-POOR-MEDIUM-POOR': 4.78,
    'G-VS1-POOR-POOR-FAINT-POOR': 4.78,
    'H-VS1-POOR-POOR-NONE-POOR': 4.78,
    'J-VS1-EX-GOOD-STRONG-POOR': 4.78,
    'J-VS1-VG-VG-STRONG-POOR': 4.78,
    'J-VS1-GOOD-POOR-STRONG-GOOD': 4.78,
    'J-VS1-GOOD-EX-STRONG-POOR': 4.78,
    'J-VS1-POOR-GOOD-STRONG-GOOD': 4.78,
    'K-VS1-GOOD-POOR-MEDIUM-GOOD': 4.78,
    'K-VS1-POOR-GOOD-MEDIUM-GOOD': 4.78,
    'K-VVS1-POOR-EX-STRONG-POOR': 4.78,
    'K-VS1-GOOD-EX-MEDIUM-POOR': 4.78,
    'K-VVS1-POOR-POOR-STRONG-GOOD': 4.78,
    'K-VS1-EX-GOOD-MEDIUM-POOR': 4.78,
    'K-VS1-VG-VG-MEDIUM-POOR': 4.78,
    'K-VVS1-GOOD-VG-STRONG-POOR': 4.78,
    'K-VVS1-VG-GOOD-STRONG-POOR': 4.78,
    'K-VVS1-EX-POOR-STRONG-POOR': 4.78,
    'L-VVS1-EX-POOR-MEDIUM-POOR': 4.78,
    'L-VVS1-POOR-EX-MEDIUM-POOR': 4.78,
    'L-VVS1-VG-GOOD-MEDIUM-POOR': 4.78,
    'L-VVS1-GOOD-VG-MEDIUM-POOR': 4.78,
    'L-VVS1-POOR-POOR-MEDIUM-GOOD': 4.78,
    'L-VS1-GOOD-EX-FAINT-POOR': 4.78,
    'L-VS1-VG-VG-FAINT-POOR': 4.78,
    'L-VS1-POOR-GOOD-FAINT-GOOD': 4.78,
    'L-VS1-EX-GOOD-FAINT-POOR': 4.78,
    'L-VS1-GOOD-POOR-FAINT-GOOD': 4.78,
    'M-VVS1-EX-POOR-FAINT-POOR': 4.78,
    'M-VS1-GOOD-POOR-NONE-GOOD': 4.78,
    'M-VVS1-GOOD-VG-FAINT-POOR': 4.78,
    'M-VVS1-VG-GOOD-FAINT-POOR': 4.78,
    'M-VS1-POOR-GOOD-NONE-GOOD': 4.78,
    'M-VVS1-POOR-EX-FAINT-POOR': 4.78,
    'M-VS1-GOOD-EX-NONE-POOR': 4.78,
    'M-VS1-EX-GOOD-NONE-POOR': 4.78,
    'M-VS1-VG-VG-NONE-POOR': 4.78,
    'M-VVS1-POOR-POOR-FAINT-GOOD': 4.78,
    'D-SI2-GOOD-POOR-MEDIUM-POOR': 4.77,
    'D-I2-GOOD-GOOD-FAINT-POOR': 4.77,
    'D-SI2-POOR-GOOD-MEDIUM-POOR': 4.77,
    'D-I2-VG-POOR-FAINT-POOR': 4.77,
    'D-I2-POOR-VG-FAINT-POOR': 4.77,
    'E-I2-POOR-VG-NONE-POOR': 4.77,
    'E-I2-GOOD-GOOD-NONE-POOR': 4.77,
    'E-I2-VG-POOR-NONE-POOR': 4.77,
    'E-SI2-POOR-GOOD-FAINT-POOR': 4.77,
    'E-SI2-GOOD-POOR-FAINT-POOR': 4.77,
    'F-SI2-GOOD-POOR-NONE-POOR': 4.77,
    'F-SI2-POOR-GOOD-NONE-POOR': 4.77,
    'G-I2-VG-GOOD-STRONG-GOOD': 4.77,
    'G-I2-GOOD-VG-STRONG-GOOD': 4.77,
    'G-I2-POOR-POOR-STRONG-VG': 4.77,
    'G-I2-POOR-EX-STRONG-GOOD': 4.77,
    'G-I2-EX-POOR-STRONG-GOOD': 4.77,
    'G-I2-EX-EX-STRONG-POOR': 4.77,
    'H-SI2-VG-EX-STRONG-POOR': 4.77,
    'H-SI2-EX-VG-STRONG-POOR': 4.77,
    'H-SI2-VG-POOR-STRONG-GOOD': 4.77,
    'H-I2-POOR-POOR-MEDIUM-VG': 4.77,
    'H-I2-EX-EX-MEDIUM-POOR': 4.77,
    'H-I2-POOR-EX-MEDIUM-GOOD': 4.77,
    'H-I2-GOOD-VG-MEDIUM-GOOD': 4.77,
    'H-SI2-POOR-VG-STRONG-GOOD': 4.77,
    'H-I2-EX-POOR-MEDIUM-GOOD': 4.77,
    'H-SI2-GOOD-GOOD-STRONG-GOOD': 4.77,
    'H-I2-VG-GOOD-MEDIUM-GOOD': 4.77,
    'I-SI2-VG-POOR-MEDIUM-GOOD': 4.77,
    'I-SI2-GOOD-GOOD-MEDIUM-GOOD': 4.77,
    'I-SI2-POOR-VG-MEDIUM-GOOD': 4.77,
    'I-SI2-EX-VG-MEDIUM-POOR': 4.77,
    'I-SI2-VG-EX-MEDIUM-POOR': 4.77,
    'I-I2-EX-POOR-FAINT-GOOD': 4.77,
    'I-I2-POOR-EX-FAINT-GOOD': 4.77,
    'I-I2-GOOD-VG-FAINT-GOOD': 4.77,
    'I-I2-EX-EX-FAINT-POOR': 4.77,
    'I-I2-VG-GOOD-FAINT-GOOD': 4.77,
    'I-I2-POOR-POOR-FAINT-VG': 4.77,
    'J-SI2-GOOD-GOOD-FAINT-GOOD': 4.77,
    'J-SI2-POOR-VG-FAINT-GOOD': 4.77,
    'J-SI2-VG-POOR-FAINT-GOOD': 4.77,
    'J-SI2-VG-EX-FAINT-POOR': 4.77,
    'J-SI2-EX-VG-FAINT-POOR': 4.77,
    'J-I2-EX-POOR-NONE-GOOD': 4.77,
    'J-I2-EX-EX-NONE-POOR': 4.77,
    'J-I2-POOR-EX-NONE-GOOD': 4.77,
    'J-I2-POOR-POOR-NONE-VG': 4.77,
    'J-I2-VG-GOOD-NONE-GOOD': 4.77,
    'J-I2-GOOD-VG-NONE-GOOD': 4.77,
    'K-SI2-VG-EX-NONE-POOR': 4.77,
    'K-SI2-EX-VG-NONE-POOR': 4.77,
    'K-SI2-VG-POOR-NONE-GOOD': 4.77,
    'K-SI2-GOOD-GOOD-NONE-GOOD': 4.77,
    'K-SI2-POOR-VG-NONE-GOOD': 4.77,
    'L-I2-VG-VG-STRONG-VG': 4.77,
    'L-I2-GOOD-EX-STRONG-VG': 4.77,
    'L-I2-EX-GOOD-STRONG-VG': 4.77,
    'L-I2-POOR-GOOD-STRONG-EX': 4.77,
    'L-I2-GOOD-POOR-STRONG-EX': 4.77,
    'M-I2-EX-GOOD-MEDIUM-VG': 4.77,
    'M-I2-POOR-GOOD-MEDIUM-EX': 4.77,
    'M-I2-GOOD-POOR-MEDIUM-EX': 4.77,
    'M-I2-GOOD-EX-MEDIUM-VG': 4.77,
    'M-SI2-EX-EX-STRONG-GOOD': 4.77,
    'M-I2-VG-VG-MEDIUM-VG': 4.77,
    'M-SI2-EX-POOR-STRONG-VG': 4.77,
    'M-SI2-VG-GOOD-STRONG-VG': 4.77,
    'M-SI2-GOOD-VG-STRONG-VG': 4.77,
    'M-SI2-POOR-EX-STRONG-VG': 4.77,
    'M-SI2-POOR-POOR-STRONG-EX': 4.77,
    'D-VS2-POOR-POOR-STRONG-POOR': 4.76,
    'E-VS2-POOR-POOR-MEDIUM-POOR': 4.76,
    'F-VS2-POOR-POOR-FAINT-POOR': 4.76,
    'G-VS2-POOR-POOR-NONE-POOR': 4.76,
    'I-VS2-EX-GOOD-STRONG-POOR': 4.76,
    'I-VS2-VG-VG-STRONG-POOR': 4.76,
    'I-VS2-GOOD-EX-STRONG-POOR': 4.76,
    'I-VS2-GOOD-POOR-STRONG-GOOD': 4.76,
    'I-VS2-POOR-GOOD-STRONG-GOOD': 4.76,
    'J-VS2-POOR-GOOD-MEDIUM-GOOD': 4.76,
    'J-VVS2-POOR-EX-STRONG-POOR': 4.76,
    'J-VVS2-GOOD-VG-STRONG-POOR': 4.76,
    'J-VVS2-VG-GOOD-STRONG-POOR': 4.76,
    'J-VVS2-POOR-POOR-STRONG-GOOD': 4.76,
    'J-VVS2-EX-POOR-STRONG-POOR': 4.76,
    'J-VS2-EX-GOOD-MEDIUM-POOR': 4.76,
    'J-VS2-VG-VG-MEDIUM-POOR': 4.76,
    'J-VS2-GOOD-POOR-MEDIUM-GOOD': 4.76,
    'J-VS2-GOOD-EX-MEDIUM-POOR': 4.76,
    'K-VS2-EX-GOOD-FAINT-POOR': 4.76,
    'K-VVS2-POOR-EX-MEDIUM-POOR': 4.76,
    'K-VS2-GOOD-EX-FAINT-POOR': 4.76,
    'K-VS2-GOOD-POOR-FAINT-GOOD': 4.76,
    'K-VS2-VG-VG-FAINT-POOR': 4.76,
    'K-VS2-POOR-GOOD-FAINT-GOOD': 4.76,
    'K-VVS2-GOOD-VG-MEDIUM-POOR': 4.76,
    'K-VVS2-POOR-POOR-MEDIUM-GOOD': 4.76,
    'K-VVS2-VG-GOOD-MEDIUM-POOR': 4.76,
    'K-VVS2-EX-POOR-MEDIUM-POOR': 4.76,
    'L-VVS2-GOOD-VG-FAINT-POOR': 4.76,
    'L-VS2-POOR-GOOD-NONE-GOOD': 4.76,
    'L-VVS2-EX-POOR-FAINT-POOR': 4.76,
    'L-VVS2-POOR-POOR-FAINT-GOOD': 4.76,
    'L-VS2-EX-GOOD-NONE-POOR': 4.76,
    'L-VS2-VG-VG-NONE-POOR': 4.76,
    'L-VS2-GOOD-EX-NONE-POOR': 4.76,
    'L-VVS2-VG-GOOD-FAINT-POOR': 4.76,
    'L-VS2-GOOD-POOR-NONE-GOOD': 4.76,
    'L-VVS2-POOR-EX-FAINT-POOR': 4.76,
    'M-VVS2-VG-GOOD-NONE-POOR': 4.76,
    'M-VVS2-POOR-POOR-NONE-GOOD': 4.76,
    'M-VVS2-POOR-EX-NONE-POOR': 4.76,
    'M-VVS2-GOOD-VG-NONE-POOR': 4.76,
    'M-VVS2-EX-POOR-NONE-POOR': 4.76,
    'K-IF-POOR-VG-STRONG-POOR': 4.75,
    'K-IF-GOOD-GOOD-STRONG-POOR': 4.75,
    'K-IF-VG-POOR-STRONG-POOR': 4.75,
    'L-IF-VG-POOR-MEDIUM-POOR': 4.75,
    'L-IF-GOOD-GOOD-MEDIUM-POOR': 4.75,
    'L-IF-POOR-VG-MEDIUM-POOR': 4.75,
    'M-IF-VG-POOR-FAINT-POOR': 4.75,
    'M-IF-GOOD-GOOD-FAINT-POOR': 4.75,
    'M-IF-POOR-VG-FAINT-POOR': 4.75,
    'D-SI1-POOR-POOR-MEDIUM-POOR': 4.74,
    'D-I1-GOOD-POOR-FAINT-POOR': 4.74,
    'D-I1-POOR-GOOD-FAINT-POOR': 4.74,
    'E-I1-GOOD-POOR-NONE-POOR': 4.74,
    'E-I1-POOR-GOOD-NONE-POOR': 4.74,
    'E-SI1-POOR-POOR-FAINT-POOR': 4.74,
    'F-SI1-POOR-POOR-NONE-POOR': 4.74,
    'G-I1-GOOD-GOOD-STRONG-GOOD': 4.74,
    'G-I1-EX-VG-STRONG-POOR': 4.74,
    'G-I1-VG-EX-STRONG-POOR': 4.74,
    'G-I1-POOR-VG-STRONG-GOOD': 4.74,
    'G-I1-VG-POOR-STRONG-GOOD': 4.74,
    'H-SI1-GOOD-EX-STRONG-POOR': 4.74,
    'H-SI1-POOR-GOOD-STRONG-GOOD': 4.74,
    'H-SI1-GOOD-POOR-STRONG-GOOD': 4.74,
    'H-I1-VG-POOR-MEDIUM-GOOD': 4.74,
    'H-I1-EX-VG-MEDIUM-POOR': 4.74,
    'H-I1-VG-EX-MEDIUM-POOR': 4.74,
    'H-I1-GOOD-GOOD-MEDIUM-GOOD': 4.74,
    'H-I1-POOR-VG-MEDIUM-GOOD': 4.74,
    'H-SI1-VG-VG-STRONG-POOR': 4.74,
    'H-SI1-EX-GOOD-STRONG-POOR': 4.74,
    'I-SI1-GOOD-EX-MEDIUM-POOR': 4.74,
    'I-I1-EX-VG-FAINT-POOR': 4.74,
    'I-SI1-POOR-GOOD-MEDIUM-GOOD': 4.74,
    'I-SI1-GOOD-POOR-MEDIUM-GOOD': 4.74,
    'I-SI1-VG-VG-MEDIUM-POOR': 4.74,
    'I-SI1-EX-GOOD-MEDIUM-POOR': 4.74,
    'I-I1-VG-EX-FAINT-POOR': 4.74,
    'I-I1-POOR-VG-FAINT-GOOD': 4.74,
    'I-I1-GOOD-GOOD-FAINT-GOOD': 4.74,
    'I-I1-VG-POOR-FAINT-GOOD': 4.74,
    'J-I1-EX-VG-NONE-POOR': 4.74,
    'J-I1-VG-EX-NONE-POOR': 4.74,
    'J-I1-VG-POOR-NONE-GOOD': 4.74,
    'J-I1-POOR-VG-NONE-GOOD': 4.74,
    'J-I1-GOOD-GOOD-NONE-GOOD': 4.74,
    'J-SI1-GOOD-POOR-FAINT-GOOD': 4.74,
    'J-SI1-POOR-GOOD-FAINT-GOOD': 4.74,
    'J-SI1-VG-VG-FAINT-POOR': 4.74,
    'J-SI1-GOOD-EX-FAINT-POOR': 4.74,
    'J-SI1-EX-GOOD-FAINT-POOR': 4.74,
    'K-SI1-POOR-GOOD-NONE-GOOD': 4.74,
    'K-SI1-GOOD-POOR-NONE-GOOD': 4.74,
    'K-SI1-GOOD-EX-NONE-POOR': 4.74,
    'K-SI1-EX-GOOD-NONE-POOR': 4.74,
    'K-SI1-VG-VG-NONE-POOR': 4.74,
    'L-I1-EX-POOR-STRONG-VG': 4.74,
    'L-I1-EX-EX-STRONG-GOOD': 4.74,
    'L-I1-VG-GOOD-STRONG-VG': 4.74,
    'L-I1-GOOD-VG-STRONG-VG': 4.74,
    'L-I1-POOR-POOR-STRONG-EX': 4.74,
    'L-I1-POOR-EX-STRONG-VG': 4.74,
    'M-SI1-VG-EX-STRONG-GOOD': 4.74,
    'M-SI1-VG-POOR-STRONG-VG': 4.74,
    'M-SI1-GOOD-GOOD-STRONG-VG': 4.74,
    'M-SI1-POOR-VG-STRONG-VG': 4.74,
    'M-I1-EX-EX-MEDIUM-GOOD': 4.74,
    'M-I1-EX-POOR-MEDIUM-VG': 4.74,
    'M-SI1-EX-VG-STRONG-GOOD': 4.74,
    'M-I1-VG-GOOD-MEDIUM-VG': 4.74,
    'M-I1-POOR-EX-MEDIUM-VG': 4.74,
    'M-I1-GOOD-VG-MEDIUM-VG': 4.74,
    'M-I1-POOR-POOR-MEDIUM-EX': 4.74,
    'I-VS1-POOR-EX-STRONG-POOR': 4.73,
    'I-VS1-EX-POOR-STRONG-POOR': 4.73,
    'I-VS1-VG-GOOD-STRONG-POOR': 4.73,
    'I-VS1-GOOD-VG-STRONG-POOR': 4.73,
    'I-VS1-POOR-POOR-STRONG-GOOD': 4.73,
    'J-VS1-GOOD-VG-MEDIUM-POOR': 4.73,
    'J-VVS1-VG-POOR-STRONG-POOR': 4.73,
    'J-VS1-VG-GOOD-MEDIUM-POOR': 4.73,
    'J-VVS1-POOR-VG-STRONG-POOR': 4.73,
    'J-VS1-POOR-EX-MEDIUM-POOR': 4.73,
    'J-VS1-POOR-POOR-MEDIUM-GOOD': 4.73,
    'J-VVS1-GOOD-GOOD-STRONG-POOR': 4.73,
    'J-VS1-EX-POOR-MEDIUM-POOR': 4.73,
    'K-VS1-POOR-EX-FAINT-POOR': 4.73,
    'K-VS1-EX-POOR-FAINT-POOR': 4.73,
    'K-VS1-POOR-POOR-FAINT-GOOD': 4.73,
    'K-VVS1-VG-POOR-MEDIUM-POOR': 4.73,
    'K-VS1-VG-GOOD-FAINT-POOR': 4.73,
    'K-VS1-GOOD-VG-FAINT-POOR': 4.73,
    'K-VVS1-POOR-VG-MEDIUM-POOR': 4.73,
    'K-VVS1-GOOD-GOOD-MEDIUM-POOR': 4.73,
    'L-VS1-EX-POOR-NONE-POOR': 4.73,
    'L-VVS1-GOOD-GOOD-FAINT-POOR': 4.73,
    'L-VVS1-POOR-VG-FAINT-POOR': 4.73,
    'L-VVS1-VG-POOR-FAINT-POOR': 4.73,
    'L-VS1-VG-GOOD-NONE-POOR': 4.73,
    'L-VS1-GOOD-VG-NONE-POOR': 4.73,
    'L-VS1-POOR-EX-NONE-POOR': 4.73,
    'L-VS1-POOR-POOR-NONE-GOOD': 4.73,
    'M-VVS1-VG-POOR-NONE-POOR': 4.73,
    'M-VVS1-POOR-VG-NONE-POOR': 4.73,
    'M-VVS1-GOOD-GOOD-NONE-POOR': 4.73,
    'D-I2-GOOD-POOR-NONE-POOR': 4.72,
    'D-SI2-POOR-POOR-FAINT-POOR': 4.72,
    'D-I2-POOR-GOOD-NONE-POOR': 4.72,
    'E-SI2-POOR-POOR-NONE-POOR': 4.72,
    'F-I2-POOR-VG-STRONG-GOOD': 4.72,
    'F-I2-VG-EX-STRONG-POOR': 4.72,
    'F-I2-EX-VG-STRONG-POOR': 4.72,
    'F-I2-VG-POOR-STRONG-GOOD': 4.72,
    'F-I2-GOOD-GOOD-STRONG-GOOD': 4.72,
    'G-I2-GOOD-GOOD-MEDIUM-GOOD': 4.72,
    'G-I2-VG-POOR-MEDIUM-GOOD': 4.72,
    'G-I2-VG-EX-MEDIUM-POOR': 4.72,
    'G-SI2-POOR-GOOD-STRONG-GOOD': 4.72,
    'G-I2-EX-VG-MEDIUM-POOR': 4.72,
    'G-SI2-GOOD-EX-STRONG-POOR': 4.72,
    'G-SI2-GOOD-POOR-STRONG-GOOD': 4.72,
    'G-SI2-VG-VG-STRONG-POOR': 4.72,
    'G-SI2-EX-GOOD-STRONG-POOR': 4.72,
    'G-I2-POOR-VG-MEDIUM-GOOD': 4.72,
    'H-I2-VG-EX-FAINT-POOR': 4.72,
    'H-I2-EX-VG-FAINT-POOR': 4.72,
    'H-I2-VG-POOR-FAINT-GOOD': 4.72,
    'H-SI2-VG-VG-MEDIUM-POOR': 4.72,
    'H-SI2-GOOD-POOR-MEDIUM-GOOD': 4.72,
    'H-SI2-POOR-GOOD-MEDIUM-GOOD': 4.72,
    'H-I2-GOOD-GOOD-FAINT-GOOD': 4.72,
    'H-I2-POOR-VG-FAINT-GOOD': 4.72,
    'H-SI2-EX-GOOD-MEDIUM-POOR': 4.72,
    'H-SI2-GOOD-EX-MEDIUM-POOR': 4.72,
    'I-I2-EX-VG-NONE-POOR': 4.72,
    'I-I2-GOOD-GOOD-NONE-GOOD': 4.72,
    'I-I2-POOR-VG-NONE-GOOD': 4.72,
    'I-I2-VG-EX-NONE-POOR': 4.72,
    'I-SI2-GOOD-EX-FAINT-POOR': 4.72,
    'I-SI2-VG-VG-FAINT-POOR': 4.72,
    'I-SI2-EX-GOOD-FAINT-POOR': 4.72,
    'I-SI2-POOR-GOOD-FAINT-GOOD': 4.72,
    'I-SI2-GOOD-POOR-FAINT-GOOD': 4.72,
    'I-I2-VG-POOR-NONE-GOOD': 4.72,
    'J-SI2-POOR-GOOD-NONE-GOOD': 4.72,
    'J-SI2-EX-GOOD-NONE-POOR': 4.72,
    'J-SI2-GOOD-POOR-NONE-GOOD': 4.72,
    'J-SI2-GOOD-EX-NONE-POOR': 4.72,
    'J-SI2-VG-VG-NONE-POOR': 4.72,
    'K-I2-EX-POOR-STRONG-VG': 4.72,
    'K-I2-POOR-EX-STRONG-VG': 4.72,
    'K-I2-VG-GOOD-STRONG-VG': 4.72,
    'K-I2-GOOD-VG-STRONG-VG': 4.72,
    'K-I2-EX-EX-STRONG-GOOD': 4.72,
    'K-I2-POOR-POOR-STRONG-EX': 4.72,
    'L-I2-POOR-EX-MEDIUM-VG': 4.72,
    'L-SI2-GOOD-GOOD-STRONG-VG': 4.72,
    'L-SI2-VG-POOR-STRONG-VG': 4.72,
    'L-I2-EX-EX-MEDIUM-GOOD': 4.72,
    'L-SI2-POOR-VG-STRONG-VG': 4.72,
    'L-SI2-VG-EX-STRONG-GOOD': 4.72,
    'L-I2-VG-GOOD-MEDIUM-VG': 4.72,
    'L-I2-POOR-POOR-MEDIUM-EX': 4.72,
    'L-I2-GOOD-VG-MEDIUM-VG': 4.72,
    'L-I2-EX-POOR-MEDIUM-VG': 4.72,
    'L-SI2-EX-VG-STRONG-GOOD': 4.72,
    'M-I2-EX-POOR-FAINT-VG': 4.72,
    'M-I2-VG-GOOD-FAINT-VG': 4.72,
    'M-I2-POOR-EX-FAINT-VG': 4.72,
    'M-I2-GOOD-VG-FAINT-VG': 4.72,
    'M-I2-EX-EX-FAINT-GOOD': 4.72,
    'M-I2-POOR-POOR-FAINT-EX': 4.72,
    'M-SI2-VG-EX-MEDIUM-GOOD': 4.72,
    'M-SI2-EX-VG-MEDIUM-GOOD': 4.72,
    'M-SI2-POOR-VG-MEDIUM-VG': 4.72,
    'M-SI2-GOOD-GOOD-MEDIUM-VG': 4.72,
    'M-SI2-VG-POOR-MEDIUM-VG': 4.72,
    'H-VS2-POOR-EX-STRONG-POOR': 4.71,
    'H-VS2-VG-GOOD-STRONG-POOR': 4.71,
    'H-VS2-EX-POOR-STRONG-POOR': 4.71,
    'H-VS2-POOR-POOR-STRONG-GOOD': 4.71,
    'H-VS2-GOOD-VG-STRONG-POOR': 4.71,
    'I-VS2-POOR-POOR-MEDIUM-GOOD': 4.71,
    'I-VVS2-VG-POOR-STRONG-POOR': 4.71,
    'I-VVS2-POOR-VG-STRONG-POOR': 4.71,
    'I-VVS2-GOOD-GOOD-STRONG-POOR': 4.71,
    'I-VS2-POOR-EX-MEDIUM-POOR': 4.71,
    'I-VS2-GOOD-VG-MEDIUM-POOR': 4.71,
    'I-VS2-VG-GOOD-MEDIUM-POOR': 4.71,
    'I-VS2-EX-POOR-MEDIUM-POOR': 4.71,
    'J-VVS2-GOOD-GOOD-MEDIUM-POOR': 4.71,
    'J-VVS2-POOR-VG-MEDIUM-POOR': 4.71,
    'J-VS2-EX-POOR-FAINT-POOR': 4.71,
    'J-VS2-VG-GOOD-FAINT-POOR': 4.71,
    'J-VS2-POOR-POOR-FAINT-GOOD': 4.71,
    'J-VS2-GOOD-VG-FAINT-POOR': 4.71,
    'J-VS2-POOR-EX-FAINT-POOR': 4.71,
    'J-VVS2-VG-POOR-MEDIUM-POOR': 4.71,
    'K-VS2-VG-GOOD-NONE-POOR': 4.71,
    'K-VS2-POOR-EX-NONE-POOR': 4.71,
    'K-VS2-GOOD-VG-NONE-POOR': 4.71,
    'K-VS2-POOR-POOR-NONE-GOOD': 4.71,
    'K-VS2-EX-POOR-NONE-POOR': 4.71,
    'K-VVS2-GOOD-GOOD-FAINT-POOR': 4.71,
    'K-VVS2-POOR-VG-FAINT-POOR': 4.71,
    'K-VVS2-VG-POOR-FAINT-POOR': 4.71,
    'L-VVS2-GOOD-GOOD-NONE-POOR': 4.71,
    'L-VVS2-POOR-VG-NONE-POOR': 4.71,
    'L-VVS2-VG-POOR-NONE-POOR': 4.71,
    'M-VS2-POOR-GOOD-STRONG-VG': 4.71,
    'M-VS2-GOOD-EX-STRONG-GOOD': 4.71,
    'M-VS2-GOOD-POOR-STRONG-VG': 4.71,
    'M-VS2-EX-GOOD-STRONG-GOOD': 4.71,
    'M-VS2-VG-VG-STRONG-GOOD': 4.71,
    'J-IF-GOOD-POOR-STRONG-POOR': 4.7,
    'J-IF-POOR-GOOD-STRONG-POOR': 4.7,
    'K-IF-GOOD-POOR-MEDIUM-POOR': 4.7,
    'K-IF-POOR-GOOD-MEDIUM-POOR': 4.7,
    'L-IF-POOR-GOOD-FAINT-POOR': 4.7,
    'L-IF-GOOD-POOR-FAINT-POOR': 4.7,
    'M-IF-GOOD-POOR-NONE-POOR': 4.7,
    'M-IF-POOR-GOOD-NONE-POOR': 4.7,
    'D-I1-POOR-POOR-NONE-POOR': 4.69,
    'F-I1-POOR-GOOD-STRONG-GOOD': 4.69,
    'F-I1-GOOD-POOR-STRONG-GOOD': 4.69,
    'F-I1-EX-GOOD-STRONG-POOR': 4.69,
    'F-I1-VG-VG-STRONG-POOR': 4.69,
    'F-I1-GOOD-EX-STRONG-POOR': 4.69,
    'G-SI1-POOR-POOR-STRONG-GOOD': 4.69,
    'G-I1-GOOD-POOR-MEDIUM-GOOD': 4.69,
    'G-I1-POOR-GOOD-MEDIUM-GOOD': 4.69,
    'G-I1-VG-VG-MEDIUM-POOR': 4.69,
    'G-SI1-EX-POOR-STRONG-POOR': 4.69,
    'G-I1-GOOD-EX-MEDIUM-POOR': 4.69,
    'G-I1-EX-GOOD-MEDIUM-POOR': 4.69,
    'G-SI1-POOR-EX-STRONG-POOR': 4.69,
    'G-SI1-VG-GOOD-STRONG-POOR': 4.69,
    'G-SI1-GOOD-VG-STRONG-POOR': 4.69,
    'H-I1-GOOD-EX-FAINT-POOR': 4.69,
    'H-I1-VG-VG-FAINT-POOR': 4.69,
    'H-I1-GOOD-POOR-FAINT-GOOD': 4.69,
    'H-I1-POOR-GOOD-FAINT-GOOD': 4.69,
    'H-I1-EX-GOOD-FAINT-POOR': 4.69,
    'H-SI1-POOR-EX-MEDIUM-POOR': 4.69,
    'H-SI1-GOOD-VG-MEDIUM-POOR': 4.69,
    'H-SI1-POOR-POOR-MEDIUM-GOOD': 4.69,
    'H-SI1-EX-POOR-MEDIUM-POOR': 4.69,
    'H-SI1-VG-GOOD-MEDIUM-POOR': 4.69,
    'I-I1-POOR-GOOD-NONE-GOOD': 4.69,
    'I-SI1-VG-GOOD-FAINT-POOR': 4.69,
    'I-SI1-POOR-EX-FAINT-POOR': 4.69,
    'I-SI1-GOOD-VG-FAINT-POOR': 4.69,
    'I-I1-VG-VG-NONE-POOR': 4.69,
    'I-I1-GOOD-POOR-NONE-GOOD': 4.69,
    'I-I1-EX-GOOD-NONE-POOR': 4.69,
    'I-SI1-POOR-POOR-FAINT-GOOD': 4.69,
    'I-I1-GOOD-EX-NONE-POOR': 4.69,
    'I-SI1-EX-POOR-FAINT-POOR': 4.69,
    'J-SI1-POOR-EX-NONE-POOR': 4.69,
    'J-SI1-GOOD-VG-NONE-POOR': 4.69,
    'J-SI1-POOR-POOR-NONE-GOOD': 4.69,
    'J-SI1-EX-POOR-NONE-POOR': 4.69,
    'J-SI1-VG-GOOD-NONE-POOR': 4.69,
    'K-I1-POOR-VG-STRONG-VG': 4.69,
    'K-I1-GOOD-GOOD-STRONG-VG': 4.69,
    'K-I1-VG-POOR-STRONG-VG': 4.69,
    'K-I1-EX-VG-STRONG-GOOD': 4.69,
    'K-I1-VG-EX-STRONG-GOOD': 4.69,
    'L-I1-POOR-VG-MEDIUM-VG': 4.69,
    'L-SI1-GOOD-POOR-STRONG-VG': 4.69,
    'L-SI1-POOR-GOOD-STRONG-VG': 4.69,
    'L-SI1-VG-VG-STRONG-GOOD': 4.69,
    'L-SI1-EX-GOOD-STRONG-GOOD': 4.69,
    'L-SI1-GOOD-EX-STRONG-GOOD': 4.69,
    'L-I1-GOOD-GOOD-MEDIUM-VG': 4.69,
    'L-I1-VG-POOR-MEDIUM-VG': 4.69,
    'L-I1-VG-EX-MEDIUM-GOOD': 4.69,
    'L-I1-EX-VG-MEDIUM-GOOD': 4.69,
    'M-I1-VG-EX-FAINT-GOOD': 4.69,
    'M-SI1-POOR-GOOD-MEDIUM-VG': 4.69,
    'M-I1-EX-VG-FAINT-GOOD': 4.69,
    'M-SI1-GOOD-POOR-MEDIUM-VG': 4.69,
    'M-I1-POOR-VG-FAINT-VG': 4.69,
    'M-SI1-VG-VG-MEDIUM-GOOD': 4.69,
    'M-I1-VG-POOR-FAINT-VG': 4.69,
    'M-SI1-EX-GOOD-MEDIUM-GOOD': 4.69,
    'M-I1-GOOD-GOOD-FAINT-VG': 4.69,
    'M-SI1-GOOD-EX-MEDIUM-GOOD': 4.69,
    'H-VS1-GOOD-GOOD-STRONG-POOR': 4.68,
    'H-VS1-VG-POOR-STRONG-POOR': 4.68,
    'H-VS1-POOR-VG-STRONG-POOR': 4.68,
    'I-VVS1-GOOD-POOR-STRONG-POOR': 4.68,
    'I-VVS1-POOR-GOOD-STRONG-POOR': 4.68,
    'I-VS1-GOOD-GOOD-MEDIUM-POOR': 4.68,
    'I-VS1-VG-POOR-MEDIUM-POOR': 4.68,
    'I-VS1-POOR-VG-MEDIUM-POOR': 4.68,
    'J-VS1-GOOD-GOOD-FAINT-POOR': 4.68,
    'J-VS1-VG-POOR-FAINT-POOR': 4.68,
    'J-VVS1-GOOD-POOR-MEDIUM-POOR': 4.68,
    'J-VVS1-POOR-GOOD-MEDIUM-POOR': 4.68,
    'J-VS1-POOR-VG-FAINT-POOR': 4.68,
    'K-VVS1-POOR-GOOD-FAINT-POOR': 4.68,
    'K-VS1-GOOD-GOOD-NONE-POOR': 4.68,
    'K-VS1-POOR-VG-NONE-POOR': 4.68,
    'K-VVS1-GOOD-POOR-FAINT-POOR': 4.68,
    'K-VS1-VG-POOR-NONE-POOR': 4.68,
    'L-VVS1-POOR-GOOD-NONE-POOR': 4.68,
    'L-VVS1-GOOD-POOR-NONE-POOR': 4.68,
    'M-VS1-POOR-POOR-STRONG-VG': 4.68,
    'M-VS1-POOR-EX-STRONG-GOOD': 4.68,
    'M-VS1-EX-POOR-STRONG-GOOD': 4.68,
    'M-VS1-VG-GOOD-STRONG-GOOD': 4.68,
    'M-VS1-GOOD-VG-STRONG-GOOD': 4.68,
    'M-VS1-EX-EX-STRONG-POOR': 4.68,
    'E-I2-EX-GOOD-STRONG-POOR': 4.67,
    'E-I2-GOOD-EX-STRONG-POOR': 4.67,
    'E-I2-VG-VG-STRONG-POOR': 4.67,
    'E-I2-GOOD-POOR-STRONG-GOOD': 4.67,
    'E-I2-POOR-GOOD-STRONG-GOOD': 4.67,
    'F-I2-POOR-GOOD-MEDIUM-GOOD': 4.67,
    'F-I2-GOOD-EX-MEDIUM-POOR': 4.67,
    'F-I2-EX-GOOD-MEDIUM-POOR': 4.67,
    'F-SI2-POOR-EX-STRONG-POOR': 4.67,
    'F-I2-VG-VG-MEDIUM-POOR': 4.67,
    'F-SI2-GOOD-VG-STRONG-POOR': 4.67,
    'F-SI2-VG-GOOD-STRONG-POOR': 4.67,
    'F-SI2-EX-POOR-STRONG-POOR': 4.67,
    'F-I2-GOOD-POOR-MEDIUM-GOOD': 4.67,
    'F-SI2-POOR-POOR-STRONG-GOOD': 4.67,
    'G-SI2-VG-GOOD-MEDIUM-POOR': 4.67,
    'G-SI2-GOOD-VG-MEDIUM-POOR': 4.67,
    'G-I2-POOR-GOOD-FAINT-GOOD': 4.67,
    'G-I2-GOOD-POOR-FAINT-GOOD': 4.67,
    'G-SI2-POOR-POOR-MEDIUM-GOOD': 4.67,
    'G-SI2-POOR-EX-MEDIUM-POOR': 4.67,
    'G-SI2-EX-POOR-MEDIUM-POOR': 4.67,
    'G-I2-VG-VG-FAINT-POOR': 4.67,
    'G-I2-GOOD-EX-FAINT-POOR': 4.67,
    'G-I2-EX-GOOD-FAINT-POOR': 4.67,
    'H-SI2-POOR-POOR-FAINT-GOOD': 4.67,
    'H-I2-POOR-GOOD-NONE-GOOD': 4.67,
    'H-SI2-EX-POOR-FAINT-POOR': 4.67,
    'H-SI2-VG-GOOD-FAINT-POOR': 4.67,
    'H-SI2-GOOD-VG-FAINT-POOR': 4.67,
    'H-SI2-POOR-EX-FAINT-POOR': 4.67,
    'H-I2-GOOD-POOR-NONE-GOOD': 4.67,
    'H-I2-EX-GOOD-NONE-POOR': 4.67,
    'H-I2-GOOD-EX-NONE-POOR': 4.67,
    'H-I2-VG-VG-NONE-POOR': 4.67,
    'I-SI2-GOOD-VG-NONE-POOR': 4.67,
    'I-SI2-POOR-EX-NONE-POOR': 4.67,
    'I-SI2-POOR-POOR-NONE-GOOD': 4.67,
    'I-SI2-VG-GOOD-NONE-POOR': 4.67,
    'I-SI2-EX-POOR-NONE-POOR': 4.67,
    'J-I2-POOR-VG-STRONG-VG': 4.67,
    'J-I2-GOOD-GOOD-STRONG-VG': 4.67,
    'J-I2-VG-POOR-STRONG-VG': 4.67,
    'J-I2-VG-EX-STRONG-GOOD': 4.67,
    'J-I2-EX-VG-STRONG-GOOD': 4.67,
    'K-SI2-POOR-GOOD-STRONG-VG': 4.67,
    'K-I2-VG-EX-MEDIUM-GOOD': 4.67,
    'K-I2-EX-VG-MEDIUM-GOOD': 4.67,
    'K-SI2-GOOD-POOR-STRONG-VG': 4.67,
    'K-I2-GOOD-GOOD-MEDIUM-VG': 4.67,
    'K-I2-POOR-VG-MEDIUM-VG': 4.67,
    'K-SI2-GOOD-EX-STRONG-GOOD': 4.67,
    'K-SI2-EX-GOOD-STRONG-GOOD': 4.67,
    'K-I2-VG-POOR-MEDIUM-VG': 4.67,
    'K-SI2-VG-VG-STRONG-GOOD': 4.67,
    'L-I2-VG-POOR-FAINT-VG': 4.67,
    'L-I2-VG-EX-FAINT-GOOD': 4.67,
    'L-I2-EX-VG-FAINT-GOOD': 4.67,
    'L-I2-GOOD-GOOD-FAINT-VG': 4.67,
    'L-SI2-EX-GOOD-MEDIUM-GOOD': 4.67,
    'L-SI2-VG-VG-MEDIUM-GOOD': 4.67,
    'L-SI2-GOOD-EX-MEDIUM-GOOD': 4.67,
    'L-I2-POOR-VG-FAINT-VG': 4.67,
    'L-SI2-GOOD-POOR-MEDIUM-VG': 4.67,
    'L-SI2-POOR-GOOD-MEDIUM-VG': 4.67,
    'M-I2-GOOD-GOOD-NONE-VG': 4.67,
    'M-I2-VG-POOR-NONE-VG': 4.67,
    'M-I2-EX-VG-NONE-GOOD': 4.67,
    'M-I2-VG-EX-NONE-GOOD': 4.67,
    'M-SI2-EX-GOOD-FAINT-GOOD': 4.67,
    'M-SI2-VG-VG-FAINT-GOOD': 4.67,
    'M-I2-POOR-VG-NONE-VG': 4.67,
    'M-SI2-GOOD-EX-FAINT-GOOD': 4.67,
    'M-SI2-GOOD-POOR-FAINT-VG': 4.67,
    'M-SI2-POOR-GOOD-FAINT-VG': 4.67,
    'G-VS2-POOR-VG-STRONG-POOR': 4.66,
    'G-VS2-VG-POOR-STRONG-POOR': 4.66,
    'G-VS2-GOOD-GOOD-STRONG-POOR': 4.66,
    'H-VVS2-POOR-GOOD-STRONG-POOR': 4.66,
    'H-VVS2-GOOD-POOR-STRONG-POOR': 4.66,
    'H-VS2-GOOD-GOOD-MEDIUM-POOR': 4.66,
    'H-VS2-POOR-VG-MEDIUM-POOR': 4.66,
    'H-VS2-VG-POOR-MEDIUM-POOR': 4.66,
    'I-VVS2-POOR-GOOD-MEDIUM-POOR': 4.66,
    'I-VS2-POOR-VG-FAINT-POOR': 4.66,
    'I-VS2-VG-POOR-FAINT-POOR': 4.66,
    'I-VS2-GOOD-GOOD-FAINT-POOR': 4.66,
    'I-VVS2-GOOD-POOR-MEDIUM-POOR': 4.66,
    'J-VVS2-POOR-GOOD-FAINT-POOR': 4.66,
    'J-VVS2-GOOD-POOR-FAINT-POOR': 4.66,
    'J-VS2-GOOD-GOOD-NONE-POOR': 4.66,
    'J-VS2-POOR-VG-NONE-POOR': 4.66,
    'J-VS2-VG-POOR-NONE-POOR': 4.66,
    'K-VVS2-POOR-GOOD-NONE-POOR': 4.66,
    'K-VVS2-GOOD-POOR-NONE-POOR': 4.66,
    'L-VS2-POOR-POOR-STRONG-VG': 4.66,
    'L-VS2-GOOD-VG-STRONG-GOOD': 4.66,
    'L-VS2-VG-GOOD-STRONG-GOOD': 4.66,
    'L-VS2-EX-EX-STRONG-POOR': 4.66,
    'L-VS2-POOR-EX-STRONG-GOOD': 4.66,
    'L-VS2-EX-POOR-STRONG-GOOD': 4.66,
    'M-VVS2-VG-EX-STRONG-POOR': 4.66,
    'M-VVS2-EX-VG-STRONG-POOR': 4.66,
    'M-VVS2-VG-POOR-STRONG-GOOD': 4.66,
    'M-VVS2-POOR-VG-STRONG-GOOD': 4.66,
    'M-VVS2-GOOD-GOOD-STRONG-GOOD': 4.66,
    'M-VS2-VG-GOOD-MEDIUM-GOOD': 4.66,
    'M-VS2-GOOD-VG-MEDIUM-GOOD': 4.66,
    'M-VS2-POOR-EX-MEDIUM-GOOD': 4.66,
    'M-VS2-POOR-POOR-MEDIUM-VG': 4.66,
    'M-VS2-EX-EX-MEDIUM-POOR': 4.66,
    'M-VS2-EX-POOR-MEDIUM-GOOD': 4.66,
    'I-IF-POOR-POOR-STRONG-POOR': 4.65,
    'J-IF-POOR-POOR-MEDIUM-POOR': 4.65,
    'K-IF-POOR-POOR-FAINT-POOR': 4.65,
    'L-IF-POOR-POOR-NONE-POOR': 4.65,
    'E-I1-EX-POOR-STRONG-POOR': 4.64,
    'E-I1-VG-GOOD-STRONG-POOR': 4.64,
    'E-I1-POOR-POOR-STRONG-GOOD': 4.64,
    'E-I1-GOOD-VG-STRONG-POOR': 4.64,
    'E-I1-POOR-EX-STRONG-POOR': 4.64,
    'F-I1-POOR-POOR-MEDIUM-GOOD': 4.64,
    'F-SI1-POOR-VG-STRONG-POOR': 4.64,
    'F-SI1-GOOD-GOOD-STRONG-POOR': 4.64,
    'F-SI1-VG-POOR-STRONG-POOR': 4.64,
    'F-I1-POOR-EX-MEDIUM-POOR': 4.64,
    'F-I1-VG-GOOD-MEDIUM-POOR': 4.64,
    'F-I1-EX-POOR-MEDIUM-POOR': 4.64,
    'F-I1-GOOD-VG-MEDIUM-POOR': 4.64,
    'G-I1-GOOD-VG-FAINT-POOR': 4.64,
    'G-I1-VG-GOOD-FAINT-POOR': 4.64,
    'G-I1-POOR-EX-FAINT-POOR': 4.64,
    'G-I1-POOR-POOR-FAINT-GOOD': 4.64,
    'G-I1-EX-POOR-FAINT-POOR': 4.64,
    'G-SI1-POOR-VG-MEDIUM-POOR': 4.64,
    'G-SI1-VG-POOR-MEDIUM-POOR': 4.64,
    'G-SI1-GOOD-GOOD-MEDIUM-POOR': 4.64,
    'H-SI1-VG-POOR-FAINT-POOR': 4.64,
    'H-I1-POOR-POOR-NONE-GOOD': 4.64,
    'H-I1-POOR-EX-NONE-POOR': 4.64,
    'H-I1-GOOD-VG-NONE-POOR': 4.64,
    'H-I1-VG-GOOD-NONE-POOR': 4.64,
    'H-I1-EX-POOR-NONE-POOR': 4.64,
    'H-SI1-GOOD-GOOD-FAINT-POOR': 4.64,
    'H-SI1-POOR-VG-FAINT-POOR': 4.64,
    'I-SI1-VG-POOR-NONE-POOR': 4.64,
    'I-SI1-GOOD-GOOD-NONE-POOR': 4.64,
    'I-SI1-POOR-VG-NONE-POOR': 4.64,
    'J-I1-EX-GOOD-STRONG-GOOD': 4.64,
    'J-I1-POOR-GOOD-STRONG-VG': 4.64,
    'J-I1-GOOD-POOR-STRONG-VG': 4.64,
    'J-I1-GOOD-EX-STRONG-GOOD': 4.64,
    'J-I1-VG-VG-STRONG-GOOD': 4.64,
    'K-SI1-POOR-POOR-STRONG-VG': 4.64,
    'K-I1-EX-GOOD-MEDIUM-GOOD': 4.64,
    'K-I1-VG-VG-MEDIUM-GOOD': 4.64,
    'K-I1-GOOD-EX-MEDIUM-GOOD': 4.64,
    'K-I1-GOOD-POOR-MEDIUM-VG': 4.64,
    'K-I1-POOR-GOOD-MEDIUM-VG': 4.64,
    'K-SI1-POOR-EX-STRONG-GOOD': 4.64,
    'K-SI1-EX-POOR-STRONG-GOOD': 4.64,
    'K-SI1-VG-GOOD-STRONG-GOOD': 4.64,
    'K-SI1-GOOD-VG-STRONG-GOOD': 4.64,
    'K-SI1-EX-EX-STRONG-POOR': 4.64,
    'L-I1-EX-GOOD-FAINT-GOOD': 4.64,
    'L-I1-VG-VG-FAINT-GOOD': 4.64,
    'L-I1-GOOD-EX-FAINT-GOOD': 4.64,
    'L-I1-GOOD-POOR-FAINT-VG': 4.64,
    'L-I1-POOR-GOOD-FAINT-VG': 4.64,
    'L-SI1-VG-GOOD-MEDIUM-GOOD': 4.64,
    'L-SI1-GOOD-VG-MEDIUM-GOOD': 4.64,
    'L-SI1-POOR-EX-MEDIUM-GOOD': 4.64,
    'L-SI1-POOR-POOR-MEDIUM-VG': 4.64,
    'L-SI1-EX-POOR-MEDIUM-GOOD': 4.64,
    'L-SI1-EX-EX-MEDIUM-POOR': 4.64,
    'M-I1-EX-GOOD-NONE-GOOD': 4.64,
    'M-I1-VG-VG-NONE-GOOD': 4.64,
    'M-I1-GOOD-EX-NONE-GOOD': 4.64,
    'M-I1-GOOD-POOR-NONE-VG': 4.64,
    'M-I1-POOR-GOOD-NONE-VG': 4.64,
    'M-SI1-POOR-EX-FAINT-GOOD': 4.64,
    'M-SI1-EX-EX-FAINT-POOR': 4.64,
    'M-SI1-EX-POOR-FAINT-GOOD': 4.64,
    'M-SI1-VG-GOOD-FAINT-GOOD': 4.64,
    'M-SI1-POOR-POOR-FAINT-VG': 4.64,
    'M-SI1-GOOD-VG-FAINT-GOOD': 4.64,
    'G-VS1-POOR-GOOD-STRONG-POOR': 4.63,
    'G-VS1-GOOD-POOR-STRONG-POOR': 4.63,
    'H-VS1-GOOD-POOR-MEDIUM-POOR': 4.63,
    'H-VS1-POOR-GOOD-MEDIUM-POOR': 4.63,
    'H-VVS1-POOR-POOR-STRONG-POOR': 4.63,
    'I-VVS1-POOR-POOR-MEDIUM-POOR': 4.63,
    'I-VS1-GOOD-POOR-FAINT-POOR': 4.63,
    'I-VS1-POOR-GOOD-FAINT-POOR': 4.63,
    'J-VS1-POOR-GOOD-NONE-POOR': 4.63,
    'J-VS1-GOOD-POOR-NONE-POOR': 4.63,
    'J-VVS1-POOR-POOR-FAINT-POOR': 4.63,
    'K-VVS1-POOR-POOR-NONE-POOR': 4.63,
    'L-VS1-GOOD-GOOD-STRONG-GOOD': 4.63,
    'L-VS1-VG-POOR-STRONG-GOOD': 4.63,
    'L-VS1-VG-EX-STRONG-POOR': 4.63,
    'L-VS1-EX-VG-STRONG-POOR': 4.63,
    'L-VS1-POOR-VG-STRONG-GOOD': 4.63,
    'M-VVS1-GOOD-POOR-STRONG-GOOD': 4.63,
    'M-VVS1-GOOD-EX-STRONG-POOR': 4.63,
    'M-VVS1-VG-VG-STRONG-POOR': 4.63,
    'M-VVS1-POOR-GOOD-STRONG-GOOD': 4.63,
    'M-VVS1-EX-GOOD-STRONG-POOR': 4.63,
    'M-VS1-GOOD-GOOD-MEDIUM-GOOD': 4.63,
    'M-VS1-EX-VG-MEDIUM-POOR': 4.63,
    'M-VS1-VG-EX-MEDIUM-POOR': 4.63,
    'M-VS1-POOR-VG-MEDIUM-GOOD': 4.63,
    'M-VS1-VG-POOR-MEDIUM-GOOD': 4.63,
    'D-I2-GOOD-VG-STRONG-POOR': 4.62,
    'D-I2-POOR-POOR-STRONG-GOOD': 4.62,
    'D-I2-EX-POOR-STRONG-POOR': 4.62,
    'D-I2-POOR-EX-STRONG-POOR': 4.62,
    'D-I2-VG-GOOD-STRONG-POOR': 4.62,
    'E-SI2-GOOD-GOOD-STRONG-POOR': 4.62,
    'E-SI2-VG-POOR-STRONG-POOR': 4.62,
    'E-SI2-POOR-VG-STRONG-POOR': 4.62,
    'E-I2-VG-GOOD-MEDIUM-POOR': 4.62,
    'E-I2-EX-POOR-MEDIUM-POOR': 4.62,
    'E-I2-GOOD-VG-MEDIUM-POOR': 4.62,
    'E-I2-POOR-EX-MEDIUM-POOR': 4.62,
    'E-I2-POOR-POOR-MEDIUM-GOOD': 4.62,
    'F-SI2-VG-POOR-MEDIUM-POOR': 4.62,
    'F-I2-VG-GOOD-FAINT-POOR': 4.62,
    'F-SI2-GOOD-GOOD-MEDIUM-POOR': 4.62,
    'F-I2-POOR-EX-FAINT-POOR': 4.62,
    'F-SI2-POOR-VG-MEDIUM-POOR': 4.62,
    'F-I2-POOR-POOR-FAINT-GOOD': 4.62,
    'F-I2-GOOD-VG-FAINT-POOR': 4.62,
    'F-I2-EX-POOR-FAINT-POOR': 4.62,
    'G-I2-POOR-POOR-NONE-GOOD': 4.62,
    'G-I2-POOR-EX-NONE-POOR': 4.62,
    'G-SI2-VG-POOR-FAINT-POOR': 4.62,
    'G-I2-GOOD-VG-NONE-POOR': 4.62,
    'G-I2-EX-POOR-NONE-POOR': 4.62,
    'G-SI2-GOOD-GOOD-FAINT-POOR': 4.62,
    'G-I2-VG-GOOD-NONE-POOR': 4.62,
    'G-SI2-POOR-VG-FAINT-POOR': 4.62,
    'H-SI2-VG-POOR-NONE-POOR': 4.62,
    'H-SI2-GOOD-GOOD-NONE-POOR': 4.62,
    'H-SI2-POOR-VG-NONE-POOR': 4.62,
    'I-I2-GOOD-POOR-STRONG-VG': 4.62,
    'I-I2-EX-GOOD-STRONG-GOOD': 4.62,
    'I-I2-POOR-GOOD-STRONG-VG': 4.62,
    'I-I2-GOOD-EX-STRONG-GOOD': 4.62,
    'I-I2-VG-VG-STRONG-GOOD': 4.62,
    'J-SI2-EX-POOR-STRONG-GOOD': 4.62,
    'J-SI2-POOR-POOR-STRONG-VG': 4.62,
    'J-SI2-POOR-EX-STRONG-GOOD': 4.62,
    'J-SI2-GOOD-VG-STRONG-GOOD': 4.62,
    'J-SI2-VG-GOOD-STRONG-GOOD': 4.62,
    'J-SI2-EX-EX-STRONG-POOR': 4.62,
    'J-I2-POOR-GOOD-MEDIUM-VG': 4.62,
    'J-I2-GOOD-POOR-MEDIUM-VG': 4.62,
    'J-I2-GOOD-EX-MEDIUM-GOOD': 4.62,
    'J-I2-VG-VG-MEDIUM-GOOD': 4.62,
    'J-I2-EX-GOOD-MEDIUM-GOOD': 4.62,
    'K-SI2-EX-EX-MEDIUM-POOR': 4.62,
    'K-I2-VG-VG-FAINT-GOOD': 4.62,
    'K-SI2-EX-POOR-MEDIUM-GOOD': 4.62,
    'K-I2-GOOD-POOR-FAINT-VG': 4.62,
    'K-I2-EX-GOOD-FAINT-GOOD': 4.62,
    'K-I2-GOOD-EX-FAINT-GOOD': 4.62,
    'K-SI2-POOR-POOR-MEDIUM-VG': 4.62,
    'K-SI2-POOR-EX-MEDIUM-GOOD': 4.62,
    'K-SI2-GOOD-VG-MEDIUM-GOOD': 4.62,
    'K-SI2-VG-GOOD-MEDIUM-GOOD': 4.62,
    'K-I2-POOR-GOOD-FAINT-VG': 4.62,
    'L-SI2-GOOD-VG-FAINT-GOOD': 4.62,
    'L-SI2-VG-GOOD-FAINT-GOOD': 4.62,
    'L-I2-POOR-GOOD-NONE-VG': 4.62,
    'L-SI2-POOR-POOR-FAINT-VG': 4.62,
    'L-I2-GOOD-EX-NONE-GOOD': 4.62,
    'L-SI2-EX-EX-FAINT-POOR': 4.62,
    'L-SI2-EX-POOR-FAINT-GOOD': 4.62,
    'L-I2-VG-VG-NONE-GOOD': 4.62,
    'L-I2-EX-GOOD-NONE-GOOD': 4.62,
    'L-I2-GOOD-POOR-NONE-VG': 4.62,
    'L-SI2-POOR-EX-FAINT-GOOD': 4.62,
    'M-SI2-VG-GOOD-NONE-GOOD': 4.62,
    'M-SI2-GOOD-VG-NONE-GOOD': 4.62,
    'M-SI2-EX-EX-NONE-POOR': 4.62,
    'M-SI2-EX-POOR-NONE-GOOD': 4.62,
    'M-SI2-POOR-EX-NONE-GOOD': 4.62,
    'M-SI2-POOR-POOR-NONE-VG': 4.62,
    'F-VS2-POOR-GOOD-STRONG-POOR': 4.61,
    'F-VS2-GOOD-POOR-STRONG-POOR': 4.61,
    'G-VVS2-POOR-POOR-STRONG-POOR': 4.61,
    'G-VS2-POOR-GOOD-MEDIUM-POOR': 4.61,
    'G-VS2-GOOD-POOR-MEDIUM-POOR': 4.61,
    'H-VVS2-POOR-POOR-MEDIUM-POOR': 4.61,
    'H-VS2-GOOD-POOR-FAINT-POOR': 4.61,
    'H-VS2-POOR-GOOD-FAINT-POOR': 4.61,
    'I-VS2-POOR-GOOD-NONE-POOR': 4.61,
    'I-VS2-GOOD-POOR-NONE-POOR': 4.61,
    'I-VVS2-POOR-POOR-FAINT-POOR': 4.61,
    'J-VVS2-POOR-POOR-NONE-POOR': 4.61,
    'K-VS2-VG-EX-STRONG-POOR': 4.61,
    'K-VS2-VG-POOR-STRONG-GOOD': 4.61,
    'K-VS2-POOR-VG-STRONG-GOOD': 4.61,
    'K-VS2-EX-VG-STRONG-POOR': 4.61,
    'K-VS2-GOOD-GOOD-STRONG-GOOD': 4.61,
    'L-VS2-POOR-VG-MEDIUM-GOOD': 4.61,
    'L-VS2-VG-EX-MEDIUM-POOR': 4.61,
    'L-VS2-GOOD-GOOD-MEDIUM-GOOD': 4.61,
    'L-VVS2-VG-VG-STRONG-POOR': 4.61,
    'L-VVS2-GOOD-POOR-STRONG-GOOD': 4.61,
    'L-VS2-EX-VG-MEDIUM-POOR': 4.61,
    'L-VVS2-EX-GOOD-STRONG-POOR': 4.61,
    'L-VVS2-GOOD-EX-STRONG-POOR': 4.61,
    'L-VVS2-POOR-GOOD-STRONG-GOOD': 4.61,
    'L-VS2-VG-POOR-MEDIUM-GOOD': 4.61,
    'M-VVS2-POOR-GOOD-MEDIUM-GOOD': 4.61,
    'M-VVS2-GOOD-POOR-MEDIUM-GOOD': 4.61,
    'M-VVS2-VG-VG-MEDIUM-POOR': 4.61,
    'M-VS2-VG-POOR-FAINT-GOOD': 4.61,
    'M-VVS2-GOOD-EX-MEDIUM-POOR': 4.61,
    'M-VS2-VG-EX-FAINT-POOR': 4.61,
    'M-VVS2-EX-GOOD-MEDIUM-POOR': 4.61,
    'M-VS2-EX-VG-FAINT-POOR': 4.61,
    'M-VS2-GOOD-GOOD-FAINT-GOOD': 4.61,
    'M-VS2-POOR-VG-FAINT-GOOD': 4.61,
    'M-IF-GOOD-VG-STRONG-POOR': 4.6,
    'M-IF-VG-GOOD-STRONG-POOR': 4.6,
    'M-IF-EX-POOR-STRONG-POOR': 4.6,
    'M-IF-POOR-POOR-STRONG-GOOD': 4.6,
    'M-IF-POOR-EX-STRONG-POOR': 4.6,
    'D-I1-GOOD-GOOD-STRONG-POOR': 4.59,
    'D-I1-VG-POOR-STRONG-POOR': 4.59,
    'D-I1-POOR-VG-STRONG-POOR': 4.59,
    'E-I1-POOR-VG-MEDIUM-POOR': 4.59,
    'E-I1-VG-POOR-MEDIUM-POOR': 4.59,
    'E-SI1-POOR-GOOD-STRONG-POOR': 4.59,
    'E-I1-GOOD-GOOD-MEDIUM-POOR': 4.59,
    'E-SI1-GOOD-POOR-STRONG-POOR': 4.59,
    'F-I1-GOOD-GOOD-FAINT-POOR': 4.59,
    'F-I1-VG-POOR-FAINT-POOR': 4.59,
    'F-SI1-POOR-GOOD-MEDIUM-POOR': 4.59,
    'F-SI1-GOOD-POOR-MEDIUM-POOR': 4.59,
    'F-I1-POOR-VG-FAINT-POOR': 4.59,
    'G-I1-VG-POOR-NONE-POOR': 4.59,
    'G-I1-POOR-VG-NONE-POOR': 4.59,
    'G-SI1-GOOD-POOR-FAINT-POOR': 4.59,
    'G-SI1-POOR-GOOD-FAINT-POOR': 4.59,
    'G-I1-GOOD-GOOD-NONE-POOR': 4.59,
    'H-SI1-POOR-GOOD-NONE-POOR': 4.59,
    'H-SI1-GOOD-POOR-NONE-POOR': 4.59,
    'I-I1-EX-POOR-STRONG-GOOD': 4.59,
    'I-I1-GOOD-VG-STRONG-GOOD': 4.59,
    'I-I1-POOR-EX-STRONG-GOOD': 4.59,
    'I-I1-POOR-POOR-STRONG-VG': 4.59,
    'I-I1-VG-GOOD-STRONG-GOOD': 4.59,
    'I-I1-EX-EX-STRONG-POOR': 4.59,
    'J-SI1-EX-VG-STRONG-POOR': 4.59,
    'J-SI1-VG-EX-STRONG-POOR': 4.59,
    'J-I1-POOR-EX-MEDIUM-GOOD': 4.59,
    'J-I1-EX-POOR-MEDIUM-GOOD': 4.59,
    'J-I1-EX-EX-MEDIUM-POOR': 4.59,
    'J-I1-POOR-POOR-MEDIUM-VG': 4.59,
    'J-I1-GOOD-VG-MEDIUM-GOOD': 4.59,
    'J-I1-VG-GOOD-MEDIUM-GOOD': 4.59,
    'J-SI1-GOOD-GOOD-STRONG-GOOD': 4.59,
    'J-SI1-POOR-VG-STRONG-GOOD': 4.59,
    'J-SI1-VG-POOR-STRONG-GOOD': 4.59,
    'K-SI1-GOOD-GOOD-MEDIUM-GOOD': 4.59,
    'K-SI1-EX-VG-MEDIUM-POOR': 4.59,
    'K-SI1-POOR-VG-MEDIUM-GOOD': 4.59,
    'K-SI1-VG-EX-MEDIUM-POOR': 4.59,
    'K-SI1-VG-POOR-MEDIUM-GOOD': 4.59,
    'K-I1-POOR-POOR-FAINT-VG': 4.59,
    'K-I1-GOOD-VG-FAINT-GOOD': 4.59,
    'K-I1-EX-EX-FAINT-POOR': 4.59,
    'K-I1-POOR-EX-FAINT-GOOD': 4.59,
    'K-I1-EX-POOR-FAINT-GOOD': 4.59,
    'K-I1-VG-GOOD-FAINT-GOOD': 4.59,
    'L-SI1-GOOD-GOOD-FAINT-GOOD': 4.59,
    'L-SI1-VG-EX-FAINT-POOR': 4.59,
    'L-SI1-VG-POOR-FAINT-GOOD': 4.59,
    'L-SI1-EX-VG-FAINT-POOR': 4.59,
    'L-SI1-POOR-VG-FAINT-GOOD': 4.59,
    'L-I1-EX-EX-NONE-POOR': 4.59,
    'L-I1-POOR-POOR-NONE-VG': 4.59,
    'L-I1-EX-POOR-NONE-GOOD': 4.59,
    'L-I1-POOR-EX-NONE-GOOD': 4.59,
    'L-I1-VG-GOOD-NONE-GOOD': 4.59,
    'L-I1-GOOD-VG-NONE-GOOD': 4.59,
    'M-SI1-VG-EX-NONE-POOR': 4.59,
    'M-SI1-VG-POOR-NONE-GOOD': 4.59,
    'M-SI1-EX-VG-NONE-POOR': 4.59,
    'M-SI1-GOOD-GOOD-NONE-GOOD': 4.59,
    'M-SI1-POOR-VG-NONE-GOOD': 4.59,
    'F-VS1-POOR-POOR-STRONG-POOR': 4.58,
    'G-VS1-POOR-POOR-MEDIUM-POOR': 4.58,
    'H-VS1-POOR-POOR-FAINT-POOR': 4.58,
    'I-VS1-POOR-POOR-NONE-POOR': 4.58,
    'K-VS1-POOR-GOOD-STRONG-GOOD': 4.58,
    'K-VS1-GOOD-POOR-STRONG-GOOD': 4.58,
    'K-VS1-VG-VG-STRONG-POOR': 4.58,
    'K-VS1-GOOD-EX-STRONG-POOR': 4.58,
    'K-VS1-EX-GOOD-STRONG-POOR': 4.58,
    'L-VVS1-GOOD-VG-STRONG-POOR': 4.58,
    'L-VS1-GOOD-POOR-MEDIUM-GOOD': 4.58,
    'L-VVS1-POOR-EX-STRONG-POOR': 4.58,
    'L-VS1-EX-GOOD-MEDIUM-POOR': 4.58,
    'L-VVS1-EX-POOR-STRONG-POOR': 4.58,
    'L-VS1-GOOD-EX-MEDIUM-POOR': 4.58,
    'L-VVS1-VG-GOOD-STRONG-POOR': 4.58,
    'L-VS1-VG-VG-MEDIUM-POOR': 4.58,
    'L-VS1-POOR-GOOD-MEDIUM-GOOD': 4.58,
    'L-VVS1-POOR-POOR-STRONG-GOOD': 4.58,
    'M-VS1-POOR-GOOD-FAINT-GOOD': 4.58,
    'M-VVS1-GOOD-VG-MEDIUM-POOR': 4.58,
    'M-VVS1-POOR-EX-MEDIUM-POOR': 4.58,
    'M-VVS1-VG-GOOD-MEDIUM-POOR': 4.58,
    'M-VVS1-POOR-POOR-MEDIUM-GOOD': 4.58,
    'M-VS1-GOOD-POOR-FAINT-GOOD': 4.58,
    'M-VS1-GOOD-EX-FAINT-POOR': 4.58,
    'M-VS1-VG-VG-FAINT-POOR': 4.58,
    'M-VVS1-EX-POOR-MEDIUM-POOR': 4.58,
    'M-VS1-EX-GOOD-FAINT-POOR': 4.58,
    'D-I2-GOOD-GOOD-MEDIUM-POOR': 4.57,
    'D-SI2-POOR-GOOD-STRONG-POOR': 4.57,
    'D-I2-VG-POOR-MEDIUM-POOR': 4.57,
    'D-SI2-GOOD-POOR-STRONG-POOR': 4.57,
    'D-I2-POOR-VG-MEDIUM-POOR': 4.57,
    'E-I2-POOR-VG-FAINT-POOR': 4.57,
    'E-I2-GOOD-GOOD-FAINT-POOR': 4.57,
    'E-I2-VG-POOR-FAINT-POOR': 4.57,
    'E-SI2-GOOD-POOR-MEDIUM-POOR': 4.57,
    'E-SI2-POOR-GOOD-MEDIUM-POOR': 4.57,
    'F-I2-VG-POOR-NONE-POOR': 4.57,
    'F-I2-GOOD-GOOD-NONE-POOR': 4.57,
    'F-SI2-GOOD-POOR-FAINT-POOR': 4.57,
    'F-SI2-POOR-GOOD-FAINT-POOR': 4.57,
    'F-I2-POOR-VG-NONE-POOR': 4.57,
    'G-SI2-POOR-GOOD-NONE-POOR': 4.57,
    'G-SI2-GOOD-POOR-NONE-POOR': 4.57,
    'H-I2-EX-EX-STRONG-POOR': 4.57,
    'H-I2-EX-POOR-STRONG-GOOD': 4.57,
    'H-I2-POOR-POOR-STRONG-VG': 4.57,
    'H-I2-POOR-EX-STRONG-GOOD': 4.57,
    'H-I2-GOOD-VG-STRONG-GOOD': 4.57,
    'H-I2-VG-GOOD-STRONG-GOOD': 4.57,
    'I-SI2-VG-POOR-STRONG-GOOD': 4.57,
    'I-SI2-EX-VG-STRONG-POOR': 4.57,
    'I-SI2-VG-EX-STRONG-POOR': 4.57,
    'I-SI2-GOOD-GOOD-STRONG-GOOD': 4.57,
    'I-SI2-POOR-VG-STRONG-GOOD': 4.57,
    'I-I2-POOR-EX-MEDIUM-GOOD': 4.57,
    'I-I2-POOR-POOR-MEDIUM-VG': 4.57,
    'I-I2-GOOD-VG-MEDIUM-GOOD': 4.57,
    'I-I2-VG-GOOD-MEDIUM-GOOD': 4.57,
    'I-I2-EX-EX-MEDIUM-POOR': 4.57,
    'I-I2-EX-POOR-MEDIUM-GOOD': 4.57,
    'J-I2-EX-EX-FAINT-POOR': 4.57,
    'J-I2-EX-POOR-FAINT-GOOD': 4.57,
    'J-I2-VG-GOOD-FAINT-GOOD': 4.57,
    'J-I2-GOOD-VG-FAINT-GOOD': 4.57,
    'J-I2-POOR-EX-FAINT-GOOD': 4.57,
    'J-I2-POOR-POOR-FAINT-VG': 4.57,
    'J-SI2-VG-POOR-MEDIUM-GOOD': 4.57,
    'J-SI2-GOOD-GOOD-MEDIUM-GOOD': 4.57,
    'J-SI2-POOR-VG-MEDIUM-GOOD': 4.57,
    'J-SI2-EX-VG-MEDIUM-POOR': 4.57,
    'J-SI2-VG-EX-MEDIUM-POOR': 4.57,
    'K-I2-VG-GOOD-NONE-GOOD': 4.57,
    'K-I2-EX-POOR-NONE-GOOD': 4.57,
    'K-SI2-EX-VG-FAINT-POOR': 4.57,
    'K-I2-POOR-EX-NONE-GOOD': 4.57,
    'K-SI2-POOR-VG-FAINT-GOOD': 4.57,
    'K-SI2-GOOD-GOOD-FAINT-GOOD': 4.57,
    'K-SI2-VG-EX-FAINT-POOR': 4.57,
    'K-I2-GOOD-VG-NONE-GOOD': 4.57,
    'K-SI2-VG-POOR-FAINT-GOOD': 4.57,
    'K-I2-POOR-POOR-NONE-VG': 4.57,
    'K-I2-EX-EX-NONE-POOR': 4.57,
    'L-SI2-EX-VG-NONE-POOR': 4.57,
    'L-SI2-VG-EX-NONE-POOR': 4.57,
    'L-SI2-VG-POOR-NONE-GOOD': 4.57,
    'L-SI2-POOR-VG-NONE-GOOD': 4.57,
    'L-SI2-GOOD-GOOD-NONE-GOOD': 4.57,
    'M-I2-VG-VG-STRONG-VG': 4.57,
    'M-I2-EX-GOOD-STRONG-VG': 4.57,
    'M-I2-GOOD-POOR-STRONG-EX': 4.57,
    'M-I2-POOR-GOOD-STRONG-EX': 4.57,
    'M-I2-GOOD-EX-STRONG-VG': 4.57,
    'E-VS2-POOR-POOR-STRONG-POOR': 4.56,
    'F-VS2-POOR-POOR-MEDIUM-POOR': 4.56,
    'G-VS2-POOR-POOR-FAINT-POOR': 4.56,
    'H-VS2-POOR-POOR-NONE-POOR': 4.56,
    'J-VS2-POOR-GOOD-STRONG-GOOD': 4.56,
    'J-VS2-GOOD-POOR-STRONG-GOOD': 4.56,
    'J-VS2-GOOD-EX-STRONG-POOR': 4.56,
    'J-VS2-VG-VG-STRONG-POOR': 4.56,
    'J-VS2-EX-GOOD-STRONG-POOR': 4.56,
    'K-VVS2-EX-POOR-STRONG-POOR': 4.56,
    'K-VVS2-POOR-EX-STRONG-POOR': 4.56,
    'K-VVS2-GOOD-VG-STRONG-POOR': 4.56,
    'K-VS2-GOOD-POOR-MEDIUM-GOOD': 4.56,
    'K-VS2-POOR-GOOD-MEDIUM-GOOD': 4.56,
    'K-VS2-GOOD-EX-MEDIUM-POOR': 4.56,
    'K-VS2-VG-VG-MEDIUM-POOR': 4.56,
    'K-VVS2-VG-GOOD-STRONG-POOR': 4.56,
    'K-VS2-EX-GOOD-MEDIUM-POOR': 4.56,
    'K-VVS2-POOR-POOR-STRONG-GOOD': 4.56,
    'L-VVS2-VG-GOOD-MEDIUM-POOR': 4.56,
    'L-VS2-GOOD-EX-FAINT-POOR': 4.56,
    'L-VVS2-POOR-EX-MEDIUM-POOR': 4.56,
    'L-VVS2-EX-POOR-MEDIUM-POOR': 4.56,
    'L-VVS2-POOR-POOR-MEDIUM-GOOD': 4.56,
    'L-VS2-POOR-GOOD-FAINT-GOOD': 4.56,
    'L-VS2-EX-GOOD-FAINT-POOR': 4.56,
    'L-VVS2-GOOD-VG-MEDIUM-POOR': 4.56,
    'L-VS2-GOOD-POOR-FAINT-GOOD': 4.56,
    'L-VS2-VG-VG-FAINT-POOR': 4.56,
    'M-VS2-POOR-GOOD-NONE-GOOD': 4.56,
    'M-VS2-GOOD-POOR-NONE-GOOD': 4.56,
    'M-VS2-GOOD-EX-NONE-POOR': 4.56,
    'M-VVS2-POOR-POOR-FAINT-GOOD': 4.56,
    'M-VS2-VG-VG-NONE-POOR': 4.56,
    'M-VVS2-EX-POOR-FAINT-POOR': 4.56,
    'M-VS2-EX-GOOD-NONE-POOR': 4.56,
    'M-VVS2-GOOD-VG-FAINT-POOR': 4.56,
    'M-VVS2-VG-GOOD-FAINT-POOR': 4.56,
    'M-VVS2-POOR-EX-FAINT-POOR': 4.56,
    'L-IF-GOOD-GOOD-STRONG-POOR': 4.55,
    'L-IF-VG-POOR-STRONG-POOR': 4.55,
    'L-IF-POOR-VG-STRONG-POOR': 4.55,
    'M-IF-VG-POOR-MEDIUM-POOR': 4.55,
    'M-IF-POOR-VG-MEDIUM-POOR': 4.55,
    'M-IF-GOOD-GOOD-MEDIUM-POOR': 4.55,
    'D-I1-POOR-GOOD-MEDIUM-POOR': 4.54,
    'D-I1-GOOD-POOR-MEDIUM-POOR': 4.54,
    'D-SI1-POOR-POOR-STRONG-POOR': 4.54,
    'E-I1-GOOD-POOR-FAINT-POOR': 4.54,
    'E-I1-POOR-GOOD-FAINT-POOR': 4.54,
    'E-SI1-POOR-POOR-MEDIUM-POOR': 4.54,
    'F-SI1-POOR-POOR-FAINT-POOR': 4.54,
    'F-I1-POOR-GOOD-NONE-POOR': 4.54,
    'F-I1-GOOD-POOR-NONE-POOR': 4.54,
    'G-SI1-POOR-POOR-NONE-POOR': 4.54,
    'H-I1-VG-POOR-STRONG-GOOD': 4.54,
    'H-I1-GOOD-GOOD-STRONG-GOOD': 4.54,
    'H-I1-POOR-VG-STRONG-GOOD': 4.54,
    'H-I1-VG-EX-STRONG-POOR': 4.54,
    'H-I1-EX-VG-STRONG-POOR': 4.54,
    'I-SI1-GOOD-POOR-STRONG-GOOD': 4.54,
    'I-SI1-POOR-GOOD-STRONG-GOOD': 4.54,
    'I-I1-POOR-VG-MEDIUM-GOOD': 4.54,
    'I-I1-EX-VG-MEDIUM-POOR': 4.54,
    'I-I1-VG-EX-MEDIUM-POOR': 4.54,
    'I-I1-VG-POOR-MEDIUM-GOOD': 4.54,
    'I-SI1-GOOD-EX-STRONG-POOR': 4.54,
    'I-I1-GOOD-GOOD-MEDIUM-GOOD': 4.54,
    'I-SI1-VG-VG-STRONG-POOR': 4.54,
    'I-SI1-EX-GOOD-STRONG-POOR': 4.54,
    'J-I1-VG-POOR-FAINT-GOOD': 4.54,
    'J-I1-EX-VG-FAINT-POOR': 4.54,
    'J-SI1-POOR-GOOD-MEDIUM-GOOD': 4.54,
    'J-I1-VG-EX-FAINT-POOR': 4.54,
    'J-SI1-GOOD-POOR-MEDIUM-GOOD': 4.54,
    'J-SI1-VG-VG-MEDIUM-POOR': 4.54,
    'J-I1-GOOD-GOOD-FAINT-GOOD': 4.54,
    'J-SI1-EX-GOOD-MEDIUM-POOR': 4.54,
    'J-I1-POOR-VG-FAINT-GOOD': 4.54,
    'J-SI1-GOOD-EX-MEDIUM-POOR': 4.54,
    'K-SI1-EX-GOOD-FAINT-POOR': 4.54,
    'K-SI1-GOOD-POOR-FAINT-GOOD': 4.54,
    'K-SI1-VG-VG-FAINT-POOR': 4.54,
    'K-SI1-POOR-GOOD-FAINT-GOOD': 4.54,
    'K-I1-POOR-VG-NONE-GOOD': 4.54,
    'K-I1-GOOD-GOOD-NONE-GOOD': 4.54,
    'K-I1-VG-POOR-NONE-GOOD': 4.54,
    'K-I1-VG-EX-NONE-POOR': 4.54,
    'K-I1-EX-VG-NONE-POOR': 4.54,
    'K-SI1-GOOD-EX-FAINT-POOR': 4.54,
    'L-SI1-GOOD-POOR-NONE-GOOD': 4.54,
    'L-SI1-POOR-GOOD-NONE-GOOD': 4.54,
    'L-SI1-VG-VG-NONE-POOR': 4.54,
    'L-SI1-GOOD-EX-NONE-POOR': 4.54,
    'L-SI1-EX-GOOD-NONE-POOR': 4.54,
    'M-I1-GOOD-VG-STRONG-VG': 4.54,
    'M-I1-POOR-POOR-STRONG-EX': 4.54,
    'M-I1-POOR-EX-STRONG-VG': 4.54,
    'M-I1-EX-POOR-STRONG-VG': 4.54,
    'M-I1-EX-EX-STRONG-GOOD': 4.54,
    'M-I1-VG-GOOD-STRONG-VG': 4.54,
    'J-VS1-POOR-EX-STRONG-POOR': 4.53,
    'J-VS1-GOOD-VG-STRONG-POOR': 4.53,
    'J-VS1-POOR-POOR-STRONG-GOOD': 4.53,
    'J-VS1-EX-POOR-STRONG-POOR': 4.53,
    'J-VS1-VG-GOOD-STRONG-POOR': 4.53,
    'K-VS1-POOR-POOR-MEDIUM-GOOD': 4.53,
    'K-VVS1-VG-POOR-STRONG-POOR': 4.53,
    'K-VS1-POOR-EX-MEDIUM-POOR': 4.53,
    'K-VS1-VG-GOOD-MEDIUM-POOR': 4.53,
    'K-VVS1-GOOD-GOOD-STRONG-POOR': 4.53,
    'K-VS1-EX-POOR-MEDIUM-POOR': 4.53,
    'K-VS1-GOOD-VG-MEDIUM-POOR': 4.53,
    'K-VVS1-POOR-VG-STRONG-POOR': 4.53,
    'L-VVS1-VG-POOR-MEDIUM-POOR': 4.53,
    'L-VS1-POOR-POOR-FAINT-GOOD': 4.53,
    'L-VVS1-POOR-VG-MEDIUM-POOR': 4.53,
    'L-VVS1-GOOD-GOOD-MEDIUM-POOR': 4.53,
    'L-VS1-EX-POOR-FAINT-POOR': 4.53,
    'L-VS1-GOOD-VG-FAINT-POOR': 4.53,
    'L-VS1-VG-GOOD-FAINT-POOR': 4.53,
    'L-VS1-POOR-EX-FAINT-POOR': 4.53,
    'M-VS1-VG-GOOD-NONE-POOR': 4.53,
    'M-VS1-GOOD-VG-NONE-POOR': 4.53,
    'M-VS1-EX-POOR-NONE-POOR': 4.53,
    'M-VS1-POOR-EX-NONE-POOR': 4.53,
    'M-VVS1-VG-POOR-FAINT-POOR': 4.53,
    'M-VS1-POOR-POOR-NONE-GOOD': 4.53,
    'M-VVS1-GOOD-GOOD-FAINT-POOR': 4.53,
    'M-VVS1-POOR-VG-FAINT-POOR': 4.53,
    'D-I2-GOOD-POOR-FAINT-POOR': 4.52,
    'D-SI2-POOR-POOR-MEDIUM-POOR': 4.52,
    'D-I2-POOR-GOOD-FAINT-POOR': 4.52,
    'E-SI2-POOR-POOR-FAINT-POOR': 4.52,
    'E-I2-GOOD-POOR-NONE-POOR': 4.52,
    'E-I2-POOR-GOOD-NONE-POOR': 4.52,
    'F-SI2-POOR-POOR-NONE-POOR': 4.52,
    'G-I2-GOOD-GOOD-STRONG-GOOD': 4.52,
    'G-I2-POOR-VG-STRONG-GOOD': 4.52,
    'G-I2-EX-VG-STRONG-POOR': 4.52,
    'G-I2-VG-EX-STRONG-POOR': 4.52,
    'G-I2-VG-POOR-STRONG-GOOD': 4.52,
    'H-SI2-GOOD-POOR-STRONG-GOOD': 4.52,
    'H-I2-GOOD-GOOD-MEDIUM-GOOD': 4.52,
    'H-I2-POOR-VG-MEDIUM-GOOD': 4.52,
    'H-I2-VG-POOR-MEDIUM-GOOD': 4.52,
    'H-SI2-EX-GOOD-STRONG-POOR': 4.52,
    'H-SI2-VG-VG-STRONG-POOR': 4.52,
    'H-SI2-GOOD-EX-STRONG-POOR': 4.52,
    'H-I2-EX-VG-MEDIUM-POOR': 4.52,
    'H-SI2-POOR-GOOD-STRONG-GOOD': 4.52,
    'H-I2-VG-EX-MEDIUM-POOR': 4.52,
    'I-I2-EX-VG-FAINT-POOR': 4.52,
    'I-I2-VG-EX-FAINT-POOR': 4.52,
    'I-I2-POOR-VG-FAINT-GOOD': 4.52,
    'I-I2-GOOD-GOOD-FAINT-GOOD': 4.52,
    'I-I2-VG-POOR-FAINT-GOOD': 4.52,
    'I-SI2-EX-GOOD-MEDIUM-POOR': 4.52,
    'I-SI2-VG-VG-MEDIUM-POOR': 4.52,
    'I-SI2-GOOD-EX-MEDIUM-POOR': 4.52,
    'I-SI2-GOOD-POOR-MEDIUM-GOOD': 4.52,
    'I-SI2-POOR-GOOD-MEDIUM-GOOD': 4.52,
    'J-SI2-EX-GOOD-FAINT-POOR': 4.52,
    'J-SI2-VG-VG-FAINT-POOR': 4.52,
    'J-SI2-GOOD-EX-FAINT-POOR': 4.52,
    'J-SI2-GOOD-POOR-FAINT-GOOD': 4.52,
    'J-SI2-POOR-GOOD-FAINT-GOOD': 4.52,
    'J-I2-POOR-VG-NONE-GOOD': 4.52,
    'J-I2-GOOD-GOOD-NONE-GOOD': 4.52,
    'J-I2-VG-POOR-NONE-GOOD': 4.52,
    'J-I2-VG-EX-NONE-POOR': 4.52,
    'J-I2-EX-VG-NONE-POOR': 4.52,
    'K-SI2-POOR-GOOD-NONE-GOOD': 4.52,
    'K-SI2-VG-VG-NONE-POOR': 4.52,
    'K-SI2-EX-GOOD-NONE-POOR': 4.52,
    'K-SI2-GOOD-EX-NONE-POOR': 4.52,
    'K-SI2-GOOD-POOR-NONE-GOOD': 4.52,
    'L-I2-EX-POOR-STRONG-VG': 4.52,
    'L-I2-GOOD-VG-STRONG-VG': 4.52,
    'L-I2-POOR-EX-STRONG-VG': 4.52,
    'L-I2-POOR-POOR-STRONG-EX': 4.52,
    'L-I2-EX-EX-STRONG-GOOD': 4.52,
    'L-I2-VG-GOOD-STRONG-VG': 4.52,
    'M-SI2-VG-POOR-STRONG-VG': 4.52,
    'M-I2-POOR-EX-MEDIUM-VG': 4.52,
    'M-I2-POOR-POOR-MEDIUM-EX': 4.52,
    'M-SI2-EX-VG-STRONG-GOOD': 4.52,
    'M-SI2-VG-EX-STRONG-GOOD': 4.52,
    'M-I2-EX-EX-MEDIUM-GOOD': 4.52,
    'M-SI2-POOR-VG-STRONG-VG': 4.52,
    'M-I2-VG-GOOD-MEDIUM-VG': 4.52,
    'M-SI2-GOOD-GOOD-STRONG-VG': 4.52,
    'M-I2-GOOD-VG-MEDIUM-VG': 4.52,
    'M-I2-EX-POOR-MEDIUM-VG': 4.52,
    'I-VS2-VG-GOOD-STRONG-POOR': 4.51,
    'I-VS2-EX-POOR-STRONG-POOR': 4.51,
    'I-VS2-GOOD-VG-STRONG-POOR': 4.51,
    'I-VS2-POOR-EX-STRONG-POOR': 4.51,
    'I-VS2-POOR-POOR-STRONG-GOOD': 4.51,
    'J-VVS2-POOR-VG-STRONG-POOR': 4.51,
    'J-VVS2-GOOD-GOOD-STRONG-POOR': 4.51,
    'J-VVS2-VG-POOR-STRONG-POOR': 4.51,
    'J-VS2-EX-POOR-MEDIUM-POOR': 4.51,
    'J-VS2-VG-GOOD-MEDIUM-POOR': 4.51,
    'J-VS2-GOOD-VG-MEDIUM-POOR': 4.51,
    'J-VS2-POOR-EX-MEDIUM-POOR': 4.51,
    'J-VS2-POOR-POOR-MEDIUM-GOOD': 4.51,
    'K-VS2-GOOD-VG-FAINT-POOR': 4.51,
    'K-VS2-POOR-POOR-FAINT-GOOD': 4.51,
    'K-VS2-POOR-EX-FAINT-POOR': 4.51,
    'K-VVS2-POOR-VG-MEDIUM-POOR': 4.51,
    'K-VS2-EX-POOR-FAINT-POOR': 4.51,
    'K-VVS2-GOOD-GOOD-MEDIUM-POOR': 4.51,
    'K-VS2-VG-GOOD-FAINT-POOR': 4.51,
    'K-VVS2-VG-POOR-MEDIUM-POOR': 4.51,
    'L-VVS2-POOR-VG-FAINT-POOR': 4.51,
    'L-VVS2-GOOD-GOOD-FAINT-POOR': 4.51,
    'L-VVS2-VG-POOR-FAINT-POOR': 4.51,
    'L-VS2-EX-POOR-NONE-POOR': 4.51,
    'L-VS2-POOR-EX-NONE-POOR': 4.51,
    'L-VS2-VG-GOOD-NONE-POOR': 4.51,
    'L-VS2-POOR-POOR-NONE-GOOD': 4.51,
    'L-VS2-GOOD-VG-NONE-POOR': 4.51,
    'M-VVS2-GOOD-GOOD-NONE-POOR': 4.51,
    'M-VVS2-POOR-VG-NONE-POOR': 4.51,
    'M-VVS2-VG-POOR-NONE-POOR': 4.51,
    'K-IF-GOOD-POOR-STRONG-POOR': 4.5,
    'K-IF-POOR-GOOD-STRONG-POOR': 4.5,
    'L-IF-GOOD-POOR-MEDIUM-POOR': 4.5,
    'L-IF-POOR-GOOD-MEDIUM-POOR': 4.5,
    'M-IF-POOR-GOOD-FAINT-POOR': 4.5,
    'M-IF-GOOD-POOR-FAINT-POOR': 4.5,
    'D-I1-POOR-POOR-FAINT-POOR': 4.49,
    'E-I1-POOR-POOR-NONE-POOR': 4.49,
    'G-I1-POOR-GOOD-STRONG-GOOD': 4.49,
    'G-I1-VG-VG-STRONG-POOR': 4.49,
    'G-I1-GOOD-EX-STRONG-POOR': 4.49,
    'G-I1-EX-GOOD-STRONG-POOR': 4.49,
    'G-I1-GOOD-POOR-STRONG-GOOD': 4.49,
    'H-SI1-VG-GOOD-STRONG-POOR': 4.49,
    'H-I1-EX-GOOD-MEDIUM-POOR': 4.49,
    'H-SI1-POOR-EX-STRONG-POOR': 4.49,
    'H-I1-POOR-GOOD-MEDIUM-GOOD': 4.49,
    'H-SI1-GOOD-VG-STRONG-POOR': 4.49,
    'H-I1-GOOD-POOR-MEDIUM-GOOD': 4.49,
    'H-I1-GOOD-EX-MEDIUM-POOR': 4.49,
    'H-SI1-POOR-POOR-STRONG-GOOD': 4.49,
    'H-SI1-EX-POOR-STRONG-POOR': 4.49,
    'H-I1-VG-VG-MEDIUM-POOR': 4.49,
    'I-SI1-POOR-EX-MEDIUM-POOR': 4.49,
    'I-SI1-GOOD-VG-MEDIUM-POOR': 4.49,
    'I-I1-GOOD-POOR-FAINT-GOOD': 4.49,
    'I-SI1-VG-GOOD-MEDIUM-POOR': 4.49,
    'I-I1-POOR-GOOD-FAINT-GOOD': 4.49,
    'I-SI1-EX-POOR-MEDIUM-POOR': 4.49,
    'I-I1-GOOD-EX-FAINT-POOR': 4.49,
    'I-I1-VG-VG-FAINT-POOR': 4.49,
    'I-SI1-POOR-POOR-MEDIUM-GOOD': 4.49,
    'I-I1-EX-GOOD-FAINT-POOR': 4.49,
    'J-SI1-EX-POOR-FAINT-POOR': 4.49,
    'J-I1-VG-VG-NONE-POOR': 4.49,
    'J-I1-GOOD-POOR-NONE-GOOD': 4.49,
    'J-I1-GOOD-EX-NONE-POOR': 4.49,
    'J-I1-POOR-GOOD-NONE-GOOD': 4.49,
    'J-SI1-POOR-POOR-FAINT-GOOD': 4.49,
    'J-SI1-GOOD-VG-FAINT-POOR': 4.49,
    'J-SI1-POOR-EX-FAINT-POOR': 4.49,
    'J-I1-EX-GOOD-NONE-POOR': 4.49,
    'J-SI1-VG-GOOD-FAINT-POOR': 4.49,
    'K-SI1-EX-POOR-NONE-POOR': 4.49,
    'K-SI1-GOOD-VG-NONE-POOR': 4.49,
    'K-SI1-VG-GOOD-NONE-POOR': 4.49,
    'K-SI1-POOR-POOR-NONE-GOOD': 4.49,
    'K-SI1-POOR-EX-NONE-POOR': 4.49,
    'L-I1-POOR-VG-STRONG-VG': 4.49,
    'L-I1-VG-EX-STRONG-GOOD': 4.49,
    'L-I1-EX-VG-STRONG-GOOD': 4.49,
    'L-I1-VG-POOR-STRONG-VG': 4.49,
    'L-I1-GOOD-GOOD-STRONG-VG': 4.49,
    'M-I1-POOR-VG-MEDIUM-VG': 4.49,
    'M-SI1-GOOD-EX-STRONG-GOOD': 4.49,
    'M-SI1-GOOD-POOR-STRONG-VG': 4.49,
    'M-I1-VG-EX-MEDIUM-GOOD': 4.49,
    'M-SI1-VG-VG-STRONG-GOOD': 4.49,
    'M-I1-GOOD-GOOD-MEDIUM-VG': 4.49,
    'M-I1-EX-VG-MEDIUM-GOOD': 4.49,
    'M-SI1-EX-GOOD-STRONG-GOOD': 4.49,
    'M-SI1-POOR-GOOD-STRONG-VG': 4.49,
    'M-I1-VG-POOR-MEDIUM-VG': 4.49,
    'I-VS1-POOR-VG-STRONG-POOR': 4.48,
    'I-VS1-GOOD-GOOD-STRONG-POOR': 4.48,
    'I-VS1-VG-POOR-STRONG-POOR': 4.48,
    'J-VVS1-POOR-GOOD-STRONG-POOR': 4.48,
    'J-VS1-POOR-VG-MEDIUM-POOR': 4.48,
    'J-VVS1-GOOD-POOR-STRONG-POOR': 4.48,
    'J-VS1-VG-POOR-MEDIUM-POOR': 4.48,
    'J-VS1-GOOD-GOOD-MEDIUM-POOR': 4.48,
    'K-VVS1-POOR-GOOD-MEDIUM-POOR': 4.48,
    'K-VVS1-GOOD-POOR-MEDIUM-POOR': 4.48,
    'K-VS1-VG-POOR-FAINT-POOR': 4.48,
    'K-VS1-POOR-VG-FAINT-POOR': 4.48,
    'K-VS1-GOOD-GOOD-FAINT-POOR': 4.48,
    'L-VVS1-POOR-GOOD-FAINT-POOR': 4.48,
    'L-VS1-VG-POOR-NONE-POOR': 4.48,
    'L-VVS1-GOOD-POOR-FAINT-POOR': 4.48,
    'L-VS1-POOR-VG-NONE-POOR': 4.48,
    'L-VS1-GOOD-GOOD-NONE-POOR': 4.48,
    'M-VVS1-GOOD-POOR-NONE-POOR': 4.48,
    'M-VVS1-POOR-GOOD-NONE-POOR': 4.48,
    'D-I2-POOR-POOR-NONE-POOR': 4.47,
    'F-I2-POOR-GOOD-STRONG-GOOD': 4.47,
    'F-I2-GOOD-EX-STRONG-POOR': 4.47,
    'F-I2-GOOD-POOR-STRONG-GOOD': 4.47,
    'F-I2-EX-GOOD-STRONG-POOR': 4.47,
    'F-I2-VG-VG-STRONG-POOR': 4.47,
    'G-SI2-GOOD-VG-STRONG-POOR': 4.47,
    'G-I2-GOOD-POOR-MEDIUM-GOOD': 4.47,
    'G-I2-POOR-GOOD-MEDIUM-GOOD': 4.47,
    'G-SI2-POOR-EX-STRONG-POOR': 4.47,
    'G-I2-VG-VG-MEDIUM-POOR': 4.47,
    'G-SI2-VG-GOOD-STRONG-POOR': 4.47,
    'G-SI2-POOR-POOR-STRONG-GOOD': 4.47,
    'G-I2-EX-GOOD-MEDIUM-POOR': 4.47,
    'G-SI2-EX-POOR-STRONG-POOR': 4.47,
    'G-I2-GOOD-EX-MEDIUM-POOR': 4.47,
    'H-I2-GOOD-POOR-FAINT-GOOD': 4.47,
    'H-SI2-EX-POOR-MEDIUM-POOR': 4.47,
    'H-SI2-POOR-POOR-MEDIUM-GOOD': 4.47,
    'H-I2-POOR-GOOD-FAINT-GOOD': 4.47,
    'H-I2-GOOD-EX-FAINT-POOR': 4.47,
    'H-I2-EX-GOOD-FAINT-POOR': 4.47,
    'H-I2-VG-VG-FAINT-POOR': 4.47,
    'H-SI2-VG-GOOD-MEDIUM-POOR': 4.47,
    'H-SI2-GOOD-VG-MEDIUM-POOR': 4.47,
    'H-SI2-POOR-EX-MEDIUM-POOR': 4.47,
    'I-I2-VG-VG-NONE-POOR': 4.47,
    'I-I2-EX-GOOD-NONE-POOR': 4.47,
    'I-I2-GOOD-EX-NONE-POOR': 4.47,
    'I-I2-GOOD-POOR-NONE-GOOD': 4.47,
    'I-SI2-EX-POOR-FAINT-POOR': 4.47,
    'I-SI2-VG-GOOD-FAINT-POOR': 4.47,
    'I-I2-POOR-GOOD-NONE-GOOD': 4.47,
    'I-SI2-GOOD-VG-FAINT-POOR': 4.47,
    'I-SI2-POOR-EX-FAINT-POOR': 4.47,
    'I-SI2-POOR-POOR-FAINT-GOOD': 4.47,
    'J-SI2-GOOD-VG-NONE-POOR': 4.47,
    'J-SI2-VG-GOOD-NONE-POOR': 4.47,
    'J-SI2-EX-POOR-NONE-POOR': 4.47,
    'J-SI2-POOR-EX-NONE-POOR': 4.47,
    'J-SI2-POOR-POOR-NONE-GOOD': 4.47,
    'K-I2-VG-EX-STRONG-GOOD': 4.47,
    'K-I2-EX-VG-STRONG-GOOD': 4.47,
    'K-I2-POOR-VG-STRONG-VG': 4.47,
    'K-I2-GOOD-GOOD-STRONG-VG': 4.47,
    'K-I2-VG-POOR-STRONG-VG': 4.47,
    'L-I2-VG-POOR-MEDIUM-VG': 4.47,
    'L-SI2-GOOD-EX-STRONG-GOOD': 4.47,
    'L-SI2-POOR-GOOD-STRONG-VG': 4.47,
    'L-SI2-VG-VG-STRONG-GOOD': 4.47,
    'L-I2-EX-VG-MEDIUM-GOOD': 4.47,
    'L-SI2-EX-GOOD-STRONG-GOOD': 4.47,
    'L-I2-VG-EX-MEDIUM-GOOD': 4.47,
    'L-SI2-GOOD-POOR-STRONG-VG': 4.47,
    'L-I2-POOR-VG-MEDIUM-VG': 4.47,
    'L-I2-GOOD-GOOD-MEDIUM-VG': 4.47,
    'M-I2-GOOD-GOOD-FAINT-VG': 4.47,
    'M-SI2-POOR-GOOD-MEDIUM-VG': 4.47,
    'M-I2-POOR-VG-FAINT-VG': 4.47,
    'M-SI2-GOOD-POOR-MEDIUM-VG': 4.47,
    'M-I2-VG-EX-FAINT-GOOD': 4.47,
    'M-SI2-EX-GOOD-MEDIUM-GOOD': 4.47,
    'M-I2-EX-VG-FAINT-GOOD': 4.47,
    'M-SI2-VG-VG-MEDIUM-GOOD': 4.47,
    'M-SI2-GOOD-EX-MEDIUM-GOOD': 4.47,
    'M-I2-VG-POOR-FAINT-VG': 4.47,
    'H-VS2-VG-POOR-STRONG-POOR': 4.46,
    'H-VS2-GOOD-GOOD-STRONG-POOR': 4.46,
    'H-VS2-POOR-VG-STRONG-POOR': 4.46,
    'I-VS2-POOR-VG-MEDIUM-POOR': 4.46,
    'I-VS2-VG-POOR-MEDIUM-POOR': 4.46,
    'I-VS2-GOOD-GOOD-MEDIUM-POOR': 4.46,
    'I-VVS2-POOR-GOOD-STRONG-POOR': 4.46,
    'I-VVS2-GOOD-POOR-STRONG-POOR': 4.46,
    'J-VS2-GOOD-GOOD-FAINT-POOR': 4.46,
    'J-VS2-VG-POOR-FAINT-POOR': 4.46,
    'J-VS2-POOR-VG-FAINT-POOR': 4.46,
    'J-VVS2-POOR-GOOD-MEDIUM-POOR': 4.46,
    'J-VVS2-GOOD-POOR-MEDIUM-POOR': 4.46,
    'K-VVS2-GOOD-POOR-FAINT-POOR': 4.46,
    'K-VS2-VG-POOR-NONE-POOR': 4.46,
    'K-VVS2-POOR-GOOD-FAINT-POOR': 4.46,
    'K-VS2-GOOD-GOOD-NONE-POOR': 4.46,
    'K-VS2-POOR-VG-NONE-POOR': 4.46,
    'L-VVS2-GOOD-POOR-NONE-POOR': 4.46,
    'L-VVS2-POOR-GOOD-NONE-POOR': 4.46,
    'M-VS2-EX-POOR-STRONG-GOOD': 4.46,
    'M-VS2-EX-EX-STRONG-POOR': 4.46,
    'M-VS2-GOOD-VG-STRONG-GOOD': 4.46,
    'M-VS2-POOR-EX-STRONG-GOOD': 4.46,
    'M-VS2-POOR-POOR-STRONG-VG': 4.46,
    'M-VS2-VG-GOOD-STRONG-GOOD': 4.46,
    'J-IF-POOR-POOR-STRONG-POOR': 4.45,
    'K-IF-POOR-POOR-MEDIUM-POOR': 4.45,
    'L-IF-POOR-POOR-FAINT-POOR': 4.45,
    'M-IF-POOR-POOR-NONE-POOR': 4.45,
    'F-I1-VG-GOOD-STRONG-POOR': 4.44,
    'F-I1-POOR-EX-STRONG-POOR': 4.44,
    'F-I1-EX-POOR-STRONG-POOR': 4.44,
    'F-I1-GOOD-VG-STRONG-POOR': 4.44,
    'F-I1-POOR-POOR-STRONG-GOOD': 4.44,
    'G-I1-POOR-POOR-MEDIUM-GOOD': 4.44,
    'G-I1-POOR-EX-MEDIUM-POOR': 4.44,
    'G-SI1-POOR-VG-STRONG-POOR': 4.44,
    'G-I1-GOOD-VG-MEDIUM-POOR': 4.44,
    'G-I1-VG-GOOD-MEDIUM-POOR': 4.44,
    'G-SI1-GOOD-GOOD-STRONG-POOR': 4.44,
    'G-I1-EX-POOR-MEDIUM-POOR': 4.44,
    'G-SI1-VG-POOR-STRONG-POOR': 4.44,
    'H-I1-VG-GOOD-FAINT-POOR': 4.44,
    'H-SI1-POOR-VG-MEDIUM-POOR': 4.44,
    'H-SI1-VG-POOR-MEDIUM-POOR': 4.44,
    'H-I1-EX-POOR-FAINT-POOR': 4.44,
    'H-SI1-GOOD-GOOD-MEDIUM-POOR': 4.44,
    'H-I1-GOOD-VG-FAINT-POOR': 4.44,
    'H-I1-POOR-EX-FAINT-POOR': 4.44,
    'H-I1-POOR-POOR-FAINT-GOOD': 4.44,
    'I-I1-POOR-POOR-NONE-GOOD': 4.44,
    'I-I1-POOR-EX-NONE-POOR': 4.44,
    'I-SI1-VG-POOR-FAINT-POOR': 4.44,
    'I-SI1-GOOD-GOOD-FAINT-POOR': 4.44,
    'I-SI1-POOR-VG-FAINT-POOR': 4.44,
    'I-I1-EX-POOR-NONE-POOR': 4.44,
    'I-I1-GOOD-VG-NONE-POOR': 4.44,
    'I-I1-VG-GOOD-NONE-POOR': 4.44,
    'J-SI1-POOR-VG-NONE-POOR': 4.44,
    'J-SI1-VG-POOR-NONE-POOR': 4.44,
    'J-SI1-GOOD-GOOD-NONE-POOR': 4.44,
    'K-I1-VG-VG-STRONG-GOOD': 4.44,
    'K-I1-EX-GOOD-STRONG-GOOD': 4.44,
    'K-I1-GOOD-EX-STRONG-GOOD': 4.44,
    'K-I1-GOOD-POOR-STRONG-VG': 4.44,
    'K-I1-POOR-GOOD-STRONG-VG': 4.44,
    'L-SI1-GOOD-VG-STRONG-GOOD': 4.44,
    'L-SI1-POOR-EX-STRONG-GOOD': 4.44,
    'L-SI1-EX-POOR-STRONG-GOOD': 4.44,
    'L-SI1-EX-EX-STRONG-POOR': 4.44,
    'L-SI1-POOR-POOR-STRONG-VG': 4.44,
    'L-I1-VG-VG-MEDIUM-GOOD': 4.44,
    'L-I1-GOOD-EX-MEDIUM-GOOD': 4.44,
    'L-I1-GOOD-POOR-MEDIUM-VG': 4.44,
    'L-SI1-VG-GOOD-STRONG-GOOD': 4.44,
    'L-I1-POOR-GOOD-MEDIUM-VG': 4.44,
    'L-I1-EX-GOOD-MEDIUM-GOOD': 4.44,
    'M-SI1-EX-POOR-MEDIUM-GOOD': 4.44,
    'M-I1-GOOD-EX-FAINT-GOOD': 4.44,
    'M-SI1-GOOD-VG-MEDIUM-GOOD': 4.44,
    'M-I1-EX-GOOD-FAINT-GOOD': 4.44,
    'M-SI1-VG-GOOD-MEDIUM-GOOD': 4.44,
    'M-I1-GOOD-POOR-FAINT-VG': 4.44,
    'M-SI1-EX-EX-MEDIUM-POOR': 4.44,
    'M-I1-VG-VG-FAINT-GOOD': 4.44,
    'M-I1-POOR-GOOD-FAINT-VG': 4.44,
    'M-SI1-POOR-POOR-MEDIUM-VG': 4.44,
    'M-SI1-POOR-EX-MEDIUM-GOOD': 4.44,
    'H-VS1-GOOD-POOR-STRONG-POOR': 4.43,
    'H-VS1-POOR-GOOD-STRONG-POOR': 4.43,
    'I-VS1-POOR-GOOD-MEDIUM-POOR': 4.43,
    'I-VVS1-POOR-POOR-STRONG-POOR': 4.43,
    'I-VS1-GOOD-POOR-MEDIUM-POOR': 4.43,
    'J-VS1-POOR-GOOD-FAINT-POOR': 4.43,
    'J-VS1-GOOD-POOR-FAINT-POOR': 4.43,
    'J-VVS1-POOR-POOR-MEDIUM-POOR': 4.43,
    'K-VS1-GOOD-POOR-NONE-POOR': 4.43,
    'K-VVS1-POOR-POOR-FAINT-POOR': 4.43,
    'K-VS1-POOR-GOOD-NONE-POOR': 4.43,
    'L-VVS1-POOR-POOR-NONE-POOR': 4.43,
    'M-VS1-GOOD-GOOD-STRONG-GOOD': 4.43,
    'M-VS1-VG-EX-STRONG-POOR': 4.43,
    'M-VS1-POOR-VG-STRONG-GOOD': 4.43,
    'M-VS1-EX-VG-STRONG-POOR': 4.43,
    'M-VS1-VG-POOR-STRONG-GOOD': 4.43,
    'E-I2-EX-POOR-STRONG-POOR': 4.42,
    'E-I2-GOOD-VG-STRONG-POOR': 4.42,
    'E-I2-POOR-EX-STRONG-POOR': 4.42,
    'E-I2-POOR-POOR-STRONG-GOOD': 4.42,
    'E-I2-VG-GOOD-STRONG-POOR': 4.42,
    'F-SI2-VG-POOR-STRONG-POOR': 4.42,
    'F-I2-VG-GOOD-MEDIUM-POOR': 4.42,
    'F-SI2-GOOD-GOOD-STRONG-POOR': 4.42,
    'F-I2-GOOD-VG-MEDIUM-POOR': 4.42,
    'F-I2-EX-POOR-MEDIUM-POOR': 4.42,
    'F-I2-POOR-EX-MEDIUM-POOR': 4.42,
    'F-I2-POOR-POOR-MEDIUM-GOOD': 4.42,
    'F-SI2-POOR-VG-STRONG-POOR': 4.42,
    'G-SI2-VG-POOR-MEDIUM-POOR': 4.42,
    'G-I2-POOR-EX-FAINT-POOR': 4.42,
    'G-I2-GOOD-VG-FAINT-POOR': 4.42,
    'G-SI2-POOR-VG-MEDIUM-POOR': 4.42,
    'G-I2-VG-GOOD-FAINT-POOR': 4.42,
    'G-SI2-GOOD-GOOD-MEDIUM-POOR': 4.42,
    'G-I2-EX-POOR-FAINT-POOR': 4.42,
    'G-I2-POOR-POOR-FAINT-GOOD': 4.42,
    'H-I2-POOR-EX-NONE-POOR': 4.42,
    'H-I2-GOOD-VG-NONE-POOR': 4.42,
    'H-I2-VG-GOOD-NONE-POOR': 4.42,
    'H-I2-EX-POOR-NONE-POOR': 4.42,
    'H-I2-POOR-POOR-NONE-GOOD': 4.42,
    'H-SI2-GOOD-GOOD-FAINT-POOR': 4.42,
    'H-SI2-VG-POOR-FAINT-POOR': 4.42,
    'H-SI2-POOR-VG-FAINT-POOR': 4.42,
    'I-SI2-POOR-VG-NONE-POOR': 4.42,
    'I-SI2-GOOD-GOOD-NONE-POOR': 4.42,
    'I-SI2-VG-POOR-NONE-POOR': 4.42,
    'J-I2-EX-GOOD-STRONG-GOOD': 4.42,
    'J-I2-VG-VG-STRONG-GOOD': 4.42,
    'J-I2-POOR-GOOD-STRONG-VG': 4.42,
    'J-I2-GOOD-POOR-STRONG-VG': 4.42,
    'J-I2-GOOD-EX-STRONG-GOOD': 4.42,
    'K-SI2-EX-EX-STRONG-POOR': 4.42,
    'K-I2-EX-GOOD-MEDIUM-GOOD': 4.42,
    'K-SI2-POOR-POOR-STRONG-VG': 4.42,
    'K-SI2-EX-POOR-STRONG-GOOD': 4.42,
    'K-I2-GOOD-EX-MEDIUM-GOOD': 4.42,
    'K-SI2-VG-GOOD-STRONG-GOOD': 4.42,
    'K-I2-POOR-GOOD-MEDIUM-VG': 4.42,
    'K-I2-GOOD-POOR-MEDIUM-VG': 4.42,
    'K-SI2-GOOD-VG-STRONG-GOOD': 4.42,
    'K-SI2-POOR-EX-STRONG-GOOD': 4.42,
    'K-I2-VG-VG-MEDIUM-GOOD': 4.42,
    'L-SI2-VG-GOOD-MEDIUM-GOOD': 4.42,
    'L-SI2-GOOD-VG-MEDIUM-GOOD': 4.42,
    'L-SI2-POOR-POOR-MEDIUM-VG': 4.42,
    'L-I2-EX-GOOD-FAINT-GOOD': 4.42,
    'L-SI2-POOR-EX-MEDIUM-GOOD': 4.42,
    'L-I2-VG-VG-FAINT-GOOD': 4.42,
    'L-I2-GOOD-EX-FAINT-GOOD': 4.42,
    'L-I2-POOR-GOOD-FAINT-VG': 4.42,
    'L-SI2-EX-POOR-MEDIUM-GOOD': 4.42,
    'L-I2-GOOD-POOR-FAINT-VG': 4.42,
    'L-SI2-EX-EX-MEDIUM-POOR': 4.42,
    'M-SI2-POOR-EX-FAINT-GOOD': 4.42,
    'M-SI2-VG-GOOD-FAINT-GOOD': 4.42,
    'M-SI2-EX-POOR-FAINT-GOOD': 4.42,
    'M-SI2-EX-EX-FAINT-POOR': 4.42,
    'M-I2-GOOD-EX-NONE-GOOD': 4.42,
    'M-SI2-GOOD-VG-FAINT-GOOD': 4.42,
    'M-I2-EX-GOOD-NONE-GOOD': 4.42,
    'M-I2-VG-VG-NONE-GOOD': 4.42,
    'M-I2-GOOD-POOR-NONE-VG': 4.42,
    'M-SI2-POOR-POOR-FAINT-VG': 4.42,
    'M-I2-POOR-GOOD-NONE-VG': 4.42,
    'G-VS2-GOOD-POOR-STRONG-POOR': 4.41,
    'G-VS2-POOR-GOOD-STRONG-POOR': 4.41,
    'H-VS2-POOR-GOOD-MEDIUM-POOR': 4.41,
    'H-VVS2-POOR-POOR-STRONG-POOR': 4.41,
    'H-VS2-GOOD-POOR-MEDIUM-POOR': 4.41,
    'I-VS2-POOR-GOOD-FAINT-POOR': 4.41,
    'I-VVS2-POOR-POOR-MEDIUM-POOR': 4.41,
    'I-VS2-GOOD-POOR-FAINT-POOR': 4.41,
    'J-VS2-GOOD-POOR-NONE-POOR': 4.41,
    'J-VVS2-POOR-POOR-FAINT-POOR': 4.41,
    'J-VS2-POOR-GOOD-NONE-POOR': 4.41,
    'K-VVS2-POOR-POOR-NONE-POOR': 4.41,
    'L-VS2-EX-VG-STRONG-POOR': 4.41,
    'L-VS2-VG-EX-STRONG-POOR': 4.41,
    'L-VS2-GOOD-GOOD-STRONG-GOOD': 4.41,
    'L-VS2-POOR-VG-STRONG-GOOD': 4.41,
    'L-VS2-VG-POOR-STRONG-GOOD': 4.41,
    'M-VVS2-POOR-GOOD-STRONG-GOOD': 4.41,
    'M-VS2-GOOD-GOOD-MEDIUM-GOOD': 4.41,
    'M-VS2-EX-VG-MEDIUM-POOR': 4.41,
    'M-VS2-POOR-VG-MEDIUM-GOOD': 4.41,
    'M-VVS2-GOOD-EX-STRONG-POOR': 4.41,
    'M-VS2-VG-POOR-MEDIUM-GOOD': 4.41,
    'M-VS2-VG-EX-MEDIUM-POOR': 4.41,
    'M-VVS2-EX-GOOD-STRONG-POOR': 4.41,
    'M-VVS2-VG-VG-STRONG-POOR': 4.41,
    'M-VVS2-GOOD-POOR-STRONG-GOOD': 4.41,
    'E-I1-GOOD-GOOD-STRONG-POOR': 4.39,
    'E-I1-VG-POOR-STRONG-POOR': 4.39,
    'E-I1-POOR-VG-STRONG-POOR': 4.39,
    'F-I1-POOR-VG-MEDIUM-POOR': 4.39,
    'F-I1-VG-POOR-MEDIUM-POOR': 4.39,
    'F-SI1-POOR-GOOD-STRONG-POOR': 4.39,
    'F-I1-GOOD-GOOD-MEDIUM-POOR': 4.39,
    'F-SI1-GOOD-POOR-STRONG-POOR': 4.39,
    'G-SI1-POOR-GOOD-MEDIUM-POOR': 4.39,
    'G-I1-VG-POOR-FAINT-POOR': 4.39,
    'G-I1-GOOD-GOOD-FAINT-POOR': 4.39,
    'G-SI1-GOOD-POOR-MEDIUM-POOR': 4.39,
    'G-I1-POOR-VG-FAINT-POOR': 4.39,
    'H-SI1-GOOD-POOR-FAINT-POOR': 4.39,
    'H-SI1-POOR-GOOD-FAINT-POOR': 4.39,
    'H-I1-GOOD-GOOD-NONE-POOR': 4.39,
    'H-I1-POOR-VG-NONE-POOR': 4.39,
    'H-I1-VG-POOR-NONE-POOR': 4.39,
    'I-SI1-POOR-GOOD-NONE-POOR': 4.39,
    'I-SI1-GOOD-POOR-NONE-POOR': 4.39,
    'J-I1-EX-EX-STRONG-POOR': 4.39,
    'J-I1-POOR-POOR-STRONG-VG': 4.39,
    'J-I1-POOR-EX-STRONG-GOOD': 4.39,
    'J-I1-GOOD-VG-STRONG-GOOD': 4.39,
    'J-I1-VG-GOOD-STRONG-GOOD': 4.39,
    'J-I1-EX-POOR-STRONG-GOOD': 4.39,
    'K-SI1-VG-EX-STRONG-POOR': 4.39,
    'K-I1-GOOD-VG-MEDIUM-GOOD': 4.39,
    'K-I1-EX-EX-MEDIUM-POOR': 4.39,
    'K-I1-EX-POOR-MEDIUM-GOOD': 4.39,
    'K-I1-VG-GOOD-MEDIUM-GOOD': 4.39,
    'K-SI1-GOOD-GOOD-STRONG-GOOD': 4.39,
    'K-SI1-POOR-VG-STRONG-GOOD': 4.39,
    'K-I1-POOR-EX-MEDIUM-GOOD': 4.39,
    'K-I1-POOR-POOR-MEDIUM-VG': 4.39,
    'K-SI1-VG-POOR-STRONG-GOOD': 4.39,
    'K-SI1-EX-VG-STRONG-POOR': 4.39,
    'L-SI1-GOOD-GOOD-MEDIUM-GOOD': 4.39,
    'L-I1-POOR-POOR-FAINT-VG': 4.39,
    'L-I1-POOR-EX-FAINT-GOOD': 4.39,
    'L-SI1-VG-POOR-MEDIUM-GOOD': 4.39,
    'L-SI1-VG-EX-MEDIUM-POOR': 4.39,
    'L-I1-EX-EX-FAINT-POOR': 4.39,
    'L-I1-EX-POOR-FAINT-GOOD': 4.39,
    'L-I1-VG-GOOD-FAINT-GOOD': 4.39,
    'L-SI1-EX-VG-MEDIUM-POOR': 4.39,
    'L-I1-GOOD-VG-FAINT-GOOD': 4.39,
    'L-SI1-POOR-VG-MEDIUM-GOOD': 4.39,
    'M-SI1-VG-POOR-FAINT-GOOD': 4.39,
    'M-I1-EX-POOR-NONE-GOOD': 4.39,
    'M-SI1-VG-EX-FAINT-POOR': 4.39,
    'M-I1-EX-EX-NONE-POOR': 4.39,
    'M-I1-VG-GOOD-NONE-GOOD': 4.39,
    'M-SI1-POOR-VG-FAINT-GOOD': 4.39,
    'M-I1-POOR-EX-NONE-GOOD': 4.39,
    'M-I1-POOR-POOR-NONE-VG': 4.39,
    'M-SI1-GOOD-GOOD-FAINT-GOOD': 4.39,
    'M-I1-GOOD-VG-NONE-GOOD': 4.39,
    'M-SI1-EX-VG-FAINT-POOR': 4.39,
    'G-VS1-POOR-POOR-STRONG-POOR': 4.38,
    'H-VS1-POOR-POOR-MEDIUM-POOR': 4.38,
    'I-VS1-POOR-POOR-FAINT-POOR': 4.38,
    'J-VS1-POOR-POOR-NONE-POOR': 4.38,
    'L-VS1-GOOD-EX-STRONG-POOR': 4.38,
    'L-VS1-POOR-GOOD-STRONG-GOOD': 4.38,
    'L-VS1-EX-GOOD-STRONG-POOR': 4.38,
    'L-VS1-GOOD-POOR-STRONG-GOOD': 4.38,
    'L-VS1-VG-VG-STRONG-POOR': 4.38,
    'M-VS1-EX-GOOD-MEDIUM-POOR': 4.38,
    'M-VVS1-VG-GOOD-STRONG-POOR': 4.38,
    'M-VVS1-POOR-POOR-STRONG-GOOD': 4.38,
    'M-VS1-GOOD-POOR-MEDIUM-GOOD': 4.38,
    'M-VVS1-EX-POOR-STRONG-POOR': 4.38,
    'M-VVS1-GOOD-VG-STRONG-POOR': 4.38,
    'M-VVS1-POOR-EX-STRONG-POOR': 4.38,
    'M-VS1-POOR-GOOD-MEDIUM-GOOD': 4.38,
    'M-VS1-VG-VG-MEDIUM-POOR': 4.38,
    'M-VS1-GOOD-EX-MEDIUM-POOR': 4.38,
    'D-I2-VG-POOR-STRONG-POOR': 4.37,
    'D-I2-POOR-VG-STRONG-POOR': 4.37,
    'D-I2-GOOD-GOOD-STRONG-POOR': 4.37,
    'E-I2-VG-POOR-MEDIUM-POOR': 4.37,
    'E-I2-POOR-VG-MEDIUM-POOR': 4.37,
    'E-I2-GOOD-GOOD-MEDIUM-POOR': 4.37,
    'E-SI2-GOOD-POOR-STRONG-POOR': 4.37,
    'E-SI2-POOR-GOOD-STRONG-POOR': 4.37,
    'F-I2-GOOD-GOOD-FAINT-POOR': 4.37,
    'F-SI2-POOR-GOOD-MEDIUM-POOR': 4.37,
    'F-SI2-GOOD-POOR-MEDIUM-POOR': 4.37,
    'F-I2-POOR-VG-FAINT-POOR': 4.37,
    'F-I2-VG-POOR-FAINT-POOR': 4.37,
    'G-SI2-POOR-GOOD-FAINT-POOR': 4.37,
    'G-I2-VG-POOR-NONE-POOR': 4.37,
    'G-I2-GOOD-GOOD-NONE-POOR': 4.37,
    'G-I2-POOR-VG-NONE-POOR': 4.37,
    'G-SI2-GOOD-POOR-FAINT-POOR': 4.37,
    'H-SI2-POOR-GOOD-NONE-POOR': 4.37,
    'H-SI2-GOOD-POOR-NONE-POOR': 4.37,
    'I-I2-EX-EX-STRONG-POOR': 4.37,
    'I-I2-GOOD-VG-STRONG-GOOD': 4.37,
    'I-I2-VG-GOOD-STRONG-GOOD': 4.37,
    'I-I2-EX-POOR-STRONG-GOOD': 4.37,
    'I-I2-POOR-POOR-STRONG-VG': 4.37,
    'I-I2-POOR-EX-STRONG-GOOD': 4.37,
    'J-SI2-VG-EX-STRONG-POOR': 4.37,
    'J-I2-VG-GOOD-MEDIUM-GOOD': 4.37,
    'J-I2-GOOD-VG-MEDIUM-GOOD': 4.37,
    'J-SI2-GOOD-GOOD-STRONG-GOOD': 4.37,
    'J-SI2-VG-POOR-STRONG-GOOD': 4.37,
    'J-SI2-POOR-VG-STRONG-GOOD': 4.37,
    'J-I2-EX-POOR-MEDIUM-GOOD': 4.37,
    'J-I2-EX-EX-MEDIUM-POOR': 4.37,
    'J-I2-POOR-EX-MEDIUM-GOOD': 4.37,
    'J-I2-POOR-POOR-MEDIUM-VG': 4.37,
    'J-SI2-EX-VG-STRONG-POOR': 4.37,
    'K-I2-POOR-POOR-FAINT-VG': 4.37,
    'K-SI2-EX-VG-MEDIUM-POOR': 4.37,
    'K-SI2-VG-EX-MEDIUM-POOR': 4.37,
    'K-I2-GOOD-VG-FAINT-GOOD': 4.37,
    'K-I2-EX-EX-FAINT-POOR': 4.37,
    'K-I2-POOR-EX-FAINT-GOOD': 4.37,
    'K-I2-EX-POOR-FAINT-GOOD': 4.37,
    'K-SI2-GOOD-GOOD-MEDIUM-GOOD': 4.37,
    'K-SI2-POOR-VG-MEDIUM-GOOD': 4.37,
    'K-I2-VG-GOOD-FAINT-GOOD': 4.37,
    'K-SI2-VG-POOR-MEDIUM-GOOD': 4.37,
    'L-I2-POOR-POOR-NONE-VG': 4.37,
    'L-I2-POOR-EX-NONE-GOOD': 4.37,
    'L-SI2-VG-EX-FAINT-POOR': 4.37,
    'L-I2-EX-EX-NONE-POOR': 4.37,
    'L-SI2-GOOD-GOOD-FAINT-GOOD': 4.37,
    'L-I2-EX-POOR-NONE-GOOD': 4.37,
    'L-I2-GOOD-VG-NONE-GOOD': 4.37,
    'L-I2-VG-GOOD-NONE-GOOD': 4.37,
    'L-SI2-EX-VG-FAINT-POOR': 4.37,
    'L-SI2-VG-POOR-FAINT-GOOD': 4.37,
    'L-SI2-POOR-VG-FAINT-GOOD': 4.37,
    'M-SI2-GOOD-GOOD-NONE-GOOD': 4.37,
    'M-SI2-POOR-VG-NONE-GOOD': 4.37,
    'M-SI2-VG-POOR-NONE-GOOD': 4.37,
    'M-SI2-EX-VG-NONE-POOR': 4.37,
    'M-SI2-VG-EX-NONE-POOR': 4.37,
    'F-VS2-POOR-POOR-STRONG-POOR': 4.36,
    'G-VS2-POOR-POOR-MEDIUM-POOR': 4.36,
    'H-VS2-POOR-POOR-FAINT-POOR': 4.36,
    'I-VS2-POOR-POOR-NONE-POOR': 4.36,
    'K-VS2-GOOD-POOR-STRONG-GOOD': 4.36,
    'K-VS2-POOR-GOOD-STRONG-GOOD': 4.36,
    'K-VS2-GOOD-EX-STRONG-POOR': 4.36,
    'K-VS2-VG-VG-STRONG-POOR': 4.36,
    'K-VS2-EX-GOOD-STRONG-POOR': 4.36,
    'L-VVS2-VG-GOOD-STRONG-POOR': 4.36,
    'L-VVS2-EX-POOR-STRONG-POOR': 4.36,
    'L-VS2-EX-GOOD-MEDIUM-POOR': 4.36,
    'L-VVS2-GOOD-VG-STRONG-POOR': 4.36,
    'L-VVS2-POOR-POOR-STRONG-GOOD': 4.36,
    'L-VVS2-POOR-EX-STRONG-POOR': 4.36,
    'L-VS2-POOR-GOOD-MEDIUM-GOOD': 4.36,
    'L-VS2-GOOD-POOR-MEDIUM-GOOD': 4.36,
    'L-VS2-GOOD-EX-MEDIUM-POOR': 4.36,
    'L-VS2-VG-VG-MEDIUM-POOR': 4.36,
    'M-VVS2-VG-GOOD-MEDIUM-POOR': 4.36,
    'M-VVS2-EX-POOR-MEDIUM-POOR': 4.36,
    'M-VVS2-POOR-EX-MEDIUM-POOR': 4.36,
    'M-VS2-GOOD-EX-FAINT-POOR': 4.36,
    'M-VVS2-POOR-POOR-MEDIUM-GOOD': 4.36,
    'M-VS2-POOR-GOOD-FAINT-GOOD': 4.36,
    'M-VS2-EX-GOOD-FAINT-POOR': 4.36,
    'M-VS2-VG-VG-FAINT-POOR': 4.36,
    'M-VS2-GOOD-POOR-FAINT-GOOD': 4.36,
    'M-VVS2-GOOD-VG-MEDIUM-POOR': 4.36,
    'M-IF-POOR-VG-STRONG-POOR': 4.35,
    'M-IF-GOOD-GOOD-STRONG-POOR': 4.35,
    'M-IF-VG-POOR-STRONG-POOR': 4.35,
    'D-I1-GOOD-POOR-STRONG-POOR': 4.34,
    'D-I1-POOR-GOOD-STRONG-POOR': 4.34,
    'E-SI1-POOR-POOR-STRONG-POOR': 4.34,
    'E-I1-GOOD-POOR-MEDIUM-POOR': 4.34,
    'E-I1-POOR-GOOD-MEDIUM-POOR': 4.34,
    'F-I1-POOR-GOOD-FAINT-POOR': 4.34,
    'F-SI1-POOR-POOR-MEDIUM-POOR': 4.34,
    'F-I1-GOOD-POOR-FAINT-POOR': 4.34,
    'G-I1-GOOD-POOR-NONE-POOR': 4.34,
    'G-SI1-POOR-POOR-FAINT-POOR': 4.34,
    'G-I1-POOR-GOOD-NONE-POOR': 4.34,
    'H-SI1-POOR-POOR-NONE-POOR': 4.34,
    'I-I1-EX-VG-STRONG-POOR': 4.34,
    'I-I1-POOR-VG-STRONG-GOOD': 4.34,
    'I-I1-GOOD-GOOD-STRONG-GOOD': 4.34,
    'I-I1-VG-POOR-STRONG-GOOD': 4.34,
    'I-I1-VG-EX-STRONG-POOR': 4.34,
    'J-SI1-GOOD-POOR-STRONG-GOOD': 4.34,
    'J-SI1-POOR-GOOD-STRONG-GOOD': 4.34,
    'J-SI1-GOOD-EX-STRONG-POOR': 4.34,
    'J-SI1-VG-VG-STRONG-POOR': 4.34,
    'J-SI1-EX-GOOD-STRONG-POOR': 4.34,
    'J-I1-EX-VG-MEDIUM-POOR': 4.34,
    'J-I1-VG-EX-MEDIUM-POOR': 4.34,
    'J-I1-VG-POOR-MEDIUM-GOOD': 4.34,
    'J-I1-GOOD-GOOD-MEDIUM-GOOD': 4.34,
    'J-I1-POOR-VG-MEDIUM-GOOD': 4.34,
    'K-I1-VG-EX-FAINT-POOR': 4.34,
    'K-SI1-EX-GOOD-MEDIUM-POOR': 4.34,
    'K-SI1-VG-VG-MEDIUM-POOR': 4.34,
    'K-SI1-GOOD-EX-MEDIUM-POOR': 4.34,
    'K-I1-GOOD-GOOD-FAINT-GOOD': 4.34,
    'K-SI1-POOR-GOOD-MEDIUM-GOOD': 4.34,
    'K-I1-EX-VG-FAINT-POOR': 4.34,
    'K-I1-POOR-VG-FAINT-GOOD': 4.34,
    'K-SI1-GOOD-POOR-MEDIUM-GOOD': 4.34,
    'K-I1-VG-POOR-FAINT-GOOD': 4.34,
    'L-I1-EX-VG-NONE-POOR': 4.34,
    'L-SI1-EX-GOOD-FAINT-POOR': 4.34,
    'L-I1-VG-POOR-NONE-GOOD': 4.34,
    'L-I1-VG-EX-NONE-POOR': 4.34,
    'L-I1-GOOD-GOOD-NONE-GOOD': 4.34,
    'L-SI1-VG-VG-FAINT-POOR': 4.34,
    'L-SI1-GOOD-EX-FAINT-POOR': 4.34,
    'L-SI1-GOOD-POOR-FAINT-GOOD': 4.34,
    'L-SI1-POOR-GOOD-FAINT-GOOD': 4.34,
    'L-I1-POOR-VG-NONE-GOOD': 4.34,
    'M-SI1-EX-GOOD-NONE-POOR': 4.34,
    'M-SI1-VG-VG-NONE-POOR': 4.34,
    'M-SI1-GOOD-EX-NONE-POOR': 4.34,
    'M-SI1-GOOD-POOR-NONE-GOOD': 4.34,
    'M-SI1-POOR-GOOD-NONE-GOOD': 4.34,
    'K-VS1-EX-POOR-STRONG-POOR': 4.33,
    'K-VS1-POOR-POOR-STRONG-GOOD': 4.33,
    'K-VS1-POOR-EX-STRONG-POOR': 4.33,
    'K-VS1-VG-GOOD-STRONG-POOR': 4.33,
    'K-VS1-GOOD-VG-STRONG-POOR': 4.33,
    'L-VVS1-GOOD-GOOD-STRONG-POOR': 4.33,
    'L-VVS1-POOR-VG-STRONG-POOR': 4.33,
    'L-VVS1-VG-POOR-STRONG-POOR': 4.33,
    'L-VS1-EX-POOR-MEDIUM-POOR': 4.33,
    'L-VS1-VG-GOOD-MEDIUM-POOR': 4.33,
    'L-VS1-GOOD-VG-MEDIUM-POOR': 4.33,
    'L-VS1-POOR-POOR-MEDIUM-GOOD': 4.33,
    'L-VS1-POOR-EX-MEDIUM-POOR': 4.33,
    'M-VS1-EX-POOR-FAINT-POOR': 4.33,
    'M-VS1-VG-GOOD-FAINT-POOR': 4.33,
    'M-VVS1-VG-POOR-MEDIUM-POOR': 4.33,
    'M-VS1-POOR-EX-FAINT-POOR': 4.33,
    'M-VS1-GOOD-VG-FAINT-POOR': 4.33,
    'M-VS1-POOR-POOR-FAINT-GOOD': 4.33,
    'M-VVS1-GOOD-GOOD-MEDIUM-POOR': 4.33,
    'M-VVS1-POOR-VG-MEDIUM-POOR': 4.33,
    'D-I2-GOOD-POOR-MEDIUM-POOR': 4.32,
    'D-I2-POOR-GOOD-MEDIUM-POOR': 4.32,
    'D-SI2-POOR-POOR-STRONG-POOR': 4.32,
    'E-I2-GOOD-POOR-FAINT-POOR': 4.32,
    'E-SI2-POOR-POOR-MEDIUM-POOR': 4.32,
    'E-I2-POOR-GOOD-FAINT-POOR': 4.32,
    'F-I2-GOOD-POOR-NONE-POOR': 4.32,
    'F-SI2-POOR-POOR-FAINT-POOR': 4.32,
    'F-I2-POOR-GOOD-NONE-POOR': 4.32,
    'G-SI2-POOR-POOR-NONE-POOR': 4.32,
    'H-I2-VG-EX-STRONG-POOR': 4.32,
    'H-I2-POOR-VG-STRONG-GOOD': 4.32,
    'H-I2-VG-POOR-STRONG-GOOD': 4.32,
    'H-I2-EX-VG-STRONG-POOR': 4.32,
    'H-I2-GOOD-GOOD-STRONG-GOOD': 4.32,
    'I-SI2-EX-GOOD-STRONG-POOR': 4.32,
    'I-I2-VG-POOR-MEDIUM-GOOD': 4.32,
    'I-SI2-VG-VG-STRONG-POOR': 4.32,
    'I-SI2-GOOD-POOR-STRONG-GOOD': 4.32,
    'I-I2-VG-EX-MEDIUM-POOR': 4.32,
    'I-SI2-GOOD-EX-STRONG-POOR': 4.32,
    'I-I2-GOOD-GOOD-MEDIUM-GOOD': 4.32,
    'I-I2-EX-VG-MEDIUM-POOR': 4.32,
    'I-I2-POOR-VG-MEDIUM-GOOD': 4.32,
    'I-SI2-POOR-GOOD-STRONG-GOOD': 4.32,
    'J-SI2-GOOD-EX-MEDIUM-POOR': 4.32,
    'J-SI2-POOR-GOOD-MEDIUM-GOOD': 4.32,
    'J-SI2-GOOD-POOR-MEDIUM-GOOD': 4.32,
    'J-I2-GOOD-GOOD-FAINT-GOOD': 4.32,
    'J-I2-POOR-VG-FAINT-GOOD': 4.32,
    'J-SI2-EX-GOOD-MEDIUM-POOR': 4.32,
    'J-SI2-VG-VG-MEDIUM-POOR': 4.32,
    'J-I2-VG-POOR-FAINT-GOOD': 4.32,
    'J-I2-VG-EX-FAINT-POOR': 4.32,
    'J-I2-EX-VG-FAINT-POOR': 4.32,
    'K-I2-VG-POOR-NONE-GOOD': 4.32,
    'K-SI2-VG-VG-FAINT-POOR': 4.32,
    'K-SI2-EX-GOOD-FAINT-POOR': 4.32,
    'K-SI2-GOOD-EX-FAINT-POOR': 4.32,
    'K-I2-GOOD-GOOD-NONE-GOOD': 4.32,
    'K-SI2-POOR-GOOD-FAINT-GOOD': 4.32,
    'K-SI2-GOOD-POOR-FAINT-GOOD': 4.32,
    'K-I2-POOR-VG-NONE-GOOD': 4.32,
    'K-I2-EX-VG-NONE-POOR': 4.32,
    'K-I2-VG-EX-NONE-POOR': 4.32,
    'L-SI2-GOOD-POOR-NONE-GOOD': 4.32,
    'L-SI2-POOR-GOOD-NONE-GOOD': 4.32,
    'L-SI2-GOOD-EX-NONE-POOR': 4.32,
    'L-SI2-VG-VG-NONE-POOR': 4.32,
    'L-SI2-EX-GOOD-NONE-POOR': 4.32,
    'M-I2-VG-GOOD-STRONG-VG': 4.32,
    'M-I2-POOR-EX-STRONG-VG': 4.32,
    'M-I2-EX-EX-STRONG-GOOD': 4.32,
    'M-I2-POOR-POOR-STRONG-EX': 4.32,
    'M-I2-GOOD-VG-STRONG-VG': 4.32,
    'M-I2-EX-POOR-STRONG-VG': 4.32,
    'J-VS2-POOR-EX-STRONG-POOR': 4.31,
    'J-VS2-GOOD-VG-STRONG-POOR': 4.31,
    'J-VS2-VG-GOOD-STRONG-POOR': 4.31,
    'J-VS2-POOR-POOR-STRONG-GOOD': 4.31,
    'J-VS2-EX-POOR-STRONG-POOR': 4.31,
    'K-VS2-POOR-EX-MEDIUM-POOR': 4.31,
    'K-VVS2-POOR-VG-STRONG-POOR': 4.31,
    'K-VS2-POOR-POOR-MEDIUM-GOOD': 4.31,
    'K-VVS2-GOOD-GOOD-STRONG-POOR': 4.31,
    'K-VVS2-VG-POOR-STRONG-POOR': 4.31,
    'K-VS2-EX-POOR-MEDIUM-POOR': 4.31,
    'K-VS2-GOOD-VG-MEDIUM-POOR': 4.31,
    'K-VS2-VG-GOOD-MEDIUM-POOR': 4.31,
    'L-VS2-VG-GOOD-FAINT-POOR': 4.31,
    'L-VVS2-POOR-VG-MEDIUM-POOR': 4.31,
    'L-VS2-EX-POOR-FAINT-POOR': 4.31,
    'L-VS2-POOR-EX-FAINT-POOR': 4.31,
    'L-VVS2-VG-POOR-MEDIUM-POOR': 4.31,
    'L-VS2-POOR-POOR-FAINT-GOOD': 4.31,
    'L-VVS2-GOOD-GOOD-MEDIUM-POOR': 4.31,
    'L-VS2-GOOD-VG-FAINT-POOR': 4.31,
    'M-VS2-POOR-EX-NONE-POOR': 4.31,
    'M-VS2-GOOD-VG-NONE-POOR': 4.31,
    'M-VVS2-POOR-VG-FAINT-POOR': 4.31,
    'M-VS2-EX-POOR-NONE-POOR': 4.31,
    'M-VS2-POOR-POOR-NONE-GOOD': 4.31,
    'M-VVS2-GOOD-GOOD-FAINT-POOR': 4.31,
    'M-VS2-VG-GOOD-NONE-POOR': 4.31,
    'M-VVS2-VG-POOR-FAINT-POOR': 4.31,
    'L-IF-GOOD-POOR-STRONG-POOR': 4.3,
    'L-IF-POOR-GOOD-STRONG-POOR': 4.3,
    'M-IF-POOR-GOOD-MEDIUM-POOR': 4.3,
    'M-IF-GOOD-POOR-MEDIUM-POOR': 4.3,
    'D-I1-POOR-POOR-MEDIUM-POOR': 4.29,
    'E-I1-POOR-POOR-FAINT-POOR': 4.29,
    'F-I1-POOR-POOR-NONE-POOR': 4.29,
    'H-I1-POOR-GOOD-STRONG-GOOD': 4.29,
    'H-I1-EX-GOOD-STRONG-POOR': 4.29,
    'H-I1-VG-VG-STRONG-POOR': 4.29,
    'H-I1-GOOD-EX-STRONG-POOR': 4.29,
    'H-I1-GOOD-POOR-STRONG-GOOD': 4.29,
    'I-SI1-POOR-POOR-STRONG-GOOD': 4.29,
    'I-SI1-VG-GOOD-STRONG-POOR': 4.29,
    'I-I1-GOOD-EX-MEDIUM-POOR': 4.29,
    'I-I1-GOOD-POOR-MEDIUM-GOOD': 4.29,
    'I-SI1-GOOD-VG-STRONG-POOR': 4.29,
    'I-SI1-POOR-EX-STRONG-POOR': 4.29,
    'I-I1-POOR-GOOD-MEDIUM-GOOD': 4.29,
    'I-SI1-EX-POOR-STRONG-POOR': 4.29,
    'I-I1-EX-GOOD-MEDIUM-POOR': 4.29,
    'I-I1-VG-VG-MEDIUM-POOR': 4.29,
    'J-I1-POOR-GOOD-FAINT-GOOD': 4.29,
    'J-SI1-POOR-POOR-MEDIUM-GOOD': 4.29,
    'J-I1-GOOD-POOR-FAINT-GOOD': 4.29,
    'J-I1-EX-GOOD-FAINT-POOR': 4.29,
    'J-I1-VG-VG-FAINT-POOR': 4.29,
    'J-I1-GOOD-EX-FAINT-POOR': 4.29,
    'J-SI1-EX-POOR-MEDIUM-POOR': 4.29,
    'J-SI1-VG-GOOD-MEDIUM-POOR': 4.29,
    'J-SI1-GOOD-VG-MEDIUM-POOR': 4.29,
    'J-SI1-POOR-EX-MEDIUM-POOR': 4.29,
    'K-I1-GOOD-EX-NONE-POOR': 4.29,
    'K-SI1-POOR-EX-FAINT-POOR': 4.29,
    'K-SI1-GOOD-VG-FAINT-POOR': 4.29,
    'K-SI1-POOR-POOR-FAINT-GOOD': 4.29,
    'K-I1-POOR-GOOD-NONE-GOOD': 4.29,
    'K-I1-EX-GOOD-NONE-POOR': 4.29,
    'K-I1-GOOD-POOR-NONE-GOOD': 4.29,
    'K-SI1-VG-GOOD-FAINT-POOR': 4.29,
    'K-SI1-EX-POOR-FAINT-POOR': 4.29,
    'K-I1-VG-VG-NONE-POOR': 4.29,
    'L-SI1-POOR-POOR-NONE-GOOD': 4.29,
    'L-SI1-POOR-EX-NONE-POOR': 4.29,
    'L-SI1-EX-POOR-NONE-POOR': 4.29,
    'L-SI1-VG-GOOD-NONE-POOR': 4.29,
    'L-SI1-GOOD-VG-NONE-POOR': 4.29,
    'M-I1-POOR-VG-STRONG-VG': 4.29,
    'M-I1-VG-EX-STRONG-GOOD': 4.29,
    'M-I1-VG-POOR-STRONG-VG': 4.29,
    'M-I1-EX-VG-STRONG-GOOD': 4.29,
    'M-I1-GOOD-GOOD-STRONG-VG': 4.29,
    'J-VS1-GOOD-GOOD-STRONG-POOR': 4.28,
    'J-VS1-POOR-VG-STRONG-POOR': 4.28,
    'J-VS1-VG-POOR-STRONG-POOR': 4.28,
    'K-VS1-GOOD-GOOD-MEDIUM-POOR': 4.28,
    'K-VVS1-GOOD-POOR-STRONG-POOR': 4.28,
    'K-VVS1-POOR-GOOD-STRONG-POOR': 4.28,
    'K-VS1-VG-POOR-MEDIUM-POOR': 4.28,
    'K-VS1-POOR-VG-MEDIUM-POOR': 4.28,
    'L-VVS1-POOR-GOOD-MEDIUM-POOR': 4.28,
    'L-VVS1-GOOD-POOR-MEDIUM-POOR': 4.28,
    'L-VS1-POOR-VG-FAINT-POOR': 4.28,
    'L-VS1-GOOD-GOOD-FAINT-POOR': 4.28,
    'L-VS1-VG-POOR-FAINT-POOR': 4.28,
    'M-VVS1-POOR-GOOD-FAINT-POOR': 4.28,
    'M-VS1-VG-POOR-NONE-POOR': 4.28,
    'M-VS1-GOOD-GOOD-NONE-POOR': 4.28,
    'M-VVS1-GOOD-POOR-FAINT-POOR': 4.28,
    'M-VS1-POOR-VG-NONE-POOR': 4.28,
    'D-I2-POOR-POOR-FAINT-POOR': 4.27,
    'E-I2-POOR-POOR-NONE-POOR': 4.27,
    'G-I2-POOR-GOOD-STRONG-GOOD': 4.27,
    'G-I2-EX-GOOD-STRONG-POOR': 4.27,
    'G-I2-GOOD-POOR-STRONG-GOOD': 4.27,
    'G-I2-VG-VG-STRONG-POOR': 4.27,
    'G-I2-GOOD-EX-STRONG-POOR': 4.27,
    'H-I2-EX-GOOD-MEDIUM-POOR': 4.27,
    'H-I2-VG-VG-MEDIUM-POOR': 4.27,
    'H-I2-GOOD-POOR-MEDIUM-GOOD': 4.27,
    'H-I2-GOOD-EX-MEDIUM-POOR': 4.27,
    'H-SI2-EX-POOR-STRONG-POOR': 4.27,
    'H-SI2-VG-GOOD-STRONG-POOR': 4.27,
    'H-SI2-GOOD-VG-STRONG-POOR': 4.27,
    'H-SI2-POOR-EX-STRONG-POOR': 4.27,
    'H-I2-POOR-GOOD-MEDIUM-GOOD': 4.27,
    'H-SI2-POOR-POOR-STRONG-GOOD': 4.27,
    'I-I2-EX-GOOD-FAINT-POOR': 4.27,
    'I-SI2-GOOD-VG-MEDIUM-POOR': 4.27,
    'I-SI2-VG-GOOD-MEDIUM-POOR': 4.27,
    'I-SI2-POOR-EX-MEDIUM-POOR': 4.27,
    'I-SI2-POOR-POOR-MEDIUM-GOOD': 4.27,
    'I-I2-VG-VG-FAINT-POOR': 4.27,
    'I-I2-GOOD-EX-FAINT-POOR': 4.27,
    'I-I2-GOOD-POOR-FAINT-GOOD': 4.27,
    'I-I2-POOR-GOOD-FAINT-GOOD': 4.27,
    'I-SI2-EX-POOR-MEDIUM-POOR': 4.27,
    'J-I2-EX-GOOD-NONE-POOR': 4.27,
    'J-I2-VG-VG-NONE-POOR': 4.27,
    'J-I2-GOOD-POOR-NONE-GOOD': 4.27,
    'J-I2-POOR-GOOD-NONE-GOOD': 4.27,
    'J-I2-GOOD-EX-NONE-POOR': 4.27,
    'J-SI2-EX-POOR-FAINT-POOR': 4.27,
    'J-SI2-POOR-POOR-FAINT-GOOD': 4.27,
    'J-SI2-VG-GOOD-FAINT-POOR': 4.27,
    'J-SI2-POOR-EX-FAINT-POOR': 4.27,
    'J-SI2-GOOD-VG-FAINT-POOR': 4.27,
    'K-SI2-POOR-POOR-NONE-GOOD': 4.27,
    'K-SI2-POOR-EX-NONE-POOR': 4.27,
    'K-SI2-GOOD-VG-NONE-POOR': 4.27,
    'K-SI2-VG-GOOD-NONE-POOR': 4.27,
    'K-SI2-EX-POOR-NONE-POOR': 4.27,
    'L-I2-EX-VG-STRONG-GOOD': 4.27,
    'L-I2-VG-EX-STRONG-GOOD': 4.27,
    'L-I2-VG-POOR-STRONG-VG': 4.27,
    'L-I2-GOOD-GOOD-STRONG-VG': 4.27,
    'L-I2-POOR-VG-STRONG-VG': 4.27,
    'M-I2-EX-VG-MEDIUM-GOOD': 4.27,
    'M-I2-VG-POOR-MEDIUM-VG': 4.27,
    'M-I2-VG-EX-MEDIUM-GOOD': 4.27,
    'M-I2-POOR-VG-MEDIUM-VG': 4.27,
    'M-I2-GOOD-GOOD-MEDIUM-VG': 4.27,
    'M-SI2-POOR-GOOD-STRONG-VG': 4.27,
    'M-SI2-GOOD-POOR-STRONG-VG': 4.27,
    'M-SI2-GOOD-EX-STRONG-GOOD': 4.27,
    'M-SI2-VG-VG-STRONG-GOOD': 4.27,
    'M-SI2-EX-GOOD-STRONG-GOOD': 4.27,
    'I-VS2-VG-POOR-STRONG-POOR': 4.26,
    'I-VS2-GOOD-GOOD-STRONG-POOR': 4.26,
    'I-VS2-POOR-VG-STRONG-POOR': 4.26,
    'J-VVS2-POOR-GOOD-STRONG-POOR': 4.26,
    'J-VS2-GOOD-GOOD-MEDIUM-POOR': 4.26,
    'J-VS2-POOR-VG-MEDIUM-POOR': 4.26,
    'J-VS2-VG-POOR-MEDIUM-POOR': 4.26,
    'J-VVS2-GOOD-POOR-STRONG-POOR': 4.26,
    'K-VVS2-POOR-GOOD-MEDIUM-POOR': 4.26,
    'K-VVS2-GOOD-POOR-MEDIUM-POOR': 4.26,
    'K-VS2-VG-POOR-FAINT-POOR': 4.26,
    'K-VS2-GOOD-GOOD-FAINT-POOR': 4.26,
    'K-VS2-POOR-VG-FAINT-POOR': 4.26,
    'L-VS2-POOR-VG-NONE-POOR': 4.26,
    'L-VS2-VG-POOR-NONE-POOR': 4.26,
    'L-VS2-GOOD-GOOD-NONE-POOR': 4.26,
    'L-VVS2-POOR-GOOD-FAINT-POOR': 4.26,
    'L-VVS2-GOOD-POOR-FAINT-POOR': 4.26,
    'M-VVS2-GOOD-POOR-NONE-POOR': 4.26,
    'M-VVS2-POOR-GOOD-NONE-POOR': 4.26,
    'K-IF-POOR-POOR-STRONG-POOR': 4.25,
    'L-IF-POOR-POOR-MEDIUM-POOR': 4.25,
    'M-IF-POOR-POOR-FAINT-POOR': 4.25,
    'G-I1-POOR-EX-STRONG-POOR': 4.24,
    'G-I1-POOR-POOR-STRONG-GOOD': 4.24,
    'G-I1-VG-GOOD-STRONG-POOR': 4.24,
    'G-I1-GOOD-VG-STRONG-POOR': 4.24,
    'G-I1-EX-POOR-STRONG-POOR': 4.24,
    'H-I1-POOR-EX-MEDIUM-POOR': 4.24,
    'H-I1-GOOD-VG-MEDIUM-POOR': 4.24,
    'H-I1-VG-GOOD-MEDIUM-POOR': 4.24,
    'H-SI1-VG-POOR-STRONG-POOR': 4.24,
    'H-SI1-GOOD-GOOD-STRONG-POOR': 4.24,
    'H-SI1-POOR-VG-STRONG-POOR': 4.24,
    'H-I1-EX-POOR-MEDIUM-POOR': 4.24,
    'H-I1-POOR-POOR-MEDIUM-GOOD': 4.24,
    'I-SI1-POOR-VG-MEDIUM-POOR': 4.24,
    'I-SI1-GOOD-GOOD-MEDIUM-POOR': 4.24,
    'I-I1-POOR-EX-FAINT-POOR': 4.24,
    'I-I1-POOR-POOR-FAINT-GOOD': 4.24,
    'I-I1-GOOD-VG-FAINT-POOR': 4.24,
    'I-I1-VG-GOOD-FAINT-POOR': 4.24,
    'I-I1-EX-POOR-FAINT-POOR': 4.24,
    'I-SI1-VG-POOR-MEDIUM-POOR': 4.24,
    'J-I1-POOR-POOR-NONE-GOOD': 4.24,
    'J-SI1-VG-POOR-FAINT-POOR': 4.24,
    'J-SI1-GOOD-GOOD-FAINT-POOR': 4.24,
    'J-SI1-POOR-VG-FAINT-POOR': 4.24,
    'J-I1-POOR-EX-NONE-POOR': 4.24,
    'J-I1-GOOD-VG-NONE-POOR': 4.24,
    'J-I1-EX-POOR-NONE-POOR': 4.24,
    'J-I1-VG-GOOD-NONE-POOR': 4.24,
    'K-SI1-POOR-VG-NONE-POOR': 4.24,
    'K-SI1-GOOD-GOOD-NONE-POOR': 4.24,
    'K-SI1-VG-POOR-NONE-POOR': 4.24,
    'L-I1-POOR-GOOD-STRONG-VG': 4.24,
    'L-I1-GOOD-POOR-STRONG-VG': 4.24,
    'L-I1-GOOD-EX-STRONG-GOOD': 4.24,
    'L-I1-VG-VG-STRONG-GOOD': 4.24,
    'L-I1-EX-GOOD-STRONG-GOOD': 4.24,
    'M-SI1-GOOD-VG-STRONG-GOOD': 4.24,
    'M-SI1-POOR-POOR-STRONG-VG': 4.24,
    'M-SI1-POOR-EX-STRONG-GOOD': 4.24,
    'M-SI1-VG-GOOD-STRONG-GOOD': 4.24,
    'M-SI1-EX-POOR-STRONG-GOOD': 4.24,
    'M-SI1-EX-EX-STRONG-POOR': 4.24,
    'M-I1-VG-VG-MEDIUM-GOOD': 4.24,
    'M-I1-EX-GOOD-MEDIUM-GOOD': 4.24,
    'M-I1-POOR-GOOD-MEDIUM-VG': 4.24,
    'M-I1-GOOD-POOR-MEDIUM-VG': 4.24,
    'M-I1-GOOD-EX-MEDIUM-GOOD': 4.24,
    'I-VS1-POOR-GOOD-STRONG-POOR': 4.23,
    'I-VS1-GOOD-POOR-STRONG-POOR': 4.23,
    'J-VS1-GOOD-POOR-MEDIUM-POOR': 4.23,
    'J-VVS1-POOR-POOR-STRONG-POOR': 4.23,
    'J-VS1-POOR-GOOD-MEDIUM-POOR': 4.23,
    'K-VS1-GOOD-POOR-FAINT-POOR': 4.23,
    'K-VS1-POOR-GOOD-FAINT-POOR': 4.23,
    'K-VVS1-POOR-POOR-MEDIUM-POOR': 4.23,
    'L-VS1-GOOD-POOR-NONE-POOR': 4.23,
    'L-VS1-POOR-GOOD-NONE-POOR': 4.23,
    'L-VVS1-POOR-POOR-FAINT-POOR': 4.23,
    'M-VVS1-POOR-POOR-NONE-POOR': 4.23,
    'F-I2-EX-POOR-STRONG-POOR': 4.22,
    'F-I2-VG-GOOD-STRONG-POOR': 4.22,
    'F-I2-GOOD-VG-STRONG-POOR': 4.22,
    'F-I2-POOR-POOR-STRONG-GOOD': 4.22,
    'F-I2-POOR-EX-STRONG-POOR': 4.22,
    'G-SI2-VG-POOR-STRONG-POOR': 4.22,
    'G-SI2-GOOD-GOOD-STRONG-POOR': 4.22,
    'G-SI2-POOR-VG-STRONG-POOR': 4.22,
    'G-I2-POOR-POOR-MEDIUM-GOOD': 4.22,
    'G-I2-GOOD-VG-MEDIUM-POOR': 4.22,
    'G-I2-VG-GOOD-MEDIUM-POOR': 4.22,
    'G-I2-EX-POOR-MEDIUM-POOR': 4.22,
    'G-I2-POOR-EX-MEDIUM-POOR': 4.22,
    'H-I2-GOOD-VG-FAINT-POOR': 4.22,
    'H-I2-POOR-POOR-FAINT-GOOD': 4.22,
    'H-I2-POOR-EX-FAINT-POOR': 4.22,
    'H-I2-EX-POOR-FAINT-POOR': 4.22,
    'H-I2-VG-GOOD-FAINT-POOR': 4.22,
    'H-SI2-VG-POOR-MEDIUM-POOR': 4.22,
    'H-SI2-GOOD-GOOD-MEDIUM-POOR': 4.22,
    'H-SI2-POOR-VG-MEDIUM-POOR': 4.22,
    'I-I2-EX-POOR-NONE-POOR': 4.22,
    'I-I2-GOOD-VG-NONE-POOR': 4.22,
    'I-I2-VG-GOOD-NONE-POOR': 4.22,
    'I-SI2-VG-POOR-FAINT-POOR': 4.22,
    'I-SI2-POOR-VG-FAINT-POOR': 4.22,
    'I-SI2-GOOD-GOOD-FAINT-POOR': 4.22,
    'I-I2-POOR-POOR-NONE-GOOD': 4.22,
    'I-I2-POOR-EX-NONE-POOR': 4.22,
    'J-SI2-POOR-VG-NONE-POOR': 4.22,
    'J-SI2-GOOD-GOOD-NONE-POOR': 4.22,
    'J-SI2-VG-POOR-NONE-POOR': 4.22,
    'K-I2-GOOD-POOR-STRONG-VG': 4.22,
    'K-I2-VG-VG-STRONG-GOOD': 4.22,
    'K-I2-EX-GOOD-STRONG-GOOD': 4.22,
    'K-I2-GOOD-EX-STRONG-GOOD': 4.22,
    'K-I2-POOR-GOOD-STRONG-VG': 4.22,
    'L-SI2-POOR-POOR-STRONG-VG': 4.22,
    'L-SI2-POOR-EX-STRONG-GOOD': 4.22,
    'L-SI2-GOOD-VG-STRONG-GOOD': 4.22,
    'L-SI2-VG-GOOD-STRONG-GOOD': 4.22,
    'L-SI2-EX-POOR-STRONG-GOOD': 4.22,
    'L-SI2-EX-EX-STRONG-POOR': 4.22,
    'L-I2-POOR-GOOD-MEDIUM-VG': 4.22,
    'L-I2-GOOD-POOR-MEDIUM-VG': 4.22,
    'L-I2-GOOD-EX-MEDIUM-GOOD': 4.22,
    'L-I2-VG-VG-MEDIUM-GOOD': 4.22,
    'L-I2-EX-GOOD-MEDIUM-GOOD': 4.22,
    'M-SI2-GOOD-VG-MEDIUM-GOOD': 4.22,
    'M-I2-GOOD-POOR-FAINT-VG': 4.22,
    'M-I2-POOR-GOOD-FAINT-VG': 4.22,
    'M-I2-GOOD-EX-FAINT-GOOD': 4.22,
    'M-I2-VG-VG-FAINT-GOOD': 4.22,
    'M-SI2-POOR-EX-MEDIUM-GOOD': 4.22,
    'M-SI2-EX-POOR-MEDIUM-GOOD': 4.22,
    'M-I2-EX-GOOD-FAINT-GOOD': 4.22,
    'M-SI2-POOR-POOR-MEDIUM-VG': 4.22,
    'M-SI2-EX-EX-MEDIUM-POOR': 4.22,
    'M-SI2-VG-GOOD-MEDIUM-GOOD': 4.22,
    'H-VS2-GOOD-POOR-STRONG-POOR': 4.21,
    'H-VS2-POOR-GOOD-STRONG-POOR': 4.21,
    'I-VVS2-POOR-POOR-STRONG-POOR': 4.21,
    'I-VS2-POOR-GOOD-MEDIUM-POOR': 4.21,
    'I-VS2-GOOD-POOR-MEDIUM-POOR': 4.21,
    'J-VVS2-POOR-POOR-MEDIUM-POOR': 4.21,
    'J-VS2-GOOD-POOR-FAINT-POOR': 4.21,
    'J-VS2-POOR-GOOD-FAINT-POOR': 4.21,
    'K-VVS2-POOR-POOR-FAINT-POOR': 4.21,
    'K-VS2-GOOD-POOR-NONE-POOR': 4.21,
    'K-VS2-POOR-GOOD-NONE-POOR': 4.21,
    'L-VVS2-POOR-POOR-NONE-POOR': 4.21,
    'M-VS2-EX-VG-STRONG-POOR': 4.21,
    'M-VS2-VG-EX-STRONG-POOR': 4.21,
    'M-VS2-POOR-VG-STRONG-GOOD': 4.21,
    'M-VS2-GOOD-GOOD-STRONG-GOOD': 4.21,
    'M-VS2-VG-POOR-STRONG-GOOD': 4.21,
    'F-I1-VG-POOR-STRONG-POOR': 4.19,
    'F-I1-POOR-VG-STRONG-POOR': 4.19,
    'F-I1-GOOD-GOOD-STRONG-POOR': 4.19,
    'G-SI1-POOR-GOOD-STRONG-POOR': 4.19,
    'G-I1-VG-POOR-MEDIUM-POOR': 4.19,
    'G-I1-GOOD-GOOD-MEDIUM-POOR': 4.19,
    'G-I1-POOR-VG-MEDIUM-POOR': 4.19,
    'G-SI1-GOOD-POOR-STRONG-POOR': 4.19,
    'H-I1-VG-POOR-FAINT-POOR': 4.19,
    'H-I1-GOOD-GOOD-FAINT-POOR': 4.19,
    'H-SI1-POOR-GOOD-MEDIUM-POOR': 4.19,
    'H-SI1-GOOD-POOR-MEDIUM-POOR': 4.19,
    'H-I1-POOR-VG-FAINT-POOR': 4.19,
    'I-I1-VG-POOR-NONE-POOR': 4.19,
    'I-I1-GOOD-GOOD-NONE-POOR': 4.19,
    'I-I1-POOR-VG-NONE-POOR': 4.19,
    'I-SI1-POOR-GOOD-FAINT-POOR': 4.19,
    'I-SI1-GOOD-POOR-FAINT-POOR': 4.19,
    'J-SI1-GOOD-POOR-NONE-POOR': 4.19,
    'J-SI1-POOR-GOOD-NONE-POOR': 4.19,
    'K-I1-EX-POOR-STRONG-GOOD': 4.19,
    'K-I1-VG-GOOD-STRONG-GOOD': 4.19,
    'K-I1-GOOD-VG-STRONG-GOOD': 4.19,
    'K-I1-POOR-EX-STRONG-GOOD': 4.19,
    'K-I1-POOR-POOR-STRONG-VG': 4.19,
    'K-I1-EX-EX-STRONG-POOR': 4.19,
    'L-I1-EX-POOR-MEDIUM-GOOD': 4.19,
    'L-I1-POOR-EX-MEDIUM-GOOD': 4.19,
    'L-SI1-POOR-VG-STRONG-GOOD': 4.19,
    'L-SI1-GOOD-GOOD-STRONG-GOOD': 4.19,
    'L-I1-GOOD-VG-MEDIUM-GOOD': 4.19,
    'L-SI1-VG-POOR-STRONG-GOOD': 4.19,
    'L-SI1-VG-EX-STRONG-POOR': 4.19,
    'L-SI1-EX-VG-STRONG-POOR': 4.19,
    'L-I1-VG-GOOD-MEDIUM-GOOD': 4.19,
    'L-I1-POOR-POOR-MEDIUM-VG': 4.19,
    'L-I1-EX-EX-MEDIUM-POOR': 4.19,
    'M-I1-POOR-POOR-FAINT-VG': 4.19,
    'M-I1-GOOD-VG-FAINT-GOOD': 4.19,
    'M-SI1-VG-EX-MEDIUM-POOR': 4.19,
    'M-I1-VG-GOOD-FAINT-GOOD': 4.19,
    'M-SI1-EX-VG-MEDIUM-POOR': 4.19,
    'M-I1-EX-POOR-FAINT-GOOD': 4.19,
    'M-SI1-POOR-VG-MEDIUM-GOOD': 4.19,
    'M-I1-EX-EX-FAINT-POOR': 4.19,
    'M-SI1-GOOD-GOOD-MEDIUM-GOOD': 4.19,
    'M-I1-POOR-EX-FAINT-GOOD': 4.19,
    'M-SI1-VG-POOR-MEDIUM-GOOD': 4.19,
    'H-VS1-POOR-POOR-STRONG-POOR': 4.18,
    'I-VS1-POOR-POOR-MEDIUM-POOR': 4.18,
    'J-VS1-POOR-POOR-FAINT-POOR': 4.18,
    'K-VS1-POOR-POOR-NONE-POOR': 4.18,
    'M-VS1-GOOD-EX-STRONG-POOR': 4.18,
    'M-VS1-VG-VG-STRONG-POOR': 4.18,
    'M-VS1-GOOD-POOR-STRONG-GOOD': 4.18,
    'M-VS1-EX-GOOD-STRONG-POOR': 4.18,
    'M-VS1-POOR-GOOD-STRONG-GOOD': 4.18,
    'E-I2-VG-POOR-STRONG-POOR': 4.17,
    'E-I2-GOOD-GOOD-STRONG-POOR': 4.17,
    'E-I2-POOR-VG-STRONG-POOR': 4.17,
    'F-I2-GOOD-GOOD-MEDIUM-POOR': 4.17,
    'F-I2-POOR-VG-MEDIUM-POOR': 4.17,
    'F-I2-VG-POOR-MEDIUM-POOR': 4.17,
    'F-SI2-POOR-GOOD-STRONG-POOR': 4.17,
    'F-SI2-GOOD-POOR-STRONG-POOR': 4.17,
    'G-I2-POOR-VG-FAINT-POOR': 4.17,
    'G-I2-GOOD-GOOD-FAINT-POOR': 4.17,
    'G-SI2-GOOD-POOR-MEDIUM-POOR': 4.17,
    'G-SI2-POOR-GOOD-MEDIUM-POOR': 4.17,
    'G-I2-VG-POOR-FAINT-POOR': 4.17,
    'H-SI2-POOR-GOOD-FAINT-POOR': 4.17,
    'H-SI2-GOOD-POOR-FAINT-POOR': 4.17,
    'H-I2-POOR-VG-NONE-POOR': 4.17,
    'H-I2-GOOD-GOOD-NONE-POOR': 4.17,
    'H-I2-VG-POOR-NONE-POOR': 4.17,
    'I-SI2-POOR-GOOD-NONE-POOR': 4.17,
    'I-SI2-GOOD-POOR-NONE-POOR': 4.17,
    'J-I2-EX-POOR-STRONG-GOOD': 4.17,
    'J-I2-EX-EX-STRONG-POOR': 4.17,
    'J-I2-VG-GOOD-STRONG-GOOD': 4.17,
    'J-I2-POOR-POOR-STRONG-VG': 4.17,
    'J-I2-GOOD-VG-STRONG-GOOD': 4.17,
    'J-I2-POOR-EX-STRONG-GOOD': 4.17,
    'K-SI2-VG-POOR-STRONG-GOOD': 4.17,
    'K-SI2-EX-VG-STRONG-POOR': 4.17,
    'K-I2-VG-GOOD-MEDIUM-GOOD': 4.17,
    'K-I2-GOOD-VG-MEDIUM-GOOD': 4.17,
    'K-I2-POOR-EX-MEDIUM-GOOD': 4.17,
    'K-I2-EX-POOR-MEDIUM-GOOD': 4.17,
    'K-I2-POOR-POOR-MEDIUM-VG': 4.17,
    'K-I2-EX-EX-MEDIUM-POOR': 4.17,
    'K-SI2-GOOD-GOOD-STRONG-GOOD': 4.17,
    'K-SI2-VG-EX-STRONG-POOR': 4.17,
    'K-SI2-POOR-VG-STRONG-GOOD': 4.17,
    'L-I2-GOOD-VG-FAINT-GOOD': 4.17,
    'L-SI2-EX-VG-MEDIUM-POOR': 4.17,
    'L-I2-EX-EX-FAINT-POOR': 4.17,
    'L-I2-POOR-EX-FAINT-GOOD': 4.17,
    'L-SI2-GOOD-GOOD-MEDIUM-GOOD': 4.17,
    'L-I2-EX-POOR-FAINT-GOOD': 4.17,
    'L-I2-VG-GOOD-FAINT-GOOD': 4.17,
    'L-SI2-POOR-VG-MEDIUM-GOOD': 4.17,
    'L-I2-POOR-POOR-FAINT-VG': 4.17,
    'L-SI2-VG-EX-MEDIUM-POOR': 4.17,
    'L-SI2-VG-POOR-MEDIUM-GOOD': 4.17,
    'M-SI2-POOR-VG-FAINT-GOOD': 4.17,
    'M-SI2-VG-EX-FAINT-POOR': 4.17,
    'M-I2-VG-GOOD-NONE-GOOD': 4.17,
    'M-SI2-VG-POOR-FAINT-GOOD': 4.17,
    'M-I2-EX-POOR-NONE-GOOD': 4.17,
    'M-SI2-EX-VG-FAINT-POOR': 4.17,
    'M-SI2-GOOD-GOOD-FAINT-GOOD': 4.17,
    'M-I2-POOR-POOR-NONE-VG': 4.17,
    'M-I2-EX-EX-NONE-POOR': 4.17,
    'M-I2-GOOD-VG-NONE-GOOD': 4.17,
    'M-I2-POOR-EX-NONE-GOOD': 4.17,
    'G-VS2-POOR-POOR-STRONG-POOR': 4.16,
    'H-VS2-POOR-POOR-MEDIUM-POOR': 4.16,
    'I-VS2-POOR-POOR-FAINT-POOR': 4.16,
    'J-VS2-POOR-POOR-NONE-POOR': 4.16,
    'L-VS2-GOOD-EX-STRONG-POOR': 4.16,
    'L-VS2-EX-GOOD-STRONG-POOR': 4.16,
    'L-VS2-VG-VG-STRONG-POOR': 4.16,
    'L-VS2-GOOD-POOR-STRONG-GOOD': 4.16,
    'L-VS2-POOR-GOOD-STRONG-GOOD': 4.16,
    'M-VS2-GOOD-POOR-MEDIUM-GOOD': 4.16,
    'M-VVS2-POOR-EX-STRONG-POOR': 4.16,
    'M-VVS2-POOR-POOR-STRONG-GOOD': 4.16,
    'M-VVS2-GOOD-VG-STRONG-POOR': 4.16,
    'M-VS2-GOOD-EX-MEDIUM-POOR': 4.16,
    'M-VVS2-VG-GOOD-STRONG-POOR': 4.16,
    'M-VS2-EX-GOOD-MEDIUM-POOR': 4.16,
    'M-VS2-POOR-GOOD-MEDIUM-GOOD': 4.16,
    'M-VS2-VG-VG-MEDIUM-POOR': 4.16,
    'M-VVS2-EX-POOR-STRONG-POOR': 4.16,
    'E-I1-GOOD-POOR-STRONG-POOR': 4.14,
    'E-I1-POOR-GOOD-STRONG-POOR': 4.14,
    'F-SI1-POOR-POOR-STRONG-POOR': 4.14,
    'F-I1-POOR-GOOD-MEDIUM-POOR': 4.14,
    'F-I1-GOOD-POOR-MEDIUM-POOR': 4.14,
    'G-I1-GOOD-POOR-FAINT-POOR': 4.14,
    'G-I1-POOR-GOOD-FAINT-POOR': 4.14,
    'G-SI1-POOR-POOR-MEDIUM-POOR': 4.14,
    'H-SI1-POOR-POOR-FAINT-POOR': 4.14,
    'H-I1-GOOD-POOR-NONE-POOR': 4.14,
    'H-I1-POOR-GOOD-NONE-POOR': 4.14,
    'I-SI1-POOR-POOR-NONE-POOR': 4.14,
    'J-I1-POOR-VG-STRONG-GOOD': 4.14,
    'J-I1-GOOD-GOOD-STRONG-GOOD': 4.14,
    'J-I1-VG-POOR-STRONG-GOOD': 4.14,
    'J-I1-VG-EX-STRONG-POOR': 4.14,
    'J-I1-EX-VG-STRONG-POOR': 4.14,
    'K-SI1-EX-GOOD-STRONG-POOR': 4.14,
    'K-I1-POOR-VG-MEDIUM-GOOD': 4.14,
    'K-I1-GOOD-GOOD-MEDIUM-GOOD': 4.14,
    'K-I1-VG-POOR-MEDIUM-GOOD': 4.14,
    'K-I1-EX-VG-MEDIUM-POOR': 4.14,
    'K-I1-VG-EX-MEDIUM-POOR': 4.14,
    'K-SI1-GOOD-EX-STRONG-POOR': 4.14,
    'K-SI1-GOOD-POOR-STRONG-GOOD': 4.14,
    'K-SI1-POOR-GOOD-STRONG-GOOD': 4.14,
    'K-SI1-VG-VG-STRONG-POOR': 4.14,
    'L-I1-GOOD-GOOD-FAINT-GOOD': 4.14,
    'L-I1-VG-POOR-FAINT-GOOD': 4.14,
    'L-I1-POOR-VG-FAINT-GOOD': 4.14,
    'L-I1-EX-VG-FAINT-POOR': 4.14,
    'L-SI1-GOOD-EX-MEDIUM-POOR': 4.14,
    'L-SI1-GOOD-POOR-MEDIUM-GOOD': 4.14,
    'L-SI1-POOR-GOOD-MEDIUM-GOOD': 4.14,
    'L-SI1-VG-VG-MEDIUM-POOR': 4.14,
    'L-I1-VG-EX-FAINT-POOR': 4.14,
    'L-SI1-EX-GOOD-MEDIUM-POOR': 4.14,
    'M-I1-VG-POOR-NONE-GOOD': 4.14,
    'M-I1-VG-EX-NONE-POOR': 4.14,
    'M-I1-EX-VG-NONE-POOR': 4.14,
    'M-SI1-POOR-GOOD-FAINT-GOOD': 4.14,
    'M-SI1-GOOD-POOR-FAINT-GOOD': 4.14,
    'M-I1-POOR-VG-NONE-GOOD': 4.14,
    'M-SI1-EX-GOOD-FAINT-POOR': 4.14,
    'M-SI1-VG-VG-FAINT-POOR': 4.14,
    'M-I1-GOOD-GOOD-NONE-GOOD': 4.14,
    'M-SI1-GOOD-EX-FAINT-POOR': 4.14,
    'L-VS1-GOOD-VG-STRONG-POOR': 4.13,
    'L-VS1-POOR-POOR-STRONG-GOOD': 4.13,
    'L-VS1-POOR-EX-STRONG-POOR': 4.13,
    'L-VS1-VG-GOOD-STRONG-POOR': 4.13,
    'L-VS1-EX-POOR-STRONG-POOR': 4.13,
    'M-VVS1-POOR-VG-STRONG-POOR': 4.13,
    'M-VVS1-GOOD-GOOD-STRONG-POOR': 4.13,
    'M-VS1-POOR-POOR-MEDIUM-GOOD': 4.13,
    'M-VVS1-VG-POOR-STRONG-POOR': 4.13,
    'M-VS1-VG-GOOD-MEDIUM-POOR': 4.13,
    'M-VS1-EX-POOR-MEDIUM-POOR': 4.13,
    'M-VS1-POOR-EX-MEDIUM-POOR': 4.13,
    'M-VS1-GOOD-VG-MEDIUM-POOR': 4.13,
    'D-I2-GOOD-POOR-STRONG-POOR': 4.12,
    'D-I2-POOR-GOOD-STRONG-POOR': 4.12,
    'E-SI2-POOR-POOR-STRONG-POOR': 4.12,
    'E-I2-POOR-GOOD-MEDIUM-POOR': 4.12,
    'E-I2-GOOD-POOR-MEDIUM-POOR': 4.12,
    'F-SI2-POOR-POOR-MEDIUM-POOR': 4.12,
    'F-I2-POOR-GOOD-FAINT-POOR': 4.12,
    'F-I2-GOOD-POOR-FAINT-POOR': 4.12,
    'G-I2-GOOD-POOR-NONE-POOR': 4.12,
    'G-I2-POOR-GOOD-NONE-POOR': 4.12,
    'G-SI2-POOR-POOR-FAINT-POOR': 4.12,
    'H-SI2-POOR-POOR-NONE-POOR': 4.12,
    'I-I2-EX-VG-STRONG-POOR': 4.12,
    'I-I2-GOOD-GOOD-STRONG-GOOD': 4.12,
    'I-I2-POOR-VG-STRONG-GOOD': 4.12,
    'I-I2-VG-POOR-STRONG-GOOD': 4.12,
    'I-I2-VG-EX-STRONG-POOR': 4.12,
    'J-I2-VG-EX-MEDIUM-POOR': 4.12,
    'J-I2-POOR-VG-MEDIUM-GOOD': 4.12,
    'J-I2-GOOD-GOOD-MEDIUM-GOOD': 4.12,
    'J-SI2-VG-VG-STRONG-POOR': 4.12,
    'J-I2-EX-VG-MEDIUM-POOR': 4.12,
    'J-SI2-GOOD-EX-STRONG-POOR': 4.12,
    'J-SI2-EX-GOOD-STRONG-POOR': 4.12,
    'J-SI2-POOR-GOOD-STRONG-GOOD': 4.12,
    'J-I2-VG-POOR-MEDIUM-GOOD': 4.12,
    'J-SI2-GOOD-POOR-STRONG-GOOD': 4.12,
    'K-I2-VG-POOR-FAINT-GOOD': 4.12,
    'K-SI2-EX-GOOD-MEDIUM-POOR': 4.12,
    'K-I2-POOR-VG-FAINT-GOOD': 4.12,
    'K-SI2-VG-VG-MEDIUM-POOR': 4.12,
    'K-I2-GOOD-GOOD-FAINT-GOOD': 4.12,
    'K-SI2-POOR-GOOD-MEDIUM-GOOD': 4.12,
    'K-I2-EX-VG-FAINT-POOR': 4.12,
    'K-SI2-GOOD-EX-MEDIUM-POOR': 4.12,
    'K-I2-VG-EX-FAINT-POOR': 4.12,
    'K-SI2-GOOD-POOR-MEDIUM-GOOD': 4.12,
    'L-I2-POOR-VG-NONE-GOOD': 4.12,
    'L-SI2-GOOD-POOR-FAINT-GOOD': 4.12,
    'L-I2-GOOD-GOOD-NONE-GOOD': 4.12,
    'L-SI2-GOOD-EX-FAINT-POOR': 4.12,
    'L-SI2-EX-GOOD-FAINT-POOR': 4.12,
    'L-SI2-POOR-GOOD-FAINT-GOOD': 4.12,
    'L-SI2-VG-VG-FAINT-POOR': 4.12,
    'L-I2-VG-POOR-NONE-GOOD': 4.12,
    'L-I2-EX-VG-NONE-POOR': 4.12,
    'L-I2-VG-EX-NONE-POOR': 4.12,
    'M-SI2-GOOD-POOR-NONE-GOOD': 4.12,
    'M-SI2-GOOD-EX-NONE-POOR': 4.12,
    'M-SI2-POOR-GOOD-NONE-GOOD': 4.12,
    'M-SI2-VG-VG-NONE-POOR': 4.12,
    'M-SI2-EX-GOOD-NONE-POOR': 4.12,
    'K-VS2-VG-GOOD-STRONG-POOR': 4.11,
    'K-VS2-GOOD-VG-STRONG-POOR': 4.11,
    'K-VS2-POOR-EX-STRONG-POOR': 4.11,
    'K-VS2-EX-POOR-STRONG-POOR': 4.11,
    'K-VS2-POOR-POOR-STRONG-GOOD': 4.11,
    'L-VS2-VG-GOOD-MEDIUM-POOR': 4.11,
    'L-VS2-POOR-EX-MEDIUM-POOR': 4.11,
    'L-VS2-GOOD-VG-MEDIUM-POOR': 4.11,
    'L-VS2-POOR-POOR-MEDIUM-GOOD': 4.11,
    'L-VS2-EX-POOR-MEDIUM-POOR': 4.11,
    'L-VVS2-GOOD-GOOD-STRONG-POOR': 4.11,
    'L-VVS2-POOR-VG-STRONG-POOR': 4.11,
    'L-VVS2-VG-POOR-STRONG-POOR': 4.11,
    'M-VS2-POOR-POOR-FAINT-GOOD': 4.11,
    'M-VVS2-GOOD-GOOD-MEDIUM-POOR': 4.11,
    'M-VVS2-VG-POOR-MEDIUM-POOR': 4.11,
    'M-VS2-VG-GOOD-FAINT-POOR': 4.11,
    'M-VS2-GOOD-VG-FAINT-POOR': 4.11,
    'M-VS2-POOR-EX-FAINT-POOR': 4.11,
    'M-VS2-EX-POOR-FAINT-POOR': 4.11,
    'M-VVS2-POOR-VG-MEDIUM-POOR': 4.11,
    'M-IF-GOOD-POOR-STRONG-POOR': 4.1,
    'M-IF-POOR-GOOD-STRONG-POOR': 4.1,
    'D-I1-POOR-POOR-STRONG-POOR': 4.09,
    'E-I1-POOR-POOR-MEDIUM-POOR': 4.09,
    'F-I1-POOR-POOR-FAINT-POOR': 4.09,
    'G-I1-POOR-POOR-NONE-POOR': 4.09,
    'I-I1-POOR-GOOD-STRONG-GOOD': 4.09,
    'I-I1-GOOD-POOR-STRONG-GOOD': 4.09,
    'I-I1-GOOD-EX-STRONG-POOR': 4.09,
    'I-I1-VG-VG-STRONG-POOR': 4.09,
    'I-I1-EX-GOOD-STRONG-POOR': 4.09,
    'J-SI1-POOR-POOR-STRONG-GOOD': 4.09,
    'J-I1-GOOD-POOR-MEDIUM-GOOD': 4.09,
    'J-I1-POOR-GOOD-MEDIUM-GOOD': 4.09,
    'J-SI1-POOR-EX-STRONG-POOR': 4.09,
    'J-SI1-VG-GOOD-STRONG-POOR': 4.09,
    'J-SI1-GOOD-VG-STRONG-POOR': 4.09,
    'J-SI1-EX-POOR-STRONG-POOR': 4.09,
    'J-I1-GOOD-EX-MEDIUM-POOR': 4.09,
    'J-I1-VG-VG-MEDIUM-POOR': 4.09,
    'J-I1-EX-GOOD-MEDIUM-POOR': 4.09,
    'K-I1-GOOD-POOR-FAINT-GOOD': 4.09,
    'K-I1-GOOD-EX-FAINT-POOR': 4.09,
    'K-SI1-EX-POOR-MEDIUM-POOR': 4.09,
    'K-SI1-VG-GOOD-MEDIUM-POOR': 4.09,
    'K-I1-VG-VG-FAINT-POOR': 4.09,
    'K-I1-POOR-GOOD-FAINT-GOOD': 4.09,
    'K-SI1-POOR-EX-MEDIUM-POOR': 4.09,
    'K-I1-EX-GOOD-FAINT-POOR': 4.09,
    'K-SI1-POOR-POOR-MEDIUM-GOOD': 4.09,
    'K-SI1-GOOD-VG-MEDIUM-POOR': 4.09,
    'L-I1-POOR-GOOD-NONE-GOOD': 4.09,
    'L-SI1-POOR-POOR-FAINT-GOOD': 4.09,
    'L-I1-EX-GOOD-NONE-POOR': 4.09,
    'L-I1-GOOD-EX-NONE-POOR': 4.09,
    'L-SI1-GOOD-VG-FAINT-POOR': 4.09,
    'L-I1-VG-VG-NONE-POOR': 4.09,
    'L-SI1-EX-POOR-FAINT-POOR': 4.09,
    'L-I1-GOOD-POOR-NONE-GOOD': 4.09,
    'L-SI1-POOR-EX-FAINT-POOR': 4.09,
    'L-SI1-VG-GOOD-FAINT-POOR': 4.09,
    'M-SI1-POOR-EX-NONE-POOR': 4.09,
    'M-SI1-GOOD-VG-NONE-POOR': 4.09,
    'M-SI1-VG-GOOD-NONE-POOR': 4.09,
    'M-SI1-EX-POOR-NONE-POOR': 4.09,
    'M-SI1-POOR-POOR-NONE-GOOD': 4.09,
    'K-VS1-POOR-VG-STRONG-POOR': 4.08,
    'K-VS1-GOOD-GOOD-STRONG-POOR': 4.08,
    'K-VS1-VG-POOR-STRONG-POOR': 4.08,
    'L-VVS1-GOOD-POOR-STRONG-POOR': 4.08,
    'L-VS1-VG-POOR-MEDIUM-POOR': 4.08,
    'L-VS1-GOOD-GOOD-MEDIUM-POOR': 4.08,
    'L-VVS1-POOR-GOOD-STRONG-POOR': 4.08,
    'L-VS1-POOR-VG-MEDIUM-POOR': 4.08,
    'M-VS1-GOOD-GOOD-FAINT-POOR': 4.08,
    'M-VS1-VG-POOR-FAINT-POOR': 4.08,
    'M-VVS1-GOOD-POOR-MEDIUM-POOR': 4.08,
    'M-VS1-POOR-VG-FAINT-POOR': 4.08,
    'M-VVS1-POOR-GOOD-MEDIUM-POOR': 4.08,
    'D-I2-POOR-POOR-MEDIUM-POOR': 4.07,
    'E-I2-POOR-POOR-FAINT-POOR': 4.07,
    'F-I2-POOR-POOR-NONE-POOR': 4.07,
    'H-I2-POOR-GOOD-STRONG-GOOD': 4.07,
    'H-I2-GOOD-POOR-STRONG-GOOD': 4.07,
    'H-I2-GOOD-EX-STRONG-POOR': 4.07,
    'H-I2-VG-VG-STRONG-POOR': 4.07,
    'H-I2-EX-GOOD-STRONG-POOR': 4.07,
    'I-I2-GOOD-POOR-MEDIUM-GOOD': 4.07,
    'I-I2-EX-GOOD-MEDIUM-POOR': 4.07,
    'I-I2-POOR-GOOD-MEDIUM-GOOD': 4.07,
    'I-I2-GOOD-EX-MEDIUM-POOR': 4.07,
    'I-I2-VG-VG-MEDIUM-POOR': 4.07,
    'I-SI2-GOOD-VG-STRONG-POOR': 4.07,
    'I-SI2-POOR-EX-STRONG-POOR': 4.07,
    'I-SI2-POOR-POOR-STRONG-GOOD': 4.07,
    'I-SI2-VG-GOOD-STRONG-POOR': 4.07,
    'I-SI2-EX-POOR-STRONG-POOR': 4.07,
    'J-SI2-POOR-POOR-MEDIUM-GOOD': 4.07,
    'J-I2-POOR-GOOD-FAINT-GOOD': 4.07,
    'J-SI2-EX-POOR-MEDIUM-POOR': 4.07,
    'J-I2-GOOD-EX-FAINT-POOR': 4.07,
    'J-I2-GOOD-POOR-FAINT-GOOD': 4.07,
    'J-SI2-GOOD-VG-MEDIUM-POOR': 4.07,
    'J-I2-VG-VG-FAINT-POOR': 4.07,
    'J-SI2-VG-GOOD-MEDIUM-POOR': 4.07,
    'J-SI2-POOR-EX-MEDIUM-POOR': 4.07,
    'J-I2-EX-GOOD-FAINT-POOR': 4.07,
    'K-I2-VG-VG-NONE-POOR': 4.07,
    'K-I2-EX-GOOD-NONE-POOR': 4.07,
    'K-I2-GOOD-POOR-NONE-GOOD': 4.07,
    'K-I2-POOR-GOOD-NONE-GOOD': 4.07,
    'K-SI2-VG-GOOD-FAINT-POOR': 4.07,
    'K-SI2-GOOD-VG-FAINT-POOR': 4.07,
    'K-SI2-POOR-EX-FAINT-POOR': 4.07,
    'K-SI2-POOR-POOR-FAINT-GOOD': 4.07,
    'K-I2-GOOD-EX-NONE-POOR': 4.07,
    'K-SI2-EX-POOR-FAINT-POOR': 4.07,
    'L-SI2-POOR-POOR-NONE-GOOD': 4.07,
    'L-SI2-POOR-EX-NONE-POOR': 4.07,
    'L-SI2-GOOD-VG-NONE-POOR': 4.07,
    'L-SI2-VG-GOOD-NONE-POOR': 4.07,
    'L-SI2-EX-POOR-NONE-POOR': 4.07,
    'M-I2-VG-POOR-STRONG-VG': 4.07,
    'M-I2-GOOD-GOOD-STRONG-VG': 4.07,
    'M-I2-POOR-VG-STRONG-VG': 4.07,
    'M-I2-VG-EX-STRONG-GOOD': 4.07,
    'M-I2-EX-VG-STRONG-GOOD': 4.07,
    'J-VS2-POOR-VG-STRONG-POOR': 4.06,
    'J-VS2-GOOD-GOOD-STRONG-POOR': 4.06,
    'J-VS2-VG-POOR-STRONG-POOR': 4.06,
    'K-VS2-GOOD-GOOD-MEDIUM-POOR': 4.06,
    'K-VVS2-GOOD-POOR-STRONG-POOR': 4.06,
    'K-VVS2-POOR-GOOD-STRONG-POOR': 4.06,
    'K-VS2-VG-POOR-MEDIUM-POOR': 4.06,
    'K-VS2-POOR-VG-MEDIUM-POOR': 4.06,
    'L-VS2-GOOD-GOOD-FAINT-POOR': 4.06,
    'L-VVS2-GOOD-POOR-MEDIUM-POOR': 4.06,
    'L-VS2-POOR-VG-FAINT-POOR': 4.06,
    'L-VS2-VG-POOR-FAINT-POOR': 4.06,
    'L-VVS2-POOR-GOOD-MEDIUM-POOR': 4.06,
    'M-VS2-VG-POOR-NONE-POOR': 4.06,
    'M-VS2-GOOD-GOOD-NONE-POOR': 4.06,
    'M-VS2-POOR-VG-NONE-POOR': 4.06,
    'M-VVS2-GOOD-POOR-FAINT-POOR': 4.06,
    'M-VVS2-POOR-GOOD-FAINT-POOR': 4.06,
    'L-IF-POOR-POOR-STRONG-POOR': 4.05,
    'M-IF-POOR-POOR-MEDIUM-POOR': 4.05,
    'H-I1-POOR-EX-STRONG-POOR': 4.04,
    'H-I1-GOOD-VG-STRONG-POOR': 4.04,
    'H-I1-VG-GOOD-STRONG-POOR': 4.04,
    'H-I1-POOR-POOR-STRONG-GOOD': 4.04,
    'H-I1-EX-POOR-STRONG-POOR': 4.04,
    'I-SI1-GOOD-GOOD-STRONG-POOR': 4.04,
    'I-SI1-POOR-VG-STRONG-POOR': 4.04,
    'I-SI1-VG-POOR-STRONG-POOR': 4.04,
    'I-I1-GOOD-VG-MEDIUM-POOR': 4.04,
    'I-I1-POOR-EX-MEDIUM-POOR': 4.04,
    'I-I1-POOR-POOR-MEDIUM-GOOD': 4.04,
    'I-I1-VG-GOOD-MEDIUM-POOR': 4.04,
    'I-I1-EX-POOR-MEDIUM-POOR': 4.04,
    'J-SI1-VG-POOR-MEDIUM-POOR': 4.04,
    'J-SI1-POOR-VG-MEDIUM-POOR': 4.04,
    'J-SI1-GOOD-GOOD-MEDIUM-POOR': 4.04,
    'J-I1-EX-POOR-FAINT-POOR': 4.04,
    'J-I1-GOOD-VG-FAINT-POOR': 4.04,
    'J-I1-VG-GOOD-FAINT-POOR': 4.04,
    'J-I1-POOR-POOR-FAINT-GOOD': 4.04,
    'J-I1-POOR-EX-FAINT-POOR': 4.04,
    'K-I1-EX-POOR-NONE-POOR': 4.04,
    'K-SI1-VG-POOR-FAINT-POOR': 4.04,
    'K-I1-POOR-POOR-NONE-GOOD': 4.04,
    'K-I1-POOR-EX-NONE-POOR': 4.04,
    'K-SI1-GOOD-GOOD-FAINT-POOR': 4.04,
    'K-SI1-POOR-VG-FAINT-POOR': 4.04,
    'K-I1-VG-GOOD-NONE-POOR': 4.04,
    'K-I1-GOOD-VG-NONE-POOR': 4.04,
    'L-SI1-VG-POOR-NONE-POOR': 4.04,
    'L-SI1-POOR-VG-NONE-POOR': 4.04,
    'L-SI1-GOOD-GOOD-NONE-POOR': 4.04,
    'M-I1-EX-GOOD-STRONG-GOOD': 4.04,
    'M-I1-POOR-GOOD-STRONG-VG': 4.04,
    'M-I1-GOOD-EX-STRONG-GOOD': 4.04,
    'M-I1-VG-VG-STRONG-GOOD': 4.04,
    'M-I1-GOOD-POOR-STRONG-VG': 4.04,
    'J-VS1-GOOD-POOR-STRONG-POOR': 4.03,
    'J-VS1-POOR-GOOD-STRONG-POOR': 4.03,
    'K-VVS1-POOR-POOR-STRONG-POOR': 4.03,
    'K-VS1-POOR-GOOD-MEDIUM-POOR': 4.03,
    'K-VS1-GOOD-POOR-MEDIUM-POOR': 4.03,
    'L-VVS1-POOR-POOR-MEDIUM-POOR': 4.03,
    'L-VS1-GOOD-POOR-FAINT-POOR': 4.03,
    'L-VS1-POOR-GOOD-FAINT-POOR': 4.03,
    'M-VVS1-POOR-POOR-FAINT-POOR': 4.03,
    'M-VS1-GOOD-POOR-NONE-POOR': 4.03,
    'M-VS1-POOR-GOOD-NONE-POOR': 4.03,
    'G-I2-GOOD-VG-STRONG-POOR': 4.02,
    'G-I2-VG-GOOD-STRONG-POOR': 4.02,
    'G-I2-EX-POOR-STRONG-POOR': 4.02,
    'G-I2-POOR-EX-STRONG-POOR': 4.02,
    'G-I2-POOR-POOR-STRONG-GOOD': 4.02,
    'H-SI2-VG-POOR-STRONG-POOR': 4.02,
    'H-SI2-GOOD-GOOD-STRONG-POOR': 4.02,
    'H-SI2-POOR-VG-STRONG-POOR': 4.02,
    'H-I2-EX-POOR-MEDIUM-POOR': 4.02,
    'H-I2-VG-GOOD-MEDIUM-POOR': 4.02,
    'H-I2-GOOD-VG-MEDIUM-POOR': 4.02,
    'H-I2-POOR-EX-MEDIUM-POOR': 4.02,
    'H-I2-POOR-POOR-MEDIUM-GOOD': 4.02,
    'I-SI2-POOR-VG-MEDIUM-POOR': 4.02,
    'I-SI2-GOOD-GOOD-MEDIUM-POOR': 4.02,
    'I-SI2-VG-POOR-MEDIUM-POOR': 4.02,
    'I-I2-POOR-POOR-FAINT-GOOD': 4.02,
    'I-I2-POOR-EX-FAINT-POOR': 4.02,
    'I-I2-GOOD-VG-FAINT-POOR': 4.02,
    'I-I2-VG-GOOD-FAINT-POOR': 4.02,
    'I-I2-EX-POOR-FAINT-POOR': 4.02,
    'J-SI2-VG-POOR-FAINT-POOR': 4.02,
    'J-SI2-GOOD-GOOD-FAINT-POOR': 4.02,
    'J-SI2-POOR-VG-FAINT-POOR': 4.02,
    'J-I2-VG-GOOD-NONE-POOR': 4.02,
    'J-I2-EX-POOR-NONE-POOR': 4.02,
    'J-I2-GOOD-VG-NONE-POOR': 4.02,
    'J-I2-POOR-EX-NONE-POOR': 4.02,
    'J-I2-POOR-POOR-NONE-GOOD': 4.02,
    'K-SI2-POOR-VG-NONE-POOR': 4.02,
    'K-SI2-GOOD-GOOD-NONE-POOR': 4.02,
    'K-SI2-VG-POOR-NONE-POOR': 4.02,
    'L-I2-POOR-GOOD-STRONG-VG': 4.02,
    'L-I2-GOOD-POOR-STRONG-VG': 4.02,
    'L-I2-GOOD-EX-STRONG-GOOD': 4.02,
    'L-I2-VG-VG-STRONG-GOOD': 4.02,
    'L-I2-EX-GOOD-STRONG-GOOD': 4.02,
    'M-I2-GOOD-POOR-MEDIUM-VG': 4.02,
    'M-SI2-EX-EX-STRONG-POOR': 4.02,
    'M-SI2-POOR-EX-STRONG-GOOD': 4.02,
    'M-SI2-GOOD-VG-STRONG-GOOD': 4.02,
    'M-SI2-VG-GOOD-STRONG-GOOD': 4.02,
    'M-SI2-EX-POOR-STRONG-GOOD': 4.02,
    'M-I2-VG-VG-MEDIUM-GOOD': 4.02,
    'M-I2-GOOD-EX-MEDIUM-GOOD': 4.02,
    'M-I2-POOR-GOOD-MEDIUM-VG': 4.02,
    'M-SI2-POOR-POOR-STRONG-VG': 4.02,
    'M-I2-EX-GOOD-MEDIUM-GOOD': 4.02,
    'I-VS2-POOR-GOOD-STRONG-POOR': 4.01,
    'I-VS2-GOOD-POOR-STRONG-POOR': 4.01,
    'J-VVS2-POOR-POOR-STRONG-POOR': 4.01,
    'J-VS2-POOR-GOOD-MEDIUM-POOR': 4.01,
    'J-VS2-GOOD-POOR-MEDIUM-POOR': 4.01,
    'K-VVS2-POOR-POOR-MEDIUM-POOR': 4.01,
    'K-VS2-GOOD-POOR-FAINT-POOR': 4.01,
    'K-VS2-POOR-GOOD-FAINT-POOR': 4.01,
    'L-VS2-GOOD-POOR-NONE-POOR': 4.01,
    'L-VS2-POOR-GOOD-NONE-POOR': 4.01,
    'L-VVS2-POOR-POOR-FAINT-POOR': 4.01,
    'M-VVS2-POOR-POOR-NONE-POOR': 4.01,
    'G-I1-VG-POOR-STRONG-POOR': 3.99,
    'G-I1-POOR-VG-STRONG-POOR': 3.99,
    'G-I1-GOOD-GOOD-STRONG-POOR': 3.99,
    'H-I1-GOOD-GOOD-MEDIUM-POOR': 3.99,
    'H-I1-POOR-VG-MEDIUM-POOR': 3.99,
    'H-I1-VG-POOR-MEDIUM-POOR': 3.99,
    'H-SI1-GOOD-POOR-STRONG-POOR': 3.99,
    'H-SI1-POOR-GOOD-STRONG-POOR': 3.99,
    'I-I1-GOOD-GOOD-FAINT-POOR': 3.99,
    'I-I1-POOR-VG-FAINT-POOR': 3.99,
    'I-SI1-POOR-GOOD-MEDIUM-POOR': 3.99,
    'I-SI1-GOOD-POOR-MEDIUM-POOR': 3.99,
    'I-I1-VG-POOR-FAINT-POOR': 3.99,
    'J-SI1-GOOD-POOR-FAINT-POOR': 3.99,
    'J-SI1-POOR-GOOD-FAINT-POOR': 3.99,
    'J-I1-GOOD-GOOD-NONE-POOR': 3.99,
    'J-I1-VG-POOR-NONE-POOR': 3.99,
    'J-I1-POOR-VG-NONE-POOR': 3.99,
    'K-SI1-GOOD-POOR-NONE-POOR': 3.99,
    'K-SI1-POOR-GOOD-NONE-POOR': 3.99,
    'L-I1-EX-POOR-STRONG-GOOD': 3.99,
    'L-I1-EX-EX-STRONG-POOR': 3.99,
    'L-I1-GOOD-VG-STRONG-GOOD': 3.99,
    'L-I1-POOR-EX-STRONG-GOOD': 3.99,
    'L-I1-POOR-POOR-STRONG-VG': 3.99,
    'L-I1-VG-GOOD-STRONG-GOOD': 3.99,
    'M-SI1-EX-VG-STRONG-POOR': 3.99,
    'M-I1-EX-EX-MEDIUM-POOR': 3.99,
    'M-I1-EX-POOR-MEDIUM-GOOD': 3.99,
    'M-I1-VG-GOOD-MEDIUM-GOOD': 3.99,
    'M-I1-GOOD-VG-MEDIUM-GOOD': 3.99,
    'M-SI1-VG-EX-STRONG-POOR': 3.99,
    'M-I1-POOR-EX-MEDIUM-GOOD': 3.99,
    'M-I1-POOR-POOR-MEDIUM-VG': 3.99,
    'M-SI1-POOR-VG-STRONG-GOOD': 3.99,
    'M-SI1-GOOD-GOOD-STRONG-GOOD': 3.99,
    'M-SI1-VG-POOR-STRONG-GOOD': 3.99,
    'I-VS1-POOR-POOR-STRONG-POOR': 3.98,
    'J-VS1-POOR-POOR-MEDIUM-POOR': 3.98,
    'K-VS1-POOR-POOR-FAINT-POOR': 3.98,
    'L-VS1-POOR-POOR-NONE-POOR': 3.98,
    'F-I2-VG-POOR-STRONG-POOR': 3.97,
    'F-I2-GOOD-GOOD-STRONG-POOR': 3.97,
    'F-I2-POOR-VG-STRONG-POOR': 3.97,
    'G-I2-POOR-VG-MEDIUM-POOR': 3.97,
    'G-I2-GOOD-GOOD-MEDIUM-POOR': 3.97,
    'G-I2-VG-POOR-MEDIUM-POOR': 3.97,
    'G-SI2-GOOD-POOR-STRONG-POOR': 3.97,
    'G-SI2-POOR-GOOD-STRONG-POOR': 3.97,
    'H-I2-VG-POOR-FAINT-POOR': 3.97,
    'H-SI2-GOOD-POOR-MEDIUM-POOR': 3.97,
    'H-SI2-POOR-GOOD-MEDIUM-POOR': 3.97,
    'H-I2-GOOD-GOOD-FAINT-POOR': 3.97,
    'H-I2-POOR-VG-FAINT-POOR': 3.97,
    'I-SI2-GOOD-POOR-FAINT-POOR': 3.97,
    'I-I2-VG-POOR-NONE-POOR': 3.97,
    'I-I2-POOR-VG-NONE-POOR': 3.97,
    'I-SI2-POOR-GOOD-FAINT-POOR': 3.97,
    'I-I2-GOOD-GOOD-NONE-POOR': 3.97,
    'J-SI2-GOOD-POOR-NONE-POOR': 3.97,
    'J-SI2-POOR-GOOD-NONE-POOR': 3.97,
    'K-I2-GOOD-VG-STRONG-GOOD': 3.97,
    'K-I2-POOR-EX-STRONG-GOOD': 3.97,
    'K-I2-EX-POOR-STRONG-GOOD': 3.97,
    'K-I2-VG-GOOD-STRONG-GOOD': 3.97,
    'K-I2-EX-EX-STRONG-POOR': 3.97,
    'K-I2-POOR-POOR-STRONG-VG': 3.97,
    'L-SI2-VG-POOR-STRONG-GOOD': 3.97,
    'L-SI2-GOOD-GOOD-STRONG-GOOD': 3.97,
    'L-SI2-POOR-VG-STRONG-GOOD': 3.97,
    'L-SI2-EX-VG-STRONG-POOR': 3.97,
    'L-SI2-VG-EX-STRONG-POOR': 3.97,
    'L-I2-EX-POOR-MEDIUM-GOOD': 3.97,
    'L-I2-EX-EX-MEDIUM-POOR': 3.97,
    'L-I2-POOR-POOR-MEDIUM-VG': 3.97,
    'L-I2-POOR-EX-MEDIUM-GOOD': 3.97,
    'L-I2-GOOD-VG-MEDIUM-GOOD': 3.97,
    'L-I2-VG-GOOD-MEDIUM-GOOD': 3.97,
    'M-I2-EX-POOR-FAINT-GOOD': 3.97,
    'M-SI2-VG-EX-MEDIUM-POOR': 3.97,
    'M-SI2-VG-POOR-MEDIUM-GOOD': 3.97,
    'M-SI2-POOR-VG-MEDIUM-GOOD': 3.97,
    'M-SI2-EX-VG-MEDIUM-POOR': 3.97,
    'M-I2-GOOD-VG-FAINT-GOOD': 3.97,
    'M-I2-EX-EX-FAINT-POOR': 3.97,
    'M-I2-VG-GOOD-FAINT-GOOD': 3.97,
    'M-SI2-GOOD-GOOD-MEDIUM-GOOD': 3.97,
    'M-I2-POOR-POOR-FAINT-VG': 3.97,
    'M-I2-POOR-EX-FAINT-GOOD': 3.97,
    'H-VS2-POOR-POOR-STRONG-POOR': 3.96,
    'I-VS2-POOR-POOR-MEDIUM-POOR': 3.96,
    'J-VS2-POOR-POOR-FAINT-POOR': 3.96,
    'K-VS2-POOR-POOR-NONE-POOR': 3.96,
    'M-VS2-POOR-GOOD-STRONG-GOOD': 3.96,
    'M-VS2-VG-VG-STRONG-POOR': 3.96,
    'M-VS2-GOOD-POOR-STRONG-GOOD': 3.96,
    'M-VS2-EX-GOOD-STRONG-POOR': 3.96,
    'M-VS2-GOOD-EX-STRONG-POOR': 3.96,
    'F-I1-GOOD-POOR-STRONG-POOR': 3.94,
    'F-I1-POOR-GOOD-STRONG-POOR': 3.94,
    'G-I1-POOR-GOOD-MEDIUM-POOR': 3.94,
    'G-I1-GOOD-POOR-MEDIUM-POOR': 3.94,
    'G-SI1-POOR-POOR-STRONG-POOR': 3.94,
    'H-I1-GOOD-POOR-FAINT-POOR': 3.94,
    'H-I1-POOR-GOOD-FAINT-POOR': 3.94,
    'H-SI1-POOR-POOR-MEDIUM-POOR': 3.94,
    'I-I1-POOR-GOOD-NONE-POOR': 3.94,
    'I-I1-GOOD-POOR-NONE-POOR': 3.94,
    'I-SI1-POOR-POOR-FAINT-POOR': 3.94,
    'J-SI1-POOR-POOR-NONE-POOR': 3.94,
    'K-I1-POOR-VG-STRONG-GOOD': 3.94,
    'K-I1-VG-POOR-STRONG-GOOD': 3.94,
    'K-I1-EX-VG-STRONG-POOR': 3.94,
    'K-I1-GOOD-GOOD-STRONG-GOOD': 3.94,
    'K-I1-VG-EX-STRONG-POOR': 3.94,
    'L-I1-GOOD-GOOD-MEDIUM-GOOD': 3.94,
    'L-I1-EX-VG-MEDIUM-POOR': 3.94,
    'L-I1-VG-POOR-MEDIUM-GOOD': 3.94,
    'L-I1-VG-EX-MEDIUM-POOR': 3.94,
    'L-I1-POOR-VG-MEDIUM-GOOD': 3.94,
    'L-SI1-EX-GOOD-STRONG-POOR': 3.94,
    'L-SI1-VG-VG-STRONG-POOR': 3.94,
    'L-SI1-GOOD-EX-STRONG-POOR': 3.94,
    'L-SI1-GOOD-POOR-STRONG-GOOD': 3.94,
    'L-SI1-POOR-GOOD-STRONG-GOOD': 3.94,
    'M-I1-VG-EX-FAINT-POOR': 3.94,
    'M-I1-VG-POOR-FAINT-GOOD': 3.94,
    'M-I1-POOR-VG-FAINT-GOOD': 3.94,
    'M-I1-EX-VG-FAINT-POOR': 3.94,
    'M-I1-GOOD-GOOD-FAINT-GOOD': 3.94,
    'M-SI1-POOR-GOOD-MEDIUM-GOOD': 3.94,
    'M-SI1-VG-VG-MEDIUM-POOR': 3.94,
    'M-SI1-EX-GOOD-MEDIUM-POOR': 3.94,
    'M-SI1-GOOD-POOR-MEDIUM-GOOD': 3.94,
    'M-SI1-GOOD-EX-MEDIUM-POOR': 3.94,
    'M-VS1-VG-GOOD-STRONG-POOR': 3.93,
    'M-VS1-POOR-EX-STRONG-POOR': 3.93,
    'M-VS1-EX-POOR-STRONG-POOR': 3.93,
    'M-VS1-POOR-POOR-STRONG-GOOD': 3.93,
    'M-VS1-GOOD-VG-STRONG-POOR': 3.93,
    'E-I2-POOR-GOOD-STRONG-POOR': 3.92,
    'E-I2-GOOD-POOR-STRONG-POOR': 3.92,
    'F-SI2-POOR-POOR-STRONG-POOR': 3.92,
    'F-I2-GOOD-POOR-MEDIUM-POOR': 3.92,
    'F-I2-POOR-GOOD-MEDIUM-POOR': 3.92,
    'G-I2-GOOD-POOR-FAINT-POOR': 3.92,
    'G-SI2-POOR-POOR-MEDIUM-POOR': 3.92,
    'G-I2-POOR-GOOD-FAINT-POOR': 3.92,
    'H-SI2-POOR-POOR-FAINT-POOR': 3.92,
    'H-I2-GOOD-POOR-NONE-POOR': 3.92,
    'H-I2-POOR-GOOD-NONE-POOR': 3.92,
    'I-SI2-POOR-POOR-NONE-POOR': 3.92,
    'J-I2-EX-VG-STRONG-POOR': 3.92,
    'J-I2-VG-EX-STRONG-POOR': 3.92,
    'J-I2-VG-POOR-STRONG-GOOD': 3.92,
    'J-I2-GOOD-GOOD-STRONG-GOOD': 3.92,
    'J-I2-POOR-VG-STRONG-GOOD': 3.92,
    'K-SI2-EX-GOOD-STRONG-POOR': 3.92,
    'K-I2-GOOD-GOOD-MEDIUM-GOOD': 3.92,
    'K-SI2-GOOD-POOR-STRONG-GOOD': 3.92,
    'K-I2-VG-EX-MEDIUM-POOR': 3.92,
    'K-SI2-POOR-GOOD-STRONG-GOOD': 3.92,
    'K-I2-VG-POOR-MEDIUM-GOOD': 3.92,
    'K-I2-EX-VG-MEDIUM-POOR': 3.92,
    'K-SI2-VG-VG-STRONG-POOR': 3.92,
    'K-I2-POOR-VG-MEDIUM-GOOD': 3.92,
    'K-SI2-GOOD-EX-STRONG-POOR': 3.92,
    'L-I2-VG-EX-FAINT-POOR': 3.92,
    'L-I2-GOOD-GOOD-FAINT-GOOD': 3.92,
    'L-I2-VG-POOR-FAINT-GOOD': 3.92,
    'L-I2-EX-VG-FAINT-POOR': 3.92,
    'L-I2-POOR-VG-FAINT-GOOD': 3.92,
    'L-SI2-GOOD-EX-MEDIUM-POOR': 3.92,
    'L-SI2-POOR-GOOD-MEDIUM-GOOD': 3.92,
    'L-SI2-EX-GOOD-MEDIUM-POOR': 3.92,
    'L-SI2-GOOD-POOR-MEDIUM-GOOD': 3.92,
    'L-SI2-VG-VG-MEDIUM-POOR': 3.92,
    'M-I2-VG-POOR-NONE-GOOD': 3.92,
    'M-SI2-POOR-GOOD-FAINT-GOOD': 3.92,
    'M-SI2-VG-VG-FAINT-POOR': 3.92,
    'M-SI2-EX-GOOD-FAINT-POOR': 3.92,
    'M-I2-GOOD-GOOD-NONE-GOOD': 3.92,
    'M-I2-POOR-VG-NONE-GOOD': 3.92,
    'M-SI2-GOOD-POOR-FAINT-GOOD': 3.92,
    'M-I2-VG-EX-NONE-POOR': 3.92,
    'M-I2-EX-VG-NONE-POOR': 3.92,
    'M-SI2-GOOD-EX-FAINT-POOR': 3.92,
    'L-VS2-POOR-POOR-STRONG-GOOD': 3.91,
    'L-VS2-POOR-EX-STRONG-POOR': 3.91,
    'L-VS2-GOOD-VG-STRONG-POOR': 3.91,
    'L-VS2-VG-GOOD-STRONG-POOR': 3.91,
    'L-VS2-EX-POOR-STRONG-POOR': 3.91,
    'M-VVS2-VG-POOR-STRONG-POOR': 3.91,
    'M-VS2-VG-GOOD-MEDIUM-POOR': 3.91,
    'M-VVS2-GOOD-GOOD-STRONG-POOR': 3.91,
    'M-VVS2-POOR-VG-STRONG-POOR': 3.91,
    'M-VS2-EX-POOR-MEDIUM-POOR': 3.91,
    'M-VS2-POOR-POOR-MEDIUM-GOOD': 3.91,
    'M-VS2-POOR-EX-MEDIUM-POOR': 3.91,
    'M-VS2-GOOD-VG-MEDIUM-POOR': 3.91,
    'E-I1-POOR-POOR-STRONG-POOR': 3.89,
    'F-I1-POOR-POOR-MEDIUM-POOR': 3.89,
    'G-I1-POOR-POOR-FAINT-POOR': 3.89,
    'H-I1-POOR-POOR-NONE-POOR': 3.89,
    'J-I1-EX-GOOD-STRONG-POOR': 3.89,
    'J-I1-VG-VG-STRONG-POOR': 3.89,
    'J-I1-GOOD-EX-STRONG-POOR': 3.89,
    'J-I1-GOOD-POOR-STRONG-GOOD': 3.89,
    'J-I1-POOR-GOOD-STRONG-GOOD': 3.89,
    'K-SI1-POOR-EX-STRONG-POOR': 3.89,
    'K-SI1-EX-POOR-STRONG-POOR': 3.89,
    'K-SI1-POOR-POOR-STRONG-GOOD': 3.89,
    'K-I1-EX-GOOD-MEDIUM-POOR': 3.89,
    'K-SI1-VG-GOOD-STRONG-POOR': 3.89,
    'K-SI1-GOOD-VG-STRONG-POOR': 3.89,
    'K-I1-VG-VG-MEDIUM-POOR': 3.89,
    'K-I1-GOOD-EX-MEDIUM-POOR': 3.89,
    'K-I1-GOOD-POOR-MEDIUM-GOOD': 3.89,
    'K-I1-POOR-GOOD-MEDIUM-GOOD': 3.89,
    'L-SI1-POOR-EX-MEDIUM-POOR': 3.89,
    'L-I1-POOR-GOOD-FAINT-GOOD': 3.89,
    'L-I1-GOOD-EX-FAINT-POOR': 3.89,
    'L-SI1-VG-GOOD-MEDIUM-POOR': 3.89,
    'L-I1-VG-VG-FAINT-POOR': 3.89,
    'L-I1-GOOD-POOR-FAINT-GOOD': 3.89,
    'L-SI1-GOOD-VG-MEDIUM-POOR': 3.89,
    'L-I1-EX-GOOD-FAINT-POOR': 3.89,
    'L-SI1-EX-POOR-MEDIUM-POOR': 3.89,
    'L-SI1-POOR-POOR-MEDIUM-GOOD': 3.89,
    'M-SI1-EX-POOR-FAINT-POOR': 3.89,
    'M-I1-GOOD-POOR-NONE-GOOD': 3.89,
    'M-SI1-VG-GOOD-FAINT-POOR': 3.89,
    'M-SI1-POOR-POOR-FAINT-GOOD': 3.89,
    'M-SI1-GOOD-VG-FAINT-POOR': 3.89,
    'M-I1-GOOD-EX-NONE-POOR': 3.89,
    'M-I1-VG-VG-NONE-POOR': 3.89,
    'M-SI1-POOR-EX-FAINT-POOR': 3.89,
    'M-I1-EX-GOOD-NONE-POOR': 3.89,
    'M-I1-POOR-GOOD-NONE-GOOD': 3.89,
    'L-VS1-VG-POOR-STRONG-POOR': 3.88,
    'L-VS1-GOOD-GOOD-STRONG-POOR': 3.88,
    'L-VS1-POOR-VG-STRONG-POOR': 3.88,
    'M-VVS1-POOR-GOOD-STRONG-POOR': 3.88,
    'M-VS1-POOR-VG-MEDIUM-POOR': 3.88,
    'M-VS1-GOOD-GOOD-MEDIUM-POOR': 3.88,
    'M-VVS1-GOOD-POOR-STRONG-POOR': 3.88,
    'M-VS1-VG-POOR-MEDIUM-POOR': 3.88,
    'D-I2-POOR-POOR-STRONG-POOR': 3.87,
    'E-I2-POOR-POOR-MEDIUM-POOR': 3.87,
    'F-I2-POOR-POOR-FAINT-POOR': 3.87,
    'G-I2-POOR-POOR-NONE-POOR': 3.87,
    'I-I2-POOR-GOOD-STRONG-GOOD': 3.87,
    'I-I2-GOOD-POOR-STRONG-GOOD': 3.87,
    'I-I2-GOOD-EX-STRONG-POOR': 3.87,
    'I-I2-VG-VG-STRONG-POOR': 3.87,
    'I-I2-EX-GOOD-STRONG-POOR': 3.87,
    'J-I2-POOR-GOOD-MEDIUM-GOOD': 3.87,
    'J-I2-GOOD-POOR-MEDIUM-GOOD': 3.87,
    'J-SI2-VG-GOOD-STRONG-POOR': 3.87,
    'J-I2-GOOD-EX-MEDIUM-POOR': 3.87,
    'J-SI2-GOOD-VG-STRONG-POOR': 3.87,
    'J-SI2-POOR-EX-STRONG-POOR': 3.87,
    'J-SI2-POOR-POOR-STRONG-GOOD': 3.87,
    'J-I2-VG-VG-MEDIUM-POOR': 3.87,
    'J-I2-EX-GOOD-MEDIUM-POOR': 3.87,
    'J-SI2-EX-POOR-STRONG-POOR': 3.87,
    'K-I2-VG-VG-FAINT-POOR': 3.87,
    'K-I2-EX-GOOD-FAINT-POOR': 3.87,
    'K-SI2-POOR-POOR-MEDIUM-GOOD': 3.87,
    'K-SI2-POOR-EX-MEDIUM-POOR': 3.87,
    'K-I2-POOR-GOOD-FAINT-GOOD': 3.87,
    'K-I2-GOOD-POOR-FAINT-GOOD': 3.87,
    'K-I2-GOOD-EX-FAINT-POOR': 3.87,
    'K-SI2-VG-GOOD-MEDIUM-POOR': 3.87,
    'K-SI2-EX-POOR-MEDIUM-POOR': 3.87,
    'K-SI2-GOOD-VG-MEDIUM-POOR': 3.87,
    'L-SI2-POOR-POOR-FAINT-GOOD': 3.87,
    'L-SI2-VG-GOOD-FAINT-POOR': 3.87,
    'L-SI2-GOOD-VG-FAINT-POOR': 3.87,
    'L-SI2-EX-POOR-FAINT-POOR': 3.87,
    'L-SI2-POOR-EX-FAINT-POOR': 3.87,
    'L-I2-POOR-GOOD-NONE-GOOD': 3.87,
    'L-I2-GOOD-POOR-NONE-GOOD': 3.87,
    'L-I2-GOOD-EX-NONE-POOR': 3.87,
    'L-I2-VG-VG-NONE-POOR': 3.87,
    'L-I2-EX-GOOD-NONE-POOR': 3.87,
    'M-SI2-VG-GOOD-NONE-POOR': 3.87,
    'M-SI2-EX-POOR-NONE-POOR': 3.87,
    'M-SI2-GOOD-VG-NONE-POOR': 3.87,
    'M-SI2-POOR-EX-NONE-POOR': 3.87,
    'M-SI2-POOR-POOR-NONE-GOOD': 3.87,
    'K-VS2-POOR-VG-STRONG-POOR': 3.86,
    'K-VS2-GOOD-GOOD-STRONG-POOR': 3.86,
    'K-VS2-VG-POOR-STRONG-POOR': 3.86,
    'L-VVS2-POOR-GOOD-STRONG-POOR': 3.86,
    'L-VS2-VG-POOR-MEDIUM-POOR': 3.86,
    'L-VVS2-GOOD-POOR-STRONG-POOR': 3.86,
    'L-VS2-POOR-VG-MEDIUM-POOR': 3.86,
    'L-VS2-GOOD-GOOD-MEDIUM-POOR': 3.86,
    'M-VS2-POOR-VG-FAINT-POOR': 3.86,
    'M-VS2-GOOD-GOOD-FAINT-POOR': 3.86,
    'M-VVS2-GOOD-POOR-MEDIUM-POOR': 3.86,
    'M-VS2-VG-POOR-FAINT-POOR': 3.86,
    'M-VVS2-POOR-GOOD-MEDIUM-POOR': 3.86,
    'M-IF-POOR-POOR-STRONG-POOR': 3.85,
    'I-I1-POOR-POOR-STRONG-GOOD': 3.84,
    'I-I1-POOR-EX-STRONG-POOR': 3.84,
    'I-I1-GOOD-VG-STRONG-POOR': 3.84,
    'I-I1-VG-GOOD-STRONG-POOR': 3.84,
    'I-I1-EX-POOR-STRONG-POOR': 3.84,
    'J-I1-POOR-EX-MEDIUM-POOR': 3.84,
    'J-I1-GOOD-VG-MEDIUM-POOR': 3.84,
    'J-I1-POOR-POOR-MEDIUM-GOOD': 3.84,
    'J-SI1-VG-POOR-STRONG-POOR': 3.84,
    'J-I1-EX-POOR-MEDIUM-POOR': 3.84,
    'J-I1-VG-GOOD-MEDIUM-POOR': 3.84,
    'J-SI1-POOR-VG-STRONG-POOR': 3.84,
    'J-SI1-GOOD-GOOD-STRONG-POOR': 3.84,
    'K-I1-POOR-POOR-FAINT-GOOD': 3.84,
    'K-SI1-POOR-VG-MEDIUM-POOR': 3.84,
    'K-I1-GOOD-VG-FAINT-POOR': 3.84,
    'K-I1-VG-GOOD-FAINT-POOR': 3.84,
    'K-SI1-GOOD-GOOD-MEDIUM-POOR': 3.84,
    'K-SI1-VG-POOR-MEDIUM-POOR': 3.84,
    'K-I1-POOR-EX-FAINT-POOR': 3.84,
    'K-I1-EX-POOR-FAINT-POOR': 3.84,
    'L-I1-POOR-POOR-NONE-GOOD': 3.84,
    'L-SI1-POOR-VG-FAINT-POOR': 3.84,
    'L-SI1-GOOD-GOOD-FAINT-POOR': 3.84,
    'L-I1-VG-GOOD-NONE-POOR': 3.84,
    'L-SI1-VG-POOR-FAINT-POOR': 3.84,
    'L-I1-GOOD-VG-NONE-POOR': 3.84,
    'L-I1-EX-POOR-NONE-POOR': 3.84,
    'L-I1-POOR-EX-NONE-POOR': 3.84,
    'M-SI1-POOR-VG-NONE-POOR': 3.84,
    'M-SI1-GOOD-GOOD-NONE-POOR': 3.84,
    'M-SI1-VG-POOR-NONE-POOR': 3.84,
    'K-VS1-GOOD-POOR-STRONG-POOR': 3.83,
    'K-VS1-POOR-GOOD-STRONG-POOR': 3.83,
    'L-VS1-POOR-GOOD-MEDIUM-POOR': 3.83,
    'L-VS1-GOOD-POOR-MEDIUM-POOR': 3.83,
    'L-VVS1-POOR-POOR-STRONG-POOR': 3.83,
    'M-VVS1-POOR-POOR-MEDIUM-POOR': 3.83,
    'M-VS1-GOOD-POOR-FAINT-POOR': 3.83,
    'M-VS1-POOR-GOOD-FAINT-POOR': 3.83,
    'H-I2-EX-POOR-STRONG-POOR': 3.82,
    'H-I2-POOR-EX-STRONG-POOR': 3.82,
    'H-I2-VG-GOOD-STRONG-POOR': 3.82,
    'H-I2-GOOD-VG-STRONG-POOR': 3.82,
    'H-I2-POOR-POOR-STRONG-GOOD': 3.82,
    'I-I2-GOOD-VG-MEDIUM-POOR': 3.82,
    'I-I2-VG-GOOD-MEDIUM-POOR': 3.82,
    'I-SI2-POOR-VG-STRONG-POOR': 3.82,
    'I-I2-EX-POOR-MEDIUM-POOR': 3.82,
    'I-I2-POOR-EX-MEDIUM-POOR': 3.82,
    'I-SI2-GOOD-GOOD-STRONG-POOR': 3.82,
    'I-SI2-VG-POOR-STRONG-POOR': 3.82,
    'I-I2-POOR-POOR-MEDIUM-GOOD': 3.82,
    'J-I2-POOR-EX-FAINT-POOR': 3.82,
    'J-I2-POOR-POOR-FAINT-GOOD': 3.82,
    'J-SI2-GOOD-GOOD-MEDIUM-POOR': 3.82,
    'J-SI2-VG-POOR-MEDIUM-POOR': 3.82,
    'J-SI2-POOR-VG-MEDIUM-POOR': 3.82,
    'J-I2-EX-POOR-FAINT-POOR': 3.82,
    'J-I2-VG-GOOD-FAINT-POOR': 3.82,
    'J-I2-GOOD-VG-FAINT-POOR': 3.82,
    'K-I2-GOOD-VG-NONE-POOR': 3.82,
    'K-I2-POOR-EX-NONE-POOR': 3.82,
    'K-I2-VG-GOOD-NONE-POOR': 3.82,
    'K-SI2-VG-POOR-FAINT-POOR': 3.82,
    'K-SI2-GOOD-GOOD-FAINT-POOR': 3.82,
    'K-I2-EX-POOR-NONE-POOR': 3.82,
    'K-SI2-POOR-VG-FAINT-POOR': 3.82,
    'K-I2-POOR-POOR-NONE-GOOD': 3.82,
    'L-SI2-VG-POOR-NONE-POOR': 3.82,
    'L-SI2-GOOD-GOOD-NONE-POOR': 3.82,
    'L-SI2-POOR-VG-NONE-POOR': 3.82,
    'M-I2-EX-GOOD-STRONG-GOOD': 3.82,
    'M-I2-POOR-GOOD-STRONG-VG': 3.82,
    'M-I2-VG-VG-STRONG-GOOD': 3.82,
    'M-I2-GOOD-EX-STRONG-GOOD': 3.82,
    'M-I2-GOOD-POOR-STRONG-VG': 3.82,
    'J-VS2-GOOD-POOR-STRONG-POOR': 3.81,
    'J-VS2-POOR-GOOD-STRONG-POOR': 3.81,
    'K-VS2-POOR-GOOD-MEDIUM-POOR': 3.81,
    'K-VVS2-POOR-POOR-STRONG-POOR': 3.81,
    'K-VS2-GOOD-POOR-MEDIUM-POOR': 3.81,
    'L-VVS2-POOR-POOR-MEDIUM-POOR': 3.81,
    'L-VS2-POOR-GOOD-FAINT-POOR': 3.81,
    'L-VS2-GOOD-POOR-FAINT-POOR': 3.81,
    'M-VS2-GOOD-POOR-NONE-POOR': 3.81,
    'M-VS2-POOR-GOOD-NONE-POOR': 3.81,
    'M-VVS2-POOR-POOR-FAINT-POOR': 3.81,
    'H-I1-GOOD-GOOD-STRONG-POOR': 3.79,
    'H-I1-VG-POOR-STRONG-POOR': 3.79,
    'H-I1-POOR-VG-STRONG-POOR': 3.79,
    'I-SI1-GOOD-POOR-STRONG-POOR': 3.79,
    'I-SI1-POOR-GOOD-STRONG-POOR': 3.79,
    'I-I1-POOR-VG-MEDIUM-POOR': 3.79,
    'I-I1-GOOD-GOOD-MEDIUM-POOR': 3.79,
    'I-I1-VG-POOR-MEDIUM-POOR': 3.79,
    'J-SI1-GOOD-POOR-MEDIUM-POOR': 3.79,
    'J-SI1-POOR-GOOD-MEDIUM-POOR': 3.79,
    'J-I1-GOOD-GOOD-FAINT-POOR': 3.79,
    'J-I1-POOR-VG-FAINT-POOR': 3.79,
    'J-I1-VG-POOR-FAINT-POOR': 3.79,
    'K-I1-GOOD-GOOD-NONE-POOR': 3.79,
    'K-SI1-POOR-GOOD-FAINT-POOR': 3.79,
    'K-SI1-GOOD-POOR-FAINT-POOR': 3.79,
    'K-I1-VG-POOR-NONE-POOR': 3.79,
    'K-I1-POOR-VG-NONE-POOR': 3.79,
    'L-SI1-POOR-GOOD-NONE-POOR': 3.79,
    'L-SI1-GOOD-POOR-NONE-POOR': 3.79,
    'M-I1-EX-POOR-STRONG-GOOD': 3.79,
    'M-I1-GOOD-VG-STRONG-GOOD': 3.79,
    'M-I1-POOR-EX-STRONG-GOOD': 3.79,
    'M-I1-POOR-POOR-STRONG-VG': 3.79,
    'M-I1-VG-GOOD-STRONG-GOOD': 3.79,
    'M-I1-EX-EX-STRONG-POOR': 3.79,
    'J-VS1-POOR-POOR-STRONG-POOR': 3.78,
    'K-VS1-POOR-POOR-MEDIUM-POOR': 3.78,
    'L-VS1-POOR-POOR-FAINT-POOR': 3.78,
    'M-VS1-POOR-POOR-NONE-POOR': 3.78,
    'G-I2-VG-POOR-STRONG-POOR': 3.77,
    'G-I2-POOR-VG-STRONG-POOR': 3.77,
    'G-I2-GOOD-GOOD-STRONG-POOR': 3.77,
    'H-SI2-GOOD-POOR-STRONG-POOR': 3.77,
    'H-SI2-POOR-GOOD-STRONG-POOR': 3.77,
    'H-I2-POOR-VG-MEDIUM-POOR': 3.77,
    'H-I2-GOOD-GOOD-MEDIUM-POOR': 3.77,
    'H-I2-VG-POOR-MEDIUM-POOR': 3.77,
    'I-I2-POOR-VG-FAINT-POOR': 3.77,
    'I-I2-GOOD-GOOD-FAINT-POOR': 3.77,
    'I-I2-VG-POOR-FAINT-POOR': 3.77,
    'I-SI2-POOR-GOOD-MEDIUM-POOR': 3.77,
    'I-SI2-GOOD-POOR-MEDIUM-POOR': 3.77,
    'J-I2-VG-POOR-NONE-POOR': 3.77,
    'J-I2-GOOD-GOOD-NONE-POOR': 3.77,
    'J-SI2-POOR-GOOD-FAINT-POOR': 3.77,
    'J-I2-POOR-VG-NONE-POOR': 3.77,
    'J-SI2-GOOD-POOR-FAINT-POOR': 3.77,
    'K-SI2-POOR-GOOD-NONE-POOR': 3.77,
    'K-SI2-GOOD-POOR-NONE-POOR': 3.77,
    'L-I2-POOR-EX-STRONG-GOOD': 3.77,
    'L-I2-POOR-POOR-STRONG-VG': 3.77,
    'L-I2-EX-EX-STRONG-POOR': 3.77,
    'L-I2-EX-POOR-STRONG-GOOD': 3.77,
    'L-I2-VG-GOOD-STRONG-GOOD': 3.77,
    'L-I2-GOOD-VG-STRONG-GOOD': 3.77,
    'M-I2-POOR-EX-MEDIUM-GOOD': 3.77,
    'M-I2-POOR-POOR-MEDIUM-VG': 3.77,
    'M-SI2-GOOD-GOOD-STRONG-GOOD': 3.77,
    'M-SI2-VG-EX-STRONG-POOR': 3.77,
    'M-I2-VG-GOOD-MEDIUM-GOOD': 3.77,
    'M-I2-EX-POOR-MEDIUM-GOOD': 3.77,
    'M-SI2-VG-POOR-STRONG-GOOD': 3.77,
    'M-SI2-EX-VG-STRONG-POOR': 3.77,
    'M-I2-EX-EX-MEDIUM-POOR': 3.77,
    'M-I2-GOOD-VG-MEDIUM-GOOD': 3.77,
    'M-SI2-POOR-VG-STRONG-GOOD': 3.77,
    'I-VS2-POOR-POOR-STRONG-POOR': 3.76,
    'J-VS2-POOR-POOR-MEDIUM-POOR': 3.76,
    'K-VS2-POOR-POOR-FAINT-POOR': 3.76,
    'L-VS2-POOR-POOR-NONE-POOR': 3.76,
    'G-I1-POOR-GOOD-STRONG-POOR': 3.74,
    'G-I1-GOOD-POOR-STRONG-POOR': 3.74,
    'H-I1-GOOD-POOR-MEDIUM-POOR': 3.74,
    'H-I1-POOR-GOOD-MEDIUM-POOR': 3.74,
    'H-SI1-POOR-POOR-STRONG-POOR': 3.74,
    'I-SI1-POOR-POOR-MEDIUM-POOR': 3.74,
    'I-I1-POOR-GOOD-FAINT-POOR': 3.74,
    'I-I1-GOOD-POOR-FAINT-POOR': 3.74,
    'J-SI1-POOR-POOR-FAINT-POOR': 3.74,
    'J-I1-POOR-GOOD-NONE-POOR': 3.74,
    'J-I1-GOOD-POOR-NONE-POOR': 3.74,
    'K-SI1-POOR-POOR-NONE-POOR': 3.74,
    'L-I1-EX-VG-STRONG-POOR': 3.74,
    'L-I1-VG-EX-STRONG-POOR': 3.74,
    'L-I1-VG-POOR-STRONG-GOOD': 3.74,
    'L-I1-GOOD-GOOD-STRONG-GOOD': 3.74,
    'L-I1-POOR-VG-STRONG-GOOD': 3.74,
    'M-SI1-POOR-GOOD-STRONG-GOOD': 3.74,
    'M-I1-VG-POOR-MEDIUM-GOOD': 3.74,
    'M-SI1-GOOD-POOR-STRONG-GOOD': 3.74,
    'M-SI1-GOOD-EX-STRONG-POOR': 3.74,
    'M-SI1-VG-VG-STRONG-POOR': 3.74,
    'M-I1-POOR-VG-MEDIUM-GOOD': 3.74,
    'M-I1-EX-VG-MEDIUM-POOR': 3.74,
    'M-I1-VG-EX-MEDIUM-POOR': 3.74,
    'M-SI1-EX-GOOD-STRONG-POOR': 3.74,
    'M-I1-GOOD-GOOD-MEDIUM-GOOD': 3.74,
    'F-I2-GOOD-POOR-STRONG-POOR': 3.72,
    'F-I2-POOR-GOOD-STRONG-POOR': 3.72,
    'G-I2-POOR-GOOD-MEDIUM-POOR': 3.72,
    'G-I2-GOOD-POOR-MEDIUM-POOR': 3.72,
    'G-SI2-POOR-POOR-STRONG-POOR': 3.72,
    'H-I2-POOR-GOOD-FAINT-POOR': 3.72,
    'H-I2-GOOD-POOR-FAINT-POOR': 3.72,
    'H-SI2-POOR-POOR-MEDIUM-POOR': 3.72,
    'I-SI2-POOR-POOR-FAINT-POOR': 3.72,
    'I-I2-GOOD-POOR-NONE-POOR': 3.72,
    'I-I2-POOR-GOOD-NONE-POOR': 3.72,
    'J-SI2-POOR-POOR-NONE-POOR': 3.72,
    'K-I2-POOR-VG-STRONG-GOOD': 3.72,
    'K-I2-GOOD-GOOD-STRONG-GOOD': 3.72,
    'K-I2-VG-POOR-STRONG-GOOD': 3.72,
    'K-I2-VG-EX-STRONG-POOR': 3.72,
    'K-I2-EX-VG-STRONG-POOR': 3.72,
    'L-I2-EX-VG-MEDIUM-POOR': 3.72,
    'L-SI2-EX-GOOD-STRONG-POOR': 3.72,
    'L-SI2-VG-VG-STRONG-POOR': 3.72,
    'L-I2-POOR-VG-MEDIUM-GOOD': 3.72,
    'L-I2-GOOD-GOOD-MEDIUM-GOOD': 3.72,
    'L-I2-VG-POOR-MEDIUM-GOOD': 3.72,
    'L-I2-VG-EX-MEDIUM-POOR': 3.72,
    'L-SI2-POOR-GOOD-STRONG-GOOD': 3.72,
    'L-SI2-GOOD-POOR-STRONG-GOOD': 3.72,
    'L-SI2-GOOD-EX-STRONG-POOR': 3.72,
    'M-I2-GOOD-GOOD-FAINT-GOOD': 3.72,
    'M-I2-VG-POOR-FAINT-GOOD': 3.72,
    'M-SI2-EX-GOOD-MEDIUM-POOR': 3.72,
    'M-SI2-GOOD-EX-MEDIUM-POOR': 3.72,
    'M-SI2-VG-VG-MEDIUM-POOR': 3.72,
    'M-I2-POOR-VG-FAINT-GOOD': 3.72,
    'M-I2-EX-VG-FAINT-POOR': 3.72,
    'M-I2-VG-EX-FAINT-POOR': 3.72,
    'M-SI2-POOR-GOOD-MEDIUM-GOOD': 3.72,
    'M-SI2-GOOD-POOR-MEDIUM-GOOD': 3.72,
    'M-VS2-EX-POOR-STRONG-POOR': 3.71,
    'M-VS2-POOR-EX-STRONG-POOR': 3.71,
    'M-VS2-GOOD-VG-STRONG-POOR': 3.71,
    'M-VS2-VG-GOOD-STRONG-POOR': 3.71,
    'M-VS2-POOR-POOR-STRONG-GOOD': 3.71,
    'F-I1-POOR-POOR-STRONG-POOR': 3.69,
    'G-I1-POOR-POOR-MEDIUM-POOR': 3.69,
    'H-I1-POOR-POOR-FAINT-POOR': 3.69,
    'I-I1-POOR-POOR-NONE-POOR': 3.69,
    'K-I1-GOOD-POOR-STRONG-GOOD': 3.69,
    'K-I1-VG-VG-STRONG-POOR': 3.69,
    'K-I1-POOR-GOOD-STRONG-GOOD': 3.69,
    'K-I1-GOOD-EX-STRONG-POOR': 3.69,
    'K-I1-EX-GOOD-STRONG-POOR': 3.69,
    'L-I1-GOOD-EX-MEDIUM-POOR': 3.69,
    'L-I1-GOOD-POOR-MEDIUM-GOOD': 3.69,
    'L-SI1-POOR-POOR-STRONG-GOOD': 3.69,
    'L-SI1-GOOD-VG-STRONG-POOR': 3.69,
    'L-SI1-POOR-EX-STRONG-POOR': 3.69,
    'L-I1-VG-VG-MEDIUM-POOR': 3.69,
    'L-SI1-VG-GOOD-STRONG-POOR': 3.69,
    'L-I1-POOR-GOOD-MEDIUM-GOOD': 3.69,
    'L-SI1-EX-POOR-STRONG-POOR': 3.69,
    'L-I1-EX-GOOD-MEDIUM-POOR': 3.69,
    'M-SI1-VG-GOOD-MEDIUM-POOR': 3.69,
    'M-I1-POOR-GOOD-FAINT-GOOD': 3.69,
    'M-I1-VG-VG-FAINT-POOR': 3.69,
    'M-I1-GOOD-POOR-FAINT-GOOD': 3.69,
    'M-SI1-POOR-POOR-MEDIUM-GOOD': 3.69,
    'M-SI1-GOOD-VG-MEDIUM-POOR': 3.69,
    'M-I1-GOOD-EX-FAINT-POOR': 3.69,
    'M-SI1-POOR-EX-MEDIUM-POOR': 3.69,
    'M-SI1-EX-POOR-MEDIUM-POOR': 3.69,
    'M-I1-EX-GOOD-FAINT-POOR': 3.69,
    'M-VS1-GOOD-GOOD-STRONG-POOR': 3.68,
    'M-VS1-VG-POOR-STRONG-POOR': 3.68,
    'M-VS1-POOR-VG-STRONG-POOR': 3.68,
    'E-I2-POOR-POOR-STRONG-POOR': 3.67,
    'F-I2-POOR-POOR-MEDIUM-POOR': 3.67,
    'G-I2-POOR-POOR-FAINT-POOR': 3.67,
    'H-I2-POOR-POOR-NONE-POOR': 3.67,
    'J-I2-VG-VG-STRONG-POOR': 3.67,
    'J-I2-POOR-GOOD-STRONG-GOOD': 3.67,
    'J-I2-GOOD-POOR-STRONG-GOOD': 3.67,
    'J-I2-EX-GOOD-STRONG-POOR': 3.67,
    'J-I2-GOOD-EX-STRONG-POOR': 3.67,
    'K-SI2-EX-POOR-STRONG-POOR': 3.67,
    'K-SI2-VG-GOOD-STRONG-POOR': 3.67,
    'K-SI2-POOR-POOR-STRONG-GOOD': 3.67,
    'K-I2-EX-GOOD-MEDIUM-POOR': 3.67,
    'K-SI2-POOR-EX-STRONG-POOR': 3.67,
    'K-SI2-GOOD-VG-STRONG-POOR': 3.67,
    'K-I2-GOOD-POOR-MEDIUM-GOOD': 3.67,
    'K-I2-GOOD-EX-MEDIUM-POOR': 3.67,
    'K-I2-POOR-GOOD-MEDIUM-GOOD': 3.67,
    'K-I2-VG-VG-MEDIUM-POOR': 3.67,
    'L-SI2-POOR-POOR-MEDIUM-GOOD': 3.67,
    'L-SI2-POOR-EX-MEDIUM-POOR': 3.67,
    'L-I2-GOOD-POOR-FAINT-GOOD': 3.67,
    'L-I2-POOR-GOOD-FAINT-GOOD': 3.67,
    'L-I2-GOOD-EX-FAINT-POOR': 3.67,
    'L-SI2-VG-GOOD-MEDIUM-POOR': 3.67,
    'L-SI2-GOOD-VG-MEDIUM-POOR': 3.67,
    'L-I2-EX-GOOD-FAINT-POOR': 3.67,
    'L-I2-VG-VG-FAINT-POOR': 3.67,
    'L-SI2-EX-POOR-MEDIUM-POOR': 3.67,
    'M-I2-GOOD-EX-NONE-POOR': 3.67,
    'M-SI2-POOR-POOR-FAINT-GOOD': 3.67,
    'M-SI2-VG-GOOD-FAINT-POOR': 3.67,
    'M-SI2-GOOD-VG-FAINT-POOR': 3.67,
    'M-SI2-POOR-EX-FAINT-POOR': 3.67,
    'M-I2-GOOD-POOR-NONE-GOOD': 3.67,
    'M-I2-EX-GOOD-NONE-POOR': 3.67,
    'M-I2-POOR-GOOD-NONE-GOOD': 3.67,
    'M-I2-VG-VG-NONE-POOR': 3.67,
    'M-SI2-EX-POOR-FAINT-POOR': 3.67,
    'L-VS2-VG-POOR-STRONG-POOR': 3.66,
    'L-VS2-GOOD-GOOD-STRONG-POOR': 3.66,
    'L-VS2-POOR-VG-STRONG-POOR': 3.66,
    'M-VS2-VG-POOR-MEDIUM-POOR': 3.66,
    'M-VVS2-POOR-GOOD-STRONG-POOR': 3.66,
    'M-VVS2-GOOD-POOR-STRONG-POOR': 3.66,
    'M-VS2-GOOD-GOOD-MEDIUM-POOR': 3.66,
    'M-VS2-POOR-VG-MEDIUM-POOR': 3.66,
    'J-I1-POOR-EX-STRONG-POOR': 3.64,
    'J-I1-POOR-POOR-STRONG-GOOD': 3.64,
    'J-I1-GOOD-VG-STRONG-POOR': 3.64,
    'J-I1-EX-POOR-STRONG-POOR': 3.64,
    'J-I1-VG-GOOD-STRONG-POOR': 3.64,
    'K-I1-VG-GOOD-MEDIUM-POOR': 3.64,
    'K-I1-EX-POOR-MEDIUM-POOR': 3.64,
    'K-SI1-POOR-VG-STRONG-POOR': 3.64,
    'K-I1-POOR-EX-MEDIUM-POOR': 3.64,
    'K-SI1-GOOD-GOOD-STRONG-POOR': 3.64,
    'K-SI1-VG-POOR-STRONG-POOR': 3.64,
    'K-I1-POOR-POOR-MEDIUM-GOOD': 3.64,
    'K-I1-GOOD-VG-MEDIUM-POOR': 3.64,
    'L-I1-GOOD-VG-FAINT-POOR': 3.64,
    'L-I1-EX-POOR-FAINT-POOR': 3.64,
    'L-I1-VG-GOOD-FAINT-POOR': 3.64,
    'L-SI1-VG-POOR-MEDIUM-POOR': 3.64,
    'L-SI1-POOR-VG-MEDIUM-POOR': 3.64,
    'L-I1-POOR-POOR-FAINT-GOOD': 3.64,
    'L-SI1-GOOD-GOOD-MEDIUM-POOR': 3.64,
    'L-I1-POOR-EX-FAINT-POOR': 3.64,
    'M-I1-VG-GOOD-NONE-POOR': 3.64,
    'M-I1-GOOD-VG-NONE-POOR': 3.64,
    'M-I1-EX-POOR-NONE-POOR': 3.64,
    'M-I1-POOR-EX-NONE-POOR': 3.64,
    'M-SI1-POOR-VG-FAINT-POOR': 3.64,
    'M-I1-POOR-POOR-NONE-GOOD': 3.64,
    'M-SI1-VG-POOR-FAINT-POOR': 3.64,
    'M-SI1-GOOD-GOOD-FAINT-POOR': 3.64,
    'L-VS1-GOOD-POOR-STRONG-POOR': 3.63,
    'L-VS1-POOR-GOOD-STRONG-POOR': 3.63,
    'M-VS1-GOOD-POOR-MEDIUM-POOR': 3.63,
    'M-VVS1-POOR-POOR-STRONG-POOR': 3.63,
    'M-VS1-POOR-GOOD-MEDIUM-POOR': 3.63,
    'I-I2-GOOD-VG-STRONG-POOR': 3.62,
    'I-I2-EX-POOR-STRONG-POOR': 3.62,
    'I-I2-POOR-POOR-STRONG-GOOD': 3.62,
    'I-I2-VG-GOOD-STRONG-POOR': 3.62,
    'I-I2-POOR-EX-STRONG-POOR': 3.62,
    'J-SI2-POOR-VG-STRONG-POOR': 3.62,
    'J-I2-POOR-EX-MEDIUM-POOR': 3.62,
    'J-I2-GOOD-VG-MEDIUM-POOR': 3.62,
    'J-SI2-VG-POOR-STRONG-POOR': 3.62,
    'J-SI2-GOOD-GOOD-STRONG-POOR': 3.62,
    'J-I2-POOR-POOR-MEDIUM-GOOD': 3.62,
    'J-I2-EX-POOR-MEDIUM-POOR': 3.62,
    'J-I2-VG-GOOD-MEDIUM-POOR': 3.62,
    'K-I2-POOR-POOR-FAINT-GOOD': 3.62,
    'K-I2-GOOD-VG-FAINT-POOR': 3.62,
    'K-I2-VG-GOOD-FAINT-POOR': 3.62,
    'K-SI2-GOOD-GOOD-MEDIUM-POOR': 3.62,
    'K-I2-EX-POOR-FAINT-POOR': 3.62,
    'K-I2-POOR-EX-FAINT-POOR': 3.62,
    'K-SI2-POOR-VG-MEDIUM-POOR': 3.62,
    'K-SI2-VG-POOR-MEDIUM-POOR': 3.62,
    'L-SI2-GOOD-GOOD-FAINT-POOR': 3.62,
    'L-SI2-VG-POOR-FAINT-POOR': 3.62,
    'L-SI2-POOR-VG-FAINT-POOR': 3.62,
    'L-I2-VG-GOOD-NONE-POOR': 3.62,
    'L-I2-GOOD-VG-NONE-POOR': 3.62,
    'L-I2-POOR-EX-NONE-POOR': 3.62,
    'L-I2-POOR-POOR-NONE-GOOD': 3.62,
    'L-I2-EX-POOR-NONE-POOR': 3.62,
    'M-SI2-POOR-VG-NONE-POOR': 3.62,
    'M-SI2-VG-POOR-NONE-POOR': 3.62,
    'M-SI2-GOOD-GOOD-NONE-POOR': 3.62,
    'K-VS2-GOOD-POOR-STRONG-POOR': 3.61,
    'K-VS2-POOR-GOOD-STRONG-POOR': 3.61,
    'L-VVS2-POOR-POOR-STRONG-POOR': 3.61,
    'L-VS2-POOR-GOOD-MEDIUM-POOR': 3.61,
    'L-VS2-GOOD-POOR-MEDIUM-POOR': 3.61,
    'M-VVS2-POOR-POOR-MEDIUM-POOR': 3.61,
    'M-VS2-GOOD-POOR-FAINT-POOR': 3.61,
    'M-VS2-POOR-GOOD-FAINT-POOR': 3.61,
    'I-I1-VG-POOR-STRONG-POOR': 3.59,
    'I-I1-GOOD-GOOD-STRONG-POOR': 3.59,
    'I-I1-POOR-VG-STRONG-POOR': 3.59,
    'J-SI1-GOOD-POOR-STRONG-POOR': 3.59,
    'J-I1-POOR-VG-MEDIUM-POOR': 3.59,
    'J-I1-VG-POOR-MEDIUM-POOR': 3.59,
    'J-I1-GOOD-GOOD-MEDIUM-POOR': 3.59,
    'J-SI1-POOR-GOOD-STRONG-POOR': 3.59,
    'K-SI1-POOR-GOOD-MEDIUM-POOR': 3.59,
    'K-SI1-GOOD-POOR-MEDIUM-POOR': 3.59,
    'K-I1-GOOD-GOOD-FAINT-POOR': 3.59,
    'K-I1-POOR-VG-FAINT-POOR': 3.59,
    'K-I1-VG-POOR-FAINT-POOR': 3.59,
    'L-SI1-GOOD-POOR-FAINT-POOR': 3.59,
    'L-I1-GOOD-GOOD-NONE-POOR': 3.59,
    'L-I1-VG-POOR-NONE-POOR': 3.59,
    'L-SI1-POOR-GOOD-FAINT-POOR': 3.59,
    'L-I1-POOR-VG-NONE-POOR': 3.59,
    'M-SI1-POOR-GOOD-NONE-POOR': 3.59,
    'M-SI1-GOOD-POOR-NONE-POOR': 3.59,
    'K-VS1-POOR-POOR-STRONG-POOR': 3.58,
    'L-VS1-POOR-POOR-MEDIUM-POOR': 3.58,
    'M-VS1-POOR-POOR-FAINT-POOR': 3.58,
    'H-I2-POOR-VG-STRONG-POOR': 3.57,
    'H-I2-GOOD-GOOD-STRONG-POOR': 3.57,
    'H-I2-VG-POOR-STRONG-POOR': 3.57,
    'I-I2-GOOD-GOOD-MEDIUM-POOR': 3.57,
    'I-I2-POOR-VG-MEDIUM-POOR': 3.57,
    'I-I2-VG-POOR-MEDIUM-POOR': 3.57,
    'I-SI2-GOOD-POOR-STRONG-POOR': 3.57,
    'I-SI2-POOR-GOOD-STRONG-POOR': 3.57,
    'J-I2-VG-POOR-FAINT-POOR': 3.57,
    'J-I2-GOOD-GOOD-FAINT-POOR': 3.57,
    'J-SI2-GOOD-POOR-MEDIUM-POOR': 3.57,
    'J-I2-POOR-VG-FAINT-POOR': 3.57,
    'J-SI2-POOR-GOOD-MEDIUM-POOR': 3.57,
    'K-I2-VG-POOR-NONE-POOR': 3.57,
    'K-I2-POOR-VG-NONE-POOR': 3.57,
    'K-SI2-GOOD-POOR-FAINT-POOR': 3.57,
    'K-I2-GOOD-GOOD-NONE-POOR': 3.57,
    'K-SI2-POOR-GOOD-FAINT-POOR': 3.57,
    'L-SI2-POOR-GOOD-NONE-POOR': 3.57,
    'L-SI2-GOOD-POOR-NONE-POOR': 3.57,
    'M-I2-EX-EX-STRONG-POOR': 3.57,
    'M-I2-POOR-EX-STRONG-GOOD': 3.57,
    'M-I2-POOR-POOR-STRONG-VG': 3.57,
    'M-I2-GOOD-VG-STRONG-GOOD': 3.57,
    'M-I2-EX-POOR-STRONG-GOOD': 3.57,
    'M-I2-VG-GOOD-STRONG-GOOD': 3.57,
    'J-VS2-POOR-POOR-STRONG-POOR': 3.56,
    'K-VS2-POOR-POOR-MEDIUM-POOR': 3.56,
    'L-VS2-POOR-POOR-FAINT-POOR': 3.56,
    'M-VS2-POOR-POOR-NONE-POOR': 3.56,
    'H-I1-POOR-GOOD-STRONG-POOR': 3.54,
    'H-I1-GOOD-POOR-STRONG-POOR': 3.54,
    'I-SI1-POOR-POOR-STRONG-POOR': 3.54,
    'I-I1-GOOD-POOR-MEDIUM-POOR': 3.54,
    'I-I1-POOR-GOOD-MEDIUM-POOR': 3.54,
    'J-I1-GOOD-POOR-FAINT-POOR': 3.54,
    'J-SI1-POOR-POOR-MEDIUM-POOR': 3.54,
    'J-I1-POOR-GOOD-FAINT-POOR': 3.54,
    'K-I1-POOR-GOOD-NONE-POOR': 3.54,
    'K-I1-GOOD-POOR-NONE-POOR': 3.54,
    'K-SI1-POOR-POOR-FAINT-POOR': 3.54,
    'L-SI1-POOR-POOR-NONE-POOR': 3.54,
    'M-I1-VG-POOR-STRONG-GOOD': 3.54,
    'M-I1-POOR-VG-STRONG-GOOD': 3.54,
    'M-I1-VG-EX-STRONG-POOR': 3.54,
    'M-I1-EX-VG-STRONG-POOR': 3.54,
    'M-I1-GOOD-GOOD-STRONG-GOOD': 3.54,
    'G-I2-GOOD-POOR-STRONG-POOR': 3.52,
    'G-I2-POOR-GOOD-STRONG-POOR': 3.52,
    'H-I2-POOR-GOOD-MEDIUM-POOR': 3.52,
    'H-I2-GOOD-POOR-MEDIUM-POOR': 3.52,
    'H-SI2-POOR-POOR-STRONG-POOR': 3.52,
    'I-I2-POOR-GOOD-FAINT-POOR': 3.52,
    'I-I2-GOOD-POOR-FAINT-POOR': 3.52,
    'I-SI2-POOR-POOR-MEDIUM-POOR': 3.52,
    'J-I2-GOOD-POOR-NONE-POOR': 3.52,
    'J-I2-POOR-GOOD-NONE-POOR': 3.52,
    'J-SI2-POOR-POOR-FAINT-POOR': 3.52,
    'K-SI2-POOR-POOR-NONE-POOR': 3.52,
    'L-I2-VG-EX-STRONG-POOR': 3.52,
    'L-I2-EX-VG-STRONG-POOR': 3.52,
    'L-I2-VG-POOR-STRONG-GOOD': 3.52,
    'L-I2-POOR-VG-STRONG-GOOD': 3.52,
    'L-I2-GOOD-GOOD-STRONG-GOOD': 3.52,
    'M-SI2-POOR-GOOD-STRONG-GOOD': 3.52,
    'M-I2-VG-EX-MEDIUM-POOR': 3.52,
    'M-SI2-VG-VG-STRONG-POOR': 3.52,
    'M-SI2-GOOD-POOR-STRONG-GOOD': 3.52,
    'M-SI2-EX-GOOD-STRONG-POOR': 3.52,
    'M-SI2-GOOD-EX-STRONG-POOR': 3.52,
    'M-I2-EX-VG-MEDIUM-POOR': 3.52,
    'M-I2-VG-POOR-MEDIUM-GOOD': 3.52,
    'M-I2-GOOD-GOOD-MEDIUM-GOOD': 3.52,
    'M-I2-POOR-VG-MEDIUM-GOOD': 3.52,
    'G-I1-POOR-POOR-STRONG-POOR': 3.49,
    'H-I1-POOR-POOR-MEDIUM-POOR': 3.49,
    'I-I1-POOR-POOR-FAINT-POOR': 3.49,
    'J-I1-POOR-POOR-NONE-POOR': 3.49,
    'L-I1-POOR-GOOD-STRONG-GOOD': 3.49,
    'L-I1-GOOD-POOR-STRONG-GOOD': 3.49,
    'L-I1-VG-VG-STRONG-POOR': 3.49,
    'L-I1-GOOD-EX-STRONG-POOR': 3.49,
    'L-I1-EX-GOOD-STRONG-POOR': 3.49,
    'M-I1-GOOD-POOR-MEDIUM-GOOD': 3.49,
    'M-SI1-VG-GOOD-STRONG-POOR': 3.49,
    'M-I1-POOR-GOOD-MEDIUM-GOOD': 3.49,
    'M-SI1-EX-POOR-STRONG-POOR': 3.49,
    'M-I1-GOOD-EX-MEDIUM-POOR': 3.49,
    'M-I1-VG-VG-MEDIUM-POOR': 3.49,
    'M-SI1-POOR-POOR-STRONG-GOOD': 3.49,
    'M-SI1-POOR-EX-STRONG-POOR': 3.49,
    'M-SI1-GOOD-VG-STRONG-POOR': 3.49,
    'M-I1-EX-GOOD-MEDIUM-POOR': 3.49,
    'F-I2-POOR-POOR-STRONG-POOR': 3.47,
    'G-I2-POOR-POOR-MEDIUM-POOR': 3.47,
    'H-I2-POOR-POOR-FAINT-POOR': 3.47,
    'I-I2-POOR-POOR-NONE-POOR': 3.47,
    'K-I2-EX-GOOD-STRONG-POOR': 3.47,
    'K-I2-POOR-GOOD-STRONG-GOOD': 3.47,
    'K-I2-GOOD-POOR-STRONG-GOOD': 3.47,
    'K-I2-VG-VG-STRONG-POOR': 3.47,
    'K-I2-GOOD-EX-STRONG-POOR': 3.47,
    'L-I2-GOOD-EX-MEDIUM-POOR': 3.47,
    'L-I2-VG-VG-MEDIUM-POOR': 3.47,
    'L-SI2-POOR-POOR-STRONG-GOOD': 3.47,
    'L-I2-POOR-GOOD-MEDIUM-GOOD': 3.47,
    'L-I2-GOOD-POOR-MEDIUM-GOOD': 3.47,
    'L-SI2-POOR-EX-STRONG-POOR': 3.47,
    'L-SI2-VG-GOOD-STRONG-POOR': 3.47,
    'L-I2-EX-GOOD-MEDIUM-POOR': 3.47,
    'L-SI2-GOOD-VG-STRONG-POOR': 3.47,
    'L-SI2-EX-POOR-STRONG-POOR': 3.47,
    'M-I2-GOOD-EX-FAINT-POOR': 3.47,
    'M-I2-POOR-GOOD-FAINT-GOOD': 3.47,
    'M-SI2-EX-POOR-MEDIUM-POOR': 3.47,
    'M-SI2-VG-GOOD-MEDIUM-POOR': 3.47,
    'M-I2-EX-GOOD-FAINT-POOR': 3.47,
    'M-SI2-POOR-EX-MEDIUM-POOR': 3.47,
    'M-I2-GOOD-POOR-FAINT-GOOD': 3.47,
    'M-SI2-GOOD-VG-MEDIUM-POOR': 3.47,
    'M-SI2-POOR-POOR-MEDIUM-GOOD': 3.47,
    'M-I2-VG-VG-FAINT-POOR': 3.47,
    'M-VS2-GOOD-GOOD-STRONG-POOR': 3.46,
    'M-VS2-POOR-VG-STRONG-POOR': 3.46,
    'M-VS2-VG-POOR-STRONG-POOR': 3.46,
    'K-I1-POOR-EX-STRONG-POOR': 3.44,
    'K-I1-VG-GOOD-STRONG-POOR': 3.44,
    'K-I1-GOOD-VG-STRONG-POOR': 3.44,
    'K-I1-EX-POOR-STRONG-POOR': 3.44,
    'K-I1-POOR-POOR-STRONG-GOOD': 3.44,
    'L-I1-POOR-EX-MEDIUM-POOR': 3.44,
    'L-I1-EX-POOR-MEDIUM-POOR': 3.44,
    'L-SI1-GOOD-GOOD-STRONG-POOR': 3.44,
    'L-I1-GOOD-VG-MEDIUM-POOR': 3.44,
    'L-SI1-VG-POOR-STRONG-POOR': 3.44,
    'L-I1-VG-GOOD-MEDIUM-POOR': 3.44,
    'L-I1-POOR-POOR-MEDIUM-GOOD': 3.44,
    'L-SI1-POOR-VG-STRONG-POOR': 3.44,
    'M-SI1-VG-POOR-MEDIUM-POOR': 3.44,
    'M-I1-VG-GOOD-FAINT-POOR': 3.44,
    'M-I1-EX-POOR-FAINT-POOR': 3.44,
    'M-I1-GOOD-VG-FAINT-POOR': 3.44,
    'M-SI1-GOOD-GOOD-MEDIUM-POOR': 3.44,
    'M-I1-POOR-EX-FAINT-POOR': 3.44,
    'M-SI1-POOR-VG-MEDIUM-POOR': 3.44,
    'M-I1-POOR-POOR-FAINT-GOOD': 3.44,
    'M-VS1-POOR-GOOD-STRONG-POOR': 3.43,
    'M-VS1-GOOD-POOR-STRONG-POOR': 3.43,
    'J-I2-POOR-EX-STRONG-POOR': 3.42,
    'J-I2-POOR-POOR-STRONG-GOOD': 3.42,
    'J-I2-VG-GOOD-STRONG-POOR': 3.42,
    'J-I2-EX-POOR-STRONG-POOR': 3.42,
    'J-I2-GOOD-VG-STRONG-POOR': 3.42,
    'K-SI2-VG-POOR-STRONG-POOR': 3.42,
    'K-I2-VG-GOOD-MEDIUM-POOR': 3.42,
    'K-I2-POOR-EX-MEDIUM-POOR': 3.42,
    'K-SI2-GOOD-GOOD-STRONG-POOR': 3.42,
    'K-I2-POOR-POOR-MEDIUM-GOOD': 3.42,
    'K-SI2-POOR-VG-STRONG-POOR': 3.42,
    'K-I2-EX-POOR-MEDIUM-POOR': 3.42,
    'K-I2-GOOD-VG-MEDIUM-POOR': 3.42,
    'L-SI2-VG-POOR-MEDIUM-POOR': 3.42,
    'L-I2-GOOD-VG-FAINT-POOR': 3.42,
    'L-SI2-POOR-VG-MEDIUM-POOR': 3.42,
    'L-I2-VG-GOOD-FAINT-POOR': 3.42,
    'L-I2-POOR-POOR-FAINT-GOOD': 3.42,
    'L-I2-EX-POOR-FAINT-POOR': 3.42,
    'L-SI2-GOOD-GOOD-MEDIUM-POOR': 3.42,
    'L-I2-POOR-EX-FAINT-POOR': 3.42,
    'M-I2-GOOD-VG-NONE-POOR': 3.42,
    'M-I2-POOR-EX-NONE-POOR': 3.42,
    'M-SI2-POOR-VG-FAINT-POOR': 3.42,
    'M-SI2-VG-POOR-FAINT-POOR': 3.42,
    'M-SI2-GOOD-GOOD-FAINT-POOR': 3.42,
    'M-I2-VG-GOOD-NONE-POOR': 3.42,
    'M-I2-EX-POOR-NONE-POOR': 3.42,
    'M-I2-POOR-POOR-NONE-GOOD': 3.42,
    'L-VS2-GOOD-POOR-STRONG-POOR': 3.41,
    'L-VS2-POOR-GOOD-STRONG-POOR': 3.41,
    'M-VS2-GOOD-POOR-MEDIUM-POOR': 3.41,
    'M-VS2-POOR-GOOD-MEDIUM-POOR': 3.41,
    'M-VVS2-POOR-POOR-STRONG-POOR': 3.41,
    'J-I1-GOOD-GOOD-STRONG-POOR': 3.39,
    'J-I1-VG-POOR-STRONG-POOR': 3.39,
    'J-I1-POOR-VG-STRONG-POOR': 3.39,
    'K-SI1-GOOD-POOR-STRONG-POOR': 3.39,
    'K-I1-VG-POOR-MEDIUM-POOR': 3.39,
    'K-I1-POOR-VG-MEDIUM-POOR': 3.39,
    'K-SI1-POOR-GOOD-STRONG-POOR': 3.39,
    'K-I1-GOOD-GOOD-MEDIUM-POOR': 3.39,
    'L-SI1-GOOD-POOR-MEDIUM-POOR': 3.39,
    'L-I1-GOOD-GOOD-FAINT-POOR': 3.39,
    'L-I1-POOR-VG-FAINT-POOR': 3.39,
    'L-I1-VG-POOR-FAINT-POOR': 3.39,
    'L-SI1-POOR-GOOD-MEDIUM-POOR': 3.39,
    'M-I1-GOOD-GOOD-NONE-POOR': 3.39,
    'M-I1-POOR-VG-NONE-POOR': 3.39,
    'M-SI1-POOR-GOOD-FAINT-POOR': 3.39,
    'M-I1-VG-POOR-NONE-POOR': 3.39,
    'M-SI1-GOOD-POOR-FAINT-POOR': 3.39,
    'L-VS1-POOR-POOR-STRONG-POOR': 3.38,
    'M-VS1-POOR-POOR-MEDIUM-POOR': 3.38,
    'I-I2-GOOD-GOOD-STRONG-POOR': 3.37,
    'I-I2-POOR-VG-STRONG-POOR': 3.37,
    'I-I2-VG-POOR-STRONG-POOR': 3.37,
    'J-I2-GOOD-GOOD-MEDIUM-POOR': 3.37,
    'J-SI2-POOR-GOOD-STRONG-POOR': 3.37,
    'J-I2-VG-POOR-MEDIUM-POOR': 3.37,
    'J-I2-POOR-VG-MEDIUM-POOR': 3.37,
    'J-SI2-GOOD-POOR-STRONG-POOR': 3.37,
    'K-SI2-GOOD-POOR-MEDIUM-POOR': 3.37,
    'K-I2-VG-POOR-FAINT-POOR': 3.37,
    'K-I2-POOR-VG-FAINT-POOR': 3.37,
    'K-SI2-POOR-GOOD-MEDIUM-POOR': 3.37,
    'K-I2-GOOD-GOOD-FAINT-POOR': 3.37,
    'L-SI2-POOR-GOOD-FAINT-POOR': 3.37,
    'L-I2-VG-POOR-NONE-POOR': 3.37,
    'L-SI2-GOOD-POOR-FAINT-POOR': 3.37,
    'L-I2-GOOD-GOOD-NONE-POOR': 3.37,
    'L-I2-POOR-VG-NONE-POOR': 3.37,
    'M-SI2-POOR-GOOD-NONE-POOR': 3.37,
    'M-SI2-GOOD-POOR-NONE-POOR': 3.37,
    'K-VS2-POOR-POOR-STRONG-POOR': 3.36,
    'L-VS2-POOR-POOR-MEDIUM-POOR': 3.36,
    'M-VS2-POOR-POOR-FAINT-POOR': 3.36,
    'I-I1-POOR-GOOD-STRONG-POOR': 3.34,
    'I-I1-GOOD-POOR-STRONG-POOR': 3.34,
    'J-I1-GOOD-POOR-MEDIUM-POOR': 3.34,
    'J-I1-POOR-GOOD-MEDIUM-POOR': 3.34,
    'J-SI1-POOR-POOR-STRONG-POOR': 3.34,
    'K-I1-GOOD-POOR-FAINT-POOR': 3.34,
    'K-SI1-POOR-POOR-MEDIUM-POOR': 3.34,
    'K-I1-POOR-GOOD-FAINT-POOR': 3.34,
    'L-SI1-POOR-POOR-FAINT-POOR': 3.34,
    'L-I1-POOR-GOOD-NONE-POOR': 3.34,
    'L-I1-GOOD-POOR-NONE-POOR': 3.34,
    'M-SI1-POOR-POOR-NONE-POOR': 3.34,
    'H-I2-POOR-GOOD-STRONG-POOR': 3.32,
    'H-I2-GOOD-POOR-STRONG-POOR': 3.32,
    'I-I2-GOOD-POOR-MEDIUM-POOR': 3.32,
    'I-I2-POOR-GOOD-MEDIUM-POOR': 3.32,
    'I-SI2-POOR-POOR-STRONG-POOR': 3.32,
    'J-SI2-POOR-POOR-MEDIUM-POOR': 3.32,
    'J-I2-GOOD-POOR-FAINT-POOR': 3.32,
    'J-I2-POOR-GOOD-FAINT-POOR': 3.32,
    'K-I2-POOR-GOOD-NONE-POOR': 3.32,
    'K-I2-GOOD-POOR-NONE-POOR': 3.32,
    'K-SI2-POOR-POOR-FAINT-POOR': 3.32,
    'L-SI2-POOR-POOR-NONE-POOR': 3.32,
    'M-I2-GOOD-GOOD-STRONG-GOOD': 3.32,
    'M-I2-VG-EX-STRONG-POOR': 3.32,
    'M-I2-EX-VG-STRONG-POOR': 3.32,
    'M-I2-VG-POOR-STRONG-GOOD': 3.32,
    'M-I2-POOR-VG-STRONG-GOOD': 3.32,
    'H-I1-POOR-POOR-STRONG-POOR': 3.29,
    'I-I1-POOR-POOR-MEDIUM-POOR': 3.29,
    'J-I1-POOR-POOR-FAINT-POOR': 3.29,
    'K-I1-POOR-POOR-NONE-POOR': 3.29,
    'M-I1-GOOD-EX-STRONG-POOR': 3.29,
    'M-I1-EX-GOOD-STRONG-POOR': 3.29,
    'M-I1-POOR-GOOD-STRONG-GOOD': 3.29,
    'M-I1-GOOD-POOR-STRONG-GOOD': 3.29,
    'M-I1-VG-VG-STRONG-POOR': 3.29,
    'G-I2-POOR-POOR-STRONG-POOR': 3.27,
    'H-I2-POOR-POOR-MEDIUM-POOR': 3.27,
    'I-I2-POOR-POOR-FAINT-POOR': 3.27,
    'J-I2-POOR-POOR-NONE-POOR': 3.27,
    'L-I2-VG-VG-STRONG-POOR': 3.27,
    'L-I2-POOR-GOOD-STRONG-GOOD': 3.27,
    'L-I2-GOOD-EX-STRONG-POOR': 3.27,
    'L-I2-EX-GOOD-STRONG-POOR': 3.27,
    'L-I2-GOOD-POOR-STRONG-GOOD': 3.27,
    'M-I2-EX-GOOD-MEDIUM-POOR': 3.27,
    'M-SI2-VG-GOOD-STRONG-POOR': 3.27,
    'M-SI2-POOR-POOR-STRONG-GOOD': 3.27,
    'M-I2-POOR-GOOD-MEDIUM-GOOD': 3.27,
    'M-SI2-POOR-EX-STRONG-POOR': 3.27,
    'M-SI2-EX-POOR-STRONG-POOR': 3.27,
    'M-I2-GOOD-POOR-MEDIUM-GOOD': 3.27,
    'M-I2-VG-VG-MEDIUM-POOR': 3.27,
    'M-I2-GOOD-EX-MEDIUM-POOR': 3.27,
    'M-SI2-GOOD-VG-STRONG-POOR': 3.27,
    'L-I1-GOOD-VG-STRONG-POOR': 3.24,
    'L-I1-POOR-EX-STRONG-POOR': 3.24,
    'L-I1-POOR-POOR-STRONG-GOOD': 3.24,
    'L-I1-VG-GOOD-STRONG-POOR': 3.24,
    'L-I1-EX-POOR-STRONG-POOR': 3.24,
    'M-I1-VG-GOOD-MEDIUM-POOR': 3.24,
    'M-I1-GOOD-VG-MEDIUM-POOR': 3.24,
    'M-I1-EX-POOR-MEDIUM-POOR': 3.24,
    'M-I1-POOR-EX-MEDIUM-POOR': 3.24,
    'M-SI1-VG-POOR-STRONG-POOR': 3.24,
    'M-SI1-GOOD-GOOD-STRONG-POOR': 3.24,
    'M-SI1-POOR-VG-STRONG-POOR': 3.24,
    'M-I1-POOR-POOR-MEDIUM-GOOD': 3.24,
    'K-I2-GOOD-VG-STRONG-POOR': 3.22,
    'K-I2-POOR-EX-STRONG-POOR': 3.22,
    'K-I2-VG-GOOD-STRONG-POOR': 3.22,
    'K-I2-POOR-POOR-STRONG-GOOD': 3.22,
    'K-I2-EX-POOR-STRONG-POOR': 3.22,
    'L-I2-POOR-POOR-MEDIUM-GOOD': 3.22,
    'L-I2-POOR-EX-MEDIUM-POOR': 3.22,
    'L-I2-EX-POOR-MEDIUM-POOR': 3.22,
    'L-SI2-GOOD-GOOD-STRONG-POOR': 3.22,
    'L-SI2-POOR-VG-STRONG-POOR': 3.22,
    'L-SI2-VG-POOR-STRONG-POOR': 3.22,
    'L-I2-GOOD-VG-MEDIUM-POOR': 3.22,
    'L-I2-VG-GOOD-MEDIUM-POOR': 3.22,
    'M-I2-GOOD-VG-FAINT-POOR': 3.22,
    'M-SI2-VG-POOR-MEDIUM-POOR': 3.22,
    'M-I2-VG-GOOD-FAINT-POOR': 3.22,
    'M-I2-EX-POOR-FAINT-POOR': 3.22,
    'M-I2-POOR-POOR-FAINT-GOOD': 3.22,
    'M-SI2-POOR-VG-MEDIUM-POOR': 3.22,
    'M-SI2-GOOD-GOOD-MEDIUM-POOR': 3.22,
    'M-I2-POOR-EX-FAINT-POOR': 3.22,
    'M-VS2-GOOD-POOR-STRONG-POOR': 3.21,
    'M-VS2-POOR-GOOD-STRONG-POOR': 3.21,
    'K-I1-POOR-VG-STRONG-POOR': 3.19,
    'K-I1-GOOD-GOOD-STRONG-POOR': 3.19,
    'K-I1-VG-POOR-STRONG-POOR': 3.19,
    'L-I1-GOOD-GOOD-MEDIUM-POOR': 3.19,
    'L-SI1-GOOD-POOR-STRONG-POOR': 3.19,
    'L-I1-POOR-VG-MEDIUM-POOR': 3.19,
    'L-SI1-POOR-GOOD-STRONG-POOR': 3.19,
    'L-I1-VG-POOR-MEDIUM-POOR': 3.19,
    'M-I1-VG-POOR-FAINT-POOR': 3.19,
    'M-I1-POOR-VG-FAINT-POOR': 3.19,
    'M-SI1-GOOD-POOR-MEDIUM-POOR': 3.19,
    'M-SI1-POOR-GOOD-MEDIUM-POOR': 3.19,
    'M-I1-GOOD-GOOD-FAINT-POOR': 3.19,
    'M-VS1-POOR-POOR-STRONG-POOR': 3.18,
    'J-I2-VG-POOR-STRONG-POOR': 3.17,
    'J-I2-GOOD-GOOD-STRONG-POOR': 3.17,
    'J-I2-POOR-VG-STRONG-POOR': 3.17,
    'K-I2-GOOD-GOOD-MEDIUM-POOR': 3.17,
    'K-I2-VG-POOR-MEDIUM-POOR': 3.17,
    'K-SI2-POOR-GOOD-STRONG-POOR': 3.17,
    'K-I2-POOR-VG-MEDIUM-POOR': 3.17,
    'K-SI2-GOOD-POOR-STRONG-POOR': 3.17,
    'L-SI2-GOOD-POOR-MEDIUM-POOR': 3.17,
    'L-I2-POOR-VG-FAINT-POOR': 3.17,
    'L-I2-GOOD-GOOD-FAINT-POOR': 3.17,
    'L-I2-VG-POOR-FAINT-POOR': 3.17,
    'L-SI2-POOR-GOOD-MEDIUM-POOR': 3.17,
    'M-SI2-GOOD-POOR-FAINT-POOR': 3.17,
    'M-I2-VG-POOR-NONE-POOR': 3.17,
    'M-I2-GOOD-GOOD-NONE-POOR': 3.17,
    'M-SI2-POOR-GOOD-FAINT-POOR': 3.17,
    'M-I2-POOR-VG-NONE-POOR': 3.17,
    'L-VS2-POOR-POOR-STRONG-POOR': 3.16,
    'M-VS2-POOR-POOR-MEDIUM-POOR': 3.16,
    'J-I1-GOOD-POOR-STRONG-POOR': 3.14,
    'J-I1-POOR-GOOD-STRONG-POOR': 3.14,
    'K-I1-GOOD-POOR-MEDIUM-POOR': 3.14,
    'K-SI1-POOR-POOR-STRONG-POOR': 3.14,
    'K-I1-POOR-GOOD-MEDIUM-POOR': 3.14,
    'L-I1-GOOD-POOR-FAINT-POOR': 3.14,
    'L-SI1-POOR-POOR-MEDIUM-POOR': 3.14,
    'L-I1-POOR-GOOD-FAINT-POOR': 3.14,
    'M-SI1-POOR-POOR-FAINT-POOR': 3.14,
    'M-I1-GOOD-POOR-NONE-POOR': 3.14,
    'M-I1-POOR-GOOD-NONE-POOR': 3.14,
    'I-I2-POOR-GOOD-STRONG-POOR': 3.12,
    'I-I2-GOOD-POOR-STRONG-POOR': 3.12,
    'J-I2-POOR-GOOD-MEDIUM-POOR': 3.12,
    'J-I2-GOOD-POOR-MEDIUM-POOR': 3.12,
    'J-SI2-POOR-POOR-STRONG-POOR': 3.12,
    'K-I2-POOR-GOOD-FAINT-POOR': 3.12,
    'K-I2-GOOD-POOR-FAINT-POOR': 3.12,
    'K-SI2-POOR-POOR-MEDIUM-POOR': 3.12,
    'L-I2-POOR-GOOD-NONE-POOR': 3.12,
    'L-SI2-POOR-POOR-FAINT-POOR': 3.12,
    'L-I2-GOOD-POOR-NONE-POOR': 3.12,
    'M-SI2-POOR-POOR-NONE-POOR': 3.12,
    'I-I1-POOR-POOR-STRONG-POOR': 3.09,
    'J-I1-POOR-POOR-MEDIUM-POOR': 3.09,
    'K-I1-POOR-POOR-FAINT-POOR': 3.09,
    'L-I1-POOR-POOR-NONE-POOR': 3.09,
    'H-I2-POOR-POOR-STRONG-POOR': 3.07,
    'I-I2-POOR-POOR-MEDIUM-POOR': 3.07,
    'J-I2-POOR-POOR-FAINT-POOR': 3.07,
    'K-I2-POOR-POOR-NONE-POOR': 3.07,
    'M-I2-GOOD-POOR-STRONG-GOOD': 3.07,
    'M-I2-VG-VG-STRONG-POOR': 3.07,
    'M-I2-GOOD-EX-STRONG-POOR': 3.07,
    'M-I2-POOR-GOOD-STRONG-GOOD': 3.07,
    'M-I2-EX-GOOD-STRONG-POOR': 3.07,
    'M-I1-GOOD-VG-STRONG-POOR': 3.04,
    'M-I1-POOR-EX-STRONG-POOR': 3.04,
    'M-I1-VG-GOOD-STRONG-POOR': 3.04,
    'M-I1-POOR-POOR-STRONG-GOOD': 3.04,
    'M-I1-EX-POOR-STRONG-POOR': 3.04,
    'L-I2-POOR-POOR-STRONG-GOOD': 3.02,
    'L-I2-POOR-EX-STRONG-POOR': 3.02,
    'L-I2-EX-POOR-STRONG-POOR': 3.02,
    'L-I2-VG-GOOD-STRONG-POOR': 3.02,
    'L-I2-GOOD-VG-STRONG-POOR': 3.02,
    'M-I2-POOR-EX-MEDIUM-POOR': 3.02,
    'M-I2-POOR-POOR-MEDIUM-GOOD': 3.02,
    'M-SI2-VG-POOR-STRONG-POOR': 3.02,
    'M-I2-EX-POOR-MEDIUM-POOR': 3.02,
    'M-SI2-GOOD-GOOD-STRONG-POOR': 3.02,
    'M-I2-GOOD-VG-MEDIUM-POOR': 3.02,
    'M-SI2-POOR-VG-STRONG-POOR': 3.02,
    'M-I2-VG-GOOD-MEDIUM-POOR': 3.02,
    'L-I1-VG-POOR-STRONG-POOR': 2.99,
    'L-I1-GOOD-GOOD-STRONG-POOR': 2.99,
    'L-I1-POOR-VG-STRONG-POOR': 2.99,
    'M-SI1-GOOD-POOR-STRONG-POOR': 2.99,
    'M-I1-GOOD-GOOD-MEDIUM-POOR': 2.99,
    'M-SI1-POOR-GOOD-STRONG-POOR': 2.99,
    'M-I1-VG-POOR-MEDIUM-POOR': 2.99,
    'M-I1-POOR-VG-MEDIUM-POOR': 2.99,
    'K-I2-POOR-VG-STRONG-POOR': 2.97,
    'K-I2-VG-POOR-STRONG-POOR': 2.97,
    'K-I2-GOOD-GOOD-STRONG-POOR': 2.97,
    'L-SI2-GOOD-POOR-STRONG-POOR': 2.97,
    'L-I2-GOOD-GOOD-MEDIUM-POOR': 2.97,
    'L-I2-VG-POOR-MEDIUM-POOR': 2.97,
    'L-I2-POOR-VG-MEDIUM-POOR': 2.97,
    'L-SI2-POOR-GOOD-STRONG-POOR': 2.97,
    'M-I2-POOR-VG-FAINT-POOR': 2.97,
    'M-I2-GOOD-GOOD-FAINT-POOR': 2.97,
    'M-I2-VG-POOR-FAINT-POOR': 2.97,
    'M-SI2-GOOD-POOR-MEDIUM-POOR': 2.97,
    'M-SI2-POOR-GOOD-MEDIUM-POOR': 2.97,
    'M-VS2-POOR-POOR-STRONG-POOR': 2.96,
    'K-I1-GOOD-POOR-STRONG-POOR': 2.94,
    'K-I1-POOR-GOOD-STRONG-POOR': 2.94,
    'L-SI1-POOR-POOR-STRONG-POOR': 2.94,
    'L-I1-POOR-GOOD-MEDIUM-POOR': 2.94,
    'L-I1-GOOD-POOR-MEDIUM-POOR': 2.94,
    'M-I1-POOR-GOOD-FAINT-POOR': 2.94,
    'M-I1-GOOD-POOR-FAINT-POOR': 2.94,
    'M-SI1-POOR-POOR-MEDIUM-POOR': 2.94,
    'J-I2-GOOD-POOR-STRONG-POOR': 2.92,
    'J-I2-POOR-GOOD-STRONG-POOR': 2.92,
    'K-SI2-POOR-POOR-STRONG-POOR': 2.92,
    'K-I2-POOR-GOOD-MEDIUM-POOR': 2.92,
    'K-I2-GOOD-POOR-MEDIUM-POOR': 2.92,
    'L-I2-POOR-GOOD-FAINT-POOR': 2.92,
    'L-I2-GOOD-POOR-FAINT-POOR': 2.92,
    'L-SI2-POOR-POOR-MEDIUM-POOR': 2.92,
    'M-SI2-POOR-POOR-FAINT-POOR': 2.92,
    'M-I2-GOOD-POOR-NONE-POOR': 2.92,
    'M-I2-POOR-GOOD-NONE-POOR': 2.92,
    'J-I1-POOR-POOR-STRONG-POOR': 2.89,
    'K-I1-POOR-POOR-MEDIUM-POOR': 2.89,
    'L-I1-POOR-POOR-FAINT-POOR': 2.89,
    'M-I1-POOR-POOR-NONE-POOR': 2.89,
    'I-I2-POOR-POOR-STRONG-POOR': 2.87,
    'J-I2-POOR-POOR-MEDIUM-POOR': 2.87,
    'K-I2-POOR-POOR-FAINT-POOR': 2.87,
    'L-I2-POOR-POOR-NONE-POOR': 2.87,
    'M-I2-POOR-POOR-STRONG-GOOD': 2.82,
    'M-I2-POOR-EX-STRONG-POOR': 2.82,
    'M-I2-GOOD-VG-STRONG-POOR': 2.82,
    'M-I2-VG-GOOD-STRONG-POOR': 2.82,
    'M-I2-EX-POOR-STRONG-POOR': 2.82,
    'M-I1-VG-POOR-STRONG-POOR': 2.79,
    'M-I1-GOOD-GOOD-STRONG-POOR': 2.79,
    'M-I1-POOR-VG-STRONG-POOR': 2.79,
    'L-I2-POOR-VG-STRONG-POOR': 2.77,
    'L-I2-GOOD-GOOD-STRONG-POOR': 2.77,
    'L-I2-VG-POOR-STRONG-POOR': 2.77,
    'M-I2-POOR-VG-MEDIUM-POOR': 2.77,
    'M-SI2-GOOD-POOR-STRONG-POOR': 2.77,
    'M-I2-GOOD-GOOD-MEDIUM-POOR': 2.77,
    'M-SI2-POOR-GOOD-STRONG-POOR': 2.77,
    'M-I2-VG-POOR-MEDIUM-POOR': 2.77,
    'L-I1-GOOD-POOR-STRONG-POOR': 2.74,
    'L-I1-POOR-GOOD-STRONG-POOR': 2.74,
    'M-SI1-POOR-POOR-STRONG-POOR': 2.74,
    'M-I1-GOOD-POOR-MEDIUM-POOR': 2.74,
    'M-I1-POOR-GOOD-MEDIUM-POOR': 2.74,
    'K-I2-GOOD-POOR-STRONG-POOR': 2.72,
    'K-I2-POOR-GOOD-STRONG-POOR': 2.72,
    'L-I2-GOOD-POOR-MEDIUM-POOR': 2.72,
    'L-I2-POOR-GOOD-MEDIUM-POOR': 2.72,
    'L-SI2-POOR-POOR-STRONG-POOR': 2.72,
    'M-SI2-POOR-POOR-MEDIUM-POOR': 2.72,
    'M-I2-POOR-GOOD-FAINT-POOR': 2.72,
    'M-I2-GOOD-POOR-FAINT-POOR': 2.72,
    'K-I1-POOR-POOR-STRONG-POOR': 2.69,
    'L-I1-POOR-POOR-MEDIUM-POOR': 2.69,
    'M-I1-POOR-POOR-FAINT-POOR': 2.69,
    'J-I2-POOR-POOR-STRONG-POOR': 2.67,
    'K-I2-POOR-POOR-MEDIUM-POOR': 2.67,
    'L-I2-POOR-POOR-FAINT-POOR': 2.67,
    'M-I2-POOR-POOR-NONE-POOR': 2.67,
    'M-I2-GOOD-GOOD-STRONG-POOR': 2.57,
    'M-I2-POOR-VG-STRONG-POOR': 2.57,
    'M-I2-VG-POOR-STRONG-POOR': 2.57,
    'M-I1-POOR-GOOD-STRONG-POOR': 2.54,
    'M-I1-GOOD-POOR-STRONG-POOR': 2.54,
    'L-I2-GOOD-POOR-STRONG-POOR': 2.52,
    'L-I2-POOR-GOOD-STRONG-POOR': 2.52,
    'M-SI2-POOR-POOR-STRONG-POOR': 2.52,
    'M-I2-GOOD-POOR-MEDIUM-POOR': 2.52,
    'M-I2-POOR-GOOD-MEDIUM-POOR': 2.52,
    'L-I1-POOR-POOR-STRONG-POOR': 2.49,
    'M-I1-POOR-POOR-MEDIUM-POOR': 2.49,
    'K-I2-POOR-POOR-STRONG-POOR': 2.47,
    'L-I2-POOR-POOR-MEDIUM-POOR': 2.47,
    'M-I2-POOR-POOR-FAINT-POOR': 2.47,
    'M-I2-POOR-GOOD-STRONG-POOR': 2.32,
    'M-I2-GOOD-POOR-STRONG-POOR': 2.32,
    'M-I1-POOR-POOR-STRONG-POOR': 2.29,
    'L-I2-POOR-POOR-STRONG-POOR': 2.27,
    'M-I2-POOR-POOR-MEDIUM-POOR': 2.27,
    'M-I2-POOR-POOR-STRONG-POOR': 2.07
  };

  console.log('Diamond grading tables loaded:', {
    fancyTableSize: Object.keys(window.FANCY_GRADING_TABLE).length,
    roundTableSize: Object.keys(window.ROUND_GRADING_TABLE).length
  });

})();
